/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.2.5.0 (NJsonSchema v10.1.7.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class BistrackClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Gets all the stock locations in the given branch
     * @param branchId The branch identifier.
     * @return Success
     */
    getAllStockLocations(branchId: number): Observable<StockLocationsResponse> {
        let url_ = this.baseUrl + "/api/Application/StockLocations/{branchId}";
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined.");
        url_ = url_.replace("{branchId}", encodeURIComponent("" + branchId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStockLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStockLocations(<any>response_);
                } catch (e) {
                    return <Observable<StockLocationsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<StockLocationsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllStockLocations(response: HttpResponseBase): Observable<StockLocationsResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockLocationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockLocationsResponse>(<any>null);
    }

    /**
     * Returns all branches for given user
     * @param staffUserID (optional) The staff user identifier.
     * @return Success
     */
    getAllBranches(staffUserID: number | null | undefined): Observable<BranchesResponse> {
        let url_ = this.baseUrl + "/api/Application/Branches?";
        if (staffUserID !== undefined)
            url_ += "staffUserID=" + encodeURIComponent("" + staffUserID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBranches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBranches(<any>response_);
                } catch (e) {
                    return <Observable<BranchesResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BranchesResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBranches(response: HttpResponseBase): Observable<BranchesResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BranchesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BranchesResponse>(<any>null);
    }

    /**
     * Returns list of Computers configured in Computer.
     * @return Success
     */
    getAllComputers(): Observable<ComputersResponse> {
        let url_ = this.baseUrl + "/api/Application/Computers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllComputers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllComputers(<any>response_);
                } catch (e) {
                    return <Observable<ComputersResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ComputersResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllComputers(response: HttpResponseBase): Observable<ComputersResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ComputersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComputersResponse>(<any>null);
    }

    /**
     * Returns all available Vehicle Types
     * @return Success
     */
    getAllVehicleTypes(): Observable<VehicleTypesResponse> {
        let url_ = this.baseUrl + "/api/Application/VehicleTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllVehicleTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllVehicleTypes(<any>response_);
                } catch (e) {
                    return <Observable<VehicleTypesResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<VehicleTypesResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllVehicleTypes(response: HttpResponseBase): Observable<VehicleTypesResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleTypesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleTypesResponse>(<any>null);
    }

    /**
     * Gets the vehicle by given vehicle ID
     * @param vehicleId The vehicle identifier.
     * @param staffUserId The user identifier.
     * @return Success
     */
    getVehiclesById(vehicleId: number, staffUserId: number): Observable<VehicleResponse> {
        let url_ = this.baseUrl + "/api/Application/VehiclebById/{vehicleId}/{staffUserId}";
        if (vehicleId === undefined || vehicleId === null)
            throw new Error("The parameter 'vehicleId' must be defined.");
        url_ = url_.replace("{vehicleId}", encodeURIComponent("" + vehicleId)); 
        if (staffUserId === undefined || staffUserId === null)
            throw new Error("The parameter 'staffUserId' must be defined.");
        url_ = url_.replace("{staffUserId}", encodeURIComponent("" + staffUserId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehiclesById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehiclesById(<any>response_);
                } catch (e) {
                    return <Observable<VehicleResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<VehicleResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetVehiclesById(response: HttpResponseBase): Observable<VehicleResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleResponse>(<any>null);
    }

    /**
     * Returns all vehicles matching the search criteria in BisTrack.Service.Dto.VehiclesQueryParams
     * @param queryParams (optional) The query parameters.
     * @return Success
     */
    getVehicles(queryParams: VehiclesQueryParams | null | undefined): Observable<VehiclesListResponse> {
        let url_ = this.baseUrl + "/api/Application/Vehicles/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicles(<any>response_);
                } catch (e) {
                    return <Observable<VehiclesListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<VehiclesListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetVehicles(response: HttpResponseBase): Observable<VehiclesListResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehiclesListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehiclesListResponse>(<any>null);
    }

    /**
     * Use this API to retrieve the vehicle types for a list of branches. 
    If only a single branch data is needed, send a list of branch with only one branch populated.
    This API is to be primarily consumed in Mark Order flow.
     * @param branches (optional) 
     * @return Success
     */
    getAllowedVehicleTypesForBranch(branches: Branch[] | null | undefined): Observable<VehicleType[]> {
        let url_ = this.baseUrl + "/api/Application/AllowedVehicleTypesForBranch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(branches);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowedVehicleTypesForBranch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedVehicleTypesForBranch(<any>response_);
                } catch (e) {
                    return <Observable<VehicleType[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<VehicleType[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllowedVehicleTypesForBranch(response: HttpResponseBase): Observable<VehicleType[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VehicleType.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleType[]>(<any>null);
    }

    /**
     * Returns all available drivers
     * @return Success
     */
    getAllDrivers(): Observable<DriversListResponse> {
        let url_ = this.baseUrl + "/api/Application/Drivers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDrivers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDrivers(<any>response_);
                } catch (e) {
                    return <Observable<DriversListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<DriversListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDrivers(response: HttpResponseBase): Observable<DriversListResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DriversListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DriversListResponse>(<any>null);
    }

    /**
     * Returns all document types for given BisTrack.Service.Dto.DocumentTypeCategory
     * @param documentTypeCategory The document type category.
     * @return Success
     */
    getDocumentTypes(documentTypeCategory: DocumentTypeCategory): Observable<DocumentTypesResponse> {
        let url_ = this.baseUrl + "/api/Application/DocumentTypes/{documentTypeCategory}";
        if (documentTypeCategory === undefined || documentTypeCategory === null)
            throw new Error("The parameter 'documentTypeCategory' must be defined.");
        url_ = url_.replace("{documentTypeCategory}", encodeURIComponent("" + documentTypeCategory)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTypes(<any>response_);
                } catch (e) {
                    return <Observable<DocumentTypesResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentTypesResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetDocumentTypes(response: HttpResponseBase): Observable<DocumentTypesResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentTypesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentTypesResponse>(<any>null);
    }

    /**
     * Returns all system options.
     * @return Success
     */
    getSystemOptions(): Observable<SystemOptionResponse> {
        let url_ = this.baseUrl + "/api/Application/SystemOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSystemOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSystemOptions(<any>response_);
                } catch (e) {
                    return <Observable<SystemOptionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SystemOptionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetSystemOptions(response: HttpResponseBase): Observable<SystemOptionResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemOptionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SystemOptionResponse>(<any>null);
    }

    /**
     * Returns all system options.
     * @return Success
     */
    getVocabularies(): Observable<VocabularyResponse> {
        let url_ = this.baseUrl + "/api/Application/Vocabularies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVocabularies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVocabularies(<any>response_);
                } catch (e) {
                    return <Observable<VocabularyResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<VocabularyResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetVocabularies(response: HttpResponseBase): Observable<VocabularyResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VocabularyResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VocabularyResponse>(<any>null);
    }

    /**
     * Returns all system options.
     * @param systemOptionsQueryParams (optional) 
     * @return Success
     */
    getSystemOptionsById(systemOptionsQueryParams: SystemOptionsQueryParams | null | undefined): Observable<SystemOptionResponse> {
        let url_ = this.baseUrl + "/api/Application/SystemOptions/Get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(systemOptionsQueryParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSystemOptionsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSystemOptionsById(<any>response_);
                } catch (e) {
                    return <Observable<SystemOptionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SystemOptionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetSystemOptionsById(response: HttpResponseBase): Observable<SystemOptionResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemOptionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SystemOptionResponse>(<any>null);
    }

    /**
     * Updates the vehicle details.
     * @param userID (optional) The user identifier.
     * @param updatedVehicle (optional) The updated vehicle.
     * @return Success
     */
    updateVehicle(userID: number | null | undefined, updatedVehicle: Vehicle | null | undefined): Observable<VehicleUpdateResponse> {
        let url_ = this.baseUrl + "/api/Application/Vehicles/Update?";
        if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedVehicle);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVehicle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVehicle(<any>response_);
                } catch (e) {
                    return <Observable<VehicleUpdateResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<VehicleUpdateResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateVehicle(response: HttpResponseBase): Observable<VehicleUpdateResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleUpdateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleUpdateResponse>(<any>null);
    }

    /**
     * Returns all the AutoTexts defined in the system.
     * @param branchID (optional) The branch identifier.
     * @param textType (optional) Type of AutoText. for list of types check BisTrack.Service.Dto.AutoTextType
     * @return Success
     */
    getAutoTexts(branchID: number | null | undefined, textType: TextType | null | undefined): Observable<AutoTextResponse> {
        let url_ = this.baseUrl + "/api/Application/autotexts?";
        if (branchID !== undefined)
            url_ += "branchID=" + encodeURIComponent("" + branchID) + "&"; 
        if (textType !== undefined)
            url_ += "textType=" + encodeURIComponent("" + textType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutoTexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoTexts(<any>response_);
                } catch (e) {
                    return <Observable<AutoTextResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AutoTextResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAutoTexts(response: HttpResponseBase): Observable<AutoTextResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AutoTextResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AutoTextResponse>(<any>null);
    }

    /**
     * Returns all the delivery areas
     * @param webTrackOnly (optional) if set to {true} [web track only].
     * @return Success
     */
    getDeliveryAreas(webTrackOnly: boolean | null | undefined): Observable<DeliveryAreasResponse> {
        let url_ = this.baseUrl + "/api/Application/DeliveryAreas?";
        if (webTrackOnly !== undefined)
            url_ += "webTrackOnly=" + encodeURIComponent("" + webTrackOnly) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryAreas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryAreas(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryAreasResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryAreasResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeliveryAreas(response: HttpResponseBase): Observable<DeliveryAreasResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryAreasResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryAreasResponse>(<any>null);
    }

    /**
     * API to get the location of the vehicle for given journey.
     * @param vehicleID The vehicle identifier.
     * @return Success
     */
    getVehicleLocation(vehicleID: number): Observable<VehicleLocationResponse> {
        let url_ = this.baseUrl + "/api/Application/vehicles/location/{vehicleID}";
        if (vehicleID === undefined || vehicleID === null)
            throw new Error("The parameter 'vehicleID' must be defined.");
        url_ = url_.replace("{vehicleID}", encodeURIComponent("" + vehicleID)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleLocation(<any>response_);
                } catch (e) {
                    return <Observable<VehicleLocationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<VehicleLocationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetVehicleLocation(response: HttpResponseBase): Observable<VehicleLocationResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleLocationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleLocationResponse>(<any>null);
    }

    /**
     * API to get the audit details.
     * @param request (optional) Data for filtering audit information
     * @return Success
     */
    getAudit(request: AuditRequest | null | undefined): Observable<AuditResponse> {
        let url_ = this.baseUrl + "/api/Application/audit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAudit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAudit(<any>response_);
                } catch (e) {
                    return <Observable<AuditResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuditResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAudit(response: HttpResponseBase): Observable<AuditResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuditResponse>(<any>null);
    }

    /**
     * Get the suppliers
     * @param request (optional) 
     * @return Success
     */
    getSuppliers(request: SupplierRequest | null | undefined): Observable<SupplierResponse> {
        let url_ = this.baseUrl + "/api/Application/suppliers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuppliers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuppliers(<any>response_);
                } catch (e) {
                    return <Observable<SupplierResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SupplierResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetSuppliers(response: HttpResponseBase): Observable<SupplierResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierResponse>(<any>null);
    }

    /**
     * Get the supplier catalog
     * @return Success
     */
    getSupplierCatalog(): Observable<SupplierCatalogResponse> {
        let url_ = this.baseUrl + "/api/Application/suppliercatalog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierCatalog(<any>response_);
                } catch (e) {
                    return <Observable<SupplierCatalogResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SupplierCatalogResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetSupplierCatalog(response: HttpResponseBase): Observable<SupplierCatalogResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierCatalogResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierCatalogResponse>(<any>null);
    }

    /**
     * Get the supplier catalog tree
     * @param supplierCode (optional) 
     * @param retailSalesCenterId (optional) 
     * @param treeLevel (optional) 
     * @param level1Code (optional) 
     * @return Success
     */
    getSupplierCatalogTree(supplierCode: string | null | undefined, retailSalesCenterId: number | null | undefined, treeLevel: number | null | undefined, level1Code: number | null | undefined): Observable<SupplierCatalogTreeResponse> {
        let url_ = this.baseUrl + "/api/Application/suppliercatalogTree?";
        if (supplierCode !== undefined)
            url_ += "supplierCode=" + encodeURIComponent("" + supplierCode) + "&"; 
        if (retailSalesCenterId !== undefined)
            url_ += "retailSalesCenterId=" + encodeURIComponent("" + retailSalesCenterId) + "&"; 
        if (treeLevel !== undefined)
            url_ += "treeLevel=" + encodeURIComponent("" + treeLevel) + "&"; 
        if (level1Code !== undefined)
            url_ += "level1Code=" + encodeURIComponent("" + level1Code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierCatalogTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierCatalogTree(<any>response_);
                } catch (e) {
                    return <Observable<SupplierCatalogTreeResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SupplierCatalogTreeResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetSupplierCatalogTree(response: HttpResponseBase): Observable<SupplierCatalogTreeResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierCatalogTreeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierCatalogTreeResponse>(<any>null);
    }

    /**
     * Get the suppliers
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    getUsers(skip: number | null | undefined, take: number | null | undefined): Observable<UsersResponse> {
        let url_ = this.baseUrl + "/api/Application/users?";
        if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&"; 
        if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(<any>response_);
                } catch (e) {
                    return <Observable<UsersResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UsersResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<UsersResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UsersResponse>(<any>null);
    }

    /**
     * Browses the object asynchronous.
     * @param browseObjectParam (optional) The browse object parameter.
     * @return Success
     */
    getBrowseObject(browseObjectParam: CollectionObjectParam | null | undefined): Observable<CollectionObjectResponse> {
        let url_ = this.baseUrl + "/api/Application/GetBrowseObject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(browseObjectParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBrowseObject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrowseObject(<any>response_);
                } catch (e) {
                    return <Observable<CollectionObjectResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CollectionObjectResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetBrowseObject(response: HttpResponseBase): Observable<CollectionObjectResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionObjectResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CollectionObjectResponse>(<any>null);
    }

    /**
     * Retrieves all of the more fields asynchronous.
     * @return Success
     */
    getUdfObjects(choice: Choice, userId: number): Observable<UserDefinedFieldResponse> {
        let url_ = this.baseUrl + "/api/Application/GetUserDefinedFields/{choice}/{userid}";
        if (choice === undefined || choice === null)
            throw new Error("The parameter 'choice' must be defined.");
        url_ = url_.replace("{choice}", encodeURIComponent("" + choice)); 
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUdfObjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUdfObjects(<any>response_);
                } catch (e) {
                    return <Observable<UserDefinedFieldResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDefinedFieldResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetUdfObjects(response: HttpResponseBase): Observable<UserDefinedFieldResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDefinedFieldResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDefinedFieldResponse>(<any>null);
    }

    /**
     * Retrieves user option details for a given user
     * @param userOptionRequest (optional) 
     * @return Success
     */
    getUserOptions(userOptionRequest: GetUserOptionRequest | null | undefined): Observable<UserOptionResponse> {
        let url_ = this.baseUrl + "/api/Application/GetUserOptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userOptionRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserOptions(<any>response_);
                } catch (e) {
                    return <Observable<UserOptionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserOptionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserOptions(response: HttpResponseBase): Observable<UserOptionResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserOptionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserOptionResponse>(<any>null);
    }

    /**
     * Set user option details for a given user
     * @param userOptionRequest (optional) 
     * @return Success
     */
    setUserOption(userOptionRequest: SetUserOptionRequest | null | undefined): Observable<SetUserOptionResponse> {
        let url_ = this.baseUrl + "/api/Application/SetUserOptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userOptionRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUserOption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserOption(<any>response_);
                } catch (e) {
                    return <Observable<SetUserOptionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SetUserOptionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSetUserOption(response: HttpResponseBase): Observable<SetUserOptionResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetUserOptionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SetUserOptionResponse>(<any>null);
    }

    /**
     * Gets the Debug Configuration Status
     * @return Success
     */
    getDebugStatus(): Observable<DebugConfiguration> {
        let url_ = this.baseUrl + "/api/Debug";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDebugStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDebugStatus(<any>response_);
                } catch (e) {
                    return <Observable<DebugConfiguration>><any>_observableThrow(e);
                }
            } else
                return <Observable<DebugConfiguration>><any>_observableThrow(response_);
        }));
    }

    protected processGetDebugStatus(response: HttpResponseBase): Observable<DebugConfiguration> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DebugConfiguration.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DebugConfiguration>(<any>null);
    }

    /**
     * Sets/update the new debug status and initalize each service with the new configuration
     * @param configuration (optional) 
     * @return Success
     */
    setDebugStatus(configuration: DebugConfiguration | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Debug";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configuration);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDebugStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDebugStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetDebugStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Gets the list of logged trace files available
     * @return Success
     */
    getLogs(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Debug/Logs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogs(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLogs(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * downloads the desired logged trace file
     * @param fileName file name of the trace file
     * @return Success
     */
    getLogFile(fileName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Debug/Log/{fileName}";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogFile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetLogFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Reset cache from all services, this allows the Master Table changes to take refresh
     * @return Success
     */
    cacheReset(): Observable<void> {
        let url_ = this.baseUrl + "/api/Debug/Cache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCacheReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCacheReset(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCacheReset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * get details about the session
     * @return Success
     */
    session(sessionId: string): Observable<SessionInfo> {
        let url_ = this.baseUrl + "/api/Debug/Session/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSession(<any>response_);
                } catch (e) {
                    return <Observable<SessionInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<SessionInfo>><any>_observableThrow(response_);
        }));
    }

    protected processSession(response: HttpResponseBase): Observable<SessionInfo> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SessionInfo>(<any>null);
    }

    /**
     * Get list of active sessions
     * @return Success
     */
    sessions(): Observable<SessionInfo[]> {
        let url_ = this.baseUrl + "/api/Debug/Sessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSessions(<any>response_);
                } catch (e) {
                    return <Observable<SessionInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SessionInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processSessions(response: HttpResponseBase): Observable<SessionInfo[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SessionInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SessionInfo[]>(<any>null);
    }

    /**
     * this Api oad the entire document, this call may be expensive as it loads the entire document
     * @return Success
     */
    getDocument(documentType: DocumentType2, documentId: number, asUserId: number): Observable<DocumentManifest> {
        let url_ = this.baseUrl + "/api/Document/Manifest/{documentType}/{documentId}/{asUserId}";
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined.");
        url_ = url_.replace("{documentType}", encodeURIComponent("" + documentType)); 
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId)); 
        if (asUserId === undefined || asUserId === null)
            throw new Error("The parameter 'asUserId' must be defined.");
        url_ = url_.replace("{asUserId}", encodeURIComponent("" + asUserId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocument(<any>response_);
                } catch (e) {
                    return <Observable<DocumentManifest>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentManifest>><any>_observableThrow(response_);
        }));
    }

    protected processGetDocument(response: HttpResponseBase): Observable<DocumentManifest> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentManifest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentManifest>(<any>null);
    }

    /**
     * Save/update created/modified journey details
     * @param manifestRequest (optional) 
     * @return Success
     */
    saveAndUpdate(manifestRequest: DocumentManifestRequest | null | undefined): Observable<DocumentManifest> {
        let url_ = this.baseUrl + "/api/Document/journey/SaveAndUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(manifestRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAndUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAndUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DocumentManifest>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentManifest>><any>_observableThrow(response_);
        }));
    }

    protected processSaveAndUpdate(response: HttpResponseBase): Observable<DocumentManifest> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentManifest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentManifest>(<any>null);
    }

    /**
     * I will load only the document header
     * @return Success
     */
    getDocumentHeader(documentType: DocumentType3, documentId: number, asUserId: number): Observable<DocumentHeaderManifest> {
        let url_ = this.baseUrl + "/api/Document/Manifest/Header/{documentType}/{documentId}/{asUserId}";
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined.");
        url_ = url_.replace("{documentType}", encodeURIComponent("" + documentType)); 
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId)); 
        if (asUserId === undefined || asUserId === null)
            throw new Error("The parameter 'asUserId' must be defined.");
        url_ = url_.replace("{asUserId}", encodeURIComponent("" + asUserId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentHeader(<any>response_);
                } catch (e) {
                    return <Observable<DocumentHeaderManifest>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentHeaderManifest>><any>_observableThrow(response_);
        }));
    }

    protected processGetDocumentHeader(response: HttpResponseBase): Observable<DocumentHeaderManifest> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentHeaderManifest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentHeaderManifest>(<any>null);
    }

    /**
     * This api is to get the smart tab names
     * @param smartTabNameQueryParams (optional) 
     * @return Success
     */
    getSmartTabNames(smartTabNameQueryParams: SmartTabNameQueryParams | null | undefined): Observable<SmartView[]> {
        let url_ = this.baseUrl + "/api/Document/SmartTabList/Get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(smartTabNameQueryParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSmartTabNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSmartTabNames(<any>response_);
                } catch (e) {
                    return <Observable<SmartView[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SmartView[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSmartTabNames(response: HttpResponseBase): Observable<SmartView[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SmartView.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SmartView[]>(<any>null);
    }

    /**
     * Returns the documents for given search crieteria in BisTrack.Service.Dto.DocumentQueryParams
     * @param queryParams (optional) The query parameters.
     * @return Success
     */
    getDocuments(queryParams: DocumentQueryParams | null | undefined): Observable<DocumentsListResponse> {
        let url_ = this.baseUrl + "/api/Document/Documents/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(<any>response_);
                } catch (e) {
                    return <Observable<DocumentsListResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentsListResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<DocumentsListResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentsListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentsListResponse>(<any>null);
    }

    /**
     * This api is to get the data for the smart tab/smart view
     * @param smartTabDataQueryParams (optional) 
     * @return Success
     */
    getSmartTabData(smartTabDataQueryParams: SmartTabDataQueryParams | null | undefined): Observable<SmartTabDataResponse> {
        let url_ = this.baseUrl + "/api/Document/SmartTabData/Get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(smartTabDataQueryParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSmartTabData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSmartTabData(<any>response_);
                } catch (e) {
                    return <Observable<SmartTabDataResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SmartTabDataResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetSmartTabData(response: HttpResponseBase): Observable<SmartTabDataResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmartTabDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SmartTabDataResponse>(<any>null);
    }

    /**
     * The DeleteDocument
     * @param documentType The documentTypeBisTrack.Service.Dto.DocumentListTypes
     * @param documentId The documentIdSystem.Int32
     * @param userId The userIdSystem.Int32
     * @return Success
     */
    deleteDocument(documentType: DocumentType4, documentId: number, userId: number): Observable<DocumentOpStatusResponse> {
        let url_ = this.baseUrl + "/api/Document/DeleteDocument/{documentType}/{documentId}/{userId}";
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined.");
        url_ = url_.replace("{documentType}", encodeURIComponent("" + documentType)); 
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId)); 
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(<any>response_);
                } catch (e) {
                    return <Observable<DocumentOpStatusResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentOpStatusResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<DocumentOpStatusResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentOpStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentOpStatusResponse>(<any>null);
    }

    /**
     * Action to mark orders.
     * @param request (optional) 
     * @return Success
     */
    markOrders(request: MarkOrderRequest | null | undefined): Observable<MarkOrderResponse> {
        let url_ = this.baseUrl + "/api/Document/document/markorders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkOrders(<any>response_);
                } catch (e) {
                    return <Observable<MarkOrderResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<MarkOrderResponse>><any>_observableThrow(response_);
        }));
    }

    protected processMarkOrders(response: HttpResponseBase): Observable<MarkOrderResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MarkOrderResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MarkOrderResponse>(<any>null);
    }

    /**
     * ConvertDocuments
     * @param convertParams (optional) Convert Documents(Order to Picking Note, Picking Note to Delivery Note
     * @return Success
     */
    convertDocuments(convertParams: ConvertDocumentParams | null | undefined): Observable<ConvertDocumentResponse> {
        let url_ = this.baseUrl + "/api/JourneyPlanner/Document/Convert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(convertParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConvertDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertDocuments(<any>response_);
                } catch (e) {
                    return <Observable<ConvertDocumentResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConvertDocumentResponse>><any>_observableThrow(response_);
        }));
    }

    protected processConvertDocuments(response: HttpResponseBase): Observable<ConvertDocumentResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConvertDocumentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConvertDocumentResponse>(<any>null);
    }

    /**
     * GetCalendarEvents API
     * @param queryParams (optional) 
     * @return Success
     */
    getCalendarEvents(queryParams: CalendarEventQueryParams | null | undefined): Observable<CalendarEventsResponse> {
        let url_ = this.baseUrl + "/api/JourneyPlanner/CalendarEvents/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarEvents(<any>response_);
                } catch (e) {
                    return <Observable<CalendarEventsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarEventsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetCalendarEvents(response: HttpResponseBase): Observable<CalendarEventsResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarEventsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarEventsResponse>(<any>null);
    }

    /**
     * Schedule Events
     * @param scheduleEventParams (optional) Request params required to validate and create an event
     * @return Success
     */
    scheduleEvent(scheduleEventParams: ScheduleEventParams | null | undefined): Observable<ScheduleEventResponse> {
        let url_ = this.baseUrl + "/api/JourneyPlanner/ScheduleEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scheduleEventParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleEvent(<any>response_);
                } catch (e) {
                    return <Observable<ScheduleEventResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ScheduleEventResponse>><any>_observableThrow(response_);
        }));
    }

    protected processScheduleEvent(response: HttpResponseBase): Observable<ScheduleEventResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleEventResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleEventResponse>(<any>null);
    }

    /**
     * API to get all unused vehicles.
     * @param queryParams (optional) 
     * @return Success
     */
    getAllUnusedVehicle(queryParams: UnusedVehicleQueryParams | null | undefined): Observable<UnusedVehicleResponse> {
        let url_ = this.baseUrl + "/api/JourneyPlanner/UnusedVehicles/Get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUnusedVehicle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUnusedVehicle(<any>response_);
                } catch (e) {
                    return <Observable<UnusedVehicleResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UnusedVehicleResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUnusedVehicle(response: HttpResponseBase): Observable<UnusedVehicleResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnusedVehicleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UnusedVehicleResponse>(<any>null);
    }

    /**
     * To update the start and end time when  schedule is moved to a different time range
     * @param scheduledDocumentMoveParams (optional) 
     * @return Success
     */
    scheduledDocumentUpdate(scheduledDocumentMoveParams: ScheduledDocumentMoveParams | null | undefined): Observable<ScheduledDocumentMoveResponse> {
        let url_ = this.baseUrl + "/api/JourneyPlanner/ScheduleEvent/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scheduledDocumentMoveParams);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduledDocumentUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduledDocumentUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ScheduledDocumentMoveResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ScheduledDocumentMoveResponse>><any>_observableThrow(response_);
        }));
    }

    protected processScheduledDocumentUpdate(response: HttpResponseBase): Observable<ScheduledDocumentMoveResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledDocumentMoveResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduledDocumentMoveResponse>(<any>null);
    }

    /**
     * Returns the journey planner options for the given user.
     * @return Success
     */
    getJourneyPlannerOptions(userID: number): Observable<JourneyPlannerOptionsResponse> {
        let url_ = this.baseUrl + "/api/JourneyPlanner/options/{userID}";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined.");
        url_ = url_.replace("{userID}", encodeURIComponent("" + userID)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJourneyPlannerOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJourneyPlannerOptions(<any>response_);
                } catch (e) {
                    return <Observable<JourneyPlannerOptionsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<JourneyPlannerOptionsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetJourneyPlannerOptions(response: HttpResponseBase): Observable<JourneyPlannerOptionsResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JourneyPlannerOptionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JourneyPlannerOptionsResponse>(<any>null);
    }

    /**
     * Updates the journey planner option values for given user.
     * @param options (optional) 
     * @return Success
     */
    saveJourneyPlannerOptions(userID: number, options: JourneyPlannerOptions | null | undefined): Observable<AppOPStatusResponse> {
        let url_ = this.baseUrl + "/api/JourneyPlanner/options/{userID}";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined.");
        url_ = url_.replace("{userID}", encodeURIComponent("" + userID)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveJourneyPlannerOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveJourneyPlannerOptions(<any>response_);
                } catch (e) {
                    return <Observable<AppOPStatusResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppOPStatusResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSaveJourneyPlannerOptions(response: HttpResponseBase): Observable<AppOPStatusResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppOPStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppOPStatusResponse>(<any>null);
    }

    /**
     * Mark the journey full day
     * @param markFullDay (optional) 
     * @return Success
     */
    markFullDay(markFullDay: MarkFullDayRequest | null | undefined): Observable<JourneyOpStatusResponse> {
        let url_ = this.baseUrl + "/api/JourneyPlanner/MarkFullDayAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(markFullDay);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkFullDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkFullDay(<any>response_);
                } catch (e) {
                    return <Observable<JourneyOpStatusResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<JourneyOpStatusResponse>><any>_observableThrow(response_);
        }));
    }

    protected processMarkFullDay(response: HttpResponseBase): Observable<JourneyOpStatusResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JourneyOpStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JourneyOpStatusResponse>(<any>null);
    }

    /**
     * Get Mark the journey full day List
     * @param markFullDay (optional) 
     * @return Success
     */
    getMarkFullDayList(markFullDay: MarkFullDayListRequest | null | undefined): Observable<JourneyOpStatusResponse> {
        let url_ = this.baseUrl + "/api/JourneyPlanner/GetMarkFullDayList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(markFullDay);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMarkFullDayList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMarkFullDayList(<any>response_);
                } catch (e) {
                    return <Observable<JourneyOpStatusResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<JourneyOpStatusResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetMarkFullDayList(response: HttpResponseBase): Observable<JourneyOpStatusResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JourneyOpStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JourneyOpStatusResponse>(<any>null);
    }

    /**
     * Save/update created/modified journey details
     * @param journeyManifestRequest (optional) 
     * @return Success
     */
    saveAndUpdate2(journeyManifestRequest: DocumentManifestRequest | null | undefined): Observable<JourneyManifestResponse> {
        let url_ = this.baseUrl + "/api/JourneyPlanner/journey/SaveAndUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(journeyManifestRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAndUpdate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAndUpdate2(<any>response_);
                } catch (e) {
                    return <Observable<JourneyManifestResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<JourneyManifestResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSaveAndUpdate2(response: HttpResponseBase): Observable<JourneyManifestResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JourneyManifestResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JourneyManifestResponse>(<any>null);
    }

    /**
     * @param loadDriveTimeRequest (optional) 
     * @return Success
     */
    loadDriveTimes(loadDriveTimeRequest: TimeEstimateRequest | null | undefined): Observable<TimeEstimateResponse> {
        let url_ = this.baseUrl + "/api/JourneyPlanner/LoadDriveTimesAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loadDriveTimeRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadDriveTimes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadDriveTimes(<any>response_);
                } catch (e) {
                    return <Observable<TimeEstimateResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<TimeEstimateResponse>><any>_observableThrow(response_);
        }));
    }

    protected processLoadDriveTimes(response: HttpResponseBase): Observable<TimeEstimateResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeEstimateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TimeEstimateResponse>(<any>null);
    }

    /**
     * Load default unloading time and recalculate planned finish time accordingly
     * @param loadDefaultsRequest (optional) 
     * @return Success
     */
    loadDefaults(loadDefaultsRequest: TimeEstimateRequest | null | undefined): Observable<TimeEstimateResponse> {
        let url_ = this.baseUrl + "/api/JourneyPlanner/journey/LoadDefaults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loadDefaultsRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadDefaults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadDefaults(<any>response_);
                } catch (e) {
                    return <Observable<TimeEstimateResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<TimeEstimateResponse>><any>_observableThrow(response_);
        }));
    }

    protected processLoadDefaults(response: HttpResponseBase): Observable<TimeEstimateResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeEstimateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TimeEstimateResponse>(<any>null);
    }

    /**
     * @param findFromDocumentRequest (optional) 
     * @return Success
     */
    findFromDocument(findFromDocumentRequest: FindFromDocumentRequest | null | undefined): Observable<FindFromDocumentResponse> {
        let url_ = this.baseUrl + "/api/JourneyPlanner/journey/FindFromDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(findFromDocumentRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindFromDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindFromDocument(<any>response_);
                } catch (e) {
                    return <Observable<FindFromDocumentResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<FindFromDocumentResponse>><any>_observableThrow(response_);
        }));
    }

    protected processFindFromDocument(response: HttpResponseBase): Observable<FindFromDocumentResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FindFromDocumentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FindFromDocumentResponse>(<any>null);
    }

    /**
     * Returns the Direction Url
     * @param request (optional) 
     * @return Success
     */
    getDirections(request: JourneyDirectionRequest | null | undefined): Observable<JourneyDirectionResponse> {
        let url_ = this.baseUrl + "/api/JourneyPlanner/journey/directions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDirections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDirections(<any>response_);
                } catch (e) {
                    return <Observable<JourneyDirectionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<JourneyDirectionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetDirections(response: HttpResponseBase): Observable<JourneyDirectionResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JourneyDirectionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JourneyDirectionResponse>(<any>null);
    }

    /**
     * Action to split a transaction in journey
     * @return Success
     */
    splitTransaction(documentId: number): Observable<JourneyOpStatusResponse> {
        let url_ = this.baseUrl + "/api/JourneyPlanner/splittransaction/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSplitTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSplitTransaction(<any>response_);
                } catch (e) {
                    return <Observable<JourneyOpStatusResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<JourneyOpStatusResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSplitTransaction(response: HttpResponseBase): Observable<JourneyOpStatusResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JourneyOpStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JourneyOpStatusResponse>(<any>null);
    }

    /**
     * @param password (optional) 
     * @return Success
     */
    signIn(userId: string, password: string | null | undefined): Observable<LoginUserResponse> {
        let url_ = this.baseUrl + "/api/Login/Signin/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(password);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignIn(<any>response_);
                } catch (e) {
                    return <Observable<LoginUserResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<LoginUserResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSignIn(response: HttpResponseBase): Observable<LoginUserResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LoginUserResponse>(<any>null);
    }

    /**
     * @return Success
     */
    currentUser(): Observable<CurrentUserResponse> {
        let url_ = this.baseUrl + "/api/Login/CurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCurrentUser(<any>response_);
                } catch (e) {
                    return <Observable<CurrentUserResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CurrentUserResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCurrentUser(response: HttpResponseBase): Observable<CurrentUserResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrentUserResponse>(<any>null);
    }

    /**
     * @return Success
     */
    userAppMenu(): Observable<UserAppMenuResponse> {
        let url_ = this.baseUrl + "/api/Login/UserAppMenu";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserAppMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserAppMenu(<any>response_);
                } catch (e) {
                    return <Observable<UserAppMenuResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserAppMenuResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUserAppMenu(response: HttpResponseBase): Observable<UserAppMenuResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAppMenuResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAppMenuResponse>(<any>null);
    }

    /**
     * @return Success
     */
    userNavMenu(): Observable<UserNavigationMenuResponse> {
        let url_ = this.baseUrl + "/api/Login/UserNavMenu";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserNavMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserNavMenu(<any>response_);
                } catch (e) {
                    return <Observable<UserNavigationMenuResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserNavigationMenuResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUserNavMenu(response: HttpResponseBase): Observable<UserNavigationMenuResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNavigationMenuResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserNavigationMenuResponse>(<any>null);
    }

    /**
     * This api will return the kit product details based on given kit product Id. This will not give the product lines and other details related to kit.
     * @return Success
     */
    getKitDetails(productId: number): Observable<KitDetailsResponse> {
        let url_ = this.baseUrl + "/api/Product/Kit/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKitDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKitDetails(<any>response_);
                } catch (e) {
                    return <Observable<KitDetailsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<KitDetailsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetKitDetails(response: HttpResponseBase): Observable<KitDetailsResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KitDetailsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<KitDetailsResponse>(<any>null);
    }

    /**
     * This api will return a kit manifest that will have all the details about a given kit product Id. This api should not be used to create the kit configurator.
     * @return Success
     */
    getKitManifest(kitProductId: number): Observable<KitManifestResponse> {
        let url_ = this.baseUrl + "/api/Product/Kit/Manifest/{kitProductId}";
        if (kitProductId === undefined || kitProductId === null)
            throw new Error("The parameter 'kitProductId' must be defined.");
        url_ = url_.replace("{kitProductId}", encodeURIComponent("" + kitProductId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKitManifest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKitManifest(<any>response_);
                } catch (e) {
                    return <Observable<KitManifestResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<KitManifestResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetKitManifest(response: HttpResponseBase): Observable<KitManifestResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KitManifestResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<KitManifestResponse>(<any>null);
    }

    /**
     * This api is for creating a kit configurator. This api will return the kit details that we need for the configurator.
     * @return Success
     */
    getKitConfiguratorManifest(kitProductId: number): Observable<KitConfiguratorResponse> {
        let url_ = this.baseUrl + "/api/Product/Kit/ConfiguratorManifest/{kitProductId}";
        if (kitProductId === undefined || kitProductId === null)
            throw new Error("The parameter 'kitProductId' must be defined.");
        url_ = url_.replace("{kitProductId}", encodeURIComponent("" + kitProductId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKitConfiguratorManifest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKitConfiguratorManifest(<any>response_);
                } catch (e) {
                    return <Observable<KitConfiguratorResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<KitConfiguratorResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetKitConfiguratorManifest(response: HttpResponseBase): Observable<KitConfiguratorResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KitConfiguratorResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<KitConfiguratorResponse>(<any>null);
    }

    /**
     * This api is to show the product image.
     * @return Success
     */
    getProductImage(sessionId: string, productId: number, imageNumber: number): Observable<Stream> {
        let url_ = this.baseUrl + "/api/Product/Image/{sessionId}/{productId}/{imageNumber}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId)); 
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId)); 
        if (imageNumber === undefined || imageNumber === null)
            throw new Error("The parameter 'imageNumber' must be defined.");
        url_ = url_.replace("{imageNumber}", encodeURIComponent("" + imageNumber)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductImage(<any>response_);
                } catch (e) {
                    return <Observable<Stream>><any>_observableThrow(e);
                }
            } else
                return <Observable<Stream>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductImage(response: HttpResponseBase): Observable<Stream> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Stream.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Stream>(<any>null);
    }

    /**
     * Gets all the stock locations in the given branch
     * @param branchId (optional) 
     * @param computerId (optional) 
     * @param documentId (optional) 
     * @param documentType (optional) 
     * @return Success
     */
    getReportFormats(branchId: number | null | undefined, computerId: number | null | undefined, documentId: number | null | undefined, documentType: number | null | undefined): Observable<ReportFormatResponse> {
        let url_ = this.baseUrl + "/api/Reports/Formats?";
        if (branchId !== undefined)
            url_ += "BranchId=" + encodeURIComponent("" + branchId) + "&"; 
        if (computerId !== undefined)
            url_ += "ComputerId=" + encodeURIComponent("" + computerId) + "&"; 
        if (documentId !== undefined)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&"; 
        if (documentType !== undefined)
            url_ += "DocumentType=" + encodeURIComponent("" + documentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportFormats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportFormats(<any>response_);
                } catch (e) {
                    return <Observable<ReportFormatResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReportFormatResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetReportFormats(response: HttpResponseBase): Observable<ReportFormatResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportFormatResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportFormatResponse>(<any>null);
    }

    /**
     * Returns PDF report
     * @param request (optional) 
     * @return Success
     */
    generateDocumentReport(request: DocumentReportRequest | null | undefined): Observable<DocumentReportResponse> {
        let url_ = this.baseUrl + "/api/Reports/documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateDocumentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateDocumentReport(<any>response_);
                } catch (e) {
                    return <Observable<DocumentReportResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentReportResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateDocumentReport(response: HttpResponseBase): Observable<DocumentReportResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentReportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentReportResponse>(<any>null);
    }

    /**
     * Validates documents and returns only valid document IDs.
     * @param request (optional) 
     * @return Success
     */
    preValidateDocuments(request: DocumentReportRequest | null | undefined): Observable<ReportsValidationResponse> {
        let url_ = this.baseUrl + "/api/Reports/documents/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreValidateDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreValidateDocuments(<any>response_);
                } catch (e) {
                    return <Observable<ReportsValidationResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReportsValidationResponse>><any>_observableThrow(response_);
        }));
    }

    protected processPreValidateDocuments(response: HttpResponseBase): Observable<ReportsValidationResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportsValidationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportsValidationResponse>(<any>null);
    }

    /**
     * Keeps a session alive, good to keep track of active sessions
     * @return Success
     */
    keepAlive(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Session/KeepAlive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKeepAlive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKeepAlive(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processKeepAlive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * Start all field agent services, based upon the db configurations
     * @return Success
     */
    startFieldAgents(): Observable<{ [key: string]: FieldAgentServiceInfo; }> {
        let url_ = this.baseUrl + "/api/Session/StartFieldAgents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartFieldAgents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartFieldAgents(<any>response_);
                } catch (e) {
                    return <Observable<{ [key: string]: FieldAgentServiceInfo; }>><any>_observableThrow(e);
                }
            } else
                return <Observable<{ [key: string]: FieldAgentServiceInfo; }>><any>_observableThrow(response_);
        }));
    }

    protected processStartFieldAgents(response: HttpResponseBase): Observable<{ [key: string]: FieldAgentServiceInfo; }> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key] ? FieldAgentServiceInfo.fromJS(resultData200[key]) : new FieldAgentServiceInfo();
                }
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: FieldAgentServiceInfo; }>(<any>null);
    }

    /**
     * stop all field agent services, created by session manager
     * @return Success
     */
    stopFieldAgents(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Session/StopFieldAgents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStopFieldAgents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStopFieldAgents(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processStopFieldAgents(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * stops all field agent services and restarts all based upon current db configurations
     * @return Success
     */
    reStartFieldAgents(): Observable<{ [key: string]: FieldAgentServiceInfo; }> {
        let url_ = this.baseUrl + "/api/Session/ReStartFieldAgents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReStartFieldAgents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReStartFieldAgents(<any>response_);
                } catch (e) {
                    return <Observable<{ [key: string]: FieldAgentServiceInfo; }>><any>_observableThrow(e);
                }
            } else
                return <Observable<{ [key: string]: FieldAgentServiceInfo; }>><any>_observableThrow(response_);
        }));
    }

    protected processReStartFieldAgents(response: HttpResponseBase): Observable<{ [key: string]: FieldAgentServiceInfo; }> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200![key] = resultData200[key] ? FieldAgentServiceInfo.fromJS(resultData200[key]) : new FieldAgentServiceInfo();
                }
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<{ [key: string]: FieldAgentServiceInfo; }>(<any>null);
    }
}

export class StockLocationsResponse implements IStockLocationsResponse {
    stockLocations?: StockLocation[] | undefined;
    status?: StockLocationsResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IStockLocationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stockLocations"])) {
                this.stockLocations = [] as any;
                for (let item of _data["stockLocations"])
                    this.stockLocations!.push(StockLocation.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): StockLocationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StockLocationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stockLocations)) {
            data["stockLocations"] = [];
            for (let item of this.stockLocations)
                data["stockLocations"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IStockLocationsResponse {
    stockLocations?: StockLocation[] | undefined;
    status?: StockLocationsResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class StockLocation implements IStockLocation {
    branchId?: number | undefined;
    name?: string | undefined;
    id?: number | undefined;
    stockLocationCode?: string | undefined;

    constructor(data?: IStockLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.name = _data["name"];
            this.id = _data["id"];
            this.stockLocationCode = _data["stockLocationCode"];
        }
    }

    static fromJS(data: any): StockLocation {
        data = typeof data === 'object' ? data : {};
        let result = new StockLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["name"] = this.name;
        data["id"] = this.id;
        data["stockLocationCode"] = this.stockLocationCode;
        return data; 
    }
}

export interface IStockLocation {
    branchId?: number | undefined;
    name?: string | undefined;
    id?: number | undefined;
    stockLocationCode?: string | undefined;
}

export class BranchesResponse implements IBranchesResponse {
    branches?: Branch[] | undefined;
    status?: BranchesResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IBranchesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["branches"])) {
                this.branches = [] as any;
                for (let item of _data["branches"])
                    this.branches!.push(Branch.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): BranchesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BranchesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.branches)) {
            data["branches"] = [];
            for (let item of this.branches)
                data["branches"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IBranchesResponse {
    branches?: Branch[] | undefined;
    status?: BranchesResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class Branch implements IBranch {
    calcTaxBasedOnBranchTaxArea?: number | undefined;
    taxAreaID?: number | undefined;
    id?: number | undefined;
    name?: string | undefined;
    regionId?: number | undefined;
    branchCode?: string | undefined;
    divisionId?: number | undefined;
    defaultStockLocationId?: number | undefined;
    wmsInstanceID?: number | undefined;
    city?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    county?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;
    fullAddress?: string | undefined;
    avoFormatSet?: string | undefined;
    deliveryFormatSetCash?: string | undefined;
    deliveryFormatSetCredit?: string | undefined;
    transferDeliveryFormatSet?: string | undefined;
    collectLaterFormatSetCash?: string | undefined;
    collectLaterFormatSetCredit?: string | undefined;
    collectNowPickingDocumentFormatSet?: string | undefined;
    specialOrderAcknowledgementDocumentFormatSet?: string | undefined;
    orderAmendPrintFormatSet?: string | undefined;
    additionalCostFormat?: string | undefined;
    pickingNoteFormat?: string | undefined;
    deliveryNoteFormat?: string | undefined;
    collectionNoteFormat?: string | undefined;
    depositReceiptFormat?: string | undefined;
    pickingZonesFormatNumbers?: string | undefined;
    readonly collateJourneySetPrintingBy?: number | undefined;
    readonly collateDocumentPrintingBy?: number | undefined;

    constructor(data?: IBranch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calcTaxBasedOnBranchTaxArea = _data["calcTaxBasedOnBranchTaxArea"];
            this.taxAreaID = _data["taxAreaID"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.regionId = _data["regionId"];
            this.branchCode = _data["branchCode"];
            this.divisionId = _data["divisionId"];
            this.defaultStockLocationId = _data["defaultStockLocationId"];
            this.wmsInstanceID = _data["wmsInstanceID"];
            this.city = _data["city"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.county = _data["county"];
            this.postCode = _data["postCode"];
            this.country = _data["country"];
            this.fullAddress = _data["fullAddress"];
            this.avoFormatSet = _data["avoFormatSet"];
            this.deliveryFormatSetCash = _data["deliveryFormatSetCash"];
            this.deliveryFormatSetCredit = _data["deliveryFormatSetCredit"];
            this.transferDeliveryFormatSet = _data["transferDeliveryFormatSet"];
            this.collectLaterFormatSetCash = _data["collectLaterFormatSetCash"];
            this.collectLaterFormatSetCredit = _data["collectLaterFormatSetCredit"];
            this.collectNowPickingDocumentFormatSet = _data["collectNowPickingDocumentFormatSet"];
            this.specialOrderAcknowledgementDocumentFormatSet = _data["specialOrderAcknowledgementDocumentFormatSet"];
            this.orderAmendPrintFormatSet = _data["orderAmendPrintFormatSet"];
            this.additionalCostFormat = _data["additionalCostFormat"];
            this.pickingNoteFormat = _data["pickingNoteFormat"];
            this.deliveryNoteFormat = _data["deliveryNoteFormat"];
            this.collectionNoteFormat = _data["collectionNoteFormat"];
            this.depositReceiptFormat = _data["depositReceiptFormat"];
            this.pickingZonesFormatNumbers = _data["pickingZonesFormatNumbers"];
            (<any>this).collateJourneySetPrintingBy = _data["collateJourneySetPrintingBy"];
            (<any>this).collateDocumentPrintingBy = _data["collateDocumentPrintingBy"];
        }
    }

    static fromJS(data: any): Branch {
        data = typeof data === 'object' ? data : {};
        let result = new Branch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calcTaxBasedOnBranchTaxArea"] = this.calcTaxBasedOnBranchTaxArea;
        data["taxAreaID"] = this.taxAreaID;
        data["id"] = this.id;
        data["name"] = this.name;
        data["regionId"] = this.regionId;
        data["branchCode"] = this.branchCode;
        data["divisionId"] = this.divisionId;
        data["defaultStockLocationId"] = this.defaultStockLocationId;
        data["wmsInstanceID"] = this.wmsInstanceID;
        data["city"] = this.city;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["county"] = this.county;
        data["postCode"] = this.postCode;
        data["country"] = this.country;
        data["fullAddress"] = this.fullAddress;
        data["avoFormatSet"] = this.avoFormatSet;
        data["deliveryFormatSetCash"] = this.deliveryFormatSetCash;
        data["deliveryFormatSetCredit"] = this.deliveryFormatSetCredit;
        data["transferDeliveryFormatSet"] = this.transferDeliveryFormatSet;
        data["collectLaterFormatSetCash"] = this.collectLaterFormatSetCash;
        data["collectLaterFormatSetCredit"] = this.collectLaterFormatSetCredit;
        data["collectNowPickingDocumentFormatSet"] = this.collectNowPickingDocumentFormatSet;
        data["specialOrderAcknowledgementDocumentFormatSet"] = this.specialOrderAcknowledgementDocumentFormatSet;
        data["orderAmendPrintFormatSet"] = this.orderAmendPrintFormatSet;
        data["additionalCostFormat"] = this.additionalCostFormat;
        data["pickingNoteFormat"] = this.pickingNoteFormat;
        data["deliveryNoteFormat"] = this.deliveryNoteFormat;
        data["collectionNoteFormat"] = this.collectionNoteFormat;
        data["depositReceiptFormat"] = this.depositReceiptFormat;
        data["pickingZonesFormatNumbers"] = this.pickingZonesFormatNumbers;
        data["collateJourneySetPrintingBy"] = this.collateJourneySetPrintingBy;
        data["collateDocumentPrintingBy"] = this.collateDocumentPrintingBy;
        return data; 
    }
}

export interface IBranch {
    calcTaxBasedOnBranchTaxArea?: number | undefined;
    taxAreaID?: number | undefined;
    id?: number | undefined;
    name?: string | undefined;
    regionId?: number | undefined;
    branchCode?: string | undefined;
    divisionId?: number | undefined;
    defaultStockLocationId?: number | undefined;
    wmsInstanceID?: number | undefined;
    city?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    county?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;
    fullAddress?: string | undefined;
    avoFormatSet?: string | undefined;
    deliveryFormatSetCash?: string | undefined;
    deliveryFormatSetCredit?: string | undefined;
    transferDeliveryFormatSet?: string | undefined;
    collectLaterFormatSetCash?: string | undefined;
    collectLaterFormatSetCredit?: string | undefined;
    collectNowPickingDocumentFormatSet?: string | undefined;
    specialOrderAcknowledgementDocumentFormatSet?: string | undefined;
    orderAmendPrintFormatSet?: string | undefined;
    additionalCostFormat?: string | undefined;
    pickingNoteFormat?: string | undefined;
    deliveryNoteFormat?: string | undefined;
    collectionNoteFormat?: string | undefined;
    depositReceiptFormat?: string | undefined;
    pickingZonesFormatNumbers?: string | undefined;
    collateJourneySetPrintingBy?: number | undefined;
    collateDocumentPrintingBy?: number | undefined;
}

export class ComputersResponse implements IComputersResponse {
    computers?: Computer[] | undefined;
    status?: ComputersResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IComputersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["computers"])) {
                this.computers = [] as any;
                for (let item of _data["computers"])
                    this.computers!.push(Computer.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): ComputersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ComputersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.computers)) {
            data["computers"] = [];
            for (let item of this.computers)
                data["computers"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IComputersResponse {
    computers?: Computer[] | undefined;
    status?: ComputersResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class Computer implements IComputer {
    computerID?: number | undefined;
    deleted?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    terminalServicesClient?: boolean | undefined;
    terminalServer?: string | undefined;
    terminalServerReportsPath?: string | undefined;
    reportServerName?: string | undefined;
    defaultSaleType?: number | undefined;
    defaultCounterSaleType?: number | undefined;
    defaultOrderPlacementType?: number | undefined;
    defaultComputer?: boolean | undefined;
    poleType?: number | undefined;
    poleCOMPort?: number | undefined;
    poleBPS?: string | undefined;
    poleDataBits?: string | undefined;
    poleParity?: string | undefined;
    poleStopBits?: string | undefined;
    poleFlowControl?: number | undefined;
    poleProductTextTop?: string | undefined;
    poleProductTextTopScroll?: boolean | undefined;
    poleProductTextBottom?: string | undefined;
    poleFinalTextTop?: string | undefined;
    poleFinalTextTopScroll?: boolean | undefined;
    poleFinalTextBottom?: string | undefined;
    poleChangeTextTop?: string | undefined;
    poleChangeTextTopScroll?: boolean | undefined;
    poleChangeTextBottom?: string | undefined;
    signatureDevice?: number | undefined;
    signatureImageWidth?: number | undefined;
    signatureImageHeight?: number | undefined;
    pinPadID?: number | undefined;
    cnppinPadID?: number | undefined;
    departmentID?: number | undefined;
    directionsSourceID?: number | undefined;
    disableOperationsStaffNoTimeout?: boolean | undefined;
    messageQueueServer?: string | undefined;
    defaultShowMarginCostToOff?: boolean | undefined;
    defaultLabelPrinter?: string | undefined;
    defaultTabOnSalesOrderForm?: number | undefined;
    swipeAhead?: boolean | undefined;
    poleIP?: string | undefined;
    poleIPPort?: number | undefined;
    poleBorderWidth?: number | undefined;
    poleBorderColor?: number | undefined;
    poleTotalFontSize?: number | undefined;
    poleGridFontSize?: number | undefined;
    airMilesTerminalID?: string | undefined;
    airMilesServerIPAddress?: string | undefined;
    airMilesServerPortNumber?: number | undefined;
    allowPaymentsOnSalesOrders?: boolean | undefined;
    defaultWMSPickingStatus?: number | undefined;
    defaultCounterWMSPickingStatus?: number | undefined;
    goToProductAfterEnteringCustomer?: number | undefined;
    defaultIssuingBranchID?: number | undefined;
    showQuickProducts?: number | undefined;
    defaultOrderInput?: number | undefined;
    lockOrderInput?: boolean | undefined;
    defaultOrderRowHeight?: number | undefined;
    includeSpecialsDefault?: number | undefined;
    includeNonStockedDefault?: number | undefined;
    defaultMergeProductsOnOrder?: number | undefined;
    hideInTerminalServicesClientDialog?: boolean | undefined;
    scaleDevice?: number | undefined;
    scaleCOMPort?: number | undefined;
    scaleBaudRate?: number | undefined;
    scaleDataBits?: number | undefined;
    scaleParity?: number | undefined;
    scaleStopBits?: number | undefined;
    staffNumberTimeout?: number | undefined;
    newOrderOnCompletion?: number | undefined;
    stockWarningsWhenNoStockUpdates?: boolean | undefined;
    cashDrawerName?: string | undefined;
    cashDrawerBranchName?: string | undefined;
    departmentName?: string | undefined;

    constructor(data?: IComputer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.computerID = _data["computerID"];
            this.deleted = _data["deleted"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.terminalServicesClient = _data["terminalServicesClient"];
            this.terminalServer = _data["terminalServer"];
            this.terminalServerReportsPath = _data["terminalServerReportsPath"];
            this.reportServerName = _data["reportServerName"];
            this.defaultSaleType = _data["defaultSaleType"];
            this.defaultCounterSaleType = _data["defaultCounterSaleType"];
            this.defaultOrderPlacementType = _data["defaultOrderPlacementType"];
            this.defaultComputer = _data["defaultComputer"];
            this.poleType = _data["poleType"];
            this.poleCOMPort = _data["poleCOMPort"];
            this.poleBPS = _data["poleBPS"];
            this.poleDataBits = _data["poleDataBits"];
            this.poleParity = _data["poleParity"];
            this.poleStopBits = _data["poleStopBits"];
            this.poleFlowControl = _data["poleFlowControl"];
            this.poleProductTextTop = _data["poleProductTextTop"];
            this.poleProductTextTopScroll = _data["poleProductTextTopScroll"];
            this.poleProductTextBottom = _data["poleProductTextBottom"];
            this.poleFinalTextTop = _data["poleFinalTextTop"];
            this.poleFinalTextTopScroll = _data["poleFinalTextTopScroll"];
            this.poleFinalTextBottom = _data["poleFinalTextBottom"];
            this.poleChangeTextTop = _data["poleChangeTextTop"];
            this.poleChangeTextTopScroll = _data["poleChangeTextTopScroll"];
            this.poleChangeTextBottom = _data["poleChangeTextBottom"];
            this.signatureDevice = _data["signatureDevice"];
            this.signatureImageWidth = _data["signatureImageWidth"];
            this.signatureImageHeight = _data["signatureImageHeight"];
            this.pinPadID = _data["pinPadID"];
            this.cnppinPadID = _data["cnppinPadID"];
            this.departmentID = _data["departmentID"];
            this.directionsSourceID = _data["directionsSourceID"];
            this.disableOperationsStaffNoTimeout = _data["disableOperationsStaffNoTimeout"];
            this.messageQueueServer = _data["messageQueueServer"];
            this.defaultShowMarginCostToOff = _data["defaultShowMarginCostToOff"];
            this.defaultLabelPrinter = _data["defaultLabelPrinter"];
            this.defaultTabOnSalesOrderForm = _data["defaultTabOnSalesOrderForm"];
            this.swipeAhead = _data["swipeAhead"];
            this.poleIP = _data["poleIP"];
            this.poleIPPort = _data["poleIPPort"];
            this.poleBorderWidth = _data["poleBorderWidth"];
            this.poleBorderColor = _data["poleBorderColor"];
            this.poleTotalFontSize = _data["poleTotalFontSize"];
            this.poleGridFontSize = _data["poleGridFontSize"];
            this.airMilesTerminalID = _data["airMilesTerminalID"];
            this.airMilesServerIPAddress = _data["airMilesServerIPAddress"];
            this.airMilesServerPortNumber = _data["airMilesServerPortNumber"];
            this.allowPaymentsOnSalesOrders = _data["allowPaymentsOnSalesOrders"];
            this.defaultWMSPickingStatus = _data["defaultWMSPickingStatus"];
            this.defaultCounterWMSPickingStatus = _data["defaultCounterWMSPickingStatus"];
            this.goToProductAfterEnteringCustomer = _data["goToProductAfterEnteringCustomer"];
            this.defaultIssuingBranchID = _data["defaultIssuingBranchID"];
            this.showQuickProducts = _data["showQuickProducts"];
            this.defaultOrderInput = _data["defaultOrderInput"];
            this.lockOrderInput = _data["lockOrderInput"];
            this.defaultOrderRowHeight = _data["defaultOrderRowHeight"];
            this.includeSpecialsDefault = _data["includeSpecialsDefault"];
            this.includeNonStockedDefault = _data["includeNonStockedDefault"];
            this.defaultMergeProductsOnOrder = _data["defaultMergeProductsOnOrder"];
            this.hideInTerminalServicesClientDialog = _data["hideInTerminalServicesClientDialog"];
            this.scaleDevice = _data["scaleDevice"];
            this.scaleCOMPort = _data["scaleCOMPort"];
            this.scaleBaudRate = _data["scaleBaudRate"];
            this.scaleDataBits = _data["scaleDataBits"];
            this.scaleParity = _data["scaleParity"];
            this.scaleStopBits = _data["scaleStopBits"];
            this.staffNumberTimeout = _data["staffNumberTimeout"];
            this.newOrderOnCompletion = _data["newOrderOnCompletion"];
            this.stockWarningsWhenNoStockUpdates = _data["stockWarningsWhenNoStockUpdates"];
            this.cashDrawerName = _data["cashDrawerName"];
            this.cashDrawerBranchName = _data["cashDrawerBranchName"];
            this.departmentName = _data["departmentName"];
        }
    }

    static fromJS(data: any): Computer {
        data = typeof data === 'object' ? data : {};
        let result = new Computer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["computerID"] = this.computerID;
        data["deleted"] = this.deleted;
        data["name"] = this.name;
        data["description"] = this.description;
        data["terminalServicesClient"] = this.terminalServicesClient;
        data["terminalServer"] = this.terminalServer;
        data["terminalServerReportsPath"] = this.terminalServerReportsPath;
        data["reportServerName"] = this.reportServerName;
        data["defaultSaleType"] = this.defaultSaleType;
        data["defaultCounterSaleType"] = this.defaultCounterSaleType;
        data["defaultOrderPlacementType"] = this.defaultOrderPlacementType;
        data["defaultComputer"] = this.defaultComputer;
        data["poleType"] = this.poleType;
        data["poleCOMPort"] = this.poleCOMPort;
        data["poleBPS"] = this.poleBPS;
        data["poleDataBits"] = this.poleDataBits;
        data["poleParity"] = this.poleParity;
        data["poleStopBits"] = this.poleStopBits;
        data["poleFlowControl"] = this.poleFlowControl;
        data["poleProductTextTop"] = this.poleProductTextTop;
        data["poleProductTextTopScroll"] = this.poleProductTextTopScroll;
        data["poleProductTextBottom"] = this.poleProductTextBottom;
        data["poleFinalTextTop"] = this.poleFinalTextTop;
        data["poleFinalTextTopScroll"] = this.poleFinalTextTopScroll;
        data["poleFinalTextBottom"] = this.poleFinalTextBottom;
        data["poleChangeTextTop"] = this.poleChangeTextTop;
        data["poleChangeTextTopScroll"] = this.poleChangeTextTopScroll;
        data["poleChangeTextBottom"] = this.poleChangeTextBottom;
        data["signatureDevice"] = this.signatureDevice;
        data["signatureImageWidth"] = this.signatureImageWidth;
        data["signatureImageHeight"] = this.signatureImageHeight;
        data["pinPadID"] = this.pinPadID;
        data["cnppinPadID"] = this.cnppinPadID;
        data["departmentID"] = this.departmentID;
        data["directionsSourceID"] = this.directionsSourceID;
        data["disableOperationsStaffNoTimeout"] = this.disableOperationsStaffNoTimeout;
        data["messageQueueServer"] = this.messageQueueServer;
        data["defaultShowMarginCostToOff"] = this.defaultShowMarginCostToOff;
        data["defaultLabelPrinter"] = this.defaultLabelPrinter;
        data["defaultTabOnSalesOrderForm"] = this.defaultTabOnSalesOrderForm;
        data["swipeAhead"] = this.swipeAhead;
        data["poleIP"] = this.poleIP;
        data["poleIPPort"] = this.poleIPPort;
        data["poleBorderWidth"] = this.poleBorderWidth;
        data["poleBorderColor"] = this.poleBorderColor;
        data["poleTotalFontSize"] = this.poleTotalFontSize;
        data["poleGridFontSize"] = this.poleGridFontSize;
        data["airMilesTerminalID"] = this.airMilesTerminalID;
        data["airMilesServerIPAddress"] = this.airMilesServerIPAddress;
        data["airMilesServerPortNumber"] = this.airMilesServerPortNumber;
        data["allowPaymentsOnSalesOrders"] = this.allowPaymentsOnSalesOrders;
        data["defaultWMSPickingStatus"] = this.defaultWMSPickingStatus;
        data["defaultCounterWMSPickingStatus"] = this.defaultCounterWMSPickingStatus;
        data["goToProductAfterEnteringCustomer"] = this.goToProductAfterEnteringCustomer;
        data["defaultIssuingBranchID"] = this.defaultIssuingBranchID;
        data["showQuickProducts"] = this.showQuickProducts;
        data["defaultOrderInput"] = this.defaultOrderInput;
        data["lockOrderInput"] = this.lockOrderInput;
        data["defaultOrderRowHeight"] = this.defaultOrderRowHeight;
        data["includeSpecialsDefault"] = this.includeSpecialsDefault;
        data["includeNonStockedDefault"] = this.includeNonStockedDefault;
        data["defaultMergeProductsOnOrder"] = this.defaultMergeProductsOnOrder;
        data["hideInTerminalServicesClientDialog"] = this.hideInTerminalServicesClientDialog;
        data["scaleDevice"] = this.scaleDevice;
        data["scaleCOMPort"] = this.scaleCOMPort;
        data["scaleBaudRate"] = this.scaleBaudRate;
        data["scaleDataBits"] = this.scaleDataBits;
        data["scaleParity"] = this.scaleParity;
        data["scaleStopBits"] = this.scaleStopBits;
        data["staffNumberTimeout"] = this.staffNumberTimeout;
        data["newOrderOnCompletion"] = this.newOrderOnCompletion;
        data["stockWarningsWhenNoStockUpdates"] = this.stockWarningsWhenNoStockUpdates;
        data["cashDrawerName"] = this.cashDrawerName;
        data["cashDrawerBranchName"] = this.cashDrawerBranchName;
        data["departmentName"] = this.departmentName;
        return data; 
    }
}

export interface IComputer {
    computerID?: number | undefined;
    deleted?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    terminalServicesClient?: boolean | undefined;
    terminalServer?: string | undefined;
    terminalServerReportsPath?: string | undefined;
    reportServerName?: string | undefined;
    defaultSaleType?: number | undefined;
    defaultCounterSaleType?: number | undefined;
    defaultOrderPlacementType?: number | undefined;
    defaultComputer?: boolean | undefined;
    poleType?: number | undefined;
    poleCOMPort?: number | undefined;
    poleBPS?: string | undefined;
    poleDataBits?: string | undefined;
    poleParity?: string | undefined;
    poleStopBits?: string | undefined;
    poleFlowControl?: number | undefined;
    poleProductTextTop?: string | undefined;
    poleProductTextTopScroll?: boolean | undefined;
    poleProductTextBottom?: string | undefined;
    poleFinalTextTop?: string | undefined;
    poleFinalTextTopScroll?: boolean | undefined;
    poleFinalTextBottom?: string | undefined;
    poleChangeTextTop?: string | undefined;
    poleChangeTextTopScroll?: boolean | undefined;
    poleChangeTextBottom?: string | undefined;
    signatureDevice?: number | undefined;
    signatureImageWidth?: number | undefined;
    signatureImageHeight?: number | undefined;
    pinPadID?: number | undefined;
    cnppinPadID?: number | undefined;
    departmentID?: number | undefined;
    directionsSourceID?: number | undefined;
    disableOperationsStaffNoTimeout?: boolean | undefined;
    messageQueueServer?: string | undefined;
    defaultShowMarginCostToOff?: boolean | undefined;
    defaultLabelPrinter?: string | undefined;
    defaultTabOnSalesOrderForm?: number | undefined;
    swipeAhead?: boolean | undefined;
    poleIP?: string | undefined;
    poleIPPort?: number | undefined;
    poleBorderWidth?: number | undefined;
    poleBorderColor?: number | undefined;
    poleTotalFontSize?: number | undefined;
    poleGridFontSize?: number | undefined;
    airMilesTerminalID?: string | undefined;
    airMilesServerIPAddress?: string | undefined;
    airMilesServerPortNumber?: number | undefined;
    allowPaymentsOnSalesOrders?: boolean | undefined;
    defaultWMSPickingStatus?: number | undefined;
    defaultCounterWMSPickingStatus?: number | undefined;
    goToProductAfterEnteringCustomer?: number | undefined;
    defaultIssuingBranchID?: number | undefined;
    showQuickProducts?: number | undefined;
    defaultOrderInput?: number | undefined;
    lockOrderInput?: boolean | undefined;
    defaultOrderRowHeight?: number | undefined;
    includeSpecialsDefault?: number | undefined;
    includeNonStockedDefault?: number | undefined;
    defaultMergeProductsOnOrder?: number | undefined;
    hideInTerminalServicesClientDialog?: boolean | undefined;
    scaleDevice?: number | undefined;
    scaleCOMPort?: number | undefined;
    scaleBaudRate?: number | undefined;
    scaleDataBits?: number | undefined;
    scaleParity?: number | undefined;
    scaleStopBits?: number | undefined;
    staffNumberTimeout?: number | undefined;
    newOrderOnCompletion?: number | undefined;
    stockWarningsWhenNoStockUpdates?: boolean | undefined;
    cashDrawerName?: string | undefined;
    cashDrawerBranchName?: string | undefined;
    departmentName?: string | undefined;
}

export class VehicleTypesResponse implements IVehicleTypesResponse {
    vehicleTypes?: VehicleType[] | undefined;
    status?: VehicleTypesResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IVehicleTypesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vehicleTypes"])) {
                this.vehicleTypes = [] as any;
                for (let item of _data["vehicleTypes"])
                    this.vehicleTypes!.push(VehicleType.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): VehicleTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vehicleTypes)) {
            data["vehicleTypes"] = [];
            for (let item of this.vehicleTypes)
                data["vehicleTypes"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IVehicleTypesResponse {
    vehicleTypes?: VehicleType[] | undefined;
    status?: VehicleTypesResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class VehicleType implements IVehicleType {
    id?: number | undefined;
    name?: string | undefined;
    trailerType?: VehicleTypeTrailerType | undefined;

    constructor(data?: IVehicleType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.trailerType = _data["trailerType"];
        }
    }

    static fromJS(data: any): VehicleType {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["trailerType"] = this.trailerType;
        return data; 
    }
}

export interface IVehicleType {
    id?: number | undefined;
    name?: string | undefined;
    trailerType?: VehicleTypeTrailerType | undefined;
}

export class VehicleResponse implements IVehicleResponse {
    /** Get or set the Vehicle information */
    vehicle?: Vehicle | undefined;
    /** Get or set the user interaction information */
    userDialogRequest?: UserDialogRequestParams | undefined;
    status?: VehicleResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IVehicleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle = _data["vehicle"] ? Vehicle.fromJS(_data["vehicle"]) : <any>undefined;
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): VehicleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IVehicleResponse {
    /** Get or set the Vehicle information */
    vehicle?: Vehicle | undefined;
    /** Get or set the user interaction information */
    userDialogRequest?: UserDialogRequestParams | undefined;
    status?: VehicleResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class Vehicle implements IVehicle {
    id?: number | undefined;
    defaultUnloadTime?: number | undefined;
    maxWeight?: number | undefined;
    maxVolume?: number | undefined;
    name?: string | undefined;
    trailerType?: VehicleTrailerType | undefined;
    branchId?: number | undefined;
    isAvailableSun?: boolean | undefined;
    isAvailableMon?: boolean | undefined;
    isAvailableTue?: boolean | undefined;
    isAvailableWed?: boolean | undefined;
    isAvailableThu?: boolean | undefined;
    isAvailableFri?: boolean | undefined;
    isAvailableSat?: boolean | undefined;
    vehicleTypeID?: number | undefined;
    vehicleTypeName?: string | undefined;
    driverId?: number | undefined;
    driverName?: string | undefined;
    registration?: string | undefined;
    exceptions?: VehicleException[] | undefined;
    moreFields?: UdfInfo[] | undefined;
    displayWeight?: string | undefined;
    displayVolume?: string | undefined;

    constructor(data?: IVehicle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.defaultUnloadTime = _data["defaultUnloadTime"];
            this.maxWeight = _data["maxWeight"];
            this.maxVolume = _data["maxVolume"];
            this.name = _data["name"];
            this.trailerType = _data["trailerType"];
            this.branchId = _data["branchId"];
            this.isAvailableSun = _data["isAvailableSun"];
            this.isAvailableMon = _data["isAvailableMon"];
            this.isAvailableTue = _data["isAvailableTue"];
            this.isAvailableWed = _data["isAvailableWed"];
            this.isAvailableThu = _data["isAvailableThu"];
            this.isAvailableFri = _data["isAvailableFri"];
            this.isAvailableSat = _data["isAvailableSat"];
            this.vehicleTypeID = _data["vehicleTypeID"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.driverId = _data["driverId"];
            this.driverName = _data["driverName"];
            this.registration = _data["registration"];
            if (Array.isArray(_data["exceptions"])) {
                this.exceptions = [] as any;
                for (let item of _data["exceptions"])
                    this.exceptions!.push(VehicleException.fromJS(item));
            }
            if (Array.isArray(_data["moreFields"])) {
                this.moreFields = [] as any;
                for (let item of _data["moreFields"])
                    this.moreFields!.push(UdfInfo.fromJS(item));
            }
            this.displayWeight = _data["displayWeight"];
            this.displayVolume = _data["displayVolume"];
        }
    }

    static fromJS(data: any): Vehicle {
        data = typeof data === 'object' ? data : {};
        let result = new Vehicle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["defaultUnloadTime"] = this.defaultUnloadTime;
        data["maxWeight"] = this.maxWeight;
        data["maxVolume"] = this.maxVolume;
        data["name"] = this.name;
        data["trailerType"] = this.trailerType;
        data["branchId"] = this.branchId;
        data["isAvailableSun"] = this.isAvailableSun;
        data["isAvailableMon"] = this.isAvailableMon;
        data["isAvailableTue"] = this.isAvailableTue;
        data["isAvailableWed"] = this.isAvailableWed;
        data["isAvailableThu"] = this.isAvailableThu;
        data["isAvailableFri"] = this.isAvailableFri;
        data["isAvailableSat"] = this.isAvailableSat;
        data["vehicleTypeID"] = this.vehicleTypeID;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["driverId"] = this.driverId;
        data["driverName"] = this.driverName;
        data["registration"] = this.registration;
        if (Array.isArray(this.exceptions)) {
            data["exceptions"] = [];
            for (let item of this.exceptions)
                data["exceptions"].push(item.toJSON());
        }
        if (Array.isArray(this.moreFields)) {
            data["moreFields"] = [];
            for (let item of this.moreFields)
                data["moreFields"].push(item.toJSON());
        }
        data["displayWeight"] = this.displayWeight;
        data["displayVolume"] = this.displayVolume;
        return data; 
    }
}

export interface IVehicle {
    id?: number | undefined;
    defaultUnloadTime?: number | undefined;
    maxWeight?: number | undefined;
    maxVolume?: number | undefined;
    name?: string | undefined;
    trailerType?: VehicleTrailerType | undefined;
    branchId?: number | undefined;
    isAvailableSun?: boolean | undefined;
    isAvailableMon?: boolean | undefined;
    isAvailableTue?: boolean | undefined;
    isAvailableWed?: boolean | undefined;
    isAvailableThu?: boolean | undefined;
    isAvailableFri?: boolean | undefined;
    isAvailableSat?: boolean | undefined;
    vehicleTypeID?: number | undefined;
    vehicleTypeName?: string | undefined;
    driverId?: number | undefined;
    driverName?: string | undefined;
    registration?: string | undefined;
    exceptions?: VehicleException[] | undefined;
    moreFields?: UdfInfo[] | undefined;
    displayWeight?: string | undefined;
    displayVolume?: string | undefined;
}

export class UserDialogRequestParams implements IUserDialogRequestParams {
    id?: UserDialogRequestParamsId | undefined;
    message?: string | undefined;
    response?: UserDialogRequestParamsResponse | undefined;
    options?: string[] | undefined;
    repeatCall?: boolean | undefined;

    constructor(data?: IUserDialogRequestParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
            this.response = _data["response"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
            this.repeatCall = _data["repeatCall"];
        }
    }

    static fromJS(data: any): UserDialogRequestParams {
        data = typeof data === 'object' ? data : {};
        let result = new UserDialogRequestParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        data["response"] = this.response;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        data["repeatCall"] = this.repeatCall;
        return data; 
    }
}

export interface IUserDialogRequestParams {
    id?: UserDialogRequestParamsId | undefined;
    message?: string | undefined;
    response?: UserDialogRequestParamsResponse | undefined;
    options?: string[] | undefined;
    repeatCall?: boolean | undefined;
}

export class VehicleException implements IVehicleException {
    vehicleExceptionID?: number | undefined;
    vehicleID?: number | undefined;
    exceptionDate?: Date | undefined;
    available?: boolean | undefined;
    deleted?: number | undefined;
    branchId?: number | undefined;

    constructor(data?: IVehicleException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleExceptionID = _data["vehicleExceptionID"];
            this.vehicleID = _data["vehicleID"];
            this.exceptionDate = _data["exceptionDate"] ? new Date(_data["exceptionDate"].toString()) : <any>undefined;
            this.available = _data["available"];
            this.deleted = _data["deleted"];
            this.branchId = _data["branchId"];
        }
    }

    static fromJS(data: any): VehicleException {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleExceptionID"] = this.vehicleExceptionID;
        data["vehicleID"] = this.vehicleID;
        data["exceptionDate"] = this.exceptionDate ? this.exceptionDate.toISOString() : <any>undefined;
        data["available"] = this.available;
        data["deleted"] = this.deleted;
        data["branchId"] = this.branchId;
        return data; 
    }
}

export interface IVehicleException {
    vehicleExceptionID?: number | undefined;
    vehicleID?: number | undefined;
    exceptionDate?: Date | undefined;
    available?: boolean | undefined;
    deleted?: number | undefined;
    branchId?: number | undefined;
}

export class UdfInfo implements IUdfInfo {
    value?: any | undefined;
    userDefinedField?: UserDefinedField | undefined;
    browseObjectValue?: { [key: string]: any; } | undefined;
    sqlDropdownObjectValue?: { [key: string]: any; } | undefined;
    sqlDropdownObjectValues?: { [key: string]: any; }[] | undefined;
    labelAndDataValue?: string | undefined;

    constructor(data?: IUdfInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.userDefinedField = _data["userDefinedField"] ? UserDefinedField.fromJS(_data["userDefinedField"]) : <any>undefined;
            if (_data["browseObjectValue"]) {
                this.browseObjectValue = {} as any;
                for (let key in _data["browseObjectValue"]) {
                    if (_data["browseObjectValue"].hasOwnProperty(key))
                        this.browseObjectValue![key] = _data["browseObjectValue"][key];
                }
            }
            if (_data["sqlDropdownObjectValue"]) {
                this.sqlDropdownObjectValue = {} as any;
                for (let key in _data["sqlDropdownObjectValue"]) {
                    if (_data["sqlDropdownObjectValue"].hasOwnProperty(key))
                        this.sqlDropdownObjectValue![key] = _data["sqlDropdownObjectValue"][key];
                }
            }
            if (Array.isArray(_data["sqlDropdownObjectValues"])) {
                this.sqlDropdownObjectValues = [] as any;
                for (let item of _data["sqlDropdownObjectValues"])
                    this.sqlDropdownObjectValues!.push(item);
            }
            this.labelAndDataValue = _data["labelAndDataValue"];
        }
    }

    static fromJS(data: any): UdfInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UdfInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["userDefinedField"] = this.userDefinedField ? this.userDefinedField.toJSON() : <any>undefined;
        if (this.browseObjectValue) {
            data["browseObjectValue"] = {};
            for (let key in this.browseObjectValue) {
                if (this.browseObjectValue.hasOwnProperty(key))
                    data["browseObjectValue"][key] = this.browseObjectValue[key];
            }
        }
        if (this.sqlDropdownObjectValue) {
            data["sqlDropdownObjectValue"] = {};
            for (let key in this.sqlDropdownObjectValue) {
                if (this.sqlDropdownObjectValue.hasOwnProperty(key))
                    data["sqlDropdownObjectValue"][key] = this.sqlDropdownObjectValue[key];
            }
        }
        if (Array.isArray(this.sqlDropdownObjectValues)) {
            data["sqlDropdownObjectValues"] = [];
            for (let item of this.sqlDropdownObjectValues)
                data["sqlDropdownObjectValues"].push(item);
        }
        data["labelAndDataValue"] = this.labelAndDataValue;
        return data; 
    }
}

export interface IUdfInfo {
    value?: any | undefined;
    userDefinedField?: UserDefinedField | undefined;
    browseObjectValue?: { [key: string]: any; } | undefined;
    sqlDropdownObjectValue?: { [key: string]: any; } | undefined;
    sqlDropdownObjectValues?: { [key: string]: any; }[] | undefined;
    labelAndDataValue?: string | undefined;
}

export class UserDefinedField implements IUserDefinedField {
    userDefinedFieldID?: number | undefined;
    tableName?: string | undefined;
    name?: string | undefined;
    sequence?: number | undefined;
    dbColumnName?: string | undefined;
    dbDefaultValue?: string | undefined;
    dbLength?: number | undefined;
    dbScale?: number | undefined;
    inputType?: number | undefined;
    inputPrompt?: string | undefined;
    inputWidth?: number | undefined;
    inputDefault?: string | undefined;
    inputMask?: string | undefined;
    inputErrorMessage?: string | undefined;
    inputRequired?: boolean | undefined;
    choices?: string | undefined;
    groupName?: string | undefined;
    visible?: boolean | undefined;
    displayTab?: number | undefined;
    validateAsLoyaltyCard?: boolean | undefined;
    lockAfterSet?: boolean | undefined;

    constructor(data?: IUserDefinedField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDefinedFieldID = _data["userDefinedFieldID"];
            this.tableName = _data["tableName"];
            this.name = _data["name"];
            this.sequence = _data["sequence"];
            this.dbColumnName = _data["dbColumnName"];
            this.dbDefaultValue = _data["dbDefaultValue"];
            this.dbLength = _data["dbLength"];
            this.dbScale = _data["dbScale"];
            this.inputType = _data["inputType"];
            this.inputPrompt = _data["inputPrompt"];
            this.inputWidth = _data["inputWidth"];
            this.inputDefault = _data["inputDefault"];
            this.inputMask = _data["inputMask"];
            this.inputErrorMessage = _data["inputErrorMessage"];
            this.inputRequired = _data["inputRequired"];
            this.choices = _data["choices"];
            this.groupName = _data["groupName"];
            this.visible = _data["visible"];
            this.displayTab = _data["displayTab"];
            this.validateAsLoyaltyCard = _data["validateAsLoyaltyCard"];
            this.lockAfterSet = _data["lockAfterSet"];
        }
    }

    static fromJS(data: any): UserDefinedField {
        data = typeof data === 'object' ? data : {};
        let result = new UserDefinedField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDefinedFieldID"] = this.userDefinedFieldID;
        data["tableName"] = this.tableName;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        data["dbColumnName"] = this.dbColumnName;
        data["dbDefaultValue"] = this.dbDefaultValue;
        data["dbLength"] = this.dbLength;
        data["dbScale"] = this.dbScale;
        data["inputType"] = this.inputType;
        data["inputPrompt"] = this.inputPrompt;
        data["inputWidth"] = this.inputWidth;
        data["inputDefault"] = this.inputDefault;
        data["inputMask"] = this.inputMask;
        data["inputErrorMessage"] = this.inputErrorMessage;
        data["inputRequired"] = this.inputRequired;
        data["choices"] = this.choices;
        data["groupName"] = this.groupName;
        data["visible"] = this.visible;
        data["displayTab"] = this.displayTab;
        data["validateAsLoyaltyCard"] = this.validateAsLoyaltyCard;
        data["lockAfterSet"] = this.lockAfterSet;
        return data; 
    }
}

export interface IUserDefinedField {
    userDefinedFieldID?: number | undefined;
    tableName?: string | undefined;
    name?: string | undefined;
    sequence?: number | undefined;
    dbColumnName?: string | undefined;
    dbDefaultValue?: string | undefined;
    dbLength?: number | undefined;
    dbScale?: number | undefined;
    inputType?: number | undefined;
    inputPrompt?: string | undefined;
    inputWidth?: number | undefined;
    inputDefault?: string | undefined;
    inputMask?: string | undefined;
    inputErrorMessage?: string | undefined;
    inputRequired?: boolean | undefined;
    choices?: string | undefined;
    groupName?: string | undefined;
    visible?: boolean | undefined;
    displayTab?: number | undefined;
    validateAsLoyaltyCard?: boolean | undefined;
    lockAfterSet?: boolean | undefined;
}

export class VehiclesQueryParams implements IVehiclesQueryParams {
    availableDate?: Date | undefined;
    branchIds?: string | undefined;
    userID?: number | undefined;
    trailerType?: VehiclesQueryParamsTrailerType | undefined;

    constructor(data?: IVehiclesQueryParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availableDate = _data["availableDate"] ? new Date(_data["availableDate"].toString()) : <any>undefined;
            this.branchIds = _data["branchIds"];
            this.userID = _data["userID"];
            this.trailerType = _data["trailerType"];
        }
    }

    static fromJS(data: any): VehiclesQueryParams {
        data = typeof data === 'object' ? data : {};
        let result = new VehiclesQueryParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availableDate"] = this.availableDate ? this.availableDate.toISOString() : <any>undefined;
        data["branchIds"] = this.branchIds;
        data["userID"] = this.userID;
        data["trailerType"] = this.trailerType;
        return data; 
    }
}

export interface IVehiclesQueryParams {
    availableDate?: Date | undefined;
    branchIds?: string | undefined;
    userID?: number | undefined;
    trailerType?: VehiclesQueryParamsTrailerType | undefined;
}

export class VehiclesListResponse implements IVehiclesListResponse {
    vehicles?: Vehicle[] | undefined;
    status?: VehiclesListResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IVehiclesListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles!.push(Vehicle.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): VehiclesListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VehiclesListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IVehiclesListResponse {
    vehicles?: Vehicle[] | undefined;
    status?: VehiclesListResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class DriversListResponse implements IDriversListResponse {
    drivers?: Driver[] | undefined;
    status?: DriversListResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IDriversListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["drivers"])) {
                this.drivers = [] as any;
                for (let item of _data["drivers"])
                    this.drivers!.push(Driver.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): DriversListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DriversListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.drivers)) {
            data["drivers"] = [];
            for (let item of this.drivers)
                data["drivers"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IDriversListResponse {
    drivers?: Driver[] | undefined;
    status?: DriversListResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class Driver implements IDriver {
    id?: number | undefined;
    name?: string | undefined;
    mobileNumber?: string | undefined;

    constructor(data?: IDriver) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.mobileNumber = _data["mobileNumber"];
        }
    }

    static fromJS(data: any): Driver {
        data = typeof data === 'object' ? data : {};
        let result = new Driver();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["mobileNumber"] = this.mobileNumber;
        return data; 
    }
}

export interface IDriver {
    id?: number | undefined;
    name?: string | undefined;
    mobileNumber?: string | undefined;
}

export class DocumentTypesResponse implements IDocumentTypesResponse {
    documentTypes?: DocumentType[] | undefined;
    status?: DocumentTypesResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IDocumentTypesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documentTypes"])) {
                this.documentTypes = [] as any;
                for (let item of _data["documentTypes"])
                    this.documentTypes!.push(DocumentType.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): DocumentTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentTypes)) {
            data["documentTypes"] = [];
            for (let item of this.documentTypes)
                data["documentTypes"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IDocumentTypesResponse {
    documentTypes?: DocumentType[] | undefined;
    status?: DocumentTypesResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class DocumentType implements IDocumentType {
    id?: DocumentTypeId | undefined;
    name?: string | undefined;

    constructor(data?: IDocumentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IDocumentType {
    id?: DocumentTypeId | undefined;
    name?: string | undefined;
}

export class SystemOptionResponse implements ISystemOptionResponse {
    systemOptions?: SystemOptions | undefined;
    status?: SystemOptionResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: ISystemOptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.systemOptions = _data["systemOptions"] ? SystemOptions.fromJS(_data["systemOptions"]) : <any>undefined;
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): SystemOptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SystemOptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systemOptions"] = this.systemOptions ? this.systemOptions.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface ISystemOptionResponse {
    systemOptions?: SystemOptions | undefined;
    status?: SystemOptionResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class VocabularyResponse implements IVocabularyResponse {
    vocabularies?: { [key: string]: string; } | undefined;
    status?: VocabularyResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IVocabularyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["vocabularies"]) {
                this.vocabularies = {} as any;
                for (let key in _data["vocabularies"]) {
                    if (_data["vocabularies"].hasOwnProperty(key))
                        this.vocabularies![key] = _data["vocabularies"][key];
                }
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): VocabularyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VocabularyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.vocabularies) {
            data["vocabularies"] = {};
            for (let key in this.vocabularies) {
                if (this.vocabularies.hasOwnProperty(key))
                    data["vocabularies"][key] = this.vocabularies[key];
            }
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IVocabularyResponse {
    vocabularies?: { [key: string]: string; } | undefined;
    status?: VocabularyResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class SystemOptionsQueryParams implements ISystemOptionsQueryParams {
    systemOptions?: SystemOptions2[] | undefined;

    constructor(data?: ISystemOptionsQueryParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["systemOptions"])) {
                this.systemOptions = [] as any;
                for (let item of _data["systemOptions"])
                    this.systemOptions!.push(item);
            }
        }
    }

    static fromJS(data: any): SystemOptionsQueryParams {
        data = typeof data === 'object' ? data : {};
        let result = new SystemOptionsQueryParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.systemOptions)) {
            data["systemOptions"] = [];
            for (let item of this.systemOptions)
                data["systemOptions"].push(item);
        }
        return data; 
    }
}

export interface ISystemOptionsQueryParams {
    systemOptions?: SystemOptions2[] | undefined;
}

export class VehicleUpdateResponse implements IVehicleUpdateResponse {
    userDialogRequest?: UserDialogRequestParams | undefined;
    status?: VehicleUpdateResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IVehicleUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): VehicleUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IVehicleUpdateResponse {
    userDialogRequest?: UserDialogRequestParams | undefined;
    status?: VehicleUpdateResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class AutoTextResponse implements IAutoTextResponse {
    autoTexts?: AutoText[] | undefined;
    status?: AutoTextResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IAutoTextResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["autoTexts"])) {
                this.autoTexts = [] as any;
                for (let item of _data["autoTexts"])
                    this.autoTexts!.push(AutoText.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): AutoTextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AutoTextResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.autoTexts)) {
            data["autoTexts"] = [];
            for (let item of this.autoTexts)
                data["autoTexts"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IAutoTextResponse {
    autoTexts?: AutoText[] | undefined;
    status?: AutoTextResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class AutoText implements IAutoText {
    autoTextID?: number | undefined;
    name?: string | undefined;
    text?: string | undefined;
    newLineAfter?: boolean | undefined;
    parentID?: number | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    branchList?: string | undefined;
    textTypeList?: string | undefined;

    constructor(data?: IAutoText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autoTextID = _data["autoTextID"];
            this.name = _data["name"];
            this.text = _data["text"];
            this.newLineAfter = _data["newLineAfter"];
            this.parentID = _data["parentID"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.branchList = _data["branchList"];
            this.textTypeList = _data["textTypeList"];
        }
    }

    static fromJS(data: any): AutoText {
        data = typeof data === 'object' ? data : {};
        let result = new AutoText();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autoTextID"] = this.autoTextID;
        data["name"] = this.name;
        data["text"] = this.text;
        data["newLineAfter"] = this.newLineAfter;
        data["parentID"] = this.parentID;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["branchList"] = this.branchList;
        data["textTypeList"] = this.textTypeList;
        return data; 
    }
}

export interface IAutoText {
    autoTextID?: number | undefined;
    name?: string | undefined;
    text?: string | undefined;
    newLineAfter?: boolean | undefined;
    parentID?: number | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    branchList?: string | undefined;
    textTypeList?: string | undefined;
}

export class DeliveryAreasResponse implements IDeliveryAreasResponse {
    deliveryAreas?: DeliveryArea[] | undefined;
    status?: DeliveryAreasResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IDeliveryAreasResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deliveryAreas"])) {
                this.deliveryAreas = [] as any;
                for (let item of _data["deliveryAreas"])
                    this.deliveryAreas!.push(DeliveryArea.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): DeliveryAreasResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryAreasResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deliveryAreas)) {
            data["deliveryAreas"] = [];
            for (let item of this.deliveryAreas)
                data["deliveryAreas"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IDeliveryAreasResponse {
    deliveryAreas?: DeliveryArea[] | undefined;
    status?: DeliveryAreasResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class DeliveryArea implements IDeliveryArea {
    deliveryAreaID?: number | undefined;
    deliveryAreaCode?: string | undefined;
    name?: string | undefined;
    congestionCharge?: number | undefined;
    webTrackOnly?: boolean | undefined;
    postCodeInformation?: string | undefined;
    deleted?: number | undefined;
    webTrackInstanceID?: number | undefined;
    autoScheduleRoute?: boolean | undefined;
    journeyID?: number | undefined;

    constructor(data?: IDeliveryArea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryAreaID = _data["deliveryAreaID"];
            this.deliveryAreaCode = _data["deliveryAreaCode"];
            this.name = _data["name"];
            this.congestionCharge = _data["congestionCharge"];
            this.webTrackOnly = _data["webTrackOnly"];
            this.postCodeInformation = _data["postCodeInformation"];
            this.deleted = _data["deleted"];
            this.webTrackInstanceID = _data["webTrackInstanceID"];
            this.autoScheduleRoute = _data["autoScheduleRoute"];
            this.journeyID = _data["journeyID"];
        }
    }

    static fromJS(data: any): DeliveryArea {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryArea();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryAreaID"] = this.deliveryAreaID;
        data["deliveryAreaCode"] = this.deliveryAreaCode;
        data["name"] = this.name;
        data["congestionCharge"] = this.congestionCharge;
        data["webTrackOnly"] = this.webTrackOnly;
        data["postCodeInformation"] = this.postCodeInformation;
        data["deleted"] = this.deleted;
        data["webTrackInstanceID"] = this.webTrackInstanceID;
        data["autoScheduleRoute"] = this.autoScheduleRoute;
        data["journeyID"] = this.journeyID;
        return data; 
    }
}

export interface IDeliveryArea {
    deliveryAreaID?: number | undefined;
    deliveryAreaCode?: string | undefined;
    name?: string | undefined;
    congestionCharge?: number | undefined;
    webTrackOnly?: boolean | undefined;
    postCodeInformation?: string | undefined;
    deleted?: number | undefined;
    webTrackInstanceID?: number | undefined;
    autoScheduleRoute?: boolean | undefined;
    journeyID?: number | undefined;
}

export class VehicleLocationResponse implements IVehicleLocationResponse {
    location?: VehicleLocation | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
    status?: VehicleLocationResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IVehicleLocationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"] ? VehicleLocation.fromJS(_data["location"]) : <any>undefined;
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): VehicleLocationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleLocationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IVehicleLocationResponse {
    location?: VehicleLocation | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
    status?: VehicleLocationResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class VehicleLocation implements IVehicleLocation {
    requestUrl?: string | undefined;
    authUrl?: string | undefined;
    mapUrl?: string | undefined;
    registration?: string | undefined;
    error?: string | undefined;
    when?: Date | undefined;
    lattitude?: string | undefined;
    longitude?: string | undefined;
    speed?: string | undefined;
    odometer?: string | undefined;
    direction?: string | undefined;
    ignition?: string | undefined;
    lastKnownLocation?: string | undefined;

    constructor(data?: IVehicleLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestUrl = _data["requestUrl"];
            this.authUrl = _data["authUrl"];
            this.mapUrl = _data["mapUrl"];
            this.registration = _data["registration"];
            this.error = _data["error"];
            this.when = _data["when"] ? new Date(_data["when"].toString()) : <any>undefined;
            this.lattitude = _data["lattitude"];
            this.longitude = _data["longitude"];
            this.speed = _data["speed"];
            this.odometer = _data["odometer"];
            this.direction = _data["direction"];
            this.ignition = _data["ignition"];
            this.lastKnownLocation = _data["lastKnownLocation"];
        }
    }

    static fromJS(data: any): VehicleLocation {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestUrl"] = this.requestUrl;
        data["authUrl"] = this.authUrl;
        data["mapUrl"] = this.mapUrl;
        data["registration"] = this.registration;
        data["error"] = this.error;
        data["when"] = this.when ? this.when.toISOString() : <any>undefined;
        data["lattitude"] = this.lattitude;
        data["longitude"] = this.longitude;
        data["speed"] = this.speed;
        data["odometer"] = this.odometer;
        data["direction"] = this.direction;
        data["ignition"] = this.ignition;
        data["lastKnownLocation"] = this.lastKnownLocation;
        return data; 
    }
}

export interface IVehicleLocation {
    requestUrl?: string | undefined;
    authUrl?: string | undefined;
    mapUrl?: string | undefined;
    registration?: string | undefined;
    error?: string | undefined;
    when?: Date | undefined;
    lattitude?: string | undefined;
    longitude?: string | undefined;
    speed?: string | undefined;
    odometer?: string | undefined;
    direction?: string | undefined;
    ignition?: string | undefined;
    lastKnownLocation?: string | undefined;
}

export class AuditRequest implements IAuditRequest {
    auditType?: AuditRequestAuditType | undefined;
    auditGroup?: AuditRequestAuditGroup | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    findText?: string | undefined;
    userID?: number | undefined;
    branchID?: number | undefined;
    customerID?: number | undefined;
    documentID?: number | undefined;
    newPageNumber?: number | undefined;
    findSupplierID?: number | undefined;
    loadAll?: boolean | undefined;

    constructor(data?: IAuditRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditType = _data["auditType"];
            this.auditGroup = _data["auditGroup"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.findText = _data["findText"];
            this.userID = _data["userID"];
            this.branchID = _data["branchID"];
            this.customerID = _data["customerID"];
            this.documentID = _data["documentID"];
            this.newPageNumber = _data["newPageNumber"];
            this.findSupplierID = _data["findSupplierID"];
            this.loadAll = _data["loadAll"];
        }
    }

    static fromJS(data: any): AuditRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuditRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditType"] = this.auditType;
        data["auditGroup"] = this.auditGroup;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["findText"] = this.findText;
        data["userID"] = this.userID;
        data["branchID"] = this.branchID;
        data["customerID"] = this.customerID;
        data["documentID"] = this.documentID;
        data["newPageNumber"] = this.newPageNumber;
        data["findSupplierID"] = this.findSupplierID;
        data["loadAll"] = this.loadAll;
        return data; 
    }
}

export interface IAuditRequest {
    auditType?: AuditRequestAuditType | undefined;
    auditGroup?: AuditRequestAuditGroup | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    findText?: string | undefined;
    userID?: number | undefined;
    branchID?: number | undefined;
    customerID?: number | undefined;
    documentID?: number | undefined;
    newPageNumber?: number | undefined;
    findSupplierID?: number | undefined;
    loadAll?: boolean | undefined;
}

export class AuditResponse implements IAuditResponse {
    recordCount?: number | undefined;
    auditItems?: AuditItem[] | undefined;
    status?: AuditResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IAuditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordCount = _data["recordCount"];
            if (Array.isArray(_data["auditItems"])) {
                this.auditItems = [] as any;
                for (let item of _data["auditItems"])
                    this.auditItems!.push(AuditItem.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): AuditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordCount"] = this.recordCount;
        if (Array.isArray(this.auditItems)) {
            data["auditItems"] = [];
            for (let item of this.auditItems)
                data["auditItems"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IAuditResponse {
    recordCount?: number | undefined;
    auditItems?: AuditItem[] | undefined;
    status?: AuditResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class AuditItem implements IAuditItem {
    auditID?: number | undefined;
    auditType?: string | undefined;
    auditDateTime?: Date | undefined;
    user?: string | undefined;
    branchName?: string | undefined;
    objectID?: number | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    otherInformation?: string | undefined;
    noOfRecords?: number | undefined;
    duration?: number | undefined;

    constructor(data?: IAuditItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.auditID = _data["auditID"];
            this.auditType = _data["auditType"];
            this.auditDateTime = _data["auditDateTime"] ? new Date(_data["auditDateTime"].toString()) : <any>undefined;
            this.user = _data["user"];
            this.branchName = _data["branchName"];
            this.objectID = _data["objectID"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.otherInformation = _data["otherInformation"];
            this.noOfRecords = _data["noOfRecords"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): AuditItem {
        data = typeof data === 'object' ? data : {};
        let result = new AuditItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditID"] = this.auditID;
        data["auditType"] = this.auditType;
        data["auditDateTime"] = this.auditDateTime ? this.auditDateTime.toISOString() : <any>undefined;
        data["user"] = this.user;
        data["branchName"] = this.branchName;
        data["objectID"] = this.objectID;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["otherInformation"] = this.otherInformation;
        data["noOfRecords"] = this.noOfRecords;
        data["duration"] = this.duration;
        return data; 
    }
}

export interface IAuditItem {
    auditID?: number | undefined;
    auditType?: string | undefined;
    auditDateTime?: Date | undefined;
    user?: string | undefined;
    branchName?: string | undefined;
    objectID?: number | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    otherInformation?: string | undefined;
    noOfRecords?: number | undefined;
    duration?: number | undefined;
}

export class SupplierRequest implements ISupplierRequest {
    supplierID?: number | undefined;
    includeInactive?: boolean | undefined;
    name?: string | undefined;
    supplierFilter?: SupplierRequestSupplierFilter | undefined;
    buyingSocietyID?: number | undefined;

    constructor(data?: ISupplierRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierID = _data["supplierID"];
            this.includeInactive = _data["includeInactive"];
            this.name = _data["name"];
            this.supplierFilter = _data["supplierFilter"];
            this.buyingSocietyID = _data["buyingSocietyID"];
        }
    }

    static fromJS(data: any): SupplierRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierID"] = this.supplierID;
        data["includeInactive"] = this.includeInactive;
        data["name"] = this.name;
        data["supplierFilter"] = this.supplierFilter;
        data["buyingSocietyID"] = this.buyingSocietyID;
        return data; 
    }
}

export interface ISupplierRequest {
    supplierID?: number | undefined;
    includeInactive?: boolean | undefined;
    name?: string | undefined;
    supplierFilter?: SupplierRequestSupplierFilter | undefined;
    buyingSocietyID?: number | undefined;
}

export class SupplierResponse implements ISupplierResponse {
    suppliers?: Supplier[] | undefined;
    status?: SupplierResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: ISupplierResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(Supplier.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): SupplierResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface ISupplierResponse {
    suppliers?: Supplier[] | undefined;
    status?: SupplierResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class Supplier implements ISupplier {
    supplierID?: number | undefined;
    deleted?: number | undefined;
    replacementID?: number | undefined;
    supplierCode?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    fullName?: string | undefined;
    payToSupplierID?: number | undefined;
    webAddress?: string | undefined;
    emailAddress?: string | undefined;
    contactName?: string | undefined;
    contactNumber?: string | undefined;
    addressCode?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;
    telephone1?: string | undefined;
    telephone2?: string | undefined;
    fax?: string | undefined;
    headerNotes?: string | undefined;
    notes?: string | undefined;
    popupText?: string | undefined;
    popupLastModifiedByID?: number | undefined;
    popupDateTimeLastModified?: Date | undefined;
    popupShowFromDate?: Date | undefined;
    popupShowEndDate?: Date | undefined;
    supplierTypeID?: number | undefined;
    defaultCountryID?: number | undefined;
    defaultCurrencyID?: number | undefined;
    onlyAllowSupplierCurrency?: boolean | undefined;
    vatRuleID?: number | undefined;
    defaultStockVatRuleID?: number | undefined;
    defaultOverheadVatRuleID?: number | undefined;
    defaultPurchaseOrderType?: number | undefined;
    defaultStockReceiptsToFullyReceived?: boolean | undefined;
    taxAreaID?: number | undefined;
    stevedoreCharge?: number | undefined;
    typeOfPurchase?: SupplierTypeOfPurchase | undefined;
    intrastatDeliveryTermsID?: number | undefined;
    intrastatTransportModeID?: number | undefined;
    deliveryCharge?: number | undefined;
    minOrderAmount?: number | undefined;
    paymentTermsID?: number | undefined;
    stockSupplier?: boolean | undefined;
    canDeliverDirect?: boolean | undefined;
    haulier?: boolean | undefined;
    subContractor?: boolean | undefined;
    allowSelfBilling?: boolean | undefined;
    chargeVat?: boolean | undefined;
    agent?: boolean | undefined;
    completesSD?: boolean | undefined;
    overheadSupplier?: boolean | undefined;
    overheadGLCodes?: string | undefined;
    chargesRollingMargin?: boolean | undefined;
    showEurosOnPO?: boolean | undefined;
    complete?: boolean | undefined;
    dateTimeCreated?: Date | undefined;
    dateTimeLastModified?: Date | undefined;
    dateTimeSynchronized?: Date | undefined;
    thirdPartyID?: number | undefined;
    inactive?: boolean | undefined;
    onHold?: boolean | undefined;
    scac?: string | undefined;
    vendor1099?: boolean | undefined;
    transportInstructionID?: number | undefined;
    usePayToSupplierTerms?: boolean | undefined;
    ediSupplierReference1?: string | undefined;
    ediSupplierReference2?: string | undefined;
    orderMethod?: SupplierOrderMethod | undefined;
    ediSupplierMessageFormat?: number | undefined;
    ediSupplierTransportMethod?: SupplierEdiSupplierTransportMethod | undefined;
    ediSupplierNextNumber?: number | undefined;
    ediCreateSupplierInvoice?: boolean | undefined;
    ediCreateStockReceipt?: boolean | undefined;
    ediRemittanceAdviceMethod?: SupplierEdiRemittanceAdviceMethod | undefined;
    ediInternalTradingCompanyID?: number | undefined;
    ediValidateSupplierInvoiceLines?: boolean | undefined;
    ediAddSupplierInvoiceLines?: number | undefined;
    ediCatalogueSubFolder?: string | undefined;
    ediCatalogueFormat?: number | undefined;
    ediCatalogueDelete?: boolean | undefined;
    ediCatalogueSupplierID?: string | undefined;
    ediAutoMatchAndApproveSupplierInvoice?: boolean | undefined;
    ediClaimsMethod?: SupplierEdiClaimsMethod | undefined;
    ediSalesHistoryMethod?: SupplierEdiSalesHistoryMethod | undefined;
    ediValidateSupplierInvoiceManualLines?: boolean | undefined;
    lastModifiedByID?: number | undefined;
    leadTime?: number | undefined;
    cutOff?: number | undefined;
    minimumWeight?: number | undefined;
    defaultPurchaseOrderToCollected?: boolean | undefined;
    ediFullyReceiveMissingLinesOnPOAck?: boolean | undefined;
    ediAllowPriceChangesToUpdatePriceUOM?: boolean | undefined;
    ediUpdatePurchaseOrderCost?: SupplierEdiUpdatePurchaseOrderCost | undefined;
    ediUpdatePurchaseOrderQuantity?: SupplierEdiUpdatePurchaseOrderQuantity | undefined;
    replacementCode?: string | undefined;
    replacementName?: string | undefined;
    notepadCount?: number | undefined;
    intrastatDeliveryTermsDescription?: string | undefined;
    intrastatTransportModeName?: string | undefined;
    payToSupplierCode?: string | undefined;
    payToSupplierName?: string | undefined;
    defaultStockTaxAreaID?: number | undefined;
    defaultOverheadTaxAreaID?: number | undefined;
    defaultPurchaseOrdersToCollected?: boolean | undefined;
    ediHasHostInformation?: boolean | undefined;
    ediReference1Invalid?: boolean | undefined;
    ediReference2Invalid?: boolean | undefined;
    supplierTypeName?: string | undefined;
    balance?: number | undefined;

    constructor(data?: ISupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierID = _data["supplierID"];
            this.deleted = _data["deleted"];
            this.replacementID = _data["replacementID"];
            this.supplierCode = _data["supplierCode"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.fullName = _data["fullName"];
            this.payToSupplierID = _data["payToSupplierID"];
            this.webAddress = _data["webAddress"];
            this.emailAddress = _data["emailAddress"];
            this.contactName = _data["contactName"];
            this.contactNumber = _data["contactNumber"];
            this.addressCode = _data["addressCode"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.city = _data["city"];
            this.county = _data["county"];
            this.postCode = _data["postCode"];
            this.country = _data["country"];
            this.telephone1 = _data["telephone1"];
            this.telephone2 = _data["telephone2"];
            this.fax = _data["fax"];
            this.headerNotes = _data["headerNotes"];
            this.notes = _data["notes"];
            this.popupText = _data["popupText"];
            this.popupLastModifiedByID = _data["popupLastModifiedByID"];
            this.popupDateTimeLastModified = _data["popupDateTimeLastModified"] ? new Date(_data["popupDateTimeLastModified"].toString()) : <any>undefined;
            this.popupShowFromDate = _data["popupShowFromDate"] ? new Date(_data["popupShowFromDate"].toString()) : <any>undefined;
            this.popupShowEndDate = _data["popupShowEndDate"] ? new Date(_data["popupShowEndDate"].toString()) : <any>undefined;
            this.supplierTypeID = _data["supplierTypeID"];
            this.defaultCountryID = _data["defaultCountryID"];
            this.defaultCurrencyID = _data["defaultCurrencyID"];
            this.onlyAllowSupplierCurrency = _data["onlyAllowSupplierCurrency"];
            this.vatRuleID = _data["vatRuleID"];
            this.defaultStockVatRuleID = _data["defaultStockVatRuleID"];
            this.defaultOverheadVatRuleID = _data["defaultOverheadVatRuleID"];
            this.defaultPurchaseOrderType = _data["defaultPurchaseOrderType"];
            this.defaultStockReceiptsToFullyReceived = _data["defaultStockReceiptsToFullyReceived"];
            this.taxAreaID = _data["taxAreaID"];
            this.stevedoreCharge = _data["stevedoreCharge"];
            this.typeOfPurchase = _data["typeOfPurchase"];
            this.intrastatDeliveryTermsID = _data["intrastatDeliveryTermsID"];
            this.intrastatTransportModeID = _data["intrastatTransportModeID"];
            this.deliveryCharge = _data["deliveryCharge"];
            this.minOrderAmount = _data["minOrderAmount"];
            this.paymentTermsID = _data["paymentTermsID"];
            this.stockSupplier = _data["stockSupplier"];
            this.canDeliverDirect = _data["canDeliverDirect"];
            this.haulier = _data["haulier"];
            this.subContractor = _data["subContractor"];
            this.allowSelfBilling = _data["allowSelfBilling"];
            this.chargeVat = _data["chargeVat"];
            this.agent = _data["agent"];
            this.completesSD = _data["completesSD"];
            this.overheadSupplier = _data["overheadSupplier"];
            this.overheadGLCodes = _data["overheadGLCodes"];
            this.chargesRollingMargin = _data["chargesRollingMargin"];
            this.showEurosOnPO = _data["showEurosOnPO"];
            this.complete = _data["complete"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.dateTimeLastModified = _data["dateTimeLastModified"] ? new Date(_data["dateTimeLastModified"].toString()) : <any>undefined;
            this.dateTimeSynchronized = _data["dateTimeSynchronized"] ? new Date(_data["dateTimeSynchronized"].toString()) : <any>undefined;
            this.thirdPartyID = _data["thirdPartyID"];
            this.inactive = _data["inactive"];
            this.onHold = _data["onHold"];
            this.scac = _data["scac"];
            this.vendor1099 = _data["vendor1099"];
            this.transportInstructionID = _data["transportInstructionID"];
            this.usePayToSupplierTerms = _data["usePayToSupplierTerms"];
            this.ediSupplierReference1 = _data["ediSupplierReference1"];
            this.ediSupplierReference2 = _data["ediSupplierReference2"];
            this.orderMethod = _data["orderMethod"];
            this.ediSupplierMessageFormat = _data["ediSupplierMessageFormat"];
            this.ediSupplierTransportMethod = _data["ediSupplierTransportMethod"];
            this.ediSupplierNextNumber = _data["ediSupplierNextNumber"];
            this.ediCreateSupplierInvoice = _data["ediCreateSupplierInvoice"];
            this.ediCreateStockReceipt = _data["ediCreateStockReceipt"];
            this.ediRemittanceAdviceMethod = _data["ediRemittanceAdviceMethod"];
            this.ediInternalTradingCompanyID = _data["ediInternalTradingCompanyID"];
            this.ediValidateSupplierInvoiceLines = _data["ediValidateSupplierInvoiceLines"];
            this.ediAddSupplierInvoiceLines = _data["ediAddSupplierInvoiceLines"];
            this.ediCatalogueSubFolder = _data["ediCatalogueSubFolder"];
            this.ediCatalogueFormat = _data["ediCatalogueFormat"];
            this.ediCatalogueDelete = _data["ediCatalogueDelete"];
            this.ediCatalogueSupplierID = _data["ediCatalogueSupplierID"];
            this.ediAutoMatchAndApproveSupplierInvoice = _data["ediAutoMatchAndApproveSupplierInvoice"];
            this.ediClaimsMethod = _data["ediClaimsMethod"];
            this.ediSalesHistoryMethod = _data["ediSalesHistoryMethod"];
            this.ediValidateSupplierInvoiceManualLines = _data["ediValidateSupplierInvoiceManualLines"];
            this.lastModifiedByID = _data["lastModifiedByID"];
            this.leadTime = _data["leadTime"];
            this.cutOff = _data["cutOff"];
            this.minimumWeight = _data["minimumWeight"];
            this.defaultPurchaseOrderToCollected = _data["defaultPurchaseOrderToCollected"];
            this.ediFullyReceiveMissingLinesOnPOAck = _data["ediFullyReceiveMissingLinesOnPOAck"];
            this.ediAllowPriceChangesToUpdatePriceUOM = _data["ediAllowPriceChangesToUpdatePriceUOM"];
            this.ediUpdatePurchaseOrderCost = _data["ediUpdatePurchaseOrderCost"];
            this.ediUpdatePurchaseOrderQuantity = _data["ediUpdatePurchaseOrderQuantity"];
            this.replacementCode = _data["replacementCode"];
            this.replacementName = _data["replacementName"];
            this.notepadCount = _data["notepadCount"];
            this.intrastatDeliveryTermsDescription = _data["intrastatDeliveryTermsDescription"];
            this.intrastatTransportModeName = _data["intrastatTransportModeName"];
            this.payToSupplierCode = _data["payToSupplierCode"];
            this.payToSupplierName = _data["payToSupplierName"];
            this.defaultStockTaxAreaID = _data["defaultStockTaxAreaID"];
            this.defaultOverheadTaxAreaID = _data["defaultOverheadTaxAreaID"];
            this.defaultPurchaseOrdersToCollected = _data["defaultPurchaseOrdersToCollected"];
            this.ediHasHostInformation = _data["ediHasHostInformation"];
            this.ediReference1Invalid = _data["ediReference1Invalid"];
            this.ediReference2Invalid = _data["ediReference2Invalid"];
            this.supplierTypeName = _data["supplierTypeName"];
            this.balance = _data["balance"];
        }
    }

    static fromJS(data: any): Supplier {
        data = typeof data === 'object' ? data : {};
        let result = new Supplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierID"] = this.supplierID;
        data["deleted"] = this.deleted;
        data["replacementID"] = this.replacementID;
        data["supplierCode"] = this.supplierCode;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["fullName"] = this.fullName;
        data["payToSupplierID"] = this.payToSupplierID;
        data["webAddress"] = this.webAddress;
        data["emailAddress"] = this.emailAddress;
        data["contactName"] = this.contactName;
        data["contactNumber"] = this.contactNumber;
        data["addressCode"] = this.addressCode;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["city"] = this.city;
        data["county"] = this.county;
        data["postCode"] = this.postCode;
        data["country"] = this.country;
        data["telephone1"] = this.telephone1;
        data["telephone2"] = this.telephone2;
        data["fax"] = this.fax;
        data["headerNotes"] = this.headerNotes;
        data["notes"] = this.notes;
        data["popupText"] = this.popupText;
        data["popupLastModifiedByID"] = this.popupLastModifiedByID;
        data["popupDateTimeLastModified"] = this.popupDateTimeLastModified ? this.popupDateTimeLastModified.toISOString() : <any>undefined;
        data["popupShowFromDate"] = this.popupShowFromDate ? this.popupShowFromDate.toISOString() : <any>undefined;
        data["popupShowEndDate"] = this.popupShowEndDate ? this.popupShowEndDate.toISOString() : <any>undefined;
        data["supplierTypeID"] = this.supplierTypeID;
        data["defaultCountryID"] = this.defaultCountryID;
        data["defaultCurrencyID"] = this.defaultCurrencyID;
        data["onlyAllowSupplierCurrency"] = this.onlyAllowSupplierCurrency;
        data["vatRuleID"] = this.vatRuleID;
        data["defaultStockVatRuleID"] = this.defaultStockVatRuleID;
        data["defaultOverheadVatRuleID"] = this.defaultOverheadVatRuleID;
        data["defaultPurchaseOrderType"] = this.defaultPurchaseOrderType;
        data["defaultStockReceiptsToFullyReceived"] = this.defaultStockReceiptsToFullyReceived;
        data["taxAreaID"] = this.taxAreaID;
        data["stevedoreCharge"] = this.stevedoreCharge;
        data["typeOfPurchase"] = this.typeOfPurchase;
        data["intrastatDeliveryTermsID"] = this.intrastatDeliveryTermsID;
        data["intrastatTransportModeID"] = this.intrastatTransportModeID;
        data["deliveryCharge"] = this.deliveryCharge;
        data["minOrderAmount"] = this.minOrderAmount;
        data["paymentTermsID"] = this.paymentTermsID;
        data["stockSupplier"] = this.stockSupplier;
        data["canDeliverDirect"] = this.canDeliverDirect;
        data["haulier"] = this.haulier;
        data["subContractor"] = this.subContractor;
        data["allowSelfBilling"] = this.allowSelfBilling;
        data["chargeVat"] = this.chargeVat;
        data["agent"] = this.agent;
        data["completesSD"] = this.completesSD;
        data["overheadSupplier"] = this.overheadSupplier;
        data["overheadGLCodes"] = this.overheadGLCodes;
        data["chargesRollingMargin"] = this.chargesRollingMargin;
        data["showEurosOnPO"] = this.showEurosOnPO;
        data["complete"] = this.complete;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["dateTimeLastModified"] = this.dateTimeLastModified ? this.dateTimeLastModified.toISOString() : <any>undefined;
        data["dateTimeSynchronized"] = this.dateTimeSynchronized ? this.dateTimeSynchronized.toISOString() : <any>undefined;
        data["thirdPartyID"] = this.thirdPartyID;
        data["inactive"] = this.inactive;
        data["onHold"] = this.onHold;
        data["scac"] = this.scac;
        data["vendor1099"] = this.vendor1099;
        data["transportInstructionID"] = this.transportInstructionID;
        data["usePayToSupplierTerms"] = this.usePayToSupplierTerms;
        data["ediSupplierReference1"] = this.ediSupplierReference1;
        data["ediSupplierReference2"] = this.ediSupplierReference2;
        data["orderMethod"] = this.orderMethod;
        data["ediSupplierMessageFormat"] = this.ediSupplierMessageFormat;
        data["ediSupplierTransportMethod"] = this.ediSupplierTransportMethod;
        data["ediSupplierNextNumber"] = this.ediSupplierNextNumber;
        data["ediCreateSupplierInvoice"] = this.ediCreateSupplierInvoice;
        data["ediCreateStockReceipt"] = this.ediCreateStockReceipt;
        data["ediRemittanceAdviceMethod"] = this.ediRemittanceAdviceMethod;
        data["ediInternalTradingCompanyID"] = this.ediInternalTradingCompanyID;
        data["ediValidateSupplierInvoiceLines"] = this.ediValidateSupplierInvoiceLines;
        data["ediAddSupplierInvoiceLines"] = this.ediAddSupplierInvoiceLines;
        data["ediCatalogueSubFolder"] = this.ediCatalogueSubFolder;
        data["ediCatalogueFormat"] = this.ediCatalogueFormat;
        data["ediCatalogueDelete"] = this.ediCatalogueDelete;
        data["ediCatalogueSupplierID"] = this.ediCatalogueSupplierID;
        data["ediAutoMatchAndApproveSupplierInvoice"] = this.ediAutoMatchAndApproveSupplierInvoice;
        data["ediClaimsMethod"] = this.ediClaimsMethod;
        data["ediSalesHistoryMethod"] = this.ediSalesHistoryMethod;
        data["ediValidateSupplierInvoiceManualLines"] = this.ediValidateSupplierInvoiceManualLines;
        data["lastModifiedByID"] = this.lastModifiedByID;
        data["leadTime"] = this.leadTime;
        data["cutOff"] = this.cutOff;
        data["minimumWeight"] = this.minimumWeight;
        data["defaultPurchaseOrderToCollected"] = this.defaultPurchaseOrderToCollected;
        data["ediFullyReceiveMissingLinesOnPOAck"] = this.ediFullyReceiveMissingLinesOnPOAck;
        data["ediAllowPriceChangesToUpdatePriceUOM"] = this.ediAllowPriceChangesToUpdatePriceUOM;
        data["ediUpdatePurchaseOrderCost"] = this.ediUpdatePurchaseOrderCost;
        data["ediUpdatePurchaseOrderQuantity"] = this.ediUpdatePurchaseOrderQuantity;
        data["replacementCode"] = this.replacementCode;
        data["replacementName"] = this.replacementName;
        data["notepadCount"] = this.notepadCount;
        data["intrastatDeliveryTermsDescription"] = this.intrastatDeliveryTermsDescription;
        data["intrastatTransportModeName"] = this.intrastatTransportModeName;
        data["payToSupplierCode"] = this.payToSupplierCode;
        data["payToSupplierName"] = this.payToSupplierName;
        data["defaultStockTaxAreaID"] = this.defaultStockTaxAreaID;
        data["defaultOverheadTaxAreaID"] = this.defaultOverheadTaxAreaID;
        data["defaultPurchaseOrdersToCollected"] = this.defaultPurchaseOrdersToCollected;
        data["ediHasHostInformation"] = this.ediHasHostInformation;
        data["ediReference1Invalid"] = this.ediReference1Invalid;
        data["ediReference2Invalid"] = this.ediReference2Invalid;
        data["supplierTypeName"] = this.supplierTypeName;
        data["balance"] = this.balance;
        return data; 
    }
}

export interface ISupplier {
    supplierID?: number | undefined;
    deleted?: number | undefined;
    replacementID?: number | undefined;
    supplierCode?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    fullName?: string | undefined;
    payToSupplierID?: number | undefined;
    webAddress?: string | undefined;
    emailAddress?: string | undefined;
    contactName?: string | undefined;
    contactNumber?: string | undefined;
    addressCode?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;
    telephone1?: string | undefined;
    telephone2?: string | undefined;
    fax?: string | undefined;
    headerNotes?: string | undefined;
    notes?: string | undefined;
    popupText?: string | undefined;
    popupLastModifiedByID?: number | undefined;
    popupDateTimeLastModified?: Date | undefined;
    popupShowFromDate?: Date | undefined;
    popupShowEndDate?: Date | undefined;
    supplierTypeID?: number | undefined;
    defaultCountryID?: number | undefined;
    defaultCurrencyID?: number | undefined;
    onlyAllowSupplierCurrency?: boolean | undefined;
    vatRuleID?: number | undefined;
    defaultStockVatRuleID?: number | undefined;
    defaultOverheadVatRuleID?: number | undefined;
    defaultPurchaseOrderType?: number | undefined;
    defaultStockReceiptsToFullyReceived?: boolean | undefined;
    taxAreaID?: number | undefined;
    stevedoreCharge?: number | undefined;
    typeOfPurchase?: SupplierTypeOfPurchase | undefined;
    intrastatDeliveryTermsID?: number | undefined;
    intrastatTransportModeID?: number | undefined;
    deliveryCharge?: number | undefined;
    minOrderAmount?: number | undefined;
    paymentTermsID?: number | undefined;
    stockSupplier?: boolean | undefined;
    canDeliverDirect?: boolean | undefined;
    haulier?: boolean | undefined;
    subContractor?: boolean | undefined;
    allowSelfBilling?: boolean | undefined;
    chargeVat?: boolean | undefined;
    agent?: boolean | undefined;
    completesSD?: boolean | undefined;
    overheadSupplier?: boolean | undefined;
    overheadGLCodes?: string | undefined;
    chargesRollingMargin?: boolean | undefined;
    showEurosOnPO?: boolean | undefined;
    complete?: boolean | undefined;
    dateTimeCreated?: Date | undefined;
    dateTimeLastModified?: Date | undefined;
    dateTimeSynchronized?: Date | undefined;
    thirdPartyID?: number | undefined;
    inactive?: boolean | undefined;
    onHold?: boolean | undefined;
    scac?: string | undefined;
    vendor1099?: boolean | undefined;
    transportInstructionID?: number | undefined;
    usePayToSupplierTerms?: boolean | undefined;
    ediSupplierReference1?: string | undefined;
    ediSupplierReference2?: string | undefined;
    orderMethod?: SupplierOrderMethod | undefined;
    ediSupplierMessageFormat?: number | undefined;
    ediSupplierTransportMethod?: SupplierEdiSupplierTransportMethod | undefined;
    ediSupplierNextNumber?: number | undefined;
    ediCreateSupplierInvoice?: boolean | undefined;
    ediCreateStockReceipt?: boolean | undefined;
    ediRemittanceAdviceMethod?: SupplierEdiRemittanceAdviceMethod | undefined;
    ediInternalTradingCompanyID?: number | undefined;
    ediValidateSupplierInvoiceLines?: boolean | undefined;
    ediAddSupplierInvoiceLines?: number | undefined;
    ediCatalogueSubFolder?: string | undefined;
    ediCatalogueFormat?: number | undefined;
    ediCatalogueDelete?: boolean | undefined;
    ediCatalogueSupplierID?: string | undefined;
    ediAutoMatchAndApproveSupplierInvoice?: boolean | undefined;
    ediClaimsMethod?: SupplierEdiClaimsMethod | undefined;
    ediSalesHistoryMethod?: SupplierEdiSalesHistoryMethod | undefined;
    ediValidateSupplierInvoiceManualLines?: boolean | undefined;
    lastModifiedByID?: number | undefined;
    leadTime?: number | undefined;
    cutOff?: number | undefined;
    minimumWeight?: number | undefined;
    defaultPurchaseOrderToCollected?: boolean | undefined;
    ediFullyReceiveMissingLinesOnPOAck?: boolean | undefined;
    ediAllowPriceChangesToUpdatePriceUOM?: boolean | undefined;
    ediUpdatePurchaseOrderCost?: SupplierEdiUpdatePurchaseOrderCost | undefined;
    ediUpdatePurchaseOrderQuantity?: SupplierEdiUpdatePurchaseOrderQuantity | undefined;
    replacementCode?: string | undefined;
    replacementName?: string | undefined;
    notepadCount?: number | undefined;
    intrastatDeliveryTermsDescription?: string | undefined;
    intrastatTransportModeName?: string | undefined;
    payToSupplierCode?: string | undefined;
    payToSupplierName?: string | undefined;
    defaultStockTaxAreaID?: number | undefined;
    defaultOverheadTaxAreaID?: number | undefined;
    defaultPurchaseOrdersToCollected?: boolean | undefined;
    ediHasHostInformation?: boolean | undefined;
    ediReference1Invalid?: boolean | undefined;
    ediReference2Invalid?: boolean | undefined;
    supplierTypeName?: string | undefined;
    balance?: number | undefined;
}

export class SupplierCatalogResponse implements ISupplierCatalogResponse {
    supplierCatalogs?: SupplierCatalog[] | undefined;
    status?: SupplierCatalogResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: ISupplierCatalogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["supplierCatalogs"])) {
                this.supplierCatalogs = [] as any;
                for (let item of _data["supplierCatalogs"])
                    this.supplierCatalogs!.push(SupplierCatalog.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): SupplierCatalogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierCatalogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.supplierCatalogs)) {
            data["supplierCatalogs"] = [];
            for (let item of this.supplierCatalogs)
                data["supplierCatalogs"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface ISupplierCatalogResponse {
    supplierCatalogs?: SupplierCatalog[] | undefined;
    status?: SupplierCatalogResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class SupplierCatalog implements ISupplierCatalog {
    supplierID?: number | undefined;
    supplierCode?: string | undefined;
    shortName?: string | undefined;
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    postcode?: string | undefined;
    telephone1?: string | undefined;
    fax?: string | undefined;
    retailSalesCenterID?: number | undefined;
    rscNumber?: string | undefined;
    rscName?: string | undefined;

    constructor(data?: ISupplierCatalog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierID = _data["supplierID"];
            this.supplierCode = _data["supplierCode"];
            this.shortName = _data["shortName"];
            this.name = _data["name"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.city = _data["city"];
            this.county = _data["county"];
            this.postcode = _data["postcode"];
            this.telephone1 = _data["telephone1"];
            this.fax = _data["fax"];
            this.retailSalesCenterID = _data["retailSalesCenterID"];
            this.rscNumber = _data["rscNumber"];
            this.rscName = _data["rscName"];
        }
    }

    static fromJS(data: any): SupplierCatalog {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierCatalog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierID"] = this.supplierID;
        data["supplierCode"] = this.supplierCode;
        data["shortName"] = this.shortName;
        data["name"] = this.name;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["city"] = this.city;
        data["county"] = this.county;
        data["postcode"] = this.postcode;
        data["telephone1"] = this.telephone1;
        data["fax"] = this.fax;
        data["retailSalesCenterID"] = this.retailSalesCenterID;
        data["rscNumber"] = this.rscNumber;
        data["rscName"] = this.rscName;
        return data; 
    }
}

export interface ISupplierCatalog {
    supplierID?: number | undefined;
    supplierCode?: string | undefined;
    shortName?: string | undefined;
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    postcode?: string | undefined;
    telephone1?: string | undefined;
    fax?: string | undefined;
    retailSalesCenterID?: number | undefined;
    rscNumber?: string | undefined;
    rscName?: string | undefined;
}

export class SupplierCatalogTreeResponse implements ISupplierCatalogTreeResponse {
    supplierCatalogTree?: SupplierCatalogTree[] | undefined;
    status?: SupplierCatalogTreeResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: ISupplierCatalogTreeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["supplierCatalogTree"])) {
                this.supplierCatalogTree = [] as any;
                for (let item of _data["supplierCatalogTree"])
                    this.supplierCatalogTree!.push(SupplierCatalogTree.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): SupplierCatalogTreeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierCatalogTreeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.supplierCatalogTree)) {
            data["supplierCatalogTree"] = [];
            for (let item of this.supplierCatalogTree)
                data["supplierCatalogTree"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface ISupplierCatalogTreeResponse {
    supplierCatalogTree?: SupplierCatalogTree[] | undefined;
    status?: SupplierCatalogTreeResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class SupplierCatalogTree implements ISupplierCatalogTree {
    supplierID?: number | undefined;
    supplierCode?: string | undefined;
    productGroupCode?: string | undefined;
    productGroupName?: string | undefined;

    constructor(data?: ISupplierCatalogTree) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierID = _data["supplierID"];
            this.supplierCode = _data["supplierCode"];
            this.productGroupCode = _data["productGroupCode"];
            this.productGroupName = _data["productGroupName"];
        }
    }

    static fromJS(data: any): SupplierCatalogTree {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierCatalogTree();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierID"] = this.supplierID;
        data["supplierCode"] = this.supplierCode;
        data["productGroupCode"] = this.productGroupCode;
        data["productGroupName"] = this.productGroupName;
        return data; 
    }
}

export interface ISupplierCatalogTree {
    supplierID?: number | undefined;
    supplierCode?: string | undefined;
    productGroupCode?: string | undefined;
    productGroupName?: string | undefined;
}

export class UsersResponse implements IUsersResponse {
    users?: User[] | undefined;
    status?: UsersResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): UsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IUsersResponse {
    users?: User[] | undefined;
    status?: UsersResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class User implements IUser {
    userId?: number | undefined;
    userType?: number | undefined;
    userName?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    title?: string | undefined;
    jobTitle?: string | undefined;
    telephone?: string | undefined;
    address?: string | undefined;
    emailAddress?: string | undefined;
    defaultBranchId?: number | undefined;
    isAdministrator?: boolean | undefined;
    accessToAllBranches?: boolean | undefined;
    accessToAllBranchLevel?: number | undefined;
    restrictCustomersToSalesReps?: boolean | undefined;
    staffNumber?: string | undefined;
    activeDirectoryUser?: string | undefined;
    useADIntegration?: boolean | undefined;
    staffUserID?: number | undefined;
    restrictDocumentsToSalesReps?: boolean | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userType = _data["userType"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.title = _data["title"];
            this.jobTitle = _data["jobTitle"];
            this.telephone = _data["telephone"];
            this.address = _data["address"];
            this.emailAddress = _data["emailAddress"];
            this.defaultBranchId = _data["defaultBranchId"];
            this.isAdministrator = _data["isAdministrator"];
            this.accessToAllBranches = _data["accessToAllBranches"];
            this.accessToAllBranchLevel = _data["accessToAllBranchLevel"];
            this.restrictCustomersToSalesReps = _data["restrictCustomersToSalesReps"];
            this.staffNumber = _data["staffNumber"];
            this.activeDirectoryUser = _data["activeDirectoryUser"];
            this.useADIntegration = _data["useADIntegration"];
            this.staffUserID = _data["staffUserID"];
            this.restrictDocumentsToSalesReps = _data["restrictDocumentsToSalesReps"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userType"] = this.userType;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["title"] = this.title;
        data["jobTitle"] = this.jobTitle;
        data["telephone"] = this.telephone;
        data["address"] = this.address;
        data["emailAddress"] = this.emailAddress;
        data["defaultBranchId"] = this.defaultBranchId;
        data["isAdministrator"] = this.isAdministrator;
        data["accessToAllBranches"] = this.accessToAllBranches;
        data["accessToAllBranchLevel"] = this.accessToAllBranchLevel;
        data["restrictCustomersToSalesReps"] = this.restrictCustomersToSalesReps;
        data["staffNumber"] = this.staffNumber;
        data["activeDirectoryUser"] = this.activeDirectoryUser;
        data["useADIntegration"] = this.useADIntegration;
        data["staffUserID"] = this.staffUserID;
        data["restrictDocumentsToSalesReps"] = this.restrictDocumentsToSalesReps;
        return data; 
    }
}

export interface IUser {
    userId?: number | undefined;
    userType?: number | undefined;
    userName?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    title?: string | undefined;
    jobTitle?: string | undefined;
    telephone?: string | undefined;
    address?: string | undefined;
    emailAddress?: string | undefined;
    defaultBranchId?: number | undefined;
    isAdministrator?: boolean | undefined;
    accessToAllBranches?: boolean | undefined;
    accessToAllBranchLevel?: number | undefined;
    restrictCustomersToSalesReps?: boolean | undefined;
    staffNumber?: string | undefined;
    activeDirectoryUser?: string | undefined;
    useADIntegration?: boolean | undefined;
    staffUserID?: number | undefined;
    restrictDocumentsToSalesReps?: boolean | undefined;
}

export class CollectionObjectParam implements ICollectionObjectParam {
    choices?: number | undefined;
    id?: number | undefined;
    findText?: string | undefined;
    staffUserID?: number | undefined;
    jobFindFilterType?: CollectionObjectParamJobFindFilterType | undefined;
    paymentTermsType?: CollectionObjectParamPaymentTermsType | undefined;
    supplierFilter?: CollectionObjectParamSupplierFilter | undefined;
    customerFindFilter?: CollectionObjectParamCustomerFindFilter | undefined;
    productFilter?: number | undefined;
    includeInactive?: boolean | undefined;
    buyingSocietyID?: number | undefined;
    filterBranchId?: number | undefined;
    matchOnBeginsWith?: boolean | undefined;
    exactMatchFirstAndFullSearch?: boolean | undefined;
    includeProductSpecificUOMRules?: boolean | undefined;
    stockLocation?: number | undefined;
    productQty?: string | undefined;
    includeSpecial?: boolean | undefined;
    includeNonStockedProducts?: boolean | undefined;
    includeOwnBrand?: boolean | undefined;
    includeCatalogueStock?: boolean | undefined;
    excludeChildProducts?: boolean | undefined;
    matchOnProductCodeOrBarCode?: boolean | undefined;
    filterProductGroupId?: number | undefined;
    filterStockSupplierID?: number | undefined;
    supplierCatalogCode?: string | undefined;
    retailSalesCenterId?: number | undefined;
    level1Code?: number | undefined;
    level2Code?: number | undefined;
    excludeExpiredPromotions?: boolean | undefined;
    skip?: number | undefined;
    take?: number | undefined;

    constructor(data?: ICollectionObjectParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.choices = _data["choices"];
            this.id = _data["id"];
            this.findText = _data["findText"];
            this.staffUserID = _data["staffUserID"];
            this.jobFindFilterType = _data["jobFindFilterType"];
            this.paymentTermsType = _data["paymentTermsType"];
            this.supplierFilter = _data["supplierFilter"];
            this.customerFindFilter = _data["customerFindFilter"];
            this.productFilter = _data["productFilter"];
            this.includeInactive = _data["includeInactive"];
            this.buyingSocietyID = _data["buyingSocietyID"];
            this.filterBranchId = _data["filterBranchId"];
            this.matchOnBeginsWith = _data["matchOnBeginsWith"];
            this.exactMatchFirstAndFullSearch = _data["exactMatchFirstAndFullSearch"];
            this.includeProductSpecificUOMRules = _data["includeProductSpecificUOMRules"];
            this.stockLocation = _data["stockLocation"];
            this.productQty = _data["productQty"];
            this.includeSpecial = _data["includeSpecial"];
            this.includeNonStockedProducts = _data["includeNonStockedProducts"];
            this.includeOwnBrand = _data["includeOwnBrand"];
            this.includeCatalogueStock = _data["includeCatalogueStock"];
            this.excludeChildProducts = _data["excludeChildProducts"];
            this.matchOnProductCodeOrBarCode = _data["matchOnProductCodeOrBarCode"];
            this.filterProductGroupId = _data["filterProductGroupId"];
            this.filterStockSupplierID = _data["filterStockSupplierID"];
            this.supplierCatalogCode = _data["supplierCatalogCode"];
            this.retailSalesCenterId = _data["retailSalesCenterId"];
            this.level1Code = _data["level1Code"];
            this.level2Code = _data["level2Code"];
            this.excludeExpiredPromotions = _data["excludeExpiredPromotions"];
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): CollectionObjectParam {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionObjectParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["choices"] = this.choices;
        data["id"] = this.id;
        data["findText"] = this.findText;
        data["staffUserID"] = this.staffUserID;
        data["jobFindFilterType"] = this.jobFindFilterType;
        data["paymentTermsType"] = this.paymentTermsType;
        data["supplierFilter"] = this.supplierFilter;
        data["customerFindFilter"] = this.customerFindFilter;
        data["productFilter"] = this.productFilter;
        data["includeInactive"] = this.includeInactive;
        data["buyingSocietyID"] = this.buyingSocietyID;
        data["filterBranchId"] = this.filterBranchId;
        data["matchOnBeginsWith"] = this.matchOnBeginsWith;
        data["exactMatchFirstAndFullSearch"] = this.exactMatchFirstAndFullSearch;
        data["includeProductSpecificUOMRules"] = this.includeProductSpecificUOMRules;
        data["stockLocation"] = this.stockLocation;
        data["productQty"] = this.productQty;
        data["includeSpecial"] = this.includeSpecial;
        data["includeNonStockedProducts"] = this.includeNonStockedProducts;
        data["includeOwnBrand"] = this.includeOwnBrand;
        data["includeCatalogueStock"] = this.includeCatalogueStock;
        data["excludeChildProducts"] = this.excludeChildProducts;
        data["matchOnProductCodeOrBarCode"] = this.matchOnProductCodeOrBarCode;
        data["filterProductGroupId"] = this.filterProductGroupId;
        data["filterStockSupplierID"] = this.filterStockSupplierID;
        data["supplierCatalogCode"] = this.supplierCatalogCode;
        data["retailSalesCenterId"] = this.retailSalesCenterId;
        data["level1Code"] = this.level1Code;
        data["level2Code"] = this.level2Code;
        data["excludeExpiredPromotions"] = this.excludeExpiredPromotions;
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data; 
    }
}

export interface ICollectionObjectParam {
    choices?: number | undefined;
    id?: number | undefined;
    findText?: string | undefined;
    staffUserID?: number | undefined;
    jobFindFilterType?: CollectionObjectParamJobFindFilterType | undefined;
    paymentTermsType?: CollectionObjectParamPaymentTermsType | undefined;
    supplierFilter?: CollectionObjectParamSupplierFilter | undefined;
    customerFindFilter?: CollectionObjectParamCustomerFindFilter | undefined;
    productFilter?: number | undefined;
    includeInactive?: boolean | undefined;
    buyingSocietyID?: number | undefined;
    filterBranchId?: number | undefined;
    matchOnBeginsWith?: boolean | undefined;
    exactMatchFirstAndFullSearch?: boolean | undefined;
    includeProductSpecificUOMRules?: boolean | undefined;
    stockLocation?: number | undefined;
    productQty?: string | undefined;
    includeSpecial?: boolean | undefined;
    includeNonStockedProducts?: boolean | undefined;
    includeOwnBrand?: boolean | undefined;
    includeCatalogueStock?: boolean | undefined;
    excludeChildProducts?: boolean | undefined;
    matchOnProductCodeOrBarCode?: boolean | undefined;
    filterProductGroupId?: number | undefined;
    filterStockSupplierID?: number | undefined;
    supplierCatalogCode?: string | undefined;
    retailSalesCenterId?: number | undefined;
    level1Code?: number | undefined;
    level2Code?: number | undefined;
    excludeExpiredPromotions?: boolean | undefined;
    skip?: number | undefined;
    take?: number | undefined;
}

export class CollectionObjectResponse implements ICollectionObjectResponse {
    collectionObjects?: { [key: string]: any; }[] | undefined;
    count?: { [key: string]: any; } | undefined;
    status?: CollectionObjectResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: ICollectionObjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["collectionObjects"])) {
                this.collectionObjects = [] as any;
                for (let item of _data["collectionObjects"])
                    this.collectionObjects!.push(item);
            }
            if (_data["count"]) {
                this.count = {} as any;
                for (let key in _data["count"]) {
                    if (_data["count"].hasOwnProperty(key))
                        this.count![key] = _data["count"][key];
                }
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): CollectionObjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionObjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.collectionObjects)) {
            data["collectionObjects"] = [];
            for (let item of this.collectionObjects)
                data["collectionObjects"].push(item);
        }
        if (this.count) {
            data["count"] = {};
            for (let key in this.count) {
                if (this.count.hasOwnProperty(key))
                    data["count"][key] = this.count[key];
            }
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface ICollectionObjectResponse {
    collectionObjects?: { [key: string]: any; }[] | undefined;
    count?: { [key: string]: any; } | undefined;
    status?: CollectionObjectResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class UserDefinedFieldResponse implements IUserDefinedFieldResponse {
    userDefinedObjects?: UdfInfo[] | undefined;
    status?: UserDefinedFieldResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IUserDefinedFieldResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userDefinedObjects"])) {
                this.userDefinedObjects = [] as any;
                for (let item of _data["userDefinedObjects"])
                    this.userDefinedObjects!.push(UdfInfo.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): UserDefinedFieldResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserDefinedFieldResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userDefinedObjects)) {
            data["userDefinedObjects"] = [];
            for (let item of this.userDefinedObjects)
                data["userDefinedObjects"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IUserDefinedFieldResponse {
    userDefinedObjects?: UdfInfo[] | undefined;
    status?: UserDefinedFieldResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class GetUserOptionRequest implements IGetUserOptionRequest {
    userId?: number | undefined;
    userOptions?: UserOption[] | undefined;

    constructor(data?: IGetUserOptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["userOptions"])) {
                this.userOptions = [] as any;
                for (let item of _data["userOptions"])
                    this.userOptions!.push(UserOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserOptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserOptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.userOptions)) {
            data["userOptions"] = [];
            for (let item of this.userOptions)
                data["userOptions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetUserOptionRequest {
    userId?: number | undefined;
    userOptions?: UserOption[] | undefined;
}

export class UserOption implements IUserOption {
    optionType?: UserOptionOptionType | undefined;
    optionKey?: string | undefined;
    optionValue?: string | undefined;

    constructor(data?: IUserOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optionType = _data["optionType"];
            this.optionKey = _data["optionKey"];
            this.optionValue = _data["optionValue"];
        }
    }

    static fromJS(data: any): UserOption {
        data = typeof data === 'object' ? data : {};
        let result = new UserOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optionType"] = this.optionType;
        data["optionKey"] = this.optionKey;
        data["optionValue"] = this.optionValue;
        return data; 
    }
}

export interface IUserOption {
    optionType?: UserOptionOptionType | undefined;
    optionKey?: string | undefined;
    optionValue?: string | undefined;
}

export class UserOptionResponse implements IUserOptionResponse {
    userOptions?: UserOption[] | undefined;
    status?: UserOptionResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IUserOptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userOptions"])) {
                this.userOptions = [] as any;
                for (let item of _data["userOptions"])
                    this.userOptions!.push(UserOption.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): UserOptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserOptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userOptions)) {
            data["userOptions"] = [];
            for (let item of this.userOptions)
                data["userOptions"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IUserOptionResponse {
    userOptions?: UserOption[] | undefined;
    status?: UserOptionResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class SetUserOptionRequest implements ISetUserOptionRequest {
    userId?: number | undefined;
    userOptions?: UserOption[] | undefined;

    constructor(data?: ISetUserOptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["userOptions"])) {
                this.userOptions = [] as any;
                for (let item of _data["userOptions"])
                    this.userOptions!.push(UserOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetUserOptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserOptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.userOptions)) {
            data["userOptions"] = [];
            for (let item of this.userOptions)
                data["userOptions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISetUserOptionRequest {
    userId?: number | undefined;
    userOptions?: UserOption[] | undefined;
}

export class SetUserOptionResponse implements ISetUserOptionResponse {
    status?: SetUserOptionResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: ISetUserOptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): SetUserOptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserOptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface ISetUserOptionResponse {
    status?: SetUserOptionResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class DebugConfiguration implements IDebugConfiguration {
    moduleDebugConfigs?: ModuleDebugConfig[] | undefined;

    constructor(data?: IDebugConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["moduleDebugConfigs"])) {
                this.moduleDebugConfigs = [] as any;
                for (let item of _data["moduleDebugConfigs"])
                    this.moduleDebugConfigs!.push(ModuleDebugConfig.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DebugConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new DebugConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.moduleDebugConfigs)) {
            data["moduleDebugConfigs"] = [];
            for (let item of this.moduleDebugConfigs)
                data["moduleDebugConfigs"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDebugConfiguration {
    moduleDebugConfigs?: ModuleDebugConfig[] | undefined;
}

export class ModuleDebugConfig implements IModuleDebugConfig {
    moduleType?: ModuleDebugConfigModuleType | undefined;
    enableLogging?: boolean | undefined;
    expiresOn?: Date | undefined;
    enableException?: boolean | undefined;
    enableExplicit?: boolean | undefined;
    enableVerbose?: boolean | undefined;
    enableServiceEventTracing?: boolean | undefined;

    constructor(data?: IModuleDebugConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleType = _data["moduleType"];
            this.enableLogging = _data["enableLogging"];
            this.expiresOn = _data["expiresOn"] ? new Date(_data["expiresOn"].toString()) : <any>undefined;
            this.enableException = _data["enableException"];
            this.enableExplicit = _data["enableExplicit"];
            this.enableVerbose = _data["enableVerbose"];
            this.enableServiceEventTracing = _data["enableServiceEventTracing"];
        }
    }

    static fromJS(data: any): ModuleDebugConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleDebugConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleType"] = this.moduleType;
        data["enableLogging"] = this.enableLogging;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : <any>undefined;
        data["enableException"] = this.enableException;
        data["enableExplicit"] = this.enableExplicit;
        data["enableVerbose"] = this.enableVerbose;
        data["enableServiceEventTracing"] = this.enableServiceEventTracing;
        return data; 
    }
}

export interface IModuleDebugConfig {
    moduleType?: ModuleDebugConfigModuleType | undefined;
    enableLogging?: boolean | undefined;
    expiresOn?: Date | undefined;
    enableException?: boolean | undefined;
    enableExplicit?: boolean | undefined;
    enableVerbose?: boolean | undefined;
    enableServiceEventTracing?: boolean | undefined;
}

export class SessionInfo implements ISessionInfo {
    sessionId?: string | undefined;
    sessionInstanceId?: number | undefined;
    startTime?: Date | undefined;
    status?: SessionInfoStatus | undefined;
    aliveTill?: Date | undefined;

    constructor(data?: ISessionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.sessionInstanceId = _data["sessionInstanceId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.aliveTill = _data["aliveTill"] ? new Date(_data["aliveTill"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SessionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SessionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["sessionInstanceId"] = this.sessionInstanceId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["aliveTill"] = this.aliveTill ? this.aliveTill.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ISessionInfo {
    sessionId?: string | undefined;
    sessionInstanceId?: number | undefined;
    startTime?: Date | undefined;
    status?: SessionInfoStatus | undefined;
    aliveTill?: Date | undefined;
}

export class DocumentManifest implements IDocumentManifest {
    documentId?: number | undefined;
    documentNumber?: number | undefined;
    documentType?: DocumentManifestDocumentType | undefined;
    orderManifest?: OrderManifest | undefined;
    pickingNoteManifest?: PickingNoteManifest | undefined;
    deliveryNoteManifest?: DeliveryNoteManifest | undefined;
    addCostProrationManifest?: AddCostProrationManifest | undefined;
    workOrderManifest?: WorkOrderManifest | undefined;
    creditNoteManifest?: CreditNoteManifest | undefined;
    journeyManifest?: JourneyManifest | undefined;
    purchaseOrderManifest?: PurchaseOrderManifest | undefined;
    stockReceiptManifest?: StockReceiptManifest | undefined;
    supplierReturnManifest?: SupplierReturnManifest | undefined;
    customerReturnManifest?: CustomerReturnManifest | undefined;
    status?: DocumentManifestStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;

    constructor(data?: IDocumentManifest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.documentNumber = _data["documentNumber"];
            this.documentType = _data["documentType"];
            this.orderManifest = _data["orderManifest"] ? OrderManifest.fromJS(_data["orderManifest"]) : <any>undefined;
            this.pickingNoteManifest = _data["pickingNoteManifest"] ? PickingNoteManifest.fromJS(_data["pickingNoteManifest"]) : <any>undefined;
            this.deliveryNoteManifest = _data["deliveryNoteManifest"] ? DeliveryNoteManifest.fromJS(_data["deliveryNoteManifest"]) : <any>undefined;
            this.addCostProrationManifest = _data["addCostProrationManifest"] ? AddCostProrationManifest.fromJS(_data["addCostProrationManifest"]) : <any>undefined;
            this.workOrderManifest = _data["workOrderManifest"] ? WorkOrderManifest.fromJS(_data["workOrderManifest"]) : <any>undefined;
            this.creditNoteManifest = _data["creditNoteManifest"] ? CreditNoteManifest.fromJS(_data["creditNoteManifest"]) : <any>undefined;
            this.journeyManifest = _data["journeyManifest"] ? JourneyManifest.fromJS(_data["journeyManifest"]) : <any>undefined;
            this.purchaseOrderManifest = _data["purchaseOrderManifest"] ? PurchaseOrderManifest.fromJS(_data["purchaseOrderManifest"]) : <any>undefined;
            this.stockReceiptManifest = _data["stockReceiptManifest"] ? StockReceiptManifest.fromJS(_data["stockReceiptManifest"]) : <any>undefined;
            this.supplierReturnManifest = _data["supplierReturnManifest"] ? SupplierReturnManifest.fromJS(_data["supplierReturnManifest"]) : <any>undefined;
            this.customerReturnManifest = _data["customerReturnManifest"] ? CustomerReturnManifest.fromJS(_data["customerReturnManifest"]) : <any>undefined;
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentManifest {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentManifest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentNumber"] = this.documentNumber;
        data["documentType"] = this.documentType;
        data["orderManifest"] = this.orderManifest ? this.orderManifest.toJSON() : <any>undefined;
        data["pickingNoteManifest"] = this.pickingNoteManifest ? this.pickingNoteManifest.toJSON() : <any>undefined;
        data["deliveryNoteManifest"] = this.deliveryNoteManifest ? this.deliveryNoteManifest.toJSON() : <any>undefined;
        data["addCostProrationManifest"] = this.addCostProrationManifest ? this.addCostProrationManifest.toJSON() : <any>undefined;
        data["workOrderManifest"] = this.workOrderManifest ? this.workOrderManifest.toJSON() : <any>undefined;
        data["creditNoteManifest"] = this.creditNoteManifest ? this.creditNoteManifest.toJSON() : <any>undefined;
        data["journeyManifest"] = this.journeyManifest ? this.journeyManifest.toJSON() : <any>undefined;
        data["purchaseOrderManifest"] = this.purchaseOrderManifest ? this.purchaseOrderManifest.toJSON() : <any>undefined;
        data["stockReceiptManifest"] = this.stockReceiptManifest ? this.stockReceiptManifest.toJSON() : <any>undefined;
        data["supplierReturnManifest"] = this.supplierReturnManifest ? this.supplierReturnManifest.toJSON() : <any>undefined;
        data["customerReturnManifest"] = this.customerReturnManifest ? this.customerReturnManifest.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDocumentManifest {
    documentId?: number | undefined;
    documentNumber?: number | undefined;
    documentType?: DocumentManifestDocumentType | undefined;
    orderManifest?: OrderManifest | undefined;
    pickingNoteManifest?: PickingNoteManifest | undefined;
    deliveryNoteManifest?: DeliveryNoteManifest | undefined;
    addCostProrationManifest?: AddCostProrationManifest | undefined;
    workOrderManifest?: WorkOrderManifest | undefined;
    creditNoteManifest?: CreditNoteManifest | undefined;
    journeyManifest?: JourneyManifest | undefined;
    purchaseOrderManifest?: PurchaseOrderManifest | undefined;
    stockReceiptManifest?: StockReceiptManifest | undefined;
    supplierReturnManifest?: SupplierReturnManifest | undefined;
    customerReturnManifest?: CustomerReturnManifest | undefined;
    status?: DocumentManifestStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
}

export class OrderManifest implements IOrderManifest {
    header?: OrderHeader | undefined;
    lines?: OrderLine[] | undefined;
    additionalCostCharges?: OrderAdditionalCostCharge[] | undefined;
    orderLineItems?: OrderLineItem[] | undefined;

    constructor(data?: IOrderManifest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? OrderHeader.fromJS(_data["header"]) : <any>undefined;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(OrderLine.fromJS(item));
            }
            if (Array.isArray(_data["additionalCostCharges"])) {
                this.additionalCostCharges = [] as any;
                for (let item of _data["additionalCostCharges"])
                    this.additionalCostCharges!.push(OrderAdditionalCostCharge.fromJS(item));
            }
            if (Array.isArray(_data["orderLineItems"])) {
                this.orderLineItems = [] as any;
                for (let item of _data["orderLineItems"])
                    this.orderLineItems!.push(OrderLineItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderManifest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderManifest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalCostCharges)) {
            data["additionalCostCharges"] = [];
            for (let item of this.additionalCostCharges)
                data["additionalCostCharges"].push(item.toJSON());
        }
        if (Array.isArray(this.orderLineItems)) {
            data["orderLineItems"] = [];
            for (let item of this.orderLineItems)
                data["orderLineItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOrderManifest {
    header?: OrderHeader | undefined;
    lines?: OrderLine[] | undefined;
    additionalCostCharges?: OrderAdditionalCostCharge[] | undefined;
    orderLineItems?: OrderLineItem[] | undefined;
}

export class PickingNoteManifest implements IPickingNoteManifest {
    header?: PickingNoteHeader | undefined;
    lines?: PickingNoteLine[] | undefined;

    constructor(data?: IPickingNoteManifest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? PickingNoteHeader.fromJS(_data["header"]) : <any>undefined;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(PickingNoteLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PickingNoteManifest {
        data = typeof data === 'object' ? data : {};
        let result = new PickingNoteManifest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPickingNoteManifest {
    header?: PickingNoteHeader | undefined;
    lines?: PickingNoteLine[] | undefined;
}

export class DeliveryNoteManifest implements IDeliveryNoteManifest {
    header?: DeliveryNoteHeader | undefined;
    lines?: DeliveryNoteLine[] | undefined;

    constructor(data?: IDeliveryNoteManifest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? DeliveryNoteHeader.fromJS(_data["header"]) : <any>undefined;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(DeliveryNoteLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeliveryNoteManifest {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryNoteManifest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeliveryNoteManifest {
    header?: DeliveryNoteHeader | undefined;
    lines?: DeliveryNoteLine[] | undefined;
}

export class AddCostProrationManifest implements IAddCostProrationManifest {
    lines?: AddCostProRateLine[] | undefined;
    header?: AddCostProrationHeader | undefined;
    documents?: AddCostProrationDocument[] | undefined;

    constructor(data?: IAddCostProrationManifest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(AddCostProRateLine.fromJS(item));
            }
            this.header = _data["header"] ? AddCostProrationHeader.fromJS(_data["header"]) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(AddCostProrationDocument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddCostProrationManifest {
        data = typeof data === 'object' ? data : {};
        let result = new AddCostProrationManifest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAddCostProrationManifest {
    lines?: AddCostProRateLine[] | undefined;
    header?: AddCostProrationHeader | undefined;
    documents?: AddCostProrationDocument[] | undefined;
}

export class WorkOrderManifest implements IWorkOrderManifest {
    header?: WorkOrderHeader | undefined;
    customerAndSupplier?: WorkOrderCustomersAndSupplier | undefined;
    linesSource?: WorkOrderLine[] | undefined;
    linesProcess?: WorkOrderLine[] | undefined;
    linesFinished?: WorkOrderLine[] | undefined;
    linesFinishedProcess?: WorkOrderLine[] | undefined;
    additionalCosts?: WorkOrderAdditionalCost[] | undefined;
    processHeaders?: WorkOrderProcessHeader[] | undefined;
    finishedAddCosts?: WorksOrderFinishedAddCost[] | undefined;

    constructor(data?: IWorkOrderManifest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? WorkOrderHeader.fromJS(_data["header"]) : <any>undefined;
            this.customerAndSupplier = _data["customerAndSupplier"] ? WorkOrderCustomersAndSupplier.fromJS(_data["customerAndSupplier"]) : <any>undefined;
            if (Array.isArray(_data["linesSource"])) {
                this.linesSource = [] as any;
                for (let item of _data["linesSource"])
                    this.linesSource!.push(WorkOrderLine.fromJS(item));
            }
            if (Array.isArray(_data["linesProcess"])) {
                this.linesProcess = [] as any;
                for (let item of _data["linesProcess"])
                    this.linesProcess!.push(WorkOrderLine.fromJS(item));
            }
            if (Array.isArray(_data["linesFinished"])) {
                this.linesFinished = [] as any;
                for (let item of _data["linesFinished"])
                    this.linesFinished!.push(WorkOrderLine.fromJS(item));
            }
            if (Array.isArray(_data["linesFinishedProcess"])) {
                this.linesFinishedProcess = [] as any;
                for (let item of _data["linesFinishedProcess"])
                    this.linesFinishedProcess!.push(WorkOrderLine.fromJS(item));
            }
            if (Array.isArray(_data["additionalCosts"])) {
                this.additionalCosts = [] as any;
                for (let item of _data["additionalCosts"])
                    this.additionalCosts!.push(WorkOrderAdditionalCost.fromJS(item));
            }
            if (Array.isArray(_data["processHeaders"])) {
                this.processHeaders = [] as any;
                for (let item of _data["processHeaders"])
                    this.processHeaders!.push(WorkOrderProcessHeader.fromJS(item));
            }
            if (Array.isArray(_data["finishedAddCosts"])) {
                this.finishedAddCosts = [] as any;
                for (let item of _data["finishedAddCosts"])
                    this.finishedAddCosts!.push(WorksOrderFinishedAddCost.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkOrderManifest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderManifest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["customerAndSupplier"] = this.customerAndSupplier ? this.customerAndSupplier.toJSON() : <any>undefined;
        if (Array.isArray(this.linesSource)) {
            data["linesSource"] = [];
            for (let item of this.linesSource)
                data["linesSource"].push(item.toJSON());
        }
        if (Array.isArray(this.linesProcess)) {
            data["linesProcess"] = [];
            for (let item of this.linesProcess)
                data["linesProcess"].push(item.toJSON());
        }
        if (Array.isArray(this.linesFinished)) {
            data["linesFinished"] = [];
            for (let item of this.linesFinished)
                data["linesFinished"].push(item.toJSON());
        }
        if (Array.isArray(this.linesFinishedProcess)) {
            data["linesFinishedProcess"] = [];
            for (let item of this.linesFinishedProcess)
                data["linesFinishedProcess"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalCosts)) {
            data["additionalCosts"] = [];
            for (let item of this.additionalCosts)
                data["additionalCosts"].push(item.toJSON());
        }
        if (Array.isArray(this.processHeaders)) {
            data["processHeaders"] = [];
            for (let item of this.processHeaders)
                data["processHeaders"].push(item.toJSON());
        }
        if (Array.isArray(this.finishedAddCosts)) {
            data["finishedAddCosts"] = [];
            for (let item of this.finishedAddCosts)
                data["finishedAddCosts"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWorkOrderManifest {
    header?: WorkOrderHeader | undefined;
    customerAndSupplier?: WorkOrderCustomersAndSupplier | undefined;
    linesSource?: WorkOrderLine[] | undefined;
    linesProcess?: WorkOrderLine[] | undefined;
    linesFinished?: WorkOrderLine[] | undefined;
    linesFinishedProcess?: WorkOrderLine[] | undefined;
    additionalCosts?: WorkOrderAdditionalCost[] | undefined;
    processHeaders?: WorkOrderProcessHeader[] | undefined;
    finishedAddCosts?: WorksOrderFinishedAddCost[] | undefined;
}

export class CreditNoteManifest implements ICreditNoteManifest {
    header?: CreditNoteHeader | undefined;
    lines?: CreditNoteLine[] | undefined;
    additionalCosts?: CreditNoteAdditionalCost[] | undefined;

    constructor(data?: ICreditNoteManifest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? CreditNoteHeader.fromJS(_data["header"]) : <any>undefined;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(CreditNoteLine.fromJS(item));
            }
            if (Array.isArray(_data["additionalCosts"])) {
                this.additionalCosts = [] as any;
                for (let item of _data["additionalCosts"])
                    this.additionalCosts!.push(CreditNoteAdditionalCost.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreditNoteManifest {
        data = typeof data === 'object' ? data : {};
        let result = new CreditNoteManifest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalCosts)) {
            data["additionalCosts"] = [];
            for (let item of this.additionalCosts)
                data["additionalCosts"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreditNoteManifest {
    header?: CreditNoteHeader | undefined;
    lines?: CreditNoteLine[] | undefined;
    additionalCosts?: CreditNoteAdditionalCost[] | undefined;
}

export class JourneyManifest implements IJourneyManifest {
    udfInfos?: UdfInfo[] | undefined;
    journeyStopIdsDeleted?: string | undefined;
    journeyLines?: JourneyManifestLine[] | undefined;
    journeyStops?: JourneyManifestStop[] | undefined;
    journeyDropsByProduct?: JourneyManifestLineDropsByProduct[] | undefined;
    journeyDeliveryAreas?: JourneyManifestDeliveryArea[] | undefined;
    header?: JourneyManifestHeader | undefined;

    constructor(data?: IJourneyManifest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["udfInfos"])) {
                this.udfInfos = [] as any;
                for (let item of _data["udfInfos"])
                    this.udfInfos!.push(UdfInfo.fromJS(item));
            }
            this.journeyStopIdsDeleted = _data["journeyStopIdsDeleted"];
            if (Array.isArray(_data["journeyLines"])) {
                this.journeyLines = [] as any;
                for (let item of _data["journeyLines"])
                    this.journeyLines!.push(JourneyManifestLine.fromJS(item));
            }
            if (Array.isArray(_data["journeyStops"])) {
                this.journeyStops = [] as any;
                for (let item of _data["journeyStops"])
                    this.journeyStops!.push(JourneyManifestStop.fromJS(item));
            }
            if (Array.isArray(_data["journeyDropsByProduct"])) {
                this.journeyDropsByProduct = [] as any;
                for (let item of _data["journeyDropsByProduct"])
                    this.journeyDropsByProduct!.push(JourneyManifestLineDropsByProduct.fromJS(item));
            }
            if (Array.isArray(_data["journeyDeliveryAreas"])) {
                this.journeyDeliveryAreas = [] as any;
                for (let item of _data["journeyDeliveryAreas"])
                    this.journeyDeliveryAreas!.push(JourneyManifestDeliveryArea.fromJS(item));
            }
            this.header = _data["header"] ? JourneyManifestHeader.fromJS(_data["header"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JourneyManifest {
        data = typeof data === 'object' ? data : {};
        let result = new JourneyManifest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.udfInfos)) {
            data["udfInfos"] = [];
            for (let item of this.udfInfos)
                data["udfInfos"].push(item.toJSON());
        }
        data["journeyStopIdsDeleted"] = this.journeyStopIdsDeleted;
        if (Array.isArray(this.journeyLines)) {
            data["journeyLines"] = [];
            for (let item of this.journeyLines)
                data["journeyLines"].push(item.toJSON());
        }
        if (Array.isArray(this.journeyStops)) {
            data["journeyStops"] = [];
            for (let item of this.journeyStops)
                data["journeyStops"].push(item.toJSON());
        }
        if (Array.isArray(this.journeyDropsByProduct)) {
            data["journeyDropsByProduct"] = [];
            for (let item of this.journeyDropsByProduct)
                data["journeyDropsByProduct"].push(item.toJSON());
        }
        if (Array.isArray(this.journeyDeliveryAreas)) {
            data["journeyDeliveryAreas"] = [];
            for (let item of this.journeyDeliveryAreas)
                data["journeyDeliveryAreas"].push(item.toJSON());
        }
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IJourneyManifest {
    udfInfos?: UdfInfo[] | undefined;
    journeyStopIdsDeleted?: string | undefined;
    journeyLines?: JourneyManifestLine[] | undefined;
    journeyStops?: JourneyManifestStop[] | undefined;
    journeyDropsByProduct?: JourneyManifestLineDropsByProduct[] | undefined;
    journeyDeliveryAreas?: JourneyManifestDeliveryArea[] | undefined;
    header?: JourneyManifestHeader | undefined;
}

export class PurchaseOrderManifest implements IPurchaseOrderManifest {
    header?: PurchaseOrderHeader | undefined;
    department?: PurchaseOrderDepartment | undefined;
    lines?: PurchaseOrderLine[] | undefined;
    additionalCostCharges?: PurchaseOrderAdditionalCostCharge[] | undefined;

    constructor(data?: IPurchaseOrderManifest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? PurchaseOrderHeader.fromJS(_data["header"]) : <any>undefined;
            this.department = _data["department"] ? PurchaseOrderDepartment.fromJS(_data["department"]) : <any>undefined;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(PurchaseOrderLine.fromJS(item));
            }
            if (Array.isArray(_data["additionalCostCharges"])) {
                this.additionalCostCharges = [] as any;
                for (let item of _data["additionalCostCharges"])
                    this.additionalCostCharges!.push(PurchaseOrderAdditionalCostCharge.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchaseOrderManifest {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderManifest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalCostCharges)) {
            data["additionalCostCharges"] = [];
            for (let item of this.additionalCostCharges)
                data["additionalCostCharges"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPurchaseOrderManifest {
    header?: PurchaseOrderHeader | undefined;
    department?: PurchaseOrderDepartment | undefined;
    lines?: PurchaseOrderLine[] | undefined;
    additionalCostCharges?: PurchaseOrderAdditionalCostCharge[] | undefined;
}

export class StockReceiptManifest implements IStockReceiptManifest {
    header?: StockReceiptHeader | undefined;
    lines?: StockReceiptLine[] | undefined;

    constructor(data?: IStockReceiptManifest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? StockReceiptHeader.fromJS(_data["header"]) : <any>undefined;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(StockReceiptLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockReceiptManifest {
        data = typeof data === 'object' ? data : {};
        let result = new StockReceiptManifest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStockReceiptManifest {
    header?: StockReceiptHeader | undefined;
    lines?: StockReceiptLine[] | undefined;
}

export class SupplierReturnManifest implements ISupplierReturnManifest {
    header?: SupplierReturnHeader | undefined;
    lines?: SupplierReturnLine[] | undefined;
    supplierReturnsAddCostCharge?: SupplierReturnsAddCostCharge[] | undefined;

    constructor(data?: ISupplierReturnManifest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? SupplierReturnHeader.fromJS(_data["header"]) : <any>undefined;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(SupplierReturnLine.fromJS(item));
            }
            if (Array.isArray(_data["supplierReturnsAddCostCharge"])) {
                this.supplierReturnsAddCostCharge = [] as any;
                for (let item of _data["supplierReturnsAddCostCharge"])
                    this.supplierReturnsAddCostCharge!.push(SupplierReturnsAddCostCharge.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SupplierReturnManifest {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierReturnManifest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        if (Array.isArray(this.supplierReturnsAddCostCharge)) {
            data["supplierReturnsAddCostCharge"] = [];
            for (let item of this.supplierReturnsAddCostCharge)
                data["supplierReturnsAddCostCharge"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISupplierReturnManifest {
    header?: SupplierReturnHeader | undefined;
    lines?: SupplierReturnLine[] | undefined;
    supplierReturnsAddCostCharge?: SupplierReturnsAddCostCharge[] | undefined;
}

export class CustomerReturnManifest implements ICustomerReturnManifest {
    header?: CustomerReturnHeader | undefined;
    lines?: CustomerReturnLine[] | undefined;
    lineItems?: CustomerReturnLineItem[] | undefined;

    constructor(data?: ICustomerReturnManifest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"] ? CustomerReturnHeader.fromJS(_data["header"]) : <any>undefined;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(CustomerReturnLine.fromJS(item));
            }
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(CustomerReturnLineItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerReturnManifest {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerReturnManifest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerReturnManifest {
    header?: CustomerReturnHeader | undefined;
    lines?: CustomerReturnLine[] | undefined;
    lineItems?: CustomerReturnLineItem[] | undefined;
}

export class OrderHeader implements IOrderHeader {
    orderID?: number | undefined;
    deleted?: number | undefined;
    orderNumber?: number | undefined;
    offlineOrderNumber?: number | undefined;
    preallocatedInvoiceNumber?: number | undefined;
    preallocatedDueDate?: Date | undefined;
    orderType?: OrderHeaderOrderType | undefined;
    orderStatus?: OrderHeaderOrderStatus | undefined;
    orderSubStatus?: OrderHeaderOrderSubStatus | undefined;
    description?: string | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    computerID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    lastModifiedByID?: number | undefined;
    branchID?: number | undefined;
    hasExternalAVOs?: boolean | undefined;
    toBranchID?: number | undefined;
    viaBranchID?: number | undefined;
    orderingBranchID?: number | undefined;
    issuingBranchID?: number | undefined;
    stockLocationID?: number | undefined;
    toStockLocationID?: number | undefined;
    customerID?: number | undefined;
    userID?: number | undefined;
    saleType?: number | undefined;
    cashSale?: boolean | undefined;
    orderPlacementTypeID?: number | undefined;
    dateRequired?: Date | undefined;
    dateRequiredOption?: number | undefined;
    daysToReserve?: number | undefined;
    expiryDate?: Date | undefined;
    quoteRank?: string | undefined;
    followUpDateTime?: Date | undefined;
    customerRef?: string | undefined;
    contactName?: string | undefined;
    contactNumber?: string | undefined;
    contactIdentified?: boolean | undefined;
    salesRepID?: number | undefined;
    salesAreaID?: number | undefined;
    yardBookRef?: string | undefined;
    orderConfirmed?: boolean | undefined;
    confirmationNotes?: string | undefined;
    testCertOption?: number | undefined;
    qaContact?: string | undefined;
    chargeRollingMargin?: boolean | undefined;
    deliveryAddressID?: number | undefined;
    deliveryAddress?: string | undefined;
    deliveryAddressLine1?: string | undefined;
    deliveryAddressLine2?: string | undefined;
    deliveryAddressLine3?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryCounty?: string | undefined;
    deliveryPostCode?: string | undefined;
    deliveryCountry?: string | undefined;
    deliveryAreaID?: number | undefined;
    deliveryTime?: number | undefined;
    deliveryOption?: number | undefined;
    invoiceAddressID?: number | undefined;
    invoiceAddress?: string | undefined;
    paymentTermsID?: number | undefined;
    vatNumber?: string | undefined;
    nonDiscountAmountInCurrency?: number | undefined;
    showEurosOnInvoice?: boolean | undefined;
    taxAreaID?: number | undefined;
    useTaxExemptCertificate?: boolean | undefined;
    vehicleTypeID?: number | undefined;
    vehicleID?: number | undefined;
    specialInstructions?: string | undefined;
    headerNotes?: string | undefined;
    notes?: string | undefined;
    onlyShowLumpSumPrice?: boolean | undefined;
    useSimpleOrderProcessing?: boolean | undefined;
    totalCostPrice?: number | undefined;
    commissionTotalCostPrice?: number | undefined;
    totalInternalCostPrice?: number | undefined;
    totalSellPrice?: number | undefined;
    totalVAT?: number | undefined;
    totalTax?: number | undefined;
    totalMargin?: number | undefined;
    commissionTotalMargin?: number | undefined;
    totalWeight?: number | undefined;
    totalVolume?: number | undefined;
    noOfPacks?: number | undefined;
    deliveryCharge?: number | undefined;
    deliveryCost?: number | undefined;
    deliverySalesAnalysisCodeID?: number | undefined;
    currencyID?: number | undefined;
    exchangeRate?: number | undefined;
    totalSellPriceInCurrency?: number | undefined;
    totalVatInCurrency?: number | undefined;
    totalTaxInCurrency?: number | undefined;
    deliveryChargeInCurrency?: number | undefined;
    backOrderedFromID?: number | undefined;
    backOrderCount?: number | undefined;
    calledOffFromID?: number | undefined;
    callOffEnforceSchedule?: boolean | undefined;
    createdFromOrderID?: number | undefined;
    createdFromWorksOrderID?: number | undefined;
    picked?: boolean | undefined;
    delivered?: boolean | undefined;
    deliveryDate?: Date | undefined;
    deliveryReference?: string | undefined;
    proofOfDeliveryReturned?: boolean | undefined;
    stockIssued?: boolean | undefined;
    dateTimeIssued?: Date | undefined;
    approval?: number | undefined;
    dateTimeApproved?: Date | undefined;
    approvedByID?: number | undefined;
    cashOnDeliveryAmount?: number | undefined;
    cashOnDeliveryRequested?: number | undefined;
    cashOnDeliveryReceived?: number | undefined;
    cashAccountBalanceAmount?: number | undefined;
    paymentOutstanding?: number | undefined;
    releaseTotalSellPrice?: number | undefined;
    invoiceID?: number | undefined;
    invoiced?: boolean | undefined;
    dateTimeTransferred?: Date | undefined;
    noOfLines?: number | undefined;
    maximumWidth?: number | undefined;
    maximumLength?: number | undefined;
    hasAVOs?: boolean | undefined;
    hasCuts?: boolean | undefined;
    hasProfiles?: boolean | undefined;
    outstandingAVOs?: number | undefined;
    outstandingCuts?: number | undefined;
    worksOrderCount?: number | undefined;
    worksOrderCountCompleted?: number | undefined;
    rejectionReasonID?: number | undefined;
    dateTimeQuoteRejected?: Date | undefined;
    dateTimeQuoteAccepted?: Date | undefined;
    rejectedOrAcceptedByID?: number | undefined;
    questionsAsked?: number | undefined;
    otherFlags?: number | undefined;
    printed?: boolean | undefined;
    printedPickingNote?: boolean | undefined;
    printedDeliveryNote?: boolean | undefined;
    journeyID?: number | undefined;
    readyForBooking?: boolean | undefined;
    readyByID?: number | undefined;
    readyDate?: Date | undefined;
    dateTimeMarkedReady?: Date | undefined;
    transportInstructionID?: number | undefined;
    distance?: number | undefined;
    transportBooked?: number | undefined;
    pickupDate?: Date | undefined;
    bookedByID?: number | undefined;
    dateTimeMarkedBooked?: Date | undefined;
    bookingNumber?: number | undefined;
    carrierID?: number | undefined;
    vehicleName?: string | undefined;
    sellPriceProfileID?: number | undefined;
    contractID?: number | undefined;
    contractInvoicing?: boolean | undefined;
    contactEmailAddress?: string | undefined;
    settlementDiscount?: number | undefined;
    settlementAmount?: number | undefined;
    settlementAmountInCurrency?: number | undefined;
    generatedOrder?: boolean | undefined;
    supplierSettlementAmount?: number | undefined;
    supplierSettlementAmountInCurrency?: number | undefined;
    cashOnDeliveryAmountInCurrency?: number | undefined;
    cashOnDeliveryRequestedInCurrency?: number | undefined;
    cashOnDeliveryReceivedInCurrency?: number | undefined;
    paymentOutstandingInCurrency?: number | undefined;
    rebateSaleType?: number | undefined;
    arCustomerID?: number | undefined;
    approvalNumber?: string | undefined;
    ladingQuantity?: number | undefined;
    createdFromCreditNoteID?: number | undefined;
    contractInvoicingLineID?: number | undefined;
    taxVerifiedByID?: number | undefined;
    campaignMemberID?: number | undefined;
    opportunityID?: number | undefined;
    dateRequested?: Date | undefined;
    quoteRankID?: number | undefined;
    imaged?: number | undefined;
    directCallOffPONumber?: number | undefined;
    computerDefaultPrinter?: string | undefined;
    allowCallingOffSectionsInWebTrack?: boolean | undefined;
    needsJourneyFromViaBranch?: boolean | undefined;
    viaBranchJourneyID?: number | undefined;
    nonSalesAmount?: number | undefined;
    wmsPickingStatus?: number | undefined;
    nonSalesAmountInCurrency?: number | undefined;
    internalCostTotalMargin?: number | undefined;
    wmsProcessed?: boolean | undefined;
    viaBranchVehicleTypeID?: number | undefined;
    viaBranchVehicleID?: number | undefined;
    splitFromOrderID?: number | undefined;
    splitJourneyToSchedule?: boolean | undefined;
    wmsJourneyID?: number | undefined;
    convertedFromOrderType?: number | undefined;
    convertedFromOrderNumber?: number | undefined;
    releasedFromMarginHold?: boolean | undefined;
    netPriced?: boolean | undefined;
    excludeFromWMS?: boolean | undefined;
    sellPriceMultiplier?: number | undefined;
    buyPriceMultiplier?: number | undefined;
    rebill?: boolean | undefined;
    taxUsageTypeID?: number | undefined;
    calculatedDateRequired?: boolean | undefined;
    rewardsCardNumber?: string | undefined;
    source?: number | undefined;
    scaleGrossWeight?: number | undefined;
    preallocatedPurchaseOrderNumber?: number | undefined;
    issueStockPending?: boolean | undefined;
    printTestCertificates?: number | undefined;
    contactID?: number | undefined;
    branch?: Branch | undefined;
    branch1?: Branch | undefined;
    branch2?: Branch | undefined;
    branch3?: Branch | undefined;
    branch4?: Branch | undefined;
    branch5?: Branch | undefined;
    customerAddress?: CustomerAddress | undefined;
    customerAddress1?: CustomerAddress | undefined;
    deliveryArea?: DeliveryArea | undefined;
    journeyHeader?: JourneyHeader | undefined;
    journeyHeader1?: JourneyHeader | undefined;
    journeyHeader2?: JourneyHeader | undefined;
    journeyLines?: JourneyLine[] | undefined;
    user?: User | undefined;
    supplier?: Supplier | undefined;
    user1?: User | undefined;
    user2?: User | undefined;
    stockLocation?: StockLocation | undefined;
    user3?: User | undefined;
    stockLocation1?: StockLocation | undefined;
    user4?: User | undefined;
    vehicle?: Vehicle | undefined;
    vehicleType?: VehicleType | undefined;
    vehicleTypeName?: string | undefined;
    deliveryVehicleName?: string | undefined;
    viaBranchVehicleTypeName?: string | undefined;
    viaBranchVehicleName?: string | undefined;
    userName?: string | undefined;
    branchCode?: string | undefined;
    branchName?: string | undefined;
    toBranchCode?: string | undefined;
    toBranchName?: string | undefined;
    viaBranchCode?: string | undefined;
    viaBranchName?: string | undefined;
    issuingBranchCode?: string | undefined;
    issuingBranchName?: string | undefined;
    salesRepName?: string | undefined;
    orderPlacementTypeName?: string | undefined;
    orderPlacementTypeSkipSignatureCapture?: boolean | undefined;
    createdByName?: string | undefined;
    lastModifiedByName?: string | undefined;
    carrierName?: string | undefined;
    contractStatus?: number | undefined;
    customerName?: string | undefined;
    isValid?: boolean | undefined;
    pickingCheckedByID?: number | undefined;
    lines?: OrderLine[] | undefined;
    payments?: OrderPayment[] | undefined;
    totalTaxOnCost?: number | undefined;
    totalTaxOnCostInCurrency?: number | undefined;
    customerOnHold?: boolean | undefined;
    customerCreditControlStatusID?: number | undefined;
    customerAvailableCredit?: number | undefined;
    customerIsCashAccount?: boolean | undefined;
    transferStockShortage?: boolean | undefined;
    readonly journeyTransportCostsApplied?: boolean | undefined;
    readonly isTransferReturn?: boolean | undefined;
    issuingBranchIsSet?: boolean | undefined;
    readonly jobDefaultAddressTaxAreaID?: number | undefined;
    readonly customerTaxAreaID?: number | undefined;
    readonly taxAreaIDUsed?: number | undefined;
    printTheseFormats?: string | undefined;
    includeTheseFormats?: string | undefined;
    excludeTheseFormats?: string | undefined;
    printedPickingNotePriorToThisPrintingSession?: boolean | undefined;
    printedDeliveryNotePriorToThisPrintingSession?: boolean | undefined;
    readonly selected?: boolean | undefined;
    readonly checkedByID?: number | undefined;
    readonly errorList?: string | undefined;

    constructor(data?: IOrderHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderID = _data["orderID"];
            this.deleted = _data["deleted"];
            this.orderNumber = _data["orderNumber"];
            this.offlineOrderNumber = _data["offlineOrderNumber"];
            this.preallocatedInvoiceNumber = _data["preallocatedInvoiceNumber"];
            this.preallocatedDueDate = _data["preallocatedDueDate"] ? new Date(_data["preallocatedDueDate"].toString()) : <any>undefined;
            this.orderType = _data["orderType"];
            this.orderStatus = _data["orderStatus"];
            this.orderSubStatus = _data["orderSubStatus"];
            this.description = _data["description"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.createdByID = _data["createdByID"];
            this.computerID = _data["computerID"];
            this.dateTimeLastModified = _data["dateTimeLastModified"] ? new Date(_data["dateTimeLastModified"].toString()) : <any>undefined;
            this.lastModifiedByID = _data["lastModifiedByID"];
            this.branchID = _data["branchID"];
            this.hasExternalAVOs = _data["hasExternalAVOs"];
            this.toBranchID = _data["toBranchID"];
            this.viaBranchID = _data["viaBranchID"];
            this.orderingBranchID = _data["orderingBranchID"];
            this.issuingBranchID = _data["issuingBranchID"];
            this.stockLocationID = _data["stockLocationID"];
            this.toStockLocationID = _data["toStockLocationID"];
            this.customerID = _data["customerID"];
            this.userID = _data["userID"];
            this.saleType = _data["saleType"];
            this.cashSale = _data["cashSale"];
            this.orderPlacementTypeID = _data["orderPlacementTypeID"];
            this.dateRequired = _data["dateRequired"] ? new Date(_data["dateRequired"].toString()) : <any>undefined;
            this.dateRequiredOption = _data["dateRequiredOption"];
            this.daysToReserve = _data["daysToReserve"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.quoteRank = _data["quoteRank"];
            this.followUpDateTime = _data["followUpDateTime"] ? new Date(_data["followUpDateTime"].toString()) : <any>undefined;
            this.customerRef = _data["customerRef"];
            this.contactName = _data["contactName"];
            this.contactNumber = _data["contactNumber"];
            this.contactIdentified = _data["contactIdentified"];
            this.salesRepID = _data["salesRepID"];
            this.salesAreaID = _data["salesAreaID"];
            this.yardBookRef = _data["yardBookRef"];
            this.orderConfirmed = _data["orderConfirmed"];
            this.confirmationNotes = _data["confirmationNotes"];
            this.testCertOption = _data["testCertOption"];
            this.qaContact = _data["qaContact"];
            this.chargeRollingMargin = _data["chargeRollingMargin"];
            this.deliveryAddressID = _data["deliveryAddressID"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.deliveryAddressLine1 = _data["deliveryAddressLine1"];
            this.deliveryAddressLine2 = _data["deliveryAddressLine2"];
            this.deliveryAddressLine3 = _data["deliveryAddressLine3"];
            this.deliveryCity = _data["deliveryCity"];
            this.deliveryCounty = _data["deliveryCounty"];
            this.deliveryPostCode = _data["deliveryPostCode"];
            this.deliveryCountry = _data["deliveryCountry"];
            this.deliveryAreaID = _data["deliveryAreaID"];
            this.deliveryTime = _data["deliveryTime"];
            this.deliveryOption = _data["deliveryOption"];
            this.invoiceAddressID = _data["invoiceAddressID"];
            this.invoiceAddress = _data["invoiceAddress"];
            this.paymentTermsID = _data["paymentTermsID"];
            this.vatNumber = _data["vatNumber"];
            this.nonDiscountAmountInCurrency = _data["nonDiscountAmountInCurrency"];
            this.showEurosOnInvoice = _data["showEurosOnInvoice"];
            this.taxAreaID = _data["taxAreaID"];
            this.useTaxExemptCertificate = _data["useTaxExemptCertificate"];
            this.vehicleTypeID = _data["vehicleTypeID"];
            this.vehicleID = _data["vehicleID"];
            this.specialInstructions = _data["specialInstructions"];
            this.headerNotes = _data["headerNotes"];
            this.notes = _data["notes"];
            this.onlyShowLumpSumPrice = _data["onlyShowLumpSumPrice"];
            this.useSimpleOrderProcessing = _data["useSimpleOrderProcessing"];
            this.totalCostPrice = _data["totalCostPrice"];
            this.commissionTotalCostPrice = _data["commissionTotalCostPrice"];
            this.totalInternalCostPrice = _data["totalInternalCostPrice"];
            this.totalSellPrice = _data["totalSellPrice"];
            this.totalVAT = _data["totalVAT"];
            this.totalTax = _data["totalTax"];
            this.totalMargin = _data["totalMargin"];
            this.commissionTotalMargin = _data["commissionTotalMargin"];
            this.totalWeight = _data["totalWeight"];
            this.totalVolume = _data["totalVolume"];
            this.noOfPacks = _data["noOfPacks"];
            this.deliveryCharge = _data["deliveryCharge"];
            this.deliveryCost = _data["deliveryCost"];
            this.deliverySalesAnalysisCodeID = _data["deliverySalesAnalysisCodeID"];
            this.currencyID = _data["currencyID"];
            this.exchangeRate = _data["exchangeRate"];
            this.totalSellPriceInCurrency = _data["totalSellPriceInCurrency"];
            this.totalVatInCurrency = _data["totalVatInCurrency"];
            this.totalTaxInCurrency = _data["totalTaxInCurrency"];
            this.deliveryChargeInCurrency = _data["deliveryChargeInCurrency"];
            this.backOrderedFromID = _data["backOrderedFromID"];
            this.backOrderCount = _data["backOrderCount"];
            this.calledOffFromID = _data["calledOffFromID"];
            this.callOffEnforceSchedule = _data["callOffEnforceSchedule"];
            this.createdFromOrderID = _data["createdFromOrderID"];
            this.createdFromWorksOrderID = _data["createdFromWorksOrderID"];
            this.picked = _data["picked"];
            this.delivered = _data["delivered"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.deliveryReference = _data["deliveryReference"];
            this.proofOfDeliveryReturned = _data["proofOfDeliveryReturned"];
            this.stockIssued = _data["stockIssued"];
            this.dateTimeIssued = _data["dateTimeIssued"] ? new Date(_data["dateTimeIssued"].toString()) : <any>undefined;
            this.approval = _data["approval"];
            this.dateTimeApproved = _data["dateTimeApproved"] ? new Date(_data["dateTimeApproved"].toString()) : <any>undefined;
            this.approvedByID = _data["approvedByID"];
            this.cashOnDeliveryAmount = _data["cashOnDeliveryAmount"];
            this.cashOnDeliveryRequested = _data["cashOnDeliveryRequested"];
            this.cashOnDeliveryReceived = _data["cashOnDeliveryReceived"];
            this.cashAccountBalanceAmount = _data["cashAccountBalanceAmount"];
            this.paymentOutstanding = _data["paymentOutstanding"];
            this.releaseTotalSellPrice = _data["releaseTotalSellPrice"];
            this.invoiceID = _data["invoiceID"];
            this.invoiced = _data["invoiced"];
            this.dateTimeTransferred = _data["dateTimeTransferred"] ? new Date(_data["dateTimeTransferred"].toString()) : <any>undefined;
            this.noOfLines = _data["noOfLines"];
            this.maximumWidth = _data["maximumWidth"];
            this.maximumLength = _data["maximumLength"];
            this.hasAVOs = _data["hasAVOs"];
            this.hasCuts = _data["hasCuts"];
            this.hasProfiles = _data["hasProfiles"];
            this.outstandingAVOs = _data["outstandingAVOs"];
            this.outstandingCuts = _data["outstandingCuts"];
            this.worksOrderCount = _data["worksOrderCount"];
            this.worksOrderCountCompleted = _data["worksOrderCountCompleted"];
            this.rejectionReasonID = _data["rejectionReasonID"];
            this.dateTimeQuoteRejected = _data["dateTimeQuoteRejected"] ? new Date(_data["dateTimeQuoteRejected"].toString()) : <any>undefined;
            this.dateTimeQuoteAccepted = _data["dateTimeQuoteAccepted"] ? new Date(_data["dateTimeQuoteAccepted"].toString()) : <any>undefined;
            this.rejectedOrAcceptedByID = _data["rejectedOrAcceptedByID"];
            this.questionsAsked = _data["questionsAsked"];
            this.otherFlags = _data["otherFlags"];
            this.printed = _data["printed"];
            this.printedPickingNote = _data["printedPickingNote"];
            this.printedDeliveryNote = _data["printedDeliveryNote"];
            this.journeyID = _data["journeyID"];
            this.readyForBooking = _data["readyForBooking"];
            this.readyByID = _data["readyByID"];
            this.readyDate = _data["readyDate"] ? new Date(_data["readyDate"].toString()) : <any>undefined;
            this.dateTimeMarkedReady = _data["dateTimeMarkedReady"] ? new Date(_data["dateTimeMarkedReady"].toString()) : <any>undefined;
            this.transportInstructionID = _data["transportInstructionID"];
            this.distance = _data["distance"];
            this.transportBooked = _data["transportBooked"];
            this.pickupDate = _data["pickupDate"] ? new Date(_data["pickupDate"].toString()) : <any>undefined;
            this.bookedByID = _data["bookedByID"];
            this.dateTimeMarkedBooked = _data["dateTimeMarkedBooked"] ? new Date(_data["dateTimeMarkedBooked"].toString()) : <any>undefined;
            this.bookingNumber = _data["bookingNumber"];
            this.carrierID = _data["carrierID"];
            this.vehicleName = _data["vehicleName"];
            this.sellPriceProfileID = _data["sellPriceProfileID"];
            this.contractID = _data["contractID"];
            this.contractInvoicing = _data["contractInvoicing"];
            this.contactEmailAddress = _data["contactEmailAddress"];
            this.settlementDiscount = _data["settlementDiscount"];
            this.settlementAmount = _data["settlementAmount"];
            this.settlementAmountInCurrency = _data["settlementAmountInCurrency"];
            this.generatedOrder = _data["generatedOrder"];
            this.supplierSettlementAmount = _data["supplierSettlementAmount"];
            this.supplierSettlementAmountInCurrency = _data["supplierSettlementAmountInCurrency"];
            this.cashOnDeliveryAmountInCurrency = _data["cashOnDeliveryAmountInCurrency"];
            this.cashOnDeliveryRequestedInCurrency = _data["cashOnDeliveryRequestedInCurrency"];
            this.cashOnDeliveryReceivedInCurrency = _data["cashOnDeliveryReceivedInCurrency"];
            this.paymentOutstandingInCurrency = _data["paymentOutstandingInCurrency"];
            this.rebateSaleType = _data["rebateSaleType"];
            this.arCustomerID = _data["arCustomerID"];
            this.approvalNumber = _data["approvalNumber"];
            this.ladingQuantity = _data["ladingQuantity"];
            this.createdFromCreditNoteID = _data["createdFromCreditNoteID"];
            this.contractInvoicingLineID = _data["contractInvoicingLineID"];
            this.taxVerifiedByID = _data["taxVerifiedByID"];
            this.campaignMemberID = _data["campaignMemberID"];
            this.opportunityID = _data["opportunityID"];
            this.dateRequested = _data["dateRequested"] ? new Date(_data["dateRequested"].toString()) : <any>undefined;
            this.quoteRankID = _data["quoteRankID"];
            this.imaged = _data["imaged"];
            this.directCallOffPONumber = _data["directCallOffPONumber"];
            this.computerDefaultPrinter = _data["computerDefaultPrinter"];
            this.allowCallingOffSectionsInWebTrack = _data["allowCallingOffSectionsInWebTrack"];
            this.needsJourneyFromViaBranch = _data["needsJourneyFromViaBranch"];
            this.viaBranchJourneyID = _data["viaBranchJourneyID"];
            this.nonSalesAmount = _data["nonSalesAmount"];
            this.wmsPickingStatus = _data["wmsPickingStatus"];
            this.nonSalesAmountInCurrency = _data["nonSalesAmountInCurrency"];
            this.internalCostTotalMargin = _data["internalCostTotalMargin"];
            this.wmsProcessed = _data["wmsProcessed"];
            this.viaBranchVehicleTypeID = _data["viaBranchVehicleTypeID"];
            this.viaBranchVehicleID = _data["viaBranchVehicleID"];
            this.splitFromOrderID = _data["splitFromOrderID"];
            this.splitJourneyToSchedule = _data["splitJourneyToSchedule"];
            this.wmsJourneyID = _data["wmsJourneyID"];
            this.convertedFromOrderType = _data["convertedFromOrderType"];
            this.convertedFromOrderNumber = _data["convertedFromOrderNumber"];
            this.releasedFromMarginHold = _data["releasedFromMarginHold"];
            this.netPriced = _data["netPriced"];
            this.excludeFromWMS = _data["excludeFromWMS"];
            this.sellPriceMultiplier = _data["sellPriceMultiplier"];
            this.buyPriceMultiplier = _data["buyPriceMultiplier"];
            this.rebill = _data["rebill"];
            this.taxUsageTypeID = _data["taxUsageTypeID"];
            this.calculatedDateRequired = _data["calculatedDateRequired"];
            this.rewardsCardNumber = _data["rewardsCardNumber"];
            this.source = _data["source"];
            this.scaleGrossWeight = _data["scaleGrossWeight"];
            this.preallocatedPurchaseOrderNumber = _data["preallocatedPurchaseOrderNumber"];
            this.issueStockPending = _data["issueStockPending"];
            this.printTestCertificates = _data["printTestCertificates"];
            this.contactID = _data["contactID"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"]) : <any>undefined;
            this.branch1 = _data["branch1"] ? Branch.fromJS(_data["branch1"]) : <any>undefined;
            this.branch2 = _data["branch2"] ? Branch.fromJS(_data["branch2"]) : <any>undefined;
            this.branch3 = _data["branch3"] ? Branch.fromJS(_data["branch3"]) : <any>undefined;
            this.branch4 = _data["branch4"] ? Branch.fromJS(_data["branch4"]) : <any>undefined;
            this.branch5 = _data["branch5"] ? Branch.fromJS(_data["branch5"]) : <any>undefined;
            this.customerAddress = _data["customerAddress"] ? CustomerAddress.fromJS(_data["customerAddress"]) : <any>undefined;
            this.customerAddress1 = _data["customerAddress1"] ? CustomerAddress.fromJS(_data["customerAddress1"]) : <any>undefined;
            this.deliveryArea = _data["deliveryArea"] ? DeliveryArea.fromJS(_data["deliveryArea"]) : <any>undefined;
            this.journeyHeader = _data["journeyHeader"] ? JourneyHeader.fromJS(_data["journeyHeader"]) : <any>undefined;
            this.journeyHeader1 = _data["journeyHeader1"] ? JourneyHeader.fromJS(_data["journeyHeader1"]) : <any>undefined;
            this.journeyHeader2 = _data["journeyHeader2"] ? JourneyHeader.fromJS(_data["journeyHeader2"]) : <any>undefined;
            if (Array.isArray(_data["journeyLines"])) {
                this.journeyLines = [] as any;
                for (let item of _data["journeyLines"])
                    this.journeyLines!.push(JourneyLine.fromJS(item));
            }
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.supplier = _data["supplier"] ? Supplier.fromJS(_data["supplier"]) : <any>undefined;
            this.user1 = _data["user1"] ? User.fromJS(_data["user1"]) : <any>undefined;
            this.user2 = _data["user2"] ? User.fromJS(_data["user2"]) : <any>undefined;
            this.stockLocation = _data["stockLocation"] ? StockLocation.fromJS(_data["stockLocation"]) : <any>undefined;
            this.user3 = _data["user3"] ? User.fromJS(_data["user3"]) : <any>undefined;
            this.stockLocation1 = _data["stockLocation1"] ? StockLocation.fromJS(_data["stockLocation1"]) : <any>undefined;
            this.user4 = _data["user4"] ? User.fromJS(_data["user4"]) : <any>undefined;
            this.vehicle = _data["vehicle"] ? Vehicle.fromJS(_data["vehicle"]) : <any>undefined;
            this.vehicleType = _data["vehicleType"] ? VehicleType.fromJS(_data["vehicleType"]) : <any>undefined;
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.deliveryVehicleName = _data["deliveryVehicleName"];
            this.viaBranchVehicleTypeName = _data["viaBranchVehicleTypeName"];
            this.viaBranchVehicleName = _data["viaBranchVehicleName"];
            this.userName = _data["userName"];
            this.branchCode = _data["branchCode"];
            this.branchName = _data["branchName"];
            this.toBranchCode = _data["toBranchCode"];
            this.toBranchName = _data["toBranchName"];
            this.viaBranchCode = _data["viaBranchCode"];
            this.viaBranchName = _data["viaBranchName"];
            this.issuingBranchCode = _data["issuingBranchCode"];
            this.issuingBranchName = _data["issuingBranchName"];
            this.salesRepName = _data["salesRepName"];
            this.orderPlacementTypeName = _data["orderPlacementTypeName"];
            this.orderPlacementTypeSkipSignatureCapture = _data["orderPlacementTypeSkipSignatureCapture"];
            this.createdByName = _data["createdByName"];
            this.lastModifiedByName = _data["lastModifiedByName"];
            this.carrierName = _data["carrierName"];
            this.contractStatus = _data["contractStatus"];
            this.customerName = _data["customerName"];
            this.isValid = _data["isValid"];
            this.pickingCheckedByID = _data["pickingCheckedByID"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(OrderLine.fromJS(item));
            }
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(OrderPayment.fromJS(item));
            }
            this.totalTaxOnCost = _data["totalTaxOnCost"];
            this.totalTaxOnCostInCurrency = _data["totalTaxOnCostInCurrency"];
            this.customerOnHold = _data["customerOnHold"];
            this.customerCreditControlStatusID = _data["customerCreditControlStatusID"];
            this.customerAvailableCredit = _data["customerAvailableCredit"];
            this.customerIsCashAccount = _data["customerIsCashAccount"];
            this.transferStockShortage = _data["transferStockShortage"];
            (<any>this).journeyTransportCostsApplied = _data["journeyTransportCostsApplied"];
            (<any>this).isTransferReturn = _data["isTransferReturn"];
            this.issuingBranchIsSet = _data["issuingBranchIsSet"];
            (<any>this).jobDefaultAddressTaxAreaID = _data["jobDefaultAddressTaxAreaID"];
            (<any>this).customerTaxAreaID = _data["customerTaxAreaID"];
            (<any>this).taxAreaIDUsed = _data["taxAreaIDUsed"];
            this.printTheseFormats = _data["printTheseFormats"];
            this.includeTheseFormats = _data["includeTheseFormats"];
            this.excludeTheseFormats = _data["excludeTheseFormats"];
            this.printedPickingNotePriorToThisPrintingSession = _data["printedPickingNotePriorToThisPrintingSession"];
            this.printedDeliveryNotePriorToThisPrintingSession = _data["printedDeliveryNotePriorToThisPrintingSession"];
            (<any>this).selected = _data["selected"];
            (<any>this).checkedByID = _data["checkedByID"];
            (<any>this).errorList = _data["errorList"];
        }
    }

    static fromJS(data: any): OrderHeader {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderID"] = this.orderID;
        data["deleted"] = this.deleted;
        data["orderNumber"] = this.orderNumber;
        data["offlineOrderNumber"] = this.offlineOrderNumber;
        data["preallocatedInvoiceNumber"] = this.preallocatedInvoiceNumber;
        data["preallocatedDueDate"] = this.preallocatedDueDate ? this.preallocatedDueDate.toISOString() : <any>undefined;
        data["orderType"] = this.orderType;
        data["orderStatus"] = this.orderStatus;
        data["orderSubStatus"] = this.orderSubStatus;
        data["description"] = this.description;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["createdByID"] = this.createdByID;
        data["computerID"] = this.computerID;
        data["dateTimeLastModified"] = this.dateTimeLastModified ? this.dateTimeLastModified.toISOString() : <any>undefined;
        data["lastModifiedByID"] = this.lastModifiedByID;
        data["branchID"] = this.branchID;
        data["hasExternalAVOs"] = this.hasExternalAVOs;
        data["toBranchID"] = this.toBranchID;
        data["viaBranchID"] = this.viaBranchID;
        data["orderingBranchID"] = this.orderingBranchID;
        data["issuingBranchID"] = this.issuingBranchID;
        data["stockLocationID"] = this.stockLocationID;
        data["toStockLocationID"] = this.toStockLocationID;
        data["customerID"] = this.customerID;
        data["userID"] = this.userID;
        data["saleType"] = this.saleType;
        data["cashSale"] = this.cashSale;
        data["orderPlacementTypeID"] = this.orderPlacementTypeID;
        data["dateRequired"] = this.dateRequired ? this.dateRequired.toISOString() : <any>undefined;
        data["dateRequiredOption"] = this.dateRequiredOption;
        data["daysToReserve"] = this.daysToReserve;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["quoteRank"] = this.quoteRank;
        data["followUpDateTime"] = this.followUpDateTime ? this.followUpDateTime.toISOString() : <any>undefined;
        data["customerRef"] = this.customerRef;
        data["contactName"] = this.contactName;
        data["contactNumber"] = this.contactNumber;
        data["contactIdentified"] = this.contactIdentified;
        data["salesRepID"] = this.salesRepID;
        data["salesAreaID"] = this.salesAreaID;
        data["yardBookRef"] = this.yardBookRef;
        data["orderConfirmed"] = this.orderConfirmed;
        data["confirmationNotes"] = this.confirmationNotes;
        data["testCertOption"] = this.testCertOption;
        data["qaContact"] = this.qaContact;
        data["chargeRollingMargin"] = this.chargeRollingMargin;
        data["deliveryAddressID"] = this.deliveryAddressID;
        data["deliveryAddress"] = this.deliveryAddress;
        data["deliveryAddressLine1"] = this.deliveryAddressLine1;
        data["deliveryAddressLine2"] = this.deliveryAddressLine2;
        data["deliveryAddressLine3"] = this.deliveryAddressLine3;
        data["deliveryCity"] = this.deliveryCity;
        data["deliveryCounty"] = this.deliveryCounty;
        data["deliveryPostCode"] = this.deliveryPostCode;
        data["deliveryCountry"] = this.deliveryCountry;
        data["deliveryAreaID"] = this.deliveryAreaID;
        data["deliveryTime"] = this.deliveryTime;
        data["deliveryOption"] = this.deliveryOption;
        data["invoiceAddressID"] = this.invoiceAddressID;
        data["invoiceAddress"] = this.invoiceAddress;
        data["paymentTermsID"] = this.paymentTermsID;
        data["vatNumber"] = this.vatNumber;
        data["nonDiscountAmountInCurrency"] = this.nonDiscountAmountInCurrency;
        data["showEurosOnInvoice"] = this.showEurosOnInvoice;
        data["taxAreaID"] = this.taxAreaID;
        data["useTaxExemptCertificate"] = this.useTaxExemptCertificate;
        data["vehicleTypeID"] = this.vehicleTypeID;
        data["vehicleID"] = this.vehicleID;
        data["specialInstructions"] = this.specialInstructions;
        data["headerNotes"] = this.headerNotes;
        data["notes"] = this.notes;
        data["onlyShowLumpSumPrice"] = this.onlyShowLumpSumPrice;
        data["useSimpleOrderProcessing"] = this.useSimpleOrderProcessing;
        data["totalCostPrice"] = this.totalCostPrice;
        data["commissionTotalCostPrice"] = this.commissionTotalCostPrice;
        data["totalInternalCostPrice"] = this.totalInternalCostPrice;
        data["totalSellPrice"] = this.totalSellPrice;
        data["totalVAT"] = this.totalVAT;
        data["totalTax"] = this.totalTax;
        data["totalMargin"] = this.totalMargin;
        data["commissionTotalMargin"] = this.commissionTotalMargin;
        data["totalWeight"] = this.totalWeight;
        data["totalVolume"] = this.totalVolume;
        data["noOfPacks"] = this.noOfPacks;
        data["deliveryCharge"] = this.deliveryCharge;
        data["deliveryCost"] = this.deliveryCost;
        data["deliverySalesAnalysisCodeID"] = this.deliverySalesAnalysisCodeID;
        data["currencyID"] = this.currencyID;
        data["exchangeRate"] = this.exchangeRate;
        data["totalSellPriceInCurrency"] = this.totalSellPriceInCurrency;
        data["totalVatInCurrency"] = this.totalVatInCurrency;
        data["totalTaxInCurrency"] = this.totalTaxInCurrency;
        data["deliveryChargeInCurrency"] = this.deliveryChargeInCurrency;
        data["backOrderedFromID"] = this.backOrderedFromID;
        data["backOrderCount"] = this.backOrderCount;
        data["calledOffFromID"] = this.calledOffFromID;
        data["callOffEnforceSchedule"] = this.callOffEnforceSchedule;
        data["createdFromOrderID"] = this.createdFromOrderID;
        data["createdFromWorksOrderID"] = this.createdFromWorksOrderID;
        data["picked"] = this.picked;
        data["delivered"] = this.delivered;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["deliveryReference"] = this.deliveryReference;
        data["proofOfDeliveryReturned"] = this.proofOfDeliveryReturned;
        data["stockIssued"] = this.stockIssued;
        data["dateTimeIssued"] = this.dateTimeIssued ? this.dateTimeIssued.toISOString() : <any>undefined;
        data["approval"] = this.approval;
        data["dateTimeApproved"] = this.dateTimeApproved ? this.dateTimeApproved.toISOString() : <any>undefined;
        data["approvedByID"] = this.approvedByID;
        data["cashOnDeliveryAmount"] = this.cashOnDeliveryAmount;
        data["cashOnDeliveryRequested"] = this.cashOnDeliveryRequested;
        data["cashOnDeliveryReceived"] = this.cashOnDeliveryReceived;
        data["cashAccountBalanceAmount"] = this.cashAccountBalanceAmount;
        data["paymentOutstanding"] = this.paymentOutstanding;
        data["releaseTotalSellPrice"] = this.releaseTotalSellPrice;
        data["invoiceID"] = this.invoiceID;
        data["invoiced"] = this.invoiced;
        data["dateTimeTransferred"] = this.dateTimeTransferred ? this.dateTimeTransferred.toISOString() : <any>undefined;
        data["noOfLines"] = this.noOfLines;
        data["maximumWidth"] = this.maximumWidth;
        data["maximumLength"] = this.maximumLength;
        data["hasAVOs"] = this.hasAVOs;
        data["hasCuts"] = this.hasCuts;
        data["hasProfiles"] = this.hasProfiles;
        data["outstandingAVOs"] = this.outstandingAVOs;
        data["outstandingCuts"] = this.outstandingCuts;
        data["worksOrderCount"] = this.worksOrderCount;
        data["worksOrderCountCompleted"] = this.worksOrderCountCompleted;
        data["rejectionReasonID"] = this.rejectionReasonID;
        data["dateTimeQuoteRejected"] = this.dateTimeQuoteRejected ? this.dateTimeQuoteRejected.toISOString() : <any>undefined;
        data["dateTimeQuoteAccepted"] = this.dateTimeQuoteAccepted ? this.dateTimeQuoteAccepted.toISOString() : <any>undefined;
        data["rejectedOrAcceptedByID"] = this.rejectedOrAcceptedByID;
        data["questionsAsked"] = this.questionsAsked;
        data["otherFlags"] = this.otherFlags;
        data["printed"] = this.printed;
        data["printedPickingNote"] = this.printedPickingNote;
        data["printedDeliveryNote"] = this.printedDeliveryNote;
        data["journeyID"] = this.journeyID;
        data["readyForBooking"] = this.readyForBooking;
        data["readyByID"] = this.readyByID;
        data["readyDate"] = this.readyDate ? this.readyDate.toISOString() : <any>undefined;
        data["dateTimeMarkedReady"] = this.dateTimeMarkedReady ? this.dateTimeMarkedReady.toISOString() : <any>undefined;
        data["transportInstructionID"] = this.transportInstructionID;
        data["distance"] = this.distance;
        data["transportBooked"] = this.transportBooked;
        data["pickupDate"] = this.pickupDate ? this.pickupDate.toISOString() : <any>undefined;
        data["bookedByID"] = this.bookedByID;
        data["dateTimeMarkedBooked"] = this.dateTimeMarkedBooked ? this.dateTimeMarkedBooked.toISOString() : <any>undefined;
        data["bookingNumber"] = this.bookingNumber;
        data["carrierID"] = this.carrierID;
        data["vehicleName"] = this.vehicleName;
        data["sellPriceProfileID"] = this.sellPriceProfileID;
        data["contractID"] = this.contractID;
        data["contractInvoicing"] = this.contractInvoicing;
        data["contactEmailAddress"] = this.contactEmailAddress;
        data["settlementDiscount"] = this.settlementDiscount;
        data["settlementAmount"] = this.settlementAmount;
        data["settlementAmountInCurrency"] = this.settlementAmountInCurrency;
        data["generatedOrder"] = this.generatedOrder;
        data["supplierSettlementAmount"] = this.supplierSettlementAmount;
        data["supplierSettlementAmountInCurrency"] = this.supplierSettlementAmountInCurrency;
        data["cashOnDeliveryAmountInCurrency"] = this.cashOnDeliveryAmountInCurrency;
        data["cashOnDeliveryRequestedInCurrency"] = this.cashOnDeliveryRequestedInCurrency;
        data["cashOnDeliveryReceivedInCurrency"] = this.cashOnDeliveryReceivedInCurrency;
        data["paymentOutstandingInCurrency"] = this.paymentOutstandingInCurrency;
        data["rebateSaleType"] = this.rebateSaleType;
        data["arCustomerID"] = this.arCustomerID;
        data["approvalNumber"] = this.approvalNumber;
        data["ladingQuantity"] = this.ladingQuantity;
        data["createdFromCreditNoteID"] = this.createdFromCreditNoteID;
        data["contractInvoicingLineID"] = this.contractInvoicingLineID;
        data["taxVerifiedByID"] = this.taxVerifiedByID;
        data["campaignMemberID"] = this.campaignMemberID;
        data["opportunityID"] = this.opportunityID;
        data["dateRequested"] = this.dateRequested ? this.dateRequested.toISOString() : <any>undefined;
        data["quoteRankID"] = this.quoteRankID;
        data["imaged"] = this.imaged;
        data["directCallOffPONumber"] = this.directCallOffPONumber;
        data["computerDefaultPrinter"] = this.computerDefaultPrinter;
        data["allowCallingOffSectionsInWebTrack"] = this.allowCallingOffSectionsInWebTrack;
        data["needsJourneyFromViaBranch"] = this.needsJourneyFromViaBranch;
        data["viaBranchJourneyID"] = this.viaBranchJourneyID;
        data["nonSalesAmount"] = this.nonSalesAmount;
        data["wmsPickingStatus"] = this.wmsPickingStatus;
        data["nonSalesAmountInCurrency"] = this.nonSalesAmountInCurrency;
        data["internalCostTotalMargin"] = this.internalCostTotalMargin;
        data["wmsProcessed"] = this.wmsProcessed;
        data["viaBranchVehicleTypeID"] = this.viaBranchVehicleTypeID;
        data["viaBranchVehicleID"] = this.viaBranchVehicleID;
        data["splitFromOrderID"] = this.splitFromOrderID;
        data["splitJourneyToSchedule"] = this.splitJourneyToSchedule;
        data["wmsJourneyID"] = this.wmsJourneyID;
        data["convertedFromOrderType"] = this.convertedFromOrderType;
        data["convertedFromOrderNumber"] = this.convertedFromOrderNumber;
        data["releasedFromMarginHold"] = this.releasedFromMarginHold;
        data["netPriced"] = this.netPriced;
        data["excludeFromWMS"] = this.excludeFromWMS;
        data["sellPriceMultiplier"] = this.sellPriceMultiplier;
        data["buyPriceMultiplier"] = this.buyPriceMultiplier;
        data["rebill"] = this.rebill;
        data["taxUsageTypeID"] = this.taxUsageTypeID;
        data["calculatedDateRequired"] = this.calculatedDateRequired;
        data["rewardsCardNumber"] = this.rewardsCardNumber;
        data["source"] = this.source;
        data["scaleGrossWeight"] = this.scaleGrossWeight;
        data["preallocatedPurchaseOrderNumber"] = this.preallocatedPurchaseOrderNumber;
        data["issueStockPending"] = this.issueStockPending;
        data["printTestCertificates"] = this.printTestCertificates;
        data["contactID"] = this.contactID;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["branch1"] = this.branch1 ? this.branch1.toJSON() : <any>undefined;
        data["branch2"] = this.branch2 ? this.branch2.toJSON() : <any>undefined;
        data["branch3"] = this.branch3 ? this.branch3.toJSON() : <any>undefined;
        data["branch4"] = this.branch4 ? this.branch4.toJSON() : <any>undefined;
        data["branch5"] = this.branch5 ? this.branch5.toJSON() : <any>undefined;
        data["customerAddress"] = this.customerAddress ? this.customerAddress.toJSON() : <any>undefined;
        data["customerAddress1"] = this.customerAddress1 ? this.customerAddress1.toJSON() : <any>undefined;
        data["deliveryArea"] = this.deliveryArea ? this.deliveryArea.toJSON() : <any>undefined;
        data["journeyHeader"] = this.journeyHeader ? this.journeyHeader.toJSON() : <any>undefined;
        data["journeyHeader1"] = this.journeyHeader1 ? this.journeyHeader1.toJSON() : <any>undefined;
        data["journeyHeader2"] = this.journeyHeader2 ? this.journeyHeader2.toJSON() : <any>undefined;
        if (Array.isArray(this.journeyLines)) {
            data["journeyLines"] = [];
            for (let item of this.journeyLines)
                data["journeyLines"].push(item.toJSON());
        }
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : <any>undefined;
        data["user1"] = this.user1 ? this.user1.toJSON() : <any>undefined;
        data["user2"] = this.user2 ? this.user2.toJSON() : <any>undefined;
        data["stockLocation"] = this.stockLocation ? this.stockLocation.toJSON() : <any>undefined;
        data["user3"] = this.user3 ? this.user3.toJSON() : <any>undefined;
        data["stockLocation1"] = this.stockLocation1 ? this.stockLocation1.toJSON() : <any>undefined;
        data["user4"] = this.user4 ? this.user4.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["vehicleType"] = this.vehicleType ? this.vehicleType.toJSON() : <any>undefined;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["deliveryVehicleName"] = this.deliveryVehicleName;
        data["viaBranchVehicleTypeName"] = this.viaBranchVehicleTypeName;
        data["viaBranchVehicleName"] = this.viaBranchVehicleName;
        data["userName"] = this.userName;
        data["branchCode"] = this.branchCode;
        data["branchName"] = this.branchName;
        data["toBranchCode"] = this.toBranchCode;
        data["toBranchName"] = this.toBranchName;
        data["viaBranchCode"] = this.viaBranchCode;
        data["viaBranchName"] = this.viaBranchName;
        data["issuingBranchCode"] = this.issuingBranchCode;
        data["issuingBranchName"] = this.issuingBranchName;
        data["salesRepName"] = this.salesRepName;
        data["orderPlacementTypeName"] = this.orderPlacementTypeName;
        data["orderPlacementTypeSkipSignatureCapture"] = this.orderPlacementTypeSkipSignatureCapture;
        data["createdByName"] = this.createdByName;
        data["lastModifiedByName"] = this.lastModifiedByName;
        data["carrierName"] = this.carrierName;
        data["contractStatus"] = this.contractStatus;
        data["customerName"] = this.customerName;
        data["isValid"] = this.isValid;
        data["pickingCheckedByID"] = this.pickingCheckedByID;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["totalTaxOnCost"] = this.totalTaxOnCost;
        data["totalTaxOnCostInCurrency"] = this.totalTaxOnCostInCurrency;
        data["customerOnHold"] = this.customerOnHold;
        data["customerCreditControlStatusID"] = this.customerCreditControlStatusID;
        data["customerAvailableCredit"] = this.customerAvailableCredit;
        data["customerIsCashAccount"] = this.customerIsCashAccount;
        data["transferStockShortage"] = this.transferStockShortage;
        data["journeyTransportCostsApplied"] = this.journeyTransportCostsApplied;
        data["isTransferReturn"] = this.isTransferReturn;
        data["issuingBranchIsSet"] = this.issuingBranchIsSet;
        data["jobDefaultAddressTaxAreaID"] = this.jobDefaultAddressTaxAreaID;
        data["customerTaxAreaID"] = this.customerTaxAreaID;
        data["taxAreaIDUsed"] = this.taxAreaIDUsed;
        data["printTheseFormats"] = this.printTheseFormats;
        data["includeTheseFormats"] = this.includeTheseFormats;
        data["excludeTheseFormats"] = this.excludeTheseFormats;
        data["printedPickingNotePriorToThisPrintingSession"] = this.printedPickingNotePriorToThisPrintingSession;
        data["printedDeliveryNotePriorToThisPrintingSession"] = this.printedDeliveryNotePriorToThisPrintingSession;
        data["selected"] = this.selected;
        data["checkedByID"] = this.checkedByID;
        data["errorList"] = this.errorList;
        return data; 
    }
}

export interface IOrderHeader {
    orderID?: number | undefined;
    deleted?: number | undefined;
    orderNumber?: number | undefined;
    offlineOrderNumber?: number | undefined;
    preallocatedInvoiceNumber?: number | undefined;
    preallocatedDueDate?: Date | undefined;
    orderType?: OrderHeaderOrderType | undefined;
    orderStatus?: OrderHeaderOrderStatus | undefined;
    orderSubStatus?: OrderHeaderOrderSubStatus | undefined;
    description?: string | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    computerID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    lastModifiedByID?: number | undefined;
    branchID?: number | undefined;
    hasExternalAVOs?: boolean | undefined;
    toBranchID?: number | undefined;
    viaBranchID?: number | undefined;
    orderingBranchID?: number | undefined;
    issuingBranchID?: number | undefined;
    stockLocationID?: number | undefined;
    toStockLocationID?: number | undefined;
    customerID?: number | undefined;
    userID?: number | undefined;
    saleType?: number | undefined;
    cashSale?: boolean | undefined;
    orderPlacementTypeID?: number | undefined;
    dateRequired?: Date | undefined;
    dateRequiredOption?: number | undefined;
    daysToReserve?: number | undefined;
    expiryDate?: Date | undefined;
    quoteRank?: string | undefined;
    followUpDateTime?: Date | undefined;
    customerRef?: string | undefined;
    contactName?: string | undefined;
    contactNumber?: string | undefined;
    contactIdentified?: boolean | undefined;
    salesRepID?: number | undefined;
    salesAreaID?: number | undefined;
    yardBookRef?: string | undefined;
    orderConfirmed?: boolean | undefined;
    confirmationNotes?: string | undefined;
    testCertOption?: number | undefined;
    qaContact?: string | undefined;
    chargeRollingMargin?: boolean | undefined;
    deliveryAddressID?: number | undefined;
    deliveryAddress?: string | undefined;
    deliveryAddressLine1?: string | undefined;
    deliveryAddressLine2?: string | undefined;
    deliveryAddressLine3?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryCounty?: string | undefined;
    deliveryPostCode?: string | undefined;
    deliveryCountry?: string | undefined;
    deliveryAreaID?: number | undefined;
    deliveryTime?: number | undefined;
    deliveryOption?: number | undefined;
    invoiceAddressID?: number | undefined;
    invoiceAddress?: string | undefined;
    paymentTermsID?: number | undefined;
    vatNumber?: string | undefined;
    nonDiscountAmountInCurrency?: number | undefined;
    showEurosOnInvoice?: boolean | undefined;
    taxAreaID?: number | undefined;
    useTaxExemptCertificate?: boolean | undefined;
    vehicleTypeID?: number | undefined;
    vehicleID?: number | undefined;
    specialInstructions?: string | undefined;
    headerNotes?: string | undefined;
    notes?: string | undefined;
    onlyShowLumpSumPrice?: boolean | undefined;
    useSimpleOrderProcessing?: boolean | undefined;
    totalCostPrice?: number | undefined;
    commissionTotalCostPrice?: number | undefined;
    totalInternalCostPrice?: number | undefined;
    totalSellPrice?: number | undefined;
    totalVAT?: number | undefined;
    totalTax?: number | undefined;
    totalMargin?: number | undefined;
    commissionTotalMargin?: number | undefined;
    totalWeight?: number | undefined;
    totalVolume?: number | undefined;
    noOfPacks?: number | undefined;
    deliveryCharge?: number | undefined;
    deliveryCost?: number | undefined;
    deliverySalesAnalysisCodeID?: number | undefined;
    currencyID?: number | undefined;
    exchangeRate?: number | undefined;
    totalSellPriceInCurrency?: number | undefined;
    totalVatInCurrency?: number | undefined;
    totalTaxInCurrency?: number | undefined;
    deliveryChargeInCurrency?: number | undefined;
    backOrderedFromID?: number | undefined;
    backOrderCount?: number | undefined;
    calledOffFromID?: number | undefined;
    callOffEnforceSchedule?: boolean | undefined;
    createdFromOrderID?: number | undefined;
    createdFromWorksOrderID?: number | undefined;
    picked?: boolean | undefined;
    delivered?: boolean | undefined;
    deliveryDate?: Date | undefined;
    deliveryReference?: string | undefined;
    proofOfDeliveryReturned?: boolean | undefined;
    stockIssued?: boolean | undefined;
    dateTimeIssued?: Date | undefined;
    approval?: number | undefined;
    dateTimeApproved?: Date | undefined;
    approvedByID?: number | undefined;
    cashOnDeliveryAmount?: number | undefined;
    cashOnDeliveryRequested?: number | undefined;
    cashOnDeliveryReceived?: number | undefined;
    cashAccountBalanceAmount?: number | undefined;
    paymentOutstanding?: number | undefined;
    releaseTotalSellPrice?: number | undefined;
    invoiceID?: number | undefined;
    invoiced?: boolean | undefined;
    dateTimeTransferred?: Date | undefined;
    noOfLines?: number | undefined;
    maximumWidth?: number | undefined;
    maximumLength?: number | undefined;
    hasAVOs?: boolean | undefined;
    hasCuts?: boolean | undefined;
    hasProfiles?: boolean | undefined;
    outstandingAVOs?: number | undefined;
    outstandingCuts?: number | undefined;
    worksOrderCount?: number | undefined;
    worksOrderCountCompleted?: number | undefined;
    rejectionReasonID?: number | undefined;
    dateTimeQuoteRejected?: Date | undefined;
    dateTimeQuoteAccepted?: Date | undefined;
    rejectedOrAcceptedByID?: number | undefined;
    questionsAsked?: number | undefined;
    otherFlags?: number | undefined;
    printed?: boolean | undefined;
    printedPickingNote?: boolean | undefined;
    printedDeliveryNote?: boolean | undefined;
    journeyID?: number | undefined;
    readyForBooking?: boolean | undefined;
    readyByID?: number | undefined;
    readyDate?: Date | undefined;
    dateTimeMarkedReady?: Date | undefined;
    transportInstructionID?: number | undefined;
    distance?: number | undefined;
    transportBooked?: number | undefined;
    pickupDate?: Date | undefined;
    bookedByID?: number | undefined;
    dateTimeMarkedBooked?: Date | undefined;
    bookingNumber?: number | undefined;
    carrierID?: number | undefined;
    vehicleName?: string | undefined;
    sellPriceProfileID?: number | undefined;
    contractID?: number | undefined;
    contractInvoicing?: boolean | undefined;
    contactEmailAddress?: string | undefined;
    settlementDiscount?: number | undefined;
    settlementAmount?: number | undefined;
    settlementAmountInCurrency?: number | undefined;
    generatedOrder?: boolean | undefined;
    supplierSettlementAmount?: number | undefined;
    supplierSettlementAmountInCurrency?: number | undefined;
    cashOnDeliveryAmountInCurrency?: number | undefined;
    cashOnDeliveryRequestedInCurrency?: number | undefined;
    cashOnDeliveryReceivedInCurrency?: number | undefined;
    paymentOutstandingInCurrency?: number | undefined;
    rebateSaleType?: number | undefined;
    arCustomerID?: number | undefined;
    approvalNumber?: string | undefined;
    ladingQuantity?: number | undefined;
    createdFromCreditNoteID?: number | undefined;
    contractInvoicingLineID?: number | undefined;
    taxVerifiedByID?: number | undefined;
    campaignMemberID?: number | undefined;
    opportunityID?: number | undefined;
    dateRequested?: Date | undefined;
    quoteRankID?: number | undefined;
    imaged?: number | undefined;
    directCallOffPONumber?: number | undefined;
    computerDefaultPrinter?: string | undefined;
    allowCallingOffSectionsInWebTrack?: boolean | undefined;
    needsJourneyFromViaBranch?: boolean | undefined;
    viaBranchJourneyID?: number | undefined;
    nonSalesAmount?: number | undefined;
    wmsPickingStatus?: number | undefined;
    nonSalesAmountInCurrency?: number | undefined;
    internalCostTotalMargin?: number | undefined;
    wmsProcessed?: boolean | undefined;
    viaBranchVehicleTypeID?: number | undefined;
    viaBranchVehicleID?: number | undefined;
    splitFromOrderID?: number | undefined;
    splitJourneyToSchedule?: boolean | undefined;
    wmsJourneyID?: number | undefined;
    convertedFromOrderType?: number | undefined;
    convertedFromOrderNumber?: number | undefined;
    releasedFromMarginHold?: boolean | undefined;
    netPriced?: boolean | undefined;
    excludeFromWMS?: boolean | undefined;
    sellPriceMultiplier?: number | undefined;
    buyPriceMultiplier?: number | undefined;
    rebill?: boolean | undefined;
    taxUsageTypeID?: number | undefined;
    calculatedDateRequired?: boolean | undefined;
    rewardsCardNumber?: string | undefined;
    source?: number | undefined;
    scaleGrossWeight?: number | undefined;
    preallocatedPurchaseOrderNumber?: number | undefined;
    issueStockPending?: boolean | undefined;
    printTestCertificates?: number | undefined;
    contactID?: number | undefined;
    branch?: Branch | undefined;
    branch1?: Branch | undefined;
    branch2?: Branch | undefined;
    branch3?: Branch | undefined;
    branch4?: Branch | undefined;
    branch5?: Branch | undefined;
    customerAddress?: CustomerAddress | undefined;
    customerAddress1?: CustomerAddress | undefined;
    deliveryArea?: DeliveryArea | undefined;
    journeyHeader?: JourneyHeader | undefined;
    journeyHeader1?: JourneyHeader | undefined;
    journeyHeader2?: JourneyHeader | undefined;
    journeyLines?: JourneyLine[] | undefined;
    user?: User | undefined;
    supplier?: Supplier | undefined;
    user1?: User | undefined;
    user2?: User | undefined;
    stockLocation?: StockLocation | undefined;
    user3?: User | undefined;
    stockLocation1?: StockLocation | undefined;
    user4?: User | undefined;
    vehicle?: Vehicle | undefined;
    vehicleType?: VehicleType | undefined;
    vehicleTypeName?: string | undefined;
    deliveryVehicleName?: string | undefined;
    viaBranchVehicleTypeName?: string | undefined;
    viaBranchVehicleName?: string | undefined;
    userName?: string | undefined;
    branchCode?: string | undefined;
    branchName?: string | undefined;
    toBranchCode?: string | undefined;
    toBranchName?: string | undefined;
    viaBranchCode?: string | undefined;
    viaBranchName?: string | undefined;
    issuingBranchCode?: string | undefined;
    issuingBranchName?: string | undefined;
    salesRepName?: string | undefined;
    orderPlacementTypeName?: string | undefined;
    orderPlacementTypeSkipSignatureCapture?: boolean | undefined;
    createdByName?: string | undefined;
    lastModifiedByName?: string | undefined;
    carrierName?: string | undefined;
    contractStatus?: number | undefined;
    customerName?: string | undefined;
    isValid?: boolean | undefined;
    pickingCheckedByID?: number | undefined;
    lines?: OrderLine[] | undefined;
    payments?: OrderPayment[] | undefined;
    totalTaxOnCost?: number | undefined;
    totalTaxOnCostInCurrency?: number | undefined;
    customerOnHold?: boolean | undefined;
    customerCreditControlStatusID?: number | undefined;
    customerAvailableCredit?: number | undefined;
    customerIsCashAccount?: boolean | undefined;
    transferStockShortage?: boolean | undefined;
    journeyTransportCostsApplied?: boolean | undefined;
    isTransferReturn?: boolean | undefined;
    issuingBranchIsSet?: boolean | undefined;
    jobDefaultAddressTaxAreaID?: number | undefined;
    customerTaxAreaID?: number | undefined;
    taxAreaIDUsed?: number | undefined;
    printTheseFormats?: string | undefined;
    includeTheseFormats?: string | undefined;
    excludeTheseFormats?: string | undefined;
    printedPickingNotePriorToThisPrintingSession?: boolean | undefined;
    printedDeliveryNotePriorToThisPrintingSession?: boolean | undefined;
    selected?: boolean | undefined;
    checkedByID?: number | undefined;
    errorList?: string | undefined;
}

export class OrderLine implements IOrderLine {
    orderLineID?: number | undefined;
    orderID?: number | undefined;
    branchID?: number | undefined;
    lineNumber?: number | undefined;
    linkedToLineID?: number | undefined;
    lineType?: number | undefined;
    lineStatus?: number | undefined;
    suggestedOrderBatchLineID?: number | undefined;
    saleType?: number | undefined;
    stockBatchID?: number | undefined;
    stockAllocationID?: number | undefined;
    stockReservationID?: number | undefined;
    productID?: number | undefined;
    productKitID?: number | undefined;
    cuttingOperationID?: number | undefined;
    profileOperationID?: number | undefined;
    worksOrderID?: number | undefined;
    worksOrderLineID?: number | undefined;
    calledOffFromLineID?: number | undefined;
    calledOffFromScheduleID?: number | undefined;
    createdFromOrderLineID?: number | undefined;
    createdFromWorksOrderLineID?: number | undefined;
    createdFromContractInvoicingLineID?: number | undefined;
    manualCode?: string | undefined;
    manualDescription?: string | undefined;
    manualOrderLineTypeID?: number | undefined;
    manualSupplierID?: number | undefined;
    manualSteelGradeID?: number | undefined;
    manualThickness?: number | undefined;
    manualWidth?: number | undefined;
    manualLength?: number | undefined;
    quantity?: number | undefined;
    quantityDisplay?: number | undefined;
    quantityPicked?: number | undefined;
    fullyPicked?: boolean | undefined;
    quantityConfirmed?: number | undefined;
    quantityDelivered?: number | undefined;
    quantityInvoiced?: number | undefined;
    quantityReturned?: number | undefined;
    quantityCredited?: number | undefined;
    quantityBackOrdered?: number | undefined;
    quantityCalledOff?: number | undefined;
    quantityTally?: string | undefined;
    quantityTallyPicked?: string | undefined;
    noOfPieces?: number | undefined;
    inputPerID?: number | undefined;
    displayInputPerID?: number | undefined;
    perID?: number | undefined;
    costPerID?: number | undefined;
    stockPerConversion?: number | undefined;
    statsPerConversion?: number | undefined;
    freeOfCharge?: boolean | undefined;
    unitCostPrice?: number | undefined;
    unitSellPrice?: number | undefined;
    unitSellPriceDisplay?: number | undefined;
    unitWeight?: number | undefined;
    totalCostPrice?: number | undefined;
    transferCostPrice?: number | undefined;
    totalSellPrice?: number | undefined;
    totalVAT?: number | undefined;
    totalTax?: number | undefined;
    retentionAmount?: number | undefined;
    totalMargin?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    pricingType?: number | undefined;
    buyingPrice?: number | undefined;
    sellingPriceRuleID?: number | undefined;
    sellingRulePriority?: number | undefined;
    sellingCalcType?: number | undefined;
    sellingCalcValue?: number | undefined;
    sellingCalcValue2?: number | undefined;
    sellingCalcValue3?: number | undefined;
    sellingPriceBand?: number | undefined;
    sellingPrice?: number | undefined;
    sellingAdjustment?: number | undefined;
    sellingAdjustments?: string | undefined;
    discount1?: number | undefined;
    discountAmount1?: number | undefined;
    discount2?: number | undefined;
    discountAmount2?: number | undefined;
    avoUnitSellPrice?: number | undefined;
    avoCostPrice?: number | undefined;
    avoSellPrice?: number | undefined;
    avoCount?: number | undefined;
    avoQuantity?: number | undefined;
    avoQuantityCompleted?: number | undefined;
    showAVOsInUnitPrice?: boolean | undefined;
    deliveryCostRecovery?: number | undefined;
    deliveryChargeRate?: number | undefined;
    deliveryCharge?: number | undefined;
    deliveryCost?: number | undefined;
    additionalCharge?: number | undefined;
    additionalCost?: number | undefined;
    unitSellPriceInCurrency?: number | undefined;
    totalSellPriceInCurrency?: number | undefined;
    totalVatInCurrency?: number | undefined;
    totalTaxInCurrency?: number | undefined;
    retentionAmountInCurrency?: number | undefined;
    discountAmount1InCurrency?: number | undefined;
    discountAmount2InCurrency?: number | undefined;
    avoUnitSellPriceInCurrency?: number | undefined;
    avoSellPriceInCurrency?: number | undefined;
    vatID?: number | undefined;
    vatRateID?: number | undefined;
    taxGroupID?: number | undefined;
    taxCodes?: string | undefined;
    purchaseAnalysisCodeID?: number | undefined;
    salesAnalysisCodeID?: number | undefined;
    customerRef?: string | undefined;
    notes?: string | undefined;
    specialInstructions?: string | undefined;
    internalNotes?: string | undefined;
    backOrder?: boolean | undefined;
    stockTransferred?: boolean | undefined;
    manufactured?: boolean | undefined;
    specialOrder?: boolean | undefined;
    purchaseOrderID?: number | undefined;
    purchaseOrderQuantity?: number | undefined;
    purchaseOrderQuantityReceived?: number | undefined;
    purchaseOrderInvoiced?: boolean | undefined;
    releaseForProcessing?: boolean | undefined;
    pickingRequired?: boolean | undefined;
    deliveryRequired?: boolean | undefined;
    invoiceID?: number | undefined;
    invoiced?: boolean | undefined;
    pendingActions?: number | undefined;
    manuallyOverriddenTransferCostPrice?: boolean | undefined;
    poLineOverrideThickness?: number | undefined;
    poLineOverrideWidth?: number | undefined;
    poLineOverrideVolume?: number | undefined;
    unitVMICostPrice?: number | undefined;
    totalVMICostPrice?: number | undefined;
    vmiRuleID?: number | undefined;
    lastModifiedReasonID?: number | undefined;
    vmiSupplierInvoiceDocumentID?: number | undefined;
    vmiReconciled?: boolean | undefined;
    transferToProductBatchID?: number | undefined;
    costDiscount1?: number | undefined;
    costDiscountAmount1?: number | undefined;
    costDiscount2?: number | undefined;
    costDiscountAmount2?: number | undefined;
    costDiscount3?: number | undefined;
    costDiscountAmount3?: number | undefined;
    costDiscount4?: number | undefined;
    costDiscountAmount4?: number | undefined;
    unitVMICostInCurrency?: number | undefined;
    totalVMICostInCurrency?: number | undefined;
    vmiExchangeRate?: number | undefined;
    sourceOrderLineID?: number | undefined;
    wmsCartNumber?: string | undefined;
    nonSalesAmount?: number | undefined;
    nonSalesAmountInCurrency?: number | undefined;
    internalCostTotalMargin?: number | undefined;
    wmsParentLineID?: number | undefined;
    cutToLength?: boolean | undefined;
    sellingCalcValue2Type?: number | undefined;
    sellingCalcValue3Type?: number | undefined;
    netPriced?: boolean | undefined;
    wmsUnitNumber?: string | undefined;
    overrideUserID?: number | undefined;
    transferQuantityAllocated?: number | undefined;
    dateExpected?: Date | undefined;
    sellingCalcValue2Method?: number | undefined;
    couponID?: number | undefined;
    usePackPriceSurcharge?: boolean | undefined;
    pointsRedeemed?: number | undefined;
    requiresKitConfiguration?: boolean | undefined;
    manufacturingOptionsXML?: string | undefined;
    isWMSAdditionalCharge?: boolean | undefined;
    quantityTallyCalledOff?: string | undefined;
    quantityFromScale?: number | undefined;
    scaleGrossWeight?: number | undefined;
    grossingRuleQuantity?: number | undefined;
    grossingRuleQuantityTally?: string | undefined;
    branch?: Branch | undefined;
    per?: Per | undefined;
    orderLine1?: OrderLine[] | undefined;
    orderLine2?: OrderLine | undefined;
    per1?: Per | undefined;
    orderLine11?: OrderLine[] | undefined;
    orderLine3?: OrderLine | undefined;
    per2?: Per | undefined;
    product?: Product | undefined;
    supplier?: Supplier | undefined;
    orderLineItems?: OrderLineItem[] | undefined;
    additionalCostCharges?: OrderLineAdditionalCostCharge[] | undefined;
    colAvos?: OrderLineAVO[] | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    perRuleID?: number | undefined;
    productCode?: string | undefined;
    productBarCode?: string | undefined;
    productDescription?: string | undefined;
    thickness?: number | undefined;
    width?: number | undefined;
    length?: number | undefined;
    dimension4?: number | undefined;
    dimension5?: number | undefined;
    imperial?: boolean | undefined;
    tallyLengths?: string | undefined;
    tallyLengthsPerID?: number | undefined;
    availableWidths?: string | undefined;
    lowMarginCollected?: number | undefined;
    lowMarginDelivered?: number | undefined;
    lowMarginDirect?: number | undefined;
    highMargin?: number | undefined;
    allowMultiplePersOnUnitSizes?: boolean | undefined;
    defaultUnitSizePerID?: number | undefined;
    perCode?: string | undefined;
    perName?: string | undefined;
    productKeepStockFigures?: boolean | undefined;
    productStockControlByLength?: boolean | undefined;
    productPickingRequired?: boolean | undefined;
    productAllowDirectSales?: boolean | undefined;
    productAllowCashSales?: boolean | undefined;
    productApplyDeliveryCharges?: boolean | undefined;
    productPromptForQuantity?: boolean | undefined;
    productAllowDescriptionOverride?: number | undefined;
    productAllowPriceNegotiation?: boolean | undefined;
    productAllowCostOverride?: number | undefined;
    productAutoCreateSpecialFromThis?: number | undefined;
    productPriceBookSection?: string | undefined;
    productPriceBookSequence?: number | undefined;
    specialSourceAutoCreateSpecialFromThis?: number | undefined;
    productSpecialSourceID?: number | undefined;
    productSpecial?: boolean | undefined;
    deliveryProductTypeID?: number | undefined;
    productExternalLinkType?: number | undefined;
    productStandardStock?: boolean | undefined;
    productGroupID?: number | undefined;
    materialGradeID?: number | undefined;
    sellTaxGroupID?: number | undefined;
    productVatRuleID?: number | undefined;
    productDefaultPiecesPerPack?: number | undefined;
    productEnvironmentalStatusID?: number | undefined;
    productTimberSurchargeID?: number | undefined;
    sellPriceGroupID?: number | undefined;
    pointsPerAmountSpentCollected?: number | undefined;
    pointsPerAmountSpentDelivered?: number | undefined;
    pointsPerAmountSpentDirect?: number | undefined;
    automaticLineChargeID?: number | undefined;
    automaticLineChargeMultiplier?: number | undefined;
    alwaysOrderStockBackToBack?: boolean | undefined;
    quantityPerInner?: number | undefined;
    quantityPerOuter?: number | undefined;
    quantityPerPallet?: number | undefined;
    quantityPerCube?: number | undefined;
    sellQuantityRoundingOption?: number | undefined;
    deleted?: number | undefined;
    productManufacturerCode?: string | undefined;
    productWidthGrossingRule?: number | undefined;
    productLengthGrossingRule?: number | undefined;
    productStockedByCost?: boolean | undefined;
    productSalesOrderTalliedInputScreen?: number | undefined;
    productPromptForTallyOnSalesOrder?: boolean | undefined;
    productWeight?: number | undefined;
    allowSettlementDiscount?: boolean | undefined;
    cutToLengthStyle?: number | undefined;
    productSellPriceRounding?: number | undefined;
    productSellPriceRoundingOption?: number | undefined;
    productSellPriceRoundingPerID?: number | undefined;
    productApplyRebateAccruals?: boolean | undefined;
    productHowSourced?: number | undefined;
    purchaseAndTransferBranchID?: number | undefined;
    branchAllowSettlementDiscount?: boolean | undefined;
    defaultAllowSettlementDiscount?: boolean | undefined;
    defaultProductHowSourced?: number | undefined;
    defaultPurchaseAndTransferBranchID?: number | undefined;
    productPickingZone?: string | undefined;
    productBinLocation?: string | undefined;
    productBatchTypeID?: number | undefined;
    stockPerCode?: string | undefined;
    productInputPerID?: number | undefined;
    weightPerID?: number | undefined;
    stockPerID?: number | undefined;
    manualSupplierName?: string | undefined;
    vatCode?: string | undefined;
    profileShapeType?: number | undefined;
    profileDimension1?: number | undefined;
    profileDimension2?: number | undefined;
    totalNettWeight?: number | undefined;
    profileWasteType?: number | undefined;
    profileWasteDimension1?: number | undefined;
    profileWasteDimension2?: number | undefined;
    profileNestQuantity?: number | undefined;
    confirmed?: boolean | undefined;
    purchaseOrderNumber?: number | undefined;
    poLineQuantityInvoiced?: number | undefined;
    poLineUnitCostPrice?: number | undefined;
    poLinePerID?: number | undefined;
    poLineDiscountAmount1?: number | undefined;
    poLineDiscountAmount2?: number | undefined;
    poLineDiscountAmount3?: number | undefined;
    poLineDiscountAmount4?: number | undefined;
    poLineNumber?: number | undefined;
    purchaseOrderDateRequired?: Date | undefined;
    purchaseOrderDateExpected?: Date | undefined;
    purchaseOrderAcknowledged?: boolean | undefined;
    poPaymentTermsID?: number | undefined;
    poExchangeRate?: number | undefined;
    poEstimatedFreightInCurrency?: number | undefined;
    poEstimatedMiscInCurrency?: number | undefined;
    supplierName?: string | undefined;
    supplierID?: number | undefined;
    supplierCode?: string | undefined;
    batchRef?: string | undefined;
    branchName?: string | undefined;
    worksOrderStatus?: number | undefined;
    worksOrderStockAllocated?: boolean | undefined;
    worksOrderNumber?: number | undefined;
    worksOrderBranchID?: number | undefined;
    worksOrderLineType?: number | undefined;
    worksOrderLineProductKitID?: number | undefined;
    workOrderIsNested?: boolean | undefined;
    workOrderIsNestedCutLine?: number | undefined;
    workOrderLinePackID?: number | undefined;
    workOrderRequiresStock?: boolean | undefined;
    kitManufacturedProductFlag?: number | undefined;
    companyNegotiationWarning?: string | undefined;
    branchNegotiationWarning?: string | undefined;
    statisticsPerID?: number | undefined;
    transferOrderID?: number | undefined;
    internalGiftCardNumber?: string | undefined;
    cashBalanceCustomerID?: number | undefined;
    specialSourceAllowSpecialsBasedOnThis?: number | undefined;
    priceRuleSettlementDiscNotAllowed?: boolean | undefined;
    poLineTransferQuantity?: number | undefined;
    allocatedToStockTransferID?: number | undefined;
    totalNetWeight?: number | undefined;
    unitNettWeight?: number | undefined;
    originalDirectPoid?: number | undefined;
    productActualThickness?: number | undefined;
    productActualWidth?: number | undefined;
    productTaxGroupID?: number | undefined;
    productBranchNegotiationWarning?: string | undefined;
    productAlwaysOrderStockBackToBack?: boolean | undefined;
    productAllowSettlementDiscount?: boolean | undefined;
    widthWithWaste?: number | undefined;
    lengthWithWaste?: number | undefined;
    poLineUnitCostInCurrency?: number | undefined;
    costPriceType?: number | undefined;
    sellPriceType?: number | undefined;
    sellPriceTypeID?: number | undefined;
    internalTotalCostPrice?: number | undefined;
    productThickness?: number | undefined;
    productWidth?: number | undefined;
    totalArea?: number | undefined;
    totalActualWeight?: number | undefined;
    totalActualVolume?: number | undefined;
    totalActualArea?: number | undefined;
    hasExternalAVOs?: boolean | undefined;
    transferLineQuantity?: number | undefined;
    receivingStockTransfer?: boolean | undefined;
    readonly childJustCreatedFromParent?: boolean | undefined;
    readonly totalLengthImperial?: number | undefined;
    readonly totalVolumeImperial?: number | undefined;
    readonly totalAreaImperial?: number | undefined;
    readonly productTallyLengthsPerID?: number | undefined;
    readonly productTallyLengths?: string | undefined;
    readonly productAvailableWidths?: string | undefined;
    readonly forceCalculateTaxEvenIfInvoiced?: boolean | undefined;
    readonly generatedFromContractInvoicing?: boolean | undefined;

    constructor(data?: IOrderLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderLineID = _data["orderLineID"];
            this.orderID = _data["orderID"];
            this.branchID = _data["branchID"];
            this.lineNumber = _data["lineNumber"];
            this.linkedToLineID = _data["linkedToLineID"];
            this.lineType = _data["lineType"];
            this.lineStatus = _data["lineStatus"];
            this.suggestedOrderBatchLineID = _data["suggestedOrderBatchLineID"];
            this.saleType = _data["saleType"];
            this.stockBatchID = _data["stockBatchID"];
            this.stockAllocationID = _data["stockAllocationID"];
            this.stockReservationID = _data["stockReservationID"];
            this.productID = _data["productID"];
            this.productKitID = _data["productKitID"];
            this.cuttingOperationID = _data["cuttingOperationID"];
            this.profileOperationID = _data["profileOperationID"];
            this.worksOrderID = _data["worksOrderID"];
            this.worksOrderLineID = _data["worksOrderLineID"];
            this.calledOffFromLineID = _data["calledOffFromLineID"];
            this.calledOffFromScheduleID = _data["calledOffFromScheduleID"];
            this.createdFromOrderLineID = _data["createdFromOrderLineID"];
            this.createdFromWorksOrderLineID = _data["createdFromWorksOrderLineID"];
            this.createdFromContractInvoicingLineID = _data["createdFromContractInvoicingLineID"];
            this.manualCode = _data["manualCode"];
            this.manualDescription = _data["manualDescription"];
            this.manualOrderLineTypeID = _data["manualOrderLineTypeID"];
            this.manualSupplierID = _data["manualSupplierID"];
            this.manualSteelGradeID = _data["manualSteelGradeID"];
            this.manualThickness = _data["manualThickness"];
            this.manualWidth = _data["manualWidth"];
            this.manualLength = _data["manualLength"];
            this.quantity = _data["quantity"];
            this.quantityDisplay = _data["quantityDisplay"];
            this.quantityPicked = _data["quantityPicked"];
            this.fullyPicked = _data["fullyPicked"];
            this.quantityConfirmed = _data["quantityConfirmed"];
            this.quantityDelivered = _data["quantityDelivered"];
            this.quantityInvoiced = _data["quantityInvoiced"];
            this.quantityReturned = _data["quantityReturned"];
            this.quantityCredited = _data["quantityCredited"];
            this.quantityBackOrdered = _data["quantityBackOrdered"];
            this.quantityCalledOff = _data["quantityCalledOff"];
            this.quantityTally = _data["quantityTally"];
            this.quantityTallyPicked = _data["quantityTallyPicked"];
            this.noOfPieces = _data["noOfPieces"];
            this.inputPerID = _data["inputPerID"];
            this.displayInputPerID = _data["displayInputPerID"];
            this.perID = _data["perID"];
            this.costPerID = _data["costPerID"];
            this.stockPerConversion = _data["stockPerConversion"];
            this.statsPerConversion = _data["statsPerConversion"];
            this.freeOfCharge = _data["freeOfCharge"];
            this.unitCostPrice = _data["unitCostPrice"];
            this.unitSellPrice = _data["unitSellPrice"];
            this.unitSellPriceDisplay = _data["unitSellPriceDisplay"];
            this.unitWeight = _data["unitWeight"];
            this.totalCostPrice = _data["totalCostPrice"];
            this.transferCostPrice = _data["transferCostPrice"];
            this.totalSellPrice = _data["totalSellPrice"];
            this.totalVAT = _data["totalVAT"];
            this.totalTax = _data["totalTax"];
            this.retentionAmount = _data["retentionAmount"];
            this.totalMargin = _data["totalMargin"];
            this.totalWeight = _data["totalWeight"];
            this.totalLength = _data["totalLength"];
            this.totalVolume = _data["totalVolume"];
            this.pricingType = _data["pricingType"];
            this.buyingPrice = _data["buyingPrice"];
            this.sellingPriceRuleID = _data["sellingPriceRuleID"];
            this.sellingRulePriority = _data["sellingRulePriority"];
            this.sellingCalcType = _data["sellingCalcType"];
            this.sellingCalcValue = _data["sellingCalcValue"];
            this.sellingCalcValue2 = _data["sellingCalcValue2"];
            this.sellingCalcValue3 = _data["sellingCalcValue3"];
            this.sellingPriceBand = _data["sellingPriceBand"];
            this.sellingPrice = _data["sellingPrice"];
            this.sellingAdjustment = _data["sellingAdjustment"];
            this.sellingAdjustments = _data["sellingAdjustments"];
            this.discount1 = _data["discount1"];
            this.discountAmount1 = _data["discountAmount1"];
            this.discount2 = _data["discount2"];
            this.discountAmount2 = _data["discountAmount2"];
            this.avoUnitSellPrice = _data["avoUnitSellPrice"];
            this.avoCostPrice = _data["avoCostPrice"];
            this.avoSellPrice = _data["avoSellPrice"];
            this.avoCount = _data["avoCount"];
            this.avoQuantity = _data["avoQuantity"];
            this.avoQuantityCompleted = _data["avoQuantityCompleted"];
            this.showAVOsInUnitPrice = _data["showAVOsInUnitPrice"];
            this.deliveryCostRecovery = _data["deliveryCostRecovery"];
            this.deliveryChargeRate = _data["deliveryChargeRate"];
            this.deliveryCharge = _data["deliveryCharge"];
            this.deliveryCost = _data["deliveryCost"];
            this.additionalCharge = _data["additionalCharge"];
            this.additionalCost = _data["additionalCost"];
            this.unitSellPriceInCurrency = _data["unitSellPriceInCurrency"];
            this.totalSellPriceInCurrency = _data["totalSellPriceInCurrency"];
            this.totalVatInCurrency = _data["totalVatInCurrency"];
            this.totalTaxInCurrency = _data["totalTaxInCurrency"];
            this.retentionAmountInCurrency = _data["retentionAmountInCurrency"];
            this.discountAmount1InCurrency = _data["discountAmount1InCurrency"];
            this.discountAmount2InCurrency = _data["discountAmount2InCurrency"];
            this.avoUnitSellPriceInCurrency = _data["avoUnitSellPriceInCurrency"];
            this.avoSellPriceInCurrency = _data["avoSellPriceInCurrency"];
            this.vatID = _data["vatID"];
            this.vatRateID = _data["vatRateID"];
            this.taxGroupID = _data["taxGroupID"];
            this.taxCodes = _data["taxCodes"];
            this.purchaseAnalysisCodeID = _data["purchaseAnalysisCodeID"];
            this.salesAnalysisCodeID = _data["salesAnalysisCodeID"];
            this.customerRef = _data["customerRef"];
            this.notes = _data["notes"];
            this.specialInstructions = _data["specialInstructions"];
            this.internalNotes = _data["internalNotes"];
            this.backOrder = _data["backOrder"];
            this.stockTransferred = _data["stockTransferred"];
            this.manufactured = _data["manufactured"];
            this.specialOrder = _data["specialOrder"];
            this.purchaseOrderID = _data["purchaseOrderID"];
            this.purchaseOrderQuantity = _data["purchaseOrderQuantity"];
            this.purchaseOrderQuantityReceived = _data["purchaseOrderQuantityReceived"];
            this.purchaseOrderInvoiced = _data["purchaseOrderInvoiced"];
            this.releaseForProcessing = _data["releaseForProcessing"];
            this.pickingRequired = _data["pickingRequired"];
            this.deliveryRequired = _data["deliveryRequired"];
            this.invoiceID = _data["invoiceID"];
            this.invoiced = _data["invoiced"];
            this.pendingActions = _data["pendingActions"];
            this.manuallyOverriddenTransferCostPrice = _data["manuallyOverriddenTransferCostPrice"];
            this.poLineOverrideThickness = _data["poLineOverrideThickness"];
            this.poLineOverrideWidth = _data["poLineOverrideWidth"];
            this.poLineOverrideVolume = _data["poLineOverrideVolume"];
            this.unitVMICostPrice = _data["unitVMICostPrice"];
            this.totalVMICostPrice = _data["totalVMICostPrice"];
            this.vmiRuleID = _data["vmiRuleID"];
            this.lastModifiedReasonID = _data["lastModifiedReasonID"];
            this.vmiSupplierInvoiceDocumentID = _data["vmiSupplierInvoiceDocumentID"];
            this.vmiReconciled = _data["vmiReconciled"];
            this.transferToProductBatchID = _data["transferToProductBatchID"];
            this.costDiscount1 = _data["costDiscount1"];
            this.costDiscountAmount1 = _data["costDiscountAmount1"];
            this.costDiscount2 = _data["costDiscount2"];
            this.costDiscountAmount2 = _data["costDiscountAmount2"];
            this.costDiscount3 = _data["costDiscount3"];
            this.costDiscountAmount3 = _data["costDiscountAmount3"];
            this.costDiscount4 = _data["costDiscount4"];
            this.costDiscountAmount4 = _data["costDiscountAmount4"];
            this.unitVMICostInCurrency = _data["unitVMICostInCurrency"];
            this.totalVMICostInCurrency = _data["totalVMICostInCurrency"];
            this.vmiExchangeRate = _data["vmiExchangeRate"];
            this.sourceOrderLineID = _data["sourceOrderLineID"];
            this.wmsCartNumber = _data["wmsCartNumber"];
            this.nonSalesAmount = _data["nonSalesAmount"];
            this.nonSalesAmountInCurrency = _data["nonSalesAmountInCurrency"];
            this.internalCostTotalMargin = _data["internalCostTotalMargin"];
            this.wmsParentLineID = _data["wmsParentLineID"];
            this.cutToLength = _data["cutToLength"];
            this.sellingCalcValue2Type = _data["sellingCalcValue2Type"];
            this.sellingCalcValue3Type = _data["sellingCalcValue3Type"];
            this.netPriced = _data["netPriced"];
            this.wmsUnitNumber = _data["wmsUnitNumber"];
            this.overrideUserID = _data["overrideUserID"];
            this.transferQuantityAllocated = _data["transferQuantityAllocated"];
            this.dateExpected = _data["dateExpected"] ? new Date(_data["dateExpected"].toString()) : <any>undefined;
            this.sellingCalcValue2Method = _data["sellingCalcValue2Method"];
            this.couponID = _data["couponID"];
            this.usePackPriceSurcharge = _data["usePackPriceSurcharge"];
            this.pointsRedeemed = _data["pointsRedeemed"];
            this.requiresKitConfiguration = _data["requiresKitConfiguration"];
            this.manufacturingOptionsXML = _data["manufacturingOptionsXML"];
            this.isWMSAdditionalCharge = _data["isWMSAdditionalCharge"];
            this.quantityTallyCalledOff = _data["quantityTallyCalledOff"];
            this.quantityFromScale = _data["quantityFromScale"];
            this.scaleGrossWeight = _data["scaleGrossWeight"];
            this.grossingRuleQuantity = _data["grossingRuleQuantity"];
            this.grossingRuleQuantityTally = _data["grossingRuleQuantityTally"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"]) : <any>undefined;
            this.per = _data["per"] ? Per.fromJS(_data["per"]) : <any>undefined;
            if (Array.isArray(_data["orderLine1"])) {
                this.orderLine1 = [] as any;
                for (let item of _data["orderLine1"])
                    this.orderLine1!.push(OrderLine.fromJS(item));
            }
            this.orderLine2 = _data["orderLine2"] ? OrderLine.fromJS(_data["orderLine2"]) : <any>undefined;
            this.per1 = _data["per1"] ? Per.fromJS(_data["per1"]) : <any>undefined;
            if (Array.isArray(_data["orderLine11"])) {
                this.orderLine11 = [] as any;
                for (let item of _data["orderLine11"])
                    this.orderLine11!.push(OrderLine.fromJS(item));
            }
            this.orderLine3 = _data["orderLine3"] ? OrderLine.fromJS(_data["orderLine3"]) : <any>undefined;
            this.per2 = _data["per2"] ? Per.fromJS(_data["per2"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.supplier = _data["supplier"] ? Supplier.fromJS(_data["supplier"]) : <any>undefined;
            if (Array.isArray(_data["orderLineItems"])) {
                this.orderLineItems = [] as any;
                for (let item of _data["orderLineItems"])
                    this.orderLineItems!.push(OrderLineItem.fromJS(item));
            }
            if (Array.isArray(_data["additionalCostCharges"])) {
                this.additionalCostCharges = [] as any;
                for (let item of _data["additionalCostCharges"])
                    this.additionalCostCharges!.push(OrderLineAdditionalCostCharge.fromJS(item));
            }
            if (Array.isArray(_data["colAvos"])) {
                this.colAvos = [] as any;
                for (let item of _data["colAvos"])
                    this.colAvos!.push(OrderLineAVO.fromJS(item));
            }
            this.productType = _data["productType"];
            this.productSubType = _data["productSubType"];
            this.perRuleID = _data["perRuleID"];
            this.productCode = _data["productCode"];
            this.productBarCode = _data["productBarCode"];
            this.productDescription = _data["productDescription"];
            this.thickness = _data["thickness"];
            this.width = _data["width"];
            this.length = _data["length"];
            this.dimension4 = _data["dimension4"];
            this.dimension5 = _data["dimension5"];
            this.imperial = _data["imperial"];
            this.tallyLengths = _data["tallyLengths"];
            this.tallyLengthsPerID = _data["tallyLengthsPerID"];
            this.availableWidths = _data["availableWidths"];
            this.lowMarginCollected = _data["lowMarginCollected"];
            this.lowMarginDelivered = _data["lowMarginDelivered"];
            this.lowMarginDirect = _data["lowMarginDirect"];
            this.highMargin = _data["highMargin"];
            this.allowMultiplePersOnUnitSizes = _data["allowMultiplePersOnUnitSizes"];
            this.defaultUnitSizePerID = _data["defaultUnitSizePerID"];
            this.perCode = _data["perCode"];
            this.perName = _data["perName"];
            this.productKeepStockFigures = _data["productKeepStockFigures"];
            this.productStockControlByLength = _data["productStockControlByLength"];
            this.productPickingRequired = _data["productPickingRequired"];
            this.productAllowDirectSales = _data["productAllowDirectSales"];
            this.productAllowCashSales = _data["productAllowCashSales"];
            this.productApplyDeliveryCharges = _data["productApplyDeliveryCharges"];
            this.productPromptForQuantity = _data["productPromptForQuantity"];
            this.productAllowDescriptionOverride = _data["productAllowDescriptionOverride"];
            this.productAllowPriceNegotiation = _data["productAllowPriceNegotiation"];
            this.productAllowCostOverride = _data["productAllowCostOverride"];
            this.productAutoCreateSpecialFromThis = _data["productAutoCreateSpecialFromThis"];
            this.productPriceBookSection = _data["productPriceBookSection"];
            this.productPriceBookSequence = _data["productPriceBookSequence"];
            this.specialSourceAutoCreateSpecialFromThis = _data["specialSourceAutoCreateSpecialFromThis"];
            this.productSpecialSourceID = _data["productSpecialSourceID"];
            this.productSpecial = _data["productSpecial"];
            this.deliveryProductTypeID = _data["deliveryProductTypeID"];
            this.productExternalLinkType = _data["productExternalLinkType"];
            this.productStandardStock = _data["productStandardStock"];
            this.productGroupID = _data["productGroupID"];
            this.materialGradeID = _data["materialGradeID"];
            this.sellTaxGroupID = _data["sellTaxGroupID"];
            this.productVatRuleID = _data["productVatRuleID"];
            this.productDefaultPiecesPerPack = _data["productDefaultPiecesPerPack"];
            this.productEnvironmentalStatusID = _data["productEnvironmentalStatusID"];
            this.productTimberSurchargeID = _data["productTimberSurchargeID"];
            this.sellPriceGroupID = _data["sellPriceGroupID"];
            this.pointsPerAmountSpentCollected = _data["pointsPerAmountSpentCollected"];
            this.pointsPerAmountSpentDelivered = _data["pointsPerAmountSpentDelivered"];
            this.pointsPerAmountSpentDirect = _data["pointsPerAmountSpentDirect"];
            this.automaticLineChargeID = _data["automaticLineChargeID"];
            this.automaticLineChargeMultiplier = _data["automaticLineChargeMultiplier"];
            this.alwaysOrderStockBackToBack = _data["alwaysOrderStockBackToBack"];
            this.quantityPerInner = _data["quantityPerInner"];
            this.quantityPerOuter = _data["quantityPerOuter"];
            this.quantityPerPallet = _data["quantityPerPallet"];
            this.quantityPerCube = _data["quantityPerCube"];
            this.sellQuantityRoundingOption = _data["sellQuantityRoundingOption"];
            this.deleted = _data["deleted"];
            this.productManufacturerCode = _data["productManufacturerCode"];
            this.productWidthGrossingRule = _data["productWidthGrossingRule"];
            this.productLengthGrossingRule = _data["productLengthGrossingRule"];
            this.productStockedByCost = _data["productStockedByCost"];
            this.productSalesOrderTalliedInputScreen = _data["productSalesOrderTalliedInputScreen"];
            this.productPromptForTallyOnSalesOrder = _data["productPromptForTallyOnSalesOrder"];
            this.productWeight = _data["productWeight"];
            this.allowSettlementDiscount = _data["allowSettlementDiscount"];
            this.cutToLengthStyle = _data["cutToLengthStyle"];
            this.productSellPriceRounding = _data["productSellPriceRounding"];
            this.productSellPriceRoundingOption = _data["productSellPriceRoundingOption"];
            this.productSellPriceRoundingPerID = _data["productSellPriceRoundingPerID"];
            this.productApplyRebateAccruals = _data["productApplyRebateAccruals"];
            this.productHowSourced = _data["productHowSourced"];
            this.purchaseAndTransferBranchID = _data["purchaseAndTransferBranchID"];
            this.branchAllowSettlementDiscount = _data["branchAllowSettlementDiscount"];
            this.defaultAllowSettlementDiscount = _data["defaultAllowSettlementDiscount"];
            this.defaultProductHowSourced = _data["defaultProductHowSourced"];
            this.defaultPurchaseAndTransferBranchID = _data["defaultPurchaseAndTransferBranchID"];
            this.productPickingZone = _data["productPickingZone"];
            this.productBinLocation = _data["productBinLocation"];
            this.productBatchTypeID = _data["productBatchTypeID"];
            this.stockPerCode = _data["stockPerCode"];
            this.productInputPerID = _data["productInputPerID"];
            this.weightPerID = _data["weightPerID"];
            this.stockPerID = _data["stockPerID"];
            this.manualSupplierName = _data["manualSupplierName"];
            this.vatCode = _data["vatCode"];
            this.profileShapeType = _data["profileShapeType"];
            this.profileDimension1 = _data["profileDimension1"];
            this.profileDimension2 = _data["profileDimension2"];
            this.totalNettWeight = _data["totalNettWeight"];
            this.profileWasteType = _data["profileWasteType"];
            this.profileWasteDimension1 = _data["profileWasteDimension1"];
            this.profileWasteDimension2 = _data["profileWasteDimension2"];
            this.profileNestQuantity = _data["profileNestQuantity"];
            this.confirmed = _data["confirmed"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.poLineQuantityInvoiced = _data["poLineQuantityInvoiced"];
            this.poLineUnitCostPrice = _data["poLineUnitCostPrice"];
            this.poLinePerID = _data["poLinePerID"];
            this.poLineDiscountAmount1 = _data["poLineDiscountAmount1"];
            this.poLineDiscountAmount2 = _data["poLineDiscountAmount2"];
            this.poLineDiscountAmount3 = _data["poLineDiscountAmount3"];
            this.poLineDiscountAmount4 = _data["poLineDiscountAmount4"];
            this.poLineNumber = _data["poLineNumber"];
            this.purchaseOrderDateRequired = _data["purchaseOrderDateRequired"] ? new Date(_data["purchaseOrderDateRequired"].toString()) : <any>undefined;
            this.purchaseOrderDateExpected = _data["purchaseOrderDateExpected"] ? new Date(_data["purchaseOrderDateExpected"].toString()) : <any>undefined;
            this.purchaseOrderAcknowledged = _data["purchaseOrderAcknowledged"];
            this.poPaymentTermsID = _data["poPaymentTermsID"];
            this.poExchangeRate = _data["poExchangeRate"];
            this.poEstimatedFreightInCurrency = _data["poEstimatedFreightInCurrency"];
            this.poEstimatedMiscInCurrency = _data["poEstimatedMiscInCurrency"];
            this.supplierName = _data["supplierName"];
            this.supplierID = _data["supplierID"];
            this.supplierCode = _data["supplierCode"];
            this.batchRef = _data["batchRef"];
            this.branchName = _data["branchName"];
            this.worksOrderStatus = _data["worksOrderStatus"];
            this.worksOrderStockAllocated = _data["worksOrderStockAllocated"];
            this.worksOrderNumber = _data["worksOrderNumber"];
            this.worksOrderBranchID = _data["worksOrderBranchID"];
            this.worksOrderLineType = _data["worksOrderLineType"];
            this.worksOrderLineProductKitID = _data["worksOrderLineProductKitID"];
            this.workOrderIsNested = _data["workOrderIsNested"];
            this.workOrderIsNestedCutLine = _data["workOrderIsNestedCutLine"];
            this.workOrderLinePackID = _data["workOrderLinePackID"];
            this.workOrderRequiresStock = _data["workOrderRequiresStock"];
            this.kitManufacturedProductFlag = _data["kitManufacturedProductFlag"];
            this.companyNegotiationWarning = _data["companyNegotiationWarning"];
            this.branchNegotiationWarning = _data["branchNegotiationWarning"];
            this.statisticsPerID = _data["statisticsPerID"];
            this.transferOrderID = _data["transferOrderID"];
            this.internalGiftCardNumber = _data["internalGiftCardNumber"];
            this.cashBalanceCustomerID = _data["cashBalanceCustomerID"];
            this.specialSourceAllowSpecialsBasedOnThis = _data["specialSourceAllowSpecialsBasedOnThis"];
            this.priceRuleSettlementDiscNotAllowed = _data["priceRuleSettlementDiscNotAllowed"];
            this.poLineTransferQuantity = _data["poLineTransferQuantity"];
            this.allocatedToStockTransferID = _data["allocatedToStockTransferID"];
            this.totalNetWeight = _data["totalNetWeight"];
            this.unitNettWeight = _data["unitNettWeight"];
            this.originalDirectPoid = _data["originalDirectPoid"];
            this.productActualThickness = _data["productActualThickness"];
            this.productActualWidth = _data["productActualWidth"];
            this.productTaxGroupID = _data["productTaxGroupID"];
            this.productBranchNegotiationWarning = _data["productBranchNegotiationWarning"];
            this.productAlwaysOrderStockBackToBack = _data["productAlwaysOrderStockBackToBack"];
            this.productAllowSettlementDiscount = _data["productAllowSettlementDiscount"];
            this.widthWithWaste = _data["widthWithWaste"];
            this.lengthWithWaste = _data["lengthWithWaste"];
            this.poLineUnitCostInCurrency = _data["poLineUnitCostInCurrency"];
            this.costPriceType = _data["costPriceType"];
            this.sellPriceType = _data["sellPriceType"];
            this.sellPriceTypeID = _data["sellPriceTypeID"];
            this.internalTotalCostPrice = _data["internalTotalCostPrice"];
            this.productThickness = _data["productThickness"];
            this.productWidth = _data["productWidth"];
            this.totalArea = _data["totalArea"];
            this.totalActualWeight = _data["totalActualWeight"];
            this.totalActualVolume = _data["totalActualVolume"];
            this.totalActualArea = _data["totalActualArea"];
            this.hasExternalAVOs = _data["hasExternalAVOs"];
            this.transferLineQuantity = _data["transferLineQuantity"];
            this.receivingStockTransfer = _data["receivingStockTransfer"];
            (<any>this).childJustCreatedFromParent = _data["childJustCreatedFromParent"];
            (<any>this).totalLengthImperial = _data["totalLengthImperial"];
            (<any>this).totalVolumeImperial = _data["totalVolumeImperial"];
            (<any>this).totalAreaImperial = _data["totalAreaImperial"];
            (<any>this).productTallyLengthsPerID = _data["productTallyLengthsPerID"];
            (<any>this).productTallyLengths = _data["productTallyLengths"];
            (<any>this).productAvailableWidths = _data["productAvailableWidths"];
            (<any>this).forceCalculateTaxEvenIfInvoiced = _data["forceCalculateTaxEvenIfInvoiced"];
            (<any>this).generatedFromContractInvoicing = _data["generatedFromContractInvoicing"];
        }
    }

    static fromJS(data: any): OrderLine {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderLineID"] = this.orderLineID;
        data["orderID"] = this.orderID;
        data["branchID"] = this.branchID;
        data["lineNumber"] = this.lineNumber;
        data["linkedToLineID"] = this.linkedToLineID;
        data["lineType"] = this.lineType;
        data["lineStatus"] = this.lineStatus;
        data["suggestedOrderBatchLineID"] = this.suggestedOrderBatchLineID;
        data["saleType"] = this.saleType;
        data["stockBatchID"] = this.stockBatchID;
        data["stockAllocationID"] = this.stockAllocationID;
        data["stockReservationID"] = this.stockReservationID;
        data["productID"] = this.productID;
        data["productKitID"] = this.productKitID;
        data["cuttingOperationID"] = this.cuttingOperationID;
        data["profileOperationID"] = this.profileOperationID;
        data["worksOrderID"] = this.worksOrderID;
        data["worksOrderLineID"] = this.worksOrderLineID;
        data["calledOffFromLineID"] = this.calledOffFromLineID;
        data["calledOffFromScheduleID"] = this.calledOffFromScheduleID;
        data["createdFromOrderLineID"] = this.createdFromOrderLineID;
        data["createdFromWorksOrderLineID"] = this.createdFromWorksOrderLineID;
        data["createdFromContractInvoicingLineID"] = this.createdFromContractInvoicingLineID;
        data["manualCode"] = this.manualCode;
        data["manualDescription"] = this.manualDescription;
        data["manualOrderLineTypeID"] = this.manualOrderLineTypeID;
        data["manualSupplierID"] = this.manualSupplierID;
        data["manualSteelGradeID"] = this.manualSteelGradeID;
        data["manualThickness"] = this.manualThickness;
        data["manualWidth"] = this.manualWidth;
        data["manualLength"] = this.manualLength;
        data["quantity"] = this.quantity;
        data["quantityDisplay"] = this.quantityDisplay;
        data["quantityPicked"] = this.quantityPicked;
        data["fullyPicked"] = this.fullyPicked;
        data["quantityConfirmed"] = this.quantityConfirmed;
        data["quantityDelivered"] = this.quantityDelivered;
        data["quantityInvoiced"] = this.quantityInvoiced;
        data["quantityReturned"] = this.quantityReturned;
        data["quantityCredited"] = this.quantityCredited;
        data["quantityBackOrdered"] = this.quantityBackOrdered;
        data["quantityCalledOff"] = this.quantityCalledOff;
        data["quantityTally"] = this.quantityTally;
        data["quantityTallyPicked"] = this.quantityTallyPicked;
        data["noOfPieces"] = this.noOfPieces;
        data["inputPerID"] = this.inputPerID;
        data["displayInputPerID"] = this.displayInputPerID;
        data["perID"] = this.perID;
        data["costPerID"] = this.costPerID;
        data["stockPerConversion"] = this.stockPerConversion;
        data["statsPerConversion"] = this.statsPerConversion;
        data["freeOfCharge"] = this.freeOfCharge;
        data["unitCostPrice"] = this.unitCostPrice;
        data["unitSellPrice"] = this.unitSellPrice;
        data["unitSellPriceDisplay"] = this.unitSellPriceDisplay;
        data["unitWeight"] = this.unitWeight;
        data["totalCostPrice"] = this.totalCostPrice;
        data["transferCostPrice"] = this.transferCostPrice;
        data["totalSellPrice"] = this.totalSellPrice;
        data["totalVAT"] = this.totalVAT;
        data["totalTax"] = this.totalTax;
        data["retentionAmount"] = this.retentionAmount;
        data["totalMargin"] = this.totalMargin;
        data["totalWeight"] = this.totalWeight;
        data["totalLength"] = this.totalLength;
        data["totalVolume"] = this.totalVolume;
        data["pricingType"] = this.pricingType;
        data["buyingPrice"] = this.buyingPrice;
        data["sellingPriceRuleID"] = this.sellingPriceRuleID;
        data["sellingRulePriority"] = this.sellingRulePriority;
        data["sellingCalcType"] = this.sellingCalcType;
        data["sellingCalcValue"] = this.sellingCalcValue;
        data["sellingCalcValue2"] = this.sellingCalcValue2;
        data["sellingCalcValue3"] = this.sellingCalcValue3;
        data["sellingPriceBand"] = this.sellingPriceBand;
        data["sellingPrice"] = this.sellingPrice;
        data["sellingAdjustment"] = this.sellingAdjustment;
        data["sellingAdjustments"] = this.sellingAdjustments;
        data["discount1"] = this.discount1;
        data["discountAmount1"] = this.discountAmount1;
        data["discount2"] = this.discount2;
        data["discountAmount2"] = this.discountAmount2;
        data["avoUnitSellPrice"] = this.avoUnitSellPrice;
        data["avoCostPrice"] = this.avoCostPrice;
        data["avoSellPrice"] = this.avoSellPrice;
        data["avoCount"] = this.avoCount;
        data["avoQuantity"] = this.avoQuantity;
        data["avoQuantityCompleted"] = this.avoQuantityCompleted;
        data["showAVOsInUnitPrice"] = this.showAVOsInUnitPrice;
        data["deliveryCostRecovery"] = this.deliveryCostRecovery;
        data["deliveryChargeRate"] = this.deliveryChargeRate;
        data["deliveryCharge"] = this.deliveryCharge;
        data["deliveryCost"] = this.deliveryCost;
        data["additionalCharge"] = this.additionalCharge;
        data["additionalCost"] = this.additionalCost;
        data["unitSellPriceInCurrency"] = this.unitSellPriceInCurrency;
        data["totalSellPriceInCurrency"] = this.totalSellPriceInCurrency;
        data["totalVatInCurrency"] = this.totalVatInCurrency;
        data["totalTaxInCurrency"] = this.totalTaxInCurrency;
        data["retentionAmountInCurrency"] = this.retentionAmountInCurrency;
        data["discountAmount1InCurrency"] = this.discountAmount1InCurrency;
        data["discountAmount2InCurrency"] = this.discountAmount2InCurrency;
        data["avoUnitSellPriceInCurrency"] = this.avoUnitSellPriceInCurrency;
        data["avoSellPriceInCurrency"] = this.avoSellPriceInCurrency;
        data["vatID"] = this.vatID;
        data["vatRateID"] = this.vatRateID;
        data["taxGroupID"] = this.taxGroupID;
        data["taxCodes"] = this.taxCodes;
        data["purchaseAnalysisCodeID"] = this.purchaseAnalysisCodeID;
        data["salesAnalysisCodeID"] = this.salesAnalysisCodeID;
        data["customerRef"] = this.customerRef;
        data["notes"] = this.notes;
        data["specialInstructions"] = this.specialInstructions;
        data["internalNotes"] = this.internalNotes;
        data["backOrder"] = this.backOrder;
        data["stockTransferred"] = this.stockTransferred;
        data["manufactured"] = this.manufactured;
        data["specialOrder"] = this.specialOrder;
        data["purchaseOrderID"] = this.purchaseOrderID;
        data["purchaseOrderQuantity"] = this.purchaseOrderQuantity;
        data["purchaseOrderQuantityReceived"] = this.purchaseOrderQuantityReceived;
        data["purchaseOrderInvoiced"] = this.purchaseOrderInvoiced;
        data["releaseForProcessing"] = this.releaseForProcessing;
        data["pickingRequired"] = this.pickingRequired;
        data["deliveryRequired"] = this.deliveryRequired;
        data["invoiceID"] = this.invoiceID;
        data["invoiced"] = this.invoiced;
        data["pendingActions"] = this.pendingActions;
        data["manuallyOverriddenTransferCostPrice"] = this.manuallyOverriddenTransferCostPrice;
        data["poLineOverrideThickness"] = this.poLineOverrideThickness;
        data["poLineOverrideWidth"] = this.poLineOverrideWidth;
        data["poLineOverrideVolume"] = this.poLineOverrideVolume;
        data["unitVMICostPrice"] = this.unitVMICostPrice;
        data["totalVMICostPrice"] = this.totalVMICostPrice;
        data["vmiRuleID"] = this.vmiRuleID;
        data["lastModifiedReasonID"] = this.lastModifiedReasonID;
        data["vmiSupplierInvoiceDocumentID"] = this.vmiSupplierInvoiceDocumentID;
        data["vmiReconciled"] = this.vmiReconciled;
        data["transferToProductBatchID"] = this.transferToProductBatchID;
        data["costDiscount1"] = this.costDiscount1;
        data["costDiscountAmount1"] = this.costDiscountAmount1;
        data["costDiscount2"] = this.costDiscount2;
        data["costDiscountAmount2"] = this.costDiscountAmount2;
        data["costDiscount3"] = this.costDiscount3;
        data["costDiscountAmount3"] = this.costDiscountAmount3;
        data["costDiscount4"] = this.costDiscount4;
        data["costDiscountAmount4"] = this.costDiscountAmount4;
        data["unitVMICostInCurrency"] = this.unitVMICostInCurrency;
        data["totalVMICostInCurrency"] = this.totalVMICostInCurrency;
        data["vmiExchangeRate"] = this.vmiExchangeRate;
        data["sourceOrderLineID"] = this.sourceOrderLineID;
        data["wmsCartNumber"] = this.wmsCartNumber;
        data["nonSalesAmount"] = this.nonSalesAmount;
        data["nonSalesAmountInCurrency"] = this.nonSalesAmountInCurrency;
        data["internalCostTotalMargin"] = this.internalCostTotalMargin;
        data["wmsParentLineID"] = this.wmsParentLineID;
        data["cutToLength"] = this.cutToLength;
        data["sellingCalcValue2Type"] = this.sellingCalcValue2Type;
        data["sellingCalcValue3Type"] = this.sellingCalcValue3Type;
        data["netPriced"] = this.netPriced;
        data["wmsUnitNumber"] = this.wmsUnitNumber;
        data["overrideUserID"] = this.overrideUserID;
        data["transferQuantityAllocated"] = this.transferQuantityAllocated;
        data["dateExpected"] = this.dateExpected ? this.dateExpected.toISOString() : <any>undefined;
        data["sellingCalcValue2Method"] = this.sellingCalcValue2Method;
        data["couponID"] = this.couponID;
        data["usePackPriceSurcharge"] = this.usePackPriceSurcharge;
        data["pointsRedeemed"] = this.pointsRedeemed;
        data["requiresKitConfiguration"] = this.requiresKitConfiguration;
        data["manufacturingOptionsXML"] = this.manufacturingOptionsXML;
        data["isWMSAdditionalCharge"] = this.isWMSAdditionalCharge;
        data["quantityTallyCalledOff"] = this.quantityTallyCalledOff;
        data["quantityFromScale"] = this.quantityFromScale;
        data["scaleGrossWeight"] = this.scaleGrossWeight;
        data["grossingRuleQuantity"] = this.grossingRuleQuantity;
        data["grossingRuleQuantityTally"] = this.grossingRuleQuantityTally;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["per"] = this.per ? this.per.toJSON() : <any>undefined;
        if (Array.isArray(this.orderLine1)) {
            data["orderLine1"] = [];
            for (let item of this.orderLine1)
                data["orderLine1"].push(item.toJSON());
        }
        data["orderLine2"] = this.orderLine2 ? this.orderLine2.toJSON() : <any>undefined;
        data["per1"] = this.per1 ? this.per1.toJSON() : <any>undefined;
        if (Array.isArray(this.orderLine11)) {
            data["orderLine11"] = [];
            for (let item of this.orderLine11)
                data["orderLine11"].push(item.toJSON());
        }
        data["orderLine3"] = this.orderLine3 ? this.orderLine3.toJSON() : <any>undefined;
        data["per2"] = this.per2 ? this.per2.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : <any>undefined;
        if (Array.isArray(this.orderLineItems)) {
            data["orderLineItems"] = [];
            for (let item of this.orderLineItems)
                data["orderLineItems"].push(item.toJSON());
        }
        if (Array.isArray(this.additionalCostCharges)) {
            data["additionalCostCharges"] = [];
            for (let item of this.additionalCostCharges)
                data["additionalCostCharges"].push(item.toJSON());
        }
        if (Array.isArray(this.colAvos)) {
            data["colAvos"] = [];
            for (let item of this.colAvos)
                data["colAvos"].push(item.toJSON());
        }
        data["productType"] = this.productType;
        data["productSubType"] = this.productSubType;
        data["perRuleID"] = this.perRuleID;
        data["productCode"] = this.productCode;
        data["productBarCode"] = this.productBarCode;
        data["productDescription"] = this.productDescription;
        data["thickness"] = this.thickness;
        data["width"] = this.width;
        data["length"] = this.length;
        data["dimension4"] = this.dimension4;
        data["dimension5"] = this.dimension5;
        data["imperial"] = this.imperial;
        data["tallyLengths"] = this.tallyLengths;
        data["tallyLengthsPerID"] = this.tallyLengthsPerID;
        data["availableWidths"] = this.availableWidths;
        data["lowMarginCollected"] = this.lowMarginCollected;
        data["lowMarginDelivered"] = this.lowMarginDelivered;
        data["lowMarginDirect"] = this.lowMarginDirect;
        data["highMargin"] = this.highMargin;
        data["allowMultiplePersOnUnitSizes"] = this.allowMultiplePersOnUnitSizes;
        data["defaultUnitSizePerID"] = this.defaultUnitSizePerID;
        data["perCode"] = this.perCode;
        data["perName"] = this.perName;
        data["productKeepStockFigures"] = this.productKeepStockFigures;
        data["productStockControlByLength"] = this.productStockControlByLength;
        data["productPickingRequired"] = this.productPickingRequired;
        data["productAllowDirectSales"] = this.productAllowDirectSales;
        data["productAllowCashSales"] = this.productAllowCashSales;
        data["productApplyDeliveryCharges"] = this.productApplyDeliveryCharges;
        data["productPromptForQuantity"] = this.productPromptForQuantity;
        data["productAllowDescriptionOverride"] = this.productAllowDescriptionOverride;
        data["productAllowPriceNegotiation"] = this.productAllowPriceNegotiation;
        data["productAllowCostOverride"] = this.productAllowCostOverride;
        data["productAutoCreateSpecialFromThis"] = this.productAutoCreateSpecialFromThis;
        data["productPriceBookSection"] = this.productPriceBookSection;
        data["productPriceBookSequence"] = this.productPriceBookSequence;
        data["specialSourceAutoCreateSpecialFromThis"] = this.specialSourceAutoCreateSpecialFromThis;
        data["productSpecialSourceID"] = this.productSpecialSourceID;
        data["productSpecial"] = this.productSpecial;
        data["deliveryProductTypeID"] = this.deliveryProductTypeID;
        data["productExternalLinkType"] = this.productExternalLinkType;
        data["productStandardStock"] = this.productStandardStock;
        data["productGroupID"] = this.productGroupID;
        data["materialGradeID"] = this.materialGradeID;
        data["sellTaxGroupID"] = this.sellTaxGroupID;
        data["productVatRuleID"] = this.productVatRuleID;
        data["productDefaultPiecesPerPack"] = this.productDefaultPiecesPerPack;
        data["productEnvironmentalStatusID"] = this.productEnvironmentalStatusID;
        data["productTimberSurchargeID"] = this.productTimberSurchargeID;
        data["sellPriceGroupID"] = this.sellPriceGroupID;
        data["pointsPerAmountSpentCollected"] = this.pointsPerAmountSpentCollected;
        data["pointsPerAmountSpentDelivered"] = this.pointsPerAmountSpentDelivered;
        data["pointsPerAmountSpentDirect"] = this.pointsPerAmountSpentDirect;
        data["automaticLineChargeID"] = this.automaticLineChargeID;
        data["automaticLineChargeMultiplier"] = this.automaticLineChargeMultiplier;
        data["alwaysOrderStockBackToBack"] = this.alwaysOrderStockBackToBack;
        data["quantityPerInner"] = this.quantityPerInner;
        data["quantityPerOuter"] = this.quantityPerOuter;
        data["quantityPerPallet"] = this.quantityPerPallet;
        data["quantityPerCube"] = this.quantityPerCube;
        data["sellQuantityRoundingOption"] = this.sellQuantityRoundingOption;
        data["deleted"] = this.deleted;
        data["productManufacturerCode"] = this.productManufacturerCode;
        data["productWidthGrossingRule"] = this.productWidthGrossingRule;
        data["productLengthGrossingRule"] = this.productLengthGrossingRule;
        data["productStockedByCost"] = this.productStockedByCost;
        data["productSalesOrderTalliedInputScreen"] = this.productSalesOrderTalliedInputScreen;
        data["productPromptForTallyOnSalesOrder"] = this.productPromptForTallyOnSalesOrder;
        data["productWeight"] = this.productWeight;
        data["allowSettlementDiscount"] = this.allowSettlementDiscount;
        data["cutToLengthStyle"] = this.cutToLengthStyle;
        data["productSellPriceRounding"] = this.productSellPriceRounding;
        data["productSellPriceRoundingOption"] = this.productSellPriceRoundingOption;
        data["productSellPriceRoundingPerID"] = this.productSellPriceRoundingPerID;
        data["productApplyRebateAccruals"] = this.productApplyRebateAccruals;
        data["productHowSourced"] = this.productHowSourced;
        data["purchaseAndTransferBranchID"] = this.purchaseAndTransferBranchID;
        data["branchAllowSettlementDiscount"] = this.branchAllowSettlementDiscount;
        data["defaultAllowSettlementDiscount"] = this.defaultAllowSettlementDiscount;
        data["defaultProductHowSourced"] = this.defaultProductHowSourced;
        data["defaultPurchaseAndTransferBranchID"] = this.defaultPurchaseAndTransferBranchID;
        data["productPickingZone"] = this.productPickingZone;
        data["productBinLocation"] = this.productBinLocation;
        data["productBatchTypeID"] = this.productBatchTypeID;
        data["stockPerCode"] = this.stockPerCode;
        data["productInputPerID"] = this.productInputPerID;
        data["weightPerID"] = this.weightPerID;
        data["stockPerID"] = this.stockPerID;
        data["manualSupplierName"] = this.manualSupplierName;
        data["vatCode"] = this.vatCode;
        data["profileShapeType"] = this.profileShapeType;
        data["profileDimension1"] = this.profileDimension1;
        data["profileDimension2"] = this.profileDimension2;
        data["totalNettWeight"] = this.totalNettWeight;
        data["profileWasteType"] = this.profileWasteType;
        data["profileWasteDimension1"] = this.profileWasteDimension1;
        data["profileWasteDimension2"] = this.profileWasteDimension2;
        data["profileNestQuantity"] = this.profileNestQuantity;
        data["confirmed"] = this.confirmed;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["poLineQuantityInvoiced"] = this.poLineQuantityInvoiced;
        data["poLineUnitCostPrice"] = this.poLineUnitCostPrice;
        data["poLinePerID"] = this.poLinePerID;
        data["poLineDiscountAmount1"] = this.poLineDiscountAmount1;
        data["poLineDiscountAmount2"] = this.poLineDiscountAmount2;
        data["poLineDiscountAmount3"] = this.poLineDiscountAmount3;
        data["poLineDiscountAmount4"] = this.poLineDiscountAmount4;
        data["poLineNumber"] = this.poLineNumber;
        data["purchaseOrderDateRequired"] = this.purchaseOrderDateRequired ? this.purchaseOrderDateRequired.toISOString() : <any>undefined;
        data["purchaseOrderDateExpected"] = this.purchaseOrderDateExpected ? this.purchaseOrderDateExpected.toISOString() : <any>undefined;
        data["purchaseOrderAcknowledged"] = this.purchaseOrderAcknowledged;
        data["poPaymentTermsID"] = this.poPaymentTermsID;
        data["poExchangeRate"] = this.poExchangeRate;
        data["poEstimatedFreightInCurrency"] = this.poEstimatedFreightInCurrency;
        data["poEstimatedMiscInCurrency"] = this.poEstimatedMiscInCurrency;
        data["supplierName"] = this.supplierName;
        data["supplierID"] = this.supplierID;
        data["supplierCode"] = this.supplierCode;
        data["batchRef"] = this.batchRef;
        data["branchName"] = this.branchName;
        data["worksOrderStatus"] = this.worksOrderStatus;
        data["worksOrderStockAllocated"] = this.worksOrderStockAllocated;
        data["worksOrderNumber"] = this.worksOrderNumber;
        data["worksOrderBranchID"] = this.worksOrderBranchID;
        data["worksOrderLineType"] = this.worksOrderLineType;
        data["worksOrderLineProductKitID"] = this.worksOrderLineProductKitID;
        data["workOrderIsNested"] = this.workOrderIsNested;
        data["workOrderIsNestedCutLine"] = this.workOrderIsNestedCutLine;
        data["workOrderLinePackID"] = this.workOrderLinePackID;
        data["workOrderRequiresStock"] = this.workOrderRequiresStock;
        data["kitManufacturedProductFlag"] = this.kitManufacturedProductFlag;
        data["companyNegotiationWarning"] = this.companyNegotiationWarning;
        data["branchNegotiationWarning"] = this.branchNegotiationWarning;
        data["statisticsPerID"] = this.statisticsPerID;
        data["transferOrderID"] = this.transferOrderID;
        data["internalGiftCardNumber"] = this.internalGiftCardNumber;
        data["cashBalanceCustomerID"] = this.cashBalanceCustomerID;
        data["specialSourceAllowSpecialsBasedOnThis"] = this.specialSourceAllowSpecialsBasedOnThis;
        data["priceRuleSettlementDiscNotAllowed"] = this.priceRuleSettlementDiscNotAllowed;
        data["poLineTransferQuantity"] = this.poLineTransferQuantity;
        data["allocatedToStockTransferID"] = this.allocatedToStockTransferID;
        data["totalNetWeight"] = this.totalNetWeight;
        data["unitNettWeight"] = this.unitNettWeight;
        data["originalDirectPoid"] = this.originalDirectPoid;
        data["productActualThickness"] = this.productActualThickness;
        data["productActualWidth"] = this.productActualWidth;
        data["productTaxGroupID"] = this.productTaxGroupID;
        data["productBranchNegotiationWarning"] = this.productBranchNegotiationWarning;
        data["productAlwaysOrderStockBackToBack"] = this.productAlwaysOrderStockBackToBack;
        data["productAllowSettlementDiscount"] = this.productAllowSettlementDiscount;
        data["widthWithWaste"] = this.widthWithWaste;
        data["lengthWithWaste"] = this.lengthWithWaste;
        data["poLineUnitCostInCurrency"] = this.poLineUnitCostInCurrency;
        data["costPriceType"] = this.costPriceType;
        data["sellPriceType"] = this.sellPriceType;
        data["sellPriceTypeID"] = this.sellPriceTypeID;
        data["internalTotalCostPrice"] = this.internalTotalCostPrice;
        data["productThickness"] = this.productThickness;
        data["productWidth"] = this.productWidth;
        data["totalArea"] = this.totalArea;
        data["totalActualWeight"] = this.totalActualWeight;
        data["totalActualVolume"] = this.totalActualVolume;
        data["totalActualArea"] = this.totalActualArea;
        data["hasExternalAVOs"] = this.hasExternalAVOs;
        data["transferLineQuantity"] = this.transferLineQuantity;
        data["receivingStockTransfer"] = this.receivingStockTransfer;
        data["childJustCreatedFromParent"] = this.childJustCreatedFromParent;
        data["totalLengthImperial"] = this.totalLengthImperial;
        data["totalVolumeImperial"] = this.totalVolumeImperial;
        data["totalAreaImperial"] = this.totalAreaImperial;
        data["productTallyLengthsPerID"] = this.productTallyLengthsPerID;
        data["productTallyLengths"] = this.productTallyLengths;
        data["productAvailableWidths"] = this.productAvailableWidths;
        data["forceCalculateTaxEvenIfInvoiced"] = this.forceCalculateTaxEvenIfInvoiced;
        data["generatedFromContractInvoicing"] = this.generatedFromContractInvoicing;
        return data; 
    }
}

export interface IOrderLine {
    orderLineID?: number | undefined;
    orderID?: number | undefined;
    branchID?: number | undefined;
    lineNumber?: number | undefined;
    linkedToLineID?: number | undefined;
    lineType?: number | undefined;
    lineStatus?: number | undefined;
    suggestedOrderBatchLineID?: number | undefined;
    saleType?: number | undefined;
    stockBatchID?: number | undefined;
    stockAllocationID?: number | undefined;
    stockReservationID?: number | undefined;
    productID?: number | undefined;
    productKitID?: number | undefined;
    cuttingOperationID?: number | undefined;
    profileOperationID?: number | undefined;
    worksOrderID?: number | undefined;
    worksOrderLineID?: number | undefined;
    calledOffFromLineID?: number | undefined;
    calledOffFromScheduleID?: number | undefined;
    createdFromOrderLineID?: number | undefined;
    createdFromWorksOrderLineID?: number | undefined;
    createdFromContractInvoicingLineID?: number | undefined;
    manualCode?: string | undefined;
    manualDescription?: string | undefined;
    manualOrderLineTypeID?: number | undefined;
    manualSupplierID?: number | undefined;
    manualSteelGradeID?: number | undefined;
    manualThickness?: number | undefined;
    manualWidth?: number | undefined;
    manualLength?: number | undefined;
    quantity?: number | undefined;
    quantityDisplay?: number | undefined;
    quantityPicked?: number | undefined;
    fullyPicked?: boolean | undefined;
    quantityConfirmed?: number | undefined;
    quantityDelivered?: number | undefined;
    quantityInvoiced?: number | undefined;
    quantityReturned?: number | undefined;
    quantityCredited?: number | undefined;
    quantityBackOrdered?: number | undefined;
    quantityCalledOff?: number | undefined;
    quantityTally?: string | undefined;
    quantityTallyPicked?: string | undefined;
    noOfPieces?: number | undefined;
    inputPerID?: number | undefined;
    displayInputPerID?: number | undefined;
    perID?: number | undefined;
    costPerID?: number | undefined;
    stockPerConversion?: number | undefined;
    statsPerConversion?: number | undefined;
    freeOfCharge?: boolean | undefined;
    unitCostPrice?: number | undefined;
    unitSellPrice?: number | undefined;
    unitSellPriceDisplay?: number | undefined;
    unitWeight?: number | undefined;
    totalCostPrice?: number | undefined;
    transferCostPrice?: number | undefined;
    totalSellPrice?: number | undefined;
    totalVAT?: number | undefined;
    totalTax?: number | undefined;
    retentionAmount?: number | undefined;
    totalMargin?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    pricingType?: number | undefined;
    buyingPrice?: number | undefined;
    sellingPriceRuleID?: number | undefined;
    sellingRulePriority?: number | undefined;
    sellingCalcType?: number | undefined;
    sellingCalcValue?: number | undefined;
    sellingCalcValue2?: number | undefined;
    sellingCalcValue3?: number | undefined;
    sellingPriceBand?: number | undefined;
    sellingPrice?: number | undefined;
    sellingAdjustment?: number | undefined;
    sellingAdjustments?: string | undefined;
    discount1?: number | undefined;
    discountAmount1?: number | undefined;
    discount2?: number | undefined;
    discountAmount2?: number | undefined;
    avoUnitSellPrice?: number | undefined;
    avoCostPrice?: number | undefined;
    avoSellPrice?: number | undefined;
    avoCount?: number | undefined;
    avoQuantity?: number | undefined;
    avoQuantityCompleted?: number | undefined;
    showAVOsInUnitPrice?: boolean | undefined;
    deliveryCostRecovery?: number | undefined;
    deliveryChargeRate?: number | undefined;
    deliveryCharge?: number | undefined;
    deliveryCost?: number | undefined;
    additionalCharge?: number | undefined;
    additionalCost?: number | undefined;
    unitSellPriceInCurrency?: number | undefined;
    totalSellPriceInCurrency?: number | undefined;
    totalVatInCurrency?: number | undefined;
    totalTaxInCurrency?: number | undefined;
    retentionAmountInCurrency?: number | undefined;
    discountAmount1InCurrency?: number | undefined;
    discountAmount2InCurrency?: number | undefined;
    avoUnitSellPriceInCurrency?: number | undefined;
    avoSellPriceInCurrency?: number | undefined;
    vatID?: number | undefined;
    vatRateID?: number | undefined;
    taxGroupID?: number | undefined;
    taxCodes?: string | undefined;
    purchaseAnalysisCodeID?: number | undefined;
    salesAnalysisCodeID?: number | undefined;
    customerRef?: string | undefined;
    notes?: string | undefined;
    specialInstructions?: string | undefined;
    internalNotes?: string | undefined;
    backOrder?: boolean | undefined;
    stockTransferred?: boolean | undefined;
    manufactured?: boolean | undefined;
    specialOrder?: boolean | undefined;
    purchaseOrderID?: number | undefined;
    purchaseOrderQuantity?: number | undefined;
    purchaseOrderQuantityReceived?: number | undefined;
    purchaseOrderInvoiced?: boolean | undefined;
    releaseForProcessing?: boolean | undefined;
    pickingRequired?: boolean | undefined;
    deliveryRequired?: boolean | undefined;
    invoiceID?: number | undefined;
    invoiced?: boolean | undefined;
    pendingActions?: number | undefined;
    manuallyOverriddenTransferCostPrice?: boolean | undefined;
    poLineOverrideThickness?: number | undefined;
    poLineOverrideWidth?: number | undefined;
    poLineOverrideVolume?: number | undefined;
    unitVMICostPrice?: number | undefined;
    totalVMICostPrice?: number | undefined;
    vmiRuleID?: number | undefined;
    lastModifiedReasonID?: number | undefined;
    vmiSupplierInvoiceDocumentID?: number | undefined;
    vmiReconciled?: boolean | undefined;
    transferToProductBatchID?: number | undefined;
    costDiscount1?: number | undefined;
    costDiscountAmount1?: number | undefined;
    costDiscount2?: number | undefined;
    costDiscountAmount2?: number | undefined;
    costDiscount3?: number | undefined;
    costDiscountAmount3?: number | undefined;
    costDiscount4?: number | undefined;
    costDiscountAmount4?: number | undefined;
    unitVMICostInCurrency?: number | undefined;
    totalVMICostInCurrency?: number | undefined;
    vmiExchangeRate?: number | undefined;
    sourceOrderLineID?: number | undefined;
    wmsCartNumber?: string | undefined;
    nonSalesAmount?: number | undefined;
    nonSalesAmountInCurrency?: number | undefined;
    internalCostTotalMargin?: number | undefined;
    wmsParentLineID?: number | undefined;
    cutToLength?: boolean | undefined;
    sellingCalcValue2Type?: number | undefined;
    sellingCalcValue3Type?: number | undefined;
    netPriced?: boolean | undefined;
    wmsUnitNumber?: string | undefined;
    overrideUserID?: number | undefined;
    transferQuantityAllocated?: number | undefined;
    dateExpected?: Date | undefined;
    sellingCalcValue2Method?: number | undefined;
    couponID?: number | undefined;
    usePackPriceSurcharge?: boolean | undefined;
    pointsRedeemed?: number | undefined;
    requiresKitConfiguration?: boolean | undefined;
    manufacturingOptionsXML?: string | undefined;
    isWMSAdditionalCharge?: boolean | undefined;
    quantityTallyCalledOff?: string | undefined;
    quantityFromScale?: number | undefined;
    scaleGrossWeight?: number | undefined;
    grossingRuleQuantity?: number | undefined;
    grossingRuleQuantityTally?: string | undefined;
    branch?: Branch | undefined;
    per?: Per | undefined;
    orderLine1?: OrderLine[] | undefined;
    orderLine2?: OrderLine | undefined;
    per1?: Per | undefined;
    orderLine11?: OrderLine[] | undefined;
    orderLine3?: OrderLine | undefined;
    per2?: Per | undefined;
    product?: Product | undefined;
    supplier?: Supplier | undefined;
    orderLineItems?: OrderLineItem[] | undefined;
    additionalCostCharges?: OrderLineAdditionalCostCharge[] | undefined;
    colAvos?: OrderLineAVO[] | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    perRuleID?: number | undefined;
    productCode?: string | undefined;
    productBarCode?: string | undefined;
    productDescription?: string | undefined;
    thickness?: number | undefined;
    width?: number | undefined;
    length?: number | undefined;
    dimension4?: number | undefined;
    dimension5?: number | undefined;
    imperial?: boolean | undefined;
    tallyLengths?: string | undefined;
    tallyLengthsPerID?: number | undefined;
    availableWidths?: string | undefined;
    lowMarginCollected?: number | undefined;
    lowMarginDelivered?: number | undefined;
    lowMarginDirect?: number | undefined;
    highMargin?: number | undefined;
    allowMultiplePersOnUnitSizes?: boolean | undefined;
    defaultUnitSizePerID?: number | undefined;
    perCode?: string | undefined;
    perName?: string | undefined;
    productKeepStockFigures?: boolean | undefined;
    productStockControlByLength?: boolean | undefined;
    productPickingRequired?: boolean | undefined;
    productAllowDirectSales?: boolean | undefined;
    productAllowCashSales?: boolean | undefined;
    productApplyDeliveryCharges?: boolean | undefined;
    productPromptForQuantity?: boolean | undefined;
    productAllowDescriptionOverride?: number | undefined;
    productAllowPriceNegotiation?: boolean | undefined;
    productAllowCostOverride?: number | undefined;
    productAutoCreateSpecialFromThis?: number | undefined;
    productPriceBookSection?: string | undefined;
    productPriceBookSequence?: number | undefined;
    specialSourceAutoCreateSpecialFromThis?: number | undefined;
    productSpecialSourceID?: number | undefined;
    productSpecial?: boolean | undefined;
    deliveryProductTypeID?: number | undefined;
    productExternalLinkType?: number | undefined;
    productStandardStock?: boolean | undefined;
    productGroupID?: number | undefined;
    materialGradeID?: number | undefined;
    sellTaxGroupID?: number | undefined;
    productVatRuleID?: number | undefined;
    productDefaultPiecesPerPack?: number | undefined;
    productEnvironmentalStatusID?: number | undefined;
    productTimberSurchargeID?: number | undefined;
    sellPriceGroupID?: number | undefined;
    pointsPerAmountSpentCollected?: number | undefined;
    pointsPerAmountSpentDelivered?: number | undefined;
    pointsPerAmountSpentDirect?: number | undefined;
    automaticLineChargeID?: number | undefined;
    automaticLineChargeMultiplier?: number | undefined;
    alwaysOrderStockBackToBack?: boolean | undefined;
    quantityPerInner?: number | undefined;
    quantityPerOuter?: number | undefined;
    quantityPerPallet?: number | undefined;
    quantityPerCube?: number | undefined;
    sellQuantityRoundingOption?: number | undefined;
    deleted?: number | undefined;
    productManufacturerCode?: string | undefined;
    productWidthGrossingRule?: number | undefined;
    productLengthGrossingRule?: number | undefined;
    productStockedByCost?: boolean | undefined;
    productSalesOrderTalliedInputScreen?: number | undefined;
    productPromptForTallyOnSalesOrder?: boolean | undefined;
    productWeight?: number | undefined;
    allowSettlementDiscount?: boolean | undefined;
    cutToLengthStyle?: number | undefined;
    productSellPriceRounding?: number | undefined;
    productSellPriceRoundingOption?: number | undefined;
    productSellPriceRoundingPerID?: number | undefined;
    productApplyRebateAccruals?: boolean | undefined;
    productHowSourced?: number | undefined;
    purchaseAndTransferBranchID?: number | undefined;
    branchAllowSettlementDiscount?: boolean | undefined;
    defaultAllowSettlementDiscount?: boolean | undefined;
    defaultProductHowSourced?: number | undefined;
    defaultPurchaseAndTransferBranchID?: number | undefined;
    productPickingZone?: string | undefined;
    productBinLocation?: string | undefined;
    productBatchTypeID?: number | undefined;
    stockPerCode?: string | undefined;
    productInputPerID?: number | undefined;
    weightPerID?: number | undefined;
    stockPerID?: number | undefined;
    manualSupplierName?: string | undefined;
    vatCode?: string | undefined;
    profileShapeType?: number | undefined;
    profileDimension1?: number | undefined;
    profileDimension2?: number | undefined;
    totalNettWeight?: number | undefined;
    profileWasteType?: number | undefined;
    profileWasteDimension1?: number | undefined;
    profileWasteDimension2?: number | undefined;
    profileNestQuantity?: number | undefined;
    confirmed?: boolean | undefined;
    purchaseOrderNumber?: number | undefined;
    poLineQuantityInvoiced?: number | undefined;
    poLineUnitCostPrice?: number | undefined;
    poLinePerID?: number | undefined;
    poLineDiscountAmount1?: number | undefined;
    poLineDiscountAmount2?: number | undefined;
    poLineDiscountAmount3?: number | undefined;
    poLineDiscountAmount4?: number | undefined;
    poLineNumber?: number | undefined;
    purchaseOrderDateRequired?: Date | undefined;
    purchaseOrderDateExpected?: Date | undefined;
    purchaseOrderAcknowledged?: boolean | undefined;
    poPaymentTermsID?: number | undefined;
    poExchangeRate?: number | undefined;
    poEstimatedFreightInCurrency?: number | undefined;
    poEstimatedMiscInCurrency?: number | undefined;
    supplierName?: string | undefined;
    supplierID?: number | undefined;
    supplierCode?: string | undefined;
    batchRef?: string | undefined;
    branchName?: string | undefined;
    worksOrderStatus?: number | undefined;
    worksOrderStockAllocated?: boolean | undefined;
    worksOrderNumber?: number | undefined;
    worksOrderBranchID?: number | undefined;
    worksOrderLineType?: number | undefined;
    worksOrderLineProductKitID?: number | undefined;
    workOrderIsNested?: boolean | undefined;
    workOrderIsNestedCutLine?: number | undefined;
    workOrderLinePackID?: number | undefined;
    workOrderRequiresStock?: boolean | undefined;
    kitManufacturedProductFlag?: number | undefined;
    companyNegotiationWarning?: string | undefined;
    branchNegotiationWarning?: string | undefined;
    statisticsPerID?: number | undefined;
    transferOrderID?: number | undefined;
    internalGiftCardNumber?: string | undefined;
    cashBalanceCustomerID?: number | undefined;
    specialSourceAllowSpecialsBasedOnThis?: number | undefined;
    priceRuleSettlementDiscNotAllowed?: boolean | undefined;
    poLineTransferQuantity?: number | undefined;
    allocatedToStockTransferID?: number | undefined;
    totalNetWeight?: number | undefined;
    unitNettWeight?: number | undefined;
    originalDirectPoid?: number | undefined;
    productActualThickness?: number | undefined;
    productActualWidth?: number | undefined;
    productTaxGroupID?: number | undefined;
    productBranchNegotiationWarning?: string | undefined;
    productAlwaysOrderStockBackToBack?: boolean | undefined;
    productAllowSettlementDiscount?: boolean | undefined;
    widthWithWaste?: number | undefined;
    lengthWithWaste?: number | undefined;
    poLineUnitCostInCurrency?: number | undefined;
    costPriceType?: number | undefined;
    sellPriceType?: number | undefined;
    sellPriceTypeID?: number | undefined;
    internalTotalCostPrice?: number | undefined;
    productThickness?: number | undefined;
    productWidth?: number | undefined;
    totalArea?: number | undefined;
    totalActualWeight?: number | undefined;
    totalActualVolume?: number | undefined;
    totalActualArea?: number | undefined;
    hasExternalAVOs?: boolean | undefined;
    transferLineQuantity?: number | undefined;
    receivingStockTransfer?: boolean | undefined;
    childJustCreatedFromParent?: boolean | undefined;
    totalLengthImperial?: number | undefined;
    totalVolumeImperial?: number | undefined;
    totalAreaImperial?: number | undefined;
    productTallyLengthsPerID?: number | undefined;
    productTallyLengths?: string | undefined;
    productAvailableWidths?: string | undefined;
    forceCalculateTaxEvenIfInvoiced?: boolean | undefined;
    generatedFromContractInvoicing?: boolean | undefined;
}

export class OrderAdditionalCostCharge implements IOrderAdditionalCostCharge {
    orderAddCostChargeID?: number | undefined;
    deleted?: number | undefined;
    orderID?: number | undefined;
    additionalCostChargeID?: number | undefined;
    supplierID?: number | undefined;
    reference?: string | undefined;
    currencyID?: number | undefined;
    estimateExchangeRate?: number | undefined;
    estimateCost?: number | undefined;
    estimateCostInCurrency?: number | undefined;
    estimatePercentEntered?: number | undefined;
    actualExchangeRate?: number | undefined;
    actualCost?: number | undefined;
    actualCostInCurrency?: number | undefined;
    costPriceValue?: number | undefined;
    costPriceValueType?: number | undefined;
    costProRateBy?: number | undefined;
    actualCharge?: number | undefined;
    chargePriceValue?: number | undefined;
    chargePriceValueType?: number | undefined;
    chargeProRateBy?: number | undefined;
    glCodePayable?: string | undefined;
    notes?: string | undefined;
    dateTimeCreated?: Date | undefined;
    createOverheadPO?: boolean | undefined;
    purchaseOrderID?: number | undefined;
    invoiced?: boolean | undefined;
    autoGenerated?: boolean | undefined;
    createdFromDeliveryID?: number | undefined;
    accountForAccDiff?: number | undefined;
    rebateAccrual?: boolean | undefined;
    description?: string | undefined;
    costCalcUseActualSize?: boolean | undefined;
    chargeCalcUseActualSize?: boolean | undefined;
    costApplyToExternalAVOs?: boolean | undefined;
    costPercentBasedOnSellPrice?: boolean | undefined;
    taxGroupID?: number | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;
    purchaseOrderNumber?: number | undefined;

    constructor(data?: IOrderAdditionalCostCharge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderAddCostChargeID = _data["orderAddCostChargeID"];
            this.deleted = _data["deleted"];
            this.orderID = _data["orderID"];
            this.additionalCostChargeID = _data["additionalCostChargeID"];
            this.supplierID = _data["supplierID"];
            this.reference = _data["reference"];
            this.currencyID = _data["currencyID"];
            this.estimateExchangeRate = _data["estimateExchangeRate"];
            this.estimateCost = _data["estimateCost"];
            this.estimateCostInCurrency = _data["estimateCostInCurrency"];
            this.estimatePercentEntered = _data["estimatePercentEntered"];
            this.actualExchangeRate = _data["actualExchangeRate"];
            this.actualCost = _data["actualCost"];
            this.actualCostInCurrency = _data["actualCostInCurrency"];
            this.costPriceValue = _data["costPriceValue"];
            this.costPriceValueType = _data["costPriceValueType"];
            this.costProRateBy = _data["costProRateBy"];
            this.actualCharge = _data["actualCharge"];
            this.chargePriceValue = _data["chargePriceValue"];
            this.chargePriceValueType = _data["chargePriceValueType"];
            this.chargeProRateBy = _data["chargeProRateBy"];
            this.glCodePayable = _data["glCodePayable"];
            this.notes = _data["notes"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.createOverheadPO = _data["createOverheadPO"];
            this.purchaseOrderID = _data["purchaseOrderID"];
            this.invoiced = _data["invoiced"];
            this.autoGenerated = _data["autoGenerated"];
            this.createdFromDeliveryID = _data["createdFromDeliveryID"];
            this.accountForAccDiff = _data["accountForAccDiff"];
            this.rebateAccrual = _data["rebateAccrual"];
            this.description = _data["description"];
            this.costCalcUseActualSize = _data["costCalcUseActualSize"];
            this.chargeCalcUseActualSize = _data["chargeCalcUseActualSize"];
            this.costApplyToExternalAVOs = _data["costApplyToExternalAVOs"];
            this.costPercentBasedOnSellPrice = _data["costPercentBasedOnSellPrice"];
            this.taxGroupID = _data["taxGroupID"];
            this.supplierCode = _data["supplierCode"];
            this.supplierName = _data["supplierName"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
        }
    }

    static fromJS(data: any): OrderAdditionalCostCharge {
        data = typeof data === 'object' ? data : {};
        let result = new OrderAdditionalCostCharge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderAddCostChargeID"] = this.orderAddCostChargeID;
        data["deleted"] = this.deleted;
        data["orderID"] = this.orderID;
        data["additionalCostChargeID"] = this.additionalCostChargeID;
        data["supplierID"] = this.supplierID;
        data["reference"] = this.reference;
        data["currencyID"] = this.currencyID;
        data["estimateExchangeRate"] = this.estimateExchangeRate;
        data["estimateCost"] = this.estimateCost;
        data["estimateCostInCurrency"] = this.estimateCostInCurrency;
        data["estimatePercentEntered"] = this.estimatePercentEntered;
        data["actualExchangeRate"] = this.actualExchangeRate;
        data["actualCost"] = this.actualCost;
        data["actualCostInCurrency"] = this.actualCostInCurrency;
        data["costPriceValue"] = this.costPriceValue;
        data["costPriceValueType"] = this.costPriceValueType;
        data["costProRateBy"] = this.costProRateBy;
        data["actualCharge"] = this.actualCharge;
        data["chargePriceValue"] = this.chargePriceValue;
        data["chargePriceValueType"] = this.chargePriceValueType;
        data["chargeProRateBy"] = this.chargeProRateBy;
        data["glCodePayable"] = this.glCodePayable;
        data["notes"] = this.notes;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["createOverheadPO"] = this.createOverheadPO;
        data["purchaseOrderID"] = this.purchaseOrderID;
        data["invoiced"] = this.invoiced;
        data["autoGenerated"] = this.autoGenerated;
        data["createdFromDeliveryID"] = this.createdFromDeliveryID;
        data["accountForAccDiff"] = this.accountForAccDiff;
        data["rebateAccrual"] = this.rebateAccrual;
        data["description"] = this.description;
        data["costCalcUseActualSize"] = this.costCalcUseActualSize;
        data["chargeCalcUseActualSize"] = this.chargeCalcUseActualSize;
        data["costApplyToExternalAVOs"] = this.costApplyToExternalAVOs;
        data["costPercentBasedOnSellPrice"] = this.costPercentBasedOnSellPrice;
        data["taxGroupID"] = this.taxGroupID;
        data["supplierCode"] = this.supplierCode;
        data["supplierName"] = this.supplierName;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        return data; 
    }
}

export interface IOrderAdditionalCostCharge {
    orderAddCostChargeID?: number | undefined;
    deleted?: number | undefined;
    orderID?: number | undefined;
    additionalCostChargeID?: number | undefined;
    supplierID?: number | undefined;
    reference?: string | undefined;
    currencyID?: number | undefined;
    estimateExchangeRate?: number | undefined;
    estimateCost?: number | undefined;
    estimateCostInCurrency?: number | undefined;
    estimatePercentEntered?: number | undefined;
    actualExchangeRate?: number | undefined;
    actualCost?: number | undefined;
    actualCostInCurrency?: number | undefined;
    costPriceValue?: number | undefined;
    costPriceValueType?: number | undefined;
    costProRateBy?: number | undefined;
    actualCharge?: number | undefined;
    chargePriceValue?: number | undefined;
    chargePriceValueType?: number | undefined;
    chargeProRateBy?: number | undefined;
    glCodePayable?: string | undefined;
    notes?: string | undefined;
    dateTimeCreated?: Date | undefined;
    createOverheadPO?: boolean | undefined;
    purchaseOrderID?: number | undefined;
    invoiced?: boolean | undefined;
    autoGenerated?: boolean | undefined;
    createdFromDeliveryID?: number | undefined;
    accountForAccDiff?: number | undefined;
    rebateAccrual?: boolean | undefined;
    description?: string | undefined;
    costCalcUseActualSize?: boolean | undefined;
    chargeCalcUseActualSize?: boolean | undefined;
    costApplyToExternalAVOs?: boolean | undefined;
    costPercentBasedOnSellPrice?: boolean | undefined;
    taxGroupID?: number | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;
    purchaseOrderNumber?: number | undefined;
}

export class OrderLineItem implements IOrderLineItem {
    orderLineItemID?: number | undefined;
    orderID?: number | undefined;
    orderLineID?: number | undefined;
    plateID?: number | undefined;
    packID?: number | undefined;
    reelID?: number | undefined;
    reelQuantity?: number | undefined;
    reelPerID?: number | undefined;
    issueEntireReel?: boolean | undefined;
    used?: boolean | undefined;
    productBatchID?: number | undefined;
    productBatchItemID?: number | undefined;
    productBatchQuantity?: number | undefined;
    productBatchQuantityPerID?: number | undefined;
    productBatchQuantityTally?: string | undefined;
    transferToProductBatchID?: number | undefined;
    productBatchUnitCostPrice?: number | undefined;
    productBatchCostPerID?: number | undefined;
    plateNumber?: string | undefined;
    sourcePlateNumber?: string | undefined;
    testCertNumber?: string | undefined;
    pages?: string | undefined;
    productCode?: string | undefined;
    description?: string | undefined;
    reelRef?: string | undefined;
    dateReceived?: Date | undefined;
    stockLocationID?: number | undefined;
    batchStockLocationID?: number | undefined;
    batchReference?: string | undefined;
    batchBinLocation?: string | undefined;
    batchItemReference?: string | undefined;

    constructor(data?: IOrderLineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderLineItemID = _data["orderLineItemID"];
            this.orderID = _data["orderID"];
            this.orderLineID = _data["orderLineID"];
            this.plateID = _data["plateID"];
            this.packID = _data["packID"];
            this.reelID = _data["reelID"];
            this.reelQuantity = _data["reelQuantity"];
            this.reelPerID = _data["reelPerID"];
            this.issueEntireReel = _data["issueEntireReel"];
            this.used = _data["used"];
            this.productBatchID = _data["productBatchID"];
            this.productBatchItemID = _data["productBatchItemID"];
            this.productBatchQuantity = _data["productBatchQuantity"];
            this.productBatchQuantityPerID = _data["productBatchQuantityPerID"];
            this.productBatchQuantityTally = _data["productBatchQuantityTally"];
            this.transferToProductBatchID = _data["transferToProductBatchID"];
            this.productBatchUnitCostPrice = _data["productBatchUnitCostPrice"];
            this.productBatchCostPerID = _data["productBatchCostPerID"];
            this.plateNumber = _data["plateNumber"];
            this.sourcePlateNumber = _data["sourcePlateNumber"];
            this.testCertNumber = _data["testCertNumber"];
            this.pages = _data["pages"];
            this.productCode = _data["productCode"];
            this.description = _data["description"];
            this.reelRef = _data["reelRef"];
            this.dateReceived = _data["dateReceived"] ? new Date(_data["dateReceived"].toString()) : <any>undefined;
            this.stockLocationID = _data["stockLocationID"];
            this.batchStockLocationID = _data["batchStockLocationID"];
            this.batchReference = _data["batchReference"];
            this.batchBinLocation = _data["batchBinLocation"];
            this.batchItemReference = _data["batchItemReference"];
        }
    }

    static fromJS(data: any): OrderLineItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderLineItemID"] = this.orderLineItemID;
        data["orderID"] = this.orderID;
        data["orderLineID"] = this.orderLineID;
        data["plateID"] = this.plateID;
        data["packID"] = this.packID;
        data["reelID"] = this.reelID;
        data["reelQuantity"] = this.reelQuantity;
        data["reelPerID"] = this.reelPerID;
        data["issueEntireReel"] = this.issueEntireReel;
        data["used"] = this.used;
        data["productBatchID"] = this.productBatchID;
        data["productBatchItemID"] = this.productBatchItemID;
        data["productBatchQuantity"] = this.productBatchQuantity;
        data["productBatchQuantityPerID"] = this.productBatchQuantityPerID;
        data["productBatchQuantityTally"] = this.productBatchQuantityTally;
        data["transferToProductBatchID"] = this.transferToProductBatchID;
        data["productBatchUnitCostPrice"] = this.productBatchUnitCostPrice;
        data["productBatchCostPerID"] = this.productBatchCostPerID;
        data["plateNumber"] = this.plateNumber;
        data["sourcePlateNumber"] = this.sourcePlateNumber;
        data["testCertNumber"] = this.testCertNumber;
        data["pages"] = this.pages;
        data["productCode"] = this.productCode;
        data["description"] = this.description;
        data["reelRef"] = this.reelRef;
        data["dateReceived"] = this.dateReceived ? this.dateReceived.toISOString() : <any>undefined;
        data["stockLocationID"] = this.stockLocationID;
        data["batchStockLocationID"] = this.batchStockLocationID;
        data["batchReference"] = this.batchReference;
        data["batchBinLocation"] = this.batchBinLocation;
        data["batchItemReference"] = this.batchItemReference;
        return data; 
    }
}

export interface IOrderLineItem {
    orderLineItemID?: number | undefined;
    orderID?: number | undefined;
    orderLineID?: number | undefined;
    plateID?: number | undefined;
    packID?: number | undefined;
    reelID?: number | undefined;
    reelQuantity?: number | undefined;
    reelPerID?: number | undefined;
    issueEntireReel?: boolean | undefined;
    used?: boolean | undefined;
    productBatchID?: number | undefined;
    productBatchItemID?: number | undefined;
    productBatchQuantity?: number | undefined;
    productBatchQuantityPerID?: number | undefined;
    productBatchQuantityTally?: string | undefined;
    transferToProductBatchID?: number | undefined;
    productBatchUnitCostPrice?: number | undefined;
    productBatchCostPerID?: number | undefined;
    plateNumber?: string | undefined;
    sourcePlateNumber?: string | undefined;
    testCertNumber?: string | undefined;
    pages?: string | undefined;
    productCode?: string | undefined;
    description?: string | undefined;
    reelRef?: string | undefined;
    dateReceived?: Date | undefined;
    stockLocationID?: number | undefined;
    batchStockLocationID?: number | undefined;
    batchReference?: string | undefined;
    batchBinLocation?: string | undefined;
    batchItemReference?: string | undefined;
}

export class PickingNoteHeader implements IPickingNoteHeader {
    pickingNoteID?: number | undefined;
    pickingNoteNumber?: number | undefined;
    orderID?: number | undefined;
    pickedBy?: string | undefined;
    dateTimeCreated?: Date | undefined;
    dateTimeLastModified?: Date | undefined;
    notes?: string | undefined;
    totalWeight?: number | undefined;
    totalVolume?: number | undefined;
    maximumWidth?: number | undefined;
    maximumLength?: number | undefined;
    fullyConfirmed?: boolean | undefined;
    fullyDelivered?: boolean | undefined;
    journeyID?: number | undefined;
    journeyHeader?: JourneyHeader | undefined;
    journeyLines?: JourneyLine[] | undefined;
    orderHeader?: OrderHeader | undefined;
    dateRequiredOption?: number | undefined;
    deliveryAreaID?: number | undefined;
    customerName?: string | undefined;
    customerPaymentTermsID?: number | undefined;
    availableCredit?: number | undefined;
    agedBalance1?: number | undefined;
    agedBalance5?: number | undefined;
    deliveryAreaName?: string | undefined;
    orderType?: number | undefined;
    deliveryCity?: string | undefined;
    orderNotes?: string | undefined;
    orderNumber?: number | undefined;
    deliveryAddress?: string | undefined;
    specialInstructions?: string | undefined;
    agedBalance2?: number | undefined;
    agedBalance6?: number | undefined;
    agedBalance3?: number | undefined;
    agedBalance7?: number | undefined;
    customerOnHold?: boolean | undefined;
    saleType?: number | undefined;
    agedBalance?: number | undefined;
    hasOverdueInvoic?: boolean | undefined;
    toBranchName?: string | undefined;
    branchID?: number | undefined;
    customerID?: number | undefined;
    branchName?: string | undefined;
    toBranchID?: number | undefined;
    customerCreditControlStatusID?: number | undefined;
    dateRequired?: Date | undefined;

    constructor(data?: IPickingNoteHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pickingNoteID = _data["pickingNoteID"];
            this.pickingNoteNumber = _data["pickingNoteNumber"];
            this.orderID = _data["orderID"];
            this.pickedBy = _data["pickedBy"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.dateTimeLastModified = _data["dateTimeLastModified"] ? new Date(_data["dateTimeLastModified"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.totalWeight = _data["totalWeight"];
            this.totalVolume = _data["totalVolume"];
            this.maximumWidth = _data["maximumWidth"];
            this.maximumLength = _data["maximumLength"];
            this.fullyConfirmed = _data["fullyConfirmed"];
            this.fullyDelivered = _data["fullyDelivered"];
            this.journeyID = _data["journeyID"];
            this.journeyHeader = _data["journeyHeader"] ? JourneyHeader.fromJS(_data["journeyHeader"]) : <any>undefined;
            if (Array.isArray(_data["journeyLines"])) {
                this.journeyLines = [] as any;
                for (let item of _data["journeyLines"])
                    this.journeyLines!.push(JourneyLine.fromJS(item));
            }
            this.orderHeader = _data["orderHeader"] ? OrderHeader.fromJS(_data["orderHeader"]) : <any>undefined;
            this.dateRequiredOption = _data["dateRequiredOption"];
            this.deliveryAreaID = _data["deliveryAreaID"];
            this.customerName = _data["customerName"];
            this.customerPaymentTermsID = _data["customerPaymentTermsID"];
            this.availableCredit = _data["availableCredit"];
            this.agedBalance1 = _data["agedBalance1"];
            this.agedBalance5 = _data["agedBalance5"];
            this.deliveryAreaName = _data["deliveryAreaName"];
            this.orderType = _data["orderType"];
            this.deliveryCity = _data["deliveryCity"];
            this.orderNotes = _data["orderNotes"];
            this.orderNumber = _data["orderNumber"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.specialInstructions = _data["specialInstructions"];
            this.agedBalance2 = _data["agedBalance2"];
            this.agedBalance6 = _data["agedBalance6"];
            this.agedBalance3 = _data["agedBalance3"];
            this.agedBalance7 = _data["agedBalance7"];
            this.customerOnHold = _data["customerOnHold"];
            this.saleType = _data["saleType"];
            this.agedBalance = _data["agedBalance"];
            this.hasOverdueInvoic = _data["hasOverdueInvoic"];
            this.toBranchName = _data["toBranchName"];
            this.branchID = _data["branchID"];
            this.customerID = _data["customerID"];
            this.branchName = _data["branchName"];
            this.toBranchID = _data["toBranchID"];
            this.customerCreditControlStatusID = _data["customerCreditControlStatusID"];
            this.dateRequired = _data["dateRequired"] ? new Date(_data["dateRequired"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PickingNoteHeader {
        data = typeof data === 'object' ? data : {};
        let result = new PickingNoteHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pickingNoteID"] = this.pickingNoteID;
        data["pickingNoteNumber"] = this.pickingNoteNumber;
        data["orderID"] = this.orderID;
        data["pickedBy"] = this.pickedBy;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["dateTimeLastModified"] = this.dateTimeLastModified ? this.dateTimeLastModified.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["totalWeight"] = this.totalWeight;
        data["totalVolume"] = this.totalVolume;
        data["maximumWidth"] = this.maximumWidth;
        data["maximumLength"] = this.maximumLength;
        data["fullyConfirmed"] = this.fullyConfirmed;
        data["fullyDelivered"] = this.fullyDelivered;
        data["journeyID"] = this.journeyID;
        data["journeyHeader"] = this.journeyHeader ? this.journeyHeader.toJSON() : <any>undefined;
        if (Array.isArray(this.journeyLines)) {
            data["journeyLines"] = [];
            for (let item of this.journeyLines)
                data["journeyLines"].push(item.toJSON());
        }
        data["orderHeader"] = this.orderHeader ? this.orderHeader.toJSON() : <any>undefined;
        data["dateRequiredOption"] = this.dateRequiredOption;
        data["deliveryAreaID"] = this.deliveryAreaID;
        data["customerName"] = this.customerName;
        data["customerPaymentTermsID"] = this.customerPaymentTermsID;
        data["availableCredit"] = this.availableCredit;
        data["agedBalance1"] = this.agedBalance1;
        data["agedBalance5"] = this.agedBalance5;
        data["deliveryAreaName"] = this.deliveryAreaName;
        data["orderType"] = this.orderType;
        data["deliveryCity"] = this.deliveryCity;
        data["orderNotes"] = this.orderNotes;
        data["orderNumber"] = this.orderNumber;
        data["deliveryAddress"] = this.deliveryAddress;
        data["specialInstructions"] = this.specialInstructions;
        data["agedBalance2"] = this.agedBalance2;
        data["agedBalance6"] = this.agedBalance6;
        data["agedBalance3"] = this.agedBalance3;
        data["agedBalance7"] = this.agedBalance7;
        data["customerOnHold"] = this.customerOnHold;
        data["saleType"] = this.saleType;
        data["agedBalance"] = this.agedBalance;
        data["hasOverdueInvoic"] = this.hasOverdueInvoic;
        data["toBranchName"] = this.toBranchName;
        data["branchID"] = this.branchID;
        data["customerID"] = this.customerID;
        data["branchName"] = this.branchName;
        data["toBranchID"] = this.toBranchID;
        data["customerCreditControlStatusID"] = this.customerCreditControlStatusID;
        data["dateRequired"] = this.dateRequired ? this.dateRequired.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IPickingNoteHeader {
    pickingNoteID?: number | undefined;
    pickingNoteNumber?: number | undefined;
    orderID?: number | undefined;
    pickedBy?: string | undefined;
    dateTimeCreated?: Date | undefined;
    dateTimeLastModified?: Date | undefined;
    notes?: string | undefined;
    totalWeight?: number | undefined;
    totalVolume?: number | undefined;
    maximumWidth?: number | undefined;
    maximumLength?: number | undefined;
    fullyConfirmed?: boolean | undefined;
    fullyDelivered?: boolean | undefined;
    journeyID?: number | undefined;
    journeyHeader?: JourneyHeader | undefined;
    journeyLines?: JourneyLine[] | undefined;
    orderHeader?: OrderHeader | undefined;
    dateRequiredOption?: number | undefined;
    deliveryAreaID?: number | undefined;
    customerName?: string | undefined;
    customerPaymentTermsID?: number | undefined;
    availableCredit?: number | undefined;
    agedBalance1?: number | undefined;
    agedBalance5?: number | undefined;
    deliveryAreaName?: string | undefined;
    orderType?: number | undefined;
    deliveryCity?: string | undefined;
    orderNotes?: string | undefined;
    orderNumber?: number | undefined;
    deliveryAddress?: string | undefined;
    specialInstructions?: string | undefined;
    agedBalance2?: number | undefined;
    agedBalance6?: number | undefined;
    agedBalance3?: number | undefined;
    agedBalance7?: number | undefined;
    customerOnHold?: boolean | undefined;
    saleType?: number | undefined;
    agedBalance?: number | undefined;
    hasOverdueInvoic?: boolean | undefined;
    toBranchName?: string | undefined;
    branchID?: number | undefined;
    customerID?: number | undefined;
    branchName?: string | undefined;
    toBranchID?: number | undefined;
    customerCreditControlStatusID?: number | undefined;
    dateRequired?: Date | undefined;
}

export class PickingNoteLine implements IPickingNoteLine {
    pickingNoteLineID?: number | undefined;
    pickingNoteID?: number | undefined;
    orderID?: number | undefined;
    orderLineID?: number | undefined;
    productID?: number | undefined;
    quantityPicked?: number | undefined;
    quantityConfirmed?: number | undefined;
    quantityDelivered?: number | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    stockInfo?: string | undefined;
    profileOperationID?: number | undefined;
    cuttingOperationID?: number | undefined;
    saleType?: number | undefined;
    manualCode?: string | undefined;
    lineType?: number | undefined;
    manualDescription?: string | undefined;
    orderLineQuantity?: number | undefined;
    orderLineQuantityPicked?: number | undefined;
    orderLineFullyPicked?: boolean | undefined;
    orderLineQuantityConfirmed?: number | undefined;
    orderLineQuantityDelivered?: number | undefined;
    orderLineQuantityTally?: string | undefined;
    orderLineInputPerID?: number | undefined;
    unitWeight?: number | undefined;
    avoCount?: number | undefined;
    notes?: string | undefined;
    avoQuantity?: number | undefined;
    avoQuantityCompleted?: number | undefined;
    orderLinePickingRequired?: boolean | undefined;
    orderLineDeliveryRequired?: boolean | undefined;
    orderLineNumber?: number | undefined;
    orderLineTotalVolume?: number | undefined;
    orderLineTotalWeight?: number | undefined;
    orderLineTotalLength?: number | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    productCode?: string | undefined;
    productThickness?: number | undefined;
    productImperial?: boolean | undefined;
    productStockControlByLength?: boolean | undefined;
    stockActual?: number | undefined;
    stockAvailable?: number | undefined;
    quantity?: number | undefined;
    profileSteelGradeID?: number | undefined;
    profileShapeType?: number | undefined;
    profileTotalNettWeight?: number | undefined;
    productWidth?: number | undefined;
    productTallyLengths?: number | undefined;
    productLength?: number | undefined;
    productTallyLengthsPerID?: number | undefined;
    stockOnOrder?: number | undefined;
    stockDue?: number | undefined;
    stockAllocated?: number | undefined;
    cuttingOperationComplete?: number | undefined;
    profileThickness?: number | undefined;
    profileDimension1?: number | undefined;
    profileTotalGrossWeight?: number | undefined;
    profileDimension2?: number | undefined;
    productWeight?: number | undefined;
    productAvailableWidths?: string | undefined;

    constructor(data?: IPickingNoteLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pickingNoteLineID = _data["pickingNoteLineID"];
            this.pickingNoteID = _data["pickingNoteID"];
            this.orderID = _data["orderID"];
            this.orderLineID = _data["orderLineID"];
            this.productID = _data["productID"];
            this.quantityPicked = _data["quantityPicked"];
            this.quantityConfirmed = _data["quantityConfirmed"];
            this.quantityDelivered = _data["quantityDelivered"];
            this.quantityTally = _data["quantityTally"];
            this.noOfPieces = _data["noOfPieces"];
            this.totalWeight = _data["totalWeight"];
            this.totalLength = _data["totalLength"];
            this.totalVolume = _data["totalVolume"];
            this.stockInfo = _data["stockInfo"];
            this.profileOperationID = _data["profileOperationID"];
            this.cuttingOperationID = _data["cuttingOperationID"];
            this.saleType = _data["saleType"];
            this.manualCode = _data["manualCode"];
            this.lineType = _data["lineType"];
            this.manualDescription = _data["manualDescription"];
            this.orderLineQuantity = _data["orderLineQuantity"];
            this.orderLineQuantityPicked = _data["orderLineQuantityPicked"];
            this.orderLineFullyPicked = _data["orderLineFullyPicked"];
            this.orderLineQuantityConfirmed = _data["orderLineQuantityConfirmed"];
            this.orderLineQuantityDelivered = _data["orderLineQuantityDelivered"];
            this.orderLineQuantityTally = _data["orderLineQuantityTally"];
            this.orderLineInputPerID = _data["orderLineInputPerID"];
            this.unitWeight = _data["unitWeight"];
            this.avoCount = _data["avoCount"];
            this.notes = _data["notes"];
            this.avoQuantity = _data["avoQuantity"];
            this.avoQuantityCompleted = _data["avoQuantityCompleted"];
            this.orderLinePickingRequired = _data["orderLinePickingRequired"];
            this.orderLineDeliveryRequired = _data["orderLineDeliveryRequired"];
            this.orderLineNumber = _data["orderLineNumber"];
            this.orderLineTotalVolume = _data["orderLineTotalVolume"];
            this.orderLineTotalWeight = _data["orderLineTotalWeight"];
            this.orderLineTotalLength = _data["orderLineTotalLength"];
            this.productType = _data["productType"];
            this.productSubType = _data["productSubType"];
            this.productCode = _data["productCode"];
            this.productThickness = _data["productThickness"];
            this.productImperial = _data["productImperial"];
            this.productStockControlByLength = _data["productStockControlByLength"];
            this.stockActual = _data["stockActual"];
            this.stockAvailable = _data["stockAvailable"];
            this.quantity = _data["quantity"];
            this.profileSteelGradeID = _data["profileSteelGradeID"];
            this.profileShapeType = _data["profileShapeType"];
            this.profileTotalNettWeight = _data["profileTotalNettWeight"];
            this.productWidth = _data["productWidth"];
            this.productTallyLengths = _data["productTallyLengths"];
            this.productLength = _data["productLength"];
            this.productTallyLengthsPerID = _data["productTallyLengthsPerID"];
            this.stockOnOrder = _data["stockOnOrder"];
            this.stockDue = _data["stockDue"];
            this.stockAllocated = _data["stockAllocated"];
            this.cuttingOperationComplete = _data["cuttingOperationComplete"];
            this.profileThickness = _data["profileThickness"];
            this.profileDimension1 = _data["profileDimension1"];
            this.profileTotalGrossWeight = _data["profileTotalGrossWeight"];
            this.profileDimension2 = _data["profileDimension2"];
            this.productWeight = _data["productWeight"];
            this.productAvailableWidths = _data["productAvailableWidths"];
        }
    }

    static fromJS(data: any): PickingNoteLine {
        data = typeof data === 'object' ? data : {};
        let result = new PickingNoteLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pickingNoteLineID"] = this.pickingNoteLineID;
        data["pickingNoteID"] = this.pickingNoteID;
        data["orderID"] = this.orderID;
        data["orderLineID"] = this.orderLineID;
        data["productID"] = this.productID;
        data["quantityPicked"] = this.quantityPicked;
        data["quantityConfirmed"] = this.quantityConfirmed;
        data["quantityDelivered"] = this.quantityDelivered;
        data["quantityTally"] = this.quantityTally;
        data["noOfPieces"] = this.noOfPieces;
        data["totalWeight"] = this.totalWeight;
        data["totalLength"] = this.totalLength;
        data["totalVolume"] = this.totalVolume;
        data["stockInfo"] = this.stockInfo;
        data["profileOperationID"] = this.profileOperationID;
        data["cuttingOperationID"] = this.cuttingOperationID;
        data["saleType"] = this.saleType;
        data["manualCode"] = this.manualCode;
        data["lineType"] = this.lineType;
        data["manualDescription"] = this.manualDescription;
        data["orderLineQuantity"] = this.orderLineQuantity;
        data["orderLineQuantityPicked"] = this.orderLineQuantityPicked;
        data["orderLineFullyPicked"] = this.orderLineFullyPicked;
        data["orderLineQuantityConfirmed"] = this.orderLineQuantityConfirmed;
        data["orderLineQuantityDelivered"] = this.orderLineQuantityDelivered;
        data["orderLineQuantityTally"] = this.orderLineQuantityTally;
        data["orderLineInputPerID"] = this.orderLineInputPerID;
        data["unitWeight"] = this.unitWeight;
        data["avoCount"] = this.avoCount;
        data["notes"] = this.notes;
        data["avoQuantity"] = this.avoQuantity;
        data["avoQuantityCompleted"] = this.avoQuantityCompleted;
        data["orderLinePickingRequired"] = this.orderLinePickingRequired;
        data["orderLineDeliveryRequired"] = this.orderLineDeliveryRequired;
        data["orderLineNumber"] = this.orderLineNumber;
        data["orderLineTotalVolume"] = this.orderLineTotalVolume;
        data["orderLineTotalWeight"] = this.orderLineTotalWeight;
        data["orderLineTotalLength"] = this.orderLineTotalLength;
        data["productType"] = this.productType;
        data["productSubType"] = this.productSubType;
        data["productCode"] = this.productCode;
        data["productThickness"] = this.productThickness;
        data["productImperial"] = this.productImperial;
        data["productStockControlByLength"] = this.productStockControlByLength;
        data["stockActual"] = this.stockActual;
        data["stockAvailable"] = this.stockAvailable;
        data["quantity"] = this.quantity;
        data["profileSteelGradeID"] = this.profileSteelGradeID;
        data["profileShapeType"] = this.profileShapeType;
        data["profileTotalNettWeight"] = this.profileTotalNettWeight;
        data["productWidth"] = this.productWidth;
        data["productTallyLengths"] = this.productTallyLengths;
        data["productLength"] = this.productLength;
        data["productTallyLengthsPerID"] = this.productTallyLengthsPerID;
        data["stockOnOrder"] = this.stockOnOrder;
        data["stockDue"] = this.stockDue;
        data["stockAllocated"] = this.stockAllocated;
        data["cuttingOperationComplete"] = this.cuttingOperationComplete;
        data["profileThickness"] = this.profileThickness;
        data["profileDimension1"] = this.profileDimension1;
        data["profileTotalGrossWeight"] = this.profileTotalGrossWeight;
        data["profileDimension2"] = this.profileDimension2;
        data["productWeight"] = this.productWeight;
        data["productAvailableWidths"] = this.productAvailableWidths;
        return data; 
    }
}

export interface IPickingNoteLine {
    pickingNoteLineID?: number | undefined;
    pickingNoteID?: number | undefined;
    orderID?: number | undefined;
    orderLineID?: number | undefined;
    productID?: number | undefined;
    quantityPicked?: number | undefined;
    quantityConfirmed?: number | undefined;
    quantityDelivered?: number | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    stockInfo?: string | undefined;
    profileOperationID?: number | undefined;
    cuttingOperationID?: number | undefined;
    saleType?: number | undefined;
    manualCode?: string | undefined;
    lineType?: number | undefined;
    manualDescription?: string | undefined;
    orderLineQuantity?: number | undefined;
    orderLineQuantityPicked?: number | undefined;
    orderLineFullyPicked?: boolean | undefined;
    orderLineQuantityConfirmed?: number | undefined;
    orderLineQuantityDelivered?: number | undefined;
    orderLineQuantityTally?: string | undefined;
    orderLineInputPerID?: number | undefined;
    unitWeight?: number | undefined;
    avoCount?: number | undefined;
    notes?: string | undefined;
    avoQuantity?: number | undefined;
    avoQuantityCompleted?: number | undefined;
    orderLinePickingRequired?: boolean | undefined;
    orderLineDeliveryRequired?: boolean | undefined;
    orderLineNumber?: number | undefined;
    orderLineTotalVolume?: number | undefined;
    orderLineTotalWeight?: number | undefined;
    orderLineTotalLength?: number | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    productCode?: string | undefined;
    productThickness?: number | undefined;
    productImperial?: boolean | undefined;
    productStockControlByLength?: boolean | undefined;
    stockActual?: number | undefined;
    stockAvailable?: number | undefined;
    quantity?: number | undefined;
    profileSteelGradeID?: number | undefined;
    profileShapeType?: number | undefined;
    profileTotalNettWeight?: number | undefined;
    productWidth?: number | undefined;
    productTallyLengths?: number | undefined;
    productLength?: number | undefined;
    productTallyLengthsPerID?: number | undefined;
    stockOnOrder?: number | undefined;
    stockDue?: number | undefined;
    stockAllocated?: number | undefined;
    cuttingOperationComplete?: number | undefined;
    profileThickness?: number | undefined;
    profileDimension1?: number | undefined;
    profileTotalGrossWeight?: number | undefined;
    profileDimension2?: number | undefined;
    productWeight?: number | undefined;
    productAvailableWidths?: string | undefined;
}

export class DeliveryNoteHeader implements IDeliveryNoteHeader {
    deliveryNoteID?: number | undefined;
    deliveryNoteNumber?: number | undefined;
    collectionNote?: boolean | undefined;
    pickingNoteID?: number | undefined;
    orderID?: number | undefined;
    deliveryDate?: Date | undefined;
    deliveryAddressID?: number | undefined;
    deliveryAddress?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryAreaID?: number | undefined;
    transportType?: number | undefined;
    transportDetails?: string | undefined;
    supplierID?: number | undefined;
    notes?: string | undefined;
    dateTimeCreated?: Date | undefined;
    dateTimeLastModified?: Date | undefined;
    totalWeight?: number | undefined;
    totalVolume?: number | undefined;
    cashOnDeliveryAmount?: number | undefined;
    cashOnDeliveryReceived?: number | undefined;
    cashOnDeliveryPrepaid?: number | undefined;
    maximumWidth?: number | undefined;
    maximumLength?: number | undefined;
    provisionalTotalAmount?: number | undefined;
    provisionalVatAmount?: number | undefined;
    provisionalTotalCost?: number | undefined;
    invoiceID?: number | undefined;
    invoiced?: boolean | undefined;
    journeyID?: number | undefined;
    selfBilled?: boolean | undefined;
    dateTimeTransferred?: Date | undefined;
    customerAddress?: CustomerAddress | undefined;
    deliveryArea?: DeliveryArea | undefined;
    journeyHeader?: JourneyHeader | undefined;
    orderHeader?: OrderHeader | undefined;
    pickingNoteHeader?: PickingNoteHeader | undefined;
    supplier?: Supplier | undefined;
    branchID?: number | undefined;
    hasLinesWithSteelProducts?: boolean | undefined;
    hasLinesWithTestCerts?: boolean | undefined;

    constructor(data?: IDeliveryNoteHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryNoteID = _data["deliveryNoteID"];
            this.deliveryNoteNumber = _data["deliveryNoteNumber"];
            this.collectionNote = _data["collectionNote"];
            this.pickingNoteID = _data["pickingNoteID"];
            this.orderID = _data["orderID"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.deliveryAddressID = _data["deliveryAddressID"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.deliveryCity = _data["deliveryCity"];
            this.deliveryAreaID = _data["deliveryAreaID"];
            this.transportType = _data["transportType"];
            this.transportDetails = _data["transportDetails"];
            this.supplierID = _data["supplierID"];
            this.notes = _data["notes"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.dateTimeLastModified = _data["dateTimeLastModified"] ? new Date(_data["dateTimeLastModified"].toString()) : <any>undefined;
            this.totalWeight = _data["totalWeight"];
            this.totalVolume = _data["totalVolume"];
            this.cashOnDeliveryAmount = _data["cashOnDeliveryAmount"];
            this.cashOnDeliveryReceived = _data["cashOnDeliveryReceived"];
            this.cashOnDeliveryPrepaid = _data["cashOnDeliveryPrepaid"];
            this.maximumWidth = _data["maximumWidth"];
            this.maximumLength = _data["maximumLength"];
            this.provisionalTotalAmount = _data["provisionalTotalAmount"];
            this.provisionalVatAmount = _data["provisionalVatAmount"];
            this.provisionalTotalCost = _data["provisionalTotalCost"];
            this.invoiceID = _data["invoiceID"];
            this.invoiced = _data["invoiced"];
            this.journeyID = _data["journeyID"];
            this.selfBilled = _data["selfBilled"];
            this.dateTimeTransferred = _data["dateTimeTransferred"] ? new Date(_data["dateTimeTransferred"].toString()) : <any>undefined;
            this.customerAddress = _data["customerAddress"] ? CustomerAddress.fromJS(_data["customerAddress"]) : <any>undefined;
            this.deliveryArea = _data["deliveryArea"] ? DeliveryArea.fromJS(_data["deliveryArea"]) : <any>undefined;
            this.journeyHeader = _data["journeyHeader"] ? JourneyHeader.fromJS(_data["journeyHeader"]) : <any>undefined;
            this.orderHeader = _data["orderHeader"] ? OrderHeader.fromJS(_data["orderHeader"]) : <any>undefined;
            this.pickingNoteHeader = _data["pickingNoteHeader"] ? PickingNoteHeader.fromJS(_data["pickingNoteHeader"]) : <any>undefined;
            this.supplier = _data["supplier"] ? Supplier.fromJS(_data["supplier"]) : <any>undefined;
            this.branchID = _data["branchID"];
            this.hasLinesWithSteelProducts = _data["hasLinesWithSteelProducts"];
            this.hasLinesWithTestCerts = _data["hasLinesWithTestCerts"];
        }
    }

    static fromJS(data: any): DeliveryNoteHeader {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryNoteHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryNoteID"] = this.deliveryNoteID;
        data["deliveryNoteNumber"] = this.deliveryNoteNumber;
        data["collectionNote"] = this.collectionNote;
        data["pickingNoteID"] = this.pickingNoteID;
        data["orderID"] = this.orderID;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["deliveryAddressID"] = this.deliveryAddressID;
        data["deliveryAddress"] = this.deliveryAddress;
        data["deliveryCity"] = this.deliveryCity;
        data["deliveryAreaID"] = this.deliveryAreaID;
        data["transportType"] = this.transportType;
        data["transportDetails"] = this.transportDetails;
        data["supplierID"] = this.supplierID;
        data["notes"] = this.notes;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["dateTimeLastModified"] = this.dateTimeLastModified ? this.dateTimeLastModified.toISOString() : <any>undefined;
        data["totalWeight"] = this.totalWeight;
        data["totalVolume"] = this.totalVolume;
        data["cashOnDeliveryAmount"] = this.cashOnDeliveryAmount;
        data["cashOnDeliveryReceived"] = this.cashOnDeliveryReceived;
        data["cashOnDeliveryPrepaid"] = this.cashOnDeliveryPrepaid;
        data["maximumWidth"] = this.maximumWidth;
        data["maximumLength"] = this.maximumLength;
        data["provisionalTotalAmount"] = this.provisionalTotalAmount;
        data["provisionalVatAmount"] = this.provisionalVatAmount;
        data["provisionalTotalCost"] = this.provisionalTotalCost;
        data["invoiceID"] = this.invoiceID;
        data["invoiced"] = this.invoiced;
        data["journeyID"] = this.journeyID;
        data["selfBilled"] = this.selfBilled;
        data["dateTimeTransferred"] = this.dateTimeTransferred ? this.dateTimeTransferred.toISOString() : <any>undefined;
        data["customerAddress"] = this.customerAddress ? this.customerAddress.toJSON() : <any>undefined;
        data["deliveryArea"] = this.deliveryArea ? this.deliveryArea.toJSON() : <any>undefined;
        data["journeyHeader"] = this.journeyHeader ? this.journeyHeader.toJSON() : <any>undefined;
        data["orderHeader"] = this.orderHeader ? this.orderHeader.toJSON() : <any>undefined;
        data["pickingNoteHeader"] = this.pickingNoteHeader ? this.pickingNoteHeader.toJSON() : <any>undefined;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : <any>undefined;
        data["branchID"] = this.branchID;
        data["hasLinesWithSteelProducts"] = this.hasLinesWithSteelProducts;
        data["hasLinesWithTestCerts"] = this.hasLinesWithTestCerts;
        return data; 
    }
}

export interface IDeliveryNoteHeader {
    deliveryNoteID?: number | undefined;
    deliveryNoteNumber?: number | undefined;
    collectionNote?: boolean | undefined;
    pickingNoteID?: number | undefined;
    orderID?: number | undefined;
    deliveryDate?: Date | undefined;
    deliveryAddressID?: number | undefined;
    deliveryAddress?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryAreaID?: number | undefined;
    transportType?: number | undefined;
    transportDetails?: string | undefined;
    supplierID?: number | undefined;
    notes?: string | undefined;
    dateTimeCreated?: Date | undefined;
    dateTimeLastModified?: Date | undefined;
    totalWeight?: number | undefined;
    totalVolume?: number | undefined;
    cashOnDeliveryAmount?: number | undefined;
    cashOnDeliveryReceived?: number | undefined;
    cashOnDeliveryPrepaid?: number | undefined;
    maximumWidth?: number | undefined;
    maximumLength?: number | undefined;
    provisionalTotalAmount?: number | undefined;
    provisionalVatAmount?: number | undefined;
    provisionalTotalCost?: number | undefined;
    invoiceID?: number | undefined;
    invoiced?: boolean | undefined;
    journeyID?: number | undefined;
    selfBilled?: boolean | undefined;
    dateTimeTransferred?: Date | undefined;
    customerAddress?: CustomerAddress | undefined;
    deliveryArea?: DeliveryArea | undefined;
    journeyHeader?: JourneyHeader | undefined;
    orderHeader?: OrderHeader | undefined;
    pickingNoteHeader?: PickingNoteHeader | undefined;
    supplier?: Supplier | undefined;
    branchID?: number | undefined;
    hasLinesWithSteelProducts?: boolean | undefined;
    hasLinesWithTestCerts?: boolean | undefined;
}

export class DeliveryNoteLine implements IDeliveryNoteLine {
    productType?: number | undefined;
    deliveryNoteLineID?: number | undefined;
    deliveryNoteID?: number | undefined;
    pickingNoteID?: number | undefined;
    pickingNoteLineID?: number | undefined;
    orderID?: number | undefined;
    orderLineID?: number | undefined;
    productID?: number | undefined;
    quantityDelivered?: number | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    stockInfo?: string | undefined;
    provisionalTotalAmount?: number | undefined;
    provisionalVatAmount?: number | undefined;
    provisionalTotalCost?: number | undefined;

    constructor(data?: IDeliveryNoteLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productType = _data["productType"];
            this.deliveryNoteLineID = _data["deliveryNoteLineID"];
            this.deliveryNoteID = _data["deliveryNoteID"];
            this.pickingNoteID = _data["pickingNoteID"];
            this.pickingNoteLineID = _data["pickingNoteLineID"];
            this.orderID = _data["orderID"];
            this.orderLineID = _data["orderLineID"];
            this.productID = _data["productID"];
            this.quantityDelivered = _data["quantityDelivered"];
            this.quantityTally = _data["quantityTally"];
            this.noOfPieces = _data["noOfPieces"];
            this.totalWeight = _data["totalWeight"];
            this.totalLength = _data["totalLength"];
            this.totalVolume = _data["totalVolume"];
            this.stockInfo = _data["stockInfo"];
            this.provisionalTotalAmount = _data["provisionalTotalAmount"];
            this.provisionalVatAmount = _data["provisionalVatAmount"];
            this.provisionalTotalCost = _data["provisionalTotalCost"];
        }
    }

    static fromJS(data: any): DeliveryNoteLine {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryNoteLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productType"] = this.productType;
        data["deliveryNoteLineID"] = this.deliveryNoteLineID;
        data["deliveryNoteID"] = this.deliveryNoteID;
        data["pickingNoteID"] = this.pickingNoteID;
        data["pickingNoteLineID"] = this.pickingNoteLineID;
        data["orderID"] = this.orderID;
        data["orderLineID"] = this.orderLineID;
        data["productID"] = this.productID;
        data["quantityDelivered"] = this.quantityDelivered;
        data["quantityTally"] = this.quantityTally;
        data["noOfPieces"] = this.noOfPieces;
        data["totalWeight"] = this.totalWeight;
        data["totalLength"] = this.totalLength;
        data["totalVolume"] = this.totalVolume;
        data["stockInfo"] = this.stockInfo;
        data["provisionalTotalAmount"] = this.provisionalTotalAmount;
        data["provisionalVatAmount"] = this.provisionalVatAmount;
        data["provisionalTotalCost"] = this.provisionalTotalCost;
        return data; 
    }
}

export interface IDeliveryNoteLine {
    productType?: number | undefined;
    deliveryNoteLineID?: number | undefined;
    deliveryNoteID?: number | undefined;
    pickingNoteID?: number | undefined;
    pickingNoteLineID?: number | undefined;
    orderID?: number | undefined;
    orderLineID?: number | undefined;
    productID?: number | undefined;
    quantityDelivered?: number | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    stockInfo?: string | undefined;
    provisionalTotalAmount?: number | undefined;
    provisionalVatAmount?: number | undefined;
    provisionalTotalCost?: number | undefined;
}

export class AddCostProRateLine implements IAddCostProRateLine {
    id?: number | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;
    addCostProRateID?: number | undefined;
    supplierID?: number | undefined;
    currencyID?: string | undefined;
    currencyDesc?: string | undefined;
    additionalCostChargeID?: number | undefined;
    estimateExchangeRate?: string | undefined;
    estimateCost?: string | undefined;
    estimateCostInCurrency?: string | undefined;
    reference?: string | undefined;
    notes?: string | undefined;
    costValue?: string | undefined;
    costValueType?: AddCostProRateLineCostValueType | undefined;
    costProRateBy?: AddCostProRateLineCostProRateBy | undefined;
    chargeValue?: number | undefined;
    chargeValueType?: AddCostProRateLineChargeValueType | undefined;
    chargeProRateBy?: AddCostProRateLineChargeProRateBy | undefined;
    actualCharge?: string | undefined;
    totalChargeProrated?: string | undefined;
    totalCostProrated?: string | undefined;
    totalCostProratedInCurrency?: string | undefined;
    additionalCostChargeDescription?: string | undefined;
    worksOrderAddCostBasedOnType?: AddCostProRateLineWorksOrderAddCostBasedOnType | undefined;
    worksOrderAddCostBasedOnTypeDesc?: string | undefined;

    constructor(data?: IAddCostProRateLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supplierCode = _data["supplierCode"];
            this.supplierName = _data["supplierName"];
            this.addCostProRateID = _data["addCostProRateID"];
            this.supplierID = _data["supplierID"];
            this.currencyID = _data["currencyID"];
            this.currencyDesc = _data["currencyDesc"];
            this.additionalCostChargeID = _data["additionalCostChargeID"];
            this.estimateExchangeRate = _data["estimateExchangeRate"];
            this.estimateCost = _data["estimateCost"];
            this.estimateCostInCurrency = _data["estimateCostInCurrency"];
            this.reference = _data["reference"];
            this.notes = _data["notes"];
            this.costValue = _data["costValue"];
            this.costValueType = _data["costValueType"];
            this.costProRateBy = _data["costProRateBy"];
            this.chargeValue = _data["chargeValue"];
            this.chargeValueType = _data["chargeValueType"];
            this.chargeProRateBy = _data["chargeProRateBy"];
            this.actualCharge = _data["actualCharge"];
            this.totalChargeProrated = _data["totalChargeProrated"];
            this.totalCostProrated = _data["totalCostProrated"];
            this.totalCostProratedInCurrency = _data["totalCostProratedInCurrency"];
            this.additionalCostChargeDescription = _data["additionalCostChargeDescription"];
            this.worksOrderAddCostBasedOnType = _data["worksOrderAddCostBasedOnType"];
            this.worksOrderAddCostBasedOnTypeDesc = _data["worksOrderAddCostBasedOnTypeDesc"];
        }
    }

    static fromJS(data: any): AddCostProRateLine {
        data = typeof data === 'object' ? data : {};
        let result = new AddCostProRateLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supplierCode"] = this.supplierCode;
        data["supplierName"] = this.supplierName;
        data["addCostProRateID"] = this.addCostProRateID;
        data["supplierID"] = this.supplierID;
        data["currencyID"] = this.currencyID;
        data["currencyDesc"] = this.currencyDesc;
        data["additionalCostChargeID"] = this.additionalCostChargeID;
        data["estimateExchangeRate"] = this.estimateExchangeRate;
        data["estimateCost"] = this.estimateCost;
        data["estimateCostInCurrency"] = this.estimateCostInCurrency;
        data["reference"] = this.reference;
        data["notes"] = this.notes;
        data["costValue"] = this.costValue;
        data["costValueType"] = this.costValueType;
        data["costProRateBy"] = this.costProRateBy;
        data["chargeValue"] = this.chargeValue;
        data["chargeValueType"] = this.chargeValueType;
        data["chargeProRateBy"] = this.chargeProRateBy;
        data["actualCharge"] = this.actualCharge;
        data["totalChargeProrated"] = this.totalChargeProrated;
        data["totalCostProrated"] = this.totalCostProrated;
        data["totalCostProratedInCurrency"] = this.totalCostProratedInCurrency;
        data["additionalCostChargeDescription"] = this.additionalCostChargeDescription;
        data["worksOrderAddCostBasedOnType"] = this.worksOrderAddCostBasedOnType;
        data["worksOrderAddCostBasedOnTypeDesc"] = this.worksOrderAddCostBasedOnTypeDesc;
        return data; 
    }
}

export interface IAddCostProRateLine {
    id?: number | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;
    addCostProRateID?: number | undefined;
    supplierID?: number | undefined;
    currencyID?: string | undefined;
    currencyDesc?: string | undefined;
    additionalCostChargeID?: number | undefined;
    estimateExchangeRate?: string | undefined;
    estimateCost?: string | undefined;
    estimateCostInCurrency?: string | undefined;
    reference?: string | undefined;
    notes?: string | undefined;
    costValue?: string | undefined;
    costValueType?: AddCostProRateLineCostValueType | undefined;
    costProRateBy?: AddCostProRateLineCostProRateBy | undefined;
    chargeValue?: number | undefined;
    chargeValueType?: AddCostProRateLineChargeValueType | undefined;
    chargeProRateBy?: AddCostProRateLineChargeProRateBy | undefined;
    actualCharge?: string | undefined;
    totalChargeProrated?: string | undefined;
    totalCostProrated?: string | undefined;
    totalCostProratedInCurrency?: string | undefined;
    additionalCostChargeDescription?: string | undefined;
    worksOrderAddCostBasedOnType?: AddCostProRateLineWorksOrderAddCostBasedOnType | undefined;
    worksOrderAddCostBasedOnTypeDesc?: string | undefined;
}

export class AddCostProrationHeader implements IAddCostProrationHeader {
    id?: number | undefined;
    notes?: string | undefined;
    datePlanned?: Date | undefined;
    sourceTotalWeight?: string | undefined;
    sourceTotalVolumeMBF?: string | undefined;
    sourceTotalVolumeM3?: string | undefined;
    totalsAdditionalCosts?: number[] | undefined;
    totalsAdditionalCharges?: number[] | undefined;
    validationMessage?: string | undefined;

    constructor(data?: IAddCostProrationHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.notes = _data["notes"];
            this.datePlanned = _data["datePlanned"] ? new Date(_data["datePlanned"].toString()) : <any>undefined;
            this.sourceTotalWeight = _data["sourceTotalWeight"];
            this.sourceTotalVolumeMBF = _data["sourceTotalVolumeMBF"];
            this.sourceTotalVolumeM3 = _data["sourceTotalVolumeM3"];
            if (Array.isArray(_data["totalsAdditionalCosts"])) {
                this.totalsAdditionalCosts = [] as any;
                for (let item of _data["totalsAdditionalCosts"])
                    this.totalsAdditionalCosts!.push(item);
            }
            if (Array.isArray(_data["totalsAdditionalCharges"])) {
                this.totalsAdditionalCharges = [] as any;
                for (let item of _data["totalsAdditionalCharges"])
                    this.totalsAdditionalCharges!.push(item);
            }
            this.validationMessage = _data["validationMessage"];
        }
    }

    static fromJS(data: any): AddCostProrationHeader {
        data = typeof data === 'object' ? data : {};
        let result = new AddCostProrationHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["notes"] = this.notes;
        data["datePlanned"] = this.datePlanned ? this.datePlanned.toISOString() : <any>undefined;
        data["sourceTotalWeight"] = this.sourceTotalWeight;
        data["sourceTotalVolumeMBF"] = this.sourceTotalVolumeMBF;
        data["sourceTotalVolumeM3"] = this.sourceTotalVolumeM3;
        if (Array.isArray(this.totalsAdditionalCosts)) {
            data["totalsAdditionalCosts"] = [];
            for (let item of this.totalsAdditionalCosts)
                data["totalsAdditionalCosts"].push(item);
        }
        if (Array.isArray(this.totalsAdditionalCharges)) {
            data["totalsAdditionalCharges"] = [];
            for (let item of this.totalsAdditionalCharges)
                data["totalsAdditionalCharges"].push(item);
        }
        data["validationMessage"] = this.validationMessage;
        return data; 
    }
}

export interface IAddCostProrationHeader {
    id?: number | undefined;
    notes?: string | undefined;
    datePlanned?: Date | undefined;
    sourceTotalWeight?: string | undefined;
    sourceTotalVolumeMBF?: string | undefined;
    sourceTotalVolumeM3?: string | undefined;
    totalsAdditionalCosts?: number[] | undefined;
    totalsAdditionalCharges?: number[] | undefined;
    validationMessage?: string | undefined;
}

export class AddCostProrationDocument implements IAddCostProrationDocument {
    documentNumber?: number | undefined;
    documentStatus?: string | undefined;
    documentDate?: Date | undefined;
    branch?: string | undefined;
    branchID?: number | undefined;
    supplierName?: string | undefined;
    totalSourceCostPrice?: string | undefined;
    totalFinishedCostPrice?: string | undefined;
    totalSellPrice?: string | undefined;
    totalSourceVolume?: string | undefined;
    totalSourceVolumeMBF?: string | undefined;
    totalFinishedVolume?: string | undefined;
    totalFinishedVolumeMBF?: string | undefined;
    totalWeight?: string | undefined;
    additionalCurrency?: string | undefined;
    totalAdditionalCost?: string | undefined;
    totalAdditionalCharge?: string | undefined;
    documentType?: AddCostProrationDocumentDocumentType | undefined;

    constructor(data?: IAddCostProrationDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.documentStatus = _data["documentStatus"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.branch = _data["branch"];
            this.branchID = _data["branchID"];
            this.supplierName = _data["supplierName"];
            this.totalSourceCostPrice = _data["totalSourceCostPrice"];
            this.totalFinishedCostPrice = _data["totalFinishedCostPrice"];
            this.totalSellPrice = _data["totalSellPrice"];
            this.totalSourceVolume = _data["totalSourceVolume"];
            this.totalSourceVolumeMBF = _data["totalSourceVolumeMBF"];
            this.totalFinishedVolume = _data["totalFinishedVolume"];
            this.totalFinishedVolumeMBF = _data["totalFinishedVolumeMBF"];
            this.totalWeight = _data["totalWeight"];
            this.additionalCurrency = _data["additionalCurrency"];
            this.totalAdditionalCost = _data["totalAdditionalCost"];
            this.totalAdditionalCharge = _data["totalAdditionalCharge"];
            this.documentType = _data["documentType"];
        }
    }

    static fromJS(data: any): AddCostProrationDocument {
        data = typeof data === 'object' ? data : {};
        let result = new AddCostProrationDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["documentStatus"] = this.documentStatus;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["branch"] = this.branch;
        data["branchID"] = this.branchID;
        data["supplierName"] = this.supplierName;
        data["totalSourceCostPrice"] = this.totalSourceCostPrice;
        data["totalFinishedCostPrice"] = this.totalFinishedCostPrice;
        data["totalSellPrice"] = this.totalSellPrice;
        data["totalSourceVolume"] = this.totalSourceVolume;
        data["totalSourceVolumeMBF"] = this.totalSourceVolumeMBF;
        data["totalFinishedVolume"] = this.totalFinishedVolume;
        data["totalFinishedVolumeMBF"] = this.totalFinishedVolumeMBF;
        data["totalWeight"] = this.totalWeight;
        data["additionalCurrency"] = this.additionalCurrency;
        data["totalAdditionalCost"] = this.totalAdditionalCost;
        data["totalAdditionalCharge"] = this.totalAdditionalCharge;
        data["documentType"] = this.documentType;
        return data; 
    }
}

export interface IAddCostProrationDocument {
    documentNumber?: number | undefined;
    documentStatus?: string | undefined;
    documentDate?: Date | undefined;
    branch?: string | undefined;
    branchID?: number | undefined;
    supplierName?: string | undefined;
    totalSourceCostPrice?: string | undefined;
    totalFinishedCostPrice?: string | undefined;
    totalSellPrice?: string | undefined;
    totalSourceVolume?: string | undefined;
    totalSourceVolumeMBF?: string | undefined;
    totalFinishedVolume?: string | undefined;
    totalFinishedVolumeMBF?: string | undefined;
    totalWeight?: string | undefined;
    additionalCurrency?: string | undefined;
    totalAdditionalCost?: string | undefined;
    totalAdditionalCharge?: string | undefined;
    documentType?: AddCostProrationDocumentDocumentType | undefined;
}

export class WorkOrderHeader implements IWorkOrderHeader {
    worksOrderID?: number | undefined;
    deleted?: number | undefined;
    worksOrderNumber?: number | undefined;
    worksOrderStatus?: number | undefined;
    template?: boolean | undefined;
    stockAllocated?: boolean | undefined;
    branchID?: number | undefined;
    orderID?: number | undefined;
    description?: string | undefined;
    dateRequired?: Date | undefined;
    dateRequiredOption?: number | undefined;
    startManufactureBy?: Date | undefined;
    machineGroupID?: number | undefined;
    machineID?: number | undefined;
    machineName?: string | undefined;
    operatorName?: string | undefined;
    shiftID?: number | undefined;
    supplierID?: number | undefined;
    processCostsToOrderOnly?: boolean | undefined;
    addCostsToOrderOnly?: boolean | undefined;
    notes?: string | undefined;
    noOfPiecesIn?: number | undefined;
    totalLengthIn?: number | undefined;
    totalVolumeIn?: number | undefined;
    totalAreaIn?: number | undefined;
    noOfPiecesOut?: number | undefined;
    totalLengthOut?: number | undefined;
    totalVolumeOut?: number | undefined;
    totalAreaOut?: number | undefined;
    volumeToOrder?: number | undefined;
    volumeToStock?: number | undefined;
    volumeToWaste?: number | undefined;
    totalSourceCost?: number | undefined;
    totalProcessCost?: number | undefined;
    totalAddCost?: number | undefined;
    totalCostPrice?: number | undefined;
    noOfSource?: number | undefined;
    noOfProcess?: number | undefined;
    noOfFinished?: number | undefined;
    totalProductionTime?: number | undefined;
    totalWeight?: number | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    dateTimeProcessed?: Date | undefined;
    processedByID?: number | undefined;
    journeyID?: number | undefined;
    needsCollection?: boolean | undefined;
    collectionJourneyID?: number | undefined;
    printed?: boolean | undefined;
    scheduleLabelPrinted?: boolean | undefined;
    totalProcessLeadTime?: number | undefined;
    generatedOrder?: boolean | undefined;
    wmsType?: number | undefined;
    wmsCreatedFromWorksOrderID?: number | undefined;
    wmsStatus?: number | undefined;
    isOnQuote?: boolean | undefined;
    lastModifiedByID?: number | undefined;
    calculatedDateRequired?: boolean | undefined;
    wmsHold?: boolean | undefined;
    isNested?: boolean | undefined;
    nestingAllowRotation?: boolean | undefined;
    requiresStock?: boolean | undefined;
    overrideUserID?: number | undefined;
    overrideDateTime?: Date | undefined;
    branchCode?: string | undefined;
    branchName?: string | undefined;
    orderNumber?: number | undefined;
    orderStatus?: number | undefined;
    customerID?: number | undefined;
    orderType?: number | undefined;
    createdByName?: string | undefined;
    processedByName?: string | undefined;
    lastModifiedByName?: string | undefined;

    constructor(data?: IWorkOrderHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.worksOrderID = _data["worksOrderID"];
            this.deleted = _data["deleted"];
            this.worksOrderNumber = _data["worksOrderNumber"];
            this.worksOrderStatus = _data["worksOrderStatus"];
            this.template = _data["template"];
            this.stockAllocated = _data["stockAllocated"];
            this.branchID = _data["branchID"];
            this.orderID = _data["orderID"];
            this.description = _data["description"];
            this.dateRequired = _data["dateRequired"] ? new Date(_data["dateRequired"].toString()) : <any>undefined;
            this.dateRequiredOption = _data["dateRequiredOption"];
            this.startManufactureBy = _data["startManufactureBy"] ? new Date(_data["startManufactureBy"].toString()) : <any>undefined;
            this.machineGroupID = _data["machineGroupID"];
            this.machineID = _data["machineID"];
            this.machineName = _data["machineName"];
            this.operatorName = _data["operatorName"];
            this.shiftID = _data["shiftID"];
            this.supplierID = _data["supplierID"];
            this.processCostsToOrderOnly = _data["processCostsToOrderOnly"];
            this.addCostsToOrderOnly = _data["addCostsToOrderOnly"];
            this.notes = _data["notes"];
            this.noOfPiecesIn = _data["noOfPiecesIn"];
            this.totalLengthIn = _data["totalLengthIn"];
            this.totalVolumeIn = _data["totalVolumeIn"];
            this.totalAreaIn = _data["totalAreaIn"];
            this.noOfPiecesOut = _data["noOfPiecesOut"];
            this.totalLengthOut = _data["totalLengthOut"];
            this.totalVolumeOut = _data["totalVolumeOut"];
            this.totalAreaOut = _data["totalAreaOut"];
            this.volumeToOrder = _data["volumeToOrder"];
            this.volumeToStock = _data["volumeToStock"];
            this.volumeToWaste = _data["volumeToWaste"];
            this.totalSourceCost = _data["totalSourceCost"];
            this.totalProcessCost = _data["totalProcessCost"];
            this.totalAddCost = _data["totalAddCost"];
            this.totalCostPrice = _data["totalCostPrice"];
            this.noOfSource = _data["noOfSource"];
            this.noOfProcess = _data["noOfProcess"];
            this.noOfFinished = _data["noOfFinished"];
            this.totalProductionTime = _data["totalProductionTime"];
            this.totalWeight = _data["totalWeight"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.createdByID = _data["createdByID"];
            this.dateTimeLastModified = _data["dateTimeLastModified"] ? new Date(_data["dateTimeLastModified"].toString()) : <any>undefined;
            this.dateTimeProcessed = _data["dateTimeProcessed"] ? new Date(_data["dateTimeProcessed"].toString()) : <any>undefined;
            this.processedByID = _data["processedByID"];
            this.journeyID = _data["journeyID"];
            this.needsCollection = _data["needsCollection"];
            this.collectionJourneyID = _data["collectionJourneyID"];
            this.printed = _data["printed"];
            this.scheduleLabelPrinted = _data["scheduleLabelPrinted"];
            this.totalProcessLeadTime = _data["totalProcessLeadTime"];
            this.generatedOrder = _data["generatedOrder"];
            this.wmsType = _data["wmsType"];
            this.wmsCreatedFromWorksOrderID = _data["wmsCreatedFromWorksOrderID"];
            this.wmsStatus = _data["wmsStatus"];
            this.isOnQuote = _data["isOnQuote"];
            this.lastModifiedByID = _data["lastModifiedByID"];
            this.calculatedDateRequired = _data["calculatedDateRequired"];
            this.wmsHold = _data["wmsHold"];
            this.isNested = _data["isNested"];
            this.nestingAllowRotation = _data["nestingAllowRotation"];
            this.requiresStock = _data["requiresStock"];
            this.overrideUserID = _data["overrideUserID"];
            this.overrideDateTime = _data["overrideDateTime"] ? new Date(_data["overrideDateTime"].toString()) : <any>undefined;
            this.branchCode = _data["branchCode"];
            this.branchName = _data["branchName"];
            this.orderNumber = _data["orderNumber"];
            this.orderStatus = _data["orderStatus"];
            this.customerID = _data["customerID"];
            this.orderType = _data["orderType"];
            this.createdByName = _data["createdByName"];
            this.processedByName = _data["processedByName"];
            this.lastModifiedByName = _data["lastModifiedByName"];
        }
    }

    static fromJS(data: any): WorkOrderHeader {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["worksOrderID"] = this.worksOrderID;
        data["deleted"] = this.deleted;
        data["worksOrderNumber"] = this.worksOrderNumber;
        data["worksOrderStatus"] = this.worksOrderStatus;
        data["template"] = this.template;
        data["stockAllocated"] = this.stockAllocated;
        data["branchID"] = this.branchID;
        data["orderID"] = this.orderID;
        data["description"] = this.description;
        data["dateRequired"] = this.dateRequired ? this.dateRequired.toISOString() : <any>undefined;
        data["dateRequiredOption"] = this.dateRequiredOption;
        data["startManufactureBy"] = this.startManufactureBy ? this.startManufactureBy.toISOString() : <any>undefined;
        data["machineGroupID"] = this.machineGroupID;
        data["machineID"] = this.machineID;
        data["machineName"] = this.machineName;
        data["operatorName"] = this.operatorName;
        data["shiftID"] = this.shiftID;
        data["supplierID"] = this.supplierID;
        data["processCostsToOrderOnly"] = this.processCostsToOrderOnly;
        data["addCostsToOrderOnly"] = this.addCostsToOrderOnly;
        data["notes"] = this.notes;
        data["noOfPiecesIn"] = this.noOfPiecesIn;
        data["totalLengthIn"] = this.totalLengthIn;
        data["totalVolumeIn"] = this.totalVolumeIn;
        data["totalAreaIn"] = this.totalAreaIn;
        data["noOfPiecesOut"] = this.noOfPiecesOut;
        data["totalLengthOut"] = this.totalLengthOut;
        data["totalVolumeOut"] = this.totalVolumeOut;
        data["totalAreaOut"] = this.totalAreaOut;
        data["volumeToOrder"] = this.volumeToOrder;
        data["volumeToStock"] = this.volumeToStock;
        data["volumeToWaste"] = this.volumeToWaste;
        data["totalSourceCost"] = this.totalSourceCost;
        data["totalProcessCost"] = this.totalProcessCost;
        data["totalAddCost"] = this.totalAddCost;
        data["totalCostPrice"] = this.totalCostPrice;
        data["noOfSource"] = this.noOfSource;
        data["noOfProcess"] = this.noOfProcess;
        data["noOfFinished"] = this.noOfFinished;
        data["totalProductionTime"] = this.totalProductionTime;
        data["totalWeight"] = this.totalWeight;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["createdByID"] = this.createdByID;
        data["dateTimeLastModified"] = this.dateTimeLastModified ? this.dateTimeLastModified.toISOString() : <any>undefined;
        data["dateTimeProcessed"] = this.dateTimeProcessed ? this.dateTimeProcessed.toISOString() : <any>undefined;
        data["processedByID"] = this.processedByID;
        data["journeyID"] = this.journeyID;
        data["needsCollection"] = this.needsCollection;
        data["collectionJourneyID"] = this.collectionJourneyID;
        data["printed"] = this.printed;
        data["scheduleLabelPrinted"] = this.scheduleLabelPrinted;
        data["totalProcessLeadTime"] = this.totalProcessLeadTime;
        data["generatedOrder"] = this.generatedOrder;
        data["wmsType"] = this.wmsType;
        data["wmsCreatedFromWorksOrderID"] = this.wmsCreatedFromWorksOrderID;
        data["wmsStatus"] = this.wmsStatus;
        data["isOnQuote"] = this.isOnQuote;
        data["lastModifiedByID"] = this.lastModifiedByID;
        data["calculatedDateRequired"] = this.calculatedDateRequired;
        data["wmsHold"] = this.wmsHold;
        data["isNested"] = this.isNested;
        data["nestingAllowRotation"] = this.nestingAllowRotation;
        data["requiresStock"] = this.requiresStock;
        data["overrideUserID"] = this.overrideUserID;
        data["overrideDateTime"] = this.overrideDateTime ? this.overrideDateTime.toISOString() : <any>undefined;
        data["branchCode"] = this.branchCode;
        data["branchName"] = this.branchName;
        data["orderNumber"] = this.orderNumber;
        data["orderStatus"] = this.orderStatus;
        data["customerID"] = this.customerID;
        data["orderType"] = this.orderType;
        data["createdByName"] = this.createdByName;
        data["processedByName"] = this.processedByName;
        data["lastModifiedByName"] = this.lastModifiedByName;
        return data; 
    }
}

export interface IWorkOrderHeader {
    worksOrderID?: number | undefined;
    deleted?: number | undefined;
    worksOrderNumber?: number | undefined;
    worksOrderStatus?: number | undefined;
    template?: boolean | undefined;
    stockAllocated?: boolean | undefined;
    branchID?: number | undefined;
    orderID?: number | undefined;
    description?: string | undefined;
    dateRequired?: Date | undefined;
    dateRequiredOption?: number | undefined;
    startManufactureBy?: Date | undefined;
    machineGroupID?: number | undefined;
    machineID?: number | undefined;
    machineName?: string | undefined;
    operatorName?: string | undefined;
    shiftID?: number | undefined;
    supplierID?: number | undefined;
    processCostsToOrderOnly?: boolean | undefined;
    addCostsToOrderOnly?: boolean | undefined;
    notes?: string | undefined;
    noOfPiecesIn?: number | undefined;
    totalLengthIn?: number | undefined;
    totalVolumeIn?: number | undefined;
    totalAreaIn?: number | undefined;
    noOfPiecesOut?: number | undefined;
    totalLengthOut?: number | undefined;
    totalVolumeOut?: number | undefined;
    totalAreaOut?: number | undefined;
    volumeToOrder?: number | undefined;
    volumeToStock?: number | undefined;
    volumeToWaste?: number | undefined;
    totalSourceCost?: number | undefined;
    totalProcessCost?: number | undefined;
    totalAddCost?: number | undefined;
    totalCostPrice?: number | undefined;
    noOfSource?: number | undefined;
    noOfProcess?: number | undefined;
    noOfFinished?: number | undefined;
    totalProductionTime?: number | undefined;
    totalWeight?: number | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    dateTimeProcessed?: Date | undefined;
    processedByID?: number | undefined;
    journeyID?: number | undefined;
    needsCollection?: boolean | undefined;
    collectionJourneyID?: number | undefined;
    printed?: boolean | undefined;
    scheduleLabelPrinted?: boolean | undefined;
    totalProcessLeadTime?: number | undefined;
    generatedOrder?: boolean | undefined;
    wmsType?: number | undefined;
    wmsCreatedFromWorksOrderID?: number | undefined;
    wmsStatus?: number | undefined;
    isOnQuote?: boolean | undefined;
    lastModifiedByID?: number | undefined;
    calculatedDateRequired?: boolean | undefined;
    wmsHold?: boolean | undefined;
    isNested?: boolean | undefined;
    nestingAllowRotation?: boolean | undefined;
    requiresStock?: boolean | undefined;
    overrideUserID?: number | undefined;
    overrideDateTime?: Date | undefined;
    branchCode?: string | undefined;
    branchName?: string | undefined;
    orderNumber?: number | undefined;
    orderStatus?: number | undefined;
    customerID?: number | undefined;
    orderType?: number | undefined;
    createdByName?: string | undefined;
    processedByName?: string | undefined;
    lastModifiedByName?: string | undefined;
}

export class WorkOrderCustomersAndSupplier implements IWorkOrderCustomersAndSupplier {
    customerCode?: string | undefined;
    customerName?: string | undefined;
    customerAddressDefaultProductBatchReference?: string | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;

    constructor(data?: IWorkOrderCustomersAndSupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerCode = _data["customerCode"];
            this.customerName = _data["customerName"];
            this.customerAddressDefaultProductBatchReference = _data["customerAddressDefaultProductBatchReference"];
            this.supplierCode = _data["supplierCode"];
            this.supplierName = _data["supplierName"];
        }
    }

    static fromJS(data: any): WorkOrderCustomersAndSupplier {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderCustomersAndSupplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerCode"] = this.customerCode;
        data["customerName"] = this.customerName;
        data["customerAddressDefaultProductBatchReference"] = this.customerAddressDefaultProductBatchReference;
        data["supplierCode"] = this.supplierCode;
        data["supplierName"] = this.supplierName;
        return data; 
    }
}

export interface IWorkOrderCustomersAndSupplier {
    customerCode?: string | undefined;
    customerName?: string | undefined;
    customerAddressDefaultProductBatchReference?: string | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;
}

export class WorkOrderLine implements IWorkOrderLine {
    worksOrderLineID?: number | undefined;
    worksOrderID?: number | undefined;
    lineType?: number | undefined;
    lineNumber?: number | undefined;
    suggestedOrderBatchLineID?: number | undefined;
    orderID?: number | undefined;
    stockBatchID?: number | undefined;
    stockAllocationID?: number | undefined;
    productID?: number | undefined;
    productKitID?: number | undefined;
    packID?: number | undefined;
    productKitLineID?: number | undefined;
    manualCode?: string | undefined;
    manualDescription?: string | undefined;
    manualThickness?: number | undefined;
    manualWidth?: number | undefined;
    manualLength?: number | undefined;
    avoid?: number | undefined;
    avoOptionID?: number | undefined;
    avoOptionSupplierID?: number | undefined;
    avoOptionBuyPriceRuleID?: number | undefined;
    noEx?: number | undefined;
    productionTime?: number | undefined;
    completedByID?: number | undefined;
    dateTimeCompleted?: Date | undefined;
    actualProductionTime?: number | undefined;
    quantity?: number | undefined;
    quantityTally?: string | undefined;
    inputPerID?: number | undefined;
    costPerID?: number | undefined;
    stockPerConversion?: number | undefined;
    statsPerConversion?: number | undefined;
    unitCostPrice?: number | undefined;
    totalCostPrice?: number | undefined;
    unitVMICostPrice?: number | undefined;
    totalVMICostPrice?: number | undefined;
    vmiRuleID?: number | undefined;
    fixedPrice?: boolean | undefined;
    processCostPriceType?: number | undefined;
    noOfPieces?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    totalArea?: number | undefined;
    notes?: string | undefined;
    specialOrder?: boolean | undefined;
    purchaseOrderID?: number | undefined;
    purchaseOrderQuantity?: number | undefined;
    purchaseOrderQuantityReceived?: number | undefined;
    pendingActions?: number | undefined;
    packConfirmed?: boolean | undefined;
    linkedToLineID?: number | undefined;
    linkedTotalQuantity?: number | undefined;
    linkedTotalCostPrice?: number | undefined;
    linkedTotalNoOfPieces?: number | undefined;
    linkedTotalWeight?: number | undefined;
    linkedTotalLength?: number | undefined;
    linkedTotalVolume?: number | undefined;
    otherFlags?: number | undefined;
    ply?: number | undefined;
    trussTypeID?: number | undefined;
    span?: number | undefined;
    pitch?: number | undefined;
    stubLeft?: number | undefined;
    stubRight?: number | undefined;
    cantileverLeft?: number | undefined;
    cantileverRight?: number | undefined;
    overhangLeft?: number | undefined;
    overhangRight?: number | undefined;
    trussVolume?: number | undefined;
    trussVolumeImperial?: number | undefined;
    sourceCostMethod?: number | undefined;
    processCostMethod?: number | undefined;
    partProcessed?: boolean | undefined;
    worksOrderPartialProcessID?: number | undefined;
    processedFromLineID?: number | undefined;
    processed?: boolean | undefined;
    quantityUnprocessed?: number | undefined;
    quantityTallyUnprocessed?: string | undefined;
    vmiSupplierInvoiceDocumentID?: number | undefined;
    vmiReconciled?: boolean | undefined;
    machineID?: number | undefined;
    scheduleID?: number | undefined;
    worksOrderProcessHeaderID?: number | undefined;
    totalVMICostInCurrency?: number | undefined;
    unitVMICostInCurrency?: number | undefined;
    vmiExchangeRate?: number | undefined;
    avoOptionCurrencyID?: number | undefined;
    avoOptionExchangeRate?: number | undefined;
    avoOptionUnitCostInCurrency?: number | undefined;
    avoOptionTotalCostInCurrency?: number | undefined;
    importedFromMiTek?: boolean | undefined;
    prorateToLinked?: boolean | undefined;
    totalCostFromAVO?: number | undefined;
    wmsProcessed?: boolean | undefined;
    wmsParentLineID?: number | undefined;
    wmsCreatedFromWorksOrderLineID?: number | undefined;
    avoMinimumCost?: number | undefined;
    avoMinimumSell?: number | undefined;
    productKitManufacturedProcessID?: number | undefined;
    productKitSellPriceGroupID?: number | undefined;
    manufacturedWorksOrderLineID?: number | undefined;
    productBatchOption?: number | undefined;
    productBatchID?: number | undefined;
    productBatchReference?: string | undefined;
    shipOnSalesOrder?: boolean | undefined;
    dateExpected?: Date | undefined;
    cutToLengthDetails?: string | undefined;
    supplierSettlementAmount?: number | undefined;
    manualWeight?: number | undefined;
    avoWasteCost?: number | undefined;
    cutLineID?: number | undefined;
    requiresStock?: boolean | undefined;
    useSourceTallyDuringRenesting?: boolean | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    perRuleID?: number | undefined;
    productCode?: string | undefined;
    productDescription?: string | undefined;
    productShortDescription?: string | undefined;
    productThickness?: number | undefined;
    productWidth?: number | undefined;
    productLength?: number | undefined;
    productWeight?: number | undefined;
    productImperial?: boolean | undefined;
    productTallyLengths?: string | undefined;
    productAvailableWidths?: string | undefined;
    productTallyLengthsPerID?: number | undefined;
    productStockControlByLength?: boolean | undefined;
    productMaterialGradeID?: number | undefined;
    productGroupID?: number | undefined;
    productSpecial?: boolean | undefined;
    productSpecialSourceID?: number | undefined;
    productDefaultPiecesPerPack?: number | undefined;
    productEnvironmentalStatusID?: number | undefined;
    cutToLengthStyle?: number | undefined;
    productKeepStockFigures?: boolean | undefined;
    productParentID?: number | undefined;
    productSalesOrderTalliedInputScreen?: number | undefined;
    standardSellPrice?: number | undefined;
    standardBuyPrice?: number | undefined;
    sellPerID?: number | undefined;
    buyPerID?: number | undefined;
    defaultUnitSizePerID?: number | undefined;
    allowMultiplePersOnUnitSizes?: boolean | undefined;
    productReplacementID?: number | undefined;
    companyStandardBuy?: number | undefined;
    companyBuyPerID?: number | undefined;
    companyStandardSell?: number | undefined;
    companySellPerID?: number | undefined;
    branchStandardBuy?: number | undefined;
    branchBuyPerID?: number | undefined;
    branchStandardSell?: number | undefined;
    branchSellPerID?: number | undefined;
    productHowSourced?: number | undefined;
    defaultProductHowSourced?: number | undefined;
    packRef?: string | undefined;
    tallyFromPack?: string | undefined;
    packNoOfPieces?: number | undefined;
    packTotalLength?: number | undefined;
    packTotalVolume?: number | undefined;
    packTotalLengthImperial?: number | undefined;
    packTotalVolumeImperial?: number | undefined;
    packTotalWeight?: number | undefined;
    packTotalCost?: number | undefined;
    packAdditionalCost?: number | undefined;
    operationName?: string | undefined;
    optionName?: string | undefined;
    avoOptionGLCodeProcessing?: string | undefined;
    avoDescription?: string | undefined;
    costPriceCalcUseActualSize?: boolean | undefined;
    sellPriceCalcUseActualSize?: boolean | undefined;
    avoOptionSupplierIDDefault?: number | undefined;
    avoOptionSupplierNameDefault?: string | undefined;
    avoOptionConcurrent?: boolean | undefined;
    avoOptionLeadTime?: number | undefined;
    avoOptionSupplierName?: string | undefined;
    completedByName?: string | undefined;
    weightPerID?: number | undefined;
    stockTransferOrderID?: number | undefined;
    stockTransferOrderLineID?: number | undefined;
    stockTransferOrderStatus?: number | undefined;
    stockTransferOrderLineNotes?: string | undefined;
    stockTransferOrderLineSpecialInstructions?: string | undefined;
    stockTransferOrderLinepublicNotes?: string | undefined;
    orderLineNotes?: string | undefined;
    orderLineSpecialInstructions?: string | undefined;
    orderLinepublicNotes?: string | undefined;
    trussTypeName?: string | undefined;
    lineDateTimeProcessed?: Date | undefined;
    lineProcessedByID?: number | undefined;
    processOverrideUserID?: number | undefined;
    processOverrideDateTime?: Date | undefined;
    defaultProductBatchReference?: string | undefined;
    productKitLineHideOnWorksOrder?: boolean | undefined;
    productBillOfMaterialID?: number | undefined;
    transferOrderID?: number | undefined;
    supplierInvoiceStatus?: number | undefined;
    totalProcessedTally?: number | undefined;
    totalProcessedQuantity?: number | undefined;
    totalProcessedCost?: number | undefined;
    totalProcessedCostFromAvo?: number | undefined;
    totalProcessedVolume?: number | undefined;
    totalProcessedWeight?: number | undefined;
    stockTransferOrderLineInternalNotes?: string | undefined;
    orderLineInternalNotes?: string | undefined;
    addCostMethod?: number | undefined;
    processedBy?: string | undefined;
    ppQuantityUnprocessed?: number | undefined;
    ppQuantityTallyUnprocessed?: string | undefined;
    wolBuyPrice?: number | undefined;
    wolBuyPerID?: number | undefined;
    wolSellPrice?: number | undefined;
    wolSellPerID?: number | undefined;
    stockTransferred?: boolean | undefined;
    branchID?: any | undefined;
    totalLengthImperial?: number | undefined;
    totalVolumeImperial?: number | undefined;
    linkedTotalLengthImperial?: number | undefined;
    linkedTotalVolumeImperial?: number | undefined;
    originalUnitCostPrice?: number | undefined;
    originalCostPerID?: number | undefined;
    originalTotalCostPrice?: number | undefined;
    productKitSetDescriptionFromLinesShortDescriptions?: boolean | undefined;
    forWorksOrderID?: number | undefined;
    forWorksOrderNumber?: number | undefined;
    forWorksOrderLineID?: number | undefined;
    manufacturedWorksOrderID?: number | undefined;
    manufacturedWorksOrderStatus?: number | undefined;
    purchaseOrderLineStatus?: number | undefined;
    manufacturedLineSetDescriptionFromLinesShortDescriptions?: boolean | undefined;
    manufacturedLineManualDescription?: string | undefined;
    wmsSent?: boolean | undefined;
    wmsExpectedQuantity?: number | undefined;
    wmsExpectedPerID?: number | undefined;

    constructor(data?: IWorkOrderLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.worksOrderLineID = _data["worksOrderLineID"];
            this.worksOrderID = _data["worksOrderID"];
            this.lineType = _data["lineType"];
            this.lineNumber = _data["lineNumber"];
            this.suggestedOrderBatchLineID = _data["suggestedOrderBatchLineID"];
            this.orderID = _data["orderID"];
            this.stockBatchID = _data["stockBatchID"];
            this.stockAllocationID = _data["stockAllocationID"];
            this.productID = _data["productID"];
            this.productKitID = _data["productKitID"];
            this.packID = _data["packID"];
            this.productKitLineID = _data["productKitLineID"];
            this.manualCode = _data["manualCode"];
            this.manualDescription = _data["manualDescription"];
            this.manualThickness = _data["manualThickness"];
            this.manualWidth = _data["manualWidth"];
            this.manualLength = _data["manualLength"];
            this.avoid = _data["avoid"];
            this.avoOptionID = _data["avoOptionID"];
            this.avoOptionSupplierID = _data["avoOptionSupplierID"];
            this.avoOptionBuyPriceRuleID = _data["avoOptionBuyPriceRuleID"];
            this.noEx = _data["noEx"];
            this.productionTime = _data["productionTime"];
            this.completedByID = _data["completedByID"];
            this.dateTimeCompleted = _data["dateTimeCompleted"] ? new Date(_data["dateTimeCompleted"].toString()) : <any>undefined;
            this.actualProductionTime = _data["actualProductionTime"];
            this.quantity = _data["quantity"];
            this.quantityTally = _data["quantityTally"];
            this.inputPerID = _data["inputPerID"];
            this.costPerID = _data["costPerID"];
            this.stockPerConversion = _data["stockPerConversion"];
            this.statsPerConversion = _data["statsPerConversion"];
            this.unitCostPrice = _data["unitCostPrice"];
            this.totalCostPrice = _data["totalCostPrice"];
            this.unitVMICostPrice = _data["unitVMICostPrice"];
            this.totalVMICostPrice = _data["totalVMICostPrice"];
            this.vmiRuleID = _data["vmiRuleID"];
            this.fixedPrice = _data["fixedPrice"];
            this.processCostPriceType = _data["processCostPriceType"];
            this.noOfPieces = _data["noOfPieces"];
            this.totalWeight = _data["totalWeight"];
            this.totalLength = _data["totalLength"];
            this.totalVolume = _data["totalVolume"];
            this.totalArea = _data["totalArea"];
            this.notes = _data["notes"];
            this.specialOrder = _data["specialOrder"];
            this.purchaseOrderID = _data["purchaseOrderID"];
            this.purchaseOrderQuantity = _data["purchaseOrderQuantity"];
            this.purchaseOrderQuantityReceived = _data["purchaseOrderQuantityReceived"];
            this.pendingActions = _data["pendingActions"];
            this.packConfirmed = _data["packConfirmed"];
            this.linkedToLineID = _data["linkedToLineID"];
            this.linkedTotalQuantity = _data["linkedTotalQuantity"];
            this.linkedTotalCostPrice = _data["linkedTotalCostPrice"];
            this.linkedTotalNoOfPieces = _data["linkedTotalNoOfPieces"];
            this.linkedTotalWeight = _data["linkedTotalWeight"];
            this.linkedTotalLength = _data["linkedTotalLength"];
            this.linkedTotalVolume = _data["linkedTotalVolume"];
            this.otherFlags = _data["otherFlags"];
            this.ply = _data["ply"];
            this.trussTypeID = _data["trussTypeID"];
            this.span = _data["span"];
            this.pitch = _data["pitch"];
            this.stubLeft = _data["stubLeft"];
            this.stubRight = _data["stubRight"];
            this.cantileverLeft = _data["cantileverLeft"];
            this.cantileverRight = _data["cantileverRight"];
            this.overhangLeft = _data["overhangLeft"];
            this.overhangRight = _data["overhangRight"];
            this.trussVolume = _data["trussVolume"];
            this.trussVolumeImperial = _data["trussVolumeImperial"];
            this.sourceCostMethod = _data["sourceCostMethod"];
            this.processCostMethod = _data["processCostMethod"];
            this.partProcessed = _data["partProcessed"];
            this.worksOrderPartialProcessID = _data["worksOrderPartialProcessID"];
            this.processedFromLineID = _data["processedFromLineID"];
            this.processed = _data["processed"];
            this.quantityUnprocessed = _data["quantityUnprocessed"];
            this.quantityTallyUnprocessed = _data["quantityTallyUnprocessed"];
            this.vmiSupplierInvoiceDocumentID = _data["vmiSupplierInvoiceDocumentID"];
            this.vmiReconciled = _data["vmiReconciled"];
            this.machineID = _data["machineID"];
            this.scheduleID = _data["scheduleID"];
            this.worksOrderProcessHeaderID = _data["worksOrderProcessHeaderID"];
            this.totalVMICostInCurrency = _data["totalVMICostInCurrency"];
            this.unitVMICostInCurrency = _data["unitVMICostInCurrency"];
            this.vmiExchangeRate = _data["vmiExchangeRate"];
            this.avoOptionCurrencyID = _data["avoOptionCurrencyID"];
            this.avoOptionExchangeRate = _data["avoOptionExchangeRate"];
            this.avoOptionUnitCostInCurrency = _data["avoOptionUnitCostInCurrency"];
            this.avoOptionTotalCostInCurrency = _data["avoOptionTotalCostInCurrency"];
            this.importedFromMiTek = _data["importedFromMiTek"];
            this.prorateToLinked = _data["prorateToLinked"];
            this.totalCostFromAVO = _data["totalCostFromAVO"];
            this.wmsProcessed = _data["wmsProcessed"];
            this.wmsParentLineID = _data["wmsParentLineID"];
            this.wmsCreatedFromWorksOrderLineID = _data["wmsCreatedFromWorksOrderLineID"];
            this.avoMinimumCost = _data["avoMinimumCost"];
            this.avoMinimumSell = _data["avoMinimumSell"];
            this.productKitManufacturedProcessID = _data["productKitManufacturedProcessID"];
            this.productKitSellPriceGroupID = _data["productKitSellPriceGroupID"];
            this.manufacturedWorksOrderLineID = _data["manufacturedWorksOrderLineID"];
            this.productBatchOption = _data["productBatchOption"];
            this.productBatchID = _data["productBatchID"];
            this.productBatchReference = _data["productBatchReference"];
            this.shipOnSalesOrder = _data["shipOnSalesOrder"];
            this.dateExpected = _data["dateExpected"] ? new Date(_data["dateExpected"].toString()) : <any>undefined;
            this.cutToLengthDetails = _data["cutToLengthDetails"];
            this.supplierSettlementAmount = _data["supplierSettlementAmount"];
            this.manualWeight = _data["manualWeight"];
            this.avoWasteCost = _data["avoWasteCost"];
            this.cutLineID = _data["cutLineID"];
            this.requiresStock = _data["requiresStock"];
            this.useSourceTallyDuringRenesting = _data["useSourceTallyDuringRenesting"];
            this.productType = _data["productType"];
            this.productSubType = _data["productSubType"];
            this.perRuleID = _data["perRuleID"];
            this.productCode = _data["productCode"];
            this.productDescription = _data["productDescription"];
            this.productShortDescription = _data["productShortDescription"];
            this.productThickness = _data["productThickness"];
            this.productWidth = _data["productWidth"];
            this.productLength = _data["productLength"];
            this.productWeight = _data["productWeight"];
            this.productImperial = _data["productImperial"];
            this.productTallyLengths = _data["productTallyLengths"];
            this.productAvailableWidths = _data["productAvailableWidths"];
            this.productTallyLengthsPerID = _data["productTallyLengthsPerID"];
            this.productStockControlByLength = _data["productStockControlByLength"];
            this.productMaterialGradeID = _data["productMaterialGradeID"];
            this.productGroupID = _data["productGroupID"];
            this.productSpecial = _data["productSpecial"];
            this.productSpecialSourceID = _data["productSpecialSourceID"];
            this.productDefaultPiecesPerPack = _data["productDefaultPiecesPerPack"];
            this.productEnvironmentalStatusID = _data["productEnvironmentalStatusID"];
            this.cutToLengthStyle = _data["cutToLengthStyle"];
            this.productKeepStockFigures = _data["productKeepStockFigures"];
            this.productParentID = _data["productParentID"];
            this.productSalesOrderTalliedInputScreen = _data["productSalesOrderTalliedInputScreen"];
            this.standardSellPrice = _data["standardSellPrice"];
            this.standardBuyPrice = _data["standardBuyPrice"];
            this.sellPerID = _data["sellPerID"];
            this.buyPerID = _data["buyPerID"];
            this.defaultUnitSizePerID = _data["defaultUnitSizePerID"];
            this.allowMultiplePersOnUnitSizes = _data["allowMultiplePersOnUnitSizes"];
            this.productReplacementID = _data["productReplacementID"];
            this.companyStandardBuy = _data["companyStandardBuy"];
            this.companyBuyPerID = _data["companyBuyPerID"];
            this.companyStandardSell = _data["companyStandardSell"];
            this.companySellPerID = _data["companySellPerID"];
            this.branchStandardBuy = _data["branchStandardBuy"];
            this.branchBuyPerID = _data["branchBuyPerID"];
            this.branchStandardSell = _data["branchStandardSell"];
            this.branchSellPerID = _data["branchSellPerID"];
            this.productHowSourced = _data["productHowSourced"];
            this.defaultProductHowSourced = _data["defaultProductHowSourced"];
            this.packRef = _data["packRef"];
            this.tallyFromPack = _data["tallyFromPack"];
            this.packNoOfPieces = _data["packNoOfPieces"];
            this.packTotalLength = _data["packTotalLength"];
            this.packTotalVolume = _data["packTotalVolume"];
            this.packTotalLengthImperial = _data["packTotalLengthImperial"];
            this.packTotalVolumeImperial = _data["packTotalVolumeImperial"];
            this.packTotalWeight = _data["packTotalWeight"];
            this.packTotalCost = _data["packTotalCost"];
            this.packAdditionalCost = _data["packAdditionalCost"];
            this.operationName = _data["operationName"];
            this.optionName = _data["optionName"];
            this.avoOptionGLCodeProcessing = _data["avoOptionGLCodeProcessing"];
            this.avoDescription = _data["avoDescription"];
            this.costPriceCalcUseActualSize = _data["costPriceCalcUseActualSize"];
            this.sellPriceCalcUseActualSize = _data["sellPriceCalcUseActualSize"];
            this.avoOptionSupplierIDDefault = _data["avoOptionSupplierIDDefault"];
            this.avoOptionSupplierNameDefault = _data["avoOptionSupplierNameDefault"];
            this.avoOptionConcurrent = _data["avoOptionConcurrent"];
            this.avoOptionLeadTime = _data["avoOptionLeadTime"];
            this.avoOptionSupplierName = _data["avoOptionSupplierName"];
            this.completedByName = _data["completedByName"];
            this.weightPerID = _data["weightPerID"];
            this.stockTransferOrderID = _data["stockTransferOrderID"];
            this.stockTransferOrderLineID = _data["stockTransferOrderLineID"];
            this.stockTransferOrderStatus = _data["stockTransferOrderStatus"];
            this.stockTransferOrderLineNotes = _data["stockTransferOrderLineNotes"];
            this.stockTransferOrderLineSpecialInstructions = _data["stockTransferOrderLineSpecialInstructions"];
            this.stockTransferOrderLinepublicNotes = _data["stockTransferOrderLinepublicNotes"];
            this.orderLineNotes = _data["orderLineNotes"];
            this.orderLineSpecialInstructions = _data["orderLineSpecialInstructions"];
            this.orderLinepublicNotes = _data["orderLinepublicNotes"];
            this.trussTypeName = _data["trussTypeName"];
            this.lineDateTimeProcessed = _data["lineDateTimeProcessed"] ? new Date(_data["lineDateTimeProcessed"].toString()) : <any>undefined;
            this.lineProcessedByID = _data["lineProcessedByID"];
            this.processOverrideUserID = _data["processOverrideUserID"];
            this.processOverrideDateTime = _data["processOverrideDateTime"] ? new Date(_data["processOverrideDateTime"].toString()) : <any>undefined;
            this.defaultProductBatchReference = _data["defaultProductBatchReference"];
            this.productKitLineHideOnWorksOrder = _data["productKitLineHideOnWorksOrder"];
            this.productBillOfMaterialID = _data["productBillOfMaterialID"];
            this.transferOrderID = _data["transferOrderID"];
            this.supplierInvoiceStatus = _data["supplierInvoiceStatus"];
            this.totalProcessedTally = _data["totalProcessedTally"];
            this.totalProcessedQuantity = _data["totalProcessedQuantity"];
            this.totalProcessedCost = _data["totalProcessedCost"];
            this.totalProcessedCostFromAvo = _data["totalProcessedCostFromAvo"];
            this.totalProcessedVolume = _data["totalProcessedVolume"];
            this.totalProcessedWeight = _data["totalProcessedWeight"];
            this.stockTransferOrderLineInternalNotes = _data["stockTransferOrderLineInternalNotes"];
            this.orderLineInternalNotes = _data["orderLineInternalNotes"];
            this.addCostMethod = _data["addCostMethod"];
            this.processedBy = _data["processedBy"];
            this.ppQuantityUnprocessed = _data["ppQuantityUnprocessed"];
            this.ppQuantityTallyUnprocessed = _data["ppQuantityTallyUnprocessed"];
            this.wolBuyPrice = _data["wolBuyPrice"];
            this.wolBuyPerID = _data["wolBuyPerID"];
            this.wolSellPrice = _data["wolSellPrice"];
            this.wolSellPerID = _data["wolSellPerID"];
            this.stockTransferred = _data["stockTransferred"];
            this.branchID = _data["branchID"];
            this.totalLengthImperial = _data["totalLengthImperial"];
            this.totalVolumeImperial = _data["totalVolumeImperial"];
            this.linkedTotalLengthImperial = _data["linkedTotalLengthImperial"];
            this.linkedTotalVolumeImperial = _data["linkedTotalVolumeImperial"];
            this.originalUnitCostPrice = _data["originalUnitCostPrice"];
            this.originalCostPerID = _data["originalCostPerID"];
            this.originalTotalCostPrice = _data["originalTotalCostPrice"];
            this.productKitSetDescriptionFromLinesShortDescriptions = _data["productKitSetDescriptionFromLinesShortDescriptions"];
            this.forWorksOrderID = _data["forWorksOrderID"];
            this.forWorksOrderNumber = _data["forWorksOrderNumber"];
            this.forWorksOrderLineID = _data["forWorksOrderLineID"];
            this.manufacturedWorksOrderID = _data["manufacturedWorksOrderID"];
            this.manufacturedWorksOrderStatus = _data["manufacturedWorksOrderStatus"];
            this.purchaseOrderLineStatus = _data["purchaseOrderLineStatus"];
            this.manufacturedLineSetDescriptionFromLinesShortDescriptions = _data["manufacturedLineSetDescriptionFromLinesShortDescriptions"];
            this.manufacturedLineManualDescription = _data["manufacturedLineManualDescription"];
            this.wmsSent = _data["wmsSent"];
            this.wmsExpectedQuantity = _data["wmsExpectedQuantity"];
            this.wmsExpectedPerID = _data["wmsExpectedPerID"];
        }
    }

    static fromJS(data: any): WorkOrderLine {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["worksOrderLineID"] = this.worksOrderLineID;
        data["worksOrderID"] = this.worksOrderID;
        data["lineType"] = this.lineType;
        data["lineNumber"] = this.lineNumber;
        data["suggestedOrderBatchLineID"] = this.suggestedOrderBatchLineID;
        data["orderID"] = this.orderID;
        data["stockBatchID"] = this.stockBatchID;
        data["stockAllocationID"] = this.stockAllocationID;
        data["productID"] = this.productID;
        data["productKitID"] = this.productKitID;
        data["packID"] = this.packID;
        data["productKitLineID"] = this.productKitLineID;
        data["manualCode"] = this.manualCode;
        data["manualDescription"] = this.manualDescription;
        data["manualThickness"] = this.manualThickness;
        data["manualWidth"] = this.manualWidth;
        data["manualLength"] = this.manualLength;
        data["avoid"] = this.avoid;
        data["avoOptionID"] = this.avoOptionID;
        data["avoOptionSupplierID"] = this.avoOptionSupplierID;
        data["avoOptionBuyPriceRuleID"] = this.avoOptionBuyPriceRuleID;
        data["noEx"] = this.noEx;
        data["productionTime"] = this.productionTime;
        data["completedByID"] = this.completedByID;
        data["dateTimeCompleted"] = this.dateTimeCompleted ? this.dateTimeCompleted.toISOString() : <any>undefined;
        data["actualProductionTime"] = this.actualProductionTime;
        data["quantity"] = this.quantity;
        data["quantityTally"] = this.quantityTally;
        data["inputPerID"] = this.inputPerID;
        data["costPerID"] = this.costPerID;
        data["stockPerConversion"] = this.stockPerConversion;
        data["statsPerConversion"] = this.statsPerConversion;
        data["unitCostPrice"] = this.unitCostPrice;
        data["totalCostPrice"] = this.totalCostPrice;
        data["unitVMICostPrice"] = this.unitVMICostPrice;
        data["totalVMICostPrice"] = this.totalVMICostPrice;
        data["vmiRuleID"] = this.vmiRuleID;
        data["fixedPrice"] = this.fixedPrice;
        data["processCostPriceType"] = this.processCostPriceType;
        data["noOfPieces"] = this.noOfPieces;
        data["totalWeight"] = this.totalWeight;
        data["totalLength"] = this.totalLength;
        data["totalVolume"] = this.totalVolume;
        data["totalArea"] = this.totalArea;
        data["notes"] = this.notes;
        data["specialOrder"] = this.specialOrder;
        data["purchaseOrderID"] = this.purchaseOrderID;
        data["purchaseOrderQuantity"] = this.purchaseOrderQuantity;
        data["purchaseOrderQuantityReceived"] = this.purchaseOrderQuantityReceived;
        data["pendingActions"] = this.pendingActions;
        data["packConfirmed"] = this.packConfirmed;
        data["linkedToLineID"] = this.linkedToLineID;
        data["linkedTotalQuantity"] = this.linkedTotalQuantity;
        data["linkedTotalCostPrice"] = this.linkedTotalCostPrice;
        data["linkedTotalNoOfPieces"] = this.linkedTotalNoOfPieces;
        data["linkedTotalWeight"] = this.linkedTotalWeight;
        data["linkedTotalLength"] = this.linkedTotalLength;
        data["linkedTotalVolume"] = this.linkedTotalVolume;
        data["otherFlags"] = this.otherFlags;
        data["ply"] = this.ply;
        data["trussTypeID"] = this.trussTypeID;
        data["span"] = this.span;
        data["pitch"] = this.pitch;
        data["stubLeft"] = this.stubLeft;
        data["stubRight"] = this.stubRight;
        data["cantileverLeft"] = this.cantileverLeft;
        data["cantileverRight"] = this.cantileverRight;
        data["overhangLeft"] = this.overhangLeft;
        data["overhangRight"] = this.overhangRight;
        data["trussVolume"] = this.trussVolume;
        data["trussVolumeImperial"] = this.trussVolumeImperial;
        data["sourceCostMethod"] = this.sourceCostMethod;
        data["processCostMethod"] = this.processCostMethod;
        data["partProcessed"] = this.partProcessed;
        data["worksOrderPartialProcessID"] = this.worksOrderPartialProcessID;
        data["processedFromLineID"] = this.processedFromLineID;
        data["processed"] = this.processed;
        data["quantityUnprocessed"] = this.quantityUnprocessed;
        data["quantityTallyUnprocessed"] = this.quantityTallyUnprocessed;
        data["vmiSupplierInvoiceDocumentID"] = this.vmiSupplierInvoiceDocumentID;
        data["vmiReconciled"] = this.vmiReconciled;
        data["machineID"] = this.machineID;
        data["scheduleID"] = this.scheduleID;
        data["worksOrderProcessHeaderID"] = this.worksOrderProcessHeaderID;
        data["totalVMICostInCurrency"] = this.totalVMICostInCurrency;
        data["unitVMICostInCurrency"] = this.unitVMICostInCurrency;
        data["vmiExchangeRate"] = this.vmiExchangeRate;
        data["avoOptionCurrencyID"] = this.avoOptionCurrencyID;
        data["avoOptionExchangeRate"] = this.avoOptionExchangeRate;
        data["avoOptionUnitCostInCurrency"] = this.avoOptionUnitCostInCurrency;
        data["avoOptionTotalCostInCurrency"] = this.avoOptionTotalCostInCurrency;
        data["importedFromMiTek"] = this.importedFromMiTek;
        data["prorateToLinked"] = this.prorateToLinked;
        data["totalCostFromAVO"] = this.totalCostFromAVO;
        data["wmsProcessed"] = this.wmsProcessed;
        data["wmsParentLineID"] = this.wmsParentLineID;
        data["wmsCreatedFromWorksOrderLineID"] = this.wmsCreatedFromWorksOrderLineID;
        data["avoMinimumCost"] = this.avoMinimumCost;
        data["avoMinimumSell"] = this.avoMinimumSell;
        data["productKitManufacturedProcessID"] = this.productKitManufacturedProcessID;
        data["productKitSellPriceGroupID"] = this.productKitSellPriceGroupID;
        data["manufacturedWorksOrderLineID"] = this.manufacturedWorksOrderLineID;
        data["productBatchOption"] = this.productBatchOption;
        data["productBatchID"] = this.productBatchID;
        data["productBatchReference"] = this.productBatchReference;
        data["shipOnSalesOrder"] = this.shipOnSalesOrder;
        data["dateExpected"] = this.dateExpected ? this.dateExpected.toISOString() : <any>undefined;
        data["cutToLengthDetails"] = this.cutToLengthDetails;
        data["supplierSettlementAmount"] = this.supplierSettlementAmount;
        data["manualWeight"] = this.manualWeight;
        data["avoWasteCost"] = this.avoWasteCost;
        data["cutLineID"] = this.cutLineID;
        data["requiresStock"] = this.requiresStock;
        data["useSourceTallyDuringRenesting"] = this.useSourceTallyDuringRenesting;
        data["productType"] = this.productType;
        data["productSubType"] = this.productSubType;
        data["perRuleID"] = this.perRuleID;
        data["productCode"] = this.productCode;
        data["productDescription"] = this.productDescription;
        data["productShortDescription"] = this.productShortDescription;
        data["productThickness"] = this.productThickness;
        data["productWidth"] = this.productWidth;
        data["productLength"] = this.productLength;
        data["productWeight"] = this.productWeight;
        data["productImperial"] = this.productImperial;
        data["productTallyLengths"] = this.productTallyLengths;
        data["productAvailableWidths"] = this.productAvailableWidths;
        data["productTallyLengthsPerID"] = this.productTallyLengthsPerID;
        data["productStockControlByLength"] = this.productStockControlByLength;
        data["productMaterialGradeID"] = this.productMaterialGradeID;
        data["productGroupID"] = this.productGroupID;
        data["productSpecial"] = this.productSpecial;
        data["productSpecialSourceID"] = this.productSpecialSourceID;
        data["productDefaultPiecesPerPack"] = this.productDefaultPiecesPerPack;
        data["productEnvironmentalStatusID"] = this.productEnvironmentalStatusID;
        data["cutToLengthStyle"] = this.cutToLengthStyle;
        data["productKeepStockFigures"] = this.productKeepStockFigures;
        data["productParentID"] = this.productParentID;
        data["productSalesOrderTalliedInputScreen"] = this.productSalesOrderTalliedInputScreen;
        data["standardSellPrice"] = this.standardSellPrice;
        data["standardBuyPrice"] = this.standardBuyPrice;
        data["sellPerID"] = this.sellPerID;
        data["buyPerID"] = this.buyPerID;
        data["defaultUnitSizePerID"] = this.defaultUnitSizePerID;
        data["allowMultiplePersOnUnitSizes"] = this.allowMultiplePersOnUnitSizes;
        data["productReplacementID"] = this.productReplacementID;
        data["companyStandardBuy"] = this.companyStandardBuy;
        data["companyBuyPerID"] = this.companyBuyPerID;
        data["companyStandardSell"] = this.companyStandardSell;
        data["companySellPerID"] = this.companySellPerID;
        data["branchStandardBuy"] = this.branchStandardBuy;
        data["branchBuyPerID"] = this.branchBuyPerID;
        data["branchStandardSell"] = this.branchStandardSell;
        data["branchSellPerID"] = this.branchSellPerID;
        data["productHowSourced"] = this.productHowSourced;
        data["defaultProductHowSourced"] = this.defaultProductHowSourced;
        data["packRef"] = this.packRef;
        data["tallyFromPack"] = this.tallyFromPack;
        data["packNoOfPieces"] = this.packNoOfPieces;
        data["packTotalLength"] = this.packTotalLength;
        data["packTotalVolume"] = this.packTotalVolume;
        data["packTotalLengthImperial"] = this.packTotalLengthImperial;
        data["packTotalVolumeImperial"] = this.packTotalVolumeImperial;
        data["packTotalWeight"] = this.packTotalWeight;
        data["packTotalCost"] = this.packTotalCost;
        data["packAdditionalCost"] = this.packAdditionalCost;
        data["operationName"] = this.operationName;
        data["optionName"] = this.optionName;
        data["avoOptionGLCodeProcessing"] = this.avoOptionGLCodeProcessing;
        data["avoDescription"] = this.avoDescription;
        data["costPriceCalcUseActualSize"] = this.costPriceCalcUseActualSize;
        data["sellPriceCalcUseActualSize"] = this.sellPriceCalcUseActualSize;
        data["avoOptionSupplierIDDefault"] = this.avoOptionSupplierIDDefault;
        data["avoOptionSupplierNameDefault"] = this.avoOptionSupplierNameDefault;
        data["avoOptionConcurrent"] = this.avoOptionConcurrent;
        data["avoOptionLeadTime"] = this.avoOptionLeadTime;
        data["avoOptionSupplierName"] = this.avoOptionSupplierName;
        data["completedByName"] = this.completedByName;
        data["weightPerID"] = this.weightPerID;
        data["stockTransferOrderID"] = this.stockTransferOrderID;
        data["stockTransferOrderLineID"] = this.stockTransferOrderLineID;
        data["stockTransferOrderStatus"] = this.stockTransferOrderStatus;
        data["stockTransferOrderLineNotes"] = this.stockTransferOrderLineNotes;
        data["stockTransferOrderLineSpecialInstructions"] = this.stockTransferOrderLineSpecialInstructions;
        data["stockTransferOrderLinepublicNotes"] = this.stockTransferOrderLinepublicNotes;
        data["orderLineNotes"] = this.orderLineNotes;
        data["orderLineSpecialInstructions"] = this.orderLineSpecialInstructions;
        data["orderLinepublicNotes"] = this.orderLinepublicNotes;
        data["trussTypeName"] = this.trussTypeName;
        data["lineDateTimeProcessed"] = this.lineDateTimeProcessed ? this.lineDateTimeProcessed.toISOString() : <any>undefined;
        data["lineProcessedByID"] = this.lineProcessedByID;
        data["processOverrideUserID"] = this.processOverrideUserID;
        data["processOverrideDateTime"] = this.processOverrideDateTime ? this.processOverrideDateTime.toISOString() : <any>undefined;
        data["defaultProductBatchReference"] = this.defaultProductBatchReference;
        data["productKitLineHideOnWorksOrder"] = this.productKitLineHideOnWorksOrder;
        data["productBillOfMaterialID"] = this.productBillOfMaterialID;
        data["transferOrderID"] = this.transferOrderID;
        data["supplierInvoiceStatus"] = this.supplierInvoiceStatus;
        data["totalProcessedTally"] = this.totalProcessedTally;
        data["totalProcessedQuantity"] = this.totalProcessedQuantity;
        data["totalProcessedCost"] = this.totalProcessedCost;
        data["totalProcessedCostFromAvo"] = this.totalProcessedCostFromAvo;
        data["totalProcessedVolume"] = this.totalProcessedVolume;
        data["totalProcessedWeight"] = this.totalProcessedWeight;
        data["stockTransferOrderLineInternalNotes"] = this.stockTransferOrderLineInternalNotes;
        data["orderLineInternalNotes"] = this.orderLineInternalNotes;
        data["addCostMethod"] = this.addCostMethod;
        data["processedBy"] = this.processedBy;
        data["ppQuantityUnprocessed"] = this.ppQuantityUnprocessed;
        data["ppQuantityTallyUnprocessed"] = this.ppQuantityTallyUnprocessed;
        data["wolBuyPrice"] = this.wolBuyPrice;
        data["wolBuyPerID"] = this.wolBuyPerID;
        data["wolSellPrice"] = this.wolSellPrice;
        data["wolSellPerID"] = this.wolSellPerID;
        data["stockTransferred"] = this.stockTransferred;
        data["branchID"] = this.branchID;
        data["totalLengthImperial"] = this.totalLengthImperial;
        data["totalVolumeImperial"] = this.totalVolumeImperial;
        data["linkedTotalLengthImperial"] = this.linkedTotalLengthImperial;
        data["linkedTotalVolumeImperial"] = this.linkedTotalVolumeImperial;
        data["originalUnitCostPrice"] = this.originalUnitCostPrice;
        data["originalCostPerID"] = this.originalCostPerID;
        data["originalTotalCostPrice"] = this.originalTotalCostPrice;
        data["productKitSetDescriptionFromLinesShortDescriptions"] = this.productKitSetDescriptionFromLinesShortDescriptions;
        data["forWorksOrderID"] = this.forWorksOrderID;
        data["forWorksOrderNumber"] = this.forWorksOrderNumber;
        data["forWorksOrderLineID"] = this.forWorksOrderLineID;
        data["manufacturedWorksOrderID"] = this.manufacturedWorksOrderID;
        data["manufacturedWorksOrderStatus"] = this.manufacturedWorksOrderStatus;
        data["purchaseOrderLineStatus"] = this.purchaseOrderLineStatus;
        data["manufacturedLineSetDescriptionFromLinesShortDescriptions"] = this.manufacturedLineSetDescriptionFromLinesShortDescriptions;
        data["manufacturedLineManualDescription"] = this.manufacturedLineManualDescription;
        data["wmsSent"] = this.wmsSent;
        data["wmsExpectedQuantity"] = this.wmsExpectedQuantity;
        data["wmsExpectedPerID"] = this.wmsExpectedPerID;
        return data; 
    }
}

export interface IWorkOrderLine {
    worksOrderLineID?: number | undefined;
    worksOrderID?: number | undefined;
    lineType?: number | undefined;
    lineNumber?: number | undefined;
    suggestedOrderBatchLineID?: number | undefined;
    orderID?: number | undefined;
    stockBatchID?: number | undefined;
    stockAllocationID?: number | undefined;
    productID?: number | undefined;
    productKitID?: number | undefined;
    packID?: number | undefined;
    productKitLineID?: number | undefined;
    manualCode?: string | undefined;
    manualDescription?: string | undefined;
    manualThickness?: number | undefined;
    manualWidth?: number | undefined;
    manualLength?: number | undefined;
    avoid?: number | undefined;
    avoOptionID?: number | undefined;
    avoOptionSupplierID?: number | undefined;
    avoOptionBuyPriceRuleID?: number | undefined;
    noEx?: number | undefined;
    productionTime?: number | undefined;
    completedByID?: number | undefined;
    dateTimeCompleted?: Date | undefined;
    actualProductionTime?: number | undefined;
    quantity?: number | undefined;
    quantityTally?: string | undefined;
    inputPerID?: number | undefined;
    costPerID?: number | undefined;
    stockPerConversion?: number | undefined;
    statsPerConversion?: number | undefined;
    unitCostPrice?: number | undefined;
    totalCostPrice?: number | undefined;
    unitVMICostPrice?: number | undefined;
    totalVMICostPrice?: number | undefined;
    vmiRuleID?: number | undefined;
    fixedPrice?: boolean | undefined;
    processCostPriceType?: number | undefined;
    noOfPieces?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    totalArea?: number | undefined;
    notes?: string | undefined;
    specialOrder?: boolean | undefined;
    purchaseOrderID?: number | undefined;
    purchaseOrderQuantity?: number | undefined;
    purchaseOrderQuantityReceived?: number | undefined;
    pendingActions?: number | undefined;
    packConfirmed?: boolean | undefined;
    linkedToLineID?: number | undefined;
    linkedTotalQuantity?: number | undefined;
    linkedTotalCostPrice?: number | undefined;
    linkedTotalNoOfPieces?: number | undefined;
    linkedTotalWeight?: number | undefined;
    linkedTotalLength?: number | undefined;
    linkedTotalVolume?: number | undefined;
    otherFlags?: number | undefined;
    ply?: number | undefined;
    trussTypeID?: number | undefined;
    span?: number | undefined;
    pitch?: number | undefined;
    stubLeft?: number | undefined;
    stubRight?: number | undefined;
    cantileverLeft?: number | undefined;
    cantileverRight?: number | undefined;
    overhangLeft?: number | undefined;
    overhangRight?: number | undefined;
    trussVolume?: number | undefined;
    trussVolumeImperial?: number | undefined;
    sourceCostMethod?: number | undefined;
    processCostMethod?: number | undefined;
    partProcessed?: boolean | undefined;
    worksOrderPartialProcessID?: number | undefined;
    processedFromLineID?: number | undefined;
    processed?: boolean | undefined;
    quantityUnprocessed?: number | undefined;
    quantityTallyUnprocessed?: string | undefined;
    vmiSupplierInvoiceDocumentID?: number | undefined;
    vmiReconciled?: boolean | undefined;
    machineID?: number | undefined;
    scheduleID?: number | undefined;
    worksOrderProcessHeaderID?: number | undefined;
    totalVMICostInCurrency?: number | undefined;
    unitVMICostInCurrency?: number | undefined;
    vmiExchangeRate?: number | undefined;
    avoOptionCurrencyID?: number | undefined;
    avoOptionExchangeRate?: number | undefined;
    avoOptionUnitCostInCurrency?: number | undefined;
    avoOptionTotalCostInCurrency?: number | undefined;
    importedFromMiTek?: boolean | undefined;
    prorateToLinked?: boolean | undefined;
    totalCostFromAVO?: number | undefined;
    wmsProcessed?: boolean | undefined;
    wmsParentLineID?: number | undefined;
    wmsCreatedFromWorksOrderLineID?: number | undefined;
    avoMinimumCost?: number | undefined;
    avoMinimumSell?: number | undefined;
    productKitManufacturedProcessID?: number | undefined;
    productKitSellPriceGroupID?: number | undefined;
    manufacturedWorksOrderLineID?: number | undefined;
    productBatchOption?: number | undefined;
    productBatchID?: number | undefined;
    productBatchReference?: string | undefined;
    shipOnSalesOrder?: boolean | undefined;
    dateExpected?: Date | undefined;
    cutToLengthDetails?: string | undefined;
    supplierSettlementAmount?: number | undefined;
    manualWeight?: number | undefined;
    avoWasteCost?: number | undefined;
    cutLineID?: number | undefined;
    requiresStock?: boolean | undefined;
    useSourceTallyDuringRenesting?: boolean | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    perRuleID?: number | undefined;
    productCode?: string | undefined;
    productDescription?: string | undefined;
    productShortDescription?: string | undefined;
    productThickness?: number | undefined;
    productWidth?: number | undefined;
    productLength?: number | undefined;
    productWeight?: number | undefined;
    productImperial?: boolean | undefined;
    productTallyLengths?: string | undefined;
    productAvailableWidths?: string | undefined;
    productTallyLengthsPerID?: number | undefined;
    productStockControlByLength?: boolean | undefined;
    productMaterialGradeID?: number | undefined;
    productGroupID?: number | undefined;
    productSpecial?: boolean | undefined;
    productSpecialSourceID?: number | undefined;
    productDefaultPiecesPerPack?: number | undefined;
    productEnvironmentalStatusID?: number | undefined;
    cutToLengthStyle?: number | undefined;
    productKeepStockFigures?: boolean | undefined;
    productParentID?: number | undefined;
    productSalesOrderTalliedInputScreen?: number | undefined;
    standardSellPrice?: number | undefined;
    standardBuyPrice?: number | undefined;
    sellPerID?: number | undefined;
    buyPerID?: number | undefined;
    defaultUnitSizePerID?: number | undefined;
    allowMultiplePersOnUnitSizes?: boolean | undefined;
    productReplacementID?: number | undefined;
    companyStandardBuy?: number | undefined;
    companyBuyPerID?: number | undefined;
    companyStandardSell?: number | undefined;
    companySellPerID?: number | undefined;
    branchStandardBuy?: number | undefined;
    branchBuyPerID?: number | undefined;
    branchStandardSell?: number | undefined;
    branchSellPerID?: number | undefined;
    productHowSourced?: number | undefined;
    defaultProductHowSourced?: number | undefined;
    packRef?: string | undefined;
    tallyFromPack?: string | undefined;
    packNoOfPieces?: number | undefined;
    packTotalLength?: number | undefined;
    packTotalVolume?: number | undefined;
    packTotalLengthImperial?: number | undefined;
    packTotalVolumeImperial?: number | undefined;
    packTotalWeight?: number | undefined;
    packTotalCost?: number | undefined;
    packAdditionalCost?: number | undefined;
    operationName?: string | undefined;
    optionName?: string | undefined;
    avoOptionGLCodeProcessing?: string | undefined;
    avoDescription?: string | undefined;
    costPriceCalcUseActualSize?: boolean | undefined;
    sellPriceCalcUseActualSize?: boolean | undefined;
    avoOptionSupplierIDDefault?: number | undefined;
    avoOptionSupplierNameDefault?: string | undefined;
    avoOptionConcurrent?: boolean | undefined;
    avoOptionLeadTime?: number | undefined;
    avoOptionSupplierName?: string | undefined;
    completedByName?: string | undefined;
    weightPerID?: number | undefined;
    stockTransferOrderID?: number | undefined;
    stockTransferOrderLineID?: number | undefined;
    stockTransferOrderStatus?: number | undefined;
    stockTransferOrderLineNotes?: string | undefined;
    stockTransferOrderLineSpecialInstructions?: string | undefined;
    stockTransferOrderLinepublicNotes?: string | undefined;
    orderLineNotes?: string | undefined;
    orderLineSpecialInstructions?: string | undefined;
    orderLinepublicNotes?: string | undefined;
    trussTypeName?: string | undefined;
    lineDateTimeProcessed?: Date | undefined;
    lineProcessedByID?: number | undefined;
    processOverrideUserID?: number | undefined;
    processOverrideDateTime?: Date | undefined;
    defaultProductBatchReference?: string | undefined;
    productKitLineHideOnWorksOrder?: boolean | undefined;
    productBillOfMaterialID?: number | undefined;
    transferOrderID?: number | undefined;
    supplierInvoiceStatus?: number | undefined;
    totalProcessedTally?: number | undefined;
    totalProcessedQuantity?: number | undefined;
    totalProcessedCost?: number | undefined;
    totalProcessedCostFromAvo?: number | undefined;
    totalProcessedVolume?: number | undefined;
    totalProcessedWeight?: number | undefined;
    stockTransferOrderLineInternalNotes?: string | undefined;
    orderLineInternalNotes?: string | undefined;
    addCostMethod?: number | undefined;
    processedBy?: string | undefined;
    ppQuantityUnprocessed?: number | undefined;
    ppQuantityTallyUnprocessed?: string | undefined;
    wolBuyPrice?: number | undefined;
    wolBuyPerID?: number | undefined;
    wolSellPrice?: number | undefined;
    wolSellPerID?: number | undefined;
    stockTransferred?: boolean | undefined;
    branchID?: any | undefined;
    totalLengthImperial?: number | undefined;
    totalVolumeImperial?: number | undefined;
    linkedTotalLengthImperial?: number | undefined;
    linkedTotalVolumeImperial?: number | undefined;
    originalUnitCostPrice?: number | undefined;
    originalCostPerID?: number | undefined;
    originalTotalCostPrice?: number | undefined;
    productKitSetDescriptionFromLinesShortDescriptions?: boolean | undefined;
    forWorksOrderID?: number | undefined;
    forWorksOrderNumber?: number | undefined;
    forWorksOrderLineID?: number | undefined;
    manufacturedWorksOrderID?: number | undefined;
    manufacturedWorksOrderStatus?: number | undefined;
    purchaseOrderLineStatus?: number | undefined;
    manufacturedLineSetDescriptionFromLinesShortDescriptions?: boolean | undefined;
    manufacturedLineManualDescription?: string | undefined;
    wmsSent?: boolean | undefined;
    wmsExpectedQuantity?: number | undefined;
    wmsExpectedPerID?: number | undefined;
}

export class WorkOrderAdditionalCost implements IWorkOrderAdditionalCost {
    worksOrderAddCostID?: number | undefined;
    worksOrderID?: number | undefined;
    additionalCostChargeID?: number | undefined;
    basedOn?: number | undefined;
    supplierID?: number | undefined;
    reference?: string | undefined;
    currencyID?: number | undefined;
    estimateExchangeRate?: number | undefined;
    estimateCost?: number | undefined;
    estimateCostInCurrency?: number | undefined;
    estimatePercentEntered?: number | undefined;
    actualExchangeRate?: number | undefined;
    actualCost?: number | undefined;
    actualCostInCurrency?: number | undefined;
    costPriceValueInCurrency?: number | undefined;
    costPriceValueType?: number | undefined;
    costProRateBy?: number | undefined;
    glCodePayable?: string | undefined;
    notes?: string | undefined;
    dateTimeCreated?: Date | undefined;
    invoiced?: boolean | undefined;
    deleted?: number | undefined;
    description?: string | undefined;
    costCalcUseActualSize?: boolean | undefined;
    chargeCalcUseActualSize?: boolean | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;
    sihDateTimeApproved?: Date | undefined;
    totalProcessedCost?: number | undefined;
    state?: any | undefined;

    constructor(data?: IWorkOrderAdditionalCost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.worksOrderAddCostID = _data["worksOrderAddCostID"];
            this.worksOrderID = _data["worksOrderID"];
            this.additionalCostChargeID = _data["additionalCostChargeID"];
            this.basedOn = _data["basedOn"];
            this.supplierID = _data["supplierID"];
            this.reference = _data["reference"];
            this.currencyID = _data["currencyID"];
            this.estimateExchangeRate = _data["estimateExchangeRate"];
            this.estimateCost = _data["estimateCost"];
            this.estimateCostInCurrency = _data["estimateCostInCurrency"];
            this.estimatePercentEntered = _data["estimatePercentEntered"];
            this.actualExchangeRate = _data["actualExchangeRate"];
            this.actualCost = _data["actualCost"];
            this.actualCostInCurrency = _data["actualCostInCurrency"];
            this.costPriceValueInCurrency = _data["costPriceValueInCurrency"];
            this.costPriceValueType = _data["costPriceValueType"];
            this.costProRateBy = _data["costProRateBy"];
            this.glCodePayable = _data["glCodePayable"];
            this.notes = _data["notes"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.invoiced = _data["invoiced"];
            this.deleted = _data["deleted"];
            this.description = _data["description"];
            this.costCalcUseActualSize = _data["costCalcUseActualSize"];
            this.chargeCalcUseActualSize = _data["chargeCalcUseActualSize"];
            this.supplierCode = _data["supplierCode"];
            this.supplierName = _data["supplierName"];
            this.sihDateTimeApproved = _data["sihDateTimeApproved"] ? new Date(_data["sihDateTimeApproved"].toString()) : <any>undefined;
            this.totalProcessedCost = _data["totalProcessedCost"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): WorkOrderAdditionalCost {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderAdditionalCost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["worksOrderAddCostID"] = this.worksOrderAddCostID;
        data["worksOrderID"] = this.worksOrderID;
        data["additionalCostChargeID"] = this.additionalCostChargeID;
        data["basedOn"] = this.basedOn;
        data["supplierID"] = this.supplierID;
        data["reference"] = this.reference;
        data["currencyID"] = this.currencyID;
        data["estimateExchangeRate"] = this.estimateExchangeRate;
        data["estimateCost"] = this.estimateCost;
        data["estimateCostInCurrency"] = this.estimateCostInCurrency;
        data["estimatePercentEntered"] = this.estimatePercentEntered;
        data["actualExchangeRate"] = this.actualExchangeRate;
        data["actualCost"] = this.actualCost;
        data["actualCostInCurrency"] = this.actualCostInCurrency;
        data["costPriceValueInCurrency"] = this.costPriceValueInCurrency;
        data["costPriceValueType"] = this.costPriceValueType;
        data["costProRateBy"] = this.costProRateBy;
        data["glCodePayable"] = this.glCodePayable;
        data["notes"] = this.notes;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["invoiced"] = this.invoiced;
        data["deleted"] = this.deleted;
        data["description"] = this.description;
        data["costCalcUseActualSize"] = this.costCalcUseActualSize;
        data["chargeCalcUseActualSize"] = this.chargeCalcUseActualSize;
        data["supplierCode"] = this.supplierCode;
        data["supplierName"] = this.supplierName;
        data["sihDateTimeApproved"] = this.sihDateTimeApproved ? this.sihDateTimeApproved.toISOString() : <any>undefined;
        data["totalProcessedCost"] = this.totalProcessedCost;
        data["state"] = this.state;
        return data; 
    }
}

export interface IWorkOrderAdditionalCost {
    worksOrderAddCostID?: number | undefined;
    worksOrderID?: number | undefined;
    additionalCostChargeID?: number | undefined;
    basedOn?: number | undefined;
    supplierID?: number | undefined;
    reference?: string | undefined;
    currencyID?: number | undefined;
    estimateExchangeRate?: number | undefined;
    estimateCost?: number | undefined;
    estimateCostInCurrency?: number | undefined;
    estimatePercentEntered?: number | undefined;
    actualExchangeRate?: number | undefined;
    actualCost?: number | undefined;
    actualCostInCurrency?: number | undefined;
    costPriceValueInCurrency?: number | undefined;
    costPriceValueType?: number | undefined;
    costProRateBy?: number | undefined;
    glCodePayable?: string | undefined;
    notes?: string | undefined;
    dateTimeCreated?: Date | undefined;
    invoiced?: boolean | undefined;
    deleted?: number | undefined;
    description?: string | undefined;
    costCalcUseActualSize?: boolean | undefined;
    chargeCalcUseActualSize?: boolean | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;
    sihDateTimeApproved?: Date | undefined;
    totalProcessedCost?: number | undefined;
    state?: any | undefined;
}

export class WorkOrderProcessHeader implements IWorkOrderProcessHeader {
    worksOrderProcessHeaderID?: number | undefined;
    worksOrderID?: number | undefined;
    description?: string | undefined;
    supplierWillCollect?: boolean | undefined;
    collectFromSupplier?: boolean | undefined;
    supplierID?: number | undefined;
    supplierAddressID?: number | undefined;
    pickedUserID?: number | undefined;
    pickedDateTime?: Date | undefined;
    deliveredOrCollectedUserID?: number | undefined;
    deliveredOrCollectedDateTime?: Date | undefined;
    deliveredOrCollectedReference?: string | undefined;
    readyForCollectionUserID?: number | undefined;
    readyForCollectionDateTime?: Date | undefined;
    receivedUserID?: number | undefined;
    receivedDateTime?: Date | undefined;
    receivedReference?: string | undefined;
    journeyOutID?: number | undefined;
    journeyInID?: number | undefined;
    outputDescription?: string | undefined;
    pickingDueDate?: Date | undefined;
    pickingDueOption?: number | undefined;
    completionDueDate?: Date | undefined;
    completionDueOption?: number | undefined;
    status?: number | undefined;
    state?: number | undefined;
    printTheseFormats?: string | undefined;

    constructor(data?: IWorkOrderProcessHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.worksOrderProcessHeaderID = _data["worksOrderProcessHeaderID"];
            this.worksOrderID = _data["worksOrderID"];
            this.description = _data["description"];
            this.supplierWillCollect = _data["supplierWillCollect"];
            this.collectFromSupplier = _data["collectFromSupplier"];
            this.supplierID = _data["supplierID"];
            this.supplierAddressID = _data["supplierAddressID"];
            this.pickedUserID = _data["pickedUserID"];
            this.pickedDateTime = _data["pickedDateTime"] ? new Date(_data["pickedDateTime"].toString()) : <any>undefined;
            this.deliveredOrCollectedUserID = _data["deliveredOrCollectedUserID"];
            this.deliveredOrCollectedDateTime = _data["deliveredOrCollectedDateTime"] ? new Date(_data["deliveredOrCollectedDateTime"].toString()) : <any>undefined;
            this.deliveredOrCollectedReference = _data["deliveredOrCollectedReference"];
            this.readyForCollectionUserID = _data["readyForCollectionUserID"];
            this.readyForCollectionDateTime = _data["readyForCollectionDateTime"] ? new Date(_data["readyForCollectionDateTime"].toString()) : <any>undefined;
            this.receivedUserID = _data["receivedUserID"];
            this.receivedDateTime = _data["receivedDateTime"] ? new Date(_data["receivedDateTime"].toString()) : <any>undefined;
            this.receivedReference = _data["receivedReference"];
            this.journeyOutID = _data["journeyOutID"];
            this.journeyInID = _data["journeyInID"];
            this.outputDescription = _data["outputDescription"];
            this.pickingDueDate = _data["pickingDueDate"] ? new Date(_data["pickingDueDate"].toString()) : <any>undefined;
            this.pickingDueOption = _data["pickingDueOption"];
            this.completionDueDate = _data["completionDueDate"] ? new Date(_data["completionDueDate"].toString()) : <any>undefined;
            this.completionDueOption = _data["completionDueOption"];
            this.status = _data["status"];
            this.state = _data["state"];
            this.printTheseFormats = _data["printTheseFormats"];
        }
    }

    static fromJS(data: any): WorkOrderProcessHeader {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderProcessHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["worksOrderProcessHeaderID"] = this.worksOrderProcessHeaderID;
        data["worksOrderID"] = this.worksOrderID;
        data["description"] = this.description;
        data["supplierWillCollect"] = this.supplierWillCollect;
        data["collectFromSupplier"] = this.collectFromSupplier;
        data["supplierID"] = this.supplierID;
        data["supplierAddressID"] = this.supplierAddressID;
        data["pickedUserID"] = this.pickedUserID;
        data["pickedDateTime"] = this.pickedDateTime ? this.pickedDateTime.toISOString() : <any>undefined;
        data["deliveredOrCollectedUserID"] = this.deliveredOrCollectedUserID;
        data["deliveredOrCollectedDateTime"] = this.deliveredOrCollectedDateTime ? this.deliveredOrCollectedDateTime.toISOString() : <any>undefined;
        data["deliveredOrCollectedReference"] = this.deliveredOrCollectedReference;
        data["readyForCollectionUserID"] = this.readyForCollectionUserID;
        data["readyForCollectionDateTime"] = this.readyForCollectionDateTime ? this.readyForCollectionDateTime.toISOString() : <any>undefined;
        data["receivedUserID"] = this.receivedUserID;
        data["receivedDateTime"] = this.receivedDateTime ? this.receivedDateTime.toISOString() : <any>undefined;
        data["receivedReference"] = this.receivedReference;
        data["journeyOutID"] = this.journeyOutID;
        data["journeyInID"] = this.journeyInID;
        data["outputDescription"] = this.outputDescription;
        data["pickingDueDate"] = this.pickingDueDate ? this.pickingDueDate.toISOString() : <any>undefined;
        data["pickingDueOption"] = this.pickingDueOption;
        data["completionDueDate"] = this.completionDueDate ? this.completionDueDate.toISOString() : <any>undefined;
        data["completionDueOption"] = this.completionDueOption;
        data["status"] = this.status;
        data["state"] = this.state;
        data["printTheseFormats"] = this.printTheseFormats;
        return data; 
    }
}

export interface IWorkOrderProcessHeader {
    worksOrderProcessHeaderID?: number | undefined;
    worksOrderID?: number | undefined;
    description?: string | undefined;
    supplierWillCollect?: boolean | undefined;
    collectFromSupplier?: boolean | undefined;
    supplierID?: number | undefined;
    supplierAddressID?: number | undefined;
    pickedUserID?: number | undefined;
    pickedDateTime?: Date | undefined;
    deliveredOrCollectedUserID?: number | undefined;
    deliveredOrCollectedDateTime?: Date | undefined;
    deliveredOrCollectedReference?: string | undefined;
    readyForCollectionUserID?: number | undefined;
    readyForCollectionDateTime?: Date | undefined;
    receivedUserID?: number | undefined;
    receivedDateTime?: Date | undefined;
    receivedReference?: string | undefined;
    journeyOutID?: number | undefined;
    journeyInID?: number | undefined;
    outputDescription?: string | undefined;
    pickingDueDate?: Date | undefined;
    pickingDueOption?: number | undefined;
    completionDueDate?: Date | undefined;
    completionDueOption?: number | undefined;
    status?: number | undefined;
    state?: number | undefined;
    printTheseFormats?: string | undefined;
}

export class WorksOrderFinishedAddCost implements IWorksOrderFinishedAddCost {
    finishedWorksOrderLineID?: number | undefined;
    worksOrderAddCostID?: number | undefined;
    percentAllocated?: number | undefined;

    constructor(data?: IWorksOrderFinishedAddCost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.finishedWorksOrderLineID = _data["finishedWorksOrderLineID"];
            this.worksOrderAddCostID = _data["worksOrderAddCostID"];
            this.percentAllocated = _data["percentAllocated"];
        }
    }

    static fromJS(data: any): WorksOrderFinishedAddCost {
        data = typeof data === 'object' ? data : {};
        let result = new WorksOrderFinishedAddCost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finishedWorksOrderLineID"] = this.finishedWorksOrderLineID;
        data["worksOrderAddCostID"] = this.worksOrderAddCostID;
        data["percentAllocated"] = this.percentAllocated;
        return data; 
    }
}

export interface IWorksOrderFinishedAddCost {
    finishedWorksOrderLineID?: number | undefined;
    worksOrderAddCostID?: number | undefined;
    percentAllocated?: number | undefined;
}

export class CreditNoteHeader implements ICreditNoteHeader {
    creditNoteID?: number | undefined;
    creditNoteNumber?: number | undefined;
    creditDate?: Date | undefined;
    cashSale?: boolean | undefined;
    handling?: number | undefined;
    branchID?: number | undefined;
    customerID?: number | undefined;
    invoiceID?: number | undefined;
    orderID?: number | undefined;
    invoiceAddressID?: number | undefined;
    invoiceAddress?: string | undefined;
    reasonID?: number | undefined;
    contact?: string | undefined;
    ourRef?: string | undefined;
    yourRef?: string | undefined;
    showEurosOnCreditNote?: boolean | undefined;
    description?: string | undefined;
    currencyID?: number | undefined;
    exchangeRate?: number | undefined;
    cashAccountBalanceAmount?: number | undefined;
    totalAmount?: number | undefined;
    totalAmountInCurrency?: number | undefined;
    totalVatAmount?: number | undefined;
    totalVatAmountInCurrency?: number | undefined;
    totalTax?: number | undefined;
    totalTaxInCurrency?: number | undefined;
    totalCost?: number | undefined;
    commissionTotalCost?: number | undefined;
    totalWeight?: number | undefined;
    dueDate?: Date | undefined;
    settlementDiscount?: number | undefined;
    settlementDate?: Date | undefined;
    settlementAmount?: number | undefined;
    taxSettlementAmount?: number | undefined;
    nonDiscountAmount?: number | undefined;
    nonDiscountAmountInCurrency?: number | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    dateTimeApproved?: Date | undefined;
    approvedByID?: number | undefined;
    dateTimeReleased?: Date | undefined;
    releasedByID?: number | undefined;
    notes?: string | undefined;
    emailed?: boolean | undefined;
    faxed?: boolean | undefined;
    sent?: boolean | undefined;
    printed?: boolean | undefined;
    imaged?: number | undefined;
    paidByID?: number | undefined;
    ediDocumentID?: number | undefined;
    ediSendInvoice?: boolean | undefined;
    markedAsReturned?: boolean | undefined;
    journeyID?: number | undefined;
    computerID?: number | undefined;
    arCustomerID?: number | undefined;
    arAddressID?: number | undefined;
    taxAdjustmentType?: number | undefined;
    correctedTaxAreaID?: number | undefined;
    correctedUseTaxExemptCert?: boolean | undefined;
    notepadCaseID?: number | undefined;
    contractID?: number | undefined;
    contractInvoicingLineID?: number | undefined;
    taxAreaID?: number | undefined;
    useTaxExemptCertificate?: boolean | undefined;
    taxVerifiedByID?: number | undefined;
    paymentTermsID?: number | undefined;
    dateRequired?: Date | undefined;
    outstandingRefund?: number | undefined;
    deliveryAddressID?: number | undefined;
    deliveryAddress?: string | undefined;
    nonSalesAmount?: number | undefined;
    nonSalesAmountInCurrency?: number | undefined;
    wmsRefusedOnTruckOrderID?: number | undefined;
    totalMargin?: number | undefined;
    internalCostTotalMargin?: number | undefined;
    takenByID?: number | undefined;
    vehicleTypeID?: number | undefined;
    vehicleID?: number | undefined;
    deliveryAreaID?: number | undefined;
    lastModifiedByID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    deleted?: boolean | undefined;
    rebill?: boolean | undefined;
    taxUsageTypeID?: number | undefined;
    contractInvoicing?: boolean | undefined;
    scaleGrossWeight?: number | undefined;
    creditOnHold?: boolean | undefined;
    authorizedByID?: number | undefined;
    branchName?: string | undefined;
    branchTaxAreaID?: number | undefined;
    customerCode?: string | undefined;
    customerName?: string | undefined;
    cashAccountCustomer?: boolean | undefined;
    allowSettlementOnDirect?: boolean | undefined;
    customerVatRuleID?: number | undefined;
    customerTaxAreaID?: number | undefined;
    customerTaxUsageTypeID?: number | undefined;
    applyPromotionalPricing?: boolean | undefined;
    applyDeliveryCharges?: boolean | undefined;
    customerSettlementDiscount?: number | undefined;
    customerAddressSettlementDiscount?: number | undefined;
    customerTypeID?: number | undefined;
    allowCashAccountBalanceCustomer?: boolean | undefined;
    reasonName?: string | undefined;
    reasonRestockCharge?: string | undefined;
    arCustomerCode?: string | undefined;
    arCustomerName?: string | undefined;
    createdByName?: string | undefined;
    approvedByName?: string | undefined;
    releasedByName?: string | undefined;
    takenByName?: string | undefined;
    paymentTermsDiscountPercent?: number | undefined;
    paymentTermsDescription?: string | undefined;
    sumLinesSettlementAmountInCurrency?: number | undefined;
    originalInvoiceNumber?: number | undefined;
    customerAddressUseTaxExemptCertificate?: boolean | undefined;
    invoiceDate?: Date | undefined;
    jobDefaultAddressTaxAreaID?: number | undefined;
    jobDefaultAddressTaxUsageTypeID?: number | undefined;
    jobReference?: string | undefined;
    addressApplyPromotionalPricing?: number | undefined;
    documentStatusName?: string | undefined;
    printTheseFormats?: string | undefined;

    constructor(data?: ICreditNoteHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creditNoteID = _data["creditNoteID"];
            this.creditNoteNumber = _data["creditNoteNumber"];
            this.creditDate = _data["creditDate"] ? new Date(_data["creditDate"].toString()) : <any>undefined;
            this.cashSale = _data["cashSale"];
            this.handling = _data["handling"];
            this.branchID = _data["branchID"];
            this.customerID = _data["customerID"];
            this.invoiceID = _data["invoiceID"];
            this.orderID = _data["orderID"];
            this.invoiceAddressID = _data["invoiceAddressID"];
            this.invoiceAddress = _data["invoiceAddress"];
            this.reasonID = _data["reasonID"];
            this.contact = _data["contact"];
            this.ourRef = _data["ourRef"];
            this.yourRef = _data["yourRef"];
            this.showEurosOnCreditNote = _data["showEurosOnCreditNote"];
            this.description = _data["description"];
            this.currencyID = _data["currencyID"];
            this.exchangeRate = _data["exchangeRate"];
            this.cashAccountBalanceAmount = _data["cashAccountBalanceAmount"];
            this.totalAmount = _data["totalAmount"];
            this.totalAmountInCurrency = _data["totalAmountInCurrency"];
            this.totalVatAmount = _data["totalVatAmount"];
            this.totalVatAmountInCurrency = _data["totalVatAmountInCurrency"];
            this.totalTax = _data["totalTax"];
            this.totalTaxInCurrency = _data["totalTaxInCurrency"];
            this.totalCost = _data["totalCost"];
            this.commissionTotalCost = _data["commissionTotalCost"];
            this.totalWeight = _data["totalWeight"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.settlementDiscount = _data["settlementDiscount"];
            this.settlementDate = _data["settlementDate"] ? new Date(_data["settlementDate"].toString()) : <any>undefined;
            this.settlementAmount = _data["settlementAmount"];
            this.taxSettlementAmount = _data["taxSettlementAmount"];
            this.nonDiscountAmount = _data["nonDiscountAmount"];
            this.nonDiscountAmountInCurrency = _data["nonDiscountAmountInCurrency"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.createdByID = _data["createdByID"];
            this.dateTimeApproved = _data["dateTimeApproved"] ? new Date(_data["dateTimeApproved"].toString()) : <any>undefined;
            this.approvedByID = _data["approvedByID"];
            this.dateTimeReleased = _data["dateTimeReleased"] ? new Date(_data["dateTimeReleased"].toString()) : <any>undefined;
            this.releasedByID = _data["releasedByID"];
            this.notes = _data["notes"];
            this.emailed = _data["emailed"];
            this.faxed = _data["faxed"];
            this.sent = _data["sent"];
            this.printed = _data["printed"];
            this.imaged = _data["imaged"];
            this.paidByID = _data["paidByID"];
            this.ediDocumentID = _data["ediDocumentID"];
            this.ediSendInvoice = _data["ediSendInvoice"];
            this.markedAsReturned = _data["markedAsReturned"];
            this.journeyID = _data["journeyID"];
            this.computerID = _data["computerID"];
            this.arCustomerID = _data["arCustomerID"];
            this.arAddressID = _data["arAddressID"];
            this.taxAdjustmentType = _data["taxAdjustmentType"];
            this.correctedTaxAreaID = _data["correctedTaxAreaID"];
            this.correctedUseTaxExemptCert = _data["correctedUseTaxExemptCert"];
            this.notepadCaseID = _data["notepadCaseID"];
            this.contractID = _data["contractID"];
            this.contractInvoicingLineID = _data["contractInvoicingLineID"];
            this.taxAreaID = _data["taxAreaID"];
            this.useTaxExemptCertificate = _data["useTaxExemptCertificate"];
            this.taxVerifiedByID = _data["taxVerifiedByID"];
            this.paymentTermsID = _data["paymentTermsID"];
            this.dateRequired = _data["dateRequired"] ? new Date(_data["dateRequired"].toString()) : <any>undefined;
            this.outstandingRefund = _data["outstandingRefund"];
            this.deliveryAddressID = _data["deliveryAddressID"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.nonSalesAmount = _data["nonSalesAmount"];
            this.nonSalesAmountInCurrency = _data["nonSalesAmountInCurrency"];
            this.wmsRefusedOnTruckOrderID = _data["wmsRefusedOnTruckOrderID"];
            this.totalMargin = _data["totalMargin"];
            this.internalCostTotalMargin = _data["internalCostTotalMargin"];
            this.takenByID = _data["takenByID"];
            this.vehicleTypeID = _data["vehicleTypeID"];
            this.vehicleID = _data["vehicleID"];
            this.deliveryAreaID = _data["deliveryAreaID"];
            this.lastModifiedByID = _data["lastModifiedByID"];
            this.dateTimeLastModified = _data["dateTimeLastModified"] ? new Date(_data["dateTimeLastModified"].toString()) : <any>undefined;
            this.deleted = _data["deleted"];
            this.rebill = _data["rebill"];
            this.taxUsageTypeID = _data["taxUsageTypeID"];
            this.contractInvoicing = _data["contractInvoicing"];
            this.scaleGrossWeight = _data["scaleGrossWeight"];
            this.creditOnHold = _data["creditOnHold"];
            this.authorizedByID = _data["authorizedByID"];
            this.branchName = _data["branchName"];
            this.branchTaxAreaID = _data["branchTaxAreaID"];
            this.customerCode = _data["customerCode"];
            this.customerName = _data["customerName"];
            this.cashAccountCustomer = _data["cashAccountCustomer"];
            this.allowSettlementOnDirect = _data["allowSettlementOnDirect"];
            this.customerVatRuleID = _data["customerVatRuleID"];
            this.customerTaxAreaID = _data["customerTaxAreaID"];
            this.customerTaxUsageTypeID = _data["customerTaxUsageTypeID"];
            this.applyPromotionalPricing = _data["applyPromotionalPricing"];
            this.applyDeliveryCharges = _data["applyDeliveryCharges"];
            this.customerSettlementDiscount = _data["customerSettlementDiscount"];
            this.customerAddressSettlementDiscount = _data["customerAddressSettlementDiscount"];
            this.customerTypeID = _data["customerTypeID"];
            this.allowCashAccountBalanceCustomer = _data["allowCashAccountBalanceCustomer"];
            this.reasonName = _data["reasonName"];
            this.reasonRestockCharge = _data["reasonRestockCharge"];
            this.arCustomerCode = _data["arCustomerCode"];
            this.arCustomerName = _data["arCustomerName"];
            this.createdByName = _data["createdByName"];
            this.approvedByName = _data["approvedByName"];
            this.releasedByName = _data["releasedByName"];
            this.takenByName = _data["takenByName"];
            this.paymentTermsDiscountPercent = _data["paymentTermsDiscountPercent"];
            this.paymentTermsDescription = _data["paymentTermsDescription"];
            this.sumLinesSettlementAmountInCurrency = _data["sumLinesSettlementAmountInCurrency"];
            this.originalInvoiceNumber = _data["originalInvoiceNumber"];
            this.customerAddressUseTaxExemptCertificate = _data["customerAddressUseTaxExemptCertificate"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            this.jobDefaultAddressTaxAreaID = _data["jobDefaultAddressTaxAreaID"];
            this.jobDefaultAddressTaxUsageTypeID = _data["jobDefaultAddressTaxUsageTypeID"];
            this.jobReference = _data["jobReference"];
            this.addressApplyPromotionalPricing = _data["addressApplyPromotionalPricing"];
            this.documentStatusName = _data["documentStatusName"];
            this.printTheseFormats = _data["printTheseFormats"];
        }
    }

    static fromJS(data: any): CreditNoteHeader {
        data = typeof data === 'object' ? data : {};
        let result = new CreditNoteHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creditNoteID"] = this.creditNoteID;
        data["creditNoteNumber"] = this.creditNoteNumber;
        data["creditDate"] = this.creditDate ? this.creditDate.toISOString() : <any>undefined;
        data["cashSale"] = this.cashSale;
        data["handling"] = this.handling;
        data["branchID"] = this.branchID;
        data["customerID"] = this.customerID;
        data["invoiceID"] = this.invoiceID;
        data["orderID"] = this.orderID;
        data["invoiceAddressID"] = this.invoiceAddressID;
        data["invoiceAddress"] = this.invoiceAddress;
        data["reasonID"] = this.reasonID;
        data["contact"] = this.contact;
        data["ourRef"] = this.ourRef;
        data["yourRef"] = this.yourRef;
        data["showEurosOnCreditNote"] = this.showEurosOnCreditNote;
        data["description"] = this.description;
        data["currencyID"] = this.currencyID;
        data["exchangeRate"] = this.exchangeRate;
        data["cashAccountBalanceAmount"] = this.cashAccountBalanceAmount;
        data["totalAmount"] = this.totalAmount;
        data["totalAmountInCurrency"] = this.totalAmountInCurrency;
        data["totalVatAmount"] = this.totalVatAmount;
        data["totalVatAmountInCurrency"] = this.totalVatAmountInCurrency;
        data["totalTax"] = this.totalTax;
        data["totalTaxInCurrency"] = this.totalTaxInCurrency;
        data["totalCost"] = this.totalCost;
        data["commissionTotalCost"] = this.commissionTotalCost;
        data["totalWeight"] = this.totalWeight;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["settlementDiscount"] = this.settlementDiscount;
        data["settlementDate"] = this.settlementDate ? this.settlementDate.toISOString() : <any>undefined;
        data["settlementAmount"] = this.settlementAmount;
        data["taxSettlementAmount"] = this.taxSettlementAmount;
        data["nonDiscountAmount"] = this.nonDiscountAmount;
        data["nonDiscountAmountInCurrency"] = this.nonDiscountAmountInCurrency;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["createdByID"] = this.createdByID;
        data["dateTimeApproved"] = this.dateTimeApproved ? this.dateTimeApproved.toISOString() : <any>undefined;
        data["approvedByID"] = this.approvedByID;
        data["dateTimeReleased"] = this.dateTimeReleased ? this.dateTimeReleased.toISOString() : <any>undefined;
        data["releasedByID"] = this.releasedByID;
        data["notes"] = this.notes;
        data["emailed"] = this.emailed;
        data["faxed"] = this.faxed;
        data["sent"] = this.sent;
        data["printed"] = this.printed;
        data["imaged"] = this.imaged;
        data["paidByID"] = this.paidByID;
        data["ediDocumentID"] = this.ediDocumentID;
        data["ediSendInvoice"] = this.ediSendInvoice;
        data["markedAsReturned"] = this.markedAsReturned;
        data["journeyID"] = this.journeyID;
        data["computerID"] = this.computerID;
        data["arCustomerID"] = this.arCustomerID;
        data["arAddressID"] = this.arAddressID;
        data["taxAdjustmentType"] = this.taxAdjustmentType;
        data["correctedTaxAreaID"] = this.correctedTaxAreaID;
        data["correctedUseTaxExemptCert"] = this.correctedUseTaxExemptCert;
        data["notepadCaseID"] = this.notepadCaseID;
        data["contractID"] = this.contractID;
        data["contractInvoicingLineID"] = this.contractInvoicingLineID;
        data["taxAreaID"] = this.taxAreaID;
        data["useTaxExemptCertificate"] = this.useTaxExemptCertificate;
        data["taxVerifiedByID"] = this.taxVerifiedByID;
        data["paymentTermsID"] = this.paymentTermsID;
        data["dateRequired"] = this.dateRequired ? this.dateRequired.toISOString() : <any>undefined;
        data["outstandingRefund"] = this.outstandingRefund;
        data["deliveryAddressID"] = this.deliveryAddressID;
        data["deliveryAddress"] = this.deliveryAddress;
        data["nonSalesAmount"] = this.nonSalesAmount;
        data["nonSalesAmountInCurrency"] = this.nonSalesAmountInCurrency;
        data["wmsRefusedOnTruckOrderID"] = this.wmsRefusedOnTruckOrderID;
        data["totalMargin"] = this.totalMargin;
        data["internalCostTotalMargin"] = this.internalCostTotalMargin;
        data["takenByID"] = this.takenByID;
        data["vehicleTypeID"] = this.vehicleTypeID;
        data["vehicleID"] = this.vehicleID;
        data["deliveryAreaID"] = this.deliveryAreaID;
        data["lastModifiedByID"] = this.lastModifiedByID;
        data["dateTimeLastModified"] = this.dateTimeLastModified ? this.dateTimeLastModified.toISOString() : <any>undefined;
        data["deleted"] = this.deleted;
        data["rebill"] = this.rebill;
        data["taxUsageTypeID"] = this.taxUsageTypeID;
        data["contractInvoicing"] = this.contractInvoicing;
        data["scaleGrossWeight"] = this.scaleGrossWeight;
        data["creditOnHold"] = this.creditOnHold;
        data["authorizedByID"] = this.authorizedByID;
        data["branchName"] = this.branchName;
        data["branchTaxAreaID"] = this.branchTaxAreaID;
        data["customerCode"] = this.customerCode;
        data["customerName"] = this.customerName;
        data["cashAccountCustomer"] = this.cashAccountCustomer;
        data["allowSettlementOnDirect"] = this.allowSettlementOnDirect;
        data["customerVatRuleID"] = this.customerVatRuleID;
        data["customerTaxAreaID"] = this.customerTaxAreaID;
        data["customerTaxUsageTypeID"] = this.customerTaxUsageTypeID;
        data["applyPromotionalPricing"] = this.applyPromotionalPricing;
        data["applyDeliveryCharges"] = this.applyDeliveryCharges;
        data["customerSettlementDiscount"] = this.customerSettlementDiscount;
        data["customerAddressSettlementDiscount"] = this.customerAddressSettlementDiscount;
        data["customerTypeID"] = this.customerTypeID;
        data["allowCashAccountBalanceCustomer"] = this.allowCashAccountBalanceCustomer;
        data["reasonName"] = this.reasonName;
        data["reasonRestockCharge"] = this.reasonRestockCharge;
        data["arCustomerCode"] = this.arCustomerCode;
        data["arCustomerName"] = this.arCustomerName;
        data["createdByName"] = this.createdByName;
        data["approvedByName"] = this.approvedByName;
        data["releasedByName"] = this.releasedByName;
        data["takenByName"] = this.takenByName;
        data["paymentTermsDiscountPercent"] = this.paymentTermsDiscountPercent;
        data["paymentTermsDescription"] = this.paymentTermsDescription;
        data["sumLinesSettlementAmountInCurrency"] = this.sumLinesSettlementAmountInCurrency;
        data["originalInvoiceNumber"] = this.originalInvoiceNumber;
        data["customerAddressUseTaxExemptCertificate"] = this.customerAddressUseTaxExemptCertificate;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["jobDefaultAddressTaxAreaID"] = this.jobDefaultAddressTaxAreaID;
        data["jobDefaultAddressTaxUsageTypeID"] = this.jobDefaultAddressTaxUsageTypeID;
        data["jobReference"] = this.jobReference;
        data["addressApplyPromotionalPricing"] = this.addressApplyPromotionalPricing;
        data["documentStatusName"] = this.documentStatusName;
        data["printTheseFormats"] = this.printTheseFormats;
        return data; 
    }
}

export interface ICreditNoteHeader {
    creditNoteID?: number | undefined;
    creditNoteNumber?: number | undefined;
    creditDate?: Date | undefined;
    cashSale?: boolean | undefined;
    handling?: number | undefined;
    branchID?: number | undefined;
    customerID?: number | undefined;
    invoiceID?: number | undefined;
    orderID?: number | undefined;
    invoiceAddressID?: number | undefined;
    invoiceAddress?: string | undefined;
    reasonID?: number | undefined;
    contact?: string | undefined;
    ourRef?: string | undefined;
    yourRef?: string | undefined;
    showEurosOnCreditNote?: boolean | undefined;
    description?: string | undefined;
    currencyID?: number | undefined;
    exchangeRate?: number | undefined;
    cashAccountBalanceAmount?: number | undefined;
    totalAmount?: number | undefined;
    totalAmountInCurrency?: number | undefined;
    totalVatAmount?: number | undefined;
    totalVatAmountInCurrency?: number | undefined;
    totalTax?: number | undefined;
    totalTaxInCurrency?: number | undefined;
    totalCost?: number | undefined;
    commissionTotalCost?: number | undefined;
    totalWeight?: number | undefined;
    dueDate?: Date | undefined;
    settlementDiscount?: number | undefined;
    settlementDate?: Date | undefined;
    settlementAmount?: number | undefined;
    taxSettlementAmount?: number | undefined;
    nonDiscountAmount?: number | undefined;
    nonDiscountAmountInCurrency?: number | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    dateTimeApproved?: Date | undefined;
    approvedByID?: number | undefined;
    dateTimeReleased?: Date | undefined;
    releasedByID?: number | undefined;
    notes?: string | undefined;
    emailed?: boolean | undefined;
    faxed?: boolean | undefined;
    sent?: boolean | undefined;
    printed?: boolean | undefined;
    imaged?: number | undefined;
    paidByID?: number | undefined;
    ediDocumentID?: number | undefined;
    ediSendInvoice?: boolean | undefined;
    markedAsReturned?: boolean | undefined;
    journeyID?: number | undefined;
    computerID?: number | undefined;
    arCustomerID?: number | undefined;
    arAddressID?: number | undefined;
    taxAdjustmentType?: number | undefined;
    correctedTaxAreaID?: number | undefined;
    correctedUseTaxExemptCert?: boolean | undefined;
    notepadCaseID?: number | undefined;
    contractID?: number | undefined;
    contractInvoicingLineID?: number | undefined;
    taxAreaID?: number | undefined;
    useTaxExemptCertificate?: boolean | undefined;
    taxVerifiedByID?: number | undefined;
    paymentTermsID?: number | undefined;
    dateRequired?: Date | undefined;
    outstandingRefund?: number | undefined;
    deliveryAddressID?: number | undefined;
    deliveryAddress?: string | undefined;
    nonSalesAmount?: number | undefined;
    nonSalesAmountInCurrency?: number | undefined;
    wmsRefusedOnTruckOrderID?: number | undefined;
    totalMargin?: number | undefined;
    internalCostTotalMargin?: number | undefined;
    takenByID?: number | undefined;
    vehicleTypeID?: number | undefined;
    vehicleID?: number | undefined;
    deliveryAreaID?: number | undefined;
    lastModifiedByID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    deleted?: boolean | undefined;
    rebill?: boolean | undefined;
    taxUsageTypeID?: number | undefined;
    contractInvoicing?: boolean | undefined;
    scaleGrossWeight?: number | undefined;
    creditOnHold?: boolean | undefined;
    authorizedByID?: number | undefined;
    branchName?: string | undefined;
    branchTaxAreaID?: number | undefined;
    customerCode?: string | undefined;
    customerName?: string | undefined;
    cashAccountCustomer?: boolean | undefined;
    allowSettlementOnDirect?: boolean | undefined;
    customerVatRuleID?: number | undefined;
    customerTaxAreaID?: number | undefined;
    customerTaxUsageTypeID?: number | undefined;
    applyPromotionalPricing?: boolean | undefined;
    applyDeliveryCharges?: boolean | undefined;
    customerSettlementDiscount?: number | undefined;
    customerAddressSettlementDiscount?: number | undefined;
    customerTypeID?: number | undefined;
    allowCashAccountBalanceCustomer?: boolean | undefined;
    reasonName?: string | undefined;
    reasonRestockCharge?: string | undefined;
    arCustomerCode?: string | undefined;
    arCustomerName?: string | undefined;
    createdByName?: string | undefined;
    approvedByName?: string | undefined;
    releasedByName?: string | undefined;
    takenByName?: string | undefined;
    paymentTermsDiscountPercent?: number | undefined;
    paymentTermsDescription?: string | undefined;
    sumLinesSettlementAmountInCurrency?: number | undefined;
    originalInvoiceNumber?: number | undefined;
    customerAddressUseTaxExemptCertificate?: boolean | undefined;
    invoiceDate?: Date | undefined;
    jobDefaultAddressTaxAreaID?: number | undefined;
    jobDefaultAddressTaxUsageTypeID?: number | undefined;
    jobReference?: string | undefined;
    addressApplyPromotionalPricing?: number | undefined;
    documentStatusName?: string | undefined;
    printTheseFormats?: string | undefined;
}

export class CreditNoteLine implements ICreditNoteLine {
    lineItems?: CreditNoteItem[] | undefined;
    creditNoteLineID?: number | undefined;
    creditNoteID?: number | undefined;
    branchID?: number | undefined;
    lineNumber?: number | undefined;
    itemNumber?: number | undefined;
    lineType?: number | undefined;
    description?: string | undefined;
    invoiceLineID?: number | undefined;
    orderLineID?: number | undefined;
    customerReturnLineID?: number | undefined;
    productID?: number | undefined;
    manualOrderLineTypeID?: number | undefined;
    manualCode?: string | undefined;
    manualDescription?: string | undefined;
    quantity?: number | undefined;
    quantityDisplay?: number | undefined;
    returnQuantity?: number | undefined;
    returnQuantityDisplay?: number | undefined;
    returnToSupplier?: boolean | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    inputPerID?: number | undefined;
    displayInputPerID?: number | undefined;
    perID?: number | undefined;
    unitAmount?: number | undefined;
    unitAmountInCurrency?: number | undefined;
    unitAmountDisplay?: number | undefined;
    totalAmount?: number | undefined;
    totalAmountInCurrency?: number | undefined;
    restockCharge?: number | undefined;
    restockChargeInCurrency?: number | undefined;
    totalCost?: number | undefined;
    totalVMICost?: number | undefined;
    vmiRuleID?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    vatAmount?: number | undefined;
    vatAmountInCurrency?: number | undefined;
    totalTax?: number | undefined;
    totalTaxInCurrency?: number | undefined;
    vatRateID?: number | undefined;
    taxGroupID?: number | undefined;
    taxCodes?: string | undefined;
    salesAnalysisCodeID?: number | undefined;
    notes?: string | undefined;
    pointsEarnedAdjustment?: number | undefined;
    exportedToDataWarehouse?: boolean | undefined;
    settlementAmount?: number | undefined;
    settlementAmountInCurrency?: number | undefined;
    additionalCharge?: number | undefined;
    additionalCost?: number | undefined;
    vmiSupplierInvoiceDocumentID?: number | undefined;
    vmiReconciled?: boolean | undefined;
    totalVMICostInCurrency?: number | undefined;
    vmiExchangeRate?: number | undefined;
    generatedFromContractInvoicing?: boolean | undefined;
    totalReportingCost?: number | undefined;
    adjustedForPriceCorrectionsAmount?: number | undefined;
    wmsProcessed?: boolean | undefined;
    nonSalesAmount?: number | undefined;
    nonSalesAmountInCurrency?: number | undefined;
    totalMargin?: number | undefined;
    internalCostTotalMargin?: number | undefined;
    manualDiscount1Amount?: number | undefined;
    manualDiscount1AmountInCurrency?: number | undefined;
    manualDiscount2Amount?: number | undefined;
    manualDiscount2AmountInCurrency?: number | undefined;
    includeAVOCost?: boolean | undefined;
    wmsCreatedFromRN?: boolean | undefined;
    sellingPriceRuleID?: number | undefined;
    promotionID?: number | undefined;
    disableRebateAccruals?: boolean | undefined;
    internalTotalCostPrice?: number | undefined;
    settlementDiscount?: number | undefined;
    manualLinePriceToCalculate?: number | undefined;
    productBatchOption?: number | undefined;
    createdFromContractInvoicingLineID?: number | undefined;
    couponID?: number | undefined;
    promotionPointsAdjustment?: number | undefined;
    quantityFromScale?: number | undefined;
    scaleGrossWeight?: number | undefined;
    invoiceLineItemNumber?: number | undefined;
    invoiceLineLineType?: number | undefined;
    invoiceLineDeliveryNoteLineID?: number | undefined;
    invoiceLineQuantity?: number | undefined;
    invoiceLineTotalAmount?: number | undefined;
    invoiceLineTotalAmountInCurrency?: number | undefined;
    invoiceLineTotalCost?: number | undefined;
    invoiceLineTotalVmiCost?: number | undefined;
    invoiceLineTotalVmiCostInCurrency?: number | undefined;
    invoiceLineVmiExchangeRate?: number | undefined;
    invoiceLineTotalWeight?: number | undefined;
    invoiceLineQuantityCredited?: number | undefined;
    invoiceLineUnitAmountInCurrency?: number | undefined;
    invoiceLineUnitAmount?: number | undefined;
    invoiceLineSettlementAmount?: number | undefined;
    invoiceLineSettlementAmountInCurrency?: number | undefined;
    invoiceID?: number | undefined;
    invoiceNumber?: number | undefined;
    invoiceCustomerID?: number | undefined;
    orderID?: number | undefined;
    invoiceLineUseTaxExemptCertificate?: boolean | undefined;
    invoiceCustomerRef?: string | undefined;
    invoiceAddressID?: number | undefined;
    invoiceAddress?: string | undefined;
    deliveryAddressID?: number | undefined;
    deliveryAddress?: string | undefined;
    deliveryAreaID?: number | undefined;
    orderLineQuantityTally?: string | undefined;
    saleType?: number | undefined;
    orderLineOrderIssuingBranchID?: number | undefined;
    orderLineNotes?: string | undefined;
    orderQuantity?: number | undefined;
    orderLineInputPerID?: number | undefined;
    orderLineQuantityDisplay?: number | undefined;
    orderLineDiscount1?: number | undefined;
    orderLineDiscount1Type?: number | undefined;
    orderLineDiscount2?: number | undefined;
    orderLineDiscount2Type?: number | undefined;
    orderLineDiscountAmount1InCurrency?: number | undefined;
    orderLineDiscountAmount2InCurrency?: number | undefined;
    orderLineUnitSellPriceInCurrency?: number | undefined;
    orderLineUnitSellPriceDisplay?: number | undefined;
    orderLineAdditionalCost?: number | undefined;
    orderLineManualOrderLineTypeID?: number | undefined;
    orderLineAdditionalCharge?: number | undefined;
    olavoCount?: number | undefined;
    orderLineWmsParentLineID?: number | undefined;
    orderLineIsWmsAdditionalCharge?: boolean | undefined;
    orderLinePackCount?: number | undefined;
    orderLineNetPriced?: boolean | undefined;
    orderLinePricingType?: number | undefined;
    orderLinePurchaseOrderID?: number | undefined;
    orderLinePurchaseOrderNumber?: number | undefined;
    orderLinePurchaseOrderSupplierID?: number | undefined;
    commissionTotalCostPrice?: number | undefined;
    orderLinePromotionID?: number | undefined;
    pointsEarned?: number | undefined;
    orderLineInternalTotalCostPrice?: number | undefined;
    orderLineTotalWorksOrderAvoCost?: number | undefined;
    vatInclusiveUnitSellPrice?: number | undefined;
    orderLineRebateSaleType?: number | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    productCode?: string | undefined;
    productBarCode?: string | undefined;
    productDescription?: string | undefined;
    productShortDescription?: string | undefined;
    thickness?: number | undefined;
    width?: number | undefined;
    imperial?: boolean | undefined;
    tallyLengths?: string | undefined;
    tallyLengthsPerID?: number | undefined;
    availableWidths?: string | undefined;
    weight?: number | undefined;
    length?: number | undefined;
    wmsSent?: boolean | undefined;
    wmsPendingOC?: boolean | undefined;
    productDefaultSupplierID?: number | undefined;
    productDefaultPiecesPerPack?: number | undefined;
    productDefaultUnitSizePerID?: number | undefined;
    productAllowMultiplePersOnUnitSizes?: boolean | undefined;
    productAllowSettlementDiscount?: boolean | undefined;
    branchAllowSettlementDiscount?: boolean | undefined;
    defaultAllowSettlementDiscount?: boolean | undefined;
    productStockControlByLength?: boolean | undefined;
    productStockedByCost?: boolean | undefined;
    productPerRuleID?: number | undefined;
    productSpecial?: boolean | undefined;
    productOwnBrandProduct?: boolean | undefined;
    productGroupID?: number | undefined;
    productWeightPerID?: number | undefined;
    productApplyRebateAccruals?: boolean | undefined;
    totalLengthImperial?: number | undefined;
    totalVolumeImperial?: number | undefined;
    priceRuleSettlementDiscNotAllowed?: boolean | undefined;
    promotionSettlementDiscNotAllowed?: boolean | undefined;
    averageCost?: number | undefined;
    averageCostPerID?: number | undefined;
    averageCostWithAdd?: number | undefined;
    companyAverageCost?: number | undefined;
    companyAverageCostPerID?: number | undefined;
    companyAverageCostWithAdd?: number | undefined;
    vatID?: number | undefined;
    rate?: number | undefined;
    branchName?: string | undefined;
    invoiceLineTaxAreaID?: number | undefined;
    invoiceLineTaxUsageTypeID?: number | undefined;
    ediVatCode?: string | undefined;
    jobID?: number | undefined;
    orderLineEdiInputPerConversionToBase?: number | undefined;
    invoiceLineManualOrderLineTypeDescription?: string | undefined;
    invoiceLineManualOrderLineTypeCode?: string | undefined;
    statisticsPerID?: number | undefined;
    stockPerID?: number | undefined;
    priceCorrection?: boolean | undefined;
    cashAccountBalanceReversed?: boolean | undefined;
    statsPerConversion?: number | undefined;
    contractID?: number | undefined;
    contractInvoicingLineID?: number | undefined;
    contractInvoicing?: boolean | undefined;
    invoiceLineBranchID?: number | undefined;
    invoiceLineJobDefaultAddressTaxAreaID?: number | undefined;
    invoiceLineJobDefaultAddressTaxUsageTypeID?: number | undefined;
    totalInvoiceLineCostAdjustment?: number | undefined;
    invoiceLineQuantityCreditedDisplay?: number | undefined;
    supplierCreditLineID?: number | undefined;
    supplierReturnLineID?: number | undefined;
    cashBalanceCustomerID?: number | undefined;
    orderLineKitHeaderID?: number | undefined;
    orderLineKitHeaderPromotionID?: number | undefined;
    productWarningText?: string | undefined;
    invoiceLineCommissionTotalCost?: number | undefined;
    supplierInvoiceLineId?: number | undefined;
    supplierInvoiceId?: number | undefined;
    totalActualVolume?: number | undefined;
    isProductLine?: boolean | undefined;
    stockPerConversion?: number | undefined;

    constructor(data?: ICreditNoteLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(CreditNoteItem.fromJS(item));
            }
            this.creditNoteLineID = _data["creditNoteLineID"];
            this.creditNoteID = _data["creditNoteID"];
            this.branchID = _data["branchID"];
            this.lineNumber = _data["lineNumber"];
            this.itemNumber = _data["itemNumber"];
            this.lineType = _data["lineType"];
            this.description = _data["description"];
            this.invoiceLineID = _data["invoiceLineID"];
            this.orderLineID = _data["orderLineID"];
            this.customerReturnLineID = _data["customerReturnLineID"];
            this.productID = _data["productID"];
            this.manualOrderLineTypeID = _data["manualOrderLineTypeID"];
            this.manualCode = _data["manualCode"];
            this.manualDescription = _data["manualDescription"];
            this.quantity = _data["quantity"];
            this.quantityDisplay = _data["quantityDisplay"];
            this.returnQuantity = _data["returnQuantity"];
            this.returnQuantityDisplay = _data["returnQuantityDisplay"];
            this.returnToSupplier = _data["returnToSupplier"];
            this.quantityTally = _data["quantityTally"];
            this.noOfPieces = _data["noOfPieces"];
            this.inputPerID = _data["inputPerID"];
            this.displayInputPerID = _data["displayInputPerID"];
            this.perID = _data["perID"];
            this.unitAmount = _data["unitAmount"];
            this.unitAmountInCurrency = _data["unitAmountInCurrency"];
            this.unitAmountDisplay = _data["unitAmountDisplay"];
            this.totalAmount = _data["totalAmount"];
            this.totalAmountInCurrency = _data["totalAmountInCurrency"];
            this.restockCharge = _data["restockCharge"];
            this.restockChargeInCurrency = _data["restockChargeInCurrency"];
            this.totalCost = _data["totalCost"];
            this.totalVMICost = _data["totalVMICost"];
            this.vmiRuleID = _data["vmiRuleID"];
            this.totalWeight = _data["totalWeight"];
            this.totalLength = _data["totalLength"];
            this.totalVolume = _data["totalVolume"];
            this.vatAmount = _data["vatAmount"];
            this.vatAmountInCurrency = _data["vatAmountInCurrency"];
            this.totalTax = _data["totalTax"];
            this.totalTaxInCurrency = _data["totalTaxInCurrency"];
            this.vatRateID = _data["vatRateID"];
            this.taxGroupID = _data["taxGroupID"];
            this.taxCodes = _data["taxCodes"];
            this.salesAnalysisCodeID = _data["salesAnalysisCodeID"];
            this.notes = _data["notes"];
            this.pointsEarnedAdjustment = _data["pointsEarnedAdjustment"];
            this.exportedToDataWarehouse = _data["exportedToDataWarehouse"];
            this.settlementAmount = _data["settlementAmount"];
            this.settlementAmountInCurrency = _data["settlementAmountInCurrency"];
            this.additionalCharge = _data["additionalCharge"];
            this.additionalCost = _data["additionalCost"];
            this.vmiSupplierInvoiceDocumentID = _data["vmiSupplierInvoiceDocumentID"];
            this.vmiReconciled = _data["vmiReconciled"];
            this.totalVMICostInCurrency = _data["totalVMICostInCurrency"];
            this.vmiExchangeRate = _data["vmiExchangeRate"];
            this.generatedFromContractInvoicing = _data["generatedFromContractInvoicing"];
            this.totalReportingCost = _data["totalReportingCost"];
            this.adjustedForPriceCorrectionsAmount = _data["adjustedForPriceCorrectionsAmount"];
            this.wmsProcessed = _data["wmsProcessed"];
            this.nonSalesAmount = _data["nonSalesAmount"];
            this.nonSalesAmountInCurrency = _data["nonSalesAmountInCurrency"];
            this.totalMargin = _data["totalMargin"];
            this.internalCostTotalMargin = _data["internalCostTotalMargin"];
            this.manualDiscount1Amount = _data["manualDiscount1Amount"];
            this.manualDiscount1AmountInCurrency = _data["manualDiscount1AmountInCurrency"];
            this.manualDiscount2Amount = _data["manualDiscount2Amount"];
            this.manualDiscount2AmountInCurrency = _data["manualDiscount2AmountInCurrency"];
            this.includeAVOCost = _data["includeAVOCost"];
            this.wmsCreatedFromRN = _data["wmsCreatedFromRN"];
            this.sellingPriceRuleID = _data["sellingPriceRuleID"];
            this.promotionID = _data["promotionID"];
            this.disableRebateAccruals = _data["disableRebateAccruals"];
            this.internalTotalCostPrice = _data["internalTotalCostPrice"];
            this.settlementDiscount = _data["settlementDiscount"];
            this.manualLinePriceToCalculate = _data["manualLinePriceToCalculate"];
            this.productBatchOption = _data["productBatchOption"];
            this.createdFromContractInvoicingLineID = _data["createdFromContractInvoicingLineID"];
            this.couponID = _data["couponID"];
            this.promotionPointsAdjustment = _data["promotionPointsAdjustment"];
            this.quantityFromScale = _data["quantityFromScale"];
            this.scaleGrossWeight = _data["scaleGrossWeight"];
            this.invoiceLineItemNumber = _data["invoiceLineItemNumber"];
            this.invoiceLineLineType = _data["invoiceLineLineType"];
            this.invoiceLineDeliveryNoteLineID = _data["invoiceLineDeliveryNoteLineID"];
            this.invoiceLineQuantity = _data["invoiceLineQuantity"];
            this.invoiceLineTotalAmount = _data["invoiceLineTotalAmount"];
            this.invoiceLineTotalAmountInCurrency = _data["invoiceLineTotalAmountInCurrency"];
            this.invoiceLineTotalCost = _data["invoiceLineTotalCost"];
            this.invoiceLineTotalVmiCost = _data["invoiceLineTotalVmiCost"];
            this.invoiceLineTotalVmiCostInCurrency = _data["invoiceLineTotalVmiCostInCurrency"];
            this.invoiceLineVmiExchangeRate = _data["invoiceLineVmiExchangeRate"];
            this.invoiceLineTotalWeight = _data["invoiceLineTotalWeight"];
            this.invoiceLineQuantityCredited = _data["invoiceLineQuantityCredited"];
            this.invoiceLineUnitAmountInCurrency = _data["invoiceLineUnitAmountInCurrency"];
            this.invoiceLineUnitAmount = _data["invoiceLineUnitAmount"];
            this.invoiceLineSettlementAmount = _data["invoiceLineSettlementAmount"];
            this.invoiceLineSettlementAmountInCurrency = _data["invoiceLineSettlementAmountInCurrency"];
            this.invoiceID = _data["invoiceID"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceCustomerID = _data["invoiceCustomerID"];
            this.orderID = _data["orderID"];
            this.invoiceLineUseTaxExemptCertificate = _data["invoiceLineUseTaxExemptCertificate"];
            this.invoiceCustomerRef = _data["invoiceCustomerRef"];
            this.invoiceAddressID = _data["invoiceAddressID"];
            this.invoiceAddress = _data["invoiceAddress"];
            this.deliveryAddressID = _data["deliveryAddressID"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.deliveryAreaID = _data["deliveryAreaID"];
            this.orderLineQuantityTally = _data["orderLineQuantityTally"];
            this.saleType = _data["saleType"];
            this.orderLineOrderIssuingBranchID = _data["orderLineOrderIssuingBranchID"];
            this.orderLineNotes = _data["orderLineNotes"];
            this.orderQuantity = _data["orderQuantity"];
            this.orderLineInputPerID = _data["orderLineInputPerID"];
            this.orderLineQuantityDisplay = _data["orderLineQuantityDisplay"];
            this.orderLineDiscount1 = _data["orderLineDiscount1"];
            this.orderLineDiscount1Type = _data["orderLineDiscount1Type"];
            this.orderLineDiscount2 = _data["orderLineDiscount2"];
            this.orderLineDiscount2Type = _data["orderLineDiscount2Type"];
            this.orderLineDiscountAmount1InCurrency = _data["orderLineDiscountAmount1InCurrency"];
            this.orderLineDiscountAmount2InCurrency = _data["orderLineDiscountAmount2InCurrency"];
            this.orderLineUnitSellPriceInCurrency = _data["orderLineUnitSellPriceInCurrency"];
            this.orderLineUnitSellPriceDisplay = _data["orderLineUnitSellPriceDisplay"];
            this.orderLineAdditionalCost = _data["orderLineAdditionalCost"];
            this.orderLineManualOrderLineTypeID = _data["orderLineManualOrderLineTypeID"];
            this.orderLineAdditionalCharge = _data["orderLineAdditionalCharge"];
            this.olavoCount = _data["olavoCount"];
            this.orderLineWmsParentLineID = _data["orderLineWmsParentLineID"];
            this.orderLineIsWmsAdditionalCharge = _data["orderLineIsWmsAdditionalCharge"];
            this.orderLinePackCount = _data["orderLinePackCount"];
            this.orderLineNetPriced = _data["orderLineNetPriced"];
            this.orderLinePricingType = _data["orderLinePricingType"];
            this.orderLinePurchaseOrderID = _data["orderLinePurchaseOrderID"];
            this.orderLinePurchaseOrderNumber = _data["orderLinePurchaseOrderNumber"];
            this.orderLinePurchaseOrderSupplierID = _data["orderLinePurchaseOrderSupplierID"];
            this.commissionTotalCostPrice = _data["commissionTotalCostPrice"];
            this.orderLinePromotionID = _data["orderLinePromotionID"];
            this.pointsEarned = _data["pointsEarned"];
            this.orderLineInternalTotalCostPrice = _data["orderLineInternalTotalCostPrice"];
            this.orderLineTotalWorksOrderAvoCost = _data["orderLineTotalWorksOrderAvoCost"];
            this.vatInclusiveUnitSellPrice = _data["vatInclusiveUnitSellPrice"];
            this.orderLineRebateSaleType = _data["orderLineRebateSaleType"];
            this.productType = _data["productType"];
            this.productSubType = _data["productSubType"];
            this.productCode = _data["productCode"];
            this.productBarCode = _data["productBarCode"];
            this.productDescription = _data["productDescription"];
            this.productShortDescription = _data["productShortDescription"];
            this.thickness = _data["thickness"];
            this.width = _data["width"];
            this.imperial = _data["imperial"];
            this.tallyLengths = _data["tallyLengths"];
            this.tallyLengthsPerID = _data["tallyLengthsPerID"];
            this.availableWidths = _data["availableWidths"];
            this.weight = _data["weight"];
            this.length = _data["length"];
            this.wmsSent = _data["wmsSent"];
            this.wmsPendingOC = _data["wmsPendingOC"];
            this.productDefaultSupplierID = _data["productDefaultSupplierID"];
            this.productDefaultPiecesPerPack = _data["productDefaultPiecesPerPack"];
            this.productDefaultUnitSizePerID = _data["productDefaultUnitSizePerID"];
            this.productAllowMultiplePersOnUnitSizes = _data["productAllowMultiplePersOnUnitSizes"];
            this.productAllowSettlementDiscount = _data["productAllowSettlementDiscount"];
            this.branchAllowSettlementDiscount = _data["branchAllowSettlementDiscount"];
            this.defaultAllowSettlementDiscount = _data["defaultAllowSettlementDiscount"];
            this.productStockControlByLength = _data["productStockControlByLength"];
            this.productStockedByCost = _data["productStockedByCost"];
            this.productPerRuleID = _data["productPerRuleID"];
            this.productSpecial = _data["productSpecial"];
            this.productOwnBrandProduct = _data["productOwnBrandProduct"];
            this.productGroupID = _data["productGroupID"];
            this.productWeightPerID = _data["productWeightPerID"];
            this.productApplyRebateAccruals = _data["productApplyRebateAccruals"];
            this.totalLengthImperial = _data["totalLengthImperial"];
            this.totalVolumeImperial = _data["totalVolumeImperial"];
            this.priceRuleSettlementDiscNotAllowed = _data["priceRuleSettlementDiscNotAllowed"];
            this.promotionSettlementDiscNotAllowed = _data["promotionSettlementDiscNotAllowed"];
            this.averageCost = _data["averageCost"];
            this.averageCostPerID = _data["averageCostPerID"];
            this.averageCostWithAdd = _data["averageCostWithAdd"];
            this.companyAverageCost = _data["companyAverageCost"];
            this.companyAverageCostPerID = _data["companyAverageCostPerID"];
            this.companyAverageCostWithAdd = _data["companyAverageCostWithAdd"];
            this.vatID = _data["vatID"];
            this.rate = _data["rate"];
            this.branchName = _data["branchName"];
            this.invoiceLineTaxAreaID = _data["invoiceLineTaxAreaID"];
            this.invoiceLineTaxUsageTypeID = _data["invoiceLineTaxUsageTypeID"];
            this.ediVatCode = _data["ediVatCode"];
            this.jobID = _data["jobID"];
            this.orderLineEdiInputPerConversionToBase = _data["orderLineEdiInputPerConversionToBase"];
            this.invoiceLineManualOrderLineTypeDescription = _data["invoiceLineManualOrderLineTypeDescription"];
            this.invoiceLineManualOrderLineTypeCode = _data["invoiceLineManualOrderLineTypeCode"];
            this.statisticsPerID = _data["statisticsPerID"];
            this.stockPerID = _data["stockPerID"];
            this.priceCorrection = _data["priceCorrection"];
            this.cashAccountBalanceReversed = _data["cashAccountBalanceReversed"];
            this.statsPerConversion = _data["statsPerConversion"];
            this.contractID = _data["contractID"];
            this.contractInvoicingLineID = _data["contractInvoicingLineID"];
            this.contractInvoicing = _data["contractInvoicing"];
            this.invoiceLineBranchID = _data["invoiceLineBranchID"];
            this.invoiceLineJobDefaultAddressTaxAreaID = _data["invoiceLineJobDefaultAddressTaxAreaID"];
            this.invoiceLineJobDefaultAddressTaxUsageTypeID = _data["invoiceLineJobDefaultAddressTaxUsageTypeID"];
            this.totalInvoiceLineCostAdjustment = _data["totalInvoiceLineCostAdjustment"];
            this.invoiceLineQuantityCreditedDisplay = _data["invoiceLineQuantityCreditedDisplay"];
            this.supplierCreditLineID = _data["supplierCreditLineID"];
            this.supplierReturnLineID = _data["supplierReturnLineID"];
            this.cashBalanceCustomerID = _data["cashBalanceCustomerID"];
            this.orderLineKitHeaderID = _data["orderLineKitHeaderID"];
            this.orderLineKitHeaderPromotionID = _data["orderLineKitHeaderPromotionID"];
            this.productWarningText = _data["productWarningText"];
            this.invoiceLineCommissionTotalCost = _data["invoiceLineCommissionTotalCost"];
            this.supplierInvoiceLineId = _data["supplierInvoiceLineId"];
            this.supplierInvoiceId = _data["supplierInvoiceId"];
            this.totalActualVolume = _data["totalActualVolume"];
            this.isProductLine = _data["isProductLine"];
            this.stockPerConversion = _data["stockPerConversion"];
        }
    }

    static fromJS(data: any): CreditNoteLine {
        data = typeof data === 'object' ? data : {};
        let result = new CreditNoteLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item.toJSON());
        }
        data["creditNoteLineID"] = this.creditNoteLineID;
        data["creditNoteID"] = this.creditNoteID;
        data["branchID"] = this.branchID;
        data["lineNumber"] = this.lineNumber;
        data["itemNumber"] = this.itemNumber;
        data["lineType"] = this.lineType;
        data["description"] = this.description;
        data["invoiceLineID"] = this.invoiceLineID;
        data["orderLineID"] = this.orderLineID;
        data["customerReturnLineID"] = this.customerReturnLineID;
        data["productID"] = this.productID;
        data["manualOrderLineTypeID"] = this.manualOrderLineTypeID;
        data["manualCode"] = this.manualCode;
        data["manualDescription"] = this.manualDescription;
        data["quantity"] = this.quantity;
        data["quantityDisplay"] = this.quantityDisplay;
        data["returnQuantity"] = this.returnQuantity;
        data["returnQuantityDisplay"] = this.returnQuantityDisplay;
        data["returnToSupplier"] = this.returnToSupplier;
        data["quantityTally"] = this.quantityTally;
        data["noOfPieces"] = this.noOfPieces;
        data["inputPerID"] = this.inputPerID;
        data["displayInputPerID"] = this.displayInputPerID;
        data["perID"] = this.perID;
        data["unitAmount"] = this.unitAmount;
        data["unitAmountInCurrency"] = this.unitAmountInCurrency;
        data["unitAmountDisplay"] = this.unitAmountDisplay;
        data["totalAmount"] = this.totalAmount;
        data["totalAmountInCurrency"] = this.totalAmountInCurrency;
        data["restockCharge"] = this.restockCharge;
        data["restockChargeInCurrency"] = this.restockChargeInCurrency;
        data["totalCost"] = this.totalCost;
        data["totalVMICost"] = this.totalVMICost;
        data["vmiRuleID"] = this.vmiRuleID;
        data["totalWeight"] = this.totalWeight;
        data["totalLength"] = this.totalLength;
        data["totalVolume"] = this.totalVolume;
        data["vatAmount"] = this.vatAmount;
        data["vatAmountInCurrency"] = this.vatAmountInCurrency;
        data["totalTax"] = this.totalTax;
        data["totalTaxInCurrency"] = this.totalTaxInCurrency;
        data["vatRateID"] = this.vatRateID;
        data["taxGroupID"] = this.taxGroupID;
        data["taxCodes"] = this.taxCodes;
        data["salesAnalysisCodeID"] = this.salesAnalysisCodeID;
        data["notes"] = this.notes;
        data["pointsEarnedAdjustment"] = this.pointsEarnedAdjustment;
        data["exportedToDataWarehouse"] = this.exportedToDataWarehouse;
        data["settlementAmount"] = this.settlementAmount;
        data["settlementAmountInCurrency"] = this.settlementAmountInCurrency;
        data["additionalCharge"] = this.additionalCharge;
        data["additionalCost"] = this.additionalCost;
        data["vmiSupplierInvoiceDocumentID"] = this.vmiSupplierInvoiceDocumentID;
        data["vmiReconciled"] = this.vmiReconciled;
        data["totalVMICostInCurrency"] = this.totalVMICostInCurrency;
        data["vmiExchangeRate"] = this.vmiExchangeRate;
        data["generatedFromContractInvoicing"] = this.generatedFromContractInvoicing;
        data["totalReportingCost"] = this.totalReportingCost;
        data["adjustedForPriceCorrectionsAmount"] = this.adjustedForPriceCorrectionsAmount;
        data["wmsProcessed"] = this.wmsProcessed;
        data["nonSalesAmount"] = this.nonSalesAmount;
        data["nonSalesAmountInCurrency"] = this.nonSalesAmountInCurrency;
        data["totalMargin"] = this.totalMargin;
        data["internalCostTotalMargin"] = this.internalCostTotalMargin;
        data["manualDiscount1Amount"] = this.manualDiscount1Amount;
        data["manualDiscount1AmountInCurrency"] = this.manualDiscount1AmountInCurrency;
        data["manualDiscount2Amount"] = this.manualDiscount2Amount;
        data["manualDiscount2AmountInCurrency"] = this.manualDiscount2AmountInCurrency;
        data["includeAVOCost"] = this.includeAVOCost;
        data["wmsCreatedFromRN"] = this.wmsCreatedFromRN;
        data["sellingPriceRuleID"] = this.sellingPriceRuleID;
        data["promotionID"] = this.promotionID;
        data["disableRebateAccruals"] = this.disableRebateAccruals;
        data["internalTotalCostPrice"] = this.internalTotalCostPrice;
        data["settlementDiscount"] = this.settlementDiscount;
        data["manualLinePriceToCalculate"] = this.manualLinePriceToCalculate;
        data["productBatchOption"] = this.productBatchOption;
        data["createdFromContractInvoicingLineID"] = this.createdFromContractInvoicingLineID;
        data["couponID"] = this.couponID;
        data["promotionPointsAdjustment"] = this.promotionPointsAdjustment;
        data["quantityFromScale"] = this.quantityFromScale;
        data["scaleGrossWeight"] = this.scaleGrossWeight;
        data["invoiceLineItemNumber"] = this.invoiceLineItemNumber;
        data["invoiceLineLineType"] = this.invoiceLineLineType;
        data["invoiceLineDeliveryNoteLineID"] = this.invoiceLineDeliveryNoteLineID;
        data["invoiceLineQuantity"] = this.invoiceLineQuantity;
        data["invoiceLineTotalAmount"] = this.invoiceLineTotalAmount;
        data["invoiceLineTotalAmountInCurrency"] = this.invoiceLineTotalAmountInCurrency;
        data["invoiceLineTotalCost"] = this.invoiceLineTotalCost;
        data["invoiceLineTotalVmiCost"] = this.invoiceLineTotalVmiCost;
        data["invoiceLineTotalVmiCostInCurrency"] = this.invoiceLineTotalVmiCostInCurrency;
        data["invoiceLineVmiExchangeRate"] = this.invoiceLineVmiExchangeRate;
        data["invoiceLineTotalWeight"] = this.invoiceLineTotalWeight;
        data["invoiceLineQuantityCredited"] = this.invoiceLineQuantityCredited;
        data["invoiceLineUnitAmountInCurrency"] = this.invoiceLineUnitAmountInCurrency;
        data["invoiceLineUnitAmount"] = this.invoiceLineUnitAmount;
        data["invoiceLineSettlementAmount"] = this.invoiceLineSettlementAmount;
        data["invoiceLineSettlementAmountInCurrency"] = this.invoiceLineSettlementAmountInCurrency;
        data["invoiceID"] = this.invoiceID;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceCustomerID"] = this.invoiceCustomerID;
        data["orderID"] = this.orderID;
        data["invoiceLineUseTaxExemptCertificate"] = this.invoiceLineUseTaxExemptCertificate;
        data["invoiceCustomerRef"] = this.invoiceCustomerRef;
        data["invoiceAddressID"] = this.invoiceAddressID;
        data["invoiceAddress"] = this.invoiceAddress;
        data["deliveryAddressID"] = this.deliveryAddressID;
        data["deliveryAddress"] = this.deliveryAddress;
        data["deliveryAreaID"] = this.deliveryAreaID;
        data["orderLineQuantityTally"] = this.orderLineQuantityTally;
        data["saleType"] = this.saleType;
        data["orderLineOrderIssuingBranchID"] = this.orderLineOrderIssuingBranchID;
        data["orderLineNotes"] = this.orderLineNotes;
        data["orderQuantity"] = this.orderQuantity;
        data["orderLineInputPerID"] = this.orderLineInputPerID;
        data["orderLineQuantityDisplay"] = this.orderLineQuantityDisplay;
        data["orderLineDiscount1"] = this.orderLineDiscount1;
        data["orderLineDiscount1Type"] = this.orderLineDiscount1Type;
        data["orderLineDiscount2"] = this.orderLineDiscount2;
        data["orderLineDiscount2Type"] = this.orderLineDiscount2Type;
        data["orderLineDiscountAmount1InCurrency"] = this.orderLineDiscountAmount1InCurrency;
        data["orderLineDiscountAmount2InCurrency"] = this.orderLineDiscountAmount2InCurrency;
        data["orderLineUnitSellPriceInCurrency"] = this.orderLineUnitSellPriceInCurrency;
        data["orderLineUnitSellPriceDisplay"] = this.orderLineUnitSellPriceDisplay;
        data["orderLineAdditionalCost"] = this.orderLineAdditionalCost;
        data["orderLineManualOrderLineTypeID"] = this.orderLineManualOrderLineTypeID;
        data["orderLineAdditionalCharge"] = this.orderLineAdditionalCharge;
        data["olavoCount"] = this.olavoCount;
        data["orderLineWmsParentLineID"] = this.orderLineWmsParentLineID;
        data["orderLineIsWmsAdditionalCharge"] = this.orderLineIsWmsAdditionalCharge;
        data["orderLinePackCount"] = this.orderLinePackCount;
        data["orderLineNetPriced"] = this.orderLineNetPriced;
        data["orderLinePricingType"] = this.orderLinePricingType;
        data["orderLinePurchaseOrderID"] = this.orderLinePurchaseOrderID;
        data["orderLinePurchaseOrderNumber"] = this.orderLinePurchaseOrderNumber;
        data["orderLinePurchaseOrderSupplierID"] = this.orderLinePurchaseOrderSupplierID;
        data["commissionTotalCostPrice"] = this.commissionTotalCostPrice;
        data["orderLinePromotionID"] = this.orderLinePromotionID;
        data["pointsEarned"] = this.pointsEarned;
        data["orderLineInternalTotalCostPrice"] = this.orderLineInternalTotalCostPrice;
        data["orderLineTotalWorksOrderAvoCost"] = this.orderLineTotalWorksOrderAvoCost;
        data["vatInclusiveUnitSellPrice"] = this.vatInclusiveUnitSellPrice;
        data["orderLineRebateSaleType"] = this.orderLineRebateSaleType;
        data["productType"] = this.productType;
        data["productSubType"] = this.productSubType;
        data["productCode"] = this.productCode;
        data["productBarCode"] = this.productBarCode;
        data["productDescription"] = this.productDescription;
        data["productShortDescription"] = this.productShortDescription;
        data["thickness"] = this.thickness;
        data["width"] = this.width;
        data["imperial"] = this.imperial;
        data["tallyLengths"] = this.tallyLengths;
        data["tallyLengthsPerID"] = this.tallyLengthsPerID;
        data["availableWidths"] = this.availableWidths;
        data["weight"] = this.weight;
        data["length"] = this.length;
        data["wmsSent"] = this.wmsSent;
        data["wmsPendingOC"] = this.wmsPendingOC;
        data["productDefaultSupplierID"] = this.productDefaultSupplierID;
        data["productDefaultPiecesPerPack"] = this.productDefaultPiecesPerPack;
        data["productDefaultUnitSizePerID"] = this.productDefaultUnitSizePerID;
        data["productAllowMultiplePersOnUnitSizes"] = this.productAllowMultiplePersOnUnitSizes;
        data["productAllowSettlementDiscount"] = this.productAllowSettlementDiscount;
        data["branchAllowSettlementDiscount"] = this.branchAllowSettlementDiscount;
        data["defaultAllowSettlementDiscount"] = this.defaultAllowSettlementDiscount;
        data["productStockControlByLength"] = this.productStockControlByLength;
        data["productStockedByCost"] = this.productStockedByCost;
        data["productPerRuleID"] = this.productPerRuleID;
        data["productSpecial"] = this.productSpecial;
        data["productOwnBrandProduct"] = this.productOwnBrandProduct;
        data["productGroupID"] = this.productGroupID;
        data["productWeightPerID"] = this.productWeightPerID;
        data["productApplyRebateAccruals"] = this.productApplyRebateAccruals;
        data["totalLengthImperial"] = this.totalLengthImperial;
        data["totalVolumeImperial"] = this.totalVolumeImperial;
        data["priceRuleSettlementDiscNotAllowed"] = this.priceRuleSettlementDiscNotAllowed;
        data["promotionSettlementDiscNotAllowed"] = this.promotionSettlementDiscNotAllowed;
        data["averageCost"] = this.averageCost;
        data["averageCostPerID"] = this.averageCostPerID;
        data["averageCostWithAdd"] = this.averageCostWithAdd;
        data["companyAverageCost"] = this.companyAverageCost;
        data["companyAverageCostPerID"] = this.companyAverageCostPerID;
        data["companyAverageCostWithAdd"] = this.companyAverageCostWithAdd;
        data["vatID"] = this.vatID;
        data["rate"] = this.rate;
        data["branchName"] = this.branchName;
        data["invoiceLineTaxAreaID"] = this.invoiceLineTaxAreaID;
        data["invoiceLineTaxUsageTypeID"] = this.invoiceLineTaxUsageTypeID;
        data["ediVatCode"] = this.ediVatCode;
        data["jobID"] = this.jobID;
        data["orderLineEdiInputPerConversionToBase"] = this.orderLineEdiInputPerConversionToBase;
        data["invoiceLineManualOrderLineTypeDescription"] = this.invoiceLineManualOrderLineTypeDescription;
        data["invoiceLineManualOrderLineTypeCode"] = this.invoiceLineManualOrderLineTypeCode;
        data["statisticsPerID"] = this.statisticsPerID;
        data["stockPerID"] = this.stockPerID;
        data["priceCorrection"] = this.priceCorrection;
        data["cashAccountBalanceReversed"] = this.cashAccountBalanceReversed;
        data["statsPerConversion"] = this.statsPerConversion;
        data["contractID"] = this.contractID;
        data["contractInvoicingLineID"] = this.contractInvoicingLineID;
        data["contractInvoicing"] = this.contractInvoicing;
        data["invoiceLineBranchID"] = this.invoiceLineBranchID;
        data["invoiceLineJobDefaultAddressTaxAreaID"] = this.invoiceLineJobDefaultAddressTaxAreaID;
        data["invoiceLineJobDefaultAddressTaxUsageTypeID"] = this.invoiceLineJobDefaultAddressTaxUsageTypeID;
        data["totalInvoiceLineCostAdjustment"] = this.totalInvoiceLineCostAdjustment;
        data["invoiceLineQuantityCreditedDisplay"] = this.invoiceLineQuantityCreditedDisplay;
        data["supplierCreditLineID"] = this.supplierCreditLineID;
        data["supplierReturnLineID"] = this.supplierReturnLineID;
        data["cashBalanceCustomerID"] = this.cashBalanceCustomerID;
        data["orderLineKitHeaderID"] = this.orderLineKitHeaderID;
        data["orderLineKitHeaderPromotionID"] = this.orderLineKitHeaderPromotionID;
        data["productWarningText"] = this.productWarningText;
        data["invoiceLineCommissionTotalCost"] = this.invoiceLineCommissionTotalCost;
        data["supplierInvoiceLineId"] = this.supplierInvoiceLineId;
        data["supplierInvoiceId"] = this.supplierInvoiceId;
        data["totalActualVolume"] = this.totalActualVolume;
        data["isProductLine"] = this.isProductLine;
        data["stockPerConversion"] = this.stockPerConversion;
        return data; 
    }
}

export interface ICreditNoteLine {
    lineItems?: CreditNoteItem[] | undefined;
    creditNoteLineID?: number | undefined;
    creditNoteID?: number | undefined;
    branchID?: number | undefined;
    lineNumber?: number | undefined;
    itemNumber?: number | undefined;
    lineType?: number | undefined;
    description?: string | undefined;
    invoiceLineID?: number | undefined;
    orderLineID?: number | undefined;
    customerReturnLineID?: number | undefined;
    productID?: number | undefined;
    manualOrderLineTypeID?: number | undefined;
    manualCode?: string | undefined;
    manualDescription?: string | undefined;
    quantity?: number | undefined;
    quantityDisplay?: number | undefined;
    returnQuantity?: number | undefined;
    returnQuantityDisplay?: number | undefined;
    returnToSupplier?: boolean | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    inputPerID?: number | undefined;
    displayInputPerID?: number | undefined;
    perID?: number | undefined;
    unitAmount?: number | undefined;
    unitAmountInCurrency?: number | undefined;
    unitAmountDisplay?: number | undefined;
    totalAmount?: number | undefined;
    totalAmountInCurrency?: number | undefined;
    restockCharge?: number | undefined;
    restockChargeInCurrency?: number | undefined;
    totalCost?: number | undefined;
    totalVMICost?: number | undefined;
    vmiRuleID?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    vatAmount?: number | undefined;
    vatAmountInCurrency?: number | undefined;
    totalTax?: number | undefined;
    totalTaxInCurrency?: number | undefined;
    vatRateID?: number | undefined;
    taxGroupID?: number | undefined;
    taxCodes?: string | undefined;
    salesAnalysisCodeID?: number | undefined;
    notes?: string | undefined;
    pointsEarnedAdjustment?: number | undefined;
    exportedToDataWarehouse?: boolean | undefined;
    settlementAmount?: number | undefined;
    settlementAmountInCurrency?: number | undefined;
    additionalCharge?: number | undefined;
    additionalCost?: number | undefined;
    vmiSupplierInvoiceDocumentID?: number | undefined;
    vmiReconciled?: boolean | undefined;
    totalVMICostInCurrency?: number | undefined;
    vmiExchangeRate?: number | undefined;
    generatedFromContractInvoicing?: boolean | undefined;
    totalReportingCost?: number | undefined;
    adjustedForPriceCorrectionsAmount?: number | undefined;
    wmsProcessed?: boolean | undefined;
    nonSalesAmount?: number | undefined;
    nonSalesAmountInCurrency?: number | undefined;
    totalMargin?: number | undefined;
    internalCostTotalMargin?: number | undefined;
    manualDiscount1Amount?: number | undefined;
    manualDiscount1AmountInCurrency?: number | undefined;
    manualDiscount2Amount?: number | undefined;
    manualDiscount2AmountInCurrency?: number | undefined;
    includeAVOCost?: boolean | undefined;
    wmsCreatedFromRN?: boolean | undefined;
    sellingPriceRuleID?: number | undefined;
    promotionID?: number | undefined;
    disableRebateAccruals?: boolean | undefined;
    internalTotalCostPrice?: number | undefined;
    settlementDiscount?: number | undefined;
    manualLinePriceToCalculate?: number | undefined;
    productBatchOption?: number | undefined;
    createdFromContractInvoicingLineID?: number | undefined;
    couponID?: number | undefined;
    promotionPointsAdjustment?: number | undefined;
    quantityFromScale?: number | undefined;
    scaleGrossWeight?: number | undefined;
    invoiceLineItemNumber?: number | undefined;
    invoiceLineLineType?: number | undefined;
    invoiceLineDeliveryNoteLineID?: number | undefined;
    invoiceLineQuantity?: number | undefined;
    invoiceLineTotalAmount?: number | undefined;
    invoiceLineTotalAmountInCurrency?: number | undefined;
    invoiceLineTotalCost?: number | undefined;
    invoiceLineTotalVmiCost?: number | undefined;
    invoiceLineTotalVmiCostInCurrency?: number | undefined;
    invoiceLineVmiExchangeRate?: number | undefined;
    invoiceLineTotalWeight?: number | undefined;
    invoiceLineQuantityCredited?: number | undefined;
    invoiceLineUnitAmountInCurrency?: number | undefined;
    invoiceLineUnitAmount?: number | undefined;
    invoiceLineSettlementAmount?: number | undefined;
    invoiceLineSettlementAmountInCurrency?: number | undefined;
    invoiceID?: number | undefined;
    invoiceNumber?: number | undefined;
    invoiceCustomerID?: number | undefined;
    orderID?: number | undefined;
    invoiceLineUseTaxExemptCertificate?: boolean | undefined;
    invoiceCustomerRef?: string | undefined;
    invoiceAddressID?: number | undefined;
    invoiceAddress?: string | undefined;
    deliveryAddressID?: number | undefined;
    deliveryAddress?: string | undefined;
    deliveryAreaID?: number | undefined;
    orderLineQuantityTally?: string | undefined;
    saleType?: number | undefined;
    orderLineOrderIssuingBranchID?: number | undefined;
    orderLineNotes?: string | undefined;
    orderQuantity?: number | undefined;
    orderLineInputPerID?: number | undefined;
    orderLineQuantityDisplay?: number | undefined;
    orderLineDiscount1?: number | undefined;
    orderLineDiscount1Type?: number | undefined;
    orderLineDiscount2?: number | undefined;
    orderLineDiscount2Type?: number | undefined;
    orderLineDiscountAmount1InCurrency?: number | undefined;
    orderLineDiscountAmount2InCurrency?: number | undefined;
    orderLineUnitSellPriceInCurrency?: number | undefined;
    orderLineUnitSellPriceDisplay?: number | undefined;
    orderLineAdditionalCost?: number | undefined;
    orderLineManualOrderLineTypeID?: number | undefined;
    orderLineAdditionalCharge?: number | undefined;
    olavoCount?: number | undefined;
    orderLineWmsParentLineID?: number | undefined;
    orderLineIsWmsAdditionalCharge?: boolean | undefined;
    orderLinePackCount?: number | undefined;
    orderLineNetPriced?: boolean | undefined;
    orderLinePricingType?: number | undefined;
    orderLinePurchaseOrderID?: number | undefined;
    orderLinePurchaseOrderNumber?: number | undefined;
    orderLinePurchaseOrderSupplierID?: number | undefined;
    commissionTotalCostPrice?: number | undefined;
    orderLinePromotionID?: number | undefined;
    pointsEarned?: number | undefined;
    orderLineInternalTotalCostPrice?: number | undefined;
    orderLineTotalWorksOrderAvoCost?: number | undefined;
    vatInclusiveUnitSellPrice?: number | undefined;
    orderLineRebateSaleType?: number | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    productCode?: string | undefined;
    productBarCode?: string | undefined;
    productDescription?: string | undefined;
    productShortDescription?: string | undefined;
    thickness?: number | undefined;
    width?: number | undefined;
    imperial?: boolean | undefined;
    tallyLengths?: string | undefined;
    tallyLengthsPerID?: number | undefined;
    availableWidths?: string | undefined;
    weight?: number | undefined;
    length?: number | undefined;
    wmsSent?: boolean | undefined;
    wmsPendingOC?: boolean | undefined;
    productDefaultSupplierID?: number | undefined;
    productDefaultPiecesPerPack?: number | undefined;
    productDefaultUnitSizePerID?: number | undefined;
    productAllowMultiplePersOnUnitSizes?: boolean | undefined;
    productAllowSettlementDiscount?: boolean | undefined;
    branchAllowSettlementDiscount?: boolean | undefined;
    defaultAllowSettlementDiscount?: boolean | undefined;
    productStockControlByLength?: boolean | undefined;
    productStockedByCost?: boolean | undefined;
    productPerRuleID?: number | undefined;
    productSpecial?: boolean | undefined;
    productOwnBrandProduct?: boolean | undefined;
    productGroupID?: number | undefined;
    productWeightPerID?: number | undefined;
    productApplyRebateAccruals?: boolean | undefined;
    totalLengthImperial?: number | undefined;
    totalVolumeImperial?: number | undefined;
    priceRuleSettlementDiscNotAllowed?: boolean | undefined;
    promotionSettlementDiscNotAllowed?: boolean | undefined;
    averageCost?: number | undefined;
    averageCostPerID?: number | undefined;
    averageCostWithAdd?: number | undefined;
    companyAverageCost?: number | undefined;
    companyAverageCostPerID?: number | undefined;
    companyAverageCostWithAdd?: number | undefined;
    vatID?: number | undefined;
    rate?: number | undefined;
    branchName?: string | undefined;
    invoiceLineTaxAreaID?: number | undefined;
    invoiceLineTaxUsageTypeID?: number | undefined;
    ediVatCode?: string | undefined;
    jobID?: number | undefined;
    orderLineEdiInputPerConversionToBase?: number | undefined;
    invoiceLineManualOrderLineTypeDescription?: string | undefined;
    invoiceLineManualOrderLineTypeCode?: string | undefined;
    statisticsPerID?: number | undefined;
    stockPerID?: number | undefined;
    priceCorrection?: boolean | undefined;
    cashAccountBalanceReversed?: boolean | undefined;
    statsPerConversion?: number | undefined;
    contractID?: number | undefined;
    contractInvoicingLineID?: number | undefined;
    contractInvoicing?: boolean | undefined;
    invoiceLineBranchID?: number | undefined;
    invoiceLineJobDefaultAddressTaxAreaID?: number | undefined;
    invoiceLineJobDefaultAddressTaxUsageTypeID?: number | undefined;
    totalInvoiceLineCostAdjustment?: number | undefined;
    invoiceLineQuantityCreditedDisplay?: number | undefined;
    supplierCreditLineID?: number | undefined;
    supplierReturnLineID?: number | undefined;
    cashBalanceCustomerID?: number | undefined;
    orderLineKitHeaderID?: number | undefined;
    orderLineKitHeaderPromotionID?: number | undefined;
    productWarningText?: string | undefined;
    invoiceLineCommissionTotalCost?: number | undefined;
    supplierInvoiceLineId?: number | undefined;
    supplierInvoiceId?: number | undefined;
    totalActualVolume?: number | undefined;
    isProductLine?: boolean | undefined;
    stockPerConversion?: number | undefined;
}

export class CreditNoteAdditionalCost implements ICreditNoteAdditionalCost {
    creditNoteAddCostChargeID?: number | undefined;
    deleted?: number | undefined;
    creditNoteID?: number | undefined;
    additionalCostChargeID?: number | undefined;
    supplierID?: number | undefined;
    reference?: string | undefined;
    currencyID?: number | undefined;
    estimateExchangeRate?: number | undefined;
    estimateCost?: number | undefined;
    estimateCostInCurrency?: number | undefined;
    estimatePercentEntered?: number | undefined;
    actualExchangeRate?: number | undefined;
    actualCost?: number | undefined;
    actualCostInCurrency?: number | undefined;
    costPriceValue?: number | undefined;
    costPriceValueType?: number | undefined;
    costProRateBy?: number | undefined;
    actualCharge?: number | undefined;
    chargePriceValue?: number | undefined;
    chargePriceValueType?: number | undefined;
    chargeProRateBy?: number | undefined;
    glCodePayable?: string | undefined;
    notes?: string | undefined;
    dateTimeCreated?: Date | undefined;
    invoiced?: boolean | undefined;
    autoGenerated?: boolean | undefined;
    createdFromDeliveryID?: number | undefined;
    rebateAccrual?: boolean | undefined;
    description?: string | undefined;
    costCalcUseActualSize?: boolean | undefined;
    chargeCalcUseActualSize?: boolean | undefined;
    costApplyToExternalAVOs?: boolean | undefined;
    costPercentBasedOnSellPrice?: boolean | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;

    constructor(data?: ICreditNoteAdditionalCost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creditNoteAddCostChargeID = _data["creditNoteAddCostChargeID"];
            this.deleted = _data["deleted"];
            this.creditNoteID = _data["creditNoteID"];
            this.additionalCostChargeID = _data["additionalCostChargeID"];
            this.supplierID = _data["supplierID"];
            this.reference = _data["reference"];
            this.currencyID = _data["currencyID"];
            this.estimateExchangeRate = _data["estimateExchangeRate"];
            this.estimateCost = _data["estimateCost"];
            this.estimateCostInCurrency = _data["estimateCostInCurrency"];
            this.estimatePercentEntered = _data["estimatePercentEntered"];
            this.actualExchangeRate = _data["actualExchangeRate"];
            this.actualCost = _data["actualCost"];
            this.actualCostInCurrency = _data["actualCostInCurrency"];
            this.costPriceValue = _data["costPriceValue"];
            this.costPriceValueType = _data["costPriceValueType"];
            this.costProRateBy = _data["costProRateBy"];
            this.actualCharge = _data["actualCharge"];
            this.chargePriceValue = _data["chargePriceValue"];
            this.chargePriceValueType = _data["chargePriceValueType"];
            this.chargeProRateBy = _data["chargeProRateBy"];
            this.glCodePayable = _data["glCodePayable"];
            this.notes = _data["notes"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.invoiced = _data["invoiced"];
            this.autoGenerated = _data["autoGenerated"];
            this.createdFromDeliveryID = _data["createdFromDeliveryID"];
            this.rebateAccrual = _data["rebateAccrual"];
            this.description = _data["description"];
            this.costCalcUseActualSize = _data["costCalcUseActualSize"];
            this.chargeCalcUseActualSize = _data["chargeCalcUseActualSize"];
            this.costApplyToExternalAVOs = _data["costApplyToExternalAVOs"];
            this.costPercentBasedOnSellPrice = _data["costPercentBasedOnSellPrice"];
            this.supplierCode = _data["supplierCode"];
            this.supplierName = _data["supplierName"];
        }
    }

    static fromJS(data: any): CreditNoteAdditionalCost {
        data = typeof data === 'object' ? data : {};
        let result = new CreditNoteAdditionalCost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creditNoteAddCostChargeID"] = this.creditNoteAddCostChargeID;
        data["deleted"] = this.deleted;
        data["creditNoteID"] = this.creditNoteID;
        data["additionalCostChargeID"] = this.additionalCostChargeID;
        data["supplierID"] = this.supplierID;
        data["reference"] = this.reference;
        data["currencyID"] = this.currencyID;
        data["estimateExchangeRate"] = this.estimateExchangeRate;
        data["estimateCost"] = this.estimateCost;
        data["estimateCostInCurrency"] = this.estimateCostInCurrency;
        data["estimatePercentEntered"] = this.estimatePercentEntered;
        data["actualExchangeRate"] = this.actualExchangeRate;
        data["actualCost"] = this.actualCost;
        data["actualCostInCurrency"] = this.actualCostInCurrency;
        data["costPriceValue"] = this.costPriceValue;
        data["costPriceValueType"] = this.costPriceValueType;
        data["costProRateBy"] = this.costProRateBy;
        data["actualCharge"] = this.actualCharge;
        data["chargePriceValue"] = this.chargePriceValue;
        data["chargePriceValueType"] = this.chargePriceValueType;
        data["chargeProRateBy"] = this.chargeProRateBy;
        data["glCodePayable"] = this.glCodePayable;
        data["notes"] = this.notes;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["invoiced"] = this.invoiced;
        data["autoGenerated"] = this.autoGenerated;
        data["createdFromDeliveryID"] = this.createdFromDeliveryID;
        data["rebateAccrual"] = this.rebateAccrual;
        data["description"] = this.description;
        data["costCalcUseActualSize"] = this.costCalcUseActualSize;
        data["chargeCalcUseActualSize"] = this.chargeCalcUseActualSize;
        data["costApplyToExternalAVOs"] = this.costApplyToExternalAVOs;
        data["costPercentBasedOnSellPrice"] = this.costPercentBasedOnSellPrice;
        data["supplierCode"] = this.supplierCode;
        data["supplierName"] = this.supplierName;
        return data; 
    }
}

export interface ICreditNoteAdditionalCost {
    creditNoteAddCostChargeID?: number | undefined;
    deleted?: number | undefined;
    creditNoteID?: number | undefined;
    additionalCostChargeID?: number | undefined;
    supplierID?: number | undefined;
    reference?: string | undefined;
    currencyID?: number | undefined;
    estimateExchangeRate?: number | undefined;
    estimateCost?: number | undefined;
    estimateCostInCurrency?: number | undefined;
    estimatePercentEntered?: number | undefined;
    actualExchangeRate?: number | undefined;
    actualCost?: number | undefined;
    actualCostInCurrency?: number | undefined;
    costPriceValue?: number | undefined;
    costPriceValueType?: number | undefined;
    costProRateBy?: number | undefined;
    actualCharge?: number | undefined;
    chargePriceValue?: number | undefined;
    chargePriceValueType?: number | undefined;
    chargeProRateBy?: number | undefined;
    glCodePayable?: string | undefined;
    notes?: string | undefined;
    dateTimeCreated?: Date | undefined;
    invoiced?: boolean | undefined;
    autoGenerated?: boolean | undefined;
    createdFromDeliveryID?: number | undefined;
    rebateAccrual?: boolean | undefined;
    description?: string | undefined;
    costCalcUseActualSize?: boolean | undefined;
    chargeCalcUseActualSize?: boolean | undefined;
    costApplyToExternalAVOs?: boolean | undefined;
    costPercentBasedOnSellPrice?: boolean | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;
}

export class JourneyManifestLine implements IJourneyManifestLine {
    journeyID?: number | undefined;
    useSimpleOrderProcessing?: boolean | undefined;
    journeyLineID?: number | undefined;
    journeyStopID?: number | undefined;
    orderID?: number | undefined;
    orderNumber?: number | undefined;
    noOfLines?: number | undefined;
    worksOrderProcessHeaderID?: number | undefined;
    dropNumber?: number | undefined;
    dropIsCollection?: boolean | undefined;
    dropTime?: Date | undefined;
    needsCollection?: boolean | undefined;
    workOrderID?: number | undefined;
    workOrderNumber?: number | undefined;
    pickingNoteNumber?: number | undefined;
    deliveryNoteNumber?: number | undefined;
    custometReturnNumber?: number | undefined;
    supplierReturnNumber?: number | undefined;
    purchaseOrderNumber?: number | undefined;
    pickingNoteID?: number | undefined;
    customerReturnID?: number | undefined;
    supplierReturnID?: number | undefined;
    deliverNoteID?: number | undefined;
    creditNoteNumber?: number | undefined;
    purchaseOrderApprovedByID?: number | undefined;
    branchID?: number | undefined;
    issuingBranchID?: number | undefined;
    workOrderStatus?: number | undefined;
    customerReturnStatus?: number | undefined;
    supplierReturnStatus?: number | undefined;
    purchaseOrderStatus?: number | undefined;
    creditNoteMarkedAsReturned?: boolean | undefined;
    creditNoteHandling?: number | undefined;
    creditNoteReleasedByID?: number | undefined;
    creditNoteApprovedByID?: number | undefined;
    workOrderProcessHeaderStatus?: number | undefined;
    wophWorksOrderID?: number | undefined;
    hasAddCostProportions?: boolean | undefined;
    purchaseOrderID?: number | undefined;
    creditNoteID?: number | undefined;
    orderType?: number | undefined;
    orderInvoiced?: boolean | undefined;
    documentNumber?: number | undefined;
    deliveryCity?: string | undefined;
    deliveryAreaName?: string | undefined;
    deliveryAddressCode?: string | undefined;
    deliveryAddress?: string | undefined;
    deliveryAddressID?: number | undefined;
    deliveryCounty?: string | undefined;
    deliveryAddress3?: string | undefined;
    deliveryAddress2?: string | undefined;
    deliveryAddress1?: string | undefined;
    deliveryAddressLongitude?: number | undefined;
    deliveryAddressLatitude?: number | undefined;
    branchName?: string | undefined;
    dateRequired?: Date | undefined;
    dateRequiredOption?: number | undefined;
    deliveryTimeDesc?: string | undefined;
    maximumWidth?: number | undefined;
    maximumLength?: number | undefined;
    noOfPacks?: number | undefined;
    orderCustomerRef?: string | undefined;
    orderJobRef?: string | undefined;
    stockLocationID?: number | undefined;
    toStockLocationID?: number | undefined;
    customerID?: number | undefined;
    totalWeight?: string | undefined;
    totalVolume?: string | undefined;
    totalVolumeMBF?: string | undefined;
    deliveryPickingNoteID?: number | undefined;
    customerName?: string | undefined;
    supplierID?: number | undefined;
    supplierName?: string | undefined;
    supplierReturnType?: number | undefined;
    issuingBranchName?: string | undefined;
    toBranchID?: number | undefined;
    toBranchName?: string | undefined;
    viaBranchID?: number | undefined;
    viaBranchName?: string | undefined;
    documentType?: number | undefined;
    documentTypeEnum?: JourneyManifestLineDocumentTypeEnum | undefined;
    viaBranchAddress?: string | undefined;
    deliveryTime?: number | undefined;
    orderSaleType?: number | undefined;
    documentID?: number | undefined;
    picked?: boolean | undefined;
    delivered?: boolean | undefined;
    proofOfDeliveryReturned?: boolean | undefined;
    creditNoteHeader?: CreditNoteHeader | undefined;
    customerReturnHeader?: CustomerReturnHeader | undefined;
    deliveryNoteHeader?: DeliveryNoteHeader | undefined;
    journeyHeader?: JourneyHeader | undefined;
    journeyStop?: JourneyStop | undefined;
    orderHeader?: OrderHeader | undefined;
    pickingNoteHeader?: PickingNoteHeader | undefined;
    purchaseOrderHeader?: PurchaseOrderHeader | undefined;
    supplierReturnHeader?: SupplierReturnHeader | undefined;
    worksOrderHeader?: WorksOrderHeader | undefined;
    worksOrderProcessHeader?: WorksOrderProcessHeader | undefined;
    displayTotalVolume?: string | undefined;
    displayTotalVolumeMBF?: string | undefined;
    displayTotalWeight?: string | undefined;
    orderCashSale?: boolean | undefined;
    deleted?: number | undefined;

    constructor(data?: IJourneyManifestLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.journeyID = _data["journeyID"];
            this.useSimpleOrderProcessing = _data["useSimpleOrderProcessing"];
            this.journeyLineID = _data["journeyLineID"];
            this.journeyStopID = _data["journeyStopID"];
            this.orderID = _data["orderID"];
            this.orderNumber = _data["orderNumber"];
            this.noOfLines = _data["noOfLines"];
            this.worksOrderProcessHeaderID = _data["worksOrderProcessHeaderID"];
            this.dropNumber = _data["dropNumber"];
            this.dropIsCollection = _data["dropIsCollection"];
            this.dropTime = _data["dropTime"] ? new Date(_data["dropTime"].toString()) : <any>undefined;
            this.needsCollection = _data["needsCollection"];
            this.workOrderID = _data["workOrderID"];
            this.workOrderNumber = _data["workOrderNumber"];
            this.pickingNoteNumber = _data["pickingNoteNumber"];
            this.deliveryNoteNumber = _data["deliveryNoteNumber"];
            this.custometReturnNumber = _data["custometReturnNumber"];
            this.supplierReturnNumber = _data["supplierReturnNumber"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.pickingNoteID = _data["pickingNoteID"];
            this.customerReturnID = _data["customerReturnID"];
            this.supplierReturnID = _data["supplierReturnID"];
            this.deliverNoteID = _data["deliverNoteID"];
            this.creditNoteNumber = _data["creditNoteNumber"];
            this.purchaseOrderApprovedByID = _data["purchaseOrderApprovedByID"];
            this.branchID = _data["branchID"];
            this.issuingBranchID = _data["issuingBranchID"];
            this.workOrderStatus = _data["workOrderStatus"];
            this.customerReturnStatus = _data["customerReturnStatus"];
            this.supplierReturnStatus = _data["supplierReturnStatus"];
            this.purchaseOrderStatus = _data["purchaseOrderStatus"];
            this.creditNoteMarkedAsReturned = _data["creditNoteMarkedAsReturned"];
            this.creditNoteHandling = _data["creditNoteHandling"];
            this.creditNoteReleasedByID = _data["creditNoteReleasedByID"];
            this.creditNoteApprovedByID = _data["creditNoteApprovedByID"];
            this.workOrderProcessHeaderStatus = _data["workOrderProcessHeaderStatus"];
            this.wophWorksOrderID = _data["wophWorksOrderID"];
            this.hasAddCostProportions = _data["hasAddCostProportions"];
            this.purchaseOrderID = _data["purchaseOrderID"];
            this.creditNoteID = _data["creditNoteID"];
            this.orderType = _data["orderType"];
            this.orderInvoiced = _data["orderInvoiced"];
            this.documentNumber = _data["documentNumber"];
            this.deliveryCity = _data["deliveryCity"];
            this.deliveryAreaName = _data["deliveryAreaName"];
            this.deliveryAddressCode = _data["deliveryAddressCode"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.deliveryAddressID = _data["deliveryAddressID"];
            this.deliveryCounty = _data["deliveryCounty"];
            this.deliveryAddress3 = _data["deliveryAddress3"];
            this.deliveryAddress2 = _data["deliveryAddress2"];
            this.deliveryAddress1 = _data["deliveryAddress1"];
            this.deliveryAddressLongitude = _data["deliveryAddressLongitude"];
            this.deliveryAddressLatitude = _data["deliveryAddressLatitude"];
            this.branchName = _data["branchName"];
            this.dateRequired = _data["dateRequired"] ? new Date(_data["dateRequired"].toString()) : <any>undefined;
            this.dateRequiredOption = _data["dateRequiredOption"];
            this.deliveryTimeDesc = _data["deliveryTimeDesc"];
            this.maximumWidth = _data["maximumWidth"];
            this.maximumLength = _data["maximumLength"];
            this.noOfPacks = _data["noOfPacks"];
            this.orderCustomerRef = _data["orderCustomerRef"];
            this.orderJobRef = _data["orderJobRef"];
            this.stockLocationID = _data["stockLocationID"];
            this.toStockLocationID = _data["toStockLocationID"];
            this.customerID = _data["customerID"];
            this.totalWeight = _data["totalWeight"];
            this.totalVolume = _data["totalVolume"];
            this.totalVolumeMBF = _data["totalVolumeMBF"];
            this.deliveryPickingNoteID = _data["deliveryPickingNoteID"];
            this.customerName = _data["customerName"];
            this.supplierID = _data["supplierID"];
            this.supplierName = _data["supplierName"];
            this.supplierReturnType = _data["supplierReturnType"];
            this.issuingBranchName = _data["issuingBranchName"];
            this.toBranchID = _data["toBranchID"];
            this.toBranchName = _data["toBranchName"];
            this.viaBranchID = _data["viaBranchID"];
            this.viaBranchName = _data["viaBranchName"];
            this.documentType = _data["documentType"];
            this.documentTypeEnum = _data["documentTypeEnum"];
            this.viaBranchAddress = _data["viaBranchAddress"];
            this.deliveryTime = _data["deliveryTime"];
            this.orderSaleType = _data["orderSaleType"];
            this.documentID = _data["documentID"];
            this.picked = _data["picked"];
            this.delivered = _data["delivered"];
            this.proofOfDeliveryReturned = _data["proofOfDeliveryReturned"];
            this.creditNoteHeader = _data["creditNoteHeader"] ? CreditNoteHeader.fromJS(_data["creditNoteHeader"]) : <any>undefined;
            this.customerReturnHeader = _data["customerReturnHeader"] ? CustomerReturnHeader.fromJS(_data["customerReturnHeader"]) : <any>undefined;
            this.deliveryNoteHeader = _data["deliveryNoteHeader"] ? DeliveryNoteHeader.fromJS(_data["deliveryNoteHeader"]) : <any>undefined;
            this.journeyHeader = _data["journeyHeader"] ? JourneyHeader.fromJS(_data["journeyHeader"]) : <any>undefined;
            this.journeyStop = _data["journeyStop"] ? JourneyStop.fromJS(_data["journeyStop"]) : <any>undefined;
            this.orderHeader = _data["orderHeader"] ? OrderHeader.fromJS(_data["orderHeader"]) : <any>undefined;
            this.pickingNoteHeader = _data["pickingNoteHeader"] ? PickingNoteHeader.fromJS(_data["pickingNoteHeader"]) : <any>undefined;
            this.purchaseOrderHeader = _data["purchaseOrderHeader"] ? PurchaseOrderHeader.fromJS(_data["purchaseOrderHeader"]) : <any>undefined;
            this.supplierReturnHeader = _data["supplierReturnHeader"] ? SupplierReturnHeader.fromJS(_data["supplierReturnHeader"]) : <any>undefined;
            this.worksOrderHeader = _data["worksOrderHeader"] ? WorksOrderHeader.fromJS(_data["worksOrderHeader"]) : <any>undefined;
            this.worksOrderProcessHeader = _data["worksOrderProcessHeader"] ? WorksOrderProcessHeader.fromJS(_data["worksOrderProcessHeader"]) : <any>undefined;
            this.displayTotalVolume = _data["displayTotalVolume"];
            this.displayTotalVolumeMBF = _data["displayTotalVolumeMBF"];
            this.displayTotalWeight = _data["displayTotalWeight"];
            this.orderCashSale = _data["orderCashSale"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): JourneyManifestLine {
        data = typeof data === 'object' ? data : {};
        let result = new JourneyManifestLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["journeyID"] = this.journeyID;
        data["useSimpleOrderProcessing"] = this.useSimpleOrderProcessing;
        data["journeyLineID"] = this.journeyLineID;
        data["journeyStopID"] = this.journeyStopID;
        data["orderID"] = this.orderID;
        data["orderNumber"] = this.orderNumber;
        data["noOfLines"] = this.noOfLines;
        data["worksOrderProcessHeaderID"] = this.worksOrderProcessHeaderID;
        data["dropNumber"] = this.dropNumber;
        data["dropIsCollection"] = this.dropIsCollection;
        data["dropTime"] = this.dropTime ? this.dropTime.toISOString() : <any>undefined;
        data["needsCollection"] = this.needsCollection;
        data["workOrderID"] = this.workOrderID;
        data["workOrderNumber"] = this.workOrderNumber;
        data["pickingNoteNumber"] = this.pickingNoteNumber;
        data["deliveryNoteNumber"] = this.deliveryNoteNumber;
        data["custometReturnNumber"] = this.custometReturnNumber;
        data["supplierReturnNumber"] = this.supplierReturnNumber;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["pickingNoteID"] = this.pickingNoteID;
        data["customerReturnID"] = this.customerReturnID;
        data["supplierReturnID"] = this.supplierReturnID;
        data["deliverNoteID"] = this.deliverNoteID;
        data["creditNoteNumber"] = this.creditNoteNumber;
        data["purchaseOrderApprovedByID"] = this.purchaseOrderApprovedByID;
        data["branchID"] = this.branchID;
        data["issuingBranchID"] = this.issuingBranchID;
        data["workOrderStatus"] = this.workOrderStatus;
        data["customerReturnStatus"] = this.customerReturnStatus;
        data["supplierReturnStatus"] = this.supplierReturnStatus;
        data["purchaseOrderStatus"] = this.purchaseOrderStatus;
        data["creditNoteMarkedAsReturned"] = this.creditNoteMarkedAsReturned;
        data["creditNoteHandling"] = this.creditNoteHandling;
        data["creditNoteReleasedByID"] = this.creditNoteReleasedByID;
        data["creditNoteApprovedByID"] = this.creditNoteApprovedByID;
        data["workOrderProcessHeaderStatus"] = this.workOrderProcessHeaderStatus;
        data["wophWorksOrderID"] = this.wophWorksOrderID;
        data["hasAddCostProportions"] = this.hasAddCostProportions;
        data["purchaseOrderID"] = this.purchaseOrderID;
        data["creditNoteID"] = this.creditNoteID;
        data["orderType"] = this.orderType;
        data["orderInvoiced"] = this.orderInvoiced;
        data["documentNumber"] = this.documentNumber;
        data["deliveryCity"] = this.deliveryCity;
        data["deliveryAreaName"] = this.deliveryAreaName;
        data["deliveryAddressCode"] = this.deliveryAddressCode;
        data["deliveryAddress"] = this.deliveryAddress;
        data["deliveryAddressID"] = this.deliveryAddressID;
        data["deliveryCounty"] = this.deliveryCounty;
        data["deliveryAddress3"] = this.deliveryAddress3;
        data["deliveryAddress2"] = this.deliveryAddress2;
        data["deliveryAddress1"] = this.deliveryAddress1;
        data["deliveryAddressLongitude"] = this.deliveryAddressLongitude;
        data["deliveryAddressLatitude"] = this.deliveryAddressLatitude;
        data["branchName"] = this.branchName;
        data["dateRequired"] = this.dateRequired ? this.dateRequired.toISOString() : <any>undefined;
        data["dateRequiredOption"] = this.dateRequiredOption;
        data["deliveryTimeDesc"] = this.deliveryTimeDesc;
        data["maximumWidth"] = this.maximumWidth;
        data["maximumLength"] = this.maximumLength;
        data["noOfPacks"] = this.noOfPacks;
        data["orderCustomerRef"] = this.orderCustomerRef;
        data["orderJobRef"] = this.orderJobRef;
        data["stockLocationID"] = this.stockLocationID;
        data["toStockLocationID"] = this.toStockLocationID;
        data["customerID"] = this.customerID;
        data["totalWeight"] = this.totalWeight;
        data["totalVolume"] = this.totalVolume;
        data["totalVolumeMBF"] = this.totalVolumeMBF;
        data["deliveryPickingNoteID"] = this.deliveryPickingNoteID;
        data["customerName"] = this.customerName;
        data["supplierID"] = this.supplierID;
        data["supplierName"] = this.supplierName;
        data["supplierReturnType"] = this.supplierReturnType;
        data["issuingBranchName"] = this.issuingBranchName;
        data["toBranchID"] = this.toBranchID;
        data["toBranchName"] = this.toBranchName;
        data["viaBranchID"] = this.viaBranchID;
        data["viaBranchName"] = this.viaBranchName;
        data["documentType"] = this.documentType;
        data["documentTypeEnum"] = this.documentTypeEnum;
        data["viaBranchAddress"] = this.viaBranchAddress;
        data["deliveryTime"] = this.deliveryTime;
        data["orderSaleType"] = this.orderSaleType;
        data["documentID"] = this.documentID;
        data["picked"] = this.picked;
        data["delivered"] = this.delivered;
        data["proofOfDeliveryReturned"] = this.proofOfDeliveryReturned;
        data["creditNoteHeader"] = this.creditNoteHeader ? this.creditNoteHeader.toJSON() : <any>undefined;
        data["customerReturnHeader"] = this.customerReturnHeader ? this.customerReturnHeader.toJSON() : <any>undefined;
        data["deliveryNoteHeader"] = this.deliveryNoteHeader ? this.deliveryNoteHeader.toJSON() : <any>undefined;
        data["journeyHeader"] = this.journeyHeader ? this.journeyHeader.toJSON() : <any>undefined;
        data["journeyStop"] = this.journeyStop ? this.journeyStop.toJSON() : <any>undefined;
        data["orderHeader"] = this.orderHeader ? this.orderHeader.toJSON() : <any>undefined;
        data["pickingNoteHeader"] = this.pickingNoteHeader ? this.pickingNoteHeader.toJSON() : <any>undefined;
        data["purchaseOrderHeader"] = this.purchaseOrderHeader ? this.purchaseOrderHeader.toJSON() : <any>undefined;
        data["supplierReturnHeader"] = this.supplierReturnHeader ? this.supplierReturnHeader.toJSON() : <any>undefined;
        data["worksOrderHeader"] = this.worksOrderHeader ? this.worksOrderHeader.toJSON() : <any>undefined;
        data["worksOrderProcessHeader"] = this.worksOrderProcessHeader ? this.worksOrderProcessHeader.toJSON() : <any>undefined;
        data["displayTotalVolume"] = this.displayTotalVolume;
        data["displayTotalVolumeMBF"] = this.displayTotalVolumeMBF;
        data["displayTotalWeight"] = this.displayTotalWeight;
        data["orderCashSale"] = this.orderCashSale;
        data["deleted"] = this.deleted;
        return data; 
    }
}

export interface IJourneyManifestLine {
    journeyID?: number | undefined;
    useSimpleOrderProcessing?: boolean | undefined;
    journeyLineID?: number | undefined;
    journeyStopID?: number | undefined;
    orderID?: number | undefined;
    orderNumber?: number | undefined;
    noOfLines?: number | undefined;
    worksOrderProcessHeaderID?: number | undefined;
    dropNumber?: number | undefined;
    dropIsCollection?: boolean | undefined;
    dropTime?: Date | undefined;
    needsCollection?: boolean | undefined;
    workOrderID?: number | undefined;
    workOrderNumber?: number | undefined;
    pickingNoteNumber?: number | undefined;
    deliveryNoteNumber?: number | undefined;
    custometReturnNumber?: number | undefined;
    supplierReturnNumber?: number | undefined;
    purchaseOrderNumber?: number | undefined;
    pickingNoteID?: number | undefined;
    customerReturnID?: number | undefined;
    supplierReturnID?: number | undefined;
    deliverNoteID?: number | undefined;
    creditNoteNumber?: number | undefined;
    purchaseOrderApprovedByID?: number | undefined;
    branchID?: number | undefined;
    issuingBranchID?: number | undefined;
    workOrderStatus?: number | undefined;
    customerReturnStatus?: number | undefined;
    supplierReturnStatus?: number | undefined;
    purchaseOrderStatus?: number | undefined;
    creditNoteMarkedAsReturned?: boolean | undefined;
    creditNoteHandling?: number | undefined;
    creditNoteReleasedByID?: number | undefined;
    creditNoteApprovedByID?: number | undefined;
    workOrderProcessHeaderStatus?: number | undefined;
    wophWorksOrderID?: number | undefined;
    hasAddCostProportions?: boolean | undefined;
    purchaseOrderID?: number | undefined;
    creditNoteID?: number | undefined;
    orderType?: number | undefined;
    orderInvoiced?: boolean | undefined;
    documentNumber?: number | undefined;
    deliveryCity?: string | undefined;
    deliveryAreaName?: string | undefined;
    deliveryAddressCode?: string | undefined;
    deliveryAddress?: string | undefined;
    deliveryAddressID?: number | undefined;
    deliveryCounty?: string | undefined;
    deliveryAddress3?: string | undefined;
    deliveryAddress2?: string | undefined;
    deliveryAddress1?: string | undefined;
    deliveryAddressLongitude?: number | undefined;
    deliveryAddressLatitude?: number | undefined;
    branchName?: string | undefined;
    dateRequired?: Date | undefined;
    dateRequiredOption?: number | undefined;
    deliveryTimeDesc?: string | undefined;
    maximumWidth?: number | undefined;
    maximumLength?: number | undefined;
    noOfPacks?: number | undefined;
    orderCustomerRef?: string | undefined;
    orderJobRef?: string | undefined;
    stockLocationID?: number | undefined;
    toStockLocationID?: number | undefined;
    customerID?: number | undefined;
    totalWeight?: string | undefined;
    totalVolume?: string | undefined;
    totalVolumeMBF?: string | undefined;
    deliveryPickingNoteID?: number | undefined;
    customerName?: string | undefined;
    supplierID?: number | undefined;
    supplierName?: string | undefined;
    supplierReturnType?: number | undefined;
    issuingBranchName?: string | undefined;
    toBranchID?: number | undefined;
    toBranchName?: string | undefined;
    viaBranchID?: number | undefined;
    viaBranchName?: string | undefined;
    documentType?: number | undefined;
    documentTypeEnum?: JourneyManifestLineDocumentTypeEnum | undefined;
    viaBranchAddress?: string | undefined;
    deliveryTime?: number | undefined;
    orderSaleType?: number | undefined;
    documentID?: number | undefined;
    picked?: boolean | undefined;
    delivered?: boolean | undefined;
    proofOfDeliveryReturned?: boolean | undefined;
    creditNoteHeader?: CreditNoteHeader | undefined;
    customerReturnHeader?: CustomerReturnHeader | undefined;
    deliveryNoteHeader?: DeliveryNoteHeader | undefined;
    journeyHeader?: JourneyHeader | undefined;
    journeyStop?: JourneyStop | undefined;
    orderHeader?: OrderHeader | undefined;
    pickingNoteHeader?: PickingNoteHeader | undefined;
    purchaseOrderHeader?: PurchaseOrderHeader | undefined;
    supplierReturnHeader?: SupplierReturnHeader | undefined;
    worksOrderHeader?: WorksOrderHeader | undefined;
    worksOrderProcessHeader?: WorksOrderProcessHeader | undefined;
    displayTotalVolume?: string | undefined;
    displayTotalVolumeMBF?: string | undefined;
    displayTotalWeight?: string | undefined;
    orderCashSale?: boolean | undefined;
    deleted?: number | undefined;
}

export class JourneyManifestStop implements IJourneyManifestStop {
    journeyStopID?: number | undefined;
    journeyID?: number | undefined;
    journeyLineID?: number | undefined;
    stopNumber?: number | undefined;
    driveTime?: number | undefined;
    unloadTime?: number | undefined;
    delayTime?: number | undefined;
    returnToBranch?: boolean | undefined;
    estimatedArrival?: Date | undefined;
    actualDeparture?: Date | undefined;
    actualArrival?: Date | undefined;
    originalEstimatedArrival?: Date | undefined;
    address?: string | undefined;
    numberOfDocuments?: number | undefined;
    customerName?: string | undefined;
    supplierName?: string | undefined;
    branchName?: string | undefined;
    city?: string | undefined;

    constructor(data?: IJourneyManifestStop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.journeyStopID = _data["journeyStopID"];
            this.journeyID = _data["journeyID"];
            this.journeyLineID = _data["journeyLineID"];
            this.stopNumber = _data["stopNumber"];
            this.driveTime = _data["driveTime"];
            this.unloadTime = _data["unloadTime"];
            this.delayTime = _data["delayTime"];
            this.returnToBranch = _data["returnToBranch"];
            this.estimatedArrival = _data["estimatedArrival"] ? new Date(_data["estimatedArrival"].toString()) : <any>undefined;
            this.actualDeparture = _data["actualDeparture"] ? new Date(_data["actualDeparture"].toString()) : <any>undefined;
            this.actualArrival = _data["actualArrival"] ? new Date(_data["actualArrival"].toString()) : <any>undefined;
            this.originalEstimatedArrival = _data["originalEstimatedArrival"] ? new Date(_data["originalEstimatedArrival"].toString()) : <any>undefined;
            this.address = _data["address"];
            this.numberOfDocuments = _data["numberOfDocuments"];
            this.customerName = _data["customerName"];
            this.supplierName = _data["supplierName"];
            this.branchName = _data["branchName"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): JourneyManifestStop {
        data = typeof data === 'object' ? data : {};
        let result = new JourneyManifestStop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["journeyStopID"] = this.journeyStopID;
        data["journeyID"] = this.journeyID;
        data["journeyLineID"] = this.journeyLineID;
        data["stopNumber"] = this.stopNumber;
        data["driveTime"] = this.driveTime;
        data["unloadTime"] = this.unloadTime;
        data["delayTime"] = this.delayTime;
        data["returnToBranch"] = this.returnToBranch;
        data["estimatedArrival"] = this.estimatedArrival ? this.estimatedArrival.toISOString() : <any>undefined;
        data["actualDeparture"] = this.actualDeparture ? this.actualDeparture.toISOString() : <any>undefined;
        data["actualArrival"] = this.actualArrival ? this.actualArrival.toISOString() : <any>undefined;
        data["originalEstimatedArrival"] = this.originalEstimatedArrival ? this.originalEstimatedArrival.toISOString() : <any>undefined;
        data["address"] = this.address;
        data["numberOfDocuments"] = this.numberOfDocuments;
        data["customerName"] = this.customerName;
        data["supplierName"] = this.supplierName;
        data["branchName"] = this.branchName;
        data["city"] = this.city;
        return data; 
    }
}

export interface IJourneyManifestStop {
    journeyStopID?: number | undefined;
    journeyID?: number | undefined;
    journeyLineID?: number | undefined;
    stopNumber?: number | undefined;
    driveTime?: number | undefined;
    unloadTime?: number | undefined;
    delayTime?: number | undefined;
    returnToBranch?: boolean | undefined;
    estimatedArrival?: Date | undefined;
    actualDeparture?: Date | undefined;
    actualArrival?: Date | undefined;
    originalEstimatedArrival?: Date | undefined;
    address?: string | undefined;
    numberOfDocuments?: number | undefined;
    customerName?: string | undefined;
    supplierName?: string | undefined;
    branchName?: string | undefined;
    city?: string | undefined;
}

export class JourneyManifestLineDropsByProduct implements IJourneyManifestLineDropsByProduct {
    displayTotalVolume?: string | undefined;
    displayTotalVolumeMBF?: string | undefined;
    displayTotalWeight?: string | undefined;
    journeyID?: number | undefined;
    journeyLineID?: number | undefined;
    documentType?: number | undefined;
    documentTypeEnum?: JourneyManifestLineDropsByProductDocumentTypeEnum | undefined;
    dropNumber?: number | undefined;
    documentID?: number | undefined;
    documentNumber?: number | undefined;
    orderNumber?: number | undefined;
    productID?: number | undefined;
    productCode?: string | undefined;
    description?: string | undefined;
    lineNumber?: number | undefined;
    quantity?: number | undefined;
    inputPerID?: number | undefined;
    perCode?: string | undefined;
    quantityTally?: string | undefined;
    totalVolume?: string | undefined;
    totalVolumeMBF?: string | undefined;
    totalWeight?: string | undefined;
    noOfPacks?: number | undefined;
    orderStatus?: number | undefined;
    wmsPickingStatus?: number | undefined;
    backOrderedFromID?: number | undefined;
    useSimpleOrderProcessing?: number | undefined;
    pickingNoteID?: number | undefined;
    dropIsCollection?: boolean | undefined;
    viaBranchID?: number | undefined;
    saleType?: number | undefined;

    constructor(data?: IJourneyManifestLineDropsByProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayTotalVolume = _data["displayTotalVolume"];
            this.displayTotalVolumeMBF = _data["displayTotalVolumeMBF"];
            this.displayTotalWeight = _data["displayTotalWeight"];
            this.journeyID = _data["journeyID"];
            this.journeyLineID = _data["journeyLineID"];
            this.documentType = _data["documentType"];
            this.documentTypeEnum = _data["documentTypeEnum"];
            this.dropNumber = _data["dropNumber"];
            this.documentID = _data["documentID"];
            this.documentNumber = _data["documentNumber"];
            this.orderNumber = _data["orderNumber"];
            this.productID = _data["productID"];
            this.productCode = _data["productCode"];
            this.description = _data["description"];
            this.lineNumber = _data["lineNumber"];
            this.quantity = _data["quantity"];
            this.inputPerID = _data["inputPerID"];
            this.perCode = _data["perCode"];
            this.quantityTally = _data["quantityTally"];
            this.totalVolume = _data["totalVolume"];
            this.totalVolumeMBF = _data["totalVolumeMBF"];
            this.totalWeight = _data["totalWeight"];
            this.noOfPacks = _data["noOfPacks"];
            this.orderStatus = _data["orderStatus"];
            this.wmsPickingStatus = _data["wmsPickingStatus"];
            this.backOrderedFromID = _data["backOrderedFromID"];
            this.useSimpleOrderProcessing = _data["useSimpleOrderProcessing"];
            this.pickingNoteID = _data["pickingNoteID"];
            this.dropIsCollection = _data["dropIsCollection"];
            this.viaBranchID = _data["viaBranchID"];
            this.saleType = _data["saleType"];
        }
    }

    static fromJS(data: any): JourneyManifestLineDropsByProduct {
        data = typeof data === 'object' ? data : {};
        let result = new JourneyManifestLineDropsByProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayTotalVolume"] = this.displayTotalVolume;
        data["displayTotalVolumeMBF"] = this.displayTotalVolumeMBF;
        data["displayTotalWeight"] = this.displayTotalWeight;
        data["journeyID"] = this.journeyID;
        data["journeyLineID"] = this.journeyLineID;
        data["documentType"] = this.documentType;
        data["documentTypeEnum"] = this.documentTypeEnum;
        data["dropNumber"] = this.dropNumber;
        data["documentID"] = this.documentID;
        data["documentNumber"] = this.documentNumber;
        data["orderNumber"] = this.orderNumber;
        data["productID"] = this.productID;
        data["productCode"] = this.productCode;
        data["description"] = this.description;
        data["lineNumber"] = this.lineNumber;
        data["quantity"] = this.quantity;
        data["inputPerID"] = this.inputPerID;
        data["perCode"] = this.perCode;
        data["quantityTally"] = this.quantityTally;
        data["totalVolume"] = this.totalVolume;
        data["totalVolumeMBF"] = this.totalVolumeMBF;
        data["totalWeight"] = this.totalWeight;
        data["noOfPacks"] = this.noOfPacks;
        data["orderStatus"] = this.orderStatus;
        data["wmsPickingStatus"] = this.wmsPickingStatus;
        data["backOrderedFromID"] = this.backOrderedFromID;
        data["useSimpleOrderProcessing"] = this.useSimpleOrderProcessing;
        data["pickingNoteID"] = this.pickingNoteID;
        data["dropIsCollection"] = this.dropIsCollection;
        data["viaBranchID"] = this.viaBranchID;
        data["saleType"] = this.saleType;
        return data; 
    }
}

export interface IJourneyManifestLineDropsByProduct {
    displayTotalVolume?: string | undefined;
    displayTotalVolumeMBF?: string | undefined;
    displayTotalWeight?: string | undefined;
    journeyID?: number | undefined;
    journeyLineID?: number | undefined;
    documentType?: number | undefined;
    documentTypeEnum?: JourneyManifestLineDropsByProductDocumentTypeEnum | undefined;
    dropNumber?: number | undefined;
    documentID?: number | undefined;
    documentNumber?: number | undefined;
    orderNumber?: number | undefined;
    productID?: number | undefined;
    productCode?: string | undefined;
    description?: string | undefined;
    lineNumber?: number | undefined;
    quantity?: number | undefined;
    inputPerID?: number | undefined;
    perCode?: string | undefined;
    quantityTally?: string | undefined;
    totalVolume?: string | undefined;
    totalVolumeMBF?: string | undefined;
    totalWeight?: string | undefined;
    noOfPacks?: number | undefined;
    orderStatus?: number | undefined;
    wmsPickingStatus?: number | undefined;
    backOrderedFromID?: number | undefined;
    useSimpleOrderProcessing?: number | undefined;
    pickingNoteID?: number | undefined;
    dropIsCollection?: boolean | undefined;
    viaBranchID?: number | undefined;
    saleType?: number | undefined;
}

export class JourneyManifestDeliveryArea implements IJourneyManifestDeliveryArea {
    deliveryAreaID?: number | undefined;
    deliveryAreaCode?: string | undefined;
    name?: string | undefined;
    congestionCharge?: number | undefined;
    webTrackOnly?: boolean | undefined;
    postCodeInformation?: string | undefined;
    deleted?: number | undefined;
    webTrackInstanceID?: number | undefined;
    autoScheduleRoute?: boolean | undefined;
    journeyID?: number | undefined;

    constructor(data?: IJourneyManifestDeliveryArea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deliveryAreaID = _data["deliveryAreaID"];
            this.deliveryAreaCode = _data["deliveryAreaCode"];
            this.name = _data["name"];
            this.congestionCharge = _data["congestionCharge"];
            this.webTrackOnly = _data["webTrackOnly"];
            this.postCodeInformation = _data["postCodeInformation"];
            this.deleted = _data["deleted"];
            this.webTrackInstanceID = _data["webTrackInstanceID"];
            this.autoScheduleRoute = _data["autoScheduleRoute"];
            this.journeyID = _data["journeyID"];
        }
    }

    static fromJS(data: any): JourneyManifestDeliveryArea {
        data = typeof data === 'object' ? data : {};
        let result = new JourneyManifestDeliveryArea();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveryAreaID"] = this.deliveryAreaID;
        data["deliveryAreaCode"] = this.deliveryAreaCode;
        data["name"] = this.name;
        data["congestionCharge"] = this.congestionCharge;
        data["webTrackOnly"] = this.webTrackOnly;
        data["postCodeInformation"] = this.postCodeInformation;
        data["deleted"] = this.deleted;
        data["webTrackInstanceID"] = this.webTrackInstanceID;
        data["autoScheduleRoute"] = this.autoScheduleRoute;
        data["journeyID"] = this.journeyID;
        return data; 
    }
}

export interface IJourneyManifestDeliveryArea {
    deliveryAreaID?: number | undefined;
    deliveryAreaCode?: string | undefined;
    name?: string | undefined;
    congestionCharge?: number | undefined;
    webTrackOnly?: boolean | undefined;
    postCodeInformation?: string | undefined;
    deleted?: number | undefined;
    webTrackInstanceID?: number | undefined;
    autoScheduleRoute?: boolean | undefined;
    journeyID?: number | undefined;
}

export class JourneyManifestHeader implements IJourneyManifestHeader {
    displayTotalWeight?: string | undefined;
    displayTrailerMaxVolume?: string | undefined;
    displayTrailerMaxWeight?: string | undefined;
    displayVehicleMaxVolume?: string | undefined;
    displayVehicleMaxWeight?: string | undefined;
    displayMaximumLength?: string | undefined;
    displayMaximumWidth?: string | undefined;
    displayTotalVolume?: string | undefined;
    lastModifiedByID?: number | undefined;
    branchName?: string | undefined;
    vehicleMaxWeight?: string | undefined;
    vehicleMaxVolume?: string | undefined;
    trailerMaxWeight?: string | undefined;
    trailerMaxVolume?: string | undefined;
    vehicleTypeName?: string | undefined;
    supplierName?: string | undefined;
    supplierScac?: string | undefined;
    journeyID?: number | undefined;
    journeyNumber?: number | undefined;
    reference?: string | undefined;
    status?: number | undefined;
    journeyDate?: Date | undefined;
    branchID?: number | undefined;
    vehicleID?: number | undefined;
    vehicleName?: string | undefined;
    vehicleTypeID?: number | undefined;
    driverID?: number | undefined;
    driverName?: string | undefined;
    vehicleDetails?: string | undefined;
    plannedStartDateTime?: Date | undefined;
    plannedFinishDateTime?: Date | undefined;
    dateTimeStarted?: Date | undefined;
    startMileage?: number | undefined;
    dateTimeFinished?: Date | undefined;
    finishMileage?: number | undefined;
    transportCost?: number | undefined;
    applyTransportCostTo?: number | undefined;
    additionalCostChargeID?: number | undefined;
    supplierID?: number | undefined;
    notes?: string | undefined;
    totalWeight?: string | undefined;
    totalVolume?: string | undefined;
    noOfPacks?: number | undefined;
    noOfDrops?: number | undefined;
    noOfCollections?: number | undefined;
    noOfStops?: number | undefined;
    maximumWidth?: string | undefined;
    maximumLength?: string | undefined;
    cutOffDateTime?: Date | undefined;
    deliveryAreaID?: number | undefined;
    markedAsFull?: boolean | undefined;
    truckVehicleID?: number | undefined;
    trailerVehicleID?: number | undefined;
    journeyForwardPlanningID?: number | undefined;
    optimizeRoutes?: boolean | undefined;
    updateAccess?: boolean | undefined;
    documentType?: JourneyManifestHeaderDocumentType | undefined;
    hasAddCostProportions?: boolean | undefined;
    addCostProrationsOnly?: boolean | undefined;

    constructor(data?: IJourneyManifestHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayTotalWeight = _data["displayTotalWeight"];
            this.displayTrailerMaxVolume = _data["displayTrailerMaxVolume"];
            this.displayTrailerMaxWeight = _data["displayTrailerMaxWeight"];
            this.displayVehicleMaxVolume = _data["displayVehicleMaxVolume"];
            this.displayVehicleMaxWeight = _data["displayVehicleMaxWeight"];
            this.displayMaximumLength = _data["displayMaximumLength"];
            this.displayMaximumWidth = _data["displayMaximumWidth"];
            this.displayTotalVolume = _data["displayTotalVolume"];
            this.lastModifiedByID = _data["lastModifiedByID"];
            this.branchName = _data["branchName"];
            this.vehicleMaxWeight = _data["vehicleMaxWeight"];
            this.vehicleMaxVolume = _data["vehicleMaxVolume"];
            this.trailerMaxWeight = _data["trailerMaxWeight"];
            this.trailerMaxVolume = _data["trailerMaxVolume"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.supplierName = _data["supplierName"];
            this.supplierScac = _data["supplierScac"];
            this.journeyID = _data["journeyID"];
            this.journeyNumber = _data["journeyNumber"];
            this.reference = _data["reference"];
            this.status = _data["status"];
            this.journeyDate = _data["journeyDate"] ? new Date(_data["journeyDate"].toString()) : <any>undefined;
            this.branchID = _data["branchID"];
            this.vehicleID = _data["vehicleID"];
            this.vehicleName = _data["vehicleName"];
            this.vehicleTypeID = _data["vehicleTypeID"];
            this.driverID = _data["driverID"];
            this.driverName = _data["driverName"];
            this.vehicleDetails = _data["vehicleDetails"];
            this.plannedStartDateTime = _data["plannedStartDateTime"] ? new Date(_data["plannedStartDateTime"].toString()) : <any>undefined;
            this.plannedFinishDateTime = _data["plannedFinishDateTime"] ? new Date(_data["plannedFinishDateTime"].toString()) : <any>undefined;
            this.dateTimeStarted = _data["dateTimeStarted"] ? new Date(_data["dateTimeStarted"].toString()) : <any>undefined;
            this.startMileage = _data["startMileage"];
            this.dateTimeFinished = _data["dateTimeFinished"] ? new Date(_data["dateTimeFinished"].toString()) : <any>undefined;
            this.finishMileage = _data["finishMileage"];
            this.transportCost = _data["transportCost"];
            this.applyTransportCostTo = _data["applyTransportCostTo"];
            this.additionalCostChargeID = _data["additionalCostChargeID"];
            this.supplierID = _data["supplierID"];
            this.notes = _data["notes"];
            this.totalWeight = _data["totalWeight"];
            this.totalVolume = _data["totalVolume"];
            this.noOfPacks = _data["noOfPacks"];
            this.noOfDrops = _data["noOfDrops"];
            this.noOfCollections = _data["noOfCollections"];
            this.noOfStops = _data["noOfStops"];
            this.maximumWidth = _data["maximumWidth"];
            this.maximumLength = _data["maximumLength"];
            this.cutOffDateTime = _data["cutOffDateTime"] ? new Date(_data["cutOffDateTime"].toString()) : <any>undefined;
            this.deliveryAreaID = _data["deliveryAreaID"];
            this.markedAsFull = _data["markedAsFull"];
            this.truckVehicleID = _data["truckVehicleID"];
            this.trailerVehicleID = _data["trailerVehicleID"];
            this.journeyForwardPlanningID = _data["journeyForwardPlanningID"];
            this.optimizeRoutes = _data["optimizeRoutes"];
            this.updateAccess = _data["updateAccess"];
            this.documentType = _data["documentType"];
            this.hasAddCostProportions = _data["hasAddCostProportions"];
            this.addCostProrationsOnly = _data["addCostProrationsOnly"];
        }
    }

    static fromJS(data: any): JourneyManifestHeader {
        data = typeof data === 'object' ? data : {};
        let result = new JourneyManifestHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayTotalWeight"] = this.displayTotalWeight;
        data["displayTrailerMaxVolume"] = this.displayTrailerMaxVolume;
        data["displayTrailerMaxWeight"] = this.displayTrailerMaxWeight;
        data["displayVehicleMaxVolume"] = this.displayVehicleMaxVolume;
        data["displayVehicleMaxWeight"] = this.displayVehicleMaxWeight;
        data["displayMaximumLength"] = this.displayMaximumLength;
        data["displayMaximumWidth"] = this.displayMaximumWidth;
        data["displayTotalVolume"] = this.displayTotalVolume;
        data["lastModifiedByID"] = this.lastModifiedByID;
        data["branchName"] = this.branchName;
        data["vehicleMaxWeight"] = this.vehicleMaxWeight;
        data["vehicleMaxVolume"] = this.vehicleMaxVolume;
        data["trailerMaxWeight"] = this.trailerMaxWeight;
        data["trailerMaxVolume"] = this.trailerMaxVolume;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["supplierName"] = this.supplierName;
        data["supplierScac"] = this.supplierScac;
        data["journeyID"] = this.journeyID;
        data["journeyNumber"] = this.journeyNumber;
        data["reference"] = this.reference;
        data["status"] = this.status;
        data["journeyDate"] = this.journeyDate ? this.journeyDate.toISOString() : <any>undefined;
        data["branchID"] = this.branchID;
        data["vehicleID"] = this.vehicleID;
        data["vehicleName"] = this.vehicleName;
        data["vehicleTypeID"] = this.vehicleTypeID;
        data["driverID"] = this.driverID;
        data["driverName"] = this.driverName;
        data["vehicleDetails"] = this.vehicleDetails;
        data["plannedStartDateTime"] = this.plannedStartDateTime ? this.plannedStartDateTime.toISOString() : <any>undefined;
        data["plannedFinishDateTime"] = this.plannedFinishDateTime ? this.plannedFinishDateTime.toISOString() : <any>undefined;
        data["dateTimeStarted"] = this.dateTimeStarted ? this.dateTimeStarted.toISOString() : <any>undefined;
        data["startMileage"] = this.startMileage;
        data["dateTimeFinished"] = this.dateTimeFinished ? this.dateTimeFinished.toISOString() : <any>undefined;
        data["finishMileage"] = this.finishMileage;
        data["transportCost"] = this.transportCost;
        data["applyTransportCostTo"] = this.applyTransportCostTo;
        data["additionalCostChargeID"] = this.additionalCostChargeID;
        data["supplierID"] = this.supplierID;
        data["notes"] = this.notes;
        data["totalWeight"] = this.totalWeight;
        data["totalVolume"] = this.totalVolume;
        data["noOfPacks"] = this.noOfPacks;
        data["noOfDrops"] = this.noOfDrops;
        data["noOfCollections"] = this.noOfCollections;
        data["noOfStops"] = this.noOfStops;
        data["maximumWidth"] = this.maximumWidth;
        data["maximumLength"] = this.maximumLength;
        data["cutOffDateTime"] = this.cutOffDateTime ? this.cutOffDateTime.toISOString() : <any>undefined;
        data["deliveryAreaID"] = this.deliveryAreaID;
        data["markedAsFull"] = this.markedAsFull;
        data["truckVehicleID"] = this.truckVehicleID;
        data["trailerVehicleID"] = this.trailerVehicleID;
        data["journeyForwardPlanningID"] = this.journeyForwardPlanningID;
        data["optimizeRoutes"] = this.optimizeRoutes;
        data["updateAccess"] = this.updateAccess;
        data["documentType"] = this.documentType;
        data["hasAddCostProportions"] = this.hasAddCostProportions;
        data["addCostProrationsOnly"] = this.addCostProrationsOnly;
        return data; 
    }
}

export interface IJourneyManifestHeader {
    displayTotalWeight?: string | undefined;
    displayTrailerMaxVolume?: string | undefined;
    displayTrailerMaxWeight?: string | undefined;
    displayVehicleMaxVolume?: string | undefined;
    displayVehicleMaxWeight?: string | undefined;
    displayMaximumLength?: string | undefined;
    displayMaximumWidth?: string | undefined;
    displayTotalVolume?: string | undefined;
    lastModifiedByID?: number | undefined;
    branchName?: string | undefined;
    vehicleMaxWeight?: string | undefined;
    vehicleMaxVolume?: string | undefined;
    trailerMaxWeight?: string | undefined;
    trailerMaxVolume?: string | undefined;
    vehicleTypeName?: string | undefined;
    supplierName?: string | undefined;
    supplierScac?: string | undefined;
    journeyID?: number | undefined;
    journeyNumber?: number | undefined;
    reference?: string | undefined;
    status?: number | undefined;
    journeyDate?: Date | undefined;
    branchID?: number | undefined;
    vehicleID?: number | undefined;
    vehicleName?: string | undefined;
    vehicleTypeID?: number | undefined;
    driverID?: number | undefined;
    driverName?: string | undefined;
    vehicleDetails?: string | undefined;
    plannedStartDateTime?: Date | undefined;
    plannedFinishDateTime?: Date | undefined;
    dateTimeStarted?: Date | undefined;
    startMileage?: number | undefined;
    dateTimeFinished?: Date | undefined;
    finishMileage?: number | undefined;
    transportCost?: number | undefined;
    applyTransportCostTo?: number | undefined;
    additionalCostChargeID?: number | undefined;
    supplierID?: number | undefined;
    notes?: string | undefined;
    totalWeight?: string | undefined;
    totalVolume?: string | undefined;
    noOfPacks?: number | undefined;
    noOfDrops?: number | undefined;
    noOfCollections?: number | undefined;
    noOfStops?: number | undefined;
    maximumWidth?: string | undefined;
    maximumLength?: string | undefined;
    cutOffDateTime?: Date | undefined;
    deliveryAreaID?: number | undefined;
    markedAsFull?: boolean | undefined;
    truckVehicleID?: number | undefined;
    trailerVehicleID?: number | undefined;
    journeyForwardPlanningID?: number | undefined;
    optimizeRoutes?: boolean | undefined;
    updateAccess?: boolean | undefined;
    documentType?: JourneyManifestHeaderDocumentType | undefined;
    hasAddCostProportions?: boolean | undefined;
    addCostProrationsOnly?: boolean | undefined;
}

export class PurchaseOrderHeader implements IPurchaseOrderHeader {
    directSOLineExists?: boolean | undefined;
    purchaseOrderID?: number | undefined;
    deleted?: number | undefined;
    purchaseOrderNumber?: number | undefined;
    orderStatus?: number | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    lastModifiedByID?: number | undefined;
    printed?: boolean | undefined;
    branchID?: number | undefined;
    supplierID?: number | undefined;
    buyingSocietyID?: number | undefined;
    buyingSocietyReference?: string | undefined;
    orderType?: number | undefined;
    collected?: boolean | undefined;
    userID?: number | undefined;
    currencyID?: number | undefined;
    vmiProgramID?: number | undefined;
    typeOfPurchase?: number | undefined;
    purchaseAnalysisCodeID?: number | undefined;
    dateRequired?: Date | undefined;
    dateRequiredOption?: number | undefined;
    dateRequiredEarliest?: Date | undefined;
    dateRequiredLatest?: Date | undefined;
    dateExpiry?: Date | undefined;
    dateExpected?: Date | undefined;
    chargeRollingMargin?: boolean | undefined;
    applyMaterialSurcharge?: boolean | undefined;
    originID?: number | undefined;
    stockLocationID?: number | undefined;
    ourRef?: string | undefined;
    supplierRef?: string | undefined;
    contactName?: string | undefined;
    contactNumber?: string | undefined;
    customerID?: number | undefined;
    deliveryAddressID?: number | undefined;
    deliveryAddress?: string | undefined;
    paymentAddressID?: number | undefined;
    paymentTermsID?: number | undefined;
    specialInstructions?: string | undefined;
    headerNotes?: string | undefined;
    notes?: string | undefined;
    contractRef?: string | undefined;
    contractPeriod?: string | undefined;
    timberMill?: string | undefined;
    ship?: string | undefined;
    voyage?: string | undefined;
    bolRef?: string | undefined;
    intrastatDeliveryTermsID?: number | undefined;
    intrastatTransportModeID?: number | undefined;
    showEurosOnOrder?: boolean | undefined;
    exchangeRate?: number | undefined;
    fixedExchangeRate?: boolean | undefined;
    totalCostPrice?: number | undefined;
    totalCostPriceInCurrency?: number | undefined;
    totalWeight?: number | undefined;
    totalVolume?: number | undefined;
    totalAdditionalCost?: number | undefined;
    totalDeliveryCharge?: number | undefined;
    totalStevedoreCharge?: number | undefined;
    deliveryRate?: number | undefined;
    stevedoreRate?: number | undefined;
    deliveryCharge?: number | undefined;
    deliveryPurchaseAnalysisCodeID?: number | undefined;
    generatedOrder?: boolean | undefined;
    orderAcknowledged?: boolean | undefined;
    confirmationRef?: string | undefined;
    noOfLines?: number | undefined;
    firstSteelGradeID?: number | undefined;
    questionsAsked?: number | undefined;
    backOrderedFromID?: number | undefined;
    calledOffFromID?: number | undefined;
    dateReceived?: Date | undefined;
    receiptDeliveryNoteNumber?: string | undefined;
    receiptDeliveryReference?: string | undefined;
    receiptHaulier?: string | undefined;
    receiptNotes?: string | undefined;
    referToID?: number | undefined;
    dateTimeApproved?: Date | undefined;
    approvedByID?: number | undefined;
    invoiced?: boolean | undefined;
    journeyID?: number | undefined;
    pendingForOrderID?: number | undefined;
    readyForBooking?: boolean | undefined;
    readyByID?: number | undefined;
    readyDate?: Date | undefined;
    dateTimeMarkedReady?: Date | undefined;
    transportInstructionID?: number | undefined;
    distance?: number | undefined;
    transportBooked?: number | undefined;
    pickupDate?: Date | undefined;
    bookedByID?: number | undefined;
    dateTimeMarkedBooked?: Date | undefined;
    bookingNumber?: number | undefined;
    vehicleTypeID?: number | undefined;
    ediDocumentID?: number | undefined;
    computerID?: number | undefined;
    useNewAdditionalCostMode?: boolean | undefined;
    estimatedFreightInCurrency?: number | undefined;
    estimatedMiscInCurrency?: number | undefined;
    settlementAmountInCurrency?: number | undefined;
    settlementDiscount?: number | undefined;
    promotion?: boolean | undefined;
    pendingActions?: number | undefined;
    saleCode?: string | undefined;
    bulletinCode?: string | undefined;
    refillOrder?: boolean | undefined;
    shippingMethodID?: number | undefined;
    shippingMethodOptionID?: number | undefined;
    rscNumber?: string | undefined;
    excludeFromWms?: boolean | undefined;
    sendRetailPrice?: boolean | undefined;
    supplierBranchReferenceID?: number | undefined;
    branchCode?: string | undefined;
    branchName?: string | undefined;
    countryName?: string | undefined;
    purchaseAnalysisCode1?: string | undefined;
    purchaseAnalysisCodeName?: string | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;
    buyingSocietyCode?: string | undefined;
    buyingSocietyName?: string | undefined;
    userName?: string | undefined;
    approvedByName?: string | undefined;
    createdByName?: string | undefined;
    lastModifiedByName?: string | undefined;
    referToName?: string | undefined;
    currencyCode?: string | undefined;
    currencyName?: string | undefined;
    deliveryFax?: string | undefined;
    paymentFax?: string | undefined;
    deliveryEmail?: string | undefined;
    paymentEmail?: string | undefined;
    vmiProgramReference?: string | undefined;
    vmiProgramUseProductBatch?: boolean | undefined;
    directOrderCustomerID?: number | undefined;
    customerName?: string | undefined;
    preReceivedOnly?: number | undefined;
    workflowPurchaseOrder?: boolean | undefined;

    constructor(data?: IPurchaseOrderHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.directSOLineExists = _data["directSOLineExists"];
            this.purchaseOrderID = _data["purchaseOrderID"];
            this.deleted = _data["deleted"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.orderStatus = _data["orderStatus"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.createdByID = _data["createdByID"];
            this.dateTimeLastModified = _data["dateTimeLastModified"] ? new Date(_data["dateTimeLastModified"].toString()) : <any>undefined;
            this.lastModifiedByID = _data["lastModifiedByID"];
            this.printed = _data["printed"];
            this.branchID = _data["branchID"];
            this.supplierID = _data["supplierID"];
            this.buyingSocietyID = _data["buyingSocietyID"];
            this.buyingSocietyReference = _data["buyingSocietyReference"];
            this.orderType = _data["orderType"];
            this.collected = _data["collected"];
            this.userID = _data["userID"];
            this.currencyID = _data["currencyID"];
            this.vmiProgramID = _data["vmiProgramID"];
            this.typeOfPurchase = _data["typeOfPurchase"];
            this.purchaseAnalysisCodeID = _data["purchaseAnalysisCodeID"];
            this.dateRequired = _data["dateRequired"] ? new Date(_data["dateRequired"].toString()) : <any>undefined;
            this.dateRequiredOption = _data["dateRequiredOption"];
            this.dateRequiredEarliest = _data["dateRequiredEarliest"] ? new Date(_data["dateRequiredEarliest"].toString()) : <any>undefined;
            this.dateRequiredLatest = _data["dateRequiredLatest"] ? new Date(_data["dateRequiredLatest"].toString()) : <any>undefined;
            this.dateExpiry = _data["dateExpiry"] ? new Date(_data["dateExpiry"].toString()) : <any>undefined;
            this.dateExpected = _data["dateExpected"] ? new Date(_data["dateExpected"].toString()) : <any>undefined;
            this.chargeRollingMargin = _data["chargeRollingMargin"];
            this.applyMaterialSurcharge = _data["applyMaterialSurcharge"];
            this.originID = _data["originID"];
            this.stockLocationID = _data["stockLocationID"];
            this.ourRef = _data["ourRef"];
            this.supplierRef = _data["supplierRef"];
            this.contactName = _data["contactName"];
            this.contactNumber = _data["contactNumber"];
            this.customerID = _data["customerID"];
            this.deliveryAddressID = _data["deliveryAddressID"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.paymentAddressID = _data["paymentAddressID"];
            this.paymentTermsID = _data["paymentTermsID"];
            this.specialInstructions = _data["specialInstructions"];
            this.headerNotes = _data["headerNotes"];
            this.notes = _data["notes"];
            this.contractRef = _data["contractRef"];
            this.contractPeriod = _data["contractPeriod"];
            this.timberMill = _data["timberMill"];
            this.ship = _data["ship"];
            this.voyage = _data["voyage"];
            this.bolRef = _data["bolRef"];
            this.intrastatDeliveryTermsID = _data["intrastatDeliveryTermsID"];
            this.intrastatTransportModeID = _data["intrastatTransportModeID"];
            this.showEurosOnOrder = _data["showEurosOnOrder"];
            this.exchangeRate = _data["exchangeRate"];
            this.fixedExchangeRate = _data["fixedExchangeRate"];
            this.totalCostPrice = _data["totalCostPrice"];
            this.totalCostPriceInCurrency = _data["totalCostPriceInCurrency"];
            this.totalWeight = _data["totalWeight"];
            this.totalVolume = _data["totalVolume"];
            this.totalAdditionalCost = _data["totalAdditionalCost"];
            this.totalDeliveryCharge = _data["totalDeliveryCharge"];
            this.totalStevedoreCharge = _data["totalStevedoreCharge"];
            this.deliveryRate = _data["deliveryRate"];
            this.stevedoreRate = _data["stevedoreRate"];
            this.deliveryCharge = _data["deliveryCharge"];
            this.deliveryPurchaseAnalysisCodeID = _data["deliveryPurchaseAnalysisCodeID"];
            this.generatedOrder = _data["generatedOrder"];
            this.orderAcknowledged = _data["orderAcknowledged"];
            this.confirmationRef = _data["confirmationRef"];
            this.noOfLines = _data["noOfLines"];
            this.firstSteelGradeID = _data["firstSteelGradeID"];
            this.questionsAsked = _data["questionsAsked"];
            this.backOrderedFromID = _data["backOrderedFromID"];
            this.calledOffFromID = _data["calledOffFromID"];
            this.dateReceived = _data["dateReceived"] ? new Date(_data["dateReceived"].toString()) : <any>undefined;
            this.receiptDeliveryNoteNumber = _data["receiptDeliveryNoteNumber"];
            this.receiptDeliveryReference = _data["receiptDeliveryReference"];
            this.receiptHaulier = _data["receiptHaulier"];
            this.receiptNotes = _data["receiptNotes"];
            this.referToID = _data["referToID"];
            this.dateTimeApproved = _data["dateTimeApproved"] ? new Date(_data["dateTimeApproved"].toString()) : <any>undefined;
            this.approvedByID = _data["approvedByID"];
            this.invoiced = _data["invoiced"];
            this.journeyID = _data["journeyID"];
            this.pendingForOrderID = _data["pendingForOrderID"];
            this.readyForBooking = _data["readyForBooking"];
            this.readyByID = _data["readyByID"];
            this.readyDate = _data["readyDate"] ? new Date(_data["readyDate"].toString()) : <any>undefined;
            this.dateTimeMarkedReady = _data["dateTimeMarkedReady"] ? new Date(_data["dateTimeMarkedReady"].toString()) : <any>undefined;
            this.transportInstructionID = _data["transportInstructionID"];
            this.distance = _data["distance"];
            this.transportBooked = _data["transportBooked"];
            this.pickupDate = _data["pickupDate"] ? new Date(_data["pickupDate"].toString()) : <any>undefined;
            this.bookedByID = _data["bookedByID"];
            this.dateTimeMarkedBooked = _data["dateTimeMarkedBooked"] ? new Date(_data["dateTimeMarkedBooked"].toString()) : <any>undefined;
            this.bookingNumber = _data["bookingNumber"];
            this.vehicleTypeID = _data["vehicleTypeID"];
            this.ediDocumentID = _data["ediDocumentID"];
            this.computerID = _data["computerID"];
            this.useNewAdditionalCostMode = _data["useNewAdditionalCostMode"];
            this.estimatedFreightInCurrency = _data["estimatedFreightInCurrency"];
            this.estimatedMiscInCurrency = _data["estimatedMiscInCurrency"];
            this.settlementAmountInCurrency = _data["settlementAmountInCurrency"];
            this.settlementDiscount = _data["settlementDiscount"];
            this.promotion = _data["promotion"];
            this.pendingActions = _data["pendingActions"];
            this.saleCode = _data["saleCode"];
            this.bulletinCode = _data["bulletinCode"];
            this.refillOrder = _data["refillOrder"];
            this.shippingMethodID = _data["shippingMethodID"];
            this.shippingMethodOptionID = _data["shippingMethodOptionID"];
            this.rscNumber = _data["rscNumber"];
            this.excludeFromWms = _data["excludeFromWms"];
            this.sendRetailPrice = _data["sendRetailPrice"];
            this.supplierBranchReferenceID = _data["supplierBranchReferenceID"];
            this.branchCode = _data["branchCode"];
            this.branchName = _data["branchName"];
            this.countryName = _data["countryName"];
            this.purchaseAnalysisCode1 = _data["purchaseAnalysisCode1"];
            this.purchaseAnalysisCodeName = _data["purchaseAnalysisCodeName"];
            this.supplierCode = _data["supplierCode"];
            this.supplierName = _data["supplierName"];
            this.buyingSocietyCode = _data["buyingSocietyCode"];
            this.buyingSocietyName = _data["buyingSocietyName"];
            this.userName = _data["userName"];
            this.approvedByName = _data["approvedByName"];
            this.createdByName = _data["createdByName"];
            this.lastModifiedByName = _data["lastModifiedByName"];
            this.referToName = _data["referToName"];
            this.currencyCode = _data["currencyCode"];
            this.currencyName = _data["currencyName"];
            this.deliveryFax = _data["deliveryFax"];
            this.paymentFax = _data["paymentFax"];
            this.deliveryEmail = _data["deliveryEmail"];
            this.paymentEmail = _data["paymentEmail"];
            this.vmiProgramReference = _data["vmiProgramReference"];
            this.vmiProgramUseProductBatch = _data["vmiProgramUseProductBatch"];
            this.directOrderCustomerID = _data["directOrderCustomerID"];
            this.customerName = _data["customerName"];
            this.preReceivedOnly = _data["preReceivedOnly"];
            this.workflowPurchaseOrder = _data["workflowPurchaseOrder"];
        }
    }

    static fromJS(data: any): PurchaseOrderHeader {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["directSOLineExists"] = this.directSOLineExists;
        data["purchaseOrderID"] = this.purchaseOrderID;
        data["deleted"] = this.deleted;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["orderStatus"] = this.orderStatus;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["createdByID"] = this.createdByID;
        data["dateTimeLastModified"] = this.dateTimeLastModified ? this.dateTimeLastModified.toISOString() : <any>undefined;
        data["lastModifiedByID"] = this.lastModifiedByID;
        data["printed"] = this.printed;
        data["branchID"] = this.branchID;
        data["supplierID"] = this.supplierID;
        data["buyingSocietyID"] = this.buyingSocietyID;
        data["buyingSocietyReference"] = this.buyingSocietyReference;
        data["orderType"] = this.orderType;
        data["collected"] = this.collected;
        data["userID"] = this.userID;
        data["currencyID"] = this.currencyID;
        data["vmiProgramID"] = this.vmiProgramID;
        data["typeOfPurchase"] = this.typeOfPurchase;
        data["purchaseAnalysisCodeID"] = this.purchaseAnalysisCodeID;
        data["dateRequired"] = this.dateRequired ? this.dateRequired.toISOString() : <any>undefined;
        data["dateRequiredOption"] = this.dateRequiredOption;
        data["dateRequiredEarliest"] = this.dateRequiredEarliest ? this.dateRequiredEarliest.toISOString() : <any>undefined;
        data["dateRequiredLatest"] = this.dateRequiredLatest ? this.dateRequiredLatest.toISOString() : <any>undefined;
        data["dateExpiry"] = this.dateExpiry ? this.dateExpiry.toISOString() : <any>undefined;
        data["dateExpected"] = this.dateExpected ? this.dateExpected.toISOString() : <any>undefined;
        data["chargeRollingMargin"] = this.chargeRollingMargin;
        data["applyMaterialSurcharge"] = this.applyMaterialSurcharge;
        data["originID"] = this.originID;
        data["stockLocationID"] = this.stockLocationID;
        data["ourRef"] = this.ourRef;
        data["supplierRef"] = this.supplierRef;
        data["contactName"] = this.contactName;
        data["contactNumber"] = this.contactNumber;
        data["customerID"] = this.customerID;
        data["deliveryAddressID"] = this.deliveryAddressID;
        data["deliveryAddress"] = this.deliveryAddress;
        data["paymentAddressID"] = this.paymentAddressID;
        data["paymentTermsID"] = this.paymentTermsID;
        data["specialInstructions"] = this.specialInstructions;
        data["headerNotes"] = this.headerNotes;
        data["notes"] = this.notes;
        data["contractRef"] = this.contractRef;
        data["contractPeriod"] = this.contractPeriod;
        data["timberMill"] = this.timberMill;
        data["ship"] = this.ship;
        data["voyage"] = this.voyage;
        data["bolRef"] = this.bolRef;
        data["intrastatDeliveryTermsID"] = this.intrastatDeliveryTermsID;
        data["intrastatTransportModeID"] = this.intrastatTransportModeID;
        data["showEurosOnOrder"] = this.showEurosOnOrder;
        data["exchangeRate"] = this.exchangeRate;
        data["fixedExchangeRate"] = this.fixedExchangeRate;
        data["totalCostPrice"] = this.totalCostPrice;
        data["totalCostPriceInCurrency"] = this.totalCostPriceInCurrency;
        data["totalWeight"] = this.totalWeight;
        data["totalVolume"] = this.totalVolume;
        data["totalAdditionalCost"] = this.totalAdditionalCost;
        data["totalDeliveryCharge"] = this.totalDeliveryCharge;
        data["totalStevedoreCharge"] = this.totalStevedoreCharge;
        data["deliveryRate"] = this.deliveryRate;
        data["stevedoreRate"] = this.stevedoreRate;
        data["deliveryCharge"] = this.deliveryCharge;
        data["deliveryPurchaseAnalysisCodeID"] = this.deliveryPurchaseAnalysisCodeID;
        data["generatedOrder"] = this.generatedOrder;
        data["orderAcknowledged"] = this.orderAcknowledged;
        data["confirmationRef"] = this.confirmationRef;
        data["noOfLines"] = this.noOfLines;
        data["firstSteelGradeID"] = this.firstSteelGradeID;
        data["questionsAsked"] = this.questionsAsked;
        data["backOrderedFromID"] = this.backOrderedFromID;
        data["calledOffFromID"] = this.calledOffFromID;
        data["dateReceived"] = this.dateReceived ? this.dateReceived.toISOString() : <any>undefined;
        data["receiptDeliveryNoteNumber"] = this.receiptDeliveryNoteNumber;
        data["receiptDeliveryReference"] = this.receiptDeliveryReference;
        data["receiptHaulier"] = this.receiptHaulier;
        data["receiptNotes"] = this.receiptNotes;
        data["referToID"] = this.referToID;
        data["dateTimeApproved"] = this.dateTimeApproved ? this.dateTimeApproved.toISOString() : <any>undefined;
        data["approvedByID"] = this.approvedByID;
        data["invoiced"] = this.invoiced;
        data["journeyID"] = this.journeyID;
        data["pendingForOrderID"] = this.pendingForOrderID;
        data["readyForBooking"] = this.readyForBooking;
        data["readyByID"] = this.readyByID;
        data["readyDate"] = this.readyDate ? this.readyDate.toISOString() : <any>undefined;
        data["dateTimeMarkedReady"] = this.dateTimeMarkedReady ? this.dateTimeMarkedReady.toISOString() : <any>undefined;
        data["transportInstructionID"] = this.transportInstructionID;
        data["distance"] = this.distance;
        data["transportBooked"] = this.transportBooked;
        data["pickupDate"] = this.pickupDate ? this.pickupDate.toISOString() : <any>undefined;
        data["bookedByID"] = this.bookedByID;
        data["dateTimeMarkedBooked"] = this.dateTimeMarkedBooked ? this.dateTimeMarkedBooked.toISOString() : <any>undefined;
        data["bookingNumber"] = this.bookingNumber;
        data["vehicleTypeID"] = this.vehicleTypeID;
        data["ediDocumentID"] = this.ediDocumentID;
        data["computerID"] = this.computerID;
        data["useNewAdditionalCostMode"] = this.useNewAdditionalCostMode;
        data["estimatedFreightInCurrency"] = this.estimatedFreightInCurrency;
        data["estimatedMiscInCurrency"] = this.estimatedMiscInCurrency;
        data["settlementAmountInCurrency"] = this.settlementAmountInCurrency;
        data["settlementDiscount"] = this.settlementDiscount;
        data["promotion"] = this.promotion;
        data["pendingActions"] = this.pendingActions;
        data["saleCode"] = this.saleCode;
        data["bulletinCode"] = this.bulletinCode;
        data["refillOrder"] = this.refillOrder;
        data["shippingMethodID"] = this.shippingMethodID;
        data["shippingMethodOptionID"] = this.shippingMethodOptionID;
        data["rscNumber"] = this.rscNumber;
        data["excludeFromWms"] = this.excludeFromWms;
        data["sendRetailPrice"] = this.sendRetailPrice;
        data["supplierBranchReferenceID"] = this.supplierBranchReferenceID;
        data["branchCode"] = this.branchCode;
        data["branchName"] = this.branchName;
        data["countryName"] = this.countryName;
        data["purchaseAnalysisCode1"] = this.purchaseAnalysisCode1;
        data["purchaseAnalysisCodeName"] = this.purchaseAnalysisCodeName;
        data["supplierCode"] = this.supplierCode;
        data["supplierName"] = this.supplierName;
        data["buyingSocietyCode"] = this.buyingSocietyCode;
        data["buyingSocietyName"] = this.buyingSocietyName;
        data["userName"] = this.userName;
        data["approvedByName"] = this.approvedByName;
        data["createdByName"] = this.createdByName;
        data["lastModifiedByName"] = this.lastModifiedByName;
        data["referToName"] = this.referToName;
        data["currencyCode"] = this.currencyCode;
        data["currencyName"] = this.currencyName;
        data["deliveryFax"] = this.deliveryFax;
        data["paymentFax"] = this.paymentFax;
        data["deliveryEmail"] = this.deliveryEmail;
        data["paymentEmail"] = this.paymentEmail;
        data["vmiProgramReference"] = this.vmiProgramReference;
        data["vmiProgramUseProductBatch"] = this.vmiProgramUseProductBatch;
        data["directOrderCustomerID"] = this.directOrderCustomerID;
        data["customerName"] = this.customerName;
        data["preReceivedOnly"] = this.preReceivedOnly;
        data["workflowPurchaseOrder"] = this.workflowPurchaseOrder;
        return data; 
    }
}

export interface IPurchaseOrderHeader {
    directSOLineExists?: boolean | undefined;
    purchaseOrderID?: number | undefined;
    deleted?: number | undefined;
    purchaseOrderNumber?: number | undefined;
    orderStatus?: number | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    lastModifiedByID?: number | undefined;
    printed?: boolean | undefined;
    branchID?: number | undefined;
    supplierID?: number | undefined;
    buyingSocietyID?: number | undefined;
    buyingSocietyReference?: string | undefined;
    orderType?: number | undefined;
    collected?: boolean | undefined;
    userID?: number | undefined;
    currencyID?: number | undefined;
    vmiProgramID?: number | undefined;
    typeOfPurchase?: number | undefined;
    purchaseAnalysisCodeID?: number | undefined;
    dateRequired?: Date | undefined;
    dateRequiredOption?: number | undefined;
    dateRequiredEarliest?: Date | undefined;
    dateRequiredLatest?: Date | undefined;
    dateExpiry?: Date | undefined;
    dateExpected?: Date | undefined;
    chargeRollingMargin?: boolean | undefined;
    applyMaterialSurcharge?: boolean | undefined;
    originID?: number | undefined;
    stockLocationID?: number | undefined;
    ourRef?: string | undefined;
    supplierRef?: string | undefined;
    contactName?: string | undefined;
    contactNumber?: string | undefined;
    customerID?: number | undefined;
    deliveryAddressID?: number | undefined;
    deliveryAddress?: string | undefined;
    paymentAddressID?: number | undefined;
    paymentTermsID?: number | undefined;
    specialInstructions?: string | undefined;
    headerNotes?: string | undefined;
    notes?: string | undefined;
    contractRef?: string | undefined;
    contractPeriod?: string | undefined;
    timberMill?: string | undefined;
    ship?: string | undefined;
    voyage?: string | undefined;
    bolRef?: string | undefined;
    intrastatDeliveryTermsID?: number | undefined;
    intrastatTransportModeID?: number | undefined;
    showEurosOnOrder?: boolean | undefined;
    exchangeRate?: number | undefined;
    fixedExchangeRate?: boolean | undefined;
    totalCostPrice?: number | undefined;
    totalCostPriceInCurrency?: number | undefined;
    totalWeight?: number | undefined;
    totalVolume?: number | undefined;
    totalAdditionalCost?: number | undefined;
    totalDeliveryCharge?: number | undefined;
    totalStevedoreCharge?: number | undefined;
    deliveryRate?: number | undefined;
    stevedoreRate?: number | undefined;
    deliveryCharge?: number | undefined;
    deliveryPurchaseAnalysisCodeID?: number | undefined;
    generatedOrder?: boolean | undefined;
    orderAcknowledged?: boolean | undefined;
    confirmationRef?: string | undefined;
    noOfLines?: number | undefined;
    firstSteelGradeID?: number | undefined;
    questionsAsked?: number | undefined;
    backOrderedFromID?: number | undefined;
    calledOffFromID?: number | undefined;
    dateReceived?: Date | undefined;
    receiptDeliveryNoteNumber?: string | undefined;
    receiptDeliveryReference?: string | undefined;
    receiptHaulier?: string | undefined;
    receiptNotes?: string | undefined;
    referToID?: number | undefined;
    dateTimeApproved?: Date | undefined;
    approvedByID?: number | undefined;
    invoiced?: boolean | undefined;
    journeyID?: number | undefined;
    pendingForOrderID?: number | undefined;
    readyForBooking?: boolean | undefined;
    readyByID?: number | undefined;
    readyDate?: Date | undefined;
    dateTimeMarkedReady?: Date | undefined;
    transportInstructionID?: number | undefined;
    distance?: number | undefined;
    transportBooked?: number | undefined;
    pickupDate?: Date | undefined;
    bookedByID?: number | undefined;
    dateTimeMarkedBooked?: Date | undefined;
    bookingNumber?: number | undefined;
    vehicleTypeID?: number | undefined;
    ediDocumentID?: number | undefined;
    computerID?: number | undefined;
    useNewAdditionalCostMode?: boolean | undefined;
    estimatedFreightInCurrency?: number | undefined;
    estimatedMiscInCurrency?: number | undefined;
    settlementAmountInCurrency?: number | undefined;
    settlementDiscount?: number | undefined;
    promotion?: boolean | undefined;
    pendingActions?: number | undefined;
    saleCode?: string | undefined;
    bulletinCode?: string | undefined;
    refillOrder?: boolean | undefined;
    shippingMethodID?: number | undefined;
    shippingMethodOptionID?: number | undefined;
    rscNumber?: string | undefined;
    excludeFromWms?: boolean | undefined;
    sendRetailPrice?: boolean | undefined;
    supplierBranchReferenceID?: number | undefined;
    branchCode?: string | undefined;
    branchName?: string | undefined;
    countryName?: string | undefined;
    purchaseAnalysisCode1?: string | undefined;
    purchaseAnalysisCodeName?: string | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;
    buyingSocietyCode?: string | undefined;
    buyingSocietyName?: string | undefined;
    userName?: string | undefined;
    approvedByName?: string | undefined;
    createdByName?: string | undefined;
    lastModifiedByName?: string | undefined;
    referToName?: string | undefined;
    currencyCode?: string | undefined;
    currencyName?: string | undefined;
    deliveryFax?: string | undefined;
    paymentFax?: string | undefined;
    deliveryEmail?: string | undefined;
    paymentEmail?: string | undefined;
    vmiProgramReference?: string | undefined;
    vmiProgramUseProductBatch?: boolean | undefined;
    directOrderCustomerID?: number | undefined;
    customerName?: string | undefined;
    preReceivedOnly?: number | undefined;
    workflowPurchaseOrder?: boolean | undefined;
}

export class PurchaseOrderDepartment implements IPurchaseOrderDepartment {
    purchaseOrderID?: number | undefined;
    departmentID?: number | undefined;

    constructor(data?: IPurchaseOrderDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseOrderID = _data["purchaseOrderID"];
            this.departmentID = _data["departmentID"];
        }
    }

    static fromJS(data: any): PurchaseOrderDepartment {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderDepartment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseOrderID"] = this.purchaseOrderID;
        data["departmentID"] = this.departmentID;
        return data; 
    }
}

export interface IPurchaseOrderDepartment {
    purchaseOrderID?: number | undefined;
    departmentID?: number | undefined;
}

export class PurchaseOrderLine implements IPurchaseOrderLine {
    purchaseOrderLineID?: number | undefined;
    purchaseOrderID?: number | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    lineStatus?: number | undefined;
    productID?: number | undefined;
    avoOptionID?: number | undefined;
    manualCode?: string | undefined;
    manualDescription?: string | undefined;
    manualThickness?: number | undefined;
    manualWidth?: number | undefined;
    manualOrderLineTypeID?: number | undefined;
    prorateCosts?: boolean | undefined;
    glCode?: string | undefined;
    customerID?: number | undefined;
    orderID?: number | undefined;
    orderLineID?: number | undefined;
    orderLineIsDirect?: boolean | undefined;
    worksOrderID?: number | undefined;
    worksOrderLineID?: number | undefined;
    calledOffFromLineID?: number | undefined;
    purchaseAnalysisCodeID?: number | undefined;
    quantity?: number | undefined;
    quantityAllocated?: number | undefined;
    quantityAllocatedUsed?: number | undefined;
    quantityReceived?: number | undefined;
    stockQuantity?: number | undefined;
    stockQuantityReceived?: number | undefined;
    fullyReceived?: boolean | undefined;
    quantityDetailed?: number | undefined;
    quantityInvoiced?: number | undefined;
    quantityCalledOff?: number | undefined;
    fullyInvoiced?: boolean | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    inputPerID?: number | undefined;
    perID?: number | undefined;
    buyStockConversion?: number | undefined;
    stockPerConversion?: number | undefined;
    statsPerConversion?: number | undefined;
    unitCostConversion?: number | undefined;
    unitCostPrice?: number | undefined;
    unitCostPriceInCurrency?: number | undefined;
    unitWeight?: number | undefined;
    totalCostPrice?: number | undefined;
    totalCostPriceInCurrency?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    totalAdditionalCost?: number | undefined;
    totalDeliveryCharge?: number | undefined;
    totalStevedoreCharge?: number | undefined;
    totalOptionCost?: number | undefined;
    totalSurcharge?: number | undefined;
    optionCount?: number | undefined;
    pricingType?: number | undefined;
    buyingRuleID?: number | undefined;
    buyingRulePriority?: number | undefined;
    buyingCalcType?: number | undefined;
    buyingCalcValue?: number | undefined;
    buyingCalcValue2?: number | undefined;
    buyingCalcValue3?: number | undefined;
    buyingCalcValue4?: number | undefined;
    buyingCalcValue5?: number | undefined;
    buyingPrice?: number | undefined;
    buyingAdjustments?: string | undefined;
    discount1?: number | undefined;
    discountAmount1?: number | undefined;
    discount2?: number | undefined;
    discountAmount2?: number | undefined;
    discount3?: number | undefined;
    discountAmount3?: number | undefined;
    discount4?: number | undefined;
    discountAmount4?: number | undefined;
    deliveryCharge?: number | undefined;
    proratedManualCost?: number | undefined;
    vatID?: number | undefined;
    taxGroupID?: number | undefined;
    materialCertTypeID?: number | undefined;
    dateExpected?: Date | undefined;
    notes?: string | undefined;
    invoiced?: boolean | undefined;
    pendingActions?: number | undefined;
    pendingActionID?: number | undefined;
    alternativeSupplierPriceUsed?: boolean | undefined;
    automaticChargeLinkedToLineID?: number | undefined;
    otherFlags?: number | undefined;
    suggestedPOBatchLineID?: number | undefined;
    ourPackMark?: string | undefined;
    timberGradeID?: number | undefined;
    sourcePurchaseOrderLineID?: number | undefined;
    actualNominalConversion?: number | undefined;
    linkedToLineID?: number | undefined;
    quantityBreakID?: number | undefined;
    settlementAmountInCurrency?: number | undefined;
    autoDirectSellPriceUpdateType?: number | undefined;
    whyThisQuantity?: string | undefined;
    manualValueType?: number | undefined;
    manualValue?: number | undefined;
    supplierManualLineID?: number | undefined;
    selectedBuyPriceRuleID?: number | undefined;
    addedOnSupplierInvoice?: boolean | undefined;
    productBatchReference?: string | undefined;
    productBatchOption?: number | undefined;
    productBatchID?: number | undefined;
    manualWeightPerID?: number | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    perRuleID?: number | undefined;
    productCode?: string | undefined;
    productBarCode?: string | undefined;
    productDescription?: string | undefined;
    steelGradeID?: number | undefined;
    materialGradeID?: number | undefined;
    environmentalStatusID?: number | undefined;
    defaultPiecesPerPack?: number | undefined;
    thickness?: number | undefined;
    width?: number | undefined;
    length?: number | undefined;
    weight?: number | undefined;
    dimension4?: number | undefined;
    dimension5?: number | undefined;
    imperial?: boolean | undefined;
    tallyLengths?: string | undefined;
    tallyLengthsPerID?: number | undefined;
    availableWidths?: string | undefined;
    vendorManagedInventory?: boolean | undefined;
    productAllowDescriptionOverride?: number | undefined;
    stockControlByLength?: boolean | undefined;
    stockedByCost?: boolean | undefined;
    productAlternativeSupplierCount?: number | undefined;
    productSupplierID?: number | undefined;
    poAutomaticLineChargeID?: number | undefined;
    poAutomaticLineChargeMultiplier?: number | undefined;
    productSpecial?: boolean | undefined;
    productAutoCreateSpecialsFromThis?: number | undefined;
    productSalesOrderTalliedInputScreen?: number | undefined;
    productManufacturerCode?: string | undefined;
    productDeleted?: number | undefined;
    perCode?: string | undefined;
    perName?: string | undefined;
    productInputPerID?: number | undefined;
    weightPerID?: number | undefined;
    productStockPerID?: number | undefined;
    purchaseAnalysisCode1?: string | undefined;
    purchaseAnalysisCodeName?: string | undefined;
    customerCode?: string | undefined;
    customerName?: string | undefined;
    customerOnHold?: boolean | undefined;
    customerCreditControlStatusID?: number | undefined;
    orderNumber?: number | undefined;
    salesOrderStatus?: number | undefined;
    salesOrderCashSale?: boolean | undefined;
    salesOrderLineNumber?: number | undefined;
    statisticsPerID?: number | undefined;
    supplierProductCode?: string | undefined;
    branchID?: number | undefined;
    supplierID?: number | undefined;
    productActualThickness?: number | undefined;
    productActualWidth?: number | undefined;
    totalLengthImperial?: number | undefined;
    totalVolumeImperial?: number | undefined;
    isTimberGradeLine?: boolean | undefined;
    wmsPendingOC?: boolean | undefined;
    totalGrossWeight?: number | undefined;
    totalOptionCostPrice?: number | undefined;
    unitGrossWeight?: number | undefined;
    lineAllocations?: PurchaseOrderLineAllocation[] | undefined;
    linePurchaseOrders?: LinesForPurchaseOrder[] | undefined;
    lineAdditionalCosts?: PurchaseOrderLineAdditionalCostCharge[] | undefined;

    constructor(data?: IPurchaseOrderLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseOrderLineID = _data["purchaseOrderLineID"];
            this.purchaseOrderID = _data["purchaseOrderID"];
            this.lineNumber = _data["lineNumber"];
            this.lineType = _data["lineType"];
            this.lineStatus = _data["lineStatus"];
            this.productID = _data["productID"];
            this.avoOptionID = _data["avoOptionID"];
            this.manualCode = _data["manualCode"];
            this.manualDescription = _data["manualDescription"];
            this.manualThickness = _data["manualThickness"];
            this.manualWidth = _data["manualWidth"];
            this.manualOrderLineTypeID = _data["manualOrderLineTypeID"];
            this.prorateCosts = _data["prorateCosts"];
            this.glCode = _data["glCode"];
            this.customerID = _data["customerID"];
            this.orderID = _data["orderID"];
            this.orderLineID = _data["orderLineID"];
            this.orderLineIsDirect = _data["orderLineIsDirect"];
            this.worksOrderID = _data["worksOrderID"];
            this.worksOrderLineID = _data["worksOrderLineID"];
            this.calledOffFromLineID = _data["calledOffFromLineID"];
            this.purchaseAnalysisCodeID = _data["purchaseAnalysisCodeID"];
            this.quantity = _data["quantity"];
            this.quantityAllocated = _data["quantityAllocated"];
            this.quantityAllocatedUsed = _data["quantityAllocatedUsed"];
            this.quantityReceived = _data["quantityReceived"];
            this.stockQuantity = _data["stockQuantity"];
            this.stockQuantityReceived = _data["stockQuantityReceived"];
            this.fullyReceived = _data["fullyReceived"];
            this.quantityDetailed = _data["quantityDetailed"];
            this.quantityInvoiced = _data["quantityInvoiced"];
            this.quantityCalledOff = _data["quantityCalledOff"];
            this.fullyInvoiced = _data["fullyInvoiced"];
            this.quantityTally = _data["quantityTally"];
            this.noOfPieces = _data["noOfPieces"];
            this.inputPerID = _data["inputPerID"];
            this.perID = _data["perID"];
            this.buyStockConversion = _data["buyStockConversion"];
            this.stockPerConversion = _data["stockPerConversion"];
            this.statsPerConversion = _data["statsPerConversion"];
            this.unitCostConversion = _data["unitCostConversion"];
            this.unitCostPrice = _data["unitCostPrice"];
            this.unitCostPriceInCurrency = _data["unitCostPriceInCurrency"];
            this.unitWeight = _data["unitWeight"];
            this.totalCostPrice = _data["totalCostPrice"];
            this.totalCostPriceInCurrency = _data["totalCostPriceInCurrency"];
            this.totalWeight = _data["totalWeight"];
            this.totalLength = _data["totalLength"];
            this.totalVolume = _data["totalVolume"];
            this.totalAdditionalCost = _data["totalAdditionalCost"];
            this.totalDeliveryCharge = _data["totalDeliveryCharge"];
            this.totalStevedoreCharge = _data["totalStevedoreCharge"];
            this.totalOptionCost = _data["totalOptionCost"];
            this.totalSurcharge = _data["totalSurcharge"];
            this.optionCount = _data["optionCount"];
            this.pricingType = _data["pricingType"];
            this.buyingRuleID = _data["buyingRuleID"];
            this.buyingRulePriority = _data["buyingRulePriority"];
            this.buyingCalcType = _data["buyingCalcType"];
            this.buyingCalcValue = _data["buyingCalcValue"];
            this.buyingCalcValue2 = _data["buyingCalcValue2"];
            this.buyingCalcValue3 = _data["buyingCalcValue3"];
            this.buyingCalcValue4 = _data["buyingCalcValue4"];
            this.buyingCalcValue5 = _data["buyingCalcValue5"];
            this.buyingPrice = _data["buyingPrice"];
            this.buyingAdjustments = _data["buyingAdjustments"];
            this.discount1 = _data["discount1"];
            this.discountAmount1 = _data["discountAmount1"];
            this.discount2 = _data["discount2"];
            this.discountAmount2 = _data["discountAmount2"];
            this.discount3 = _data["discount3"];
            this.discountAmount3 = _data["discountAmount3"];
            this.discount4 = _data["discount4"];
            this.discountAmount4 = _data["discountAmount4"];
            this.deliveryCharge = _data["deliveryCharge"];
            this.proratedManualCost = _data["proratedManualCost"];
            this.vatID = _data["vatID"];
            this.taxGroupID = _data["taxGroupID"];
            this.materialCertTypeID = _data["materialCertTypeID"];
            this.dateExpected = _data["dateExpected"] ? new Date(_data["dateExpected"].toString()) : <any>undefined;
            this.notes = _data["notes"];
            this.invoiced = _data["invoiced"];
            this.pendingActions = _data["pendingActions"];
            this.pendingActionID = _data["pendingActionID"];
            this.alternativeSupplierPriceUsed = _data["alternativeSupplierPriceUsed"];
            this.automaticChargeLinkedToLineID = _data["automaticChargeLinkedToLineID"];
            this.otherFlags = _data["otherFlags"];
            this.suggestedPOBatchLineID = _data["suggestedPOBatchLineID"];
            this.ourPackMark = _data["ourPackMark"];
            this.timberGradeID = _data["timberGradeID"];
            this.sourcePurchaseOrderLineID = _data["sourcePurchaseOrderLineID"];
            this.actualNominalConversion = _data["actualNominalConversion"];
            this.linkedToLineID = _data["linkedToLineID"];
            this.quantityBreakID = _data["quantityBreakID"];
            this.settlementAmountInCurrency = _data["settlementAmountInCurrency"];
            this.autoDirectSellPriceUpdateType = _data["autoDirectSellPriceUpdateType"];
            this.whyThisQuantity = _data["whyThisQuantity"];
            this.manualValueType = _data["manualValueType"];
            this.manualValue = _data["manualValue"];
            this.supplierManualLineID = _data["supplierManualLineID"];
            this.selectedBuyPriceRuleID = _data["selectedBuyPriceRuleID"];
            this.addedOnSupplierInvoice = _data["addedOnSupplierInvoice"];
            this.productBatchReference = _data["productBatchReference"];
            this.productBatchOption = _data["productBatchOption"];
            this.productBatchID = _data["productBatchID"];
            this.manualWeightPerID = _data["manualWeightPerID"];
            this.productType = _data["productType"];
            this.productSubType = _data["productSubType"];
            this.perRuleID = _data["perRuleID"];
            this.productCode = _data["productCode"];
            this.productBarCode = _data["productBarCode"];
            this.productDescription = _data["productDescription"];
            this.steelGradeID = _data["steelGradeID"];
            this.materialGradeID = _data["materialGradeID"];
            this.environmentalStatusID = _data["environmentalStatusID"];
            this.defaultPiecesPerPack = _data["defaultPiecesPerPack"];
            this.thickness = _data["thickness"];
            this.width = _data["width"];
            this.length = _data["length"];
            this.weight = _data["weight"];
            this.dimension4 = _data["dimension4"];
            this.dimension5 = _data["dimension5"];
            this.imperial = _data["imperial"];
            this.tallyLengths = _data["tallyLengths"];
            this.tallyLengthsPerID = _data["tallyLengthsPerID"];
            this.availableWidths = _data["availableWidths"];
            this.vendorManagedInventory = _data["vendorManagedInventory"];
            this.productAllowDescriptionOverride = _data["productAllowDescriptionOverride"];
            this.stockControlByLength = _data["stockControlByLength"];
            this.stockedByCost = _data["stockedByCost"];
            this.productAlternativeSupplierCount = _data["productAlternativeSupplierCount"];
            this.productSupplierID = _data["productSupplierID"];
            this.poAutomaticLineChargeID = _data["poAutomaticLineChargeID"];
            this.poAutomaticLineChargeMultiplier = _data["poAutomaticLineChargeMultiplier"];
            this.productSpecial = _data["productSpecial"];
            this.productAutoCreateSpecialsFromThis = _data["productAutoCreateSpecialsFromThis"];
            this.productSalesOrderTalliedInputScreen = _data["productSalesOrderTalliedInputScreen"];
            this.productManufacturerCode = _data["productManufacturerCode"];
            this.productDeleted = _data["productDeleted"];
            this.perCode = _data["perCode"];
            this.perName = _data["perName"];
            this.productInputPerID = _data["productInputPerID"];
            this.weightPerID = _data["weightPerID"];
            this.productStockPerID = _data["productStockPerID"];
            this.purchaseAnalysisCode1 = _data["purchaseAnalysisCode1"];
            this.purchaseAnalysisCodeName = _data["purchaseAnalysisCodeName"];
            this.customerCode = _data["customerCode"];
            this.customerName = _data["customerName"];
            this.customerOnHold = _data["customerOnHold"];
            this.customerCreditControlStatusID = _data["customerCreditControlStatusID"];
            this.orderNumber = _data["orderNumber"];
            this.salesOrderStatus = _data["salesOrderStatus"];
            this.salesOrderCashSale = _data["salesOrderCashSale"];
            this.salesOrderLineNumber = _data["salesOrderLineNumber"];
            this.statisticsPerID = _data["statisticsPerID"];
            this.supplierProductCode = _data["supplierProductCode"];
            this.branchID = _data["branchID"];
            this.supplierID = _data["supplierID"];
            this.productActualThickness = _data["productActualThickness"];
            this.productActualWidth = _data["productActualWidth"];
            this.totalLengthImperial = _data["totalLengthImperial"];
            this.totalVolumeImperial = _data["totalVolumeImperial"];
            this.isTimberGradeLine = _data["isTimberGradeLine"];
            this.wmsPendingOC = _data["wmsPendingOC"];
            this.totalGrossWeight = _data["totalGrossWeight"];
            this.totalOptionCostPrice = _data["totalOptionCostPrice"];
            this.unitGrossWeight = _data["unitGrossWeight"];
            if (Array.isArray(_data["lineAllocations"])) {
                this.lineAllocations = [] as any;
                for (let item of _data["lineAllocations"])
                    this.lineAllocations!.push(PurchaseOrderLineAllocation.fromJS(item));
            }
            if (Array.isArray(_data["linePurchaseOrders"])) {
                this.linePurchaseOrders = [] as any;
                for (let item of _data["linePurchaseOrders"])
                    this.linePurchaseOrders!.push(LinesForPurchaseOrder.fromJS(item));
            }
            if (Array.isArray(_data["lineAdditionalCosts"])) {
                this.lineAdditionalCosts = [] as any;
                for (let item of _data["lineAdditionalCosts"])
                    this.lineAdditionalCosts!.push(PurchaseOrderLineAdditionalCostCharge.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PurchaseOrderLine {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseOrderLineID"] = this.purchaseOrderLineID;
        data["purchaseOrderID"] = this.purchaseOrderID;
        data["lineNumber"] = this.lineNumber;
        data["lineType"] = this.lineType;
        data["lineStatus"] = this.lineStatus;
        data["productID"] = this.productID;
        data["avoOptionID"] = this.avoOptionID;
        data["manualCode"] = this.manualCode;
        data["manualDescription"] = this.manualDescription;
        data["manualThickness"] = this.manualThickness;
        data["manualWidth"] = this.manualWidth;
        data["manualOrderLineTypeID"] = this.manualOrderLineTypeID;
        data["prorateCosts"] = this.prorateCosts;
        data["glCode"] = this.glCode;
        data["customerID"] = this.customerID;
        data["orderID"] = this.orderID;
        data["orderLineID"] = this.orderLineID;
        data["orderLineIsDirect"] = this.orderLineIsDirect;
        data["worksOrderID"] = this.worksOrderID;
        data["worksOrderLineID"] = this.worksOrderLineID;
        data["calledOffFromLineID"] = this.calledOffFromLineID;
        data["purchaseAnalysisCodeID"] = this.purchaseAnalysisCodeID;
        data["quantity"] = this.quantity;
        data["quantityAllocated"] = this.quantityAllocated;
        data["quantityAllocatedUsed"] = this.quantityAllocatedUsed;
        data["quantityReceived"] = this.quantityReceived;
        data["stockQuantity"] = this.stockQuantity;
        data["stockQuantityReceived"] = this.stockQuantityReceived;
        data["fullyReceived"] = this.fullyReceived;
        data["quantityDetailed"] = this.quantityDetailed;
        data["quantityInvoiced"] = this.quantityInvoiced;
        data["quantityCalledOff"] = this.quantityCalledOff;
        data["fullyInvoiced"] = this.fullyInvoiced;
        data["quantityTally"] = this.quantityTally;
        data["noOfPieces"] = this.noOfPieces;
        data["inputPerID"] = this.inputPerID;
        data["perID"] = this.perID;
        data["buyStockConversion"] = this.buyStockConversion;
        data["stockPerConversion"] = this.stockPerConversion;
        data["statsPerConversion"] = this.statsPerConversion;
        data["unitCostConversion"] = this.unitCostConversion;
        data["unitCostPrice"] = this.unitCostPrice;
        data["unitCostPriceInCurrency"] = this.unitCostPriceInCurrency;
        data["unitWeight"] = this.unitWeight;
        data["totalCostPrice"] = this.totalCostPrice;
        data["totalCostPriceInCurrency"] = this.totalCostPriceInCurrency;
        data["totalWeight"] = this.totalWeight;
        data["totalLength"] = this.totalLength;
        data["totalVolume"] = this.totalVolume;
        data["totalAdditionalCost"] = this.totalAdditionalCost;
        data["totalDeliveryCharge"] = this.totalDeliveryCharge;
        data["totalStevedoreCharge"] = this.totalStevedoreCharge;
        data["totalOptionCost"] = this.totalOptionCost;
        data["totalSurcharge"] = this.totalSurcharge;
        data["optionCount"] = this.optionCount;
        data["pricingType"] = this.pricingType;
        data["buyingRuleID"] = this.buyingRuleID;
        data["buyingRulePriority"] = this.buyingRulePriority;
        data["buyingCalcType"] = this.buyingCalcType;
        data["buyingCalcValue"] = this.buyingCalcValue;
        data["buyingCalcValue2"] = this.buyingCalcValue2;
        data["buyingCalcValue3"] = this.buyingCalcValue3;
        data["buyingCalcValue4"] = this.buyingCalcValue4;
        data["buyingCalcValue5"] = this.buyingCalcValue5;
        data["buyingPrice"] = this.buyingPrice;
        data["buyingAdjustments"] = this.buyingAdjustments;
        data["discount1"] = this.discount1;
        data["discountAmount1"] = this.discountAmount1;
        data["discount2"] = this.discount2;
        data["discountAmount2"] = this.discountAmount2;
        data["discount3"] = this.discount3;
        data["discountAmount3"] = this.discountAmount3;
        data["discount4"] = this.discount4;
        data["discountAmount4"] = this.discountAmount4;
        data["deliveryCharge"] = this.deliveryCharge;
        data["proratedManualCost"] = this.proratedManualCost;
        data["vatID"] = this.vatID;
        data["taxGroupID"] = this.taxGroupID;
        data["materialCertTypeID"] = this.materialCertTypeID;
        data["dateExpected"] = this.dateExpected ? this.dateExpected.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["invoiced"] = this.invoiced;
        data["pendingActions"] = this.pendingActions;
        data["pendingActionID"] = this.pendingActionID;
        data["alternativeSupplierPriceUsed"] = this.alternativeSupplierPriceUsed;
        data["automaticChargeLinkedToLineID"] = this.automaticChargeLinkedToLineID;
        data["otherFlags"] = this.otherFlags;
        data["suggestedPOBatchLineID"] = this.suggestedPOBatchLineID;
        data["ourPackMark"] = this.ourPackMark;
        data["timberGradeID"] = this.timberGradeID;
        data["sourcePurchaseOrderLineID"] = this.sourcePurchaseOrderLineID;
        data["actualNominalConversion"] = this.actualNominalConversion;
        data["linkedToLineID"] = this.linkedToLineID;
        data["quantityBreakID"] = this.quantityBreakID;
        data["settlementAmountInCurrency"] = this.settlementAmountInCurrency;
        data["autoDirectSellPriceUpdateType"] = this.autoDirectSellPriceUpdateType;
        data["whyThisQuantity"] = this.whyThisQuantity;
        data["manualValueType"] = this.manualValueType;
        data["manualValue"] = this.manualValue;
        data["supplierManualLineID"] = this.supplierManualLineID;
        data["selectedBuyPriceRuleID"] = this.selectedBuyPriceRuleID;
        data["addedOnSupplierInvoice"] = this.addedOnSupplierInvoice;
        data["productBatchReference"] = this.productBatchReference;
        data["productBatchOption"] = this.productBatchOption;
        data["productBatchID"] = this.productBatchID;
        data["manualWeightPerID"] = this.manualWeightPerID;
        data["productType"] = this.productType;
        data["productSubType"] = this.productSubType;
        data["perRuleID"] = this.perRuleID;
        data["productCode"] = this.productCode;
        data["productBarCode"] = this.productBarCode;
        data["productDescription"] = this.productDescription;
        data["steelGradeID"] = this.steelGradeID;
        data["materialGradeID"] = this.materialGradeID;
        data["environmentalStatusID"] = this.environmentalStatusID;
        data["defaultPiecesPerPack"] = this.defaultPiecesPerPack;
        data["thickness"] = this.thickness;
        data["width"] = this.width;
        data["length"] = this.length;
        data["weight"] = this.weight;
        data["dimension4"] = this.dimension4;
        data["dimension5"] = this.dimension5;
        data["imperial"] = this.imperial;
        data["tallyLengths"] = this.tallyLengths;
        data["tallyLengthsPerID"] = this.tallyLengthsPerID;
        data["availableWidths"] = this.availableWidths;
        data["vendorManagedInventory"] = this.vendorManagedInventory;
        data["productAllowDescriptionOverride"] = this.productAllowDescriptionOverride;
        data["stockControlByLength"] = this.stockControlByLength;
        data["stockedByCost"] = this.stockedByCost;
        data["productAlternativeSupplierCount"] = this.productAlternativeSupplierCount;
        data["productSupplierID"] = this.productSupplierID;
        data["poAutomaticLineChargeID"] = this.poAutomaticLineChargeID;
        data["poAutomaticLineChargeMultiplier"] = this.poAutomaticLineChargeMultiplier;
        data["productSpecial"] = this.productSpecial;
        data["productAutoCreateSpecialsFromThis"] = this.productAutoCreateSpecialsFromThis;
        data["productSalesOrderTalliedInputScreen"] = this.productSalesOrderTalliedInputScreen;
        data["productManufacturerCode"] = this.productManufacturerCode;
        data["productDeleted"] = this.productDeleted;
        data["perCode"] = this.perCode;
        data["perName"] = this.perName;
        data["productInputPerID"] = this.productInputPerID;
        data["weightPerID"] = this.weightPerID;
        data["productStockPerID"] = this.productStockPerID;
        data["purchaseAnalysisCode1"] = this.purchaseAnalysisCode1;
        data["purchaseAnalysisCodeName"] = this.purchaseAnalysisCodeName;
        data["customerCode"] = this.customerCode;
        data["customerName"] = this.customerName;
        data["customerOnHold"] = this.customerOnHold;
        data["customerCreditControlStatusID"] = this.customerCreditControlStatusID;
        data["orderNumber"] = this.orderNumber;
        data["salesOrderStatus"] = this.salesOrderStatus;
        data["salesOrderCashSale"] = this.salesOrderCashSale;
        data["salesOrderLineNumber"] = this.salesOrderLineNumber;
        data["statisticsPerID"] = this.statisticsPerID;
        data["supplierProductCode"] = this.supplierProductCode;
        data["branchID"] = this.branchID;
        data["supplierID"] = this.supplierID;
        data["productActualThickness"] = this.productActualThickness;
        data["productActualWidth"] = this.productActualWidth;
        data["totalLengthImperial"] = this.totalLengthImperial;
        data["totalVolumeImperial"] = this.totalVolumeImperial;
        data["isTimberGradeLine"] = this.isTimberGradeLine;
        data["wmsPendingOC"] = this.wmsPendingOC;
        data["totalGrossWeight"] = this.totalGrossWeight;
        data["totalOptionCostPrice"] = this.totalOptionCostPrice;
        data["unitGrossWeight"] = this.unitGrossWeight;
        if (Array.isArray(this.lineAllocations)) {
            data["lineAllocations"] = [];
            for (let item of this.lineAllocations)
                data["lineAllocations"].push(item.toJSON());
        }
        if (Array.isArray(this.linePurchaseOrders)) {
            data["linePurchaseOrders"] = [];
            for (let item of this.linePurchaseOrders)
                data["linePurchaseOrders"].push(item.toJSON());
        }
        if (Array.isArray(this.lineAdditionalCosts)) {
            data["lineAdditionalCosts"] = [];
            for (let item of this.lineAdditionalCosts)
                data["lineAdditionalCosts"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPurchaseOrderLine {
    purchaseOrderLineID?: number | undefined;
    purchaseOrderID?: number | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    lineStatus?: number | undefined;
    productID?: number | undefined;
    avoOptionID?: number | undefined;
    manualCode?: string | undefined;
    manualDescription?: string | undefined;
    manualThickness?: number | undefined;
    manualWidth?: number | undefined;
    manualOrderLineTypeID?: number | undefined;
    prorateCosts?: boolean | undefined;
    glCode?: string | undefined;
    customerID?: number | undefined;
    orderID?: number | undefined;
    orderLineID?: number | undefined;
    orderLineIsDirect?: boolean | undefined;
    worksOrderID?: number | undefined;
    worksOrderLineID?: number | undefined;
    calledOffFromLineID?: number | undefined;
    purchaseAnalysisCodeID?: number | undefined;
    quantity?: number | undefined;
    quantityAllocated?: number | undefined;
    quantityAllocatedUsed?: number | undefined;
    quantityReceived?: number | undefined;
    stockQuantity?: number | undefined;
    stockQuantityReceived?: number | undefined;
    fullyReceived?: boolean | undefined;
    quantityDetailed?: number | undefined;
    quantityInvoiced?: number | undefined;
    quantityCalledOff?: number | undefined;
    fullyInvoiced?: boolean | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    inputPerID?: number | undefined;
    perID?: number | undefined;
    buyStockConversion?: number | undefined;
    stockPerConversion?: number | undefined;
    statsPerConversion?: number | undefined;
    unitCostConversion?: number | undefined;
    unitCostPrice?: number | undefined;
    unitCostPriceInCurrency?: number | undefined;
    unitWeight?: number | undefined;
    totalCostPrice?: number | undefined;
    totalCostPriceInCurrency?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    totalAdditionalCost?: number | undefined;
    totalDeliveryCharge?: number | undefined;
    totalStevedoreCharge?: number | undefined;
    totalOptionCost?: number | undefined;
    totalSurcharge?: number | undefined;
    optionCount?: number | undefined;
    pricingType?: number | undefined;
    buyingRuleID?: number | undefined;
    buyingRulePriority?: number | undefined;
    buyingCalcType?: number | undefined;
    buyingCalcValue?: number | undefined;
    buyingCalcValue2?: number | undefined;
    buyingCalcValue3?: number | undefined;
    buyingCalcValue4?: number | undefined;
    buyingCalcValue5?: number | undefined;
    buyingPrice?: number | undefined;
    buyingAdjustments?: string | undefined;
    discount1?: number | undefined;
    discountAmount1?: number | undefined;
    discount2?: number | undefined;
    discountAmount2?: number | undefined;
    discount3?: number | undefined;
    discountAmount3?: number | undefined;
    discount4?: number | undefined;
    discountAmount4?: number | undefined;
    deliveryCharge?: number | undefined;
    proratedManualCost?: number | undefined;
    vatID?: number | undefined;
    taxGroupID?: number | undefined;
    materialCertTypeID?: number | undefined;
    dateExpected?: Date | undefined;
    notes?: string | undefined;
    invoiced?: boolean | undefined;
    pendingActions?: number | undefined;
    pendingActionID?: number | undefined;
    alternativeSupplierPriceUsed?: boolean | undefined;
    automaticChargeLinkedToLineID?: number | undefined;
    otherFlags?: number | undefined;
    suggestedPOBatchLineID?: number | undefined;
    ourPackMark?: string | undefined;
    timberGradeID?: number | undefined;
    sourcePurchaseOrderLineID?: number | undefined;
    actualNominalConversion?: number | undefined;
    linkedToLineID?: number | undefined;
    quantityBreakID?: number | undefined;
    settlementAmountInCurrency?: number | undefined;
    autoDirectSellPriceUpdateType?: number | undefined;
    whyThisQuantity?: string | undefined;
    manualValueType?: number | undefined;
    manualValue?: number | undefined;
    supplierManualLineID?: number | undefined;
    selectedBuyPriceRuleID?: number | undefined;
    addedOnSupplierInvoice?: boolean | undefined;
    productBatchReference?: string | undefined;
    productBatchOption?: number | undefined;
    productBatchID?: number | undefined;
    manualWeightPerID?: number | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    perRuleID?: number | undefined;
    productCode?: string | undefined;
    productBarCode?: string | undefined;
    productDescription?: string | undefined;
    steelGradeID?: number | undefined;
    materialGradeID?: number | undefined;
    environmentalStatusID?: number | undefined;
    defaultPiecesPerPack?: number | undefined;
    thickness?: number | undefined;
    width?: number | undefined;
    length?: number | undefined;
    weight?: number | undefined;
    dimension4?: number | undefined;
    dimension5?: number | undefined;
    imperial?: boolean | undefined;
    tallyLengths?: string | undefined;
    tallyLengthsPerID?: number | undefined;
    availableWidths?: string | undefined;
    vendorManagedInventory?: boolean | undefined;
    productAllowDescriptionOverride?: number | undefined;
    stockControlByLength?: boolean | undefined;
    stockedByCost?: boolean | undefined;
    productAlternativeSupplierCount?: number | undefined;
    productSupplierID?: number | undefined;
    poAutomaticLineChargeID?: number | undefined;
    poAutomaticLineChargeMultiplier?: number | undefined;
    productSpecial?: boolean | undefined;
    productAutoCreateSpecialsFromThis?: number | undefined;
    productSalesOrderTalliedInputScreen?: number | undefined;
    productManufacturerCode?: string | undefined;
    productDeleted?: number | undefined;
    perCode?: string | undefined;
    perName?: string | undefined;
    productInputPerID?: number | undefined;
    weightPerID?: number | undefined;
    productStockPerID?: number | undefined;
    purchaseAnalysisCode1?: string | undefined;
    purchaseAnalysisCodeName?: string | undefined;
    customerCode?: string | undefined;
    customerName?: string | undefined;
    customerOnHold?: boolean | undefined;
    customerCreditControlStatusID?: number | undefined;
    orderNumber?: number | undefined;
    salesOrderStatus?: number | undefined;
    salesOrderCashSale?: boolean | undefined;
    salesOrderLineNumber?: number | undefined;
    statisticsPerID?: number | undefined;
    supplierProductCode?: string | undefined;
    branchID?: number | undefined;
    supplierID?: number | undefined;
    productActualThickness?: number | undefined;
    productActualWidth?: number | undefined;
    totalLengthImperial?: number | undefined;
    totalVolumeImperial?: number | undefined;
    isTimberGradeLine?: boolean | undefined;
    wmsPendingOC?: boolean | undefined;
    totalGrossWeight?: number | undefined;
    totalOptionCostPrice?: number | undefined;
    unitGrossWeight?: number | undefined;
    lineAllocations?: PurchaseOrderLineAllocation[] | undefined;
    linePurchaseOrders?: LinesForPurchaseOrder[] | undefined;
    lineAdditionalCosts?: PurchaseOrderLineAdditionalCostCharge[] | undefined;
}

export class PurchaseOrderAdditionalCostCharge implements IPurchaseOrderAdditionalCostCharge {
    purchaseOrderAddCostChargeID?: number | undefined;
    purchaseOrderID?: number | undefined;
    additionalCostChargeID?: number | undefined;
    supplierID?: number | undefined;
    reference?: string | undefined;
    currencyID?: number | undefined;
    estimateExchangeRate?: number | undefined;
    estimateCost?: number | undefined;
    estimateCostInCurrency?: number | undefined;
    estimatePercentEntered?: number | undefined;
    actualExchangeRate?: number | undefined;
    actualCost?: number | undefined;
    actualCostInCurrency?: number | undefined;
    costPriceValue?: number | undefined;
    costPriceValueType?: number | undefined;
    costProRateBy?: number | undefined;
    glCodePayable?: string | undefined;
    notes?: string | undefined;
    dateTimeCreated?: Date | undefined;
    invoiced?: boolean | undefined;
    deleted?: number | undefined;

    constructor(data?: IPurchaseOrderAdditionalCostCharge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseOrderAddCostChargeID = _data["purchaseOrderAddCostChargeID"];
            this.purchaseOrderID = _data["purchaseOrderID"];
            this.additionalCostChargeID = _data["additionalCostChargeID"];
            this.supplierID = _data["supplierID"];
            this.reference = _data["reference"];
            this.currencyID = _data["currencyID"];
            this.estimateExchangeRate = _data["estimateExchangeRate"];
            this.estimateCost = _data["estimateCost"];
            this.estimateCostInCurrency = _data["estimateCostInCurrency"];
            this.estimatePercentEntered = _data["estimatePercentEntered"];
            this.actualExchangeRate = _data["actualExchangeRate"];
            this.actualCost = _data["actualCost"];
            this.actualCostInCurrency = _data["actualCostInCurrency"];
            this.costPriceValue = _data["costPriceValue"];
            this.costPriceValueType = _data["costPriceValueType"];
            this.costProRateBy = _data["costProRateBy"];
            this.glCodePayable = _data["glCodePayable"];
            this.notes = _data["notes"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.invoiced = _data["invoiced"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): PurchaseOrderAdditionalCostCharge {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderAdditionalCostCharge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseOrderAddCostChargeID"] = this.purchaseOrderAddCostChargeID;
        data["purchaseOrderID"] = this.purchaseOrderID;
        data["additionalCostChargeID"] = this.additionalCostChargeID;
        data["supplierID"] = this.supplierID;
        data["reference"] = this.reference;
        data["currencyID"] = this.currencyID;
        data["estimateExchangeRate"] = this.estimateExchangeRate;
        data["estimateCost"] = this.estimateCost;
        data["estimateCostInCurrency"] = this.estimateCostInCurrency;
        data["estimatePercentEntered"] = this.estimatePercentEntered;
        data["actualExchangeRate"] = this.actualExchangeRate;
        data["actualCost"] = this.actualCost;
        data["actualCostInCurrency"] = this.actualCostInCurrency;
        data["costPriceValue"] = this.costPriceValue;
        data["costPriceValueType"] = this.costPriceValueType;
        data["costProRateBy"] = this.costProRateBy;
        data["glCodePayable"] = this.glCodePayable;
        data["notes"] = this.notes;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["invoiced"] = this.invoiced;
        data["deleted"] = this.deleted;
        return data; 
    }
}

export interface IPurchaseOrderAdditionalCostCharge {
    purchaseOrderAddCostChargeID?: number | undefined;
    purchaseOrderID?: number | undefined;
    additionalCostChargeID?: number | undefined;
    supplierID?: number | undefined;
    reference?: string | undefined;
    currencyID?: number | undefined;
    estimateExchangeRate?: number | undefined;
    estimateCost?: number | undefined;
    estimateCostInCurrency?: number | undefined;
    estimatePercentEntered?: number | undefined;
    actualExchangeRate?: number | undefined;
    actualCost?: number | undefined;
    actualCostInCurrency?: number | undefined;
    costPriceValue?: number | undefined;
    costPriceValueType?: number | undefined;
    costProRateBy?: number | undefined;
    glCodePayable?: string | undefined;
    notes?: string | undefined;
    dateTimeCreated?: Date | undefined;
    invoiced?: boolean | undefined;
    deleted?: number | undefined;
}

export class StockReceiptHeader implements IStockReceiptHeader {
    totalActualVolume?: number | undefined;
    stockReceiptID?: number | undefined;
    stockReceiptNumber?: number | undefined;
    receiptStatus?: number | undefined;
    purchaseOrderID?: number | undefined;
    dateReceived?: Date | undefined;
    deliveryNoteNumber?: string | undefined;
    deliveryReference?: string | undefined;
    haulier?: string | undefined;
    putAwayLocation?: string | undefined;
    exchangeRate?: number | undefined;
    fixedExchangeRate?: boolean | undefined;
    enteredInAdvance?: boolean | undefined;
    printed?: boolean | undefined;
    quantityReceived?: number | undefined;
    totalWeight?: number | undefined;
    readonly totalPackWeight?: number | undefined;
    readonly totalReceivedPackWeight?: number | undefined;
    readonly totalCostPrice?: number | undefined;
    readonly totalCostPriceInCurrency?: number | undefined;
    notes?: string | undefined;
    stockLocationID?: number | undefined;
    contractRef?: string | undefined;
    contractPeriod?: string | undefined;
    countryOfOriginID?: number | undefined;
    timberMill?: string | undefined;
    ship?: string | undefined;
    voyage?: string | undefined;
    bolRef?: string | undefined;
    intrastatDeliveryTermsID?: number | undefined;
    intrastatTransportModeID?: number | undefined;
    invoiced?: boolean | undefined;
    dateExpected?: Date | undefined;
    dateTimeInAdvanceRemoved?: Date | undefined;
    useNewAdditionalCostMode?: boolean | undefined;
    estimatedFreightInCurrency?: number | undefined;
    estimatedMiscInCurrency?: number | undefined;
    settlementAmountInCurrency?: number | undefined;
    settlementDiscount?: number | undefined;
    paymentTermsID?: number | undefined;
    wmsTransNumber?: number | undefined;
    addingSupplierInvoiceID?: number | undefined;
    purchaseOrderNumber?: number | undefined;
    orderType?: number | undefined;
    typeOfPurchase?: number | undefined;
    supplierID?: number | undefined;
    buyingSocietyID?: number | undefined;
    originID?: number | undefined;
    currencyID?: number | undefined;
    poExchangeRate?: number | undefined;
    poFixedExchangeRate?: boolean | undefined;
    poDeliveryBranchID?: number | undefined;
    poStockLocationID?: number | undefined;
    poContractRef?: string | undefined;
    poContractPeriod?: string | undefined;
    poCountryOfOriginID?: number | undefined;
    poTimberMill?: string | undefined;
    poShip?: string | undefined;
    poVoyage?: string | undefined;
    pobolRef?: string | undefined;
    poIntrastatDeliveryTermsID?: number | undefined;
    poIntrastatTransportModeID?: number | undefined;
    poTransportInstructionID?: number | undefined;
    vmiProgramID?: number | undefined;
    poTotalCostPriceInCurrency?: number | undefined;
    purchaseOrderExcludeFromWms?: boolean | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;
    defaultStockReceiptsToFullyReceived?: boolean | undefined;
    buyingSocietyCode?: string | undefined;
    buyingSocietyName?: string | undefined;
    lastModifiedByName?: string | undefined;
    creatingFirstStockReceiptForPO?: boolean | undefined;
    totalVolume?: number | undefined;

    constructor(data?: IStockReceiptHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalActualVolume = _data["totalActualVolume"];
            this.stockReceiptID = _data["stockReceiptID"];
            this.stockReceiptNumber = _data["stockReceiptNumber"];
            this.receiptStatus = _data["receiptStatus"];
            this.purchaseOrderID = _data["purchaseOrderID"];
            this.dateReceived = _data["dateReceived"] ? new Date(_data["dateReceived"].toString()) : <any>undefined;
            this.deliveryNoteNumber = _data["deliveryNoteNumber"];
            this.deliveryReference = _data["deliveryReference"];
            this.haulier = _data["haulier"];
            this.putAwayLocation = _data["putAwayLocation"];
            this.exchangeRate = _data["exchangeRate"];
            this.fixedExchangeRate = _data["fixedExchangeRate"];
            this.enteredInAdvance = _data["enteredInAdvance"];
            this.printed = _data["printed"];
            this.quantityReceived = _data["quantityReceived"];
            this.totalWeight = _data["totalWeight"];
            (<any>this).totalPackWeight = _data["totalPackWeight"];
            (<any>this).totalReceivedPackWeight = _data["totalReceivedPackWeight"];
            (<any>this).totalCostPrice = _data["totalCostPrice"];
            (<any>this).totalCostPriceInCurrency = _data["totalCostPriceInCurrency"];
            this.notes = _data["notes"];
            this.stockLocationID = _data["stockLocationID"];
            this.contractRef = _data["contractRef"];
            this.contractPeriod = _data["contractPeriod"];
            this.countryOfOriginID = _data["countryOfOriginID"];
            this.timberMill = _data["timberMill"];
            this.ship = _data["ship"];
            this.voyage = _data["voyage"];
            this.bolRef = _data["bolRef"];
            this.intrastatDeliveryTermsID = _data["intrastatDeliveryTermsID"];
            this.intrastatTransportModeID = _data["intrastatTransportModeID"];
            this.invoiced = _data["invoiced"];
            this.dateExpected = _data["dateExpected"] ? new Date(_data["dateExpected"].toString()) : <any>undefined;
            this.dateTimeInAdvanceRemoved = _data["dateTimeInAdvanceRemoved"] ? new Date(_data["dateTimeInAdvanceRemoved"].toString()) : <any>undefined;
            this.useNewAdditionalCostMode = _data["useNewAdditionalCostMode"];
            this.estimatedFreightInCurrency = _data["estimatedFreightInCurrency"];
            this.estimatedMiscInCurrency = _data["estimatedMiscInCurrency"];
            this.settlementAmountInCurrency = _data["settlementAmountInCurrency"];
            this.settlementDiscount = _data["settlementDiscount"];
            this.paymentTermsID = _data["paymentTermsID"];
            this.wmsTransNumber = _data["wmsTransNumber"];
            this.addingSupplierInvoiceID = _data["addingSupplierInvoiceID"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.orderType = _data["orderType"];
            this.typeOfPurchase = _data["typeOfPurchase"];
            this.supplierID = _data["supplierID"];
            this.buyingSocietyID = _data["buyingSocietyID"];
            this.originID = _data["originID"];
            this.currencyID = _data["currencyID"];
            this.poExchangeRate = _data["poExchangeRate"];
            this.poFixedExchangeRate = _data["poFixedExchangeRate"];
            this.poDeliveryBranchID = _data["poDeliveryBranchID"];
            this.poStockLocationID = _data["poStockLocationID"];
            this.poContractRef = _data["poContractRef"];
            this.poContractPeriod = _data["poContractPeriod"];
            this.poCountryOfOriginID = _data["poCountryOfOriginID"];
            this.poTimberMill = _data["poTimberMill"];
            this.poShip = _data["poShip"];
            this.poVoyage = _data["poVoyage"];
            this.pobolRef = _data["pobolRef"];
            this.poIntrastatDeliveryTermsID = _data["poIntrastatDeliveryTermsID"];
            this.poIntrastatTransportModeID = _data["poIntrastatTransportModeID"];
            this.poTransportInstructionID = _data["poTransportInstructionID"];
            this.vmiProgramID = _data["vmiProgramID"];
            this.poTotalCostPriceInCurrency = _data["poTotalCostPriceInCurrency"];
            this.purchaseOrderExcludeFromWms = _data["purchaseOrderExcludeFromWms"];
            this.supplierCode = _data["supplierCode"];
            this.supplierName = _data["supplierName"];
            this.defaultStockReceiptsToFullyReceived = _data["defaultStockReceiptsToFullyReceived"];
            this.buyingSocietyCode = _data["buyingSocietyCode"];
            this.buyingSocietyName = _data["buyingSocietyName"];
            this.lastModifiedByName = _data["lastModifiedByName"];
            this.creatingFirstStockReceiptForPO = _data["creatingFirstStockReceiptForPO"];
            this.totalVolume = _data["totalVolume"];
        }
    }

    static fromJS(data: any): StockReceiptHeader {
        data = typeof data === 'object' ? data : {};
        let result = new StockReceiptHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalActualVolume"] = this.totalActualVolume;
        data["stockReceiptID"] = this.stockReceiptID;
        data["stockReceiptNumber"] = this.stockReceiptNumber;
        data["receiptStatus"] = this.receiptStatus;
        data["purchaseOrderID"] = this.purchaseOrderID;
        data["dateReceived"] = this.dateReceived ? this.dateReceived.toISOString() : <any>undefined;
        data["deliveryNoteNumber"] = this.deliveryNoteNumber;
        data["deliveryReference"] = this.deliveryReference;
        data["haulier"] = this.haulier;
        data["putAwayLocation"] = this.putAwayLocation;
        data["exchangeRate"] = this.exchangeRate;
        data["fixedExchangeRate"] = this.fixedExchangeRate;
        data["enteredInAdvance"] = this.enteredInAdvance;
        data["printed"] = this.printed;
        data["quantityReceived"] = this.quantityReceived;
        data["totalWeight"] = this.totalWeight;
        data["totalPackWeight"] = this.totalPackWeight;
        data["totalReceivedPackWeight"] = this.totalReceivedPackWeight;
        data["totalCostPrice"] = this.totalCostPrice;
        data["totalCostPriceInCurrency"] = this.totalCostPriceInCurrency;
        data["notes"] = this.notes;
        data["stockLocationID"] = this.stockLocationID;
        data["contractRef"] = this.contractRef;
        data["contractPeriod"] = this.contractPeriod;
        data["countryOfOriginID"] = this.countryOfOriginID;
        data["timberMill"] = this.timberMill;
        data["ship"] = this.ship;
        data["voyage"] = this.voyage;
        data["bolRef"] = this.bolRef;
        data["intrastatDeliveryTermsID"] = this.intrastatDeliveryTermsID;
        data["intrastatTransportModeID"] = this.intrastatTransportModeID;
        data["invoiced"] = this.invoiced;
        data["dateExpected"] = this.dateExpected ? this.dateExpected.toISOString() : <any>undefined;
        data["dateTimeInAdvanceRemoved"] = this.dateTimeInAdvanceRemoved ? this.dateTimeInAdvanceRemoved.toISOString() : <any>undefined;
        data["useNewAdditionalCostMode"] = this.useNewAdditionalCostMode;
        data["estimatedFreightInCurrency"] = this.estimatedFreightInCurrency;
        data["estimatedMiscInCurrency"] = this.estimatedMiscInCurrency;
        data["settlementAmountInCurrency"] = this.settlementAmountInCurrency;
        data["settlementDiscount"] = this.settlementDiscount;
        data["paymentTermsID"] = this.paymentTermsID;
        data["wmsTransNumber"] = this.wmsTransNumber;
        data["addingSupplierInvoiceID"] = this.addingSupplierInvoiceID;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["orderType"] = this.orderType;
        data["typeOfPurchase"] = this.typeOfPurchase;
        data["supplierID"] = this.supplierID;
        data["buyingSocietyID"] = this.buyingSocietyID;
        data["originID"] = this.originID;
        data["currencyID"] = this.currencyID;
        data["poExchangeRate"] = this.poExchangeRate;
        data["poFixedExchangeRate"] = this.poFixedExchangeRate;
        data["poDeliveryBranchID"] = this.poDeliveryBranchID;
        data["poStockLocationID"] = this.poStockLocationID;
        data["poContractRef"] = this.poContractRef;
        data["poContractPeriod"] = this.poContractPeriod;
        data["poCountryOfOriginID"] = this.poCountryOfOriginID;
        data["poTimberMill"] = this.poTimberMill;
        data["poShip"] = this.poShip;
        data["poVoyage"] = this.poVoyage;
        data["pobolRef"] = this.pobolRef;
        data["poIntrastatDeliveryTermsID"] = this.poIntrastatDeliveryTermsID;
        data["poIntrastatTransportModeID"] = this.poIntrastatTransportModeID;
        data["poTransportInstructionID"] = this.poTransportInstructionID;
        data["vmiProgramID"] = this.vmiProgramID;
        data["poTotalCostPriceInCurrency"] = this.poTotalCostPriceInCurrency;
        data["purchaseOrderExcludeFromWms"] = this.purchaseOrderExcludeFromWms;
        data["supplierCode"] = this.supplierCode;
        data["supplierName"] = this.supplierName;
        data["defaultStockReceiptsToFullyReceived"] = this.defaultStockReceiptsToFullyReceived;
        data["buyingSocietyCode"] = this.buyingSocietyCode;
        data["buyingSocietyName"] = this.buyingSocietyName;
        data["lastModifiedByName"] = this.lastModifiedByName;
        data["creatingFirstStockReceiptForPO"] = this.creatingFirstStockReceiptForPO;
        data["totalVolume"] = this.totalVolume;
        return data; 
    }
}

export interface IStockReceiptHeader {
    totalActualVolume?: number | undefined;
    stockReceiptID?: number | undefined;
    stockReceiptNumber?: number | undefined;
    receiptStatus?: number | undefined;
    purchaseOrderID?: number | undefined;
    dateReceived?: Date | undefined;
    deliveryNoteNumber?: string | undefined;
    deliveryReference?: string | undefined;
    haulier?: string | undefined;
    putAwayLocation?: string | undefined;
    exchangeRate?: number | undefined;
    fixedExchangeRate?: boolean | undefined;
    enteredInAdvance?: boolean | undefined;
    printed?: boolean | undefined;
    quantityReceived?: number | undefined;
    totalWeight?: number | undefined;
    totalPackWeight?: number | undefined;
    totalReceivedPackWeight?: number | undefined;
    totalCostPrice?: number | undefined;
    totalCostPriceInCurrency?: number | undefined;
    notes?: string | undefined;
    stockLocationID?: number | undefined;
    contractRef?: string | undefined;
    contractPeriod?: string | undefined;
    countryOfOriginID?: number | undefined;
    timberMill?: string | undefined;
    ship?: string | undefined;
    voyage?: string | undefined;
    bolRef?: string | undefined;
    intrastatDeliveryTermsID?: number | undefined;
    intrastatTransportModeID?: number | undefined;
    invoiced?: boolean | undefined;
    dateExpected?: Date | undefined;
    dateTimeInAdvanceRemoved?: Date | undefined;
    useNewAdditionalCostMode?: boolean | undefined;
    estimatedFreightInCurrency?: number | undefined;
    estimatedMiscInCurrency?: number | undefined;
    settlementAmountInCurrency?: number | undefined;
    settlementDiscount?: number | undefined;
    paymentTermsID?: number | undefined;
    wmsTransNumber?: number | undefined;
    addingSupplierInvoiceID?: number | undefined;
    purchaseOrderNumber?: number | undefined;
    orderType?: number | undefined;
    typeOfPurchase?: number | undefined;
    supplierID?: number | undefined;
    buyingSocietyID?: number | undefined;
    originID?: number | undefined;
    currencyID?: number | undefined;
    poExchangeRate?: number | undefined;
    poFixedExchangeRate?: boolean | undefined;
    poDeliveryBranchID?: number | undefined;
    poStockLocationID?: number | undefined;
    poContractRef?: string | undefined;
    poContractPeriod?: string | undefined;
    poCountryOfOriginID?: number | undefined;
    poTimberMill?: string | undefined;
    poShip?: string | undefined;
    poVoyage?: string | undefined;
    pobolRef?: string | undefined;
    poIntrastatDeliveryTermsID?: number | undefined;
    poIntrastatTransportModeID?: number | undefined;
    poTransportInstructionID?: number | undefined;
    vmiProgramID?: number | undefined;
    poTotalCostPriceInCurrency?: number | undefined;
    purchaseOrderExcludeFromWms?: boolean | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;
    defaultStockReceiptsToFullyReceived?: boolean | undefined;
    buyingSocietyCode?: string | undefined;
    buyingSocietyName?: string | undefined;
    lastModifiedByName?: string | undefined;
    creatingFirstStockReceiptForPO?: boolean | undefined;
    totalVolume?: number | undefined;
}

export class StockReceiptLine implements IStockReceiptLine {
    colItems?: StockReceiptLineItems[] | undefined;
    colPacks?: StockReceiptPack[] | undefined;
    colReels?: StockReceipt_ProductReels[] | undefined;
    colBatchItems?: StockReceipt_ProductBatchItems[] | undefined;
    stockReceiptLineID?: number | undefined;
    stockReceiptID?: number | undefined;
    lineStatus?: number | undefined;
    stockBatchID?: number | undefined;
    purchaseOrderID?: number | undefined;
    purchaseOrderLineID?: number | undefined;
    productID?: number | undefined;
    quantityReceived?: number | undefined;
    quantityDetailed?: number | undefined;
    quantityUsed?: number | undefined;
    quantityInvoiced?: number | undefined;
    quantityReceivedOriginal?: number | undefined;
    amountOriginal?: number | undefined;
    addAmountOriginal?: number | undefined;
    manualAmountOriginal?: number | undefined;
    stockQuantityReceived?: number | undefined;
    markedAsFullyReceived?: boolean | undefined;
    fullyInvoiced?: boolean | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    noOfPacks?: number | undefined;
    noOfPackPieces?: number | undefined;
    totalPackWeight?: number | undefined;
    totalPackLength?: number | undefined;
    totalPackVolume?: number | undefined;
    notes?: string | undefined;
    splitLine?: boolean | undefined;
    stockUpdated?: boolean | undefined;
    invoiced?: boolean | undefined;
    skipUpdateAverageCostPrice?: boolean | undefined;
    prePaid?: boolean | undefined;
    binLocation?: string | undefined;
    perID?: number | undefined;
    unitCostPrice?: number | undefined;
    unitCostPriceInCurrency?: number | undefined;
    totalCostPrice?: number | undefined;
    totalCostPriceInCurrency?: number | undefined;
    totalAdditionalCost?: number | undefined;
    totalAdditionalCostInCurrency?: number | undefined;
    totalManualCost?: number | undefined;
    totalManualCostInCurrency?: number | undefined;
    amountOriginalInCurrency?: number | undefined;
    addAmountOriginalInCurrency?: number | undefined;
    manualAmountOriginalInCurrency?: number | undefined;
    deliveryCharge?: number | undefined;
    pendingActions?: number | undefined;
    pendingActionID?: number | undefined;
    pendingAdjustmentTransID?: number | undefined;
    averageCostUpdated?: boolean | undefined;
    settlementAmountInCurrency?: number | undefined;
    settlementAmount?: number | undefined;
    productBatchID?: number | undefined;
    productBatchStockLocationID?: number | undefined;
    productBatchReference?: string | undefined;
    productBatchBinLocation?: string | undefined;
    originalSettlementAmountInCurrency?: number | undefined;
    originalSettlementAmount?: number | undefined;
    productBatchOption?: number | undefined;
    totalReceivedPackWeight?: number | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    manualCode?: string | undefined;
    manualDescription?: string | undefined;
    orderLineQuantity?: number | undefined;
    orderLineQuantityReceived?: number | undefined;
    orderLineFullyReceived?: boolean | undefined;
    orderLineQuantityDetailed?: number | undefined;
    orderLineQuantityTally?: string | undefined;
    orderLineInputPerID?: number | undefined;
    orderLinePerID?: number | undefined;
    orderLineUnitCostPrice?: number | undefined;
    orderLineUnitCostPriceInCurrency?: number | undefined;
    unitWeight?: number | undefined;
    orderLineTotalCostPrice?: number | undefined;
    orderLineTotalCostPriceInCurrency?: number | undefined;
    orderLineTotalAdditionalCost?: number | undefined;
    orderLineDeliveryCharge?: number | undefined;
    orderLineTotalOptionCost?: number | undefined;
    orderLineTotalVolume?: number | undefined;
    orderLineTotalWeight?: number | undefined;
    orderLineTotalLength?: number | undefined;
    orderLineNoOfPieces?: number | undefined;
    orderLineManualThickness?: number | undefined;
    orderLineManualWidth?: number | undefined;
    actualNominalConversion?: number | undefined;
    orderLineOtherFlags?: number | undefined;
    orderLineNotes?: string | undefined;
    olid?: number | undefined;
    ohid?: number | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    productCode?: string | undefined;
    productDescription?: string | undefined;
    perRuleID?: number | undefined;
    productThickness?: number | undefined;
    productWidth?: number | undefined;
    productLength?: number | undefined;
    productWeight?: number | undefined;
    productWeighedWeight?: boolean | undefined;
    productUseReceivedWeight?: boolean | undefined;
    productImperial?: boolean | undefined;
    productTallyLengths?: string | undefined;
    productTallyLengthsPerID?: number | undefined;
    productAvailableWidths?: string | undefined;
    productStockControlByLength?: boolean | undefined;
    productMaterialGradeID?: number | undefined;
    productDefaultPiecesPerPack?: number | undefined;
    productEnvironmentalStatusID?: number | undefined;
    productStandardStock?: boolean | undefined;
    productSpecial?: boolean | undefined;
    dimension4?: number | undefined;
    dimension5?: number | undefined;
    productManufacturerCode?: string | undefined;
    materialCertTypeID?: number | undefined;
    certificateStatus?: number | undefined;
    weightPerID?: number | undefined;
    stockPerID?: number | undefined;
    poOurPackMark?: string | undefined;
    productBinLocation?: string | undefined;
    supplierProductCode?: string | undefined;
    quantityInvoicedMatched?: number | undefined;
    orderLineSpecialOrder?: boolean | undefined;
    productBatchTypeID?: number | undefined;
    productActualThickness?: number | undefined;
    productActualWidth?: number | undefined;
    totalActualVolume?: number | undefined;
    needsStockInformation?: boolean | undefined;
    noOfLoosePieces?: number | undefined;
    totalLooseWeight?: number | undefined;
    totalLooseLength?: number | undefined;
    totalLooseVolume?: number | undefined;
    totalLengthImperial?: number | undefined;
    totalVolumeImperial?: number | undefined;
    totalPackLengthImperial?: number | undefined;
    totalPackVolumeImperial?: number | undefined;
    totalLooseLengthImperial?: number | undefined;
    totalLooseVolumeImperial?: number | undefined;
    totalCostPriceWithoutCharges?: number | undefined;
    totalArea?: number | undefined;
    totalAreaImperial?: number | undefined;
    realTotalPackArea?: number | undefined;
    totalActualVolume2?: number | undefined;

    constructor(data?: IStockReceiptLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["colItems"])) {
                this.colItems = [] as any;
                for (let item of _data["colItems"])
                    this.colItems!.push(StockReceiptLineItems.fromJS(item));
            }
            if (Array.isArray(_data["colPacks"])) {
                this.colPacks = [] as any;
                for (let item of _data["colPacks"])
                    this.colPacks!.push(StockReceiptPack.fromJS(item));
            }
            if (Array.isArray(_data["colReels"])) {
                this.colReels = [] as any;
                for (let item of _data["colReels"])
                    this.colReels!.push(StockReceipt_ProductReels.fromJS(item));
            }
            if (Array.isArray(_data["colBatchItems"])) {
                this.colBatchItems = [] as any;
                for (let item of _data["colBatchItems"])
                    this.colBatchItems!.push(StockReceipt_ProductBatchItems.fromJS(item));
            }
            this.stockReceiptLineID = _data["stockReceiptLineID"];
            this.stockReceiptID = _data["stockReceiptID"];
            this.lineStatus = _data["lineStatus"];
            this.stockBatchID = _data["stockBatchID"];
            this.purchaseOrderID = _data["purchaseOrderID"];
            this.purchaseOrderLineID = _data["purchaseOrderLineID"];
            this.productID = _data["productID"];
            this.quantityReceived = _data["quantityReceived"];
            this.quantityDetailed = _data["quantityDetailed"];
            this.quantityUsed = _data["quantityUsed"];
            this.quantityInvoiced = _data["quantityInvoiced"];
            this.quantityReceivedOriginal = _data["quantityReceivedOriginal"];
            this.amountOriginal = _data["amountOriginal"];
            this.addAmountOriginal = _data["addAmountOriginal"];
            this.manualAmountOriginal = _data["manualAmountOriginal"];
            this.stockQuantityReceived = _data["stockQuantityReceived"];
            this.markedAsFullyReceived = _data["markedAsFullyReceived"];
            this.fullyInvoiced = _data["fullyInvoiced"];
            this.quantityTally = _data["quantityTally"];
            this.noOfPieces = _data["noOfPieces"];
            this.totalWeight = _data["totalWeight"];
            this.totalLength = _data["totalLength"];
            this.totalVolume = _data["totalVolume"];
            this.noOfPacks = _data["noOfPacks"];
            this.noOfPackPieces = _data["noOfPackPieces"];
            this.totalPackWeight = _data["totalPackWeight"];
            this.totalPackLength = _data["totalPackLength"];
            this.totalPackVolume = _data["totalPackVolume"];
            this.notes = _data["notes"];
            this.splitLine = _data["splitLine"];
            this.stockUpdated = _data["stockUpdated"];
            this.invoiced = _data["invoiced"];
            this.skipUpdateAverageCostPrice = _data["skipUpdateAverageCostPrice"];
            this.prePaid = _data["prePaid"];
            this.binLocation = _data["binLocation"];
            this.perID = _data["perID"];
            this.unitCostPrice = _data["unitCostPrice"];
            this.unitCostPriceInCurrency = _data["unitCostPriceInCurrency"];
            this.totalCostPrice = _data["totalCostPrice"];
            this.totalCostPriceInCurrency = _data["totalCostPriceInCurrency"];
            this.totalAdditionalCost = _data["totalAdditionalCost"];
            this.totalAdditionalCostInCurrency = _data["totalAdditionalCostInCurrency"];
            this.totalManualCost = _data["totalManualCost"];
            this.totalManualCostInCurrency = _data["totalManualCostInCurrency"];
            this.amountOriginalInCurrency = _data["amountOriginalInCurrency"];
            this.addAmountOriginalInCurrency = _data["addAmountOriginalInCurrency"];
            this.manualAmountOriginalInCurrency = _data["manualAmountOriginalInCurrency"];
            this.deliveryCharge = _data["deliveryCharge"];
            this.pendingActions = _data["pendingActions"];
            this.pendingActionID = _data["pendingActionID"];
            this.pendingAdjustmentTransID = _data["pendingAdjustmentTransID"];
            this.averageCostUpdated = _data["averageCostUpdated"];
            this.settlementAmountInCurrency = _data["settlementAmountInCurrency"];
            this.settlementAmount = _data["settlementAmount"];
            this.productBatchID = _data["productBatchID"];
            this.productBatchStockLocationID = _data["productBatchStockLocationID"];
            this.productBatchReference = _data["productBatchReference"];
            this.productBatchBinLocation = _data["productBatchBinLocation"];
            this.originalSettlementAmountInCurrency = _data["originalSettlementAmountInCurrency"];
            this.originalSettlementAmount = _data["originalSettlementAmount"];
            this.productBatchOption = _data["productBatchOption"];
            this.totalReceivedPackWeight = _data["totalReceivedPackWeight"];
            this.lineNumber = _data["lineNumber"];
            this.lineType = _data["lineType"];
            this.manualCode = _data["manualCode"];
            this.manualDescription = _data["manualDescription"];
            this.orderLineQuantity = _data["orderLineQuantity"];
            this.orderLineQuantityReceived = _data["orderLineQuantityReceived"];
            this.orderLineFullyReceived = _data["orderLineFullyReceived"];
            this.orderLineQuantityDetailed = _data["orderLineQuantityDetailed"];
            this.orderLineQuantityTally = _data["orderLineQuantityTally"];
            this.orderLineInputPerID = _data["orderLineInputPerID"];
            this.orderLinePerID = _data["orderLinePerID"];
            this.orderLineUnitCostPrice = _data["orderLineUnitCostPrice"];
            this.orderLineUnitCostPriceInCurrency = _data["orderLineUnitCostPriceInCurrency"];
            this.unitWeight = _data["unitWeight"];
            this.orderLineTotalCostPrice = _data["orderLineTotalCostPrice"];
            this.orderLineTotalCostPriceInCurrency = _data["orderLineTotalCostPriceInCurrency"];
            this.orderLineTotalAdditionalCost = _data["orderLineTotalAdditionalCost"];
            this.orderLineDeliveryCharge = _data["orderLineDeliveryCharge"];
            this.orderLineTotalOptionCost = _data["orderLineTotalOptionCost"];
            this.orderLineTotalVolume = _data["orderLineTotalVolume"];
            this.orderLineTotalWeight = _data["orderLineTotalWeight"];
            this.orderLineTotalLength = _data["orderLineTotalLength"];
            this.orderLineNoOfPieces = _data["orderLineNoOfPieces"];
            this.orderLineManualThickness = _data["orderLineManualThickness"];
            this.orderLineManualWidth = _data["orderLineManualWidth"];
            this.actualNominalConversion = _data["actualNominalConversion"];
            this.orderLineOtherFlags = _data["orderLineOtherFlags"];
            this.orderLineNotes = _data["orderLineNotes"];
            this.olid = _data["olid"];
            this.ohid = _data["ohid"];
            this.productType = _data["productType"];
            this.productSubType = _data["productSubType"];
            this.productCode = _data["productCode"];
            this.productDescription = _data["productDescription"];
            this.perRuleID = _data["perRuleID"];
            this.productThickness = _data["productThickness"];
            this.productWidth = _data["productWidth"];
            this.productLength = _data["productLength"];
            this.productWeight = _data["productWeight"];
            this.productWeighedWeight = _data["productWeighedWeight"];
            this.productUseReceivedWeight = _data["productUseReceivedWeight"];
            this.productImperial = _data["productImperial"];
            this.productTallyLengths = _data["productTallyLengths"];
            this.productTallyLengthsPerID = _data["productTallyLengthsPerID"];
            this.productAvailableWidths = _data["productAvailableWidths"];
            this.productStockControlByLength = _data["productStockControlByLength"];
            this.productMaterialGradeID = _data["productMaterialGradeID"];
            this.productDefaultPiecesPerPack = _data["productDefaultPiecesPerPack"];
            this.productEnvironmentalStatusID = _data["productEnvironmentalStatusID"];
            this.productStandardStock = _data["productStandardStock"];
            this.productSpecial = _data["productSpecial"];
            this.dimension4 = _data["dimension4"];
            this.dimension5 = _data["dimension5"];
            this.productManufacturerCode = _data["productManufacturerCode"];
            this.materialCertTypeID = _data["materialCertTypeID"];
            this.certificateStatus = _data["certificateStatus"];
            this.weightPerID = _data["weightPerID"];
            this.stockPerID = _data["stockPerID"];
            this.poOurPackMark = _data["poOurPackMark"];
            this.productBinLocation = _data["productBinLocation"];
            this.supplierProductCode = _data["supplierProductCode"];
            this.quantityInvoicedMatched = _data["quantityInvoicedMatched"];
            this.orderLineSpecialOrder = _data["orderLineSpecialOrder"];
            this.productBatchTypeID = _data["productBatchTypeID"];
            this.productActualThickness = _data["productActualThickness"];
            this.productActualWidth = _data["productActualWidth"];
            this.totalActualVolume = _data["totalActualVolume"];
            this.needsStockInformation = _data["needsStockInformation"];
            this.noOfLoosePieces = _data["noOfLoosePieces"];
            this.totalLooseWeight = _data["totalLooseWeight"];
            this.totalLooseLength = _data["totalLooseLength"];
            this.totalLooseVolume = _data["totalLooseVolume"];
            this.totalLengthImperial = _data["totalLengthImperial"];
            this.totalVolumeImperial = _data["totalVolumeImperial"];
            this.totalPackLengthImperial = _data["totalPackLengthImperial"];
            this.totalPackVolumeImperial = _data["totalPackVolumeImperial"];
            this.totalLooseLengthImperial = _data["totalLooseLengthImperial"];
            this.totalLooseVolumeImperial = _data["totalLooseVolumeImperial"];
            this.totalCostPriceWithoutCharges = _data["totalCostPriceWithoutCharges"];
            this.totalArea = _data["totalArea"];
            this.totalAreaImperial = _data["totalAreaImperial"];
            this.realTotalPackArea = _data["realTotalPackArea"];
            this.totalActualVolume2 = _data["totalActualVolume2"];
        }
    }

    static fromJS(data: any): StockReceiptLine {
        data = typeof data === 'object' ? data : {};
        let result = new StockReceiptLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.colItems)) {
            data["colItems"] = [];
            for (let item of this.colItems)
                data["colItems"].push(item.toJSON());
        }
        if (Array.isArray(this.colPacks)) {
            data["colPacks"] = [];
            for (let item of this.colPacks)
                data["colPacks"].push(item.toJSON());
        }
        if (Array.isArray(this.colReels)) {
            data["colReels"] = [];
            for (let item of this.colReels)
                data["colReels"].push(item.toJSON());
        }
        if (Array.isArray(this.colBatchItems)) {
            data["colBatchItems"] = [];
            for (let item of this.colBatchItems)
                data["colBatchItems"].push(item.toJSON());
        }
        data["stockReceiptLineID"] = this.stockReceiptLineID;
        data["stockReceiptID"] = this.stockReceiptID;
        data["lineStatus"] = this.lineStatus;
        data["stockBatchID"] = this.stockBatchID;
        data["purchaseOrderID"] = this.purchaseOrderID;
        data["purchaseOrderLineID"] = this.purchaseOrderLineID;
        data["productID"] = this.productID;
        data["quantityReceived"] = this.quantityReceived;
        data["quantityDetailed"] = this.quantityDetailed;
        data["quantityUsed"] = this.quantityUsed;
        data["quantityInvoiced"] = this.quantityInvoiced;
        data["quantityReceivedOriginal"] = this.quantityReceivedOriginal;
        data["amountOriginal"] = this.amountOriginal;
        data["addAmountOriginal"] = this.addAmountOriginal;
        data["manualAmountOriginal"] = this.manualAmountOriginal;
        data["stockQuantityReceived"] = this.stockQuantityReceived;
        data["markedAsFullyReceived"] = this.markedAsFullyReceived;
        data["fullyInvoiced"] = this.fullyInvoiced;
        data["quantityTally"] = this.quantityTally;
        data["noOfPieces"] = this.noOfPieces;
        data["totalWeight"] = this.totalWeight;
        data["totalLength"] = this.totalLength;
        data["totalVolume"] = this.totalVolume;
        data["noOfPacks"] = this.noOfPacks;
        data["noOfPackPieces"] = this.noOfPackPieces;
        data["totalPackWeight"] = this.totalPackWeight;
        data["totalPackLength"] = this.totalPackLength;
        data["totalPackVolume"] = this.totalPackVolume;
        data["notes"] = this.notes;
        data["splitLine"] = this.splitLine;
        data["stockUpdated"] = this.stockUpdated;
        data["invoiced"] = this.invoiced;
        data["skipUpdateAverageCostPrice"] = this.skipUpdateAverageCostPrice;
        data["prePaid"] = this.prePaid;
        data["binLocation"] = this.binLocation;
        data["perID"] = this.perID;
        data["unitCostPrice"] = this.unitCostPrice;
        data["unitCostPriceInCurrency"] = this.unitCostPriceInCurrency;
        data["totalCostPrice"] = this.totalCostPrice;
        data["totalCostPriceInCurrency"] = this.totalCostPriceInCurrency;
        data["totalAdditionalCost"] = this.totalAdditionalCost;
        data["totalAdditionalCostInCurrency"] = this.totalAdditionalCostInCurrency;
        data["totalManualCost"] = this.totalManualCost;
        data["totalManualCostInCurrency"] = this.totalManualCostInCurrency;
        data["amountOriginalInCurrency"] = this.amountOriginalInCurrency;
        data["addAmountOriginalInCurrency"] = this.addAmountOriginalInCurrency;
        data["manualAmountOriginalInCurrency"] = this.manualAmountOriginalInCurrency;
        data["deliveryCharge"] = this.deliveryCharge;
        data["pendingActions"] = this.pendingActions;
        data["pendingActionID"] = this.pendingActionID;
        data["pendingAdjustmentTransID"] = this.pendingAdjustmentTransID;
        data["averageCostUpdated"] = this.averageCostUpdated;
        data["settlementAmountInCurrency"] = this.settlementAmountInCurrency;
        data["settlementAmount"] = this.settlementAmount;
        data["productBatchID"] = this.productBatchID;
        data["productBatchStockLocationID"] = this.productBatchStockLocationID;
        data["productBatchReference"] = this.productBatchReference;
        data["productBatchBinLocation"] = this.productBatchBinLocation;
        data["originalSettlementAmountInCurrency"] = this.originalSettlementAmountInCurrency;
        data["originalSettlementAmount"] = this.originalSettlementAmount;
        data["productBatchOption"] = this.productBatchOption;
        data["totalReceivedPackWeight"] = this.totalReceivedPackWeight;
        data["lineNumber"] = this.lineNumber;
        data["lineType"] = this.lineType;
        data["manualCode"] = this.manualCode;
        data["manualDescription"] = this.manualDescription;
        data["orderLineQuantity"] = this.orderLineQuantity;
        data["orderLineQuantityReceived"] = this.orderLineQuantityReceived;
        data["orderLineFullyReceived"] = this.orderLineFullyReceived;
        data["orderLineQuantityDetailed"] = this.orderLineQuantityDetailed;
        data["orderLineQuantityTally"] = this.orderLineQuantityTally;
        data["orderLineInputPerID"] = this.orderLineInputPerID;
        data["orderLinePerID"] = this.orderLinePerID;
        data["orderLineUnitCostPrice"] = this.orderLineUnitCostPrice;
        data["orderLineUnitCostPriceInCurrency"] = this.orderLineUnitCostPriceInCurrency;
        data["unitWeight"] = this.unitWeight;
        data["orderLineTotalCostPrice"] = this.orderLineTotalCostPrice;
        data["orderLineTotalCostPriceInCurrency"] = this.orderLineTotalCostPriceInCurrency;
        data["orderLineTotalAdditionalCost"] = this.orderLineTotalAdditionalCost;
        data["orderLineDeliveryCharge"] = this.orderLineDeliveryCharge;
        data["orderLineTotalOptionCost"] = this.orderLineTotalOptionCost;
        data["orderLineTotalVolume"] = this.orderLineTotalVolume;
        data["orderLineTotalWeight"] = this.orderLineTotalWeight;
        data["orderLineTotalLength"] = this.orderLineTotalLength;
        data["orderLineNoOfPieces"] = this.orderLineNoOfPieces;
        data["orderLineManualThickness"] = this.orderLineManualThickness;
        data["orderLineManualWidth"] = this.orderLineManualWidth;
        data["actualNominalConversion"] = this.actualNominalConversion;
        data["orderLineOtherFlags"] = this.orderLineOtherFlags;
        data["orderLineNotes"] = this.orderLineNotes;
        data["olid"] = this.olid;
        data["ohid"] = this.ohid;
        data["productType"] = this.productType;
        data["productSubType"] = this.productSubType;
        data["productCode"] = this.productCode;
        data["productDescription"] = this.productDescription;
        data["perRuleID"] = this.perRuleID;
        data["productThickness"] = this.productThickness;
        data["productWidth"] = this.productWidth;
        data["productLength"] = this.productLength;
        data["productWeight"] = this.productWeight;
        data["productWeighedWeight"] = this.productWeighedWeight;
        data["productUseReceivedWeight"] = this.productUseReceivedWeight;
        data["productImperial"] = this.productImperial;
        data["productTallyLengths"] = this.productTallyLengths;
        data["productTallyLengthsPerID"] = this.productTallyLengthsPerID;
        data["productAvailableWidths"] = this.productAvailableWidths;
        data["productStockControlByLength"] = this.productStockControlByLength;
        data["productMaterialGradeID"] = this.productMaterialGradeID;
        data["productDefaultPiecesPerPack"] = this.productDefaultPiecesPerPack;
        data["productEnvironmentalStatusID"] = this.productEnvironmentalStatusID;
        data["productStandardStock"] = this.productStandardStock;
        data["productSpecial"] = this.productSpecial;
        data["dimension4"] = this.dimension4;
        data["dimension5"] = this.dimension5;
        data["productManufacturerCode"] = this.productManufacturerCode;
        data["materialCertTypeID"] = this.materialCertTypeID;
        data["certificateStatus"] = this.certificateStatus;
        data["weightPerID"] = this.weightPerID;
        data["stockPerID"] = this.stockPerID;
        data["poOurPackMark"] = this.poOurPackMark;
        data["productBinLocation"] = this.productBinLocation;
        data["supplierProductCode"] = this.supplierProductCode;
        data["quantityInvoicedMatched"] = this.quantityInvoicedMatched;
        data["orderLineSpecialOrder"] = this.orderLineSpecialOrder;
        data["productBatchTypeID"] = this.productBatchTypeID;
        data["productActualThickness"] = this.productActualThickness;
        data["productActualWidth"] = this.productActualWidth;
        data["totalActualVolume"] = this.totalActualVolume;
        data["needsStockInformation"] = this.needsStockInformation;
        data["noOfLoosePieces"] = this.noOfLoosePieces;
        data["totalLooseWeight"] = this.totalLooseWeight;
        data["totalLooseLength"] = this.totalLooseLength;
        data["totalLooseVolume"] = this.totalLooseVolume;
        data["totalLengthImperial"] = this.totalLengthImperial;
        data["totalVolumeImperial"] = this.totalVolumeImperial;
        data["totalPackLengthImperial"] = this.totalPackLengthImperial;
        data["totalPackVolumeImperial"] = this.totalPackVolumeImperial;
        data["totalLooseLengthImperial"] = this.totalLooseLengthImperial;
        data["totalLooseVolumeImperial"] = this.totalLooseVolumeImperial;
        data["totalCostPriceWithoutCharges"] = this.totalCostPriceWithoutCharges;
        data["totalArea"] = this.totalArea;
        data["totalAreaImperial"] = this.totalAreaImperial;
        data["realTotalPackArea"] = this.realTotalPackArea;
        data["totalActualVolume2"] = this.totalActualVolume2;
        return data; 
    }
}

export interface IStockReceiptLine {
    colItems?: StockReceiptLineItems[] | undefined;
    colPacks?: StockReceiptPack[] | undefined;
    colReels?: StockReceipt_ProductReels[] | undefined;
    colBatchItems?: StockReceipt_ProductBatchItems[] | undefined;
    stockReceiptLineID?: number | undefined;
    stockReceiptID?: number | undefined;
    lineStatus?: number | undefined;
    stockBatchID?: number | undefined;
    purchaseOrderID?: number | undefined;
    purchaseOrderLineID?: number | undefined;
    productID?: number | undefined;
    quantityReceived?: number | undefined;
    quantityDetailed?: number | undefined;
    quantityUsed?: number | undefined;
    quantityInvoiced?: number | undefined;
    quantityReceivedOriginal?: number | undefined;
    amountOriginal?: number | undefined;
    addAmountOriginal?: number | undefined;
    manualAmountOriginal?: number | undefined;
    stockQuantityReceived?: number | undefined;
    markedAsFullyReceived?: boolean | undefined;
    fullyInvoiced?: boolean | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    noOfPacks?: number | undefined;
    noOfPackPieces?: number | undefined;
    totalPackWeight?: number | undefined;
    totalPackLength?: number | undefined;
    totalPackVolume?: number | undefined;
    notes?: string | undefined;
    splitLine?: boolean | undefined;
    stockUpdated?: boolean | undefined;
    invoiced?: boolean | undefined;
    skipUpdateAverageCostPrice?: boolean | undefined;
    prePaid?: boolean | undefined;
    binLocation?: string | undefined;
    perID?: number | undefined;
    unitCostPrice?: number | undefined;
    unitCostPriceInCurrency?: number | undefined;
    totalCostPrice?: number | undefined;
    totalCostPriceInCurrency?: number | undefined;
    totalAdditionalCost?: number | undefined;
    totalAdditionalCostInCurrency?: number | undefined;
    totalManualCost?: number | undefined;
    totalManualCostInCurrency?: number | undefined;
    amountOriginalInCurrency?: number | undefined;
    addAmountOriginalInCurrency?: number | undefined;
    manualAmountOriginalInCurrency?: number | undefined;
    deliveryCharge?: number | undefined;
    pendingActions?: number | undefined;
    pendingActionID?: number | undefined;
    pendingAdjustmentTransID?: number | undefined;
    averageCostUpdated?: boolean | undefined;
    settlementAmountInCurrency?: number | undefined;
    settlementAmount?: number | undefined;
    productBatchID?: number | undefined;
    productBatchStockLocationID?: number | undefined;
    productBatchReference?: string | undefined;
    productBatchBinLocation?: string | undefined;
    originalSettlementAmountInCurrency?: number | undefined;
    originalSettlementAmount?: number | undefined;
    productBatchOption?: number | undefined;
    totalReceivedPackWeight?: number | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    manualCode?: string | undefined;
    manualDescription?: string | undefined;
    orderLineQuantity?: number | undefined;
    orderLineQuantityReceived?: number | undefined;
    orderLineFullyReceived?: boolean | undefined;
    orderLineQuantityDetailed?: number | undefined;
    orderLineQuantityTally?: string | undefined;
    orderLineInputPerID?: number | undefined;
    orderLinePerID?: number | undefined;
    orderLineUnitCostPrice?: number | undefined;
    orderLineUnitCostPriceInCurrency?: number | undefined;
    unitWeight?: number | undefined;
    orderLineTotalCostPrice?: number | undefined;
    orderLineTotalCostPriceInCurrency?: number | undefined;
    orderLineTotalAdditionalCost?: number | undefined;
    orderLineDeliveryCharge?: number | undefined;
    orderLineTotalOptionCost?: number | undefined;
    orderLineTotalVolume?: number | undefined;
    orderLineTotalWeight?: number | undefined;
    orderLineTotalLength?: number | undefined;
    orderLineNoOfPieces?: number | undefined;
    orderLineManualThickness?: number | undefined;
    orderLineManualWidth?: number | undefined;
    actualNominalConversion?: number | undefined;
    orderLineOtherFlags?: number | undefined;
    orderLineNotes?: string | undefined;
    olid?: number | undefined;
    ohid?: number | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    productCode?: string | undefined;
    productDescription?: string | undefined;
    perRuleID?: number | undefined;
    productThickness?: number | undefined;
    productWidth?: number | undefined;
    productLength?: number | undefined;
    productWeight?: number | undefined;
    productWeighedWeight?: boolean | undefined;
    productUseReceivedWeight?: boolean | undefined;
    productImperial?: boolean | undefined;
    productTallyLengths?: string | undefined;
    productTallyLengthsPerID?: number | undefined;
    productAvailableWidths?: string | undefined;
    productStockControlByLength?: boolean | undefined;
    productMaterialGradeID?: number | undefined;
    productDefaultPiecesPerPack?: number | undefined;
    productEnvironmentalStatusID?: number | undefined;
    productStandardStock?: boolean | undefined;
    productSpecial?: boolean | undefined;
    dimension4?: number | undefined;
    dimension5?: number | undefined;
    productManufacturerCode?: string | undefined;
    materialCertTypeID?: number | undefined;
    certificateStatus?: number | undefined;
    weightPerID?: number | undefined;
    stockPerID?: number | undefined;
    poOurPackMark?: string | undefined;
    productBinLocation?: string | undefined;
    supplierProductCode?: string | undefined;
    quantityInvoicedMatched?: number | undefined;
    orderLineSpecialOrder?: boolean | undefined;
    productBatchTypeID?: number | undefined;
    productActualThickness?: number | undefined;
    productActualWidth?: number | undefined;
    totalActualVolume?: number | undefined;
    needsStockInformation?: boolean | undefined;
    noOfLoosePieces?: number | undefined;
    totalLooseWeight?: number | undefined;
    totalLooseLength?: number | undefined;
    totalLooseVolume?: number | undefined;
    totalLengthImperial?: number | undefined;
    totalVolumeImperial?: number | undefined;
    totalPackLengthImperial?: number | undefined;
    totalPackVolumeImperial?: number | undefined;
    totalLooseLengthImperial?: number | undefined;
    totalLooseVolumeImperial?: number | undefined;
    totalCostPriceWithoutCharges?: number | undefined;
    totalArea?: number | undefined;
    totalAreaImperial?: number | undefined;
    realTotalPackArea?: number | undefined;
    totalActualVolume2?: number | undefined;
}

export class SupplierReturnHeader implements ISupplierReturnHeader {
    returnStatus?: number | undefined;
    supplierID?: number | undefined;
    stockReceiptID?: number | undefined;
    purchaseOrderID?: number | undefined;
    reasonID?: number | undefined;
    reference?: string | undefined;
    returnType?: number | undefined;
    returnAddressID?: number | undefined;
    returnAddress?: string | undefined;
    returnCity?: string | undefined;
    returnAreaID?: number | undefined;
    inspectionRequired?: boolean | undefined;
    dateInspected?: Date | undefined;
    inspectionNotes?: string | undefined;
    dateReturned?: string | undefined;
    returnedNotes?: string | undefined;
    completed?: boolean | undefined;
    creditNoteNumbers?: string | undefined;
    creditAmount?: number | undefined;
    completedNotes?: string | undefined;
    headerNotes?: string | undefined;
    notes?: string | undefined;
    totalWeight?: number | undefined;
    totalVolume?: number | undefined;
    currencyID?: number | undefined;
    exchangeRate?: number | undefined;
    postingDate?: Date | undefined;
    totalCost?: number | undefined;
    totalCostInCurrency?: number | undefined;
    createdFromCreditNoteID?: number | undefined;
    dateRequired?: Date | undefined;
    branchCode?: string | undefined;
    stockReceiptNumber?: number | undefined;
    purchaseOrderNumber?: number | undefined;
    reasonName?: string | undefined;
    returnAreaName?: string | undefined;
    journeyID?: number | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;
    orderID?: number | undefined;
    supplierReturnNumber?: number | undefined;
    branchID?: number | undefined;

    constructor(data?: ISupplierReturnHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.returnStatus = _data["returnStatus"];
            this.supplierID = _data["supplierID"];
            this.stockReceiptID = _data["stockReceiptID"];
            this.purchaseOrderID = _data["purchaseOrderID"];
            this.reasonID = _data["reasonID"];
            this.reference = _data["reference"];
            this.returnType = _data["returnType"];
            this.returnAddressID = _data["returnAddressID"];
            this.returnAddress = _data["returnAddress"];
            this.returnCity = _data["returnCity"];
            this.returnAreaID = _data["returnAreaID"];
            this.inspectionRequired = _data["inspectionRequired"];
            this.dateInspected = _data["dateInspected"] ? new Date(_data["dateInspected"].toString()) : <any>undefined;
            this.inspectionNotes = _data["inspectionNotes"];
            this.dateReturned = _data["dateReturned"];
            this.returnedNotes = _data["returnedNotes"];
            this.completed = _data["completed"];
            this.creditNoteNumbers = _data["creditNoteNumbers"];
            this.creditAmount = _data["creditAmount"];
            this.completedNotes = _data["completedNotes"];
            this.headerNotes = _data["headerNotes"];
            this.notes = _data["notes"];
            this.totalWeight = _data["totalWeight"];
            this.totalVolume = _data["totalVolume"];
            this.currencyID = _data["currencyID"];
            this.exchangeRate = _data["exchangeRate"];
            this.postingDate = _data["postingDate"] ? new Date(_data["postingDate"].toString()) : <any>undefined;
            this.totalCost = _data["totalCost"];
            this.totalCostInCurrency = _data["totalCostInCurrency"];
            this.createdFromCreditNoteID = _data["createdFromCreditNoteID"];
            this.dateRequired = _data["dateRequired"] ? new Date(_data["dateRequired"].toString()) : <any>undefined;
            this.branchCode = _data["branchCode"];
            this.stockReceiptNumber = _data["stockReceiptNumber"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.reasonName = _data["reasonName"];
            this.returnAreaName = _data["returnAreaName"];
            this.journeyID = _data["journeyID"];
            this.supplierCode = _data["supplierCode"];
            this.supplierName = _data["supplierName"];
            this.orderID = _data["orderID"];
            this.supplierReturnNumber = _data["supplierReturnNumber"];
            this.branchID = _data["branchID"];
        }
    }

    static fromJS(data: any): SupplierReturnHeader {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierReturnHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["returnStatus"] = this.returnStatus;
        data["supplierID"] = this.supplierID;
        data["stockReceiptID"] = this.stockReceiptID;
        data["purchaseOrderID"] = this.purchaseOrderID;
        data["reasonID"] = this.reasonID;
        data["reference"] = this.reference;
        data["returnType"] = this.returnType;
        data["returnAddressID"] = this.returnAddressID;
        data["returnAddress"] = this.returnAddress;
        data["returnCity"] = this.returnCity;
        data["returnAreaID"] = this.returnAreaID;
        data["inspectionRequired"] = this.inspectionRequired;
        data["dateInspected"] = this.dateInspected ? this.dateInspected.toISOString() : <any>undefined;
        data["inspectionNotes"] = this.inspectionNotes;
        data["dateReturned"] = this.dateReturned;
        data["returnedNotes"] = this.returnedNotes;
        data["completed"] = this.completed;
        data["creditNoteNumbers"] = this.creditNoteNumbers;
        data["creditAmount"] = this.creditAmount;
        data["completedNotes"] = this.completedNotes;
        data["headerNotes"] = this.headerNotes;
        data["notes"] = this.notes;
        data["totalWeight"] = this.totalWeight;
        data["totalVolume"] = this.totalVolume;
        data["currencyID"] = this.currencyID;
        data["exchangeRate"] = this.exchangeRate;
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["totalCost"] = this.totalCost;
        data["totalCostInCurrency"] = this.totalCostInCurrency;
        data["createdFromCreditNoteID"] = this.createdFromCreditNoteID;
        data["dateRequired"] = this.dateRequired ? this.dateRequired.toISOString() : <any>undefined;
        data["branchCode"] = this.branchCode;
        data["stockReceiptNumber"] = this.stockReceiptNumber;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["reasonName"] = this.reasonName;
        data["returnAreaName"] = this.returnAreaName;
        data["journeyID"] = this.journeyID;
        data["supplierCode"] = this.supplierCode;
        data["supplierName"] = this.supplierName;
        data["orderID"] = this.orderID;
        data["supplierReturnNumber"] = this.supplierReturnNumber;
        data["branchID"] = this.branchID;
        return data; 
    }
}

export interface ISupplierReturnHeader {
    returnStatus?: number | undefined;
    supplierID?: number | undefined;
    stockReceiptID?: number | undefined;
    purchaseOrderID?: number | undefined;
    reasonID?: number | undefined;
    reference?: string | undefined;
    returnType?: number | undefined;
    returnAddressID?: number | undefined;
    returnAddress?: string | undefined;
    returnCity?: string | undefined;
    returnAreaID?: number | undefined;
    inspectionRequired?: boolean | undefined;
    dateInspected?: Date | undefined;
    inspectionNotes?: string | undefined;
    dateReturned?: string | undefined;
    returnedNotes?: string | undefined;
    completed?: boolean | undefined;
    creditNoteNumbers?: string | undefined;
    creditAmount?: number | undefined;
    completedNotes?: string | undefined;
    headerNotes?: string | undefined;
    notes?: string | undefined;
    totalWeight?: number | undefined;
    totalVolume?: number | undefined;
    currencyID?: number | undefined;
    exchangeRate?: number | undefined;
    postingDate?: Date | undefined;
    totalCost?: number | undefined;
    totalCostInCurrency?: number | undefined;
    createdFromCreditNoteID?: number | undefined;
    dateRequired?: Date | undefined;
    branchCode?: string | undefined;
    stockReceiptNumber?: number | undefined;
    purchaseOrderNumber?: number | undefined;
    reasonName?: string | undefined;
    returnAreaName?: string | undefined;
    journeyID?: number | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;
    orderID?: number | undefined;
    supplierReturnNumber?: number | undefined;
    branchID?: number | undefined;
}

export class SupplierReturnLine implements ISupplierReturnLine {
    supplierReturnLineID?: number | undefined;
    supplierReturnID?: number | undefined;
    lineType?: number | undefined;
    lineStatus?: number | undefined;
    stockReceiptLineID?: number | undefined;
    purchaseOrderLineID?: number | undefined;
    productID?: number | undefined;
    quantity?: number | undefined;
    quantityCredited?: number | undefined;
    fullyCredited?: boolean | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    inputPerID?: number | undefined;
    stockPerConversion?: number | undefined;
    statsPerConversion?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    scrapped?: boolean | undefined;
    notes?: string | undefined;
    totalCost?: number | undefined;
    totalSettlementAmount?: number | undefined;
    creditNotExpected?: boolean | undefined;
    totalCostInCurrency?: number | undefined;
    totalSettlementAmountInCurrency?: number | undefined;
    stockCost?: number | undefined;
    stockCostInCurrency?: number | undefined;
    branchID?: number | undefined;
    unitCost?: number | undefined;
    unitCostInCurrency?: number | undefined;
    costPerID?: number | undefined;
    costPricingType?: number | undefined;
    createdFromCreditNoteLineID?: number | undefined;
    productCode?: string | undefined;
    productDescription?: string | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    perRuleID?: number | undefined;
    thickness?: number | undefined;
    width?: number | undefined;
    length?: number | undefined;
    imperial?: boolean | undefined;
    tallyLengths?: string | undefined;
    availableWidths?: string | undefined;
    tallyLengthsPerID?: number | undefined;
    stockControlByLength?: boolean | undefined;
    weight?: number | undefined;
    defaultPiecesPerPack?: number | undefined;
    defaultUnitSizePerID?: number | undefined;
    allowMultiplePersOnUnitSizes?: boolean | undefined;
    stockPerID?: number | undefined;
    statisticsPerID?: number | undefined;
    weightPerID?: number | undefined;
    srlQuantityReceived?: number | undefined;
    stockReceiptNumber?: number | undefined;
    srlQuantityTally?: string | undefined;
    branchName?: string | undefined;
    polQuantityReceived?: number | undefined;
    lineNumber?: number | undefined;
    unitWeight?: number | undefined;
    polQuantityTally?: string | undefined;
    manualCode?: string | undefined;
    manualDescription?: string | undefined;
    purchaseOrderNumber?: number | undefined;
    totalLengthImperial?: number | undefined;
    totalVolumeImperial?: number | undefined;
    useThisUnitCostPerID?: number | undefined;
    state?: number | undefined;
    colItems?: SupplierReturnsLineItems[] | undefined;

    constructor(data?: ISupplierReturnLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierReturnLineID = _data["supplierReturnLineID"];
            this.supplierReturnID = _data["supplierReturnID"];
            this.lineType = _data["lineType"];
            this.lineStatus = _data["lineStatus"];
            this.stockReceiptLineID = _data["stockReceiptLineID"];
            this.purchaseOrderLineID = _data["purchaseOrderLineID"];
            this.productID = _data["productID"];
            this.quantity = _data["quantity"];
            this.quantityCredited = _data["quantityCredited"];
            this.fullyCredited = _data["fullyCredited"];
            this.quantityTally = _data["quantityTally"];
            this.noOfPieces = _data["noOfPieces"];
            this.inputPerID = _data["inputPerID"];
            this.stockPerConversion = _data["stockPerConversion"];
            this.statsPerConversion = _data["statsPerConversion"];
            this.totalWeight = _data["totalWeight"];
            this.totalLength = _data["totalLength"];
            this.totalVolume = _data["totalVolume"];
            this.scrapped = _data["scrapped"];
            this.notes = _data["notes"];
            this.totalCost = _data["totalCost"];
            this.totalSettlementAmount = _data["totalSettlementAmount"];
            this.creditNotExpected = _data["creditNotExpected"];
            this.totalCostInCurrency = _data["totalCostInCurrency"];
            this.totalSettlementAmountInCurrency = _data["totalSettlementAmountInCurrency"];
            this.stockCost = _data["stockCost"];
            this.stockCostInCurrency = _data["stockCostInCurrency"];
            this.branchID = _data["branchID"];
            this.unitCost = _data["unitCost"];
            this.unitCostInCurrency = _data["unitCostInCurrency"];
            this.costPerID = _data["costPerID"];
            this.costPricingType = _data["costPricingType"];
            this.createdFromCreditNoteLineID = _data["createdFromCreditNoteLineID"];
            this.productCode = _data["productCode"];
            this.productDescription = _data["productDescription"];
            this.productType = _data["productType"];
            this.productSubType = _data["productSubType"];
            this.perRuleID = _data["perRuleID"];
            this.thickness = _data["thickness"];
            this.width = _data["width"];
            this.length = _data["length"];
            this.imperial = _data["imperial"];
            this.tallyLengths = _data["tallyLengths"];
            this.availableWidths = _data["availableWidths"];
            this.tallyLengthsPerID = _data["tallyLengthsPerID"];
            this.stockControlByLength = _data["stockControlByLength"];
            this.weight = _data["weight"];
            this.defaultPiecesPerPack = _data["defaultPiecesPerPack"];
            this.defaultUnitSizePerID = _data["defaultUnitSizePerID"];
            this.allowMultiplePersOnUnitSizes = _data["allowMultiplePersOnUnitSizes"];
            this.stockPerID = _data["stockPerID"];
            this.statisticsPerID = _data["statisticsPerID"];
            this.weightPerID = _data["weightPerID"];
            this.srlQuantityReceived = _data["srlQuantityReceived"];
            this.stockReceiptNumber = _data["stockReceiptNumber"];
            this.srlQuantityTally = _data["srlQuantityTally"];
            this.branchName = _data["branchName"];
            this.polQuantityReceived = _data["polQuantityReceived"];
            this.lineNumber = _data["lineNumber"];
            this.unitWeight = _data["unitWeight"];
            this.polQuantityTally = _data["polQuantityTally"];
            this.manualCode = _data["manualCode"];
            this.manualDescription = _data["manualDescription"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.totalLengthImperial = _data["totalLengthImperial"];
            this.totalVolumeImperial = _data["totalVolumeImperial"];
            this.useThisUnitCostPerID = _data["useThisUnitCostPerID"];
            this.state = _data["state"];
            if (Array.isArray(_data["colItems"])) {
                this.colItems = [] as any;
                for (let item of _data["colItems"])
                    this.colItems!.push(SupplierReturnsLineItems.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SupplierReturnLine {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierReturnLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierReturnLineID"] = this.supplierReturnLineID;
        data["supplierReturnID"] = this.supplierReturnID;
        data["lineType"] = this.lineType;
        data["lineStatus"] = this.lineStatus;
        data["stockReceiptLineID"] = this.stockReceiptLineID;
        data["purchaseOrderLineID"] = this.purchaseOrderLineID;
        data["productID"] = this.productID;
        data["quantity"] = this.quantity;
        data["quantityCredited"] = this.quantityCredited;
        data["fullyCredited"] = this.fullyCredited;
        data["quantityTally"] = this.quantityTally;
        data["noOfPieces"] = this.noOfPieces;
        data["inputPerID"] = this.inputPerID;
        data["stockPerConversion"] = this.stockPerConversion;
        data["statsPerConversion"] = this.statsPerConversion;
        data["totalWeight"] = this.totalWeight;
        data["totalLength"] = this.totalLength;
        data["totalVolume"] = this.totalVolume;
        data["scrapped"] = this.scrapped;
        data["notes"] = this.notes;
        data["totalCost"] = this.totalCost;
        data["totalSettlementAmount"] = this.totalSettlementAmount;
        data["creditNotExpected"] = this.creditNotExpected;
        data["totalCostInCurrency"] = this.totalCostInCurrency;
        data["totalSettlementAmountInCurrency"] = this.totalSettlementAmountInCurrency;
        data["stockCost"] = this.stockCost;
        data["stockCostInCurrency"] = this.stockCostInCurrency;
        data["branchID"] = this.branchID;
        data["unitCost"] = this.unitCost;
        data["unitCostInCurrency"] = this.unitCostInCurrency;
        data["costPerID"] = this.costPerID;
        data["costPricingType"] = this.costPricingType;
        data["createdFromCreditNoteLineID"] = this.createdFromCreditNoteLineID;
        data["productCode"] = this.productCode;
        data["productDescription"] = this.productDescription;
        data["productType"] = this.productType;
        data["productSubType"] = this.productSubType;
        data["perRuleID"] = this.perRuleID;
        data["thickness"] = this.thickness;
        data["width"] = this.width;
        data["length"] = this.length;
        data["imperial"] = this.imperial;
        data["tallyLengths"] = this.tallyLengths;
        data["availableWidths"] = this.availableWidths;
        data["tallyLengthsPerID"] = this.tallyLengthsPerID;
        data["stockControlByLength"] = this.stockControlByLength;
        data["weight"] = this.weight;
        data["defaultPiecesPerPack"] = this.defaultPiecesPerPack;
        data["defaultUnitSizePerID"] = this.defaultUnitSizePerID;
        data["allowMultiplePersOnUnitSizes"] = this.allowMultiplePersOnUnitSizes;
        data["stockPerID"] = this.stockPerID;
        data["statisticsPerID"] = this.statisticsPerID;
        data["weightPerID"] = this.weightPerID;
        data["srlQuantityReceived"] = this.srlQuantityReceived;
        data["stockReceiptNumber"] = this.stockReceiptNumber;
        data["srlQuantityTally"] = this.srlQuantityTally;
        data["branchName"] = this.branchName;
        data["polQuantityReceived"] = this.polQuantityReceived;
        data["lineNumber"] = this.lineNumber;
        data["unitWeight"] = this.unitWeight;
        data["polQuantityTally"] = this.polQuantityTally;
        data["manualCode"] = this.manualCode;
        data["manualDescription"] = this.manualDescription;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["totalLengthImperial"] = this.totalLengthImperial;
        data["totalVolumeImperial"] = this.totalVolumeImperial;
        data["useThisUnitCostPerID"] = this.useThisUnitCostPerID;
        data["state"] = this.state;
        if (Array.isArray(this.colItems)) {
            data["colItems"] = [];
            for (let item of this.colItems)
                data["colItems"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISupplierReturnLine {
    supplierReturnLineID?: number | undefined;
    supplierReturnID?: number | undefined;
    lineType?: number | undefined;
    lineStatus?: number | undefined;
    stockReceiptLineID?: number | undefined;
    purchaseOrderLineID?: number | undefined;
    productID?: number | undefined;
    quantity?: number | undefined;
    quantityCredited?: number | undefined;
    fullyCredited?: boolean | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    inputPerID?: number | undefined;
    stockPerConversion?: number | undefined;
    statsPerConversion?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    scrapped?: boolean | undefined;
    notes?: string | undefined;
    totalCost?: number | undefined;
    totalSettlementAmount?: number | undefined;
    creditNotExpected?: boolean | undefined;
    totalCostInCurrency?: number | undefined;
    totalSettlementAmountInCurrency?: number | undefined;
    stockCost?: number | undefined;
    stockCostInCurrency?: number | undefined;
    branchID?: number | undefined;
    unitCost?: number | undefined;
    unitCostInCurrency?: number | undefined;
    costPerID?: number | undefined;
    costPricingType?: number | undefined;
    createdFromCreditNoteLineID?: number | undefined;
    productCode?: string | undefined;
    productDescription?: string | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    perRuleID?: number | undefined;
    thickness?: number | undefined;
    width?: number | undefined;
    length?: number | undefined;
    imperial?: boolean | undefined;
    tallyLengths?: string | undefined;
    availableWidths?: string | undefined;
    tallyLengthsPerID?: number | undefined;
    stockControlByLength?: boolean | undefined;
    weight?: number | undefined;
    defaultPiecesPerPack?: number | undefined;
    defaultUnitSizePerID?: number | undefined;
    allowMultiplePersOnUnitSizes?: boolean | undefined;
    stockPerID?: number | undefined;
    statisticsPerID?: number | undefined;
    weightPerID?: number | undefined;
    srlQuantityReceived?: number | undefined;
    stockReceiptNumber?: number | undefined;
    srlQuantityTally?: string | undefined;
    branchName?: string | undefined;
    polQuantityReceived?: number | undefined;
    lineNumber?: number | undefined;
    unitWeight?: number | undefined;
    polQuantityTally?: string | undefined;
    manualCode?: string | undefined;
    manualDescription?: string | undefined;
    purchaseOrderNumber?: number | undefined;
    totalLengthImperial?: number | undefined;
    totalVolumeImperial?: number | undefined;
    useThisUnitCostPerID?: number | undefined;
    state?: number | undefined;
    colItems?: SupplierReturnsLineItems[] | undefined;
}

export class SupplierReturnsAddCostCharge implements ISupplierReturnsAddCostCharge {
    supplierReturnAddCostChargeID?: number | undefined;
    deleted?: number | undefined;
    supplierReturnID?: number | undefined;
    additionalCostChargeID?: number | undefined;
    supplierID?: number | undefined;
    reference?: string | undefined;
    currencyID?: number | undefined;
    estimateExchangeRate?: number | undefined;
    estimateCost?: number | undefined;
    estimateCostInCurrency?: number | undefined;
    estimatePercentEntered?: number | undefined;
    actualExchangeRate?: number | undefined;
    actualCost?: number | undefined;
    actualCostInCurrency?: number | undefined;
    costPriceValue?: number | undefined;
    costPriceValueType?: number | undefined;
    costProRateBy?: number | undefined;
    actualCharge?: number | undefined;
    chargePriceValue?: number | undefined;
    chargePriceValueType?: number | undefined;
    chargeProRateBy?: number | undefined;
    glCodePayable?: string | undefined;
    notes?: string | undefined;
    dateTimeCreated?: Date | undefined;
    invoiced?: boolean | undefined;
    description?: string | undefined;
    costCalcUseActualSize?: boolean | undefined;
    chargeCalcUseActualSize?: boolean | undefined;
    costApplyToExternalAVOs?: boolean | undefined;
    costPercentBasedOnSellPrice?: boolean | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;

    constructor(data?: ISupplierReturnsAddCostCharge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierReturnAddCostChargeID = _data["supplierReturnAddCostChargeID"];
            this.deleted = _data["deleted"];
            this.supplierReturnID = _data["supplierReturnID"];
            this.additionalCostChargeID = _data["additionalCostChargeID"];
            this.supplierID = _data["supplierID"];
            this.reference = _data["reference"];
            this.currencyID = _data["currencyID"];
            this.estimateExchangeRate = _data["estimateExchangeRate"];
            this.estimateCost = _data["estimateCost"];
            this.estimateCostInCurrency = _data["estimateCostInCurrency"];
            this.estimatePercentEntered = _data["estimatePercentEntered"];
            this.actualExchangeRate = _data["actualExchangeRate"];
            this.actualCost = _data["actualCost"];
            this.actualCostInCurrency = _data["actualCostInCurrency"];
            this.costPriceValue = _data["costPriceValue"];
            this.costPriceValueType = _data["costPriceValueType"];
            this.costProRateBy = _data["costProRateBy"];
            this.actualCharge = _data["actualCharge"];
            this.chargePriceValue = _data["chargePriceValue"];
            this.chargePriceValueType = _data["chargePriceValueType"];
            this.chargeProRateBy = _data["chargeProRateBy"];
            this.glCodePayable = _data["glCodePayable"];
            this.notes = _data["notes"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.invoiced = _data["invoiced"];
            this.description = _data["description"];
            this.costCalcUseActualSize = _data["costCalcUseActualSize"];
            this.chargeCalcUseActualSize = _data["chargeCalcUseActualSize"];
            this.costApplyToExternalAVOs = _data["costApplyToExternalAVOs"];
            this.costPercentBasedOnSellPrice = _data["costPercentBasedOnSellPrice"];
            this.supplierCode = _data["supplierCode"];
            this.supplierName = _data["supplierName"];
        }
    }

    static fromJS(data: any): SupplierReturnsAddCostCharge {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierReturnsAddCostCharge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierReturnAddCostChargeID"] = this.supplierReturnAddCostChargeID;
        data["deleted"] = this.deleted;
        data["supplierReturnID"] = this.supplierReturnID;
        data["additionalCostChargeID"] = this.additionalCostChargeID;
        data["supplierID"] = this.supplierID;
        data["reference"] = this.reference;
        data["currencyID"] = this.currencyID;
        data["estimateExchangeRate"] = this.estimateExchangeRate;
        data["estimateCost"] = this.estimateCost;
        data["estimateCostInCurrency"] = this.estimateCostInCurrency;
        data["estimatePercentEntered"] = this.estimatePercentEntered;
        data["actualExchangeRate"] = this.actualExchangeRate;
        data["actualCost"] = this.actualCost;
        data["actualCostInCurrency"] = this.actualCostInCurrency;
        data["costPriceValue"] = this.costPriceValue;
        data["costPriceValueType"] = this.costPriceValueType;
        data["costProRateBy"] = this.costProRateBy;
        data["actualCharge"] = this.actualCharge;
        data["chargePriceValue"] = this.chargePriceValue;
        data["chargePriceValueType"] = this.chargePriceValueType;
        data["chargeProRateBy"] = this.chargeProRateBy;
        data["glCodePayable"] = this.glCodePayable;
        data["notes"] = this.notes;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["invoiced"] = this.invoiced;
        data["description"] = this.description;
        data["costCalcUseActualSize"] = this.costCalcUseActualSize;
        data["chargeCalcUseActualSize"] = this.chargeCalcUseActualSize;
        data["costApplyToExternalAVOs"] = this.costApplyToExternalAVOs;
        data["costPercentBasedOnSellPrice"] = this.costPercentBasedOnSellPrice;
        data["supplierCode"] = this.supplierCode;
        data["supplierName"] = this.supplierName;
        return data; 
    }
}

export interface ISupplierReturnsAddCostCharge {
    supplierReturnAddCostChargeID?: number | undefined;
    deleted?: number | undefined;
    supplierReturnID?: number | undefined;
    additionalCostChargeID?: number | undefined;
    supplierID?: number | undefined;
    reference?: string | undefined;
    currencyID?: number | undefined;
    estimateExchangeRate?: number | undefined;
    estimateCost?: number | undefined;
    estimateCostInCurrency?: number | undefined;
    estimatePercentEntered?: number | undefined;
    actualExchangeRate?: number | undefined;
    actualCost?: number | undefined;
    actualCostInCurrency?: number | undefined;
    costPriceValue?: number | undefined;
    costPriceValueType?: number | undefined;
    costProRateBy?: number | undefined;
    actualCharge?: number | undefined;
    chargePriceValue?: number | undefined;
    chargePriceValueType?: number | undefined;
    chargeProRateBy?: number | undefined;
    glCodePayable?: string | undefined;
    notes?: string | undefined;
    dateTimeCreated?: Date | undefined;
    invoiced?: boolean | undefined;
    description?: string | undefined;
    costCalcUseActualSize?: boolean | undefined;
    chargeCalcUseActualSize?: boolean | undefined;
    costApplyToExternalAVOs?: boolean | undefined;
    costPercentBasedOnSellPrice?: boolean | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;
}

export class CustomerReturnHeader implements ICustomerReturnHeader {
    customerReturnID?: number | undefined;
    customerReturnNumber?: number | undefined;
    returnStatus?: number | undefined;
    branchID?: number | undefined;
    orderID?: number | undefined;
    customerID?: number | undefined;
    collectionAddressID?: number | undefined;
    collectionAddress?: string | undefined;
    collectionCity?: string | undefined;
    collectionAreaID?: number | undefined;
    collectionDate?: Date | undefined;
    reasonID?: number | undefined;
    dateReturned?: Date | undefined;
    headerNotes?: string | undefined;
    notes?: string | undefined;
    totalWeight?: number | undefined;
    totalVolume?: number | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    lastModifiedByID?: number | undefined;
    journeyID?: number | undefined;
    completed?: boolean | undefined;
    deleted?: number | undefined;

    constructor(data?: ICustomerReturnHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerReturnID = _data["customerReturnID"];
            this.customerReturnNumber = _data["customerReturnNumber"];
            this.returnStatus = _data["returnStatus"];
            this.branchID = _data["branchID"];
            this.orderID = _data["orderID"];
            this.customerID = _data["customerID"];
            this.collectionAddressID = _data["collectionAddressID"];
            this.collectionAddress = _data["collectionAddress"];
            this.collectionCity = _data["collectionCity"];
            this.collectionAreaID = _data["collectionAreaID"];
            this.collectionDate = _data["collectionDate"] ? new Date(_data["collectionDate"].toString()) : <any>undefined;
            this.reasonID = _data["reasonID"];
            this.dateReturned = _data["dateReturned"] ? new Date(_data["dateReturned"].toString()) : <any>undefined;
            this.headerNotes = _data["headerNotes"];
            this.notes = _data["notes"];
            this.totalWeight = _data["totalWeight"];
            this.totalVolume = _data["totalVolume"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.createdByID = _data["createdByID"];
            this.dateTimeLastModified = _data["dateTimeLastModified"] ? new Date(_data["dateTimeLastModified"].toString()) : <any>undefined;
            this.lastModifiedByID = _data["lastModifiedByID"];
            this.journeyID = _data["journeyID"];
            this.completed = _data["completed"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): CustomerReturnHeader {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerReturnHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerReturnID"] = this.customerReturnID;
        data["customerReturnNumber"] = this.customerReturnNumber;
        data["returnStatus"] = this.returnStatus;
        data["branchID"] = this.branchID;
        data["orderID"] = this.orderID;
        data["customerID"] = this.customerID;
        data["collectionAddressID"] = this.collectionAddressID;
        data["collectionAddress"] = this.collectionAddress;
        data["collectionCity"] = this.collectionCity;
        data["collectionAreaID"] = this.collectionAreaID;
        data["collectionDate"] = this.collectionDate ? this.collectionDate.toISOString() : <any>undefined;
        data["reasonID"] = this.reasonID;
        data["dateReturned"] = this.dateReturned ? this.dateReturned.toISOString() : <any>undefined;
        data["headerNotes"] = this.headerNotes;
        data["notes"] = this.notes;
        data["totalWeight"] = this.totalWeight;
        data["totalVolume"] = this.totalVolume;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["createdByID"] = this.createdByID;
        data["dateTimeLastModified"] = this.dateTimeLastModified ? this.dateTimeLastModified.toISOString() : <any>undefined;
        data["lastModifiedByID"] = this.lastModifiedByID;
        data["journeyID"] = this.journeyID;
        data["completed"] = this.completed;
        data["deleted"] = this.deleted;
        return data; 
    }
}

export interface ICustomerReturnHeader {
    customerReturnID?: number | undefined;
    customerReturnNumber?: number | undefined;
    returnStatus?: number | undefined;
    branchID?: number | undefined;
    orderID?: number | undefined;
    customerID?: number | undefined;
    collectionAddressID?: number | undefined;
    collectionAddress?: string | undefined;
    collectionCity?: string | undefined;
    collectionAreaID?: number | undefined;
    collectionDate?: Date | undefined;
    reasonID?: number | undefined;
    dateReturned?: Date | undefined;
    headerNotes?: string | undefined;
    notes?: string | undefined;
    totalWeight?: number | undefined;
    totalVolume?: number | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    lastModifiedByID?: number | undefined;
    journeyID?: number | undefined;
    completed?: boolean | undefined;
    deleted?: number | undefined;
}

export class CustomerReturnLine implements ICustomerReturnLine {
    customerReturnLineID?: number | undefined;
    customerReturnID?: number | undefined;
    branchID?: number | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    lineStatus?: number | undefined;
    orderLineID?: number | undefined;
    stockBatchID?: number | undefined;
    productID?: number | undefined;
    quantity?: number | undefined;
    quantityReturned?: number | undefined;
    quantityToSuspense?: number | undefined;
    quantityCredited?: number | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    inputPerID?: number | undefined;
    stockPerConversion?: number | undefined;
    statsPerConversion?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    notes?: string | undefined;
    branch?: Branch | undefined;
    orderLine?: OrderLine | undefined;
    per?: Per | undefined;
    product?: Product | undefined;

    constructor(data?: ICustomerReturnLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerReturnLineID = _data["customerReturnLineID"];
            this.customerReturnID = _data["customerReturnID"];
            this.branchID = _data["branchID"];
            this.lineNumber = _data["lineNumber"];
            this.lineType = _data["lineType"];
            this.lineStatus = _data["lineStatus"];
            this.orderLineID = _data["orderLineID"];
            this.stockBatchID = _data["stockBatchID"];
            this.productID = _data["productID"];
            this.quantity = _data["quantity"];
            this.quantityReturned = _data["quantityReturned"];
            this.quantityToSuspense = _data["quantityToSuspense"];
            this.quantityCredited = _data["quantityCredited"];
            this.quantityTally = _data["quantityTally"];
            this.noOfPieces = _data["noOfPieces"];
            this.inputPerID = _data["inputPerID"];
            this.stockPerConversion = _data["stockPerConversion"];
            this.statsPerConversion = _data["statsPerConversion"];
            this.totalWeight = _data["totalWeight"];
            this.totalLength = _data["totalLength"];
            this.totalVolume = _data["totalVolume"];
            this.notes = _data["notes"];
            this.branch = _data["branch"] ? Branch.fromJS(_data["branch"]) : <any>undefined;
            this.orderLine = _data["orderLine"] ? OrderLine.fromJS(_data["orderLine"]) : <any>undefined;
            this.per = _data["per"] ? Per.fromJS(_data["per"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerReturnLine {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerReturnLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerReturnLineID"] = this.customerReturnLineID;
        data["customerReturnID"] = this.customerReturnID;
        data["branchID"] = this.branchID;
        data["lineNumber"] = this.lineNumber;
        data["lineType"] = this.lineType;
        data["lineStatus"] = this.lineStatus;
        data["orderLineID"] = this.orderLineID;
        data["stockBatchID"] = this.stockBatchID;
        data["productID"] = this.productID;
        data["quantity"] = this.quantity;
        data["quantityReturned"] = this.quantityReturned;
        data["quantityToSuspense"] = this.quantityToSuspense;
        data["quantityCredited"] = this.quantityCredited;
        data["quantityTally"] = this.quantityTally;
        data["noOfPieces"] = this.noOfPieces;
        data["inputPerID"] = this.inputPerID;
        data["stockPerConversion"] = this.stockPerConversion;
        data["statsPerConversion"] = this.statsPerConversion;
        data["totalWeight"] = this.totalWeight;
        data["totalLength"] = this.totalLength;
        data["totalVolume"] = this.totalVolume;
        data["notes"] = this.notes;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["orderLine"] = this.orderLine ? this.orderLine.toJSON() : <any>undefined;
        data["per"] = this.per ? this.per.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICustomerReturnLine {
    customerReturnLineID?: number | undefined;
    customerReturnID?: number | undefined;
    branchID?: number | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    lineStatus?: number | undefined;
    orderLineID?: number | undefined;
    stockBatchID?: number | undefined;
    productID?: number | undefined;
    quantity?: number | undefined;
    quantityReturned?: number | undefined;
    quantityToSuspense?: number | undefined;
    quantityCredited?: number | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    inputPerID?: number | undefined;
    stockPerConversion?: number | undefined;
    statsPerConversion?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    notes?: string | undefined;
    branch?: Branch | undefined;
    orderLine?: OrderLine | undefined;
    per?: Per | undefined;
    product?: Product | undefined;
}

export class CustomerReturnLineItem implements ICustomerReturnLineItem {
    customerReturnLineItemID?: number | undefined;
    customerReturnID?: number | undefined;
    customerReturnLineID?: number | undefined;
    plateID?: number | undefined;
    packID?: number | undefined;
    productBatchID?: number | undefined;
    productBatchItemID?: number | undefined;
    productBatchQuantity?: number | undefined;
    productBatchQuantityPerID?: number | undefined;
    productBatchQuantityTally?: string | undefined;

    constructor(data?: ICustomerReturnLineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerReturnLineItemID = _data["customerReturnLineItemID"];
            this.customerReturnID = _data["customerReturnID"];
            this.customerReturnLineID = _data["customerReturnLineID"];
            this.plateID = _data["plateID"];
            this.packID = _data["packID"];
            this.productBatchID = _data["productBatchID"];
            this.productBatchItemID = _data["productBatchItemID"];
            this.productBatchQuantity = _data["productBatchQuantity"];
            this.productBatchQuantityPerID = _data["productBatchQuantityPerID"];
            this.productBatchQuantityTally = _data["productBatchQuantityTally"];
        }
    }

    static fromJS(data: any): CustomerReturnLineItem {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerReturnLineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerReturnLineItemID"] = this.customerReturnLineItemID;
        data["customerReturnID"] = this.customerReturnID;
        data["customerReturnLineID"] = this.customerReturnLineID;
        data["plateID"] = this.plateID;
        data["packID"] = this.packID;
        data["productBatchID"] = this.productBatchID;
        data["productBatchItemID"] = this.productBatchItemID;
        data["productBatchQuantity"] = this.productBatchQuantity;
        data["productBatchQuantityPerID"] = this.productBatchQuantityPerID;
        data["productBatchQuantityTally"] = this.productBatchQuantityTally;
        return data; 
    }
}

export interface ICustomerReturnLineItem {
    customerReturnLineItemID?: number | undefined;
    customerReturnID?: number | undefined;
    customerReturnLineID?: number | undefined;
    plateID?: number | undefined;
    packID?: number | undefined;
    productBatchID?: number | undefined;
    productBatchItemID?: number | undefined;
    productBatchQuantity?: number | undefined;
    productBatchQuantityPerID?: number | undefined;
    productBatchQuantityTally?: string | undefined;
}

export class CustomerAddress implements ICustomerAddress {
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    customerName?: string | undefined;

    constructor(data?: ICustomerAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.customerName = _data["customerName"];
        }
    }

    static fromJS(data: any): CustomerAddress {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["customerName"] = this.customerName;
        return data; 
    }
}

export interface ICustomerAddress {
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    customerName?: string | undefined;
}

export class JourneyHeader implements IJourneyHeader {
    journeyID?: number | undefined;
    journeyNumber?: number | undefined;
    reference?: string | undefined;
    worksOrderID?: number | undefined;
    status?: number | undefined;
    docType?: number | undefined;
    journeyDate?: Date | undefined;
    branchID?: number | undefined;
    vehicleID?: number | undefined;
    vehicleName?: string | undefined;
    vehicleTypeID?: number | undefined;
    vehicleTypeName?: string | undefined;
    driverID?: number | undefined;
    driverName?: string | undefined;
    keyedByDate?: boolean | undefined;
    vehicleDetails?: string | undefined;
    plannedStartDateTime?: Date | undefined;
    plannedFinishDateTime?: Date | undefined;
    dateTimeStarted?: Date | undefined;
    startMileage?: number | undefined;
    dateTimeFinished?: Date | undefined;
    finishMileage?: number | undefined;
    transportCost?: number | undefined;
    hasAddCostProrations?: boolean | undefined;
    applyTransportCostTo?: number | undefined;
    additionalCostChargeID?: number | undefined;
    supplierID?: number | undefined;
    notes?: string | undefined;
    totalWeight?: number | undefined;
    vehicleMaxWeight?: number | undefined;
    vehicleMaxVolume?: number | undefined;
    vehicleMaxWidth?: number | undefined;
    vehicleMaxLength?: number | undefined;
    totalVolume?: number | undefined;
    updateAccess?: boolean | undefined;
    noOfDrops?: number | undefined;
    noOfCollections?: number | undefined;
    noOfStops?: number | undefined;
    noOfPacks?: number | undefined;
    cutOffDateTime?: Date | undefined;
    deliveryAreaID?: number | undefined;
    lastModifiedByID?: number | undefined;
    markedAsFull?: boolean | undefined;
    truckVehicleID?: number | undefined;
    trailerVehicleID?: number | undefined;
    journeyForwardPlanningID?: number | undefined;
    optimizeRoutes?: boolean | undefined;
    plannedTimesSet?: boolean | undefined;
    trailerVehicleName?: string | undefined;
    truckName?: string | undefined;

    constructor(data?: IJourneyHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.journeyID = _data["journeyID"];
            this.journeyNumber = _data["journeyNumber"];
            this.reference = _data["reference"];
            this.worksOrderID = _data["worksOrderID"];
            this.status = _data["status"];
            this.docType = _data["docType"];
            this.journeyDate = _data["journeyDate"] ? new Date(_data["journeyDate"].toString()) : <any>undefined;
            this.branchID = _data["branchID"];
            this.vehicleID = _data["vehicleID"];
            this.vehicleName = _data["vehicleName"];
            this.vehicleTypeID = _data["vehicleTypeID"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.driverID = _data["driverID"];
            this.driverName = _data["driverName"];
            this.keyedByDate = _data["keyedByDate"];
            this.vehicleDetails = _data["vehicleDetails"];
            this.plannedStartDateTime = _data["plannedStartDateTime"] ? new Date(_data["plannedStartDateTime"].toString()) : <any>undefined;
            this.plannedFinishDateTime = _data["plannedFinishDateTime"] ? new Date(_data["plannedFinishDateTime"].toString()) : <any>undefined;
            this.dateTimeStarted = _data["dateTimeStarted"] ? new Date(_data["dateTimeStarted"].toString()) : <any>undefined;
            this.startMileage = _data["startMileage"];
            this.dateTimeFinished = _data["dateTimeFinished"] ? new Date(_data["dateTimeFinished"].toString()) : <any>undefined;
            this.finishMileage = _data["finishMileage"];
            this.transportCost = _data["transportCost"];
            this.hasAddCostProrations = _data["hasAddCostProrations"];
            this.applyTransportCostTo = _data["applyTransportCostTo"];
            this.additionalCostChargeID = _data["additionalCostChargeID"];
            this.supplierID = _data["supplierID"];
            this.notes = _data["notes"];
            this.totalWeight = _data["totalWeight"];
            this.vehicleMaxWeight = _data["vehicleMaxWeight"];
            this.vehicleMaxVolume = _data["vehicleMaxVolume"];
            this.vehicleMaxWidth = _data["vehicleMaxWidth"];
            this.vehicleMaxLength = _data["vehicleMaxLength"];
            this.totalVolume = _data["totalVolume"];
            this.updateAccess = _data["updateAccess"];
            this.noOfDrops = _data["noOfDrops"];
            this.noOfCollections = _data["noOfCollections"];
            this.noOfStops = _data["noOfStops"];
            this.noOfPacks = _data["noOfPacks"];
            this.cutOffDateTime = _data["cutOffDateTime"] ? new Date(_data["cutOffDateTime"].toString()) : <any>undefined;
            this.deliveryAreaID = _data["deliveryAreaID"];
            this.lastModifiedByID = _data["lastModifiedByID"];
            this.markedAsFull = _data["markedAsFull"];
            this.truckVehicleID = _data["truckVehicleID"];
            this.trailerVehicleID = _data["trailerVehicleID"];
            this.journeyForwardPlanningID = _data["journeyForwardPlanningID"];
            this.optimizeRoutes = _data["optimizeRoutes"];
            this.plannedTimesSet = _data["plannedTimesSet"];
            this.trailerVehicleName = _data["trailerVehicleName"];
            this.truckName = _data["truckName"];
        }
    }

    static fromJS(data: any): JourneyHeader {
        data = typeof data === 'object' ? data : {};
        let result = new JourneyHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["journeyID"] = this.journeyID;
        data["journeyNumber"] = this.journeyNumber;
        data["reference"] = this.reference;
        data["worksOrderID"] = this.worksOrderID;
        data["status"] = this.status;
        data["docType"] = this.docType;
        data["journeyDate"] = this.journeyDate ? this.journeyDate.toISOString() : <any>undefined;
        data["branchID"] = this.branchID;
        data["vehicleID"] = this.vehicleID;
        data["vehicleName"] = this.vehicleName;
        data["vehicleTypeID"] = this.vehicleTypeID;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["driverID"] = this.driverID;
        data["driverName"] = this.driverName;
        data["keyedByDate"] = this.keyedByDate;
        data["vehicleDetails"] = this.vehicleDetails;
        data["plannedStartDateTime"] = this.plannedStartDateTime ? this.plannedStartDateTime.toISOString() : <any>undefined;
        data["plannedFinishDateTime"] = this.plannedFinishDateTime ? this.plannedFinishDateTime.toISOString() : <any>undefined;
        data["dateTimeStarted"] = this.dateTimeStarted ? this.dateTimeStarted.toISOString() : <any>undefined;
        data["startMileage"] = this.startMileage;
        data["dateTimeFinished"] = this.dateTimeFinished ? this.dateTimeFinished.toISOString() : <any>undefined;
        data["finishMileage"] = this.finishMileage;
        data["transportCost"] = this.transportCost;
        data["hasAddCostProrations"] = this.hasAddCostProrations;
        data["applyTransportCostTo"] = this.applyTransportCostTo;
        data["additionalCostChargeID"] = this.additionalCostChargeID;
        data["supplierID"] = this.supplierID;
        data["notes"] = this.notes;
        data["totalWeight"] = this.totalWeight;
        data["vehicleMaxWeight"] = this.vehicleMaxWeight;
        data["vehicleMaxVolume"] = this.vehicleMaxVolume;
        data["vehicleMaxWidth"] = this.vehicleMaxWidth;
        data["vehicleMaxLength"] = this.vehicleMaxLength;
        data["totalVolume"] = this.totalVolume;
        data["updateAccess"] = this.updateAccess;
        data["noOfDrops"] = this.noOfDrops;
        data["noOfCollections"] = this.noOfCollections;
        data["noOfStops"] = this.noOfStops;
        data["noOfPacks"] = this.noOfPacks;
        data["cutOffDateTime"] = this.cutOffDateTime ? this.cutOffDateTime.toISOString() : <any>undefined;
        data["deliveryAreaID"] = this.deliveryAreaID;
        data["lastModifiedByID"] = this.lastModifiedByID;
        data["markedAsFull"] = this.markedAsFull;
        data["truckVehicleID"] = this.truckVehicleID;
        data["trailerVehicleID"] = this.trailerVehicleID;
        data["journeyForwardPlanningID"] = this.journeyForwardPlanningID;
        data["optimizeRoutes"] = this.optimizeRoutes;
        data["plannedTimesSet"] = this.plannedTimesSet;
        data["trailerVehicleName"] = this.trailerVehicleName;
        data["truckName"] = this.truckName;
        return data; 
    }
}

export interface IJourneyHeader {
    journeyID?: number | undefined;
    journeyNumber?: number | undefined;
    reference?: string | undefined;
    worksOrderID?: number | undefined;
    status?: number | undefined;
    docType?: number | undefined;
    journeyDate?: Date | undefined;
    branchID?: number | undefined;
    vehicleID?: number | undefined;
    vehicleName?: string | undefined;
    vehicleTypeID?: number | undefined;
    vehicleTypeName?: string | undefined;
    driverID?: number | undefined;
    driverName?: string | undefined;
    keyedByDate?: boolean | undefined;
    vehicleDetails?: string | undefined;
    plannedStartDateTime?: Date | undefined;
    plannedFinishDateTime?: Date | undefined;
    dateTimeStarted?: Date | undefined;
    startMileage?: number | undefined;
    dateTimeFinished?: Date | undefined;
    finishMileage?: number | undefined;
    transportCost?: number | undefined;
    hasAddCostProrations?: boolean | undefined;
    applyTransportCostTo?: number | undefined;
    additionalCostChargeID?: number | undefined;
    supplierID?: number | undefined;
    notes?: string | undefined;
    totalWeight?: number | undefined;
    vehicleMaxWeight?: number | undefined;
    vehicleMaxVolume?: number | undefined;
    vehicleMaxWidth?: number | undefined;
    vehicleMaxLength?: number | undefined;
    totalVolume?: number | undefined;
    updateAccess?: boolean | undefined;
    noOfDrops?: number | undefined;
    noOfCollections?: number | undefined;
    noOfStops?: number | undefined;
    noOfPacks?: number | undefined;
    cutOffDateTime?: Date | undefined;
    deliveryAreaID?: number | undefined;
    lastModifiedByID?: number | undefined;
    markedAsFull?: boolean | undefined;
    truckVehicleID?: number | undefined;
    trailerVehicleID?: number | undefined;
    journeyForwardPlanningID?: number | undefined;
    optimizeRoutes?: boolean | undefined;
    plannedTimesSet?: boolean | undefined;
    trailerVehicleName?: string | undefined;
    truckName?: string | undefined;
}

export class JourneyLine implements IJourneyLine {
    startTime?: Date | undefined;
    documentType?: JourneyLineDocumentType | undefined;
    endTime?: Date | undefined;
    journeyDate?: Date | undefined;
    journeyLineId?: number | undefined;
    scheduleId?: number | undefined;
    orderCashSale?: boolean | undefined;
    orderPicked?: number | undefined;
    orderDelivered?: number | undefined;
    orderProofOfDeliveryReturned?: number | undefined;
    stockIssued?: number | undefined;
    orderStatus?: number | undefined;
    orderSubStatus?: number | undefined;
    orderUseSimpleProcessing?: number | undefined;
    orderInvoiced?: number | undefined;
    customerID?: number | undefined;
    customerAddress?: CustomerAddress | undefined;
    customerName?: string | undefined;
    deliveryTime?: number | undefined;
    saleType?: number | undefined;
    hasAddCostProrations?: boolean | undefined;
    documentNumber?: number | undefined;
    docType?: JourneyLineDocType | undefined;
    deliveryCity?: string | undefined;
    viaBranchID?: number | undefined;
    viaBranchName?: string | undefined;
    toBranchID?: number | undefined;
    toBranchName?: string | undefined;
    documentID?: number | undefined;
    dblTotalWeight?: number | undefined;
    dblTotalVolume?: number | undefined;
    dblNoOfPacks?: number | undefined;
    dropIsCollection?: boolean | undefined;
    journeyID?: number | undefined;
    maximumWidth?: number | undefined;
    maximumLength?: number | undefined;
    issuingBranchId?: number | undefined;
    issuingBranchName?: string | undefined;
    dropNumber?: number | undefined;
    deliveryAddress1?: string | undefined;
    deliveryAddress2?: string | undefined;
    deliveryAddress3?: string | undefined;
    deliveryAddressCountry?: string | undefined;
    deliveryAddressID?: number | undefined;
    deliveryAddressCode?: string | undefined;
    deliveryAddressLongitude?: number | undefined;
    deliveryAddressLatitude?: number | undefined;
    branchId?: number | undefined;
    branchName?: string | undefined;
    deliveryAddress?: string | undefined;
    deliveryAreaName?: string | undefined;
    documentListType?: JourneyLineDocumentListType | undefined;
    supplierId?: number | undefined;
    supplierName?: string | undefined;
    creditNoteMarkedAsreturned?: boolean | undefined;
    properties?: Properties | undefined;

    constructor(data?: IJourneyLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.documentType = _data["documentType"];
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.journeyDate = _data["journeyDate"] ? new Date(_data["journeyDate"].toString()) : <any>undefined;
            this.journeyLineId = _data["journeyLineId"];
            this.scheduleId = _data["scheduleId"];
            this.orderCashSale = _data["orderCashSale"];
            this.orderPicked = _data["orderPicked"];
            this.orderDelivered = _data["orderDelivered"];
            this.orderProofOfDeliveryReturned = _data["orderProofOfDeliveryReturned"];
            this.stockIssued = _data["stockIssued"];
            this.orderStatus = _data["orderStatus"];
            this.orderSubStatus = _data["orderSubStatus"];
            this.orderUseSimpleProcessing = _data["orderUseSimpleProcessing"];
            this.orderInvoiced = _data["orderInvoiced"];
            this.customerID = _data["customerID"];
            this.customerAddress = _data["customerAddress"] ? CustomerAddress.fromJS(_data["customerAddress"]) : <any>undefined;
            this.customerName = _data["customerName"];
            this.deliveryTime = _data["deliveryTime"];
            this.saleType = _data["saleType"];
            this.hasAddCostProrations = _data["hasAddCostProrations"];
            this.documentNumber = _data["documentNumber"];
            this.docType = _data["docType"];
            this.deliveryCity = _data["deliveryCity"];
            this.viaBranchID = _data["viaBranchID"];
            this.viaBranchName = _data["viaBranchName"];
            this.toBranchID = _data["toBranchID"];
            this.toBranchName = _data["toBranchName"];
            this.documentID = _data["documentID"];
            this.dblTotalWeight = _data["dblTotalWeight"];
            this.dblTotalVolume = _data["dblTotalVolume"];
            this.dblNoOfPacks = _data["dblNoOfPacks"];
            this.dropIsCollection = _data["dropIsCollection"];
            this.journeyID = _data["journeyID"];
            this.maximumWidth = _data["maximumWidth"];
            this.maximumLength = _data["maximumLength"];
            this.issuingBranchId = _data["issuingBranchId"];
            this.issuingBranchName = _data["issuingBranchName"];
            this.dropNumber = _data["dropNumber"];
            this.deliveryAddress1 = _data["deliveryAddress1"];
            this.deliveryAddress2 = _data["deliveryAddress2"];
            this.deliveryAddress3 = _data["deliveryAddress3"];
            this.deliveryAddressCountry = _data["deliveryAddressCountry"];
            this.deliveryAddressID = _data["deliveryAddressID"];
            this.deliveryAddressCode = _data["deliveryAddressCode"];
            this.deliveryAddressLongitude = _data["deliveryAddressLongitude"];
            this.deliveryAddressLatitude = _data["deliveryAddressLatitude"];
            this.branchId = _data["branchId"];
            this.branchName = _data["branchName"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.deliveryAreaName = _data["deliveryAreaName"];
            this.documentListType = _data["documentListType"];
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            this.creditNoteMarkedAsreturned = _data["creditNoteMarkedAsreturned"];
            this.properties = _data["properties"] ? Properties.fromJS(_data["properties"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JourneyLine {
        data = typeof data === 'object' ? data : {};
        let result = new JourneyLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["journeyDate"] = this.journeyDate ? this.journeyDate.toISOString() : <any>undefined;
        data["journeyLineId"] = this.journeyLineId;
        data["scheduleId"] = this.scheduleId;
        data["orderCashSale"] = this.orderCashSale;
        data["orderPicked"] = this.orderPicked;
        data["orderDelivered"] = this.orderDelivered;
        data["orderProofOfDeliveryReturned"] = this.orderProofOfDeliveryReturned;
        data["stockIssued"] = this.stockIssued;
        data["orderStatus"] = this.orderStatus;
        data["orderSubStatus"] = this.orderSubStatus;
        data["orderUseSimpleProcessing"] = this.orderUseSimpleProcessing;
        data["orderInvoiced"] = this.orderInvoiced;
        data["customerID"] = this.customerID;
        data["customerAddress"] = this.customerAddress ? this.customerAddress.toJSON() : <any>undefined;
        data["customerName"] = this.customerName;
        data["deliveryTime"] = this.deliveryTime;
        data["saleType"] = this.saleType;
        data["hasAddCostProrations"] = this.hasAddCostProrations;
        data["documentNumber"] = this.documentNumber;
        data["docType"] = this.docType;
        data["deliveryCity"] = this.deliveryCity;
        data["viaBranchID"] = this.viaBranchID;
        data["viaBranchName"] = this.viaBranchName;
        data["toBranchID"] = this.toBranchID;
        data["toBranchName"] = this.toBranchName;
        data["documentID"] = this.documentID;
        data["dblTotalWeight"] = this.dblTotalWeight;
        data["dblTotalVolume"] = this.dblTotalVolume;
        data["dblNoOfPacks"] = this.dblNoOfPacks;
        data["dropIsCollection"] = this.dropIsCollection;
        data["journeyID"] = this.journeyID;
        data["maximumWidth"] = this.maximumWidth;
        data["maximumLength"] = this.maximumLength;
        data["issuingBranchId"] = this.issuingBranchId;
        data["issuingBranchName"] = this.issuingBranchName;
        data["dropNumber"] = this.dropNumber;
        data["deliveryAddress1"] = this.deliveryAddress1;
        data["deliveryAddress2"] = this.deliveryAddress2;
        data["deliveryAddress3"] = this.deliveryAddress3;
        data["deliveryAddressCountry"] = this.deliveryAddressCountry;
        data["deliveryAddressID"] = this.deliveryAddressID;
        data["deliveryAddressCode"] = this.deliveryAddressCode;
        data["deliveryAddressLongitude"] = this.deliveryAddressLongitude;
        data["deliveryAddressLatitude"] = this.deliveryAddressLatitude;
        data["branchId"] = this.branchId;
        data["branchName"] = this.branchName;
        data["deliveryAddress"] = this.deliveryAddress;
        data["deliveryAreaName"] = this.deliveryAreaName;
        data["documentListType"] = this.documentListType;
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["creditNoteMarkedAsreturned"] = this.creditNoteMarkedAsreturned;
        data["properties"] = this.properties ? this.properties.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IJourneyLine {
    startTime?: Date | undefined;
    documentType?: JourneyLineDocumentType | undefined;
    endTime?: Date | undefined;
    journeyDate?: Date | undefined;
    journeyLineId?: number | undefined;
    scheduleId?: number | undefined;
    orderCashSale?: boolean | undefined;
    orderPicked?: number | undefined;
    orderDelivered?: number | undefined;
    orderProofOfDeliveryReturned?: number | undefined;
    stockIssued?: number | undefined;
    orderStatus?: number | undefined;
    orderSubStatus?: number | undefined;
    orderUseSimpleProcessing?: number | undefined;
    orderInvoiced?: number | undefined;
    customerID?: number | undefined;
    customerAddress?: CustomerAddress | undefined;
    customerName?: string | undefined;
    deliveryTime?: number | undefined;
    saleType?: number | undefined;
    hasAddCostProrations?: boolean | undefined;
    documentNumber?: number | undefined;
    docType?: JourneyLineDocType | undefined;
    deliveryCity?: string | undefined;
    viaBranchID?: number | undefined;
    viaBranchName?: string | undefined;
    toBranchID?: number | undefined;
    toBranchName?: string | undefined;
    documentID?: number | undefined;
    dblTotalWeight?: number | undefined;
    dblTotalVolume?: number | undefined;
    dblNoOfPacks?: number | undefined;
    dropIsCollection?: boolean | undefined;
    journeyID?: number | undefined;
    maximumWidth?: number | undefined;
    maximumLength?: number | undefined;
    issuingBranchId?: number | undefined;
    issuingBranchName?: string | undefined;
    dropNumber?: number | undefined;
    deliveryAddress1?: string | undefined;
    deliveryAddress2?: string | undefined;
    deliveryAddress3?: string | undefined;
    deliveryAddressCountry?: string | undefined;
    deliveryAddressID?: number | undefined;
    deliveryAddressCode?: string | undefined;
    deliveryAddressLongitude?: number | undefined;
    deliveryAddressLatitude?: number | undefined;
    branchId?: number | undefined;
    branchName?: string | undefined;
    deliveryAddress?: string | undefined;
    deliveryAreaName?: string | undefined;
    documentListType?: JourneyLineDocumentListType | undefined;
    supplierId?: number | undefined;
    supplierName?: string | undefined;
    creditNoteMarkedAsreturned?: boolean | undefined;
    properties?: Properties | undefined;
}

export class OrderPayment implements IOrderPayment {
    cashDrawerCompleted?: boolean | undefined;
    orderPaymentID?: number | undefined;
    orderID?: number | undefined;
    deliveryNoteID?: number | undefined;
    creditNoteID?: number | undefined;
    accountsTransactionID?: number | undefined;
    splitFromOrderPaymentID?: number | undefined;
    orderLineID?: number | undefined;
    paymentDateTime?: Date | undefined;
    currencyID?: number | undefined;
    paymentMethodID?: number | undefined;
    amount?: number | undefined;
    amountInCurrency?: number | undefined;
    cashBackAmount?: number | undefined;
    cashBackAmountInCurrency?: number | undefined;
    additionalCardInfo?: string | undefined;
    cardNumber?: string | undefined;
    expiryDate?: string | undefined;
    cardSecurityCode?: string | undefined;
    issueNumber?: string | undefined;
    startDate?: string | undefined;
    cardholderPresent?: boolean | undefined;
    deposit?: boolean | undefined;
    cashOnDeliveryPayment?: boolean | undefined;
    reference?: string | undefined;
    details?: string | undefined;
    computerID?: number | undefined;
    userID?: number | undefined;
    authorisationCode?: string | undefined;
    billingHouseNoOrName?: string | undefined;
    billingPostalCode?: string | undefined;
    isElectronic?: boolean | undefined;
    isVoided?: boolean | undefined;
    isSettled?: boolean | undefined;
    forceFlag?: boolean | undefined;
    terminalCode?: string | undefined;
    settlementBatchNumber?: number | undefined;
    cardType?: string | undefined;
    cardName?: string | undefined;
    hostReference?: string | undefined;
    surchargeAmount?: number | undefined;
    traceNumber?: number | undefined;
    businessDate?: Date | undefined;
    processorBatchNumber?: number | undefined;
    debitNetworkCode?: string | undefined;
    authorisationDateTime?: Date | undefined;
    totalAuthorisedAmount?: number | undefined;
    dateTimeExported?: Date | undefined;
    electronicTransactionType?: number | undefined;
    electronicTransactionStatus?: number | undefined;
    merchantNumber?: string | undefined;
    receiptBranchID?: number | undefined;
    remainingAccountBalance?: number | undefined;
    deleted?: boolean | undefined;
    webTrackPaymentCode?: string | undefined;
    providerPaymentCode?: string | undefined;
    providerSecurityCode?: string | undefined;
    preAuthorised?: boolean | undefined;
    amountCollected?: number | undefined;
    amountCollectedInCurrency?: number | undefined;
    guaranteeCardNumber?: string | undefined;
    overriddenByID?: number | undefined;
    bankReconcilliationID?: number | undefined;
    cardOnFile?: boolean | undefined;
    electronicReceiptText?: string | undefined;
    electronicSaleType?: number | undefined;
    webTrackInstanceID?: number | undefined;
    promoCode?: string | undefined;
    tokenSerialNumber?: string | undefined;
    merchantReceipt?: string | undefined;
    customerReceipt?: string | undefined;
    departmentID?: number | undefined;
    paymentMethodName?: string | undefined;
    paymentType?: number | undefined;
    completedByID?: number | undefined;
    opWebTrackInstanceID?: number | undefined;
    webTrackInstanceID1?: number | undefined;
    orderSettlementFromWeb?: boolean | undefined;

    constructor(data?: IOrderPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cashDrawerCompleted = _data["cashDrawerCompleted"];
            this.orderPaymentID = _data["orderPaymentID"];
            this.orderID = _data["orderID"];
            this.deliveryNoteID = _data["deliveryNoteID"];
            this.creditNoteID = _data["creditNoteID"];
            this.accountsTransactionID = _data["accountsTransactionID"];
            this.splitFromOrderPaymentID = _data["splitFromOrderPaymentID"];
            this.orderLineID = _data["orderLineID"];
            this.paymentDateTime = _data["paymentDateTime"] ? new Date(_data["paymentDateTime"].toString()) : <any>undefined;
            this.currencyID = _data["currencyID"];
            this.paymentMethodID = _data["paymentMethodID"];
            this.amount = _data["amount"];
            this.amountInCurrency = _data["amountInCurrency"];
            this.cashBackAmount = _data["cashBackAmount"];
            this.cashBackAmountInCurrency = _data["cashBackAmountInCurrency"];
            this.additionalCardInfo = _data["additionalCardInfo"];
            this.cardNumber = _data["cardNumber"];
            this.expiryDate = _data["expiryDate"];
            this.cardSecurityCode = _data["cardSecurityCode"];
            this.issueNumber = _data["issueNumber"];
            this.startDate = _data["startDate"];
            this.cardholderPresent = _data["cardholderPresent"];
            this.deposit = _data["deposit"];
            this.cashOnDeliveryPayment = _data["cashOnDeliveryPayment"];
            this.reference = _data["reference"];
            this.details = _data["details"];
            this.computerID = _data["computerID"];
            this.userID = _data["userID"];
            this.authorisationCode = _data["authorisationCode"];
            this.billingHouseNoOrName = _data["billingHouseNoOrName"];
            this.billingPostalCode = _data["billingPostalCode"];
            this.isElectronic = _data["isElectronic"];
            this.isVoided = _data["isVoided"];
            this.isSettled = _data["isSettled"];
            this.forceFlag = _data["forceFlag"];
            this.terminalCode = _data["terminalCode"];
            this.settlementBatchNumber = _data["settlementBatchNumber"];
            this.cardType = _data["cardType"];
            this.cardName = _data["cardName"];
            this.hostReference = _data["hostReference"];
            this.surchargeAmount = _data["surchargeAmount"];
            this.traceNumber = _data["traceNumber"];
            this.businessDate = _data["businessDate"] ? new Date(_data["businessDate"].toString()) : <any>undefined;
            this.processorBatchNumber = _data["processorBatchNumber"];
            this.debitNetworkCode = _data["debitNetworkCode"];
            this.authorisationDateTime = _data["authorisationDateTime"] ? new Date(_data["authorisationDateTime"].toString()) : <any>undefined;
            this.totalAuthorisedAmount = _data["totalAuthorisedAmount"];
            this.dateTimeExported = _data["dateTimeExported"] ? new Date(_data["dateTimeExported"].toString()) : <any>undefined;
            this.electronicTransactionType = _data["electronicTransactionType"];
            this.electronicTransactionStatus = _data["electronicTransactionStatus"];
            this.merchantNumber = _data["merchantNumber"];
            this.receiptBranchID = _data["receiptBranchID"];
            this.remainingAccountBalance = _data["remainingAccountBalance"];
            this.deleted = _data["deleted"];
            this.webTrackPaymentCode = _data["webTrackPaymentCode"];
            this.providerPaymentCode = _data["providerPaymentCode"];
            this.providerSecurityCode = _data["providerSecurityCode"];
            this.preAuthorised = _data["preAuthorised"];
            this.amountCollected = _data["amountCollected"];
            this.amountCollectedInCurrency = _data["amountCollectedInCurrency"];
            this.guaranteeCardNumber = _data["guaranteeCardNumber"];
            this.overriddenByID = _data["overriddenByID"];
            this.bankReconcilliationID = _data["bankReconcilliationID"];
            this.cardOnFile = _data["cardOnFile"];
            this.electronicReceiptText = _data["electronicReceiptText"];
            this.electronicSaleType = _data["electronicSaleType"];
            this.webTrackInstanceID = _data["webTrackInstanceID"];
            this.promoCode = _data["promoCode"];
            this.tokenSerialNumber = _data["tokenSerialNumber"];
            this.merchantReceipt = _data["merchantReceipt"];
            this.customerReceipt = _data["customerReceipt"];
            this.departmentID = _data["departmentID"];
            this.paymentMethodName = _data["paymentMethodName"];
            this.paymentType = _data["paymentType"];
            this.completedByID = _data["completedByID"];
            this.opWebTrackInstanceID = _data["opWebTrackInstanceID"];
            this.webTrackInstanceID1 = _data["webTrackInstanceID1"];
            this.orderSettlementFromWeb = _data["orderSettlementFromWeb"];
        }
    }

    static fromJS(data: any): OrderPayment {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cashDrawerCompleted"] = this.cashDrawerCompleted;
        data["orderPaymentID"] = this.orderPaymentID;
        data["orderID"] = this.orderID;
        data["deliveryNoteID"] = this.deliveryNoteID;
        data["creditNoteID"] = this.creditNoteID;
        data["accountsTransactionID"] = this.accountsTransactionID;
        data["splitFromOrderPaymentID"] = this.splitFromOrderPaymentID;
        data["orderLineID"] = this.orderLineID;
        data["paymentDateTime"] = this.paymentDateTime ? this.paymentDateTime.toISOString() : <any>undefined;
        data["currencyID"] = this.currencyID;
        data["paymentMethodID"] = this.paymentMethodID;
        data["amount"] = this.amount;
        data["amountInCurrency"] = this.amountInCurrency;
        data["cashBackAmount"] = this.cashBackAmount;
        data["cashBackAmountInCurrency"] = this.cashBackAmountInCurrency;
        data["additionalCardInfo"] = this.additionalCardInfo;
        data["cardNumber"] = this.cardNumber;
        data["expiryDate"] = this.expiryDate;
        data["cardSecurityCode"] = this.cardSecurityCode;
        data["issueNumber"] = this.issueNumber;
        data["startDate"] = this.startDate;
        data["cardholderPresent"] = this.cardholderPresent;
        data["deposit"] = this.deposit;
        data["cashOnDeliveryPayment"] = this.cashOnDeliveryPayment;
        data["reference"] = this.reference;
        data["details"] = this.details;
        data["computerID"] = this.computerID;
        data["userID"] = this.userID;
        data["authorisationCode"] = this.authorisationCode;
        data["billingHouseNoOrName"] = this.billingHouseNoOrName;
        data["billingPostalCode"] = this.billingPostalCode;
        data["isElectronic"] = this.isElectronic;
        data["isVoided"] = this.isVoided;
        data["isSettled"] = this.isSettled;
        data["forceFlag"] = this.forceFlag;
        data["terminalCode"] = this.terminalCode;
        data["settlementBatchNumber"] = this.settlementBatchNumber;
        data["cardType"] = this.cardType;
        data["cardName"] = this.cardName;
        data["hostReference"] = this.hostReference;
        data["surchargeAmount"] = this.surchargeAmount;
        data["traceNumber"] = this.traceNumber;
        data["businessDate"] = this.businessDate ? this.businessDate.toISOString() : <any>undefined;
        data["processorBatchNumber"] = this.processorBatchNumber;
        data["debitNetworkCode"] = this.debitNetworkCode;
        data["authorisationDateTime"] = this.authorisationDateTime ? this.authorisationDateTime.toISOString() : <any>undefined;
        data["totalAuthorisedAmount"] = this.totalAuthorisedAmount;
        data["dateTimeExported"] = this.dateTimeExported ? this.dateTimeExported.toISOString() : <any>undefined;
        data["electronicTransactionType"] = this.electronicTransactionType;
        data["electronicTransactionStatus"] = this.electronicTransactionStatus;
        data["merchantNumber"] = this.merchantNumber;
        data["receiptBranchID"] = this.receiptBranchID;
        data["remainingAccountBalance"] = this.remainingAccountBalance;
        data["deleted"] = this.deleted;
        data["webTrackPaymentCode"] = this.webTrackPaymentCode;
        data["providerPaymentCode"] = this.providerPaymentCode;
        data["providerSecurityCode"] = this.providerSecurityCode;
        data["preAuthorised"] = this.preAuthorised;
        data["amountCollected"] = this.amountCollected;
        data["amountCollectedInCurrency"] = this.amountCollectedInCurrency;
        data["guaranteeCardNumber"] = this.guaranteeCardNumber;
        data["overriddenByID"] = this.overriddenByID;
        data["bankReconcilliationID"] = this.bankReconcilliationID;
        data["cardOnFile"] = this.cardOnFile;
        data["electronicReceiptText"] = this.electronicReceiptText;
        data["electronicSaleType"] = this.electronicSaleType;
        data["webTrackInstanceID"] = this.webTrackInstanceID;
        data["promoCode"] = this.promoCode;
        data["tokenSerialNumber"] = this.tokenSerialNumber;
        data["merchantReceipt"] = this.merchantReceipt;
        data["customerReceipt"] = this.customerReceipt;
        data["departmentID"] = this.departmentID;
        data["paymentMethodName"] = this.paymentMethodName;
        data["paymentType"] = this.paymentType;
        data["completedByID"] = this.completedByID;
        data["opWebTrackInstanceID"] = this.opWebTrackInstanceID;
        data["webTrackInstanceID1"] = this.webTrackInstanceID1;
        data["orderSettlementFromWeb"] = this.orderSettlementFromWeb;
        return data; 
    }
}

export interface IOrderPayment {
    cashDrawerCompleted?: boolean | undefined;
    orderPaymentID?: number | undefined;
    orderID?: number | undefined;
    deliveryNoteID?: number | undefined;
    creditNoteID?: number | undefined;
    accountsTransactionID?: number | undefined;
    splitFromOrderPaymentID?: number | undefined;
    orderLineID?: number | undefined;
    paymentDateTime?: Date | undefined;
    currencyID?: number | undefined;
    paymentMethodID?: number | undefined;
    amount?: number | undefined;
    amountInCurrency?: number | undefined;
    cashBackAmount?: number | undefined;
    cashBackAmountInCurrency?: number | undefined;
    additionalCardInfo?: string | undefined;
    cardNumber?: string | undefined;
    expiryDate?: string | undefined;
    cardSecurityCode?: string | undefined;
    issueNumber?: string | undefined;
    startDate?: string | undefined;
    cardholderPresent?: boolean | undefined;
    deposit?: boolean | undefined;
    cashOnDeliveryPayment?: boolean | undefined;
    reference?: string | undefined;
    details?: string | undefined;
    computerID?: number | undefined;
    userID?: number | undefined;
    authorisationCode?: string | undefined;
    billingHouseNoOrName?: string | undefined;
    billingPostalCode?: string | undefined;
    isElectronic?: boolean | undefined;
    isVoided?: boolean | undefined;
    isSettled?: boolean | undefined;
    forceFlag?: boolean | undefined;
    terminalCode?: string | undefined;
    settlementBatchNumber?: number | undefined;
    cardType?: string | undefined;
    cardName?: string | undefined;
    hostReference?: string | undefined;
    surchargeAmount?: number | undefined;
    traceNumber?: number | undefined;
    businessDate?: Date | undefined;
    processorBatchNumber?: number | undefined;
    debitNetworkCode?: string | undefined;
    authorisationDateTime?: Date | undefined;
    totalAuthorisedAmount?: number | undefined;
    dateTimeExported?: Date | undefined;
    electronicTransactionType?: number | undefined;
    electronicTransactionStatus?: number | undefined;
    merchantNumber?: string | undefined;
    receiptBranchID?: number | undefined;
    remainingAccountBalance?: number | undefined;
    deleted?: boolean | undefined;
    webTrackPaymentCode?: string | undefined;
    providerPaymentCode?: string | undefined;
    providerSecurityCode?: string | undefined;
    preAuthorised?: boolean | undefined;
    amountCollected?: number | undefined;
    amountCollectedInCurrency?: number | undefined;
    guaranteeCardNumber?: string | undefined;
    overriddenByID?: number | undefined;
    bankReconcilliationID?: number | undefined;
    cardOnFile?: boolean | undefined;
    electronicReceiptText?: string | undefined;
    electronicSaleType?: number | undefined;
    webTrackInstanceID?: number | undefined;
    promoCode?: string | undefined;
    tokenSerialNumber?: string | undefined;
    merchantReceipt?: string | undefined;
    customerReceipt?: string | undefined;
    departmentID?: number | undefined;
    paymentMethodName?: string | undefined;
    paymentType?: number | undefined;
    completedByID?: number | undefined;
    opWebTrackInstanceID?: number | undefined;
    webTrackInstanceID1?: number | undefined;
    orderSettlementFromWeb?: boolean | undefined;
}

export class Per implements IPer {
    perId?: number | undefined;
    perName?: string | undefined;
    perCode?: string | undefined;
    perType?: number | undefined;
    conversionToBase?: number | undefined;
    basePer?: boolean | undefined;
    systemDefined?: boolean | undefined;
    ediPerCode?: string | undefined;

    constructor(data?: IPer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.perId = _data["perId"];
            this.perName = _data["perName"];
            this.perCode = _data["perCode"];
            this.perType = _data["perType"];
            this.conversionToBase = _data["conversionToBase"];
            this.basePer = _data["basePer"];
            this.systemDefined = _data["systemDefined"];
            this.ediPerCode = _data["ediPerCode"];
        }
    }

    static fromJS(data: any): Per {
        data = typeof data === 'object' ? data : {};
        let result = new Per();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["perId"] = this.perId;
        data["perName"] = this.perName;
        data["perCode"] = this.perCode;
        data["perType"] = this.perType;
        data["conversionToBase"] = this.conversionToBase;
        data["basePer"] = this.basePer;
        data["systemDefined"] = this.systemDefined;
        data["ediPerCode"] = this.ediPerCode;
        return data; 
    }
}

export interface IPer {
    perId?: number | undefined;
    perName?: string | undefined;
    perCode?: string | undefined;
    perType?: number | undefined;
    conversionToBase?: number | undefined;
    basePer?: boolean | undefined;
    systemDefined?: boolean | undefined;
    ediPerCode?: string | undefined;
}

export class Product implements IProduct {
    productID?: number | undefined;
    deleted?: number | undefined;
    replacementID?: number | undefined;
    parentID?: number | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    perRuleID?: number | undefined;
    productCode?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
    manufacturerCode?: string | undefined;
    barCode?: string | undefined;
    intrastatCommodityCode?: string | undefined;
    informationURL?: string | undefined;
    coshhurl?: string | undefined;
    popupText?: string | undefined;
    alternativeKeywords?: string | undefined;
    notesEntered?: number | undefined;
    orderLineInternalNotes?: string | undefined;
    productGroupID?: number | undefined;
    steelGradeID?: number | undefined;
    timberGradeID?: number | undefined;
    materialGradeID?: number | undefined;
    imperial?: boolean | undefined;
    thickness?: number | undefined;
    width?: number | undefined;
    length?: number | undefined;
    dimension4?: number | undefined;
    dimension5?: number | undefined;
    dimension6?: number | undefined;
    weight?: number | undefined;
    weighedWeight?: boolean | undefined;
    weighedWeightAllowance?: number | undefined;
    testCertTypeID?: number | undefined;
    tallyLengths?: string | undefined;
    availableWidths?: string | undefined;
    defaultPiecesPerPack?: number | undefined;
    environmentalStatusID?: number | undefined;
    supplierID?: number | undefined;
    supplierAddressID?: number | undefined;
    standardStock?: boolean | undefined;
    keepStockFigures?: boolean | undefined;
    stockControlByLength?: boolean | undefined;
    stockLevelsByLength?: boolean | undefined;
    pickingRequired?: boolean | undefined;
    qaInspectionRequired?: boolean | undefined;
    ownBrandProduct?: boolean | undefined;
    vendorManagedInventory?: boolean | undefined;
    stockedByCost?: boolean | undefined;
    useActualCostForPacks?: boolean | undefined;
    packsAreTagged?: boolean | undefined;
    keepUntaggedPackRecords?: boolean | undefined;
    packPurchasing?: number | undefined;
    packSelling?: number | undefined;
    quantityPerInner?: number | undefined;
    quantityPerOuter?: number | undefined;
    quantityPerPallet?: number | undefined;
    barCodeInner?: string | undefined;
    barCodeOuter?: string | undefined;
    barCodePallet?: string | undefined;
    buyProductID?: number | undefined;
    standardBuyPrice?: number | undefined;
    buyPerID?: number | undefined;
    buyStockConversion?: number | undefined;
    buyPriceGroupID?: number | undefined;
    buyTaxGroupID?: number | undefined;
    purchaseAnalysisCodeID?: number | undefined;
    countryOfOriginID?: number | undefined;
    timberSurchargeID?: number | undefined;
    salesOrderTalliedInputScreen?: number | undefined;
    promptForTallyOnSalesOrder?: boolean | undefined;
    retrospectiveDiscountType?: number | undefined;
    retrospectiveDiscount?: number | undefined;
    buyingQuantityBreakID?: number | undefined;
    averageCostPrice?: number | undefined;
    averageCostPriceWithAdditional?: number | undefined;
    lastCostPrice?: number | undefined;
    lastCostPriceWithAdditional?: number | undefined;
    lastCostPerID?: number | undefined;
    lastCostPriceDateTime?: Date | undefined;
    internalCostPrice?: number | undefined;
    standardPurchase?: boolean | undefined;
    sellProductID?: number | undefined;
    standardSellPrice?: number | undefined;
    sellPerID?: number | undefined;
    sellPriceGroupID?: number | undefined;
    sellTaxGroupID?: number | undefined;
    salesAnalysisCodeID?: number | undefined;
    vatRuleID?: number | undefined;
    sellingQuantityBreakID?: number | undefined;
    lowMarginCollected?: number | undefined;
    lowMarginDelivered?: number | undefined;
    lowMarginDirect?: number | undefined;
    highMargin?: number | undefined;
    deliveryProductTypeID?: number | undefined;
    allowDirectSales?: boolean | undefined;
    allowCashSales?: boolean | undefined;
    allowSettlementDiscount?: boolean | undefined;
    applyDeliveryCharges?: boolean | undefined;
    promptForQuantityOnOrders?: boolean | undefined;
    allowDescriptionOverride?: number | undefined;
    allowPriceNegotiation?: boolean | undefined;
    allowCostOverride?: number | undefined;
    allowSpecialsBasedOnThis?: number | undefined;
    autoCreateSpecialFromThis?: number | undefined;
    useLastSellPriceIfNoRules?: boolean | undefined;
    sellPriceRounding?: number | undefined;
    sellPriceRoundingOption?: number | undefined;
    sellPriceRoundingPerID?: number | undefined;
    sellQuantityRoundingOption?: number | undefined;
    automaticLineChargeID?: number | undefined;
    automaticLineChargeMultiplier?: number | undefined;
    poAutomaticLineChargeID?: number | undefined;
    poAutomaticLineChargeMultiplier?: number | undefined;
    priceMarkingPerID?: number | undefined;
    priceMarkingConversion?: number | undefined;
    special?: boolean | undefined;
    specialSourceID?: number | undefined;
    nextSpecialSuffix?: number | undefined;
    buyBasedOnCount?: number | undefined;
    sellBasedOnCount?: number | undefined;
    externalLinkType?: number | undefined;
    pointsPerAmountSpentCollected?: number | undefined;
    pointsPerAmountSpentDelivered?: number | undefined;
    pointsPerAmountSpentDirect?: number | undefined;
    alternativeSupplierCount?: number | undefined;
    includeInWebTrack?: boolean | undefined;
    includeInWebTrackCashSales?: boolean | undefined;
    alwaysOrderStockBackToBack?: boolean | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    lastModifiedByID?: number | undefined;
    relatedProductCount?: number | undefined;
    promotionCodeTypeID?: number | undefined;
    defaultUnitSizePerID?: number | undefined;
    allowMultiplePersOnUnitSizes?: boolean | undefined;
    minManual?: boolean | undefined;
    maxManual?: boolean | undefined;
    cutToLengthStyle?: number | undefined;
    quickProductCaption?: string | undefined;
    roundUpToInnerOuterPallet?: number | undefined;
    copiedFromProductID?: number | undefined;
    lockSellPerToInputPer?: boolean | undefined;
    applyRebateAccruals?: boolean | undefined;
    productCatalogID?: number | undefined;
    parentChildDistribution?: number | undefined;
    tallyLengthDistribution?: string | undefined;
    nextBillOfMaterialSuffix?: number | undefined;
    quantityPerCube?: number | undefined;
    defaultGLCode?: string | undefined;
    tallyLengthsPerID?: number | undefined;
    widthGrossingRule?: number | undefined;
    lengthGrossingRule?: number | undefined;
    onlyApplyQtyBreakOnSellPerMatch?: boolean | undefined;
    warningText?: string | undefined;
    useReceivedWeight?: boolean | undefined;
    udfExportToMarginMaster?: boolean | undefined;
    udfCheckBoxTest?: boolean | undefined;
    udf86005YN?: boolean | undefined;
    udfobject?: number | undefined;
    udfSeason?: string | undefined;
    udfExportToDIB?: boolean | undefined;
    udfMarketCostSourceTag?: string | undefined;
    udfMarketCostAdderPct?: number | undefined;
    udfMarketCostAdderAmt1?: number | undefined;
    udfMarketCostAdderAmt2?: number | undefined;
    udfMarketCostAdderAmt3?: number | undefined;
    udfMarketCostAdderAmt4?: number | undefined;
    udfMarketCostAdderAmt5?: number | undefined;
    udfLMTestudfonproduct?: string | undefined;
    udfStockedDate?: Date | undefined;
    udfSKU?: string | undefined;
    udfExportToLuxwood?: boolean | undefined;
    udfDiscontinued?: boolean | undefined;
    udfWebTrackTest?: string | undefined;
    productImages?: ProductImage[] | undefined;
    stocks?: Stock[] | undefined;
    productStockOptions?: ProductStockOption[] | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productID = _data["productID"];
            this.deleted = _data["deleted"];
            this.replacementID = _data["replacementID"];
            this.parentID = _data["parentID"];
            this.productType = _data["productType"];
            this.productSubType = _data["productSubType"];
            this.perRuleID = _data["perRuleID"];
            this.productCode = _data["productCode"];
            this.description = _data["description"];
            this.shortDescription = _data["shortDescription"];
            this.fullDescription = _data["fullDescription"];
            this.manufacturerCode = _data["manufacturerCode"];
            this.barCode = _data["barCode"];
            this.intrastatCommodityCode = _data["intrastatCommodityCode"];
            this.informationURL = _data["informationURL"];
            this.coshhurl = _data["coshhurl"];
            this.popupText = _data["popupText"];
            this.alternativeKeywords = _data["alternativeKeywords"];
            this.notesEntered = _data["notesEntered"];
            this.orderLineInternalNotes = _data["orderLineInternalNotes"];
            this.productGroupID = _data["productGroupID"];
            this.steelGradeID = _data["steelGradeID"];
            this.timberGradeID = _data["timberGradeID"];
            this.materialGradeID = _data["materialGradeID"];
            this.imperial = _data["imperial"];
            this.thickness = _data["thickness"];
            this.width = _data["width"];
            this.length = _data["length"];
            this.dimension4 = _data["dimension4"];
            this.dimension5 = _data["dimension5"];
            this.dimension6 = _data["dimension6"];
            this.weight = _data["weight"];
            this.weighedWeight = _data["weighedWeight"];
            this.weighedWeightAllowance = _data["weighedWeightAllowance"];
            this.testCertTypeID = _data["testCertTypeID"];
            this.tallyLengths = _data["tallyLengths"];
            this.availableWidths = _data["availableWidths"];
            this.defaultPiecesPerPack = _data["defaultPiecesPerPack"];
            this.environmentalStatusID = _data["environmentalStatusID"];
            this.supplierID = _data["supplierID"];
            this.supplierAddressID = _data["supplierAddressID"];
            this.standardStock = _data["standardStock"];
            this.keepStockFigures = _data["keepStockFigures"];
            this.stockControlByLength = _data["stockControlByLength"];
            this.stockLevelsByLength = _data["stockLevelsByLength"];
            this.pickingRequired = _data["pickingRequired"];
            this.qaInspectionRequired = _data["qaInspectionRequired"];
            this.ownBrandProduct = _data["ownBrandProduct"];
            this.vendorManagedInventory = _data["vendorManagedInventory"];
            this.stockedByCost = _data["stockedByCost"];
            this.useActualCostForPacks = _data["useActualCostForPacks"];
            this.packsAreTagged = _data["packsAreTagged"];
            this.keepUntaggedPackRecords = _data["keepUntaggedPackRecords"];
            this.packPurchasing = _data["packPurchasing"];
            this.packSelling = _data["packSelling"];
            this.quantityPerInner = _data["quantityPerInner"];
            this.quantityPerOuter = _data["quantityPerOuter"];
            this.quantityPerPallet = _data["quantityPerPallet"];
            this.barCodeInner = _data["barCodeInner"];
            this.barCodeOuter = _data["barCodeOuter"];
            this.barCodePallet = _data["barCodePallet"];
            this.buyProductID = _data["buyProductID"];
            this.standardBuyPrice = _data["standardBuyPrice"];
            this.buyPerID = _data["buyPerID"];
            this.buyStockConversion = _data["buyStockConversion"];
            this.buyPriceGroupID = _data["buyPriceGroupID"];
            this.buyTaxGroupID = _data["buyTaxGroupID"];
            this.purchaseAnalysisCodeID = _data["purchaseAnalysisCodeID"];
            this.countryOfOriginID = _data["countryOfOriginID"];
            this.timberSurchargeID = _data["timberSurchargeID"];
            this.salesOrderTalliedInputScreen = _data["salesOrderTalliedInputScreen"];
            this.promptForTallyOnSalesOrder = _data["promptForTallyOnSalesOrder"];
            this.retrospectiveDiscountType = _data["retrospectiveDiscountType"];
            this.retrospectiveDiscount = _data["retrospectiveDiscount"];
            this.buyingQuantityBreakID = _data["buyingQuantityBreakID"];
            this.averageCostPrice = _data["averageCostPrice"];
            this.averageCostPriceWithAdditional = _data["averageCostPriceWithAdditional"];
            this.lastCostPrice = _data["lastCostPrice"];
            this.lastCostPriceWithAdditional = _data["lastCostPriceWithAdditional"];
            this.lastCostPerID = _data["lastCostPerID"];
            this.lastCostPriceDateTime = _data["lastCostPriceDateTime"] ? new Date(_data["lastCostPriceDateTime"].toString()) : <any>undefined;
            this.internalCostPrice = _data["internalCostPrice"];
            this.standardPurchase = _data["standardPurchase"];
            this.sellProductID = _data["sellProductID"];
            this.standardSellPrice = _data["standardSellPrice"];
            this.sellPerID = _data["sellPerID"];
            this.sellPriceGroupID = _data["sellPriceGroupID"];
            this.sellTaxGroupID = _data["sellTaxGroupID"];
            this.salesAnalysisCodeID = _data["salesAnalysisCodeID"];
            this.vatRuleID = _data["vatRuleID"];
            this.sellingQuantityBreakID = _data["sellingQuantityBreakID"];
            this.lowMarginCollected = _data["lowMarginCollected"];
            this.lowMarginDelivered = _data["lowMarginDelivered"];
            this.lowMarginDirect = _data["lowMarginDirect"];
            this.highMargin = _data["highMargin"];
            this.deliveryProductTypeID = _data["deliveryProductTypeID"];
            this.allowDirectSales = _data["allowDirectSales"];
            this.allowCashSales = _data["allowCashSales"];
            this.allowSettlementDiscount = _data["allowSettlementDiscount"];
            this.applyDeliveryCharges = _data["applyDeliveryCharges"];
            this.promptForQuantityOnOrders = _data["promptForQuantityOnOrders"];
            this.allowDescriptionOverride = _data["allowDescriptionOverride"];
            this.allowPriceNegotiation = _data["allowPriceNegotiation"];
            this.allowCostOverride = _data["allowCostOverride"];
            this.allowSpecialsBasedOnThis = _data["allowSpecialsBasedOnThis"];
            this.autoCreateSpecialFromThis = _data["autoCreateSpecialFromThis"];
            this.useLastSellPriceIfNoRules = _data["useLastSellPriceIfNoRules"];
            this.sellPriceRounding = _data["sellPriceRounding"];
            this.sellPriceRoundingOption = _data["sellPriceRoundingOption"];
            this.sellPriceRoundingPerID = _data["sellPriceRoundingPerID"];
            this.sellQuantityRoundingOption = _data["sellQuantityRoundingOption"];
            this.automaticLineChargeID = _data["automaticLineChargeID"];
            this.automaticLineChargeMultiplier = _data["automaticLineChargeMultiplier"];
            this.poAutomaticLineChargeID = _data["poAutomaticLineChargeID"];
            this.poAutomaticLineChargeMultiplier = _data["poAutomaticLineChargeMultiplier"];
            this.priceMarkingPerID = _data["priceMarkingPerID"];
            this.priceMarkingConversion = _data["priceMarkingConversion"];
            this.special = _data["special"];
            this.specialSourceID = _data["specialSourceID"];
            this.nextSpecialSuffix = _data["nextSpecialSuffix"];
            this.buyBasedOnCount = _data["buyBasedOnCount"];
            this.sellBasedOnCount = _data["sellBasedOnCount"];
            this.externalLinkType = _data["externalLinkType"];
            this.pointsPerAmountSpentCollected = _data["pointsPerAmountSpentCollected"];
            this.pointsPerAmountSpentDelivered = _data["pointsPerAmountSpentDelivered"];
            this.pointsPerAmountSpentDirect = _data["pointsPerAmountSpentDirect"];
            this.alternativeSupplierCount = _data["alternativeSupplierCount"];
            this.includeInWebTrack = _data["includeInWebTrack"];
            this.includeInWebTrackCashSales = _data["includeInWebTrackCashSales"];
            this.alwaysOrderStockBackToBack = _data["alwaysOrderStockBackToBack"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.createdByID = _data["createdByID"];
            this.dateTimeLastModified = _data["dateTimeLastModified"] ? new Date(_data["dateTimeLastModified"].toString()) : <any>undefined;
            this.lastModifiedByID = _data["lastModifiedByID"];
            this.relatedProductCount = _data["relatedProductCount"];
            this.promotionCodeTypeID = _data["promotionCodeTypeID"];
            this.defaultUnitSizePerID = _data["defaultUnitSizePerID"];
            this.allowMultiplePersOnUnitSizes = _data["allowMultiplePersOnUnitSizes"];
            this.minManual = _data["minManual"];
            this.maxManual = _data["maxManual"];
            this.cutToLengthStyle = _data["cutToLengthStyle"];
            this.quickProductCaption = _data["quickProductCaption"];
            this.roundUpToInnerOuterPallet = _data["roundUpToInnerOuterPallet"];
            this.copiedFromProductID = _data["copiedFromProductID"];
            this.lockSellPerToInputPer = _data["lockSellPerToInputPer"];
            this.applyRebateAccruals = _data["applyRebateAccruals"];
            this.productCatalogID = _data["productCatalogID"];
            this.parentChildDistribution = _data["parentChildDistribution"];
            this.tallyLengthDistribution = _data["tallyLengthDistribution"];
            this.nextBillOfMaterialSuffix = _data["nextBillOfMaterialSuffix"];
            this.quantityPerCube = _data["quantityPerCube"];
            this.defaultGLCode = _data["defaultGLCode"];
            this.tallyLengthsPerID = _data["tallyLengthsPerID"];
            this.widthGrossingRule = _data["widthGrossingRule"];
            this.lengthGrossingRule = _data["lengthGrossingRule"];
            this.onlyApplyQtyBreakOnSellPerMatch = _data["onlyApplyQtyBreakOnSellPerMatch"];
            this.warningText = _data["warningText"];
            this.useReceivedWeight = _data["useReceivedWeight"];
            this.udfExportToMarginMaster = _data["udfExportToMarginMaster"];
            this.udfCheckBoxTest = _data["udfCheckBoxTest"];
            this.udf86005YN = _data["udf86005YN"];
            this.udfobject = _data["udfobject"];
            this.udfSeason = _data["udfSeason"];
            this.udfExportToDIB = _data["udfExportToDIB"];
            this.udfMarketCostSourceTag = _data["udfMarketCostSourceTag"];
            this.udfMarketCostAdderPct = _data["udfMarketCostAdderPct"];
            this.udfMarketCostAdderAmt1 = _data["udfMarketCostAdderAmt1"];
            this.udfMarketCostAdderAmt2 = _data["udfMarketCostAdderAmt2"];
            this.udfMarketCostAdderAmt3 = _data["udfMarketCostAdderAmt3"];
            this.udfMarketCostAdderAmt4 = _data["udfMarketCostAdderAmt4"];
            this.udfMarketCostAdderAmt5 = _data["udfMarketCostAdderAmt5"];
            this.udfLMTestudfonproduct = _data["udfLMTestudfonproduct"];
            this.udfStockedDate = _data["udfStockedDate"] ? new Date(_data["udfStockedDate"].toString()) : <any>undefined;
            this.udfSKU = _data["udfSKU"];
            this.udfExportToLuxwood = _data["udfExportToLuxwood"];
            this.udfDiscontinued = _data["udfDiscontinued"];
            this.udfWebTrackTest = _data["udfWebTrackTest"];
            if (Array.isArray(_data["productImages"])) {
                this.productImages = [] as any;
                for (let item of _data["productImages"])
                    this.productImages!.push(ProductImage.fromJS(item));
            }
            if (Array.isArray(_data["stocks"])) {
                this.stocks = [] as any;
                for (let item of _data["stocks"])
                    this.stocks!.push(Stock.fromJS(item));
            }
            if (Array.isArray(_data["productStockOptions"])) {
                this.productStockOptions = [] as any;
                for (let item of _data["productStockOptions"])
                    this.productStockOptions!.push(ProductStockOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productID"] = this.productID;
        data["deleted"] = this.deleted;
        data["replacementID"] = this.replacementID;
        data["parentID"] = this.parentID;
        data["productType"] = this.productType;
        data["productSubType"] = this.productSubType;
        data["perRuleID"] = this.perRuleID;
        data["productCode"] = this.productCode;
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["fullDescription"] = this.fullDescription;
        data["manufacturerCode"] = this.manufacturerCode;
        data["barCode"] = this.barCode;
        data["intrastatCommodityCode"] = this.intrastatCommodityCode;
        data["informationURL"] = this.informationURL;
        data["coshhurl"] = this.coshhurl;
        data["popupText"] = this.popupText;
        data["alternativeKeywords"] = this.alternativeKeywords;
        data["notesEntered"] = this.notesEntered;
        data["orderLineInternalNotes"] = this.orderLineInternalNotes;
        data["productGroupID"] = this.productGroupID;
        data["steelGradeID"] = this.steelGradeID;
        data["timberGradeID"] = this.timberGradeID;
        data["materialGradeID"] = this.materialGradeID;
        data["imperial"] = this.imperial;
        data["thickness"] = this.thickness;
        data["width"] = this.width;
        data["length"] = this.length;
        data["dimension4"] = this.dimension4;
        data["dimension5"] = this.dimension5;
        data["dimension6"] = this.dimension6;
        data["weight"] = this.weight;
        data["weighedWeight"] = this.weighedWeight;
        data["weighedWeightAllowance"] = this.weighedWeightAllowance;
        data["testCertTypeID"] = this.testCertTypeID;
        data["tallyLengths"] = this.tallyLengths;
        data["availableWidths"] = this.availableWidths;
        data["defaultPiecesPerPack"] = this.defaultPiecesPerPack;
        data["environmentalStatusID"] = this.environmentalStatusID;
        data["supplierID"] = this.supplierID;
        data["supplierAddressID"] = this.supplierAddressID;
        data["standardStock"] = this.standardStock;
        data["keepStockFigures"] = this.keepStockFigures;
        data["stockControlByLength"] = this.stockControlByLength;
        data["stockLevelsByLength"] = this.stockLevelsByLength;
        data["pickingRequired"] = this.pickingRequired;
        data["qaInspectionRequired"] = this.qaInspectionRequired;
        data["ownBrandProduct"] = this.ownBrandProduct;
        data["vendorManagedInventory"] = this.vendorManagedInventory;
        data["stockedByCost"] = this.stockedByCost;
        data["useActualCostForPacks"] = this.useActualCostForPacks;
        data["packsAreTagged"] = this.packsAreTagged;
        data["keepUntaggedPackRecords"] = this.keepUntaggedPackRecords;
        data["packPurchasing"] = this.packPurchasing;
        data["packSelling"] = this.packSelling;
        data["quantityPerInner"] = this.quantityPerInner;
        data["quantityPerOuter"] = this.quantityPerOuter;
        data["quantityPerPallet"] = this.quantityPerPallet;
        data["barCodeInner"] = this.barCodeInner;
        data["barCodeOuter"] = this.barCodeOuter;
        data["barCodePallet"] = this.barCodePallet;
        data["buyProductID"] = this.buyProductID;
        data["standardBuyPrice"] = this.standardBuyPrice;
        data["buyPerID"] = this.buyPerID;
        data["buyStockConversion"] = this.buyStockConversion;
        data["buyPriceGroupID"] = this.buyPriceGroupID;
        data["buyTaxGroupID"] = this.buyTaxGroupID;
        data["purchaseAnalysisCodeID"] = this.purchaseAnalysisCodeID;
        data["countryOfOriginID"] = this.countryOfOriginID;
        data["timberSurchargeID"] = this.timberSurchargeID;
        data["salesOrderTalliedInputScreen"] = this.salesOrderTalliedInputScreen;
        data["promptForTallyOnSalesOrder"] = this.promptForTallyOnSalesOrder;
        data["retrospectiveDiscountType"] = this.retrospectiveDiscountType;
        data["retrospectiveDiscount"] = this.retrospectiveDiscount;
        data["buyingQuantityBreakID"] = this.buyingQuantityBreakID;
        data["averageCostPrice"] = this.averageCostPrice;
        data["averageCostPriceWithAdditional"] = this.averageCostPriceWithAdditional;
        data["lastCostPrice"] = this.lastCostPrice;
        data["lastCostPriceWithAdditional"] = this.lastCostPriceWithAdditional;
        data["lastCostPerID"] = this.lastCostPerID;
        data["lastCostPriceDateTime"] = this.lastCostPriceDateTime ? this.lastCostPriceDateTime.toISOString() : <any>undefined;
        data["internalCostPrice"] = this.internalCostPrice;
        data["standardPurchase"] = this.standardPurchase;
        data["sellProductID"] = this.sellProductID;
        data["standardSellPrice"] = this.standardSellPrice;
        data["sellPerID"] = this.sellPerID;
        data["sellPriceGroupID"] = this.sellPriceGroupID;
        data["sellTaxGroupID"] = this.sellTaxGroupID;
        data["salesAnalysisCodeID"] = this.salesAnalysisCodeID;
        data["vatRuleID"] = this.vatRuleID;
        data["sellingQuantityBreakID"] = this.sellingQuantityBreakID;
        data["lowMarginCollected"] = this.lowMarginCollected;
        data["lowMarginDelivered"] = this.lowMarginDelivered;
        data["lowMarginDirect"] = this.lowMarginDirect;
        data["highMargin"] = this.highMargin;
        data["deliveryProductTypeID"] = this.deliveryProductTypeID;
        data["allowDirectSales"] = this.allowDirectSales;
        data["allowCashSales"] = this.allowCashSales;
        data["allowSettlementDiscount"] = this.allowSettlementDiscount;
        data["applyDeliveryCharges"] = this.applyDeliveryCharges;
        data["promptForQuantityOnOrders"] = this.promptForQuantityOnOrders;
        data["allowDescriptionOverride"] = this.allowDescriptionOverride;
        data["allowPriceNegotiation"] = this.allowPriceNegotiation;
        data["allowCostOverride"] = this.allowCostOverride;
        data["allowSpecialsBasedOnThis"] = this.allowSpecialsBasedOnThis;
        data["autoCreateSpecialFromThis"] = this.autoCreateSpecialFromThis;
        data["useLastSellPriceIfNoRules"] = this.useLastSellPriceIfNoRules;
        data["sellPriceRounding"] = this.sellPriceRounding;
        data["sellPriceRoundingOption"] = this.sellPriceRoundingOption;
        data["sellPriceRoundingPerID"] = this.sellPriceRoundingPerID;
        data["sellQuantityRoundingOption"] = this.sellQuantityRoundingOption;
        data["automaticLineChargeID"] = this.automaticLineChargeID;
        data["automaticLineChargeMultiplier"] = this.automaticLineChargeMultiplier;
        data["poAutomaticLineChargeID"] = this.poAutomaticLineChargeID;
        data["poAutomaticLineChargeMultiplier"] = this.poAutomaticLineChargeMultiplier;
        data["priceMarkingPerID"] = this.priceMarkingPerID;
        data["priceMarkingConversion"] = this.priceMarkingConversion;
        data["special"] = this.special;
        data["specialSourceID"] = this.specialSourceID;
        data["nextSpecialSuffix"] = this.nextSpecialSuffix;
        data["buyBasedOnCount"] = this.buyBasedOnCount;
        data["sellBasedOnCount"] = this.sellBasedOnCount;
        data["externalLinkType"] = this.externalLinkType;
        data["pointsPerAmountSpentCollected"] = this.pointsPerAmountSpentCollected;
        data["pointsPerAmountSpentDelivered"] = this.pointsPerAmountSpentDelivered;
        data["pointsPerAmountSpentDirect"] = this.pointsPerAmountSpentDirect;
        data["alternativeSupplierCount"] = this.alternativeSupplierCount;
        data["includeInWebTrack"] = this.includeInWebTrack;
        data["includeInWebTrackCashSales"] = this.includeInWebTrackCashSales;
        data["alwaysOrderStockBackToBack"] = this.alwaysOrderStockBackToBack;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["createdByID"] = this.createdByID;
        data["dateTimeLastModified"] = this.dateTimeLastModified ? this.dateTimeLastModified.toISOString() : <any>undefined;
        data["lastModifiedByID"] = this.lastModifiedByID;
        data["relatedProductCount"] = this.relatedProductCount;
        data["promotionCodeTypeID"] = this.promotionCodeTypeID;
        data["defaultUnitSizePerID"] = this.defaultUnitSizePerID;
        data["allowMultiplePersOnUnitSizes"] = this.allowMultiplePersOnUnitSizes;
        data["minManual"] = this.minManual;
        data["maxManual"] = this.maxManual;
        data["cutToLengthStyle"] = this.cutToLengthStyle;
        data["quickProductCaption"] = this.quickProductCaption;
        data["roundUpToInnerOuterPallet"] = this.roundUpToInnerOuterPallet;
        data["copiedFromProductID"] = this.copiedFromProductID;
        data["lockSellPerToInputPer"] = this.lockSellPerToInputPer;
        data["applyRebateAccruals"] = this.applyRebateAccruals;
        data["productCatalogID"] = this.productCatalogID;
        data["parentChildDistribution"] = this.parentChildDistribution;
        data["tallyLengthDistribution"] = this.tallyLengthDistribution;
        data["nextBillOfMaterialSuffix"] = this.nextBillOfMaterialSuffix;
        data["quantityPerCube"] = this.quantityPerCube;
        data["defaultGLCode"] = this.defaultGLCode;
        data["tallyLengthsPerID"] = this.tallyLengthsPerID;
        data["widthGrossingRule"] = this.widthGrossingRule;
        data["lengthGrossingRule"] = this.lengthGrossingRule;
        data["onlyApplyQtyBreakOnSellPerMatch"] = this.onlyApplyQtyBreakOnSellPerMatch;
        data["warningText"] = this.warningText;
        data["useReceivedWeight"] = this.useReceivedWeight;
        data["udfExportToMarginMaster"] = this.udfExportToMarginMaster;
        data["udfCheckBoxTest"] = this.udfCheckBoxTest;
        data["udf86005YN"] = this.udf86005YN;
        data["udfobject"] = this.udfobject;
        data["udfSeason"] = this.udfSeason;
        data["udfExportToDIB"] = this.udfExportToDIB;
        data["udfMarketCostSourceTag"] = this.udfMarketCostSourceTag;
        data["udfMarketCostAdderPct"] = this.udfMarketCostAdderPct;
        data["udfMarketCostAdderAmt1"] = this.udfMarketCostAdderAmt1;
        data["udfMarketCostAdderAmt2"] = this.udfMarketCostAdderAmt2;
        data["udfMarketCostAdderAmt3"] = this.udfMarketCostAdderAmt3;
        data["udfMarketCostAdderAmt4"] = this.udfMarketCostAdderAmt4;
        data["udfMarketCostAdderAmt5"] = this.udfMarketCostAdderAmt5;
        data["udfLMTestudfonproduct"] = this.udfLMTestudfonproduct;
        data["udfStockedDate"] = this.udfStockedDate ? this.udfStockedDate.toISOString() : <any>undefined;
        data["udfSKU"] = this.udfSKU;
        data["udfExportToLuxwood"] = this.udfExportToLuxwood;
        data["udfDiscontinued"] = this.udfDiscontinued;
        data["udfWebTrackTest"] = this.udfWebTrackTest;
        if (Array.isArray(this.productImages)) {
            data["productImages"] = [];
            for (let item of this.productImages)
                data["productImages"].push(item.toJSON());
        }
        if (Array.isArray(this.stocks)) {
            data["stocks"] = [];
            for (let item of this.stocks)
                data["stocks"].push(item.toJSON());
        }
        if (Array.isArray(this.productStockOptions)) {
            data["productStockOptions"] = [];
            for (let item of this.productStockOptions)
                data["productStockOptions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProduct {
    productID?: number | undefined;
    deleted?: number | undefined;
    replacementID?: number | undefined;
    parentID?: number | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    perRuleID?: number | undefined;
    productCode?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
    manufacturerCode?: string | undefined;
    barCode?: string | undefined;
    intrastatCommodityCode?: string | undefined;
    informationURL?: string | undefined;
    coshhurl?: string | undefined;
    popupText?: string | undefined;
    alternativeKeywords?: string | undefined;
    notesEntered?: number | undefined;
    orderLineInternalNotes?: string | undefined;
    productGroupID?: number | undefined;
    steelGradeID?: number | undefined;
    timberGradeID?: number | undefined;
    materialGradeID?: number | undefined;
    imperial?: boolean | undefined;
    thickness?: number | undefined;
    width?: number | undefined;
    length?: number | undefined;
    dimension4?: number | undefined;
    dimension5?: number | undefined;
    dimension6?: number | undefined;
    weight?: number | undefined;
    weighedWeight?: boolean | undefined;
    weighedWeightAllowance?: number | undefined;
    testCertTypeID?: number | undefined;
    tallyLengths?: string | undefined;
    availableWidths?: string | undefined;
    defaultPiecesPerPack?: number | undefined;
    environmentalStatusID?: number | undefined;
    supplierID?: number | undefined;
    supplierAddressID?: number | undefined;
    standardStock?: boolean | undefined;
    keepStockFigures?: boolean | undefined;
    stockControlByLength?: boolean | undefined;
    stockLevelsByLength?: boolean | undefined;
    pickingRequired?: boolean | undefined;
    qaInspectionRequired?: boolean | undefined;
    ownBrandProduct?: boolean | undefined;
    vendorManagedInventory?: boolean | undefined;
    stockedByCost?: boolean | undefined;
    useActualCostForPacks?: boolean | undefined;
    packsAreTagged?: boolean | undefined;
    keepUntaggedPackRecords?: boolean | undefined;
    packPurchasing?: number | undefined;
    packSelling?: number | undefined;
    quantityPerInner?: number | undefined;
    quantityPerOuter?: number | undefined;
    quantityPerPallet?: number | undefined;
    barCodeInner?: string | undefined;
    barCodeOuter?: string | undefined;
    barCodePallet?: string | undefined;
    buyProductID?: number | undefined;
    standardBuyPrice?: number | undefined;
    buyPerID?: number | undefined;
    buyStockConversion?: number | undefined;
    buyPriceGroupID?: number | undefined;
    buyTaxGroupID?: number | undefined;
    purchaseAnalysisCodeID?: number | undefined;
    countryOfOriginID?: number | undefined;
    timberSurchargeID?: number | undefined;
    salesOrderTalliedInputScreen?: number | undefined;
    promptForTallyOnSalesOrder?: boolean | undefined;
    retrospectiveDiscountType?: number | undefined;
    retrospectiveDiscount?: number | undefined;
    buyingQuantityBreakID?: number | undefined;
    averageCostPrice?: number | undefined;
    averageCostPriceWithAdditional?: number | undefined;
    lastCostPrice?: number | undefined;
    lastCostPriceWithAdditional?: number | undefined;
    lastCostPerID?: number | undefined;
    lastCostPriceDateTime?: Date | undefined;
    internalCostPrice?: number | undefined;
    standardPurchase?: boolean | undefined;
    sellProductID?: number | undefined;
    standardSellPrice?: number | undefined;
    sellPerID?: number | undefined;
    sellPriceGroupID?: number | undefined;
    sellTaxGroupID?: number | undefined;
    salesAnalysisCodeID?: number | undefined;
    vatRuleID?: number | undefined;
    sellingQuantityBreakID?: number | undefined;
    lowMarginCollected?: number | undefined;
    lowMarginDelivered?: number | undefined;
    lowMarginDirect?: number | undefined;
    highMargin?: number | undefined;
    deliveryProductTypeID?: number | undefined;
    allowDirectSales?: boolean | undefined;
    allowCashSales?: boolean | undefined;
    allowSettlementDiscount?: boolean | undefined;
    applyDeliveryCharges?: boolean | undefined;
    promptForQuantityOnOrders?: boolean | undefined;
    allowDescriptionOverride?: number | undefined;
    allowPriceNegotiation?: boolean | undefined;
    allowCostOverride?: number | undefined;
    allowSpecialsBasedOnThis?: number | undefined;
    autoCreateSpecialFromThis?: number | undefined;
    useLastSellPriceIfNoRules?: boolean | undefined;
    sellPriceRounding?: number | undefined;
    sellPriceRoundingOption?: number | undefined;
    sellPriceRoundingPerID?: number | undefined;
    sellQuantityRoundingOption?: number | undefined;
    automaticLineChargeID?: number | undefined;
    automaticLineChargeMultiplier?: number | undefined;
    poAutomaticLineChargeID?: number | undefined;
    poAutomaticLineChargeMultiplier?: number | undefined;
    priceMarkingPerID?: number | undefined;
    priceMarkingConversion?: number | undefined;
    special?: boolean | undefined;
    specialSourceID?: number | undefined;
    nextSpecialSuffix?: number | undefined;
    buyBasedOnCount?: number | undefined;
    sellBasedOnCount?: number | undefined;
    externalLinkType?: number | undefined;
    pointsPerAmountSpentCollected?: number | undefined;
    pointsPerAmountSpentDelivered?: number | undefined;
    pointsPerAmountSpentDirect?: number | undefined;
    alternativeSupplierCount?: number | undefined;
    includeInWebTrack?: boolean | undefined;
    includeInWebTrackCashSales?: boolean | undefined;
    alwaysOrderStockBackToBack?: boolean | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    lastModifiedByID?: number | undefined;
    relatedProductCount?: number | undefined;
    promotionCodeTypeID?: number | undefined;
    defaultUnitSizePerID?: number | undefined;
    allowMultiplePersOnUnitSizes?: boolean | undefined;
    minManual?: boolean | undefined;
    maxManual?: boolean | undefined;
    cutToLengthStyle?: number | undefined;
    quickProductCaption?: string | undefined;
    roundUpToInnerOuterPallet?: number | undefined;
    copiedFromProductID?: number | undefined;
    lockSellPerToInputPer?: boolean | undefined;
    applyRebateAccruals?: boolean | undefined;
    productCatalogID?: number | undefined;
    parentChildDistribution?: number | undefined;
    tallyLengthDistribution?: string | undefined;
    nextBillOfMaterialSuffix?: number | undefined;
    quantityPerCube?: number | undefined;
    defaultGLCode?: string | undefined;
    tallyLengthsPerID?: number | undefined;
    widthGrossingRule?: number | undefined;
    lengthGrossingRule?: number | undefined;
    onlyApplyQtyBreakOnSellPerMatch?: boolean | undefined;
    warningText?: string | undefined;
    useReceivedWeight?: boolean | undefined;
    udfExportToMarginMaster?: boolean | undefined;
    udfCheckBoxTest?: boolean | undefined;
    udf86005YN?: boolean | undefined;
    udfobject?: number | undefined;
    udfSeason?: string | undefined;
    udfExportToDIB?: boolean | undefined;
    udfMarketCostSourceTag?: string | undefined;
    udfMarketCostAdderPct?: number | undefined;
    udfMarketCostAdderAmt1?: number | undefined;
    udfMarketCostAdderAmt2?: number | undefined;
    udfMarketCostAdderAmt3?: number | undefined;
    udfMarketCostAdderAmt4?: number | undefined;
    udfMarketCostAdderAmt5?: number | undefined;
    udfLMTestudfonproduct?: string | undefined;
    udfStockedDate?: Date | undefined;
    udfSKU?: string | undefined;
    udfExportToLuxwood?: boolean | undefined;
    udfDiscontinued?: boolean | undefined;
    udfWebTrackTest?: string | undefined;
    productImages?: ProductImage[] | undefined;
    stocks?: Stock[] | undefined;
    productStockOptions?: ProductStockOption[] | undefined;
}

export class OrderLineAdditionalCostCharge implements IOrderLineAdditionalCostCharge {
    orderLineAddCostChargeID?: number | undefined;
    deleted?: number | undefined;
    orderAddCostChargeID?: number | undefined;
    additionalCostChargeID?: number | undefined;
    orderID?: number | undefined;
    orderLineID?: number | undefined;
    additionalCost?: number | undefined;
    additionalCostInCurrency?: number | undefined;
    additionalCharge?: number | undefined;
    estimateAdditionalCost?: number | undefined;

    constructor(data?: IOrderLineAdditionalCostCharge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderLineAddCostChargeID = _data["orderLineAddCostChargeID"];
            this.deleted = _data["deleted"];
            this.orderAddCostChargeID = _data["orderAddCostChargeID"];
            this.additionalCostChargeID = _data["additionalCostChargeID"];
            this.orderID = _data["orderID"];
            this.orderLineID = _data["orderLineID"];
            this.additionalCost = _data["additionalCost"];
            this.additionalCostInCurrency = _data["additionalCostInCurrency"];
            this.additionalCharge = _data["additionalCharge"];
            this.estimateAdditionalCost = _data["estimateAdditionalCost"];
        }
    }

    static fromJS(data: any): OrderLineAdditionalCostCharge {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLineAdditionalCostCharge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderLineAddCostChargeID"] = this.orderLineAddCostChargeID;
        data["deleted"] = this.deleted;
        data["orderAddCostChargeID"] = this.orderAddCostChargeID;
        data["additionalCostChargeID"] = this.additionalCostChargeID;
        data["orderID"] = this.orderID;
        data["orderLineID"] = this.orderLineID;
        data["additionalCost"] = this.additionalCost;
        data["additionalCostInCurrency"] = this.additionalCostInCurrency;
        data["additionalCharge"] = this.additionalCharge;
        data["estimateAdditionalCost"] = this.estimateAdditionalCost;
        return data; 
    }
}

export interface IOrderLineAdditionalCostCharge {
    orderLineAddCostChargeID?: number | undefined;
    deleted?: number | undefined;
    orderAddCostChargeID?: number | undefined;
    additionalCostChargeID?: number | undefined;
    orderID?: number | undefined;
    orderLineID?: number | undefined;
    additionalCost?: number | undefined;
    additionalCostInCurrency?: number | undefined;
    additionalCharge?: number | undefined;
    estimateAdditionalCost?: number | undefined;
}

export class OrderLineAVO implements IOrderLineAVO {
    orderLineAvoid?: number | undefined;
    orderID?: number | undefined;
    orderLineID?: number | undefined;
    avoid?: number | undefined;
    avoOptionID?: number | undefined;
    perID?: number | undefined;
    perConversion?: number | undefined;
    perConversionActualSizes?: number | undefined;
    costPrice?: number | undefined;
    sellPrice?: number | undefined;
    totalCostPrice?: number | undefined;
    totalSellPrice?: number | undefined;
    costPriceType?: number | undefined;
    sellPriceType?: number | undefined;
    sellPriceInCurrency?: number | undefined;
    totalSellPriceInCurrency?: number | undefined;
    quantity?: number | undefined;
    quantityCompleted?: number | undefined;
    notes?: string | undefined;
    purchaseOrderID?: number | undefined;
    avoSellPriceRuleID?: number | undefined;
    avoBuyPriceRuleID?: number | undefined;
    minimumCost?: number | undefined;
    minimumSell?: number | undefined;
    productionTime?: number | undefined;
    machineID?: number | undefined;
    createdFromWorksOrderLineID?: number | undefined;
    originalProductionTime?: number | undefined;
    operationName?: string | undefined;
    internalOperation?: boolean | undefined;
    requiresConfirmation?: boolean | undefined;
    optionName?: string | undefined;
    supplierID?: number | undefined;
    vatRuleID?: number | undefined;
    taxGroupID?: number | undefined;

    constructor(data?: IOrderLineAVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderLineAvoid = _data["orderLineAvoid"];
            this.orderID = _data["orderID"];
            this.orderLineID = _data["orderLineID"];
            this.avoid = _data["avoid"];
            this.avoOptionID = _data["avoOptionID"];
            this.perID = _data["perID"];
            this.perConversion = _data["perConversion"];
            this.perConversionActualSizes = _data["perConversionActualSizes"];
            this.costPrice = _data["costPrice"];
            this.sellPrice = _data["sellPrice"];
            this.totalCostPrice = _data["totalCostPrice"];
            this.totalSellPrice = _data["totalSellPrice"];
            this.costPriceType = _data["costPriceType"];
            this.sellPriceType = _data["sellPriceType"];
            this.sellPriceInCurrency = _data["sellPriceInCurrency"];
            this.totalSellPriceInCurrency = _data["totalSellPriceInCurrency"];
            this.quantity = _data["quantity"];
            this.quantityCompleted = _data["quantityCompleted"];
            this.notes = _data["notes"];
            this.purchaseOrderID = _data["purchaseOrderID"];
            this.avoSellPriceRuleID = _data["avoSellPriceRuleID"];
            this.avoBuyPriceRuleID = _data["avoBuyPriceRuleID"];
            this.minimumCost = _data["minimumCost"];
            this.minimumSell = _data["minimumSell"];
            this.productionTime = _data["productionTime"];
            this.machineID = _data["machineID"];
            this.createdFromWorksOrderLineID = _data["createdFromWorksOrderLineID"];
            this.originalProductionTime = _data["originalProductionTime"];
            this.operationName = _data["operationName"];
            this.internalOperation = _data["internalOperation"];
            this.requiresConfirmation = _data["requiresConfirmation"];
            this.optionName = _data["optionName"];
            this.supplierID = _data["supplierID"];
            this.vatRuleID = _data["vatRuleID"];
            this.taxGroupID = _data["taxGroupID"];
        }
    }

    static fromJS(data: any): OrderLineAVO {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLineAVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderLineAvoid"] = this.orderLineAvoid;
        data["orderID"] = this.orderID;
        data["orderLineID"] = this.orderLineID;
        data["avoid"] = this.avoid;
        data["avoOptionID"] = this.avoOptionID;
        data["perID"] = this.perID;
        data["perConversion"] = this.perConversion;
        data["perConversionActualSizes"] = this.perConversionActualSizes;
        data["costPrice"] = this.costPrice;
        data["sellPrice"] = this.sellPrice;
        data["totalCostPrice"] = this.totalCostPrice;
        data["totalSellPrice"] = this.totalSellPrice;
        data["costPriceType"] = this.costPriceType;
        data["sellPriceType"] = this.sellPriceType;
        data["sellPriceInCurrency"] = this.sellPriceInCurrency;
        data["totalSellPriceInCurrency"] = this.totalSellPriceInCurrency;
        data["quantity"] = this.quantity;
        data["quantityCompleted"] = this.quantityCompleted;
        data["notes"] = this.notes;
        data["purchaseOrderID"] = this.purchaseOrderID;
        data["avoSellPriceRuleID"] = this.avoSellPriceRuleID;
        data["avoBuyPriceRuleID"] = this.avoBuyPriceRuleID;
        data["minimumCost"] = this.minimumCost;
        data["minimumSell"] = this.minimumSell;
        data["productionTime"] = this.productionTime;
        data["machineID"] = this.machineID;
        data["createdFromWorksOrderLineID"] = this.createdFromWorksOrderLineID;
        data["originalProductionTime"] = this.originalProductionTime;
        data["operationName"] = this.operationName;
        data["internalOperation"] = this.internalOperation;
        data["requiresConfirmation"] = this.requiresConfirmation;
        data["optionName"] = this.optionName;
        data["supplierID"] = this.supplierID;
        data["vatRuleID"] = this.vatRuleID;
        data["taxGroupID"] = this.taxGroupID;
        return data; 
    }
}

export interface IOrderLineAVO {
    orderLineAvoid?: number | undefined;
    orderID?: number | undefined;
    orderLineID?: number | undefined;
    avoid?: number | undefined;
    avoOptionID?: number | undefined;
    perID?: number | undefined;
    perConversion?: number | undefined;
    perConversionActualSizes?: number | undefined;
    costPrice?: number | undefined;
    sellPrice?: number | undefined;
    totalCostPrice?: number | undefined;
    totalSellPrice?: number | undefined;
    costPriceType?: number | undefined;
    sellPriceType?: number | undefined;
    sellPriceInCurrency?: number | undefined;
    totalSellPriceInCurrency?: number | undefined;
    quantity?: number | undefined;
    quantityCompleted?: number | undefined;
    notes?: string | undefined;
    purchaseOrderID?: number | undefined;
    avoSellPriceRuleID?: number | undefined;
    avoBuyPriceRuleID?: number | undefined;
    minimumCost?: number | undefined;
    minimumSell?: number | undefined;
    productionTime?: number | undefined;
    machineID?: number | undefined;
    createdFromWorksOrderLineID?: number | undefined;
    originalProductionTime?: number | undefined;
    operationName?: string | undefined;
    internalOperation?: boolean | undefined;
    requiresConfirmation?: boolean | undefined;
    optionName?: string | undefined;
    supplierID?: number | undefined;
    vatRuleID?: number | undefined;
    taxGroupID?: number | undefined;
}

export class CreditNoteItem implements ICreditNoteItem {
    creditNoteItemID?: number | undefined;
    creditNoteID?: number | undefined;
    creditNoteLineID?: number | undefined;
    pickingNoteItemID?: number | undefined;
    plateID?: number | undefined;
    packID?: number | undefined;
    productBatchID?: number | undefined;
    productBatchItemID?: number | undefined;
    productBatchQuantity?: number | undefined;
    productBatchQuantityPerID?: number | undefined;
    productBatchQuantityTally?: string | undefined;
    productBatchUnitCostPrice?: number | undefined;
    productBatchCostPerID?: number | undefined;
    plateNumber?: string | undefined;
    sourcePlateNumber?: string | undefined;
    testCertNumber?: string | undefined;
    pages?: string | undefined;
    batchStockLocationID?: number | undefined;
    batchReference?: string | undefined;
    batchBinLocation?: string | undefined;
    batchItemReference?: string | undefined;
    useThisInputPerID?: number | undefined;
    useThisInputPerCode?: string | undefined;
    useThisStockPerConversion?: number | undefined;
    productBatchQuantityInInputPer?: number | undefined;

    constructor(data?: ICreditNoteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creditNoteItemID = _data["creditNoteItemID"];
            this.creditNoteID = _data["creditNoteID"];
            this.creditNoteLineID = _data["creditNoteLineID"];
            this.pickingNoteItemID = _data["pickingNoteItemID"];
            this.plateID = _data["plateID"];
            this.packID = _data["packID"];
            this.productBatchID = _data["productBatchID"];
            this.productBatchItemID = _data["productBatchItemID"];
            this.productBatchQuantity = _data["productBatchQuantity"];
            this.productBatchQuantityPerID = _data["productBatchQuantityPerID"];
            this.productBatchQuantityTally = _data["productBatchQuantityTally"];
            this.productBatchUnitCostPrice = _data["productBatchUnitCostPrice"];
            this.productBatchCostPerID = _data["productBatchCostPerID"];
            this.plateNumber = _data["plateNumber"];
            this.sourcePlateNumber = _data["sourcePlateNumber"];
            this.testCertNumber = _data["testCertNumber"];
            this.pages = _data["pages"];
            this.batchStockLocationID = _data["batchStockLocationID"];
            this.batchReference = _data["batchReference"];
            this.batchBinLocation = _data["batchBinLocation"];
            this.batchItemReference = _data["batchItemReference"];
            this.useThisInputPerID = _data["useThisInputPerID"];
            this.useThisInputPerCode = _data["useThisInputPerCode"];
            this.useThisStockPerConversion = _data["useThisStockPerConversion"];
            this.productBatchQuantityInInputPer = _data["productBatchQuantityInInputPer"];
        }
    }

    static fromJS(data: any): CreditNoteItem {
        data = typeof data === 'object' ? data : {};
        let result = new CreditNoteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creditNoteItemID"] = this.creditNoteItemID;
        data["creditNoteID"] = this.creditNoteID;
        data["creditNoteLineID"] = this.creditNoteLineID;
        data["pickingNoteItemID"] = this.pickingNoteItemID;
        data["plateID"] = this.plateID;
        data["packID"] = this.packID;
        data["productBatchID"] = this.productBatchID;
        data["productBatchItemID"] = this.productBatchItemID;
        data["productBatchQuantity"] = this.productBatchQuantity;
        data["productBatchQuantityPerID"] = this.productBatchQuantityPerID;
        data["productBatchQuantityTally"] = this.productBatchQuantityTally;
        data["productBatchUnitCostPrice"] = this.productBatchUnitCostPrice;
        data["productBatchCostPerID"] = this.productBatchCostPerID;
        data["plateNumber"] = this.plateNumber;
        data["sourcePlateNumber"] = this.sourcePlateNumber;
        data["testCertNumber"] = this.testCertNumber;
        data["pages"] = this.pages;
        data["batchStockLocationID"] = this.batchStockLocationID;
        data["batchReference"] = this.batchReference;
        data["batchBinLocation"] = this.batchBinLocation;
        data["batchItemReference"] = this.batchItemReference;
        data["useThisInputPerID"] = this.useThisInputPerID;
        data["useThisInputPerCode"] = this.useThisInputPerCode;
        data["useThisStockPerConversion"] = this.useThisStockPerConversion;
        data["productBatchQuantityInInputPer"] = this.productBatchQuantityInInputPer;
        return data; 
    }
}

export interface ICreditNoteItem {
    creditNoteItemID?: number | undefined;
    creditNoteID?: number | undefined;
    creditNoteLineID?: number | undefined;
    pickingNoteItemID?: number | undefined;
    plateID?: number | undefined;
    packID?: number | undefined;
    productBatchID?: number | undefined;
    productBatchItemID?: number | undefined;
    productBatchQuantity?: number | undefined;
    productBatchQuantityPerID?: number | undefined;
    productBatchQuantityTally?: string | undefined;
    productBatchUnitCostPrice?: number | undefined;
    productBatchCostPerID?: number | undefined;
    plateNumber?: string | undefined;
    sourcePlateNumber?: string | undefined;
    testCertNumber?: string | undefined;
    pages?: string | undefined;
    batchStockLocationID?: number | undefined;
    batchReference?: string | undefined;
    batchBinLocation?: string | undefined;
    batchItemReference?: string | undefined;
    useThisInputPerID?: number | undefined;
    useThisInputPerCode?: string | undefined;
    useThisStockPerConversion?: number | undefined;
    productBatchQuantityInInputPer?: number | undefined;
}

export class JourneyStop implements IJourneyStop {
    journeyStopID?: number | undefined;
    journeyID?: number | undefined;
    stopNumber?: number | undefined;
    driveTime?: number | undefined;
    unloadTime?: number | undefined;
    delayTime?: number | undefined;
    returnToBranch?: boolean | undefined;
    estimatedArrival?: Date | undefined;
    actualDeparture?: Date | undefined;
    actualArrival?: Date | undefined;
    address?: string | undefined;

    constructor(data?: IJourneyStop) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.journeyStopID = _data["journeyStopID"];
            this.journeyID = _data["journeyID"];
            this.stopNumber = _data["stopNumber"];
            this.driveTime = _data["driveTime"];
            this.unloadTime = _data["unloadTime"];
            this.delayTime = _data["delayTime"];
            this.returnToBranch = _data["returnToBranch"];
            this.estimatedArrival = _data["estimatedArrival"] ? new Date(_data["estimatedArrival"].toString()) : <any>undefined;
            this.actualDeparture = _data["actualDeparture"] ? new Date(_data["actualDeparture"].toString()) : <any>undefined;
            this.actualArrival = _data["actualArrival"] ? new Date(_data["actualArrival"].toString()) : <any>undefined;
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): JourneyStop {
        data = typeof data === 'object' ? data : {};
        let result = new JourneyStop();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["journeyStopID"] = this.journeyStopID;
        data["journeyID"] = this.journeyID;
        data["stopNumber"] = this.stopNumber;
        data["driveTime"] = this.driveTime;
        data["unloadTime"] = this.unloadTime;
        data["delayTime"] = this.delayTime;
        data["returnToBranch"] = this.returnToBranch;
        data["estimatedArrival"] = this.estimatedArrival ? this.estimatedArrival.toISOString() : <any>undefined;
        data["actualDeparture"] = this.actualDeparture ? this.actualDeparture.toISOString() : <any>undefined;
        data["actualArrival"] = this.actualArrival ? this.actualArrival.toISOString() : <any>undefined;
        data["address"] = this.address;
        return data; 
    }
}

export interface IJourneyStop {
    journeyStopID?: number | undefined;
    journeyID?: number | undefined;
    stopNumber?: number | undefined;
    driveTime?: number | undefined;
    unloadTime?: number | undefined;
    delayTime?: number | undefined;
    returnToBranch?: boolean | undefined;
    estimatedArrival?: Date | undefined;
    actualDeparture?: Date | undefined;
    actualArrival?: Date | undefined;
    address?: string | undefined;
}

export class WorksOrderHeader implements IWorksOrderHeader {
    worksOrderID?: number | undefined;
    deleted?: number | undefined;
    worksOrderNumber?: number | undefined;
    worksOrderStatus?: number | undefined;
    template?: boolean | undefined;
    stockAllocated?: boolean | undefined;
    branchID?: number | undefined;
    orderID?: number | undefined;
    description?: string | undefined;
    dateRequired?: Date | undefined;
    dateRequiredOption?: number | undefined;
    startManufactureBy?: Date | undefined;
    machineGroupID?: number | undefined;
    machineID?: number | undefined;
    machineName?: string | undefined;
    operatorName?: string | undefined;
    shiftID?: number | undefined;
    supplierID?: number | undefined;
    processCostsToOrderOnly?: boolean | undefined;
    addCostsToOrderOnly?: boolean | undefined;
    notes?: string | undefined;
    noOfPiecesIn?: number | undefined;
    totalLengthIn?: number | undefined;
    totalVolumeIn?: number | undefined;
    totalAreaIn?: number | undefined;
    noOfPiecesOut?: number | undefined;
    totalLengthOut?: number | undefined;
    totalVolumeOut?: number | undefined;
    totalAreaOut?: number | undefined;
    volumeToOrder?: number | undefined;
    volumeToStock?: number | undefined;
    volumeToWaste?: number | undefined;
    totalSourceCost?: number | undefined;
    totalProcessCost?: number | undefined;
    totalAddCost?: number | undefined;
    totalCostPrice?: number | undefined;
    noOfSource?: number | undefined;
    noOfProcess?: number | undefined;
    noOfFinished?: number | undefined;
    totalProductionTime?: number | undefined;
    totalWeight?: number | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    dateTimeProcessed?: Date | undefined;
    processedByID?: number | undefined;
    journeyID?: number | undefined;
    needsCollection?: boolean | undefined;
    collectionJourneyID?: number | undefined;
    printed?: boolean | undefined;
    scheduleLabelPrinted?: boolean | undefined;
    totalProcessLeadTime?: number | undefined;
    generatedOrder?: boolean | undefined;
    wmsType?: number | undefined;
    wmsCreatedFromWorksOrderID?: number | undefined;
    wmsStatus?: number | undefined;
    isOnQuote?: boolean | undefined;
    lastModifiedByID?: number | undefined;
    calculatedDateRequired?: boolean | undefined;
    wmsHold?: boolean | undefined;
    isNested?: boolean | undefined;
    nestingAllowRotation?: boolean | undefined;
    requiresStock?: boolean | undefined;
    overrideUserID?: number | undefined;
    overrideDateTime?: Date | undefined;

    constructor(data?: IWorksOrderHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.worksOrderID = _data["worksOrderID"];
            this.deleted = _data["deleted"];
            this.worksOrderNumber = _data["worksOrderNumber"];
            this.worksOrderStatus = _data["worksOrderStatus"];
            this.template = _data["template"];
            this.stockAllocated = _data["stockAllocated"];
            this.branchID = _data["branchID"];
            this.orderID = _data["orderID"];
            this.description = _data["description"];
            this.dateRequired = _data["dateRequired"] ? new Date(_data["dateRequired"].toString()) : <any>undefined;
            this.dateRequiredOption = _data["dateRequiredOption"];
            this.startManufactureBy = _data["startManufactureBy"] ? new Date(_data["startManufactureBy"].toString()) : <any>undefined;
            this.machineGroupID = _data["machineGroupID"];
            this.machineID = _data["machineID"];
            this.machineName = _data["machineName"];
            this.operatorName = _data["operatorName"];
            this.shiftID = _data["shiftID"];
            this.supplierID = _data["supplierID"];
            this.processCostsToOrderOnly = _data["processCostsToOrderOnly"];
            this.addCostsToOrderOnly = _data["addCostsToOrderOnly"];
            this.notes = _data["notes"];
            this.noOfPiecesIn = _data["noOfPiecesIn"];
            this.totalLengthIn = _data["totalLengthIn"];
            this.totalVolumeIn = _data["totalVolumeIn"];
            this.totalAreaIn = _data["totalAreaIn"];
            this.noOfPiecesOut = _data["noOfPiecesOut"];
            this.totalLengthOut = _data["totalLengthOut"];
            this.totalVolumeOut = _data["totalVolumeOut"];
            this.totalAreaOut = _data["totalAreaOut"];
            this.volumeToOrder = _data["volumeToOrder"];
            this.volumeToStock = _data["volumeToStock"];
            this.volumeToWaste = _data["volumeToWaste"];
            this.totalSourceCost = _data["totalSourceCost"];
            this.totalProcessCost = _data["totalProcessCost"];
            this.totalAddCost = _data["totalAddCost"];
            this.totalCostPrice = _data["totalCostPrice"];
            this.noOfSource = _data["noOfSource"];
            this.noOfProcess = _data["noOfProcess"];
            this.noOfFinished = _data["noOfFinished"];
            this.totalProductionTime = _data["totalProductionTime"];
            this.totalWeight = _data["totalWeight"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.createdByID = _data["createdByID"];
            this.dateTimeLastModified = _data["dateTimeLastModified"] ? new Date(_data["dateTimeLastModified"].toString()) : <any>undefined;
            this.dateTimeProcessed = _data["dateTimeProcessed"] ? new Date(_data["dateTimeProcessed"].toString()) : <any>undefined;
            this.processedByID = _data["processedByID"];
            this.journeyID = _data["journeyID"];
            this.needsCollection = _data["needsCollection"];
            this.collectionJourneyID = _data["collectionJourneyID"];
            this.printed = _data["printed"];
            this.scheduleLabelPrinted = _data["scheduleLabelPrinted"];
            this.totalProcessLeadTime = _data["totalProcessLeadTime"];
            this.generatedOrder = _data["generatedOrder"];
            this.wmsType = _data["wmsType"];
            this.wmsCreatedFromWorksOrderID = _data["wmsCreatedFromWorksOrderID"];
            this.wmsStatus = _data["wmsStatus"];
            this.isOnQuote = _data["isOnQuote"];
            this.lastModifiedByID = _data["lastModifiedByID"];
            this.calculatedDateRequired = _data["calculatedDateRequired"];
            this.wmsHold = _data["wmsHold"];
            this.isNested = _data["isNested"];
            this.nestingAllowRotation = _data["nestingAllowRotation"];
            this.requiresStock = _data["requiresStock"];
            this.overrideUserID = _data["overrideUserID"];
            this.overrideDateTime = _data["overrideDateTime"] ? new Date(_data["overrideDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WorksOrderHeader {
        data = typeof data === 'object' ? data : {};
        let result = new WorksOrderHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["worksOrderID"] = this.worksOrderID;
        data["deleted"] = this.deleted;
        data["worksOrderNumber"] = this.worksOrderNumber;
        data["worksOrderStatus"] = this.worksOrderStatus;
        data["template"] = this.template;
        data["stockAllocated"] = this.stockAllocated;
        data["branchID"] = this.branchID;
        data["orderID"] = this.orderID;
        data["description"] = this.description;
        data["dateRequired"] = this.dateRequired ? this.dateRequired.toISOString() : <any>undefined;
        data["dateRequiredOption"] = this.dateRequiredOption;
        data["startManufactureBy"] = this.startManufactureBy ? this.startManufactureBy.toISOString() : <any>undefined;
        data["machineGroupID"] = this.machineGroupID;
        data["machineID"] = this.machineID;
        data["machineName"] = this.machineName;
        data["operatorName"] = this.operatorName;
        data["shiftID"] = this.shiftID;
        data["supplierID"] = this.supplierID;
        data["processCostsToOrderOnly"] = this.processCostsToOrderOnly;
        data["addCostsToOrderOnly"] = this.addCostsToOrderOnly;
        data["notes"] = this.notes;
        data["noOfPiecesIn"] = this.noOfPiecesIn;
        data["totalLengthIn"] = this.totalLengthIn;
        data["totalVolumeIn"] = this.totalVolumeIn;
        data["totalAreaIn"] = this.totalAreaIn;
        data["noOfPiecesOut"] = this.noOfPiecesOut;
        data["totalLengthOut"] = this.totalLengthOut;
        data["totalVolumeOut"] = this.totalVolumeOut;
        data["totalAreaOut"] = this.totalAreaOut;
        data["volumeToOrder"] = this.volumeToOrder;
        data["volumeToStock"] = this.volumeToStock;
        data["volumeToWaste"] = this.volumeToWaste;
        data["totalSourceCost"] = this.totalSourceCost;
        data["totalProcessCost"] = this.totalProcessCost;
        data["totalAddCost"] = this.totalAddCost;
        data["totalCostPrice"] = this.totalCostPrice;
        data["noOfSource"] = this.noOfSource;
        data["noOfProcess"] = this.noOfProcess;
        data["noOfFinished"] = this.noOfFinished;
        data["totalProductionTime"] = this.totalProductionTime;
        data["totalWeight"] = this.totalWeight;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["createdByID"] = this.createdByID;
        data["dateTimeLastModified"] = this.dateTimeLastModified ? this.dateTimeLastModified.toISOString() : <any>undefined;
        data["dateTimeProcessed"] = this.dateTimeProcessed ? this.dateTimeProcessed.toISOString() : <any>undefined;
        data["processedByID"] = this.processedByID;
        data["journeyID"] = this.journeyID;
        data["needsCollection"] = this.needsCollection;
        data["collectionJourneyID"] = this.collectionJourneyID;
        data["printed"] = this.printed;
        data["scheduleLabelPrinted"] = this.scheduleLabelPrinted;
        data["totalProcessLeadTime"] = this.totalProcessLeadTime;
        data["generatedOrder"] = this.generatedOrder;
        data["wmsType"] = this.wmsType;
        data["wmsCreatedFromWorksOrderID"] = this.wmsCreatedFromWorksOrderID;
        data["wmsStatus"] = this.wmsStatus;
        data["isOnQuote"] = this.isOnQuote;
        data["lastModifiedByID"] = this.lastModifiedByID;
        data["calculatedDateRequired"] = this.calculatedDateRequired;
        data["wmsHold"] = this.wmsHold;
        data["isNested"] = this.isNested;
        data["nestingAllowRotation"] = this.nestingAllowRotation;
        data["requiresStock"] = this.requiresStock;
        data["overrideUserID"] = this.overrideUserID;
        data["overrideDateTime"] = this.overrideDateTime ? this.overrideDateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IWorksOrderHeader {
    worksOrderID?: number | undefined;
    deleted?: number | undefined;
    worksOrderNumber?: number | undefined;
    worksOrderStatus?: number | undefined;
    template?: boolean | undefined;
    stockAllocated?: boolean | undefined;
    branchID?: number | undefined;
    orderID?: number | undefined;
    description?: string | undefined;
    dateRequired?: Date | undefined;
    dateRequiredOption?: number | undefined;
    startManufactureBy?: Date | undefined;
    machineGroupID?: number | undefined;
    machineID?: number | undefined;
    machineName?: string | undefined;
    operatorName?: string | undefined;
    shiftID?: number | undefined;
    supplierID?: number | undefined;
    processCostsToOrderOnly?: boolean | undefined;
    addCostsToOrderOnly?: boolean | undefined;
    notes?: string | undefined;
    noOfPiecesIn?: number | undefined;
    totalLengthIn?: number | undefined;
    totalVolumeIn?: number | undefined;
    totalAreaIn?: number | undefined;
    noOfPiecesOut?: number | undefined;
    totalLengthOut?: number | undefined;
    totalVolumeOut?: number | undefined;
    totalAreaOut?: number | undefined;
    volumeToOrder?: number | undefined;
    volumeToStock?: number | undefined;
    volumeToWaste?: number | undefined;
    totalSourceCost?: number | undefined;
    totalProcessCost?: number | undefined;
    totalAddCost?: number | undefined;
    totalCostPrice?: number | undefined;
    noOfSource?: number | undefined;
    noOfProcess?: number | undefined;
    noOfFinished?: number | undefined;
    totalProductionTime?: number | undefined;
    totalWeight?: number | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    dateTimeProcessed?: Date | undefined;
    processedByID?: number | undefined;
    journeyID?: number | undefined;
    needsCollection?: boolean | undefined;
    collectionJourneyID?: number | undefined;
    printed?: boolean | undefined;
    scheduleLabelPrinted?: boolean | undefined;
    totalProcessLeadTime?: number | undefined;
    generatedOrder?: boolean | undefined;
    wmsType?: number | undefined;
    wmsCreatedFromWorksOrderID?: number | undefined;
    wmsStatus?: number | undefined;
    isOnQuote?: boolean | undefined;
    lastModifiedByID?: number | undefined;
    calculatedDateRequired?: boolean | undefined;
    wmsHold?: boolean | undefined;
    isNested?: boolean | undefined;
    nestingAllowRotation?: boolean | undefined;
    requiresStock?: boolean | undefined;
    overrideUserID?: number | undefined;
    overrideDateTime?: Date | undefined;
}

export class WorksOrderProcessHeader implements IWorksOrderProcessHeader {
    worksOrderProcessHeaderID?: number | undefined;
    worksOrderID?: number | undefined;
    description?: string | undefined;
    supplierWillCollect?: boolean | undefined;
    collectFromSupplier?: boolean | undefined;
    supplierID?: number | undefined;
    supplierAddressID?: number | undefined;
    pickedUserID?: number | undefined;
    pickedDateTime?: Date | undefined;
    deliveredOrCollectedUserID?: number | undefined;
    deliveredOrCollectedDateTime?: Date | undefined;
    deliveredOrCollectedReference?: string | undefined;
    readyForCollectionUserID?: number | undefined;
    readyForCollectionDateTime?: Date | undefined;
    receivedUserID?: number | undefined;
    receivedDateTime?: Date | undefined;
    receivedReference?: string | undefined;
    journeyOutID?: number | undefined;
    journeyInID?: number | undefined;
    outputDescription?: string | undefined;
    pickingDueDate?: Date | undefined;
    pickingDueOption?: number | undefined;
    completionDueDate?: Date | undefined;
    completionDueOption?: number | undefined;
    branchID?: number | undefined;

    constructor(data?: IWorksOrderProcessHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.worksOrderProcessHeaderID = _data["worksOrderProcessHeaderID"];
            this.worksOrderID = _data["worksOrderID"];
            this.description = _data["description"];
            this.supplierWillCollect = _data["supplierWillCollect"];
            this.collectFromSupplier = _data["collectFromSupplier"];
            this.supplierID = _data["supplierID"];
            this.supplierAddressID = _data["supplierAddressID"];
            this.pickedUserID = _data["pickedUserID"];
            this.pickedDateTime = _data["pickedDateTime"] ? new Date(_data["pickedDateTime"].toString()) : <any>undefined;
            this.deliveredOrCollectedUserID = _data["deliveredOrCollectedUserID"];
            this.deliveredOrCollectedDateTime = _data["deliveredOrCollectedDateTime"] ? new Date(_data["deliveredOrCollectedDateTime"].toString()) : <any>undefined;
            this.deliveredOrCollectedReference = _data["deliveredOrCollectedReference"];
            this.readyForCollectionUserID = _data["readyForCollectionUserID"];
            this.readyForCollectionDateTime = _data["readyForCollectionDateTime"] ? new Date(_data["readyForCollectionDateTime"].toString()) : <any>undefined;
            this.receivedUserID = _data["receivedUserID"];
            this.receivedDateTime = _data["receivedDateTime"] ? new Date(_data["receivedDateTime"].toString()) : <any>undefined;
            this.receivedReference = _data["receivedReference"];
            this.journeyOutID = _data["journeyOutID"];
            this.journeyInID = _data["journeyInID"];
            this.outputDescription = _data["outputDescription"];
            this.pickingDueDate = _data["pickingDueDate"] ? new Date(_data["pickingDueDate"].toString()) : <any>undefined;
            this.pickingDueOption = _data["pickingDueOption"];
            this.completionDueDate = _data["completionDueDate"] ? new Date(_data["completionDueDate"].toString()) : <any>undefined;
            this.completionDueOption = _data["completionDueOption"];
            this.branchID = _data["branchID"];
        }
    }

    static fromJS(data: any): WorksOrderProcessHeader {
        data = typeof data === 'object' ? data : {};
        let result = new WorksOrderProcessHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["worksOrderProcessHeaderID"] = this.worksOrderProcessHeaderID;
        data["worksOrderID"] = this.worksOrderID;
        data["description"] = this.description;
        data["supplierWillCollect"] = this.supplierWillCollect;
        data["collectFromSupplier"] = this.collectFromSupplier;
        data["supplierID"] = this.supplierID;
        data["supplierAddressID"] = this.supplierAddressID;
        data["pickedUserID"] = this.pickedUserID;
        data["pickedDateTime"] = this.pickedDateTime ? this.pickedDateTime.toISOString() : <any>undefined;
        data["deliveredOrCollectedUserID"] = this.deliveredOrCollectedUserID;
        data["deliveredOrCollectedDateTime"] = this.deliveredOrCollectedDateTime ? this.deliveredOrCollectedDateTime.toISOString() : <any>undefined;
        data["deliveredOrCollectedReference"] = this.deliveredOrCollectedReference;
        data["readyForCollectionUserID"] = this.readyForCollectionUserID;
        data["readyForCollectionDateTime"] = this.readyForCollectionDateTime ? this.readyForCollectionDateTime.toISOString() : <any>undefined;
        data["receivedUserID"] = this.receivedUserID;
        data["receivedDateTime"] = this.receivedDateTime ? this.receivedDateTime.toISOString() : <any>undefined;
        data["receivedReference"] = this.receivedReference;
        data["journeyOutID"] = this.journeyOutID;
        data["journeyInID"] = this.journeyInID;
        data["outputDescription"] = this.outputDescription;
        data["pickingDueDate"] = this.pickingDueDate ? this.pickingDueDate.toISOString() : <any>undefined;
        data["pickingDueOption"] = this.pickingDueOption;
        data["completionDueDate"] = this.completionDueDate ? this.completionDueDate.toISOString() : <any>undefined;
        data["completionDueOption"] = this.completionDueOption;
        data["branchID"] = this.branchID;
        return data; 
    }
}

export interface IWorksOrderProcessHeader {
    worksOrderProcessHeaderID?: number | undefined;
    worksOrderID?: number | undefined;
    description?: string | undefined;
    supplierWillCollect?: boolean | undefined;
    collectFromSupplier?: boolean | undefined;
    supplierID?: number | undefined;
    supplierAddressID?: number | undefined;
    pickedUserID?: number | undefined;
    pickedDateTime?: Date | undefined;
    deliveredOrCollectedUserID?: number | undefined;
    deliveredOrCollectedDateTime?: Date | undefined;
    deliveredOrCollectedReference?: string | undefined;
    readyForCollectionUserID?: number | undefined;
    readyForCollectionDateTime?: Date | undefined;
    receivedUserID?: number | undefined;
    receivedDateTime?: Date | undefined;
    receivedReference?: string | undefined;
    journeyOutID?: number | undefined;
    journeyInID?: number | undefined;
    outputDescription?: string | undefined;
    pickingDueDate?: Date | undefined;
    pickingDueOption?: number | undefined;
    completionDueDate?: Date | undefined;
    completionDueOption?: number | undefined;
    branchID?: number | undefined;
}

export class PurchaseOrderLineAllocation implements IPurchaseOrderLineAllocation {
    orderID?: number | undefined;
    orderLineID?: number | undefined;
    purchaseOrderLineID?: number | undefined;
    orderNumber?: number | undefined;
    customerID?: number | undefined;
    customerName?: string | undefined;
    purchaseOrderQuantity?: number | undefined;
    branchID?: number | undefined;

    constructor(data?: IPurchaseOrderLineAllocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderID = _data["orderID"];
            this.orderLineID = _data["orderLineID"];
            this.purchaseOrderLineID = _data["purchaseOrderLineID"];
            this.orderNumber = _data["orderNumber"];
            this.customerID = _data["customerID"];
            this.customerName = _data["customerName"];
            this.purchaseOrderQuantity = _data["purchaseOrderQuantity"];
            this.branchID = _data["branchID"];
        }
    }

    static fromJS(data: any): PurchaseOrderLineAllocation {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderLineAllocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderID"] = this.orderID;
        data["orderLineID"] = this.orderLineID;
        data["purchaseOrderLineID"] = this.purchaseOrderLineID;
        data["orderNumber"] = this.orderNumber;
        data["customerID"] = this.customerID;
        data["customerName"] = this.customerName;
        data["purchaseOrderQuantity"] = this.purchaseOrderQuantity;
        data["branchID"] = this.branchID;
        return data; 
    }
}

export interface IPurchaseOrderLineAllocation {
    orderID?: number | undefined;
    orderLineID?: number | undefined;
    purchaseOrderLineID?: number | undefined;
    orderNumber?: number | undefined;
    customerID?: number | undefined;
    customerName?: string | undefined;
    purchaseOrderQuantity?: number | undefined;
    branchID?: number | undefined;
}

export class LinesForPurchaseOrder implements ILinesForPurchaseOrder {
    purchaseOrderLineID?: number | undefined;
    toBranchID?: number | undefined;
    quantity?: number | undefined;
    orderID?: number | undefined;
    orderLineID?: number | undefined;
    transferQuantity?: number | undefined;
    orderNumber?: number | undefined;

    constructor(data?: ILinesForPurchaseOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseOrderLineID = _data["purchaseOrderLineID"];
            this.toBranchID = _data["toBranchID"];
            this.quantity = _data["quantity"];
            this.orderID = _data["orderID"];
            this.orderLineID = _data["orderLineID"];
            this.transferQuantity = _data["transferQuantity"];
            this.orderNumber = _data["orderNumber"];
        }
    }

    static fromJS(data: any): LinesForPurchaseOrder {
        data = typeof data === 'object' ? data : {};
        let result = new LinesForPurchaseOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseOrderLineID"] = this.purchaseOrderLineID;
        data["toBranchID"] = this.toBranchID;
        data["quantity"] = this.quantity;
        data["orderID"] = this.orderID;
        data["orderLineID"] = this.orderLineID;
        data["transferQuantity"] = this.transferQuantity;
        data["orderNumber"] = this.orderNumber;
        return data; 
    }
}

export interface ILinesForPurchaseOrder {
    purchaseOrderLineID?: number | undefined;
    toBranchID?: number | undefined;
    quantity?: number | undefined;
    orderID?: number | undefined;
    orderLineID?: number | undefined;
    transferQuantity?: number | undefined;
    orderNumber?: number | undefined;
}

export class PurchaseOrderLineAdditionalCostCharge implements IPurchaseOrderLineAdditionalCostCharge {
    purchaseOrderLineAddCostChargeID?: number | undefined;
    purchaseOrderAddCostChargeID?: number | undefined;
    additionalCostChargeID?: number | undefined;
    purchaseOrderID?: number | undefined;
    purchaseOrderLineID?: number | undefined;
    additionalCost?: number | undefined;
    additionalCostInCurrency?: number | undefined;
    deleted?: number | undefined;
    invoiced?: boolean | undefined;

    constructor(data?: IPurchaseOrderLineAdditionalCostCharge) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseOrderLineAddCostChargeID = _data["purchaseOrderLineAddCostChargeID"];
            this.purchaseOrderAddCostChargeID = _data["purchaseOrderAddCostChargeID"];
            this.additionalCostChargeID = _data["additionalCostChargeID"];
            this.purchaseOrderID = _data["purchaseOrderID"];
            this.purchaseOrderLineID = _data["purchaseOrderLineID"];
            this.additionalCost = _data["additionalCost"];
            this.additionalCostInCurrency = _data["additionalCostInCurrency"];
            this.deleted = _data["deleted"];
            this.invoiced = _data["invoiced"];
        }
    }

    static fromJS(data: any): PurchaseOrderLineAdditionalCostCharge {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderLineAdditionalCostCharge();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseOrderLineAddCostChargeID"] = this.purchaseOrderLineAddCostChargeID;
        data["purchaseOrderAddCostChargeID"] = this.purchaseOrderAddCostChargeID;
        data["additionalCostChargeID"] = this.additionalCostChargeID;
        data["purchaseOrderID"] = this.purchaseOrderID;
        data["purchaseOrderLineID"] = this.purchaseOrderLineID;
        data["additionalCost"] = this.additionalCost;
        data["additionalCostInCurrency"] = this.additionalCostInCurrency;
        data["deleted"] = this.deleted;
        data["invoiced"] = this.invoiced;
        return data; 
    }
}

export interface IPurchaseOrderLineAdditionalCostCharge {
    purchaseOrderLineAddCostChargeID?: number | undefined;
    purchaseOrderAddCostChargeID?: number | undefined;
    additionalCostChargeID?: number | undefined;
    purchaseOrderID?: number | undefined;
    purchaseOrderLineID?: number | undefined;
    additionalCost?: number | undefined;
    additionalCostInCurrency?: number | undefined;
    deleted?: number | undefined;
    invoiced?: boolean | undefined;
}

export class StockReceiptLineItems implements IStockReceiptLineItems {
    stockReceiptItemID?: number | undefined;
    stockReceiptLineID?: number | undefined;
    stockReceiptID?: number | undefined;
    plateID?: number | undefined;
    plateNumber?: string | undefined;
    testCertNumber?: string | undefined;
    pages?: string | undefined;
    unitWeight?: number | undefined;
    countryID?: number | undefined;
    stockLocationID?: number | undefined;
    notes?: string | undefined;
    plateStatus?: number | undefined;
    stockUpdated?: boolean | undefined;
    indexed?: boolean | undefined;
    countryName?: string | undefined;
    stockLocationName?: string | undefined;

    constructor(data?: IStockReceiptLineItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockReceiptItemID = _data["stockReceiptItemID"];
            this.stockReceiptLineID = _data["stockReceiptLineID"];
            this.stockReceiptID = _data["stockReceiptID"];
            this.plateID = _data["plateID"];
            this.plateNumber = _data["plateNumber"];
            this.testCertNumber = _data["testCertNumber"];
            this.pages = _data["pages"];
            this.unitWeight = _data["unitWeight"];
            this.countryID = _data["countryID"];
            this.stockLocationID = _data["stockLocationID"];
            this.notes = _data["notes"];
            this.plateStatus = _data["plateStatus"];
            this.stockUpdated = _data["stockUpdated"];
            this.indexed = _data["indexed"];
            this.countryName = _data["countryName"];
            this.stockLocationName = _data["stockLocationName"];
        }
    }

    static fromJS(data: any): StockReceiptLineItems {
        data = typeof data === 'object' ? data : {};
        let result = new StockReceiptLineItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockReceiptItemID"] = this.stockReceiptItemID;
        data["stockReceiptLineID"] = this.stockReceiptLineID;
        data["stockReceiptID"] = this.stockReceiptID;
        data["plateID"] = this.plateID;
        data["plateNumber"] = this.plateNumber;
        data["testCertNumber"] = this.testCertNumber;
        data["pages"] = this.pages;
        data["unitWeight"] = this.unitWeight;
        data["countryID"] = this.countryID;
        data["stockLocationID"] = this.stockLocationID;
        data["notes"] = this.notes;
        data["plateStatus"] = this.plateStatus;
        data["stockUpdated"] = this.stockUpdated;
        data["indexed"] = this.indexed;
        data["countryName"] = this.countryName;
        data["stockLocationName"] = this.stockLocationName;
        return data; 
    }
}

export interface IStockReceiptLineItems {
    stockReceiptItemID?: number | undefined;
    stockReceiptLineID?: number | undefined;
    stockReceiptID?: number | undefined;
    plateID?: number | undefined;
    plateNumber?: string | undefined;
    testCertNumber?: string | undefined;
    pages?: string | undefined;
    unitWeight?: number | undefined;
    countryID?: number | undefined;
    stockLocationID?: number | undefined;
    notes?: string | undefined;
    plateStatus?: number | undefined;
    stockUpdated?: boolean | undefined;
    indexed?: boolean | undefined;
    countryName?: string | undefined;
    stockLocationName?: string | undefined;
}

export class StockReceiptPack implements IStockReceiptPack {
    stockReceiptPackID?: number | undefined;
    stockReceiptLineID?: number | undefined;
    stockReceiptID?: number | undefined;
    productID?: number | undefined;
    packID?: number | undefined;
    stockLocationID?: number | undefined;
    binLocation?: string | undefined;
    packRef?: string | undefined;
    packStatus?: number | undefined;
    packSubStatus?: number | undefined;
    packType?: number | undefined;
    contractRef?: string | undefined;
    contractPeriod?: string | undefined;
    countryOfOriginID?: number | undefined;
    timberMill?: string | undefined;
    ship?: string | undefined;
    voyage?: string | undefined;
    bolRef?: string | undefined;
    shippingRef?: string | undefined;
    ourPackMark?: string | undefined;
    barCodeNumber?: number | undefined;
    barCodeSuffix?: string | undefined;
    environmentalStatusID?: number | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    primaryLength?: number | undefined;
    totalLengthImperial?: number | undefined;
    totalVolumeImperial?: number | undefined;
    totalCost?: number | undefined;
    additionalCost?: number | undefined;
    notes?: string | undefined;
    stockUpdated?: boolean | undefined;
    productBatchID?: number | undefined;
    priceSurchargePercent?: number | undefined;
    heatNumber?: string | undefined;
    totalReceivedWeight?: number | undefined;
    coil?: string | undefined;
    tag?: string | undefined;
    stockLocationName?: string | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    productCode?: string | undefined;
    productDescription?: string | undefined;
    perRuleID?: number | undefined;
    productThickness?: number | undefined;
    productWidth?: number | undefined;
    productLength?: number | undefined;
    productWeight?: number | undefined;
    weightPerID?: number | undefined;
    productImperial?: boolean | undefined;
    productTallyLengths?: string | undefined;
    productTallyLengthsPerID?: number | undefined;
    productAvailableWidths?: string | undefined;
    productStockControlByLength?: boolean | undefined;
    productMaterialGradeID?: number | undefined;
    productDefaultPiecesPerPack?: number | undefined;
    productEnvironmentalStatusID?: number | undefined;
    stockPerID?: number | undefined;
    inputPerID?: number | undefined;
    inputPerCode?: string | undefined;
    productPackStatus?: number | undefined;
    totalAreaImperial?: number | undefined;
    totalArea?: number | undefined;

    constructor(data?: IStockReceiptPack) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stockReceiptPackID = _data["stockReceiptPackID"];
            this.stockReceiptLineID = _data["stockReceiptLineID"];
            this.stockReceiptID = _data["stockReceiptID"];
            this.productID = _data["productID"];
            this.packID = _data["packID"];
            this.stockLocationID = _data["stockLocationID"];
            this.binLocation = _data["binLocation"];
            this.packRef = _data["packRef"];
            this.packStatus = _data["packStatus"];
            this.packSubStatus = _data["packSubStatus"];
            this.packType = _data["packType"];
            this.contractRef = _data["contractRef"];
            this.contractPeriod = _data["contractPeriod"];
            this.countryOfOriginID = _data["countryOfOriginID"];
            this.timberMill = _data["timberMill"];
            this.ship = _data["ship"];
            this.voyage = _data["voyage"];
            this.bolRef = _data["bolRef"];
            this.shippingRef = _data["shippingRef"];
            this.ourPackMark = _data["ourPackMark"];
            this.barCodeNumber = _data["barCodeNumber"];
            this.barCodeSuffix = _data["barCodeSuffix"];
            this.environmentalStatusID = _data["environmentalStatusID"];
            this.quantityTally = _data["quantityTally"];
            this.noOfPieces = _data["noOfPieces"];
            this.totalWeight = _data["totalWeight"];
            this.totalLength = _data["totalLength"];
            this.totalVolume = _data["totalVolume"];
            this.primaryLength = _data["primaryLength"];
            this.totalLengthImperial = _data["totalLengthImperial"];
            this.totalVolumeImperial = _data["totalVolumeImperial"];
            this.totalCost = _data["totalCost"];
            this.additionalCost = _data["additionalCost"];
            this.notes = _data["notes"];
            this.stockUpdated = _data["stockUpdated"];
            this.productBatchID = _data["productBatchID"];
            this.priceSurchargePercent = _data["priceSurchargePercent"];
            this.heatNumber = _data["heatNumber"];
            this.totalReceivedWeight = _data["totalReceivedWeight"];
            this.coil = _data["coil"];
            this.tag = _data["tag"];
            this.stockLocationName = _data["stockLocationName"];
            this.productType = _data["productType"];
            this.productSubType = _data["productSubType"];
            this.productCode = _data["productCode"];
            this.productDescription = _data["productDescription"];
            this.perRuleID = _data["perRuleID"];
            this.productThickness = _data["productThickness"];
            this.productWidth = _data["productWidth"];
            this.productLength = _data["productLength"];
            this.productWeight = _data["productWeight"];
            this.weightPerID = _data["weightPerID"];
            this.productImperial = _data["productImperial"];
            this.productTallyLengths = _data["productTallyLengths"];
            this.productTallyLengthsPerID = _data["productTallyLengthsPerID"];
            this.productAvailableWidths = _data["productAvailableWidths"];
            this.productStockControlByLength = _data["productStockControlByLength"];
            this.productMaterialGradeID = _data["productMaterialGradeID"];
            this.productDefaultPiecesPerPack = _data["productDefaultPiecesPerPack"];
            this.productEnvironmentalStatusID = _data["productEnvironmentalStatusID"];
            this.stockPerID = _data["stockPerID"];
            this.inputPerID = _data["inputPerID"];
            this.inputPerCode = _data["inputPerCode"];
            this.productPackStatus = _data["productPackStatus"];
            this.totalAreaImperial = _data["totalAreaImperial"];
            this.totalArea = _data["totalArea"];
        }
    }

    static fromJS(data: any): StockReceiptPack {
        data = typeof data === 'object' ? data : {};
        let result = new StockReceiptPack();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stockReceiptPackID"] = this.stockReceiptPackID;
        data["stockReceiptLineID"] = this.stockReceiptLineID;
        data["stockReceiptID"] = this.stockReceiptID;
        data["productID"] = this.productID;
        data["packID"] = this.packID;
        data["stockLocationID"] = this.stockLocationID;
        data["binLocation"] = this.binLocation;
        data["packRef"] = this.packRef;
        data["packStatus"] = this.packStatus;
        data["packSubStatus"] = this.packSubStatus;
        data["packType"] = this.packType;
        data["contractRef"] = this.contractRef;
        data["contractPeriod"] = this.contractPeriod;
        data["countryOfOriginID"] = this.countryOfOriginID;
        data["timberMill"] = this.timberMill;
        data["ship"] = this.ship;
        data["voyage"] = this.voyage;
        data["bolRef"] = this.bolRef;
        data["shippingRef"] = this.shippingRef;
        data["ourPackMark"] = this.ourPackMark;
        data["barCodeNumber"] = this.barCodeNumber;
        data["barCodeSuffix"] = this.barCodeSuffix;
        data["environmentalStatusID"] = this.environmentalStatusID;
        data["quantityTally"] = this.quantityTally;
        data["noOfPieces"] = this.noOfPieces;
        data["totalWeight"] = this.totalWeight;
        data["totalLength"] = this.totalLength;
        data["totalVolume"] = this.totalVolume;
        data["primaryLength"] = this.primaryLength;
        data["totalLengthImperial"] = this.totalLengthImperial;
        data["totalVolumeImperial"] = this.totalVolumeImperial;
        data["totalCost"] = this.totalCost;
        data["additionalCost"] = this.additionalCost;
        data["notes"] = this.notes;
        data["stockUpdated"] = this.stockUpdated;
        data["productBatchID"] = this.productBatchID;
        data["priceSurchargePercent"] = this.priceSurchargePercent;
        data["heatNumber"] = this.heatNumber;
        data["totalReceivedWeight"] = this.totalReceivedWeight;
        data["coil"] = this.coil;
        data["tag"] = this.tag;
        data["stockLocationName"] = this.stockLocationName;
        data["productType"] = this.productType;
        data["productSubType"] = this.productSubType;
        data["productCode"] = this.productCode;
        data["productDescription"] = this.productDescription;
        data["perRuleID"] = this.perRuleID;
        data["productThickness"] = this.productThickness;
        data["productWidth"] = this.productWidth;
        data["productLength"] = this.productLength;
        data["productWeight"] = this.productWeight;
        data["weightPerID"] = this.weightPerID;
        data["productImperial"] = this.productImperial;
        data["productTallyLengths"] = this.productTallyLengths;
        data["productTallyLengthsPerID"] = this.productTallyLengthsPerID;
        data["productAvailableWidths"] = this.productAvailableWidths;
        data["productStockControlByLength"] = this.productStockControlByLength;
        data["productMaterialGradeID"] = this.productMaterialGradeID;
        data["productDefaultPiecesPerPack"] = this.productDefaultPiecesPerPack;
        data["productEnvironmentalStatusID"] = this.productEnvironmentalStatusID;
        data["stockPerID"] = this.stockPerID;
        data["inputPerID"] = this.inputPerID;
        data["inputPerCode"] = this.inputPerCode;
        data["productPackStatus"] = this.productPackStatus;
        data["totalAreaImperial"] = this.totalAreaImperial;
        data["totalArea"] = this.totalArea;
        return data; 
    }
}

export interface IStockReceiptPack {
    stockReceiptPackID?: number | undefined;
    stockReceiptLineID?: number | undefined;
    stockReceiptID?: number | undefined;
    productID?: number | undefined;
    packID?: number | undefined;
    stockLocationID?: number | undefined;
    binLocation?: string | undefined;
    packRef?: string | undefined;
    packStatus?: number | undefined;
    packSubStatus?: number | undefined;
    packType?: number | undefined;
    contractRef?: string | undefined;
    contractPeriod?: string | undefined;
    countryOfOriginID?: number | undefined;
    timberMill?: string | undefined;
    ship?: string | undefined;
    voyage?: string | undefined;
    bolRef?: string | undefined;
    shippingRef?: string | undefined;
    ourPackMark?: string | undefined;
    barCodeNumber?: number | undefined;
    barCodeSuffix?: string | undefined;
    environmentalStatusID?: number | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    primaryLength?: number | undefined;
    totalLengthImperial?: number | undefined;
    totalVolumeImperial?: number | undefined;
    totalCost?: number | undefined;
    additionalCost?: number | undefined;
    notes?: string | undefined;
    stockUpdated?: boolean | undefined;
    productBatchID?: number | undefined;
    priceSurchargePercent?: number | undefined;
    heatNumber?: string | undefined;
    totalReceivedWeight?: number | undefined;
    coil?: string | undefined;
    tag?: string | undefined;
    stockLocationName?: string | undefined;
    productType?: number | undefined;
    productSubType?: number | undefined;
    productCode?: string | undefined;
    productDescription?: string | undefined;
    perRuleID?: number | undefined;
    productThickness?: number | undefined;
    productWidth?: number | undefined;
    productLength?: number | undefined;
    productWeight?: number | undefined;
    weightPerID?: number | undefined;
    productImperial?: boolean | undefined;
    productTallyLengths?: string | undefined;
    productTallyLengthsPerID?: number | undefined;
    productAvailableWidths?: string | undefined;
    productStockControlByLength?: boolean | undefined;
    productMaterialGradeID?: number | undefined;
    productDefaultPiecesPerPack?: number | undefined;
    productEnvironmentalStatusID?: number | undefined;
    stockPerID?: number | undefined;
    inputPerID?: number | undefined;
    inputPerCode?: string | undefined;
    productPackStatus?: number | undefined;
    totalAreaImperial?: number | undefined;
    totalArea?: number | undefined;
}

export class StockReceipt_ProductReels implements IStockReceipt_ProductReels {
    reelID?: number | undefined;
    productID?: number | undefined;
    branchID?: number | undefined;
    reelRef?: string | undefined;
    originalLength?: number | undefined;
    purchaseOrderID?: number | undefined;
    purchaseOrderLineID?: number | undefined;
    stockReceiptID?: number | undefined;
    stockReceiptLineID?: number | undefined;
    dateReceived?: Date | undefined;
    stockUpdated?: boolean | undefined;
    purchaseOrderNumber?: number | undefined;
    stockReceiptNumber?: number | undefined;
    supplierName?: string | undefined;
    defaultStockReceiptsToFullyReceived?: boolean | undefined;
    productCode?: string | undefined;
    productDescription?: string | undefined;
    productLength?: number | undefined;
    productImperial?: boolean | undefined;
    stockPerID?: number | undefined;
    stockPerType?: number | undefined;

    constructor(data?: IStockReceipt_ProductReels) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reelID = _data["reelID"];
            this.productID = _data["productID"];
            this.branchID = _data["branchID"];
            this.reelRef = _data["reelRef"];
            this.originalLength = _data["originalLength"];
            this.purchaseOrderID = _data["purchaseOrderID"];
            this.purchaseOrderLineID = _data["purchaseOrderLineID"];
            this.stockReceiptID = _data["stockReceiptID"];
            this.stockReceiptLineID = _data["stockReceiptLineID"];
            this.dateReceived = _data["dateReceived"] ? new Date(_data["dateReceived"].toString()) : <any>undefined;
            this.stockUpdated = _data["stockUpdated"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.stockReceiptNumber = _data["stockReceiptNumber"];
            this.supplierName = _data["supplierName"];
            this.defaultStockReceiptsToFullyReceived = _data["defaultStockReceiptsToFullyReceived"];
            this.productCode = _data["productCode"];
            this.productDescription = _data["productDescription"];
            this.productLength = _data["productLength"];
            this.productImperial = _data["productImperial"];
            this.stockPerID = _data["stockPerID"];
            this.stockPerType = _data["stockPerType"];
        }
    }

    static fromJS(data: any): StockReceipt_ProductReels {
        data = typeof data === 'object' ? data : {};
        let result = new StockReceipt_ProductReels();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reelID"] = this.reelID;
        data["productID"] = this.productID;
        data["branchID"] = this.branchID;
        data["reelRef"] = this.reelRef;
        data["originalLength"] = this.originalLength;
        data["purchaseOrderID"] = this.purchaseOrderID;
        data["purchaseOrderLineID"] = this.purchaseOrderLineID;
        data["stockReceiptID"] = this.stockReceiptID;
        data["stockReceiptLineID"] = this.stockReceiptLineID;
        data["dateReceived"] = this.dateReceived ? this.dateReceived.toISOString() : <any>undefined;
        data["stockUpdated"] = this.stockUpdated;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["stockReceiptNumber"] = this.stockReceiptNumber;
        data["supplierName"] = this.supplierName;
        data["defaultStockReceiptsToFullyReceived"] = this.defaultStockReceiptsToFullyReceived;
        data["productCode"] = this.productCode;
        data["productDescription"] = this.productDescription;
        data["productLength"] = this.productLength;
        data["productImperial"] = this.productImperial;
        data["stockPerID"] = this.stockPerID;
        data["stockPerType"] = this.stockPerType;
        return data; 
    }
}

export interface IStockReceipt_ProductReels {
    reelID?: number | undefined;
    productID?: number | undefined;
    branchID?: number | undefined;
    reelRef?: string | undefined;
    originalLength?: number | undefined;
    purchaseOrderID?: number | undefined;
    purchaseOrderLineID?: number | undefined;
    stockReceiptID?: number | undefined;
    stockReceiptLineID?: number | undefined;
    dateReceived?: Date | undefined;
    stockUpdated?: boolean | undefined;
    purchaseOrderNumber?: number | undefined;
    stockReceiptNumber?: number | undefined;
    supplierName?: string | undefined;
    defaultStockReceiptsToFullyReceived?: boolean | undefined;
    productCode?: string | undefined;
    productDescription?: string | undefined;
    productLength?: number | undefined;
    productImperial?: boolean | undefined;
    stockPerID?: number | undefined;
    stockPerType?: number | undefined;
}

export class StockReceipt_ProductBatchItems implements IStockReceipt_ProductBatchItems {
    productBatchItemID?: number | undefined;
    deleted?: number | undefined;
    productBatchID?: number | undefined;
    reference?: string | undefined;
    itemStatus?: number | undefined;
    stockReceiptLineID?: number | undefined;
    stockReceiptID?: number | undefined;

    constructor(data?: IStockReceipt_ProductBatchItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productBatchItemID = _data["productBatchItemID"];
            this.deleted = _data["deleted"];
            this.productBatchID = _data["productBatchID"];
            this.reference = _data["reference"];
            this.itemStatus = _data["itemStatus"];
            this.stockReceiptLineID = _data["stockReceiptLineID"];
            this.stockReceiptID = _data["stockReceiptID"];
        }
    }

    static fromJS(data: any): StockReceipt_ProductBatchItems {
        data = typeof data === 'object' ? data : {};
        let result = new StockReceipt_ProductBatchItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productBatchItemID"] = this.productBatchItemID;
        data["deleted"] = this.deleted;
        data["productBatchID"] = this.productBatchID;
        data["reference"] = this.reference;
        data["itemStatus"] = this.itemStatus;
        data["stockReceiptLineID"] = this.stockReceiptLineID;
        data["stockReceiptID"] = this.stockReceiptID;
        return data; 
    }
}

export interface IStockReceipt_ProductBatchItems {
    productBatchItemID?: number | undefined;
    deleted?: number | undefined;
    productBatchID?: number | undefined;
    reference?: string | undefined;
    itemStatus?: number | undefined;
    stockReceiptLineID?: number | undefined;
    stockReceiptID?: number | undefined;
}

export class SupplierReturnsLineItems implements ISupplierReturnsLineItems {
    supplierReturnLineItemID?: number | undefined;
    supplierReturnID?: number | undefined;
    supplierReturnLineID?: number | undefined;
    plateID?: number | undefined;
    packID?: number | undefined;
    productBatchID?: number | undefined;
    productBatchItemID?: number | undefined;
    productBatchQuantity?: number | undefined;
    productBatchQuantityPerID?: number | undefined;
    productBatchQuantityTally?: string | undefined;
    plateNumber?: string | undefined;
    sourcePlateNumber?: string | undefined;
    testCertNumber?: string | undefined;
    pages?: string | undefined;
    batchStockLocationID?: number | undefined;
    batchReference?: string | undefined;
    batchBinLocation?: string | undefined;
    batchItemReference?: string | undefined;
    productCode?: string | undefined;
    description?: string | undefined;
    useThisInputPerID?: number | undefined;
    useThisStockPerConversion?: number | undefined;
    useThisInputPerCode?: string | undefined;
    productBatchQuantityInInputPer?: number | undefined;

    constructor(data?: ISupplierReturnsLineItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierReturnLineItemID = _data["supplierReturnLineItemID"];
            this.supplierReturnID = _data["supplierReturnID"];
            this.supplierReturnLineID = _data["supplierReturnLineID"];
            this.plateID = _data["plateID"];
            this.packID = _data["packID"];
            this.productBatchID = _data["productBatchID"];
            this.productBatchItemID = _data["productBatchItemID"];
            this.productBatchQuantity = _data["productBatchQuantity"];
            this.productBatchQuantityPerID = _data["productBatchQuantityPerID"];
            this.productBatchQuantityTally = _data["productBatchQuantityTally"];
            this.plateNumber = _data["plateNumber"];
            this.sourcePlateNumber = _data["sourcePlateNumber"];
            this.testCertNumber = _data["testCertNumber"];
            this.pages = _data["pages"];
            this.batchStockLocationID = _data["batchStockLocationID"];
            this.batchReference = _data["batchReference"];
            this.batchBinLocation = _data["batchBinLocation"];
            this.batchItemReference = _data["batchItemReference"];
            this.productCode = _data["productCode"];
            this.description = _data["description"];
            this.useThisInputPerID = _data["useThisInputPerID"];
            this.useThisStockPerConversion = _data["useThisStockPerConversion"];
            this.useThisInputPerCode = _data["useThisInputPerCode"];
            this.productBatchQuantityInInputPer = _data["productBatchQuantityInInputPer"];
        }
    }

    static fromJS(data: any): SupplierReturnsLineItems {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierReturnsLineItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierReturnLineItemID"] = this.supplierReturnLineItemID;
        data["supplierReturnID"] = this.supplierReturnID;
        data["supplierReturnLineID"] = this.supplierReturnLineID;
        data["plateID"] = this.plateID;
        data["packID"] = this.packID;
        data["productBatchID"] = this.productBatchID;
        data["productBatchItemID"] = this.productBatchItemID;
        data["productBatchQuantity"] = this.productBatchQuantity;
        data["productBatchQuantityPerID"] = this.productBatchQuantityPerID;
        data["productBatchQuantityTally"] = this.productBatchQuantityTally;
        data["plateNumber"] = this.plateNumber;
        data["sourcePlateNumber"] = this.sourcePlateNumber;
        data["testCertNumber"] = this.testCertNumber;
        data["pages"] = this.pages;
        data["batchStockLocationID"] = this.batchStockLocationID;
        data["batchReference"] = this.batchReference;
        data["batchBinLocation"] = this.batchBinLocation;
        data["batchItemReference"] = this.batchItemReference;
        data["productCode"] = this.productCode;
        data["description"] = this.description;
        data["useThisInputPerID"] = this.useThisInputPerID;
        data["useThisStockPerConversion"] = this.useThisStockPerConversion;
        data["useThisInputPerCode"] = this.useThisInputPerCode;
        data["productBatchQuantityInInputPer"] = this.productBatchQuantityInInputPer;
        return data; 
    }
}

export interface ISupplierReturnsLineItems {
    supplierReturnLineItemID?: number | undefined;
    supplierReturnID?: number | undefined;
    supplierReturnLineID?: number | undefined;
    plateID?: number | undefined;
    packID?: number | undefined;
    productBatchID?: number | undefined;
    productBatchItemID?: number | undefined;
    productBatchQuantity?: number | undefined;
    productBatchQuantityPerID?: number | undefined;
    productBatchQuantityTally?: string | undefined;
    plateNumber?: string | undefined;
    sourcePlateNumber?: string | undefined;
    testCertNumber?: string | undefined;
    pages?: string | undefined;
    batchStockLocationID?: number | undefined;
    batchReference?: string | undefined;
    batchBinLocation?: string | undefined;
    batchItemReference?: string | undefined;
    productCode?: string | undefined;
    description?: string | undefined;
    useThisInputPerID?: number | undefined;
    useThisStockPerConversion?: number | undefined;
    useThisInputPerCode?: string | undefined;
    productBatchQuantityInInputPer?: number | undefined;
}

export class ProductImage implements IProductImage {
    productID?: number | undefined;
    imageNumber?: number | undefined;
    image?: string | undefined;

    constructor(data?: IProductImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productID = _data["productID"];
            this.imageNumber = _data["imageNumber"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): ProductImage {
        data = typeof data === 'object' ? data : {};
        let result = new ProductImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productID"] = this.productID;
        data["imageNumber"] = this.imageNumber;
        data["image"] = this.image;
        return data; 
    }
}

export interface IProductImage {
    productID?: number | undefined;
    imageNumber?: number | undefined;
    image?: string | undefined;
}

export class Stock implements IStock {
    branchID?: number | undefined;
    stockLocationID?: number | undefined;
    productID?: number | undefined;
    stockActual?: number | undefined;
    stockAvailable?: number | undefined;
    stockOnOrder?: number | undefined;
    stockDue?: number | undefined;
    stockAllocated?: number | undefined;
    stockReserved?: number | undefined;
    stockSuspense?: number | undefined;
    stockThirdParty?: number | undefined;
    stockAwaitingProcess?: number | undefined;
    stockAwaitingProcessNotAvailable?: number | undefined;

    constructor(data?: IStock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchID = _data["branchID"];
            this.stockLocationID = _data["stockLocationID"];
            this.productID = _data["productID"];
            this.stockActual = _data["stockActual"];
            this.stockAvailable = _data["stockAvailable"];
            this.stockOnOrder = _data["stockOnOrder"];
            this.stockDue = _data["stockDue"];
            this.stockAllocated = _data["stockAllocated"];
            this.stockReserved = _data["stockReserved"];
            this.stockSuspense = _data["stockSuspense"];
            this.stockThirdParty = _data["stockThirdParty"];
            this.stockAwaitingProcess = _data["stockAwaitingProcess"];
            this.stockAwaitingProcessNotAvailable = _data["stockAwaitingProcessNotAvailable"];
        }
    }

    static fromJS(data: any): Stock {
        data = typeof data === 'object' ? data : {};
        let result = new Stock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchID"] = this.branchID;
        data["stockLocationID"] = this.stockLocationID;
        data["productID"] = this.productID;
        data["stockActual"] = this.stockActual;
        data["stockAvailable"] = this.stockAvailable;
        data["stockOnOrder"] = this.stockOnOrder;
        data["stockDue"] = this.stockDue;
        data["stockAllocated"] = this.stockAllocated;
        data["stockReserved"] = this.stockReserved;
        data["stockSuspense"] = this.stockSuspense;
        data["stockThirdParty"] = this.stockThirdParty;
        data["stockAwaitingProcess"] = this.stockAwaitingProcess;
        data["stockAwaitingProcessNotAvailable"] = this.stockAwaitingProcessNotAvailable;
        return data; 
    }
}

export interface IStock {
    branchID?: number | undefined;
    stockLocationID?: number | undefined;
    productID?: number | undefined;
    stockActual?: number | undefined;
    stockAvailable?: number | undefined;
    stockOnOrder?: number | undefined;
    stockDue?: number | undefined;
    stockAllocated?: number | undefined;
    stockReserved?: number | undefined;
    stockSuspense?: number | undefined;
    stockThirdParty?: number | undefined;
    stockAwaitingProcess?: number | undefined;
    stockAwaitingProcessNotAvailable?: number | undefined;
}

export class ProductStockOption implements IProductStockOption {
    productID?: number | undefined;
    branchID?: number | undefined;
    stocked?: boolean | undefined;
    stockClass?: string | undefined;
    howSourced?: number | undefined;
    transferBranchID?: number | undefined;
    manufactureBranchID?: number | undefined;
    purchaseAndTransferBranchID?: number | undefined;
    leadTime?: number | undefined;
    weeksCover?: number | undefined;
    stockLevelMin?: number | undefined;
    stockLevelMax?: number | undefined;
    shelfLife?: number | undefined;
    stockCountGroup?: string | undefined;
    binLocation?: string | undefined;
    commissionCodeID?: number | undefined;
    productManagerID?: number | undefined;
    pickingZone?: string | undefined;
    dateTimeLastCounted?: Date | undefined;
    dateLastAged?: Date | undefined;
    averageAge?: number | undefined;
    stockCountID?: number | undefined;
    stockCountLineNumber?: number | undefined;
    fullStockTurn?: number | undefined;
    fullStockAge?: number | undefined;
    gmroi?: number | undefined;
    periodsAnalysed?: number | undefined;
    standardPurchase?: boolean | undefined;
    defaultLabelTemplateID?: number | undefined;
    useMemoQuantityInput?: boolean | undefined;
    useActualCostForPacks?: boolean | undefined;
    packsAreTagged?: boolean | undefined;
    keepUntaggedPackRecords?: boolean | undefined;
    packPurchasing?: number | undefined;
    packSelling?: number | undefined;
    productBatchTypeID?: number | undefined;
    vmi?: boolean | undefined;
    dateFirstStocked?: Date | undefined;
    sellingQuantityBreakID?: number | undefined;
    pickingRequired?: boolean | undefined;
    allowSettlementDiscount?: boolean | undefined;
    skipStockWarning?: boolean | undefined;
    priceSensitivityID?: number | undefined;
    quickTallyAVOID?: number | undefined;
    quickTallyAVOOptionID?: number | undefined;
    quickTallyAVOProductionTimeMultiplier?: number | undefined;
    quickTallyAVOPriceMultiplier?: number | undefined;
    inputPerID?: number | undefined;
    seasonalityID?: number | undefined;
    averageValuation?: number | undefined;
    orderEntryManufacturedKitID?: number | undefined;
    sellPriceRounding?: number | undefined;
    sellPriceRoundingOption?: number | undefined;
    sellPriceRoundingPerID?: number | undefined;

    constructor(data?: IProductStockOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productID = _data["productID"];
            this.branchID = _data["branchID"];
            this.stocked = _data["stocked"];
            this.stockClass = _data["stockClass"];
            this.howSourced = _data["howSourced"];
            this.transferBranchID = _data["transferBranchID"];
            this.manufactureBranchID = _data["manufactureBranchID"];
            this.purchaseAndTransferBranchID = _data["purchaseAndTransferBranchID"];
            this.leadTime = _data["leadTime"];
            this.weeksCover = _data["weeksCover"];
            this.stockLevelMin = _data["stockLevelMin"];
            this.stockLevelMax = _data["stockLevelMax"];
            this.shelfLife = _data["shelfLife"];
            this.stockCountGroup = _data["stockCountGroup"];
            this.binLocation = _data["binLocation"];
            this.commissionCodeID = _data["commissionCodeID"];
            this.productManagerID = _data["productManagerID"];
            this.pickingZone = _data["pickingZone"];
            this.dateTimeLastCounted = _data["dateTimeLastCounted"] ? new Date(_data["dateTimeLastCounted"].toString()) : <any>undefined;
            this.dateLastAged = _data["dateLastAged"] ? new Date(_data["dateLastAged"].toString()) : <any>undefined;
            this.averageAge = _data["averageAge"];
            this.stockCountID = _data["stockCountID"];
            this.stockCountLineNumber = _data["stockCountLineNumber"];
            this.fullStockTurn = _data["fullStockTurn"];
            this.fullStockAge = _data["fullStockAge"];
            this.gmroi = _data["gmroi"];
            this.periodsAnalysed = _data["periodsAnalysed"];
            this.standardPurchase = _data["standardPurchase"];
            this.defaultLabelTemplateID = _data["defaultLabelTemplateID"];
            this.useMemoQuantityInput = _data["useMemoQuantityInput"];
            this.useActualCostForPacks = _data["useActualCostForPacks"];
            this.packsAreTagged = _data["packsAreTagged"];
            this.keepUntaggedPackRecords = _data["keepUntaggedPackRecords"];
            this.packPurchasing = _data["packPurchasing"];
            this.packSelling = _data["packSelling"];
            this.productBatchTypeID = _data["productBatchTypeID"];
            this.vmi = _data["vmi"];
            this.dateFirstStocked = _data["dateFirstStocked"] ? new Date(_data["dateFirstStocked"].toString()) : <any>undefined;
            this.sellingQuantityBreakID = _data["sellingQuantityBreakID"];
            this.pickingRequired = _data["pickingRequired"];
            this.allowSettlementDiscount = _data["allowSettlementDiscount"];
            this.skipStockWarning = _data["skipStockWarning"];
            this.priceSensitivityID = _data["priceSensitivityID"];
            this.quickTallyAVOID = _data["quickTallyAVOID"];
            this.quickTallyAVOOptionID = _data["quickTallyAVOOptionID"];
            this.quickTallyAVOProductionTimeMultiplier = _data["quickTallyAVOProductionTimeMultiplier"];
            this.quickTallyAVOPriceMultiplier = _data["quickTallyAVOPriceMultiplier"];
            this.inputPerID = _data["inputPerID"];
            this.seasonalityID = _data["seasonalityID"];
            this.averageValuation = _data["averageValuation"];
            this.orderEntryManufacturedKitID = _data["orderEntryManufacturedKitID"];
            this.sellPriceRounding = _data["sellPriceRounding"];
            this.sellPriceRoundingOption = _data["sellPriceRoundingOption"];
            this.sellPriceRoundingPerID = _data["sellPriceRoundingPerID"];
        }
    }

    static fromJS(data: any): ProductStockOption {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStockOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productID"] = this.productID;
        data["branchID"] = this.branchID;
        data["stocked"] = this.stocked;
        data["stockClass"] = this.stockClass;
        data["howSourced"] = this.howSourced;
        data["transferBranchID"] = this.transferBranchID;
        data["manufactureBranchID"] = this.manufactureBranchID;
        data["purchaseAndTransferBranchID"] = this.purchaseAndTransferBranchID;
        data["leadTime"] = this.leadTime;
        data["weeksCover"] = this.weeksCover;
        data["stockLevelMin"] = this.stockLevelMin;
        data["stockLevelMax"] = this.stockLevelMax;
        data["shelfLife"] = this.shelfLife;
        data["stockCountGroup"] = this.stockCountGroup;
        data["binLocation"] = this.binLocation;
        data["commissionCodeID"] = this.commissionCodeID;
        data["productManagerID"] = this.productManagerID;
        data["pickingZone"] = this.pickingZone;
        data["dateTimeLastCounted"] = this.dateTimeLastCounted ? this.dateTimeLastCounted.toISOString() : <any>undefined;
        data["dateLastAged"] = this.dateLastAged ? this.dateLastAged.toISOString() : <any>undefined;
        data["averageAge"] = this.averageAge;
        data["stockCountID"] = this.stockCountID;
        data["stockCountLineNumber"] = this.stockCountLineNumber;
        data["fullStockTurn"] = this.fullStockTurn;
        data["fullStockAge"] = this.fullStockAge;
        data["gmroi"] = this.gmroi;
        data["periodsAnalysed"] = this.periodsAnalysed;
        data["standardPurchase"] = this.standardPurchase;
        data["defaultLabelTemplateID"] = this.defaultLabelTemplateID;
        data["useMemoQuantityInput"] = this.useMemoQuantityInput;
        data["useActualCostForPacks"] = this.useActualCostForPacks;
        data["packsAreTagged"] = this.packsAreTagged;
        data["keepUntaggedPackRecords"] = this.keepUntaggedPackRecords;
        data["packPurchasing"] = this.packPurchasing;
        data["packSelling"] = this.packSelling;
        data["productBatchTypeID"] = this.productBatchTypeID;
        data["vmi"] = this.vmi;
        data["dateFirstStocked"] = this.dateFirstStocked ? this.dateFirstStocked.toISOString() : <any>undefined;
        data["sellingQuantityBreakID"] = this.sellingQuantityBreakID;
        data["pickingRequired"] = this.pickingRequired;
        data["allowSettlementDiscount"] = this.allowSettlementDiscount;
        data["skipStockWarning"] = this.skipStockWarning;
        data["priceSensitivityID"] = this.priceSensitivityID;
        data["quickTallyAVOID"] = this.quickTallyAVOID;
        data["quickTallyAVOOptionID"] = this.quickTallyAVOOptionID;
        data["quickTallyAVOProductionTimeMultiplier"] = this.quickTallyAVOProductionTimeMultiplier;
        data["quickTallyAVOPriceMultiplier"] = this.quickTallyAVOPriceMultiplier;
        data["inputPerID"] = this.inputPerID;
        data["seasonalityID"] = this.seasonalityID;
        data["averageValuation"] = this.averageValuation;
        data["orderEntryManufacturedKitID"] = this.orderEntryManufacturedKitID;
        data["sellPriceRounding"] = this.sellPriceRounding;
        data["sellPriceRoundingOption"] = this.sellPriceRoundingOption;
        data["sellPriceRoundingPerID"] = this.sellPriceRoundingPerID;
        return data; 
    }
}

export interface IProductStockOption {
    productID?: number | undefined;
    branchID?: number | undefined;
    stocked?: boolean | undefined;
    stockClass?: string | undefined;
    howSourced?: number | undefined;
    transferBranchID?: number | undefined;
    manufactureBranchID?: number | undefined;
    purchaseAndTransferBranchID?: number | undefined;
    leadTime?: number | undefined;
    weeksCover?: number | undefined;
    stockLevelMin?: number | undefined;
    stockLevelMax?: number | undefined;
    shelfLife?: number | undefined;
    stockCountGroup?: string | undefined;
    binLocation?: string | undefined;
    commissionCodeID?: number | undefined;
    productManagerID?: number | undefined;
    pickingZone?: string | undefined;
    dateTimeLastCounted?: Date | undefined;
    dateLastAged?: Date | undefined;
    averageAge?: number | undefined;
    stockCountID?: number | undefined;
    stockCountLineNumber?: number | undefined;
    fullStockTurn?: number | undefined;
    fullStockAge?: number | undefined;
    gmroi?: number | undefined;
    periodsAnalysed?: number | undefined;
    standardPurchase?: boolean | undefined;
    defaultLabelTemplateID?: number | undefined;
    useMemoQuantityInput?: boolean | undefined;
    useActualCostForPacks?: boolean | undefined;
    packsAreTagged?: boolean | undefined;
    keepUntaggedPackRecords?: boolean | undefined;
    packPurchasing?: number | undefined;
    packSelling?: number | undefined;
    productBatchTypeID?: number | undefined;
    vmi?: boolean | undefined;
    dateFirstStocked?: Date | undefined;
    sellingQuantityBreakID?: number | undefined;
    pickingRequired?: boolean | undefined;
    allowSettlementDiscount?: boolean | undefined;
    skipStockWarning?: boolean | undefined;
    priceSensitivityID?: number | undefined;
    quickTallyAVOID?: number | undefined;
    quickTallyAVOOptionID?: number | undefined;
    quickTallyAVOProductionTimeMultiplier?: number | undefined;
    quickTallyAVOPriceMultiplier?: number | undefined;
    inputPerID?: number | undefined;
    seasonalityID?: number | undefined;
    averageValuation?: number | undefined;
    orderEntryManufacturedKitID?: number | undefined;
    sellPriceRounding?: number | undefined;
    sellPriceRoundingOption?: number | undefined;
    sellPriceRoundingPerID?: number | undefined;
}

export class DocumentManifestRequest implements IDocumentManifestRequest {
    userId?: number | undefined;
    journeyStopsDeletedIds?: string | undefined;
    documentType?: DocumentManifestRequestDocumentType | undefined;
    /** The manifest */
    documentManifest?: DocumentManifest | undefined;

    constructor(data?: IDocumentManifestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.journeyStopsDeletedIds = _data["journeyStopsDeletedIds"];
            this.documentType = _data["documentType"];
            this.documentManifest = _data["documentManifest"] ? DocumentManifest.fromJS(_data["documentManifest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentManifestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentManifestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["journeyStopsDeletedIds"] = this.journeyStopsDeletedIds;
        data["documentType"] = this.documentType;
        data["documentManifest"] = this.documentManifest ? this.documentManifest.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDocumentManifestRequest {
    userId?: number | undefined;
    journeyStopsDeletedIds?: string | undefined;
    documentType?: DocumentManifestRequestDocumentType | undefined;
    /** The manifest */
    documentManifest?: DocumentManifest | undefined;
}

export class DocumentHeaderManifest implements IDocumentHeaderManifest {
    documentId?: number | undefined;
    documentNumber?: number | undefined;
    documentType?: DocumentHeaderManifestDocumentType | undefined;
    orderHeader?: OrderHeader | undefined;
    pickingNoteHeader?: PickingNoteHeader | undefined;
    deliveryNoteHeader?: DeliveryNoteHeader | undefined;
    addCostProrationHeader?: AddCostProrationHeader | undefined;
    workOrderHeader?: WorkOrderHeader | undefined;
    workOrderProcessHeaders?: WorkOrderProcessHeader[] | undefined;
    creditNoteHeader?: CreditNoteHeader | undefined;
    journeyManifestHeader?: JourneyManifestHeader | undefined;
    purchaseOrderHeader?: PurchaseOrderHeader | undefined;
    stockReceiptHeader?: StockReceiptHeader | undefined;
    supplierReturnHeader?: SupplierReturnHeader | undefined;
    customerReturnHeader?: CustomerReturnHeader | undefined;
    status?: DocumentHeaderManifestStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;

    constructor(data?: IDocumentHeaderManifest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.documentNumber = _data["documentNumber"];
            this.documentType = _data["documentType"];
            this.orderHeader = _data["orderHeader"] ? OrderHeader.fromJS(_data["orderHeader"]) : <any>undefined;
            this.pickingNoteHeader = _data["pickingNoteHeader"] ? PickingNoteHeader.fromJS(_data["pickingNoteHeader"]) : <any>undefined;
            this.deliveryNoteHeader = _data["deliveryNoteHeader"] ? DeliveryNoteHeader.fromJS(_data["deliveryNoteHeader"]) : <any>undefined;
            this.addCostProrationHeader = _data["addCostProrationHeader"] ? AddCostProrationHeader.fromJS(_data["addCostProrationHeader"]) : <any>undefined;
            this.workOrderHeader = _data["workOrderHeader"] ? WorkOrderHeader.fromJS(_data["workOrderHeader"]) : <any>undefined;
            if (Array.isArray(_data["workOrderProcessHeaders"])) {
                this.workOrderProcessHeaders = [] as any;
                for (let item of _data["workOrderProcessHeaders"])
                    this.workOrderProcessHeaders!.push(WorkOrderProcessHeader.fromJS(item));
            }
            this.creditNoteHeader = _data["creditNoteHeader"] ? CreditNoteHeader.fromJS(_data["creditNoteHeader"]) : <any>undefined;
            this.journeyManifestHeader = _data["journeyManifestHeader"] ? JourneyManifestHeader.fromJS(_data["journeyManifestHeader"]) : <any>undefined;
            this.purchaseOrderHeader = _data["purchaseOrderHeader"] ? PurchaseOrderHeader.fromJS(_data["purchaseOrderHeader"]) : <any>undefined;
            this.stockReceiptHeader = _data["stockReceiptHeader"] ? StockReceiptHeader.fromJS(_data["stockReceiptHeader"]) : <any>undefined;
            this.supplierReturnHeader = _data["supplierReturnHeader"] ? SupplierReturnHeader.fromJS(_data["supplierReturnHeader"]) : <any>undefined;
            this.customerReturnHeader = _data["customerReturnHeader"] ? CustomerReturnHeader.fromJS(_data["customerReturnHeader"]) : <any>undefined;
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentHeaderManifest {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentHeaderManifest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentNumber"] = this.documentNumber;
        data["documentType"] = this.documentType;
        data["orderHeader"] = this.orderHeader ? this.orderHeader.toJSON() : <any>undefined;
        data["pickingNoteHeader"] = this.pickingNoteHeader ? this.pickingNoteHeader.toJSON() : <any>undefined;
        data["deliveryNoteHeader"] = this.deliveryNoteHeader ? this.deliveryNoteHeader.toJSON() : <any>undefined;
        data["addCostProrationHeader"] = this.addCostProrationHeader ? this.addCostProrationHeader.toJSON() : <any>undefined;
        data["workOrderHeader"] = this.workOrderHeader ? this.workOrderHeader.toJSON() : <any>undefined;
        if (Array.isArray(this.workOrderProcessHeaders)) {
            data["workOrderProcessHeaders"] = [];
            for (let item of this.workOrderProcessHeaders)
                data["workOrderProcessHeaders"].push(item.toJSON());
        }
        data["creditNoteHeader"] = this.creditNoteHeader ? this.creditNoteHeader.toJSON() : <any>undefined;
        data["journeyManifestHeader"] = this.journeyManifestHeader ? this.journeyManifestHeader.toJSON() : <any>undefined;
        data["purchaseOrderHeader"] = this.purchaseOrderHeader ? this.purchaseOrderHeader.toJSON() : <any>undefined;
        data["stockReceiptHeader"] = this.stockReceiptHeader ? this.stockReceiptHeader.toJSON() : <any>undefined;
        data["supplierReturnHeader"] = this.supplierReturnHeader ? this.supplierReturnHeader.toJSON() : <any>undefined;
        data["customerReturnHeader"] = this.customerReturnHeader ? this.customerReturnHeader.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDocumentHeaderManifest {
    documentId?: number | undefined;
    documentNumber?: number | undefined;
    documentType?: DocumentHeaderManifestDocumentType | undefined;
    orderHeader?: OrderHeader | undefined;
    pickingNoteHeader?: PickingNoteHeader | undefined;
    deliveryNoteHeader?: DeliveryNoteHeader | undefined;
    addCostProrationHeader?: AddCostProrationHeader | undefined;
    workOrderHeader?: WorkOrderHeader | undefined;
    workOrderProcessHeaders?: WorkOrderProcessHeader[] | undefined;
    creditNoteHeader?: CreditNoteHeader | undefined;
    journeyManifestHeader?: JourneyManifestHeader | undefined;
    purchaseOrderHeader?: PurchaseOrderHeader | undefined;
    stockReceiptHeader?: StockReceiptHeader | undefined;
    supplierReturnHeader?: SupplierReturnHeader | undefined;
    customerReturnHeader?: CustomerReturnHeader | undefined;
    status?: DocumentHeaderManifestStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
}

export class SmartTabNameQueryParams implements ISmartTabNameQueryParams {
    userId?: number | undefined;
    loadWithUserSettings?: boolean | undefined;
    systemOptionIDs?: number[] | undefined;

    constructor(data?: ISmartTabNameQueryParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.loadWithUserSettings = _data["loadWithUserSettings"];
            if (Array.isArray(_data["systemOptionIDs"])) {
                this.systemOptionIDs = [] as any;
                for (let item of _data["systemOptionIDs"])
                    this.systemOptionIDs!.push(item);
            }
        }
    }

    static fromJS(data: any): SmartTabNameQueryParams {
        data = typeof data === 'object' ? data : {};
        let result = new SmartTabNameQueryParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["loadWithUserSettings"] = this.loadWithUserSettings;
        if (Array.isArray(this.systemOptionIDs)) {
            data["systemOptionIDs"] = [];
            for (let item of this.systemOptionIDs)
                data["systemOptionIDs"].push(item);
        }
        return data; 
    }
}

export interface ISmartTabNameQueryParams {
    userId?: number | undefined;
    loadWithUserSettings?: boolean | undefined;
    systemOptionIDs?: number[] | undefined;
}

export class SmartView implements ISmartView {
    smartViewID?: number | undefined;
    listTableID?: number | undefined;
    sqlDocumentListType?: number | undefined;
    sqlObjectListType?: number | undefined;
    name?: string | undefined;
    groupName?: string | undefined;
    drillDownTargetOnly?: boolean | undefined;
    dataSource?: number | undefined;
    alternativeServer?: string | undefined;
    alternativeDatabase?: string | undefined;
    viewProfileID?: number | undefined;
    disablePaging?: boolean | undefined;
    enableLoadAll?: boolean | undefined;
    refreshOnSelection?: boolean | undefined;
    allowMultipleSelections?: boolean | undefined;
    showQuickBrowse?: boolean | undefined;
    quickBrowseColumnName1?: string | undefined;
    quickBrowseColumnName2?: string | undefined;
    quickBrowseColumnName3?: string | undefined;
    showAlphaIndex?: boolean | undefined;
    showGroupByBox?: boolean | undefined;
    useEvenOddColors?: boolean | undefined;
    showPreviewRow?: boolean | undefined;
    previewRowColumnName?: string | undefined;
    previewRowLines?: number | undefined;
    previewRowIndent?: number | undefined;
    hidePreviewColumn?: boolean | undefined;
    columnHeaderHeight?: number | undefined;
    frozenColumnCount?: number | undefined;
    shadeFrozenColumns?: boolean | undefined;
    selectionStyle?: number | undefined;
    gridLines?: number | undefined;
    gridLineStyle?: number | undefined;
    groupByColumnName1?: string | undefined;
    groupByColumnName2?: string | undefined;
    groupByColumnName3?: string | undefined;
    groupByColumnName4?: string | undefined;
    groupByAscending1?: boolean | undefined;
    groupByAscending2?: boolean | undefined;
    groupByAscending3?: boolean | undefined;
    groupByAscending4?: boolean | undefined;
    groupByExpansion?: number | undefined;
    sortColumnName1?: string | undefined;
    sortColumnName2?: string | undefined;
    sortColumnName3?: string | undefined;
    sortColumnName4?: string | undefined;
    sortAscending1?: boolean | undefined;
    sortAscending2?: boolean | undefined;
    sortAscending3?: boolean | undefined;
    sortAscending4?: boolean | undefined;
    availableToAllUsers?: boolean | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    lastModifiedByID?: number | undefined;
    campaignID?: number | undefined;
    drillDownID?: number | undefined;
    showPreviewPane?: boolean | undefined;
    sortName?: string | undefined;
    orderMonitorOptions?: number | undefined;
    smartTileLabel?: string | undefined;
    smartTileSQL?: string | undefined;
    smartTileSize?: number | undefined;
    conditionalFormatType?: boolean | undefined;
    quickBrowseColumnName4?: string | undefined;
    quickBrowseColumnName5?: string | undefined;
    smartViewSmartClicks?: SmartViewSmartClick[] | undefined;
    createdByName?: string | undefined;
    lastModifiedByName?: string | undefined;

    constructor(data?: ISmartView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smartViewID = _data["smartViewID"];
            this.listTableID = _data["listTableID"];
            this.sqlDocumentListType = _data["sqlDocumentListType"];
            this.sqlObjectListType = _data["sqlObjectListType"];
            this.name = _data["name"];
            this.groupName = _data["groupName"];
            this.drillDownTargetOnly = _data["drillDownTargetOnly"];
            this.dataSource = _data["dataSource"];
            this.alternativeServer = _data["alternativeServer"];
            this.alternativeDatabase = _data["alternativeDatabase"];
            this.viewProfileID = _data["viewProfileID"];
            this.disablePaging = _data["disablePaging"];
            this.enableLoadAll = _data["enableLoadAll"];
            this.refreshOnSelection = _data["refreshOnSelection"];
            this.allowMultipleSelections = _data["allowMultipleSelections"];
            this.showQuickBrowse = _data["showQuickBrowse"];
            this.quickBrowseColumnName1 = _data["quickBrowseColumnName1"];
            this.quickBrowseColumnName2 = _data["quickBrowseColumnName2"];
            this.quickBrowseColumnName3 = _data["quickBrowseColumnName3"];
            this.showAlphaIndex = _data["showAlphaIndex"];
            this.showGroupByBox = _data["showGroupByBox"];
            this.useEvenOddColors = _data["useEvenOddColors"];
            this.showPreviewRow = _data["showPreviewRow"];
            this.previewRowColumnName = _data["previewRowColumnName"];
            this.previewRowLines = _data["previewRowLines"];
            this.previewRowIndent = _data["previewRowIndent"];
            this.hidePreviewColumn = _data["hidePreviewColumn"];
            this.columnHeaderHeight = _data["columnHeaderHeight"];
            this.frozenColumnCount = _data["frozenColumnCount"];
            this.shadeFrozenColumns = _data["shadeFrozenColumns"];
            this.selectionStyle = _data["selectionStyle"];
            this.gridLines = _data["gridLines"];
            this.gridLineStyle = _data["gridLineStyle"];
            this.groupByColumnName1 = _data["groupByColumnName1"];
            this.groupByColumnName2 = _data["groupByColumnName2"];
            this.groupByColumnName3 = _data["groupByColumnName3"];
            this.groupByColumnName4 = _data["groupByColumnName4"];
            this.groupByAscending1 = _data["groupByAscending1"];
            this.groupByAscending2 = _data["groupByAscending2"];
            this.groupByAscending3 = _data["groupByAscending3"];
            this.groupByAscending4 = _data["groupByAscending4"];
            this.groupByExpansion = _data["groupByExpansion"];
            this.sortColumnName1 = _data["sortColumnName1"];
            this.sortColumnName2 = _data["sortColumnName2"];
            this.sortColumnName3 = _data["sortColumnName3"];
            this.sortColumnName4 = _data["sortColumnName4"];
            this.sortAscending1 = _data["sortAscending1"];
            this.sortAscending2 = _data["sortAscending2"];
            this.sortAscending3 = _data["sortAscending3"];
            this.sortAscending4 = _data["sortAscending4"];
            this.availableToAllUsers = _data["availableToAllUsers"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.createdByID = _data["createdByID"];
            this.dateTimeLastModified = _data["dateTimeLastModified"] ? new Date(_data["dateTimeLastModified"].toString()) : <any>undefined;
            this.lastModifiedByID = _data["lastModifiedByID"];
            this.campaignID = _data["campaignID"];
            this.drillDownID = _data["drillDownID"];
            this.showPreviewPane = _data["showPreviewPane"];
            this.sortName = _data["sortName"];
            this.orderMonitorOptions = _data["orderMonitorOptions"];
            this.smartTileLabel = _data["smartTileLabel"];
            this.smartTileSQL = _data["smartTileSQL"];
            this.smartTileSize = _data["smartTileSize"];
            this.conditionalFormatType = _data["conditionalFormatType"];
            this.quickBrowseColumnName4 = _data["quickBrowseColumnName4"];
            this.quickBrowseColumnName5 = _data["quickBrowseColumnName5"];
            if (Array.isArray(_data["smartViewSmartClicks"])) {
                this.smartViewSmartClicks = [] as any;
                for (let item of _data["smartViewSmartClicks"])
                    this.smartViewSmartClicks!.push(SmartViewSmartClick.fromJS(item));
            }
            this.createdByName = _data["createdByName"];
            this.lastModifiedByName = _data["lastModifiedByName"];
        }
    }

    static fromJS(data: any): SmartView {
        data = typeof data === 'object' ? data : {};
        let result = new SmartView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smartViewID"] = this.smartViewID;
        data["listTableID"] = this.listTableID;
        data["sqlDocumentListType"] = this.sqlDocumentListType;
        data["sqlObjectListType"] = this.sqlObjectListType;
        data["name"] = this.name;
        data["groupName"] = this.groupName;
        data["drillDownTargetOnly"] = this.drillDownTargetOnly;
        data["dataSource"] = this.dataSource;
        data["alternativeServer"] = this.alternativeServer;
        data["alternativeDatabase"] = this.alternativeDatabase;
        data["viewProfileID"] = this.viewProfileID;
        data["disablePaging"] = this.disablePaging;
        data["enableLoadAll"] = this.enableLoadAll;
        data["refreshOnSelection"] = this.refreshOnSelection;
        data["allowMultipleSelections"] = this.allowMultipleSelections;
        data["showQuickBrowse"] = this.showQuickBrowse;
        data["quickBrowseColumnName1"] = this.quickBrowseColumnName1;
        data["quickBrowseColumnName2"] = this.quickBrowseColumnName2;
        data["quickBrowseColumnName3"] = this.quickBrowseColumnName3;
        data["showAlphaIndex"] = this.showAlphaIndex;
        data["showGroupByBox"] = this.showGroupByBox;
        data["useEvenOddColors"] = this.useEvenOddColors;
        data["showPreviewRow"] = this.showPreviewRow;
        data["previewRowColumnName"] = this.previewRowColumnName;
        data["previewRowLines"] = this.previewRowLines;
        data["previewRowIndent"] = this.previewRowIndent;
        data["hidePreviewColumn"] = this.hidePreviewColumn;
        data["columnHeaderHeight"] = this.columnHeaderHeight;
        data["frozenColumnCount"] = this.frozenColumnCount;
        data["shadeFrozenColumns"] = this.shadeFrozenColumns;
        data["selectionStyle"] = this.selectionStyle;
        data["gridLines"] = this.gridLines;
        data["gridLineStyle"] = this.gridLineStyle;
        data["groupByColumnName1"] = this.groupByColumnName1;
        data["groupByColumnName2"] = this.groupByColumnName2;
        data["groupByColumnName3"] = this.groupByColumnName3;
        data["groupByColumnName4"] = this.groupByColumnName4;
        data["groupByAscending1"] = this.groupByAscending1;
        data["groupByAscending2"] = this.groupByAscending2;
        data["groupByAscending3"] = this.groupByAscending3;
        data["groupByAscending4"] = this.groupByAscending4;
        data["groupByExpansion"] = this.groupByExpansion;
        data["sortColumnName1"] = this.sortColumnName1;
        data["sortColumnName2"] = this.sortColumnName2;
        data["sortColumnName3"] = this.sortColumnName3;
        data["sortColumnName4"] = this.sortColumnName4;
        data["sortAscending1"] = this.sortAscending1;
        data["sortAscending2"] = this.sortAscending2;
        data["sortAscending3"] = this.sortAscending3;
        data["sortAscending4"] = this.sortAscending4;
        data["availableToAllUsers"] = this.availableToAllUsers;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["createdByID"] = this.createdByID;
        data["dateTimeLastModified"] = this.dateTimeLastModified ? this.dateTimeLastModified.toISOString() : <any>undefined;
        data["lastModifiedByID"] = this.lastModifiedByID;
        data["campaignID"] = this.campaignID;
        data["drillDownID"] = this.drillDownID;
        data["showPreviewPane"] = this.showPreviewPane;
        data["sortName"] = this.sortName;
        data["orderMonitorOptions"] = this.orderMonitorOptions;
        data["smartTileLabel"] = this.smartTileLabel;
        data["smartTileSQL"] = this.smartTileSQL;
        data["smartTileSize"] = this.smartTileSize;
        data["conditionalFormatType"] = this.conditionalFormatType;
        data["quickBrowseColumnName4"] = this.quickBrowseColumnName4;
        data["quickBrowseColumnName5"] = this.quickBrowseColumnName5;
        if (Array.isArray(this.smartViewSmartClicks)) {
            data["smartViewSmartClicks"] = [];
            for (let item of this.smartViewSmartClicks)
                data["smartViewSmartClicks"].push(item.toJSON());
        }
        data["createdByName"] = this.createdByName;
        data["lastModifiedByName"] = this.lastModifiedByName;
        return data; 
    }
}

export interface ISmartView {
    smartViewID?: number | undefined;
    listTableID?: number | undefined;
    sqlDocumentListType?: number | undefined;
    sqlObjectListType?: number | undefined;
    name?: string | undefined;
    groupName?: string | undefined;
    drillDownTargetOnly?: boolean | undefined;
    dataSource?: number | undefined;
    alternativeServer?: string | undefined;
    alternativeDatabase?: string | undefined;
    viewProfileID?: number | undefined;
    disablePaging?: boolean | undefined;
    enableLoadAll?: boolean | undefined;
    refreshOnSelection?: boolean | undefined;
    allowMultipleSelections?: boolean | undefined;
    showQuickBrowse?: boolean | undefined;
    quickBrowseColumnName1?: string | undefined;
    quickBrowseColumnName2?: string | undefined;
    quickBrowseColumnName3?: string | undefined;
    showAlphaIndex?: boolean | undefined;
    showGroupByBox?: boolean | undefined;
    useEvenOddColors?: boolean | undefined;
    showPreviewRow?: boolean | undefined;
    previewRowColumnName?: string | undefined;
    previewRowLines?: number | undefined;
    previewRowIndent?: number | undefined;
    hidePreviewColumn?: boolean | undefined;
    columnHeaderHeight?: number | undefined;
    frozenColumnCount?: number | undefined;
    shadeFrozenColumns?: boolean | undefined;
    selectionStyle?: number | undefined;
    gridLines?: number | undefined;
    gridLineStyle?: number | undefined;
    groupByColumnName1?: string | undefined;
    groupByColumnName2?: string | undefined;
    groupByColumnName3?: string | undefined;
    groupByColumnName4?: string | undefined;
    groupByAscending1?: boolean | undefined;
    groupByAscending2?: boolean | undefined;
    groupByAscending3?: boolean | undefined;
    groupByAscending4?: boolean | undefined;
    groupByExpansion?: number | undefined;
    sortColumnName1?: string | undefined;
    sortColumnName2?: string | undefined;
    sortColumnName3?: string | undefined;
    sortColumnName4?: string | undefined;
    sortAscending1?: boolean | undefined;
    sortAscending2?: boolean | undefined;
    sortAscending3?: boolean | undefined;
    sortAscending4?: boolean | undefined;
    availableToAllUsers?: boolean | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    lastModifiedByID?: number | undefined;
    campaignID?: number | undefined;
    drillDownID?: number | undefined;
    showPreviewPane?: boolean | undefined;
    sortName?: string | undefined;
    orderMonitorOptions?: number | undefined;
    smartTileLabel?: string | undefined;
    smartTileSQL?: string | undefined;
    smartTileSize?: number | undefined;
    conditionalFormatType?: boolean | undefined;
    quickBrowseColumnName4?: string | undefined;
    quickBrowseColumnName5?: string | undefined;
    smartViewSmartClicks?: SmartViewSmartClick[] | undefined;
    createdByName?: string | undefined;
    lastModifiedByName?: string | undefined;
}

export class SmartViewSmartClick implements ISmartViewSmartClick {
    smartViewSmartClickID?: number | undefined;
    smartViewID?: number | undefined;
    name?: string | undefined;
    sqlStatement?: string | undefined;
    param1Prompt?: string | undefined;
    param1ListID?: number | undefined;
    param2Prompt?: string | undefined;
    param2ListID?: number | undefined;
    param3Prompt?: string | undefined;
    param3ListID?: number | undefined;
    param4Prompt?: string | undefined;
    param4ListID?: number | undefined;
    param5Prompt?: string | undefined;
    param5ListID?: number | undefined;
    param6Prompt?: string | undefined;
    param6ListID?: number | undefined;
    param7Prompt?: string | undefined;
    param7ListID?: number | undefined;
    param8Prompt?: string | undefined;
    param8ListID?: number | undefined;
    param9Prompt?: string | undefined;
    param9ListID?: number | undefined;
    param10Prompt?: string | undefined;
    param10ListID?: number | undefined;
    type?: boolean | undefined;
    param1SQL?: string | undefined;
    param2SQL?: string | undefined;
    param3SQL?: string | undefined;
    param4SQL?: string | undefined;
    param5SQL?: string | undefined;
    param6SQL?: string | undefined;
    param7SQL?: string | undefined;
    param8SQL?: string | undefined;
    param9SQL?: string | undefined;
    param10SQL?: string | undefined;
    smartView?: SmartView | undefined;

    constructor(data?: ISmartViewSmartClick) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smartViewSmartClickID = _data["smartViewSmartClickID"];
            this.smartViewID = _data["smartViewID"];
            this.name = _data["name"];
            this.sqlStatement = _data["sqlStatement"];
            this.param1Prompt = _data["param1Prompt"];
            this.param1ListID = _data["param1ListID"];
            this.param2Prompt = _data["param2Prompt"];
            this.param2ListID = _data["param2ListID"];
            this.param3Prompt = _data["param3Prompt"];
            this.param3ListID = _data["param3ListID"];
            this.param4Prompt = _data["param4Prompt"];
            this.param4ListID = _data["param4ListID"];
            this.param5Prompt = _data["param5Prompt"];
            this.param5ListID = _data["param5ListID"];
            this.param6Prompt = _data["param6Prompt"];
            this.param6ListID = _data["param6ListID"];
            this.param7Prompt = _data["param7Prompt"];
            this.param7ListID = _data["param7ListID"];
            this.param8Prompt = _data["param8Prompt"];
            this.param8ListID = _data["param8ListID"];
            this.param9Prompt = _data["param9Prompt"];
            this.param9ListID = _data["param9ListID"];
            this.param10Prompt = _data["param10Prompt"];
            this.param10ListID = _data["param10ListID"];
            this.type = _data["type"];
            this.param1SQL = _data["param1SQL"];
            this.param2SQL = _data["param2SQL"];
            this.param3SQL = _data["param3SQL"];
            this.param4SQL = _data["param4SQL"];
            this.param5SQL = _data["param5SQL"];
            this.param6SQL = _data["param6SQL"];
            this.param7SQL = _data["param7SQL"];
            this.param8SQL = _data["param8SQL"];
            this.param9SQL = _data["param9SQL"];
            this.param10SQL = _data["param10SQL"];
            this.smartView = _data["smartView"] ? SmartView.fromJS(_data["smartView"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SmartViewSmartClick {
        data = typeof data === 'object' ? data : {};
        let result = new SmartViewSmartClick();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smartViewSmartClickID"] = this.smartViewSmartClickID;
        data["smartViewID"] = this.smartViewID;
        data["name"] = this.name;
        data["sqlStatement"] = this.sqlStatement;
        data["param1Prompt"] = this.param1Prompt;
        data["param1ListID"] = this.param1ListID;
        data["param2Prompt"] = this.param2Prompt;
        data["param2ListID"] = this.param2ListID;
        data["param3Prompt"] = this.param3Prompt;
        data["param3ListID"] = this.param3ListID;
        data["param4Prompt"] = this.param4Prompt;
        data["param4ListID"] = this.param4ListID;
        data["param5Prompt"] = this.param5Prompt;
        data["param5ListID"] = this.param5ListID;
        data["param6Prompt"] = this.param6Prompt;
        data["param6ListID"] = this.param6ListID;
        data["param7Prompt"] = this.param7Prompt;
        data["param7ListID"] = this.param7ListID;
        data["param8Prompt"] = this.param8Prompt;
        data["param8ListID"] = this.param8ListID;
        data["param9Prompt"] = this.param9Prompt;
        data["param9ListID"] = this.param9ListID;
        data["param10Prompt"] = this.param10Prompt;
        data["param10ListID"] = this.param10ListID;
        data["type"] = this.type;
        data["param1SQL"] = this.param1SQL;
        data["param2SQL"] = this.param2SQL;
        data["param3SQL"] = this.param3SQL;
        data["param4SQL"] = this.param4SQL;
        data["param5SQL"] = this.param5SQL;
        data["param6SQL"] = this.param6SQL;
        data["param7SQL"] = this.param7SQL;
        data["param8SQL"] = this.param8SQL;
        data["param9SQL"] = this.param9SQL;
        data["param10SQL"] = this.param10SQL;
        data["smartView"] = this.smartView ? this.smartView.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISmartViewSmartClick {
    smartViewSmartClickID?: number | undefined;
    smartViewID?: number | undefined;
    name?: string | undefined;
    sqlStatement?: string | undefined;
    param1Prompt?: string | undefined;
    param1ListID?: number | undefined;
    param2Prompt?: string | undefined;
    param2ListID?: number | undefined;
    param3Prompt?: string | undefined;
    param3ListID?: number | undefined;
    param4Prompt?: string | undefined;
    param4ListID?: number | undefined;
    param5Prompt?: string | undefined;
    param5ListID?: number | undefined;
    param6Prompt?: string | undefined;
    param6ListID?: number | undefined;
    param7Prompt?: string | undefined;
    param7ListID?: number | undefined;
    param8Prompt?: string | undefined;
    param8ListID?: number | undefined;
    param9Prompt?: string | undefined;
    param9ListID?: number | undefined;
    param10Prompt?: string | undefined;
    param10ListID?: number | undefined;
    type?: boolean | undefined;
    param1SQL?: string | undefined;
    param2SQL?: string | undefined;
    param3SQL?: string | undefined;
    param4SQL?: string | undefined;
    param5SQL?: string | undefined;
    param6SQL?: string | undefined;
    param7SQL?: string | undefined;
    param8SQL?: string | undefined;
    param9SQL?: string | undefined;
    param10SQL?: string | undefined;
    smartView?: SmartView | undefined;
}

export class DocumentQueryParams implements IDocumentQueryParams {
    relatedDocumentsQueryPrams?: RelatedDocumentQueryParams | undefined;
    journeyDocumentQueryParams?: JourneyDocumentQueryParams | undefined;
    staffUserID?: number | undefined;

    constructor(data?: IDocumentQueryParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.relatedDocumentsQueryPrams = _data["relatedDocumentsQueryPrams"] ? RelatedDocumentQueryParams.fromJS(_data["relatedDocumentsQueryPrams"]) : <any>undefined;
            this.journeyDocumentQueryParams = _data["journeyDocumentQueryParams"] ? JourneyDocumentQueryParams.fromJS(_data["journeyDocumentQueryParams"]) : <any>undefined;
            this.staffUserID = _data["staffUserID"];
        }
    }

    static fromJS(data: any): DocumentQueryParams {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentQueryParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["relatedDocumentsQueryPrams"] = this.relatedDocumentsQueryPrams ? this.relatedDocumentsQueryPrams.toJSON() : <any>undefined;
        data["journeyDocumentQueryParams"] = this.journeyDocumentQueryParams ? this.journeyDocumentQueryParams.toJSON() : <any>undefined;
        data["staffUserID"] = this.staffUserID;
        return data; 
    }
}

export interface IDocumentQueryParams {
    relatedDocumentsQueryPrams?: RelatedDocumentQueryParams | undefined;
    journeyDocumentQueryParams?: JourneyDocumentQueryParams | undefined;
    staffUserID?: number | undefined;
}

export class RelatedDocumentQueryParams implements IRelatedDocumentQueryParams {
    documentId?: number | undefined;
    documentListType?: RelatedDocumentQueryParamsDocumentListType | undefined;
    loadAllChild?: boolean | undefined;
    isRootNode?: boolean | undefined;

    constructor(data?: IRelatedDocumentQueryParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.documentListType = _data["documentListType"];
            this.loadAllChild = _data["loadAllChild"];
            this.isRootNode = _data["isRootNode"];
        }
    }

    static fromJS(data: any): RelatedDocumentQueryParams {
        data = typeof data === 'object' ? data : {};
        let result = new RelatedDocumentQueryParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentListType"] = this.documentListType;
        data["loadAllChild"] = this.loadAllChild;
        data["isRootNode"] = this.isRootNode;
        return data; 
    }
}

export interface IRelatedDocumentQueryParams {
    documentId?: number | undefined;
    documentListType?: RelatedDocumentQueryParamsDocumentListType | undefined;
    loadAllChild?: boolean | undefined;
    isRootNode?: boolean | undefined;
}

export class JourneyDocumentQueryParams implements IJourneyDocumentQueryParams {
    findText?: string | undefined;
    documentListTypes?: string | undefined;
    findBranchIDs?: string | undefined;
    stockLocationID?: number | undefined;
    loadAll?: boolean | undefined;
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    queryIentifier?: string | undefined;

    constructor(data?: IJourneyDocumentQueryParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.findText = _data["findText"];
            this.documentListTypes = _data["documentListTypes"];
            this.findBranchIDs = _data["findBranchIDs"];
            this.stockLocationID = _data["stockLocationID"];
            this.loadAll = _data["loadAll"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.queryIentifier = _data["queryIentifier"];
        }
    }

    static fromJS(data: any): JourneyDocumentQueryParams {
        data = typeof data === 'object' ? data : {};
        let result = new JourneyDocumentQueryParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["findText"] = this.findText;
        data["documentListTypes"] = this.documentListTypes;
        data["findBranchIDs"] = this.findBranchIDs;
        data["stockLocationID"] = this.stockLocationID;
        data["loadAll"] = this.loadAll;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["queryIentifier"] = this.queryIentifier;
        return data; 
    }
}

export interface IJourneyDocumentQueryParams {
    findText?: string | undefined;
    documentListTypes?: string | undefined;
    findBranchIDs?: string | undefined;
    stockLocationID?: number | undefined;
    loadAll?: boolean | undefined;
    pageNumber?: number | undefined;
    pageSize?: number | undefined;
    queryIentifier?: string | undefined;
}

export class DocumentsListResponse implements IDocumentsListResponse {
    documentList?: DocumentsList | undefined;
    status?: DocumentsListResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IDocumentsListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentList = _data["documentList"] ? DocumentsList.fromJS(_data["documentList"]) : <any>undefined;
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): DocumentsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentList"] = this.documentList ? this.documentList.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IDocumentsListResponse {
    documentList?: DocumentsList | undefined;
    status?: DocumentsListResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class DocumentsList implements IDocumentsList {
    documents?: DocumentData[] | undefined;
    rootNodeDescription?: string | undefined;
    pageSize?: number | undefined;
    pages?: number | undefined;
    recordCount?: number | undefined;
    queryIdentifier?: string | undefined;

    constructor(data?: IDocumentsList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentData.fromJS(item));
            }
            this.rootNodeDescription = _data["rootNodeDescription"];
            this.pageSize = _data["pageSize"];
            this.pages = _data["pages"];
            this.recordCount = _data["recordCount"];
            this.queryIdentifier = _data["queryIdentifier"];
        }
    }

    static fromJS(data: any): DocumentsList {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["rootNodeDescription"] = this.rootNodeDescription;
        data["pageSize"] = this.pageSize;
        data["pages"] = this.pages;
        data["recordCount"] = this.recordCount;
        data["queryIdentifier"] = this.queryIdentifier;
        return data; 
    }
}

export interface IDocumentsList {
    documents?: DocumentData[] | undefined;
    rootNodeDescription?: string | undefined;
    pageSize?: number | undefined;
    pages?: number | undefined;
    recordCount?: number | undefined;
    queryIdentifier?: string | undefined;
}

export class DocumentData implements IDocumentData {
    documentType?: DocumentDataDocumentType | undefined;
    documentId?: number | undefined;
    properties?: { [key: string]: string; } | undefined;
    documents?: DocumentData[] | undefined;

    constructor(data?: IDocumentData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentType = _data["documentType"];
            this.documentId = _data["documentId"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        this.properties![key] = _data["properties"][key];
                }
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentData {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["documentId"] = this.documentId;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDocumentData {
    documentType?: DocumentDataDocumentType | undefined;
    documentId?: number | undefined;
    properties?: { [key: string]: string; } | undefined;
    documents?: DocumentData[] | undefined;
}

export class SmartTabDataQueryParams implements ISmartTabDataQueryParams {
    findText?: string | undefined;
    smartViewID?: number | undefined;
    pageNumber?: number | undefined;
    loadMore?: boolean | undefined;
    loadAll?: boolean | undefined;
    justInitialise?: boolean | undefined;
    currentUserID?: number | undefined;
    currentBranchID?: number | undefined;
    currentBranchName?: string | undefined;
    currentBranchCode?: string | undefined;
    loadWithUserSettings?: boolean | undefined;

    constructor(data?: ISmartTabDataQueryParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.findText = _data["findText"];
            this.smartViewID = _data["smartViewID"];
            this.pageNumber = _data["pageNumber"];
            this.loadMore = _data["loadMore"];
            this.loadAll = _data["loadAll"];
            this.justInitialise = _data["justInitialise"];
            this.currentUserID = _data["currentUserID"];
            this.currentBranchID = _data["currentBranchID"];
            this.currentBranchName = _data["currentBranchName"];
            this.currentBranchCode = _data["currentBranchCode"];
            this.loadWithUserSettings = _data["loadWithUserSettings"];
        }
    }

    static fromJS(data: any): SmartTabDataQueryParams {
        data = typeof data === 'object' ? data : {};
        let result = new SmartTabDataQueryParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["findText"] = this.findText;
        data["smartViewID"] = this.smartViewID;
        data["pageNumber"] = this.pageNumber;
        data["loadMore"] = this.loadMore;
        data["loadAll"] = this.loadAll;
        data["justInitialise"] = this.justInitialise;
        data["currentUserID"] = this.currentUserID;
        data["currentBranchID"] = this.currentBranchID;
        data["currentBranchName"] = this.currentBranchName;
        data["currentBranchCode"] = this.currentBranchCode;
        data["loadWithUserSettings"] = this.loadWithUserSettings;
        return data; 
    }
}

export interface ISmartTabDataQueryParams {
    findText?: string | undefined;
    smartViewID?: number | undefined;
    pageNumber?: number | undefined;
    loadMore?: boolean | undefined;
    loadAll?: boolean | undefined;
    justInitialise?: boolean | undefined;
    currentUserID?: number | undefined;
    currentBranchID?: number | undefined;
    currentBranchName?: string | undefined;
    currentBranchCode?: string | undefined;
    loadWithUserSettings?: boolean | undefined;
}

export class SmartTabDataResponse implements ISmartTabDataResponse {
    smartViewColumns?: SmartViewColumn[] | undefined;
    smartViewFormats?: SmartViewFormat[] | undefined;
    tables?: { [key: string]: string; }[][] | undefined;

    constructor(data?: ISmartTabDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["smartViewColumns"])) {
                this.smartViewColumns = [] as any;
                for (let item of _data["smartViewColumns"])
                    this.smartViewColumns!.push(SmartViewColumn.fromJS(item));
            }
            if (Array.isArray(_data["smartViewFormats"])) {
                this.smartViewFormats = [] as any;
                for (let item of _data["smartViewFormats"])
                    this.smartViewFormats!.push(SmartViewFormat.fromJS(item));
            }
            if (Array.isArray(_data["tables"])) {
                this.tables = [] as any;
                for (let item of _data["tables"])
                    this.tables!.push(item);
            }
        }
    }

    static fromJS(data: any): SmartTabDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SmartTabDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.smartViewColumns)) {
            data["smartViewColumns"] = [];
            for (let item of this.smartViewColumns)
                data["smartViewColumns"].push(item.toJSON());
        }
        if (Array.isArray(this.smartViewFormats)) {
            data["smartViewFormats"] = [];
            for (let item of this.smartViewFormats)
                data["smartViewFormats"].push(item.toJSON());
        }
        if (Array.isArray(this.tables)) {
            data["tables"] = [];
            for (let item of this.tables)
                data["tables"].push(item);
        }
        return data; 
    }
}

export interface ISmartTabDataResponse {
    smartViewColumns?: SmartViewColumn[] | undefined;
    smartViewFormats?: SmartViewFormat[] | undefined;
    tables?: { [key: string]: string; }[][] | undefined;
}

export class SmartViewColumn implements ISmartViewColumn {
    smartViewID?: number | undefined;
    listColumnName?: string | undefined;
    sequence?: number | undefined;
    caption?: string | undefined;
    width?: number | undefined;
    textAlignment?: number | undefined;
    headerAlignment?: number | undefined;
    format?: string | undefined;
    groupTotalType?: number | undefined;
    showTotalsInGroupHeader?: boolean | undefined;
    totalRowFormat?: string | undefined;
    totalRowPrefix?: string | undefined;
    enableTextSearching?: boolean | undefined;
    sqlDocumentListType?: number | undefined;
    sqlObjectListType?: number | undefined;
    drillDownAs?: string | undefined;
    specialFieldType?: number | undefined;
    enableEditing?: boolean | undefined;
    defaultNewValue?: string | undefined;
    displayAs?: number | undefined;

    constructor(data?: ISmartViewColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smartViewID = _data["smartViewID"];
            this.listColumnName = _data["listColumnName"];
            this.sequence = _data["sequence"];
            this.caption = _data["caption"];
            this.width = _data["width"];
            this.textAlignment = _data["textAlignment"];
            this.headerAlignment = _data["headerAlignment"];
            this.format = _data["format"];
            this.groupTotalType = _data["groupTotalType"];
            this.showTotalsInGroupHeader = _data["showTotalsInGroupHeader"];
            this.totalRowFormat = _data["totalRowFormat"];
            this.totalRowPrefix = _data["totalRowPrefix"];
            this.enableTextSearching = _data["enableTextSearching"];
            this.sqlDocumentListType = _data["sqlDocumentListType"];
            this.sqlObjectListType = _data["sqlObjectListType"];
            this.drillDownAs = _data["drillDownAs"];
            this.specialFieldType = _data["specialFieldType"];
            this.enableEditing = _data["enableEditing"];
            this.defaultNewValue = _data["defaultNewValue"];
            this.displayAs = _data["displayAs"];
        }
    }

    static fromJS(data: any): SmartViewColumn {
        data = typeof data === 'object' ? data : {};
        let result = new SmartViewColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smartViewID"] = this.smartViewID;
        data["listColumnName"] = this.listColumnName;
        data["sequence"] = this.sequence;
        data["caption"] = this.caption;
        data["width"] = this.width;
        data["textAlignment"] = this.textAlignment;
        data["headerAlignment"] = this.headerAlignment;
        data["format"] = this.format;
        data["groupTotalType"] = this.groupTotalType;
        data["showTotalsInGroupHeader"] = this.showTotalsInGroupHeader;
        data["totalRowFormat"] = this.totalRowFormat;
        data["totalRowPrefix"] = this.totalRowPrefix;
        data["enableTextSearching"] = this.enableTextSearching;
        data["sqlDocumentListType"] = this.sqlDocumentListType;
        data["sqlObjectListType"] = this.sqlObjectListType;
        data["drillDownAs"] = this.drillDownAs;
        data["specialFieldType"] = this.specialFieldType;
        data["enableEditing"] = this.enableEditing;
        data["defaultNewValue"] = this.defaultNewValue;
        data["displayAs"] = this.displayAs;
        return data; 
    }
}

export interface ISmartViewColumn {
    smartViewID?: number | undefined;
    listColumnName?: string | undefined;
    sequence?: number | undefined;
    caption?: string | undefined;
    width?: number | undefined;
    textAlignment?: number | undefined;
    headerAlignment?: number | undefined;
    format?: string | undefined;
    groupTotalType?: number | undefined;
    showTotalsInGroupHeader?: boolean | undefined;
    totalRowFormat?: string | undefined;
    totalRowPrefix?: string | undefined;
    enableTextSearching?: boolean | undefined;
    sqlDocumentListType?: number | undefined;
    sqlObjectListType?: number | undefined;
    drillDownAs?: string | undefined;
    specialFieldType?: number | undefined;
    enableEditing?: boolean | undefined;
    defaultNewValue?: string | undefined;
    displayAs?: number | undefined;
}

export class SmartViewFormat implements ISmartViewFormat {
    smartViewFormatID?: number | undefined;
    smartViewID?: number | undefined;
    listColumnName?: string | undefined;
    comparisonOperator?: number | undefined;
    value1?: string | undefined;
    value2?: string | undefined;
    textColor?: number | undefined;
    backColor?: number | undefined;
    fontBold?: boolean | undefined;
    fontItalic?: boolean | undefined;
    fontStrikethrough?: boolean | undefined;
    fontUnderline?: boolean | undefined;
    applyToListColumnName?: string | undefined;
    applyToEntireRow?: boolean | undefined;

    constructor(data?: ISmartViewFormat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smartViewFormatID = _data["smartViewFormatID"];
            this.smartViewID = _data["smartViewID"];
            this.listColumnName = _data["listColumnName"];
            this.comparisonOperator = _data["comparisonOperator"];
            this.value1 = _data["value1"];
            this.value2 = _data["value2"];
            this.textColor = _data["textColor"];
            this.backColor = _data["backColor"];
            this.fontBold = _data["fontBold"];
            this.fontItalic = _data["fontItalic"];
            this.fontStrikethrough = _data["fontStrikethrough"];
            this.fontUnderline = _data["fontUnderline"];
            this.applyToListColumnName = _data["applyToListColumnName"];
            this.applyToEntireRow = _data["applyToEntireRow"];
        }
    }

    static fromJS(data: any): SmartViewFormat {
        data = typeof data === 'object' ? data : {};
        let result = new SmartViewFormat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smartViewFormatID"] = this.smartViewFormatID;
        data["smartViewID"] = this.smartViewID;
        data["listColumnName"] = this.listColumnName;
        data["comparisonOperator"] = this.comparisonOperator;
        data["value1"] = this.value1;
        data["value2"] = this.value2;
        data["textColor"] = this.textColor;
        data["backColor"] = this.backColor;
        data["fontBold"] = this.fontBold;
        data["fontItalic"] = this.fontItalic;
        data["fontStrikethrough"] = this.fontStrikethrough;
        data["fontUnderline"] = this.fontUnderline;
        data["applyToListColumnName"] = this.applyToListColumnName;
        data["applyToEntireRow"] = this.applyToEntireRow;
        return data; 
    }
}

export interface ISmartViewFormat {
    smartViewFormatID?: number | undefined;
    smartViewID?: number | undefined;
    listColumnName?: string | undefined;
    comparisonOperator?: number | undefined;
    value1?: string | undefined;
    value2?: string | undefined;
    textColor?: number | undefined;
    backColor?: number | undefined;
    fontBold?: boolean | undefined;
    fontItalic?: boolean | undefined;
    fontStrikethrough?: boolean | undefined;
    fontUnderline?: boolean | undefined;
    applyToListColumnName?: string | undefined;
    applyToEntireRow?: boolean | undefined;
}

export class DocumentOpStatusResponse implements IDocumentOpStatusResponse {
    status?: DocumentOpStatusResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;

    constructor(data?: IDocumentOpStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentOpStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentOpStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDocumentOpStatusResponse {
    status?: DocumentOpStatusResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
}

export class MarkOrderRequest implements IMarkOrderRequest {
    userID?: number | undefined;
    orderIdentifiers?: number[] | undefined;
    processOption?: MarkOrderRequestProcessOption | undefined;
    promptForDeliveryDate?: boolean | undefined;
    userDialogResponses?: UserDialogResponse[] | undefined;

    constructor(data?: IMarkOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userID = _data["userID"];
            if (Array.isArray(_data["orderIdentifiers"])) {
                this.orderIdentifiers = [] as any;
                for (let item of _data["orderIdentifiers"])
                    this.orderIdentifiers!.push(item);
            }
            this.processOption = _data["processOption"];
            this.promptForDeliveryDate = _data["promptForDeliveryDate"];
            if (Array.isArray(_data["userDialogResponses"])) {
                this.userDialogResponses = [] as any;
                for (let item of _data["userDialogResponses"])
                    this.userDialogResponses!.push(UserDialogResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        if (Array.isArray(this.orderIdentifiers)) {
            data["orderIdentifiers"] = [];
            for (let item of this.orderIdentifiers)
                data["orderIdentifiers"].push(item);
        }
        data["processOption"] = this.processOption;
        data["promptForDeliveryDate"] = this.promptForDeliveryDate;
        if (Array.isArray(this.userDialogResponses)) {
            data["userDialogResponses"] = [];
            for (let item of this.userDialogResponses)
                data["userDialogResponses"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMarkOrderRequest {
    userID?: number | undefined;
    orderIdentifiers?: number[] | undefined;
    processOption?: MarkOrderRequestProcessOption | undefined;
    promptForDeliveryDate?: boolean | undefined;
    userDialogResponses?: UserDialogResponse[] | undefined;
}

export class UserDialogResponse implements IUserDialogResponse {
    id?: UserDialogResponseId | undefined;
    response?: UserDialogResponseResponse | undefined;
    optionValue?: string | undefined;
    orderDisplayParams?: OrderDisplay | undefined;
    stockTransferReceiptQtyParams?: OrderHeader | undefined;
    invoiceReleaseDisplayParams?: InvoiceReleaseDisplay | undefined;
    processDisplay?: ProcessDisplay | undefined;

    constructor(data?: IUserDialogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.response = _data["response"];
            this.optionValue = _data["optionValue"];
            this.orderDisplayParams = _data["orderDisplayParams"] ? OrderDisplay.fromJS(_data["orderDisplayParams"]) : <any>undefined;
            this.stockTransferReceiptQtyParams = _data["stockTransferReceiptQtyParams"] ? OrderHeader.fromJS(_data["stockTransferReceiptQtyParams"]) : <any>undefined;
            this.invoiceReleaseDisplayParams = _data["invoiceReleaseDisplayParams"] ? InvoiceReleaseDisplay.fromJS(_data["invoiceReleaseDisplayParams"]) : <any>undefined;
            this.processDisplay = _data["processDisplay"] ? ProcessDisplay.fromJS(_data["processDisplay"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDialogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserDialogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["response"] = this.response;
        data["optionValue"] = this.optionValue;
        data["orderDisplayParams"] = this.orderDisplayParams ? this.orderDisplayParams.toJSON() : <any>undefined;
        data["stockTransferReceiptQtyParams"] = this.stockTransferReceiptQtyParams ? this.stockTransferReceiptQtyParams.toJSON() : <any>undefined;
        data["invoiceReleaseDisplayParams"] = this.invoiceReleaseDisplayParams ? this.invoiceReleaseDisplayParams.toJSON() : <any>undefined;
        data["processDisplay"] = this.processDisplay ? this.processDisplay.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUserDialogResponse {
    id?: UserDialogResponseId | undefined;
    response?: UserDialogResponseResponse | undefined;
    optionValue?: string | undefined;
    orderDisplayParams?: OrderDisplay | undefined;
    stockTransferReceiptQtyParams?: OrderHeader | undefined;
    invoiceReleaseDisplayParams?: InvoiceReleaseDisplay | undefined;
    processDisplay?: ProcessDisplay | undefined;
}

export class OrderDisplay implements IOrderDisplay {
    fromStockTransfer?: boolean | undefined;
    allowSendTransfer?: boolean | undefined;
    vehicleTypeID?: number | undefined;
    allowAutoInvoice?: boolean | undefined;
    deliveryVehicleID?: number | undefined;
    branchID?: number | undefined;
    invoiced?: boolean | undefined;
    vehicleTypeList?: VehicleType[] | undefined;
    deliveryDate?: Date | undefined;
    deliveryReference?: string | undefined;
    printDeliverySet?: boolean | undefined;
    sendTransfer?: boolean | undefined;
    vehicleTypeName?: string | undefined;

    constructor(data?: IOrderDisplay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromStockTransfer = _data["fromStockTransfer"];
            this.allowSendTransfer = _data["allowSendTransfer"];
            this.vehicleTypeID = _data["vehicleTypeID"];
            this.allowAutoInvoice = _data["allowAutoInvoice"];
            this.deliveryVehicleID = _data["deliveryVehicleID"];
            this.branchID = _data["branchID"];
            this.invoiced = _data["invoiced"];
            if (Array.isArray(_data["vehicleTypeList"])) {
                this.vehicleTypeList = [] as any;
                for (let item of _data["vehicleTypeList"])
                    this.vehicleTypeList!.push(VehicleType.fromJS(item));
            }
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.deliveryReference = _data["deliveryReference"];
            this.printDeliverySet = _data["printDeliverySet"];
            this.sendTransfer = _data["sendTransfer"];
            this.vehicleTypeName = _data["vehicleTypeName"];
        }
    }

    static fromJS(data: any): OrderDisplay {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDisplay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromStockTransfer"] = this.fromStockTransfer;
        data["allowSendTransfer"] = this.allowSendTransfer;
        data["vehicleTypeID"] = this.vehicleTypeID;
        data["allowAutoInvoice"] = this.allowAutoInvoice;
        data["deliveryVehicleID"] = this.deliveryVehicleID;
        data["branchID"] = this.branchID;
        data["invoiced"] = this.invoiced;
        if (Array.isArray(this.vehicleTypeList)) {
            data["vehicleTypeList"] = [];
            for (let item of this.vehicleTypeList)
                data["vehicleTypeList"].push(item.toJSON());
        }
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["deliveryReference"] = this.deliveryReference;
        data["printDeliverySet"] = this.printDeliverySet;
        data["sendTransfer"] = this.sendTransfer;
        data["vehicleTypeName"] = this.vehicleTypeName;
        return data; 
    }
}

export interface IOrderDisplay {
    fromStockTransfer?: boolean | undefined;
    allowSendTransfer?: boolean | undefined;
    vehicleTypeID?: number | undefined;
    allowAutoInvoice?: boolean | undefined;
    deliveryVehicleID?: number | undefined;
    branchID?: number | undefined;
    invoiced?: boolean | undefined;
    vehicleTypeList?: VehicleType[] | undefined;
    deliveryDate?: Date | undefined;
    deliveryReference?: string | undefined;
    printDeliverySet?: boolean | undefined;
    sendTransfer?: boolean | undefined;
    vehicleTypeName?: string | undefined;
}

export class InvoiceReleaseDisplay implements IInvoiceReleaseDisplay {
    creditNoteMode?: boolean | undefined;
    hasDirectOrdersToRelease?: boolean | undefined;
    hasNotepadCases?: boolean | undefined;
    defaultToEmail?: boolean | undefined;
    printDocuments?: boolean | undefined;
    setInvoiceDateFromSupplierInvoice?: boolean | undefined;
    emailDocuments?: boolean | undefined;
    documentDate?: Date | undefined;

    constructor(data?: IInvoiceReleaseDisplay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creditNoteMode = _data["creditNoteMode"];
            this.hasDirectOrdersToRelease = _data["hasDirectOrdersToRelease"];
            this.hasNotepadCases = _data["hasNotepadCases"];
            this.defaultToEmail = _data["defaultToEmail"];
            this.printDocuments = _data["printDocuments"];
            this.setInvoiceDateFromSupplierInvoice = _data["setInvoiceDateFromSupplierInvoice"];
            this.emailDocuments = _data["emailDocuments"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InvoiceReleaseDisplay {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceReleaseDisplay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creditNoteMode"] = this.creditNoteMode;
        data["hasDirectOrdersToRelease"] = this.hasDirectOrdersToRelease;
        data["hasNotepadCases"] = this.hasNotepadCases;
        data["defaultToEmail"] = this.defaultToEmail;
        data["printDocuments"] = this.printDocuments;
        data["setInvoiceDateFromSupplierInvoice"] = this.setInvoiceDateFromSupplierInvoice;
        data["emailDocuments"] = this.emailDocuments;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IInvoiceReleaseDisplay {
    creditNoteMode?: boolean | undefined;
    hasDirectOrdersToRelease?: boolean | undefined;
    hasNotepadCases?: boolean | undefined;
    defaultToEmail?: boolean | undefined;
    printDocuments?: boolean | undefined;
    setInvoiceDateFromSupplierInvoice?: boolean | undefined;
    emailDocuments?: boolean | undefined;
    documentDate?: Date | undefined;
}

export class ProcessDisplay implements IProcessDisplay {
    errorsOccurred?: boolean | undefined;
    process?: ProcessDisplayProcess | undefined;
    documentDate?: Date | undefined;
    documentList?: OrderDocumentList[] | undefined;
    resultantList?: OrderDocumentList[] | undefined;
    extraProcess1?: boolean | undefined;
    extraData1?: any | undefined;
    extraProcess2?: boolean | undefined;
    extraData2?: any | undefined;
    setInvoiceDateFromSupplierInvoice?: boolean | undefined;
    orderDeliveryReference?: string | undefined;
    vehicleTypeID?: number | undefined;
    vehicleTypeName?: string | undefined;
    showResults?: boolean | undefined;
    deliveryVehicleID?: number | undefined;
    newNotepadCaseStatusID?: number | undefined;
    extraProcess3?: boolean | undefined;

    constructor(data?: IProcessDisplay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorsOccurred = _data["errorsOccurred"];
            this.process = _data["process"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["documentList"])) {
                this.documentList = [] as any;
                for (let item of _data["documentList"])
                    this.documentList!.push(OrderDocumentList.fromJS(item));
            }
            if (Array.isArray(_data["resultantList"])) {
                this.resultantList = [] as any;
                for (let item of _data["resultantList"])
                    this.resultantList!.push(OrderDocumentList.fromJS(item));
            }
            this.extraProcess1 = _data["extraProcess1"];
            this.extraData1 = _data["extraData1"];
            this.extraProcess2 = _data["extraProcess2"];
            this.extraData2 = _data["extraData2"];
            this.setInvoiceDateFromSupplierInvoice = _data["setInvoiceDateFromSupplierInvoice"];
            this.orderDeliveryReference = _data["orderDeliveryReference"];
            this.vehicleTypeID = _data["vehicleTypeID"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.showResults = _data["showResults"];
            this.deliveryVehicleID = _data["deliveryVehicleID"];
            this.newNotepadCaseStatusID = _data["newNotepadCaseStatusID"];
            this.extraProcess3 = _data["extraProcess3"];
        }
    }

    static fromJS(data: any): ProcessDisplay {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDisplay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorsOccurred"] = this.errorsOccurred;
        data["process"] = this.process;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        if (Array.isArray(this.documentList)) {
            data["documentList"] = [];
            for (let item of this.documentList)
                data["documentList"].push(item.toJSON());
        }
        if (Array.isArray(this.resultantList)) {
            data["resultantList"] = [];
            for (let item of this.resultantList)
                data["resultantList"].push(item.toJSON());
        }
        data["extraProcess1"] = this.extraProcess1;
        data["extraData1"] = this.extraData1;
        data["extraProcess2"] = this.extraProcess2;
        data["extraData2"] = this.extraData2;
        data["setInvoiceDateFromSupplierInvoice"] = this.setInvoiceDateFromSupplierInvoice;
        data["orderDeliveryReference"] = this.orderDeliveryReference;
        data["vehicleTypeID"] = this.vehicleTypeID;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["showResults"] = this.showResults;
        data["deliveryVehicleID"] = this.deliveryVehicleID;
        data["newNotepadCaseStatusID"] = this.newNotepadCaseStatusID;
        data["extraProcess3"] = this.extraProcess3;
        return data; 
    }
}

export interface IProcessDisplay {
    errorsOccurred?: boolean | undefined;
    process?: ProcessDisplayProcess | undefined;
    documentDate?: Date | undefined;
    documentList?: OrderDocumentList[] | undefined;
    resultantList?: OrderDocumentList[] | undefined;
    extraProcess1?: boolean | undefined;
    extraData1?: any | undefined;
    extraProcess2?: boolean | undefined;
    extraData2?: any | undefined;
    setInvoiceDateFromSupplierInvoice?: boolean | undefined;
    orderDeliveryReference?: string | undefined;
    vehicleTypeID?: number | undefined;
    vehicleTypeName?: string | undefined;
    showResults?: boolean | undefined;
    deliveryVehicleID?: number | undefined;
    newNotepadCaseStatusID?: number | undefined;
    extraProcess3?: boolean | undefined;
}

export class OrderDocumentList implements IOrderDocumentList {
    selected?: boolean | undefined;
    stockBranchID?: number | undefined;
    transferStockShortage?: boolean | undefined;
    cashOnDeliveryOutstandingInCurrency?: number | undefined;
    documentType?: OrderDocumentListDocumentType | undefined;
    orderID?: number | undefined;
    orderNumber?: number | undefined;
    orderType?: number | undefined;
    orderStatus?: number | undefined;
    orderSubStatus?: number | undefined;
    description?: string | undefined;
    saleType?: number | undefined;
    cashSale?: boolean | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    lastModifiedByID?: number | undefined;
    branchID?: number | undefined;
    issuingBranchID?: number | undefined;
    toBranchID?: number | undefined;
    viaBranchID?: number | undefined;
    stockLocationID?: number | undefined;
    toStockLocationID?: number | undefined;
    userID?: number | undefined;
    deliveryAreaID?: number | undefined;
    deliveryCity?: string | undefined;
    deliveryAddress?: string | undefined;
    deliveryAddressLine1?: string | undefined;
    deliveryAddressLine2?: string | undefined;
    deliveryAddressLine3?: string | undefined;
    deliveryCounty?: string | undefined;
    deliveryPostCode?: string | undefined;
    deliveryCountry?: string | undefined;
    invoiceAddress?: string | undefined;
    excludeFromWMS?: number | undefined;
    dateRequested?: Date | undefined;
    dateRequired?: Date | undefined;
    dateRequiredOption?: number | undefined;
    expiryDate?: Date | undefined;
    quoteRank?: string | undefined;
    totalInternalCostPrice?: number | undefined;
    totalCostPrice?: number | undefined;
    settlementAmount?: number | undefined;
    supplierSettlementAmount?: number | undefined;
    totalSellPrice?: number | undefined;
    totalVAT?: number | undefined;
    totalTax?: number | undefined;
    totalMargin?: number | undefined;
    internalCostTotalMargin?: number | undefined;
    commissionTotalMargin?: number | undefined;
    commissionTotalCostPrice?: number | undefined;
    totalWeight?: number | undefined;
    totalVolume?: number | undefined;
    noOfPacks?: number | undefined;
    maximumWidth?: number | undefined;
    maximumLength?: number | undefined;
    customerID?: number | undefined;
    customerRef?: string | undefined;
    yardBookRef?: string | undefined;
    arCustomerID?: number | undefined;
    outstandingAVOs?: number | undefined;
    outstandingCuts?: number | undefined;
    noOfLines?: number | undefined;
    hasProfiles?: number | undefined;
    callOffEnforceSchedule?: number | undefined;
    worksOrderCount?: number | undefined;
    worksOrderCountCompleted?: number | undefined;
    picked?: boolean | undefined;
    delivered?: boolean | undefined;
    deliveryDate?: Date | undefined;
    deliveryTime?: number | undefined;
    deliveryTimeName?: string | undefined;
    deliveryReference?: string | undefined;
    proofOfDeliveryReturned?: number | undefined;
    stockIssued?: boolean | undefined;
    approval?: number | undefined;
    dateTimeApproved?: Date | undefined;
    invoiceID?: number | undefined;
    invoiceNumber?: number | undefined;
    invoiced?: boolean | undefined;
    dateTimeTransferred?: Date | undefined;
    specialInstructions?: string | undefined;
    notes?: string | undefined;
    printed?: number | undefined;
    printedPickingNote?: number | undefined;
    printedDeliveryNote?: number | undefined;
    approvalNumber?: string | undefined;
    wmsPickingStatus?: number | undefined;
    nonSalesAmount?: number | undefined;
    nonSalesAmountInCurrency?: number | undefined;
    cashOnDeliveryAmount?: number | undefined;
    cashOnDeliveryRequested?: number | undefined;
    cashOnDeliveryReceived?: number | undefined;
    cashAccountBalanceAmount?: number | undefined;
    paymentOutstanding?: number | undefined;
    cashOnDeliveryAmountInCurrency?: number | undefined;
    cashOnDeliveryRequestedInCurrency?: number | undefined;
    cashOnDeliveryReceivedInCurrency?: number | undefined;
    paymentOutstandingInCurrency?: number | undefined;
    useSimpleOrderProcessing?: number | undefined;
    otherFlags?: number | undefined;
    journeyID?: number | undefined;
    splitJourneyToSchedule?: number | undefined;
    releaseTotalSellPrice?: number | undefined;
    sellPriceProfileID?: number | undefined;
    currencyID?: number | undefined;
    exchangeRate?: number | undefined;
    contractID?: number | undefined;
    followUpDateTime?: Date | undefined;
    viaBranchJourneyID?: number | undefined;
    needsJourneyFromViaBranch?: number | undefined;
    dateTimeQuoteAccepted?: Date | undefined;
    dateTimeQuoteRejected?: Date | undefined;
    rejectedOrAcceptedByID?: number | undefined;
    rejectionReasonID?: number | undefined;
    opportunityID?: number | undefined;
    totalSellPriceInCurrency?: number | undefined;
    totalVATInCurrency?: number | undefined;
    totalTaxInCurrency?: number | undefined;
    deleted?: number | undefined;
    salesRepID?: number | undefined;
    deliveryFax?: string | undefined;
    invoiceFax?: string | undefined;
    deliveryEmail?: string | undefined;
    invoiceEmail?: string | undefined;
    contactEmailAddress?: string | undefined;
    createdFromQuoteNumber?: number | undefined;
    hasAddCostProrations?: number | undefined;
    pickingStartedByID?: number | undefined;
    dateTimePickingStarted?: Date | undefined;
    dateTimePicked?: Date | undefined;
    pickingStartedByName?: string | undefined;
    checkedByID?: number | undefined;
    dateTimeChecked?: Date | undefined;
    checkedByName?: string | undefined;
    pickCompletedByID?: number | undefined;
    dateTimePickCompleted?: Date | undefined;
    pickCompletedByName?: string | undefined;
    ediDocumentID?: number | undefined;
    createdByName?: string | undefined;
    lastModifiedByName?: string | undefined;
    customerCode?: string | undefined;
    customerName?: string | undefined;
    cashAccount?: number | undefined;
    contactName?: string | undefined;
    contactNumber?: string | undefined;
    creditControllerName?: string | undefined;
    arCustomerCreditControllerName?: string | undefined;
    takenByName?: string | undefined;
    customerOnHold?: boolean | undefined;
    customerCreditControlStatusID?: number | undefined;
    customerIsCashAccount?: boolean | undefined;
    customerShowPricesOnAdviceNote?: number | undefined;
    arCustomerCode?: string | undefined;
    arCustomerName?: string | undefined;
    customerAutoEmailManualInvoice?: number | undefined;
    customerAvailableCredit?: number | undefined;
    arCustomerAvailableCredit?: number | undefined;
    branchName?: string | undefined;
    toBranchName?: string | undefined;
    viaBranchName?: string | undefined;
    issuingBranchName?: string | undefined;
    stockLocationName?: string | undefined;
    toStockLocationName?: string | undefined;
    deliveryAddressCode?: string | undefined;
    deliveryAreaName?: string | undefined;
    approvedByName?: string | undefined;
    printedInvoice?: number | undefined;
    backOrderedFromID?: number | undefined;
    backOrderFromNumber?: number | undefined;
    journeyNumber?: number | undefined;
    journeyStatus?: number | undefined;
    journeyDate?: Date | undefined;
    journeyPlannedStartDateTime?: Date | undefined;
    cutToLengthCount?: number | undefined;
    journeyCountSaved?: number | undefined;
    journeyCountInProgress?: number | undefined;
    journeyCountComplete?: number | undefined;
    printTestCertificates?: number | undefined;
    salesRepName?: string | undefined;
    totalTaxOnCost?: number | undefined;
    totalTaxOnCostInCurrency?: number | undefined;
    totalVMICostPrice?: number | undefined;
    jobID?: number | undefined;
    jobReference?: string | undefined;
    vehicleTypeID?: number | undefined;
    vehicleTypeName?: string | undefined;
    vehicleID?: number | undefined;
    deliveryVehicleName?: string | undefined;
    jobStatus?: number | undefined;
    viaBranchVehicleTypeID?: number | undefined;
    viaBranchVehicleTypeName?: string | undefined;
    viaBranchVehicleID?: number | undefined;
    viaBranchVehicleName?: string | undefined;
    departmentName?: string | undefined;
    toDepartmentName?: string | undefined;
    orderPlacementTypeName?: string | undefined;
    waitingForRFP?: number | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;
    isValid?: boolean | undefined;
    errorList?: string | undefined;
    printTheseFormats?: string | undefined;

    constructor(data?: IOrderDocumentList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selected = _data["selected"];
            this.stockBranchID = _data["stockBranchID"];
            this.transferStockShortage = _data["transferStockShortage"];
            this.cashOnDeliveryOutstandingInCurrency = _data["cashOnDeliveryOutstandingInCurrency"];
            this.documentType = _data["documentType"];
            this.orderID = _data["orderID"];
            this.orderNumber = _data["orderNumber"];
            this.orderType = _data["orderType"];
            this.orderStatus = _data["orderStatus"];
            this.orderSubStatus = _data["orderSubStatus"];
            this.description = _data["description"];
            this.saleType = _data["saleType"];
            this.cashSale = _data["cashSale"];
            this.dateTimeCreated = _data["dateTimeCreated"] ? new Date(_data["dateTimeCreated"].toString()) : <any>undefined;
            this.createdByID = _data["createdByID"];
            this.dateTimeLastModified = _data["dateTimeLastModified"] ? new Date(_data["dateTimeLastModified"].toString()) : <any>undefined;
            this.lastModifiedByID = _data["lastModifiedByID"];
            this.branchID = _data["branchID"];
            this.issuingBranchID = _data["issuingBranchID"];
            this.toBranchID = _data["toBranchID"];
            this.viaBranchID = _data["viaBranchID"];
            this.stockLocationID = _data["stockLocationID"];
            this.toStockLocationID = _data["toStockLocationID"];
            this.userID = _data["userID"];
            this.deliveryAreaID = _data["deliveryAreaID"];
            this.deliveryCity = _data["deliveryCity"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.deliveryAddressLine1 = _data["deliveryAddressLine1"];
            this.deliveryAddressLine2 = _data["deliveryAddressLine2"];
            this.deliveryAddressLine3 = _data["deliveryAddressLine3"];
            this.deliveryCounty = _data["deliveryCounty"];
            this.deliveryPostCode = _data["deliveryPostCode"];
            this.deliveryCountry = _data["deliveryCountry"];
            this.invoiceAddress = _data["invoiceAddress"];
            this.excludeFromWMS = _data["excludeFromWMS"];
            this.dateRequested = _data["dateRequested"] ? new Date(_data["dateRequested"].toString()) : <any>undefined;
            this.dateRequired = _data["dateRequired"] ? new Date(_data["dateRequired"].toString()) : <any>undefined;
            this.dateRequiredOption = _data["dateRequiredOption"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : <any>undefined;
            this.quoteRank = _data["quoteRank"];
            this.totalInternalCostPrice = _data["totalInternalCostPrice"];
            this.totalCostPrice = _data["totalCostPrice"];
            this.settlementAmount = _data["settlementAmount"];
            this.supplierSettlementAmount = _data["supplierSettlementAmount"];
            this.totalSellPrice = _data["totalSellPrice"];
            this.totalVAT = _data["totalVAT"];
            this.totalTax = _data["totalTax"];
            this.totalMargin = _data["totalMargin"];
            this.internalCostTotalMargin = _data["internalCostTotalMargin"];
            this.commissionTotalMargin = _data["commissionTotalMargin"];
            this.commissionTotalCostPrice = _data["commissionTotalCostPrice"];
            this.totalWeight = _data["totalWeight"];
            this.totalVolume = _data["totalVolume"];
            this.noOfPacks = _data["noOfPacks"];
            this.maximumWidth = _data["maximumWidth"];
            this.maximumLength = _data["maximumLength"];
            this.customerID = _data["customerID"];
            this.customerRef = _data["customerRef"];
            this.yardBookRef = _data["yardBookRef"];
            this.arCustomerID = _data["arCustomerID"];
            this.outstandingAVOs = _data["outstandingAVOs"];
            this.outstandingCuts = _data["outstandingCuts"];
            this.noOfLines = _data["noOfLines"];
            this.hasProfiles = _data["hasProfiles"];
            this.callOffEnforceSchedule = _data["callOffEnforceSchedule"];
            this.worksOrderCount = _data["worksOrderCount"];
            this.worksOrderCountCompleted = _data["worksOrderCountCompleted"];
            this.picked = _data["picked"];
            this.delivered = _data["delivered"];
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : <any>undefined;
            this.deliveryTime = _data["deliveryTime"];
            this.deliveryTimeName = _data["deliveryTimeName"];
            this.deliveryReference = _data["deliveryReference"];
            this.proofOfDeliveryReturned = _data["proofOfDeliveryReturned"];
            this.stockIssued = _data["stockIssued"];
            this.approval = _data["approval"];
            this.dateTimeApproved = _data["dateTimeApproved"] ? new Date(_data["dateTimeApproved"].toString()) : <any>undefined;
            this.invoiceID = _data["invoiceID"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiced = _data["invoiced"];
            this.dateTimeTransferred = _data["dateTimeTransferred"] ? new Date(_data["dateTimeTransferred"].toString()) : <any>undefined;
            this.specialInstructions = _data["specialInstructions"];
            this.notes = _data["notes"];
            this.printed = _data["printed"];
            this.printedPickingNote = _data["printedPickingNote"];
            this.printedDeliveryNote = _data["printedDeliveryNote"];
            this.approvalNumber = _data["approvalNumber"];
            this.wmsPickingStatus = _data["wmsPickingStatus"];
            this.nonSalesAmount = _data["nonSalesAmount"];
            this.nonSalesAmountInCurrency = _data["nonSalesAmountInCurrency"];
            this.cashOnDeliveryAmount = _data["cashOnDeliveryAmount"];
            this.cashOnDeliveryRequested = _data["cashOnDeliveryRequested"];
            this.cashOnDeliveryReceived = _data["cashOnDeliveryReceived"];
            this.cashAccountBalanceAmount = _data["cashAccountBalanceAmount"];
            this.paymentOutstanding = _data["paymentOutstanding"];
            this.cashOnDeliveryAmountInCurrency = _data["cashOnDeliveryAmountInCurrency"];
            this.cashOnDeliveryRequestedInCurrency = _data["cashOnDeliveryRequestedInCurrency"];
            this.cashOnDeliveryReceivedInCurrency = _data["cashOnDeliveryReceivedInCurrency"];
            this.paymentOutstandingInCurrency = _data["paymentOutstandingInCurrency"];
            this.useSimpleOrderProcessing = _data["useSimpleOrderProcessing"];
            this.otherFlags = _data["otherFlags"];
            this.journeyID = _data["journeyID"];
            this.splitJourneyToSchedule = _data["splitJourneyToSchedule"];
            this.releaseTotalSellPrice = _data["releaseTotalSellPrice"];
            this.sellPriceProfileID = _data["sellPriceProfileID"];
            this.currencyID = _data["currencyID"];
            this.exchangeRate = _data["exchangeRate"];
            this.contractID = _data["contractID"];
            this.followUpDateTime = _data["followUpDateTime"] ? new Date(_data["followUpDateTime"].toString()) : <any>undefined;
            this.viaBranchJourneyID = _data["viaBranchJourneyID"];
            this.needsJourneyFromViaBranch = _data["needsJourneyFromViaBranch"];
            this.dateTimeQuoteAccepted = _data["dateTimeQuoteAccepted"] ? new Date(_data["dateTimeQuoteAccepted"].toString()) : <any>undefined;
            this.dateTimeQuoteRejected = _data["dateTimeQuoteRejected"] ? new Date(_data["dateTimeQuoteRejected"].toString()) : <any>undefined;
            this.rejectedOrAcceptedByID = _data["rejectedOrAcceptedByID"];
            this.rejectionReasonID = _data["rejectionReasonID"];
            this.opportunityID = _data["opportunityID"];
            this.totalSellPriceInCurrency = _data["totalSellPriceInCurrency"];
            this.totalVATInCurrency = _data["totalVATInCurrency"];
            this.totalTaxInCurrency = _data["totalTaxInCurrency"];
            this.deleted = _data["deleted"];
            this.salesRepID = _data["salesRepID"];
            this.deliveryFax = _data["deliveryFax"];
            this.invoiceFax = _data["invoiceFax"];
            this.deliveryEmail = _data["deliveryEmail"];
            this.invoiceEmail = _data["invoiceEmail"];
            this.contactEmailAddress = _data["contactEmailAddress"];
            this.createdFromQuoteNumber = _data["createdFromQuoteNumber"];
            this.hasAddCostProrations = _data["hasAddCostProrations"];
            this.pickingStartedByID = _data["pickingStartedByID"];
            this.dateTimePickingStarted = _data["dateTimePickingStarted"] ? new Date(_data["dateTimePickingStarted"].toString()) : <any>undefined;
            this.dateTimePicked = _data["dateTimePicked"] ? new Date(_data["dateTimePicked"].toString()) : <any>undefined;
            this.pickingStartedByName = _data["pickingStartedByName"];
            this.checkedByID = _data["checkedByID"];
            this.dateTimeChecked = _data["dateTimeChecked"] ? new Date(_data["dateTimeChecked"].toString()) : <any>undefined;
            this.checkedByName = _data["checkedByName"];
            this.pickCompletedByID = _data["pickCompletedByID"];
            this.dateTimePickCompleted = _data["dateTimePickCompleted"] ? new Date(_data["dateTimePickCompleted"].toString()) : <any>undefined;
            this.pickCompletedByName = _data["pickCompletedByName"];
            this.ediDocumentID = _data["ediDocumentID"];
            this.createdByName = _data["createdByName"];
            this.lastModifiedByName = _data["lastModifiedByName"];
            this.customerCode = _data["customerCode"];
            this.customerName = _data["customerName"];
            this.cashAccount = _data["cashAccount"];
            this.contactName = _data["contactName"];
            this.contactNumber = _data["contactNumber"];
            this.creditControllerName = _data["creditControllerName"];
            this.arCustomerCreditControllerName = _data["arCustomerCreditControllerName"];
            this.takenByName = _data["takenByName"];
            this.customerOnHold = _data["customerOnHold"];
            this.customerCreditControlStatusID = _data["customerCreditControlStatusID"];
            this.customerIsCashAccount = _data["customerIsCashAccount"];
            this.customerShowPricesOnAdviceNote = _data["customerShowPricesOnAdviceNote"];
            this.arCustomerCode = _data["arCustomerCode"];
            this.arCustomerName = _data["arCustomerName"];
            this.customerAutoEmailManualInvoice = _data["customerAutoEmailManualInvoice"];
            this.customerAvailableCredit = _data["customerAvailableCredit"];
            this.arCustomerAvailableCredit = _data["arCustomerAvailableCredit"];
            this.branchName = _data["branchName"];
            this.toBranchName = _data["toBranchName"];
            this.viaBranchName = _data["viaBranchName"];
            this.issuingBranchName = _data["issuingBranchName"];
            this.stockLocationName = _data["stockLocationName"];
            this.toStockLocationName = _data["toStockLocationName"];
            this.deliveryAddressCode = _data["deliveryAddressCode"];
            this.deliveryAreaName = _data["deliveryAreaName"];
            this.approvedByName = _data["approvedByName"];
            this.printedInvoice = _data["printedInvoice"];
            this.backOrderedFromID = _data["backOrderedFromID"];
            this.backOrderFromNumber = _data["backOrderFromNumber"];
            this.journeyNumber = _data["journeyNumber"];
            this.journeyStatus = _data["journeyStatus"];
            this.journeyDate = _data["journeyDate"] ? new Date(_data["journeyDate"].toString()) : <any>undefined;
            this.journeyPlannedStartDateTime = _data["journeyPlannedStartDateTime"] ? new Date(_data["journeyPlannedStartDateTime"].toString()) : <any>undefined;
            this.cutToLengthCount = _data["cutToLengthCount"];
            this.journeyCountSaved = _data["journeyCountSaved"];
            this.journeyCountInProgress = _data["journeyCountInProgress"];
            this.journeyCountComplete = _data["journeyCountComplete"];
            this.printTestCertificates = _data["printTestCertificates"];
            this.salesRepName = _data["salesRepName"];
            this.totalTaxOnCost = _data["totalTaxOnCost"];
            this.totalTaxOnCostInCurrency = _data["totalTaxOnCostInCurrency"];
            this.totalVMICostPrice = _data["totalVMICostPrice"];
            this.jobID = _data["jobID"];
            this.jobReference = _data["jobReference"];
            this.vehicleTypeID = _data["vehicleTypeID"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.vehicleID = _data["vehicleID"];
            this.deliveryVehicleName = _data["deliveryVehicleName"];
            this.jobStatus = _data["jobStatus"];
            this.viaBranchVehicleTypeID = _data["viaBranchVehicleTypeID"];
            this.viaBranchVehicleTypeName = _data["viaBranchVehicleTypeName"];
            this.viaBranchVehicleID = _data["viaBranchVehicleID"];
            this.viaBranchVehicleName = _data["viaBranchVehicleName"];
            this.departmentName = _data["departmentName"];
            this.toDepartmentName = _data["toDepartmentName"];
            this.orderPlacementTypeName = _data["orderPlacementTypeName"];
            this.waitingForRFP = _data["waitingForRFP"];
            this.supplierCode = _data["supplierCode"];
            this.supplierName = _data["supplierName"];
            this.isValid = _data["isValid"];
            this.errorList = _data["errorList"];
            this.printTheseFormats = _data["printTheseFormats"];
        }
    }

    static fromJS(data: any): OrderDocumentList {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDocumentList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selected"] = this.selected;
        data["stockBranchID"] = this.stockBranchID;
        data["transferStockShortage"] = this.transferStockShortage;
        data["cashOnDeliveryOutstandingInCurrency"] = this.cashOnDeliveryOutstandingInCurrency;
        data["documentType"] = this.documentType;
        data["orderID"] = this.orderID;
        data["orderNumber"] = this.orderNumber;
        data["orderType"] = this.orderType;
        data["orderStatus"] = this.orderStatus;
        data["orderSubStatus"] = this.orderSubStatus;
        data["description"] = this.description;
        data["saleType"] = this.saleType;
        data["cashSale"] = this.cashSale;
        data["dateTimeCreated"] = this.dateTimeCreated ? this.dateTimeCreated.toISOString() : <any>undefined;
        data["createdByID"] = this.createdByID;
        data["dateTimeLastModified"] = this.dateTimeLastModified ? this.dateTimeLastModified.toISOString() : <any>undefined;
        data["lastModifiedByID"] = this.lastModifiedByID;
        data["branchID"] = this.branchID;
        data["issuingBranchID"] = this.issuingBranchID;
        data["toBranchID"] = this.toBranchID;
        data["viaBranchID"] = this.viaBranchID;
        data["stockLocationID"] = this.stockLocationID;
        data["toStockLocationID"] = this.toStockLocationID;
        data["userID"] = this.userID;
        data["deliveryAreaID"] = this.deliveryAreaID;
        data["deliveryCity"] = this.deliveryCity;
        data["deliveryAddress"] = this.deliveryAddress;
        data["deliveryAddressLine1"] = this.deliveryAddressLine1;
        data["deliveryAddressLine2"] = this.deliveryAddressLine2;
        data["deliveryAddressLine3"] = this.deliveryAddressLine3;
        data["deliveryCounty"] = this.deliveryCounty;
        data["deliveryPostCode"] = this.deliveryPostCode;
        data["deliveryCountry"] = this.deliveryCountry;
        data["invoiceAddress"] = this.invoiceAddress;
        data["excludeFromWMS"] = this.excludeFromWMS;
        data["dateRequested"] = this.dateRequested ? this.dateRequested.toISOString() : <any>undefined;
        data["dateRequired"] = this.dateRequired ? this.dateRequired.toISOString() : <any>undefined;
        data["dateRequiredOption"] = this.dateRequiredOption;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : <any>undefined;
        data["quoteRank"] = this.quoteRank;
        data["totalInternalCostPrice"] = this.totalInternalCostPrice;
        data["totalCostPrice"] = this.totalCostPrice;
        data["settlementAmount"] = this.settlementAmount;
        data["supplierSettlementAmount"] = this.supplierSettlementAmount;
        data["totalSellPrice"] = this.totalSellPrice;
        data["totalVAT"] = this.totalVAT;
        data["totalTax"] = this.totalTax;
        data["totalMargin"] = this.totalMargin;
        data["internalCostTotalMargin"] = this.internalCostTotalMargin;
        data["commissionTotalMargin"] = this.commissionTotalMargin;
        data["commissionTotalCostPrice"] = this.commissionTotalCostPrice;
        data["totalWeight"] = this.totalWeight;
        data["totalVolume"] = this.totalVolume;
        data["noOfPacks"] = this.noOfPacks;
        data["maximumWidth"] = this.maximumWidth;
        data["maximumLength"] = this.maximumLength;
        data["customerID"] = this.customerID;
        data["customerRef"] = this.customerRef;
        data["yardBookRef"] = this.yardBookRef;
        data["arCustomerID"] = this.arCustomerID;
        data["outstandingAVOs"] = this.outstandingAVOs;
        data["outstandingCuts"] = this.outstandingCuts;
        data["noOfLines"] = this.noOfLines;
        data["hasProfiles"] = this.hasProfiles;
        data["callOffEnforceSchedule"] = this.callOffEnforceSchedule;
        data["worksOrderCount"] = this.worksOrderCount;
        data["worksOrderCountCompleted"] = this.worksOrderCountCompleted;
        data["picked"] = this.picked;
        data["delivered"] = this.delivered;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["deliveryTime"] = this.deliveryTime;
        data["deliveryTimeName"] = this.deliveryTimeName;
        data["deliveryReference"] = this.deliveryReference;
        data["proofOfDeliveryReturned"] = this.proofOfDeliveryReturned;
        data["stockIssued"] = this.stockIssued;
        data["approval"] = this.approval;
        data["dateTimeApproved"] = this.dateTimeApproved ? this.dateTimeApproved.toISOString() : <any>undefined;
        data["invoiceID"] = this.invoiceID;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiced"] = this.invoiced;
        data["dateTimeTransferred"] = this.dateTimeTransferred ? this.dateTimeTransferred.toISOString() : <any>undefined;
        data["specialInstructions"] = this.specialInstructions;
        data["notes"] = this.notes;
        data["printed"] = this.printed;
        data["printedPickingNote"] = this.printedPickingNote;
        data["printedDeliveryNote"] = this.printedDeliveryNote;
        data["approvalNumber"] = this.approvalNumber;
        data["wmsPickingStatus"] = this.wmsPickingStatus;
        data["nonSalesAmount"] = this.nonSalesAmount;
        data["nonSalesAmountInCurrency"] = this.nonSalesAmountInCurrency;
        data["cashOnDeliveryAmount"] = this.cashOnDeliveryAmount;
        data["cashOnDeliveryRequested"] = this.cashOnDeliveryRequested;
        data["cashOnDeliveryReceived"] = this.cashOnDeliveryReceived;
        data["cashAccountBalanceAmount"] = this.cashAccountBalanceAmount;
        data["paymentOutstanding"] = this.paymentOutstanding;
        data["cashOnDeliveryAmountInCurrency"] = this.cashOnDeliveryAmountInCurrency;
        data["cashOnDeliveryRequestedInCurrency"] = this.cashOnDeliveryRequestedInCurrency;
        data["cashOnDeliveryReceivedInCurrency"] = this.cashOnDeliveryReceivedInCurrency;
        data["paymentOutstandingInCurrency"] = this.paymentOutstandingInCurrency;
        data["useSimpleOrderProcessing"] = this.useSimpleOrderProcessing;
        data["otherFlags"] = this.otherFlags;
        data["journeyID"] = this.journeyID;
        data["splitJourneyToSchedule"] = this.splitJourneyToSchedule;
        data["releaseTotalSellPrice"] = this.releaseTotalSellPrice;
        data["sellPriceProfileID"] = this.sellPriceProfileID;
        data["currencyID"] = this.currencyID;
        data["exchangeRate"] = this.exchangeRate;
        data["contractID"] = this.contractID;
        data["followUpDateTime"] = this.followUpDateTime ? this.followUpDateTime.toISOString() : <any>undefined;
        data["viaBranchJourneyID"] = this.viaBranchJourneyID;
        data["needsJourneyFromViaBranch"] = this.needsJourneyFromViaBranch;
        data["dateTimeQuoteAccepted"] = this.dateTimeQuoteAccepted ? this.dateTimeQuoteAccepted.toISOString() : <any>undefined;
        data["dateTimeQuoteRejected"] = this.dateTimeQuoteRejected ? this.dateTimeQuoteRejected.toISOString() : <any>undefined;
        data["rejectedOrAcceptedByID"] = this.rejectedOrAcceptedByID;
        data["rejectionReasonID"] = this.rejectionReasonID;
        data["opportunityID"] = this.opportunityID;
        data["totalSellPriceInCurrency"] = this.totalSellPriceInCurrency;
        data["totalVATInCurrency"] = this.totalVATInCurrency;
        data["totalTaxInCurrency"] = this.totalTaxInCurrency;
        data["deleted"] = this.deleted;
        data["salesRepID"] = this.salesRepID;
        data["deliveryFax"] = this.deliveryFax;
        data["invoiceFax"] = this.invoiceFax;
        data["deliveryEmail"] = this.deliveryEmail;
        data["invoiceEmail"] = this.invoiceEmail;
        data["contactEmailAddress"] = this.contactEmailAddress;
        data["createdFromQuoteNumber"] = this.createdFromQuoteNumber;
        data["hasAddCostProrations"] = this.hasAddCostProrations;
        data["pickingStartedByID"] = this.pickingStartedByID;
        data["dateTimePickingStarted"] = this.dateTimePickingStarted ? this.dateTimePickingStarted.toISOString() : <any>undefined;
        data["dateTimePicked"] = this.dateTimePicked ? this.dateTimePicked.toISOString() : <any>undefined;
        data["pickingStartedByName"] = this.pickingStartedByName;
        data["checkedByID"] = this.checkedByID;
        data["dateTimeChecked"] = this.dateTimeChecked ? this.dateTimeChecked.toISOString() : <any>undefined;
        data["checkedByName"] = this.checkedByName;
        data["pickCompletedByID"] = this.pickCompletedByID;
        data["dateTimePickCompleted"] = this.dateTimePickCompleted ? this.dateTimePickCompleted.toISOString() : <any>undefined;
        data["pickCompletedByName"] = this.pickCompletedByName;
        data["ediDocumentID"] = this.ediDocumentID;
        data["createdByName"] = this.createdByName;
        data["lastModifiedByName"] = this.lastModifiedByName;
        data["customerCode"] = this.customerCode;
        data["customerName"] = this.customerName;
        data["cashAccount"] = this.cashAccount;
        data["contactName"] = this.contactName;
        data["contactNumber"] = this.contactNumber;
        data["creditControllerName"] = this.creditControllerName;
        data["arCustomerCreditControllerName"] = this.arCustomerCreditControllerName;
        data["takenByName"] = this.takenByName;
        data["customerOnHold"] = this.customerOnHold;
        data["customerCreditControlStatusID"] = this.customerCreditControlStatusID;
        data["customerIsCashAccount"] = this.customerIsCashAccount;
        data["customerShowPricesOnAdviceNote"] = this.customerShowPricesOnAdviceNote;
        data["arCustomerCode"] = this.arCustomerCode;
        data["arCustomerName"] = this.arCustomerName;
        data["customerAutoEmailManualInvoice"] = this.customerAutoEmailManualInvoice;
        data["customerAvailableCredit"] = this.customerAvailableCredit;
        data["arCustomerAvailableCredit"] = this.arCustomerAvailableCredit;
        data["branchName"] = this.branchName;
        data["toBranchName"] = this.toBranchName;
        data["viaBranchName"] = this.viaBranchName;
        data["issuingBranchName"] = this.issuingBranchName;
        data["stockLocationName"] = this.stockLocationName;
        data["toStockLocationName"] = this.toStockLocationName;
        data["deliveryAddressCode"] = this.deliveryAddressCode;
        data["deliveryAreaName"] = this.deliveryAreaName;
        data["approvedByName"] = this.approvedByName;
        data["printedInvoice"] = this.printedInvoice;
        data["backOrderedFromID"] = this.backOrderedFromID;
        data["backOrderFromNumber"] = this.backOrderFromNumber;
        data["journeyNumber"] = this.journeyNumber;
        data["journeyStatus"] = this.journeyStatus;
        data["journeyDate"] = this.journeyDate ? this.journeyDate.toISOString() : <any>undefined;
        data["journeyPlannedStartDateTime"] = this.journeyPlannedStartDateTime ? this.journeyPlannedStartDateTime.toISOString() : <any>undefined;
        data["cutToLengthCount"] = this.cutToLengthCount;
        data["journeyCountSaved"] = this.journeyCountSaved;
        data["journeyCountInProgress"] = this.journeyCountInProgress;
        data["journeyCountComplete"] = this.journeyCountComplete;
        data["printTestCertificates"] = this.printTestCertificates;
        data["salesRepName"] = this.salesRepName;
        data["totalTaxOnCost"] = this.totalTaxOnCost;
        data["totalTaxOnCostInCurrency"] = this.totalTaxOnCostInCurrency;
        data["totalVMICostPrice"] = this.totalVMICostPrice;
        data["jobID"] = this.jobID;
        data["jobReference"] = this.jobReference;
        data["vehicleTypeID"] = this.vehicleTypeID;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["vehicleID"] = this.vehicleID;
        data["deliveryVehicleName"] = this.deliveryVehicleName;
        data["jobStatus"] = this.jobStatus;
        data["viaBranchVehicleTypeID"] = this.viaBranchVehicleTypeID;
        data["viaBranchVehicleTypeName"] = this.viaBranchVehicleTypeName;
        data["viaBranchVehicleID"] = this.viaBranchVehicleID;
        data["viaBranchVehicleName"] = this.viaBranchVehicleName;
        data["departmentName"] = this.departmentName;
        data["toDepartmentName"] = this.toDepartmentName;
        data["orderPlacementTypeName"] = this.orderPlacementTypeName;
        data["waitingForRFP"] = this.waitingForRFP;
        data["supplierCode"] = this.supplierCode;
        data["supplierName"] = this.supplierName;
        data["isValid"] = this.isValid;
        data["errorList"] = this.errorList;
        data["printTheseFormats"] = this.printTheseFormats;
        return data; 
    }
}

export interface IOrderDocumentList {
    selected?: boolean | undefined;
    stockBranchID?: number | undefined;
    transferStockShortage?: boolean | undefined;
    cashOnDeliveryOutstandingInCurrency?: number | undefined;
    documentType?: OrderDocumentListDocumentType | undefined;
    orderID?: number | undefined;
    orderNumber?: number | undefined;
    orderType?: number | undefined;
    orderStatus?: number | undefined;
    orderSubStatus?: number | undefined;
    description?: string | undefined;
    saleType?: number | undefined;
    cashSale?: boolean | undefined;
    dateTimeCreated?: Date | undefined;
    createdByID?: number | undefined;
    dateTimeLastModified?: Date | undefined;
    lastModifiedByID?: number | undefined;
    branchID?: number | undefined;
    issuingBranchID?: number | undefined;
    toBranchID?: number | undefined;
    viaBranchID?: number | undefined;
    stockLocationID?: number | undefined;
    toStockLocationID?: number | undefined;
    userID?: number | undefined;
    deliveryAreaID?: number | undefined;
    deliveryCity?: string | undefined;
    deliveryAddress?: string | undefined;
    deliveryAddressLine1?: string | undefined;
    deliveryAddressLine2?: string | undefined;
    deliveryAddressLine3?: string | undefined;
    deliveryCounty?: string | undefined;
    deliveryPostCode?: string | undefined;
    deliveryCountry?: string | undefined;
    invoiceAddress?: string | undefined;
    excludeFromWMS?: number | undefined;
    dateRequested?: Date | undefined;
    dateRequired?: Date | undefined;
    dateRequiredOption?: number | undefined;
    expiryDate?: Date | undefined;
    quoteRank?: string | undefined;
    totalInternalCostPrice?: number | undefined;
    totalCostPrice?: number | undefined;
    settlementAmount?: number | undefined;
    supplierSettlementAmount?: number | undefined;
    totalSellPrice?: number | undefined;
    totalVAT?: number | undefined;
    totalTax?: number | undefined;
    totalMargin?: number | undefined;
    internalCostTotalMargin?: number | undefined;
    commissionTotalMargin?: number | undefined;
    commissionTotalCostPrice?: number | undefined;
    totalWeight?: number | undefined;
    totalVolume?: number | undefined;
    noOfPacks?: number | undefined;
    maximumWidth?: number | undefined;
    maximumLength?: number | undefined;
    customerID?: number | undefined;
    customerRef?: string | undefined;
    yardBookRef?: string | undefined;
    arCustomerID?: number | undefined;
    outstandingAVOs?: number | undefined;
    outstandingCuts?: number | undefined;
    noOfLines?: number | undefined;
    hasProfiles?: number | undefined;
    callOffEnforceSchedule?: number | undefined;
    worksOrderCount?: number | undefined;
    worksOrderCountCompleted?: number | undefined;
    picked?: boolean | undefined;
    delivered?: boolean | undefined;
    deliveryDate?: Date | undefined;
    deliveryTime?: number | undefined;
    deliveryTimeName?: string | undefined;
    deliveryReference?: string | undefined;
    proofOfDeliveryReturned?: number | undefined;
    stockIssued?: boolean | undefined;
    approval?: number | undefined;
    dateTimeApproved?: Date | undefined;
    invoiceID?: number | undefined;
    invoiceNumber?: number | undefined;
    invoiced?: boolean | undefined;
    dateTimeTransferred?: Date | undefined;
    specialInstructions?: string | undefined;
    notes?: string | undefined;
    printed?: number | undefined;
    printedPickingNote?: number | undefined;
    printedDeliveryNote?: number | undefined;
    approvalNumber?: string | undefined;
    wmsPickingStatus?: number | undefined;
    nonSalesAmount?: number | undefined;
    nonSalesAmountInCurrency?: number | undefined;
    cashOnDeliveryAmount?: number | undefined;
    cashOnDeliveryRequested?: number | undefined;
    cashOnDeliveryReceived?: number | undefined;
    cashAccountBalanceAmount?: number | undefined;
    paymentOutstanding?: number | undefined;
    cashOnDeliveryAmountInCurrency?: number | undefined;
    cashOnDeliveryRequestedInCurrency?: number | undefined;
    cashOnDeliveryReceivedInCurrency?: number | undefined;
    paymentOutstandingInCurrency?: number | undefined;
    useSimpleOrderProcessing?: number | undefined;
    otherFlags?: number | undefined;
    journeyID?: number | undefined;
    splitJourneyToSchedule?: number | undefined;
    releaseTotalSellPrice?: number | undefined;
    sellPriceProfileID?: number | undefined;
    currencyID?: number | undefined;
    exchangeRate?: number | undefined;
    contractID?: number | undefined;
    followUpDateTime?: Date | undefined;
    viaBranchJourneyID?: number | undefined;
    needsJourneyFromViaBranch?: number | undefined;
    dateTimeQuoteAccepted?: Date | undefined;
    dateTimeQuoteRejected?: Date | undefined;
    rejectedOrAcceptedByID?: number | undefined;
    rejectionReasonID?: number | undefined;
    opportunityID?: number | undefined;
    totalSellPriceInCurrency?: number | undefined;
    totalVATInCurrency?: number | undefined;
    totalTaxInCurrency?: number | undefined;
    deleted?: number | undefined;
    salesRepID?: number | undefined;
    deliveryFax?: string | undefined;
    invoiceFax?: string | undefined;
    deliveryEmail?: string | undefined;
    invoiceEmail?: string | undefined;
    contactEmailAddress?: string | undefined;
    createdFromQuoteNumber?: number | undefined;
    hasAddCostProrations?: number | undefined;
    pickingStartedByID?: number | undefined;
    dateTimePickingStarted?: Date | undefined;
    dateTimePicked?: Date | undefined;
    pickingStartedByName?: string | undefined;
    checkedByID?: number | undefined;
    dateTimeChecked?: Date | undefined;
    checkedByName?: string | undefined;
    pickCompletedByID?: number | undefined;
    dateTimePickCompleted?: Date | undefined;
    pickCompletedByName?: string | undefined;
    ediDocumentID?: number | undefined;
    createdByName?: string | undefined;
    lastModifiedByName?: string | undefined;
    customerCode?: string | undefined;
    customerName?: string | undefined;
    cashAccount?: number | undefined;
    contactName?: string | undefined;
    contactNumber?: string | undefined;
    creditControllerName?: string | undefined;
    arCustomerCreditControllerName?: string | undefined;
    takenByName?: string | undefined;
    customerOnHold?: boolean | undefined;
    customerCreditControlStatusID?: number | undefined;
    customerIsCashAccount?: boolean | undefined;
    customerShowPricesOnAdviceNote?: number | undefined;
    arCustomerCode?: string | undefined;
    arCustomerName?: string | undefined;
    customerAutoEmailManualInvoice?: number | undefined;
    customerAvailableCredit?: number | undefined;
    arCustomerAvailableCredit?: number | undefined;
    branchName?: string | undefined;
    toBranchName?: string | undefined;
    viaBranchName?: string | undefined;
    issuingBranchName?: string | undefined;
    stockLocationName?: string | undefined;
    toStockLocationName?: string | undefined;
    deliveryAddressCode?: string | undefined;
    deliveryAreaName?: string | undefined;
    approvedByName?: string | undefined;
    printedInvoice?: number | undefined;
    backOrderedFromID?: number | undefined;
    backOrderFromNumber?: number | undefined;
    journeyNumber?: number | undefined;
    journeyStatus?: number | undefined;
    journeyDate?: Date | undefined;
    journeyPlannedStartDateTime?: Date | undefined;
    cutToLengthCount?: number | undefined;
    journeyCountSaved?: number | undefined;
    journeyCountInProgress?: number | undefined;
    journeyCountComplete?: number | undefined;
    printTestCertificates?: number | undefined;
    salesRepName?: string | undefined;
    totalTaxOnCost?: number | undefined;
    totalTaxOnCostInCurrency?: number | undefined;
    totalVMICostPrice?: number | undefined;
    jobID?: number | undefined;
    jobReference?: string | undefined;
    vehicleTypeID?: number | undefined;
    vehicleTypeName?: string | undefined;
    vehicleID?: number | undefined;
    deliveryVehicleName?: string | undefined;
    jobStatus?: number | undefined;
    viaBranchVehicleTypeID?: number | undefined;
    viaBranchVehicleTypeName?: string | undefined;
    viaBranchVehicleID?: number | undefined;
    viaBranchVehicleName?: string | undefined;
    departmentName?: string | undefined;
    toDepartmentName?: string | undefined;
    orderPlacementTypeName?: string | undefined;
    waitingForRFP?: number | undefined;
    supplierCode?: string | undefined;
    supplierName?: string | undefined;
    isValid?: boolean | undefined;
    errorList?: string | undefined;
    printTheseFormats?: string | undefined;
}

export class MarkOrderResponse implements IMarkOrderResponse {
    promptForDeliveryDate?: boolean | undefined;
    status?: MarkOrderResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;

    constructor(data?: IMarkOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promptForDeliveryDate = _data["promptForDeliveryDate"];
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MarkOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MarkOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promptForDeliveryDate"] = this.promptForDeliveryDate;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMarkOrderResponse {
    promptForDeliveryDate?: boolean | undefined;
    status?: MarkOrderResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
}

export class ConvertDocumentParams implements IConvertDocumentParams {
    documents?: JourneyManifestLine[] | undefined;
    journeyDate?: Date | undefined;
    cutOffDate?: Date | undefined;
    userId?: number | undefined;
    conversionType?: ConvertDocumentParamsConversionType | undefined;

    constructor(data?: IConvertDocumentParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(JourneyManifestLine.fromJS(item));
            }
            this.journeyDate = _data["journeyDate"] ? new Date(_data["journeyDate"].toString()) : <any>undefined;
            this.cutOffDate = _data["cutOffDate"] ? new Date(_data["cutOffDate"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.conversionType = _data["conversionType"];
        }
    }

    static fromJS(data: any): ConvertDocumentParams {
        data = typeof data === 'object' ? data : {};
        let result = new ConvertDocumentParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["journeyDate"] = this.journeyDate ? this.journeyDate.toISOString() : <any>undefined;
        data["cutOffDate"] = this.cutOffDate ? this.cutOffDate.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["conversionType"] = this.conversionType;
        return data; 
    }
}

export interface IConvertDocumentParams {
    documents?: JourneyManifestLine[] | undefined;
    journeyDate?: Date | undefined;
    cutOffDate?: Date | undefined;
    userId?: number | undefined;
    conversionType?: ConvertDocumentParamsConversionType | undefined;
}

export class ConvertDocumentResponse implements IConvertDocumentResponse {
    isConverted?: boolean | undefined;
    status?: ConvertDocumentResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;

    constructor(data?: IConvertDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isConverted = _data["isConverted"];
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConvertDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConvertDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isConverted"] = this.isConverted;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IConvertDocumentResponse {
    isConverted?: boolean | undefined;
    status?: ConvertDocumentResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
}

export class CalendarEventQueryParams implements ICalendarEventQueryParams {
    branchId?: string | undefined;
    stockLocationId?: number | undefined;
    vehicleTypeId?: number | undefined;
    from?: Date | undefined;
    till?: Date | undefined;
    userId?: number | undefined;

    constructor(data?: ICalendarEventQueryParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchId = _data["branchId"];
            this.stockLocationId = _data["stockLocationId"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.till = _data["till"] ? new Date(_data["till"].toString()) : <any>undefined;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CalendarEventQueryParams {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarEventQueryParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchId"] = this.branchId;
        data["stockLocationId"] = this.stockLocationId;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["till"] = this.till ? this.till.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface ICalendarEventQueryParams {
    branchId?: string | undefined;
    stockLocationId?: number | undefined;
    vehicleTypeId?: number | undefined;
    from?: Date | undefined;
    till?: Date | undefined;
    userId?: number | undefined;
}

export class CalendarEventsResponse implements ICalendarEventsResponse {
    journeyPlans?: JourneyPlanHeader[] | undefined;
    status?: CalendarEventsResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;

    constructor(data?: ICalendarEventsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["journeyPlans"])) {
                this.journeyPlans = [] as any;
                for (let item of _data["journeyPlans"])
                    this.journeyPlans!.push(JourneyPlanHeader.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CalendarEventsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarEventsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.journeyPlans)) {
            data["journeyPlans"] = [];
            for (let item of this.journeyPlans)
                data["journeyPlans"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICalendarEventsResponse {
    journeyPlans?: JourneyPlanHeader[] | undefined;
    status?: CalendarEventsResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
}

export class JourneyPlanHeader implements IJourneyPlanHeader {
    vehicleId?: number | undefined;
    vehicleName?: string | undefined;
    vehicleRegistration?: string | undefined;
    driverId?: number | undefined;
    driverName?: string | undefined;
    journeys?: Journey[] | undefined;
    journeydate?: Date | undefined;
    trailervehicleId?: number | undefined;
    trailerRegistration?: string | undefined;
    vehicleMaxWeight?: string | undefined;
    vehicleMaxVolume?: string | undefined;
    truckId?: number | undefined;
    vehicleTypeId?: number | undefined;
    vehicleTypeName?: string | undefined;
    trailerVehicleName?: string | undefined;
    truckRegistration?: string | undefined;
    truckName?: string | undefined;

    constructor(data?: IJourneyPlanHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["vehicleId"];
            this.vehicleName = _data["vehicleName"];
            this.vehicleRegistration = _data["vehicleRegistration"];
            this.driverId = _data["driverId"];
            this.driverName = _data["driverName"];
            if (Array.isArray(_data["journeys"])) {
                this.journeys = [] as any;
                for (let item of _data["journeys"])
                    this.journeys!.push(Journey.fromJS(item));
            }
            this.journeydate = _data["journeydate"] ? new Date(_data["journeydate"].toString()) : <any>undefined;
            this.trailervehicleId = _data["trailervehicleId"];
            this.trailerRegistration = _data["trailerRegistration"];
            this.vehicleMaxWeight = _data["vehicleMaxWeight"];
            this.vehicleMaxVolume = _data["vehicleMaxVolume"];
            this.truckId = _data["truckId"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.trailerVehicleName = _data["trailerVehicleName"];
            this.truckRegistration = _data["truckRegistration"];
            this.truckName = _data["truckName"];
        }
    }

    static fromJS(data: any): JourneyPlanHeader {
        data = typeof data === 'object' ? data : {};
        let result = new JourneyPlanHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleId"] = this.vehicleId;
        data["vehicleName"] = this.vehicleName;
        data["vehicleRegistration"] = this.vehicleRegistration;
        data["driverId"] = this.driverId;
        data["driverName"] = this.driverName;
        if (Array.isArray(this.journeys)) {
            data["journeys"] = [];
            for (let item of this.journeys)
                data["journeys"].push(item.toJSON());
        }
        data["journeydate"] = this.journeydate ? this.journeydate.toISOString() : <any>undefined;
        data["trailervehicleId"] = this.trailervehicleId;
        data["trailerRegistration"] = this.trailerRegistration;
        data["vehicleMaxWeight"] = this.vehicleMaxWeight;
        data["vehicleMaxVolume"] = this.vehicleMaxVolume;
        data["truckId"] = this.truckId;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["trailerVehicleName"] = this.trailerVehicleName;
        data["truckRegistration"] = this.truckRegistration;
        data["truckName"] = this.truckName;
        return data; 
    }
}

export interface IJourneyPlanHeader {
    vehicleId?: number | undefined;
    vehicleName?: string | undefined;
    vehicleRegistration?: string | undefined;
    driverId?: number | undefined;
    driverName?: string | undefined;
    journeys?: Journey[] | undefined;
    journeydate?: Date | undefined;
    trailervehicleId?: number | undefined;
    trailerRegistration?: string | undefined;
    vehicleMaxWeight?: string | undefined;
    vehicleMaxVolume?: string | undefined;
    truckId?: number | undefined;
    vehicleTypeId?: number | undefined;
    vehicleTypeName?: string | undefined;
    trailerVehicleName?: string | undefined;
    truckRegistration?: string | undefined;
    truckName?: string | undefined;
}

export class Journey implements IJourney {
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    status?: JourneyStatus | undefined;
    allDayEvent?: boolean | undefined;
    journeyId?: number | undefined;
    properties?: Properties2 | undefined;
    journeyNumber?: number | undefined;
    journeyLines?: JourneyLine[] | undefined;
    journeyDate?: Date | undefined;
    journeyHeader?: JourneyHeader | undefined;

    constructor(data?: IJourney) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.status = _data["status"];
            this.allDayEvent = _data["allDayEvent"];
            this.journeyId = _data["journeyId"];
            this.properties = _data["properties"] ? Properties2.fromJS(_data["properties"]) : <any>undefined;
            this.journeyNumber = _data["journeyNumber"];
            if (Array.isArray(_data["journeyLines"])) {
                this.journeyLines = [] as any;
                for (let item of _data["journeyLines"])
                    this.journeyLines!.push(JourneyLine.fromJS(item));
            }
            this.journeyDate = _data["journeyDate"] ? new Date(_data["journeyDate"].toString()) : <any>undefined;
            this.journeyHeader = _data["journeyHeader"] ? JourneyHeader.fromJS(_data["journeyHeader"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Journey {
        data = typeof data === 'object' ? data : {};
        let result = new Journey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["status"] = this.status;
        data["allDayEvent"] = this.allDayEvent;
        data["journeyId"] = this.journeyId;
        data["properties"] = this.properties ? this.properties.toJSON() : <any>undefined;
        data["journeyNumber"] = this.journeyNumber;
        if (Array.isArray(this.journeyLines)) {
            data["journeyLines"] = [];
            for (let item of this.journeyLines)
                data["journeyLines"].push(item.toJSON());
        }
        data["journeyDate"] = this.journeyDate ? this.journeyDate.toISOString() : <any>undefined;
        data["journeyHeader"] = this.journeyHeader ? this.journeyHeader.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IJourney {
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    status?: JourneyStatus | undefined;
    allDayEvent?: boolean | undefined;
    journeyId?: number | undefined;
    properties?: Properties2 | undefined;
    journeyNumber?: number | undefined;
    journeyLines?: JourneyLine[] | undefined;
    journeyDate?: Date | undefined;
    journeyHeader?: JourneyHeader | undefined;
}

export class ScheduleEventParams implements IScheduleEventParams {
    userId?: number | undefined;
    scheduleId?: string | undefined;
    journeyId?: number | undefined;
    documentId?: number | undefined;
    documentNumber?: number | undefined;
    documentType?: ScheduleEventParamsDocumentType | undefined;
    branchIds?: string | undefined;
    addDocumentOption?: ScheduleEventParamsAddDocumentOption | undefined;
    addToExistingJourney?: ScheduleEventParamsAddToExistingJourney | undefined;
    scheduleVehicleParams?: ScheduleVehicleParams | undefined;
    stockLocationId?: number | undefined;
    reference?: string | undefined;
    fromDate?: Date | undefined;
    tillDate?: Date | undefined;
    userDialogResponses?: UserDialogResponse[] | undefined;
    needsCollection?: boolean | undefined;
    dropIsCollection?: boolean | undefined;

    constructor(data?: IScheduleEventParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.scheduleId = _data["scheduleId"];
            this.journeyId = _data["journeyId"];
            this.documentId = _data["documentId"];
            this.documentNumber = _data["documentNumber"];
            this.documentType = _data["documentType"];
            this.branchIds = _data["branchIds"];
            this.addDocumentOption = _data["addDocumentOption"];
            this.addToExistingJourney = _data["addToExistingJourney"];
            this.scheduleVehicleParams = _data["scheduleVehicleParams"] ? ScheduleVehicleParams.fromJS(_data["scheduleVehicleParams"]) : <any>undefined;
            this.stockLocationId = _data["stockLocationId"];
            this.reference = _data["reference"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.tillDate = _data["tillDate"] ? new Date(_data["tillDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["userDialogResponses"])) {
                this.userDialogResponses = [] as any;
                for (let item of _data["userDialogResponses"])
                    this.userDialogResponses!.push(UserDialogResponse.fromJS(item));
            }
            this.needsCollection = _data["needsCollection"];
            this.dropIsCollection = _data["dropIsCollection"];
        }
    }

    static fromJS(data: any): ScheduleEventParams {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleEventParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["scheduleId"] = this.scheduleId;
        data["journeyId"] = this.journeyId;
        data["documentId"] = this.documentId;
        data["documentNumber"] = this.documentNumber;
        data["documentType"] = this.documentType;
        data["branchIds"] = this.branchIds;
        data["addDocumentOption"] = this.addDocumentOption;
        data["addToExistingJourney"] = this.addToExistingJourney;
        data["scheduleVehicleParams"] = this.scheduleVehicleParams ? this.scheduleVehicleParams.toJSON() : <any>undefined;
        data["stockLocationId"] = this.stockLocationId;
        data["reference"] = this.reference;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["tillDate"] = this.tillDate ? this.tillDate.toISOString() : <any>undefined;
        if (Array.isArray(this.userDialogResponses)) {
            data["userDialogResponses"] = [];
            for (let item of this.userDialogResponses)
                data["userDialogResponses"].push(item.toJSON());
        }
        data["needsCollection"] = this.needsCollection;
        data["dropIsCollection"] = this.dropIsCollection;
        return data; 
    }
}

export interface IScheduleEventParams {
    userId?: number | undefined;
    scheduleId?: string | undefined;
    journeyId?: number | undefined;
    documentId?: number | undefined;
    documentNumber?: number | undefined;
    documentType?: ScheduleEventParamsDocumentType | undefined;
    branchIds?: string | undefined;
    addDocumentOption?: ScheduleEventParamsAddDocumentOption | undefined;
    addToExistingJourney?: ScheduleEventParamsAddToExistingJourney | undefined;
    scheduleVehicleParams?: ScheduleVehicleParams | undefined;
    stockLocationId?: number | undefined;
    reference?: string | undefined;
    fromDate?: Date | undefined;
    tillDate?: Date | undefined;
    userDialogResponses?: UserDialogResponse[] | undefined;
    needsCollection?: boolean | undefined;
    dropIsCollection?: boolean | undefined;
}

export class ScheduleVehicleParams implements IScheduleVehicleParams {
    vehicleId?: number | undefined;
    driverId?: number | undefined;
    trailerId?: number | undefined;
    truckId?: number | undefined;
    availableDate?: Date | undefined;
    vehicleTypeId?: number | undefined;
    branchIds?: string | undefined;
    userID?: number | undefined;
    trailerTypeId?: ScheduleVehicleParamsTrailerTypeId | undefined;

    constructor(data?: IScheduleVehicleParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["vehicleId"];
            this.driverId = _data["driverId"];
            this.trailerId = _data["trailerId"];
            this.truckId = _data["truckId"];
            this.availableDate = _data["availableDate"] ? new Date(_data["availableDate"].toString()) : <any>undefined;
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.branchIds = _data["branchIds"];
            this.userID = _data["userID"];
            this.trailerTypeId = _data["trailerTypeId"];
        }
    }

    static fromJS(data: any): ScheduleVehicleParams {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleVehicleParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleId"] = this.vehicleId;
        data["driverId"] = this.driverId;
        data["trailerId"] = this.trailerId;
        data["truckId"] = this.truckId;
        data["availableDate"] = this.availableDate ? this.availableDate.toISOString() : <any>undefined;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["branchIds"] = this.branchIds;
        data["userID"] = this.userID;
        data["trailerTypeId"] = this.trailerTypeId;
        return data; 
    }
}

export interface IScheduleVehicleParams {
    vehicleId?: number | undefined;
    driverId?: number | undefined;
    trailerId?: number | undefined;
    truckId?: number | undefined;
    availableDate?: Date | undefined;
    vehicleTypeId?: number | undefined;
    branchIds?: string | undefined;
    userID?: number | undefined;
    trailerTypeId?: ScheduleVehicleParamsTrailerTypeId | undefined;
}

export class ScheduleEventResponse implements IScheduleEventResponse {
    status?: ScheduleEventResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;

    constructor(data?: IScheduleEventResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduleEventResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleEventResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IScheduleEventResponse {
    status?: ScheduleEventResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
}

export class UnusedVehicleQueryParams implements IUnusedVehicleQueryParams {
    from?: Date | undefined;
    till?: Date | undefined;
    userId?: number | undefined;
    trailerType?: number | undefined;
    branchIds?: string | undefined;
    stockLocationId?: number | undefined;
    vehicleTypeId?: number | undefined;

    constructor(data?: IUnusedVehicleQueryParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.till = _data["till"] ? new Date(_data["till"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.trailerType = _data["trailerType"];
            this.branchIds = _data["branchIds"];
            this.stockLocationId = _data["stockLocationId"];
            this.vehicleTypeId = _data["vehicleTypeId"];
        }
    }

    static fromJS(data: any): UnusedVehicleQueryParams {
        data = typeof data === 'object' ? data : {};
        let result = new UnusedVehicleQueryParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["till"] = this.till ? this.till.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["trailerType"] = this.trailerType;
        data["branchIds"] = this.branchIds;
        data["stockLocationId"] = this.stockLocationId;
        data["vehicleTypeId"] = this.vehicleTypeId;
        return data; 
    }
}

export interface IUnusedVehicleQueryParams {
    from?: Date | undefined;
    till?: Date | undefined;
    userId?: number | undefined;
    trailerType?: number | undefined;
    branchIds?: string | undefined;
    stockLocationId?: number | undefined;
    vehicleTypeId?: number | undefined;
}

export class UnusedVehicleResponse implements IUnusedVehicleResponse {
    vehicles?: Vehicle[] | undefined;
    status?: UnusedVehicleResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;

    constructor(data?: IUnusedVehicleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles!.push(Vehicle.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UnusedVehicleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnusedVehicleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUnusedVehicleResponse {
    vehicles?: Vehicle[] | undefined;
    status?: UnusedVehicleResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
}

export class ScheduledDocumentMoveParams implements IScheduledDocumentMoveParams {
    userId?: number | undefined;
    journeyId?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    vehicleId?: number | undefined;
    truckVehicleId?: number | undefined;
    trailerVehicleId?: number | undefined;
    driverId?: number | undefined;
    reference?: string | undefined;
    cutOffDateTime?: string | undefined;

    constructor(data?: IScheduledDocumentMoveParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.journeyId = _data["journeyId"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.truckVehicleId = _data["truckVehicleId"];
            this.trailerVehicleId = _data["trailerVehicleId"];
            this.driverId = _data["driverId"];
            this.reference = _data["reference"];
            this.cutOffDateTime = _data["cutOffDateTime"];
        }
    }

    static fromJS(data: any): ScheduledDocumentMoveParams {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledDocumentMoveParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["journeyId"] = this.journeyId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["truckVehicleId"] = this.truckVehicleId;
        data["trailerVehicleId"] = this.trailerVehicleId;
        data["driverId"] = this.driverId;
        data["reference"] = this.reference;
        data["cutOffDateTime"] = this.cutOffDateTime;
        return data; 
    }
}

export interface IScheduledDocumentMoveParams {
    userId?: number | undefined;
    journeyId?: string | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    vehicleId?: number | undefined;
    truckVehicleId?: number | undefined;
    trailerVehicleId?: number | undefined;
    driverId?: number | undefined;
    reference?: string | undefined;
    cutOffDateTime?: string | undefined;
}

export class ScheduledDocumentMoveResponse implements IScheduledDocumentMoveResponse {
    journey?: Journey | undefined;
    status?: ScheduledDocumentMoveResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;

    constructor(data?: IScheduledDocumentMoveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.journey = _data["journey"] ? Journey.fromJS(_data["journey"]) : <any>undefined;
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduledDocumentMoveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledDocumentMoveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["journey"] = this.journey ? this.journey.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IScheduledDocumentMoveResponse {
    journey?: Journey | undefined;
    status?: ScheduledDocumentMoveResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
}

export class JourneyPlannerOptionsResponse implements IJourneyPlannerOptionsResponse {
    /** Get or set the journey planner options */
    options?: JourneyPlannerOptions | undefined;
    status?: JourneyPlannerOptionsResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;

    constructor(data?: IJourneyPlannerOptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.options = _data["options"] ? JourneyPlannerOptions.fromJS(_data["options"]) : <any>undefined;
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JourneyPlannerOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new JourneyPlannerOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IJourneyPlannerOptionsResponse {
    /** Get or set the journey planner options */
    options?: JourneyPlannerOptions | undefined;
    status?: JourneyPlannerOptionsResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
}

export class JourneyPlannerOptions implements IJourneyPlannerOptions {
    timeFrame?: JourneyPlannerOptionsTimeFrame | undefined;
    newTimeFrame?: JourneyPlannerOptionsNewTimeFrame | undefined;
    firstDayOfWeek?: string | undefined;
    dayStart?: Date | undefined;
    workingDays?: number | undefined;
    dayEnd?: Date | undefined;
    timeInterval?: number | undefined;
    timeIntervalForCalendarView?: number | undefined;
    autoRefreshInterval?: string | undefined;
    colourSaved?: number | undefined;
    colourInProgress?: number | undefined;
    colourComplete?: number | undefined;
    decimalPlacesWeight?: number | undefined;
    decimalPlacesVolume?: number | undefined;
    weightDisplayFormat?: string | undefined;
    volumeDisplayFormat?: string | undefined;

    constructor(data?: IJourneyPlannerOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeFrame = _data["timeFrame"];
            this.newTimeFrame = _data["newTimeFrame"];
            this.firstDayOfWeek = _data["firstDayOfWeek"];
            this.dayStart = _data["dayStart"] ? new Date(_data["dayStart"].toString()) : <any>undefined;
            this.workingDays = _data["workingDays"];
            this.dayEnd = _data["dayEnd"] ? new Date(_data["dayEnd"].toString()) : <any>undefined;
            this.timeInterval = _data["timeInterval"];
            this.timeIntervalForCalendarView = _data["timeIntervalForCalendarView"];
            this.autoRefreshInterval = _data["autoRefreshInterval"];
            this.colourSaved = _data["colourSaved"];
            this.colourInProgress = _data["colourInProgress"];
            this.colourComplete = _data["colourComplete"];
            this.decimalPlacesWeight = _data["decimalPlacesWeight"];
            this.decimalPlacesVolume = _data["decimalPlacesVolume"];
            this.weightDisplayFormat = _data["weightDisplayFormat"];
            this.volumeDisplayFormat = _data["volumeDisplayFormat"];
        }
    }

    static fromJS(data: any): JourneyPlannerOptions {
        data = typeof data === 'object' ? data : {};
        let result = new JourneyPlannerOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeFrame"] = this.timeFrame;
        data["newTimeFrame"] = this.newTimeFrame;
        data["firstDayOfWeek"] = this.firstDayOfWeek;
        data["dayStart"] = this.dayStart ? this.dayStart.toISOString() : <any>undefined;
        data["workingDays"] = this.workingDays;
        data["dayEnd"] = this.dayEnd ? this.dayEnd.toISOString() : <any>undefined;
        data["timeInterval"] = this.timeInterval;
        data["timeIntervalForCalendarView"] = this.timeIntervalForCalendarView;
        data["autoRefreshInterval"] = this.autoRefreshInterval;
        data["colourSaved"] = this.colourSaved;
        data["colourInProgress"] = this.colourInProgress;
        data["colourComplete"] = this.colourComplete;
        data["decimalPlacesWeight"] = this.decimalPlacesWeight;
        data["decimalPlacesVolume"] = this.decimalPlacesVolume;
        data["weightDisplayFormat"] = this.weightDisplayFormat;
        data["volumeDisplayFormat"] = this.volumeDisplayFormat;
        return data; 
    }
}

export interface IJourneyPlannerOptions {
    timeFrame?: JourneyPlannerOptionsTimeFrame | undefined;
    newTimeFrame?: JourneyPlannerOptionsNewTimeFrame | undefined;
    firstDayOfWeek?: string | undefined;
    dayStart?: Date | undefined;
    workingDays?: number | undefined;
    dayEnd?: Date | undefined;
    timeInterval?: number | undefined;
    timeIntervalForCalendarView?: number | undefined;
    autoRefreshInterval?: string | undefined;
    colourSaved?: number | undefined;
    colourInProgress?: number | undefined;
    colourComplete?: number | undefined;
    decimalPlacesWeight?: number | undefined;
    decimalPlacesVolume?: number | undefined;
    weightDisplayFormat?: string | undefined;
    volumeDisplayFormat?: string | undefined;
}

export class AppOPStatusResponse implements IAppOPStatusResponse {
    status?: AppOPStatusResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IAppOPStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): AppOPStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppOPStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IAppOPStatusResponse {
    status?: AppOPStatusResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class MarkFullDayRequest implements IMarkFullDayRequest {
    userID?: number | undefined;
    plannerDate?: Date | undefined;
    unmark?: boolean | undefined;
    branchId?: number | undefined;
    vehicleTypeId?: number | undefined;
    deliveryTimeId?: number | undefined;

    constructor(data?: IMarkFullDayRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userID = _data["userID"];
            this.plannerDate = _data["plannerDate"] ? new Date(_data["plannerDate"].toString()) : <any>undefined;
            this.unmark = _data["unmark"];
            this.branchId = _data["branchId"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.deliveryTimeId = _data["deliveryTimeId"];
        }
    }

    static fromJS(data: any): MarkFullDayRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkFullDayRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["plannerDate"] = this.plannerDate ? this.plannerDate.toISOString() : <any>undefined;
        data["unmark"] = this.unmark;
        data["branchId"] = this.branchId;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["deliveryTimeId"] = this.deliveryTimeId;
        return data; 
    }
}

export interface IMarkFullDayRequest {
    userID?: number | undefined;
    plannerDate?: Date | undefined;
    unmark?: boolean | undefined;
    branchId?: number | undefined;
    vehicleTypeId?: number | undefined;
    deliveryTimeId?: number | undefined;
}

export class JourneyOpStatusResponse implements IJourneyOpStatusResponse {
    status?: JourneyOpStatusResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;

    constructor(data?: IJourneyOpStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JourneyOpStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new JourneyOpStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IJourneyOpStatusResponse {
    status?: JourneyOpStatusResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
}

export class MarkFullDayListRequest implements IMarkFullDayListRequest {
    userId?: number | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    branchIds?: string | undefined;
    vehicleTypeId?: number | undefined;
    deliveryTimeId?: number | undefined;

    constructor(data?: IMarkFullDayListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.branchIds = _data["branchIds"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.deliveryTimeId = _data["deliveryTimeId"];
        }
    }

    static fromJS(data: any): MarkFullDayListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkFullDayListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["branchIds"] = this.branchIds;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["deliveryTimeId"] = this.deliveryTimeId;
        return data; 
    }
}

export interface IMarkFullDayListRequest {
    userId?: number | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    branchIds?: string | undefined;
    vehicleTypeId?: number | undefined;
    deliveryTimeId?: number | undefined;
}

export class JourneyManifestResponse implements IJourneyManifestResponse {
    /** The manifest */
    manifest?: JourneyManifest | undefined;
    status?: JourneyManifestResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;

    constructor(data?: IJourneyManifestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.manifest = _data["manifest"] ? JourneyManifest.fromJS(_data["manifest"]) : <any>undefined;
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JourneyManifestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new JourneyManifestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manifest"] = this.manifest ? this.manifest.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IJourneyManifestResponse {
    /** The manifest */
    manifest?: JourneyManifest | undefined;
    status?: JourneyManifestResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
}

export class TimeEstimateRequest implements ITimeEstimateRequest {
    branchID?: number | undefined;
    vehicleId?: number | undefined;
    plannedStartDateTime?: Date | undefined;
    plannedFinishDateTime?: Date | undefined;
    journeyStops?: JourneyManifestStop[] | undefined;
    optimizeRoute?: boolean | undefined;

    constructor(data?: ITimeEstimateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchID = _data["branchID"];
            this.vehicleId = _data["vehicleId"];
            this.plannedStartDateTime = _data["plannedStartDateTime"] ? new Date(_data["plannedStartDateTime"].toString()) : <any>undefined;
            this.plannedFinishDateTime = _data["plannedFinishDateTime"] ? new Date(_data["plannedFinishDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["journeyStops"])) {
                this.journeyStops = [] as any;
                for (let item of _data["journeyStops"])
                    this.journeyStops!.push(JourneyManifestStop.fromJS(item));
            }
            this.optimizeRoute = _data["optimizeRoute"];
        }
    }

    static fromJS(data: any): TimeEstimateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEstimateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchID"] = this.branchID;
        data["vehicleId"] = this.vehicleId;
        data["plannedStartDateTime"] = this.plannedStartDateTime ? this.plannedStartDateTime.toISOString() : <any>undefined;
        data["plannedFinishDateTime"] = this.plannedFinishDateTime ? this.plannedFinishDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.journeyStops)) {
            data["journeyStops"] = [];
            for (let item of this.journeyStops)
                data["journeyStops"].push(item.toJSON());
        }
        data["optimizeRoute"] = this.optimizeRoute;
        return data; 
    }
}

export interface ITimeEstimateRequest {
    branchID?: number | undefined;
    vehicleId?: number | undefined;
    plannedStartDateTime?: Date | undefined;
    plannedFinishDateTime?: Date | undefined;
    journeyStops?: JourneyManifestStop[] | undefined;
    optimizeRoute?: boolean | undefined;
}

export class TimeEstimateResponse implements ITimeEstimateResponse {
    copyRight?: string | undefined;
    plannedFinishDateTime?: Date | undefined;
    journeyStops?: JourneyManifestStop[] | undefined;
    status?: TimeEstimateResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;

    constructor(data?: ITimeEstimateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.copyRight = _data["copyRight"];
            this.plannedFinishDateTime = _data["plannedFinishDateTime"] ? new Date(_data["plannedFinishDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["journeyStops"])) {
                this.journeyStops = [] as any;
                for (let item of _data["journeyStops"])
                    this.journeyStops!.push(JourneyManifestStop.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeEstimateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEstimateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["copyRight"] = this.copyRight;
        data["plannedFinishDateTime"] = this.plannedFinishDateTime ? this.plannedFinishDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.journeyStops)) {
            data["journeyStops"] = [];
            for (let item of this.journeyStops)
                data["journeyStops"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITimeEstimateResponse {
    copyRight?: string | undefined;
    plannedFinishDateTime?: Date | undefined;
    journeyStops?: JourneyManifestStop[] | undefined;
    status?: TimeEstimateResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
}

export class FindFromDocumentRequest implements IFindFromDocumentRequest {
    documentNumber?: number | undefined;
    documentType?: FindFromDocumentRequestDocumentType | undefined;

    constructor(data?: IFindFromDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"];
            this.documentType = _data["documentType"];
        }
    }

    static fromJS(data: any): FindFromDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FindFromDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber;
        data["documentType"] = this.documentType;
        return data; 
    }
}

export interface IFindFromDocumentRequest {
    documentNumber?: number | undefined;
    documentType?: FindFromDocumentRequestDocumentType | undefined;
}

export class FindFromDocumentResponse implements IFindFromDocumentResponse {
    journeyId?: number | undefined;
    journeyDate?: Date | undefined;
    status?: FindFromDocumentResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;

    constructor(data?: IFindFromDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.journeyId = _data["journeyId"];
            this.journeyDate = _data["journeyDate"] ? new Date(_data["journeyDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FindFromDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FindFromDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["journeyId"] = this.journeyId;
        data["journeyDate"] = this.journeyDate ? this.journeyDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFindFromDocumentResponse {
    journeyId?: number | undefined;
    journeyDate?: Date | undefined;
    status?: FindFromDocumentResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
}

export class JourneyDirectionRequest implements IJourneyDirectionRequest {
    computerId?: number | undefined;
    journeyLines?: JourneyManifestLine[] | undefined;

    constructor(data?: IJourneyDirectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.computerId = _data["computerId"];
            if (Array.isArray(_data["journeyLines"])) {
                this.journeyLines = [] as any;
                for (let item of _data["journeyLines"])
                    this.journeyLines!.push(JourneyManifestLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JourneyDirectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new JourneyDirectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["computerId"] = this.computerId;
        if (Array.isArray(this.journeyLines)) {
            data["journeyLines"] = [];
            for (let item of this.journeyLines)
                data["journeyLines"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IJourneyDirectionRequest {
    computerId?: number | undefined;
    journeyLines?: JourneyManifestLine[] | undefined;
}

export class JourneyDirectionResponse implements IJourneyDirectionResponse {
    mapUrl?: string | undefined;
    status?: JourneyDirectionResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;

    constructor(data?: IJourneyDirectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mapUrl = _data["mapUrl"];
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JourneyDirectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new JourneyDirectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mapUrl"] = this.mapUrl;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IJourneyDirectionResponse {
    mapUrl?: string | undefined;
    status?: JourneyDirectionResponseStatus | undefined;
    statusDetail?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
}

export class LoginUserResponse implements ILoginUserResponse {
    user?: User | undefined;
    status?: LoginUserResponseStatus | undefined;

    constructor(data?: ILoginUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): LoginUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["status"] = this.status;
        return data; 
    }
}

export interface ILoginUserResponse {
    user?: User | undefined;
    status?: LoginUserResponseStatus | undefined;
}

export class CurrentUserResponse implements ICurrentUserResponse {
    user?: User | undefined;
    webTrackUser?: WebTrackUser[] | undefined;
    additionalLoginInfo?: AdditionalLoginInfo | undefined;
    status?: CurrentUserResponseStatus | undefined;

    constructor(data?: ICurrentUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["webTrackUser"])) {
                this.webTrackUser = [] as any;
                for (let item of _data["webTrackUser"])
                    this.webTrackUser!.push(WebTrackUser.fromJS(item));
            }
            this.additionalLoginInfo = _data["additionalLoginInfo"] ? AdditionalLoginInfo.fromJS(_data["additionalLoginInfo"]) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CurrentUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.webTrackUser)) {
            data["webTrackUser"] = [];
            for (let item of this.webTrackUser)
                data["webTrackUser"].push(item.toJSON());
        }
        data["additionalLoginInfo"] = this.additionalLoginInfo ? this.additionalLoginInfo.toJSON() : <any>undefined;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICurrentUserResponse {
    user?: User | undefined;
    webTrackUser?: WebTrackUser[] | undefined;
    additionalLoginInfo?: AdditionalLoginInfo | undefined;
    status?: CurrentUserResponseStatus | undefined;
}

export class WebTrackUser implements IWebTrackUser {
    loginName?: string | undefined;
    userID?: number | undefined;
    customerID?: number | undefined;
    webTrackTradingBranchID?: number | undefined;
    customerContactID?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    supportEmailAddress?: string | undefined;
    maximumOrderValue?: number | undefined;
    webTrackInstanceID?: number | undefined;

    constructor(data?: IWebTrackUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginName = _data["loginName"];
            this.userID = _data["userID"];
            this.customerID = _data["customerID"];
            this.webTrackTradingBranchID = _data["webTrackTradingBranchID"];
            this.customerContactID = _data["customerContactID"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.supportEmailAddress = _data["supportEmailAddress"];
            this.maximumOrderValue = _data["maximumOrderValue"];
            this.webTrackInstanceID = _data["webTrackInstanceID"];
        }
    }

    static fromJS(data: any): WebTrackUser {
        data = typeof data === 'object' ? data : {};
        let result = new WebTrackUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginName"] = this.loginName;
        data["userID"] = this.userID;
        data["customerID"] = this.customerID;
        data["webTrackTradingBranchID"] = this.webTrackTradingBranchID;
        data["customerContactID"] = this.customerContactID;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["supportEmailAddress"] = this.supportEmailAddress;
        data["maximumOrderValue"] = this.maximumOrderValue;
        data["webTrackInstanceID"] = this.webTrackInstanceID;
        return data; 
    }
}

export interface IWebTrackUser {
    loginName?: string | undefined;
    userID?: number | undefined;
    customerID?: number | undefined;
    webTrackTradingBranchID?: number | undefined;
    customerContactID?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    supportEmailAddress?: string | undefined;
    maximumOrderValue?: number | undefined;
    webTrackInstanceID?: number | undefined;
}

export class AdditionalLoginInfo implements IAdditionalLoginInfo {
    dbInstanceName?: string | undefined;
    databaseServer?: string | undefined;
    databaseName?: string | undefined;
    applicationVersion?: string | undefined;
    tenantId?: string | undefined;
    sessionId?: string | undefined;

    constructor(data?: IAdditionalLoginInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dbInstanceName = _data["dbInstanceName"];
            this.databaseServer = _data["databaseServer"];
            this.databaseName = _data["databaseName"];
            this.applicationVersion = _data["applicationVersion"];
            this.tenantId = _data["tenantId"];
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): AdditionalLoginInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalLoginInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dbInstanceName"] = this.dbInstanceName;
        data["databaseServer"] = this.databaseServer;
        data["databaseName"] = this.databaseName;
        data["applicationVersion"] = this.applicationVersion;
        data["tenantId"] = this.tenantId;
        data["sessionId"] = this.sessionId;
        return data; 
    }
}

export interface IAdditionalLoginInfo {
    dbInstanceName?: string | undefined;
    databaseServer?: string | undefined;
    databaseName?: string | undefined;
    applicationVersion?: string | undefined;
    tenantId?: string | undefined;
    sessionId?: string | undefined;
}

export class UserAppMenuResponse implements IUserAppMenuResponse {
    featureTabs?: FeatureTab[] | undefined;
    status?: UserAppMenuResponseStatus | undefined;

    constructor(data?: IUserAppMenuResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureTabs"])) {
                this.featureTabs = [] as any;
                for (let item of _data["featureTabs"])
                    this.featureTabs!.push(FeatureTab.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserAppMenuResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserAppMenuResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureTabs)) {
            data["featureTabs"] = [];
            for (let item of this.featureTabs)
                data["featureTabs"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IUserAppMenuResponse {
    featureTabs?: FeatureTab[] | undefined;
    status?: UserAppMenuResponseStatus | undefined;
}

export class FeatureTab implements IFeatureTab {
    name?: string | undefined;
    id?: number | undefined;
    order?: number | undefined;
    featureGroups?: FeatureGroup[] | undefined;

    constructor(data?: IFeatureTab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.order = _data["order"];
            if (Array.isArray(_data["featureGroups"])) {
                this.featureGroups = [] as any;
                for (let item of _data["featureGroups"])
                    this.featureGroups!.push(FeatureGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeatureTab {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureTab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["order"] = this.order;
        if (Array.isArray(this.featureGroups)) {
            data["featureGroups"] = [];
            for (let item of this.featureGroups)
                data["featureGroups"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFeatureTab {
    name?: string | undefined;
    id?: number | undefined;
    order?: number | undefined;
    featureGroups?: FeatureGroup[] | undefined;
}

export class FeatureGroup implements IFeatureGroup {
    name?: string | undefined;
    id?: number | undefined;
    order?: number | undefined;
    features?: Feature[] | undefined;

    constructor(data?: IFeatureGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.order = _data["order"];
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(Feature.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeatureGroup {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["order"] = this.order;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFeatureGroup {
    name?: string | undefined;
    id?: number | undefined;
    order?: number | undefined;
    features?: Feature[] | undefined;
}

export class Feature implements IFeature {
    id?: number | undefined;
    name?: string | undefined;
    overrideName?: string | undefined;
    featureID?: number | undefined;

    constructor(data?: IFeature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.overrideName = _data["overrideName"];
            this.featureID = _data["featureID"];
        }
    }

    static fromJS(data: any): Feature {
        data = typeof data === 'object' ? data : {};
        let result = new Feature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["overrideName"] = this.overrideName;
        data["featureID"] = this.featureID;
        return data; 
    }
}

export interface IFeature {
    id?: number | undefined;
    name?: string | undefined;
    overrideName?: string | undefined;
    featureID?: number | undefined;
}

export class UserNavigationMenuResponse implements IUserNavigationMenuResponse {
    menuItems?: MenuItem[] | undefined;
    status?: UserNavigationMenuResponseStatus | undefined;

    constructor(data?: IUserNavigationMenuResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["menuItems"])) {
                this.menuItems = [] as any;
                for (let item of _data["menuItems"])
                    this.menuItems!.push(MenuItem.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserNavigationMenuResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserNavigationMenuResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.menuItems)) {
            data["menuItems"] = [];
            for (let item of this.menuItems)
                data["menuItems"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IUserNavigationMenuResponse {
    menuItems?: MenuItem[] | undefined;
    status?: UserNavigationMenuResponseStatus | undefined;
}

export class MenuItem implements IMenuItem {
    id?: string | undefined;
    featureType?: MenuItemFeatureType | undefined;
    caption?: string | undefined;
    parentId?: string | undefined;

    constructor(data?: IMenuItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.featureType = _data["featureType"];
            this.caption = _data["caption"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): MenuItem {
        data = typeof data === 'object' ? data : {};
        let result = new MenuItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["featureType"] = this.featureType;
        data["caption"] = this.caption;
        data["parentId"] = this.parentId;
        return data; 
    }
}

export interface IMenuItem {
    id?: string | undefined;
    featureType?: MenuItemFeatureType | undefined;
    caption?: string | undefined;
    parentId?: string | undefined;
}

export class KitDetailsResponse implements IKitDetailsResponse {
    productKits?: ProductKit | undefined;
    status?: KitDetailsResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IKitDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKits = _data["productKits"] ? ProductKit.fromJS(_data["productKits"]) : <any>undefined;
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): KitDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KitDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKits"] = this.productKits ? this.productKits.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IKitDetailsResponse {
    productKits?: ProductKit | undefined;
    status?: KitDetailsResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class ProductKit implements IProductKit {
    productID?: number | undefined;
    documentDescription?: string | undefined;
    totalSellPrice?: number | undefined;
    minSellPrice?: number | undefined;
    maxSellPrice?: number | undefined;
    branchID?: number | undefined;
    customerID?: number | undefined;
    customerAddressID?: number | undefined;
    documentPresentation?: number | undefined;
    manufactured?: boolean | undefined;
    manufacturedProductID?: number | undefined;
    setDescriptionFromLinesShortDescriptions?: boolean | undefined;
    alwaysUseSellPriceOfFinishedItem?: boolean | undefined;
    promptForFinishedProduct?: boolean | undefined;
    combineManKitsonWO?: boolean | undefined;
    purchased?: boolean | undefined;
    purchaseProductID?: number | undefined;
    fractionalMultiplierOption?: number | undefined;

    constructor(data?: IProductKit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productID = _data["productID"];
            this.documentDescription = _data["documentDescription"];
            this.totalSellPrice = _data["totalSellPrice"];
            this.minSellPrice = _data["minSellPrice"];
            this.maxSellPrice = _data["maxSellPrice"];
            this.branchID = _data["branchID"];
            this.customerID = _data["customerID"];
            this.customerAddressID = _data["customerAddressID"];
            this.documentPresentation = _data["documentPresentation"];
            this.manufactured = _data["manufactured"];
            this.manufacturedProductID = _data["manufacturedProductID"];
            this.setDescriptionFromLinesShortDescriptions = _data["setDescriptionFromLinesShortDescriptions"];
            this.alwaysUseSellPriceOfFinishedItem = _data["alwaysUseSellPriceOfFinishedItem"];
            this.promptForFinishedProduct = _data["promptForFinishedProduct"];
            this.combineManKitsonWO = _data["combineManKitsonWO"];
            this.purchased = _data["purchased"];
            this.purchaseProductID = _data["purchaseProductID"];
            this.fractionalMultiplierOption = _data["fractionalMultiplierOption"];
        }
    }

    static fromJS(data: any): ProductKit {
        data = typeof data === 'object' ? data : {};
        let result = new ProductKit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productID"] = this.productID;
        data["documentDescription"] = this.documentDescription;
        data["totalSellPrice"] = this.totalSellPrice;
        data["minSellPrice"] = this.minSellPrice;
        data["maxSellPrice"] = this.maxSellPrice;
        data["branchID"] = this.branchID;
        data["customerID"] = this.customerID;
        data["customerAddressID"] = this.customerAddressID;
        data["documentPresentation"] = this.documentPresentation;
        data["manufactured"] = this.manufactured;
        data["manufacturedProductID"] = this.manufacturedProductID;
        data["setDescriptionFromLinesShortDescriptions"] = this.setDescriptionFromLinesShortDescriptions;
        data["alwaysUseSellPriceOfFinishedItem"] = this.alwaysUseSellPriceOfFinishedItem;
        data["promptForFinishedProduct"] = this.promptForFinishedProduct;
        data["combineManKitsonWO"] = this.combineManKitsonWO;
        data["purchased"] = this.purchased;
        data["purchaseProductID"] = this.purchaseProductID;
        data["fractionalMultiplierOption"] = this.fractionalMultiplierOption;
        return data; 
    }
}

export interface IProductKit {
    productID?: number | undefined;
    documentDescription?: string | undefined;
    totalSellPrice?: number | undefined;
    minSellPrice?: number | undefined;
    maxSellPrice?: number | undefined;
    branchID?: number | undefined;
    customerID?: number | undefined;
    customerAddressID?: number | undefined;
    documentPresentation?: number | undefined;
    manufactured?: boolean | undefined;
    manufacturedProductID?: number | undefined;
    setDescriptionFromLinesShortDescriptions?: boolean | undefined;
    alwaysUseSellPriceOfFinishedItem?: boolean | undefined;
    promptForFinishedProduct?: boolean | undefined;
    combineManKitsonWO?: boolean | undefined;
    purchased?: boolean | undefined;
    purchaseProductID?: number | undefined;
    fractionalMultiplierOption?: number | undefined;
}

export class KitManifestResponse implements IKitManifestResponse {
    productKit?: ProductKit | undefined;
    productKitLines?: ProductKitLine[] | undefined;
    lineProducts?: Product[] | undefined;
    perRules?: PerRule[] | undefined;
    kitChoiceTypes?: KitChoiceType[] | undefined;
    productKitManufacturedProcesses?: ProductKitManufacturedProcess[] | undefined;
    productKitAVOs?: ProductKitAVO[] | undefined;
    productKitDescOverrides?: ProductKitDescOverride[] | undefined;
    productKitLineRules?: ProductKitLineRule[] | undefined;
    productKitLineOptions?: ProductKitLineOption[] | undefined;
    productPrices?: ProductPrice[][] | undefined;
    productStockOptions?: ProductStockOption[][] | undefined;
    stocks?: Stock[][] | undefined;
    avOs?: AVO[] | undefined;
    avoOptions?: AVOOption[][] | undefined;
    status?: KitManifestResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IKitManifestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKit = _data["productKit"] ? ProductKit.fromJS(_data["productKit"]) : <any>undefined;
            if (Array.isArray(_data["productKitLines"])) {
                this.productKitLines = [] as any;
                for (let item of _data["productKitLines"])
                    this.productKitLines!.push(ProductKitLine.fromJS(item));
            }
            if (Array.isArray(_data["lineProducts"])) {
                this.lineProducts = [] as any;
                for (let item of _data["lineProducts"])
                    this.lineProducts!.push(Product.fromJS(item));
            }
            if (Array.isArray(_data["perRules"])) {
                this.perRules = [] as any;
                for (let item of _data["perRules"])
                    this.perRules!.push(PerRule.fromJS(item));
            }
            if (Array.isArray(_data["kitChoiceTypes"])) {
                this.kitChoiceTypes = [] as any;
                for (let item of _data["kitChoiceTypes"])
                    this.kitChoiceTypes!.push(KitChoiceType.fromJS(item));
            }
            if (Array.isArray(_data["productKitManufacturedProcesses"])) {
                this.productKitManufacturedProcesses = [] as any;
                for (let item of _data["productKitManufacturedProcesses"])
                    this.productKitManufacturedProcesses!.push(ProductKitManufacturedProcess.fromJS(item));
            }
            if (Array.isArray(_data["productKitAVOs"])) {
                this.productKitAVOs = [] as any;
                for (let item of _data["productKitAVOs"])
                    this.productKitAVOs!.push(ProductKitAVO.fromJS(item));
            }
            if (Array.isArray(_data["productKitDescOverrides"])) {
                this.productKitDescOverrides = [] as any;
                for (let item of _data["productKitDescOverrides"])
                    this.productKitDescOverrides!.push(ProductKitDescOverride.fromJS(item));
            }
            if (Array.isArray(_data["productKitLineRules"])) {
                this.productKitLineRules = [] as any;
                for (let item of _data["productKitLineRules"])
                    this.productKitLineRules!.push(ProductKitLineRule.fromJS(item));
            }
            if (Array.isArray(_data["productKitLineOptions"])) {
                this.productKitLineOptions = [] as any;
                for (let item of _data["productKitLineOptions"])
                    this.productKitLineOptions!.push(ProductKitLineOption.fromJS(item));
            }
            if (Array.isArray(_data["productPrices"])) {
                this.productPrices = [] as any;
                for (let item of _data["productPrices"])
                    this.productPrices!.push(item);
            }
            if (Array.isArray(_data["productStockOptions"])) {
                this.productStockOptions = [] as any;
                for (let item of _data["productStockOptions"])
                    this.productStockOptions!.push(item);
            }
            if (Array.isArray(_data["stocks"])) {
                this.stocks = [] as any;
                for (let item of _data["stocks"])
                    this.stocks!.push(item);
            }
            if (Array.isArray(_data["avOs"])) {
                this.avOs = [] as any;
                for (let item of _data["avOs"])
                    this.avOs!.push(AVO.fromJS(item));
            }
            if (Array.isArray(_data["avoOptions"])) {
                this.avoOptions = [] as any;
                for (let item of _data["avoOptions"])
                    this.avoOptions!.push(item);
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): KitManifestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KitManifestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKit"] = this.productKit ? this.productKit.toJSON() : <any>undefined;
        if (Array.isArray(this.productKitLines)) {
            data["productKitLines"] = [];
            for (let item of this.productKitLines)
                data["productKitLines"].push(item.toJSON());
        }
        if (Array.isArray(this.lineProducts)) {
            data["lineProducts"] = [];
            for (let item of this.lineProducts)
                data["lineProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.perRules)) {
            data["perRules"] = [];
            for (let item of this.perRules)
                data["perRules"].push(item.toJSON());
        }
        if (Array.isArray(this.kitChoiceTypes)) {
            data["kitChoiceTypes"] = [];
            for (let item of this.kitChoiceTypes)
                data["kitChoiceTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.productKitManufacturedProcesses)) {
            data["productKitManufacturedProcesses"] = [];
            for (let item of this.productKitManufacturedProcesses)
                data["productKitManufacturedProcesses"].push(item.toJSON());
        }
        if (Array.isArray(this.productKitAVOs)) {
            data["productKitAVOs"] = [];
            for (let item of this.productKitAVOs)
                data["productKitAVOs"].push(item.toJSON());
        }
        if (Array.isArray(this.productKitDescOverrides)) {
            data["productKitDescOverrides"] = [];
            for (let item of this.productKitDescOverrides)
                data["productKitDescOverrides"].push(item.toJSON());
        }
        if (Array.isArray(this.productKitLineRules)) {
            data["productKitLineRules"] = [];
            for (let item of this.productKitLineRules)
                data["productKitLineRules"].push(item.toJSON());
        }
        if (Array.isArray(this.productKitLineOptions)) {
            data["productKitLineOptions"] = [];
            for (let item of this.productKitLineOptions)
                data["productKitLineOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.productPrices)) {
            data["productPrices"] = [];
            for (let item of this.productPrices)
                data["productPrices"].push(item);
        }
        if (Array.isArray(this.productStockOptions)) {
            data["productStockOptions"] = [];
            for (let item of this.productStockOptions)
                data["productStockOptions"].push(item);
        }
        if (Array.isArray(this.stocks)) {
            data["stocks"] = [];
            for (let item of this.stocks)
                data["stocks"].push(item);
        }
        if (Array.isArray(this.avOs)) {
            data["avOs"] = [];
            for (let item of this.avOs)
                data["avOs"].push(item.toJSON());
        }
        if (Array.isArray(this.avoOptions)) {
            data["avoOptions"] = [];
            for (let item of this.avoOptions)
                data["avoOptions"].push(item);
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IKitManifestResponse {
    productKit?: ProductKit | undefined;
    productKitLines?: ProductKitLine[] | undefined;
    lineProducts?: Product[] | undefined;
    perRules?: PerRule[] | undefined;
    kitChoiceTypes?: KitChoiceType[] | undefined;
    productKitManufacturedProcesses?: ProductKitManufacturedProcess[] | undefined;
    productKitAVOs?: ProductKitAVO[] | undefined;
    productKitDescOverrides?: ProductKitDescOverride[] | undefined;
    productKitLineRules?: ProductKitLineRule[] | undefined;
    productKitLineOptions?: ProductKitLineOption[] | undefined;
    productPrices?: ProductPrice[][] | undefined;
    productStockOptions?: ProductStockOption[][] | undefined;
    stocks?: Stock[][] | undefined;
    avOs?: AVO[] | undefined;
    avoOptions?: AVOOption[][] | undefined;
    status?: KitManifestResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class ProductKitLine implements IProductKitLine {
    productKitLineID?: number | undefined;
    productID?: number | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    description?: string | undefined;
    lineProductID?: number | undefined;
    quantity?: number | undefined;
    inputPerID?: number | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    unitSellPrice?: number | undefined;
    totalSellPrice?: number | undefined;
    discount1?: number | undefined;
    discountAmount1?: number | undefined;
    discount2?: number | undefined;
    discountAmount2?: number | undefined;
    pricingType?: number | undefined;
    perID?: number | undefined;
    sellPriceType?: number | undefined;
    notes?: string | undefined;
    specialInstructions?: string | undefined;
    isChoiceLine?: boolean | undefined;
    defaultChoice?: boolean | undefined;
    choiceAdditionalCharge?: number | undefined;
    copyLineToOrder?: boolean | undefined;
    manualCode?: string | undefined;
    manualDescription?: string | undefined;
    autoCreateSpecialProduct?: boolean | undefined;
    promptForProduct?: boolean | undefined;
    timeAppliesToProcessID?: number | undefined;
    productionTime?: number | undefined;
    allowKitScreenQuantityEntry?: boolean | undefined;
    sellPriceGroupID?: number | undefined;
    sectionStartOrderLineID?: number | undefined;
    orderSectionID?: number | undefined;
    sectionSubtotal?: boolean | undefined;
    appliesToProductKitAVOID?: number | undefined;
    excludeFromMultiplier?: boolean | undefined;
    quantityFormula?: string | undefined;
    kitChoiceTypeID?: number | undefined;
    inheritFromChoiceType?: boolean | undefined;
    hideOnWorksOrder?: boolean | undefined;
    lineNotesRequired?: boolean | undefined;
    productKitLineRules?: ProductKitLineRule[] | undefined;
    product?: Product | undefined;

    constructor(data?: IProductKitLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKitLineID = _data["productKitLineID"];
            this.productID = _data["productID"];
            this.lineNumber = _data["lineNumber"];
            this.lineType = _data["lineType"];
            this.description = _data["description"];
            this.lineProductID = _data["lineProductID"];
            this.quantity = _data["quantity"];
            this.inputPerID = _data["inputPerID"];
            this.quantityTally = _data["quantityTally"];
            this.noOfPieces = _data["noOfPieces"];
            this.totalWeight = _data["totalWeight"];
            this.totalLength = _data["totalLength"];
            this.totalVolume = _data["totalVolume"];
            this.unitSellPrice = _data["unitSellPrice"];
            this.totalSellPrice = _data["totalSellPrice"];
            this.discount1 = _data["discount1"];
            this.discountAmount1 = _data["discountAmount1"];
            this.discount2 = _data["discount2"];
            this.discountAmount2 = _data["discountAmount2"];
            this.pricingType = _data["pricingType"];
            this.perID = _data["perID"];
            this.sellPriceType = _data["sellPriceType"];
            this.notes = _data["notes"];
            this.specialInstructions = _data["specialInstructions"];
            this.isChoiceLine = _data["isChoiceLine"];
            this.defaultChoice = _data["defaultChoice"];
            this.choiceAdditionalCharge = _data["choiceAdditionalCharge"];
            this.copyLineToOrder = _data["copyLineToOrder"];
            this.manualCode = _data["manualCode"];
            this.manualDescription = _data["manualDescription"];
            this.autoCreateSpecialProduct = _data["autoCreateSpecialProduct"];
            this.promptForProduct = _data["promptForProduct"];
            this.timeAppliesToProcessID = _data["timeAppliesToProcessID"];
            this.productionTime = _data["productionTime"];
            this.allowKitScreenQuantityEntry = _data["allowKitScreenQuantityEntry"];
            this.sellPriceGroupID = _data["sellPriceGroupID"];
            this.sectionStartOrderLineID = _data["sectionStartOrderLineID"];
            this.orderSectionID = _data["orderSectionID"];
            this.sectionSubtotal = _data["sectionSubtotal"];
            this.appliesToProductKitAVOID = _data["appliesToProductKitAVOID"];
            this.excludeFromMultiplier = _data["excludeFromMultiplier"];
            this.quantityFormula = _data["quantityFormula"];
            this.kitChoiceTypeID = _data["kitChoiceTypeID"];
            this.inheritFromChoiceType = _data["inheritFromChoiceType"];
            this.hideOnWorksOrder = _data["hideOnWorksOrder"];
            this.lineNotesRequired = _data["lineNotesRequired"];
            if (Array.isArray(_data["productKitLineRules"])) {
                this.productKitLineRules = [] as any;
                for (let item of _data["productKitLineRules"])
                    this.productKitLineRules!.push(ProductKitLineRule.fromJS(item));
            }
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductKitLine {
        data = typeof data === 'object' ? data : {};
        let result = new ProductKitLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKitLineID"] = this.productKitLineID;
        data["productID"] = this.productID;
        data["lineNumber"] = this.lineNumber;
        data["lineType"] = this.lineType;
        data["description"] = this.description;
        data["lineProductID"] = this.lineProductID;
        data["quantity"] = this.quantity;
        data["inputPerID"] = this.inputPerID;
        data["quantityTally"] = this.quantityTally;
        data["noOfPieces"] = this.noOfPieces;
        data["totalWeight"] = this.totalWeight;
        data["totalLength"] = this.totalLength;
        data["totalVolume"] = this.totalVolume;
        data["unitSellPrice"] = this.unitSellPrice;
        data["totalSellPrice"] = this.totalSellPrice;
        data["discount1"] = this.discount1;
        data["discountAmount1"] = this.discountAmount1;
        data["discount2"] = this.discount2;
        data["discountAmount2"] = this.discountAmount2;
        data["pricingType"] = this.pricingType;
        data["perID"] = this.perID;
        data["sellPriceType"] = this.sellPriceType;
        data["notes"] = this.notes;
        data["specialInstructions"] = this.specialInstructions;
        data["isChoiceLine"] = this.isChoiceLine;
        data["defaultChoice"] = this.defaultChoice;
        data["choiceAdditionalCharge"] = this.choiceAdditionalCharge;
        data["copyLineToOrder"] = this.copyLineToOrder;
        data["manualCode"] = this.manualCode;
        data["manualDescription"] = this.manualDescription;
        data["autoCreateSpecialProduct"] = this.autoCreateSpecialProduct;
        data["promptForProduct"] = this.promptForProduct;
        data["timeAppliesToProcessID"] = this.timeAppliesToProcessID;
        data["productionTime"] = this.productionTime;
        data["allowKitScreenQuantityEntry"] = this.allowKitScreenQuantityEntry;
        data["sellPriceGroupID"] = this.sellPriceGroupID;
        data["sectionStartOrderLineID"] = this.sectionStartOrderLineID;
        data["orderSectionID"] = this.orderSectionID;
        data["sectionSubtotal"] = this.sectionSubtotal;
        data["appliesToProductKitAVOID"] = this.appliesToProductKitAVOID;
        data["excludeFromMultiplier"] = this.excludeFromMultiplier;
        data["quantityFormula"] = this.quantityFormula;
        data["kitChoiceTypeID"] = this.kitChoiceTypeID;
        data["inheritFromChoiceType"] = this.inheritFromChoiceType;
        data["hideOnWorksOrder"] = this.hideOnWorksOrder;
        data["lineNotesRequired"] = this.lineNotesRequired;
        if (Array.isArray(this.productKitLineRules)) {
            data["productKitLineRules"] = [];
            for (let item of this.productKitLineRules)
                data["productKitLineRules"].push(item.toJSON());
        }
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IProductKitLine {
    productKitLineID?: number | undefined;
    productID?: number | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    description?: string | undefined;
    lineProductID?: number | undefined;
    quantity?: number | undefined;
    inputPerID?: number | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    unitSellPrice?: number | undefined;
    totalSellPrice?: number | undefined;
    discount1?: number | undefined;
    discountAmount1?: number | undefined;
    discount2?: number | undefined;
    discountAmount2?: number | undefined;
    pricingType?: number | undefined;
    perID?: number | undefined;
    sellPriceType?: number | undefined;
    notes?: string | undefined;
    specialInstructions?: string | undefined;
    isChoiceLine?: boolean | undefined;
    defaultChoice?: boolean | undefined;
    choiceAdditionalCharge?: number | undefined;
    copyLineToOrder?: boolean | undefined;
    manualCode?: string | undefined;
    manualDescription?: string | undefined;
    autoCreateSpecialProduct?: boolean | undefined;
    promptForProduct?: boolean | undefined;
    timeAppliesToProcessID?: number | undefined;
    productionTime?: number | undefined;
    allowKitScreenQuantityEntry?: boolean | undefined;
    sellPriceGroupID?: number | undefined;
    sectionStartOrderLineID?: number | undefined;
    orderSectionID?: number | undefined;
    sectionSubtotal?: boolean | undefined;
    appliesToProductKitAVOID?: number | undefined;
    excludeFromMultiplier?: boolean | undefined;
    quantityFormula?: string | undefined;
    kitChoiceTypeID?: number | undefined;
    inheritFromChoiceType?: boolean | undefined;
    hideOnWorksOrder?: boolean | undefined;
    lineNotesRequired?: boolean | undefined;
    productKitLineRules?: ProductKitLineRule[] | undefined;
    product?: Product | undefined;
}

export class PerRule implements IPerRule {
    perRuleID?: number | undefined;
    name?: string | undefined;
    basePerID?: number | undefined;
    stockPerID?: number | undefined;
    statisticsPerID?: number | undefined;
    weightPerID?: number | undefined;
    inputPerID?: number | undefined;
    inputPerIDs?: string | undefined;
    buyPerIDs?: string | undefined;
    sellPerIDs?: string | undefined;
    displayPerIDs?: string | undefined;
    usageCount?: number | undefined;
    stockedByCost?: boolean | undefined;
    deleted?: number | undefined;
    ruleProductID?: number | undefined;
    wmsSmallPerID?: number | undefined;
    wmsMediumPerID?: number | undefined;
    wmsLargePerID?: number | undefined;
    purchaseInputPerID?: number | undefined;

    constructor(data?: IPerRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.perRuleID = _data["perRuleID"];
            this.name = _data["name"];
            this.basePerID = _data["basePerID"];
            this.stockPerID = _data["stockPerID"];
            this.statisticsPerID = _data["statisticsPerID"];
            this.weightPerID = _data["weightPerID"];
            this.inputPerID = _data["inputPerID"];
            this.inputPerIDs = _data["inputPerIDs"];
            this.buyPerIDs = _data["buyPerIDs"];
            this.sellPerIDs = _data["sellPerIDs"];
            this.displayPerIDs = _data["displayPerIDs"];
            this.usageCount = _data["usageCount"];
            this.stockedByCost = _data["stockedByCost"];
            this.deleted = _data["deleted"];
            this.ruleProductID = _data["ruleProductID"];
            this.wmsSmallPerID = _data["wmsSmallPerID"];
            this.wmsMediumPerID = _data["wmsMediumPerID"];
            this.wmsLargePerID = _data["wmsLargePerID"];
            this.purchaseInputPerID = _data["purchaseInputPerID"];
        }
    }

    static fromJS(data: any): PerRule {
        data = typeof data === 'object' ? data : {};
        let result = new PerRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["perRuleID"] = this.perRuleID;
        data["name"] = this.name;
        data["basePerID"] = this.basePerID;
        data["stockPerID"] = this.stockPerID;
        data["statisticsPerID"] = this.statisticsPerID;
        data["weightPerID"] = this.weightPerID;
        data["inputPerID"] = this.inputPerID;
        data["inputPerIDs"] = this.inputPerIDs;
        data["buyPerIDs"] = this.buyPerIDs;
        data["sellPerIDs"] = this.sellPerIDs;
        data["displayPerIDs"] = this.displayPerIDs;
        data["usageCount"] = this.usageCount;
        data["stockedByCost"] = this.stockedByCost;
        data["deleted"] = this.deleted;
        data["ruleProductID"] = this.ruleProductID;
        data["wmsSmallPerID"] = this.wmsSmallPerID;
        data["wmsMediumPerID"] = this.wmsMediumPerID;
        data["wmsLargePerID"] = this.wmsLargePerID;
        data["purchaseInputPerID"] = this.purchaseInputPerID;
        return data; 
    }
}

export interface IPerRule {
    perRuleID?: number | undefined;
    name?: string | undefined;
    basePerID?: number | undefined;
    stockPerID?: number | undefined;
    statisticsPerID?: number | undefined;
    weightPerID?: number | undefined;
    inputPerID?: number | undefined;
    inputPerIDs?: string | undefined;
    buyPerIDs?: string | undefined;
    sellPerIDs?: string | undefined;
    displayPerIDs?: string | undefined;
    usageCount?: number | undefined;
    stockedByCost?: boolean | undefined;
    deleted?: number | undefined;
    ruleProductID?: number | undefined;
    wmsSmallPerID?: number | undefined;
    wmsMediumPerID?: number | undefined;
    wmsLargePerID?: number | undefined;
    purchaseInputPerID?: number | undefined;
}

export class KitChoiceType implements IKitChoiceType {
    kitChoiceTypeID?: number | undefined;
    typeCode?: string | undefined;
    description?: string | undefined;
    deleted?: boolean | undefined;

    constructor(data?: IKitChoiceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kitChoiceTypeID = _data["kitChoiceTypeID"];
            this.typeCode = _data["typeCode"];
            this.description = _data["description"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): KitChoiceType {
        data = typeof data === 'object' ? data : {};
        let result = new KitChoiceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kitChoiceTypeID"] = this.kitChoiceTypeID;
        data["typeCode"] = this.typeCode;
        data["description"] = this.description;
        data["deleted"] = this.deleted;
        return data; 
    }
}

export interface IKitChoiceType {
    kitChoiceTypeID?: number | undefined;
    typeCode?: string | undefined;
    description?: string | undefined;
    deleted?: boolean | undefined;
}

export class ProductKitManufacturedProcess implements IProductKitManufacturedProcess {
    productKitManufacturedProcessID?: number | undefined;
    productID?: number | undefined;
    avoid?: number | undefined;
    avoOptionID?: number | undefined;
    kitCosted?: boolean | undefined;
    costPrice?: number | undefined;
    costPerID?: number | undefined;
    totalCostPriceBasedOn?: number | undefined;
    kitPriced?: boolean | undefined;
    sellPrice?: number | undefined;
    sellPerID?: number | undefined;
    totalSellPriceBasedOn?: number | undefined;
    oneTimeFee?: boolean | undefined;
    minimumCost?: number | undefined;
    minimumSell?: number | undefined;
    lineNumber?: number | undefined;

    constructor(data?: IProductKitManufacturedProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKitManufacturedProcessID = _data["productKitManufacturedProcessID"];
            this.productID = _data["productID"];
            this.avoid = _data["avoid"];
            this.avoOptionID = _data["avoOptionID"];
            this.kitCosted = _data["kitCosted"];
            this.costPrice = _data["costPrice"];
            this.costPerID = _data["costPerID"];
            this.totalCostPriceBasedOn = _data["totalCostPriceBasedOn"];
            this.kitPriced = _data["kitPriced"];
            this.sellPrice = _data["sellPrice"];
            this.sellPerID = _data["sellPerID"];
            this.totalSellPriceBasedOn = _data["totalSellPriceBasedOn"];
            this.oneTimeFee = _data["oneTimeFee"];
            this.minimumCost = _data["minimumCost"];
            this.minimumSell = _data["minimumSell"];
            this.lineNumber = _data["lineNumber"];
        }
    }

    static fromJS(data: any): ProductKitManufacturedProcess {
        data = typeof data === 'object' ? data : {};
        let result = new ProductKitManufacturedProcess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKitManufacturedProcessID"] = this.productKitManufacturedProcessID;
        data["productID"] = this.productID;
        data["avoid"] = this.avoid;
        data["avoOptionID"] = this.avoOptionID;
        data["kitCosted"] = this.kitCosted;
        data["costPrice"] = this.costPrice;
        data["costPerID"] = this.costPerID;
        data["totalCostPriceBasedOn"] = this.totalCostPriceBasedOn;
        data["kitPriced"] = this.kitPriced;
        data["sellPrice"] = this.sellPrice;
        data["sellPerID"] = this.sellPerID;
        data["totalSellPriceBasedOn"] = this.totalSellPriceBasedOn;
        data["oneTimeFee"] = this.oneTimeFee;
        data["minimumCost"] = this.minimumCost;
        data["minimumSell"] = this.minimumSell;
        data["lineNumber"] = this.lineNumber;
        return data; 
    }
}

export interface IProductKitManufacturedProcess {
    productKitManufacturedProcessID?: number | undefined;
    productID?: number | undefined;
    avoid?: number | undefined;
    avoOptionID?: number | undefined;
    kitCosted?: boolean | undefined;
    costPrice?: number | undefined;
    costPerID?: number | undefined;
    totalCostPriceBasedOn?: number | undefined;
    kitPriced?: boolean | undefined;
    sellPrice?: number | undefined;
    sellPerID?: number | undefined;
    totalSellPriceBasedOn?: number | undefined;
    oneTimeFee?: boolean | undefined;
    minimumCost?: number | undefined;
    minimumSell?: number | undefined;
    lineNumber?: number | undefined;
}

export class ProductKitAVO implements IProductKitAVO {
    productKitAVOID?: number | undefined;
    productID?: number | undefined;
    avoid?: number | undefined;
    avoOptionID?: number | undefined;
    kitCosted?: boolean | undefined;
    costPrice?: number | undefined;
    costPerID?: number | undefined;
    totalCostPriceBasedOn?: number | undefined;
    kitPriced?: boolean | undefined;
    sellPrice?: number | undefined;
    sellPerID?: number | undefined;
    totalSellPriceBasedOn?: number | undefined;
    minimumCost?: number | undefined;
    minimumSell?: number | undefined;
    lineNumber?: number | undefined;

    constructor(data?: IProductKitAVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKitAVOID = _data["productKitAVOID"];
            this.productID = _data["productID"];
            this.avoid = _data["avoid"];
            this.avoOptionID = _data["avoOptionID"];
            this.kitCosted = _data["kitCosted"];
            this.costPrice = _data["costPrice"];
            this.costPerID = _data["costPerID"];
            this.totalCostPriceBasedOn = _data["totalCostPriceBasedOn"];
            this.kitPriced = _data["kitPriced"];
            this.sellPrice = _data["sellPrice"];
            this.sellPerID = _data["sellPerID"];
            this.totalSellPriceBasedOn = _data["totalSellPriceBasedOn"];
            this.minimumCost = _data["minimumCost"];
            this.minimumSell = _data["minimumSell"];
            this.lineNumber = _data["lineNumber"];
        }
    }

    static fromJS(data: any): ProductKitAVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProductKitAVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKitAVOID"] = this.productKitAVOID;
        data["productID"] = this.productID;
        data["avoid"] = this.avoid;
        data["avoOptionID"] = this.avoOptionID;
        data["kitCosted"] = this.kitCosted;
        data["costPrice"] = this.costPrice;
        data["costPerID"] = this.costPerID;
        data["totalCostPriceBasedOn"] = this.totalCostPriceBasedOn;
        data["kitPriced"] = this.kitPriced;
        data["sellPrice"] = this.sellPrice;
        data["sellPerID"] = this.sellPerID;
        data["totalSellPriceBasedOn"] = this.totalSellPriceBasedOn;
        data["minimumCost"] = this.minimumCost;
        data["minimumSell"] = this.minimumSell;
        data["lineNumber"] = this.lineNumber;
        return data; 
    }
}

export interface IProductKitAVO {
    productKitAVOID?: number | undefined;
    productID?: number | undefined;
    avoid?: number | undefined;
    avoOptionID?: number | undefined;
    kitCosted?: boolean | undefined;
    costPrice?: number | undefined;
    costPerID?: number | undefined;
    totalCostPriceBasedOn?: number | undefined;
    kitPriced?: boolean | undefined;
    sellPrice?: number | undefined;
    sellPerID?: number | undefined;
    totalSellPriceBasedOn?: number | undefined;
    minimumCost?: number | undefined;
    minimumSell?: number | undefined;
    lineNumber?: number | undefined;
}

export class ProductKitDescOverride implements IProductKitDescOverride {
    productKitID?: number | undefined;
    sequence?: number | undefined;
    productKitLineID?: number | undefined;

    constructor(data?: IProductKitDescOverride) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKitID = _data["productKitID"];
            this.sequence = _data["sequence"];
            this.productKitLineID = _data["productKitLineID"];
        }
    }

    static fromJS(data: any): ProductKitDescOverride {
        data = typeof data === 'object' ? data : {};
        let result = new ProductKitDescOverride();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKitID"] = this.productKitID;
        data["sequence"] = this.sequence;
        data["productKitLineID"] = this.productKitLineID;
        return data; 
    }
}

export interface IProductKitDescOverride {
    productKitID?: number | undefined;
    sequence?: number | undefined;
    productKitLineID?: number | undefined;
}

export class ProductKitLineRule implements IProductKitLineRule {
    kitLineRuleID?: number | undefined;
    productKitLineID?: number | undefined;
    productID?: number | undefined;
    lineNumber?: number | undefined;
    andOr?: number | undefined;
    choiceProductKitLineID?: number | undefined;
    ruleIs?: boolean | undefined;
    productKitLineOptions?: ProductKitLineOption[] | undefined;

    constructor(data?: IProductKitLineRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kitLineRuleID = _data["kitLineRuleID"];
            this.productKitLineID = _data["productKitLineID"];
            this.productID = _data["productID"];
            this.lineNumber = _data["lineNumber"];
            this.andOr = _data["andOr"];
            this.choiceProductKitLineID = _data["choiceProductKitLineID"];
            this.ruleIs = _data["ruleIs"];
            if (Array.isArray(_data["productKitLineOptions"])) {
                this.productKitLineOptions = [] as any;
                for (let item of _data["productKitLineOptions"])
                    this.productKitLineOptions!.push(ProductKitLineOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductKitLineRule {
        data = typeof data === 'object' ? data : {};
        let result = new ProductKitLineRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kitLineRuleID"] = this.kitLineRuleID;
        data["productKitLineID"] = this.productKitLineID;
        data["productID"] = this.productID;
        data["lineNumber"] = this.lineNumber;
        data["andOr"] = this.andOr;
        data["choiceProductKitLineID"] = this.choiceProductKitLineID;
        data["ruleIs"] = this.ruleIs;
        if (Array.isArray(this.productKitLineOptions)) {
            data["productKitLineOptions"] = [];
            for (let item of this.productKitLineOptions)
                data["productKitLineOptions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProductKitLineRule {
    kitLineRuleID?: number | undefined;
    productKitLineID?: number | undefined;
    productID?: number | undefined;
    lineNumber?: number | undefined;
    andOr?: number | undefined;
    choiceProductKitLineID?: number | undefined;
    ruleIs?: boolean | undefined;
    productKitLineOptions?: ProductKitLineOption[] | undefined;
}

export class ProductKitLineOption implements IProductKitLineOption {
    kitLineOptionID?: number | undefined;
    kitLineRuleID?: number | undefined;
    productKitLineID?: number | undefined;
    productID?: number | undefined;
    optionProductKitLineID?: number | undefined;

    constructor(data?: IProductKitLineOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kitLineOptionID = _data["kitLineOptionID"];
            this.kitLineRuleID = _data["kitLineRuleID"];
            this.productKitLineID = _data["productKitLineID"];
            this.productID = _data["productID"];
            this.optionProductKitLineID = _data["optionProductKitLineID"];
        }
    }

    static fromJS(data: any): ProductKitLineOption {
        data = typeof data === 'object' ? data : {};
        let result = new ProductKitLineOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kitLineOptionID"] = this.kitLineOptionID;
        data["kitLineRuleID"] = this.kitLineRuleID;
        data["productKitLineID"] = this.productKitLineID;
        data["productID"] = this.productID;
        data["optionProductKitLineID"] = this.optionProductKitLineID;
        return data; 
    }
}

export interface IProductKitLineOption {
    kitLineOptionID?: number | undefined;
    kitLineRuleID?: number | undefined;
    productKitLineID?: number | undefined;
    productID?: number | undefined;
    optionProductKitLineID?: number | undefined;
}

export class ProductPrice implements IProductPrice {
    productID?: number | undefined;
    branchID?: number | undefined;
    length?: number | undefined;
    standardBuy?: number | undefined;
    buyPerID?: number | undefined;
    buyStockConversion?: number | undefined;
    standardBuyDateTime?: Date | undefined;
    averageCost?: number | undefined;
    averageCostWithAdd?: number | undefined;
    averageCostPerID?: number | undefined;
    averageCostDateTime?: Date | undefined;
    lastCost?: number | undefined;
    lastCostWithAdd?: number | undefined;
    lastCostPerID?: number | undefined;
    lastCostDateTime?: Date | undefined;
    standardSell?: number | undefined;
    sellPerID?: number | undefined;
    standardSellDateTime?: Date | undefined;
    internalCost?: number | undefined;
    internalCostPerID?: number | undefined;
    internalCostDateTime?: Date | undefined;
    commissionCost?: number | undefined;
    commissionCostPerID?: number | undefined;
    commissionCostDateTime?: Date | undefined;
    sourceType?: number | undefined;
    sourceID?: number | undefined;
    sourceNumber?: number | undefined;
    transactionUnitPrice?: number | undefined;
    transactionUnitPriceWithAdd?: number | undefined;
    transactionTotalPrice?: number | undefined;
    transactionTotalPriceWithAdd?: number | undefined;
    transactionQuantity?: number | undefined;
    newStockActual?: number | undefined;
    negativeInventoryAdjustment?: number | undefined;
    oldStockActual?: number | undefined;
    totalStockValuation?: number | undefined;
    postingDate?: Date | undefined;
    productBatchID?: number | undefined;

    constructor(data?: IProductPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productID = _data["productID"];
            this.branchID = _data["branchID"];
            this.length = _data["length"];
            this.standardBuy = _data["standardBuy"];
            this.buyPerID = _data["buyPerID"];
            this.buyStockConversion = _data["buyStockConversion"];
            this.standardBuyDateTime = _data["standardBuyDateTime"] ? new Date(_data["standardBuyDateTime"].toString()) : <any>undefined;
            this.averageCost = _data["averageCost"];
            this.averageCostWithAdd = _data["averageCostWithAdd"];
            this.averageCostPerID = _data["averageCostPerID"];
            this.averageCostDateTime = _data["averageCostDateTime"] ? new Date(_data["averageCostDateTime"].toString()) : <any>undefined;
            this.lastCost = _data["lastCost"];
            this.lastCostWithAdd = _data["lastCostWithAdd"];
            this.lastCostPerID = _data["lastCostPerID"];
            this.lastCostDateTime = _data["lastCostDateTime"] ? new Date(_data["lastCostDateTime"].toString()) : <any>undefined;
            this.standardSell = _data["standardSell"];
            this.sellPerID = _data["sellPerID"];
            this.standardSellDateTime = _data["standardSellDateTime"] ? new Date(_data["standardSellDateTime"].toString()) : <any>undefined;
            this.internalCost = _data["internalCost"];
            this.internalCostPerID = _data["internalCostPerID"];
            this.internalCostDateTime = _data["internalCostDateTime"] ? new Date(_data["internalCostDateTime"].toString()) : <any>undefined;
            this.commissionCost = _data["commissionCost"];
            this.commissionCostPerID = _data["commissionCostPerID"];
            this.commissionCostDateTime = _data["commissionCostDateTime"] ? new Date(_data["commissionCostDateTime"].toString()) : <any>undefined;
            this.sourceType = _data["sourceType"];
            this.sourceID = _data["sourceID"];
            this.sourceNumber = _data["sourceNumber"];
            this.transactionUnitPrice = _data["transactionUnitPrice"];
            this.transactionUnitPriceWithAdd = _data["transactionUnitPriceWithAdd"];
            this.transactionTotalPrice = _data["transactionTotalPrice"];
            this.transactionTotalPriceWithAdd = _data["transactionTotalPriceWithAdd"];
            this.transactionQuantity = _data["transactionQuantity"];
            this.newStockActual = _data["newStockActual"];
            this.negativeInventoryAdjustment = _data["negativeInventoryAdjustment"];
            this.oldStockActual = _data["oldStockActual"];
            this.totalStockValuation = _data["totalStockValuation"];
            this.postingDate = _data["postingDate"] ? new Date(_data["postingDate"].toString()) : <any>undefined;
            this.productBatchID = _data["productBatchID"];
        }
    }

    static fromJS(data: any): ProductPrice {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productID"] = this.productID;
        data["branchID"] = this.branchID;
        data["length"] = this.length;
        data["standardBuy"] = this.standardBuy;
        data["buyPerID"] = this.buyPerID;
        data["buyStockConversion"] = this.buyStockConversion;
        data["standardBuyDateTime"] = this.standardBuyDateTime ? this.standardBuyDateTime.toISOString() : <any>undefined;
        data["averageCost"] = this.averageCost;
        data["averageCostWithAdd"] = this.averageCostWithAdd;
        data["averageCostPerID"] = this.averageCostPerID;
        data["averageCostDateTime"] = this.averageCostDateTime ? this.averageCostDateTime.toISOString() : <any>undefined;
        data["lastCost"] = this.lastCost;
        data["lastCostWithAdd"] = this.lastCostWithAdd;
        data["lastCostPerID"] = this.lastCostPerID;
        data["lastCostDateTime"] = this.lastCostDateTime ? this.lastCostDateTime.toISOString() : <any>undefined;
        data["standardSell"] = this.standardSell;
        data["sellPerID"] = this.sellPerID;
        data["standardSellDateTime"] = this.standardSellDateTime ? this.standardSellDateTime.toISOString() : <any>undefined;
        data["internalCost"] = this.internalCost;
        data["internalCostPerID"] = this.internalCostPerID;
        data["internalCostDateTime"] = this.internalCostDateTime ? this.internalCostDateTime.toISOString() : <any>undefined;
        data["commissionCost"] = this.commissionCost;
        data["commissionCostPerID"] = this.commissionCostPerID;
        data["commissionCostDateTime"] = this.commissionCostDateTime ? this.commissionCostDateTime.toISOString() : <any>undefined;
        data["sourceType"] = this.sourceType;
        data["sourceID"] = this.sourceID;
        data["sourceNumber"] = this.sourceNumber;
        data["transactionUnitPrice"] = this.transactionUnitPrice;
        data["transactionUnitPriceWithAdd"] = this.transactionUnitPriceWithAdd;
        data["transactionTotalPrice"] = this.transactionTotalPrice;
        data["transactionTotalPriceWithAdd"] = this.transactionTotalPriceWithAdd;
        data["transactionQuantity"] = this.transactionQuantity;
        data["newStockActual"] = this.newStockActual;
        data["negativeInventoryAdjustment"] = this.negativeInventoryAdjustment;
        data["oldStockActual"] = this.oldStockActual;
        data["totalStockValuation"] = this.totalStockValuation;
        data["postingDate"] = this.postingDate ? this.postingDate.toISOString() : <any>undefined;
        data["productBatchID"] = this.productBatchID;
        return data; 
    }
}

export interface IProductPrice {
    productID?: number | undefined;
    branchID?: number | undefined;
    length?: number | undefined;
    standardBuy?: number | undefined;
    buyPerID?: number | undefined;
    buyStockConversion?: number | undefined;
    standardBuyDateTime?: Date | undefined;
    averageCost?: number | undefined;
    averageCostWithAdd?: number | undefined;
    averageCostPerID?: number | undefined;
    averageCostDateTime?: Date | undefined;
    lastCost?: number | undefined;
    lastCostWithAdd?: number | undefined;
    lastCostPerID?: number | undefined;
    lastCostDateTime?: Date | undefined;
    standardSell?: number | undefined;
    sellPerID?: number | undefined;
    standardSellDateTime?: Date | undefined;
    internalCost?: number | undefined;
    internalCostPerID?: number | undefined;
    internalCostDateTime?: Date | undefined;
    commissionCost?: number | undefined;
    commissionCostPerID?: number | undefined;
    commissionCostDateTime?: Date | undefined;
    sourceType?: number | undefined;
    sourceID?: number | undefined;
    sourceNumber?: number | undefined;
    transactionUnitPrice?: number | undefined;
    transactionUnitPriceWithAdd?: number | undefined;
    transactionTotalPrice?: number | undefined;
    transactionTotalPriceWithAdd?: number | undefined;
    transactionQuantity?: number | undefined;
    newStockActual?: number | undefined;
    negativeInventoryAdjustment?: number | undefined;
    oldStockActual?: number | undefined;
    totalStockValuation?: number | undefined;
    postingDate?: Date | undefined;
    productBatchID?: number | undefined;
}

export class AVO implements IAVO {
    avoid?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    productID?: number | undefined;
    internalOperation?: boolean | undefined;
    requiresConfirmation?: boolean | undefined;
    allowMultipleOptions?: boolean | undefined;
    allowProductType1?: boolean | undefined;
    allowProductType2?: boolean | undefined;
    allowProductType3?: boolean | undefined;
    allowProductType4?: boolean | undefined;
    allowProductType5?: boolean | undefined;
    allowProductType6?: boolean | undefined;
    allowProductType7?: boolean | undefined;
    allowProductType8?: boolean | undefined;
    allowProductType9?: boolean | undefined;
    deleted?: number | undefined;

    constructor(data?: IAVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avoid = _data["avoid"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.productID = _data["productID"];
            this.internalOperation = _data["internalOperation"];
            this.requiresConfirmation = _data["requiresConfirmation"];
            this.allowMultipleOptions = _data["allowMultipleOptions"];
            this.allowProductType1 = _data["allowProductType1"];
            this.allowProductType2 = _data["allowProductType2"];
            this.allowProductType3 = _data["allowProductType3"];
            this.allowProductType4 = _data["allowProductType4"];
            this.allowProductType5 = _data["allowProductType5"];
            this.allowProductType6 = _data["allowProductType6"];
            this.allowProductType7 = _data["allowProductType7"];
            this.allowProductType8 = _data["allowProductType8"];
            this.allowProductType9 = _data["allowProductType9"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): AVO {
        data = typeof data === 'object' ? data : {};
        let result = new AVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avoid"] = this.avoid;
        data["name"] = this.name;
        data["description"] = this.description;
        data["productID"] = this.productID;
        data["internalOperation"] = this.internalOperation;
        data["requiresConfirmation"] = this.requiresConfirmation;
        data["allowMultipleOptions"] = this.allowMultipleOptions;
        data["allowProductType1"] = this.allowProductType1;
        data["allowProductType2"] = this.allowProductType2;
        data["allowProductType3"] = this.allowProductType3;
        data["allowProductType4"] = this.allowProductType4;
        data["allowProductType5"] = this.allowProductType5;
        data["allowProductType6"] = this.allowProductType6;
        data["allowProductType7"] = this.allowProductType7;
        data["allowProductType8"] = this.allowProductType8;
        data["allowProductType9"] = this.allowProductType9;
        data["deleted"] = this.deleted;
        return data; 
    }
}

export interface IAVO {
    avoid?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    productID?: number | undefined;
    internalOperation?: boolean | undefined;
    requiresConfirmation?: boolean | undefined;
    allowMultipleOptions?: boolean | undefined;
    allowProductType1?: boolean | undefined;
    allowProductType2?: boolean | undefined;
    allowProductType3?: boolean | undefined;
    allowProductType4?: boolean | undefined;
    allowProductType5?: boolean | undefined;
    allowProductType6?: boolean | undefined;
    allowProductType7?: boolean | undefined;
    allowProductType8?: boolean | undefined;
    allowProductType9?: boolean | undefined;
    deleted?: number | undefined;
}

export class AVOOption implements IAVOOption {
    avoOptionID?: number | undefined;
    avoid?: number | undefined;
    name?: string | undefined;
    supplierID?: number | undefined;
    costPrice?: number | undefined;
    sellPrice?: number | undefined;
    costPriceCalcUseActualSize?: boolean | undefined;
    sellPriceCalcUseActualSize?: boolean | undefined;
    perID?: number | undefined;
    branchID?: number | undefined;
    productGroupID?: number | undefined;
    salesAnalysisCodeID?: number | undefined;
    profileAnalysisCodeID?: number | undefined;
    vatRuleID?: number | undefined;
    taxGroupID?: number | undefined;
    glCodeSales?: string | undefined;
    glCodeCost?: string | undefined;
    glCodeProcessing?: string | undefined;
    createPurchaseOrder?: boolean | undefined;
    leadTime?: number | undefined;
    concurrent?: boolean | undefined;
    deleted?: number | undefined;
    ediOptionCode?: string | undefined;
    machineID?: number | undefined;
    worksOrderCurrencyID?: number | undefined;
    minimumCost?: number | undefined;
    minimumSell?: number | undefined;
    machineGroupID?: number | undefined;
    positiveTolerance?: number | undefined;
    negativeTolerance?: number | undefined;
    productionTime?: number | undefined;

    constructor(data?: IAVOOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avoOptionID = _data["avoOptionID"];
            this.avoid = _data["avoid"];
            this.name = _data["name"];
            this.supplierID = _data["supplierID"];
            this.costPrice = _data["costPrice"];
            this.sellPrice = _data["sellPrice"];
            this.costPriceCalcUseActualSize = _data["costPriceCalcUseActualSize"];
            this.sellPriceCalcUseActualSize = _data["sellPriceCalcUseActualSize"];
            this.perID = _data["perID"];
            this.branchID = _data["branchID"];
            this.productGroupID = _data["productGroupID"];
            this.salesAnalysisCodeID = _data["salesAnalysisCodeID"];
            this.profileAnalysisCodeID = _data["profileAnalysisCodeID"];
            this.vatRuleID = _data["vatRuleID"];
            this.taxGroupID = _data["taxGroupID"];
            this.glCodeSales = _data["glCodeSales"];
            this.glCodeCost = _data["glCodeCost"];
            this.glCodeProcessing = _data["glCodeProcessing"];
            this.createPurchaseOrder = _data["createPurchaseOrder"];
            this.leadTime = _data["leadTime"];
            this.concurrent = _data["concurrent"];
            this.deleted = _data["deleted"];
            this.ediOptionCode = _data["ediOptionCode"];
            this.machineID = _data["machineID"];
            this.worksOrderCurrencyID = _data["worksOrderCurrencyID"];
            this.minimumCost = _data["minimumCost"];
            this.minimumSell = _data["minimumSell"];
            this.machineGroupID = _data["machineGroupID"];
            this.positiveTolerance = _data["positiveTolerance"];
            this.negativeTolerance = _data["negativeTolerance"];
            this.productionTime = _data["productionTime"];
        }
    }

    static fromJS(data: any): AVOOption {
        data = typeof data === 'object' ? data : {};
        let result = new AVOOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avoOptionID"] = this.avoOptionID;
        data["avoid"] = this.avoid;
        data["name"] = this.name;
        data["supplierID"] = this.supplierID;
        data["costPrice"] = this.costPrice;
        data["sellPrice"] = this.sellPrice;
        data["costPriceCalcUseActualSize"] = this.costPriceCalcUseActualSize;
        data["sellPriceCalcUseActualSize"] = this.sellPriceCalcUseActualSize;
        data["perID"] = this.perID;
        data["branchID"] = this.branchID;
        data["productGroupID"] = this.productGroupID;
        data["salesAnalysisCodeID"] = this.salesAnalysisCodeID;
        data["profileAnalysisCodeID"] = this.profileAnalysisCodeID;
        data["vatRuleID"] = this.vatRuleID;
        data["taxGroupID"] = this.taxGroupID;
        data["glCodeSales"] = this.glCodeSales;
        data["glCodeCost"] = this.glCodeCost;
        data["glCodeProcessing"] = this.glCodeProcessing;
        data["createPurchaseOrder"] = this.createPurchaseOrder;
        data["leadTime"] = this.leadTime;
        data["concurrent"] = this.concurrent;
        data["deleted"] = this.deleted;
        data["ediOptionCode"] = this.ediOptionCode;
        data["machineID"] = this.machineID;
        data["worksOrderCurrencyID"] = this.worksOrderCurrencyID;
        data["minimumCost"] = this.minimumCost;
        data["minimumSell"] = this.minimumSell;
        data["machineGroupID"] = this.machineGroupID;
        data["positiveTolerance"] = this.positiveTolerance;
        data["negativeTolerance"] = this.negativeTolerance;
        data["productionTime"] = this.productionTime;
        return data; 
    }
}

export interface IAVOOption {
    avoOptionID?: number | undefined;
    avoid?: number | undefined;
    name?: string | undefined;
    supplierID?: number | undefined;
    costPrice?: number | undefined;
    sellPrice?: number | undefined;
    costPriceCalcUseActualSize?: boolean | undefined;
    sellPriceCalcUseActualSize?: boolean | undefined;
    perID?: number | undefined;
    branchID?: number | undefined;
    productGroupID?: number | undefined;
    salesAnalysisCodeID?: number | undefined;
    profileAnalysisCodeID?: number | undefined;
    vatRuleID?: number | undefined;
    taxGroupID?: number | undefined;
    glCodeSales?: string | undefined;
    glCodeCost?: string | undefined;
    glCodeProcessing?: string | undefined;
    createPurchaseOrder?: boolean | undefined;
    leadTime?: number | undefined;
    concurrent?: boolean | undefined;
    deleted?: number | undefined;
    ediOptionCode?: string | undefined;
    machineID?: number | undefined;
    worksOrderCurrencyID?: number | undefined;
    minimumCost?: number | undefined;
    minimumSell?: number | undefined;
    machineGroupID?: number | undefined;
    positiveTolerance?: number | undefined;
    negativeTolerance?: number | undefined;
    productionTime?: number | undefined;
}

export class KitConfiguratorResponse implements IKitConfiguratorResponse {
    productKit?: ProductKitConfigurator | undefined;
    productLineChoices?: KitProductLineChoices | undefined;
    productKitManufacturedProcess?: ProductKitConfiguratorManufacturedProcess[] | undefined;
    productKitDescOverrides?: ProductKitDescOverride[] | undefined;
    status?: KitConfiguratorResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IKitConfiguratorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKit = _data["productKit"] ? ProductKitConfigurator.fromJS(_data["productKit"]) : <any>undefined;
            this.productLineChoices = _data["productLineChoices"] ? KitProductLineChoices.fromJS(_data["productLineChoices"]) : <any>undefined;
            if (Array.isArray(_data["productKitManufacturedProcess"])) {
                this.productKitManufacturedProcess = [] as any;
                for (let item of _data["productKitManufacturedProcess"])
                    this.productKitManufacturedProcess!.push(ProductKitConfiguratorManufacturedProcess.fromJS(item));
            }
            if (Array.isArray(_data["productKitDescOverrides"])) {
                this.productKitDescOverrides = [] as any;
                for (let item of _data["productKitDescOverrides"])
                    this.productKitDescOverrides!.push(ProductKitDescOverride.fromJS(item));
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): KitConfiguratorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KitConfiguratorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKit"] = this.productKit ? this.productKit.toJSON() : <any>undefined;
        data["productLineChoices"] = this.productLineChoices ? this.productLineChoices.toJSON() : <any>undefined;
        if (Array.isArray(this.productKitManufacturedProcess)) {
            data["productKitManufacturedProcess"] = [];
            for (let item of this.productKitManufacturedProcess)
                data["productKitManufacturedProcess"].push(item.toJSON());
        }
        if (Array.isArray(this.productKitDescOverrides)) {
            data["productKitDescOverrides"] = [];
            for (let item of this.productKitDescOverrides)
                data["productKitDescOverrides"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IKitConfiguratorResponse {
    productKit?: ProductKitConfigurator | undefined;
    productLineChoices?: KitProductLineChoices | undefined;
    productKitManufacturedProcess?: ProductKitConfiguratorManufacturedProcess[] | undefined;
    productKitDescOverrides?: ProductKitDescOverride[] | undefined;
    status?: KitConfiguratorResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class ProductKitConfigurator implements IProductKitConfigurator {
    productID?: number | undefined;
    documentDescription?: string | undefined;
    totalSellPrice?: number | undefined;
    minSellPrice?: number | undefined;
    maxSellPrice?: number | undefined;
    branchID?: number | undefined;
    customerID?: number | undefined;
    customerAddressID?: number | undefined;
    documentPresentation?: number | undefined;
    manufactured?: boolean | undefined;
    manufacturedProductID?: number | undefined;
    setDescriptionFromLinesShortDescriptions?: boolean | undefined;
    alwaysUseSellPriceOfFinishedItem?: boolean | undefined;
    promptForFinishedProduct?: boolean | undefined;
    combineManKitsonWO?: boolean | undefined;
    purchased?: boolean | undefined;
    purchaseProductID?: number | undefined;
    fractionalMultiplierOption?: number | undefined;

    constructor(data?: IProductKitConfigurator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productID = _data["productID"];
            this.documentDescription = _data["documentDescription"];
            this.totalSellPrice = _data["totalSellPrice"];
            this.minSellPrice = _data["minSellPrice"];
            this.maxSellPrice = _data["maxSellPrice"];
            this.branchID = _data["branchID"];
            this.customerID = _data["customerID"];
            this.customerAddressID = _data["customerAddressID"];
            this.documentPresentation = _data["documentPresentation"];
            this.manufactured = _data["manufactured"];
            this.manufacturedProductID = _data["manufacturedProductID"];
            this.setDescriptionFromLinesShortDescriptions = _data["setDescriptionFromLinesShortDescriptions"];
            this.alwaysUseSellPriceOfFinishedItem = _data["alwaysUseSellPriceOfFinishedItem"];
            this.promptForFinishedProduct = _data["promptForFinishedProduct"];
            this.combineManKitsonWO = _data["combineManKitsonWO"];
            this.purchased = _data["purchased"];
            this.purchaseProductID = _data["purchaseProductID"];
            this.fractionalMultiplierOption = _data["fractionalMultiplierOption"];
        }
    }

    static fromJS(data: any): ProductKitConfigurator {
        data = typeof data === 'object' ? data : {};
        let result = new ProductKitConfigurator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productID"] = this.productID;
        data["documentDescription"] = this.documentDescription;
        data["totalSellPrice"] = this.totalSellPrice;
        data["minSellPrice"] = this.minSellPrice;
        data["maxSellPrice"] = this.maxSellPrice;
        data["branchID"] = this.branchID;
        data["customerID"] = this.customerID;
        data["customerAddressID"] = this.customerAddressID;
        data["documentPresentation"] = this.documentPresentation;
        data["manufactured"] = this.manufactured;
        data["manufacturedProductID"] = this.manufacturedProductID;
        data["setDescriptionFromLinesShortDescriptions"] = this.setDescriptionFromLinesShortDescriptions;
        data["alwaysUseSellPriceOfFinishedItem"] = this.alwaysUseSellPriceOfFinishedItem;
        data["promptForFinishedProduct"] = this.promptForFinishedProduct;
        data["combineManKitsonWO"] = this.combineManKitsonWO;
        data["purchased"] = this.purchased;
        data["purchaseProductID"] = this.purchaseProductID;
        data["fractionalMultiplierOption"] = this.fractionalMultiplierOption;
        return data; 
    }
}

export interface IProductKitConfigurator {
    productID?: number | undefined;
    documentDescription?: string | undefined;
    totalSellPrice?: number | undefined;
    minSellPrice?: number | undefined;
    maxSellPrice?: number | undefined;
    branchID?: number | undefined;
    customerID?: number | undefined;
    customerAddressID?: number | undefined;
    documentPresentation?: number | undefined;
    manufactured?: boolean | undefined;
    manufacturedProductID?: number | undefined;
    setDescriptionFromLinesShortDescriptions?: boolean | undefined;
    alwaysUseSellPriceOfFinishedItem?: boolean | undefined;
    promptForFinishedProduct?: boolean | undefined;
    combineManKitsonWO?: boolean | undefined;
    purchased?: boolean | undefined;
    purchaseProductID?: number | undefined;
    fractionalMultiplierOption?: number | undefined;
}

export class KitProductLineChoices implements IKitProductLineChoices {
    kitProductLines?: Node[] | undefined;
    productKitLineRules?: ProductKitConfiguratorLineRule[][] | undefined;
    productKitLineOptions?: ProductKitConfiguratorLineOption[][] | undefined;
    stocks?: KitProductStock[][] | undefined;
    productStockOptions?: KitProductStockOption[][] | undefined;
    productKitImages?: ProductConfiguratorImages[][] | undefined;

    constructor(data?: IKitProductLineChoices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["kitProductLines"])) {
                this.kitProductLines = [] as any;
                for (let item of _data["kitProductLines"])
                    this.kitProductLines!.push(Node.fromJS(item));
            }
            if (Array.isArray(_data["productKitLineRules"])) {
                this.productKitLineRules = [] as any;
                for (let item of _data["productKitLineRules"])
                    this.productKitLineRules!.push(item);
            }
            if (Array.isArray(_data["productKitLineOptions"])) {
                this.productKitLineOptions = [] as any;
                for (let item of _data["productKitLineOptions"])
                    this.productKitLineOptions!.push(item);
            }
            if (Array.isArray(_data["stocks"])) {
                this.stocks = [] as any;
                for (let item of _data["stocks"])
                    this.stocks!.push(item);
            }
            if (Array.isArray(_data["productStockOptions"])) {
                this.productStockOptions = [] as any;
                for (let item of _data["productStockOptions"])
                    this.productStockOptions!.push(item);
            }
            if (Array.isArray(_data["productKitImages"])) {
                this.productKitImages = [] as any;
                for (let item of _data["productKitImages"])
                    this.productKitImages!.push(item);
            }
        }
    }

    static fromJS(data: any): KitProductLineChoices {
        data = typeof data === 'object' ? data : {};
        let result = new KitProductLineChoices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.kitProductLines)) {
            data["kitProductLines"] = [];
            for (let item of this.kitProductLines)
                data["kitProductLines"].push(item.toJSON());
        }
        if (Array.isArray(this.productKitLineRules)) {
            data["productKitLineRules"] = [];
            for (let item of this.productKitLineRules)
                data["productKitLineRules"].push(item);
        }
        if (Array.isArray(this.productKitLineOptions)) {
            data["productKitLineOptions"] = [];
            for (let item of this.productKitLineOptions)
                data["productKitLineOptions"].push(item);
        }
        if (Array.isArray(this.stocks)) {
            data["stocks"] = [];
            for (let item of this.stocks)
                data["stocks"].push(item);
        }
        if (Array.isArray(this.productStockOptions)) {
            data["productStockOptions"] = [];
            for (let item of this.productStockOptions)
                data["productStockOptions"].push(item);
        }
        if (Array.isArray(this.productKitImages)) {
            data["productKitImages"] = [];
            for (let item of this.productKitImages)
                data["productKitImages"].push(item);
        }
        return data; 
    }
}

export interface IKitProductLineChoices {
    kitProductLines?: Node[] | undefined;
    productKitLineRules?: ProductKitConfiguratorLineRule[][] | undefined;
    productKitLineOptions?: ProductKitConfiguratorLineOption[][] | undefined;
    stocks?: KitProductStock[][] | undefined;
    productStockOptions?: KitProductStockOption[][] | undefined;
    productKitImages?: ProductConfiguratorImages[][] | undefined;
}

export class ProductKitConfiguratorManufacturedProcess implements IProductKitConfiguratorManufacturedProcess {
    productKitManufacturedProcessID?: number | undefined;
    productID?: number | undefined;
    avoid?: number | undefined;
    avoOptionID?: number | undefined;
    kitCosted?: boolean | undefined;
    costPrice?: number | undefined;
    costPerID?: number | undefined;
    totalCostPriceBasedOn?: number | undefined;
    kitPriced?: boolean | undefined;
    sellPrice?: number | undefined;
    sellPerID?: number | undefined;
    totalSellPriceBasedOn?: number | undefined;
    oneTimeFee?: boolean | undefined;
    minimumCost?: number | undefined;
    minimumSell?: number | undefined;
    lineNumber?: number | undefined;

    constructor(data?: IProductKitConfiguratorManufacturedProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKitManufacturedProcessID = _data["productKitManufacturedProcessID"];
            this.productID = _data["productID"];
            this.avoid = _data["avoid"];
            this.avoOptionID = _data["avoOptionID"];
            this.kitCosted = _data["kitCosted"];
            this.costPrice = _data["costPrice"];
            this.costPerID = _data["costPerID"];
            this.totalCostPriceBasedOn = _data["totalCostPriceBasedOn"];
            this.kitPriced = _data["kitPriced"];
            this.sellPrice = _data["sellPrice"];
            this.sellPerID = _data["sellPerID"];
            this.totalSellPriceBasedOn = _data["totalSellPriceBasedOn"];
            this.oneTimeFee = _data["oneTimeFee"];
            this.minimumCost = _data["minimumCost"];
            this.minimumSell = _data["minimumSell"];
            this.lineNumber = _data["lineNumber"];
        }
    }

    static fromJS(data: any): ProductKitConfiguratorManufacturedProcess {
        data = typeof data === 'object' ? data : {};
        let result = new ProductKitConfiguratorManufacturedProcess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKitManufacturedProcessID"] = this.productKitManufacturedProcessID;
        data["productID"] = this.productID;
        data["avoid"] = this.avoid;
        data["avoOptionID"] = this.avoOptionID;
        data["kitCosted"] = this.kitCosted;
        data["costPrice"] = this.costPrice;
        data["costPerID"] = this.costPerID;
        data["totalCostPriceBasedOn"] = this.totalCostPriceBasedOn;
        data["kitPriced"] = this.kitPriced;
        data["sellPrice"] = this.sellPrice;
        data["sellPerID"] = this.sellPerID;
        data["totalSellPriceBasedOn"] = this.totalSellPriceBasedOn;
        data["oneTimeFee"] = this.oneTimeFee;
        data["minimumCost"] = this.minimumCost;
        data["minimumSell"] = this.minimumSell;
        data["lineNumber"] = this.lineNumber;
        return data; 
    }
}

export interface IProductKitConfiguratorManufacturedProcess {
    productKitManufacturedProcessID?: number | undefined;
    productID?: number | undefined;
    avoid?: number | undefined;
    avoOptionID?: number | undefined;
    kitCosted?: boolean | undefined;
    costPrice?: number | undefined;
    costPerID?: number | undefined;
    totalCostPriceBasedOn?: number | undefined;
    kitPriced?: boolean | undefined;
    sellPrice?: number | undefined;
    sellPerID?: number | undefined;
    totalSellPriceBasedOn?: number | undefined;
    oneTimeFee?: boolean | undefined;
    minimumCost?: number | undefined;
    minimumSell?: number | undefined;
    lineNumber?: number | undefined;
}

export class Node implements INode {
    type?: number | undefined;
    choices?: Node[] | undefined;
    kitProduct?: KitProduct | undefined;
    kitText?: KitText | undefined;
    kitChoiceStart?: KitChoiceStart | undefined;
    kitNoChoice?: KitNoChoice | undefined;
    kitPriceGroup?: KitPriceGroup | undefined;
    kitSectionStart?: KitSectionStart | undefined;
    kitSectionEnd?: KitSectionEnd | undefined;

    constructor(data?: INode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(Node.fromJS(item));
            }
            this.kitProduct = _data["kitProduct"] ? KitProduct.fromJS(_data["kitProduct"]) : <any>undefined;
            this.kitText = _data["kitText"] ? KitText.fromJS(_data["kitText"]) : <any>undefined;
            this.kitChoiceStart = _data["kitChoiceStart"] ? KitChoiceStart.fromJS(_data["kitChoiceStart"]) : <any>undefined;
            this.kitNoChoice = _data["kitNoChoice"] ? KitNoChoice.fromJS(_data["kitNoChoice"]) : <any>undefined;
            this.kitPriceGroup = _data["kitPriceGroup"] ? KitPriceGroup.fromJS(_data["kitPriceGroup"]) : <any>undefined;
            this.kitSectionStart = _data["kitSectionStart"] ? KitSectionStart.fromJS(_data["kitSectionStart"]) : <any>undefined;
            this.kitSectionEnd = _data["kitSectionEnd"] ? KitSectionEnd.fromJS(_data["kitSectionEnd"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Node {
        data = typeof data === 'object' ? data : {};
        let result = new Node();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        data["kitProduct"] = this.kitProduct ? this.kitProduct.toJSON() : <any>undefined;
        data["kitText"] = this.kitText ? this.kitText.toJSON() : <any>undefined;
        data["kitChoiceStart"] = this.kitChoiceStart ? this.kitChoiceStart.toJSON() : <any>undefined;
        data["kitNoChoice"] = this.kitNoChoice ? this.kitNoChoice.toJSON() : <any>undefined;
        data["kitPriceGroup"] = this.kitPriceGroup ? this.kitPriceGroup.toJSON() : <any>undefined;
        data["kitSectionStart"] = this.kitSectionStart ? this.kitSectionStart.toJSON() : <any>undefined;
        data["kitSectionEnd"] = this.kitSectionEnd ? this.kitSectionEnd.toJSON() : <any>undefined;
        return data; 
    }
}

export interface INode {
    type?: number | undefined;
    choices?: Node[] | undefined;
    kitProduct?: KitProduct | undefined;
    kitText?: KitText | undefined;
    kitChoiceStart?: KitChoiceStart | undefined;
    kitNoChoice?: KitNoChoice | undefined;
    kitPriceGroup?: KitPriceGroup | undefined;
    kitSectionStart?: KitSectionStart | undefined;
    kitSectionEnd?: KitSectionEnd | undefined;
}

export class ProductKitConfiguratorLineRule implements IProductKitConfiguratorLineRule {
    kitLineRuleID?: number | undefined;
    productKitLineID?: number | undefined;
    lineNumber?: number | undefined;
    andOr?: number | undefined;
    choiceProductKitLineID?: number | undefined;
    ruleIs?: boolean | undefined;

    constructor(data?: IProductKitConfiguratorLineRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kitLineRuleID = _data["kitLineRuleID"];
            this.productKitLineID = _data["productKitLineID"];
            this.lineNumber = _data["lineNumber"];
            this.andOr = _data["andOr"];
            this.choiceProductKitLineID = _data["choiceProductKitLineID"];
            this.ruleIs = _data["ruleIs"];
        }
    }

    static fromJS(data: any): ProductKitConfiguratorLineRule {
        data = typeof data === 'object' ? data : {};
        let result = new ProductKitConfiguratorLineRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kitLineRuleID"] = this.kitLineRuleID;
        data["productKitLineID"] = this.productKitLineID;
        data["lineNumber"] = this.lineNumber;
        data["andOr"] = this.andOr;
        data["choiceProductKitLineID"] = this.choiceProductKitLineID;
        data["ruleIs"] = this.ruleIs;
        return data; 
    }
}

export interface IProductKitConfiguratorLineRule {
    kitLineRuleID?: number | undefined;
    productKitLineID?: number | undefined;
    lineNumber?: number | undefined;
    andOr?: number | undefined;
    choiceProductKitLineID?: number | undefined;
    ruleIs?: boolean | undefined;
}

export class ProductKitConfiguratorLineOption implements IProductKitConfiguratorLineOption {
    kitLineOptionID?: number | undefined;
    kitLineRuleID?: number | undefined;
    productKitLineID?: number | undefined;
    optionProductKitLineID?: number | undefined;

    constructor(data?: IProductKitConfiguratorLineOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kitLineOptionID = _data["kitLineOptionID"];
            this.kitLineRuleID = _data["kitLineRuleID"];
            this.productKitLineID = _data["productKitLineID"];
            this.optionProductKitLineID = _data["optionProductKitLineID"];
        }
    }

    static fromJS(data: any): ProductKitConfiguratorLineOption {
        data = typeof data === 'object' ? data : {};
        let result = new ProductKitConfiguratorLineOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kitLineOptionID"] = this.kitLineOptionID;
        data["kitLineRuleID"] = this.kitLineRuleID;
        data["productKitLineID"] = this.productKitLineID;
        data["optionProductKitLineID"] = this.optionProductKitLineID;
        return data; 
    }
}

export interface IProductKitConfiguratorLineOption {
    kitLineOptionID?: number | undefined;
    kitLineRuleID?: number | undefined;
    productKitLineID?: number | undefined;
    optionProductKitLineID?: number | undefined;
}

export class KitProductStock implements IKitProductStock {
    productID?: number | undefined;
    branchID?: number | undefined;
    stockLocationID?: number | undefined;
    stockActual?: number | undefined;
    stockAvailable?: number | undefined;
    stockOnOrder?: number | undefined;
    stockDue?: number | undefined;
    stockAllocated?: number | undefined;
    stockReserved?: number | undefined;
    stockSuspense?: number | undefined;
    stockThirdParty?: number | undefined;
    stockAwaitingProcess?: number | undefined;
    stockAwaitingProcessNotAvailable?: number | undefined;
    stockPerID?: number | undefined;
    stockPerCode?: Per | undefined;

    constructor(data?: IKitProductStock) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productID = _data["productID"];
            this.branchID = _data["branchID"];
            this.stockLocationID = _data["stockLocationID"];
            this.stockActual = _data["stockActual"];
            this.stockAvailable = _data["stockAvailable"];
            this.stockOnOrder = _data["stockOnOrder"];
            this.stockDue = _data["stockDue"];
            this.stockAllocated = _data["stockAllocated"];
            this.stockReserved = _data["stockReserved"];
            this.stockSuspense = _data["stockSuspense"];
            this.stockThirdParty = _data["stockThirdParty"];
            this.stockAwaitingProcess = _data["stockAwaitingProcess"];
            this.stockAwaitingProcessNotAvailable = _data["stockAwaitingProcessNotAvailable"];
            this.stockPerID = _data["stockPerID"];
            this.stockPerCode = _data["stockPerCode"] ? Per.fromJS(_data["stockPerCode"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KitProductStock {
        data = typeof data === 'object' ? data : {};
        let result = new KitProductStock();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productID"] = this.productID;
        data["branchID"] = this.branchID;
        data["stockLocationID"] = this.stockLocationID;
        data["stockActual"] = this.stockActual;
        data["stockAvailable"] = this.stockAvailable;
        data["stockOnOrder"] = this.stockOnOrder;
        data["stockDue"] = this.stockDue;
        data["stockAllocated"] = this.stockAllocated;
        data["stockReserved"] = this.stockReserved;
        data["stockSuspense"] = this.stockSuspense;
        data["stockThirdParty"] = this.stockThirdParty;
        data["stockAwaitingProcess"] = this.stockAwaitingProcess;
        data["stockAwaitingProcessNotAvailable"] = this.stockAwaitingProcessNotAvailable;
        data["stockPerID"] = this.stockPerID;
        data["stockPerCode"] = this.stockPerCode ? this.stockPerCode.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IKitProductStock {
    productID?: number | undefined;
    branchID?: number | undefined;
    stockLocationID?: number | undefined;
    stockActual?: number | undefined;
    stockAvailable?: number | undefined;
    stockOnOrder?: number | undefined;
    stockDue?: number | undefined;
    stockAllocated?: number | undefined;
    stockReserved?: number | undefined;
    stockSuspense?: number | undefined;
    stockThirdParty?: number | undefined;
    stockAwaitingProcess?: number | undefined;
    stockAwaitingProcessNotAvailable?: number | undefined;
    stockPerID?: number | undefined;
    stockPerCode?: Per | undefined;
}

export class KitProductStockOption implements IKitProductStockOption {
    productID?: number | undefined;
    branchID?: number | undefined;
    stocked?: boolean | undefined;
    stockClass?: string | undefined;
    howSourced?: number | undefined;
    transferBranchID?: number | undefined;
    manufactureBranchID?: number | undefined;
    purchaseAndTransferBranchID?: number | undefined;
    leadTime?: number | undefined;
    weeksCover?: number | undefined;
    stockLevelMin?: number | undefined;
    stockLevelMax?: number | undefined;
    shelfLife?: number | undefined;
    stockCountGroup?: string | undefined;
    binLocation?: string | undefined;
    commissionCodeID?: number | undefined;
    productManagerID?: number | undefined;
    pickingZone?: string | undefined;
    dateTimeLastCounted?: Date | undefined;
    dateLastAged?: Date | undefined;
    averageAge?: number | undefined;
    stockCountID?: number | undefined;
    stockCountLineNumber?: number | undefined;
    fullStockTurn?: number | undefined;
    fullStockAge?: number | undefined;
    gmroi?: number | undefined;
    periodsAnalysed?: number | undefined;
    standardPurchase?: boolean | undefined;
    defaultLabelTemplateID?: number | undefined;
    useMemoQuantityInput?: boolean | undefined;
    useActualCostForPacks?: boolean | undefined;
    packsAreTagged?: boolean | undefined;
    keepUntaggedPackRecords?: boolean | undefined;
    packPurchasing?: number | undefined;
    packSelling?: number | undefined;
    productBatchTypeID?: number | undefined;
    vmi?: boolean | undefined;
    dateFirstStocked?: Date | undefined;
    sellingQuantityBreakID?: number | undefined;
    pickingRequired?: boolean | undefined;
    allowSettlementDiscount?: boolean | undefined;
    skipStockWarning?: boolean | undefined;
    priceSensitivityID?: number | undefined;
    quickTallyAVOID?: number | undefined;
    quickTallyAVOOptionID?: number | undefined;
    quickTallyAVOProductionTimeMultiplier?: number | undefined;
    quickTallyAVOPriceMultiplier?: number | undefined;
    inputPerID?: number | undefined;
    seasonalityID?: number | undefined;
    averageValuation?: number | undefined;
    orderEntryManufacturedKitID?: number | undefined;
    sellPriceRounding?: number | undefined;
    sellPriceRoundingOption?: number | undefined;
    sellPriceRoundingPerID?: number | undefined;

    constructor(data?: IKitProductStockOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productID = _data["productID"];
            this.branchID = _data["branchID"];
            this.stocked = _data["stocked"];
            this.stockClass = _data["stockClass"];
            this.howSourced = _data["howSourced"];
            this.transferBranchID = _data["transferBranchID"];
            this.manufactureBranchID = _data["manufactureBranchID"];
            this.purchaseAndTransferBranchID = _data["purchaseAndTransferBranchID"];
            this.leadTime = _data["leadTime"];
            this.weeksCover = _data["weeksCover"];
            this.stockLevelMin = _data["stockLevelMin"];
            this.stockLevelMax = _data["stockLevelMax"];
            this.shelfLife = _data["shelfLife"];
            this.stockCountGroup = _data["stockCountGroup"];
            this.binLocation = _data["binLocation"];
            this.commissionCodeID = _data["commissionCodeID"];
            this.productManagerID = _data["productManagerID"];
            this.pickingZone = _data["pickingZone"];
            this.dateTimeLastCounted = _data["dateTimeLastCounted"] ? new Date(_data["dateTimeLastCounted"].toString()) : <any>undefined;
            this.dateLastAged = _data["dateLastAged"] ? new Date(_data["dateLastAged"].toString()) : <any>undefined;
            this.averageAge = _data["averageAge"];
            this.stockCountID = _data["stockCountID"];
            this.stockCountLineNumber = _data["stockCountLineNumber"];
            this.fullStockTurn = _data["fullStockTurn"];
            this.fullStockAge = _data["fullStockAge"];
            this.gmroi = _data["gmroi"];
            this.periodsAnalysed = _data["periodsAnalysed"];
            this.standardPurchase = _data["standardPurchase"];
            this.defaultLabelTemplateID = _data["defaultLabelTemplateID"];
            this.useMemoQuantityInput = _data["useMemoQuantityInput"];
            this.useActualCostForPacks = _data["useActualCostForPacks"];
            this.packsAreTagged = _data["packsAreTagged"];
            this.keepUntaggedPackRecords = _data["keepUntaggedPackRecords"];
            this.packPurchasing = _data["packPurchasing"];
            this.packSelling = _data["packSelling"];
            this.productBatchTypeID = _data["productBatchTypeID"];
            this.vmi = _data["vmi"];
            this.dateFirstStocked = _data["dateFirstStocked"] ? new Date(_data["dateFirstStocked"].toString()) : <any>undefined;
            this.sellingQuantityBreakID = _data["sellingQuantityBreakID"];
            this.pickingRequired = _data["pickingRequired"];
            this.allowSettlementDiscount = _data["allowSettlementDiscount"];
            this.skipStockWarning = _data["skipStockWarning"];
            this.priceSensitivityID = _data["priceSensitivityID"];
            this.quickTallyAVOID = _data["quickTallyAVOID"];
            this.quickTallyAVOOptionID = _data["quickTallyAVOOptionID"];
            this.quickTallyAVOProductionTimeMultiplier = _data["quickTallyAVOProductionTimeMultiplier"];
            this.quickTallyAVOPriceMultiplier = _data["quickTallyAVOPriceMultiplier"];
            this.inputPerID = _data["inputPerID"];
            this.seasonalityID = _data["seasonalityID"];
            this.averageValuation = _data["averageValuation"];
            this.orderEntryManufacturedKitID = _data["orderEntryManufacturedKitID"];
            this.sellPriceRounding = _data["sellPriceRounding"];
            this.sellPriceRoundingOption = _data["sellPriceRoundingOption"];
            this.sellPriceRoundingPerID = _data["sellPriceRoundingPerID"];
        }
    }

    static fromJS(data: any): KitProductStockOption {
        data = typeof data === 'object' ? data : {};
        let result = new KitProductStockOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productID"] = this.productID;
        data["branchID"] = this.branchID;
        data["stocked"] = this.stocked;
        data["stockClass"] = this.stockClass;
        data["howSourced"] = this.howSourced;
        data["transferBranchID"] = this.transferBranchID;
        data["manufactureBranchID"] = this.manufactureBranchID;
        data["purchaseAndTransferBranchID"] = this.purchaseAndTransferBranchID;
        data["leadTime"] = this.leadTime;
        data["weeksCover"] = this.weeksCover;
        data["stockLevelMin"] = this.stockLevelMin;
        data["stockLevelMax"] = this.stockLevelMax;
        data["shelfLife"] = this.shelfLife;
        data["stockCountGroup"] = this.stockCountGroup;
        data["binLocation"] = this.binLocation;
        data["commissionCodeID"] = this.commissionCodeID;
        data["productManagerID"] = this.productManagerID;
        data["pickingZone"] = this.pickingZone;
        data["dateTimeLastCounted"] = this.dateTimeLastCounted ? this.dateTimeLastCounted.toISOString() : <any>undefined;
        data["dateLastAged"] = this.dateLastAged ? this.dateLastAged.toISOString() : <any>undefined;
        data["averageAge"] = this.averageAge;
        data["stockCountID"] = this.stockCountID;
        data["stockCountLineNumber"] = this.stockCountLineNumber;
        data["fullStockTurn"] = this.fullStockTurn;
        data["fullStockAge"] = this.fullStockAge;
        data["gmroi"] = this.gmroi;
        data["periodsAnalysed"] = this.periodsAnalysed;
        data["standardPurchase"] = this.standardPurchase;
        data["defaultLabelTemplateID"] = this.defaultLabelTemplateID;
        data["useMemoQuantityInput"] = this.useMemoQuantityInput;
        data["useActualCostForPacks"] = this.useActualCostForPacks;
        data["packsAreTagged"] = this.packsAreTagged;
        data["keepUntaggedPackRecords"] = this.keepUntaggedPackRecords;
        data["packPurchasing"] = this.packPurchasing;
        data["packSelling"] = this.packSelling;
        data["productBatchTypeID"] = this.productBatchTypeID;
        data["vmi"] = this.vmi;
        data["dateFirstStocked"] = this.dateFirstStocked ? this.dateFirstStocked.toISOString() : <any>undefined;
        data["sellingQuantityBreakID"] = this.sellingQuantityBreakID;
        data["pickingRequired"] = this.pickingRequired;
        data["allowSettlementDiscount"] = this.allowSettlementDiscount;
        data["skipStockWarning"] = this.skipStockWarning;
        data["priceSensitivityID"] = this.priceSensitivityID;
        data["quickTallyAVOID"] = this.quickTallyAVOID;
        data["quickTallyAVOOptionID"] = this.quickTallyAVOOptionID;
        data["quickTallyAVOProductionTimeMultiplier"] = this.quickTallyAVOProductionTimeMultiplier;
        data["quickTallyAVOPriceMultiplier"] = this.quickTallyAVOPriceMultiplier;
        data["inputPerID"] = this.inputPerID;
        data["seasonalityID"] = this.seasonalityID;
        data["averageValuation"] = this.averageValuation;
        data["orderEntryManufacturedKitID"] = this.orderEntryManufacturedKitID;
        data["sellPriceRounding"] = this.sellPriceRounding;
        data["sellPriceRoundingOption"] = this.sellPriceRoundingOption;
        data["sellPriceRoundingPerID"] = this.sellPriceRoundingPerID;
        return data; 
    }
}

export interface IKitProductStockOption {
    productID?: number | undefined;
    branchID?: number | undefined;
    stocked?: boolean | undefined;
    stockClass?: string | undefined;
    howSourced?: number | undefined;
    transferBranchID?: number | undefined;
    manufactureBranchID?: number | undefined;
    purchaseAndTransferBranchID?: number | undefined;
    leadTime?: number | undefined;
    weeksCover?: number | undefined;
    stockLevelMin?: number | undefined;
    stockLevelMax?: number | undefined;
    shelfLife?: number | undefined;
    stockCountGroup?: string | undefined;
    binLocation?: string | undefined;
    commissionCodeID?: number | undefined;
    productManagerID?: number | undefined;
    pickingZone?: string | undefined;
    dateTimeLastCounted?: Date | undefined;
    dateLastAged?: Date | undefined;
    averageAge?: number | undefined;
    stockCountID?: number | undefined;
    stockCountLineNumber?: number | undefined;
    fullStockTurn?: number | undefined;
    fullStockAge?: number | undefined;
    gmroi?: number | undefined;
    periodsAnalysed?: number | undefined;
    standardPurchase?: boolean | undefined;
    defaultLabelTemplateID?: number | undefined;
    useMemoQuantityInput?: boolean | undefined;
    useActualCostForPacks?: boolean | undefined;
    packsAreTagged?: boolean | undefined;
    keepUntaggedPackRecords?: boolean | undefined;
    packPurchasing?: number | undefined;
    packSelling?: number | undefined;
    productBatchTypeID?: number | undefined;
    vmi?: boolean | undefined;
    dateFirstStocked?: Date | undefined;
    sellingQuantityBreakID?: number | undefined;
    pickingRequired?: boolean | undefined;
    allowSettlementDiscount?: boolean | undefined;
    skipStockWarning?: boolean | undefined;
    priceSensitivityID?: number | undefined;
    quickTallyAVOID?: number | undefined;
    quickTallyAVOOptionID?: number | undefined;
    quickTallyAVOProductionTimeMultiplier?: number | undefined;
    quickTallyAVOPriceMultiplier?: number | undefined;
    inputPerID?: number | undefined;
    seasonalityID?: number | undefined;
    averageValuation?: number | undefined;
    orderEntryManufacturedKitID?: number | undefined;
    sellPriceRounding?: number | undefined;
    sellPriceRoundingOption?: number | undefined;
    sellPriceRoundingPerID?: number | undefined;
}

export class ProductConfiguratorImages implements IProductConfiguratorImages {
    productID?: number | undefined;
    imageNumber?: number | undefined;

    constructor(data?: IProductConfiguratorImages) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productID = _data["productID"];
            this.imageNumber = _data["imageNumber"];
        }
    }

    static fromJS(data: any): ProductConfiguratorImages {
        data = typeof data === 'object' ? data : {};
        let result = new ProductConfiguratorImages();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productID"] = this.productID;
        data["imageNumber"] = this.imageNumber;
        return data; 
    }
}

export interface IProductConfiguratorImages {
    productID?: number | undefined;
    imageNumber?: number | undefined;
}

export class KitProduct implements IKitProduct {
    productKitLineID?: number | undefined;
    productID?: number | undefined;
    productCode?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    quantity?: number | undefined;
    inputPerID?: number | undefined;
    inputPer?: Per | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    unitSellPrice?: number | undefined;
    totalSellPrice?: number | undefined;
    discount1?: number | undefined;
    discountAmount1?: number | undefined;
    discount2?: number | undefined;
    discountAmount2?: number | undefined;
    pricingType?: number | undefined;
    perID?: number | undefined;
    per?: Per | undefined;
    sellPriceType?: number | undefined;
    notes?: string | undefined;
    specialInstructions?: string | undefined;
    isChoiceLine?: boolean | undefined;
    defaultChoice?: boolean | undefined;
    choiceAdditionalCharge?: number | undefined;
    copyLineToOrder?: boolean | undefined;
    manualCode?: string | undefined;
    manualDescription?: string | undefined;
    autoCreateSpecialProduct?: boolean | undefined;
    promptForProduct?: boolean | undefined;
    timeAppliesToProcessID?: number | undefined;
    productionTime?: number | undefined;
    allowKitScreenQuantityEntry?: boolean | undefined;
    sellPriceGroupID?: number | undefined;
    sectionStartOrderLineID?: number | undefined;
    orderSectionID?: number | undefined;
    sectionSubtotal?: boolean | undefined;
    appliesToProductKitAVOID?: number | undefined;
    excludeFromMultiplier?: boolean | undefined;
    quantityFormula?: string | undefined;
    kitChoiceTypeID?: number | undefined;
    inheritFromChoiceType?: boolean | undefined;
    hideOnWorksOrder?: boolean | undefined;
    lineNotesRequired?: boolean | undefined;

    constructor(data?: IKitProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKitLineID = _data["productKitLineID"];
            this.productID = _data["productID"];
            this.productCode = _data["productCode"];
            this.description = _data["description"];
            this.shortDescription = _data["shortDescription"];
            this.fullDescription = _data["fullDescription"];
            this.lineNumber = _data["lineNumber"];
            this.lineType = _data["lineType"];
            this.quantity = _data["quantity"];
            this.inputPerID = _data["inputPerID"];
            this.inputPer = _data["inputPer"] ? Per.fromJS(_data["inputPer"]) : <any>undefined;
            this.quantityTally = _data["quantityTally"];
            this.noOfPieces = _data["noOfPieces"];
            this.totalWeight = _data["totalWeight"];
            this.totalLength = _data["totalLength"];
            this.totalVolume = _data["totalVolume"];
            this.unitSellPrice = _data["unitSellPrice"];
            this.totalSellPrice = _data["totalSellPrice"];
            this.discount1 = _data["discount1"];
            this.discountAmount1 = _data["discountAmount1"];
            this.discount2 = _data["discount2"];
            this.discountAmount2 = _data["discountAmount2"];
            this.pricingType = _data["pricingType"];
            this.perID = _data["perID"];
            this.per = _data["per"] ? Per.fromJS(_data["per"]) : <any>undefined;
            this.sellPriceType = _data["sellPriceType"];
            this.notes = _data["notes"];
            this.specialInstructions = _data["specialInstructions"];
            this.isChoiceLine = _data["isChoiceLine"];
            this.defaultChoice = _data["defaultChoice"];
            this.choiceAdditionalCharge = _data["choiceAdditionalCharge"];
            this.copyLineToOrder = _data["copyLineToOrder"];
            this.manualCode = _data["manualCode"];
            this.manualDescription = _data["manualDescription"];
            this.autoCreateSpecialProduct = _data["autoCreateSpecialProduct"];
            this.promptForProduct = _data["promptForProduct"];
            this.timeAppliesToProcessID = _data["timeAppliesToProcessID"];
            this.productionTime = _data["productionTime"];
            this.allowKitScreenQuantityEntry = _data["allowKitScreenQuantityEntry"];
            this.sellPriceGroupID = _data["sellPriceGroupID"];
            this.sectionStartOrderLineID = _data["sectionStartOrderLineID"];
            this.orderSectionID = _data["orderSectionID"];
            this.sectionSubtotal = _data["sectionSubtotal"];
            this.appliesToProductKitAVOID = _data["appliesToProductKitAVOID"];
            this.excludeFromMultiplier = _data["excludeFromMultiplier"];
            this.quantityFormula = _data["quantityFormula"];
            this.kitChoiceTypeID = _data["kitChoiceTypeID"];
            this.inheritFromChoiceType = _data["inheritFromChoiceType"];
            this.hideOnWorksOrder = _data["hideOnWorksOrder"];
            this.lineNotesRequired = _data["lineNotesRequired"];
        }
    }

    static fromJS(data: any): KitProduct {
        data = typeof data === 'object' ? data : {};
        let result = new KitProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKitLineID"] = this.productKitLineID;
        data["productID"] = this.productID;
        data["productCode"] = this.productCode;
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["fullDescription"] = this.fullDescription;
        data["lineNumber"] = this.lineNumber;
        data["lineType"] = this.lineType;
        data["quantity"] = this.quantity;
        data["inputPerID"] = this.inputPerID;
        data["inputPer"] = this.inputPer ? this.inputPer.toJSON() : <any>undefined;
        data["quantityTally"] = this.quantityTally;
        data["noOfPieces"] = this.noOfPieces;
        data["totalWeight"] = this.totalWeight;
        data["totalLength"] = this.totalLength;
        data["totalVolume"] = this.totalVolume;
        data["unitSellPrice"] = this.unitSellPrice;
        data["totalSellPrice"] = this.totalSellPrice;
        data["discount1"] = this.discount1;
        data["discountAmount1"] = this.discountAmount1;
        data["discount2"] = this.discount2;
        data["discountAmount2"] = this.discountAmount2;
        data["pricingType"] = this.pricingType;
        data["perID"] = this.perID;
        data["per"] = this.per ? this.per.toJSON() : <any>undefined;
        data["sellPriceType"] = this.sellPriceType;
        data["notes"] = this.notes;
        data["specialInstructions"] = this.specialInstructions;
        data["isChoiceLine"] = this.isChoiceLine;
        data["defaultChoice"] = this.defaultChoice;
        data["choiceAdditionalCharge"] = this.choiceAdditionalCharge;
        data["copyLineToOrder"] = this.copyLineToOrder;
        data["manualCode"] = this.manualCode;
        data["manualDescription"] = this.manualDescription;
        data["autoCreateSpecialProduct"] = this.autoCreateSpecialProduct;
        data["promptForProduct"] = this.promptForProduct;
        data["timeAppliesToProcessID"] = this.timeAppliesToProcessID;
        data["productionTime"] = this.productionTime;
        data["allowKitScreenQuantityEntry"] = this.allowKitScreenQuantityEntry;
        data["sellPriceGroupID"] = this.sellPriceGroupID;
        data["sectionStartOrderLineID"] = this.sectionStartOrderLineID;
        data["orderSectionID"] = this.orderSectionID;
        data["sectionSubtotal"] = this.sectionSubtotal;
        data["appliesToProductKitAVOID"] = this.appliesToProductKitAVOID;
        data["excludeFromMultiplier"] = this.excludeFromMultiplier;
        data["quantityFormula"] = this.quantityFormula;
        data["kitChoiceTypeID"] = this.kitChoiceTypeID;
        data["inheritFromChoiceType"] = this.inheritFromChoiceType;
        data["hideOnWorksOrder"] = this.hideOnWorksOrder;
        data["lineNotesRequired"] = this.lineNotesRequired;
        return data; 
    }
}

export interface IKitProduct {
    productKitLineID?: number | undefined;
    productID?: number | undefined;
    productCode?: string | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    quantity?: number | undefined;
    inputPerID?: number | undefined;
    inputPer?: Per | undefined;
    quantityTally?: string | undefined;
    noOfPieces?: number | undefined;
    totalWeight?: number | undefined;
    totalLength?: number | undefined;
    totalVolume?: number | undefined;
    unitSellPrice?: number | undefined;
    totalSellPrice?: number | undefined;
    discount1?: number | undefined;
    discountAmount1?: number | undefined;
    discount2?: number | undefined;
    discountAmount2?: number | undefined;
    pricingType?: number | undefined;
    perID?: number | undefined;
    per?: Per | undefined;
    sellPriceType?: number | undefined;
    notes?: string | undefined;
    specialInstructions?: string | undefined;
    isChoiceLine?: boolean | undefined;
    defaultChoice?: boolean | undefined;
    choiceAdditionalCharge?: number | undefined;
    copyLineToOrder?: boolean | undefined;
    manualCode?: string | undefined;
    manualDescription?: string | undefined;
    autoCreateSpecialProduct?: boolean | undefined;
    promptForProduct?: boolean | undefined;
    timeAppliesToProcessID?: number | undefined;
    productionTime?: number | undefined;
    allowKitScreenQuantityEntry?: boolean | undefined;
    sellPriceGroupID?: number | undefined;
    sectionStartOrderLineID?: number | undefined;
    orderSectionID?: number | undefined;
    sectionSubtotal?: boolean | undefined;
    appliesToProductKitAVOID?: number | undefined;
    excludeFromMultiplier?: boolean | undefined;
    quantityFormula?: string | undefined;
    kitChoiceTypeID?: number | undefined;
    inheritFromChoiceType?: boolean | undefined;
    hideOnWorksOrder?: boolean | undefined;
    lineNotesRequired?: boolean | undefined;
}

export class KitText implements IKitText {
    productKitLineID?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    quantity?: number | undefined;
    isChoiceLine?: boolean | undefined;
    defaultChoice?: boolean | undefined;

    constructor(data?: IKitText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKitLineID = _data["productKitLineID"];
            this.description = _data["description"];
            this.shortDescription = _data["shortDescription"];
            this.fullDescription = _data["fullDescription"];
            this.lineNumber = _data["lineNumber"];
            this.lineType = _data["lineType"];
            this.quantity = _data["quantity"];
            this.isChoiceLine = _data["isChoiceLine"];
            this.defaultChoice = _data["defaultChoice"];
        }
    }

    static fromJS(data: any): KitText {
        data = typeof data === 'object' ? data : {};
        let result = new KitText();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKitLineID"] = this.productKitLineID;
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["fullDescription"] = this.fullDescription;
        data["lineNumber"] = this.lineNumber;
        data["lineType"] = this.lineType;
        data["quantity"] = this.quantity;
        data["isChoiceLine"] = this.isChoiceLine;
        data["defaultChoice"] = this.defaultChoice;
        return data; 
    }
}

export interface IKitText {
    productKitLineID?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    quantity?: number | undefined;
    isChoiceLine?: boolean | undefined;
    defaultChoice?: boolean | undefined;
}

export class KitChoiceStart implements IKitChoiceStart {
    productKitLineID?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    isChoiceLine?: boolean | undefined;
    defaultChoice?: boolean | undefined;

    constructor(data?: IKitChoiceStart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKitLineID = _data["productKitLineID"];
            this.description = _data["description"];
            this.shortDescription = _data["shortDescription"];
            this.fullDescription = _data["fullDescription"];
            this.lineNumber = _data["lineNumber"];
            this.lineType = _data["lineType"];
            this.isChoiceLine = _data["isChoiceLine"];
            this.defaultChoice = _data["defaultChoice"];
        }
    }

    static fromJS(data: any): KitChoiceStart {
        data = typeof data === 'object' ? data : {};
        let result = new KitChoiceStart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKitLineID"] = this.productKitLineID;
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["fullDescription"] = this.fullDescription;
        data["lineNumber"] = this.lineNumber;
        data["lineType"] = this.lineType;
        data["isChoiceLine"] = this.isChoiceLine;
        data["defaultChoice"] = this.defaultChoice;
        return data; 
    }
}

export interface IKitChoiceStart {
    productKitLineID?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    isChoiceLine?: boolean | undefined;
    defaultChoice?: boolean | undefined;
}

export class KitNoChoice implements IKitNoChoice {
    productKitLineID?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    isChoiceLine?: boolean | undefined;
    defaultChoice?: boolean | undefined;

    constructor(data?: IKitNoChoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKitLineID = _data["productKitLineID"];
            this.description = _data["description"];
            this.shortDescription = _data["shortDescription"];
            this.fullDescription = _data["fullDescription"];
            this.lineNumber = _data["lineNumber"];
            this.lineType = _data["lineType"];
            this.isChoiceLine = _data["isChoiceLine"];
            this.defaultChoice = _data["defaultChoice"];
        }
    }

    static fromJS(data: any): KitNoChoice {
        data = typeof data === 'object' ? data : {};
        let result = new KitNoChoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKitLineID"] = this.productKitLineID;
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["fullDescription"] = this.fullDescription;
        data["lineNumber"] = this.lineNumber;
        data["lineType"] = this.lineType;
        data["isChoiceLine"] = this.isChoiceLine;
        data["defaultChoice"] = this.defaultChoice;
        return data; 
    }
}

export interface IKitNoChoice {
    productKitLineID?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    isChoiceLine?: boolean | undefined;
    defaultChoice?: boolean | undefined;
}

export class KitPriceGroup implements IKitPriceGroup {
    productKitLineID?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    isChoiceLine?: boolean | undefined;
    defaultChoice?: boolean | undefined;
    sellPriceGroupID?: number | undefined;

    constructor(data?: IKitPriceGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKitLineID = _data["productKitLineID"];
            this.description = _data["description"];
            this.shortDescription = _data["shortDescription"];
            this.fullDescription = _data["fullDescription"];
            this.lineNumber = _data["lineNumber"];
            this.lineType = _data["lineType"];
            this.isChoiceLine = _data["isChoiceLine"];
            this.defaultChoice = _data["defaultChoice"];
            this.sellPriceGroupID = _data["sellPriceGroupID"];
        }
    }

    static fromJS(data: any): KitPriceGroup {
        data = typeof data === 'object' ? data : {};
        let result = new KitPriceGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKitLineID"] = this.productKitLineID;
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["fullDescription"] = this.fullDescription;
        data["lineNumber"] = this.lineNumber;
        data["lineType"] = this.lineType;
        data["isChoiceLine"] = this.isChoiceLine;
        data["defaultChoice"] = this.defaultChoice;
        data["sellPriceGroupID"] = this.sellPriceGroupID;
        return data; 
    }
}

export interface IKitPriceGroup {
    productKitLineID?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    isChoiceLine?: boolean | undefined;
    defaultChoice?: boolean | undefined;
    sellPriceGroupID?: number | undefined;
}

export class KitSectionStart implements IKitSectionStart {
    productKitLineID?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    isChoiceLine?: boolean | undefined;
    defaultChoice?: boolean | undefined;

    constructor(data?: IKitSectionStart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKitLineID = _data["productKitLineID"];
            this.description = _data["description"];
            this.shortDescription = _data["shortDescription"];
            this.fullDescription = _data["fullDescription"];
            this.lineNumber = _data["lineNumber"];
            this.lineType = _data["lineType"];
            this.isChoiceLine = _data["isChoiceLine"];
            this.defaultChoice = _data["defaultChoice"];
        }
    }

    static fromJS(data: any): KitSectionStart {
        data = typeof data === 'object' ? data : {};
        let result = new KitSectionStart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKitLineID"] = this.productKitLineID;
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["fullDescription"] = this.fullDescription;
        data["lineNumber"] = this.lineNumber;
        data["lineType"] = this.lineType;
        data["isChoiceLine"] = this.isChoiceLine;
        data["defaultChoice"] = this.defaultChoice;
        return data; 
    }
}

export interface IKitSectionStart {
    productKitLineID?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    isChoiceLine?: boolean | undefined;
    defaultChoice?: boolean | undefined;
}

export class KitSectionEnd implements IKitSectionEnd {
    productKitLineID?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    isChoiceLine?: boolean | undefined;
    defaultChoice?: boolean | undefined;

    constructor(data?: IKitSectionEnd) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKitLineID = _data["productKitLineID"];
            this.description = _data["description"];
            this.shortDescription = _data["shortDescription"];
            this.fullDescription = _data["fullDescription"];
            this.lineNumber = _data["lineNumber"];
            this.lineType = _data["lineType"];
            this.isChoiceLine = _data["isChoiceLine"];
            this.defaultChoice = _data["defaultChoice"];
        }
    }

    static fromJS(data: any): KitSectionEnd {
        data = typeof data === 'object' ? data : {};
        let result = new KitSectionEnd();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKitLineID"] = this.productKitLineID;
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["fullDescription"] = this.fullDescription;
        data["lineNumber"] = this.lineNumber;
        data["lineType"] = this.lineType;
        data["isChoiceLine"] = this.isChoiceLine;
        data["defaultChoice"] = this.defaultChoice;
        return data; 
    }
}

export interface IKitSectionEnd {
    productKitLineID?: number | undefined;
    description?: string | undefined;
    shortDescription?: string | undefined;
    fullDescription?: string | undefined;
    lineNumber?: number | undefined;
    lineType?: number | undefined;
    isChoiceLine?: boolean | undefined;
    defaultChoice?: boolean | undefined;
}

export class Stream implements IStream {
    readonly canRead?: boolean | undefined;
    readonly canSeek?: boolean | undefined;
    readonly canTimeout?: boolean | undefined;
    readonly canWrite?: boolean | undefined;
    readonly length?: number | undefined;
    position?: number | undefined;
    readTimeout?: number | undefined;
    writeTimeout?: number | undefined;

    constructor(data?: IStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).canRead = _data["canRead"];
            (<any>this).canSeek = _data["canSeek"];
            (<any>this).canTimeout = _data["canTimeout"];
            (<any>this).canWrite = _data["canWrite"];
            (<any>this).length = _data["length"];
            this.position = _data["position"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        let result = new Stream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canSeek"] = this.canSeek;
        data["canTimeout"] = this.canTimeout;
        data["canWrite"] = this.canWrite;
        data["length"] = this.length;
        data["position"] = this.position;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        return data; 
    }
}

export interface IStream {
    canRead?: boolean | undefined;
    canSeek?: boolean | undefined;
    canTimeout?: boolean | undefined;
    canWrite?: boolean | undefined;
    length?: number | undefined;
    position?: number | undefined;
    readTimeout?: number | undefined;
    writeTimeout?: number | undefined;
}

export class ReportFormatResponse implements IReportFormatResponse {
    formats?: { [key: string]: string; } | undefined;
    status?: ReportFormatResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IReportFormatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["formats"]) {
                this.formats = {} as any;
                for (let key in _data["formats"]) {
                    if (_data["formats"].hasOwnProperty(key))
                        this.formats![key] = _data["formats"][key];
                }
            }
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): ReportFormatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportFormatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.formats) {
            data["formats"] = {};
            for (let key in this.formats) {
                if (this.formats.hasOwnProperty(key))
                    data["formats"][key] = this.formats[key];
            }
        }
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IReportFormatResponse {
    formats?: { [key: string]: string; } | undefined;
    status?: ReportFormatResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class DocumentReportRequest implements IDocumentReportRequest {
    documentIds?: number[] | undefined;
    printTool?: DocumentReportRequestPrintTool | undefined;
    format?: number | undefined;
    computerId?: number | undefined;
    userId?: number | undefined;
    alwaysPrintPickingNoteFormat?: boolean | undefined;
    documentType?: DocumentReportRequestDocumentType | undefined;

    constructor(data?: IDocumentReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            this.printTool = _data["printTool"];
            this.format = _data["format"];
            this.computerId = _data["computerId"];
            this.userId = _data["userId"];
            this.alwaysPrintPickingNoteFormat = _data["alwaysPrintPickingNoteFormat"];
            this.documentType = _data["documentType"];
        }
    }

    static fromJS(data: any): DocumentReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        data["printTool"] = this.printTool;
        data["format"] = this.format;
        data["computerId"] = this.computerId;
        data["userId"] = this.userId;
        data["alwaysPrintPickingNoteFormat"] = this.alwaysPrintPickingNoteFormat;
        data["documentType"] = this.documentType;
        return data; 
    }
}

export interface IDocumentReportRequest {
    documentIds?: number[] | undefined;
    printTool?: DocumentReportRequestPrintTool | undefined;
    format?: number | undefined;
    computerId?: number | undefined;
    userId?: number | undefined;
    alwaysPrintPickingNoteFormat?: boolean | undefined;
    documentType?: DocumentReportRequestDocumentType | undefined;
}

export class DocumentReportResponse implements IDocumentReportResponse {
    fileContents?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
    status?: DocumentReportResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IDocumentReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileContents = _data["fileContents"];
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): DocumentReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileContents"] = this.fileContents;
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IDocumentReportResponse {
    fileContents?: string | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
    status?: DocumentReportResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class ReportsValidationResponse implements IReportsValidationResponse {
    documents?: ReportValidationDocument[] | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
    status?: ReportsValidationResponseStatus | undefined;
    statusDetail?: string | undefined;

    constructor(data?: IReportsValidationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(ReportValidationDocument.fromJS(item));
            }
            this.userDialogRequest = _data["userDialogRequest"] ? UserDialogRequestParams.fromJS(_data["userDialogRequest"]) : <any>undefined;
            this.status = _data["status"];
            this.statusDetail = _data["statusDetail"];
        }
    }

    static fromJS(data: any): ReportsValidationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportsValidationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["userDialogRequest"] = this.userDialogRequest ? this.userDialogRequest.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["statusDetail"] = this.statusDetail;
        return data; 
    }
}

export interface IReportsValidationResponse {
    documents?: ReportValidationDocument[] | undefined;
    userDialogRequest?: UserDialogRequestParams | undefined;
    status?: ReportsValidationResponseStatus | undefined;
    statusDetail?: string | undefined;
}

export class ReportValidationDocument implements IReportValidationDocument {
    documentId?: number | undefined;
    brokenRules?: { [key: string]: string; } | undefined;
    readonly documentType?: ReportValidationDocumentDocumentType | undefined;
    readonly isValid?: boolean | undefined;

    constructor(data?: IReportValidationDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            if (_data["brokenRules"]) {
                this.brokenRules = {} as any;
                for (let key in _data["brokenRules"]) {
                    if (_data["brokenRules"].hasOwnProperty(key))
                        this.brokenRules![key] = _data["brokenRules"][key];
                }
            }
            (<any>this).documentType = _data["documentType"];
            (<any>this).isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): ReportValidationDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ReportValidationDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        if (this.brokenRules) {
            data["brokenRules"] = {};
            for (let key in this.brokenRules) {
                if (this.brokenRules.hasOwnProperty(key))
                    data["brokenRules"][key] = this.brokenRules[key];
            }
        }
        data["documentType"] = this.documentType;
        data["isValid"] = this.isValid;
        return data; 
    }
}

export interface IReportValidationDocument {
    documentId?: number | undefined;
    brokenRules?: { [key: string]: string; } | undefined;
    documentType?: ReportValidationDocumentDocumentType | undefined;
    isValid?: boolean | undefined;
}

export class FieldAgentServiceInfo implements IFieldAgentServiceInfo {
    dbConnectionClusterId?: number | undefined;
    fieldAgentCoreUri?: string | undefined;

    constructor(data?: IFieldAgentServiceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dbConnectionClusterId = _data["dbConnectionClusterId"];
            this.fieldAgentCoreUri = _data["fieldAgentCoreUri"];
        }
    }

    static fromJS(data: any): FieldAgentServiceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FieldAgentServiceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dbConnectionClusterId"] = this.dbConnectionClusterId;
        data["fieldAgentCoreUri"] = this.fieldAgentCoreUri;
        return data; 
    }
}

export interface IFieldAgentServiceInfo {
    dbConnectionClusterId?: number | undefined;
    fieldAgentCoreUri?: string | undefined;
}

/** The document type category. */
export enum DocumentTypeCategory {
    All = "All",
    JourneyPlanner = "JourneyPlanner",
}

/** Type of AutoText. for list of types check BisTrack.Service.Dto.AutoTextType */
export enum TextType {
    None = "None",
    OrderNotes = "OrderNotes",
    OrderSpecialInstructions = "OrderSpecialInstructions",
    OrderNotesInternal = "OrderNotesInternal",
    PurchaseOrderNotes = "PurchaseOrderNotes",
    PurchaseOrderSpecialInstructions = "PurchaseOrderSpecialInstructions",
    PurchaseOrderNotesInternal = "PurchaseOrderNotesInternal",
    WorksOrderNotes = "WorksOrderNotes",
    CustomerNotes = "CustomerNotes",
    CustomerSpecialInstructions = "CustomerSpecialInstructions",
    CustomerNotepadNotes = "CustomerNotepadNotes",
    CustomerCreditControlNotepadNotes = "CustomerCreditControlNotepadNotes",
    CustomerAddressSpecialInstructions = "CustomerAddressSpecialInstructions",
    SupplierNotes = "SupplierNotes",
    SupplierSpecialInstructions = "SupplierSpecialInstructions",
    SupplierNotepadNotes = "SupplierNotepadNotes",
    SupplierCreditControlNotepadNotes = "SupplierCreditControlNotepadNotes",
    SupplierAddressSpecialInstructions = "SupplierAddressSpecialInstructions",
    SupplierDeliveryAddress = "SupplierDeliveryAddress",
    JobNotepadNotes = "JobNotepadNotes",
    JobCreditControlNotepadNotes = "JobCreditControlNotepadNotes",
    ProductDescription = "ProductDescription",
    DebitNotes = "DebitNotes",
    StockCount = "StockCount",
    DataRuleDescription = "DataRuleDescription",
    JourneyManifest = "JourneyManifest",
    InvoiceNotes = "InvoiceNotes",
    SupplierReturnNotes = "SupplierReturnNotes",
    CustomerReturnNotes = "customerReturnNotes",
    KitNotes = "KitNotes",
    KitSpecialInstructions = "KitSpecialInstructions",
    ABCSpecialInstructions = "ABCSpecialInstructions",
    SupplierInvoiceOnHoldNotepadNotes = "SupplierInvoiceOnHoldNotepadNotes",
    SupplierInvoiceOffHoldNotepadNotes = "SupplierInvoiceOffHoldNotepadNotes",
    Scheduling = "Scheduling",
    WorksOrderProcess = "WorksOrderProcess",
}

export enum Choice {
    AutoAverageCostAdjRule = "AutoAverageCostAdjRule",
    Branch = "Branch",
    Campaign = "Campaign",
    CreditNoteHeader = "CreditNoteHeader",
    Customer = "Customer",
    CustomerAddress = "CustomerAddress",
    CustomerContact = "CustomerContact",
    CustomerNotepad = "CustomerNotepad",
    InvoiceHeader = "InvoiceHeader",
    Item = "Item",
    Job = "Job",
    JobNotepad = "JobNotepad",
    JourneyHeader = "JourneyHeader",
    Opportunity = "Opportunity",
    OrderHeader = "OrderHeader",
    OrderLineUDF = "OrderLineUDF",
    Product = "Product",
    ProductPack = "ProductPack",
    PurchaseDocumentNotepad = "PurchaseDocumentNotepad",
    PurchaseOrderHeader = "PurchaseOrderHeader",
    SalesDocumentNotepad = "SalesDocumentNotepad",
    ScheduleHeader = "ScheduleHeader",
    Supplier = "Supplier",
    SupplierAddress = "SupplierAddress",
    SupplierContact = "SupplierContact",
    SupplierNotepad = "SupplierNotepad",
    SupplierProduct = "SupplierProduct",
    Users = "Users",
    Vehicle = "Vehicle",
    WorksOrderHeader = "WorksOrderHeader",
}

export enum DocumentType2 {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export enum DocumentType3 {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

/** The documentTypeBisTrack.Service.Dto.DocumentListTypes */
export enum DocumentType4 {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export enum StockLocationsResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum BranchesResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum ComputersResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum VehicleTypesResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum VehicleTypeTrailerType {
    None = "None",
    TtTruckAndTrailer = "ttTruckAndTrailer",
    TtTrailerOnly = "ttTrailerOnly",
    TtTruckOnly = "ttTruckOnly",
}

export enum VehicleResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum VehicleTrailerType {
    None = "None",
    TtTruckAndTrailer = "ttTruckAndTrailer",
    TtTrailerOnly = "ttTrailerOnly",
    TtTruckOnly = "ttTruckOnly",
}

export enum UserDialogRequestParamsId {
    JP_PromptDocumentDateDoesNotMatchJourneyDate_OK = "JP_PromptDocumentDateDoesNotMatchJourneyDate_OK",
    JP_PromtSupplierReturnNotDeliveredSale_OkCancel = "JP_PromtSupplierReturnNotDeliveredSale_OkCancel",
    JP_PromptDocumentIsNotDelivered = "JP_PromptDocumentIsNotDelivered",
    JP_PromptForCreditHoldOrParkedOrders_OkCancel = "JP_PromptForCreditHoldOrParkedOrders_OkCancel",
    JP_PromptForCreditHoldOrParkedOrders_Ok = "JP_PromptForCreditHoldOrParkedOrders_Ok",
    JP_PromptJourneyToViaBranch_Option = "JP_PromptJourneyToViaBranch_Option",
    JP_PromptJourneyViaBranchOrFinalDestinationBranch_Option = "JP_PromptJourneyViaBranchOrFinalDestinationBranch_Option",
    JP_PromptSameAddressJourney_YESNO = "JP_PromptSameAddressJourney_YESNO",
    ADDCOST_PromptForDocumentValidation_OK = "ADDCOST_PromptForDocumentValidation_OK",
    OrderMonitor_PromptForWMSCheck_OkCancel = "OrderMonitor_PromptForWMSCheck_OkCancel",
    OrderMonitor_PromptForMarkOrders_OK = "OrderMonitor_PromptForMarkOrders_OK",
    OrderMonitor_ExecuteProcessOptionDialog1_YesNo = "OrderMonitor_ExecuteProcessOptionDialog1_YesNo",
    OrderMonitor_ExecuteProcessOptionDialog2_YesNoCancel = "OrderMonitor_ExecuteProcessOptionDialog2_YesNoCancel",
    OrderMonitor_ExecuteProcessOptionDialog3_YesNoCancel = "OrderMonitor_ExecuteProcessOptionDialog3_YesNoCancel",
    OrderMonitor_ExecuteProcessOptionDialog4_YesNoCancel = "OrderMonitor_ExecuteProcessOptionDialog4_YesNoCancel",
    OrderMonitor_ExecuteProcessOptionDialog5_YesNoCancel = "OrderMonitor_ExecuteProcessOptionDialog5_YesNoCancel",
    OrderMonitor_SendTransfer_YesNo = "OrderMonitor_SendTransfer_YesNo",
    OrderMonitor_OrderDisplay_OkCancel = "OrderMonitor_OrderDisplay_OkCancel",
    OrderMonitor_OrderTransferDialog1_YesNo = "OrderMonitor_OrderTransferDialog1_YesNo",
    OrderMonitor_OrderTransferDialog2_YesNo = "OrderMonitor_OrderTransferDialog2_YesNo",
    OrderMonitor_OrderTransferDialog3_YesNo = "OrderMonitor_OrderTransferDialog3_YesNo",
    OrderMonitor_ApproveOrders_YesNo = "OrderMonitor_ApproveOrders_YesNo",
    OrderMonitor_OptionInvoice_Dialog1_YesNo = "OrderMonitor_OptionInvoice_Dialog1_YesNo",
    OrderMonitor_OptionInvoice_Dialog2_YesNo = "OrderMonitor_OptionInvoice_Dialog2_YesNo",
    OrderMonitor_StockTransferReceiptQty_Dialog = "OrderMonitor_StockTransferReceiptQty_Dialog",
    OrderMonitor_DocumentPrint_Dialog = "OrderMonitor_DocumentPrint_Dialog",
    OrderMonitor_InvoiceReleaseDisplay_Dialog = "OrderMonitor_InvoiceReleaseDisplay_Dialog",
    OrderMonitor_ProcessDisplay_Dialog = "OrderMonitor_ProcessDisplay_Dialog",
    OrderMonitor_ValidateOrderDelivery_OK = "OrderMonitor_ValidateOrderDelivery_OK",
    OrderMonitor_OrderDeliveryDetailsInvoiced_OK = "OrderMonitor_OrderDeliveryDetailsInvoiced_OK",
    OrderMonitor_PaymentValidation_OK = "OrderMonitor_PaymentValidation_OK",
    OrderMonitor_WMSBranchCheck_OK = "OrderMonitor_WMSBranchCheck_OK",
    Prompt_OK = "Prompt_OK",
}

export enum UserDialogRequestParamsResponse {
    OK_TYPE = "OK_TYPE",
    OKCANCEL_TYPE = "OKCANCEL_TYPE",
    YESNO_TYPE = "YESNO_TYPE",
    OPTION_TYPE = "OPTION_TYPE",
    YESNOCANCEL_TYPE = "YESNOCANCEL_TYPE",
    MODAL_WINDOW = "MODAL_WINDOW",
}

export enum VehiclesQueryParamsTrailerType {
    None = "None",
    TtTruckAndTrailer = "ttTruckAndTrailer",
    TtTrailerOnly = "ttTrailerOnly",
    TtTruckOnly = "ttTruckOnly",
}

export enum VehiclesListResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum DriversListResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum DocumentTypesResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum DocumentTypeId {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export class SystemOptions implements ISystemOptions {
    soidPickingZoneFormatNumber?: string | undefined;
    soidServerFolder?: string | undefined;
    soidAllowBlankPasswords?: string | undefined;
    soidMaximumProductGroupLevels?: string | undefined;
    soidCubeServerFolder?: string | undefined;
    soidHTMLServerFolder?: string | undefined;
    soidReportServerFolder?: string | undefined;
    soidTemplateServerFolder?: string | undefined;
    soidTerminalServers?: string | undefined;
    soidDefaultLabelPrinter?: string | undefined;
    soidAllowBackToBacks?: string | undefined;
    soidNoOfDocumentFormats?: string | undefined;
    soidShowDetailedPrinterDialogForLabels?: string | undefined;
    soidDefaultCountry?: string | undefined;
    soidOrderNumberIncrement?: string | undefined;
    soidCompanyName?: string | undefined;
    soidCompanyAddress?: string | undefined;
    soidCompanyRegistrationNumber?: string | undefined;
    soidVATRegistrationNumber?: string | undefined;
    soidCompanyCatalogueURL?: string | undefined;
    soidCompanyCatalogueName?: string | undefined;
    soidVATValidationURL?: string | undefined;
    soidLongRunningProceduresTimeout?: string | undefined;
    soidStandardSQLQueryTimeout?: string | undefined;
    soidUseReadUnCommittedTransactionIsolationLevel?: string | undefined;
    soidCrystalReportsVersion?: string | undefined;
    soidReportServerVersion?: string | undefined;
    soidCrystalReportsAllowIntegratedSecurity?: string | undefined;
    soidSQLReportsServerURL?: string | undefined;
    soidSQLReportsBuilderVersion?: string | undefined;
    soidSQLReportsServerVersion?: string | undefined;
    soidSQLReportsViewerVersion?: string | undefined;
    soidBaseCurrency?: string | undefined;
    soidAlternativeCurrency?: string | undefined;
    soidDefaultVatRate?: string | undefined;
    soidDefaultCashCustomer?: string | undefined;
    soidConsolidateLines?: string | undefined;
    soidVatRuleForDeliveryCharge?: string | undefined;
    soidMaximumDimensions?: string | undefined;
    soidAllowSetCustomerOnHold?: string | undefined;
    soidDueDateGraceDays?: string | undefined;
    soidIgnoreSmallBalancesUpTo?: string | undefined;
    soidOverdueBalanceChecking?: string | undefined;
    soidCreditControlDisableCreditLimitChecksOnOrders?: string | undefined;
    soidCreditControlAllowCashOnCreditHold?: string | undefined;
    soidCreditControlAllowInstantCreditRelease?: string | undefined;
    soidCreditControlPromptForOriginalComputer?: string | undefined;
    soidCreditControlAllowCashAccountBalances?: string | undefined;
    soidCreditControlOrderChangeTolerance?: string | undefined;
    soidCreditControlDisableCreditLimitChecksOnOrderAmend?: string | undefined;
    soidAllowGreatPlainsMessages?: string | undefined;
    soidCreditControlExcludePreviouslyReleasedOrdersFromCheck?: string | undefined;
    soidCreditControlDisableCreditChecksOnReleasedBackOrders?: string | undefined;
    soidCreditControlUseARCustomerForOrderCreditApproval?: string | undefined;
    soidCreditControlMaximumSalesOrderValueAmount?: string | undefined;
    soidCreditControlMaximumSalesOrderPercentage?: string | undefined;
    soidCreditControlCreditLimitExtensionPercentage?: string | undefined;
    soidCreditControlCreditHoldThresholdAmount?: string | undefined;
    soidCreditControlAllowPaymentOnAccountOnCreditHold?: string | undefined;
    soidCreditControlMarginHoldOrderChangeTolerance?: string | undefined;
    soidCustomerFullSyncJobName?: string | undefined;
    soidCustomerPartialSyncJobName?: string | undefined;
    soidSupplierFullSyncJobName?: string | undefined;
    soidSupplierPartialSyncJobName?: string | undefined;
    soidCreditControlPrintDocsAwaitingCustomerApproval?: string | undefined;
    soidDynamicsDatabase?: string | undefined;
    soidDynamicsServer?: string | undefined;
    soidDynamicsUserID?: string | undefined;
    soidFinancialInterfaceFolder?: string | undefined;
    soidFinancialInterfaceVersion?: string | undefined;
    soidNavisionCompanyName?: string | undefined;
    soidNavisionServer?: string | undefined;
    soidNavisionDatabase?: string | undefined;
    soidNavisionNTAuthentication?: string | undefined;
    soidNavisionUserID?: string | undefined;
    soidNavisionShowCFRONTErrors?: string | undefined;
    soidNavisionNetType?: string | undefined;
    soidSendDebitNotes?: string | undefined;
    soidSendDebitNotesOnHold?: string | undefined;
    soidAutoApplyCreditNotes?: string | undefined;
    soidUseNAVAgent?: string | undefined;
    soidAgentGenerateXMLOnly?: string | undefined;
    soidDisallowReExport?: string | undefined;
    soidSendDebitNoteAmount?: string | undefined;
    soidNavisionPostingGroupSales?: string | undefined;
    soidNavisionPostingGroupPurch?: string | undefined;
    soidNAVUseSeparateBatches?: string | undefined;
    soidUseNAVCache?: string | undefined;
    soidNAVCacheDatabaseName?: string | undefined;
    soidCreditControlCustomerReferencePutOrdersOnHold?: string | undefined;
    soidCalculateJobCreditLimitFromCustomerReferencePurchaseOrderAmounts?: string | undefined;
    soidCalculatedJobCreditLimitExtensionPercentage?: string | undefined;
    soidCalculateInvoiceDueAndDiscountDatesFromDeliveryDate?: string | undefined;
    soidCustomerAgedDebt1?: string | undefined;
    soidCustomerAgedDebt2?: string | undefined;
    soidCustomerAgedDebt3?: string | undefined;
    soidCustomerAgedDebt4?: string | undefined;
    soidCustomerAgedDebt5?: string | undefined;
    soidCustomerAgedDebt6?: string | undefined;
    soidCustomerAgedDebt7?: string | undefined;
    soidSupplierAgedDebt1?: string | undefined;
    soidSupplierAgedDebt2?: string | undefined;
    soidSupplierAgedDebt3?: string | undefined;
    soidSupplierAgedDebt4?: string | undefined;
    soidSupplierAgedDebt5?: string | undefined;
    soidSupplierAgedDebt6?: string | undefined;
    soidSupplierAgedDebt7?: string | undefined;
    soidGreatPlainsMessageQueue?: string | undefined;
    soidGreatPlainsMessageServer?: string | undefined;
    soidGreatPlainsPollInterval?: string | undefined;
    soidGreatPlainsLoggingLevel?: string | undefined;
    soidGreatPlainsCompanyID?: string | undefined;
    soidGreatPlainsServer?: string | undefined;
    soidGreatPlainseConnectServer?: string | undefined;
    soidBankAccountCash?: string | undefined;
    soidBankAccountCheque?: string | undefined;
    soidBankAccountCreditCard?: string | undefined;
    soidGreatPlainsOutputTo?: string | undefined;
    soidGreatPlainsARPathFile?: string | undefined;
    soidGreatPlainsAPPathFile?: string | undefined;
    soidGreatPlainsbisTrackServiceServer?: string | undefined;
    soidSalesGLRuleTaxSales?: string | undefined;
    soidWriteOffGLRule?: string | undefined;
    soidFinanceChargeGLRule?: string | undefined;
    soidNSFChargeGLRule?: string | undefined;
    soidCashGLCode?: string | undefined;
    soidChequeGLCode?: string | undefined;
    soidCreditCardGLCode?: string | undefined;
    soidGreatPlainsGLPathFile?: string | undefined;
    soidSalesDisableTaxSalesGLRule?: string | undefined;
    soidGPDirectUsername?: string | undefined;
    soidGPDirectPassword?: string | undefined;
    soidExtendedNumberFormat?: string | undefined;
    soidCreateGLTransactionsStockReceipts?: string | undefined;
    soidCreateGLTransactionsStockAdjustment?: string | undefined;
    soidFinancialDepositControl?: string | undefined;
    soidFinancialUnallocatedCashControl?: string | undefined;
    soidFinancialDepositVatPosting?: string | undefined;
    soidFinancialUnallocatedVatPosting?: string | undefined;
    soidbTAAccountCodeMask?: string | undefined;
    soidbTAApplyLateCharges?: string | undefined;
    soidbTAMinLatePaymentCharge?: string | undefined;
    soidbTAAutoWOThreshold?: string | undefined;
    soidbTALapsedAccountMonths?: string | undefined;
    soidbTAInactiveAccountMonths?: string | undefined;
    soidbTADeletedAccountMonths?: string | undefined;
    soidbTACustomerAgedBalanceMethod?: string | undefined;
    soidbTACustomerApplicationInProcess?: string | undefined;
    soidbTACustomerStatementReportName?: string | undefined;
    soidbTACustomerInterimStatementReportName?: string | undefined;
    soidbTAGeneralContractorInfoRequired?: string | undefined;
    soidbTACustomerStatementStyle?: string | undefined;
    soidbTAStatementScannedDocTypeForCollect?: string | undefined;
    soidbTAStatementScannedDocTypeForDelivered?: string | undefined;
    soidbTAStatementSendIntervalInSeconds?: string | undefined;
    soidbTAStatementEmailBodyText?: string | undefined;
    soidbTASettDiscToFullAmountWhenMatching?: string | undefined;
    soidbTAARBy?: string | undefined;
    soidbTAStatementScanTrackImagesOnly?: string | undefined;
    soidTransferGLRuleInbound?: string | undefined;
    soidTransferGLRuleOutbound?: string | undefined;
    soidTransferGLRuleInTransit?: string | undefined;
    soidTransferGLRuleUpliftCalculated?: string | undefined;
    soidTransferGLRuleUpliftInput?: string | undefined;
    soidTransferGLRuleTransferProfit?: string | undefined;
    soidGenericXMLARPathFileName?: string | undefined;
    soidGenericXMLAPPathFileName?: string | undefined;
    soidGenericXMLGLPathFileName?: string | undefined;
    soidbTAStatementScannedDocTypeForInvoice?: string | undefined;
    soidbTAStatementScannedDocTypeForCredit?: string | undefined;
    soidbTAStatementImagesDefaultReportName?: string | undefined;
    soidbTAStatementImages1upReportName?: string | undefined;
    soidbTAStatementImages2upReportName?: string | undefined;
    soidbTAStatementImages4upReportName?: string | undefined;
    soidbTAPostARGrossAndDiscountAtTimeOfSale?: string | undefined;
    soidbTACustomerAgedBalancePeriodStyle?: string | undefined;
    soidbTAAllowDifferentARCustomerOnCustomerAddress?: string | undefined;
    soidbTAAllowAccountsPaymentOnJobAddress?: string | undefined;
    soidbTAAllowEntryOfCustomerRemittanceAdvice?: string | undefined;
    soidbTACompareByAccountInFES?: string | undefined;
    soidbtaUseBranchAccessInAccounts?: string | undefined;
    soidbTAEmailBodyTextForStatementNotification?: string | undefined;
    soidbTAIgnoreDiscountDueDateWhenMatchingCreditNotes?: string | undefined;
    soidbTAUseExpectedDetailsCheckingWithBatchCash?: string | undefined;
    soidbTACustomerAgeCreditNotes?: string | undefined;
    soidbTACustomerAgeUnappliedCash?: string | undefined;
    soidbTAMatchingNewCustomerResetOptions?: string | undefined;
    soidbTADefaultNewCreditCustomerToOperationalStatus?: string | undefined;
    soidDefaultOrderToCashCustomer?: string | undefined;
    soidDefaultOrderSaleType?: string | undefined;
    soidDefaultOrderPlacementType?: string | undefined;
    soidDefaultManualOrderLineType?: string | undefined;
    soidDefaultOrderTestCertOption?: string | undefined;
    soidDefaultShowAVOsInUnitPrice?: string | undefined;
    soidPrintDocumentReleaseDelay?: string | undefined;
    soidPrintDocumentReleaseConfirm?: string | undefined;
    soidDefaultPrintFinalDocOnInvoiceAndCreditRelease?: string | undefined;
    soidAllowCashOnDelivery?: string | undefined;
    soidStaffNumberTimeout?: string | undefined;
    soidDefaultOrdersToNegotiation?: string | undefined;
    soidDefaultOrderQuantityToZero?: string | undefined;
    soidPrintOrderOnCashSales?: string | undefined;
    soidPurchaseFromOrderRequiredDays?: string | undefined;
    soidUseActualSizesForTimberCosts?: string | undefined;
    soidWarnIfDateRequiredNotChanged?: string | undefined;
    soidWarnIfDeliveryAddressNotChanged?: string | undefined;
    soidCheckForExistingQuotes?: string | undefined;
    soidPurchaseOrderNumberDisplayFormat?: string | undefined;
    soidStockReceiptNumberDisplayFormat?: string | undefined;
    soidOrderNumberDisplayFormat?: string | undefined;
    soidPickingNoteNumberDisplayFormat?: string | undefined;
    soidSubContractNumberDisplayFormat?: string | undefined;
    soidDeliveryNoteNumberDisplayFormat?: string | undefined;
    soidInvoiceNumberDisplayFormat?: string | undefined;
    soidCreditNoteNumberDisplayFormat?: string | undefined;
    soidCuttingOperationNumberDisplayFormat?: string | undefined;
    soidWorksOrderNumberDisplayFormat?: string | undefined;
    soidSupplierInvoiceNumberDisplayFormat?: string | undefined;
    soidDebitNoteNumberDisplayFormat?: string | undefined;
    soidSupplierCreditNoteNumberDisplayFormat?: string | undefined;
    soidCustomerReturnNumberDisplayFormat?: string | undefined;
    soidJourneyManifestNumberDisplayFormat?: string | undefined;
    soidStockWarningCollectedAlwaysProceed?: string | undefined;
    soidStockWarningNonCollectedAlwaysBackOrder?: string | undefined;
    soidStockWarningDefaultToProceed?: string | undefined;
    soidSupplierReturnNumberDisplayFormat?: string | undefined;
    soidCostAdjustmentNumberDisplayFormat?: string | undefined;
    soidDropDownListThreshold?: string | undefined;
    soidDefaultProductTypeSearch?: string | undefined;
    soidFindFromAvailableStock?: string | undefined;
    soidSearchPageSize?: string | undefined;
    soidReturnOwnBrandProductsFirst?: string | undefined;
    soidPriceHistorySize?: string | undefined;
    soidUseCurrentBranchForFindDocuments?: string | undefined;
    soidPackBarcodeNumberDisplayFormat?: string | undefined;
    soidAllowLoadAllInAllForProcessing?: string | undefined;
    soidStaffNumberTimeoutOperations?: string | undefined;
    soidPickingNoteReprint?: string | undefined;
    soidSchedulingNumberDisplayFormat?: string | undefined;
    soidOrderProductsByPriceBookSection?: string | undefined;
    soidDefaultQuoteDays?: string | undefined;
    soidDefaultReservationDays?: string | undefined;
    soidDefaultTemplateOrderQuoteDays?: string | undefined;
    soidProfitAbbreviation?: string | undefined;
    soidMarginAbbreviation?: string | undefined;
    soidSuppressCurrencyAndPercentageSymbolsInProfitAndMargin?: string | undefined;
    soidSuppressMarginWarningsWhenPriceRulesUsed?: string | undefined;
    soidSuppressMarginWarningsWhenStandardPriceUsed?: string | undefined;
    soidDefaultMergeProductsOnOrder?: string | undefined;
    soidDefaultShowDoubleRowsOnOrder?: string | undefined;
    soidSpecialProductCodePrefix?: string | undefined;
    soidSpecialProductCodeSuffixLength?: string | undefined;
    soidCheckForExistingQuotesInAllBranches?: string | undefined;
    soidAlwaysMergeProductsOnQuickAdd?: string | undefined;
    soidBillOfMaterialProductCodePrefix?: string | undefined;
    soidBillOfMaterialProductCodeSuffixLength?: string | undefined;
    soidSpecialGetHowSourcedFromBase?: string | undefined;
    soidCheckForExistingQuotesAtLineLevel?: string | undefined;
    soidbTADefaultTransactionStatusFilter?: string | undefined;
    soidbTADirectPostingBatchMode?: string | undefined;
    soidbTACreateCaseWhenMarkingInDispute?: string | undefined;
    soidbTARequireBatchCashMatchingNoteForUnmatchedCredits?: string | undefined;
    soidbTAUseMatchDateForStatements?: string | undefined;
    soidbTAAllowWriteOffMoreThanRemainingAmount?: string | undefined;
    soidShowCTLInstructionsWithoutCutFrom?: string | undefined;
    soidSuppressMarginWarningsForSpecials?: string | undefined;
    soidbTABatchCashMatchingSortOrder?: string | undefined;
    soidWorksOrderScheduleNumberDisplayFormat?: string | undefined;
    soidNotepadCaseNumberDisplayFormat?: string | undefined;
    soidStockWarningIncludeOnlyApprovedPurchaseOrdersForAllocation?: string | undefined;
    soidbTAAllowUnapplyingTransactionsInClosedFinancialPeriods?: string | undefined;
    soidbTAFinanceChargeDefaultGenerateBy?: string | undefined;
    soidbTACalcFinanceChargesOnFinanceCharges?: string | undefined;
    soidbTADisplayChildCreditTransactionsOnParentAccounts?: string | undefined;
    soidStaffNumberBatchProcessingTimeout?: string | undefined;
    soidProductSearchPageSize?: string | undefined;
    soidProductExplorerPageSize?: string | undefined;
    soidCustomerSearchPageSize?: string | undefined;
    soidSupplierSearchPageSize?: string | undefined;
    soidOrderMonitorPageSize?: string | undefined;
    soidJourneyPlannerPageSize?: string | undefined;
    soidDefaultCreateNewSpecialsOnOrderCopy?: string | undefined;
    soidDefaultSectionEndWithSubtotal?: string | undefined;
    soidCheckCustomerOnHoldOnPickingAndDelivery?: string | undefined;
    soidCheckCustomerCreditOnPickingAndDelivery?: string | undefined;
    soidAllowProceedOnPickingAndDeliveryCreditChecks?: string | undefined;
    soidEnableSteppedFinanceCharge?: string | undefined;
    soidCustomerChequeReferencesRequireCustomer?: string | undefined;
    soidbTADefaultNewCashCustomerToOperationalStatus?: string | undefined;
    soidDefaultTransportType?: string | undefined;
    soidDefaultDeliveryDate?: string | undefined;
    soidInputMaskforDeliveryReference?: string | undefined;
    soidEnableUnitPriceDeliveryCharges?: string | undefined;
    soidAutomaticallySendDeliveryNotificationsByEmail?: string | undefined;
    soidCalendarStartOfWeek?: string | undefined;
    soidDefaultDateRequiredDays?: string | undefined;
    soidDefaultDateRequiredOption?: string | undefined;
    soidDefaultDeliveryTime?: string | undefined;
    soidDefaultDateRequiredToBlankOnQuotes?: string | undefined;
    soidDefaultDateRequiredCutOffTime?: string | undefined;
    soidDefaultDateRequiredToBlankOnOrders?: string | undefined;
    soidEnableTransactionLocking?: string | undefined;
    soidSkipBranchPromptWhenUserHasDefault?: string | undefined;
    soidPurchaseOrderCostCalculation?: string | undefined;
    soidSalesOrderCostCalculation?: string | undefined;
    soidSalesOrderShowVatPercentage?: string | undefined;
    soidSupplierInvoiceToleranceStockPercent?: string | undefined;
    soidSupplierInvoiceToleranceStockValue?: string | undefined;
    soidSupplierInvoiceToleranceDirectPercent?: string | undefined;
    soidSupplierInvoiceToleranceDirectValue?: string | undefined;
    soidSupplierInvoiceToleranceAdditionalCostPercent?: string | undefined;
    soidSupplierInvoiceToleranceAdditionalCostValue?: string | undefined;
    soidDefaultCounterOrderSaleType?: string | undefined;
    soidSupplierInvoiceShowWeight?: string | undefined;
    soidSupplierInvoiceToleranceVatPercent?: string | undefined;
    soidSupplierInvoiceToleranceVatValue?: string | undefined;
    soidSupplierInvoiceShowVAT?: string | undefined;
    soidSupplierInvoiceCalcSettlementDiscOnCredits?: string | undefined;
    soidSupplierInvoiceDeliveryText?: string | undefined;
    soidSupplierInvoicePromptForDeliveryDetails?: string | undefined;
    soidSupplierInvoiceMustChooseGLCode?: string | undefined;
    soidSupplierInvoiceBlock2ndInvoiceOnDirectOrders?: string | undefined;
    soidSupplierInvoiceApproveDirectSalesOrderOnInvoiceApproval?: string | undefined;
    soidSupplierInvoiceSetDirectSalesInvoiceDateFromInvoice?: string | undefined;
    soidOrdersPricingIncludeAdditionalCostInDirectSalesOrderCost?: string | undefined;
    soidSupplierInvoiceUseSupplierPaymentTerms?: string | undefined;
    soidIncludeOnOrderInAvailableStock?: string | undefined;
    soidIncludeStockDueInAvailableStock?: string | undefined;
    soidIncludeThirdPartyInAvailableStock?: string | undefined;
    soidIncludeAwaitingProcessInAvailableStock?: string | undefined;
    soidAllocateStockOnBackToBacks?: string | undefined;
    soidAllowUseOfCostRecordAfterValuationDate?: string | undefined;
    soidIncludeAwaitingProcessForOrderOnlyInAvailStock?: string | undefined;
    soidCompanyStockLimitedByUserAccess?: string | undefined;
    soidDoNotAllowBackAndForwardDatingThatHarmsCostIntegrity?: string | undefined;
    soidStockCountAllowTickedStockUpdates?: string | undefined;
    soidStockCountAllowBackDatingOfCompletion?: string | undefined;
    soidStockIncludeLooseAndPackInStockCheckWhenAllocating?: string | undefined;
    soidIncludeStockAllocatedToBackToBackOrderInOnOrderStock?: string | undefined;
    soidAllowAddingProductsToTicketedStockCounts?: string | undefined;
    soidShowStockInformationInStockCountProductSearches?: string | undefined;
    soidShowActualAndAvailableStockWhenEnteringTicketCounts?: string | undefined;
    soidReasonCodeToUseForStockCount?: string | undefined;
    soidCustomerObjectReport?: string | undefined;
    soidProductObjectReport?: string | undefined;
    soidSupplierObjectReport?: string | undefined;
    soidFinancialInvoiceAuditCustomerReport?: string | undefined;
    soidFinancialInvoiceAuditSupplierReport?: string | undefined;
    soidStockPackReconciliationReport?: string | undefined;
    soidCashDrawerReportName?: string | undefined;
    soidCustomerProductRefObjectReport?: string | undefined;
    soidSuggestedPurchaseOrderDetailReport?: string | undefined;
    soidStockValuationNegativeStockReportName?: string | undefined;
    soidStockValuationReceivedNotInvoicedReportName?: string | undefined;
    soidStockValuationPaidNotReceivedReportName?: string | undefined;
    soidStockValuationIssuedNotInvoicedReportName?: string | undefined;
    soidStockValuationInvoicedNotIssuedReportName?: string | undefined;
    soidStockValuationPaidNotDeliveredReportName?: string | undefined;
    soidStockValuationTransferSentNotreceivedReportName?: string | undefined;
    soidScansUseDocReadPermissions?: string | undefined;
    soidReportsAccruedPurchaseDetailSupplierCredits?: string | undefined;
    soidDashboardRefreshInterval?: string | undefined;
    soidDashboardOperationsFilename?: string | undefined;
    soidDashboardSystemManagerFilename?: string | undefined;
    soidDashboardFigures?: string | undefined;
    soidDashboardOrderingBranch?: string | undefined;
    soidDashBoardEnableFlowLayouts?: string | undefined;
    soidDataRuleDataSetXML?: string | undefined;
    soidPerformanceMonitorShowProfit?: string | undefined;
    soidPerformanceMonitorUseInternalCosts?: string | undefined;
    soidDefaultCustomerVATRule?: string | undefined;
    soidDefaultProductVATRule?: string | undefined;
    soidCalculateVATOnGoodsLessDiscount?: string | undefined;
    soidCalculateVATTaxAtTotalLevel?: string | undefined;
    soidCalculateTaxBasedOnBranchTaxArea?: string | undefined;
    soidVatRateForAutomaticUplift?: string | undefined;
    soidCalculateSettlementAtTotalLevel?: string | undefined;
    soidVatRateForAutomaticLineCharge?: string | undefined;
    soidEnableNonDiscountableAmount?: string | undefined;
    soidVatRateForExportSales?: string | undefined;
    soidUseWashingtonStateTaxRateValidation?: string | undefined;
    soidRequireTaxVerificationOnDeliveredSalesOrders?: string | undefined;
    soidUseDefaultJobAddressTaxAreaForCustomerDefault?: string | undefined;
    soidCalculateTaxOnCostMinusWorksOrderAVOCost?: string | undefined;
    soidUseIssuingBranchTaxArea?: string | undefined;
    soidSalesTaxCalculationMethod?: string | undefined;
    soidUseBranchTaxAreaForCustomerDefault?: string | undefined;
    soidSendFullAddressInfoInWashingtonStateTaxRateValidation?: string | undefined;
    soidWashingtonStateTaxRateURL?: string | undefined;
    soidFinancialStockValuationCostType?: string | undefined;
    soidFinancialReferenceRequiredOnCheckPayment?: string | undefined;
    soidInputMaskForChequeReference?: string | undefined;
    soidPreventUseOfNewJournalNumberOnReExport?: string | undefined;
    soidUseFiscalCalendarToControlPostingDates?: string | undefined;
    soidSearchHistoryRecordsInFinancialPackage?: string | undefined;
    soidUpdateDailySalesAnalysisTable?: string | undefined;
    soidChequeGuaranteeCardNumberRequired?: string | undefined;
    soidAuthorisationCodeOrderValueThreshold?: string | undefined;
    soidSendSeparateBatchForEachBranchGLCode?: string | undefined;
    soidRetainOrigExchangeRateOnSOAndPO?: string | undefined;
    soidEnableGLCodeValidation?: string | undefined;
    soidFinancialGPbTGeneratesJournalEntryNumber?: string | undefined;
    soidFinancialGPMinbTJournalEntryNumber?: string | undefined;
    soidFinancialGPMaxbTJournalEntryNumber?: string | undefined;
    soidPostSalesAndCOGSWhenUsingIssuingBranchTo?: string | undefined;
    soidEnableIntercompanyDistribution?: string | undefined;
    soidEpicorTaxConnectAccountNumber?: string | undefined;
    soidEpicorTaxConnectLicenseKey?: string | undefined;
    soidEpicorTaxConnectWebAddress?: string | undefined;
    soidTaxToUseForEpicorTaxConnectTaxes?: string | undefined;
    soidEpicorTaxConnectCompanyCode?: string | undefined;
    soidGenericXMLFinancialExportMethod?: string | undefined;
    soidSettDiscAllowedWhenMatchedToCreditCardPayments?: string | undefined;
    soidSettDiscAllowedWhenMatchedToACHPayments?: string | undefined;
    soidNoOfSellingBands?: string | undefined;
    soidUsePriceRulesForSpecials?: string | undefined;
    soidDeliveryCriteriaPrecedence1?: string | undefined;
    soidDeliveryCriteriaPrecedence2?: string | undefined;
    soidDeliveryCriteriaPrecedence3?: string | undefined;
    soidDeliveryCriteriaPrecedence4?: string | undefined;
    soidUseStandardBuyCostForSpecials?: string | undefined;
    soidRebateIDRequiredForRebateAccruals?: string | undefined;
    soidPricingDefaultCompanyLevelPriceChange?: string | undefined;
    soidPricingUseOldCompanyPriceAsOldAmount?: string | undefined;
    soidSigmaNESTEnableIntegration?: string | undefined;
    soidSigmaNESTWorkOrderAttachmentFolder?: string | undefined;
    soidSigmaNESTWorkOrderAttachmentFilename?: string | undefined;
    soidSigmaNESTWorkOrderAttachmentOrigin?: string | undefined;
    soidDontCalculateSellingPriceWhenAddingProductWithZeroQuantity?: string | undefined;
    soidSupplierInvoiceConfirmZeroTax?: string | undefined;
    soidSupplierInvoiceAllowAlternateCreditor?: string | undefined;
    soidSupplierInvoiceAutoCalcSettlementDiscOnInvoices?: string | undefined;
    soidSupplierInvoiceIncludeCostOnDirectLineDescription?: string | undefined;
    soidSupplierInvoiceEnablePostingDate?: string | undefined;
    soidSupplierInvoiceAutoSelectPostingDate?: string | undefined;
    soidSupplierInvoiceOnlyExportDiscountsNotEqualToZero?: string | undefined;
    soidSupplierInvoiceCanadianTaxInput?: string | undefined;
    soidSupplierInvoiceShowSupplierProductCode?: string | undefined;
    soidSupplierInvoiceAllowZeroTotalInvoices?: string | undefined;
    soidSupplierInvoiceDisplayExpectedCostsFromPO?: string | undefined;
    soidSupplierInvoiceEnableWorkflow?: string | undefined;
    soidSupplierInvoiceShowBrowseForGLSubCodeThreshold?: string | undefined;
    soidSupplierInvoiceRestrictWorkflowMessagesToSingleRecipient?: string | undefined;
    soidSupplierInvoiceGPIncludePOSupplierCodeWhenAlternativeCreditor?: string | undefined;
    soidSupplierInvoiceRequireWorkflowMessageRecipient?: string | undefined;
    soidSupplierCreditRequiresReasonCode?: string | undefined;
    soidSupplierInvoicePrintBarcodeLabelOnMatchOrMatchAndApprove?: string | undefined;
    soidSupplierInvoiceAllowMatchingDirectSupplierInvoiceWhenPaymentOutstanding?: string | undefined;
    soidSupplierInvoiceSendOtherRefAsPONumberToGPForOverheadSIs?: string | undefined;
    soidSupplierInvoiceSkipMsgsWhenMatchingApproving?: string | undefined;
    soidSupplierInvoiceBranchSelectionType?: string | undefined;
    soidSupplierInvoiceCalculateGoodsTotalOnOverheadInvoicesWithNoPurchaseOrder?: string | undefined;
    soidNavisionUseIssuingBranchForDimension?: string | undefined;
    soidLoyaltyCurrencyToPointExchangeRate?: string | undefined;
    soidLoyaltyOrderEntryPromptPointMinimum?: string | undefined;
    soidLoyaltyRedeemManualOrderLineType?: string | undefined;
    soidLoyaltyRepeatRewardsMOLT?: string | undefined;
    soidDefaultSystemToImperial?: string | undefined;
    soidWeightPer?: string | undefined;
    soidWeightDecimalPlaces?: string | undefined;
    soidQuotePickDocumentReleaseFormat?: string | undefined;
    soidDepartmentUsage?: string | undefined;
    soidDefaultDepartmentUsageDepartment?: string | undefined;
    soidGeneralEnableReportingCost?: string | undefined;
    soidAllowManualAdjustmentOfVolumeOnAdditionalCostProrations?: string | undefined;
    soidShowJobReferenceInLists?: string | undefined;
    soidAllowMultipleOrderReferenceMasks?: string | undefined;
    soidLimitSellAndBuyPriceChangesToBranchWithUpdateAccess?: string | undefined;
    soidGeneralEnableNotepadNotifications?: string | undefined;
    soidGeneralValidateDefaultRefOnCustomerAddress?: string | undefined;
    soidLimitRelatedDocsBasedOnBranchAccess?: string | undefined;
    soidVerifyInternalGiftCardsAgainstLoadedGiftCardList?: string | undefined;
    soidSetDepartmentOnOrdersDuringCreation?: string | undefined;
    soidUpdateTransactionLineManualDescriptionWithSpecialProductDescription?: string | undefined;
    soidDefaultCustomerNotepadTypeFilterFromUserOption?: string | undefined;
    soidDepartmentOnAccountPaymentsWhereDepartmentUsageIsSalesRepOrComputer?: string | undefined;
    soidDepartmentOnCashDrawerLodgementsWhereDepartmentUsageIsSalesRepOrComputer?: string | undefined;
    soidPricingPlannerSmartView1?: string | undefined;
    soidPricingPlannerSmartView2?: string | undefined;
    soidPricingPlannerSmartView3?: string | undefined;
    soidPricingPlannerSmartView4?: string | undefined;
    soidPricingPlannerSmartView5?: string | undefined;
    soidWorksOrderSpecifyFinQtyWhenConfirmSourcePacks?: string | undefined;
    soidPurchasingLimitFindProdToSupplier?: string | undefined;
    soidPurchasingAllowApprovalIfCreditProblem?: string | undefined;
    soidPurchasingAutoApproveDirectOrders?: string | undefined;
    soidPurchaseOrderSecondaryCostCalculation?: string | undefined;
    soidPurchasingAutoApproveBackToBackOrders?: string | undefined;
    soidPurchasingRoundToInnerOuterPallet?: string | undefined;
    soidPurchasingInputGLCodeOnOverheadAdvanced?: string | undefined;
    soidPurchasingWarnWhenNotPrimarySupplier?: string | undefined;
    soidPurchasingAutoPrintDirectOrders?: string | undefined;
    soidPurchasingAutoPrintBackToBackOrders?: string | undefined;
    soidPurchasingPopulateAnalysisCodeOnGeneratedPO?: string | undefined;
    soidPurchasingCopyCostPerFromDirectOrBackToBack?: string | undefined;
    soidPurchasingAllowCostQtyChangeAfterStockReceipt?: string | undefined;
    soidPurchasingCostToleranceWarning?: string | undefined;
    soidPurchasingWarnIfNotInnerOuterPalletMultiple?: string | undefined;
    soidPurchasingAllowPrintingUnapprovedPurchaseOrders?: string | undefined;
    soidPurchaseOrderCallOffAutoComplete?: string | undefined;
    soidPurchasingShowAndAllowUpdateOfStandardBuyPrice?: string | undefined;
    soidPurchasingDefaultAnalysisCodeOnGenerateFromAVO?: string | undefined;
    soidPurchasingShowCustomerOnInternalNotes?: string | undefined;
    soidPurchasingDefaultInputPerToSupplierBuyPer?: string | undefined;
    soidPurchasingDisplayCompletionButtonsOnPO?: string | undefined;
    soidPurchasingDisplayCreatePOOnAddCostChargeOnXfers?: string | undefined;
    soidPurchasingAlwaysUseOverriddenDimsOnAddCosts?: string | undefined;
    soidPurchasingApplyEnvironmentalStatusRestrictions?: string | undefined;
    soidPurchasingAllowChangingUnitCostForCostControlledItems?: string | undefined;
    soidGenerateCallOffPOForDirectSO?: string | undefined;
    soidPurchasingPromptForSellPriceWhenDirectCostChanged?: string | undefined;
    soidPurchasingKeepDateRequiredInSynchForDirects?: string | undefined;
    soidPurchasingCheckForCallOffs?: string | undefined;
    soidPurchasingSetDefaultStockLocation?: string | undefined;
    soidPurchasingPurchaseOrderChangeApprovalThreshold?: string | undefined;
    soidPurchasingUseLeadTimeToSetPOLineDateExpected?: string | undefined;
    soidIncludeOrderLineLinksForSOItemsOnWMSPOs?: string | undefined;
    soidPurchasingPromptForBuyPriceRuleSelection?: string | undefined;
    soidGLCodeSelectionMethodForMOLTsOnOverheadPO?: string | undefined;
    soidCentralizedPurchasingIncludesSourcedByTransfer?: string | undefined;
    soidSuggestedOrdersSmartView1?: string | undefined;
    soidSuggestedOrdersSmartView2?: string | undefined;
    soidSuggestedOrdersSmartView3?: string | undefined;
    soidSuggestedOrdersSmartView4?: string | undefined;
    soidSuggestedOrdersSmartView5?: string | undefined;
    soidSuggestedOrdersAdjustByStockClass?: string | undefined;
    soidDefaultPurchaseAnalysisCodeOnOverheadPOs?: string | undefined;
    soidPurchasingUseSecondaryCostWhenPrimaryCostValueIsZero?: string | undefined;
    soidPurchasingShow15LevelsForAutoAverageCostAdjRule?: string | undefined;
    soidRetainRaisedByInformationWhenConvertingPOToADirect?: string | undefined;
    soidApplyFixedAmountManualLinesAndAdditionalCostsToAllStockReceipts?: string | undefined;
    soidPurchasingSetMOLTDescriptionToGLCodeDescriptionOnOverheadPO?: string | undefined;
    soidPurchasingAutoPrintLabels?: string | undefined;
    soidPurchasingShowSupplierPopupForAutomaticPurchaseOrders?: string | undefined;
    soidSuggestedOrderingIncludeAllOpenPurchaseOrders?: string | undefined;
    soidFindDocPreviewPaneSmartViewSO1?: string | undefined;
    soidFindDocPreviewPaneSmartViewSO2?: string | undefined;
    soidFindDocPreviewPaneSmartViewSO3?: string | undefined;
    soidFindDocPreviewPaneSmartViewSO4?: string | undefined;
    soidFindDocPreviewPaneSmartViewSO5?: string | undefined;
    soidFindDocPreviewPaneSmartViewQU1?: string | undefined;
    soidFindDocPreviewPaneSmartViewQU2?: string | undefined;
    soidFindDocPreviewPaneSmartViewQU3?: string | undefined;
    soidFindDocPreviewPaneSmartViewQU4?: string | undefined;
    soidFindDocPreviewPaneSmartViewQU5?: string | undefined;
    soidFindDocPreviewPaneSmartViewCO1?: string | undefined;
    soidFindDocPreviewPaneSmartViewCO2?: string | undefined;
    soidFindDocPreviewPaneSmartViewCO3?: string | undefined;
    soidFindDocPreviewPaneSmartViewCO4?: string | undefined;
    soidFindDocPreviewPaneSmartViewCO5?: string | undefined;
    soidFindDocPreviewPaneSmartViewPO1?: string | undefined;
    soidFindDocPreviewPaneSmartViewPO2?: string | undefined;
    soidFindDocPreviewPaneSmartViewPO3?: string | undefined;
    soidFindDocPreviewPaneSmartViewPO4?: string | undefined;
    soidFindDocPreviewPaneSmartViewPO5?: string | undefined;
    soidFindDocPreviewPaneSmartViewCN1?: string | undefined;
    soidFindDocPreviewPaneSmartViewCN2?: string | undefined;
    soidFindDocPreviewPaneSmartViewCN3?: string | undefined;
    soidFindDocPreviewPaneSmartViewCN4?: string | undefined;
    soidFindDocPreviewPaneSmartViewCN5?: string | undefined;
    soidSalesOrderAllowChangeCurrencies?: string | undefined;
    soidSalesOrderChangeTakenBy?: string | undefined;
    soidSalesOrderForceSupplierReview?: string | undefined;
    soidSalesOrderWarnIfDirectCostNotChanged?: string | undefined;
    soidSalesOrderMaximumReservationDays?: string | undefined;
    soidSalesOrderAllowDirectSalesInCounterSales?: string | undefined;
    soidSalesOrderOnlyApproveIssuedOrders?: string | undefined;
    soidSalesOrderParkedOrderFormats?: string | undefined;
    soidSalesOrderWaitForNewStockOnBackOrder?: string | undefined;
    soidSalesOrderWarnIfOrderLinePriceIsZero?: string | undefined;
    soidSalesOrderDeliveryAreaRequired?: string | undefined;
    soidSalesOrderAllowCashBackOnCashSales?: string | undefined;
    soidSalesOrderMaintainTakenByFromOriginalOrderOnBackOrder?: string | undefined;
    soidMarkOrderApprovedWhenStockIssued?: string | undefined;
    soidDefaultSpecialOrderQtyChangeToCreateBackOrder?: string | undefined;
    soidOrdersSuppressStockUpdatesDuringEntry?: string | undefined;
    soidOrdersProductCodeColumnContent?: string | undefined;
    soidOrdersReserveStockOnCallOff?: string | undefined;
    soidOrdersAutoApplyDeliveryCharges?: string | undefined;
    soidOrdersDisplayCommissionCode?: string | undefined;
    soidOrdersForceSupplierToBeChangedWhenSupplierIs?: string | undefined;
    soidSignatureCaptureCollectNow?: string | undefined;
    soidSignatureCaptureCollectLater?: string | undefined;
    soidOrdersShowBinLocationFromSROnSOLine?: string | undefined;
    soidOrderExcludeParkedOrdersFromOnOrderBalance?: string | undefined;
    soidOrdersDisplayStockLocationOnOrderEntry?: string | undefined;
    soidOrdersDefaultVehicleType?: string | undefined;
    soidOrdersDefaultOrderMonitorToAllBranches?: string | undefined;
    soidOrdersDefaultSellPriceFromParentNATally?: string | undefined;
    soidOrdersDefaultCustomerSearchOnOrdersToAddress?: string | undefined;
    soidOrdersManualLineDeliveryChargeExclusionCode?: string | undefined;
    soidOrdersDisplayTotalCostInOrderTotals?: string | undefined;
    soidOrdersAutoApplyRebateAccruals?: string | undefined;
    soidOrdersDisplayNegWarningOnGeneral?: string | undefined;
    soidOrdersAllowOverrideOfRebateSaleType?: string | undefined;
    soidOrdersOnlyCalcTransferCostForBranchesWithStock?: string | undefined;
    soidOrdersEnableMultipleBranches?: string | undefined;
    soidOrdersMixedBranchRestrictions?: string | undefined;
    soidOrdersAllowMixedSaleTypesOnOrders?: string | undefined;
    soidOrdersEnterAddressViaForm?: string | undefined;
    soidOrdersCallOffAllowCreateSOFromMultipleCallOffs?: string | undefined;
    soidOrdersEnableCollectNow?: string | undefined;
    soidOrdersEnableCollectLater?: string | undefined;
    soidOrdersEnableDelivered?: string | undefined;
    soidOrdersEnableDirect?: string | undefined;
    soidOrdersShowQuickProductsInCounter?: string | undefined;
    soidOrdersAllowTextLines?: string | undefined;
    soidOrdersAllowCustomerLookupByAddress?: string | undefined;
    soidOrdersAllowMultipleSalesRepPerOrder?: string | undefined;
    soidOrdersMinimumDeposit?: string | undefined;
    soidOrdersMergeDirectPOsForSameSO?: string | undefined;
    soidOrdersWarnIfVehicleTypeNotSet?: string | undefined;
    soidOrdersCallOffScheduleColumn1Heading?: string | undefined;
    soidOrdersCallOffScheduleColumn2Heading?: string | undefined;
    soidOrdersPromptForPacksIfAlwaysPackSelling?: string | undefined;
    soidOrdersAllowIssuingStockFromOtherBranches?: string | undefined;
    soidOrdersAllowIssuingBranchWithReadOnlyAccess?: string | undefined;
    soidOrdersKeepDeliveryAddressForCollectSales?: string | undefined;
    soidOrdersHideAvailableCreditOnSO?: string | undefined;
    soidOrdersCopyProductInternalLineNotesToLineNotes?: string | undefined;
    soidOrdersPromptToMarkOrderAsCollectedOnSaveAndClose?: string | undefined;
    soidOrdersAllowChangeOfNotesAndTypeOnOrdersInvoiced?: string | undefined;
    soidOrdersAllowFractionalKits?: string | undefined;
    soidOrdersSortByBinLocationWhenConsolidatingProductLines?: string | undefined;
    soidOrdersSpecialsCopyEnvironmentalStatus?: string | undefined;
    soidOrdersCanChangeSaleTypeIfCardholderNotPresentPayment?: string | undefined;
    soidOrdersIgnoreAllowProceedonStockWarningforBackOrder?: string | undefined;
    soidDisableOtherSizeOptionForStockByLengthProductsOnOrders?: string | undefined;
    soidOrdersDisplayOrderNumberDialog?: string | undefined;
    soidOrdersSkipOrderCompletionDialog?: string | undefined;
    soidOrdersWarnSupplierMinAmountOnPOs?: string | undefined;
    soidPickVehicleWhenMarkingOrderAsDelivered?: string | undefined;
    soidShowTotalQuantityInformationinCounterSales?: string | undefined;
    soidForceAddressSelectionInCounterSales?: string | undefined;
    soidCopySellPriceAndCostOnSpecialOrderCopyFromBaseItem?: string | undefined;
    soidUpdateExistingPOOnDirectBO?: string | undefined;
    soidOrdersApplyEnvironmentalStatusRestrictions?: string | undefined;
    soidOrdersShowChangeInformationDuringPrint?: string | undefined;
    soidOrdersReasonCodeOnLineAmend?: string | undefined;
    soidAllowLadingQuantityEntryDuringPicking?: string | undefined;
    soidOrdersMinimumDepositThreshold?: string | undefined;
    soidOrdersRequireFullPaymentWhenBelowMinimumDepositThreshold?: string | undefined;
    soidOrdersDisplayMinimumDepositOverrideButton?: string | undefined;
    soidOrdersSpecialLinesOnCashSalesMustBePaidInFull?: string | undefined;
    soidOrdersShowTaxAreaButton?: string | undefined;
    soidOrdersBackOrderReleaseCheckAvailableStock?: string | undefined;
    soidOrdersCheckMinimumDepositOnBackOrders?: string | undefined;
    soidOrdersPromptForReferenceInCounter?: string | undefined;
    soidWarnWhenDateRequiredMonthsInAdvance?: string | undefined;
    soidOrderFixOriginalQtyAt?: string | undefined;
    soidForceAddressSelectionInOperations?: string | undefined;
    soidOrdersDisplayPaymentScreenOnModifiedDeliveredCashSale?: string | undefined;
    soidSalesOrderSetDefaultSupplierOnDirects?: string | undefined;
    soidOrdersOpenPurchaseOrders?: string | undefined;
    soidOrdersLargeKitProcessing?: string | undefined;
    soidOrdersEnableEditQtyAndPriceInGrid?: string | undefined;
    soidTransferCreatorModify?: string | undefined;
    soidTransferCreatedByReceivingBranch?: string | undefined;
    soidTransferAutoApplyDeliveryCosts?: string | undefined;
    soidTransferReceiptConfirmationFormat?: string | undefined;
    soidTransferCanChangeViaBranch?: string | undefined;
    soidTransferCostCalculation?: string | undefined;
    soidTransferReturnAutoApplyDeliveryCosts?: string | undefined;
    soidDefaultTransferSaleType?: string | undefined;
    soidTransferSplitPacksToLoose?: string | undefined;
    soidTransferRequireUpdateAccessForToBranch?: string | undefined;
    soidTransferAllowZeroCost?: string | undefined;
    soidTransferAllowToBeLessThanCurrentCost?: string | undefined;
    soidTransferRequirePackConfirmation?: string | undefined;
    soidTransferApplyUplifts?: string | undefined;
    soidTransferBranchAccessLevelRequiredForFromBranch?: string | undefined;
    soidTransferReturnAtOriginalCost?: string | undefined;
    soidTransferRequireSendingBranchApproval?: string | undefined;
    soidTransferApprovalRequiredBeforeAllocation?: string | undefined;
    soidTransferSuggestionQuantity?: string | undefined;
    soidTransferDontApproveAllocateStockTransfersLinkedToPOUntilReceived?: string | undefined;
    soidTransferReturnUseOriginalBranchInGLTransferUplift?: string | undefined;
    soidTransferDateRequiredFromManufacturedSpecials?: string | undefined;
    soidCalculateBranchTransferCostsBasedOnTotalValues?: string | undefined;
    soidTransferDateRequiredDaysBetweenPOAndLinkTransfers?: string | undefined;
    soidTransferUpdateDateRequiredWhenLinkedSODateRequiredChanges?: string | undefined;
    soidOrdersNewOneTimeAddressIsBlank?: string | undefined;
    soidTransferReceiveInBranchesNotLoggedIn?: string | undefined;
    soidTransferCopyOrderLineAVOsToTransferLineWhenSourcedFromTransfer?: string | undefined;
    soidTransferUseVMICostForBranchTransferCostOnVMIProducts?: string | undefined;
    soidOrdersCopyFromSelectMultipleTemplates?: string | undefined;
    soidUpdateSpecialOrderCostOnChangesOnPO_SR_SI?: string | undefined;
    soidLumpSumSectionsOnCopyFrom?: string | undefined;
    soidConsolidatePositiveQuantitiesWithinSectionsByDefault?: string | undefined;
    soidOpenOrderLinePropertiesForRelatedProducts?: string | undefined;
    soidOrdersNotifyIfDeletedLinesOnSalesTransactionCopy?: string | undefined;
    soidOrderSectionsToMaintainSectionPrice?: string | undefined;
    soidBackToBackIgnoresHowSourced?: string | undefined;
    soidSectionSelectionBoxType?: string | undefined;
    soidOrdersPromptForBuyPriceRuleOnBackToBackPO?: string | undefined;
    soidOrdersAllowChangingSaleTypeAndDeliveryAfterPicking?: string | undefined;
    soidOrdersAllowChangingScheduledSalesOrders?: string | undefined;
    soidDefaultAddressTypeWhenCreatedFromSalesOrders?: string | undefined;
    soidCreateJobAddressesInSalesTransactionWithQuickJobScreen?: string | undefined;
    soidApplyPermissionsOnChangesWithPickingNotePrintedToDeliveredOrdersOnly?: string | undefined;
    soidTransfersAdvanceDaysFromOrder?: string | undefined;
    soidAllowEditingKitsAfterBackToBackPurchaseOrderApproved?: string | undefined;
    soidParkOrdersWhenWorkOrderDateRequiredFull?: string | undefined;
    soidOrdersPromptDuringOrderEntryWhenDefaultBatchDoesNotExist?: string | undefined;
    soidOrdersPromptDuringPickingWhenDefaultBatchDoesNotExist?: string | undefined;
    soidSuggestedOrdersIncludeSuggestionsInStockAvailable?: string | undefined;
    soidAllowAdjustmentOfQuantityDuringReceiptOfStockTransfer?: string | undefined;
    soidReasonCodeForACAGenearatedFromQuantityAdjustmentTransfers?: string | undefined;
    soidOrdersUseAlternatePaymentTermsByProductGroup?: string | undefined;
    soidWMSOnlyReleaseLinesAvailForPickWhenSplitDelivAllowed?: string | undefined;
    soidFindProductSmartView1?: string | undefined;
    soidFindProductSmartView2?: string | undefined;
    soidFindProductSmartView3?: string | undefined;
    soidFindProductSmartView4?: string | undefined;
    soidFindProductSmartView5?: string | undefined;
    soidFindCustomerSmartView1?: string | undefined;
    soidFindCustomerSmartView2?: string | undefined;
    soidFindCustomerSmartView3?: string | undefined;
    soidFindCustomerSmartView4?: string | undefined;
    soidFindCustomerSmartView5?: string | undefined;
    soidJourneyPlannerSmartView1?: string | undefined;
    soidJourneyPlannerSmartView2?: string | undefined;
    soidJourneyPlannerSmartView3?: string | undefined;
    soidJourneyPlannerSmartView4?: string | undefined;
    soidJourneyPlannerSmartView5?: string | undefined;
    soidOrderQuotesForceFollowUp?: string | undefined;
    soidOrderQuotesFollowUpDays?: string | undefined;
    soidOrderQuotesFollowUpNotepadType?: string | undefined;
    soidOrderQuotesApplyMarginWarningAndStops?: string | undefined;
    soidOrderQuotesAllowPark?: string | undefined;
    soidOrderQuotesAllowPrintWhenSupplierRequestExists?: string | undefined;
    soidOrderQuotesCopyCreatedByUserAndOrderingBranch?: string | undefined;
    soidOrderQuotesAllowMultipleAccept?: string | undefined;
    soidOrderQuotesForceRecalculateWhenAcceptingExpiredQuote?: string | undefined;
    soidOrderQuotesUseTakenByFromQuoteWhenAcceptingIntoOrder?: string | undefined;
    soidOrderQuotesAllowBlankText?: string | undefined;
    soidOrderQuotesExcludeQuotesFromPromotionalPricing?: string | undefined;
    soidOrdersDontCompleteOrdersWhenWorkOrdersNeedStock?: string | undefined;
    soidOrdersCompleteDeliveredOrdersWhenDateRequiredIsFull?: string | undefined;
    soidUseSearchForTakenBy?: string | undefined;
    soidSimpleOrderProcessCollectNow?: string | undefined;
    soidSimpleOrderProcessCollectLater?: string | undefined;
    soidSimpleOrderProcessDelivered?: string | undefined;
    soidSimpleOrderProcessDirect?: string | undefined;
    soidSimpleOrderProcessTransfer?: string | undefined;
    soidSimpleOrderControlAVOProcessing?: string | undefined;
    soidSimpleOrderPreAllocateOrderInvoiceNo?: string | undefined;
    soidSimpleConfirmPicking?: string | undefined;
    soidSimpleConfirmDelivery?: string | undefined;
    soidSimpleConfirmPODReturned?: string | undefined;
    soidSimplePrintPickingNoteOnPark?: string | undefined;
    soidSimpleDeliveryAfterPickingConfirmed?: string | undefined;
    soidSimpleOnlyAllowDeliveryPrintAfterMarked?: string | undefined;
    soidSimpleAutoIssueOnMarkAsDelivered?: string | undefined;
    soidSimpleOnlyInvoiceDirectsAfterSuppInv?: string | undefined;
    soidSimpleAllowPickDeliveryPrintWhenWaitingForStock?: string | undefined;
    soidSimpleDontIssueIfNegativeStock?: string | undefined;
    soidSimplePickingNoteFormat?: string | undefined;
    soidSimpleDeliveryNoteFormat?: string | undefined;
    soidSimpleCollectionNoteFormat?: string | undefined;
    soidSimpleDepositReceiptFormat?: string | undefined;
    soidSimpleDeliveryFormatSetCash?: string | undefined;
    soidSimpleOrderPickingStyle?: string | undefined;
    soidSimpleOrderPickingZonesFormatNumbers?: string | undefined;
    soidSimpleTransferDeliveryFormatSet?: string | undefined;
    soidSimplePrintDocumentsOnBackOrder?: string | undefined;
    soidSimpleOnlyInvoiceWhenCODFullyPaid?: string | undefined;
    soidSimpleOrderRecordPickingStarted?: string | undefined;
    soidSimpleOrderOnlyApproveIfJourneyComplete?: string | undefined;
    soidSimpleAutoIssueOnInvoiceIfNotYetIssued?: string | undefined;
    soidSimpleAVOFormatSet?: string | undefined;
    soidSimpleAdditionalCostFormat?: string | undefined;
    soidSimplePromptForDeliveryInAdvancedPicking?: string | undefined;
    soidSimplePromptUserIfQtyPickedNotEqualToQtyOrdered?: string | undefined;
    soidSimpleDeliveryFormatSetCredit?: string | undefined;
    soidSimpleCollectLaterFormatSetCash?: string | undefined;
    soidSimpleCollectLaterFormatSetCredit?: string | undefined;
    soidSimpleRequireReasonCodeOnPickShortage?: string | undefined;
    soidSimplePrintPickingNoteWhenStockAvailable?: string | undefined;
    soidSimpleDepositReceiptOnFinalPayment?: string | undefined;
    soidDefaultBackOrderBehaviourInAdvancedPicking?: string | undefined;
    soidSimpleCollectNowPickingDocumentFormatSet?: string | undefined;
    soidSimpleAllowAutoMarkPickWhenUsingAdvancedPicking?: string | undefined;
    soidSimpleAutoPrintSpecialOrderAcknowledgementDocument?: string | undefined;
    soidSimpleSpecialOrderAcknowledgementDocumentFormatSet?: string | undefined;
    soidSimpleDisplayBinLocationOnPickingConfirmation?: string | undefined;
    soidSimpleAllowPackReferenceScanningOnPickingConfirmation?: string | undefined;
    soidSimpleAllowPickingNotePrintOnDeliveredCashSaleWithOutstandingBalance?: string | undefined;
    soidSimpleAllowdeliveryNotePrintOnDeliveredCashSaleWithOutstandingBalance?: string | undefined;
    soidSimpleOrderAmendPrintFormatSet?: string | undefined;
    soidSimpleOrderAmendPrintHandling?: string | undefined;
    soidSimpleOrderAllowUnpickIfInvoiced?: string | undefined;
    soidDefaultPrintDeliveryNoteDocumentSet?: string | undefined;
    soidPrintDeliveryNoteFormatWhenMarkingDelivered?: string | undefined;
    soidOrderAllowQuantityLessThanPicked?: string | undefined;
    soidSimpleOrderDefaultPickingZoneFromOrderMonitor?: string | undefined;
    soidSimpleOrderHideItemsWhichAreNotInSelectedZone?: string | undefined;
    soidSimpleOrderDefaultMOLTasPickedInAdvancedPicking?: string | undefined;
    soidSimpleOrderOnlyReleaseBackOrderWithSingleDeliveryOption?: string | undefined;
    soidSimpleConfirmChecked?: string | undefined;
    soidDefaultPrintPickingNoteWhenMarkingPickStarted?: string | undefined;
    soidScanActionBarcodesInBatchUpdate?: string | undefined;
    soidSimpleDeliveryAfterChecked?: string | undefined;
    soidOrdersAllowCompleteWhenJobIsPreliminary?: string | undefined;
    soidCheckPickingRequiredFlagWhenDeterminingPickingZonePrintingFormats?: string | undefined;
    soidSimpleOrderSetDefaultReleaseQuantityToAll?: string | undefined;
    soidIncludeUnapprovedOrdersInOrdersForInvoicingFilter?: string | undefined;
    soidOrdersAllowChangingUOMsinQtyAndQtyPriceEntry?: string | undefined;
    soidShowMsgWhenPickingLessSpecialOrderThanAvailable?: string | undefined;
    soidSimpleOrderLimitPickingAndCheckedByUsersByBranch?: string | undefined;
    soidSimpleOrderDefaultPickingStartedUserToFirstAvailable?: string | undefined;
    soidPrintDeliveryNoteDocumentSetWhenMarkingDelvOrdersPicked?: string | undefined;
    soidSimpleOrderRecordPickComplete?: string | undefined;
    soidPromptSignatureWhenCompletingCollectNowOrderThatGoesCreditHold?: string | undefined;
    soidPromptSignatureWhenChangingWMSOrderTypeToCollectLaterNow?: string | undefined;
    soidUseSignatureCaptureSettingsForCollectNowWhenCompletingCollectLaterNow?: string | undefined;
    soidSimpleOrderEnableMarkFullyPicked?: string | undefined;
    soidDisplayAwaitingStockWarningMessagesInPickingConfirmation?: string | undefined;
    soidBackOrderEntireSingleDeliveryOrderWhenAnyLineBackOrdered?: string | undefined;
    soidWMSDefaultBackOrderBehaviour?: string | undefined;
    soidWMSMarkOrdersDeliveredWhenPickCompletedFromWMS?: string | undefined;
    soidCashSalesPercentToleranceForTalliedTimber?: string | undefined;
    soidCashSalesAmountToleranceForTalliedTimber?: string | undefined;
    soidCashSalesPercentToleranceForNonTalliedTimber?: string | undefined;
    soidCashSalesAmountToleranceForNonTalliedTimber?: string | undefined;
    soidCashSalesPercentToleranceForProductSubstitutions?: string | undefined;
    soidCashSalesAmountToleranceForProductSubstitutions?: string | undefined;
    soidCashSalesRestrictFullyPaidCashSaleToSameProductGroup?: string | undefined;
    soidCashSalesRunWithNewCashBehaviour?: string | undefined;
    soidCashSalesEnableToleranceChecking?: string | undefined;
    soidCashSalesAutoFinalizeDaily?: string | undefined;
    soidCashSalesForceAddressCollectNow?: string | undefined;
    soidCashSalesForceAddressCollectLater?: string | undefined;
    soidCashSalesOrderMaximumCashAllowed?: string | undefined;
    soidCashSalesAllowDepositGreaterThanOrderTotal?: string | undefined;
    soidCashSalesPostCheckOverpaymentAsChangeDue?: string | undefined;
    soidSimpleOnlyAllowDeliverySetPrintAfterMarked?: string | undefined;
    soidForceSelectionOfReasonCodeForLodgement?: string | undefined;
    soidCashSalesRetainInvoiceAddressWhenCopyingCashSales?: string | undefined;
    soidCashSalesDepositReceiptOnBackOrders?: string | undefined;
    soidDefaultLodgementPostingDate?: string | undefined;
    soidAllowLodgementsOnCreditAndDebitCards?: string | undefined;
    soidSortPaymentMethodByPaymentMethodCode?: string | undefined;
    soidReturnToPaymentDetailsAfterFullyPaid?: string | undefined;
    soidCashSalesAllowDeliveryCollectionOfUnpaid?: string | undefined;
    soidDefaultContractSchedule?: string | undefined;
    soidPostInstalledSalesShipmentsToManualOrderInvoicingLines?: string | undefined;
    soidPostSalesAmountAtTimeOfMaterialShipment?: string | undefined;
    soidForceSelectionOfAddressOnContractCreation?: string | undefined;
    soidDefaultOrdersAndCallOffsToUseOpenContracts?: string | undefined;
    soidAllowMultipleCallOffOrdersOnContracts?: string | undefined;
    soidDefaultMarginForPostCostToWIPMethod?: string | undefined;
    soidAccruedARInstalledSalesVarianceMOLT?: string | undefined;
    soidContractsCopyFromDefaultDocType?: string | undefined;
    soidContractsCopyFromDefaultConsolidateByMOLT?: string | undefined;
    soidAllowSettingTaxAreaOnContracts?: string | undefined;
    soidContractsIncludeSalesTaxAmountDuringCopySections?: string | undefined;
    soidAllowSettingRetentionPercentageOnContractInvoicingLines?: string | undefined;
    soidAutoCloseContractsWithNoTransactionsInNumberOfDays?: string | undefined;
    soidIncludeTaxInRetentionCalculations?: string | undefined;
    soidAllowSelectingJobAddressOnContractBillingLine?: string | undefined;
    soidShowTimberFunctionality?: string | undefined;
    soidTimberSplitPackRefSuffix?: string | undefined;
    soidTimberAllowSplitToLoose?: string | undefined;
    soidTimberSplitPackVolumeWarningTreshold?: string | undefined;
    soidTimberDuplicatePackReferenceOption?: string | undefined;
    soidTimberTallyLengthDecimalPlaces?: string | undefined;
    soidTimberPackTallyInput?: string | undefined;
    soidTimberAutoAllocatePackBarCodes?: string | undefined;
    soidTimberAllowDecimalPlacesOnNumberOfSheets?: string | undefined;
    soidTimberInputAdvanced?: string | undefined;
    soidTimberInputShowStdLengths?: string | undefined;
    soidTimberInputNoOfBlankRows?: string | undefined;
    soidTimberInputColumnSequence?: string | undefined;
    soidTimberAutoSetPackType?: string | undefined;
    soidTimberPercForAPTL?: string | undefined;
    soidTimberInputMaskContractRef?: string | undefined;
    soidTimberInputMaskContractPeriod?: string | undefined;
    soidTimberInputMaskShip?: string | undefined;
    soidTimberInputMaskVoyage?: string | undefined;
    soidTimberInputMaskBOLRef?: string | undefined;
    soidTimberInputMaskShipPackRef?: string | undefined;
    soidTimberPackVolFormatString?: string | undefined;
    soidTimberPackShowPackEstimate?: string | undefined;
    soidTimberDefaultStatusOnStockReceipt?: string | undefined;
    soidTimberPackQuantityAbbreviation?: string | undefined;
    soidTimberSplitPackAllowHigherVolume?: string | undefined;
    soidTimberUsePackSubstitution?: string | undefined;
    soidTimberPackVolDecimalPlaces?: string | undefined;
    soidTimberPackLengthDecimalPlaces?: string | undefined;
    soidTimberPackFindDefaultView?: string | undefined;
    soidTimberPackTallyDisplayAvailableOrActual?: string | undefined;
    soidTimberSplitPackReasonCode?: string | undefined;
    soidTimberInputRoundToNearestTallyLength?: string | undefined;
    soidTimberUseTallyCalculator?: string | undefined;
    soidTimberStockShortageWarningOnSOTally?: string | undefined;
    soidTimberOrdersShowInvalidTallyWarnings?: string | undefined;
    soidTimberAllowBulkChangeStockLocationOnFreePacks?: string | undefined;
    soidTimberDefaultNATalliedScreenToSplitTallyOnPO?: string | undefined;
    soidTimberAllowDifferentTallySelectionOnSalesTransactions?: string | undefined;
    soidTimberRetainPackRefWhenReuseSourceOnWorksOrders?: string | undefined;
    soidTimberIncludeFreePacksAsAvailable?: string | undefined;
    soidTimberIncludePackStockAsAvailableOnTallyInput?: string | undefined;
    soidTimberInputLimitToNoOfBlankRows?: string | undefined;
    soidTimberDisplayTallyLengthsInProductFindForAvailableStock?: string | undefined;
    soidTimberDefaultUsePackPriceSurcharge?: string | undefined;
    soidTimberAllowDifferentTallySelectionOnWorksOrderSourceLines?: string | undefined;
    soidTimberCopyParentTallyAndQuantityToNotesWhenTallySplit?: string | undefined;
    soidPacksAutoSplitOnPackConfirmation?: string | undefined;
    soidPacksCopyAttachmentsDuringSplit?: string | undefined;
    soidPacksReuseSourcePacksOnFinishedProducts?: string | undefined;
    soidAllowPartialCreditOfTaggedPacks?: string | undefined;
    soidTimberShowProductLinealFeetPercentage?: string | undefined;
    soidShowSteelFunctionality?: string | undefined;
    soidProfileSalesAnalysisCode?: string | undefined;
    soidDefaultProfileMachine?: string | undefined;
    soidDefaultProfileManualOrderLineType?: string | undefined;
    soidSteelPickingWeightDifferenceLow?: string | undefined;
    soidSteelPickingWeightDifferenceHigh?: string | undefined;
    soidAllowWeightAsStockingUnitOfMeasure?: string | undefined;
    soidEnableAlternateUnitOfMeasureForTallyLengths?: string | undefined;
    soidShowTestCertificateFunctionality?: string | undefined;
    soidTestCertificateAttachmentFolder?: string | undefined;
    soidEnableAVOTolerances?: string | undefined;
    soidMetalConformanceCertificateFormatNumber?: string | undefined;
    soidOrdersOrderLineAdditionalInfoDisplay?: string | undefined;
    soidSignatureCaptureDelivered?: string | undefined;
    soidSignatureCaptureDirect?: string | undefined;
    soidSignatureCaptureCollectLaterCash?: string | undefined;
    soidCalculateDeliveryChargesCostsBasedOnTotalValues?: string | undefined;
    soidCalculateDeliveryChargesAtLineLevelOnly?: string | undefined;
    soidRequireUserToAcceptSignaturesFromSignatureCapture?: string | undefined;
    soidDisplayMarginAndCostDuringQuickAddEntry?: string | undefined;
    soidDisplayExtendedOrderLineQuantityInformation?: string | undefined;
    soidOrdersAllowDisablingAndEditingOfDeliveryChargesWithPermission?: string | undefined;
    soidOrdersShowSaleTypeInDocumentInformationBar?: string | undefined;
    soidOrdersBackOrderReleaseCheckPackAndLooseAvailableStock?: string | undefined;
    soidOrdersForceUpperCaseAddress?: string | undefined;
    soidUpdateSpecialOrderSalesQuantityWithQuantityReceived?: string | undefined;
    soidAllowCompanyChequeOnOrdersCreatedFromCreditNotes?: string | undefined;
    soidOrdersCustomerJobInstructionsAsAutoText?: string | undefined;
    soidOrdersCalcDeliveryAndAllowCODonOrdersWithJustMOLTlines?: string | undefined;
    soidOrdersUsingF6GoesToCustomerField?: string | undefined;
    soidOrdersProrateDepositsDuringBackOrder?: string | undefined;
    soidOrdersOpenPurchaseOrdersOnSalesOrderUpdate?: string | undefined;
    soidOrdersAutomaticallyReleaseBackOrders?: string | undefined;
    soidOrdersAllowChangeOfVehicleAndDeliveryTimeOnOrdersInvoiced?: string | undefined;
    soidCheckMinimumDepositWhenOrderIsModified?: string | undefined;
    soidDisableAdditionalCostDeliveryChargesWhenDeliveryChargesAreDisabled?: string | undefined;
    soidbTAStatementsAlwaysPrintImages?: string | undefined;
    soidbTAFinanceChargeDefaultOverdueBy?: string | undefined;
    soidbTAFinanceChargeDefaultMonthlyFinanceChargePercent?: string | undefined;
    soidbTAFinanceChargeDefaultRevolvingAccountGrace?: string | undefined;
    soidbTAStatementGenerateDefaultIncludeCustomersWithNoTransactions?: string | undefined;
    soidbTAStatementGenerateDefaultTransactionsToInclude?: string | undefined;
    soidbTAStatementGenerateDefaultConsolidateGroupAccounts?: string | undefined;
    soidbTAStatementGenerateDefaultIndividualChildStatements?: string | undefined;
    soidbTAStatementSendDefaultIncludeStatementsWithZeroBalance?: string | undefined;
    soidbTAStatementSendDefaultIncludeFullyPaidTransactions?: string | undefined;
    soidbTACustomerStatementByJobReportName?: string | undefined;
    soidbTASummaryStatementReportName?: string | undefined;
    soidbTAAllowGeneratingStatementsByJob?: string | undefined;
    soidbTACanGenerateFinChargesByCustomerGroup?: string | undefined;
    soidbTADefaultAccountPaymentToCustomersHomeBranch?: string | undefined;
    soidbTAAccountPaymentCreditCardSurchargePercentage?: string | undefined;
    soidbTADirectPostingReasonCodeForAccountPaymentCreditCardSurcharge?: string | undefined;
    soidbTAAccountPaymentCreditCardSurchargeType?: string | undefined;
    soidbTAAllowMatchingTransactionsBetweenARAccounts?: string | undefined;
    soidbTAReasonCodeToUseForInterBranchDirectPostings?: string | undefined;
    soidbTAAllowSelectionOfPaymentMethodInBatchCasPosting?: string | undefined;
    soidbTAUseAcctPmtsInsteadOfCashPosting?: string | undefined;
    soidbTAAllowTakingDepositsOnARSalesOrders?: string | undefined;
    soidPopupJourneyDateVisible?: string | undefined;
    soidPopupJourneyDriverVisible?: string | undefined;
    soidPopupJourneyVehicleVisible?: string | undefined;
    soidPopupJourneyWeightVisible?: string | undefined;
    soidPopupJourneyDropsVisible?: string | undefined;
    soidPopupJourneyVolumeVisible?: string | undefined;
    soidJourneyPlannerGroupJourneysByReference?: string | undefined;
    soidJourneyPlannerTimeFrame?: string | undefined;
    soidJourneyPlannerFirstDayOfWeek?: string | undefined;
    soidJourneyPlannerWorkingDays?: string | undefined;
    soidJourneyPlannerStartOfDay?: string | undefined;
    soidJourneyPlannerEndOfDay?: string | undefined;
    soidJourneyPlannerTimeInterval?: string | undefined;
    soidJourneyPlannerWeightDecimalPlaces?: string | undefined;
    soidJourneyPlannerVolumeDecimalPlaces?: string | undefined;
    soidJourneyOnlyAllowTransportCostsForPicked?: string | undefined;
    soidJourneyAllowCompleteWithNoTransportCost?: string | undefined;
    soidJourneyApplyTransportCostsOnCompletion?: string | undefined;
    soidJourneyApplyTransportCostsTo?: string | undefined;
    soidJourneyPromptForCreditHoldOrParkedOrders?: string | undefined;
    soidJourneyPlannerBranchViewDefault?: string | undefined;
    soidJourneyPlannerTimeIntervalForCalendar?: string | undefined;
    soidJourneyPlannerGroupJourneysByDriver?: string | undefined;
    soidJourneyShowAdditionalCostsOnJourney?: string | undefined;
    soidJourneyAutoRemoveAndAddDocumentsToRelatedAddCostChargeProRates?: string | undefined;
    soidJourneyIncludePOWeight?: string | undefined;
    soidJourneyPlannerLimitToBranchVehicles?: string | undefined;
    soidJourneyMarkOrdersDeliveredWhenJourneyMarkedInProgress?: string | undefined;
    soidJourneyPlannerDisplayVIN?: string | undefined;
    soidJourneyEnableAutomaticScheduledRoutes?: string | undefined;
    soidJourneyPromptForExistingJourneyWithTheSameAddress?: string | undefined;
    soidJourneyPlannerAutoRefreshInterval?: string | undefined;
    soidJourneyAllowLinkingTrailersToTruchAndTrailerVehicles?: string | undefined;
    soidJourneyReferenceRequired?: string | undefined;
    soidJourneyShowWarningWhenDocumentDateRequiredDontMatchJourneyDate?: string | undefined;
    soidJourneyEnableAllowMultipleDeliveryAreasInJourney?: string | undefined;
    soidJourneyDefaultUnloadTimePerStop?: string | undefined;
    soidJourneyShowCreditNotePrintedInDocumentList?: string | undefined;
    soidJourneyPlannerAutoAddUnusedVehicles?: string | undefined;
    soidJourneyMarkDatesFull?: string | undefined;
    soidDirectionsSource?: string | undefined;
    soidAddressingSource?: string | undefined;
    soidAddReturnToStart?: string | undefined;
    soidCustomerMapPointFolder?: string | undefined;
    soidDirectionsGoogleMapsURL?: string | undefined;
    soidDirectionsBingMapsURL?: string | undefined;
    soidDirectionsAddressPattern?: string | undefined;
    soidVehicleTrackingSoftwareService?: string | undefined;
    soidVehicleTrackingWebServiceLocation?: string | undefined;
    soidVehicleTrackingClientAccessCode?: string | undefined;
    soidVehicleTrackingSpeedSuffix?: string | undefined;
    soidVehicleTrackingClientPassword?: string | undefined;
    soidVehicleTrackingInternetMapURL?: string | undefined;
    soidCustomerAddressMapGridSettings?: string | undefined;
    soidPassAddressCoordinatesForInternetMapping?: string | undefined;
    soidShowMapDirectlySkippingVehicleLocationForm?: string | undefined;
    soidDirectionsGMapsDirectionsURL?: string | undefined;
    soidDirectionsGMapsDirectionsKey?: string | undefined;
    soidWorksOrderWasteWarning?: string | undefined;
    soidDefaultToManufactured?: string | undefined;
    soidWorksOrderPrintOnChange?: string | undefined;
    soidWorksOrderEnableCalendarScheduling?: string | undefined;
    soidWorksOrderConsolidateIdenticalWOProcessesOnWOSchedule?: string | undefined;
    soidWorksOrderHybridCostingWarning?: string | undefined;
    soidWorksOrderSourcePrefixText?: string | undefined;
    soidWorksOrderNewLineAfterSourcePrefix?: string | undefined;
    soidWorksOrderProcessPrefixText?: string | undefined;
    soidWorksOrderFinishedPrefixText?: string | undefined;
    soidWorksOrderNewLineAfterFinishedPrefix?: string | undefined;
    soidWorksOrderSOWaitForStock?: string | undefined;
    soidWorksOrderAllowProcessingIfCreditControl?: string | undefined;
    soidWorksOrderAllowFinishCostOverride?: string | undefined;
    soidWorksOrderCreateProductsOnManufactured?: string | undefined;
    soidWorksOrderForceCreateOnManufactured?: string | undefined;
    soidCreateGLTransactionsWorksOrder?: string | undefined;
    soidWorksOrderBaseSpecialOnProdGroupID?: string | undefined;
    soidWorksOrderIgnoreHowSourcedOnSpecials?: string | undefined;
    soidCreateGLTransactionsCOGS?: string | undefined;
    soidCreateGLTransactionsStockTransfer?: string | undefined;
    soidCreateGLTransactionsSupplierReturns?: string | undefined;
    soidWorksOrderTrussDescription?: string | undefined;
    soidFinancialDescAppendDocRef?: string | undefined;
    soidWorksOrderAutoCopySourceToFinished?: string | undefined;
    soidWorksOrderAllowMultiplePacksWhenConfirmingSourceMaterialPacks?: string | undefined;
    soidWorksOrderEnablePCMInterface?: string | undefined;
    soidWorksOrderPCMInputFileLocation?: string | undefined;
    soidWorksOrderPCMOutputFileLocation?: string | undefined;
    soidWorksOrderPCMPackRefDestination?: string | undefined;
    soidWorksOrderPCMPackPrefix?: string | undefined;
    soidWorksOrderPCMDescriptionField?: string | undefined;
    soidWorksOrderUseDocumentReleaseProcess?: string | undefined;
    soidWorksOrderAlwaysReplaceForConfirmPacks?: string | undefined;
    soidWorksOrderDefaultLinesFromSalesOrderWOCreation?: string | undefined;
    soidWorksOrderAllowPartProcessing?: string | undefined;
    soidWorksOrderCopyAVONotesToOverheadPOManualLineDescription?: string | undefined;
    soidWorksOrderProcessDefaultManualLineType?: string | undefined;
    soidWorksOrderCombineAVOsIntoSinglePurchaseOrder?: string | undefined;
    soidWorksOrderAllowProcessingWorksOrderAwaitingSourceMaterial?: string | undefined;
    soidWorksOrderReviewSuppliersForPOCreatedFromWO?: string | undefined;
    soidWorksOrderForceSourceSelectionForPartProcess?: string | undefined;
    soidWorksOrderUseProcessWorkflow?: string | undefined;
    soidWorksOrderSuppressWorkflowPOPrint?: string | undefined;
    soidWorksOrderProcessPickingFormatSet?: string | undefined;
    soidWorksOrderProcessDeliveryFormatSet?: string | undefined;
    soidWorksOrderProcessCollectionFormatSet?: string | undefined;
    soidWorksOrderProcessReceiptFormatSet?: string | undefined;
    soidWorksOrderDefaultProcessWorksOrder?: string | undefined;
    soidWorksOrderFromOrderRequiredDays?: string | undefined;
    soidWorksOrderAllowDifferentAVOCurrency?: string | undefined;
    soidWorksOrderProcessReadyForCollectionFormatSet?: string | undefined;
    soidWorksOrderDefaultSourceProductsDisplayCostOnCreationToStandardBuy?: string | undefined;
    soidWorksOrderAllowOnJourneyIfHasWorkflow?: string | undefined;
    soidWorksOrderAutoSplitPacksDuringConfirmation?: string | undefined;
    soidWorksOrderDefaultAVOsToSpreadCostToLinesTheyAreBasedOn?: string | undefined;
    soidWorksOrderAllowBranchChangeWhenAllocated?: string | undefined;
    soidWorksOrderAlwaysAllocateStockWhenCopying?: string | undefined;
    soidWorksOrderUpdateDateRequiredWhenSODateRequiredChanges?: string | undefined;
    soidWorksOrderSetSpecialDescriptionFromFinishedLine?: string | undefined;
    soidWorksOrderDisplay_BF_SF_LF_MachineSchedule?: string | undefined;
    soidWorksOrderAveCostAdjReasonForProcessCostAppliedToSO?: string | undefined;
    soidWorksOrderSalesOrderAVOForProcessCostAppliedToSO?: string | undefined;
    soidWorksOrderDefaultNewWOCreation?: string | undefined;
    soidWorksOrderPromptToProcessUponScheduleCompletion?: string | undefined;
    soidWorksOrderDefaultApplyProcessCostsToLinesOnWOCreatedFromSO?: string | undefined;
    soidWorksOrderShowStockWarningOnWOGeneratedFromSO?: string | undefined;
    soidWorksOrderAllowProcessingIfSourceMaterialStockWillGoNegative?: string | undefined;
    soidWorksOrderPromptToPrintLabelsForTaggedPacksWhenWOCompleted?: string | undefined;
    soidWorksOrderPromptToPrintLabelsForTaggedPacksWhenWOProcessed?: string | undefined;
    soidWorksOrderAlwaysCalculateRequiredDateOnCreation?: string | undefined;
    soidWorksOrderSalesOrderAVOForWasteCosts?: string | undefined;
    soidWorksOrderAveCostAdjReasonForWasteCosts?: string | undefined;
    soidStockReceiptPrintOnChange?: string | undefined;
    soidStockReceiptsPreentered?: string | undefined;
    soidStockreceiptQtyOverReceivedWarningThreshold?: string | undefined;
    soidStockReceiptRetainERWhenReceivingPreEnteredPacks?: string | undefined;
    soidStockreceiptQtyUnderReceivedWarningThreshold?: string | undefined;
    soidStockReceiptAutoPrintLabels?: string | undefined;
    soidStockReceiptsRequiresDeliveryDetails?: string | undefined;
    soidStockReceiptsRequiresHaulierDetails?: string | undefined;
    soidStockReceiptsInAdvanceAffectOnOrder?: string | undefined;
    soidStockReceiptsQuickAddInputStyle?: string | undefined;
    soidStockReceiptBackdateERWhenBackdating?: string | undefined;
    soidStockReceiptRequireBinForSpecials?: string | undefined;
    soidInvoiceLowMarginCollected?: string | undefined;
    soidInvoiceLowMarginDelivered?: string | undefined;
    soidInvoiceLowMarginDirect?: string | undefined;
    soidInvoiceHighMargin?: string | undefined;
    soidDefaultInvoicePaymentMethod?: string | undefined;
    soidDefaultInvoicePaymentTerms?: string | undefined;
    soidIncludeOrderTextLinesInInvoice?: string | undefined;
    soidDefaultInvoiceBrowserFilterToUnreleased?: string | undefined;
    soidInvoiceOnMarkDelivered?: string | undefined;
    soidAllowUpdatesOfUnreleasedInvoices?: string | undefined;
    soidInvoiceAllowEditInternalNotesAfterCompletion?: string | undefined;
    soidInvoiceSendSeparateInvoicesForEachJob?: string | undefined;
    soidDefaultInvoiceCostAdjustmentReason?: string | undefined;
    soidAllowInvoiceToBeSentType?: string | undefined;
    soidOnlyMarkInvoicesSentFromBrowser?: string | undefined;
    soidOrdersAutoInvoiceCollectNowChargeOrdersOnCompletion?: string | undefined;
    soidOrdersMarkCollectNowChargeOrdersAsSentWhenInvoicingOnCompletion?: string | undefined;
    soidOrdersAutoInvoiceCollectLaterChargeOrdersOnCompletion?: string | undefined;
    soidInvoiceAutoApproveIfIssued?: string | undefined;
    soidInvoiceAutoSetDateTo?: string | undefined;
    soidInvoiceAutoOnlyIfOrderStatusIsInvoicing?: string | undefined;
    soidCreditDefaultReturnStockToZero?: string | undefined;
    soidCreditReturnStockToReceivingBranch?: string | undefined;
    soidCreditAllowSettlementDiscount?: string | undefined;
    soidCreditUserMustReconfirmPassword?: string | undefined;
    soidCreditRefundAmountToForceCompanyCheque?: string | undefined;
    soidCreditCalculateSellPriceManualLine?: string | undefined;
    soidCreditApplyRestockChargeToOwnBrandProducts?: string | undefined;
    soidCreditFullRestockChargeOnSpecials?: string | undefined;
    soidCreditLockCashRefundsToOriginalPayment?: string | undefined;
    soidCreditUseCustomerCreditsForCustomerReturns?: string | undefined;
    soidCreditRefundAmountToForceGiftCard?: string | undefined;
    soidCreditRefundChequeFormat?: string | undefined;
    soidCreditReturnToSupplierOnDirect?: string | undefined;
    soidCreditConfirmRefundAddress?: string | undefined;
    soidCreditNoteRequestFormatNumber?: string | undefined;
    soidCreditRefundAllowCompanyCheque?: string | undefined;
    soidCreditAllowPrintFinalDocumentOnRelease?: string | undefined;
    soidCreditSearchInvoicesByOrderNumber?: string | undefined;
    soidCreditAllowUnpaidCustomerCredits?: string | undefined;
    soidCreditAllowSalesOrderCreationFromCreditNotes?: string | undefined;
    soidCreditDefaultReturnStockToZeroFromProductsPurchased?: string | undefined;
    soidCreditUseTakenByFromLinkedInvoiceForSalesAnalysis?: string | undefined;
    soidCreditDoNotAllowReturnToStockCreditNotesBackToVMIPrograms?: string | undefined;
    soidCreditRefundAlwaysAllowCompanyCheque?: string | undefined;
    soidCreditUpdateQuantityCreditedAtTimeOfCreditCreation?: string | undefined;
    soidCreditDefaultHandling?: string | undefined;
    soidCreditAlwaysUseARCustomerFromAddress?: string | undefined;
    soidCreditAllowQuantityLessThanReturnToStockQuantity?: string | undefined;
    soidCreditAutoApproveCreditNoteOnCompletionWhenStockReturned?: string | undefined;
    soidCreditWMSRefuseOnTruckReasonCode?: string | undefined;
    soidCreditWMSRefuseOnTruckReasonCodeCash?: string | undefined;
    soidCreditWMSUpdateCreditQuantity?: string | undefined;
    soidCreditPostSalesAndCOGSToInvoiceBranch?: string | undefined;
    soidCreditRebillCreditNoteReason?: string | undefined;
    soidCreditRebillCashRefundReason?: string | undefined;
    soidCreditDefaultCreditNoteLinesToIncludeAVOCost?: string | undefined;
    soidCreditRequireCashRefundAuthorization?: string | undefined;
    soidCreditSignatureCaptureForReturnToBranch?: string | undefined;
    soidCreditReasonCodeToUseForContractBillingCreditNotes?: string | undefined;
    soidCreditReasonCodeToUseForContractBillingCashRefunds?: string | undefined;
    soidCreditCopyCustomerAddressNotesIntoDescription?: string | undefined;
    soidCreditDefaultProductsPurchasedDateSearch?: string | undefined;
    soidCreditPrintCreditFormatFromCashRefund?: string | undefined;
    soidCreditLimitInvoiceAndProductPurchasedSearchesToTheJobOnCreditNotes?: string | undefined;
    soidCashDrawerCOMEnabled?: string | undefined;
    soidCashDrawerDefaultClosingFloat?: string | undefined;
    soidUpdateLCPOnPurchaseOrderUpdate?: string | undefined;
    soidUpdateLCPOnStockReceiptUpdate?: string | undefined;
    soidUpdateLCPOnSupplierInvoiceApprove?: string | undefined;
    soidUpdateLCPOnWorksOrderProcess?: string | undefined;
    soidIncludeProratedManualCostsInACP?: string | undefined;
    soidIncludeProratedManualCostsInLCP?: string | undefined;
    soidUpdateLCPOnStockTransferReceipt?: string | undefined;
    soidInventoryAgingAnnualCostRate?: string | undefined;
    soidFreeDaysBeforeAgingApplies?: string | undefined;
    soidSkipUpdateACPOnSupplierInvoiceApprove?: string | undefined;
    soidTurnOffProduceInvoiceOnCOD?: string | undefined;
    soidVolumeDisplayUnitInOrderSummary?: string | undefined;
    soidDisplayVolumeAreaLengthInOrderSummary?: string | undefined;
    soidSalesAndPOLineVolumeDisplayPer?: string | undefined;
    soidSalesAndPOLineAreaDisplayPer?: string | undefined;
    soidSalesAndPOLineLengthDisplayPer?: string | undefined;
    soidEnableVMIProcessingUseThisOne?: string | undefined;
    soidShowReelFunctionality?: string | undefined;
    soidDefaultNotepadCaseStatus?: string | undefined;
    soidAllowVMIPRulesThatAreCalculatedFromSellPrice?: string | undefined;
    soidUseEstimateCostsOnlyOnAdditionalCostCalcs?: string | undefined;
    soidUpdateCostsOnSupplierInvoiceWhenStockReceiptPreEntered?: string | undefined;
    soidAlwaysProrateAdditionalCostsBySellPrice?: string | undefined;
    soidInventoryValueNetOfSupplierDiscount?: string | undefined;
    soidNumberOfCostDiscountFields?: string | undefined;
    soidSetAverageCostsOnSpecialOrderCreation?: string | undefined;
    soidEnableCostDiscountFieldsOnDirects?: string | undefined;
    soidPOCostControlledByPermission?: string | undefined;
    soidPPVCalculation?: string | undefined;
    soidReasonCodeForPPVWhenCreatingAutoACA?: string | undefined;
    soidIntrastatSupplierDefaultDeliveryTerms?: string | undefined;
    soidIntrastatSupplierDefaultModeOfTransport?: string | undefined;
    soidIntrastatCustomerDefaultDeliveryTerms?: string | undefined;
    soidIntrastatCustomerDefaultModeOfTransport?: string | undefined;
    soidIntrastatIntegration?: string | undefined;
    soidDefaultProductStockClass?: string | undefined;
    soidProductDefaultSpecialsToKeepStockFigures?: string | undefined;
    soidEnablePermissionsByProductTab?: string | undefined;
    soidProductShowAveCostInBuyPer?: string | undefined;
    soidNoOfProductImages?: string | undefined;
    soidProductImageNames?: string | undefined;
    soidDefaultProductHistoryDays?: string | undefined;
    soidProductShowCompanyStockInFindProducts?: string | undefined;
    soidProductEnableProductManagerNotifications?: string | undefined;
    soidProductDefaultSpecialsProductGroup?: string | undefined;
    soidProductAlternativeSupplierPriceWeeks?: string | undefined;
    soidProductEditProductGroupAffectsSalesAnalysis?: string | undefined;
    soidProductQtyInFindProductsToRead?: string | undefined;
    soidProductEnablePrintingofZebraLabels?: string | undefined;
    soidProductAllowDuplicateBarcodes?: string | undefined;
    soidProductSupplierPricesInSupplierCurrency?: string | undefined;
    soidProductDefaultStocked?: string | undefined;
    soidProductDefaultAllowSpecialsBasedOnThis?: string | undefined;
    soidProductRequireWeightOnProductsAndSpecials?: string | undefined;
    soidProductRequireEnvironmentalStatusOnSpecials?: string | undefined;
    soidProductUpdateStandardBranchPricesWithCompanyPrices?: string | undefined;
    soidProductSkipDetailsOnAutoCreatedPurchasedSpecials?: string | undefined;
    soidProductLimitSellingPriceBandsToSpecificBranches?: string | undefined;
    soidProductLimitStockOptionsToBranchesWithUpdateAccess?: string | undefined;
    soidProductDefaultSalesTabToCurrentBranch?: string | undefined;
    soidProductDefaultSalesTabToLast12Months?: string | undefined;
    soidProductSetupSellingQuantityBreakByBranch?: string | undefined;
    soidProductSetupPickingRequiredByBranch?: string | undefined;
    soidProductSetupAllowSettlementDiscountByBranch?: string | undefined;
    soidProductAllowChangingProductCodeOnSpecialOrderCreation?: string | undefined;
    soidProductSetSellEntireRelatedSet?: string | undefined;
    soidProductSetSelectDefaultToExpanded?: string | undefined;
    soidProductDefaultNewSpecialProductToBranchCreating?: string | undefined;
    soidProductDefaultShortDescriptionToDescriptionOnSpecialOrderCreation?: string | undefined;
    soidProductCopyPopupTextOnSpecialOrderCreation?: string | undefined;
    soidImportProductFollowBranchAccessPermissions?: string | undefined;
    soidConvertTalliesToSpecialInstructions?: string | undefined;
    soidDefaultDocumentPresentation?: string | undefined;
    soidAddManufacturedKitToExistingWO?: string | undefined;
    soidDefaultHideOnWorksOrders?: string | undefined;
    soidKitsSelectionImageNumber?: string | undefined;
    soidEnableStandardKitPromotions?: string | undefined;
    soidABCDStockClassCalculationBasedOn?: string | undefined;
    soidNumberOfMonthsToBaseRankingsOn?: string | undefined;
    soidNumberOfMonthsOfSalesBeforeRanking?: string | undefined;
    soidStockClassARanking?: string | undefined;
    soidStockClassBRanking?: string | undefined;
    soidStockClassCRanking?: string | undefined;
    soidStockClassDRanking?: string | undefined;
    soidRankInComparisonToProductGroupLevel?: string | undefined;
    soidSearchingIncludeOrderFindSupplierFields?: string | undefined;
    soidHighlightOwnBrandProducts?: string | undefined;
    soidExcludeBarcodeInOrderProductFind?: string | undefined;
    soidUseExactProductCodeSearchOnCollectNow?: string | undefined;
    soidSearchingSortFindDocumentFilterLists?: string | undefined;
    soidSearchingUseIssuingBranch?: string | undefined;
    soidBarcodePrefix?: string | undefined;
    soidUseAdditionalBarcodesInOrderProductFind?: string | undefined;
    soidSearchingFindDocsDeliveryAreaSearchStyle?: string | undefined;
    soidSearchingTrimSearchText?: string | undefined;
    soidSearchMOLTsInProductFindInOrderEntry?: string | undefined;
    soidSearchCouponsInProductFindInOrderEntry?: string | undefined;
    soidSearchingDeliveryAreaSearchStyle?: string | undefined;
    soidAllowCustomerProductReference?: string | undefined;
    soidSupplierReturnEnable?: string | undefined;
    soidSupplierReturnAlwaysDefaultCostToAverageCostWithAdd?: string | undefined;
    soidSupplierReturnAllowBranchChangeWhenLinkedToDocument?: string | undefined;
    soidSupplierReturnUseAccountsPayableGLCodeFromLinkedDocument?: string | undefined;
    soidSupplierReturnAllowInspectAfterPickup?: string | undefined;
    soidOrdersPricingSpecialPriceMessage?: string | undefined;
    soidOrdersPricingSpecialPriceMessageColour?: string | undefined;
    soidOrdersPricingUseDeferredDiscountInCostCalc?: string | undefined;
    soidPricingUseOrderCostForSpecialBackToBack?: string | undefined;
    soidSalesOrderSecondaryCostCalculation?: string | undefined;
    soidPricingUseQuotePriceUnlessRuleExists?: string | undefined;
    soidPricingRecostOrderOn?: string | undefined;
    soidPricingUseLastSellPriceWithin?: string | undefined;
    soidOrdersPricingQuotePriceMessage?: string | undefined;
    soidOrdersPricingQuotePriceMessageColour?: string | undefined;
    soidOrdersPricingLastSellPriceMessage?: string | undefined;
    soidOrdersPricingLastSellPriceMessageColour?: string | undefined;
    soidCostDefaultQuoteToStandardBuy?: string | undefined;
    soidCostDefaultTemplateOrderToStandardBuy?: string | undefined;
    soidOrdersPricingCheckIfCallOffExists?: string | undefined;
    soidPricingUseQuotePriceAlways?: string | undefined;
    soidOrdersLastSellPriceIsBranchSpecific?: string | undefined;
    soidOrdersPricingLumpSumQtySell?: string | undefined;
    soidOrdersPricingLumpSumQtyCost?: string | undefined;
    soidOrdersPricingShowLastPOPriceInNegotiation?: string | undefined;
    soidOrdersPricingPOPriceOutOfDateDays?: string | undefined;
    soidOrdersPricingShowContributionOnOrders?: string | undefined;
    soidOrdersPricingUseDeferredDiscountInLastCostCalc?: string | undefined;
    soidOrdersPricingUseDeferredDiscountInAverageCostCalc?: string | undefined;
    soidOrdersPricingRecostBackToBackOrders?: string | undefined;
    soidOrdersPricingPromotionPointsPer?: string | undefined;
    soidOrdersPricingPromotionCalculateAfterDeliveryCharges?: string | undefined;
    soidOrdersPricingAllowNegotiateIfNoMarginOptions?: string | undefined;
    soidOrdersPricingPromotionExcludeAbsolutePriceLines?: string | undefined;
    soidOrdersPricingPromotionExcludeDirects?: string | undefined;
    soidOrdersPricingPromptToChangePriceOnIdenticalItems?: string | undefined;
    soidOrdersPricingDefaultReplaceExistingLineDiscounts?: string | undefined;
    soidOrdersPricingDefaultPriceRulesToCalculateDiscountsIntoUnitPrice?: string | undefined;
    soidOrdersPricingUseInternalCostInMarginCalcs?: string | undefined;
    soidOrdersPricingUseInternalCostRules?: string | undefined;
    soidOrdersPricingApplyPriceRoundingWhenManuallyPricingLines?: string | undefined;
    soidOrdersPricingDefaultCostToZeroOnDirectSalesOrders?: string | undefined;
    soidOrdersPricingShowLastPriceDates?: string | undefined;
    soidOrdersPricingShowNextPricesXDays?: string | undefined;
    soidOrdersPricingManualPriceOnMarginNegotiation?: string | undefined;
    soidOrdersPricingShowPriceBandsOnNegotiation?: string | undefined;
    soidOrdersPricingShowInternalCostInfo?: string | undefined;
    soidOrdersPricingEnsureAVOInclusiveSellPriceExtends?: string | undefined;
    soidOrdersPricingOrderlinePriceInfoToDisplay?: string | undefined;
    soidOrdersPricingUseInternalCostRulesOnDirects?: string | undefined;
    soidOrdersPricingCalculatePriceBandDiscountsIntoUnitPrice?: string | undefined;
    soidOrdersPricingDefaultUseBasedOnProductsOnNewPriceRules?: string | undefined;
    soidOrdersPricingPriceBandsUtilizeBasedOnProducts?: string | undefined;
    soidOrdersPricingRecalcSellPriceOnNonSpecialManKitRefresh?: string | undefined;
    soidOrdersPricingApplyPriceRoundingWhenNegotiatingMargin?: string | undefined;
    soidOrdersPricingEnableManagerOverrideOnOrderLinePrice?: string | undefined;
    soidOrdersPricingRequireReasonCodeOnSalesLinePriceChange?: string | undefined;
    soidOrdersPricingAllowMultiplePromotionsPerLine?: string | undefined;
    soidOrdersPricingShowMultiplierOnOrderLine?: string | undefined;
    soidOrdersPricingRetainOriginalPriceCalc?: string | undefined;
    soidOrdersPricingDefaultCostPerToSellingPerOnSalesOrder?: string | undefined;
    soidOrdersPricingControlFreeOfChargeLines?: string | undefined;
    soidOrdersPricingManualPriceAlwaysClearsDiscounts?: string | undefined;
    soidOrdersPricingRecordSalesNetOfDiscounts?: string | undefined;
    soidOrdersPricingApplySettlementDiscountToCashOrderLines?: string | undefined;
    soidOrdersIncludeAdditionalChargeInOrderLineTotalPrice?: string | undefined;
    soidOrdersRepriceOrderLinesAtFixedMarginPctPerLine?: string | undefined;
    soidOrdersRoundUpSellPriceOnMarginNegotiate?: string | undefined;
    soidOrdersRoundDiscountDown?: string | undefined;
    soidOrdersPricingAutoCreateInvoiceCostAdjForSpecials?: string | undefined;
    soidOrdersPricingDefaultRepriceProductsOnFindAndReplace?: string | undefined;
    soidDefaultCostPerToLastCostWithAdditionalPerOnTransfers?: string | undefined;
    soidOrdersPricingSpecialPriceMessageOverride?: string | undefined;
    soidOrdersPricingApplyPriceRoundingAfterDelChargeIsAdded?: string | undefined;
    soidOrdersPricingKeepPricePerWhenSpecificPriceBandIsUsed?: string | undefined;
    soidOrdersPricingRestoreCostOnSpecialProductsOnRecalculate?: string | undefined;
    soidOrdersPricingDisplayMultiplierInPriceRulesAndSellingBands?: string | undefined;
    soidOrdersPricingShowCostAndSellPriceMultipliersOnSalesSpecialOrderCreation?: string | undefined;
    soidOrdersPricingRecostSalesTransactionsOnCopyFrom?: string | undefined;
    soidOrdersPricingAutoCreateInvoiceCostAdjForNonSpecials?: string | undefined;
    soidAllowMarkingSalesOrderLinesAsNetPriced?: string | undefined;
    soidOrdersPricingDefaultCostOnBackToBackOrderLines?: string | undefined;
    soidOrdersPricingAutoCreateInvoiceCostAdjForManProducts?: string | undefined;
    soidDefaultCalculationMethodForCostBasedSellingPriceRules?: string | undefined;
    soidOrdersPricingAutoApplySellingPriceChangesNightly?: string | undefined;
    soidOrdersUseDefaultJobAddressPriceProfile?: string | undefined;
    soidExcludePriceRoundingWhenUsingSpecialPriceRules?: string | undefined;
    soidQuantityBreaksThatUseSpecificPriceBandWillOnlyUseDiscountFromThatBand?: string | undefined;
    soidOrdersPricingAllowMultipleSpendXSaveYCouponPromotions?: string | undefined;
    soidBranchPrinter1?: string | undefined;
    soidBranchPrinter2?: string | undefined;
    soidBranchPrinter3?: string | undefined;
    soidBranchPrinter4?: string | undefined;
    soidBranchPrinter5?: string | undefined;
    soidBranchPrinter6?: string | undefined;
    soidBranchPrinter7?: string | undefined;
    soidBranchPrinter8?: string | undefined;
    soidBranchPrinter9?: string | undefined;
    soidBranchPrinter10?: string | undefined;
    soidPrintingMaxDocument?: string | undefined;
    soidAlternatePrintDialog?: string | undefined;
    soidAllowDocumentPrintingFromPreview?: string | undefined;
    soidPrinterListMethod?: string | undefined;
    soidPrintingSortPrinterList?: string | undefined;
    soidPrintingPrinterDisplayFormat?: string | undefined;
    soidDepartmentPinter1?: string | undefined;
    soidDepartmentPinter2?: string | undefined;
    soidDepartmentPinter3?: string | undefined;
    soidDepartmentPinter4?: string | undefined;
    soidDepartmentPinter5?: string | undefined;
    soidDepartmentPinter6?: string | undefined;
    soidDepartmentPinter7?: string | undefined;
    soidDepartmentPinter8?: string | undefined;
    soidDepartmentPinter9?: string | undefined;
    soidDepartmentPinter10?: string | undefined;
    soidOrdersEnablePricingOptionToChangeSellingPriceUOM?: string | undefined;
    soidCustomersDefaultRefRequired?: string | undefined;
    soidCustomersDefaultDropdownLists?: string | undefined;
    soidCustomersDefaultEnforceEnterOrderContact?: string | undefined;
    soidAllowCustomerSalesRepToBeOptional?: string | undefined;
    soidRemitToAddressRequiredOnDefaultAddress?: string | undefined;
    soidPreventDuplicateJobReferencesPerCustomer?: string | undefined;
    soidRestrictUpdatingCustomersToHomeBranch?: string | undefined;
    soidAutoAllocateJobNumbers?: string | undefined;
    soidCustomersEnablePermissionsByTab?: string | undefined;
    soidCustomersLimitSearchToHomeBranch?: string | undefined;
    soidCustomersUseTaxExemptionsFromARCustomer?: string | undefined;
    soidCustomersDefaultEnforceJobAddressOrderEntry?: string | undefined;
    soidCustomersDefaultFinanceChargeAmountToNotSet?: string | undefined;
    soidCustomerCopyInstructionsToTransactions?: string | undefined;
    soidCustomerDefaultAllowOvertypeInvoiceAddress?: string | undefined;
    soidCustomerForceVerifyOfContactIdentification?: string | undefined;
    soidCustomerLimitContactsToThoseBasedAtDeliveryAddress?: string | undefined;
    soidCustomerDisplayCustomerContactDefaultOnOrders?: string | undefined;
    soidCustomerDefaultHomeBranchInCustomerFindToLoggedInBranch?: string | undefined;
    soidOptimizeCustomerAddressUsage?: string | undefined;
    soidCustomerTypeLevel1?: string | undefined;
    soidCustomerTypeLevel2?: string | undefined;
    soidCustomersAutomaticallyGenerateProspectCode?: string | undefined;
    soidCustomerEnableContactLoyaltyCards?: string | undefined;
    soidPreventDuplicateAddressCodesPerCustomer?: string | undefined;
    soidForceStateSelectionFromDropdown?: string | undefined;
    soidCustomerLimitContactsToThoseWhoCanAuthoriseSalesOrders?: string | undefined;
    soidGenerateCustomerCodesStartingPoint?: string | undefined;
    soidUseCounterSalesCashAliasCreationFormInBisTrack?: string | undefined;
    soidAutomaticallyGenerateCashCustomerAliasCode?: string | undefined;
    soidAutomaticallyApproveJobs?: string | undefined;
    soidCustomerGenerateNewAddressCodeMethod?: string | undefined;
    soidCopyInfoFromDefaultJobAddress?: string | undefined;
    soidAddressValidationMethod?: string | undefined;
    soidPasswordExpiryDays?: string | undefined;
    soidAllowNonAdministrativePasswordChange?: string | undefined;
    soidStaffNumberRestoreOriginalUser?: string | undefined;
    soidStaffNumberRequiredForNonSalesTransactions?: string | undefined;
    soidServerManagerBackupFolder?: string | undefined;
    soidOrdersPricingRequireReasonCodeOnQuoteLinePriceChange?: string | undefined;
    soidEmailFaxAllowEmailFromOrderCompletion?: string | undefined;
    soidEmailFaxAllowEmailFromPurchaseOrderCompletion?: string | undefined;
    soidEmailFaxCCOtherSalesRepsOnOrderSend?: string | undefined;
    soidDefaultSalesOrderEmailAddressFromContactEmailAddress?: string | undefined;
    soidEmailFaxFaxMethod?: string | undefined;
    soidEmailFaxFaxAutoSendFolder?: string | undefined;
    soidEmailFaxFaxEmailAddress?: string | undefined;
    soidEmailUseSMTPForAllEmail?: string | undefined;
    soidEmailUseTemplates?: string | undefined;
    soidDatabaseMailProfileName?: string | undefined;
    soidPrefaceEmailAddressWithContact?: string | undefined;
    soidEmailFaxVsiFaxEmailNotifyOnEvent?: string | undefined;
    soidCashDrawerTotalTolerance?: string | undefined;
    soidCashDrawerTenderBillDenominations?: string | undefined;
    soidCashDrawerTenderCoinDenominations?: string | undefined;
    soidCashDrawerRequireCashDetailsToBeEntered?: string | undefined;
    soidCashDrawerRequireClosingFloatDetailsToBeEntered?: string | undefined;
    soidCashDrawerRequireOpeningFloatToBeCountedBeforeUse?: string | undefined;
    soidCashDrawerRequireChequeDetailsToBeEntered?: string | undefined;
    soidTransportBookingAllowUse?: string | undefined;
    soidTransportBookingDistanceUnit?: string | undefined;
    soidTransportBookingRequireDistance?: string | undefined;
    soidTransportBookingRequireInstructionsOnPO?: string | undefined;
    soidTransportBookingRequireInstructionsOnSO?: string | undefined;
    soidDisableRemainingCountInFindDocuments?: string | undefined;
    soidDisableRemainingCountInFindObjects?: string | undefined;
    soidWarnIfNoSearchTextEnteredInFindProducts?: string | undefined;
    soidWarnIfNoSearchTextEnteredInFindCustomers?: string | undefined;
    soidAllowLoadAllInPriceRules?: string | undefined;
    soidPoleCommunicationMethod?: string | undefined;
    soidCachedSalesOrderCount?: string | undefined;
    soidPerformanceAllowLoadAllOnJobs?: string | undefined;
    soidEnableGarbageCollection?: string | undefined;
    soidEDICreateImportedProductsForAllBranches?: string | undefined;
    soidEDIUpdateCompanyLevelPricesOnImport?: string | undefined;
    soidElectronicPaymentMethod?: string | undefined;
    soidElectronicPaymentsUsePostalCode?: string | undefined;
    soidWebTrackServicesDefaultLocation?: string | undefined;
    soidNumberOfDigitsOfCardNumberForDisplay?: string | undefined;
    soidElectronicPaymentLoggingLevel?: string | undefined;
    soidElectronicPaymentsUseAVS?: string | undefined;
    soidElectronicPaymentLoginTimeout?: string | undefined;
    soidElectronicPaymentTransactionTimeout?: string | undefined;
    soidbisTrackServicesDefaultLocation?: string | undefined;
    soidWebTrackServicesDefaultKey?: string | undefined;
    soidElectronicPaymentNoLogin?: string | undefined;
    soidEDIUpdatePurchaseOrderCostOnImport?: string | undefined;
    soidElectronicPaymentProviderForPurchasingCards?: string | undefined;
    soidPaymentProviderWebServiceURL?: string | undefined;
    soidEDIUpdateCompanyLevelCostsOnImport?: string | undefined;
    soidEDIRootFolder?: string | undefined;
    soidEDIManualLineTypeAVOPOs?: string | undefined;
    soidEDIAddressCodeForStockOrders?: string | undefined;
    soidEDIStockSalesOrderDocumentFormats?: string | undefined;
    soidEDICustomerSalesOrderDocumentFormats?: string | undefined;
    soidEDIAgentComputerName?: string | undefined;
    soidEDIAutoApproveInternalTradingOrders?: string | undefined;
    soidElectronicPaymentsUseAddress?: string | undefined;
    soidEDIDefaultProductCodeToSKUForProductMaint?: string | undefined;
    soidEDIUpdatePurchaseOrderQuantityOnImport?: string | undefined;
    soidEDIDefaultSupplierInvoiceManualOrderLineType?: string | undefined;
    soidEDIInternalTradingSupplierAtBranchLevel?: string | undefined;
    soidElectronicPaymentsShowWarningWhenCardDontMatchPaymentMethod?: string | undefined;
    soidElectronicPaymentsNoCardAuthenticationOnApprovedTransaction?: string | undefined;
    soidEDIAddLinesOnInboundSupplierInvoiceIfNoProductMatch?: string | undefined;
    soidEDIRequireSupplierProductCodeForOutboundPO?: string | undefined;
    soidEDIAddLinesOnInboundSupplierInvoiceIfPerIsNotMapped?: string | undefined;
    soidEDICheckProductSpecialOrderBehaviourForXpressPOS?: string | undefined;
    soidShift4MerchantID?: string | undefined;
    soidShift4SerialNumber?: string | undefined;
    soidShift4Vendor?: string | undefined;
    soidEDIAllowSelectionOfEDISupplierReferenceOnSalesOrder?: string | undefined;
    soidShift4TokenLongTermStorageDuration?: string | undefined;
    soidShift4CaptureSignatureThresholdAmount?: string | undefined;
    soidShift4TransactionGlobalTimerIntervalInSeconds?: string | undefined;
    soidShift4TransactionReTryTimerIntervalInSeconds?: string | undefined;
    soidShift4APIPassword?: string | undefined;
    soidShift4UserName?: string | undefined;
    soidShift4CreditCardsOnReturnsOnly?: string | undefined;
    soidElectronicPaymentConnectionDelay?: string | undefined;
    soidEDIExportAdditionalChargesAsAllowances?: string | undefined;
    soidEDIExportAVOsAsAllowances?: string | undefined;
    soidShift4i4GoAccountID?: string | undefined;
    soidShift4i4GoSiteID?: string | undefined;
    soidShift4i4GoPassword?: string | undefined;
    soidCommunicateToShift4UTGServersUsingHTTPS?: string | undefined;
    soidEDIEnableDIBBuyingGroupFeatures?: string | undefined;
    soidTenderRetailConnectionTimeoutInSeconds?: string | undefined;
    soidTenderRetailResponseTimeoutInSeconds?: string | undefined;
    soidTenderRetailPositiveAckTimeoutInSeconds?: string | undefined;
    soidGivexUserID?: string | undefined;
    soidGivexPassword?: string | undefined;
    soidShift4SkipSignatureCaptureForCardOnFile?: string | undefined;
    soidShift4EnableSwipeAhead?: string | undefined;
    soidShift4PINPadDisplayDelayInMilliseconds?: string | undefined;
    soidEDIUpdateProductDescriptionOnEDIProductMaintenance?: string | undefined;
    soidEDIUpdateSupplierProductDescriptionOnEDIProductMaintenance?: string | undefined;
    soidShift4TRAllowTokensForSubsequentPaymentsOnSameTransaction?: string | undefined;
    soidDisplayPromoCodeForPrivateLabelCreditCardProcessing?: string | undefined;
    soidEnableBlueTarpElectronicPaymentIntegration?: string | undefined;
    soidShift4i4GoLiveURL?: string | undefined;
    soidShift4i4GoTestURL?: string | undefined;
    soidBlueTarpMerchantID?: string | undefined;
    soidBlueTarpClientKey?: string | undefined;
    soidBlueTarpBaseURL?: string | undefined;
    soidEDIRestrictProductUpdateToDefaultSupplier?: string | undefined;
    soidCollectAirMilesCardDetailsWithPayments?: string | undefined;
    soidAirMilesDefaultOfferCodeForCashSales?: string | undefined;
    soidAirMilesDefaultOfferCodeForCashSalesToChargeAccount?: string | undefined;
    soidAirMilesDefaultOfferCodeForZeroAmountAirMilesTransactions?: string | undefined;
    soidAirMilesDefaultTerminalID?: string | undefined;
    soidAirMilesDefaultServerIPAddress?: string | undefined;
    soidAirMilesDefaultServerPortNumber?: string | undefined;
    soidAirMilesConnectionTimeoutInSeconds?: string | undefined;
    soidAirMilesResponseTimeoutInSeconds?: string | undefined;
    soidShift4UseVoidOnDebitReversal?: string | undefined;
    soidPerformPreAuthWhenBackOrderingSOWithExistingWTPreAuth?: string | undefined;
    soidShift4ReceiptTextWidth?: string | undefined;
    soidShift4AccessMethod?: string | undefined;
    soidEDITemplateManualOrderLine?: string | undefined;
    soidShift4i4GoVersion?: string | undefined;
    soidEDIAPAutomationAttachmentsFolder?: string | undefined;
    soidDoNotDisplayManualCheckboxForShift4ElectronicPayments?: string | undefined;
    soidPreSaveNewSalesOrdersBeforeProcessingShift4ElectronicPayment?: string | undefined;
    soidShift4AllowManualEntryOfVoiceAuthorizations?: string | undefined;
    soidShift4i4GoAccessLiveURL?: string | undefined;
    soidShift4i4GoAccessTestURL?: string | undefined;
    soidShift4i4GoTokenServiceURL?: string | undefined;
    soidShift4i4GoCardSecurityCodeRequired?: string | undefined;
    soidShift4i4GoAcceptedCardTypes?: string | undefined;
    soidShift4i4GoCardholderNamePrompt?: string | undefined;
    soidShift4i4GoStreetAddressPrompt?: string | undefined;
    soidShift4i4GoPostalCodePrompt?: string | undefined;
    soidShift4GetNewLongTermTokenWhenCardOnFileIsUsed?: string | undefined;
    soidShift4UseI4GoAVS?: string | undefined;
    soidShift4i4GoPublicIPServiceURL?: string | undefined;
    soidTenderRetailProcessor?: string | undefined;
    soidShift4VoidOnTimeOut?: string | undefined;
    soidShift4SendTransactionsInAsyncMode?: string | undefined;
    soidAirMilesStandardOfferCodes?: string | undefined;
    soidShift4CreditCardsOnPaymentsOnly?: string | undefined;
    soidTemplateManualOrderLineForAcePromotions?: string | undefined;
    soidAceCustomerLoyaltyLevel?: string | undefined;
    soidACERewardsWebService?: string | undefined;
    soidACERewardsWebServiceUsername?: string | undefined;
    soidACERewardsWebServicePassword?: string | undefined;
    soidUseDefaultCashCustomerForExistingACERewardsCustomers?: string | undefined;
    soidACERewardsCustomerLookupWebService?: string | undefined;
    soidTenderRetailCheckForWinsockErrorAfterSendingPositiveACK?: string | undefined;
    soidACERewardsVerifyCustomerDetailsWhenRequestedByACE?: string | undefined;
    soidEDIAPAutomationProcessTo?: string | undefined;
    soidShift4i4GoCardholderNamePromptInWebTrack?: string | undefined;
    soidShift4i4GoStreetAddressPromptInWebTrack?: string | undefined;
    soidShift4i4GoPostalCodePromptInWebTrack?: string | undefined;
    soidEDIIgnoreBlankOrZeroValuesDuringProductMaintenanceUpdate?: string | undefined;
    soidEDIAttachmentFolderForSOProductImages?: string | undefined;
    soidEDIAPAutomationCreateInvoiceWithoutStockReceipt?: string | undefined;
    soidGiftCardProductForACETypeXPromotions?: string | undefined;
    soidSplitIntegratedCardPaymentMethodByTypeOnAccountPayments?: string | undefined;
    soidEDIAPAutomationCreditNoteAttachmentFolder?: string | undefined;
    soidWebTrackSecondsToWaitForReportServerToReturnDocument?: string | undefined;
    soidWebTrackShift4i4GoAccountID?: string | undefined;
    soidWebTrackShift4i4GoSiteID?: string | undefined;
    soidWebTrackShift4i4GoPassword?: string | undefined;
    soidWebTrackRestrictProdAccessUsingCustWTProdGrps?: string | undefined;
    soidWebTrackShowLocationWithVehicleTracking?: string | undefined;
    soidOrdersEnableMiTekImportFeatures?: string | undefined;
    soidOrdersMiTekImportFolder?: string | undefined;
    soidOrdersImportReferenceDestination?: string | undefined;
    soidNewPerMode?: string | undefined;
    soidNewTaxMode?: string | undefined;
    soidLastLiveOrderID?: string | undefined;
    soidLastLiveSellPriceRuleID?: string | undefined;
    soidNewReportPrintMode?: string | undefined;
    soidNewPriceMode?: string | undefined;
    soidSupplierInvoiceAllowPreEnteredStockReceipts?: string | undefined;
    soidEnablePromptForCrystalParameters?: string | undefined;
    soidUseOrderFilterForSOPSearches?: string | undefined;
    soidNewSearchMode?: string | undefined;
    soidDatabaseUpgrading?: string | undefined;
    soidUseInventoryAgingAndCommissionCosts?: string | undefined;
    soidEnablePerformanceLogging?: string | undefined;
    soidPurchasingInputExchangeRateFromBase?: string | undefined;
    soidUseOldCrystalPrintingMethods?: string | undefined;
    soidShowInternalCostOnProductFind?: string | undefined;
    soidAllowSupplierProductReference?: string | undefined;
    soidEnableScanTrackIntegration?: string | undefined;
    soidJourneyPlanningStyle?: string | undefined;
    soidEnableNewProductFindMode?: string | undefined;
    soidDisableLicensing?: string | undefined;
    soidDisableRebuildStockOnOrderForReceipt?: string | undefined;
    soidCashDrawerRedirectMessageValidity?: string | undefined;
    soidLastProductGroupEdit?: string | undefined;
    soidLastSortedProductGroupUpdate?: string | undefined;
    soidAllowBranchLevelPackOptions?: string | undefined;
    soidUseRecordsetLoadWithNoTransaction?: string | undefined;
    soidAllowMemoQuantityInput?: string | undefined;
    soidJourneyPlannerAllowDeliveredPOs?: string | undefined;
    soidQuickProductsImage1?: string | undefined;
    soidQuickProductsImage2?: string | undefined;
    soidQuickProductsImage3?: string | undefined;
    soidQuickProductsShowImages?: string | undefined;
    soidAllowAuthorizedBuyerByJob?: string | undefined;
    soidEnablePricingPlanner?: string | undefined;
    soidSystemUpgradeEmailAddress?: string | undefined;
    soidEnablePriceChecker?: string | undefined;
    soidEnableBisTrackCount?: string | undefined;
    soidEnableBisTrackReceipt?: string | undefined;
    soidPurchasingCostDebugMode?: string | undefined;
    soidAllowTotalStockAdjustmentOfStockByLengthProducts?: string | undefined;
    soidWorksOrderKeepSameCostIfFinishedInSource?: string | undefined;
    soidPermissionDetailLastUpdateVersion?: string | undefined;
    soidAddSettlementDiscAvailToSalesAndProductAnalysisCubes?: string | undefined;
    soidSalesAnalysisCodeForSettlementDiscAvailInSalesAnalysis?: string | undefined;
    soidPurchaseAnalysisType?: string | undefined;
    soidPurchaseAnalysisDetailStartDate?: string | undefined;
    soidSalesAnalysisCodeToPostSalesDiscountsToInSalesAnalysis?: string | undefined;
    soidPostPromotionDiscountAmountsProratedOverProducts?: string | undefined;
    soidReportServer2AgentPollingInterval?: string | undefined;
    soidReportServer2AgentLoggingLevel?: string | undefined;
    soidReportServer2ProcessEmailedDocuments?: string | undefined;
    soidReportServer2ImageInvoiceFormat?: string | undefined;
    soidReportServer2ImageCreditNoteFormat?: string | undefined;
    soidReportServer2ImageSalesOrderFormat?: string | undefined;
    soidReportServer2ImageInvoiceSTDocType?: string | undefined;
    soidReportServer2ImageCreditNoteSTDocType?: string | undefined;
    soidReportServer2ImageSalesOrderSTDocType?: string | undefined;
    soidReportServer2ImageReleasedFrom?: string | undefined;
    soidReportServer2ImageFileType?: string | undefined;
    soidReportServer2ImageColourDepth?: string | undefined;
    soidReportServer2ImageDPI?: string | undefined;
    soidReportServer2ImageJPGQuality?: string | undefined;
    soidReportServer2ImageTIFCompression?: string | undefined;
    soidReportServer2ImageTIFMultiPage?: string | undefined;
    soidReportServer2ImageTimeTo?: string | undefined;
    soidReportServer2Timeout?: string | undefined;
    soidReportServer2AutoDelInvoiceFormat?: string | undefined;
    soidReportServer2AutoDelInvoiceEmailTemplate?: string | undefined;
    soidReportServer2AutoDelCreditNoteFormat?: string | undefined;
    soidReportServer2AutoDelCreditNoteEmailTemplate?: string | undefined;
    soidReportServer2AutoDelSendTime?: string | undefined;
    soidReportServer2AutoDelDocumentsSince?: string | undefined;
    soidReportServer2AutoDeliveryEnabled?: string | undefined;
    soidDeadProductsCheck?: string | undefined;
    soidDeadProductsIncludeTimber?: string | undefined;
    soidDeadProductsLowUsageCount?: string | undefined;
    soidDeadProductsLowReceiptCount?: string | undefined;
    soidDeadProductsMarkNonStockedIfLowActivityxMonths?: string | undefined;
    soidDeadProductsMarkDeletedIfLowActivityxMonths?: string | undefined;
    soidDeadProductsStandardStockOnly?: string | undefined;
    soidDeadProductsSpecialsDaysAgo?: string | undefined;
    soidReportServer2AutoDelCashInvoiceFormat?: string | undefined;
    soidReportServer2AutoDelCashRefundFormat?: string | undefined;
    soidReportServer2NotificationDeliveryInProgressEmailTemplate?: string | undefined;
    soidReportServer2NotificationDeliveryInProgressFormat?: string | undefined;
    soidReportServer2NotificationOrderDeliveredEmailTemplate?: string | undefined;
    soidReportServer2NotificationOrderDeliveredFormat?: string | undefined;
    soidReportServer2NotificationDeliveryETAEmailTemplate?: string | undefined;
    soidReportServer2NotificationDeliveryETAFormat?: string | undefined;
    soidCRMEventsQuoteAcceptEnable?: string | undefined;
    soidCRMEventsQuoteRejectEnable?: string | undefined;
    soidCRMEventsEmailSentEnable?: string | undefined;
    soidCRMEventsLetterWrittenEnable?: string | undefined;
    soidCRMEventsOrderCreditHoldOnEnable?: string | undefined;
    soidCRMEventsOrderCreditHoldOffEnable?: string | undefined;
    soidCRMEventsAccountOnHoldEnable?: string | undefined;
    soidCRMEventsAccountOffHoldEnable?: string | undefined;
    soidCRMCalendarDayStart?: string | undefined;
    soidCRMCalendarDayEnd?: string | undefined;
    soidCRMCalendarTimeInterval?: string | undefined;
    soidCRMCalendarFollowUpDuration?: string | undefined;
    soidCRMCampaignsDefaultNotepadType?: string | undefined;
    soidCRMEventsCampaignActionComplete?: string | undefined;
    soidItemMessageCreationSubject?: string | undefined;
    soidItemMessageCreationBody?: string | undefined;
    soidItemMessageClosureSubject?: string | undefined;
    soidItemMessageClosureBody?: string | undefined;
    soidItemMessageNotificationSubject?: string | undefined;
    soidItemMessageNotificationBody?: string | undefined;
    soidItemDevSignOffPrompt1?: string | undefined;
    soidItemDevSignOffPrompt2?: string | undefined;
    soidItemDefaultTesterID?: string | undefined;
    soidItemDefaultTesterName?: string | undefined;
    soidItemDefaultTesterTypeOfWorkID?: string | undefined;
    soidItemDefaultTestAnalysisCodeID?: string | undefined;
    soidItemForceProjectEntry?: string | undefined;
    soidItemNotesForNonDevItems?: string | undefined;
    soidItemGenerateCustomerSpecificeItemReferences?: string | undefined;
    soidItemUseBillToItems?: string | undefined;
    soidItemLockTimeTransactionsPreviousToThisDate?: string | undefined;
    soidItemPreventAddEditOfTimeOnClosedCancelledItems?: string | undefined;
    soidSTServerFolder?: string | undefined;
    soidItemAllowEntryOfSeparateChargeableTime?: string | undefined;
    soidItemAllowTimeSheetWeekApproval?: string | undefined;
    soidItemNonDevVersionOptional?: string | undefined;
    soidItemNonDevDefaultPriority?: string | undefined;
    soidItemLockChargingInfoBeforeThisDate?: string | undefined;
    soidItemUseProjectInvoiceApproval?: string | undefined;
    soidEmailServer?: string | undefined;
    soidEmailUsername?: string | undefined;
    soidEmailPassword?: string | undefined;
    soidEmailSenderAddress?: string | undefined;
    soidEmailPort?: string | undefined;
    soidEmailUseSMTPDefaultAsFromAddress?: string | undefined;
    soidEmailUseSMTPDefaultAsSenderAddress?: string | undefined;
    soidEmailUseSMTPReplyToAddress?: string | undefined;
    soidEmailEncryption?: string | undefined;
    soidInstantReleaseKey?: string | undefined;
    soidCloudQuoteDocumentFormatNumber?: string | undefined;
    soidCloudTemplateOrderDocumentFormatNumber?: string | undefined;
    soidCloudCallOffOrderDocumentFormatNumber?: string | undefined;
    soidCloudSalesOrderDocumentFormatNumber?: string | undefined;
    soidCloudInvoiceDocumentFormatNumber?: string | undefined;
    soidCloudCreditNoteDocumentFormatNumber?: string | undefined;
    soidCloudPurchaseOrderDocumentFormatNumber?: string | undefined;
    soidCloudTransferDocumentFormatNumber?: string | undefined;
    soidCloudWorkOrderDocumentFormatNumber?: string | undefined;
    soidCrystalUsePrintLayoutSettings?: string | undefined;
    soidCrystalUseRAS?: string | undefined;
    soidCrystalUseThreading?: string | undefined;
    soidCrystalThreadingTimeout?: string | undefined;
    soidEnableCTI?: string | undefined;
    soidOIGServerAddress?: string | undefined;
    soidOIGIcpIPAddress?: string | undefined;
    soidOIGEventHandlerURL?: string | undefined;
    soidOIGApplicationName?: string | undefined;
    soidOIGApplicationPassword?: string | undefined;
    soidOIGCompanyName?: string | undefined;
    soidOIGLocalPassword?: string | undefined;
    soidCTIProvider?: string | undefined;
    soidCTICustomerDashboard?: string | undefined;
    soidCTISupplierDashboard?: string | undefined;
    soidCTIUserDashboard?: string | undefined;
    soidCTICustomerDashboardDefault?: string | undefined;
    soidCTISupplierDashboardDefault?: string | undefined;
    soidCTIUserDashboardDefault?: string | undefined;
    soidGrahamsDemo?: string | undefined;
    soidSuppliersEnablePermissionsByTab?: string | undefined;
    soidDefaultOrderSingleLengthTalliedLumberQuantityToZero?: string | undefined;
    soidOnlyUseReplacementProductWhenNoStock?: string | undefined;
    soidAllowStockInformationForBranchesWithoutReadAccess?: string | undefined;
    soidLimitProductAddToQtyOnlyMethodOnTransfers?: string | undefined;
    soidBranchAccessLevelRequiredForIssuingBranch?: string | undefined;
    soidEnableWMSProcessing?: string | undefined;
    soidDefaultCollectLaterWMSPickingStatus?: string | undefined;
    soidWMSOutgoingGenerationInProgress?: string | undefined;
    soidEDIPurgeWMSDocumentDays?: string | undefined;
    soidConsolidateLineNotesOnSOConsolidate?: string | undefined;
    soidDefaultExcludeSpecialsOnPricingOption?: string | undefined;
    soidTranferLimitToFinalCostWhenNoReadAccessToSendingBranch?: string | undefined;
    soidDisplayProductPopupOnQuoteAcceptanceAndSalesCopy?: string | undefined;
    soidEnableWMSBackWorksOrders?: string | undefined;
    soidEnableWMSDocumentPrinting?: string | undefined;
    soidWorksOrderDefaultWMSType?: string | undefined;
    soidUpdateSpecialProductDescriptionWithOrderLineDescription?: string | undefined;
    soidCashSalesRequireFullPaymentForCollectLaterNowCompletion?: string | undefined;
    soidDefaultOrderLineAmendReasonForWMSSubstitution?: string | undefined;
    soidWMSSubstitutionRecalculatePrice?: string | undefined;
    soidDisplaySuccessfulConfirmationPopUps?: string | undefined;
    soidConfirmContractSelectionOnSalesOrderCompletion?: string | undefined;
    soidWMSSendReleasedNotProcessedCreditNoteQuantityInQuantitySync?: string | undefined;
    soidEnableWMSBackTransfers?: string | undefined;
    soidEnablePurchaseOrderExcludeFromWMS?: string | undefined;
    soidWMSDoNotSentOrderLineInternalNotes?: string | undefined;
    soidWMSTimberTalliedProductsMustBeSingleLength?: string | undefined;
    soidWMSOrderHeaderLicensePlateUDF?: string | undefined;
    soidShowCubeMeasures?: string | undefined;
    soidDefaultPricingOptionsToPriceProfiles?: string | undefined;
    soidUseNewSalesOrderEntryForm?: string | undefined;
    soidWorksOrderSendMachineGroupToWMS?: string | undefined;
    soidOrdersSendJourneyReferenceToWMS?: string | undefined;
    soidReleaseOrdersForPickingToWMSDaysInAdvance?: string | undefined;
    soidWorksOrderRequireReleaseForManufactureInWMS?: string | undefined;
    soidReleaseWorksOrdersForManufactureToWMSDaysInAdvance?: string | undefined;
    soidGenerateWorkOrdersForIncomingSalesOrders?: string | undefined;
    soidWMSJourneyReferenceLength?: string | undefined;
    soidWMSSendShipCompleteTagForSalesOrders?: string | undefined;
    soidDefaultSalesRepOnTransactionsToTakenByLinkedSalesRep?: string | undefined;
    soidWMSEnableASNTransactions?: string | undefined;

    constructor(data?: ISystemOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.soidPickingZoneFormatNumber = _data["soidPickingZoneFormatNumber"];
            this.soidServerFolder = _data["soidServerFolder"];
            this.soidAllowBlankPasswords = _data["soidAllowBlankPasswords"];
            this.soidMaximumProductGroupLevels = _data["soidMaximumProductGroupLevels"];
            this.soidCubeServerFolder = _data["soidCubeServerFolder"];
            this.soidHTMLServerFolder = _data["soidHTMLServerFolder"];
            this.soidReportServerFolder = _data["soidReportServerFolder"];
            this.soidTemplateServerFolder = _data["soidTemplateServerFolder"];
            this.soidTerminalServers = _data["soidTerminalServers"];
            this.soidDefaultLabelPrinter = _data["soidDefaultLabelPrinter"];
            this.soidAllowBackToBacks = _data["soidAllowBackToBacks"];
            this.soidNoOfDocumentFormats = _data["soidNoOfDocumentFormats"];
            this.soidShowDetailedPrinterDialogForLabels = _data["soidShowDetailedPrinterDialogForLabels"];
            this.soidDefaultCountry = _data["soidDefaultCountry"];
            this.soidOrderNumberIncrement = _data["soidOrderNumberIncrement"];
            this.soidCompanyName = _data["soidCompanyName"];
            this.soidCompanyAddress = _data["soidCompanyAddress"];
            this.soidCompanyRegistrationNumber = _data["soidCompanyRegistrationNumber"];
            this.soidVATRegistrationNumber = _data["soidVATRegistrationNumber"];
            this.soidCompanyCatalogueURL = _data["soidCompanyCatalogueURL"];
            this.soidCompanyCatalogueName = _data["soidCompanyCatalogueName"];
            this.soidVATValidationURL = _data["soidVATValidationURL"];
            this.soidLongRunningProceduresTimeout = _data["soidLongRunningProceduresTimeout"];
            this.soidStandardSQLQueryTimeout = _data["soidStandardSQLQueryTimeout"];
            this.soidUseReadUnCommittedTransactionIsolationLevel = _data["soidUseReadUnCommittedTransactionIsolationLevel"];
            this.soidCrystalReportsVersion = _data["soidCrystalReportsVersion"];
            this.soidReportServerVersion = _data["soidReportServerVersion"];
            this.soidCrystalReportsAllowIntegratedSecurity = _data["soidCrystalReportsAllowIntegratedSecurity"];
            this.soidSQLReportsServerURL = _data["soidSQLReportsServerURL"];
            this.soidSQLReportsBuilderVersion = _data["soidSQLReportsBuilderVersion"];
            this.soidSQLReportsServerVersion = _data["soidSQLReportsServerVersion"];
            this.soidSQLReportsViewerVersion = _data["soidSQLReportsViewerVersion"];
            this.soidBaseCurrency = _data["soidBaseCurrency"];
            this.soidAlternativeCurrency = _data["soidAlternativeCurrency"];
            this.soidDefaultVatRate = _data["soidDefaultVatRate"];
            this.soidDefaultCashCustomer = _data["soidDefaultCashCustomer"];
            this.soidConsolidateLines = _data["soidConsolidateLines"];
            this.soidVatRuleForDeliveryCharge = _data["soidVatRuleForDeliveryCharge"];
            this.soidMaximumDimensions = _data["soidMaximumDimensions"];
            this.soidAllowSetCustomerOnHold = _data["soidAllowSetCustomerOnHold"];
            this.soidDueDateGraceDays = _data["soidDueDateGraceDays"];
            this.soidIgnoreSmallBalancesUpTo = _data["soidIgnoreSmallBalancesUpTo"];
            this.soidOverdueBalanceChecking = _data["soidOverdueBalanceChecking"];
            this.soidCreditControlDisableCreditLimitChecksOnOrders = _data["soidCreditControlDisableCreditLimitChecksOnOrders"];
            this.soidCreditControlAllowCashOnCreditHold = _data["soidCreditControlAllowCashOnCreditHold"];
            this.soidCreditControlAllowInstantCreditRelease = _data["soidCreditControlAllowInstantCreditRelease"];
            this.soidCreditControlPromptForOriginalComputer = _data["soidCreditControlPromptForOriginalComputer"];
            this.soidCreditControlAllowCashAccountBalances = _data["soidCreditControlAllowCashAccountBalances"];
            this.soidCreditControlOrderChangeTolerance = _data["soidCreditControlOrderChangeTolerance"];
            this.soidCreditControlDisableCreditLimitChecksOnOrderAmend = _data["soidCreditControlDisableCreditLimitChecksOnOrderAmend"];
            this.soidAllowGreatPlainsMessages = _data["soidAllowGreatPlainsMessages"];
            this.soidCreditControlExcludePreviouslyReleasedOrdersFromCheck = _data["soidCreditControlExcludePreviouslyReleasedOrdersFromCheck"];
            this.soidCreditControlDisableCreditChecksOnReleasedBackOrders = _data["soidCreditControlDisableCreditChecksOnReleasedBackOrders"];
            this.soidCreditControlUseARCustomerForOrderCreditApproval = _data["soidCreditControlUseARCustomerForOrderCreditApproval"];
            this.soidCreditControlMaximumSalesOrderValueAmount = _data["soidCreditControlMaximumSalesOrderValueAmount"];
            this.soidCreditControlMaximumSalesOrderPercentage = _data["soidCreditControlMaximumSalesOrderPercentage"];
            this.soidCreditControlCreditLimitExtensionPercentage = _data["soidCreditControlCreditLimitExtensionPercentage"];
            this.soidCreditControlCreditHoldThresholdAmount = _data["soidCreditControlCreditHoldThresholdAmount"];
            this.soidCreditControlAllowPaymentOnAccountOnCreditHold = _data["soidCreditControlAllowPaymentOnAccountOnCreditHold"];
            this.soidCreditControlMarginHoldOrderChangeTolerance = _data["soidCreditControlMarginHoldOrderChangeTolerance"];
            this.soidCustomerFullSyncJobName = _data["soidCustomerFullSyncJobName"];
            this.soidCustomerPartialSyncJobName = _data["soidCustomerPartialSyncJobName"];
            this.soidSupplierFullSyncJobName = _data["soidSupplierFullSyncJobName"];
            this.soidSupplierPartialSyncJobName = _data["soidSupplierPartialSyncJobName"];
            this.soidCreditControlPrintDocsAwaitingCustomerApproval = _data["soidCreditControlPrintDocsAwaitingCustomerApproval"];
            this.soidDynamicsDatabase = _data["soidDynamicsDatabase"];
            this.soidDynamicsServer = _data["soidDynamicsServer"];
            this.soidDynamicsUserID = _data["soidDynamicsUserID"];
            this.soidFinancialInterfaceFolder = _data["soidFinancialInterfaceFolder"];
            this.soidFinancialInterfaceVersion = _data["soidFinancialInterfaceVersion"];
            this.soidNavisionCompanyName = _data["soidNavisionCompanyName"];
            this.soidNavisionServer = _data["soidNavisionServer"];
            this.soidNavisionDatabase = _data["soidNavisionDatabase"];
            this.soidNavisionNTAuthentication = _data["soidNavisionNTAuthentication"];
            this.soidNavisionUserID = _data["soidNavisionUserID"];
            this.soidNavisionShowCFRONTErrors = _data["soidNavisionShowCFRONTErrors"];
            this.soidNavisionNetType = _data["soidNavisionNetType"];
            this.soidSendDebitNotes = _data["soidSendDebitNotes"];
            this.soidSendDebitNotesOnHold = _data["soidSendDebitNotesOnHold"];
            this.soidAutoApplyCreditNotes = _data["soidAutoApplyCreditNotes"];
            this.soidUseNAVAgent = _data["soidUseNAVAgent"];
            this.soidAgentGenerateXMLOnly = _data["soidAgentGenerateXMLOnly"];
            this.soidDisallowReExport = _data["soidDisallowReExport"];
            this.soidSendDebitNoteAmount = _data["soidSendDebitNoteAmount"];
            this.soidNavisionPostingGroupSales = _data["soidNavisionPostingGroupSales"];
            this.soidNavisionPostingGroupPurch = _data["soidNavisionPostingGroupPurch"];
            this.soidNAVUseSeparateBatches = _data["soidNAVUseSeparateBatches"];
            this.soidUseNAVCache = _data["soidUseNAVCache"];
            this.soidNAVCacheDatabaseName = _data["soidNAVCacheDatabaseName"];
            this.soidCreditControlCustomerReferencePutOrdersOnHold = _data["soidCreditControlCustomerReferencePutOrdersOnHold"];
            this.soidCalculateJobCreditLimitFromCustomerReferencePurchaseOrderAmounts = _data["soidCalculateJobCreditLimitFromCustomerReferencePurchaseOrderAmounts"];
            this.soidCalculatedJobCreditLimitExtensionPercentage = _data["soidCalculatedJobCreditLimitExtensionPercentage"];
            this.soidCalculateInvoiceDueAndDiscountDatesFromDeliveryDate = _data["soidCalculateInvoiceDueAndDiscountDatesFromDeliveryDate"];
            this.soidCustomerAgedDebt1 = _data["soidCustomerAgedDebt1"];
            this.soidCustomerAgedDebt2 = _data["soidCustomerAgedDebt2"];
            this.soidCustomerAgedDebt3 = _data["soidCustomerAgedDebt3"];
            this.soidCustomerAgedDebt4 = _data["soidCustomerAgedDebt4"];
            this.soidCustomerAgedDebt5 = _data["soidCustomerAgedDebt5"];
            this.soidCustomerAgedDebt6 = _data["soidCustomerAgedDebt6"];
            this.soidCustomerAgedDebt7 = _data["soidCustomerAgedDebt7"];
            this.soidSupplierAgedDebt1 = _data["soidSupplierAgedDebt1"];
            this.soidSupplierAgedDebt2 = _data["soidSupplierAgedDebt2"];
            this.soidSupplierAgedDebt3 = _data["soidSupplierAgedDebt3"];
            this.soidSupplierAgedDebt4 = _data["soidSupplierAgedDebt4"];
            this.soidSupplierAgedDebt5 = _data["soidSupplierAgedDebt5"];
            this.soidSupplierAgedDebt6 = _data["soidSupplierAgedDebt6"];
            this.soidSupplierAgedDebt7 = _data["soidSupplierAgedDebt7"];
            this.soidGreatPlainsMessageQueue = _data["soidGreatPlainsMessageQueue"];
            this.soidGreatPlainsMessageServer = _data["soidGreatPlainsMessageServer"];
            this.soidGreatPlainsPollInterval = _data["soidGreatPlainsPollInterval"];
            this.soidGreatPlainsLoggingLevel = _data["soidGreatPlainsLoggingLevel"];
            this.soidGreatPlainsCompanyID = _data["soidGreatPlainsCompanyID"];
            this.soidGreatPlainsServer = _data["soidGreatPlainsServer"];
            this.soidGreatPlainseConnectServer = _data["soidGreatPlainseConnectServer"];
            this.soidBankAccountCash = _data["soidBankAccountCash"];
            this.soidBankAccountCheque = _data["soidBankAccountCheque"];
            this.soidBankAccountCreditCard = _data["soidBankAccountCreditCard"];
            this.soidGreatPlainsOutputTo = _data["soidGreatPlainsOutputTo"];
            this.soidGreatPlainsARPathFile = _data["soidGreatPlainsARPathFile"];
            this.soidGreatPlainsAPPathFile = _data["soidGreatPlainsAPPathFile"];
            this.soidGreatPlainsbisTrackServiceServer = _data["soidGreatPlainsbisTrackServiceServer"];
            this.soidSalesGLRuleTaxSales = _data["soidSalesGLRuleTaxSales"];
            this.soidWriteOffGLRule = _data["soidWriteOffGLRule"];
            this.soidFinanceChargeGLRule = _data["soidFinanceChargeGLRule"];
            this.soidNSFChargeGLRule = _data["soidNSFChargeGLRule"];
            this.soidCashGLCode = _data["soidCashGLCode"];
            this.soidChequeGLCode = _data["soidChequeGLCode"];
            this.soidCreditCardGLCode = _data["soidCreditCardGLCode"];
            this.soidGreatPlainsGLPathFile = _data["soidGreatPlainsGLPathFile"];
            this.soidSalesDisableTaxSalesGLRule = _data["soidSalesDisableTaxSalesGLRule"];
            this.soidGPDirectUsername = _data["soidGPDirectUsername"];
            this.soidGPDirectPassword = _data["soidGPDirectPassword"];
            this.soidExtendedNumberFormat = _data["soidExtendedNumberFormat"];
            this.soidCreateGLTransactionsStockReceipts = _data["soidCreateGLTransactionsStockReceipts"];
            this.soidCreateGLTransactionsStockAdjustment = _data["soidCreateGLTransactionsStockAdjustment"];
            this.soidFinancialDepositControl = _data["soidFinancialDepositControl"];
            this.soidFinancialUnallocatedCashControl = _data["soidFinancialUnallocatedCashControl"];
            this.soidFinancialDepositVatPosting = _data["soidFinancialDepositVatPosting"];
            this.soidFinancialUnallocatedVatPosting = _data["soidFinancialUnallocatedVatPosting"];
            this.soidbTAAccountCodeMask = _data["soidbTAAccountCodeMask"];
            this.soidbTAApplyLateCharges = _data["soidbTAApplyLateCharges"];
            this.soidbTAMinLatePaymentCharge = _data["soidbTAMinLatePaymentCharge"];
            this.soidbTAAutoWOThreshold = _data["soidbTAAutoWOThreshold"];
            this.soidbTALapsedAccountMonths = _data["soidbTALapsedAccountMonths"];
            this.soidbTAInactiveAccountMonths = _data["soidbTAInactiveAccountMonths"];
            this.soidbTADeletedAccountMonths = _data["soidbTADeletedAccountMonths"];
            this.soidbTACustomerAgedBalanceMethod = _data["soidbTACustomerAgedBalanceMethod"];
            this.soidbTACustomerApplicationInProcess = _data["soidbTACustomerApplicationInProcess"];
            this.soidbTACustomerStatementReportName = _data["soidbTACustomerStatementReportName"];
            this.soidbTACustomerInterimStatementReportName = _data["soidbTACustomerInterimStatementReportName"];
            this.soidbTAGeneralContractorInfoRequired = _data["soidbTAGeneralContractorInfoRequired"];
            this.soidbTACustomerStatementStyle = _data["soidbTACustomerStatementStyle"];
            this.soidbTAStatementScannedDocTypeForCollect = _data["soidbTAStatementScannedDocTypeForCollect"];
            this.soidbTAStatementScannedDocTypeForDelivered = _data["soidbTAStatementScannedDocTypeForDelivered"];
            this.soidbTAStatementSendIntervalInSeconds = _data["soidbTAStatementSendIntervalInSeconds"];
            this.soidbTAStatementEmailBodyText = _data["soidbTAStatementEmailBodyText"];
            this.soidbTASettDiscToFullAmountWhenMatching = _data["soidbTASettDiscToFullAmountWhenMatching"];
            this.soidbTAARBy = _data["soidbTAARBy"];
            this.soidbTAStatementScanTrackImagesOnly = _data["soidbTAStatementScanTrackImagesOnly"];
            this.soidTransferGLRuleInbound = _data["soidTransferGLRuleInbound"];
            this.soidTransferGLRuleOutbound = _data["soidTransferGLRuleOutbound"];
            this.soidTransferGLRuleInTransit = _data["soidTransferGLRuleInTransit"];
            this.soidTransferGLRuleUpliftCalculated = _data["soidTransferGLRuleUpliftCalculated"];
            this.soidTransferGLRuleUpliftInput = _data["soidTransferGLRuleUpliftInput"];
            this.soidTransferGLRuleTransferProfit = _data["soidTransferGLRuleTransferProfit"];
            this.soidGenericXMLARPathFileName = _data["soidGenericXMLARPathFileName"];
            this.soidGenericXMLAPPathFileName = _data["soidGenericXMLAPPathFileName"];
            this.soidGenericXMLGLPathFileName = _data["soidGenericXMLGLPathFileName"];
            this.soidbTAStatementScannedDocTypeForInvoice = _data["soidbTAStatementScannedDocTypeForInvoice"];
            this.soidbTAStatementScannedDocTypeForCredit = _data["soidbTAStatementScannedDocTypeForCredit"];
            this.soidbTAStatementImagesDefaultReportName = _data["soidbTAStatementImagesDefaultReportName"];
            this.soidbTAStatementImages1upReportName = _data["soidbTAStatementImages1upReportName"];
            this.soidbTAStatementImages2upReportName = _data["soidbTAStatementImages2upReportName"];
            this.soidbTAStatementImages4upReportName = _data["soidbTAStatementImages4upReportName"];
            this.soidbTAPostARGrossAndDiscountAtTimeOfSale = _data["soidbTAPostARGrossAndDiscountAtTimeOfSale"];
            this.soidbTACustomerAgedBalancePeriodStyle = _data["soidbTACustomerAgedBalancePeriodStyle"];
            this.soidbTAAllowDifferentARCustomerOnCustomerAddress = _data["soidbTAAllowDifferentARCustomerOnCustomerAddress"];
            this.soidbTAAllowAccountsPaymentOnJobAddress = _data["soidbTAAllowAccountsPaymentOnJobAddress"];
            this.soidbTAAllowEntryOfCustomerRemittanceAdvice = _data["soidbTAAllowEntryOfCustomerRemittanceAdvice"];
            this.soidbTACompareByAccountInFES = _data["soidbTACompareByAccountInFES"];
            this.soidbtaUseBranchAccessInAccounts = _data["soidbtaUseBranchAccessInAccounts"];
            this.soidbTAEmailBodyTextForStatementNotification = _data["soidbTAEmailBodyTextForStatementNotification"];
            this.soidbTAIgnoreDiscountDueDateWhenMatchingCreditNotes = _data["soidbTAIgnoreDiscountDueDateWhenMatchingCreditNotes"];
            this.soidbTAUseExpectedDetailsCheckingWithBatchCash = _data["soidbTAUseExpectedDetailsCheckingWithBatchCash"];
            this.soidbTACustomerAgeCreditNotes = _data["soidbTACustomerAgeCreditNotes"];
            this.soidbTACustomerAgeUnappliedCash = _data["soidbTACustomerAgeUnappliedCash"];
            this.soidbTAMatchingNewCustomerResetOptions = _data["soidbTAMatchingNewCustomerResetOptions"];
            this.soidbTADefaultNewCreditCustomerToOperationalStatus = _data["soidbTADefaultNewCreditCustomerToOperationalStatus"];
            this.soidDefaultOrderToCashCustomer = _data["soidDefaultOrderToCashCustomer"];
            this.soidDefaultOrderSaleType = _data["soidDefaultOrderSaleType"];
            this.soidDefaultOrderPlacementType = _data["soidDefaultOrderPlacementType"];
            this.soidDefaultManualOrderLineType = _data["soidDefaultManualOrderLineType"];
            this.soidDefaultOrderTestCertOption = _data["soidDefaultOrderTestCertOption"];
            this.soidDefaultShowAVOsInUnitPrice = _data["soidDefaultShowAVOsInUnitPrice"];
            this.soidPrintDocumentReleaseDelay = _data["soidPrintDocumentReleaseDelay"];
            this.soidPrintDocumentReleaseConfirm = _data["soidPrintDocumentReleaseConfirm"];
            this.soidDefaultPrintFinalDocOnInvoiceAndCreditRelease = _data["soidDefaultPrintFinalDocOnInvoiceAndCreditRelease"];
            this.soidAllowCashOnDelivery = _data["soidAllowCashOnDelivery"];
            this.soidStaffNumberTimeout = _data["soidStaffNumberTimeout"];
            this.soidDefaultOrdersToNegotiation = _data["soidDefaultOrdersToNegotiation"];
            this.soidDefaultOrderQuantityToZero = _data["soidDefaultOrderQuantityToZero"];
            this.soidPrintOrderOnCashSales = _data["soidPrintOrderOnCashSales"];
            this.soidPurchaseFromOrderRequiredDays = _data["soidPurchaseFromOrderRequiredDays"];
            this.soidUseActualSizesForTimberCosts = _data["soidUseActualSizesForTimberCosts"];
            this.soidWarnIfDateRequiredNotChanged = _data["soidWarnIfDateRequiredNotChanged"];
            this.soidWarnIfDeliveryAddressNotChanged = _data["soidWarnIfDeliveryAddressNotChanged"];
            this.soidCheckForExistingQuotes = _data["soidCheckForExistingQuotes"];
            this.soidPurchaseOrderNumberDisplayFormat = _data["soidPurchaseOrderNumberDisplayFormat"];
            this.soidStockReceiptNumberDisplayFormat = _data["soidStockReceiptNumberDisplayFormat"];
            this.soidOrderNumberDisplayFormat = _data["soidOrderNumberDisplayFormat"];
            this.soidPickingNoteNumberDisplayFormat = _data["soidPickingNoteNumberDisplayFormat"];
            this.soidSubContractNumberDisplayFormat = _data["soidSubContractNumberDisplayFormat"];
            this.soidDeliveryNoteNumberDisplayFormat = _data["soidDeliveryNoteNumberDisplayFormat"];
            this.soidInvoiceNumberDisplayFormat = _data["soidInvoiceNumberDisplayFormat"];
            this.soidCreditNoteNumberDisplayFormat = _data["soidCreditNoteNumberDisplayFormat"];
            this.soidCuttingOperationNumberDisplayFormat = _data["soidCuttingOperationNumberDisplayFormat"];
            this.soidWorksOrderNumberDisplayFormat = _data["soidWorksOrderNumberDisplayFormat"];
            this.soidSupplierInvoiceNumberDisplayFormat = _data["soidSupplierInvoiceNumberDisplayFormat"];
            this.soidDebitNoteNumberDisplayFormat = _data["soidDebitNoteNumberDisplayFormat"];
            this.soidSupplierCreditNoteNumberDisplayFormat = _data["soidSupplierCreditNoteNumberDisplayFormat"];
            this.soidCustomerReturnNumberDisplayFormat = _data["soidCustomerReturnNumberDisplayFormat"];
            this.soidJourneyManifestNumberDisplayFormat = _data["soidJourneyManifestNumberDisplayFormat"];
            this.soidStockWarningCollectedAlwaysProceed = _data["soidStockWarningCollectedAlwaysProceed"];
            this.soidStockWarningNonCollectedAlwaysBackOrder = _data["soidStockWarningNonCollectedAlwaysBackOrder"];
            this.soidStockWarningDefaultToProceed = _data["soidStockWarningDefaultToProceed"];
            this.soidSupplierReturnNumberDisplayFormat = _data["soidSupplierReturnNumberDisplayFormat"];
            this.soidCostAdjustmentNumberDisplayFormat = _data["soidCostAdjustmentNumberDisplayFormat"];
            this.soidDropDownListThreshold = _data["soidDropDownListThreshold"];
            this.soidDefaultProductTypeSearch = _data["soidDefaultProductTypeSearch"];
            this.soidFindFromAvailableStock = _data["soidFindFromAvailableStock"];
            this.soidSearchPageSize = _data["soidSearchPageSize"];
            this.soidReturnOwnBrandProductsFirst = _data["soidReturnOwnBrandProductsFirst"];
            this.soidPriceHistorySize = _data["soidPriceHistorySize"];
            this.soidUseCurrentBranchForFindDocuments = _data["soidUseCurrentBranchForFindDocuments"];
            this.soidPackBarcodeNumberDisplayFormat = _data["soidPackBarcodeNumberDisplayFormat"];
            this.soidAllowLoadAllInAllForProcessing = _data["soidAllowLoadAllInAllForProcessing"];
            this.soidStaffNumberTimeoutOperations = _data["soidStaffNumberTimeoutOperations"];
            this.soidPickingNoteReprint = _data["soidPickingNoteReprint"];
            this.soidSchedulingNumberDisplayFormat = _data["soidSchedulingNumberDisplayFormat"];
            this.soidOrderProductsByPriceBookSection = _data["soidOrderProductsByPriceBookSection"];
            this.soidDefaultQuoteDays = _data["soidDefaultQuoteDays"];
            this.soidDefaultReservationDays = _data["soidDefaultReservationDays"];
            this.soidDefaultTemplateOrderQuoteDays = _data["soidDefaultTemplateOrderQuoteDays"];
            this.soidProfitAbbreviation = _data["soidProfitAbbreviation"];
            this.soidMarginAbbreviation = _data["soidMarginAbbreviation"];
            this.soidSuppressCurrencyAndPercentageSymbolsInProfitAndMargin = _data["soidSuppressCurrencyAndPercentageSymbolsInProfitAndMargin"];
            this.soidSuppressMarginWarningsWhenPriceRulesUsed = _data["soidSuppressMarginWarningsWhenPriceRulesUsed"];
            this.soidSuppressMarginWarningsWhenStandardPriceUsed = _data["soidSuppressMarginWarningsWhenStandardPriceUsed"];
            this.soidDefaultMergeProductsOnOrder = _data["soidDefaultMergeProductsOnOrder"];
            this.soidDefaultShowDoubleRowsOnOrder = _data["soidDefaultShowDoubleRowsOnOrder"];
            this.soidSpecialProductCodePrefix = _data["soidSpecialProductCodePrefix"];
            this.soidSpecialProductCodeSuffixLength = _data["soidSpecialProductCodeSuffixLength"];
            this.soidCheckForExistingQuotesInAllBranches = _data["soidCheckForExistingQuotesInAllBranches"];
            this.soidAlwaysMergeProductsOnQuickAdd = _data["soidAlwaysMergeProductsOnQuickAdd"];
            this.soidBillOfMaterialProductCodePrefix = _data["soidBillOfMaterialProductCodePrefix"];
            this.soidBillOfMaterialProductCodeSuffixLength = _data["soidBillOfMaterialProductCodeSuffixLength"];
            this.soidSpecialGetHowSourcedFromBase = _data["soidSpecialGetHowSourcedFromBase"];
            this.soidCheckForExistingQuotesAtLineLevel = _data["soidCheckForExistingQuotesAtLineLevel"];
            this.soidbTADefaultTransactionStatusFilter = _data["soidbTADefaultTransactionStatusFilter"];
            this.soidbTADirectPostingBatchMode = _data["soidbTADirectPostingBatchMode"];
            this.soidbTACreateCaseWhenMarkingInDispute = _data["soidbTACreateCaseWhenMarkingInDispute"];
            this.soidbTARequireBatchCashMatchingNoteForUnmatchedCredits = _data["soidbTARequireBatchCashMatchingNoteForUnmatchedCredits"];
            this.soidbTAUseMatchDateForStatements = _data["soidbTAUseMatchDateForStatements"];
            this.soidbTAAllowWriteOffMoreThanRemainingAmount = _data["soidbTAAllowWriteOffMoreThanRemainingAmount"];
            this.soidShowCTLInstructionsWithoutCutFrom = _data["soidShowCTLInstructionsWithoutCutFrom"];
            this.soidSuppressMarginWarningsForSpecials = _data["soidSuppressMarginWarningsForSpecials"];
            this.soidbTABatchCashMatchingSortOrder = _data["soidbTABatchCashMatchingSortOrder"];
            this.soidWorksOrderScheduleNumberDisplayFormat = _data["soidWorksOrderScheduleNumberDisplayFormat"];
            this.soidNotepadCaseNumberDisplayFormat = _data["soidNotepadCaseNumberDisplayFormat"];
            this.soidStockWarningIncludeOnlyApprovedPurchaseOrdersForAllocation = _data["soidStockWarningIncludeOnlyApprovedPurchaseOrdersForAllocation"];
            this.soidbTAAllowUnapplyingTransactionsInClosedFinancialPeriods = _data["soidbTAAllowUnapplyingTransactionsInClosedFinancialPeriods"];
            this.soidbTAFinanceChargeDefaultGenerateBy = _data["soidbTAFinanceChargeDefaultGenerateBy"];
            this.soidbTACalcFinanceChargesOnFinanceCharges = _data["soidbTACalcFinanceChargesOnFinanceCharges"];
            this.soidbTADisplayChildCreditTransactionsOnParentAccounts = _data["soidbTADisplayChildCreditTransactionsOnParentAccounts"];
            this.soidStaffNumberBatchProcessingTimeout = _data["soidStaffNumberBatchProcessingTimeout"];
            this.soidProductSearchPageSize = _data["soidProductSearchPageSize"];
            this.soidProductExplorerPageSize = _data["soidProductExplorerPageSize"];
            this.soidCustomerSearchPageSize = _data["soidCustomerSearchPageSize"];
            this.soidSupplierSearchPageSize = _data["soidSupplierSearchPageSize"];
            this.soidOrderMonitorPageSize = _data["soidOrderMonitorPageSize"];
            this.soidJourneyPlannerPageSize = _data["soidJourneyPlannerPageSize"];
            this.soidDefaultCreateNewSpecialsOnOrderCopy = _data["soidDefaultCreateNewSpecialsOnOrderCopy"];
            this.soidDefaultSectionEndWithSubtotal = _data["soidDefaultSectionEndWithSubtotal"];
            this.soidCheckCustomerOnHoldOnPickingAndDelivery = _data["soidCheckCustomerOnHoldOnPickingAndDelivery"];
            this.soidCheckCustomerCreditOnPickingAndDelivery = _data["soidCheckCustomerCreditOnPickingAndDelivery"];
            this.soidAllowProceedOnPickingAndDeliveryCreditChecks = _data["soidAllowProceedOnPickingAndDeliveryCreditChecks"];
            this.soidEnableSteppedFinanceCharge = _data["soidEnableSteppedFinanceCharge"];
            this.soidCustomerChequeReferencesRequireCustomer = _data["soidCustomerChequeReferencesRequireCustomer"];
            this.soidbTADefaultNewCashCustomerToOperationalStatus = _data["soidbTADefaultNewCashCustomerToOperationalStatus"];
            this.soidDefaultTransportType = _data["soidDefaultTransportType"];
            this.soidDefaultDeliveryDate = _data["soidDefaultDeliveryDate"];
            this.soidInputMaskforDeliveryReference = _data["soidInputMaskforDeliveryReference"];
            this.soidEnableUnitPriceDeliveryCharges = _data["soidEnableUnitPriceDeliveryCharges"];
            this.soidAutomaticallySendDeliveryNotificationsByEmail = _data["soidAutomaticallySendDeliveryNotificationsByEmail"];
            this.soidCalendarStartOfWeek = _data["soidCalendarStartOfWeek"];
            this.soidDefaultDateRequiredDays = _data["soidDefaultDateRequiredDays"];
            this.soidDefaultDateRequiredOption = _data["soidDefaultDateRequiredOption"];
            this.soidDefaultDeliveryTime = _data["soidDefaultDeliveryTime"];
            this.soidDefaultDateRequiredToBlankOnQuotes = _data["soidDefaultDateRequiredToBlankOnQuotes"];
            this.soidDefaultDateRequiredCutOffTime = _data["soidDefaultDateRequiredCutOffTime"];
            this.soidDefaultDateRequiredToBlankOnOrders = _data["soidDefaultDateRequiredToBlankOnOrders"];
            this.soidEnableTransactionLocking = _data["soidEnableTransactionLocking"];
            this.soidSkipBranchPromptWhenUserHasDefault = _data["soidSkipBranchPromptWhenUserHasDefault"];
            this.soidPurchaseOrderCostCalculation = _data["soidPurchaseOrderCostCalculation"];
            this.soidSalesOrderCostCalculation = _data["soidSalesOrderCostCalculation"];
            this.soidSalesOrderShowVatPercentage = _data["soidSalesOrderShowVatPercentage"];
            this.soidSupplierInvoiceToleranceStockPercent = _data["soidSupplierInvoiceToleranceStockPercent"];
            this.soidSupplierInvoiceToleranceStockValue = _data["soidSupplierInvoiceToleranceStockValue"];
            this.soidSupplierInvoiceToleranceDirectPercent = _data["soidSupplierInvoiceToleranceDirectPercent"];
            this.soidSupplierInvoiceToleranceDirectValue = _data["soidSupplierInvoiceToleranceDirectValue"];
            this.soidSupplierInvoiceToleranceAdditionalCostPercent = _data["soidSupplierInvoiceToleranceAdditionalCostPercent"];
            this.soidSupplierInvoiceToleranceAdditionalCostValue = _data["soidSupplierInvoiceToleranceAdditionalCostValue"];
            this.soidDefaultCounterOrderSaleType = _data["soidDefaultCounterOrderSaleType"];
            this.soidSupplierInvoiceShowWeight = _data["soidSupplierInvoiceShowWeight"];
            this.soidSupplierInvoiceToleranceVatPercent = _data["soidSupplierInvoiceToleranceVatPercent"];
            this.soidSupplierInvoiceToleranceVatValue = _data["soidSupplierInvoiceToleranceVatValue"];
            this.soidSupplierInvoiceShowVAT = _data["soidSupplierInvoiceShowVAT"];
            this.soidSupplierInvoiceCalcSettlementDiscOnCredits = _data["soidSupplierInvoiceCalcSettlementDiscOnCredits"];
            this.soidSupplierInvoiceDeliveryText = _data["soidSupplierInvoiceDeliveryText"];
            this.soidSupplierInvoicePromptForDeliveryDetails = _data["soidSupplierInvoicePromptForDeliveryDetails"];
            this.soidSupplierInvoiceMustChooseGLCode = _data["soidSupplierInvoiceMustChooseGLCode"];
            this.soidSupplierInvoiceBlock2ndInvoiceOnDirectOrders = _data["soidSupplierInvoiceBlock2ndInvoiceOnDirectOrders"];
            this.soidSupplierInvoiceApproveDirectSalesOrderOnInvoiceApproval = _data["soidSupplierInvoiceApproveDirectSalesOrderOnInvoiceApproval"];
            this.soidSupplierInvoiceSetDirectSalesInvoiceDateFromInvoice = _data["soidSupplierInvoiceSetDirectSalesInvoiceDateFromInvoice"];
            this.soidOrdersPricingIncludeAdditionalCostInDirectSalesOrderCost = _data["soidOrdersPricingIncludeAdditionalCostInDirectSalesOrderCost"];
            this.soidSupplierInvoiceUseSupplierPaymentTerms = _data["soidSupplierInvoiceUseSupplierPaymentTerms"];
            this.soidIncludeOnOrderInAvailableStock = _data["soidIncludeOnOrderInAvailableStock"];
            this.soidIncludeStockDueInAvailableStock = _data["soidIncludeStockDueInAvailableStock"];
            this.soidIncludeThirdPartyInAvailableStock = _data["soidIncludeThirdPartyInAvailableStock"];
            this.soidIncludeAwaitingProcessInAvailableStock = _data["soidIncludeAwaitingProcessInAvailableStock"];
            this.soidAllocateStockOnBackToBacks = _data["soidAllocateStockOnBackToBacks"];
            this.soidAllowUseOfCostRecordAfterValuationDate = _data["soidAllowUseOfCostRecordAfterValuationDate"];
            this.soidIncludeAwaitingProcessForOrderOnlyInAvailStock = _data["soidIncludeAwaitingProcessForOrderOnlyInAvailStock"];
            this.soidCompanyStockLimitedByUserAccess = _data["soidCompanyStockLimitedByUserAccess"];
            this.soidDoNotAllowBackAndForwardDatingThatHarmsCostIntegrity = _data["soidDoNotAllowBackAndForwardDatingThatHarmsCostIntegrity"];
            this.soidStockCountAllowTickedStockUpdates = _data["soidStockCountAllowTickedStockUpdates"];
            this.soidStockCountAllowBackDatingOfCompletion = _data["soidStockCountAllowBackDatingOfCompletion"];
            this.soidStockIncludeLooseAndPackInStockCheckWhenAllocating = _data["soidStockIncludeLooseAndPackInStockCheckWhenAllocating"];
            this.soidIncludeStockAllocatedToBackToBackOrderInOnOrderStock = _data["soidIncludeStockAllocatedToBackToBackOrderInOnOrderStock"];
            this.soidAllowAddingProductsToTicketedStockCounts = _data["soidAllowAddingProductsToTicketedStockCounts"];
            this.soidShowStockInformationInStockCountProductSearches = _data["soidShowStockInformationInStockCountProductSearches"];
            this.soidShowActualAndAvailableStockWhenEnteringTicketCounts = _data["soidShowActualAndAvailableStockWhenEnteringTicketCounts"];
            this.soidReasonCodeToUseForStockCount = _data["soidReasonCodeToUseForStockCount"];
            this.soidCustomerObjectReport = _data["soidCustomerObjectReport"];
            this.soidProductObjectReport = _data["soidProductObjectReport"];
            this.soidSupplierObjectReport = _data["soidSupplierObjectReport"];
            this.soidFinancialInvoiceAuditCustomerReport = _data["soidFinancialInvoiceAuditCustomerReport"];
            this.soidFinancialInvoiceAuditSupplierReport = _data["soidFinancialInvoiceAuditSupplierReport"];
            this.soidStockPackReconciliationReport = _data["soidStockPackReconciliationReport"];
            this.soidCashDrawerReportName = _data["soidCashDrawerReportName"];
            this.soidCustomerProductRefObjectReport = _data["soidCustomerProductRefObjectReport"];
            this.soidSuggestedPurchaseOrderDetailReport = _data["soidSuggestedPurchaseOrderDetailReport"];
            this.soidStockValuationNegativeStockReportName = _data["soidStockValuationNegativeStockReportName"];
            this.soidStockValuationReceivedNotInvoicedReportName = _data["soidStockValuationReceivedNotInvoicedReportName"];
            this.soidStockValuationPaidNotReceivedReportName = _data["soidStockValuationPaidNotReceivedReportName"];
            this.soidStockValuationIssuedNotInvoicedReportName = _data["soidStockValuationIssuedNotInvoicedReportName"];
            this.soidStockValuationInvoicedNotIssuedReportName = _data["soidStockValuationInvoicedNotIssuedReportName"];
            this.soidStockValuationPaidNotDeliveredReportName = _data["soidStockValuationPaidNotDeliveredReportName"];
            this.soidStockValuationTransferSentNotreceivedReportName = _data["soidStockValuationTransferSentNotreceivedReportName"];
            this.soidScansUseDocReadPermissions = _data["soidScansUseDocReadPermissions"];
            this.soidReportsAccruedPurchaseDetailSupplierCredits = _data["soidReportsAccruedPurchaseDetailSupplierCredits"];
            this.soidDashboardRefreshInterval = _data["soidDashboardRefreshInterval"];
            this.soidDashboardOperationsFilename = _data["soidDashboardOperationsFilename"];
            this.soidDashboardSystemManagerFilename = _data["soidDashboardSystemManagerFilename"];
            this.soidDashboardFigures = _data["soidDashboardFigures"];
            this.soidDashboardOrderingBranch = _data["soidDashboardOrderingBranch"];
            this.soidDashBoardEnableFlowLayouts = _data["soidDashBoardEnableFlowLayouts"];
            this.soidDataRuleDataSetXML = _data["soidDataRuleDataSetXML"];
            this.soidPerformanceMonitorShowProfit = _data["soidPerformanceMonitorShowProfit"];
            this.soidPerformanceMonitorUseInternalCosts = _data["soidPerformanceMonitorUseInternalCosts"];
            this.soidDefaultCustomerVATRule = _data["soidDefaultCustomerVATRule"];
            this.soidDefaultProductVATRule = _data["soidDefaultProductVATRule"];
            this.soidCalculateVATOnGoodsLessDiscount = _data["soidCalculateVATOnGoodsLessDiscount"];
            this.soidCalculateVATTaxAtTotalLevel = _data["soidCalculateVATTaxAtTotalLevel"];
            this.soidCalculateTaxBasedOnBranchTaxArea = _data["soidCalculateTaxBasedOnBranchTaxArea"];
            this.soidVatRateForAutomaticUplift = _data["soidVatRateForAutomaticUplift"];
            this.soidCalculateSettlementAtTotalLevel = _data["soidCalculateSettlementAtTotalLevel"];
            this.soidVatRateForAutomaticLineCharge = _data["soidVatRateForAutomaticLineCharge"];
            this.soidEnableNonDiscountableAmount = _data["soidEnableNonDiscountableAmount"];
            this.soidVatRateForExportSales = _data["soidVatRateForExportSales"];
            this.soidUseWashingtonStateTaxRateValidation = _data["soidUseWashingtonStateTaxRateValidation"];
            this.soidRequireTaxVerificationOnDeliveredSalesOrders = _data["soidRequireTaxVerificationOnDeliveredSalesOrders"];
            this.soidUseDefaultJobAddressTaxAreaForCustomerDefault = _data["soidUseDefaultJobAddressTaxAreaForCustomerDefault"];
            this.soidCalculateTaxOnCostMinusWorksOrderAVOCost = _data["soidCalculateTaxOnCostMinusWorksOrderAVOCost"];
            this.soidUseIssuingBranchTaxArea = _data["soidUseIssuingBranchTaxArea"];
            this.soidSalesTaxCalculationMethod = _data["soidSalesTaxCalculationMethod"];
            this.soidUseBranchTaxAreaForCustomerDefault = _data["soidUseBranchTaxAreaForCustomerDefault"];
            this.soidSendFullAddressInfoInWashingtonStateTaxRateValidation = _data["soidSendFullAddressInfoInWashingtonStateTaxRateValidation"];
            this.soidWashingtonStateTaxRateURL = _data["soidWashingtonStateTaxRateURL"];
            this.soidFinancialStockValuationCostType = _data["soidFinancialStockValuationCostType"];
            this.soidFinancialReferenceRequiredOnCheckPayment = _data["soidFinancialReferenceRequiredOnCheckPayment"];
            this.soidInputMaskForChequeReference = _data["soidInputMaskForChequeReference"];
            this.soidPreventUseOfNewJournalNumberOnReExport = _data["soidPreventUseOfNewJournalNumberOnReExport"];
            this.soidUseFiscalCalendarToControlPostingDates = _data["soidUseFiscalCalendarToControlPostingDates"];
            this.soidSearchHistoryRecordsInFinancialPackage = _data["soidSearchHistoryRecordsInFinancialPackage"];
            this.soidUpdateDailySalesAnalysisTable = _data["soidUpdateDailySalesAnalysisTable"];
            this.soidChequeGuaranteeCardNumberRequired = _data["soidChequeGuaranteeCardNumberRequired"];
            this.soidAuthorisationCodeOrderValueThreshold = _data["soidAuthorisationCodeOrderValueThreshold"];
            this.soidSendSeparateBatchForEachBranchGLCode = _data["soidSendSeparateBatchForEachBranchGLCode"];
            this.soidRetainOrigExchangeRateOnSOAndPO = _data["soidRetainOrigExchangeRateOnSOAndPO"];
            this.soidEnableGLCodeValidation = _data["soidEnableGLCodeValidation"];
            this.soidFinancialGPbTGeneratesJournalEntryNumber = _data["soidFinancialGPbTGeneratesJournalEntryNumber"];
            this.soidFinancialGPMinbTJournalEntryNumber = _data["soidFinancialGPMinbTJournalEntryNumber"];
            this.soidFinancialGPMaxbTJournalEntryNumber = _data["soidFinancialGPMaxbTJournalEntryNumber"];
            this.soidPostSalesAndCOGSWhenUsingIssuingBranchTo = _data["soidPostSalesAndCOGSWhenUsingIssuingBranchTo"];
            this.soidEnableIntercompanyDistribution = _data["soidEnableIntercompanyDistribution"];
            this.soidEpicorTaxConnectAccountNumber = _data["soidEpicorTaxConnectAccountNumber"];
            this.soidEpicorTaxConnectLicenseKey = _data["soidEpicorTaxConnectLicenseKey"];
            this.soidEpicorTaxConnectWebAddress = _data["soidEpicorTaxConnectWebAddress"];
            this.soidTaxToUseForEpicorTaxConnectTaxes = _data["soidTaxToUseForEpicorTaxConnectTaxes"];
            this.soidEpicorTaxConnectCompanyCode = _data["soidEpicorTaxConnectCompanyCode"];
            this.soidGenericXMLFinancialExportMethod = _data["soidGenericXMLFinancialExportMethod"];
            this.soidSettDiscAllowedWhenMatchedToCreditCardPayments = _data["soidSettDiscAllowedWhenMatchedToCreditCardPayments"];
            this.soidSettDiscAllowedWhenMatchedToACHPayments = _data["soidSettDiscAllowedWhenMatchedToACHPayments"];
            this.soidNoOfSellingBands = _data["soidNoOfSellingBands"];
            this.soidUsePriceRulesForSpecials = _data["soidUsePriceRulesForSpecials"];
            this.soidDeliveryCriteriaPrecedence1 = _data["soidDeliveryCriteriaPrecedence1"];
            this.soidDeliveryCriteriaPrecedence2 = _data["soidDeliveryCriteriaPrecedence2"];
            this.soidDeliveryCriteriaPrecedence3 = _data["soidDeliveryCriteriaPrecedence3"];
            this.soidDeliveryCriteriaPrecedence4 = _data["soidDeliveryCriteriaPrecedence4"];
            this.soidUseStandardBuyCostForSpecials = _data["soidUseStandardBuyCostForSpecials"];
            this.soidRebateIDRequiredForRebateAccruals = _data["soidRebateIDRequiredForRebateAccruals"];
            this.soidPricingDefaultCompanyLevelPriceChange = _data["soidPricingDefaultCompanyLevelPriceChange"];
            this.soidPricingUseOldCompanyPriceAsOldAmount = _data["soidPricingUseOldCompanyPriceAsOldAmount"];
            this.soidSigmaNESTEnableIntegration = _data["soidSigmaNESTEnableIntegration"];
            this.soidSigmaNESTWorkOrderAttachmentFolder = _data["soidSigmaNESTWorkOrderAttachmentFolder"];
            this.soidSigmaNESTWorkOrderAttachmentFilename = _data["soidSigmaNESTWorkOrderAttachmentFilename"];
            this.soidSigmaNESTWorkOrderAttachmentOrigin = _data["soidSigmaNESTWorkOrderAttachmentOrigin"];
            this.soidDontCalculateSellingPriceWhenAddingProductWithZeroQuantity = _data["soidDontCalculateSellingPriceWhenAddingProductWithZeroQuantity"];
            this.soidSupplierInvoiceConfirmZeroTax = _data["soidSupplierInvoiceConfirmZeroTax"];
            this.soidSupplierInvoiceAllowAlternateCreditor = _data["soidSupplierInvoiceAllowAlternateCreditor"];
            this.soidSupplierInvoiceAutoCalcSettlementDiscOnInvoices = _data["soidSupplierInvoiceAutoCalcSettlementDiscOnInvoices"];
            this.soidSupplierInvoiceIncludeCostOnDirectLineDescription = _data["soidSupplierInvoiceIncludeCostOnDirectLineDescription"];
            this.soidSupplierInvoiceEnablePostingDate = _data["soidSupplierInvoiceEnablePostingDate"];
            this.soidSupplierInvoiceAutoSelectPostingDate = _data["soidSupplierInvoiceAutoSelectPostingDate"];
            this.soidSupplierInvoiceOnlyExportDiscountsNotEqualToZero = _data["soidSupplierInvoiceOnlyExportDiscountsNotEqualToZero"];
            this.soidSupplierInvoiceCanadianTaxInput = _data["soidSupplierInvoiceCanadianTaxInput"];
            this.soidSupplierInvoiceShowSupplierProductCode = _data["soidSupplierInvoiceShowSupplierProductCode"];
            this.soidSupplierInvoiceAllowZeroTotalInvoices = _data["soidSupplierInvoiceAllowZeroTotalInvoices"];
            this.soidSupplierInvoiceDisplayExpectedCostsFromPO = _data["soidSupplierInvoiceDisplayExpectedCostsFromPO"];
            this.soidSupplierInvoiceEnableWorkflow = _data["soidSupplierInvoiceEnableWorkflow"];
            this.soidSupplierInvoiceShowBrowseForGLSubCodeThreshold = _data["soidSupplierInvoiceShowBrowseForGLSubCodeThreshold"];
            this.soidSupplierInvoiceRestrictWorkflowMessagesToSingleRecipient = _data["soidSupplierInvoiceRestrictWorkflowMessagesToSingleRecipient"];
            this.soidSupplierInvoiceGPIncludePOSupplierCodeWhenAlternativeCreditor = _data["soidSupplierInvoiceGPIncludePOSupplierCodeWhenAlternativeCreditor"];
            this.soidSupplierInvoiceRequireWorkflowMessageRecipient = _data["soidSupplierInvoiceRequireWorkflowMessageRecipient"];
            this.soidSupplierCreditRequiresReasonCode = _data["soidSupplierCreditRequiresReasonCode"];
            this.soidSupplierInvoicePrintBarcodeLabelOnMatchOrMatchAndApprove = _data["soidSupplierInvoicePrintBarcodeLabelOnMatchOrMatchAndApprove"];
            this.soidSupplierInvoiceAllowMatchingDirectSupplierInvoiceWhenPaymentOutstanding = _data["soidSupplierInvoiceAllowMatchingDirectSupplierInvoiceWhenPaymentOutstanding"];
            this.soidSupplierInvoiceSendOtherRefAsPONumberToGPForOverheadSIs = _data["soidSupplierInvoiceSendOtherRefAsPONumberToGPForOverheadSIs"];
            this.soidSupplierInvoiceSkipMsgsWhenMatchingApproving = _data["soidSupplierInvoiceSkipMsgsWhenMatchingApproving"];
            this.soidSupplierInvoiceBranchSelectionType = _data["soidSupplierInvoiceBranchSelectionType"];
            this.soidSupplierInvoiceCalculateGoodsTotalOnOverheadInvoicesWithNoPurchaseOrder = _data["soidSupplierInvoiceCalculateGoodsTotalOnOverheadInvoicesWithNoPurchaseOrder"];
            this.soidNavisionUseIssuingBranchForDimension = _data["soidNavisionUseIssuingBranchForDimension"];
            this.soidLoyaltyCurrencyToPointExchangeRate = _data["soidLoyaltyCurrencyToPointExchangeRate"];
            this.soidLoyaltyOrderEntryPromptPointMinimum = _data["soidLoyaltyOrderEntryPromptPointMinimum"];
            this.soidLoyaltyRedeemManualOrderLineType = _data["soidLoyaltyRedeemManualOrderLineType"];
            this.soidLoyaltyRepeatRewardsMOLT = _data["soidLoyaltyRepeatRewardsMOLT"];
            this.soidDefaultSystemToImperial = _data["soidDefaultSystemToImperial"];
            this.soidWeightPer = _data["soidWeightPer"];
            this.soidWeightDecimalPlaces = _data["soidWeightDecimalPlaces"];
            this.soidQuotePickDocumentReleaseFormat = _data["soidQuotePickDocumentReleaseFormat"];
            this.soidDepartmentUsage = _data["soidDepartmentUsage"];
            this.soidDefaultDepartmentUsageDepartment = _data["soidDefaultDepartmentUsageDepartment"];
            this.soidGeneralEnableReportingCost = _data["soidGeneralEnableReportingCost"];
            this.soidAllowManualAdjustmentOfVolumeOnAdditionalCostProrations = _data["soidAllowManualAdjustmentOfVolumeOnAdditionalCostProrations"];
            this.soidShowJobReferenceInLists = _data["soidShowJobReferenceInLists"];
            this.soidAllowMultipleOrderReferenceMasks = _data["soidAllowMultipleOrderReferenceMasks"];
            this.soidLimitSellAndBuyPriceChangesToBranchWithUpdateAccess = _data["soidLimitSellAndBuyPriceChangesToBranchWithUpdateAccess"];
            this.soidGeneralEnableNotepadNotifications = _data["soidGeneralEnableNotepadNotifications"];
            this.soidGeneralValidateDefaultRefOnCustomerAddress = _data["soidGeneralValidateDefaultRefOnCustomerAddress"];
            this.soidLimitRelatedDocsBasedOnBranchAccess = _data["soidLimitRelatedDocsBasedOnBranchAccess"];
            this.soidVerifyInternalGiftCardsAgainstLoadedGiftCardList = _data["soidVerifyInternalGiftCardsAgainstLoadedGiftCardList"];
            this.soidSetDepartmentOnOrdersDuringCreation = _data["soidSetDepartmentOnOrdersDuringCreation"];
            this.soidUpdateTransactionLineManualDescriptionWithSpecialProductDescription = _data["soidUpdateTransactionLineManualDescriptionWithSpecialProductDescription"];
            this.soidDefaultCustomerNotepadTypeFilterFromUserOption = _data["soidDefaultCustomerNotepadTypeFilterFromUserOption"];
            this.soidDepartmentOnAccountPaymentsWhereDepartmentUsageIsSalesRepOrComputer = _data["soidDepartmentOnAccountPaymentsWhereDepartmentUsageIsSalesRepOrComputer"];
            this.soidDepartmentOnCashDrawerLodgementsWhereDepartmentUsageIsSalesRepOrComputer = _data["soidDepartmentOnCashDrawerLodgementsWhereDepartmentUsageIsSalesRepOrComputer"];
            this.soidPricingPlannerSmartView1 = _data["soidPricingPlannerSmartView1"];
            this.soidPricingPlannerSmartView2 = _data["soidPricingPlannerSmartView2"];
            this.soidPricingPlannerSmartView3 = _data["soidPricingPlannerSmartView3"];
            this.soidPricingPlannerSmartView4 = _data["soidPricingPlannerSmartView4"];
            this.soidPricingPlannerSmartView5 = _data["soidPricingPlannerSmartView5"];
            this.soidWorksOrderSpecifyFinQtyWhenConfirmSourcePacks = _data["soidWorksOrderSpecifyFinQtyWhenConfirmSourcePacks"];
            this.soidPurchasingLimitFindProdToSupplier = _data["soidPurchasingLimitFindProdToSupplier"];
            this.soidPurchasingAllowApprovalIfCreditProblem = _data["soidPurchasingAllowApprovalIfCreditProblem"];
            this.soidPurchasingAutoApproveDirectOrders = _data["soidPurchasingAutoApproveDirectOrders"];
            this.soidPurchaseOrderSecondaryCostCalculation = _data["soidPurchaseOrderSecondaryCostCalculation"];
            this.soidPurchasingAutoApproveBackToBackOrders = _data["soidPurchasingAutoApproveBackToBackOrders"];
            this.soidPurchasingRoundToInnerOuterPallet = _data["soidPurchasingRoundToInnerOuterPallet"];
            this.soidPurchasingInputGLCodeOnOverheadAdvanced = _data["soidPurchasingInputGLCodeOnOverheadAdvanced"];
            this.soidPurchasingWarnWhenNotPrimarySupplier = _data["soidPurchasingWarnWhenNotPrimarySupplier"];
            this.soidPurchasingAutoPrintDirectOrders = _data["soidPurchasingAutoPrintDirectOrders"];
            this.soidPurchasingAutoPrintBackToBackOrders = _data["soidPurchasingAutoPrintBackToBackOrders"];
            this.soidPurchasingPopulateAnalysisCodeOnGeneratedPO = _data["soidPurchasingPopulateAnalysisCodeOnGeneratedPO"];
            this.soidPurchasingCopyCostPerFromDirectOrBackToBack = _data["soidPurchasingCopyCostPerFromDirectOrBackToBack"];
            this.soidPurchasingAllowCostQtyChangeAfterStockReceipt = _data["soidPurchasingAllowCostQtyChangeAfterStockReceipt"];
            this.soidPurchasingCostToleranceWarning = _data["soidPurchasingCostToleranceWarning"];
            this.soidPurchasingWarnIfNotInnerOuterPalletMultiple = _data["soidPurchasingWarnIfNotInnerOuterPalletMultiple"];
            this.soidPurchasingAllowPrintingUnapprovedPurchaseOrders = _data["soidPurchasingAllowPrintingUnapprovedPurchaseOrders"];
            this.soidPurchaseOrderCallOffAutoComplete = _data["soidPurchaseOrderCallOffAutoComplete"];
            this.soidPurchasingShowAndAllowUpdateOfStandardBuyPrice = _data["soidPurchasingShowAndAllowUpdateOfStandardBuyPrice"];
            this.soidPurchasingDefaultAnalysisCodeOnGenerateFromAVO = _data["soidPurchasingDefaultAnalysisCodeOnGenerateFromAVO"];
            this.soidPurchasingShowCustomerOnInternalNotes = _data["soidPurchasingShowCustomerOnInternalNotes"];
            this.soidPurchasingDefaultInputPerToSupplierBuyPer = _data["soidPurchasingDefaultInputPerToSupplierBuyPer"];
            this.soidPurchasingDisplayCompletionButtonsOnPO = _data["soidPurchasingDisplayCompletionButtonsOnPO"];
            this.soidPurchasingDisplayCreatePOOnAddCostChargeOnXfers = _data["soidPurchasingDisplayCreatePOOnAddCostChargeOnXfers"];
            this.soidPurchasingAlwaysUseOverriddenDimsOnAddCosts = _data["soidPurchasingAlwaysUseOverriddenDimsOnAddCosts"];
            this.soidPurchasingApplyEnvironmentalStatusRestrictions = _data["soidPurchasingApplyEnvironmentalStatusRestrictions"];
            this.soidPurchasingAllowChangingUnitCostForCostControlledItems = _data["soidPurchasingAllowChangingUnitCostForCostControlledItems"];
            this.soidGenerateCallOffPOForDirectSO = _data["soidGenerateCallOffPOForDirectSO"];
            this.soidPurchasingPromptForSellPriceWhenDirectCostChanged = _data["soidPurchasingPromptForSellPriceWhenDirectCostChanged"];
            this.soidPurchasingKeepDateRequiredInSynchForDirects = _data["soidPurchasingKeepDateRequiredInSynchForDirects"];
            this.soidPurchasingCheckForCallOffs = _data["soidPurchasingCheckForCallOffs"];
            this.soidPurchasingSetDefaultStockLocation = _data["soidPurchasingSetDefaultStockLocation"];
            this.soidPurchasingPurchaseOrderChangeApprovalThreshold = _data["soidPurchasingPurchaseOrderChangeApprovalThreshold"];
            this.soidPurchasingUseLeadTimeToSetPOLineDateExpected = _data["soidPurchasingUseLeadTimeToSetPOLineDateExpected"];
            this.soidIncludeOrderLineLinksForSOItemsOnWMSPOs = _data["soidIncludeOrderLineLinksForSOItemsOnWMSPOs"];
            this.soidPurchasingPromptForBuyPriceRuleSelection = _data["soidPurchasingPromptForBuyPriceRuleSelection"];
            this.soidGLCodeSelectionMethodForMOLTsOnOverheadPO = _data["soidGLCodeSelectionMethodForMOLTsOnOverheadPO"];
            this.soidCentralizedPurchasingIncludesSourcedByTransfer = _data["soidCentralizedPurchasingIncludesSourcedByTransfer"];
            this.soidSuggestedOrdersSmartView1 = _data["soidSuggestedOrdersSmartView1"];
            this.soidSuggestedOrdersSmartView2 = _data["soidSuggestedOrdersSmartView2"];
            this.soidSuggestedOrdersSmartView3 = _data["soidSuggestedOrdersSmartView3"];
            this.soidSuggestedOrdersSmartView4 = _data["soidSuggestedOrdersSmartView4"];
            this.soidSuggestedOrdersSmartView5 = _data["soidSuggestedOrdersSmartView5"];
            this.soidSuggestedOrdersAdjustByStockClass = _data["soidSuggestedOrdersAdjustByStockClass"];
            this.soidDefaultPurchaseAnalysisCodeOnOverheadPOs = _data["soidDefaultPurchaseAnalysisCodeOnOverheadPOs"];
            this.soidPurchasingUseSecondaryCostWhenPrimaryCostValueIsZero = _data["soidPurchasingUseSecondaryCostWhenPrimaryCostValueIsZero"];
            this.soidPurchasingShow15LevelsForAutoAverageCostAdjRule = _data["soidPurchasingShow15LevelsForAutoAverageCostAdjRule"];
            this.soidRetainRaisedByInformationWhenConvertingPOToADirect = _data["soidRetainRaisedByInformationWhenConvertingPOToADirect"];
            this.soidApplyFixedAmountManualLinesAndAdditionalCostsToAllStockReceipts = _data["soidApplyFixedAmountManualLinesAndAdditionalCostsToAllStockReceipts"];
            this.soidPurchasingSetMOLTDescriptionToGLCodeDescriptionOnOverheadPO = _data["soidPurchasingSetMOLTDescriptionToGLCodeDescriptionOnOverheadPO"];
            this.soidPurchasingAutoPrintLabels = _data["soidPurchasingAutoPrintLabels"];
            this.soidPurchasingShowSupplierPopupForAutomaticPurchaseOrders = _data["soidPurchasingShowSupplierPopupForAutomaticPurchaseOrders"];
            this.soidSuggestedOrderingIncludeAllOpenPurchaseOrders = _data["soidSuggestedOrderingIncludeAllOpenPurchaseOrders"];
            this.soidFindDocPreviewPaneSmartViewSO1 = _data["soidFindDocPreviewPaneSmartViewSO1"];
            this.soidFindDocPreviewPaneSmartViewSO2 = _data["soidFindDocPreviewPaneSmartViewSO2"];
            this.soidFindDocPreviewPaneSmartViewSO3 = _data["soidFindDocPreviewPaneSmartViewSO3"];
            this.soidFindDocPreviewPaneSmartViewSO4 = _data["soidFindDocPreviewPaneSmartViewSO4"];
            this.soidFindDocPreviewPaneSmartViewSO5 = _data["soidFindDocPreviewPaneSmartViewSO5"];
            this.soidFindDocPreviewPaneSmartViewQU1 = _data["soidFindDocPreviewPaneSmartViewQU1"];
            this.soidFindDocPreviewPaneSmartViewQU2 = _data["soidFindDocPreviewPaneSmartViewQU2"];
            this.soidFindDocPreviewPaneSmartViewQU3 = _data["soidFindDocPreviewPaneSmartViewQU3"];
            this.soidFindDocPreviewPaneSmartViewQU4 = _data["soidFindDocPreviewPaneSmartViewQU4"];
            this.soidFindDocPreviewPaneSmartViewQU5 = _data["soidFindDocPreviewPaneSmartViewQU5"];
            this.soidFindDocPreviewPaneSmartViewCO1 = _data["soidFindDocPreviewPaneSmartViewCO1"];
            this.soidFindDocPreviewPaneSmartViewCO2 = _data["soidFindDocPreviewPaneSmartViewCO2"];
            this.soidFindDocPreviewPaneSmartViewCO3 = _data["soidFindDocPreviewPaneSmartViewCO3"];
            this.soidFindDocPreviewPaneSmartViewCO4 = _data["soidFindDocPreviewPaneSmartViewCO4"];
            this.soidFindDocPreviewPaneSmartViewCO5 = _data["soidFindDocPreviewPaneSmartViewCO5"];
            this.soidFindDocPreviewPaneSmartViewPO1 = _data["soidFindDocPreviewPaneSmartViewPO1"];
            this.soidFindDocPreviewPaneSmartViewPO2 = _data["soidFindDocPreviewPaneSmartViewPO2"];
            this.soidFindDocPreviewPaneSmartViewPO3 = _data["soidFindDocPreviewPaneSmartViewPO3"];
            this.soidFindDocPreviewPaneSmartViewPO4 = _data["soidFindDocPreviewPaneSmartViewPO4"];
            this.soidFindDocPreviewPaneSmartViewPO5 = _data["soidFindDocPreviewPaneSmartViewPO5"];
            this.soidFindDocPreviewPaneSmartViewCN1 = _data["soidFindDocPreviewPaneSmartViewCN1"];
            this.soidFindDocPreviewPaneSmartViewCN2 = _data["soidFindDocPreviewPaneSmartViewCN2"];
            this.soidFindDocPreviewPaneSmartViewCN3 = _data["soidFindDocPreviewPaneSmartViewCN3"];
            this.soidFindDocPreviewPaneSmartViewCN4 = _data["soidFindDocPreviewPaneSmartViewCN4"];
            this.soidFindDocPreviewPaneSmartViewCN5 = _data["soidFindDocPreviewPaneSmartViewCN5"];
            this.soidSalesOrderAllowChangeCurrencies = _data["soidSalesOrderAllowChangeCurrencies"];
            this.soidSalesOrderChangeTakenBy = _data["soidSalesOrderChangeTakenBy"];
            this.soidSalesOrderForceSupplierReview = _data["soidSalesOrderForceSupplierReview"];
            this.soidSalesOrderWarnIfDirectCostNotChanged = _data["soidSalesOrderWarnIfDirectCostNotChanged"];
            this.soidSalesOrderMaximumReservationDays = _data["soidSalesOrderMaximumReservationDays"];
            this.soidSalesOrderAllowDirectSalesInCounterSales = _data["soidSalesOrderAllowDirectSalesInCounterSales"];
            this.soidSalesOrderOnlyApproveIssuedOrders = _data["soidSalesOrderOnlyApproveIssuedOrders"];
            this.soidSalesOrderParkedOrderFormats = _data["soidSalesOrderParkedOrderFormats"];
            this.soidSalesOrderWaitForNewStockOnBackOrder = _data["soidSalesOrderWaitForNewStockOnBackOrder"];
            this.soidSalesOrderWarnIfOrderLinePriceIsZero = _data["soidSalesOrderWarnIfOrderLinePriceIsZero"];
            this.soidSalesOrderDeliveryAreaRequired = _data["soidSalesOrderDeliveryAreaRequired"];
            this.soidSalesOrderAllowCashBackOnCashSales = _data["soidSalesOrderAllowCashBackOnCashSales"];
            this.soidSalesOrderMaintainTakenByFromOriginalOrderOnBackOrder = _data["soidSalesOrderMaintainTakenByFromOriginalOrderOnBackOrder"];
            this.soidMarkOrderApprovedWhenStockIssued = _data["soidMarkOrderApprovedWhenStockIssued"];
            this.soidDefaultSpecialOrderQtyChangeToCreateBackOrder = _data["soidDefaultSpecialOrderQtyChangeToCreateBackOrder"];
            this.soidOrdersSuppressStockUpdatesDuringEntry = _data["soidOrdersSuppressStockUpdatesDuringEntry"];
            this.soidOrdersProductCodeColumnContent = _data["soidOrdersProductCodeColumnContent"];
            this.soidOrdersReserveStockOnCallOff = _data["soidOrdersReserveStockOnCallOff"];
            this.soidOrdersAutoApplyDeliveryCharges = _data["soidOrdersAutoApplyDeliveryCharges"];
            this.soidOrdersDisplayCommissionCode = _data["soidOrdersDisplayCommissionCode"];
            this.soidOrdersForceSupplierToBeChangedWhenSupplierIs = _data["soidOrdersForceSupplierToBeChangedWhenSupplierIs"];
            this.soidSignatureCaptureCollectNow = _data["soidSignatureCaptureCollectNow"];
            this.soidSignatureCaptureCollectLater = _data["soidSignatureCaptureCollectLater"];
            this.soidOrdersShowBinLocationFromSROnSOLine = _data["soidOrdersShowBinLocationFromSROnSOLine"];
            this.soidOrderExcludeParkedOrdersFromOnOrderBalance = _data["soidOrderExcludeParkedOrdersFromOnOrderBalance"];
            this.soidOrdersDisplayStockLocationOnOrderEntry = _data["soidOrdersDisplayStockLocationOnOrderEntry"];
            this.soidOrdersDefaultVehicleType = _data["soidOrdersDefaultVehicleType"];
            this.soidOrdersDefaultOrderMonitorToAllBranches = _data["soidOrdersDefaultOrderMonitorToAllBranches"];
            this.soidOrdersDefaultSellPriceFromParentNATally = _data["soidOrdersDefaultSellPriceFromParentNATally"];
            this.soidOrdersDefaultCustomerSearchOnOrdersToAddress = _data["soidOrdersDefaultCustomerSearchOnOrdersToAddress"];
            this.soidOrdersManualLineDeliveryChargeExclusionCode = _data["soidOrdersManualLineDeliveryChargeExclusionCode"];
            this.soidOrdersDisplayTotalCostInOrderTotals = _data["soidOrdersDisplayTotalCostInOrderTotals"];
            this.soidOrdersAutoApplyRebateAccruals = _data["soidOrdersAutoApplyRebateAccruals"];
            this.soidOrdersDisplayNegWarningOnGeneral = _data["soidOrdersDisplayNegWarningOnGeneral"];
            this.soidOrdersAllowOverrideOfRebateSaleType = _data["soidOrdersAllowOverrideOfRebateSaleType"];
            this.soidOrdersOnlyCalcTransferCostForBranchesWithStock = _data["soidOrdersOnlyCalcTransferCostForBranchesWithStock"];
            this.soidOrdersEnableMultipleBranches = _data["soidOrdersEnableMultipleBranches"];
            this.soidOrdersMixedBranchRestrictions = _data["soidOrdersMixedBranchRestrictions"];
            this.soidOrdersAllowMixedSaleTypesOnOrders = _data["soidOrdersAllowMixedSaleTypesOnOrders"];
            this.soidOrdersEnterAddressViaForm = _data["soidOrdersEnterAddressViaForm"];
            this.soidOrdersCallOffAllowCreateSOFromMultipleCallOffs = _data["soidOrdersCallOffAllowCreateSOFromMultipleCallOffs"];
            this.soidOrdersEnableCollectNow = _data["soidOrdersEnableCollectNow"];
            this.soidOrdersEnableCollectLater = _data["soidOrdersEnableCollectLater"];
            this.soidOrdersEnableDelivered = _data["soidOrdersEnableDelivered"];
            this.soidOrdersEnableDirect = _data["soidOrdersEnableDirect"];
            this.soidOrdersShowQuickProductsInCounter = _data["soidOrdersShowQuickProductsInCounter"];
            this.soidOrdersAllowTextLines = _data["soidOrdersAllowTextLines"];
            this.soidOrdersAllowCustomerLookupByAddress = _data["soidOrdersAllowCustomerLookupByAddress"];
            this.soidOrdersAllowMultipleSalesRepPerOrder = _data["soidOrdersAllowMultipleSalesRepPerOrder"];
            this.soidOrdersMinimumDeposit = _data["soidOrdersMinimumDeposit"];
            this.soidOrdersMergeDirectPOsForSameSO = _data["soidOrdersMergeDirectPOsForSameSO"];
            this.soidOrdersWarnIfVehicleTypeNotSet = _data["soidOrdersWarnIfVehicleTypeNotSet"];
            this.soidOrdersCallOffScheduleColumn1Heading = _data["soidOrdersCallOffScheduleColumn1Heading"];
            this.soidOrdersCallOffScheduleColumn2Heading = _data["soidOrdersCallOffScheduleColumn2Heading"];
            this.soidOrdersPromptForPacksIfAlwaysPackSelling = _data["soidOrdersPromptForPacksIfAlwaysPackSelling"];
            this.soidOrdersAllowIssuingStockFromOtherBranches = _data["soidOrdersAllowIssuingStockFromOtherBranches"];
            this.soidOrdersAllowIssuingBranchWithReadOnlyAccess = _data["soidOrdersAllowIssuingBranchWithReadOnlyAccess"];
            this.soidOrdersKeepDeliveryAddressForCollectSales = _data["soidOrdersKeepDeliveryAddressForCollectSales"];
            this.soidOrdersHideAvailableCreditOnSO = _data["soidOrdersHideAvailableCreditOnSO"];
            this.soidOrdersCopyProductInternalLineNotesToLineNotes = _data["soidOrdersCopyProductInternalLineNotesToLineNotes"];
            this.soidOrdersPromptToMarkOrderAsCollectedOnSaveAndClose = _data["soidOrdersPromptToMarkOrderAsCollectedOnSaveAndClose"];
            this.soidOrdersAllowChangeOfNotesAndTypeOnOrdersInvoiced = _data["soidOrdersAllowChangeOfNotesAndTypeOnOrdersInvoiced"];
            this.soidOrdersAllowFractionalKits = _data["soidOrdersAllowFractionalKits"];
            this.soidOrdersSortByBinLocationWhenConsolidatingProductLines = _data["soidOrdersSortByBinLocationWhenConsolidatingProductLines"];
            this.soidOrdersSpecialsCopyEnvironmentalStatus = _data["soidOrdersSpecialsCopyEnvironmentalStatus"];
            this.soidOrdersCanChangeSaleTypeIfCardholderNotPresentPayment = _data["soidOrdersCanChangeSaleTypeIfCardholderNotPresentPayment"];
            this.soidOrdersIgnoreAllowProceedonStockWarningforBackOrder = _data["soidOrdersIgnoreAllowProceedonStockWarningforBackOrder"];
            this.soidDisableOtherSizeOptionForStockByLengthProductsOnOrders = _data["soidDisableOtherSizeOptionForStockByLengthProductsOnOrders"];
            this.soidOrdersDisplayOrderNumberDialog = _data["soidOrdersDisplayOrderNumberDialog"];
            this.soidOrdersSkipOrderCompletionDialog = _data["soidOrdersSkipOrderCompletionDialog"];
            this.soidOrdersWarnSupplierMinAmountOnPOs = _data["soidOrdersWarnSupplierMinAmountOnPOs"];
            this.soidPickVehicleWhenMarkingOrderAsDelivered = _data["soidPickVehicleWhenMarkingOrderAsDelivered"];
            this.soidShowTotalQuantityInformationinCounterSales = _data["soidShowTotalQuantityInformationinCounterSales"];
            this.soidForceAddressSelectionInCounterSales = _data["soidForceAddressSelectionInCounterSales"];
            this.soidCopySellPriceAndCostOnSpecialOrderCopyFromBaseItem = _data["soidCopySellPriceAndCostOnSpecialOrderCopyFromBaseItem"];
            this.soidUpdateExistingPOOnDirectBO = _data["soidUpdateExistingPOOnDirectBO"];
            this.soidOrdersApplyEnvironmentalStatusRestrictions = _data["soidOrdersApplyEnvironmentalStatusRestrictions"];
            this.soidOrdersShowChangeInformationDuringPrint = _data["soidOrdersShowChangeInformationDuringPrint"];
            this.soidOrdersReasonCodeOnLineAmend = _data["soidOrdersReasonCodeOnLineAmend"];
            this.soidAllowLadingQuantityEntryDuringPicking = _data["soidAllowLadingQuantityEntryDuringPicking"];
            this.soidOrdersMinimumDepositThreshold = _data["soidOrdersMinimumDepositThreshold"];
            this.soidOrdersRequireFullPaymentWhenBelowMinimumDepositThreshold = _data["soidOrdersRequireFullPaymentWhenBelowMinimumDepositThreshold"];
            this.soidOrdersDisplayMinimumDepositOverrideButton = _data["soidOrdersDisplayMinimumDepositOverrideButton"];
            this.soidOrdersSpecialLinesOnCashSalesMustBePaidInFull = _data["soidOrdersSpecialLinesOnCashSalesMustBePaidInFull"];
            this.soidOrdersShowTaxAreaButton = _data["soidOrdersShowTaxAreaButton"];
            this.soidOrdersBackOrderReleaseCheckAvailableStock = _data["soidOrdersBackOrderReleaseCheckAvailableStock"];
            this.soidOrdersCheckMinimumDepositOnBackOrders = _data["soidOrdersCheckMinimumDepositOnBackOrders"];
            this.soidOrdersPromptForReferenceInCounter = _data["soidOrdersPromptForReferenceInCounter"];
            this.soidWarnWhenDateRequiredMonthsInAdvance = _data["soidWarnWhenDateRequiredMonthsInAdvance"];
            this.soidOrderFixOriginalQtyAt = _data["soidOrderFixOriginalQtyAt"];
            this.soidForceAddressSelectionInOperations = _data["soidForceAddressSelectionInOperations"];
            this.soidOrdersDisplayPaymentScreenOnModifiedDeliveredCashSale = _data["soidOrdersDisplayPaymentScreenOnModifiedDeliveredCashSale"];
            this.soidSalesOrderSetDefaultSupplierOnDirects = _data["soidSalesOrderSetDefaultSupplierOnDirects"];
            this.soidOrdersOpenPurchaseOrders = _data["soidOrdersOpenPurchaseOrders"];
            this.soidOrdersLargeKitProcessing = _data["soidOrdersLargeKitProcessing"];
            this.soidOrdersEnableEditQtyAndPriceInGrid = _data["soidOrdersEnableEditQtyAndPriceInGrid"];
            this.soidTransferCreatorModify = _data["soidTransferCreatorModify"];
            this.soidTransferCreatedByReceivingBranch = _data["soidTransferCreatedByReceivingBranch"];
            this.soidTransferAutoApplyDeliveryCosts = _data["soidTransferAutoApplyDeliveryCosts"];
            this.soidTransferReceiptConfirmationFormat = _data["soidTransferReceiptConfirmationFormat"];
            this.soidTransferCanChangeViaBranch = _data["soidTransferCanChangeViaBranch"];
            this.soidTransferCostCalculation = _data["soidTransferCostCalculation"];
            this.soidTransferReturnAutoApplyDeliveryCosts = _data["soidTransferReturnAutoApplyDeliveryCosts"];
            this.soidDefaultTransferSaleType = _data["soidDefaultTransferSaleType"];
            this.soidTransferSplitPacksToLoose = _data["soidTransferSplitPacksToLoose"];
            this.soidTransferRequireUpdateAccessForToBranch = _data["soidTransferRequireUpdateAccessForToBranch"];
            this.soidTransferAllowZeroCost = _data["soidTransferAllowZeroCost"];
            this.soidTransferAllowToBeLessThanCurrentCost = _data["soidTransferAllowToBeLessThanCurrentCost"];
            this.soidTransferRequirePackConfirmation = _data["soidTransferRequirePackConfirmation"];
            this.soidTransferApplyUplifts = _data["soidTransferApplyUplifts"];
            this.soidTransferBranchAccessLevelRequiredForFromBranch = _data["soidTransferBranchAccessLevelRequiredForFromBranch"];
            this.soidTransferReturnAtOriginalCost = _data["soidTransferReturnAtOriginalCost"];
            this.soidTransferRequireSendingBranchApproval = _data["soidTransferRequireSendingBranchApproval"];
            this.soidTransferApprovalRequiredBeforeAllocation = _data["soidTransferApprovalRequiredBeforeAllocation"];
            this.soidTransferSuggestionQuantity = _data["soidTransferSuggestionQuantity"];
            this.soidTransferDontApproveAllocateStockTransfersLinkedToPOUntilReceived = _data["soidTransferDontApproveAllocateStockTransfersLinkedToPOUntilReceived"];
            this.soidTransferReturnUseOriginalBranchInGLTransferUplift = _data["soidTransferReturnUseOriginalBranchInGLTransferUplift"];
            this.soidTransferDateRequiredFromManufacturedSpecials = _data["soidTransferDateRequiredFromManufacturedSpecials"];
            this.soidCalculateBranchTransferCostsBasedOnTotalValues = _data["soidCalculateBranchTransferCostsBasedOnTotalValues"];
            this.soidTransferDateRequiredDaysBetweenPOAndLinkTransfers = _data["soidTransferDateRequiredDaysBetweenPOAndLinkTransfers"];
            this.soidTransferUpdateDateRequiredWhenLinkedSODateRequiredChanges = _data["soidTransferUpdateDateRequiredWhenLinkedSODateRequiredChanges"];
            this.soidOrdersNewOneTimeAddressIsBlank = _data["soidOrdersNewOneTimeAddressIsBlank"];
            this.soidTransferReceiveInBranchesNotLoggedIn = _data["soidTransferReceiveInBranchesNotLoggedIn"];
            this.soidTransferCopyOrderLineAVOsToTransferLineWhenSourcedFromTransfer = _data["soidTransferCopyOrderLineAVOsToTransferLineWhenSourcedFromTransfer"];
            this.soidTransferUseVMICostForBranchTransferCostOnVMIProducts = _data["soidTransferUseVMICostForBranchTransferCostOnVMIProducts"];
            this.soidOrdersCopyFromSelectMultipleTemplates = _data["soidOrdersCopyFromSelectMultipleTemplates"];
            this.soidUpdateSpecialOrderCostOnChangesOnPO_SR_SI = _data["soidUpdateSpecialOrderCostOnChangesOnPO_SR_SI"];
            this.soidLumpSumSectionsOnCopyFrom = _data["soidLumpSumSectionsOnCopyFrom"];
            this.soidConsolidatePositiveQuantitiesWithinSectionsByDefault = _data["soidConsolidatePositiveQuantitiesWithinSectionsByDefault"];
            this.soidOpenOrderLinePropertiesForRelatedProducts = _data["soidOpenOrderLinePropertiesForRelatedProducts"];
            this.soidOrdersNotifyIfDeletedLinesOnSalesTransactionCopy = _data["soidOrdersNotifyIfDeletedLinesOnSalesTransactionCopy"];
            this.soidOrderSectionsToMaintainSectionPrice = _data["soidOrderSectionsToMaintainSectionPrice"];
            this.soidBackToBackIgnoresHowSourced = _data["soidBackToBackIgnoresHowSourced"];
            this.soidSectionSelectionBoxType = _data["soidSectionSelectionBoxType"];
            this.soidOrdersPromptForBuyPriceRuleOnBackToBackPO = _data["soidOrdersPromptForBuyPriceRuleOnBackToBackPO"];
            this.soidOrdersAllowChangingSaleTypeAndDeliveryAfterPicking = _data["soidOrdersAllowChangingSaleTypeAndDeliveryAfterPicking"];
            this.soidOrdersAllowChangingScheduledSalesOrders = _data["soidOrdersAllowChangingScheduledSalesOrders"];
            this.soidDefaultAddressTypeWhenCreatedFromSalesOrders = _data["soidDefaultAddressTypeWhenCreatedFromSalesOrders"];
            this.soidCreateJobAddressesInSalesTransactionWithQuickJobScreen = _data["soidCreateJobAddressesInSalesTransactionWithQuickJobScreen"];
            this.soidApplyPermissionsOnChangesWithPickingNotePrintedToDeliveredOrdersOnly = _data["soidApplyPermissionsOnChangesWithPickingNotePrintedToDeliveredOrdersOnly"];
            this.soidTransfersAdvanceDaysFromOrder = _data["soidTransfersAdvanceDaysFromOrder"];
            this.soidAllowEditingKitsAfterBackToBackPurchaseOrderApproved = _data["soidAllowEditingKitsAfterBackToBackPurchaseOrderApproved"];
            this.soidParkOrdersWhenWorkOrderDateRequiredFull = _data["soidParkOrdersWhenWorkOrderDateRequiredFull"];
            this.soidOrdersPromptDuringOrderEntryWhenDefaultBatchDoesNotExist = _data["soidOrdersPromptDuringOrderEntryWhenDefaultBatchDoesNotExist"];
            this.soidOrdersPromptDuringPickingWhenDefaultBatchDoesNotExist = _data["soidOrdersPromptDuringPickingWhenDefaultBatchDoesNotExist"];
            this.soidSuggestedOrdersIncludeSuggestionsInStockAvailable = _data["soidSuggestedOrdersIncludeSuggestionsInStockAvailable"];
            this.soidAllowAdjustmentOfQuantityDuringReceiptOfStockTransfer = _data["soidAllowAdjustmentOfQuantityDuringReceiptOfStockTransfer"];
            this.soidReasonCodeForACAGenearatedFromQuantityAdjustmentTransfers = _data["soidReasonCodeForACAGenearatedFromQuantityAdjustmentTransfers"];
            this.soidOrdersUseAlternatePaymentTermsByProductGroup = _data["soidOrdersUseAlternatePaymentTermsByProductGroup"];
            this.soidWMSOnlyReleaseLinesAvailForPickWhenSplitDelivAllowed = _data["soidWMSOnlyReleaseLinesAvailForPickWhenSplitDelivAllowed"];
            this.soidFindProductSmartView1 = _data["soidFindProductSmartView1"];
            this.soidFindProductSmartView2 = _data["soidFindProductSmartView2"];
            this.soidFindProductSmartView3 = _data["soidFindProductSmartView3"];
            this.soidFindProductSmartView4 = _data["soidFindProductSmartView4"];
            this.soidFindProductSmartView5 = _data["soidFindProductSmartView5"];
            this.soidFindCustomerSmartView1 = _data["soidFindCustomerSmartView1"];
            this.soidFindCustomerSmartView2 = _data["soidFindCustomerSmartView2"];
            this.soidFindCustomerSmartView3 = _data["soidFindCustomerSmartView3"];
            this.soidFindCustomerSmartView4 = _data["soidFindCustomerSmartView4"];
            this.soidFindCustomerSmartView5 = _data["soidFindCustomerSmartView5"];
            this.soidJourneyPlannerSmartView1 = _data["soidJourneyPlannerSmartView1"];
            this.soidJourneyPlannerSmartView2 = _data["soidJourneyPlannerSmartView2"];
            this.soidJourneyPlannerSmartView3 = _data["soidJourneyPlannerSmartView3"];
            this.soidJourneyPlannerSmartView4 = _data["soidJourneyPlannerSmartView4"];
            this.soidJourneyPlannerSmartView5 = _data["soidJourneyPlannerSmartView5"];
            this.soidOrderQuotesForceFollowUp = _data["soidOrderQuotesForceFollowUp"];
            this.soidOrderQuotesFollowUpDays = _data["soidOrderQuotesFollowUpDays"];
            this.soidOrderQuotesFollowUpNotepadType = _data["soidOrderQuotesFollowUpNotepadType"];
            this.soidOrderQuotesApplyMarginWarningAndStops = _data["soidOrderQuotesApplyMarginWarningAndStops"];
            this.soidOrderQuotesAllowPark = _data["soidOrderQuotesAllowPark"];
            this.soidOrderQuotesAllowPrintWhenSupplierRequestExists = _data["soidOrderQuotesAllowPrintWhenSupplierRequestExists"];
            this.soidOrderQuotesCopyCreatedByUserAndOrderingBranch = _data["soidOrderQuotesCopyCreatedByUserAndOrderingBranch"];
            this.soidOrderQuotesAllowMultipleAccept = _data["soidOrderQuotesAllowMultipleAccept"];
            this.soidOrderQuotesForceRecalculateWhenAcceptingExpiredQuote = _data["soidOrderQuotesForceRecalculateWhenAcceptingExpiredQuote"];
            this.soidOrderQuotesUseTakenByFromQuoteWhenAcceptingIntoOrder = _data["soidOrderQuotesUseTakenByFromQuoteWhenAcceptingIntoOrder"];
            this.soidOrderQuotesAllowBlankText = _data["soidOrderQuotesAllowBlankText"];
            this.soidOrderQuotesExcludeQuotesFromPromotionalPricing = _data["soidOrderQuotesExcludeQuotesFromPromotionalPricing"];
            this.soidOrdersDontCompleteOrdersWhenWorkOrdersNeedStock = _data["soidOrdersDontCompleteOrdersWhenWorkOrdersNeedStock"];
            this.soidOrdersCompleteDeliveredOrdersWhenDateRequiredIsFull = _data["soidOrdersCompleteDeliveredOrdersWhenDateRequiredIsFull"];
            this.soidUseSearchForTakenBy = _data["soidUseSearchForTakenBy"];
            this.soidSimpleOrderProcessCollectNow = _data["soidSimpleOrderProcessCollectNow"];
            this.soidSimpleOrderProcessCollectLater = _data["soidSimpleOrderProcessCollectLater"];
            this.soidSimpleOrderProcessDelivered = _data["soidSimpleOrderProcessDelivered"];
            this.soidSimpleOrderProcessDirect = _data["soidSimpleOrderProcessDirect"];
            this.soidSimpleOrderProcessTransfer = _data["soidSimpleOrderProcessTransfer"];
            this.soidSimpleOrderControlAVOProcessing = _data["soidSimpleOrderControlAVOProcessing"];
            this.soidSimpleOrderPreAllocateOrderInvoiceNo = _data["soidSimpleOrderPreAllocateOrderInvoiceNo"];
            this.soidSimpleConfirmPicking = _data["soidSimpleConfirmPicking"];
            this.soidSimpleConfirmDelivery = _data["soidSimpleConfirmDelivery"];
            this.soidSimpleConfirmPODReturned = _data["soidSimpleConfirmPODReturned"];
            this.soidSimplePrintPickingNoteOnPark = _data["soidSimplePrintPickingNoteOnPark"];
            this.soidSimpleDeliveryAfterPickingConfirmed = _data["soidSimpleDeliveryAfterPickingConfirmed"];
            this.soidSimpleOnlyAllowDeliveryPrintAfterMarked = _data["soidSimpleOnlyAllowDeliveryPrintAfterMarked"];
            this.soidSimpleAutoIssueOnMarkAsDelivered = _data["soidSimpleAutoIssueOnMarkAsDelivered"];
            this.soidSimpleOnlyInvoiceDirectsAfterSuppInv = _data["soidSimpleOnlyInvoiceDirectsAfterSuppInv"];
            this.soidSimpleAllowPickDeliveryPrintWhenWaitingForStock = _data["soidSimpleAllowPickDeliveryPrintWhenWaitingForStock"];
            this.soidSimpleDontIssueIfNegativeStock = _data["soidSimpleDontIssueIfNegativeStock"];
            this.soidSimplePickingNoteFormat = _data["soidSimplePickingNoteFormat"];
            this.soidSimpleDeliveryNoteFormat = _data["soidSimpleDeliveryNoteFormat"];
            this.soidSimpleCollectionNoteFormat = _data["soidSimpleCollectionNoteFormat"];
            this.soidSimpleDepositReceiptFormat = _data["soidSimpleDepositReceiptFormat"];
            this.soidSimpleDeliveryFormatSetCash = _data["soidSimpleDeliveryFormatSetCash"];
            this.soidSimpleOrderPickingStyle = _data["soidSimpleOrderPickingStyle"];
            this.soidSimpleOrderPickingZonesFormatNumbers = _data["soidSimpleOrderPickingZonesFormatNumbers"];
            this.soidSimpleTransferDeliveryFormatSet = _data["soidSimpleTransferDeliveryFormatSet"];
            this.soidSimplePrintDocumentsOnBackOrder = _data["soidSimplePrintDocumentsOnBackOrder"];
            this.soidSimpleOnlyInvoiceWhenCODFullyPaid = _data["soidSimpleOnlyInvoiceWhenCODFullyPaid"];
            this.soidSimpleOrderRecordPickingStarted = _data["soidSimpleOrderRecordPickingStarted"];
            this.soidSimpleOrderOnlyApproveIfJourneyComplete = _data["soidSimpleOrderOnlyApproveIfJourneyComplete"];
            this.soidSimpleAutoIssueOnInvoiceIfNotYetIssued = _data["soidSimpleAutoIssueOnInvoiceIfNotYetIssued"];
            this.soidSimpleAVOFormatSet = _data["soidSimpleAVOFormatSet"];
            this.soidSimpleAdditionalCostFormat = _data["soidSimpleAdditionalCostFormat"];
            this.soidSimplePromptForDeliveryInAdvancedPicking = _data["soidSimplePromptForDeliveryInAdvancedPicking"];
            this.soidSimplePromptUserIfQtyPickedNotEqualToQtyOrdered = _data["soidSimplePromptUserIfQtyPickedNotEqualToQtyOrdered"];
            this.soidSimpleDeliveryFormatSetCredit = _data["soidSimpleDeliveryFormatSetCredit"];
            this.soidSimpleCollectLaterFormatSetCash = _data["soidSimpleCollectLaterFormatSetCash"];
            this.soidSimpleCollectLaterFormatSetCredit = _data["soidSimpleCollectLaterFormatSetCredit"];
            this.soidSimpleRequireReasonCodeOnPickShortage = _data["soidSimpleRequireReasonCodeOnPickShortage"];
            this.soidSimplePrintPickingNoteWhenStockAvailable = _data["soidSimplePrintPickingNoteWhenStockAvailable"];
            this.soidSimpleDepositReceiptOnFinalPayment = _data["soidSimpleDepositReceiptOnFinalPayment"];
            this.soidDefaultBackOrderBehaviourInAdvancedPicking = _data["soidDefaultBackOrderBehaviourInAdvancedPicking"];
            this.soidSimpleCollectNowPickingDocumentFormatSet = _data["soidSimpleCollectNowPickingDocumentFormatSet"];
            this.soidSimpleAllowAutoMarkPickWhenUsingAdvancedPicking = _data["soidSimpleAllowAutoMarkPickWhenUsingAdvancedPicking"];
            this.soidSimpleAutoPrintSpecialOrderAcknowledgementDocument = _data["soidSimpleAutoPrintSpecialOrderAcknowledgementDocument"];
            this.soidSimpleSpecialOrderAcknowledgementDocumentFormatSet = _data["soidSimpleSpecialOrderAcknowledgementDocumentFormatSet"];
            this.soidSimpleDisplayBinLocationOnPickingConfirmation = _data["soidSimpleDisplayBinLocationOnPickingConfirmation"];
            this.soidSimpleAllowPackReferenceScanningOnPickingConfirmation = _data["soidSimpleAllowPackReferenceScanningOnPickingConfirmation"];
            this.soidSimpleAllowPickingNotePrintOnDeliveredCashSaleWithOutstandingBalance = _data["soidSimpleAllowPickingNotePrintOnDeliveredCashSaleWithOutstandingBalance"];
            this.soidSimpleAllowdeliveryNotePrintOnDeliveredCashSaleWithOutstandingBalance = _data["soidSimpleAllowdeliveryNotePrintOnDeliveredCashSaleWithOutstandingBalance"];
            this.soidSimpleOrderAmendPrintFormatSet = _data["soidSimpleOrderAmendPrintFormatSet"];
            this.soidSimpleOrderAmendPrintHandling = _data["soidSimpleOrderAmendPrintHandling"];
            this.soidSimpleOrderAllowUnpickIfInvoiced = _data["soidSimpleOrderAllowUnpickIfInvoiced"];
            this.soidDefaultPrintDeliveryNoteDocumentSet = _data["soidDefaultPrintDeliveryNoteDocumentSet"];
            this.soidPrintDeliveryNoteFormatWhenMarkingDelivered = _data["soidPrintDeliveryNoteFormatWhenMarkingDelivered"];
            this.soidOrderAllowQuantityLessThanPicked = _data["soidOrderAllowQuantityLessThanPicked"];
            this.soidSimpleOrderDefaultPickingZoneFromOrderMonitor = _data["soidSimpleOrderDefaultPickingZoneFromOrderMonitor"];
            this.soidSimpleOrderHideItemsWhichAreNotInSelectedZone = _data["soidSimpleOrderHideItemsWhichAreNotInSelectedZone"];
            this.soidSimpleOrderDefaultMOLTasPickedInAdvancedPicking = _data["soidSimpleOrderDefaultMOLTasPickedInAdvancedPicking"];
            this.soidSimpleOrderOnlyReleaseBackOrderWithSingleDeliveryOption = _data["soidSimpleOrderOnlyReleaseBackOrderWithSingleDeliveryOption"];
            this.soidSimpleConfirmChecked = _data["soidSimpleConfirmChecked"];
            this.soidDefaultPrintPickingNoteWhenMarkingPickStarted = _data["soidDefaultPrintPickingNoteWhenMarkingPickStarted"];
            this.soidScanActionBarcodesInBatchUpdate = _data["soidScanActionBarcodesInBatchUpdate"];
            this.soidSimpleDeliveryAfterChecked = _data["soidSimpleDeliveryAfterChecked"];
            this.soidOrdersAllowCompleteWhenJobIsPreliminary = _data["soidOrdersAllowCompleteWhenJobIsPreliminary"];
            this.soidCheckPickingRequiredFlagWhenDeterminingPickingZonePrintingFormats = _data["soidCheckPickingRequiredFlagWhenDeterminingPickingZonePrintingFormats"];
            this.soidSimpleOrderSetDefaultReleaseQuantityToAll = _data["soidSimpleOrderSetDefaultReleaseQuantityToAll"];
            this.soidIncludeUnapprovedOrdersInOrdersForInvoicingFilter = _data["soidIncludeUnapprovedOrdersInOrdersForInvoicingFilter"];
            this.soidOrdersAllowChangingUOMsinQtyAndQtyPriceEntry = _data["soidOrdersAllowChangingUOMsinQtyAndQtyPriceEntry"];
            this.soidShowMsgWhenPickingLessSpecialOrderThanAvailable = _data["soidShowMsgWhenPickingLessSpecialOrderThanAvailable"];
            this.soidSimpleOrderLimitPickingAndCheckedByUsersByBranch = _data["soidSimpleOrderLimitPickingAndCheckedByUsersByBranch"];
            this.soidSimpleOrderDefaultPickingStartedUserToFirstAvailable = _data["soidSimpleOrderDefaultPickingStartedUserToFirstAvailable"];
            this.soidPrintDeliveryNoteDocumentSetWhenMarkingDelvOrdersPicked = _data["soidPrintDeliveryNoteDocumentSetWhenMarkingDelvOrdersPicked"];
            this.soidSimpleOrderRecordPickComplete = _data["soidSimpleOrderRecordPickComplete"];
            this.soidPromptSignatureWhenCompletingCollectNowOrderThatGoesCreditHold = _data["soidPromptSignatureWhenCompletingCollectNowOrderThatGoesCreditHold"];
            this.soidPromptSignatureWhenChangingWMSOrderTypeToCollectLaterNow = _data["soidPromptSignatureWhenChangingWMSOrderTypeToCollectLaterNow"];
            this.soidUseSignatureCaptureSettingsForCollectNowWhenCompletingCollectLaterNow = _data["soidUseSignatureCaptureSettingsForCollectNowWhenCompletingCollectLaterNow"];
            this.soidSimpleOrderEnableMarkFullyPicked = _data["soidSimpleOrderEnableMarkFullyPicked"];
            this.soidDisplayAwaitingStockWarningMessagesInPickingConfirmation = _data["soidDisplayAwaitingStockWarningMessagesInPickingConfirmation"];
            this.soidBackOrderEntireSingleDeliveryOrderWhenAnyLineBackOrdered = _data["soidBackOrderEntireSingleDeliveryOrderWhenAnyLineBackOrdered"];
            this.soidWMSDefaultBackOrderBehaviour = _data["soidWMSDefaultBackOrderBehaviour"];
            this.soidWMSMarkOrdersDeliveredWhenPickCompletedFromWMS = _data["soidWMSMarkOrdersDeliveredWhenPickCompletedFromWMS"];
            this.soidCashSalesPercentToleranceForTalliedTimber = _data["soidCashSalesPercentToleranceForTalliedTimber"];
            this.soidCashSalesAmountToleranceForTalliedTimber = _data["soidCashSalesAmountToleranceForTalliedTimber"];
            this.soidCashSalesPercentToleranceForNonTalliedTimber = _data["soidCashSalesPercentToleranceForNonTalliedTimber"];
            this.soidCashSalesAmountToleranceForNonTalliedTimber = _data["soidCashSalesAmountToleranceForNonTalliedTimber"];
            this.soidCashSalesPercentToleranceForProductSubstitutions = _data["soidCashSalesPercentToleranceForProductSubstitutions"];
            this.soidCashSalesAmountToleranceForProductSubstitutions = _data["soidCashSalesAmountToleranceForProductSubstitutions"];
            this.soidCashSalesRestrictFullyPaidCashSaleToSameProductGroup = _data["soidCashSalesRestrictFullyPaidCashSaleToSameProductGroup"];
            this.soidCashSalesRunWithNewCashBehaviour = _data["soidCashSalesRunWithNewCashBehaviour"];
            this.soidCashSalesEnableToleranceChecking = _data["soidCashSalesEnableToleranceChecking"];
            this.soidCashSalesAutoFinalizeDaily = _data["soidCashSalesAutoFinalizeDaily"];
            this.soidCashSalesForceAddressCollectNow = _data["soidCashSalesForceAddressCollectNow"];
            this.soidCashSalesForceAddressCollectLater = _data["soidCashSalesForceAddressCollectLater"];
            this.soidCashSalesOrderMaximumCashAllowed = _data["soidCashSalesOrderMaximumCashAllowed"];
            this.soidCashSalesAllowDepositGreaterThanOrderTotal = _data["soidCashSalesAllowDepositGreaterThanOrderTotal"];
            this.soidCashSalesPostCheckOverpaymentAsChangeDue = _data["soidCashSalesPostCheckOverpaymentAsChangeDue"];
            this.soidSimpleOnlyAllowDeliverySetPrintAfterMarked = _data["soidSimpleOnlyAllowDeliverySetPrintAfterMarked"];
            this.soidForceSelectionOfReasonCodeForLodgement = _data["soidForceSelectionOfReasonCodeForLodgement"];
            this.soidCashSalesRetainInvoiceAddressWhenCopyingCashSales = _data["soidCashSalesRetainInvoiceAddressWhenCopyingCashSales"];
            this.soidCashSalesDepositReceiptOnBackOrders = _data["soidCashSalesDepositReceiptOnBackOrders"];
            this.soidDefaultLodgementPostingDate = _data["soidDefaultLodgementPostingDate"];
            this.soidAllowLodgementsOnCreditAndDebitCards = _data["soidAllowLodgementsOnCreditAndDebitCards"];
            this.soidSortPaymentMethodByPaymentMethodCode = _data["soidSortPaymentMethodByPaymentMethodCode"];
            this.soidReturnToPaymentDetailsAfterFullyPaid = _data["soidReturnToPaymentDetailsAfterFullyPaid"];
            this.soidCashSalesAllowDeliveryCollectionOfUnpaid = _data["soidCashSalesAllowDeliveryCollectionOfUnpaid"];
            this.soidDefaultContractSchedule = _data["soidDefaultContractSchedule"];
            this.soidPostInstalledSalesShipmentsToManualOrderInvoicingLines = _data["soidPostInstalledSalesShipmentsToManualOrderInvoicingLines"];
            this.soidPostSalesAmountAtTimeOfMaterialShipment = _data["soidPostSalesAmountAtTimeOfMaterialShipment"];
            this.soidForceSelectionOfAddressOnContractCreation = _data["soidForceSelectionOfAddressOnContractCreation"];
            this.soidDefaultOrdersAndCallOffsToUseOpenContracts = _data["soidDefaultOrdersAndCallOffsToUseOpenContracts"];
            this.soidAllowMultipleCallOffOrdersOnContracts = _data["soidAllowMultipleCallOffOrdersOnContracts"];
            this.soidDefaultMarginForPostCostToWIPMethod = _data["soidDefaultMarginForPostCostToWIPMethod"];
            this.soidAccruedARInstalledSalesVarianceMOLT = _data["soidAccruedARInstalledSalesVarianceMOLT"];
            this.soidContractsCopyFromDefaultDocType = _data["soidContractsCopyFromDefaultDocType"];
            this.soidContractsCopyFromDefaultConsolidateByMOLT = _data["soidContractsCopyFromDefaultConsolidateByMOLT"];
            this.soidAllowSettingTaxAreaOnContracts = _data["soidAllowSettingTaxAreaOnContracts"];
            this.soidContractsIncludeSalesTaxAmountDuringCopySections = _data["soidContractsIncludeSalesTaxAmountDuringCopySections"];
            this.soidAllowSettingRetentionPercentageOnContractInvoicingLines = _data["soidAllowSettingRetentionPercentageOnContractInvoicingLines"];
            this.soidAutoCloseContractsWithNoTransactionsInNumberOfDays = _data["soidAutoCloseContractsWithNoTransactionsInNumberOfDays"];
            this.soidIncludeTaxInRetentionCalculations = _data["soidIncludeTaxInRetentionCalculations"];
            this.soidAllowSelectingJobAddressOnContractBillingLine = _data["soidAllowSelectingJobAddressOnContractBillingLine"];
            this.soidShowTimberFunctionality = _data["soidShowTimberFunctionality"];
            this.soidTimberSplitPackRefSuffix = _data["soidTimberSplitPackRefSuffix"];
            this.soidTimberAllowSplitToLoose = _data["soidTimberAllowSplitToLoose"];
            this.soidTimberSplitPackVolumeWarningTreshold = _data["soidTimberSplitPackVolumeWarningTreshold"];
            this.soidTimberDuplicatePackReferenceOption = _data["soidTimberDuplicatePackReferenceOption"];
            this.soidTimberTallyLengthDecimalPlaces = _data["soidTimberTallyLengthDecimalPlaces"];
            this.soidTimberPackTallyInput = _data["soidTimberPackTallyInput"];
            this.soidTimberAutoAllocatePackBarCodes = _data["soidTimberAutoAllocatePackBarCodes"];
            this.soidTimberAllowDecimalPlacesOnNumberOfSheets = _data["soidTimberAllowDecimalPlacesOnNumberOfSheets"];
            this.soidTimberInputAdvanced = _data["soidTimberInputAdvanced"];
            this.soidTimberInputShowStdLengths = _data["soidTimberInputShowStdLengths"];
            this.soidTimberInputNoOfBlankRows = _data["soidTimberInputNoOfBlankRows"];
            this.soidTimberInputColumnSequence = _data["soidTimberInputColumnSequence"];
            this.soidTimberAutoSetPackType = _data["soidTimberAutoSetPackType"];
            this.soidTimberPercForAPTL = _data["soidTimberPercForAPTL"];
            this.soidTimberInputMaskContractRef = _data["soidTimberInputMaskContractRef"];
            this.soidTimberInputMaskContractPeriod = _data["soidTimberInputMaskContractPeriod"];
            this.soidTimberInputMaskShip = _data["soidTimberInputMaskShip"];
            this.soidTimberInputMaskVoyage = _data["soidTimberInputMaskVoyage"];
            this.soidTimberInputMaskBOLRef = _data["soidTimberInputMaskBOLRef"];
            this.soidTimberInputMaskShipPackRef = _data["soidTimberInputMaskShipPackRef"];
            this.soidTimberPackVolFormatString = _data["soidTimberPackVolFormatString"];
            this.soidTimberPackShowPackEstimate = _data["soidTimberPackShowPackEstimate"];
            this.soidTimberDefaultStatusOnStockReceipt = _data["soidTimberDefaultStatusOnStockReceipt"];
            this.soidTimberPackQuantityAbbreviation = _data["soidTimberPackQuantityAbbreviation"];
            this.soidTimberSplitPackAllowHigherVolume = _data["soidTimberSplitPackAllowHigherVolume"];
            this.soidTimberUsePackSubstitution = _data["soidTimberUsePackSubstitution"];
            this.soidTimberPackVolDecimalPlaces = _data["soidTimberPackVolDecimalPlaces"];
            this.soidTimberPackLengthDecimalPlaces = _data["soidTimberPackLengthDecimalPlaces"];
            this.soidTimberPackFindDefaultView = _data["soidTimberPackFindDefaultView"];
            this.soidTimberPackTallyDisplayAvailableOrActual = _data["soidTimberPackTallyDisplayAvailableOrActual"];
            this.soidTimberSplitPackReasonCode = _data["soidTimberSplitPackReasonCode"];
            this.soidTimberInputRoundToNearestTallyLength = _data["soidTimberInputRoundToNearestTallyLength"];
            this.soidTimberUseTallyCalculator = _data["soidTimberUseTallyCalculator"];
            this.soidTimberStockShortageWarningOnSOTally = _data["soidTimberStockShortageWarningOnSOTally"];
            this.soidTimberOrdersShowInvalidTallyWarnings = _data["soidTimberOrdersShowInvalidTallyWarnings"];
            this.soidTimberAllowBulkChangeStockLocationOnFreePacks = _data["soidTimberAllowBulkChangeStockLocationOnFreePacks"];
            this.soidTimberDefaultNATalliedScreenToSplitTallyOnPO = _data["soidTimberDefaultNATalliedScreenToSplitTallyOnPO"];
            this.soidTimberAllowDifferentTallySelectionOnSalesTransactions = _data["soidTimberAllowDifferentTallySelectionOnSalesTransactions"];
            this.soidTimberRetainPackRefWhenReuseSourceOnWorksOrders = _data["soidTimberRetainPackRefWhenReuseSourceOnWorksOrders"];
            this.soidTimberIncludeFreePacksAsAvailable = _data["soidTimberIncludeFreePacksAsAvailable"];
            this.soidTimberIncludePackStockAsAvailableOnTallyInput = _data["soidTimberIncludePackStockAsAvailableOnTallyInput"];
            this.soidTimberInputLimitToNoOfBlankRows = _data["soidTimberInputLimitToNoOfBlankRows"];
            this.soidTimberDisplayTallyLengthsInProductFindForAvailableStock = _data["soidTimberDisplayTallyLengthsInProductFindForAvailableStock"];
            this.soidTimberDefaultUsePackPriceSurcharge = _data["soidTimberDefaultUsePackPriceSurcharge"];
            this.soidTimberAllowDifferentTallySelectionOnWorksOrderSourceLines = _data["soidTimberAllowDifferentTallySelectionOnWorksOrderSourceLines"];
            this.soidTimberCopyParentTallyAndQuantityToNotesWhenTallySplit = _data["soidTimberCopyParentTallyAndQuantityToNotesWhenTallySplit"];
            this.soidPacksAutoSplitOnPackConfirmation = _data["soidPacksAutoSplitOnPackConfirmation"];
            this.soidPacksCopyAttachmentsDuringSplit = _data["soidPacksCopyAttachmentsDuringSplit"];
            this.soidPacksReuseSourcePacksOnFinishedProducts = _data["soidPacksReuseSourcePacksOnFinishedProducts"];
            this.soidAllowPartialCreditOfTaggedPacks = _data["soidAllowPartialCreditOfTaggedPacks"];
            this.soidTimberShowProductLinealFeetPercentage = _data["soidTimberShowProductLinealFeetPercentage"];
            this.soidShowSteelFunctionality = _data["soidShowSteelFunctionality"];
            this.soidProfileSalesAnalysisCode = _data["soidProfileSalesAnalysisCode"];
            this.soidDefaultProfileMachine = _data["soidDefaultProfileMachine"];
            this.soidDefaultProfileManualOrderLineType = _data["soidDefaultProfileManualOrderLineType"];
            this.soidSteelPickingWeightDifferenceLow = _data["soidSteelPickingWeightDifferenceLow"];
            this.soidSteelPickingWeightDifferenceHigh = _data["soidSteelPickingWeightDifferenceHigh"];
            this.soidAllowWeightAsStockingUnitOfMeasure = _data["soidAllowWeightAsStockingUnitOfMeasure"];
            this.soidEnableAlternateUnitOfMeasureForTallyLengths = _data["soidEnableAlternateUnitOfMeasureForTallyLengths"];
            this.soidShowTestCertificateFunctionality = _data["soidShowTestCertificateFunctionality"];
            this.soidTestCertificateAttachmentFolder = _data["soidTestCertificateAttachmentFolder"];
            this.soidEnableAVOTolerances = _data["soidEnableAVOTolerances"];
            this.soidMetalConformanceCertificateFormatNumber = _data["soidMetalConformanceCertificateFormatNumber"];
            this.soidOrdersOrderLineAdditionalInfoDisplay = _data["soidOrdersOrderLineAdditionalInfoDisplay"];
            this.soidSignatureCaptureDelivered = _data["soidSignatureCaptureDelivered"];
            this.soidSignatureCaptureDirect = _data["soidSignatureCaptureDirect"];
            this.soidSignatureCaptureCollectLaterCash = _data["soidSignatureCaptureCollectLaterCash"];
            this.soidCalculateDeliveryChargesCostsBasedOnTotalValues = _data["soidCalculateDeliveryChargesCostsBasedOnTotalValues"];
            this.soidCalculateDeliveryChargesAtLineLevelOnly = _data["soidCalculateDeliveryChargesAtLineLevelOnly"];
            this.soidRequireUserToAcceptSignaturesFromSignatureCapture = _data["soidRequireUserToAcceptSignaturesFromSignatureCapture"];
            this.soidDisplayMarginAndCostDuringQuickAddEntry = _data["soidDisplayMarginAndCostDuringQuickAddEntry"];
            this.soidDisplayExtendedOrderLineQuantityInformation = _data["soidDisplayExtendedOrderLineQuantityInformation"];
            this.soidOrdersAllowDisablingAndEditingOfDeliveryChargesWithPermission = _data["soidOrdersAllowDisablingAndEditingOfDeliveryChargesWithPermission"];
            this.soidOrdersShowSaleTypeInDocumentInformationBar = _data["soidOrdersShowSaleTypeInDocumentInformationBar"];
            this.soidOrdersBackOrderReleaseCheckPackAndLooseAvailableStock = _data["soidOrdersBackOrderReleaseCheckPackAndLooseAvailableStock"];
            this.soidOrdersForceUpperCaseAddress = _data["soidOrdersForceUpperCaseAddress"];
            this.soidUpdateSpecialOrderSalesQuantityWithQuantityReceived = _data["soidUpdateSpecialOrderSalesQuantityWithQuantityReceived"];
            this.soidAllowCompanyChequeOnOrdersCreatedFromCreditNotes = _data["soidAllowCompanyChequeOnOrdersCreatedFromCreditNotes"];
            this.soidOrdersCustomerJobInstructionsAsAutoText = _data["soidOrdersCustomerJobInstructionsAsAutoText"];
            this.soidOrdersCalcDeliveryAndAllowCODonOrdersWithJustMOLTlines = _data["soidOrdersCalcDeliveryAndAllowCODonOrdersWithJustMOLTlines"];
            this.soidOrdersUsingF6GoesToCustomerField = _data["soidOrdersUsingF6GoesToCustomerField"];
            this.soidOrdersProrateDepositsDuringBackOrder = _data["soidOrdersProrateDepositsDuringBackOrder"];
            this.soidOrdersOpenPurchaseOrdersOnSalesOrderUpdate = _data["soidOrdersOpenPurchaseOrdersOnSalesOrderUpdate"];
            this.soidOrdersAutomaticallyReleaseBackOrders = _data["soidOrdersAutomaticallyReleaseBackOrders"];
            this.soidOrdersAllowChangeOfVehicleAndDeliveryTimeOnOrdersInvoiced = _data["soidOrdersAllowChangeOfVehicleAndDeliveryTimeOnOrdersInvoiced"];
            this.soidCheckMinimumDepositWhenOrderIsModified = _data["soidCheckMinimumDepositWhenOrderIsModified"];
            this.soidDisableAdditionalCostDeliveryChargesWhenDeliveryChargesAreDisabled = _data["soidDisableAdditionalCostDeliveryChargesWhenDeliveryChargesAreDisabled"];
            this.soidbTAStatementsAlwaysPrintImages = _data["soidbTAStatementsAlwaysPrintImages"];
            this.soidbTAFinanceChargeDefaultOverdueBy = _data["soidbTAFinanceChargeDefaultOverdueBy"];
            this.soidbTAFinanceChargeDefaultMonthlyFinanceChargePercent = _data["soidbTAFinanceChargeDefaultMonthlyFinanceChargePercent"];
            this.soidbTAFinanceChargeDefaultRevolvingAccountGrace = _data["soidbTAFinanceChargeDefaultRevolvingAccountGrace"];
            this.soidbTAStatementGenerateDefaultIncludeCustomersWithNoTransactions = _data["soidbTAStatementGenerateDefaultIncludeCustomersWithNoTransactions"];
            this.soidbTAStatementGenerateDefaultTransactionsToInclude = _data["soidbTAStatementGenerateDefaultTransactionsToInclude"];
            this.soidbTAStatementGenerateDefaultConsolidateGroupAccounts = _data["soidbTAStatementGenerateDefaultConsolidateGroupAccounts"];
            this.soidbTAStatementGenerateDefaultIndividualChildStatements = _data["soidbTAStatementGenerateDefaultIndividualChildStatements"];
            this.soidbTAStatementSendDefaultIncludeStatementsWithZeroBalance = _data["soidbTAStatementSendDefaultIncludeStatementsWithZeroBalance"];
            this.soidbTAStatementSendDefaultIncludeFullyPaidTransactions = _data["soidbTAStatementSendDefaultIncludeFullyPaidTransactions"];
            this.soidbTACustomerStatementByJobReportName = _data["soidbTACustomerStatementByJobReportName"];
            this.soidbTASummaryStatementReportName = _data["soidbTASummaryStatementReportName"];
            this.soidbTAAllowGeneratingStatementsByJob = _data["soidbTAAllowGeneratingStatementsByJob"];
            this.soidbTACanGenerateFinChargesByCustomerGroup = _data["soidbTACanGenerateFinChargesByCustomerGroup"];
            this.soidbTADefaultAccountPaymentToCustomersHomeBranch = _data["soidbTADefaultAccountPaymentToCustomersHomeBranch"];
            this.soidbTAAccountPaymentCreditCardSurchargePercentage = _data["soidbTAAccountPaymentCreditCardSurchargePercentage"];
            this.soidbTADirectPostingReasonCodeForAccountPaymentCreditCardSurcharge = _data["soidbTADirectPostingReasonCodeForAccountPaymentCreditCardSurcharge"];
            this.soidbTAAccountPaymentCreditCardSurchargeType = _data["soidbTAAccountPaymentCreditCardSurchargeType"];
            this.soidbTAAllowMatchingTransactionsBetweenARAccounts = _data["soidbTAAllowMatchingTransactionsBetweenARAccounts"];
            this.soidbTAReasonCodeToUseForInterBranchDirectPostings = _data["soidbTAReasonCodeToUseForInterBranchDirectPostings"];
            this.soidbTAAllowSelectionOfPaymentMethodInBatchCasPosting = _data["soidbTAAllowSelectionOfPaymentMethodInBatchCasPosting"];
            this.soidbTAUseAcctPmtsInsteadOfCashPosting = _data["soidbTAUseAcctPmtsInsteadOfCashPosting"];
            this.soidbTAAllowTakingDepositsOnARSalesOrders = _data["soidbTAAllowTakingDepositsOnARSalesOrders"];
            this.soidPopupJourneyDateVisible = _data["soidPopupJourneyDateVisible"];
            this.soidPopupJourneyDriverVisible = _data["soidPopupJourneyDriverVisible"];
            this.soidPopupJourneyVehicleVisible = _data["soidPopupJourneyVehicleVisible"];
            this.soidPopupJourneyWeightVisible = _data["soidPopupJourneyWeightVisible"];
            this.soidPopupJourneyDropsVisible = _data["soidPopupJourneyDropsVisible"];
            this.soidPopupJourneyVolumeVisible = _data["soidPopupJourneyVolumeVisible"];
            this.soidJourneyPlannerGroupJourneysByReference = _data["soidJourneyPlannerGroupJourneysByReference"];
            this.soidJourneyPlannerTimeFrame = _data["soidJourneyPlannerTimeFrame"];
            this.soidJourneyPlannerFirstDayOfWeek = _data["soidJourneyPlannerFirstDayOfWeek"];
            this.soidJourneyPlannerWorkingDays = _data["soidJourneyPlannerWorkingDays"];
            this.soidJourneyPlannerStartOfDay = _data["soidJourneyPlannerStartOfDay"];
            this.soidJourneyPlannerEndOfDay = _data["soidJourneyPlannerEndOfDay"];
            this.soidJourneyPlannerTimeInterval = _data["soidJourneyPlannerTimeInterval"];
            this.soidJourneyPlannerWeightDecimalPlaces = _data["soidJourneyPlannerWeightDecimalPlaces"];
            this.soidJourneyPlannerVolumeDecimalPlaces = _data["soidJourneyPlannerVolumeDecimalPlaces"];
            this.soidJourneyOnlyAllowTransportCostsForPicked = _data["soidJourneyOnlyAllowTransportCostsForPicked"];
            this.soidJourneyAllowCompleteWithNoTransportCost = _data["soidJourneyAllowCompleteWithNoTransportCost"];
            this.soidJourneyApplyTransportCostsOnCompletion = _data["soidJourneyApplyTransportCostsOnCompletion"];
            this.soidJourneyApplyTransportCostsTo = _data["soidJourneyApplyTransportCostsTo"];
            this.soidJourneyPromptForCreditHoldOrParkedOrders = _data["soidJourneyPromptForCreditHoldOrParkedOrders"];
            this.soidJourneyPlannerBranchViewDefault = _data["soidJourneyPlannerBranchViewDefault"];
            this.soidJourneyPlannerTimeIntervalForCalendar = _data["soidJourneyPlannerTimeIntervalForCalendar"];
            this.soidJourneyPlannerGroupJourneysByDriver = _data["soidJourneyPlannerGroupJourneysByDriver"];
            this.soidJourneyShowAdditionalCostsOnJourney = _data["soidJourneyShowAdditionalCostsOnJourney"];
            this.soidJourneyAutoRemoveAndAddDocumentsToRelatedAddCostChargeProRates = _data["soidJourneyAutoRemoveAndAddDocumentsToRelatedAddCostChargeProRates"];
            this.soidJourneyIncludePOWeight = _data["soidJourneyIncludePOWeight"];
            this.soidJourneyPlannerLimitToBranchVehicles = _data["soidJourneyPlannerLimitToBranchVehicles"];
            this.soidJourneyMarkOrdersDeliveredWhenJourneyMarkedInProgress = _data["soidJourneyMarkOrdersDeliveredWhenJourneyMarkedInProgress"];
            this.soidJourneyPlannerDisplayVIN = _data["soidJourneyPlannerDisplayVIN"];
            this.soidJourneyEnableAutomaticScheduledRoutes = _data["soidJourneyEnableAutomaticScheduledRoutes"];
            this.soidJourneyPromptForExistingJourneyWithTheSameAddress = _data["soidJourneyPromptForExistingJourneyWithTheSameAddress"];
            this.soidJourneyPlannerAutoRefreshInterval = _data["soidJourneyPlannerAutoRefreshInterval"];
            this.soidJourneyAllowLinkingTrailersToTruchAndTrailerVehicles = _data["soidJourneyAllowLinkingTrailersToTruchAndTrailerVehicles"];
            this.soidJourneyReferenceRequired = _data["soidJourneyReferenceRequired"];
            this.soidJourneyShowWarningWhenDocumentDateRequiredDontMatchJourneyDate = _data["soidJourneyShowWarningWhenDocumentDateRequiredDontMatchJourneyDate"];
            this.soidJourneyEnableAllowMultipleDeliveryAreasInJourney = _data["soidJourneyEnableAllowMultipleDeliveryAreasInJourney"];
            this.soidJourneyDefaultUnloadTimePerStop = _data["soidJourneyDefaultUnloadTimePerStop"];
            this.soidJourneyShowCreditNotePrintedInDocumentList = _data["soidJourneyShowCreditNotePrintedInDocumentList"];
            this.soidJourneyPlannerAutoAddUnusedVehicles = _data["soidJourneyPlannerAutoAddUnusedVehicles"];
            this.soidJourneyMarkDatesFull = _data["soidJourneyMarkDatesFull"];
            this.soidDirectionsSource = _data["soidDirectionsSource"];
            this.soidAddressingSource = _data["soidAddressingSource"];
            this.soidAddReturnToStart = _data["soidAddReturnToStart"];
            this.soidCustomerMapPointFolder = _data["soidCustomerMapPointFolder"];
            this.soidDirectionsGoogleMapsURL = _data["soidDirectionsGoogleMapsURL"];
            this.soidDirectionsBingMapsURL = _data["soidDirectionsBingMapsURL"];
            this.soidDirectionsAddressPattern = _data["soidDirectionsAddressPattern"];
            this.soidVehicleTrackingSoftwareService = _data["soidVehicleTrackingSoftwareService"];
            this.soidVehicleTrackingWebServiceLocation = _data["soidVehicleTrackingWebServiceLocation"];
            this.soidVehicleTrackingClientAccessCode = _data["soidVehicleTrackingClientAccessCode"];
            this.soidVehicleTrackingSpeedSuffix = _data["soidVehicleTrackingSpeedSuffix"];
            this.soidVehicleTrackingClientPassword = _data["soidVehicleTrackingClientPassword"];
            this.soidVehicleTrackingInternetMapURL = _data["soidVehicleTrackingInternetMapURL"];
            this.soidCustomerAddressMapGridSettings = _data["soidCustomerAddressMapGridSettings"];
            this.soidPassAddressCoordinatesForInternetMapping = _data["soidPassAddressCoordinatesForInternetMapping"];
            this.soidShowMapDirectlySkippingVehicleLocationForm = _data["soidShowMapDirectlySkippingVehicleLocationForm"];
            this.soidDirectionsGMapsDirectionsURL = _data["soidDirectionsGMapsDirectionsURL"];
            this.soidDirectionsGMapsDirectionsKey = _data["soidDirectionsGMapsDirectionsKey"];
            this.soidWorksOrderWasteWarning = _data["soidWorksOrderWasteWarning"];
            this.soidDefaultToManufactured = _data["soidDefaultToManufactured"];
            this.soidWorksOrderPrintOnChange = _data["soidWorksOrderPrintOnChange"];
            this.soidWorksOrderEnableCalendarScheduling = _data["soidWorksOrderEnableCalendarScheduling"];
            this.soidWorksOrderConsolidateIdenticalWOProcessesOnWOSchedule = _data["soidWorksOrderConsolidateIdenticalWOProcessesOnWOSchedule"];
            this.soidWorksOrderHybridCostingWarning = _data["soidWorksOrderHybridCostingWarning"];
            this.soidWorksOrderSourcePrefixText = _data["soidWorksOrderSourcePrefixText"];
            this.soidWorksOrderNewLineAfterSourcePrefix = _data["soidWorksOrderNewLineAfterSourcePrefix"];
            this.soidWorksOrderProcessPrefixText = _data["soidWorksOrderProcessPrefixText"];
            this.soidWorksOrderFinishedPrefixText = _data["soidWorksOrderFinishedPrefixText"];
            this.soidWorksOrderNewLineAfterFinishedPrefix = _data["soidWorksOrderNewLineAfterFinishedPrefix"];
            this.soidWorksOrderSOWaitForStock = _data["soidWorksOrderSOWaitForStock"];
            this.soidWorksOrderAllowProcessingIfCreditControl = _data["soidWorksOrderAllowProcessingIfCreditControl"];
            this.soidWorksOrderAllowFinishCostOverride = _data["soidWorksOrderAllowFinishCostOverride"];
            this.soidWorksOrderCreateProductsOnManufactured = _data["soidWorksOrderCreateProductsOnManufactured"];
            this.soidWorksOrderForceCreateOnManufactured = _data["soidWorksOrderForceCreateOnManufactured"];
            this.soidCreateGLTransactionsWorksOrder = _data["soidCreateGLTransactionsWorksOrder"];
            this.soidWorksOrderBaseSpecialOnProdGroupID = _data["soidWorksOrderBaseSpecialOnProdGroupID"];
            this.soidWorksOrderIgnoreHowSourcedOnSpecials = _data["soidWorksOrderIgnoreHowSourcedOnSpecials"];
            this.soidCreateGLTransactionsCOGS = _data["soidCreateGLTransactionsCOGS"];
            this.soidCreateGLTransactionsStockTransfer = _data["soidCreateGLTransactionsStockTransfer"];
            this.soidCreateGLTransactionsSupplierReturns = _data["soidCreateGLTransactionsSupplierReturns"];
            this.soidWorksOrderTrussDescription = _data["soidWorksOrderTrussDescription"];
            this.soidFinancialDescAppendDocRef = _data["soidFinancialDescAppendDocRef"];
            this.soidWorksOrderAutoCopySourceToFinished = _data["soidWorksOrderAutoCopySourceToFinished"];
            this.soidWorksOrderAllowMultiplePacksWhenConfirmingSourceMaterialPacks = _data["soidWorksOrderAllowMultiplePacksWhenConfirmingSourceMaterialPacks"];
            this.soidWorksOrderEnablePCMInterface = _data["soidWorksOrderEnablePCMInterface"];
            this.soidWorksOrderPCMInputFileLocation = _data["soidWorksOrderPCMInputFileLocation"];
            this.soidWorksOrderPCMOutputFileLocation = _data["soidWorksOrderPCMOutputFileLocation"];
            this.soidWorksOrderPCMPackRefDestination = _data["soidWorksOrderPCMPackRefDestination"];
            this.soidWorksOrderPCMPackPrefix = _data["soidWorksOrderPCMPackPrefix"];
            this.soidWorksOrderPCMDescriptionField = _data["soidWorksOrderPCMDescriptionField"];
            this.soidWorksOrderUseDocumentReleaseProcess = _data["soidWorksOrderUseDocumentReleaseProcess"];
            this.soidWorksOrderAlwaysReplaceForConfirmPacks = _data["soidWorksOrderAlwaysReplaceForConfirmPacks"];
            this.soidWorksOrderDefaultLinesFromSalesOrderWOCreation = _data["soidWorksOrderDefaultLinesFromSalesOrderWOCreation"];
            this.soidWorksOrderAllowPartProcessing = _data["soidWorksOrderAllowPartProcessing"];
            this.soidWorksOrderCopyAVONotesToOverheadPOManualLineDescription = _data["soidWorksOrderCopyAVONotesToOverheadPOManualLineDescription"];
            this.soidWorksOrderProcessDefaultManualLineType = _data["soidWorksOrderProcessDefaultManualLineType"];
            this.soidWorksOrderCombineAVOsIntoSinglePurchaseOrder = _data["soidWorksOrderCombineAVOsIntoSinglePurchaseOrder"];
            this.soidWorksOrderAllowProcessingWorksOrderAwaitingSourceMaterial = _data["soidWorksOrderAllowProcessingWorksOrderAwaitingSourceMaterial"];
            this.soidWorksOrderReviewSuppliersForPOCreatedFromWO = _data["soidWorksOrderReviewSuppliersForPOCreatedFromWO"];
            this.soidWorksOrderForceSourceSelectionForPartProcess = _data["soidWorksOrderForceSourceSelectionForPartProcess"];
            this.soidWorksOrderUseProcessWorkflow = _data["soidWorksOrderUseProcessWorkflow"];
            this.soidWorksOrderSuppressWorkflowPOPrint = _data["soidWorksOrderSuppressWorkflowPOPrint"];
            this.soidWorksOrderProcessPickingFormatSet = _data["soidWorksOrderProcessPickingFormatSet"];
            this.soidWorksOrderProcessDeliveryFormatSet = _data["soidWorksOrderProcessDeliveryFormatSet"];
            this.soidWorksOrderProcessCollectionFormatSet = _data["soidWorksOrderProcessCollectionFormatSet"];
            this.soidWorksOrderProcessReceiptFormatSet = _data["soidWorksOrderProcessReceiptFormatSet"];
            this.soidWorksOrderDefaultProcessWorksOrder = _data["soidWorksOrderDefaultProcessWorksOrder"];
            this.soidWorksOrderFromOrderRequiredDays = _data["soidWorksOrderFromOrderRequiredDays"];
            this.soidWorksOrderAllowDifferentAVOCurrency = _data["soidWorksOrderAllowDifferentAVOCurrency"];
            this.soidWorksOrderProcessReadyForCollectionFormatSet = _data["soidWorksOrderProcessReadyForCollectionFormatSet"];
            this.soidWorksOrderDefaultSourceProductsDisplayCostOnCreationToStandardBuy = _data["soidWorksOrderDefaultSourceProductsDisplayCostOnCreationToStandardBuy"];
            this.soidWorksOrderAllowOnJourneyIfHasWorkflow = _data["soidWorksOrderAllowOnJourneyIfHasWorkflow"];
            this.soidWorksOrderAutoSplitPacksDuringConfirmation = _data["soidWorksOrderAutoSplitPacksDuringConfirmation"];
            this.soidWorksOrderDefaultAVOsToSpreadCostToLinesTheyAreBasedOn = _data["soidWorksOrderDefaultAVOsToSpreadCostToLinesTheyAreBasedOn"];
            this.soidWorksOrderAllowBranchChangeWhenAllocated = _data["soidWorksOrderAllowBranchChangeWhenAllocated"];
            this.soidWorksOrderAlwaysAllocateStockWhenCopying = _data["soidWorksOrderAlwaysAllocateStockWhenCopying"];
            this.soidWorksOrderUpdateDateRequiredWhenSODateRequiredChanges = _data["soidWorksOrderUpdateDateRequiredWhenSODateRequiredChanges"];
            this.soidWorksOrderSetSpecialDescriptionFromFinishedLine = _data["soidWorksOrderSetSpecialDescriptionFromFinishedLine"];
            this.soidWorksOrderDisplay_BF_SF_LF_MachineSchedule = _data["soidWorksOrderDisplay_BF_SF_LF_MachineSchedule"];
            this.soidWorksOrderAveCostAdjReasonForProcessCostAppliedToSO = _data["soidWorksOrderAveCostAdjReasonForProcessCostAppliedToSO"];
            this.soidWorksOrderSalesOrderAVOForProcessCostAppliedToSO = _data["soidWorksOrderSalesOrderAVOForProcessCostAppliedToSO"];
            this.soidWorksOrderDefaultNewWOCreation = _data["soidWorksOrderDefaultNewWOCreation"];
            this.soidWorksOrderPromptToProcessUponScheduleCompletion = _data["soidWorksOrderPromptToProcessUponScheduleCompletion"];
            this.soidWorksOrderDefaultApplyProcessCostsToLinesOnWOCreatedFromSO = _data["soidWorksOrderDefaultApplyProcessCostsToLinesOnWOCreatedFromSO"];
            this.soidWorksOrderShowStockWarningOnWOGeneratedFromSO = _data["soidWorksOrderShowStockWarningOnWOGeneratedFromSO"];
            this.soidWorksOrderAllowProcessingIfSourceMaterialStockWillGoNegative = _data["soidWorksOrderAllowProcessingIfSourceMaterialStockWillGoNegative"];
            this.soidWorksOrderPromptToPrintLabelsForTaggedPacksWhenWOCompleted = _data["soidWorksOrderPromptToPrintLabelsForTaggedPacksWhenWOCompleted"];
            this.soidWorksOrderPromptToPrintLabelsForTaggedPacksWhenWOProcessed = _data["soidWorksOrderPromptToPrintLabelsForTaggedPacksWhenWOProcessed"];
            this.soidWorksOrderAlwaysCalculateRequiredDateOnCreation = _data["soidWorksOrderAlwaysCalculateRequiredDateOnCreation"];
            this.soidWorksOrderSalesOrderAVOForWasteCosts = _data["soidWorksOrderSalesOrderAVOForWasteCosts"];
            this.soidWorksOrderAveCostAdjReasonForWasteCosts = _data["soidWorksOrderAveCostAdjReasonForWasteCosts"];
            this.soidStockReceiptPrintOnChange = _data["soidStockReceiptPrintOnChange"];
            this.soidStockReceiptsPreentered = _data["soidStockReceiptsPreentered"];
            this.soidStockreceiptQtyOverReceivedWarningThreshold = _data["soidStockreceiptQtyOverReceivedWarningThreshold"];
            this.soidStockReceiptRetainERWhenReceivingPreEnteredPacks = _data["soidStockReceiptRetainERWhenReceivingPreEnteredPacks"];
            this.soidStockreceiptQtyUnderReceivedWarningThreshold = _data["soidStockreceiptQtyUnderReceivedWarningThreshold"];
            this.soidStockReceiptAutoPrintLabels = _data["soidStockReceiptAutoPrintLabels"];
            this.soidStockReceiptsRequiresDeliveryDetails = _data["soidStockReceiptsRequiresDeliveryDetails"];
            this.soidStockReceiptsRequiresHaulierDetails = _data["soidStockReceiptsRequiresHaulierDetails"];
            this.soidStockReceiptsInAdvanceAffectOnOrder = _data["soidStockReceiptsInAdvanceAffectOnOrder"];
            this.soidStockReceiptsQuickAddInputStyle = _data["soidStockReceiptsQuickAddInputStyle"];
            this.soidStockReceiptBackdateERWhenBackdating = _data["soidStockReceiptBackdateERWhenBackdating"];
            this.soidStockReceiptRequireBinForSpecials = _data["soidStockReceiptRequireBinForSpecials"];
            this.soidInvoiceLowMarginCollected = _data["soidInvoiceLowMarginCollected"];
            this.soidInvoiceLowMarginDelivered = _data["soidInvoiceLowMarginDelivered"];
            this.soidInvoiceLowMarginDirect = _data["soidInvoiceLowMarginDirect"];
            this.soidInvoiceHighMargin = _data["soidInvoiceHighMargin"];
            this.soidDefaultInvoicePaymentMethod = _data["soidDefaultInvoicePaymentMethod"];
            this.soidDefaultInvoicePaymentTerms = _data["soidDefaultInvoicePaymentTerms"];
            this.soidIncludeOrderTextLinesInInvoice = _data["soidIncludeOrderTextLinesInInvoice"];
            this.soidDefaultInvoiceBrowserFilterToUnreleased = _data["soidDefaultInvoiceBrowserFilterToUnreleased"];
            this.soidInvoiceOnMarkDelivered = _data["soidInvoiceOnMarkDelivered"];
            this.soidAllowUpdatesOfUnreleasedInvoices = _data["soidAllowUpdatesOfUnreleasedInvoices"];
            this.soidInvoiceAllowEditInternalNotesAfterCompletion = _data["soidInvoiceAllowEditInternalNotesAfterCompletion"];
            this.soidInvoiceSendSeparateInvoicesForEachJob = _data["soidInvoiceSendSeparateInvoicesForEachJob"];
            this.soidDefaultInvoiceCostAdjustmentReason = _data["soidDefaultInvoiceCostAdjustmentReason"];
            this.soidAllowInvoiceToBeSentType = _data["soidAllowInvoiceToBeSentType"];
            this.soidOnlyMarkInvoicesSentFromBrowser = _data["soidOnlyMarkInvoicesSentFromBrowser"];
            this.soidOrdersAutoInvoiceCollectNowChargeOrdersOnCompletion = _data["soidOrdersAutoInvoiceCollectNowChargeOrdersOnCompletion"];
            this.soidOrdersMarkCollectNowChargeOrdersAsSentWhenInvoicingOnCompletion = _data["soidOrdersMarkCollectNowChargeOrdersAsSentWhenInvoicingOnCompletion"];
            this.soidOrdersAutoInvoiceCollectLaterChargeOrdersOnCompletion = _data["soidOrdersAutoInvoiceCollectLaterChargeOrdersOnCompletion"];
            this.soidInvoiceAutoApproveIfIssued = _data["soidInvoiceAutoApproveIfIssued"];
            this.soidInvoiceAutoSetDateTo = _data["soidInvoiceAutoSetDateTo"];
            this.soidInvoiceAutoOnlyIfOrderStatusIsInvoicing = _data["soidInvoiceAutoOnlyIfOrderStatusIsInvoicing"];
            this.soidCreditDefaultReturnStockToZero = _data["soidCreditDefaultReturnStockToZero"];
            this.soidCreditReturnStockToReceivingBranch = _data["soidCreditReturnStockToReceivingBranch"];
            this.soidCreditAllowSettlementDiscount = _data["soidCreditAllowSettlementDiscount"];
            this.soidCreditUserMustReconfirmPassword = _data["soidCreditUserMustReconfirmPassword"];
            this.soidCreditRefundAmountToForceCompanyCheque = _data["soidCreditRefundAmountToForceCompanyCheque"];
            this.soidCreditCalculateSellPriceManualLine = _data["soidCreditCalculateSellPriceManualLine"];
            this.soidCreditApplyRestockChargeToOwnBrandProducts = _data["soidCreditApplyRestockChargeToOwnBrandProducts"];
            this.soidCreditFullRestockChargeOnSpecials = _data["soidCreditFullRestockChargeOnSpecials"];
            this.soidCreditLockCashRefundsToOriginalPayment = _data["soidCreditLockCashRefundsToOriginalPayment"];
            this.soidCreditUseCustomerCreditsForCustomerReturns = _data["soidCreditUseCustomerCreditsForCustomerReturns"];
            this.soidCreditRefundAmountToForceGiftCard = _data["soidCreditRefundAmountToForceGiftCard"];
            this.soidCreditRefundChequeFormat = _data["soidCreditRefundChequeFormat"];
            this.soidCreditReturnToSupplierOnDirect = _data["soidCreditReturnToSupplierOnDirect"];
            this.soidCreditConfirmRefundAddress = _data["soidCreditConfirmRefundAddress"];
            this.soidCreditNoteRequestFormatNumber = _data["soidCreditNoteRequestFormatNumber"];
            this.soidCreditRefundAllowCompanyCheque = _data["soidCreditRefundAllowCompanyCheque"];
            this.soidCreditAllowPrintFinalDocumentOnRelease = _data["soidCreditAllowPrintFinalDocumentOnRelease"];
            this.soidCreditSearchInvoicesByOrderNumber = _data["soidCreditSearchInvoicesByOrderNumber"];
            this.soidCreditAllowUnpaidCustomerCredits = _data["soidCreditAllowUnpaidCustomerCredits"];
            this.soidCreditAllowSalesOrderCreationFromCreditNotes = _data["soidCreditAllowSalesOrderCreationFromCreditNotes"];
            this.soidCreditDefaultReturnStockToZeroFromProductsPurchased = _data["soidCreditDefaultReturnStockToZeroFromProductsPurchased"];
            this.soidCreditUseTakenByFromLinkedInvoiceForSalesAnalysis = _data["soidCreditUseTakenByFromLinkedInvoiceForSalesAnalysis"];
            this.soidCreditDoNotAllowReturnToStockCreditNotesBackToVMIPrograms = _data["soidCreditDoNotAllowReturnToStockCreditNotesBackToVMIPrograms"];
            this.soidCreditRefundAlwaysAllowCompanyCheque = _data["soidCreditRefundAlwaysAllowCompanyCheque"];
            this.soidCreditUpdateQuantityCreditedAtTimeOfCreditCreation = _data["soidCreditUpdateQuantityCreditedAtTimeOfCreditCreation"];
            this.soidCreditDefaultHandling = _data["soidCreditDefaultHandling"];
            this.soidCreditAlwaysUseARCustomerFromAddress = _data["soidCreditAlwaysUseARCustomerFromAddress"];
            this.soidCreditAllowQuantityLessThanReturnToStockQuantity = _data["soidCreditAllowQuantityLessThanReturnToStockQuantity"];
            this.soidCreditAutoApproveCreditNoteOnCompletionWhenStockReturned = _data["soidCreditAutoApproveCreditNoteOnCompletionWhenStockReturned"];
            this.soidCreditWMSRefuseOnTruckReasonCode = _data["soidCreditWMSRefuseOnTruckReasonCode"];
            this.soidCreditWMSRefuseOnTruckReasonCodeCash = _data["soidCreditWMSRefuseOnTruckReasonCodeCash"];
            this.soidCreditWMSUpdateCreditQuantity = _data["soidCreditWMSUpdateCreditQuantity"];
            this.soidCreditPostSalesAndCOGSToInvoiceBranch = _data["soidCreditPostSalesAndCOGSToInvoiceBranch"];
            this.soidCreditRebillCreditNoteReason = _data["soidCreditRebillCreditNoteReason"];
            this.soidCreditRebillCashRefundReason = _data["soidCreditRebillCashRefundReason"];
            this.soidCreditDefaultCreditNoteLinesToIncludeAVOCost = _data["soidCreditDefaultCreditNoteLinesToIncludeAVOCost"];
            this.soidCreditRequireCashRefundAuthorization = _data["soidCreditRequireCashRefundAuthorization"];
            this.soidCreditSignatureCaptureForReturnToBranch = _data["soidCreditSignatureCaptureForReturnToBranch"];
            this.soidCreditReasonCodeToUseForContractBillingCreditNotes = _data["soidCreditReasonCodeToUseForContractBillingCreditNotes"];
            this.soidCreditReasonCodeToUseForContractBillingCashRefunds = _data["soidCreditReasonCodeToUseForContractBillingCashRefunds"];
            this.soidCreditCopyCustomerAddressNotesIntoDescription = _data["soidCreditCopyCustomerAddressNotesIntoDescription"];
            this.soidCreditDefaultProductsPurchasedDateSearch = _data["soidCreditDefaultProductsPurchasedDateSearch"];
            this.soidCreditPrintCreditFormatFromCashRefund = _data["soidCreditPrintCreditFormatFromCashRefund"];
            this.soidCreditLimitInvoiceAndProductPurchasedSearchesToTheJobOnCreditNotes = _data["soidCreditLimitInvoiceAndProductPurchasedSearchesToTheJobOnCreditNotes"];
            this.soidCashDrawerCOMEnabled = _data["soidCashDrawerCOMEnabled"];
            this.soidCashDrawerDefaultClosingFloat = _data["soidCashDrawerDefaultClosingFloat"];
            this.soidUpdateLCPOnPurchaseOrderUpdate = _data["soidUpdateLCPOnPurchaseOrderUpdate"];
            this.soidUpdateLCPOnStockReceiptUpdate = _data["soidUpdateLCPOnStockReceiptUpdate"];
            this.soidUpdateLCPOnSupplierInvoiceApprove = _data["soidUpdateLCPOnSupplierInvoiceApprove"];
            this.soidUpdateLCPOnWorksOrderProcess = _data["soidUpdateLCPOnWorksOrderProcess"];
            this.soidIncludeProratedManualCostsInACP = _data["soidIncludeProratedManualCostsInACP"];
            this.soidIncludeProratedManualCostsInLCP = _data["soidIncludeProratedManualCostsInLCP"];
            this.soidUpdateLCPOnStockTransferReceipt = _data["soidUpdateLCPOnStockTransferReceipt"];
            this.soidInventoryAgingAnnualCostRate = _data["soidInventoryAgingAnnualCostRate"];
            this.soidFreeDaysBeforeAgingApplies = _data["soidFreeDaysBeforeAgingApplies"];
            this.soidSkipUpdateACPOnSupplierInvoiceApprove = _data["soidSkipUpdateACPOnSupplierInvoiceApprove"];
            this.soidTurnOffProduceInvoiceOnCOD = _data["soidTurnOffProduceInvoiceOnCOD"];
            this.soidVolumeDisplayUnitInOrderSummary = _data["soidVolumeDisplayUnitInOrderSummary"];
            this.soidDisplayVolumeAreaLengthInOrderSummary = _data["soidDisplayVolumeAreaLengthInOrderSummary"];
            this.soidSalesAndPOLineVolumeDisplayPer = _data["soidSalesAndPOLineVolumeDisplayPer"];
            this.soidSalesAndPOLineAreaDisplayPer = _data["soidSalesAndPOLineAreaDisplayPer"];
            this.soidSalesAndPOLineLengthDisplayPer = _data["soidSalesAndPOLineLengthDisplayPer"];
            this.soidEnableVMIProcessingUseThisOne = _data["soidEnableVMIProcessingUseThisOne"];
            this.soidShowReelFunctionality = _data["soidShowReelFunctionality"];
            this.soidDefaultNotepadCaseStatus = _data["soidDefaultNotepadCaseStatus"];
            this.soidAllowVMIPRulesThatAreCalculatedFromSellPrice = _data["soidAllowVMIPRulesThatAreCalculatedFromSellPrice"];
            this.soidUseEstimateCostsOnlyOnAdditionalCostCalcs = _data["soidUseEstimateCostsOnlyOnAdditionalCostCalcs"];
            this.soidUpdateCostsOnSupplierInvoiceWhenStockReceiptPreEntered = _data["soidUpdateCostsOnSupplierInvoiceWhenStockReceiptPreEntered"];
            this.soidAlwaysProrateAdditionalCostsBySellPrice = _data["soidAlwaysProrateAdditionalCostsBySellPrice"];
            this.soidInventoryValueNetOfSupplierDiscount = _data["soidInventoryValueNetOfSupplierDiscount"];
            this.soidNumberOfCostDiscountFields = _data["soidNumberOfCostDiscountFields"];
            this.soidSetAverageCostsOnSpecialOrderCreation = _data["soidSetAverageCostsOnSpecialOrderCreation"];
            this.soidEnableCostDiscountFieldsOnDirects = _data["soidEnableCostDiscountFieldsOnDirects"];
            this.soidPOCostControlledByPermission = _data["soidPOCostControlledByPermission"];
            this.soidPPVCalculation = _data["soidPPVCalculation"];
            this.soidReasonCodeForPPVWhenCreatingAutoACA = _data["soidReasonCodeForPPVWhenCreatingAutoACA"];
            this.soidIntrastatSupplierDefaultDeliveryTerms = _data["soidIntrastatSupplierDefaultDeliveryTerms"];
            this.soidIntrastatSupplierDefaultModeOfTransport = _data["soidIntrastatSupplierDefaultModeOfTransport"];
            this.soidIntrastatCustomerDefaultDeliveryTerms = _data["soidIntrastatCustomerDefaultDeliveryTerms"];
            this.soidIntrastatCustomerDefaultModeOfTransport = _data["soidIntrastatCustomerDefaultModeOfTransport"];
            this.soidIntrastatIntegration = _data["soidIntrastatIntegration"];
            this.soidDefaultProductStockClass = _data["soidDefaultProductStockClass"];
            this.soidProductDefaultSpecialsToKeepStockFigures = _data["soidProductDefaultSpecialsToKeepStockFigures"];
            this.soidEnablePermissionsByProductTab = _data["soidEnablePermissionsByProductTab"];
            this.soidProductShowAveCostInBuyPer = _data["soidProductShowAveCostInBuyPer"];
            this.soidNoOfProductImages = _data["soidNoOfProductImages"];
            this.soidProductImageNames = _data["soidProductImageNames"];
            this.soidDefaultProductHistoryDays = _data["soidDefaultProductHistoryDays"];
            this.soidProductShowCompanyStockInFindProducts = _data["soidProductShowCompanyStockInFindProducts"];
            this.soidProductEnableProductManagerNotifications = _data["soidProductEnableProductManagerNotifications"];
            this.soidProductDefaultSpecialsProductGroup = _data["soidProductDefaultSpecialsProductGroup"];
            this.soidProductAlternativeSupplierPriceWeeks = _data["soidProductAlternativeSupplierPriceWeeks"];
            this.soidProductEditProductGroupAffectsSalesAnalysis = _data["soidProductEditProductGroupAffectsSalesAnalysis"];
            this.soidProductQtyInFindProductsToRead = _data["soidProductQtyInFindProductsToRead"];
            this.soidProductEnablePrintingofZebraLabels = _data["soidProductEnablePrintingofZebraLabels"];
            this.soidProductAllowDuplicateBarcodes = _data["soidProductAllowDuplicateBarcodes"];
            this.soidProductSupplierPricesInSupplierCurrency = _data["soidProductSupplierPricesInSupplierCurrency"];
            this.soidProductDefaultStocked = _data["soidProductDefaultStocked"];
            this.soidProductDefaultAllowSpecialsBasedOnThis = _data["soidProductDefaultAllowSpecialsBasedOnThis"];
            this.soidProductRequireWeightOnProductsAndSpecials = _data["soidProductRequireWeightOnProductsAndSpecials"];
            this.soidProductRequireEnvironmentalStatusOnSpecials = _data["soidProductRequireEnvironmentalStatusOnSpecials"];
            this.soidProductUpdateStandardBranchPricesWithCompanyPrices = _data["soidProductUpdateStandardBranchPricesWithCompanyPrices"];
            this.soidProductSkipDetailsOnAutoCreatedPurchasedSpecials = _data["soidProductSkipDetailsOnAutoCreatedPurchasedSpecials"];
            this.soidProductLimitSellingPriceBandsToSpecificBranches = _data["soidProductLimitSellingPriceBandsToSpecificBranches"];
            this.soidProductLimitStockOptionsToBranchesWithUpdateAccess = _data["soidProductLimitStockOptionsToBranchesWithUpdateAccess"];
            this.soidProductDefaultSalesTabToCurrentBranch = _data["soidProductDefaultSalesTabToCurrentBranch"];
            this.soidProductDefaultSalesTabToLast12Months = _data["soidProductDefaultSalesTabToLast12Months"];
            this.soidProductSetupSellingQuantityBreakByBranch = _data["soidProductSetupSellingQuantityBreakByBranch"];
            this.soidProductSetupPickingRequiredByBranch = _data["soidProductSetupPickingRequiredByBranch"];
            this.soidProductSetupAllowSettlementDiscountByBranch = _data["soidProductSetupAllowSettlementDiscountByBranch"];
            this.soidProductAllowChangingProductCodeOnSpecialOrderCreation = _data["soidProductAllowChangingProductCodeOnSpecialOrderCreation"];
            this.soidProductSetSellEntireRelatedSet = _data["soidProductSetSellEntireRelatedSet"];
            this.soidProductSetSelectDefaultToExpanded = _data["soidProductSetSelectDefaultToExpanded"];
            this.soidProductDefaultNewSpecialProductToBranchCreating = _data["soidProductDefaultNewSpecialProductToBranchCreating"];
            this.soidProductDefaultShortDescriptionToDescriptionOnSpecialOrderCreation = _data["soidProductDefaultShortDescriptionToDescriptionOnSpecialOrderCreation"];
            this.soidProductCopyPopupTextOnSpecialOrderCreation = _data["soidProductCopyPopupTextOnSpecialOrderCreation"];
            this.soidImportProductFollowBranchAccessPermissions = _data["soidImportProductFollowBranchAccessPermissions"];
            this.soidConvertTalliesToSpecialInstructions = _data["soidConvertTalliesToSpecialInstructions"];
            this.soidDefaultDocumentPresentation = _data["soidDefaultDocumentPresentation"];
            this.soidAddManufacturedKitToExistingWO = _data["soidAddManufacturedKitToExistingWO"];
            this.soidDefaultHideOnWorksOrders = _data["soidDefaultHideOnWorksOrders"];
            this.soidKitsSelectionImageNumber = _data["soidKitsSelectionImageNumber"];
            this.soidEnableStandardKitPromotions = _data["soidEnableStandardKitPromotions"];
            this.soidABCDStockClassCalculationBasedOn = _data["soidABCDStockClassCalculationBasedOn"];
            this.soidNumberOfMonthsToBaseRankingsOn = _data["soidNumberOfMonthsToBaseRankingsOn"];
            this.soidNumberOfMonthsOfSalesBeforeRanking = _data["soidNumberOfMonthsOfSalesBeforeRanking"];
            this.soidStockClassARanking = _data["soidStockClassARanking"];
            this.soidStockClassBRanking = _data["soidStockClassBRanking"];
            this.soidStockClassCRanking = _data["soidStockClassCRanking"];
            this.soidStockClassDRanking = _data["soidStockClassDRanking"];
            this.soidRankInComparisonToProductGroupLevel = _data["soidRankInComparisonToProductGroupLevel"];
            this.soidSearchingIncludeOrderFindSupplierFields = _data["soidSearchingIncludeOrderFindSupplierFields"];
            this.soidHighlightOwnBrandProducts = _data["soidHighlightOwnBrandProducts"];
            this.soidExcludeBarcodeInOrderProductFind = _data["soidExcludeBarcodeInOrderProductFind"];
            this.soidUseExactProductCodeSearchOnCollectNow = _data["soidUseExactProductCodeSearchOnCollectNow"];
            this.soidSearchingSortFindDocumentFilterLists = _data["soidSearchingSortFindDocumentFilterLists"];
            this.soidSearchingUseIssuingBranch = _data["soidSearchingUseIssuingBranch"];
            this.soidBarcodePrefix = _data["soidBarcodePrefix"];
            this.soidUseAdditionalBarcodesInOrderProductFind = _data["soidUseAdditionalBarcodesInOrderProductFind"];
            this.soidSearchingFindDocsDeliveryAreaSearchStyle = _data["soidSearchingFindDocsDeliveryAreaSearchStyle"];
            this.soidSearchingTrimSearchText = _data["soidSearchingTrimSearchText"];
            this.soidSearchMOLTsInProductFindInOrderEntry = _data["soidSearchMOLTsInProductFindInOrderEntry"];
            this.soidSearchCouponsInProductFindInOrderEntry = _data["soidSearchCouponsInProductFindInOrderEntry"];
            this.soidSearchingDeliveryAreaSearchStyle = _data["soidSearchingDeliveryAreaSearchStyle"];
            this.soidAllowCustomerProductReference = _data["soidAllowCustomerProductReference"];
            this.soidSupplierReturnEnable = _data["soidSupplierReturnEnable"];
            this.soidSupplierReturnAlwaysDefaultCostToAverageCostWithAdd = _data["soidSupplierReturnAlwaysDefaultCostToAverageCostWithAdd"];
            this.soidSupplierReturnAllowBranchChangeWhenLinkedToDocument = _data["soidSupplierReturnAllowBranchChangeWhenLinkedToDocument"];
            this.soidSupplierReturnUseAccountsPayableGLCodeFromLinkedDocument = _data["soidSupplierReturnUseAccountsPayableGLCodeFromLinkedDocument"];
            this.soidSupplierReturnAllowInspectAfterPickup = _data["soidSupplierReturnAllowInspectAfterPickup"];
            this.soidOrdersPricingSpecialPriceMessage = _data["soidOrdersPricingSpecialPriceMessage"];
            this.soidOrdersPricingSpecialPriceMessageColour = _data["soidOrdersPricingSpecialPriceMessageColour"];
            this.soidOrdersPricingUseDeferredDiscountInCostCalc = _data["soidOrdersPricingUseDeferredDiscountInCostCalc"];
            this.soidPricingUseOrderCostForSpecialBackToBack = _data["soidPricingUseOrderCostForSpecialBackToBack"];
            this.soidSalesOrderSecondaryCostCalculation = _data["soidSalesOrderSecondaryCostCalculation"];
            this.soidPricingUseQuotePriceUnlessRuleExists = _data["soidPricingUseQuotePriceUnlessRuleExists"];
            this.soidPricingRecostOrderOn = _data["soidPricingRecostOrderOn"];
            this.soidPricingUseLastSellPriceWithin = _data["soidPricingUseLastSellPriceWithin"];
            this.soidOrdersPricingQuotePriceMessage = _data["soidOrdersPricingQuotePriceMessage"];
            this.soidOrdersPricingQuotePriceMessageColour = _data["soidOrdersPricingQuotePriceMessageColour"];
            this.soidOrdersPricingLastSellPriceMessage = _data["soidOrdersPricingLastSellPriceMessage"];
            this.soidOrdersPricingLastSellPriceMessageColour = _data["soidOrdersPricingLastSellPriceMessageColour"];
            this.soidCostDefaultQuoteToStandardBuy = _data["soidCostDefaultQuoteToStandardBuy"];
            this.soidCostDefaultTemplateOrderToStandardBuy = _data["soidCostDefaultTemplateOrderToStandardBuy"];
            this.soidOrdersPricingCheckIfCallOffExists = _data["soidOrdersPricingCheckIfCallOffExists"];
            this.soidPricingUseQuotePriceAlways = _data["soidPricingUseQuotePriceAlways"];
            this.soidOrdersLastSellPriceIsBranchSpecific = _data["soidOrdersLastSellPriceIsBranchSpecific"];
            this.soidOrdersPricingLumpSumQtySell = _data["soidOrdersPricingLumpSumQtySell"];
            this.soidOrdersPricingLumpSumQtyCost = _data["soidOrdersPricingLumpSumQtyCost"];
            this.soidOrdersPricingShowLastPOPriceInNegotiation = _data["soidOrdersPricingShowLastPOPriceInNegotiation"];
            this.soidOrdersPricingPOPriceOutOfDateDays = _data["soidOrdersPricingPOPriceOutOfDateDays"];
            this.soidOrdersPricingShowContributionOnOrders = _data["soidOrdersPricingShowContributionOnOrders"];
            this.soidOrdersPricingUseDeferredDiscountInLastCostCalc = _data["soidOrdersPricingUseDeferredDiscountInLastCostCalc"];
            this.soidOrdersPricingUseDeferredDiscountInAverageCostCalc = _data["soidOrdersPricingUseDeferredDiscountInAverageCostCalc"];
            this.soidOrdersPricingRecostBackToBackOrders = _data["soidOrdersPricingRecostBackToBackOrders"];
            this.soidOrdersPricingPromotionPointsPer = _data["soidOrdersPricingPromotionPointsPer"];
            this.soidOrdersPricingPromotionCalculateAfterDeliveryCharges = _data["soidOrdersPricingPromotionCalculateAfterDeliveryCharges"];
            this.soidOrdersPricingAllowNegotiateIfNoMarginOptions = _data["soidOrdersPricingAllowNegotiateIfNoMarginOptions"];
            this.soidOrdersPricingPromotionExcludeAbsolutePriceLines = _data["soidOrdersPricingPromotionExcludeAbsolutePriceLines"];
            this.soidOrdersPricingPromotionExcludeDirects = _data["soidOrdersPricingPromotionExcludeDirects"];
            this.soidOrdersPricingPromptToChangePriceOnIdenticalItems = _data["soidOrdersPricingPromptToChangePriceOnIdenticalItems"];
            this.soidOrdersPricingDefaultReplaceExistingLineDiscounts = _data["soidOrdersPricingDefaultReplaceExistingLineDiscounts"];
            this.soidOrdersPricingDefaultPriceRulesToCalculateDiscountsIntoUnitPrice = _data["soidOrdersPricingDefaultPriceRulesToCalculateDiscountsIntoUnitPrice"];
            this.soidOrdersPricingUseInternalCostInMarginCalcs = _data["soidOrdersPricingUseInternalCostInMarginCalcs"];
            this.soidOrdersPricingUseInternalCostRules = _data["soidOrdersPricingUseInternalCostRules"];
            this.soidOrdersPricingApplyPriceRoundingWhenManuallyPricingLines = _data["soidOrdersPricingApplyPriceRoundingWhenManuallyPricingLines"];
            this.soidOrdersPricingDefaultCostToZeroOnDirectSalesOrders = _data["soidOrdersPricingDefaultCostToZeroOnDirectSalesOrders"];
            this.soidOrdersPricingShowLastPriceDates = _data["soidOrdersPricingShowLastPriceDates"];
            this.soidOrdersPricingShowNextPricesXDays = _data["soidOrdersPricingShowNextPricesXDays"];
            this.soidOrdersPricingManualPriceOnMarginNegotiation = _data["soidOrdersPricingManualPriceOnMarginNegotiation"];
            this.soidOrdersPricingShowPriceBandsOnNegotiation = _data["soidOrdersPricingShowPriceBandsOnNegotiation"];
            this.soidOrdersPricingShowInternalCostInfo = _data["soidOrdersPricingShowInternalCostInfo"];
            this.soidOrdersPricingEnsureAVOInclusiveSellPriceExtends = _data["soidOrdersPricingEnsureAVOInclusiveSellPriceExtends"];
            this.soidOrdersPricingOrderlinePriceInfoToDisplay = _data["soidOrdersPricingOrderlinePriceInfoToDisplay"];
            this.soidOrdersPricingUseInternalCostRulesOnDirects = _data["soidOrdersPricingUseInternalCostRulesOnDirects"];
            this.soidOrdersPricingCalculatePriceBandDiscountsIntoUnitPrice = _data["soidOrdersPricingCalculatePriceBandDiscountsIntoUnitPrice"];
            this.soidOrdersPricingDefaultUseBasedOnProductsOnNewPriceRules = _data["soidOrdersPricingDefaultUseBasedOnProductsOnNewPriceRules"];
            this.soidOrdersPricingPriceBandsUtilizeBasedOnProducts = _data["soidOrdersPricingPriceBandsUtilizeBasedOnProducts"];
            this.soidOrdersPricingRecalcSellPriceOnNonSpecialManKitRefresh = _data["soidOrdersPricingRecalcSellPriceOnNonSpecialManKitRefresh"];
            this.soidOrdersPricingApplyPriceRoundingWhenNegotiatingMargin = _data["soidOrdersPricingApplyPriceRoundingWhenNegotiatingMargin"];
            this.soidOrdersPricingEnableManagerOverrideOnOrderLinePrice = _data["soidOrdersPricingEnableManagerOverrideOnOrderLinePrice"];
            this.soidOrdersPricingRequireReasonCodeOnSalesLinePriceChange = _data["soidOrdersPricingRequireReasonCodeOnSalesLinePriceChange"];
            this.soidOrdersPricingAllowMultiplePromotionsPerLine = _data["soidOrdersPricingAllowMultiplePromotionsPerLine"];
            this.soidOrdersPricingShowMultiplierOnOrderLine = _data["soidOrdersPricingShowMultiplierOnOrderLine"];
            this.soidOrdersPricingRetainOriginalPriceCalc = _data["soidOrdersPricingRetainOriginalPriceCalc"];
            this.soidOrdersPricingDefaultCostPerToSellingPerOnSalesOrder = _data["soidOrdersPricingDefaultCostPerToSellingPerOnSalesOrder"];
            this.soidOrdersPricingControlFreeOfChargeLines = _data["soidOrdersPricingControlFreeOfChargeLines"];
            this.soidOrdersPricingManualPriceAlwaysClearsDiscounts = _data["soidOrdersPricingManualPriceAlwaysClearsDiscounts"];
            this.soidOrdersPricingRecordSalesNetOfDiscounts = _data["soidOrdersPricingRecordSalesNetOfDiscounts"];
            this.soidOrdersPricingApplySettlementDiscountToCashOrderLines = _data["soidOrdersPricingApplySettlementDiscountToCashOrderLines"];
            this.soidOrdersIncludeAdditionalChargeInOrderLineTotalPrice = _data["soidOrdersIncludeAdditionalChargeInOrderLineTotalPrice"];
            this.soidOrdersRepriceOrderLinesAtFixedMarginPctPerLine = _data["soidOrdersRepriceOrderLinesAtFixedMarginPctPerLine"];
            this.soidOrdersRoundUpSellPriceOnMarginNegotiate = _data["soidOrdersRoundUpSellPriceOnMarginNegotiate"];
            this.soidOrdersRoundDiscountDown = _data["soidOrdersRoundDiscountDown"];
            this.soidOrdersPricingAutoCreateInvoiceCostAdjForSpecials = _data["soidOrdersPricingAutoCreateInvoiceCostAdjForSpecials"];
            this.soidOrdersPricingDefaultRepriceProductsOnFindAndReplace = _data["soidOrdersPricingDefaultRepriceProductsOnFindAndReplace"];
            this.soidDefaultCostPerToLastCostWithAdditionalPerOnTransfers = _data["soidDefaultCostPerToLastCostWithAdditionalPerOnTransfers"];
            this.soidOrdersPricingSpecialPriceMessageOverride = _data["soidOrdersPricingSpecialPriceMessageOverride"];
            this.soidOrdersPricingApplyPriceRoundingAfterDelChargeIsAdded = _data["soidOrdersPricingApplyPriceRoundingAfterDelChargeIsAdded"];
            this.soidOrdersPricingKeepPricePerWhenSpecificPriceBandIsUsed = _data["soidOrdersPricingKeepPricePerWhenSpecificPriceBandIsUsed"];
            this.soidOrdersPricingRestoreCostOnSpecialProductsOnRecalculate = _data["soidOrdersPricingRestoreCostOnSpecialProductsOnRecalculate"];
            this.soidOrdersPricingDisplayMultiplierInPriceRulesAndSellingBands = _data["soidOrdersPricingDisplayMultiplierInPriceRulesAndSellingBands"];
            this.soidOrdersPricingShowCostAndSellPriceMultipliersOnSalesSpecialOrderCreation = _data["soidOrdersPricingShowCostAndSellPriceMultipliersOnSalesSpecialOrderCreation"];
            this.soidOrdersPricingRecostSalesTransactionsOnCopyFrom = _data["soidOrdersPricingRecostSalesTransactionsOnCopyFrom"];
            this.soidOrdersPricingAutoCreateInvoiceCostAdjForNonSpecials = _data["soidOrdersPricingAutoCreateInvoiceCostAdjForNonSpecials"];
            this.soidAllowMarkingSalesOrderLinesAsNetPriced = _data["soidAllowMarkingSalesOrderLinesAsNetPriced"];
            this.soidOrdersPricingDefaultCostOnBackToBackOrderLines = _data["soidOrdersPricingDefaultCostOnBackToBackOrderLines"];
            this.soidOrdersPricingAutoCreateInvoiceCostAdjForManProducts = _data["soidOrdersPricingAutoCreateInvoiceCostAdjForManProducts"];
            this.soidDefaultCalculationMethodForCostBasedSellingPriceRules = _data["soidDefaultCalculationMethodForCostBasedSellingPriceRules"];
            this.soidOrdersPricingAutoApplySellingPriceChangesNightly = _data["soidOrdersPricingAutoApplySellingPriceChangesNightly"];
            this.soidOrdersUseDefaultJobAddressPriceProfile = _data["soidOrdersUseDefaultJobAddressPriceProfile"];
            this.soidExcludePriceRoundingWhenUsingSpecialPriceRules = _data["soidExcludePriceRoundingWhenUsingSpecialPriceRules"];
            this.soidQuantityBreaksThatUseSpecificPriceBandWillOnlyUseDiscountFromThatBand = _data["soidQuantityBreaksThatUseSpecificPriceBandWillOnlyUseDiscountFromThatBand"];
            this.soidOrdersPricingAllowMultipleSpendXSaveYCouponPromotions = _data["soidOrdersPricingAllowMultipleSpendXSaveYCouponPromotions"];
            this.soidBranchPrinter1 = _data["soidBranchPrinter1"];
            this.soidBranchPrinter2 = _data["soidBranchPrinter2"];
            this.soidBranchPrinter3 = _data["soidBranchPrinter3"];
            this.soidBranchPrinter4 = _data["soidBranchPrinter4"];
            this.soidBranchPrinter5 = _data["soidBranchPrinter5"];
            this.soidBranchPrinter6 = _data["soidBranchPrinter6"];
            this.soidBranchPrinter7 = _data["soidBranchPrinter7"];
            this.soidBranchPrinter8 = _data["soidBranchPrinter8"];
            this.soidBranchPrinter9 = _data["soidBranchPrinter9"];
            this.soidBranchPrinter10 = _data["soidBranchPrinter10"];
            this.soidPrintingMaxDocument = _data["soidPrintingMaxDocument"];
            this.soidAlternatePrintDialog = _data["soidAlternatePrintDialog"];
            this.soidAllowDocumentPrintingFromPreview = _data["soidAllowDocumentPrintingFromPreview"];
            this.soidPrinterListMethod = _data["soidPrinterListMethod"];
            this.soidPrintingSortPrinterList = _data["soidPrintingSortPrinterList"];
            this.soidPrintingPrinterDisplayFormat = _data["soidPrintingPrinterDisplayFormat"];
            this.soidDepartmentPinter1 = _data["soidDepartmentPinter1"];
            this.soidDepartmentPinter2 = _data["soidDepartmentPinter2"];
            this.soidDepartmentPinter3 = _data["soidDepartmentPinter3"];
            this.soidDepartmentPinter4 = _data["soidDepartmentPinter4"];
            this.soidDepartmentPinter5 = _data["soidDepartmentPinter5"];
            this.soidDepartmentPinter6 = _data["soidDepartmentPinter6"];
            this.soidDepartmentPinter7 = _data["soidDepartmentPinter7"];
            this.soidDepartmentPinter8 = _data["soidDepartmentPinter8"];
            this.soidDepartmentPinter9 = _data["soidDepartmentPinter9"];
            this.soidDepartmentPinter10 = _data["soidDepartmentPinter10"];
            this.soidOrdersEnablePricingOptionToChangeSellingPriceUOM = _data["soidOrdersEnablePricingOptionToChangeSellingPriceUOM"];
            this.soidCustomersDefaultRefRequired = _data["soidCustomersDefaultRefRequired"];
            this.soidCustomersDefaultDropdownLists = _data["soidCustomersDefaultDropdownLists"];
            this.soidCustomersDefaultEnforceEnterOrderContact = _data["soidCustomersDefaultEnforceEnterOrderContact"];
            this.soidAllowCustomerSalesRepToBeOptional = _data["soidAllowCustomerSalesRepToBeOptional"];
            this.soidRemitToAddressRequiredOnDefaultAddress = _data["soidRemitToAddressRequiredOnDefaultAddress"];
            this.soidPreventDuplicateJobReferencesPerCustomer = _data["soidPreventDuplicateJobReferencesPerCustomer"];
            this.soidRestrictUpdatingCustomersToHomeBranch = _data["soidRestrictUpdatingCustomersToHomeBranch"];
            this.soidAutoAllocateJobNumbers = _data["soidAutoAllocateJobNumbers"];
            this.soidCustomersEnablePermissionsByTab = _data["soidCustomersEnablePermissionsByTab"];
            this.soidCustomersLimitSearchToHomeBranch = _data["soidCustomersLimitSearchToHomeBranch"];
            this.soidCustomersUseTaxExemptionsFromARCustomer = _data["soidCustomersUseTaxExemptionsFromARCustomer"];
            this.soidCustomersDefaultEnforceJobAddressOrderEntry = _data["soidCustomersDefaultEnforceJobAddressOrderEntry"];
            this.soidCustomersDefaultFinanceChargeAmountToNotSet = _data["soidCustomersDefaultFinanceChargeAmountToNotSet"];
            this.soidCustomerCopyInstructionsToTransactions = _data["soidCustomerCopyInstructionsToTransactions"];
            this.soidCustomerDefaultAllowOvertypeInvoiceAddress = _data["soidCustomerDefaultAllowOvertypeInvoiceAddress"];
            this.soidCustomerForceVerifyOfContactIdentification = _data["soidCustomerForceVerifyOfContactIdentification"];
            this.soidCustomerLimitContactsToThoseBasedAtDeliveryAddress = _data["soidCustomerLimitContactsToThoseBasedAtDeliveryAddress"];
            this.soidCustomerDisplayCustomerContactDefaultOnOrders = _data["soidCustomerDisplayCustomerContactDefaultOnOrders"];
            this.soidCustomerDefaultHomeBranchInCustomerFindToLoggedInBranch = _data["soidCustomerDefaultHomeBranchInCustomerFindToLoggedInBranch"];
            this.soidOptimizeCustomerAddressUsage = _data["soidOptimizeCustomerAddressUsage"];
            this.soidCustomerTypeLevel1 = _data["soidCustomerTypeLevel1"];
            this.soidCustomerTypeLevel2 = _data["soidCustomerTypeLevel2"];
            this.soidCustomersAutomaticallyGenerateProspectCode = _data["soidCustomersAutomaticallyGenerateProspectCode"];
            this.soidCustomerEnableContactLoyaltyCards = _data["soidCustomerEnableContactLoyaltyCards"];
            this.soidPreventDuplicateAddressCodesPerCustomer = _data["soidPreventDuplicateAddressCodesPerCustomer"];
            this.soidForceStateSelectionFromDropdown = _data["soidForceStateSelectionFromDropdown"];
            this.soidCustomerLimitContactsToThoseWhoCanAuthoriseSalesOrders = _data["soidCustomerLimitContactsToThoseWhoCanAuthoriseSalesOrders"];
            this.soidGenerateCustomerCodesStartingPoint = _data["soidGenerateCustomerCodesStartingPoint"];
            this.soidUseCounterSalesCashAliasCreationFormInBisTrack = _data["soidUseCounterSalesCashAliasCreationFormInBisTrack"];
            this.soidAutomaticallyGenerateCashCustomerAliasCode = _data["soidAutomaticallyGenerateCashCustomerAliasCode"];
            this.soidAutomaticallyApproveJobs = _data["soidAutomaticallyApproveJobs"];
            this.soidCustomerGenerateNewAddressCodeMethod = _data["soidCustomerGenerateNewAddressCodeMethod"];
            this.soidCopyInfoFromDefaultJobAddress = _data["soidCopyInfoFromDefaultJobAddress"];
            this.soidAddressValidationMethod = _data["soidAddressValidationMethod"];
            this.soidPasswordExpiryDays = _data["soidPasswordExpiryDays"];
            this.soidAllowNonAdministrativePasswordChange = _data["soidAllowNonAdministrativePasswordChange"];
            this.soidStaffNumberRestoreOriginalUser = _data["soidStaffNumberRestoreOriginalUser"];
            this.soidStaffNumberRequiredForNonSalesTransactions = _data["soidStaffNumberRequiredForNonSalesTransactions"];
            this.soidServerManagerBackupFolder = _data["soidServerManagerBackupFolder"];
            this.soidOrdersPricingRequireReasonCodeOnQuoteLinePriceChange = _data["soidOrdersPricingRequireReasonCodeOnQuoteLinePriceChange"];
            this.soidEmailFaxAllowEmailFromOrderCompletion = _data["soidEmailFaxAllowEmailFromOrderCompletion"];
            this.soidEmailFaxAllowEmailFromPurchaseOrderCompletion = _data["soidEmailFaxAllowEmailFromPurchaseOrderCompletion"];
            this.soidEmailFaxCCOtherSalesRepsOnOrderSend = _data["soidEmailFaxCCOtherSalesRepsOnOrderSend"];
            this.soidDefaultSalesOrderEmailAddressFromContactEmailAddress = _data["soidDefaultSalesOrderEmailAddressFromContactEmailAddress"];
            this.soidEmailFaxFaxMethod = _data["soidEmailFaxFaxMethod"];
            this.soidEmailFaxFaxAutoSendFolder = _data["soidEmailFaxFaxAutoSendFolder"];
            this.soidEmailFaxFaxEmailAddress = _data["soidEmailFaxFaxEmailAddress"];
            this.soidEmailUseSMTPForAllEmail = _data["soidEmailUseSMTPForAllEmail"];
            this.soidEmailUseTemplates = _data["soidEmailUseTemplates"];
            this.soidDatabaseMailProfileName = _data["soidDatabaseMailProfileName"];
            this.soidPrefaceEmailAddressWithContact = _data["soidPrefaceEmailAddressWithContact"];
            this.soidEmailFaxVsiFaxEmailNotifyOnEvent = _data["soidEmailFaxVsiFaxEmailNotifyOnEvent"];
            this.soidCashDrawerTotalTolerance = _data["soidCashDrawerTotalTolerance"];
            this.soidCashDrawerTenderBillDenominations = _data["soidCashDrawerTenderBillDenominations"];
            this.soidCashDrawerTenderCoinDenominations = _data["soidCashDrawerTenderCoinDenominations"];
            this.soidCashDrawerRequireCashDetailsToBeEntered = _data["soidCashDrawerRequireCashDetailsToBeEntered"];
            this.soidCashDrawerRequireClosingFloatDetailsToBeEntered = _data["soidCashDrawerRequireClosingFloatDetailsToBeEntered"];
            this.soidCashDrawerRequireOpeningFloatToBeCountedBeforeUse = _data["soidCashDrawerRequireOpeningFloatToBeCountedBeforeUse"];
            this.soidCashDrawerRequireChequeDetailsToBeEntered = _data["soidCashDrawerRequireChequeDetailsToBeEntered"];
            this.soidTransportBookingAllowUse = _data["soidTransportBookingAllowUse"];
            this.soidTransportBookingDistanceUnit = _data["soidTransportBookingDistanceUnit"];
            this.soidTransportBookingRequireDistance = _data["soidTransportBookingRequireDistance"];
            this.soidTransportBookingRequireInstructionsOnPO = _data["soidTransportBookingRequireInstructionsOnPO"];
            this.soidTransportBookingRequireInstructionsOnSO = _data["soidTransportBookingRequireInstructionsOnSO"];
            this.soidDisableRemainingCountInFindDocuments = _data["soidDisableRemainingCountInFindDocuments"];
            this.soidDisableRemainingCountInFindObjects = _data["soidDisableRemainingCountInFindObjects"];
            this.soidWarnIfNoSearchTextEnteredInFindProducts = _data["soidWarnIfNoSearchTextEnteredInFindProducts"];
            this.soidWarnIfNoSearchTextEnteredInFindCustomers = _data["soidWarnIfNoSearchTextEnteredInFindCustomers"];
            this.soidAllowLoadAllInPriceRules = _data["soidAllowLoadAllInPriceRules"];
            this.soidPoleCommunicationMethod = _data["soidPoleCommunicationMethod"];
            this.soidCachedSalesOrderCount = _data["soidCachedSalesOrderCount"];
            this.soidPerformanceAllowLoadAllOnJobs = _data["soidPerformanceAllowLoadAllOnJobs"];
            this.soidEnableGarbageCollection = _data["soidEnableGarbageCollection"];
            this.soidEDICreateImportedProductsForAllBranches = _data["soidEDICreateImportedProductsForAllBranches"];
            this.soidEDIUpdateCompanyLevelPricesOnImport = _data["soidEDIUpdateCompanyLevelPricesOnImport"];
            this.soidElectronicPaymentMethod = _data["soidElectronicPaymentMethod"];
            this.soidElectronicPaymentsUsePostalCode = _data["soidElectronicPaymentsUsePostalCode"];
            this.soidWebTrackServicesDefaultLocation = _data["soidWebTrackServicesDefaultLocation"];
            this.soidNumberOfDigitsOfCardNumberForDisplay = _data["soidNumberOfDigitsOfCardNumberForDisplay"];
            this.soidElectronicPaymentLoggingLevel = _data["soidElectronicPaymentLoggingLevel"];
            this.soidElectronicPaymentsUseAVS = _data["soidElectronicPaymentsUseAVS"];
            this.soidElectronicPaymentLoginTimeout = _data["soidElectronicPaymentLoginTimeout"];
            this.soidElectronicPaymentTransactionTimeout = _data["soidElectronicPaymentTransactionTimeout"];
            this.soidbisTrackServicesDefaultLocation = _data["soidbisTrackServicesDefaultLocation"];
            this.soidWebTrackServicesDefaultKey = _data["soidWebTrackServicesDefaultKey"];
            this.soidElectronicPaymentNoLogin = _data["soidElectronicPaymentNoLogin"];
            this.soidEDIUpdatePurchaseOrderCostOnImport = _data["soidEDIUpdatePurchaseOrderCostOnImport"];
            this.soidElectronicPaymentProviderForPurchasingCards = _data["soidElectronicPaymentProviderForPurchasingCards"];
            this.soidPaymentProviderWebServiceURL = _data["soidPaymentProviderWebServiceURL"];
            this.soidEDIUpdateCompanyLevelCostsOnImport = _data["soidEDIUpdateCompanyLevelCostsOnImport"];
            this.soidEDIRootFolder = _data["soidEDIRootFolder"];
            this.soidEDIManualLineTypeAVOPOs = _data["soidEDIManualLineTypeAVOPOs"];
            this.soidEDIAddressCodeForStockOrders = _data["soidEDIAddressCodeForStockOrders"];
            this.soidEDIStockSalesOrderDocumentFormats = _data["soidEDIStockSalesOrderDocumentFormats"];
            this.soidEDICustomerSalesOrderDocumentFormats = _data["soidEDICustomerSalesOrderDocumentFormats"];
            this.soidEDIAgentComputerName = _data["soidEDIAgentComputerName"];
            this.soidEDIAutoApproveInternalTradingOrders = _data["soidEDIAutoApproveInternalTradingOrders"];
            this.soidElectronicPaymentsUseAddress = _data["soidElectronicPaymentsUseAddress"];
            this.soidEDIDefaultProductCodeToSKUForProductMaint = _data["soidEDIDefaultProductCodeToSKUForProductMaint"];
            this.soidEDIUpdatePurchaseOrderQuantityOnImport = _data["soidEDIUpdatePurchaseOrderQuantityOnImport"];
            this.soidEDIDefaultSupplierInvoiceManualOrderLineType = _data["soidEDIDefaultSupplierInvoiceManualOrderLineType"];
            this.soidEDIInternalTradingSupplierAtBranchLevel = _data["soidEDIInternalTradingSupplierAtBranchLevel"];
            this.soidElectronicPaymentsShowWarningWhenCardDontMatchPaymentMethod = _data["soidElectronicPaymentsShowWarningWhenCardDontMatchPaymentMethod"];
            this.soidElectronicPaymentsNoCardAuthenticationOnApprovedTransaction = _data["soidElectronicPaymentsNoCardAuthenticationOnApprovedTransaction"];
            this.soidEDIAddLinesOnInboundSupplierInvoiceIfNoProductMatch = _data["soidEDIAddLinesOnInboundSupplierInvoiceIfNoProductMatch"];
            this.soidEDIRequireSupplierProductCodeForOutboundPO = _data["soidEDIRequireSupplierProductCodeForOutboundPO"];
            this.soidEDIAddLinesOnInboundSupplierInvoiceIfPerIsNotMapped = _data["soidEDIAddLinesOnInboundSupplierInvoiceIfPerIsNotMapped"];
            this.soidEDICheckProductSpecialOrderBehaviourForXpressPOS = _data["soidEDICheckProductSpecialOrderBehaviourForXpressPOS"];
            this.soidShift4MerchantID = _data["soidShift4MerchantID"];
            this.soidShift4SerialNumber = _data["soidShift4SerialNumber"];
            this.soidShift4Vendor = _data["soidShift4Vendor"];
            this.soidEDIAllowSelectionOfEDISupplierReferenceOnSalesOrder = _data["soidEDIAllowSelectionOfEDISupplierReferenceOnSalesOrder"];
            this.soidShift4TokenLongTermStorageDuration = _data["soidShift4TokenLongTermStorageDuration"];
            this.soidShift4CaptureSignatureThresholdAmount = _data["soidShift4CaptureSignatureThresholdAmount"];
            this.soidShift4TransactionGlobalTimerIntervalInSeconds = _data["soidShift4TransactionGlobalTimerIntervalInSeconds"];
            this.soidShift4TransactionReTryTimerIntervalInSeconds = _data["soidShift4TransactionReTryTimerIntervalInSeconds"];
            this.soidShift4APIPassword = _data["soidShift4APIPassword"];
            this.soidShift4UserName = _data["soidShift4UserName"];
            this.soidShift4CreditCardsOnReturnsOnly = _data["soidShift4CreditCardsOnReturnsOnly"];
            this.soidElectronicPaymentConnectionDelay = _data["soidElectronicPaymentConnectionDelay"];
            this.soidEDIExportAdditionalChargesAsAllowances = _data["soidEDIExportAdditionalChargesAsAllowances"];
            this.soidEDIExportAVOsAsAllowances = _data["soidEDIExportAVOsAsAllowances"];
            this.soidShift4i4GoAccountID = _data["soidShift4i4GoAccountID"];
            this.soidShift4i4GoSiteID = _data["soidShift4i4GoSiteID"];
            this.soidShift4i4GoPassword = _data["soidShift4i4GoPassword"];
            this.soidCommunicateToShift4UTGServersUsingHTTPS = _data["soidCommunicateToShift4UTGServersUsingHTTPS"];
            this.soidEDIEnableDIBBuyingGroupFeatures = _data["soidEDIEnableDIBBuyingGroupFeatures"];
            this.soidTenderRetailConnectionTimeoutInSeconds = _data["soidTenderRetailConnectionTimeoutInSeconds"];
            this.soidTenderRetailResponseTimeoutInSeconds = _data["soidTenderRetailResponseTimeoutInSeconds"];
            this.soidTenderRetailPositiveAckTimeoutInSeconds = _data["soidTenderRetailPositiveAckTimeoutInSeconds"];
            this.soidGivexUserID = _data["soidGivexUserID"];
            this.soidGivexPassword = _data["soidGivexPassword"];
            this.soidShift4SkipSignatureCaptureForCardOnFile = _data["soidShift4SkipSignatureCaptureForCardOnFile"];
            this.soidShift4EnableSwipeAhead = _data["soidShift4EnableSwipeAhead"];
            this.soidShift4PINPadDisplayDelayInMilliseconds = _data["soidShift4PINPadDisplayDelayInMilliseconds"];
            this.soidEDIUpdateProductDescriptionOnEDIProductMaintenance = _data["soidEDIUpdateProductDescriptionOnEDIProductMaintenance"];
            this.soidEDIUpdateSupplierProductDescriptionOnEDIProductMaintenance = _data["soidEDIUpdateSupplierProductDescriptionOnEDIProductMaintenance"];
            this.soidShift4TRAllowTokensForSubsequentPaymentsOnSameTransaction = _data["soidShift4TRAllowTokensForSubsequentPaymentsOnSameTransaction"];
            this.soidDisplayPromoCodeForPrivateLabelCreditCardProcessing = _data["soidDisplayPromoCodeForPrivateLabelCreditCardProcessing"];
            this.soidEnableBlueTarpElectronicPaymentIntegration = _data["soidEnableBlueTarpElectronicPaymentIntegration"];
            this.soidShift4i4GoLiveURL = _data["soidShift4i4GoLiveURL"];
            this.soidShift4i4GoTestURL = _data["soidShift4i4GoTestURL"];
            this.soidBlueTarpMerchantID = _data["soidBlueTarpMerchantID"];
            this.soidBlueTarpClientKey = _data["soidBlueTarpClientKey"];
            this.soidBlueTarpBaseURL = _data["soidBlueTarpBaseURL"];
            this.soidEDIRestrictProductUpdateToDefaultSupplier = _data["soidEDIRestrictProductUpdateToDefaultSupplier"];
            this.soidCollectAirMilesCardDetailsWithPayments = _data["soidCollectAirMilesCardDetailsWithPayments"];
            this.soidAirMilesDefaultOfferCodeForCashSales = _data["soidAirMilesDefaultOfferCodeForCashSales"];
            this.soidAirMilesDefaultOfferCodeForCashSalesToChargeAccount = _data["soidAirMilesDefaultOfferCodeForCashSalesToChargeAccount"];
            this.soidAirMilesDefaultOfferCodeForZeroAmountAirMilesTransactions = _data["soidAirMilesDefaultOfferCodeForZeroAmountAirMilesTransactions"];
            this.soidAirMilesDefaultTerminalID = _data["soidAirMilesDefaultTerminalID"];
            this.soidAirMilesDefaultServerIPAddress = _data["soidAirMilesDefaultServerIPAddress"];
            this.soidAirMilesDefaultServerPortNumber = _data["soidAirMilesDefaultServerPortNumber"];
            this.soidAirMilesConnectionTimeoutInSeconds = _data["soidAirMilesConnectionTimeoutInSeconds"];
            this.soidAirMilesResponseTimeoutInSeconds = _data["soidAirMilesResponseTimeoutInSeconds"];
            this.soidShift4UseVoidOnDebitReversal = _data["soidShift4UseVoidOnDebitReversal"];
            this.soidPerformPreAuthWhenBackOrderingSOWithExistingWTPreAuth = _data["soidPerformPreAuthWhenBackOrderingSOWithExistingWTPreAuth"];
            this.soidShift4ReceiptTextWidth = _data["soidShift4ReceiptTextWidth"];
            this.soidShift4AccessMethod = _data["soidShift4AccessMethod"];
            this.soidEDITemplateManualOrderLine = _data["soidEDITemplateManualOrderLine"];
            this.soidShift4i4GoVersion = _data["soidShift4i4GoVersion"];
            this.soidEDIAPAutomationAttachmentsFolder = _data["soidEDIAPAutomationAttachmentsFolder"];
            this.soidDoNotDisplayManualCheckboxForShift4ElectronicPayments = _data["soidDoNotDisplayManualCheckboxForShift4ElectronicPayments"];
            this.soidPreSaveNewSalesOrdersBeforeProcessingShift4ElectronicPayment = _data["soidPreSaveNewSalesOrdersBeforeProcessingShift4ElectronicPayment"];
            this.soidShift4AllowManualEntryOfVoiceAuthorizations = _data["soidShift4AllowManualEntryOfVoiceAuthorizations"];
            this.soidShift4i4GoAccessLiveURL = _data["soidShift4i4GoAccessLiveURL"];
            this.soidShift4i4GoAccessTestURL = _data["soidShift4i4GoAccessTestURL"];
            this.soidShift4i4GoTokenServiceURL = _data["soidShift4i4GoTokenServiceURL"];
            this.soidShift4i4GoCardSecurityCodeRequired = _data["soidShift4i4GoCardSecurityCodeRequired"];
            this.soidShift4i4GoAcceptedCardTypes = _data["soidShift4i4GoAcceptedCardTypes"];
            this.soidShift4i4GoCardholderNamePrompt = _data["soidShift4i4GoCardholderNamePrompt"];
            this.soidShift4i4GoStreetAddressPrompt = _data["soidShift4i4GoStreetAddressPrompt"];
            this.soidShift4i4GoPostalCodePrompt = _data["soidShift4i4GoPostalCodePrompt"];
            this.soidShift4GetNewLongTermTokenWhenCardOnFileIsUsed = _data["soidShift4GetNewLongTermTokenWhenCardOnFileIsUsed"];
            this.soidShift4UseI4GoAVS = _data["soidShift4UseI4GoAVS"];
            this.soidShift4i4GoPublicIPServiceURL = _data["soidShift4i4GoPublicIPServiceURL"];
            this.soidTenderRetailProcessor = _data["soidTenderRetailProcessor"];
            this.soidShift4VoidOnTimeOut = _data["soidShift4VoidOnTimeOut"];
            this.soidShift4SendTransactionsInAsyncMode = _data["soidShift4SendTransactionsInAsyncMode"];
            this.soidAirMilesStandardOfferCodes = _data["soidAirMilesStandardOfferCodes"];
            this.soidShift4CreditCardsOnPaymentsOnly = _data["soidShift4CreditCardsOnPaymentsOnly"];
            this.soidTemplateManualOrderLineForAcePromotions = _data["soidTemplateManualOrderLineForAcePromotions"];
            this.soidAceCustomerLoyaltyLevel = _data["soidAceCustomerLoyaltyLevel"];
            this.soidACERewardsWebService = _data["soidACERewardsWebService"];
            this.soidACERewardsWebServiceUsername = _data["soidACERewardsWebServiceUsername"];
            this.soidACERewardsWebServicePassword = _data["soidACERewardsWebServicePassword"];
            this.soidUseDefaultCashCustomerForExistingACERewardsCustomers = _data["soidUseDefaultCashCustomerForExistingACERewardsCustomers"];
            this.soidACERewardsCustomerLookupWebService = _data["soidACERewardsCustomerLookupWebService"];
            this.soidTenderRetailCheckForWinsockErrorAfterSendingPositiveACK = _data["soidTenderRetailCheckForWinsockErrorAfterSendingPositiveACK"];
            this.soidACERewardsVerifyCustomerDetailsWhenRequestedByACE = _data["soidACERewardsVerifyCustomerDetailsWhenRequestedByACE"];
            this.soidEDIAPAutomationProcessTo = _data["soidEDIAPAutomationProcessTo"];
            this.soidShift4i4GoCardholderNamePromptInWebTrack = _data["soidShift4i4GoCardholderNamePromptInWebTrack"];
            this.soidShift4i4GoStreetAddressPromptInWebTrack = _data["soidShift4i4GoStreetAddressPromptInWebTrack"];
            this.soidShift4i4GoPostalCodePromptInWebTrack = _data["soidShift4i4GoPostalCodePromptInWebTrack"];
            this.soidEDIIgnoreBlankOrZeroValuesDuringProductMaintenanceUpdate = _data["soidEDIIgnoreBlankOrZeroValuesDuringProductMaintenanceUpdate"];
            this.soidEDIAttachmentFolderForSOProductImages = _data["soidEDIAttachmentFolderForSOProductImages"];
            this.soidEDIAPAutomationCreateInvoiceWithoutStockReceipt = _data["soidEDIAPAutomationCreateInvoiceWithoutStockReceipt"];
            this.soidGiftCardProductForACETypeXPromotions = _data["soidGiftCardProductForACETypeXPromotions"];
            this.soidSplitIntegratedCardPaymentMethodByTypeOnAccountPayments = _data["soidSplitIntegratedCardPaymentMethodByTypeOnAccountPayments"];
            this.soidEDIAPAutomationCreditNoteAttachmentFolder = _data["soidEDIAPAutomationCreditNoteAttachmentFolder"];
            this.soidWebTrackSecondsToWaitForReportServerToReturnDocument = _data["soidWebTrackSecondsToWaitForReportServerToReturnDocument"];
            this.soidWebTrackShift4i4GoAccountID = _data["soidWebTrackShift4i4GoAccountID"];
            this.soidWebTrackShift4i4GoSiteID = _data["soidWebTrackShift4i4GoSiteID"];
            this.soidWebTrackShift4i4GoPassword = _data["soidWebTrackShift4i4GoPassword"];
            this.soidWebTrackRestrictProdAccessUsingCustWTProdGrps = _data["soidWebTrackRestrictProdAccessUsingCustWTProdGrps"];
            this.soidWebTrackShowLocationWithVehicleTracking = _data["soidWebTrackShowLocationWithVehicleTracking"];
            this.soidOrdersEnableMiTekImportFeatures = _data["soidOrdersEnableMiTekImportFeatures"];
            this.soidOrdersMiTekImportFolder = _data["soidOrdersMiTekImportFolder"];
            this.soidOrdersImportReferenceDestination = _data["soidOrdersImportReferenceDestination"];
            this.soidNewPerMode = _data["soidNewPerMode"];
            this.soidNewTaxMode = _data["soidNewTaxMode"];
            this.soidLastLiveOrderID = _data["soidLastLiveOrderID"];
            this.soidLastLiveSellPriceRuleID = _data["soidLastLiveSellPriceRuleID"];
            this.soidNewReportPrintMode = _data["soidNewReportPrintMode"];
            this.soidNewPriceMode = _data["soidNewPriceMode"];
            this.soidSupplierInvoiceAllowPreEnteredStockReceipts = _data["soidSupplierInvoiceAllowPreEnteredStockReceipts"];
            this.soidEnablePromptForCrystalParameters = _data["soidEnablePromptForCrystalParameters"];
            this.soidUseOrderFilterForSOPSearches = _data["soidUseOrderFilterForSOPSearches"];
            this.soidNewSearchMode = _data["soidNewSearchMode"];
            this.soidDatabaseUpgrading = _data["soidDatabaseUpgrading"];
            this.soidUseInventoryAgingAndCommissionCosts = _data["soidUseInventoryAgingAndCommissionCosts"];
            this.soidEnablePerformanceLogging = _data["soidEnablePerformanceLogging"];
            this.soidPurchasingInputExchangeRateFromBase = _data["soidPurchasingInputExchangeRateFromBase"];
            this.soidUseOldCrystalPrintingMethods = _data["soidUseOldCrystalPrintingMethods"];
            this.soidShowInternalCostOnProductFind = _data["soidShowInternalCostOnProductFind"];
            this.soidAllowSupplierProductReference = _data["soidAllowSupplierProductReference"];
            this.soidEnableScanTrackIntegration = _data["soidEnableScanTrackIntegration"];
            this.soidJourneyPlanningStyle = _data["soidJourneyPlanningStyle"];
            this.soidEnableNewProductFindMode = _data["soidEnableNewProductFindMode"];
            this.soidDisableLicensing = _data["soidDisableLicensing"];
            this.soidDisableRebuildStockOnOrderForReceipt = _data["soidDisableRebuildStockOnOrderForReceipt"];
            this.soidCashDrawerRedirectMessageValidity = _data["soidCashDrawerRedirectMessageValidity"];
            this.soidLastProductGroupEdit = _data["soidLastProductGroupEdit"];
            this.soidLastSortedProductGroupUpdate = _data["soidLastSortedProductGroupUpdate"];
            this.soidAllowBranchLevelPackOptions = _data["soidAllowBranchLevelPackOptions"];
            this.soidUseRecordsetLoadWithNoTransaction = _data["soidUseRecordsetLoadWithNoTransaction"];
            this.soidAllowMemoQuantityInput = _data["soidAllowMemoQuantityInput"];
            this.soidJourneyPlannerAllowDeliveredPOs = _data["soidJourneyPlannerAllowDeliveredPOs"];
            this.soidQuickProductsImage1 = _data["soidQuickProductsImage1"];
            this.soidQuickProductsImage2 = _data["soidQuickProductsImage2"];
            this.soidQuickProductsImage3 = _data["soidQuickProductsImage3"];
            this.soidQuickProductsShowImages = _data["soidQuickProductsShowImages"];
            this.soidAllowAuthorizedBuyerByJob = _data["soidAllowAuthorizedBuyerByJob"];
            this.soidEnablePricingPlanner = _data["soidEnablePricingPlanner"];
            this.soidSystemUpgradeEmailAddress = _data["soidSystemUpgradeEmailAddress"];
            this.soidEnablePriceChecker = _data["soidEnablePriceChecker"];
            this.soidEnableBisTrackCount = _data["soidEnableBisTrackCount"];
            this.soidEnableBisTrackReceipt = _data["soidEnableBisTrackReceipt"];
            this.soidPurchasingCostDebugMode = _data["soidPurchasingCostDebugMode"];
            this.soidAllowTotalStockAdjustmentOfStockByLengthProducts = _data["soidAllowTotalStockAdjustmentOfStockByLengthProducts"];
            this.soidWorksOrderKeepSameCostIfFinishedInSource = _data["soidWorksOrderKeepSameCostIfFinishedInSource"];
            this.soidPermissionDetailLastUpdateVersion = _data["soidPermissionDetailLastUpdateVersion"];
            this.soidAddSettlementDiscAvailToSalesAndProductAnalysisCubes = _data["soidAddSettlementDiscAvailToSalesAndProductAnalysisCubes"];
            this.soidSalesAnalysisCodeForSettlementDiscAvailInSalesAnalysis = _data["soidSalesAnalysisCodeForSettlementDiscAvailInSalesAnalysis"];
            this.soidPurchaseAnalysisType = _data["soidPurchaseAnalysisType"];
            this.soidPurchaseAnalysisDetailStartDate = _data["soidPurchaseAnalysisDetailStartDate"];
            this.soidSalesAnalysisCodeToPostSalesDiscountsToInSalesAnalysis = _data["soidSalesAnalysisCodeToPostSalesDiscountsToInSalesAnalysis"];
            this.soidPostPromotionDiscountAmountsProratedOverProducts = _data["soidPostPromotionDiscountAmountsProratedOverProducts"];
            this.soidReportServer2AgentPollingInterval = _data["soidReportServer2AgentPollingInterval"];
            this.soidReportServer2AgentLoggingLevel = _data["soidReportServer2AgentLoggingLevel"];
            this.soidReportServer2ProcessEmailedDocuments = _data["soidReportServer2ProcessEmailedDocuments"];
            this.soidReportServer2ImageInvoiceFormat = _data["soidReportServer2ImageInvoiceFormat"];
            this.soidReportServer2ImageCreditNoteFormat = _data["soidReportServer2ImageCreditNoteFormat"];
            this.soidReportServer2ImageSalesOrderFormat = _data["soidReportServer2ImageSalesOrderFormat"];
            this.soidReportServer2ImageInvoiceSTDocType = _data["soidReportServer2ImageInvoiceSTDocType"];
            this.soidReportServer2ImageCreditNoteSTDocType = _data["soidReportServer2ImageCreditNoteSTDocType"];
            this.soidReportServer2ImageSalesOrderSTDocType = _data["soidReportServer2ImageSalesOrderSTDocType"];
            this.soidReportServer2ImageReleasedFrom = _data["soidReportServer2ImageReleasedFrom"];
            this.soidReportServer2ImageFileType = _data["soidReportServer2ImageFileType"];
            this.soidReportServer2ImageColourDepth = _data["soidReportServer2ImageColourDepth"];
            this.soidReportServer2ImageDPI = _data["soidReportServer2ImageDPI"];
            this.soidReportServer2ImageJPGQuality = _data["soidReportServer2ImageJPGQuality"];
            this.soidReportServer2ImageTIFCompression = _data["soidReportServer2ImageTIFCompression"];
            this.soidReportServer2ImageTIFMultiPage = _data["soidReportServer2ImageTIFMultiPage"];
            this.soidReportServer2ImageTimeTo = _data["soidReportServer2ImageTimeTo"];
            this.soidReportServer2Timeout = _data["soidReportServer2Timeout"];
            this.soidReportServer2AutoDelInvoiceFormat = _data["soidReportServer2AutoDelInvoiceFormat"];
            this.soidReportServer2AutoDelInvoiceEmailTemplate = _data["soidReportServer2AutoDelInvoiceEmailTemplate"];
            this.soidReportServer2AutoDelCreditNoteFormat = _data["soidReportServer2AutoDelCreditNoteFormat"];
            this.soidReportServer2AutoDelCreditNoteEmailTemplate = _data["soidReportServer2AutoDelCreditNoteEmailTemplate"];
            this.soidReportServer2AutoDelSendTime = _data["soidReportServer2AutoDelSendTime"];
            this.soidReportServer2AutoDelDocumentsSince = _data["soidReportServer2AutoDelDocumentsSince"];
            this.soidReportServer2AutoDeliveryEnabled = _data["soidReportServer2AutoDeliveryEnabled"];
            this.soidDeadProductsCheck = _data["soidDeadProductsCheck"];
            this.soidDeadProductsIncludeTimber = _data["soidDeadProductsIncludeTimber"];
            this.soidDeadProductsLowUsageCount = _data["soidDeadProductsLowUsageCount"];
            this.soidDeadProductsLowReceiptCount = _data["soidDeadProductsLowReceiptCount"];
            this.soidDeadProductsMarkNonStockedIfLowActivityxMonths = _data["soidDeadProductsMarkNonStockedIfLowActivityxMonths"];
            this.soidDeadProductsMarkDeletedIfLowActivityxMonths = _data["soidDeadProductsMarkDeletedIfLowActivityxMonths"];
            this.soidDeadProductsStandardStockOnly = _data["soidDeadProductsStandardStockOnly"];
            this.soidDeadProductsSpecialsDaysAgo = _data["soidDeadProductsSpecialsDaysAgo"];
            this.soidReportServer2AutoDelCashInvoiceFormat = _data["soidReportServer2AutoDelCashInvoiceFormat"];
            this.soidReportServer2AutoDelCashRefundFormat = _data["soidReportServer2AutoDelCashRefundFormat"];
            this.soidReportServer2NotificationDeliveryInProgressEmailTemplate = _data["soidReportServer2NotificationDeliveryInProgressEmailTemplate"];
            this.soidReportServer2NotificationDeliveryInProgressFormat = _data["soidReportServer2NotificationDeliveryInProgressFormat"];
            this.soidReportServer2NotificationOrderDeliveredEmailTemplate = _data["soidReportServer2NotificationOrderDeliveredEmailTemplate"];
            this.soidReportServer2NotificationOrderDeliveredFormat = _data["soidReportServer2NotificationOrderDeliveredFormat"];
            this.soidReportServer2NotificationDeliveryETAEmailTemplate = _data["soidReportServer2NotificationDeliveryETAEmailTemplate"];
            this.soidReportServer2NotificationDeliveryETAFormat = _data["soidReportServer2NotificationDeliveryETAFormat"];
            this.soidCRMEventsQuoteAcceptEnable = _data["soidCRMEventsQuoteAcceptEnable"];
            this.soidCRMEventsQuoteRejectEnable = _data["soidCRMEventsQuoteRejectEnable"];
            this.soidCRMEventsEmailSentEnable = _data["soidCRMEventsEmailSentEnable"];
            this.soidCRMEventsLetterWrittenEnable = _data["soidCRMEventsLetterWrittenEnable"];
            this.soidCRMEventsOrderCreditHoldOnEnable = _data["soidCRMEventsOrderCreditHoldOnEnable"];
            this.soidCRMEventsOrderCreditHoldOffEnable = _data["soidCRMEventsOrderCreditHoldOffEnable"];
            this.soidCRMEventsAccountOnHoldEnable = _data["soidCRMEventsAccountOnHoldEnable"];
            this.soidCRMEventsAccountOffHoldEnable = _data["soidCRMEventsAccountOffHoldEnable"];
            this.soidCRMCalendarDayStart = _data["soidCRMCalendarDayStart"];
            this.soidCRMCalendarDayEnd = _data["soidCRMCalendarDayEnd"];
            this.soidCRMCalendarTimeInterval = _data["soidCRMCalendarTimeInterval"];
            this.soidCRMCalendarFollowUpDuration = _data["soidCRMCalendarFollowUpDuration"];
            this.soidCRMCampaignsDefaultNotepadType = _data["soidCRMCampaignsDefaultNotepadType"];
            this.soidCRMEventsCampaignActionComplete = _data["soidCRMEventsCampaignActionComplete"];
            this.soidItemMessageCreationSubject = _data["soidItemMessageCreationSubject"];
            this.soidItemMessageCreationBody = _data["soidItemMessageCreationBody"];
            this.soidItemMessageClosureSubject = _data["soidItemMessageClosureSubject"];
            this.soidItemMessageClosureBody = _data["soidItemMessageClosureBody"];
            this.soidItemMessageNotificationSubject = _data["soidItemMessageNotificationSubject"];
            this.soidItemMessageNotificationBody = _data["soidItemMessageNotificationBody"];
            this.soidItemDevSignOffPrompt1 = _data["soidItemDevSignOffPrompt1"];
            this.soidItemDevSignOffPrompt2 = _data["soidItemDevSignOffPrompt2"];
            this.soidItemDefaultTesterID = _data["soidItemDefaultTesterID"];
            this.soidItemDefaultTesterName = _data["soidItemDefaultTesterName"];
            this.soidItemDefaultTesterTypeOfWorkID = _data["soidItemDefaultTesterTypeOfWorkID"];
            this.soidItemDefaultTestAnalysisCodeID = _data["soidItemDefaultTestAnalysisCodeID"];
            this.soidItemForceProjectEntry = _data["soidItemForceProjectEntry"];
            this.soidItemNotesForNonDevItems = _data["soidItemNotesForNonDevItems"];
            this.soidItemGenerateCustomerSpecificeItemReferences = _data["soidItemGenerateCustomerSpecificeItemReferences"];
            this.soidItemUseBillToItems = _data["soidItemUseBillToItems"];
            this.soidItemLockTimeTransactionsPreviousToThisDate = _data["soidItemLockTimeTransactionsPreviousToThisDate"];
            this.soidItemPreventAddEditOfTimeOnClosedCancelledItems = _data["soidItemPreventAddEditOfTimeOnClosedCancelledItems"];
            this.soidSTServerFolder = _data["soidSTServerFolder"];
            this.soidItemAllowEntryOfSeparateChargeableTime = _data["soidItemAllowEntryOfSeparateChargeableTime"];
            this.soidItemAllowTimeSheetWeekApproval = _data["soidItemAllowTimeSheetWeekApproval"];
            this.soidItemNonDevVersionOptional = _data["soidItemNonDevVersionOptional"];
            this.soidItemNonDevDefaultPriority = _data["soidItemNonDevDefaultPriority"];
            this.soidItemLockChargingInfoBeforeThisDate = _data["soidItemLockChargingInfoBeforeThisDate"];
            this.soidItemUseProjectInvoiceApproval = _data["soidItemUseProjectInvoiceApproval"];
            this.soidEmailServer = _data["soidEmailServer"];
            this.soidEmailUsername = _data["soidEmailUsername"];
            this.soidEmailPassword = _data["soidEmailPassword"];
            this.soidEmailSenderAddress = _data["soidEmailSenderAddress"];
            this.soidEmailPort = _data["soidEmailPort"];
            this.soidEmailUseSMTPDefaultAsFromAddress = _data["soidEmailUseSMTPDefaultAsFromAddress"];
            this.soidEmailUseSMTPDefaultAsSenderAddress = _data["soidEmailUseSMTPDefaultAsSenderAddress"];
            this.soidEmailUseSMTPReplyToAddress = _data["soidEmailUseSMTPReplyToAddress"];
            this.soidEmailEncryption = _data["soidEmailEncryption"];
            this.soidInstantReleaseKey = _data["soidInstantReleaseKey"];
            this.soidCloudQuoteDocumentFormatNumber = _data["soidCloudQuoteDocumentFormatNumber"];
            this.soidCloudTemplateOrderDocumentFormatNumber = _data["soidCloudTemplateOrderDocumentFormatNumber"];
            this.soidCloudCallOffOrderDocumentFormatNumber = _data["soidCloudCallOffOrderDocumentFormatNumber"];
            this.soidCloudSalesOrderDocumentFormatNumber = _data["soidCloudSalesOrderDocumentFormatNumber"];
            this.soidCloudInvoiceDocumentFormatNumber = _data["soidCloudInvoiceDocumentFormatNumber"];
            this.soidCloudCreditNoteDocumentFormatNumber = _data["soidCloudCreditNoteDocumentFormatNumber"];
            this.soidCloudPurchaseOrderDocumentFormatNumber = _data["soidCloudPurchaseOrderDocumentFormatNumber"];
            this.soidCloudTransferDocumentFormatNumber = _data["soidCloudTransferDocumentFormatNumber"];
            this.soidCloudWorkOrderDocumentFormatNumber = _data["soidCloudWorkOrderDocumentFormatNumber"];
            this.soidCrystalUsePrintLayoutSettings = _data["soidCrystalUsePrintLayoutSettings"];
            this.soidCrystalUseRAS = _data["soidCrystalUseRAS"];
            this.soidCrystalUseThreading = _data["soidCrystalUseThreading"];
            this.soidCrystalThreadingTimeout = _data["soidCrystalThreadingTimeout"];
            this.soidEnableCTI = _data["soidEnableCTI"];
            this.soidOIGServerAddress = _data["soidOIGServerAddress"];
            this.soidOIGIcpIPAddress = _data["soidOIGIcpIPAddress"];
            this.soidOIGEventHandlerURL = _data["soidOIGEventHandlerURL"];
            this.soidOIGApplicationName = _data["soidOIGApplicationName"];
            this.soidOIGApplicationPassword = _data["soidOIGApplicationPassword"];
            this.soidOIGCompanyName = _data["soidOIGCompanyName"];
            this.soidOIGLocalPassword = _data["soidOIGLocalPassword"];
            this.soidCTIProvider = _data["soidCTIProvider"];
            this.soidCTICustomerDashboard = _data["soidCTICustomerDashboard"];
            this.soidCTISupplierDashboard = _data["soidCTISupplierDashboard"];
            this.soidCTIUserDashboard = _data["soidCTIUserDashboard"];
            this.soidCTICustomerDashboardDefault = _data["soidCTICustomerDashboardDefault"];
            this.soidCTISupplierDashboardDefault = _data["soidCTISupplierDashboardDefault"];
            this.soidCTIUserDashboardDefault = _data["soidCTIUserDashboardDefault"];
            this.soidGrahamsDemo = _data["soidGrahamsDemo"];
            this.soidSuppliersEnablePermissionsByTab = _data["soidSuppliersEnablePermissionsByTab"];
            this.soidDefaultOrderSingleLengthTalliedLumberQuantityToZero = _data["soidDefaultOrderSingleLengthTalliedLumberQuantityToZero"];
            this.soidOnlyUseReplacementProductWhenNoStock = _data["soidOnlyUseReplacementProductWhenNoStock"];
            this.soidAllowStockInformationForBranchesWithoutReadAccess = _data["soidAllowStockInformationForBranchesWithoutReadAccess"];
            this.soidLimitProductAddToQtyOnlyMethodOnTransfers = _data["soidLimitProductAddToQtyOnlyMethodOnTransfers"];
            this.soidBranchAccessLevelRequiredForIssuingBranch = _data["soidBranchAccessLevelRequiredForIssuingBranch"];
            this.soidEnableWMSProcessing = _data["soidEnableWMSProcessing"];
            this.soidDefaultCollectLaterWMSPickingStatus = _data["soidDefaultCollectLaterWMSPickingStatus"];
            this.soidWMSOutgoingGenerationInProgress = _data["soidWMSOutgoingGenerationInProgress"];
            this.soidEDIPurgeWMSDocumentDays = _data["soidEDIPurgeWMSDocumentDays"];
            this.soidConsolidateLineNotesOnSOConsolidate = _data["soidConsolidateLineNotesOnSOConsolidate"];
            this.soidDefaultExcludeSpecialsOnPricingOption = _data["soidDefaultExcludeSpecialsOnPricingOption"];
            this.soidTranferLimitToFinalCostWhenNoReadAccessToSendingBranch = _data["soidTranferLimitToFinalCostWhenNoReadAccessToSendingBranch"];
            this.soidDisplayProductPopupOnQuoteAcceptanceAndSalesCopy = _data["soidDisplayProductPopupOnQuoteAcceptanceAndSalesCopy"];
            this.soidEnableWMSBackWorksOrders = _data["soidEnableWMSBackWorksOrders"];
            this.soidEnableWMSDocumentPrinting = _data["soidEnableWMSDocumentPrinting"];
            this.soidWorksOrderDefaultWMSType = _data["soidWorksOrderDefaultWMSType"];
            this.soidUpdateSpecialProductDescriptionWithOrderLineDescription = _data["soidUpdateSpecialProductDescriptionWithOrderLineDescription"];
            this.soidCashSalesRequireFullPaymentForCollectLaterNowCompletion = _data["soidCashSalesRequireFullPaymentForCollectLaterNowCompletion"];
            this.soidDefaultOrderLineAmendReasonForWMSSubstitution = _data["soidDefaultOrderLineAmendReasonForWMSSubstitution"];
            this.soidWMSSubstitutionRecalculatePrice = _data["soidWMSSubstitutionRecalculatePrice"];
            this.soidDisplaySuccessfulConfirmationPopUps = _data["soidDisplaySuccessfulConfirmationPopUps"];
            this.soidConfirmContractSelectionOnSalesOrderCompletion = _data["soidConfirmContractSelectionOnSalesOrderCompletion"];
            this.soidWMSSendReleasedNotProcessedCreditNoteQuantityInQuantitySync = _data["soidWMSSendReleasedNotProcessedCreditNoteQuantityInQuantitySync"];
            this.soidEnableWMSBackTransfers = _data["soidEnableWMSBackTransfers"];
            this.soidEnablePurchaseOrderExcludeFromWMS = _data["soidEnablePurchaseOrderExcludeFromWMS"];
            this.soidWMSDoNotSentOrderLineInternalNotes = _data["soidWMSDoNotSentOrderLineInternalNotes"];
            this.soidWMSTimberTalliedProductsMustBeSingleLength = _data["soidWMSTimberTalliedProductsMustBeSingleLength"];
            this.soidWMSOrderHeaderLicensePlateUDF = _data["soidWMSOrderHeaderLicensePlateUDF"];
            this.soidShowCubeMeasures = _data["soidShowCubeMeasures"];
            this.soidDefaultPricingOptionsToPriceProfiles = _data["soidDefaultPricingOptionsToPriceProfiles"];
            this.soidUseNewSalesOrderEntryForm = _data["soidUseNewSalesOrderEntryForm"];
            this.soidWorksOrderSendMachineGroupToWMS = _data["soidWorksOrderSendMachineGroupToWMS"];
            this.soidOrdersSendJourneyReferenceToWMS = _data["soidOrdersSendJourneyReferenceToWMS"];
            this.soidReleaseOrdersForPickingToWMSDaysInAdvance = _data["soidReleaseOrdersForPickingToWMSDaysInAdvance"];
            this.soidWorksOrderRequireReleaseForManufactureInWMS = _data["soidWorksOrderRequireReleaseForManufactureInWMS"];
            this.soidReleaseWorksOrdersForManufactureToWMSDaysInAdvance = _data["soidReleaseWorksOrdersForManufactureToWMSDaysInAdvance"];
            this.soidGenerateWorkOrdersForIncomingSalesOrders = _data["soidGenerateWorkOrdersForIncomingSalesOrders"];
            this.soidWMSJourneyReferenceLength = _data["soidWMSJourneyReferenceLength"];
            this.soidWMSSendShipCompleteTagForSalesOrders = _data["soidWMSSendShipCompleteTagForSalesOrders"];
            this.soidDefaultSalesRepOnTransactionsToTakenByLinkedSalesRep = _data["soidDefaultSalesRepOnTransactionsToTakenByLinkedSalesRep"];
            this.soidWMSEnableASNTransactions = _data["soidWMSEnableASNTransactions"];
        }
    }

    static fromJS(data: any): SystemOptions {
        data = typeof data === 'object' ? data : {};
        let result = new SystemOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["soidPickingZoneFormatNumber"] = this.soidPickingZoneFormatNumber;
        data["soidServerFolder"] = this.soidServerFolder;
        data["soidAllowBlankPasswords"] = this.soidAllowBlankPasswords;
        data["soidMaximumProductGroupLevels"] = this.soidMaximumProductGroupLevels;
        data["soidCubeServerFolder"] = this.soidCubeServerFolder;
        data["soidHTMLServerFolder"] = this.soidHTMLServerFolder;
        data["soidReportServerFolder"] = this.soidReportServerFolder;
        data["soidTemplateServerFolder"] = this.soidTemplateServerFolder;
        data["soidTerminalServers"] = this.soidTerminalServers;
        data["soidDefaultLabelPrinter"] = this.soidDefaultLabelPrinter;
        data["soidAllowBackToBacks"] = this.soidAllowBackToBacks;
        data["soidNoOfDocumentFormats"] = this.soidNoOfDocumentFormats;
        data["soidShowDetailedPrinterDialogForLabels"] = this.soidShowDetailedPrinterDialogForLabels;
        data["soidDefaultCountry"] = this.soidDefaultCountry;
        data["soidOrderNumberIncrement"] = this.soidOrderNumberIncrement;
        data["soidCompanyName"] = this.soidCompanyName;
        data["soidCompanyAddress"] = this.soidCompanyAddress;
        data["soidCompanyRegistrationNumber"] = this.soidCompanyRegistrationNumber;
        data["soidVATRegistrationNumber"] = this.soidVATRegistrationNumber;
        data["soidCompanyCatalogueURL"] = this.soidCompanyCatalogueURL;
        data["soidCompanyCatalogueName"] = this.soidCompanyCatalogueName;
        data["soidVATValidationURL"] = this.soidVATValidationURL;
        data["soidLongRunningProceduresTimeout"] = this.soidLongRunningProceduresTimeout;
        data["soidStandardSQLQueryTimeout"] = this.soidStandardSQLQueryTimeout;
        data["soidUseReadUnCommittedTransactionIsolationLevel"] = this.soidUseReadUnCommittedTransactionIsolationLevel;
        data["soidCrystalReportsVersion"] = this.soidCrystalReportsVersion;
        data["soidReportServerVersion"] = this.soidReportServerVersion;
        data["soidCrystalReportsAllowIntegratedSecurity"] = this.soidCrystalReportsAllowIntegratedSecurity;
        data["soidSQLReportsServerURL"] = this.soidSQLReportsServerURL;
        data["soidSQLReportsBuilderVersion"] = this.soidSQLReportsBuilderVersion;
        data["soidSQLReportsServerVersion"] = this.soidSQLReportsServerVersion;
        data["soidSQLReportsViewerVersion"] = this.soidSQLReportsViewerVersion;
        data["soidBaseCurrency"] = this.soidBaseCurrency;
        data["soidAlternativeCurrency"] = this.soidAlternativeCurrency;
        data["soidDefaultVatRate"] = this.soidDefaultVatRate;
        data["soidDefaultCashCustomer"] = this.soidDefaultCashCustomer;
        data["soidConsolidateLines"] = this.soidConsolidateLines;
        data["soidVatRuleForDeliveryCharge"] = this.soidVatRuleForDeliveryCharge;
        data["soidMaximumDimensions"] = this.soidMaximumDimensions;
        data["soidAllowSetCustomerOnHold"] = this.soidAllowSetCustomerOnHold;
        data["soidDueDateGraceDays"] = this.soidDueDateGraceDays;
        data["soidIgnoreSmallBalancesUpTo"] = this.soidIgnoreSmallBalancesUpTo;
        data["soidOverdueBalanceChecking"] = this.soidOverdueBalanceChecking;
        data["soidCreditControlDisableCreditLimitChecksOnOrders"] = this.soidCreditControlDisableCreditLimitChecksOnOrders;
        data["soidCreditControlAllowCashOnCreditHold"] = this.soidCreditControlAllowCashOnCreditHold;
        data["soidCreditControlAllowInstantCreditRelease"] = this.soidCreditControlAllowInstantCreditRelease;
        data["soidCreditControlPromptForOriginalComputer"] = this.soidCreditControlPromptForOriginalComputer;
        data["soidCreditControlAllowCashAccountBalances"] = this.soidCreditControlAllowCashAccountBalances;
        data["soidCreditControlOrderChangeTolerance"] = this.soidCreditControlOrderChangeTolerance;
        data["soidCreditControlDisableCreditLimitChecksOnOrderAmend"] = this.soidCreditControlDisableCreditLimitChecksOnOrderAmend;
        data["soidAllowGreatPlainsMessages"] = this.soidAllowGreatPlainsMessages;
        data["soidCreditControlExcludePreviouslyReleasedOrdersFromCheck"] = this.soidCreditControlExcludePreviouslyReleasedOrdersFromCheck;
        data["soidCreditControlDisableCreditChecksOnReleasedBackOrders"] = this.soidCreditControlDisableCreditChecksOnReleasedBackOrders;
        data["soidCreditControlUseARCustomerForOrderCreditApproval"] = this.soidCreditControlUseARCustomerForOrderCreditApproval;
        data["soidCreditControlMaximumSalesOrderValueAmount"] = this.soidCreditControlMaximumSalesOrderValueAmount;
        data["soidCreditControlMaximumSalesOrderPercentage"] = this.soidCreditControlMaximumSalesOrderPercentage;
        data["soidCreditControlCreditLimitExtensionPercentage"] = this.soidCreditControlCreditLimitExtensionPercentage;
        data["soidCreditControlCreditHoldThresholdAmount"] = this.soidCreditControlCreditHoldThresholdAmount;
        data["soidCreditControlAllowPaymentOnAccountOnCreditHold"] = this.soidCreditControlAllowPaymentOnAccountOnCreditHold;
        data["soidCreditControlMarginHoldOrderChangeTolerance"] = this.soidCreditControlMarginHoldOrderChangeTolerance;
        data["soidCustomerFullSyncJobName"] = this.soidCustomerFullSyncJobName;
        data["soidCustomerPartialSyncJobName"] = this.soidCustomerPartialSyncJobName;
        data["soidSupplierFullSyncJobName"] = this.soidSupplierFullSyncJobName;
        data["soidSupplierPartialSyncJobName"] = this.soidSupplierPartialSyncJobName;
        data["soidCreditControlPrintDocsAwaitingCustomerApproval"] = this.soidCreditControlPrintDocsAwaitingCustomerApproval;
        data["soidDynamicsDatabase"] = this.soidDynamicsDatabase;
        data["soidDynamicsServer"] = this.soidDynamicsServer;
        data["soidDynamicsUserID"] = this.soidDynamicsUserID;
        data["soidFinancialInterfaceFolder"] = this.soidFinancialInterfaceFolder;
        data["soidFinancialInterfaceVersion"] = this.soidFinancialInterfaceVersion;
        data["soidNavisionCompanyName"] = this.soidNavisionCompanyName;
        data["soidNavisionServer"] = this.soidNavisionServer;
        data["soidNavisionDatabase"] = this.soidNavisionDatabase;
        data["soidNavisionNTAuthentication"] = this.soidNavisionNTAuthentication;
        data["soidNavisionUserID"] = this.soidNavisionUserID;
        data["soidNavisionShowCFRONTErrors"] = this.soidNavisionShowCFRONTErrors;
        data["soidNavisionNetType"] = this.soidNavisionNetType;
        data["soidSendDebitNotes"] = this.soidSendDebitNotes;
        data["soidSendDebitNotesOnHold"] = this.soidSendDebitNotesOnHold;
        data["soidAutoApplyCreditNotes"] = this.soidAutoApplyCreditNotes;
        data["soidUseNAVAgent"] = this.soidUseNAVAgent;
        data["soidAgentGenerateXMLOnly"] = this.soidAgentGenerateXMLOnly;
        data["soidDisallowReExport"] = this.soidDisallowReExport;
        data["soidSendDebitNoteAmount"] = this.soidSendDebitNoteAmount;
        data["soidNavisionPostingGroupSales"] = this.soidNavisionPostingGroupSales;
        data["soidNavisionPostingGroupPurch"] = this.soidNavisionPostingGroupPurch;
        data["soidNAVUseSeparateBatches"] = this.soidNAVUseSeparateBatches;
        data["soidUseNAVCache"] = this.soidUseNAVCache;
        data["soidNAVCacheDatabaseName"] = this.soidNAVCacheDatabaseName;
        data["soidCreditControlCustomerReferencePutOrdersOnHold"] = this.soidCreditControlCustomerReferencePutOrdersOnHold;
        data["soidCalculateJobCreditLimitFromCustomerReferencePurchaseOrderAmounts"] = this.soidCalculateJobCreditLimitFromCustomerReferencePurchaseOrderAmounts;
        data["soidCalculatedJobCreditLimitExtensionPercentage"] = this.soidCalculatedJobCreditLimitExtensionPercentage;
        data["soidCalculateInvoiceDueAndDiscountDatesFromDeliveryDate"] = this.soidCalculateInvoiceDueAndDiscountDatesFromDeliveryDate;
        data["soidCustomerAgedDebt1"] = this.soidCustomerAgedDebt1;
        data["soidCustomerAgedDebt2"] = this.soidCustomerAgedDebt2;
        data["soidCustomerAgedDebt3"] = this.soidCustomerAgedDebt3;
        data["soidCustomerAgedDebt4"] = this.soidCustomerAgedDebt4;
        data["soidCustomerAgedDebt5"] = this.soidCustomerAgedDebt5;
        data["soidCustomerAgedDebt6"] = this.soidCustomerAgedDebt6;
        data["soidCustomerAgedDebt7"] = this.soidCustomerAgedDebt7;
        data["soidSupplierAgedDebt1"] = this.soidSupplierAgedDebt1;
        data["soidSupplierAgedDebt2"] = this.soidSupplierAgedDebt2;
        data["soidSupplierAgedDebt3"] = this.soidSupplierAgedDebt3;
        data["soidSupplierAgedDebt4"] = this.soidSupplierAgedDebt4;
        data["soidSupplierAgedDebt5"] = this.soidSupplierAgedDebt5;
        data["soidSupplierAgedDebt6"] = this.soidSupplierAgedDebt6;
        data["soidSupplierAgedDebt7"] = this.soidSupplierAgedDebt7;
        data["soidGreatPlainsMessageQueue"] = this.soidGreatPlainsMessageQueue;
        data["soidGreatPlainsMessageServer"] = this.soidGreatPlainsMessageServer;
        data["soidGreatPlainsPollInterval"] = this.soidGreatPlainsPollInterval;
        data["soidGreatPlainsLoggingLevel"] = this.soidGreatPlainsLoggingLevel;
        data["soidGreatPlainsCompanyID"] = this.soidGreatPlainsCompanyID;
        data["soidGreatPlainsServer"] = this.soidGreatPlainsServer;
        data["soidGreatPlainseConnectServer"] = this.soidGreatPlainseConnectServer;
        data["soidBankAccountCash"] = this.soidBankAccountCash;
        data["soidBankAccountCheque"] = this.soidBankAccountCheque;
        data["soidBankAccountCreditCard"] = this.soidBankAccountCreditCard;
        data["soidGreatPlainsOutputTo"] = this.soidGreatPlainsOutputTo;
        data["soidGreatPlainsARPathFile"] = this.soidGreatPlainsARPathFile;
        data["soidGreatPlainsAPPathFile"] = this.soidGreatPlainsAPPathFile;
        data["soidGreatPlainsbisTrackServiceServer"] = this.soidGreatPlainsbisTrackServiceServer;
        data["soidSalesGLRuleTaxSales"] = this.soidSalesGLRuleTaxSales;
        data["soidWriteOffGLRule"] = this.soidWriteOffGLRule;
        data["soidFinanceChargeGLRule"] = this.soidFinanceChargeGLRule;
        data["soidNSFChargeGLRule"] = this.soidNSFChargeGLRule;
        data["soidCashGLCode"] = this.soidCashGLCode;
        data["soidChequeGLCode"] = this.soidChequeGLCode;
        data["soidCreditCardGLCode"] = this.soidCreditCardGLCode;
        data["soidGreatPlainsGLPathFile"] = this.soidGreatPlainsGLPathFile;
        data["soidSalesDisableTaxSalesGLRule"] = this.soidSalesDisableTaxSalesGLRule;
        data["soidGPDirectUsername"] = this.soidGPDirectUsername;
        data["soidGPDirectPassword"] = this.soidGPDirectPassword;
        data["soidExtendedNumberFormat"] = this.soidExtendedNumberFormat;
        data["soidCreateGLTransactionsStockReceipts"] = this.soidCreateGLTransactionsStockReceipts;
        data["soidCreateGLTransactionsStockAdjustment"] = this.soidCreateGLTransactionsStockAdjustment;
        data["soidFinancialDepositControl"] = this.soidFinancialDepositControl;
        data["soidFinancialUnallocatedCashControl"] = this.soidFinancialUnallocatedCashControl;
        data["soidFinancialDepositVatPosting"] = this.soidFinancialDepositVatPosting;
        data["soidFinancialUnallocatedVatPosting"] = this.soidFinancialUnallocatedVatPosting;
        data["soidbTAAccountCodeMask"] = this.soidbTAAccountCodeMask;
        data["soidbTAApplyLateCharges"] = this.soidbTAApplyLateCharges;
        data["soidbTAMinLatePaymentCharge"] = this.soidbTAMinLatePaymentCharge;
        data["soidbTAAutoWOThreshold"] = this.soidbTAAutoWOThreshold;
        data["soidbTALapsedAccountMonths"] = this.soidbTALapsedAccountMonths;
        data["soidbTAInactiveAccountMonths"] = this.soidbTAInactiveAccountMonths;
        data["soidbTADeletedAccountMonths"] = this.soidbTADeletedAccountMonths;
        data["soidbTACustomerAgedBalanceMethod"] = this.soidbTACustomerAgedBalanceMethod;
        data["soidbTACustomerApplicationInProcess"] = this.soidbTACustomerApplicationInProcess;
        data["soidbTACustomerStatementReportName"] = this.soidbTACustomerStatementReportName;
        data["soidbTACustomerInterimStatementReportName"] = this.soidbTACustomerInterimStatementReportName;
        data["soidbTAGeneralContractorInfoRequired"] = this.soidbTAGeneralContractorInfoRequired;
        data["soidbTACustomerStatementStyle"] = this.soidbTACustomerStatementStyle;
        data["soidbTAStatementScannedDocTypeForCollect"] = this.soidbTAStatementScannedDocTypeForCollect;
        data["soidbTAStatementScannedDocTypeForDelivered"] = this.soidbTAStatementScannedDocTypeForDelivered;
        data["soidbTAStatementSendIntervalInSeconds"] = this.soidbTAStatementSendIntervalInSeconds;
        data["soidbTAStatementEmailBodyText"] = this.soidbTAStatementEmailBodyText;
        data["soidbTASettDiscToFullAmountWhenMatching"] = this.soidbTASettDiscToFullAmountWhenMatching;
        data["soidbTAARBy"] = this.soidbTAARBy;
        data["soidbTAStatementScanTrackImagesOnly"] = this.soidbTAStatementScanTrackImagesOnly;
        data["soidTransferGLRuleInbound"] = this.soidTransferGLRuleInbound;
        data["soidTransferGLRuleOutbound"] = this.soidTransferGLRuleOutbound;
        data["soidTransferGLRuleInTransit"] = this.soidTransferGLRuleInTransit;
        data["soidTransferGLRuleUpliftCalculated"] = this.soidTransferGLRuleUpliftCalculated;
        data["soidTransferGLRuleUpliftInput"] = this.soidTransferGLRuleUpliftInput;
        data["soidTransferGLRuleTransferProfit"] = this.soidTransferGLRuleTransferProfit;
        data["soidGenericXMLARPathFileName"] = this.soidGenericXMLARPathFileName;
        data["soidGenericXMLAPPathFileName"] = this.soidGenericXMLAPPathFileName;
        data["soidGenericXMLGLPathFileName"] = this.soidGenericXMLGLPathFileName;
        data["soidbTAStatementScannedDocTypeForInvoice"] = this.soidbTAStatementScannedDocTypeForInvoice;
        data["soidbTAStatementScannedDocTypeForCredit"] = this.soidbTAStatementScannedDocTypeForCredit;
        data["soidbTAStatementImagesDefaultReportName"] = this.soidbTAStatementImagesDefaultReportName;
        data["soidbTAStatementImages1upReportName"] = this.soidbTAStatementImages1upReportName;
        data["soidbTAStatementImages2upReportName"] = this.soidbTAStatementImages2upReportName;
        data["soidbTAStatementImages4upReportName"] = this.soidbTAStatementImages4upReportName;
        data["soidbTAPostARGrossAndDiscountAtTimeOfSale"] = this.soidbTAPostARGrossAndDiscountAtTimeOfSale;
        data["soidbTACustomerAgedBalancePeriodStyle"] = this.soidbTACustomerAgedBalancePeriodStyle;
        data["soidbTAAllowDifferentARCustomerOnCustomerAddress"] = this.soidbTAAllowDifferentARCustomerOnCustomerAddress;
        data["soidbTAAllowAccountsPaymentOnJobAddress"] = this.soidbTAAllowAccountsPaymentOnJobAddress;
        data["soidbTAAllowEntryOfCustomerRemittanceAdvice"] = this.soidbTAAllowEntryOfCustomerRemittanceAdvice;
        data["soidbTACompareByAccountInFES"] = this.soidbTACompareByAccountInFES;
        data["soidbtaUseBranchAccessInAccounts"] = this.soidbtaUseBranchAccessInAccounts;
        data["soidbTAEmailBodyTextForStatementNotification"] = this.soidbTAEmailBodyTextForStatementNotification;
        data["soidbTAIgnoreDiscountDueDateWhenMatchingCreditNotes"] = this.soidbTAIgnoreDiscountDueDateWhenMatchingCreditNotes;
        data["soidbTAUseExpectedDetailsCheckingWithBatchCash"] = this.soidbTAUseExpectedDetailsCheckingWithBatchCash;
        data["soidbTACustomerAgeCreditNotes"] = this.soidbTACustomerAgeCreditNotes;
        data["soidbTACustomerAgeUnappliedCash"] = this.soidbTACustomerAgeUnappliedCash;
        data["soidbTAMatchingNewCustomerResetOptions"] = this.soidbTAMatchingNewCustomerResetOptions;
        data["soidbTADefaultNewCreditCustomerToOperationalStatus"] = this.soidbTADefaultNewCreditCustomerToOperationalStatus;
        data["soidDefaultOrderToCashCustomer"] = this.soidDefaultOrderToCashCustomer;
        data["soidDefaultOrderSaleType"] = this.soidDefaultOrderSaleType;
        data["soidDefaultOrderPlacementType"] = this.soidDefaultOrderPlacementType;
        data["soidDefaultManualOrderLineType"] = this.soidDefaultManualOrderLineType;
        data["soidDefaultOrderTestCertOption"] = this.soidDefaultOrderTestCertOption;
        data["soidDefaultShowAVOsInUnitPrice"] = this.soidDefaultShowAVOsInUnitPrice;
        data["soidPrintDocumentReleaseDelay"] = this.soidPrintDocumentReleaseDelay;
        data["soidPrintDocumentReleaseConfirm"] = this.soidPrintDocumentReleaseConfirm;
        data["soidDefaultPrintFinalDocOnInvoiceAndCreditRelease"] = this.soidDefaultPrintFinalDocOnInvoiceAndCreditRelease;
        data["soidAllowCashOnDelivery"] = this.soidAllowCashOnDelivery;
        data["soidStaffNumberTimeout"] = this.soidStaffNumberTimeout;
        data["soidDefaultOrdersToNegotiation"] = this.soidDefaultOrdersToNegotiation;
        data["soidDefaultOrderQuantityToZero"] = this.soidDefaultOrderQuantityToZero;
        data["soidPrintOrderOnCashSales"] = this.soidPrintOrderOnCashSales;
        data["soidPurchaseFromOrderRequiredDays"] = this.soidPurchaseFromOrderRequiredDays;
        data["soidUseActualSizesForTimberCosts"] = this.soidUseActualSizesForTimberCosts;
        data["soidWarnIfDateRequiredNotChanged"] = this.soidWarnIfDateRequiredNotChanged;
        data["soidWarnIfDeliveryAddressNotChanged"] = this.soidWarnIfDeliveryAddressNotChanged;
        data["soidCheckForExistingQuotes"] = this.soidCheckForExistingQuotes;
        data["soidPurchaseOrderNumberDisplayFormat"] = this.soidPurchaseOrderNumberDisplayFormat;
        data["soidStockReceiptNumberDisplayFormat"] = this.soidStockReceiptNumberDisplayFormat;
        data["soidOrderNumberDisplayFormat"] = this.soidOrderNumberDisplayFormat;
        data["soidPickingNoteNumberDisplayFormat"] = this.soidPickingNoteNumberDisplayFormat;
        data["soidSubContractNumberDisplayFormat"] = this.soidSubContractNumberDisplayFormat;
        data["soidDeliveryNoteNumberDisplayFormat"] = this.soidDeliveryNoteNumberDisplayFormat;
        data["soidInvoiceNumberDisplayFormat"] = this.soidInvoiceNumberDisplayFormat;
        data["soidCreditNoteNumberDisplayFormat"] = this.soidCreditNoteNumberDisplayFormat;
        data["soidCuttingOperationNumberDisplayFormat"] = this.soidCuttingOperationNumberDisplayFormat;
        data["soidWorksOrderNumberDisplayFormat"] = this.soidWorksOrderNumberDisplayFormat;
        data["soidSupplierInvoiceNumberDisplayFormat"] = this.soidSupplierInvoiceNumberDisplayFormat;
        data["soidDebitNoteNumberDisplayFormat"] = this.soidDebitNoteNumberDisplayFormat;
        data["soidSupplierCreditNoteNumberDisplayFormat"] = this.soidSupplierCreditNoteNumberDisplayFormat;
        data["soidCustomerReturnNumberDisplayFormat"] = this.soidCustomerReturnNumberDisplayFormat;
        data["soidJourneyManifestNumberDisplayFormat"] = this.soidJourneyManifestNumberDisplayFormat;
        data["soidStockWarningCollectedAlwaysProceed"] = this.soidStockWarningCollectedAlwaysProceed;
        data["soidStockWarningNonCollectedAlwaysBackOrder"] = this.soidStockWarningNonCollectedAlwaysBackOrder;
        data["soidStockWarningDefaultToProceed"] = this.soidStockWarningDefaultToProceed;
        data["soidSupplierReturnNumberDisplayFormat"] = this.soidSupplierReturnNumberDisplayFormat;
        data["soidCostAdjustmentNumberDisplayFormat"] = this.soidCostAdjustmentNumberDisplayFormat;
        data["soidDropDownListThreshold"] = this.soidDropDownListThreshold;
        data["soidDefaultProductTypeSearch"] = this.soidDefaultProductTypeSearch;
        data["soidFindFromAvailableStock"] = this.soidFindFromAvailableStock;
        data["soidSearchPageSize"] = this.soidSearchPageSize;
        data["soidReturnOwnBrandProductsFirst"] = this.soidReturnOwnBrandProductsFirst;
        data["soidPriceHistorySize"] = this.soidPriceHistorySize;
        data["soidUseCurrentBranchForFindDocuments"] = this.soidUseCurrentBranchForFindDocuments;
        data["soidPackBarcodeNumberDisplayFormat"] = this.soidPackBarcodeNumberDisplayFormat;
        data["soidAllowLoadAllInAllForProcessing"] = this.soidAllowLoadAllInAllForProcessing;
        data["soidStaffNumberTimeoutOperations"] = this.soidStaffNumberTimeoutOperations;
        data["soidPickingNoteReprint"] = this.soidPickingNoteReprint;
        data["soidSchedulingNumberDisplayFormat"] = this.soidSchedulingNumberDisplayFormat;
        data["soidOrderProductsByPriceBookSection"] = this.soidOrderProductsByPriceBookSection;
        data["soidDefaultQuoteDays"] = this.soidDefaultQuoteDays;
        data["soidDefaultReservationDays"] = this.soidDefaultReservationDays;
        data["soidDefaultTemplateOrderQuoteDays"] = this.soidDefaultTemplateOrderQuoteDays;
        data["soidProfitAbbreviation"] = this.soidProfitAbbreviation;
        data["soidMarginAbbreviation"] = this.soidMarginAbbreviation;
        data["soidSuppressCurrencyAndPercentageSymbolsInProfitAndMargin"] = this.soidSuppressCurrencyAndPercentageSymbolsInProfitAndMargin;
        data["soidSuppressMarginWarningsWhenPriceRulesUsed"] = this.soidSuppressMarginWarningsWhenPriceRulesUsed;
        data["soidSuppressMarginWarningsWhenStandardPriceUsed"] = this.soidSuppressMarginWarningsWhenStandardPriceUsed;
        data["soidDefaultMergeProductsOnOrder"] = this.soidDefaultMergeProductsOnOrder;
        data["soidDefaultShowDoubleRowsOnOrder"] = this.soidDefaultShowDoubleRowsOnOrder;
        data["soidSpecialProductCodePrefix"] = this.soidSpecialProductCodePrefix;
        data["soidSpecialProductCodeSuffixLength"] = this.soidSpecialProductCodeSuffixLength;
        data["soidCheckForExistingQuotesInAllBranches"] = this.soidCheckForExistingQuotesInAllBranches;
        data["soidAlwaysMergeProductsOnQuickAdd"] = this.soidAlwaysMergeProductsOnQuickAdd;
        data["soidBillOfMaterialProductCodePrefix"] = this.soidBillOfMaterialProductCodePrefix;
        data["soidBillOfMaterialProductCodeSuffixLength"] = this.soidBillOfMaterialProductCodeSuffixLength;
        data["soidSpecialGetHowSourcedFromBase"] = this.soidSpecialGetHowSourcedFromBase;
        data["soidCheckForExistingQuotesAtLineLevel"] = this.soidCheckForExistingQuotesAtLineLevel;
        data["soidbTADefaultTransactionStatusFilter"] = this.soidbTADefaultTransactionStatusFilter;
        data["soidbTADirectPostingBatchMode"] = this.soidbTADirectPostingBatchMode;
        data["soidbTACreateCaseWhenMarkingInDispute"] = this.soidbTACreateCaseWhenMarkingInDispute;
        data["soidbTARequireBatchCashMatchingNoteForUnmatchedCredits"] = this.soidbTARequireBatchCashMatchingNoteForUnmatchedCredits;
        data["soidbTAUseMatchDateForStatements"] = this.soidbTAUseMatchDateForStatements;
        data["soidbTAAllowWriteOffMoreThanRemainingAmount"] = this.soidbTAAllowWriteOffMoreThanRemainingAmount;
        data["soidShowCTLInstructionsWithoutCutFrom"] = this.soidShowCTLInstructionsWithoutCutFrom;
        data["soidSuppressMarginWarningsForSpecials"] = this.soidSuppressMarginWarningsForSpecials;
        data["soidbTABatchCashMatchingSortOrder"] = this.soidbTABatchCashMatchingSortOrder;
        data["soidWorksOrderScheduleNumberDisplayFormat"] = this.soidWorksOrderScheduleNumberDisplayFormat;
        data["soidNotepadCaseNumberDisplayFormat"] = this.soidNotepadCaseNumberDisplayFormat;
        data["soidStockWarningIncludeOnlyApprovedPurchaseOrdersForAllocation"] = this.soidStockWarningIncludeOnlyApprovedPurchaseOrdersForAllocation;
        data["soidbTAAllowUnapplyingTransactionsInClosedFinancialPeriods"] = this.soidbTAAllowUnapplyingTransactionsInClosedFinancialPeriods;
        data["soidbTAFinanceChargeDefaultGenerateBy"] = this.soidbTAFinanceChargeDefaultGenerateBy;
        data["soidbTACalcFinanceChargesOnFinanceCharges"] = this.soidbTACalcFinanceChargesOnFinanceCharges;
        data["soidbTADisplayChildCreditTransactionsOnParentAccounts"] = this.soidbTADisplayChildCreditTransactionsOnParentAccounts;
        data["soidStaffNumberBatchProcessingTimeout"] = this.soidStaffNumberBatchProcessingTimeout;
        data["soidProductSearchPageSize"] = this.soidProductSearchPageSize;
        data["soidProductExplorerPageSize"] = this.soidProductExplorerPageSize;
        data["soidCustomerSearchPageSize"] = this.soidCustomerSearchPageSize;
        data["soidSupplierSearchPageSize"] = this.soidSupplierSearchPageSize;
        data["soidOrderMonitorPageSize"] = this.soidOrderMonitorPageSize;
        data["soidJourneyPlannerPageSize"] = this.soidJourneyPlannerPageSize;
        data["soidDefaultCreateNewSpecialsOnOrderCopy"] = this.soidDefaultCreateNewSpecialsOnOrderCopy;
        data["soidDefaultSectionEndWithSubtotal"] = this.soidDefaultSectionEndWithSubtotal;
        data["soidCheckCustomerOnHoldOnPickingAndDelivery"] = this.soidCheckCustomerOnHoldOnPickingAndDelivery;
        data["soidCheckCustomerCreditOnPickingAndDelivery"] = this.soidCheckCustomerCreditOnPickingAndDelivery;
        data["soidAllowProceedOnPickingAndDeliveryCreditChecks"] = this.soidAllowProceedOnPickingAndDeliveryCreditChecks;
        data["soidEnableSteppedFinanceCharge"] = this.soidEnableSteppedFinanceCharge;
        data["soidCustomerChequeReferencesRequireCustomer"] = this.soidCustomerChequeReferencesRequireCustomer;
        data["soidbTADefaultNewCashCustomerToOperationalStatus"] = this.soidbTADefaultNewCashCustomerToOperationalStatus;
        data["soidDefaultTransportType"] = this.soidDefaultTransportType;
        data["soidDefaultDeliveryDate"] = this.soidDefaultDeliveryDate;
        data["soidInputMaskforDeliveryReference"] = this.soidInputMaskforDeliveryReference;
        data["soidEnableUnitPriceDeliveryCharges"] = this.soidEnableUnitPriceDeliveryCharges;
        data["soidAutomaticallySendDeliveryNotificationsByEmail"] = this.soidAutomaticallySendDeliveryNotificationsByEmail;
        data["soidCalendarStartOfWeek"] = this.soidCalendarStartOfWeek;
        data["soidDefaultDateRequiredDays"] = this.soidDefaultDateRequiredDays;
        data["soidDefaultDateRequiredOption"] = this.soidDefaultDateRequiredOption;
        data["soidDefaultDeliveryTime"] = this.soidDefaultDeliveryTime;
        data["soidDefaultDateRequiredToBlankOnQuotes"] = this.soidDefaultDateRequiredToBlankOnQuotes;
        data["soidDefaultDateRequiredCutOffTime"] = this.soidDefaultDateRequiredCutOffTime;
        data["soidDefaultDateRequiredToBlankOnOrders"] = this.soidDefaultDateRequiredToBlankOnOrders;
        data["soidEnableTransactionLocking"] = this.soidEnableTransactionLocking;
        data["soidSkipBranchPromptWhenUserHasDefault"] = this.soidSkipBranchPromptWhenUserHasDefault;
        data["soidPurchaseOrderCostCalculation"] = this.soidPurchaseOrderCostCalculation;
        data["soidSalesOrderCostCalculation"] = this.soidSalesOrderCostCalculation;
        data["soidSalesOrderShowVatPercentage"] = this.soidSalesOrderShowVatPercentage;
        data["soidSupplierInvoiceToleranceStockPercent"] = this.soidSupplierInvoiceToleranceStockPercent;
        data["soidSupplierInvoiceToleranceStockValue"] = this.soidSupplierInvoiceToleranceStockValue;
        data["soidSupplierInvoiceToleranceDirectPercent"] = this.soidSupplierInvoiceToleranceDirectPercent;
        data["soidSupplierInvoiceToleranceDirectValue"] = this.soidSupplierInvoiceToleranceDirectValue;
        data["soidSupplierInvoiceToleranceAdditionalCostPercent"] = this.soidSupplierInvoiceToleranceAdditionalCostPercent;
        data["soidSupplierInvoiceToleranceAdditionalCostValue"] = this.soidSupplierInvoiceToleranceAdditionalCostValue;
        data["soidDefaultCounterOrderSaleType"] = this.soidDefaultCounterOrderSaleType;
        data["soidSupplierInvoiceShowWeight"] = this.soidSupplierInvoiceShowWeight;
        data["soidSupplierInvoiceToleranceVatPercent"] = this.soidSupplierInvoiceToleranceVatPercent;
        data["soidSupplierInvoiceToleranceVatValue"] = this.soidSupplierInvoiceToleranceVatValue;
        data["soidSupplierInvoiceShowVAT"] = this.soidSupplierInvoiceShowVAT;
        data["soidSupplierInvoiceCalcSettlementDiscOnCredits"] = this.soidSupplierInvoiceCalcSettlementDiscOnCredits;
        data["soidSupplierInvoiceDeliveryText"] = this.soidSupplierInvoiceDeliveryText;
        data["soidSupplierInvoicePromptForDeliveryDetails"] = this.soidSupplierInvoicePromptForDeliveryDetails;
        data["soidSupplierInvoiceMustChooseGLCode"] = this.soidSupplierInvoiceMustChooseGLCode;
        data["soidSupplierInvoiceBlock2ndInvoiceOnDirectOrders"] = this.soidSupplierInvoiceBlock2ndInvoiceOnDirectOrders;
        data["soidSupplierInvoiceApproveDirectSalesOrderOnInvoiceApproval"] = this.soidSupplierInvoiceApproveDirectSalesOrderOnInvoiceApproval;
        data["soidSupplierInvoiceSetDirectSalesInvoiceDateFromInvoice"] = this.soidSupplierInvoiceSetDirectSalesInvoiceDateFromInvoice;
        data["soidOrdersPricingIncludeAdditionalCostInDirectSalesOrderCost"] = this.soidOrdersPricingIncludeAdditionalCostInDirectSalesOrderCost;
        data["soidSupplierInvoiceUseSupplierPaymentTerms"] = this.soidSupplierInvoiceUseSupplierPaymentTerms;
        data["soidIncludeOnOrderInAvailableStock"] = this.soidIncludeOnOrderInAvailableStock;
        data["soidIncludeStockDueInAvailableStock"] = this.soidIncludeStockDueInAvailableStock;
        data["soidIncludeThirdPartyInAvailableStock"] = this.soidIncludeThirdPartyInAvailableStock;
        data["soidIncludeAwaitingProcessInAvailableStock"] = this.soidIncludeAwaitingProcessInAvailableStock;
        data["soidAllocateStockOnBackToBacks"] = this.soidAllocateStockOnBackToBacks;
        data["soidAllowUseOfCostRecordAfterValuationDate"] = this.soidAllowUseOfCostRecordAfterValuationDate;
        data["soidIncludeAwaitingProcessForOrderOnlyInAvailStock"] = this.soidIncludeAwaitingProcessForOrderOnlyInAvailStock;
        data["soidCompanyStockLimitedByUserAccess"] = this.soidCompanyStockLimitedByUserAccess;
        data["soidDoNotAllowBackAndForwardDatingThatHarmsCostIntegrity"] = this.soidDoNotAllowBackAndForwardDatingThatHarmsCostIntegrity;
        data["soidStockCountAllowTickedStockUpdates"] = this.soidStockCountAllowTickedStockUpdates;
        data["soidStockCountAllowBackDatingOfCompletion"] = this.soidStockCountAllowBackDatingOfCompletion;
        data["soidStockIncludeLooseAndPackInStockCheckWhenAllocating"] = this.soidStockIncludeLooseAndPackInStockCheckWhenAllocating;
        data["soidIncludeStockAllocatedToBackToBackOrderInOnOrderStock"] = this.soidIncludeStockAllocatedToBackToBackOrderInOnOrderStock;
        data["soidAllowAddingProductsToTicketedStockCounts"] = this.soidAllowAddingProductsToTicketedStockCounts;
        data["soidShowStockInformationInStockCountProductSearches"] = this.soidShowStockInformationInStockCountProductSearches;
        data["soidShowActualAndAvailableStockWhenEnteringTicketCounts"] = this.soidShowActualAndAvailableStockWhenEnteringTicketCounts;
        data["soidReasonCodeToUseForStockCount"] = this.soidReasonCodeToUseForStockCount;
        data["soidCustomerObjectReport"] = this.soidCustomerObjectReport;
        data["soidProductObjectReport"] = this.soidProductObjectReport;
        data["soidSupplierObjectReport"] = this.soidSupplierObjectReport;
        data["soidFinancialInvoiceAuditCustomerReport"] = this.soidFinancialInvoiceAuditCustomerReport;
        data["soidFinancialInvoiceAuditSupplierReport"] = this.soidFinancialInvoiceAuditSupplierReport;
        data["soidStockPackReconciliationReport"] = this.soidStockPackReconciliationReport;
        data["soidCashDrawerReportName"] = this.soidCashDrawerReportName;
        data["soidCustomerProductRefObjectReport"] = this.soidCustomerProductRefObjectReport;
        data["soidSuggestedPurchaseOrderDetailReport"] = this.soidSuggestedPurchaseOrderDetailReport;
        data["soidStockValuationNegativeStockReportName"] = this.soidStockValuationNegativeStockReportName;
        data["soidStockValuationReceivedNotInvoicedReportName"] = this.soidStockValuationReceivedNotInvoicedReportName;
        data["soidStockValuationPaidNotReceivedReportName"] = this.soidStockValuationPaidNotReceivedReportName;
        data["soidStockValuationIssuedNotInvoicedReportName"] = this.soidStockValuationIssuedNotInvoicedReportName;
        data["soidStockValuationInvoicedNotIssuedReportName"] = this.soidStockValuationInvoicedNotIssuedReportName;
        data["soidStockValuationPaidNotDeliveredReportName"] = this.soidStockValuationPaidNotDeliveredReportName;
        data["soidStockValuationTransferSentNotreceivedReportName"] = this.soidStockValuationTransferSentNotreceivedReportName;
        data["soidScansUseDocReadPermissions"] = this.soidScansUseDocReadPermissions;
        data["soidReportsAccruedPurchaseDetailSupplierCredits"] = this.soidReportsAccruedPurchaseDetailSupplierCredits;
        data["soidDashboardRefreshInterval"] = this.soidDashboardRefreshInterval;
        data["soidDashboardOperationsFilename"] = this.soidDashboardOperationsFilename;
        data["soidDashboardSystemManagerFilename"] = this.soidDashboardSystemManagerFilename;
        data["soidDashboardFigures"] = this.soidDashboardFigures;
        data["soidDashboardOrderingBranch"] = this.soidDashboardOrderingBranch;
        data["soidDashBoardEnableFlowLayouts"] = this.soidDashBoardEnableFlowLayouts;
        data["soidDataRuleDataSetXML"] = this.soidDataRuleDataSetXML;
        data["soidPerformanceMonitorShowProfit"] = this.soidPerformanceMonitorShowProfit;
        data["soidPerformanceMonitorUseInternalCosts"] = this.soidPerformanceMonitorUseInternalCosts;
        data["soidDefaultCustomerVATRule"] = this.soidDefaultCustomerVATRule;
        data["soidDefaultProductVATRule"] = this.soidDefaultProductVATRule;
        data["soidCalculateVATOnGoodsLessDiscount"] = this.soidCalculateVATOnGoodsLessDiscount;
        data["soidCalculateVATTaxAtTotalLevel"] = this.soidCalculateVATTaxAtTotalLevel;
        data["soidCalculateTaxBasedOnBranchTaxArea"] = this.soidCalculateTaxBasedOnBranchTaxArea;
        data["soidVatRateForAutomaticUplift"] = this.soidVatRateForAutomaticUplift;
        data["soidCalculateSettlementAtTotalLevel"] = this.soidCalculateSettlementAtTotalLevel;
        data["soidVatRateForAutomaticLineCharge"] = this.soidVatRateForAutomaticLineCharge;
        data["soidEnableNonDiscountableAmount"] = this.soidEnableNonDiscountableAmount;
        data["soidVatRateForExportSales"] = this.soidVatRateForExportSales;
        data["soidUseWashingtonStateTaxRateValidation"] = this.soidUseWashingtonStateTaxRateValidation;
        data["soidRequireTaxVerificationOnDeliveredSalesOrders"] = this.soidRequireTaxVerificationOnDeliveredSalesOrders;
        data["soidUseDefaultJobAddressTaxAreaForCustomerDefault"] = this.soidUseDefaultJobAddressTaxAreaForCustomerDefault;
        data["soidCalculateTaxOnCostMinusWorksOrderAVOCost"] = this.soidCalculateTaxOnCostMinusWorksOrderAVOCost;
        data["soidUseIssuingBranchTaxArea"] = this.soidUseIssuingBranchTaxArea;
        data["soidSalesTaxCalculationMethod"] = this.soidSalesTaxCalculationMethod;
        data["soidUseBranchTaxAreaForCustomerDefault"] = this.soidUseBranchTaxAreaForCustomerDefault;
        data["soidSendFullAddressInfoInWashingtonStateTaxRateValidation"] = this.soidSendFullAddressInfoInWashingtonStateTaxRateValidation;
        data["soidWashingtonStateTaxRateURL"] = this.soidWashingtonStateTaxRateURL;
        data["soidFinancialStockValuationCostType"] = this.soidFinancialStockValuationCostType;
        data["soidFinancialReferenceRequiredOnCheckPayment"] = this.soidFinancialReferenceRequiredOnCheckPayment;
        data["soidInputMaskForChequeReference"] = this.soidInputMaskForChequeReference;
        data["soidPreventUseOfNewJournalNumberOnReExport"] = this.soidPreventUseOfNewJournalNumberOnReExport;
        data["soidUseFiscalCalendarToControlPostingDates"] = this.soidUseFiscalCalendarToControlPostingDates;
        data["soidSearchHistoryRecordsInFinancialPackage"] = this.soidSearchHistoryRecordsInFinancialPackage;
        data["soidUpdateDailySalesAnalysisTable"] = this.soidUpdateDailySalesAnalysisTable;
        data["soidChequeGuaranteeCardNumberRequired"] = this.soidChequeGuaranteeCardNumberRequired;
        data["soidAuthorisationCodeOrderValueThreshold"] = this.soidAuthorisationCodeOrderValueThreshold;
        data["soidSendSeparateBatchForEachBranchGLCode"] = this.soidSendSeparateBatchForEachBranchGLCode;
        data["soidRetainOrigExchangeRateOnSOAndPO"] = this.soidRetainOrigExchangeRateOnSOAndPO;
        data["soidEnableGLCodeValidation"] = this.soidEnableGLCodeValidation;
        data["soidFinancialGPbTGeneratesJournalEntryNumber"] = this.soidFinancialGPbTGeneratesJournalEntryNumber;
        data["soidFinancialGPMinbTJournalEntryNumber"] = this.soidFinancialGPMinbTJournalEntryNumber;
        data["soidFinancialGPMaxbTJournalEntryNumber"] = this.soidFinancialGPMaxbTJournalEntryNumber;
        data["soidPostSalesAndCOGSWhenUsingIssuingBranchTo"] = this.soidPostSalesAndCOGSWhenUsingIssuingBranchTo;
        data["soidEnableIntercompanyDistribution"] = this.soidEnableIntercompanyDistribution;
        data["soidEpicorTaxConnectAccountNumber"] = this.soidEpicorTaxConnectAccountNumber;
        data["soidEpicorTaxConnectLicenseKey"] = this.soidEpicorTaxConnectLicenseKey;
        data["soidEpicorTaxConnectWebAddress"] = this.soidEpicorTaxConnectWebAddress;
        data["soidTaxToUseForEpicorTaxConnectTaxes"] = this.soidTaxToUseForEpicorTaxConnectTaxes;
        data["soidEpicorTaxConnectCompanyCode"] = this.soidEpicorTaxConnectCompanyCode;
        data["soidGenericXMLFinancialExportMethod"] = this.soidGenericXMLFinancialExportMethod;
        data["soidSettDiscAllowedWhenMatchedToCreditCardPayments"] = this.soidSettDiscAllowedWhenMatchedToCreditCardPayments;
        data["soidSettDiscAllowedWhenMatchedToACHPayments"] = this.soidSettDiscAllowedWhenMatchedToACHPayments;
        data["soidNoOfSellingBands"] = this.soidNoOfSellingBands;
        data["soidUsePriceRulesForSpecials"] = this.soidUsePriceRulesForSpecials;
        data["soidDeliveryCriteriaPrecedence1"] = this.soidDeliveryCriteriaPrecedence1;
        data["soidDeliveryCriteriaPrecedence2"] = this.soidDeliveryCriteriaPrecedence2;
        data["soidDeliveryCriteriaPrecedence3"] = this.soidDeliveryCriteriaPrecedence3;
        data["soidDeliveryCriteriaPrecedence4"] = this.soidDeliveryCriteriaPrecedence4;
        data["soidUseStandardBuyCostForSpecials"] = this.soidUseStandardBuyCostForSpecials;
        data["soidRebateIDRequiredForRebateAccruals"] = this.soidRebateIDRequiredForRebateAccruals;
        data["soidPricingDefaultCompanyLevelPriceChange"] = this.soidPricingDefaultCompanyLevelPriceChange;
        data["soidPricingUseOldCompanyPriceAsOldAmount"] = this.soidPricingUseOldCompanyPriceAsOldAmount;
        data["soidSigmaNESTEnableIntegration"] = this.soidSigmaNESTEnableIntegration;
        data["soidSigmaNESTWorkOrderAttachmentFolder"] = this.soidSigmaNESTWorkOrderAttachmentFolder;
        data["soidSigmaNESTWorkOrderAttachmentFilename"] = this.soidSigmaNESTWorkOrderAttachmentFilename;
        data["soidSigmaNESTWorkOrderAttachmentOrigin"] = this.soidSigmaNESTWorkOrderAttachmentOrigin;
        data["soidDontCalculateSellingPriceWhenAddingProductWithZeroQuantity"] = this.soidDontCalculateSellingPriceWhenAddingProductWithZeroQuantity;
        data["soidSupplierInvoiceConfirmZeroTax"] = this.soidSupplierInvoiceConfirmZeroTax;
        data["soidSupplierInvoiceAllowAlternateCreditor"] = this.soidSupplierInvoiceAllowAlternateCreditor;
        data["soidSupplierInvoiceAutoCalcSettlementDiscOnInvoices"] = this.soidSupplierInvoiceAutoCalcSettlementDiscOnInvoices;
        data["soidSupplierInvoiceIncludeCostOnDirectLineDescription"] = this.soidSupplierInvoiceIncludeCostOnDirectLineDescription;
        data["soidSupplierInvoiceEnablePostingDate"] = this.soidSupplierInvoiceEnablePostingDate;
        data["soidSupplierInvoiceAutoSelectPostingDate"] = this.soidSupplierInvoiceAutoSelectPostingDate;
        data["soidSupplierInvoiceOnlyExportDiscountsNotEqualToZero"] = this.soidSupplierInvoiceOnlyExportDiscountsNotEqualToZero;
        data["soidSupplierInvoiceCanadianTaxInput"] = this.soidSupplierInvoiceCanadianTaxInput;
        data["soidSupplierInvoiceShowSupplierProductCode"] = this.soidSupplierInvoiceShowSupplierProductCode;
        data["soidSupplierInvoiceAllowZeroTotalInvoices"] = this.soidSupplierInvoiceAllowZeroTotalInvoices;
        data["soidSupplierInvoiceDisplayExpectedCostsFromPO"] = this.soidSupplierInvoiceDisplayExpectedCostsFromPO;
        data["soidSupplierInvoiceEnableWorkflow"] = this.soidSupplierInvoiceEnableWorkflow;
        data["soidSupplierInvoiceShowBrowseForGLSubCodeThreshold"] = this.soidSupplierInvoiceShowBrowseForGLSubCodeThreshold;
        data["soidSupplierInvoiceRestrictWorkflowMessagesToSingleRecipient"] = this.soidSupplierInvoiceRestrictWorkflowMessagesToSingleRecipient;
        data["soidSupplierInvoiceGPIncludePOSupplierCodeWhenAlternativeCreditor"] = this.soidSupplierInvoiceGPIncludePOSupplierCodeWhenAlternativeCreditor;
        data["soidSupplierInvoiceRequireWorkflowMessageRecipient"] = this.soidSupplierInvoiceRequireWorkflowMessageRecipient;
        data["soidSupplierCreditRequiresReasonCode"] = this.soidSupplierCreditRequiresReasonCode;
        data["soidSupplierInvoicePrintBarcodeLabelOnMatchOrMatchAndApprove"] = this.soidSupplierInvoicePrintBarcodeLabelOnMatchOrMatchAndApprove;
        data["soidSupplierInvoiceAllowMatchingDirectSupplierInvoiceWhenPaymentOutstanding"] = this.soidSupplierInvoiceAllowMatchingDirectSupplierInvoiceWhenPaymentOutstanding;
        data["soidSupplierInvoiceSendOtherRefAsPONumberToGPForOverheadSIs"] = this.soidSupplierInvoiceSendOtherRefAsPONumberToGPForOverheadSIs;
        data["soidSupplierInvoiceSkipMsgsWhenMatchingApproving"] = this.soidSupplierInvoiceSkipMsgsWhenMatchingApproving;
        data["soidSupplierInvoiceBranchSelectionType"] = this.soidSupplierInvoiceBranchSelectionType;
        data["soidSupplierInvoiceCalculateGoodsTotalOnOverheadInvoicesWithNoPurchaseOrder"] = this.soidSupplierInvoiceCalculateGoodsTotalOnOverheadInvoicesWithNoPurchaseOrder;
        data["soidNavisionUseIssuingBranchForDimension"] = this.soidNavisionUseIssuingBranchForDimension;
        data["soidLoyaltyCurrencyToPointExchangeRate"] = this.soidLoyaltyCurrencyToPointExchangeRate;
        data["soidLoyaltyOrderEntryPromptPointMinimum"] = this.soidLoyaltyOrderEntryPromptPointMinimum;
        data["soidLoyaltyRedeemManualOrderLineType"] = this.soidLoyaltyRedeemManualOrderLineType;
        data["soidLoyaltyRepeatRewardsMOLT"] = this.soidLoyaltyRepeatRewardsMOLT;
        data["soidDefaultSystemToImperial"] = this.soidDefaultSystemToImperial;
        data["soidWeightPer"] = this.soidWeightPer;
        data["soidWeightDecimalPlaces"] = this.soidWeightDecimalPlaces;
        data["soidQuotePickDocumentReleaseFormat"] = this.soidQuotePickDocumentReleaseFormat;
        data["soidDepartmentUsage"] = this.soidDepartmentUsage;
        data["soidDefaultDepartmentUsageDepartment"] = this.soidDefaultDepartmentUsageDepartment;
        data["soidGeneralEnableReportingCost"] = this.soidGeneralEnableReportingCost;
        data["soidAllowManualAdjustmentOfVolumeOnAdditionalCostProrations"] = this.soidAllowManualAdjustmentOfVolumeOnAdditionalCostProrations;
        data["soidShowJobReferenceInLists"] = this.soidShowJobReferenceInLists;
        data["soidAllowMultipleOrderReferenceMasks"] = this.soidAllowMultipleOrderReferenceMasks;
        data["soidLimitSellAndBuyPriceChangesToBranchWithUpdateAccess"] = this.soidLimitSellAndBuyPriceChangesToBranchWithUpdateAccess;
        data["soidGeneralEnableNotepadNotifications"] = this.soidGeneralEnableNotepadNotifications;
        data["soidGeneralValidateDefaultRefOnCustomerAddress"] = this.soidGeneralValidateDefaultRefOnCustomerAddress;
        data["soidLimitRelatedDocsBasedOnBranchAccess"] = this.soidLimitRelatedDocsBasedOnBranchAccess;
        data["soidVerifyInternalGiftCardsAgainstLoadedGiftCardList"] = this.soidVerifyInternalGiftCardsAgainstLoadedGiftCardList;
        data["soidSetDepartmentOnOrdersDuringCreation"] = this.soidSetDepartmentOnOrdersDuringCreation;
        data["soidUpdateTransactionLineManualDescriptionWithSpecialProductDescription"] = this.soidUpdateTransactionLineManualDescriptionWithSpecialProductDescription;
        data["soidDefaultCustomerNotepadTypeFilterFromUserOption"] = this.soidDefaultCustomerNotepadTypeFilterFromUserOption;
        data["soidDepartmentOnAccountPaymentsWhereDepartmentUsageIsSalesRepOrComputer"] = this.soidDepartmentOnAccountPaymentsWhereDepartmentUsageIsSalesRepOrComputer;
        data["soidDepartmentOnCashDrawerLodgementsWhereDepartmentUsageIsSalesRepOrComputer"] = this.soidDepartmentOnCashDrawerLodgementsWhereDepartmentUsageIsSalesRepOrComputer;
        data["soidPricingPlannerSmartView1"] = this.soidPricingPlannerSmartView1;
        data["soidPricingPlannerSmartView2"] = this.soidPricingPlannerSmartView2;
        data["soidPricingPlannerSmartView3"] = this.soidPricingPlannerSmartView3;
        data["soidPricingPlannerSmartView4"] = this.soidPricingPlannerSmartView4;
        data["soidPricingPlannerSmartView5"] = this.soidPricingPlannerSmartView5;
        data["soidWorksOrderSpecifyFinQtyWhenConfirmSourcePacks"] = this.soidWorksOrderSpecifyFinQtyWhenConfirmSourcePacks;
        data["soidPurchasingLimitFindProdToSupplier"] = this.soidPurchasingLimitFindProdToSupplier;
        data["soidPurchasingAllowApprovalIfCreditProblem"] = this.soidPurchasingAllowApprovalIfCreditProblem;
        data["soidPurchasingAutoApproveDirectOrders"] = this.soidPurchasingAutoApproveDirectOrders;
        data["soidPurchaseOrderSecondaryCostCalculation"] = this.soidPurchaseOrderSecondaryCostCalculation;
        data["soidPurchasingAutoApproveBackToBackOrders"] = this.soidPurchasingAutoApproveBackToBackOrders;
        data["soidPurchasingRoundToInnerOuterPallet"] = this.soidPurchasingRoundToInnerOuterPallet;
        data["soidPurchasingInputGLCodeOnOverheadAdvanced"] = this.soidPurchasingInputGLCodeOnOverheadAdvanced;
        data["soidPurchasingWarnWhenNotPrimarySupplier"] = this.soidPurchasingWarnWhenNotPrimarySupplier;
        data["soidPurchasingAutoPrintDirectOrders"] = this.soidPurchasingAutoPrintDirectOrders;
        data["soidPurchasingAutoPrintBackToBackOrders"] = this.soidPurchasingAutoPrintBackToBackOrders;
        data["soidPurchasingPopulateAnalysisCodeOnGeneratedPO"] = this.soidPurchasingPopulateAnalysisCodeOnGeneratedPO;
        data["soidPurchasingCopyCostPerFromDirectOrBackToBack"] = this.soidPurchasingCopyCostPerFromDirectOrBackToBack;
        data["soidPurchasingAllowCostQtyChangeAfterStockReceipt"] = this.soidPurchasingAllowCostQtyChangeAfterStockReceipt;
        data["soidPurchasingCostToleranceWarning"] = this.soidPurchasingCostToleranceWarning;
        data["soidPurchasingWarnIfNotInnerOuterPalletMultiple"] = this.soidPurchasingWarnIfNotInnerOuterPalletMultiple;
        data["soidPurchasingAllowPrintingUnapprovedPurchaseOrders"] = this.soidPurchasingAllowPrintingUnapprovedPurchaseOrders;
        data["soidPurchaseOrderCallOffAutoComplete"] = this.soidPurchaseOrderCallOffAutoComplete;
        data["soidPurchasingShowAndAllowUpdateOfStandardBuyPrice"] = this.soidPurchasingShowAndAllowUpdateOfStandardBuyPrice;
        data["soidPurchasingDefaultAnalysisCodeOnGenerateFromAVO"] = this.soidPurchasingDefaultAnalysisCodeOnGenerateFromAVO;
        data["soidPurchasingShowCustomerOnInternalNotes"] = this.soidPurchasingShowCustomerOnInternalNotes;
        data["soidPurchasingDefaultInputPerToSupplierBuyPer"] = this.soidPurchasingDefaultInputPerToSupplierBuyPer;
        data["soidPurchasingDisplayCompletionButtonsOnPO"] = this.soidPurchasingDisplayCompletionButtonsOnPO;
        data["soidPurchasingDisplayCreatePOOnAddCostChargeOnXfers"] = this.soidPurchasingDisplayCreatePOOnAddCostChargeOnXfers;
        data["soidPurchasingAlwaysUseOverriddenDimsOnAddCosts"] = this.soidPurchasingAlwaysUseOverriddenDimsOnAddCosts;
        data["soidPurchasingApplyEnvironmentalStatusRestrictions"] = this.soidPurchasingApplyEnvironmentalStatusRestrictions;
        data["soidPurchasingAllowChangingUnitCostForCostControlledItems"] = this.soidPurchasingAllowChangingUnitCostForCostControlledItems;
        data["soidGenerateCallOffPOForDirectSO"] = this.soidGenerateCallOffPOForDirectSO;
        data["soidPurchasingPromptForSellPriceWhenDirectCostChanged"] = this.soidPurchasingPromptForSellPriceWhenDirectCostChanged;
        data["soidPurchasingKeepDateRequiredInSynchForDirects"] = this.soidPurchasingKeepDateRequiredInSynchForDirects;
        data["soidPurchasingCheckForCallOffs"] = this.soidPurchasingCheckForCallOffs;
        data["soidPurchasingSetDefaultStockLocation"] = this.soidPurchasingSetDefaultStockLocation;
        data["soidPurchasingPurchaseOrderChangeApprovalThreshold"] = this.soidPurchasingPurchaseOrderChangeApprovalThreshold;
        data["soidPurchasingUseLeadTimeToSetPOLineDateExpected"] = this.soidPurchasingUseLeadTimeToSetPOLineDateExpected;
        data["soidIncludeOrderLineLinksForSOItemsOnWMSPOs"] = this.soidIncludeOrderLineLinksForSOItemsOnWMSPOs;
        data["soidPurchasingPromptForBuyPriceRuleSelection"] = this.soidPurchasingPromptForBuyPriceRuleSelection;
        data["soidGLCodeSelectionMethodForMOLTsOnOverheadPO"] = this.soidGLCodeSelectionMethodForMOLTsOnOverheadPO;
        data["soidCentralizedPurchasingIncludesSourcedByTransfer"] = this.soidCentralizedPurchasingIncludesSourcedByTransfer;
        data["soidSuggestedOrdersSmartView1"] = this.soidSuggestedOrdersSmartView1;
        data["soidSuggestedOrdersSmartView2"] = this.soidSuggestedOrdersSmartView2;
        data["soidSuggestedOrdersSmartView3"] = this.soidSuggestedOrdersSmartView3;
        data["soidSuggestedOrdersSmartView4"] = this.soidSuggestedOrdersSmartView4;
        data["soidSuggestedOrdersSmartView5"] = this.soidSuggestedOrdersSmartView5;
        data["soidSuggestedOrdersAdjustByStockClass"] = this.soidSuggestedOrdersAdjustByStockClass;
        data["soidDefaultPurchaseAnalysisCodeOnOverheadPOs"] = this.soidDefaultPurchaseAnalysisCodeOnOverheadPOs;
        data["soidPurchasingUseSecondaryCostWhenPrimaryCostValueIsZero"] = this.soidPurchasingUseSecondaryCostWhenPrimaryCostValueIsZero;
        data["soidPurchasingShow15LevelsForAutoAverageCostAdjRule"] = this.soidPurchasingShow15LevelsForAutoAverageCostAdjRule;
        data["soidRetainRaisedByInformationWhenConvertingPOToADirect"] = this.soidRetainRaisedByInformationWhenConvertingPOToADirect;
        data["soidApplyFixedAmountManualLinesAndAdditionalCostsToAllStockReceipts"] = this.soidApplyFixedAmountManualLinesAndAdditionalCostsToAllStockReceipts;
        data["soidPurchasingSetMOLTDescriptionToGLCodeDescriptionOnOverheadPO"] = this.soidPurchasingSetMOLTDescriptionToGLCodeDescriptionOnOverheadPO;
        data["soidPurchasingAutoPrintLabels"] = this.soidPurchasingAutoPrintLabels;
        data["soidPurchasingShowSupplierPopupForAutomaticPurchaseOrders"] = this.soidPurchasingShowSupplierPopupForAutomaticPurchaseOrders;
        data["soidSuggestedOrderingIncludeAllOpenPurchaseOrders"] = this.soidSuggestedOrderingIncludeAllOpenPurchaseOrders;
        data["soidFindDocPreviewPaneSmartViewSO1"] = this.soidFindDocPreviewPaneSmartViewSO1;
        data["soidFindDocPreviewPaneSmartViewSO2"] = this.soidFindDocPreviewPaneSmartViewSO2;
        data["soidFindDocPreviewPaneSmartViewSO3"] = this.soidFindDocPreviewPaneSmartViewSO3;
        data["soidFindDocPreviewPaneSmartViewSO4"] = this.soidFindDocPreviewPaneSmartViewSO4;
        data["soidFindDocPreviewPaneSmartViewSO5"] = this.soidFindDocPreviewPaneSmartViewSO5;
        data["soidFindDocPreviewPaneSmartViewQU1"] = this.soidFindDocPreviewPaneSmartViewQU1;
        data["soidFindDocPreviewPaneSmartViewQU2"] = this.soidFindDocPreviewPaneSmartViewQU2;
        data["soidFindDocPreviewPaneSmartViewQU3"] = this.soidFindDocPreviewPaneSmartViewQU3;
        data["soidFindDocPreviewPaneSmartViewQU4"] = this.soidFindDocPreviewPaneSmartViewQU4;
        data["soidFindDocPreviewPaneSmartViewQU5"] = this.soidFindDocPreviewPaneSmartViewQU5;
        data["soidFindDocPreviewPaneSmartViewCO1"] = this.soidFindDocPreviewPaneSmartViewCO1;
        data["soidFindDocPreviewPaneSmartViewCO2"] = this.soidFindDocPreviewPaneSmartViewCO2;
        data["soidFindDocPreviewPaneSmartViewCO3"] = this.soidFindDocPreviewPaneSmartViewCO3;
        data["soidFindDocPreviewPaneSmartViewCO4"] = this.soidFindDocPreviewPaneSmartViewCO4;
        data["soidFindDocPreviewPaneSmartViewCO5"] = this.soidFindDocPreviewPaneSmartViewCO5;
        data["soidFindDocPreviewPaneSmartViewPO1"] = this.soidFindDocPreviewPaneSmartViewPO1;
        data["soidFindDocPreviewPaneSmartViewPO2"] = this.soidFindDocPreviewPaneSmartViewPO2;
        data["soidFindDocPreviewPaneSmartViewPO3"] = this.soidFindDocPreviewPaneSmartViewPO3;
        data["soidFindDocPreviewPaneSmartViewPO4"] = this.soidFindDocPreviewPaneSmartViewPO4;
        data["soidFindDocPreviewPaneSmartViewPO5"] = this.soidFindDocPreviewPaneSmartViewPO5;
        data["soidFindDocPreviewPaneSmartViewCN1"] = this.soidFindDocPreviewPaneSmartViewCN1;
        data["soidFindDocPreviewPaneSmartViewCN2"] = this.soidFindDocPreviewPaneSmartViewCN2;
        data["soidFindDocPreviewPaneSmartViewCN3"] = this.soidFindDocPreviewPaneSmartViewCN3;
        data["soidFindDocPreviewPaneSmartViewCN4"] = this.soidFindDocPreviewPaneSmartViewCN4;
        data["soidFindDocPreviewPaneSmartViewCN5"] = this.soidFindDocPreviewPaneSmartViewCN5;
        data["soidSalesOrderAllowChangeCurrencies"] = this.soidSalesOrderAllowChangeCurrencies;
        data["soidSalesOrderChangeTakenBy"] = this.soidSalesOrderChangeTakenBy;
        data["soidSalesOrderForceSupplierReview"] = this.soidSalesOrderForceSupplierReview;
        data["soidSalesOrderWarnIfDirectCostNotChanged"] = this.soidSalesOrderWarnIfDirectCostNotChanged;
        data["soidSalesOrderMaximumReservationDays"] = this.soidSalesOrderMaximumReservationDays;
        data["soidSalesOrderAllowDirectSalesInCounterSales"] = this.soidSalesOrderAllowDirectSalesInCounterSales;
        data["soidSalesOrderOnlyApproveIssuedOrders"] = this.soidSalesOrderOnlyApproveIssuedOrders;
        data["soidSalesOrderParkedOrderFormats"] = this.soidSalesOrderParkedOrderFormats;
        data["soidSalesOrderWaitForNewStockOnBackOrder"] = this.soidSalesOrderWaitForNewStockOnBackOrder;
        data["soidSalesOrderWarnIfOrderLinePriceIsZero"] = this.soidSalesOrderWarnIfOrderLinePriceIsZero;
        data["soidSalesOrderDeliveryAreaRequired"] = this.soidSalesOrderDeliveryAreaRequired;
        data["soidSalesOrderAllowCashBackOnCashSales"] = this.soidSalesOrderAllowCashBackOnCashSales;
        data["soidSalesOrderMaintainTakenByFromOriginalOrderOnBackOrder"] = this.soidSalesOrderMaintainTakenByFromOriginalOrderOnBackOrder;
        data["soidMarkOrderApprovedWhenStockIssued"] = this.soidMarkOrderApprovedWhenStockIssued;
        data["soidDefaultSpecialOrderQtyChangeToCreateBackOrder"] = this.soidDefaultSpecialOrderQtyChangeToCreateBackOrder;
        data["soidOrdersSuppressStockUpdatesDuringEntry"] = this.soidOrdersSuppressStockUpdatesDuringEntry;
        data["soidOrdersProductCodeColumnContent"] = this.soidOrdersProductCodeColumnContent;
        data["soidOrdersReserveStockOnCallOff"] = this.soidOrdersReserveStockOnCallOff;
        data["soidOrdersAutoApplyDeliveryCharges"] = this.soidOrdersAutoApplyDeliveryCharges;
        data["soidOrdersDisplayCommissionCode"] = this.soidOrdersDisplayCommissionCode;
        data["soidOrdersForceSupplierToBeChangedWhenSupplierIs"] = this.soidOrdersForceSupplierToBeChangedWhenSupplierIs;
        data["soidSignatureCaptureCollectNow"] = this.soidSignatureCaptureCollectNow;
        data["soidSignatureCaptureCollectLater"] = this.soidSignatureCaptureCollectLater;
        data["soidOrdersShowBinLocationFromSROnSOLine"] = this.soidOrdersShowBinLocationFromSROnSOLine;
        data["soidOrderExcludeParkedOrdersFromOnOrderBalance"] = this.soidOrderExcludeParkedOrdersFromOnOrderBalance;
        data["soidOrdersDisplayStockLocationOnOrderEntry"] = this.soidOrdersDisplayStockLocationOnOrderEntry;
        data["soidOrdersDefaultVehicleType"] = this.soidOrdersDefaultVehicleType;
        data["soidOrdersDefaultOrderMonitorToAllBranches"] = this.soidOrdersDefaultOrderMonitorToAllBranches;
        data["soidOrdersDefaultSellPriceFromParentNATally"] = this.soidOrdersDefaultSellPriceFromParentNATally;
        data["soidOrdersDefaultCustomerSearchOnOrdersToAddress"] = this.soidOrdersDefaultCustomerSearchOnOrdersToAddress;
        data["soidOrdersManualLineDeliveryChargeExclusionCode"] = this.soidOrdersManualLineDeliveryChargeExclusionCode;
        data["soidOrdersDisplayTotalCostInOrderTotals"] = this.soidOrdersDisplayTotalCostInOrderTotals;
        data["soidOrdersAutoApplyRebateAccruals"] = this.soidOrdersAutoApplyRebateAccruals;
        data["soidOrdersDisplayNegWarningOnGeneral"] = this.soidOrdersDisplayNegWarningOnGeneral;
        data["soidOrdersAllowOverrideOfRebateSaleType"] = this.soidOrdersAllowOverrideOfRebateSaleType;
        data["soidOrdersOnlyCalcTransferCostForBranchesWithStock"] = this.soidOrdersOnlyCalcTransferCostForBranchesWithStock;
        data["soidOrdersEnableMultipleBranches"] = this.soidOrdersEnableMultipleBranches;
        data["soidOrdersMixedBranchRestrictions"] = this.soidOrdersMixedBranchRestrictions;
        data["soidOrdersAllowMixedSaleTypesOnOrders"] = this.soidOrdersAllowMixedSaleTypesOnOrders;
        data["soidOrdersEnterAddressViaForm"] = this.soidOrdersEnterAddressViaForm;
        data["soidOrdersCallOffAllowCreateSOFromMultipleCallOffs"] = this.soidOrdersCallOffAllowCreateSOFromMultipleCallOffs;
        data["soidOrdersEnableCollectNow"] = this.soidOrdersEnableCollectNow;
        data["soidOrdersEnableCollectLater"] = this.soidOrdersEnableCollectLater;
        data["soidOrdersEnableDelivered"] = this.soidOrdersEnableDelivered;
        data["soidOrdersEnableDirect"] = this.soidOrdersEnableDirect;
        data["soidOrdersShowQuickProductsInCounter"] = this.soidOrdersShowQuickProductsInCounter;
        data["soidOrdersAllowTextLines"] = this.soidOrdersAllowTextLines;
        data["soidOrdersAllowCustomerLookupByAddress"] = this.soidOrdersAllowCustomerLookupByAddress;
        data["soidOrdersAllowMultipleSalesRepPerOrder"] = this.soidOrdersAllowMultipleSalesRepPerOrder;
        data["soidOrdersMinimumDeposit"] = this.soidOrdersMinimumDeposit;
        data["soidOrdersMergeDirectPOsForSameSO"] = this.soidOrdersMergeDirectPOsForSameSO;
        data["soidOrdersWarnIfVehicleTypeNotSet"] = this.soidOrdersWarnIfVehicleTypeNotSet;
        data["soidOrdersCallOffScheduleColumn1Heading"] = this.soidOrdersCallOffScheduleColumn1Heading;
        data["soidOrdersCallOffScheduleColumn2Heading"] = this.soidOrdersCallOffScheduleColumn2Heading;
        data["soidOrdersPromptForPacksIfAlwaysPackSelling"] = this.soidOrdersPromptForPacksIfAlwaysPackSelling;
        data["soidOrdersAllowIssuingStockFromOtherBranches"] = this.soidOrdersAllowIssuingStockFromOtherBranches;
        data["soidOrdersAllowIssuingBranchWithReadOnlyAccess"] = this.soidOrdersAllowIssuingBranchWithReadOnlyAccess;
        data["soidOrdersKeepDeliveryAddressForCollectSales"] = this.soidOrdersKeepDeliveryAddressForCollectSales;
        data["soidOrdersHideAvailableCreditOnSO"] = this.soidOrdersHideAvailableCreditOnSO;
        data["soidOrdersCopyProductInternalLineNotesToLineNotes"] = this.soidOrdersCopyProductInternalLineNotesToLineNotes;
        data["soidOrdersPromptToMarkOrderAsCollectedOnSaveAndClose"] = this.soidOrdersPromptToMarkOrderAsCollectedOnSaveAndClose;
        data["soidOrdersAllowChangeOfNotesAndTypeOnOrdersInvoiced"] = this.soidOrdersAllowChangeOfNotesAndTypeOnOrdersInvoiced;
        data["soidOrdersAllowFractionalKits"] = this.soidOrdersAllowFractionalKits;
        data["soidOrdersSortByBinLocationWhenConsolidatingProductLines"] = this.soidOrdersSortByBinLocationWhenConsolidatingProductLines;
        data["soidOrdersSpecialsCopyEnvironmentalStatus"] = this.soidOrdersSpecialsCopyEnvironmentalStatus;
        data["soidOrdersCanChangeSaleTypeIfCardholderNotPresentPayment"] = this.soidOrdersCanChangeSaleTypeIfCardholderNotPresentPayment;
        data["soidOrdersIgnoreAllowProceedonStockWarningforBackOrder"] = this.soidOrdersIgnoreAllowProceedonStockWarningforBackOrder;
        data["soidDisableOtherSizeOptionForStockByLengthProductsOnOrders"] = this.soidDisableOtherSizeOptionForStockByLengthProductsOnOrders;
        data["soidOrdersDisplayOrderNumberDialog"] = this.soidOrdersDisplayOrderNumberDialog;
        data["soidOrdersSkipOrderCompletionDialog"] = this.soidOrdersSkipOrderCompletionDialog;
        data["soidOrdersWarnSupplierMinAmountOnPOs"] = this.soidOrdersWarnSupplierMinAmountOnPOs;
        data["soidPickVehicleWhenMarkingOrderAsDelivered"] = this.soidPickVehicleWhenMarkingOrderAsDelivered;
        data["soidShowTotalQuantityInformationinCounterSales"] = this.soidShowTotalQuantityInformationinCounterSales;
        data["soidForceAddressSelectionInCounterSales"] = this.soidForceAddressSelectionInCounterSales;
        data["soidCopySellPriceAndCostOnSpecialOrderCopyFromBaseItem"] = this.soidCopySellPriceAndCostOnSpecialOrderCopyFromBaseItem;
        data["soidUpdateExistingPOOnDirectBO"] = this.soidUpdateExistingPOOnDirectBO;
        data["soidOrdersApplyEnvironmentalStatusRestrictions"] = this.soidOrdersApplyEnvironmentalStatusRestrictions;
        data["soidOrdersShowChangeInformationDuringPrint"] = this.soidOrdersShowChangeInformationDuringPrint;
        data["soidOrdersReasonCodeOnLineAmend"] = this.soidOrdersReasonCodeOnLineAmend;
        data["soidAllowLadingQuantityEntryDuringPicking"] = this.soidAllowLadingQuantityEntryDuringPicking;
        data["soidOrdersMinimumDepositThreshold"] = this.soidOrdersMinimumDepositThreshold;
        data["soidOrdersRequireFullPaymentWhenBelowMinimumDepositThreshold"] = this.soidOrdersRequireFullPaymentWhenBelowMinimumDepositThreshold;
        data["soidOrdersDisplayMinimumDepositOverrideButton"] = this.soidOrdersDisplayMinimumDepositOverrideButton;
        data["soidOrdersSpecialLinesOnCashSalesMustBePaidInFull"] = this.soidOrdersSpecialLinesOnCashSalesMustBePaidInFull;
        data["soidOrdersShowTaxAreaButton"] = this.soidOrdersShowTaxAreaButton;
        data["soidOrdersBackOrderReleaseCheckAvailableStock"] = this.soidOrdersBackOrderReleaseCheckAvailableStock;
        data["soidOrdersCheckMinimumDepositOnBackOrders"] = this.soidOrdersCheckMinimumDepositOnBackOrders;
        data["soidOrdersPromptForReferenceInCounter"] = this.soidOrdersPromptForReferenceInCounter;
        data["soidWarnWhenDateRequiredMonthsInAdvance"] = this.soidWarnWhenDateRequiredMonthsInAdvance;
        data["soidOrderFixOriginalQtyAt"] = this.soidOrderFixOriginalQtyAt;
        data["soidForceAddressSelectionInOperations"] = this.soidForceAddressSelectionInOperations;
        data["soidOrdersDisplayPaymentScreenOnModifiedDeliveredCashSale"] = this.soidOrdersDisplayPaymentScreenOnModifiedDeliveredCashSale;
        data["soidSalesOrderSetDefaultSupplierOnDirects"] = this.soidSalesOrderSetDefaultSupplierOnDirects;
        data["soidOrdersOpenPurchaseOrders"] = this.soidOrdersOpenPurchaseOrders;
        data["soidOrdersLargeKitProcessing"] = this.soidOrdersLargeKitProcessing;
        data["soidOrdersEnableEditQtyAndPriceInGrid"] = this.soidOrdersEnableEditQtyAndPriceInGrid;
        data["soidTransferCreatorModify"] = this.soidTransferCreatorModify;
        data["soidTransferCreatedByReceivingBranch"] = this.soidTransferCreatedByReceivingBranch;
        data["soidTransferAutoApplyDeliveryCosts"] = this.soidTransferAutoApplyDeliveryCosts;
        data["soidTransferReceiptConfirmationFormat"] = this.soidTransferReceiptConfirmationFormat;
        data["soidTransferCanChangeViaBranch"] = this.soidTransferCanChangeViaBranch;
        data["soidTransferCostCalculation"] = this.soidTransferCostCalculation;
        data["soidTransferReturnAutoApplyDeliveryCosts"] = this.soidTransferReturnAutoApplyDeliveryCosts;
        data["soidDefaultTransferSaleType"] = this.soidDefaultTransferSaleType;
        data["soidTransferSplitPacksToLoose"] = this.soidTransferSplitPacksToLoose;
        data["soidTransferRequireUpdateAccessForToBranch"] = this.soidTransferRequireUpdateAccessForToBranch;
        data["soidTransferAllowZeroCost"] = this.soidTransferAllowZeroCost;
        data["soidTransferAllowToBeLessThanCurrentCost"] = this.soidTransferAllowToBeLessThanCurrentCost;
        data["soidTransferRequirePackConfirmation"] = this.soidTransferRequirePackConfirmation;
        data["soidTransferApplyUplifts"] = this.soidTransferApplyUplifts;
        data["soidTransferBranchAccessLevelRequiredForFromBranch"] = this.soidTransferBranchAccessLevelRequiredForFromBranch;
        data["soidTransferReturnAtOriginalCost"] = this.soidTransferReturnAtOriginalCost;
        data["soidTransferRequireSendingBranchApproval"] = this.soidTransferRequireSendingBranchApproval;
        data["soidTransferApprovalRequiredBeforeAllocation"] = this.soidTransferApprovalRequiredBeforeAllocation;
        data["soidTransferSuggestionQuantity"] = this.soidTransferSuggestionQuantity;
        data["soidTransferDontApproveAllocateStockTransfersLinkedToPOUntilReceived"] = this.soidTransferDontApproveAllocateStockTransfersLinkedToPOUntilReceived;
        data["soidTransferReturnUseOriginalBranchInGLTransferUplift"] = this.soidTransferReturnUseOriginalBranchInGLTransferUplift;
        data["soidTransferDateRequiredFromManufacturedSpecials"] = this.soidTransferDateRequiredFromManufacturedSpecials;
        data["soidCalculateBranchTransferCostsBasedOnTotalValues"] = this.soidCalculateBranchTransferCostsBasedOnTotalValues;
        data["soidTransferDateRequiredDaysBetweenPOAndLinkTransfers"] = this.soidTransferDateRequiredDaysBetweenPOAndLinkTransfers;
        data["soidTransferUpdateDateRequiredWhenLinkedSODateRequiredChanges"] = this.soidTransferUpdateDateRequiredWhenLinkedSODateRequiredChanges;
        data["soidOrdersNewOneTimeAddressIsBlank"] = this.soidOrdersNewOneTimeAddressIsBlank;
        data["soidTransferReceiveInBranchesNotLoggedIn"] = this.soidTransferReceiveInBranchesNotLoggedIn;
        data["soidTransferCopyOrderLineAVOsToTransferLineWhenSourcedFromTransfer"] = this.soidTransferCopyOrderLineAVOsToTransferLineWhenSourcedFromTransfer;
        data["soidTransferUseVMICostForBranchTransferCostOnVMIProducts"] = this.soidTransferUseVMICostForBranchTransferCostOnVMIProducts;
        data["soidOrdersCopyFromSelectMultipleTemplates"] = this.soidOrdersCopyFromSelectMultipleTemplates;
        data["soidUpdateSpecialOrderCostOnChangesOnPO_SR_SI"] = this.soidUpdateSpecialOrderCostOnChangesOnPO_SR_SI;
        data["soidLumpSumSectionsOnCopyFrom"] = this.soidLumpSumSectionsOnCopyFrom;
        data["soidConsolidatePositiveQuantitiesWithinSectionsByDefault"] = this.soidConsolidatePositiveQuantitiesWithinSectionsByDefault;
        data["soidOpenOrderLinePropertiesForRelatedProducts"] = this.soidOpenOrderLinePropertiesForRelatedProducts;
        data["soidOrdersNotifyIfDeletedLinesOnSalesTransactionCopy"] = this.soidOrdersNotifyIfDeletedLinesOnSalesTransactionCopy;
        data["soidOrderSectionsToMaintainSectionPrice"] = this.soidOrderSectionsToMaintainSectionPrice;
        data["soidBackToBackIgnoresHowSourced"] = this.soidBackToBackIgnoresHowSourced;
        data["soidSectionSelectionBoxType"] = this.soidSectionSelectionBoxType;
        data["soidOrdersPromptForBuyPriceRuleOnBackToBackPO"] = this.soidOrdersPromptForBuyPriceRuleOnBackToBackPO;
        data["soidOrdersAllowChangingSaleTypeAndDeliveryAfterPicking"] = this.soidOrdersAllowChangingSaleTypeAndDeliveryAfterPicking;
        data["soidOrdersAllowChangingScheduledSalesOrders"] = this.soidOrdersAllowChangingScheduledSalesOrders;
        data["soidDefaultAddressTypeWhenCreatedFromSalesOrders"] = this.soidDefaultAddressTypeWhenCreatedFromSalesOrders;
        data["soidCreateJobAddressesInSalesTransactionWithQuickJobScreen"] = this.soidCreateJobAddressesInSalesTransactionWithQuickJobScreen;
        data["soidApplyPermissionsOnChangesWithPickingNotePrintedToDeliveredOrdersOnly"] = this.soidApplyPermissionsOnChangesWithPickingNotePrintedToDeliveredOrdersOnly;
        data["soidTransfersAdvanceDaysFromOrder"] = this.soidTransfersAdvanceDaysFromOrder;
        data["soidAllowEditingKitsAfterBackToBackPurchaseOrderApproved"] = this.soidAllowEditingKitsAfterBackToBackPurchaseOrderApproved;
        data["soidParkOrdersWhenWorkOrderDateRequiredFull"] = this.soidParkOrdersWhenWorkOrderDateRequiredFull;
        data["soidOrdersPromptDuringOrderEntryWhenDefaultBatchDoesNotExist"] = this.soidOrdersPromptDuringOrderEntryWhenDefaultBatchDoesNotExist;
        data["soidOrdersPromptDuringPickingWhenDefaultBatchDoesNotExist"] = this.soidOrdersPromptDuringPickingWhenDefaultBatchDoesNotExist;
        data["soidSuggestedOrdersIncludeSuggestionsInStockAvailable"] = this.soidSuggestedOrdersIncludeSuggestionsInStockAvailable;
        data["soidAllowAdjustmentOfQuantityDuringReceiptOfStockTransfer"] = this.soidAllowAdjustmentOfQuantityDuringReceiptOfStockTransfer;
        data["soidReasonCodeForACAGenearatedFromQuantityAdjustmentTransfers"] = this.soidReasonCodeForACAGenearatedFromQuantityAdjustmentTransfers;
        data["soidOrdersUseAlternatePaymentTermsByProductGroup"] = this.soidOrdersUseAlternatePaymentTermsByProductGroup;
        data["soidWMSOnlyReleaseLinesAvailForPickWhenSplitDelivAllowed"] = this.soidWMSOnlyReleaseLinesAvailForPickWhenSplitDelivAllowed;
        data["soidFindProductSmartView1"] = this.soidFindProductSmartView1;
        data["soidFindProductSmartView2"] = this.soidFindProductSmartView2;
        data["soidFindProductSmartView3"] = this.soidFindProductSmartView3;
        data["soidFindProductSmartView4"] = this.soidFindProductSmartView4;
        data["soidFindProductSmartView5"] = this.soidFindProductSmartView5;
        data["soidFindCustomerSmartView1"] = this.soidFindCustomerSmartView1;
        data["soidFindCustomerSmartView2"] = this.soidFindCustomerSmartView2;
        data["soidFindCustomerSmartView3"] = this.soidFindCustomerSmartView3;
        data["soidFindCustomerSmartView4"] = this.soidFindCustomerSmartView4;
        data["soidFindCustomerSmartView5"] = this.soidFindCustomerSmartView5;
        data["soidJourneyPlannerSmartView1"] = this.soidJourneyPlannerSmartView1;
        data["soidJourneyPlannerSmartView2"] = this.soidJourneyPlannerSmartView2;
        data["soidJourneyPlannerSmartView3"] = this.soidJourneyPlannerSmartView3;
        data["soidJourneyPlannerSmartView4"] = this.soidJourneyPlannerSmartView4;
        data["soidJourneyPlannerSmartView5"] = this.soidJourneyPlannerSmartView5;
        data["soidOrderQuotesForceFollowUp"] = this.soidOrderQuotesForceFollowUp;
        data["soidOrderQuotesFollowUpDays"] = this.soidOrderQuotesFollowUpDays;
        data["soidOrderQuotesFollowUpNotepadType"] = this.soidOrderQuotesFollowUpNotepadType;
        data["soidOrderQuotesApplyMarginWarningAndStops"] = this.soidOrderQuotesApplyMarginWarningAndStops;
        data["soidOrderQuotesAllowPark"] = this.soidOrderQuotesAllowPark;
        data["soidOrderQuotesAllowPrintWhenSupplierRequestExists"] = this.soidOrderQuotesAllowPrintWhenSupplierRequestExists;
        data["soidOrderQuotesCopyCreatedByUserAndOrderingBranch"] = this.soidOrderQuotesCopyCreatedByUserAndOrderingBranch;
        data["soidOrderQuotesAllowMultipleAccept"] = this.soidOrderQuotesAllowMultipleAccept;
        data["soidOrderQuotesForceRecalculateWhenAcceptingExpiredQuote"] = this.soidOrderQuotesForceRecalculateWhenAcceptingExpiredQuote;
        data["soidOrderQuotesUseTakenByFromQuoteWhenAcceptingIntoOrder"] = this.soidOrderQuotesUseTakenByFromQuoteWhenAcceptingIntoOrder;
        data["soidOrderQuotesAllowBlankText"] = this.soidOrderQuotesAllowBlankText;
        data["soidOrderQuotesExcludeQuotesFromPromotionalPricing"] = this.soidOrderQuotesExcludeQuotesFromPromotionalPricing;
        data["soidOrdersDontCompleteOrdersWhenWorkOrdersNeedStock"] = this.soidOrdersDontCompleteOrdersWhenWorkOrdersNeedStock;
        data["soidOrdersCompleteDeliveredOrdersWhenDateRequiredIsFull"] = this.soidOrdersCompleteDeliveredOrdersWhenDateRequiredIsFull;
        data["soidUseSearchForTakenBy"] = this.soidUseSearchForTakenBy;
        data["soidSimpleOrderProcessCollectNow"] = this.soidSimpleOrderProcessCollectNow;
        data["soidSimpleOrderProcessCollectLater"] = this.soidSimpleOrderProcessCollectLater;
        data["soidSimpleOrderProcessDelivered"] = this.soidSimpleOrderProcessDelivered;
        data["soidSimpleOrderProcessDirect"] = this.soidSimpleOrderProcessDirect;
        data["soidSimpleOrderProcessTransfer"] = this.soidSimpleOrderProcessTransfer;
        data["soidSimpleOrderControlAVOProcessing"] = this.soidSimpleOrderControlAVOProcessing;
        data["soidSimpleOrderPreAllocateOrderInvoiceNo"] = this.soidSimpleOrderPreAllocateOrderInvoiceNo;
        data["soidSimpleConfirmPicking"] = this.soidSimpleConfirmPicking;
        data["soidSimpleConfirmDelivery"] = this.soidSimpleConfirmDelivery;
        data["soidSimpleConfirmPODReturned"] = this.soidSimpleConfirmPODReturned;
        data["soidSimplePrintPickingNoteOnPark"] = this.soidSimplePrintPickingNoteOnPark;
        data["soidSimpleDeliveryAfterPickingConfirmed"] = this.soidSimpleDeliveryAfterPickingConfirmed;
        data["soidSimpleOnlyAllowDeliveryPrintAfterMarked"] = this.soidSimpleOnlyAllowDeliveryPrintAfterMarked;
        data["soidSimpleAutoIssueOnMarkAsDelivered"] = this.soidSimpleAutoIssueOnMarkAsDelivered;
        data["soidSimpleOnlyInvoiceDirectsAfterSuppInv"] = this.soidSimpleOnlyInvoiceDirectsAfterSuppInv;
        data["soidSimpleAllowPickDeliveryPrintWhenWaitingForStock"] = this.soidSimpleAllowPickDeliveryPrintWhenWaitingForStock;
        data["soidSimpleDontIssueIfNegativeStock"] = this.soidSimpleDontIssueIfNegativeStock;
        data["soidSimplePickingNoteFormat"] = this.soidSimplePickingNoteFormat;
        data["soidSimpleDeliveryNoteFormat"] = this.soidSimpleDeliveryNoteFormat;
        data["soidSimpleCollectionNoteFormat"] = this.soidSimpleCollectionNoteFormat;
        data["soidSimpleDepositReceiptFormat"] = this.soidSimpleDepositReceiptFormat;
        data["soidSimpleDeliveryFormatSetCash"] = this.soidSimpleDeliveryFormatSetCash;
        data["soidSimpleOrderPickingStyle"] = this.soidSimpleOrderPickingStyle;
        data["soidSimpleOrderPickingZonesFormatNumbers"] = this.soidSimpleOrderPickingZonesFormatNumbers;
        data["soidSimpleTransferDeliveryFormatSet"] = this.soidSimpleTransferDeliveryFormatSet;
        data["soidSimplePrintDocumentsOnBackOrder"] = this.soidSimplePrintDocumentsOnBackOrder;
        data["soidSimpleOnlyInvoiceWhenCODFullyPaid"] = this.soidSimpleOnlyInvoiceWhenCODFullyPaid;
        data["soidSimpleOrderRecordPickingStarted"] = this.soidSimpleOrderRecordPickingStarted;
        data["soidSimpleOrderOnlyApproveIfJourneyComplete"] = this.soidSimpleOrderOnlyApproveIfJourneyComplete;
        data["soidSimpleAutoIssueOnInvoiceIfNotYetIssued"] = this.soidSimpleAutoIssueOnInvoiceIfNotYetIssued;
        data["soidSimpleAVOFormatSet"] = this.soidSimpleAVOFormatSet;
        data["soidSimpleAdditionalCostFormat"] = this.soidSimpleAdditionalCostFormat;
        data["soidSimplePromptForDeliveryInAdvancedPicking"] = this.soidSimplePromptForDeliveryInAdvancedPicking;
        data["soidSimplePromptUserIfQtyPickedNotEqualToQtyOrdered"] = this.soidSimplePromptUserIfQtyPickedNotEqualToQtyOrdered;
        data["soidSimpleDeliveryFormatSetCredit"] = this.soidSimpleDeliveryFormatSetCredit;
        data["soidSimpleCollectLaterFormatSetCash"] = this.soidSimpleCollectLaterFormatSetCash;
        data["soidSimpleCollectLaterFormatSetCredit"] = this.soidSimpleCollectLaterFormatSetCredit;
        data["soidSimpleRequireReasonCodeOnPickShortage"] = this.soidSimpleRequireReasonCodeOnPickShortage;
        data["soidSimplePrintPickingNoteWhenStockAvailable"] = this.soidSimplePrintPickingNoteWhenStockAvailable;
        data["soidSimpleDepositReceiptOnFinalPayment"] = this.soidSimpleDepositReceiptOnFinalPayment;
        data["soidDefaultBackOrderBehaviourInAdvancedPicking"] = this.soidDefaultBackOrderBehaviourInAdvancedPicking;
        data["soidSimpleCollectNowPickingDocumentFormatSet"] = this.soidSimpleCollectNowPickingDocumentFormatSet;
        data["soidSimpleAllowAutoMarkPickWhenUsingAdvancedPicking"] = this.soidSimpleAllowAutoMarkPickWhenUsingAdvancedPicking;
        data["soidSimpleAutoPrintSpecialOrderAcknowledgementDocument"] = this.soidSimpleAutoPrintSpecialOrderAcknowledgementDocument;
        data["soidSimpleSpecialOrderAcknowledgementDocumentFormatSet"] = this.soidSimpleSpecialOrderAcknowledgementDocumentFormatSet;
        data["soidSimpleDisplayBinLocationOnPickingConfirmation"] = this.soidSimpleDisplayBinLocationOnPickingConfirmation;
        data["soidSimpleAllowPackReferenceScanningOnPickingConfirmation"] = this.soidSimpleAllowPackReferenceScanningOnPickingConfirmation;
        data["soidSimpleAllowPickingNotePrintOnDeliveredCashSaleWithOutstandingBalance"] = this.soidSimpleAllowPickingNotePrintOnDeliveredCashSaleWithOutstandingBalance;
        data["soidSimpleAllowdeliveryNotePrintOnDeliveredCashSaleWithOutstandingBalance"] = this.soidSimpleAllowdeliveryNotePrintOnDeliveredCashSaleWithOutstandingBalance;
        data["soidSimpleOrderAmendPrintFormatSet"] = this.soidSimpleOrderAmendPrintFormatSet;
        data["soidSimpleOrderAmendPrintHandling"] = this.soidSimpleOrderAmendPrintHandling;
        data["soidSimpleOrderAllowUnpickIfInvoiced"] = this.soidSimpleOrderAllowUnpickIfInvoiced;
        data["soidDefaultPrintDeliveryNoteDocumentSet"] = this.soidDefaultPrintDeliveryNoteDocumentSet;
        data["soidPrintDeliveryNoteFormatWhenMarkingDelivered"] = this.soidPrintDeliveryNoteFormatWhenMarkingDelivered;
        data["soidOrderAllowQuantityLessThanPicked"] = this.soidOrderAllowQuantityLessThanPicked;
        data["soidSimpleOrderDefaultPickingZoneFromOrderMonitor"] = this.soidSimpleOrderDefaultPickingZoneFromOrderMonitor;
        data["soidSimpleOrderHideItemsWhichAreNotInSelectedZone"] = this.soidSimpleOrderHideItemsWhichAreNotInSelectedZone;
        data["soidSimpleOrderDefaultMOLTasPickedInAdvancedPicking"] = this.soidSimpleOrderDefaultMOLTasPickedInAdvancedPicking;
        data["soidSimpleOrderOnlyReleaseBackOrderWithSingleDeliveryOption"] = this.soidSimpleOrderOnlyReleaseBackOrderWithSingleDeliveryOption;
        data["soidSimpleConfirmChecked"] = this.soidSimpleConfirmChecked;
        data["soidDefaultPrintPickingNoteWhenMarkingPickStarted"] = this.soidDefaultPrintPickingNoteWhenMarkingPickStarted;
        data["soidScanActionBarcodesInBatchUpdate"] = this.soidScanActionBarcodesInBatchUpdate;
        data["soidSimpleDeliveryAfterChecked"] = this.soidSimpleDeliveryAfterChecked;
        data["soidOrdersAllowCompleteWhenJobIsPreliminary"] = this.soidOrdersAllowCompleteWhenJobIsPreliminary;
        data["soidCheckPickingRequiredFlagWhenDeterminingPickingZonePrintingFormats"] = this.soidCheckPickingRequiredFlagWhenDeterminingPickingZonePrintingFormats;
        data["soidSimpleOrderSetDefaultReleaseQuantityToAll"] = this.soidSimpleOrderSetDefaultReleaseQuantityToAll;
        data["soidIncludeUnapprovedOrdersInOrdersForInvoicingFilter"] = this.soidIncludeUnapprovedOrdersInOrdersForInvoicingFilter;
        data["soidOrdersAllowChangingUOMsinQtyAndQtyPriceEntry"] = this.soidOrdersAllowChangingUOMsinQtyAndQtyPriceEntry;
        data["soidShowMsgWhenPickingLessSpecialOrderThanAvailable"] = this.soidShowMsgWhenPickingLessSpecialOrderThanAvailable;
        data["soidSimpleOrderLimitPickingAndCheckedByUsersByBranch"] = this.soidSimpleOrderLimitPickingAndCheckedByUsersByBranch;
        data["soidSimpleOrderDefaultPickingStartedUserToFirstAvailable"] = this.soidSimpleOrderDefaultPickingStartedUserToFirstAvailable;
        data["soidPrintDeliveryNoteDocumentSetWhenMarkingDelvOrdersPicked"] = this.soidPrintDeliveryNoteDocumentSetWhenMarkingDelvOrdersPicked;
        data["soidSimpleOrderRecordPickComplete"] = this.soidSimpleOrderRecordPickComplete;
        data["soidPromptSignatureWhenCompletingCollectNowOrderThatGoesCreditHold"] = this.soidPromptSignatureWhenCompletingCollectNowOrderThatGoesCreditHold;
        data["soidPromptSignatureWhenChangingWMSOrderTypeToCollectLaterNow"] = this.soidPromptSignatureWhenChangingWMSOrderTypeToCollectLaterNow;
        data["soidUseSignatureCaptureSettingsForCollectNowWhenCompletingCollectLaterNow"] = this.soidUseSignatureCaptureSettingsForCollectNowWhenCompletingCollectLaterNow;
        data["soidSimpleOrderEnableMarkFullyPicked"] = this.soidSimpleOrderEnableMarkFullyPicked;
        data["soidDisplayAwaitingStockWarningMessagesInPickingConfirmation"] = this.soidDisplayAwaitingStockWarningMessagesInPickingConfirmation;
        data["soidBackOrderEntireSingleDeliveryOrderWhenAnyLineBackOrdered"] = this.soidBackOrderEntireSingleDeliveryOrderWhenAnyLineBackOrdered;
        data["soidWMSDefaultBackOrderBehaviour"] = this.soidWMSDefaultBackOrderBehaviour;
        data["soidWMSMarkOrdersDeliveredWhenPickCompletedFromWMS"] = this.soidWMSMarkOrdersDeliveredWhenPickCompletedFromWMS;
        data["soidCashSalesPercentToleranceForTalliedTimber"] = this.soidCashSalesPercentToleranceForTalliedTimber;
        data["soidCashSalesAmountToleranceForTalliedTimber"] = this.soidCashSalesAmountToleranceForTalliedTimber;
        data["soidCashSalesPercentToleranceForNonTalliedTimber"] = this.soidCashSalesPercentToleranceForNonTalliedTimber;
        data["soidCashSalesAmountToleranceForNonTalliedTimber"] = this.soidCashSalesAmountToleranceForNonTalliedTimber;
        data["soidCashSalesPercentToleranceForProductSubstitutions"] = this.soidCashSalesPercentToleranceForProductSubstitutions;
        data["soidCashSalesAmountToleranceForProductSubstitutions"] = this.soidCashSalesAmountToleranceForProductSubstitutions;
        data["soidCashSalesRestrictFullyPaidCashSaleToSameProductGroup"] = this.soidCashSalesRestrictFullyPaidCashSaleToSameProductGroup;
        data["soidCashSalesRunWithNewCashBehaviour"] = this.soidCashSalesRunWithNewCashBehaviour;
        data["soidCashSalesEnableToleranceChecking"] = this.soidCashSalesEnableToleranceChecking;
        data["soidCashSalesAutoFinalizeDaily"] = this.soidCashSalesAutoFinalizeDaily;
        data["soidCashSalesForceAddressCollectNow"] = this.soidCashSalesForceAddressCollectNow;
        data["soidCashSalesForceAddressCollectLater"] = this.soidCashSalesForceAddressCollectLater;
        data["soidCashSalesOrderMaximumCashAllowed"] = this.soidCashSalesOrderMaximumCashAllowed;
        data["soidCashSalesAllowDepositGreaterThanOrderTotal"] = this.soidCashSalesAllowDepositGreaterThanOrderTotal;
        data["soidCashSalesPostCheckOverpaymentAsChangeDue"] = this.soidCashSalesPostCheckOverpaymentAsChangeDue;
        data["soidSimpleOnlyAllowDeliverySetPrintAfterMarked"] = this.soidSimpleOnlyAllowDeliverySetPrintAfterMarked;
        data["soidForceSelectionOfReasonCodeForLodgement"] = this.soidForceSelectionOfReasonCodeForLodgement;
        data["soidCashSalesRetainInvoiceAddressWhenCopyingCashSales"] = this.soidCashSalesRetainInvoiceAddressWhenCopyingCashSales;
        data["soidCashSalesDepositReceiptOnBackOrders"] = this.soidCashSalesDepositReceiptOnBackOrders;
        data["soidDefaultLodgementPostingDate"] = this.soidDefaultLodgementPostingDate;
        data["soidAllowLodgementsOnCreditAndDebitCards"] = this.soidAllowLodgementsOnCreditAndDebitCards;
        data["soidSortPaymentMethodByPaymentMethodCode"] = this.soidSortPaymentMethodByPaymentMethodCode;
        data["soidReturnToPaymentDetailsAfterFullyPaid"] = this.soidReturnToPaymentDetailsAfterFullyPaid;
        data["soidCashSalesAllowDeliveryCollectionOfUnpaid"] = this.soidCashSalesAllowDeliveryCollectionOfUnpaid;
        data["soidDefaultContractSchedule"] = this.soidDefaultContractSchedule;
        data["soidPostInstalledSalesShipmentsToManualOrderInvoicingLines"] = this.soidPostInstalledSalesShipmentsToManualOrderInvoicingLines;
        data["soidPostSalesAmountAtTimeOfMaterialShipment"] = this.soidPostSalesAmountAtTimeOfMaterialShipment;
        data["soidForceSelectionOfAddressOnContractCreation"] = this.soidForceSelectionOfAddressOnContractCreation;
        data["soidDefaultOrdersAndCallOffsToUseOpenContracts"] = this.soidDefaultOrdersAndCallOffsToUseOpenContracts;
        data["soidAllowMultipleCallOffOrdersOnContracts"] = this.soidAllowMultipleCallOffOrdersOnContracts;
        data["soidDefaultMarginForPostCostToWIPMethod"] = this.soidDefaultMarginForPostCostToWIPMethod;
        data["soidAccruedARInstalledSalesVarianceMOLT"] = this.soidAccruedARInstalledSalesVarianceMOLT;
        data["soidContractsCopyFromDefaultDocType"] = this.soidContractsCopyFromDefaultDocType;
        data["soidContractsCopyFromDefaultConsolidateByMOLT"] = this.soidContractsCopyFromDefaultConsolidateByMOLT;
        data["soidAllowSettingTaxAreaOnContracts"] = this.soidAllowSettingTaxAreaOnContracts;
        data["soidContractsIncludeSalesTaxAmountDuringCopySections"] = this.soidContractsIncludeSalesTaxAmountDuringCopySections;
        data["soidAllowSettingRetentionPercentageOnContractInvoicingLines"] = this.soidAllowSettingRetentionPercentageOnContractInvoicingLines;
        data["soidAutoCloseContractsWithNoTransactionsInNumberOfDays"] = this.soidAutoCloseContractsWithNoTransactionsInNumberOfDays;
        data["soidIncludeTaxInRetentionCalculations"] = this.soidIncludeTaxInRetentionCalculations;
        data["soidAllowSelectingJobAddressOnContractBillingLine"] = this.soidAllowSelectingJobAddressOnContractBillingLine;
        data["soidShowTimberFunctionality"] = this.soidShowTimberFunctionality;
        data["soidTimberSplitPackRefSuffix"] = this.soidTimberSplitPackRefSuffix;
        data["soidTimberAllowSplitToLoose"] = this.soidTimberAllowSplitToLoose;
        data["soidTimberSplitPackVolumeWarningTreshold"] = this.soidTimberSplitPackVolumeWarningTreshold;
        data["soidTimberDuplicatePackReferenceOption"] = this.soidTimberDuplicatePackReferenceOption;
        data["soidTimberTallyLengthDecimalPlaces"] = this.soidTimberTallyLengthDecimalPlaces;
        data["soidTimberPackTallyInput"] = this.soidTimberPackTallyInput;
        data["soidTimberAutoAllocatePackBarCodes"] = this.soidTimberAutoAllocatePackBarCodes;
        data["soidTimberAllowDecimalPlacesOnNumberOfSheets"] = this.soidTimberAllowDecimalPlacesOnNumberOfSheets;
        data["soidTimberInputAdvanced"] = this.soidTimberInputAdvanced;
        data["soidTimberInputShowStdLengths"] = this.soidTimberInputShowStdLengths;
        data["soidTimberInputNoOfBlankRows"] = this.soidTimberInputNoOfBlankRows;
        data["soidTimberInputColumnSequence"] = this.soidTimberInputColumnSequence;
        data["soidTimberAutoSetPackType"] = this.soidTimberAutoSetPackType;
        data["soidTimberPercForAPTL"] = this.soidTimberPercForAPTL;
        data["soidTimberInputMaskContractRef"] = this.soidTimberInputMaskContractRef;
        data["soidTimberInputMaskContractPeriod"] = this.soidTimberInputMaskContractPeriod;
        data["soidTimberInputMaskShip"] = this.soidTimberInputMaskShip;
        data["soidTimberInputMaskVoyage"] = this.soidTimberInputMaskVoyage;
        data["soidTimberInputMaskBOLRef"] = this.soidTimberInputMaskBOLRef;
        data["soidTimberInputMaskShipPackRef"] = this.soidTimberInputMaskShipPackRef;
        data["soidTimberPackVolFormatString"] = this.soidTimberPackVolFormatString;
        data["soidTimberPackShowPackEstimate"] = this.soidTimberPackShowPackEstimate;
        data["soidTimberDefaultStatusOnStockReceipt"] = this.soidTimberDefaultStatusOnStockReceipt;
        data["soidTimberPackQuantityAbbreviation"] = this.soidTimberPackQuantityAbbreviation;
        data["soidTimberSplitPackAllowHigherVolume"] = this.soidTimberSplitPackAllowHigherVolume;
        data["soidTimberUsePackSubstitution"] = this.soidTimberUsePackSubstitution;
        data["soidTimberPackVolDecimalPlaces"] = this.soidTimberPackVolDecimalPlaces;
        data["soidTimberPackLengthDecimalPlaces"] = this.soidTimberPackLengthDecimalPlaces;
        data["soidTimberPackFindDefaultView"] = this.soidTimberPackFindDefaultView;
        data["soidTimberPackTallyDisplayAvailableOrActual"] = this.soidTimberPackTallyDisplayAvailableOrActual;
        data["soidTimberSplitPackReasonCode"] = this.soidTimberSplitPackReasonCode;
        data["soidTimberInputRoundToNearestTallyLength"] = this.soidTimberInputRoundToNearestTallyLength;
        data["soidTimberUseTallyCalculator"] = this.soidTimberUseTallyCalculator;
        data["soidTimberStockShortageWarningOnSOTally"] = this.soidTimberStockShortageWarningOnSOTally;
        data["soidTimberOrdersShowInvalidTallyWarnings"] = this.soidTimberOrdersShowInvalidTallyWarnings;
        data["soidTimberAllowBulkChangeStockLocationOnFreePacks"] = this.soidTimberAllowBulkChangeStockLocationOnFreePacks;
        data["soidTimberDefaultNATalliedScreenToSplitTallyOnPO"] = this.soidTimberDefaultNATalliedScreenToSplitTallyOnPO;
        data["soidTimberAllowDifferentTallySelectionOnSalesTransactions"] = this.soidTimberAllowDifferentTallySelectionOnSalesTransactions;
        data["soidTimberRetainPackRefWhenReuseSourceOnWorksOrders"] = this.soidTimberRetainPackRefWhenReuseSourceOnWorksOrders;
        data["soidTimberIncludeFreePacksAsAvailable"] = this.soidTimberIncludeFreePacksAsAvailable;
        data["soidTimberIncludePackStockAsAvailableOnTallyInput"] = this.soidTimberIncludePackStockAsAvailableOnTallyInput;
        data["soidTimberInputLimitToNoOfBlankRows"] = this.soidTimberInputLimitToNoOfBlankRows;
        data["soidTimberDisplayTallyLengthsInProductFindForAvailableStock"] = this.soidTimberDisplayTallyLengthsInProductFindForAvailableStock;
        data["soidTimberDefaultUsePackPriceSurcharge"] = this.soidTimberDefaultUsePackPriceSurcharge;
        data["soidTimberAllowDifferentTallySelectionOnWorksOrderSourceLines"] = this.soidTimberAllowDifferentTallySelectionOnWorksOrderSourceLines;
        data["soidTimberCopyParentTallyAndQuantityToNotesWhenTallySplit"] = this.soidTimberCopyParentTallyAndQuantityToNotesWhenTallySplit;
        data["soidPacksAutoSplitOnPackConfirmation"] = this.soidPacksAutoSplitOnPackConfirmation;
        data["soidPacksCopyAttachmentsDuringSplit"] = this.soidPacksCopyAttachmentsDuringSplit;
        data["soidPacksReuseSourcePacksOnFinishedProducts"] = this.soidPacksReuseSourcePacksOnFinishedProducts;
        data["soidAllowPartialCreditOfTaggedPacks"] = this.soidAllowPartialCreditOfTaggedPacks;
        data["soidTimberShowProductLinealFeetPercentage"] = this.soidTimberShowProductLinealFeetPercentage;
        data["soidShowSteelFunctionality"] = this.soidShowSteelFunctionality;
        data["soidProfileSalesAnalysisCode"] = this.soidProfileSalesAnalysisCode;
        data["soidDefaultProfileMachine"] = this.soidDefaultProfileMachine;
        data["soidDefaultProfileManualOrderLineType"] = this.soidDefaultProfileManualOrderLineType;
        data["soidSteelPickingWeightDifferenceLow"] = this.soidSteelPickingWeightDifferenceLow;
        data["soidSteelPickingWeightDifferenceHigh"] = this.soidSteelPickingWeightDifferenceHigh;
        data["soidAllowWeightAsStockingUnitOfMeasure"] = this.soidAllowWeightAsStockingUnitOfMeasure;
        data["soidEnableAlternateUnitOfMeasureForTallyLengths"] = this.soidEnableAlternateUnitOfMeasureForTallyLengths;
        data["soidShowTestCertificateFunctionality"] = this.soidShowTestCertificateFunctionality;
        data["soidTestCertificateAttachmentFolder"] = this.soidTestCertificateAttachmentFolder;
        data["soidEnableAVOTolerances"] = this.soidEnableAVOTolerances;
        data["soidMetalConformanceCertificateFormatNumber"] = this.soidMetalConformanceCertificateFormatNumber;
        data["soidOrdersOrderLineAdditionalInfoDisplay"] = this.soidOrdersOrderLineAdditionalInfoDisplay;
        data["soidSignatureCaptureDelivered"] = this.soidSignatureCaptureDelivered;
        data["soidSignatureCaptureDirect"] = this.soidSignatureCaptureDirect;
        data["soidSignatureCaptureCollectLaterCash"] = this.soidSignatureCaptureCollectLaterCash;
        data["soidCalculateDeliveryChargesCostsBasedOnTotalValues"] = this.soidCalculateDeliveryChargesCostsBasedOnTotalValues;
        data["soidCalculateDeliveryChargesAtLineLevelOnly"] = this.soidCalculateDeliveryChargesAtLineLevelOnly;
        data["soidRequireUserToAcceptSignaturesFromSignatureCapture"] = this.soidRequireUserToAcceptSignaturesFromSignatureCapture;
        data["soidDisplayMarginAndCostDuringQuickAddEntry"] = this.soidDisplayMarginAndCostDuringQuickAddEntry;
        data["soidDisplayExtendedOrderLineQuantityInformation"] = this.soidDisplayExtendedOrderLineQuantityInformation;
        data["soidOrdersAllowDisablingAndEditingOfDeliveryChargesWithPermission"] = this.soidOrdersAllowDisablingAndEditingOfDeliveryChargesWithPermission;
        data["soidOrdersShowSaleTypeInDocumentInformationBar"] = this.soidOrdersShowSaleTypeInDocumentInformationBar;
        data["soidOrdersBackOrderReleaseCheckPackAndLooseAvailableStock"] = this.soidOrdersBackOrderReleaseCheckPackAndLooseAvailableStock;
        data["soidOrdersForceUpperCaseAddress"] = this.soidOrdersForceUpperCaseAddress;
        data["soidUpdateSpecialOrderSalesQuantityWithQuantityReceived"] = this.soidUpdateSpecialOrderSalesQuantityWithQuantityReceived;
        data["soidAllowCompanyChequeOnOrdersCreatedFromCreditNotes"] = this.soidAllowCompanyChequeOnOrdersCreatedFromCreditNotes;
        data["soidOrdersCustomerJobInstructionsAsAutoText"] = this.soidOrdersCustomerJobInstructionsAsAutoText;
        data["soidOrdersCalcDeliveryAndAllowCODonOrdersWithJustMOLTlines"] = this.soidOrdersCalcDeliveryAndAllowCODonOrdersWithJustMOLTlines;
        data["soidOrdersUsingF6GoesToCustomerField"] = this.soidOrdersUsingF6GoesToCustomerField;
        data["soidOrdersProrateDepositsDuringBackOrder"] = this.soidOrdersProrateDepositsDuringBackOrder;
        data["soidOrdersOpenPurchaseOrdersOnSalesOrderUpdate"] = this.soidOrdersOpenPurchaseOrdersOnSalesOrderUpdate;
        data["soidOrdersAutomaticallyReleaseBackOrders"] = this.soidOrdersAutomaticallyReleaseBackOrders;
        data["soidOrdersAllowChangeOfVehicleAndDeliveryTimeOnOrdersInvoiced"] = this.soidOrdersAllowChangeOfVehicleAndDeliveryTimeOnOrdersInvoiced;
        data["soidCheckMinimumDepositWhenOrderIsModified"] = this.soidCheckMinimumDepositWhenOrderIsModified;
        data["soidDisableAdditionalCostDeliveryChargesWhenDeliveryChargesAreDisabled"] = this.soidDisableAdditionalCostDeliveryChargesWhenDeliveryChargesAreDisabled;
        data["soidbTAStatementsAlwaysPrintImages"] = this.soidbTAStatementsAlwaysPrintImages;
        data["soidbTAFinanceChargeDefaultOverdueBy"] = this.soidbTAFinanceChargeDefaultOverdueBy;
        data["soidbTAFinanceChargeDefaultMonthlyFinanceChargePercent"] = this.soidbTAFinanceChargeDefaultMonthlyFinanceChargePercent;
        data["soidbTAFinanceChargeDefaultRevolvingAccountGrace"] = this.soidbTAFinanceChargeDefaultRevolvingAccountGrace;
        data["soidbTAStatementGenerateDefaultIncludeCustomersWithNoTransactions"] = this.soidbTAStatementGenerateDefaultIncludeCustomersWithNoTransactions;
        data["soidbTAStatementGenerateDefaultTransactionsToInclude"] = this.soidbTAStatementGenerateDefaultTransactionsToInclude;
        data["soidbTAStatementGenerateDefaultConsolidateGroupAccounts"] = this.soidbTAStatementGenerateDefaultConsolidateGroupAccounts;
        data["soidbTAStatementGenerateDefaultIndividualChildStatements"] = this.soidbTAStatementGenerateDefaultIndividualChildStatements;
        data["soidbTAStatementSendDefaultIncludeStatementsWithZeroBalance"] = this.soidbTAStatementSendDefaultIncludeStatementsWithZeroBalance;
        data["soidbTAStatementSendDefaultIncludeFullyPaidTransactions"] = this.soidbTAStatementSendDefaultIncludeFullyPaidTransactions;
        data["soidbTACustomerStatementByJobReportName"] = this.soidbTACustomerStatementByJobReportName;
        data["soidbTASummaryStatementReportName"] = this.soidbTASummaryStatementReportName;
        data["soidbTAAllowGeneratingStatementsByJob"] = this.soidbTAAllowGeneratingStatementsByJob;
        data["soidbTACanGenerateFinChargesByCustomerGroup"] = this.soidbTACanGenerateFinChargesByCustomerGroup;
        data["soidbTADefaultAccountPaymentToCustomersHomeBranch"] = this.soidbTADefaultAccountPaymentToCustomersHomeBranch;
        data["soidbTAAccountPaymentCreditCardSurchargePercentage"] = this.soidbTAAccountPaymentCreditCardSurchargePercentage;
        data["soidbTADirectPostingReasonCodeForAccountPaymentCreditCardSurcharge"] = this.soidbTADirectPostingReasonCodeForAccountPaymentCreditCardSurcharge;
        data["soidbTAAccountPaymentCreditCardSurchargeType"] = this.soidbTAAccountPaymentCreditCardSurchargeType;
        data["soidbTAAllowMatchingTransactionsBetweenARAccounts"] = this.soidbTAAllowMatchingTransactionsBetweenARAccounts;
        data["soidbTAReasonCodeToUseForInterBranchDirectPostings"] = this.soidbTAReasonCodeToUseForInterBranchDirectPostings;
        data["soidbTAAllowSelectionOfPaymentMethodInBatchCasPosting"] = this.soidbTAAllowSelectionOfPaymentMethodInBatchCasPosting;
        data["soidbTAUseAcctPmtsInsteadOfCashPosting"] = this.soidbTAUseAcctPmtsInsteadOfCashPosting;
        data["soidbTAAllowTakingDepositsOnARSalesOrders"] = this.soidbTAAllowTakingDepositsOnARSalesOrders;
        data["soidPopupJourneyDateVisible"] = this.soidPopupJourneyDateVisible;
        data["soidPopupJourneyDriverVisible"] = this.soidPopupJourneyDriverVisible;
        data["soidPopupJourneyVehicleVisible"] = this.soidPopupJourneyVehicleVisible;
        data["soidPopupJourneyWeightVisible"] = this.soidPopupJourneyWeightVisible;
        data["soidPopupJourneyDropsVisible"] = this.soidPopupJourneyDropsVisible;
        data["soidPopupJourneyVolumeVisible"] = this.soidPopupJourneyVolumeVisible;
        data["soidJourneyPlannerGroupJourneysByReference"] = this.soidJourneyPlannerGroupJourneysByReference;
        data["soidJourneyPlannerTimeFrame"] = this.soidJourneyPlannerTimeFrame;
        data["soidJourneyPlannerFirstDayOfWeek"] = this.soidJourneyPlannerFirstDayOfWeek;
        data["soidJourneyPlannerWorkingDays"] = this.soidJourneyPlannerWorkingDays;
        data["soidJourneyPlannerStartOfDay"] = this.soidJourneyPlannerStartOfDay;
        data["soidJourneyPlannerEndOfDay"] = this.soidJourneyPlannerEndOfDay;
        data["soidJourneyPlannerTimeInterval"] = this.soidJourneyPlannerTimeInterval;
        data["soidJourneyPlannerWeightDecimalPlaces"] = this.soidJourneyPlannerWeightDecimalPlaces;
        data["soidJourneyPlannerVolumeDecimalPlaces"] = this.soidJourneyPlannerVolumeDecimalPlaces;
        data["soidJourneyOnlyAllowTransportCostsForPicked"] = this.soidJourneyOnlyAllowTransportCostsForPicked;
        data["soidJourneyAllowCompleteWithNoTransportCost"] = this.soidJourneyAllowCompleteWithNoTransportCost;
        data["soidJourneyApplyTransportCostsOnCompletion"] = this.soidJourneyApplyTransportCostsOnCompletion;
        data["soidJourneyApplyTransportCostsTo"] = this.soidJourneyApplyTransportCostsTo;
        data["soidJourneyPromptForCreditHoldOrParkedOrders"] = this.soidJourneyPromptForCreditHoldOrParkedOrders;
        data["soidJourneyPlannerBranchViewDefault"] = this.soidJourneyPlannerBranchViewDefault;
        data["soidJourneyPlannerTimeIntervalForCalendar"] = this.soidJourneyPlannerTimeIntervalForCalendar;
        data["soidJourneyPlannerGroupJourneysByDriver"] = this.soidJourneyPlannerGroupJourneysByDriver;
        data["soidJourneyShowAdditionalCostsOnJourney"] = this.soidJourneyShowAdditionalCostsOnJourney;
        data["soidJourneyAutoRemoveAndAddDocumentsToRelatedAddCostChargeProRates"] = this.soidJourneyAutoRemoveAndAddDocumentsToRelatedAddCostChargeProRates;
        data["soidJourneyIncludePOWeight"] = this.soidJourneyIncludePOWeight;
        data["soidJourneyPlannerLimitToBranchVehicles"] = this.soidJourneyPlannerLimitToBranchVehicles;
        data["soidJourneyMarkOrdersDeliveredWhenJourneyMarkedInProgress"] = this.soidJourneyMarkOrdersDeliveredWhenJourneyMarkedInProgress;
        data["soidJourneyPlannerDisplayVIN"] = this.soidJourneyPlannerDisplayVIN;
        data["soidJourneyEnableAutomaticScheduledRoutes"] = this.soidJourneyEnableAutomaticScheduledRoutes;
        data["soidJourneyPromptForExistingJourneyWithTheSameAddress"] = this.soidJourneyPromptForExistingJourneyWithTheSameAddress;
        data["soidJourneyPlannerAutoRefreshInterval"] = this.soidJourneyPlannerAutoRefreshInterval;
        data["soidJourneyAllowLinkingTrailersToTruchAndTrailerVehicles"] = this.soidJourneyAllowLinkingTrailersToTruchAndTrailerVehicles;
        data["soidJourneyReferenceRequired"] = this.soidJourneyReferenceRequired;
        data["soidJourneyShowWarningWhenDocumentDateRequiredDontMatchJourneyDate"] = this.soidJourneyShowWarningWhenDocumentDateRequiredDontMatchJourneyDate;
        data["soidJourneyEnableAllowMultipleDeliveryAreasInJourney"] = this.soidJourneyEnableAllowMultipleDeliveryAreasInJourney;
        data["soidJourneyDefaultUnloadTimePerStop"] = this.soidJourneyDefaultUnloadTimePerStop;
        data["soidJourneyShowCreditNotePrintedInDocumentList"] = this.soidJourneyShowCreditNotePrintedInDocumentList;
        data["soidJourneyPlannerAutoAddUnusedVehicles"] = this.soidJourneyPlannerAutoAddUnusedVehicles;
        data["soidJourneyMarkDatesFull"] = this.soidJourneyMarkDatesFull;
        data["soidDirectionsSource"] = this.soidDirectionsSource;
        data["soidAddressingSource"] = this.soidAddressingSource;
        data["soidAddReturnToStart"] = this.soidAddReturnToStart;
        data["soidCustomerMapPointFolder"] = this.soidCustomerMapPointFolder;
        data["soidDirectionsGoogleMapsURL"] = this.soidDirectionsGoogleMapsURL;
        data["soidDirectionsBingMapsURL"] = this.soidDirectionsBingMapsURL;
        data["soidDirectionsAddressPattern"] = this.soidDirectionsAddressPattern;
        data["soidVehicleTrackingSoftwareService"] = this.soidVehicleTrackingSoftwareService;
        data["soidVehicleTrackingWebServiceLocation"] = this.soidVehicleTrackingWebServiceLocation;
        data["soidVehicleTrackingClientAccessCode"] = this.soidVehicleTrackingClientAccessCode;
        data["soidVehicleTrackingSpeedSuffix"] = this.soidVehicleTrackingSpeedSuffix;
        data["soidVehicleTrackingClientPassword"] = this.soidVehicleTrackingClientPassword;
        data["soidVehicleTrackingInternetMapURL"] = this.soidVehicleTrackingInternetMapURL;
        data["soidCustomerAddressMapGridSettings"] = this.soidCustomerAddressMapGridSettings;
        data["soidPassAddressCoordinatesForInternetMapping"] = this.soidPassAddressCoordinatesForInternetMapping;
        data["soidShowMapDirectlySkippingVehicleLocationForm"] = this.soidShowMapDirectlySkippingVehicleLocationForm;
        data["soidDirectionsGMapsDirectionsURL"] = this.soidDirectionsGMapsDirectionsURL;
        data["soidDirectionsGMapsDirectionsKey"] = this.soidDirectionsGMapsDirectionsKey;
        data["soidWorksOrderWasteWarning"] = this.soidWorksOrderWasteWarning;
        data["soidDefaultToManufactured"] = this.soidDefaultToManufactured;
        data["soidWorksOrderPrintOnChange"] = this.soidWorksOrderPrintOnChange;
        data["soidWorksOrderEnableCalendarScheduling"] = this.soidWorksOrderEnableCalendarScheduling;
        data["soidWorksOrderConsolidateIdenticalWOProcessesOnWOSchedule"] = this.soidWorksOrderConsolidateIdenticalWOProcessesOnWOSchedule;
        data["soidWorksOrderHybridCostingWarning"] = this.soidWorksOrderHybridCostingWarning;
        data["soidWorksOrderSourcePrefixText"] = this.soidWorksOrderSourcePrefixText;
        data["soidWorksOrderNewLineAfterSourcePrefix"] = this.soidWorksOrderNewLineAfterSourcePrefix;
        data["soidWorksOrderProcessPrefixText"] = this.soidWorksOrderProcessPrefixText;
        data["soidWorksOrderFinishedPrefixText"] = this.soidWorksOrderFinishedPrefixText;
        data["soidWorksOrderNewLineAfterFinishedPrefix"] = this.soidWorksOrderNewLineAfterFinishedPrefix;
        data["soidWorksOrderSOWaitForStock"] = this.soidWorksOrderSOWaitForStock;
        data["soidWorksOrderAllowProcessingIfCreditControl"] = this.soidWorksOrderAllowProcessingIfCreditControl;
        data["soidWorksOrderAllowFinishCostOverride"] = this.soidWorksOrderAllowFinishCostOverride;
        data["soidWorksOrderCreateProductsOnManufactured"] = this.soidWorksOrderCreateProductsOnManufactured;
        data["soidWorksOrderForceCreateOnManufactured"] = this.soidWorksOrderForceCreateOnManufactured;
        data["soidCreateGLTransactionsWorksOrder"] = this.soidCreateGLTransactionsWorksOrder;
        data["soidWorksOrderBaseSpecialOnProdGroupID"] = this.soidWorksOrderBaseSpecialOnProdGroupID;
        data["soidWorksOrderIgnoreHowSourcedOnSpecials"] = this.soidWorksOrderIgnoreHowSourcedOnSpecials;
        data["soidCreateGLTransactionsCOGS"] = this.soidCreateGLTransactionsCOGS;
        data["soidCreateGLTransactionsStockTransfer"] = this.soidCreateGLTransactionsStockTransfer;
        data["soidCreateGLTransactionsSupplierReturns"] = this.soidCreateGLTransactionsSupplierReturns;
        data["soidWorksOrderTrussDescription"] = this.soidWorksOrderTrussDescription;
        data["soidFinancialDescAppendDocRef"] = this.soidFinancialDescAppendDocRef;
        data["soidWorksOrderAutoCopySourceToFinished"] = this.soidWorksOrderAutoCopySourceToFinished;
        data["soidWorksOrderAllowMultiplePacksWhenConfirmingSourceMaterialPacks"] = this.soidWorksOrderAllowMultiplePacksWhenConfirmingSourceMaterialPacks;
        data["soidWorksOrderEnablePCMInterface"] = this.soidWorksOrderEnablePCMInterface;
        data["soidWorksOrderPCMInputFileLocation"] = this.soidWorksOrderPCMInputFileLocation;
        data["soidWorksOrderPCMOutputFileLocation"] = this.soidWorksOrderPCMOutputFileLocation;
        data["soidWorksOrderPCMPackRefDestination"] = this.soidWorksOrderPCMPackRefDestination;
        data["soidWorksOrderPCMPackPrefix"] = this.soidWorksOrderPCMPackPrefix;
        data["soidWorksOrderPCMDescriptionField"] = this.soidWorksOrderPCMDescriptionField;
        data["soidWorksOrderUseDocumentReleaseProcess"] = this.soidWorksOrderUseDocumentReleaseProcess;
        data["soidWorksOrderAlwaysReplaceForConfirmPacks"] = this.soidWorksOrderAlwaysReplaceForConfirmPacks;
        data["soidWorksOrderDefaultLinesFromSalesOrderWOCreation"] = this.soidWorksOrderDefaultLinesFromSalesOrderWOCreation;
        data["soidWorksOrderAllowPartProcessing"] = this.soidWorksOrderAllowPartProcessing;
        data["soidWorksOrderCopyAVONotesToOverheadPOManualLineDescription"] = this.soidWorksOrderCopyAVONotesToOverheadPOManualLineDescription;
        data["soidWorksOrderProcessDefaultManualLineType"] = this.soidWorksOrderProcessDefaultManualLineType;
        data["soidWorksOrderCombineAVOsIntoSinglePurchaseOrder"] = this.soidWorksOrderCombineAVOsIntoSinglePurchaseOrder;
        data["soidWorksOrderAllowProcessingWorksOrderAwaitingSourceMaterial"] = this.soidWorksOrderAllowProcessingWorksOrderAwaitingSourceMaterial;
        data["soidWorksOrderReviewSuppliersForPOCreatedFromWO"] = this.soidWorksOrderReviewSuppliersForPOCreatedFromWO;
        data["soidWorksOrderForceSourceSelectionForPartProcess"] = this.soidWorksOrderForceSourceSelectionForPartProcess;
        data["soidWorksOrderUseProcessWorkflow"] = this.soidWorksOrderUseProcessWorkflow;
        data["soidWorksOrderSuppressWorkflowPOPrint"] = this.soidWorksOrderSuppressWorkflowPOPrint;
        data["soidWorksOrderProcessPickingFormatSet"] = this.soidWorksOrderProcessPickingFormatSet;
        data["soidWorksOrderProcessDeliveryFormatSet"] = this.soidWorksOrderProcessDeliveryFormatSet;
        data["soidWorksOrderProcessCollectionFormatSet"] = this.soidWorksOrderProcessCollectionFormatSet;
        data["soidWorksOrderProcessReceiptFormatSet"] = this.soidWorksOrderProcessReceiptFormatSet;
        data["soidWorksOrderDefaultProcessWorksOrder"] = this.soidWorksOrderDefaultProcessWorksOrder;
        data["soidWorksOrderFromOrderRequiredDays"] = this.soidWorksOrderFromOrderRequiredDays;
        data["soidWorksOrderAllowDifferentAVOCurrency"] = this.soidWorksOrderAllowDifferentAVOCurrency;
        data["soidWorksOrderProcessReadyForCollectionFormatSet"] = this.soidWorksOrderProcessReadyForCollectionFormatSet;
        data["soidWorksOrderDefaultSourceProductsDisplayCostOnCreationToStandardBuy"] = this.soidWorksOrderDefaultSourceProductsDisplayCostOnCreationToStandardBuy;
        data["soidWorksOrderAllowOnJourneyIfHasWorkflow"] = this.soidWorksOrderAllowOnJourneyIfHasWorkflow;
        data["soidWorksOrderAutoSplitPacksDuringConfirmation"] = this.soidWorksOrderAutoSplitPacksDuringConfirmation;
        data["soidWorksOrderDefaultAVOsToSpreadCostToLinesTheyAreBasedOn"] = this.soidWorksOrderDefaultAVOsToSpreadCostToLinesTheyAreBasedOn;
        data["soidWorksOrderAllowBranchChangeWhenAllocated"] = this.soidWorksOrderAllowBranchChangeWhenAllocated;
        data["soidWorksOrderAlwaysAllocateStockWhenCopying"] = this.soidWorksOrderAlwaysAllocateStockWhenCopying;
        data["soidWorksOrderUpdateDateRequiredWhenSODateRequiredChanges"] = this.soidWorksOrderUpdateDateRequiredWhenSODateRequiredChanges;
        data["soidWorksOrderSetSpecialDescriptionFromFinishedLine"] = this.soidWorksOrderSetSpecialDescriptionFromFinishedLine;
        data["soidWorksOrderDisplay_BF_SF_LF_MachineSchedule"] = this.soidWorksOrderDisplay_BF_SF_LF_MachineSchedule;
        data["soidWorksOrderAveCostAdjReasonForProcessCostAppliedToSO"] = this.soidWorksOrderAveCostAdjReasonForProcessCostAppliedToSO;
        data["soidWorksOrderSalesOrderAVOForProcessCostAppliedToSO"] = this.soidWorksOrderSalesOrderAVOForProcessCostAppliedToSO;
        data["soidWorksOrderDefaultNewWOCreation"] = this.soidWorksOrderDefaultNewWOCreation;
        data["soidWorksOrderPromptToProcessUponScheduleCompletion"] = this.soidWorksOrderPromptToProcessUponScheduleCompletion;
        data["soidWorksOrderDefaultApplyProcessCostsToLinesOnWOCreatedFromSO"] = this.soidWorksOrderDefaultApplyProcessCostsToLinesOnWOCreatedFromSO;
        data["soidWorksOrderShowStockWarningOnWOGeneratedFromSO"] = this.soidWorksOrderShowStockWarningOnWOGeneratedFromSO;
        data["soidWorksOrderAllowProcessingIfSourceMaterialStockWillGoNegative"] = this.soidWorksOrderAllowProcessingIfSourceMaterialStockWillGoNegative;
        data["soidWorksOrderPromptToPrintLabelsForTaggedPacksWhenWOCompleted"] = this.soidWorksOrderPromptToPrintLabelsForTaggedPacksWhenWOCompleted;
        data["soidWorksOrderPromptToPrintLabelsForTaggedPacksWhenWOProcessed"] = this.soidWorksOrderPromptToPrintLabelsForTaggedPacksWhenWOProcessed;
        data["soidWorksOrderAlwaysCalculateRequiredDateOnCreation"] = this.soidWorksOrderAlwaysCalculateRequiredDateOnCreation;
        data["soidWorksOrderSalesOrderAVOForWasteCosts"] = this.soidWorksOrderSalesOrderAVOForWasteCosts;
        data["soidWorksOrderAveCostAdjReasonForWasteCosts"] = this.soidWorksOrderAveCostAdjReasonForWasteCosts;
        data["soidStockReceiptPrintOnChange"] = this.soidStockReceiptPrintOnChange;
        data["soidStockReceiptsPreentered"] = this.soidStockReceiptsPreentered;
        data["soidStockreceiptQtyOverReceivedWarningThreshold"] = this.soidStockreceiptQtyOverReceivedWarningThreshold;
        data["soidStockReceiptRetainERWhenReceivingPreEnteredPacks"] = this.soidStockReceiptRetainERWhenReceivingPreEnteredPacks;
        data["soidStockreceiptQtyUnderReceivedWarningThreshold"] = this.soidStockreceiptQtyUnderReceivedWarningThreshold;
        data["soidStockReceiptAutoPrintLabels"] = this.soidStockReceiptAutoPrintLabels;
        data["soidStockReceiptsRequiresDeliveryDetails"] = this.soidStockReceiptsRequiresDeliveryDetails;
        data["soidStockReceiptsRequiresHaulierDetails"] = this.soidStockReceiptsRequiresHaulierDetails;
        data["soidStockReceiptsInAdvanceAffectOnOrder"] = this.soidStockReceiptsInAdvanceAffectOnOrder;
        data["soidStockReceiptsQuickAddInputStyle"] = this.soidStockReceiptsQuickAddInputStyle;
        data["soidStockReceiptBackdateERWhenBackdating"] = this.soidStockReceiptBackdateERWhenBackdating;
        data["soidStockReceiptRequireBinForSpecials"] = this.soidStockReceiptRequireBinForSpecials;
        data["soidInvoiceLowMarginCollected"] = this.soidInvoiceLowMarginCollected;
        data["soidInvoiceLowMarginDelivered"] = this.soidInvoiceLowMarginDelivered;
        data["soidInvoiceLowMarginDirect"] = this.soidInvoiceLowMarginDirect;
        data["soidInvoiceHighMargin"] = this.soidInvoiceHighMargin;
        data["soidDefaultInvoicePaymentMethod"] = this.soidDefaultInvoicePaymentMethod;
        data["soidDefaultInvoicePaymentTerms"] = this.soidDefaultInvoicePaymentTerms;
        data["soidIncludeOrderTextLinesInInvoice"] = this.soidIncludeOrderTextLinesInInvoice;
        data["soidDefaultInvoiceBrowserFilterToUnreleased"] = this.soidDefaultInvoiceBrowserFilterToUnreleased;
        data["soidInvoiceOnMarkDelivered"] = this.soidInvoiceOnMarkDelivered;
        data["soidAllowUpdatesOfUnreleasedInvoices"] = this.soidAllowUpdatesOfUnreleasedInvoices;
        data["soidInvoiceAllowEditInternalNotesAfterCompletion"] = this.soidInvoiceAllowEditInternalNotesAfterCompletion;
        data["soidInvoiceSendSeparateInvoicesForEachJob"] = this.soidInvoiceSendSeparateInvoicesForEachJob;
        data["soidDefaultInvoiceCostAdjustmentReason"] = this.soidDefaultInvoiceCostAdjustmentReason;
        data["soidAllowInvoiceToBeSentType"] = this.soidAllowInvoiceToBeSentType;
        data["soidOnlyMarkInvoicesSentFromBrowser"] = this.soidOnlyMarkInvoicesSentFromBrowser;
        data["soidOrdersAutoInvoiceCollectNowChargeOrdersOnCompletion"] = this.soidOrdersAutoInvoiceCollectNowChargeOrdersOnCompletion;
        data["soidOrdersMarkCollectNowChargeOrdersAsSentWhenInvoicingOnCompletion"] = this.soidOrdersMarkCollectNowChargeOrdersAsSentWhenInvoicingOnCompletion;
        data["soidOrdersAutoInvoiceCollectLaterChargeOrdersOnCompletion"] = this.soidOrdersAutoInvoiceCollectLaterChargeOrdersOnCompletion;
        data["soidInvoiceAutoApproveIfIssued"] = this.soidInvoiceAutoApproveIfIssued;
        data["soidInvoiceAutoSetDateTo"] = this.soidInvoiceAutoSetDateTo;
        data["soidInvoiceAutoOnlyIfOrderStatusIsInvoicing"] = this.soidInvoiceAutoOnlyIfOrderStatusIsInvoicing;
        data["soidCreditDefaultReturnStockToZero"] = this.soidCreditDefaultReturnStockToZero;
        data["soidCreditReturnStockToReceivingBranch"] = this.soidCreditReturnStockToReceivingBranch;
        data["soidCreditAllowSettlementDiscount"] = this.soidCreditAllowSettlementDiscount;
        data["soidCreditUserMustReconfirmPassword"] = this.soidCreditUserMustReconfirmPassword;
        data["soidCreditRefundAmountToForceCompanyCheque"] = this.soidCreditRefundAmountToForceCompanyCheque;
        data["soidCreditCalculateSellPriceManualLine"] = this.soidCreditCalculateSellPriceManualLine;
        data["soidCreditApplyRestockChargeToOwnBrandProducts"] = this.soidCreditApplyRestockChargeToOwnBrandProducts;
        data["soidCreditFullRestockChargeOnSpecials"] = this.soidCreditFullRestockChargeOnSpecials;
        data["soidCreditLockCashRefundsToOriginalPayment"] = this.soidCreditLockCashRefundsToOriginalPayment;
        data["soidCreditUseCustomerCreditsForCustomerReturns"] = this.soidCreditUseCustomerCreditsForCustomerReturns;
        data["soidCreditRefundAmountToForceGiftCard"] = this.soidCreditRefundAmountToForceGiftCard;
        data["soidCreditRefundChequeFormat"] = this.soidCreditRefundChequeFormat;
        data["soidCreditReturnToSupplierOnDirect"] = this.soidCreditReturnToSupplierOnDirect;
        data["soidCreditConfirmRefundAddress"] = this.soidCreditConfirmRefundAddress;
        data["soidCreditNoteRequestFormatNumber"] = this.soidCreditNoteRequestFormatNumber;
        data["soidCreditRefundAllowCompanyCheque"] = this.soidCreditRefundAllowCompanyCheque;
        data["soidCreditAllowPrintFinalDocumentOnRelease"] = this.soidCreditAllowPrintFinalDocumentOnRelease;
        data["soidCreditSearchInvoicesByOrderNumber"] = this.soidCreditSearchInvoicesByOrderNumber;
        data["soidCreditAllowUnpaidCustomerCredits"] = this.soidCreditAllowUnpaidCustomerCredits;
        data["soidCreditAllowSalesOrderCreationFromCreditNotes"] = this.soidCreditAllowSalesOrderCreationFromCreditNotes;
        data["soidCreditDefaultReturnStockToZeroFromProductsPurchased"] = this.soidCreditDefaultReturnStockToZeroFromProductsPurchased;
        data["soidCreditUseTakenByFromLinkedInvoiceForSalesAnalysis"] = this.soidCreditUseTakenByFromLinkedInvoiceForSalesAnalysis;
        data["soidCreditDoNotAllowReturnToStockCreditNotesBackToVMIPrograms"] = this.soidCreditDoNotAllowReturnToStockCreditNotesBackToVMIPrograms;
        data["soidCreditRefundAlwaysAllowCompanyCheque"] = this.soidCreditRefundAlwaysAllowCompanyCheque;
        data["soidCreditUpdateQuantityCreditedAtTimeOfCreditCreation"] = this.soidCreditUpdateQuantityCreditedAtTimeOfCreditCreation;
        data["soidCreditDefaultHandling"] = this.soidCreditDefaultHandling;
        data["soidCreditAlwaysUseARCustomerFromAddress"] = this.soidCreditAlwaysUseARCustomerFromAddress;
        data["soidCreditAllowQuantityLessThanReturnToStockQuantity"] = this.soidCreditAllowQuantityLessThanReturnToStockQuantity;
        data["soidCreditAutoApproveCreditNoteOnCompletionWhenStockReturned"] = this.soidCreditAutoApproveCreditNoteOnCompletionWhenStockReturned;
        data["soidCreditWMSRefuseOnTruckReasonCode"] = this.soidCreditWMSRefuseOnTruckReasonCode;
        data["soidCreditWMSRefuseOnTruckReasonCodeCash"] = this.soidCreditWMSRefuseOnTruckReasonCodeCash;
        data["soidCreditWMSUpdateCreditQuantity"] = this.soidCreditWMSUpdateCreditQuantity;
        data["soidCreditPostSalesAndCOGSToInvoiceBranch"] = this.soidCreditPostSalesAndCOGSToInvoiceBranch;
        data["soidCreditRebillCreditNoteReason"] = this.soidCreditRebillCreditNoteReason;
        data["soidCreditRebillCashRefundReason"] = this.soidCreditRebillCashRefundReason;
        data["soidCreditDefaultCreditNoteLinesToIncludeAVOCost"] = this.soidCreditDefaultCreditNoteLinesToIncludeAVOCost;
        data["soidCreditRequireCashRefundAuthorization"] = this.soidCreditRequireCashRefundAuthorization;
        data["soidCreditSignatureCaptureForReturnToBranch"] = this.soidCreditSignatureCaptureForReturnToBranch;
        data["soidCreditReasonCodeToUseForContractBillingCreditNotes"] = this.soidCreditReasonCodeToUseForContractBillingCreditNotes;
        data["soidCreditReasonCodeToUseForContractBillingCashRefunds"] = this.soidCreditReasonCodeToUseForContractBillingCashRefunds;
        data["soidCreditCopyCustomerAddressNotesIntoDescription"] = this.soidCreditCopyCustomerAddressNotesIntoDescription;
        data["soidCreditDefaultProductsPurchasedDateSearch"] = this.soidCreditDefaultProductsPurchasedDateSearch;
        data["soidCreditPrintCreditFormatFromCashRefund"] = this.soidCreditPrintCreditFormatFromCashRefund;
        data["soidCreditLimitInvoiceAndProductPurchasedSearchesToTheJobOnCreditNotes"] = this.soidCreditLimitInvoiceAndProductPurchasedSearchesToTheJobOnCreditNotes;
        data["soidCashDrawerCOMEnabled"] = this.soidCashDrawerCOMEnabled;
        data["soidCashDrawerDefaultClosingFloat"] = this.soidCashDrawerDefaultClosingFloat;
        data["soidUpdateLCPOnPurchaseOrderUpdate"] = this.soidUpdateLCPOnPurchaseOrderUpdate;
        data["soidUpdateLCPOnStockReceiptUpdate"] = this.soidUpdateLCPOnStockReceiptUpdate;
        data["soidUpdateLCPOnSupplierInvoiceApprove"] = this.soidUpdateLCPOnSupplierInvoiceApprove;
        data["soidUpdateLCPOnWorksOrderProcess"] = this.soidUpdateLCPOnWorksOrderProcess;
        data["soidIncludeProratedManualCostsInACP"] = this.soidIncludeProratedManualCostsInACP;
        data["soidIncludeProratedManualCostsInLCP"] = this.soidIncludeProratedManualCostsInLCP;
        data["soidUpdateLCPOnStockTransferReceipt"] = this.soidUpdateLCPOnStockTransferReceipt;
        data["soidInventoryAgingAnnualCostRate"] = this.soidInventoryAgingAnnualCostRate;
        data["soidFreeDaysBeforeAgingApplies"] = this.soidFreeDaysBeforeAgingApplies;
        data["soidSkipUpdateACPOnSupplierInvoiceApprove"] = this.soidSkipUpdateACPOnSupplierInvoiceApprove;
        data["soidTurnOffProduceInvoiceOnCOD"] = this.soidTurnOffProduceInvoiceOnCOD;
        data["soidVolumeDisplayUnitInOrderSummary"] = this.soidVolumeDisplayUnitInOrderSummary;
        data["soidDisplayVolumeAreaLengthInOrderSummary"] = this.soidDisplayVolumeAreaLengthInOrderSummary;
        data["soidSalesAndPOLineVolumeDisplayPer"] = this.soidSalesAndPOLineVolumeDisplayPer;
        data["soidSalesAndPOLineAreaDisplayPer"] = this.soidSalesAndPOLineAreaDisplayPer;
        data["soidSalesAndPOLineLengthDisplayPer"] = this.soidSalesAndPOLineLengthDisplayPer;
        data["soidEnableVMIProcessingUseThisOne"] = this.soidEnableVMIProcessingUseThisOne;
        data["soidShowReelFunctionality"] = this.soidShowReelFunctionality;
        data["soidDefaultNotepadCaseStatus"] = this.soidDefaultNotepadCaseStatus;
        data["soidAllowVMIPRulesThatAreCalculatedFromSellPrice"] = this.soidAllowVMIPRulesThatAreCalculatedFromSellPrice;
        data["soidUseEstimateCostsOnlyOnAdditionalCostCalcs"] = this.soidUseEstimateCostsOnlyOnAdditionalCostCalcs;
        data["soidUpdateCostsOnSupplierInvoiceWhenStockReceiptPreEntered"] = this.soidUpdateCostsOnSupplierInvoiceWhenStockReceiptPreEntered;
        data["soidAlwaysProrateAdditionalCostsBySellPrice"] = this.soidAlwaysProrateAdditionalCostsBySellPrice;
        data["soidInventoryValueNetOfSupplierDiscount"] = this.soidInventoryValueNetOfSupplierDiscount;
        data["soidNumberOfCostDiscountFields"] = this.soidNumberOfCostDiscountFields;
        data["soidSetAverageCostsOnSpecialOrderCreation"] = this.soidSetAverageCostsOnSpecialOrderCreation;
        data["soidEnableCostDiscountFieldsOnDirects"] = this.soidEnableCostDiscountFieldsOnDirects;
        data["soidPOCostControlledByPermission"] = this.soidPOCostControlledByPermission;
        data["soidPPVCalculation"] = this.soidPPVCalculation;
        data["soidReasonCodeForPPVWhenCreatingAutoACA"] = this.soidReasonCodeForPPVWhenCreatingAutoACA;
        data["soidIntrastatSupplierDefaultDeliveryTerms"] = this.soidIntrastatSupplierDefaultDeliveryTerms;
        data["soidIntrastatSupplierDefaultModeOfTransport"] = this.soidIntrastatSupplierDefaultModeOfTransport;
        data["soidIntrastatCustomerDefaultDeliveryTerms"] = this.soidIntrastatCustomerDefaultDeliveryTerms;
        data["soidIntrastatCustomerDefaultModeOfTransport"] = this.soidIntrastatCustomerDefaultModeOfTransport;
        data["soidIntrastatIntegration"] = this.soidIntrastatIntegration;
        data["soidDefaultProductStockClass"] = this.soidDefaultProductStockClass;
        data["soidProductDefaultSpecialsToKeepStockFigures"] = this.soidProductDefaultSpecialsToKeepStockFigures;
        data["soidEnablePermissionsByProductTab"] = this.soidEnablePermissionsByProductTab;
        data["soidProductShowAveCostInBuyPer"] = this.soidProductShowAveCostInBuyPer;
        data["soidNoOfProductImages"] = this.soidNoOfProductImages;
        data["soidProductImageNames"] = this.soidProductImageNames;
        data["soidDefaultProductHistoryDays"] = this.soidDefaultProductHistoryDays;
        data["soidProductShowCompanyStockInFindProducts"] = this.soidProductShowCompanyStockInFindProducts;
        data["soidProductEnableProductManagerNotifications"] = this.soidProductEnableProductManagerNotifications;
        data["soidProductDefaultSpecialsProductGroup"] = this.soidProductDefaultSpecialsProductGroup;
        data["soidProductAlternativeSupplierPriceWeeks"] = this.soidProductAlternativeSupplierPriceWeeks;
        data["soidProductEditProductGroupAffectsSalesAnalysis"] = this.soidProductEditProductGroupAffectsSalesAnalysis;
        data["soidProductQtyInFindProductsToRead"] = this.soidProductQtyInFindProductsToRead;
        data["soidProductEnablePrintingofZebraLabels"] = this.soidProductEnablePrintingofZebraLabels;
        data["soidProductAllowDuplicateBarcodes"] = this.soidProductAllowDuplicateBarcodes;
        data["soidProductSupplierPricesInSupplierCurrency"] = this.soidProductSupplierPricesInSupplierCurrency;
        data["soidProductDefaultStocked"] = this.soidProductDefaultStocked;
        data["soidProductDefaultAllowSpecialsBasedOnThis"] = this.soidProductDefaultAllowSpecialsBasedOnThis;
        data["soidProductRequireWeightOnProductsAndSpecials"] = this.soidProductRequireWeightOnProductsAndSpecials;
        data["soidProductRequireEnvironmentalStatusOnSpecials"] = this.soidProductRequireEnvironmentalStatusOnSpecials;
        data["soidProductUpdateStandardBranchPricesWithCompanyPrices"] = this.soidProductUpdateStandardBranchPricesWithCompanyPrices;
        data["soidProductSkipDetailsOnAutoCreatedPurchasedSpecials"] = this.soidProductSkipDetailsOnAutoCreatedPurchasedSpecials;
        data["soidProductLimitSellingPriceBandsToSpecificBranches"] = this.soidProductLimitSellingPriceBandsToSpecificBranches;
        data["soidProductLimitStockOptionsToBranchesWithUpdateAccess"] = this.soidProductLimitStockOptionsToBranchesWithUpdateAccess;
        data["soidProductDefaultSalesTabToCurrentBranch"] = this.soidProductDefaultSalesTabToCurrentBranch;
        data["soidProductDefaultSalesTabToLast12Months"] = this.soidProductDefaultSalesTabToLast12Months;
        data["soidProductSetupSellingQuantityBreakByBranch"] = this.soidProductSetupSellingQuantityBreakByBranch;
        data["soidProductSetupPickingRequiredByBranch"] = this.soidProductSetupPickingRequiredByBranch;
        data["soidProductSetupAllowSettlementDiscountByBranch"] = this.soidProductSetupAllowSettlementDiscountByBranch;
        data["soidProductAllowChangingProductCodeOnSpecialOrderCreation"] = this.soidProductAllowChangingProductCodeOnSpecialOrderCreation;
        data["soidProductSetSellEntireRelatedSet"] = this.soidProductSetSellEntireRelatedSet;
        data["soidProductSetSelectDefaultToExpanded"] = this.soidProductSetSelectDefaultToExpanded;
        data["soidProductDefaultNewSpecialProductToBranchCreating"] = this.soidProductDefaultNewSpecialProductToBranchCreating;
        data["soidProductDefaultShortDescriptionToDescriptionOnSpecialOrderCreation"] = this.soidProductDefaultShortDescriptionToDescriptionOnSpecialOrderCreation;
        data["soidProductCopyPopupTextOnSpecialOrderCreation"] = this.soidProductCopyPopupTextOnSpecialOrderCreation;
        data["soidImportProductFollowBranchAccessPermissions"] = this.soidImportProductFollowBranchAccessPermissions;
        data["soidConvertTalliesToSpecialInstructions"] = this.soidConvertTalliesToSpecialInstructions;
        data["soidDefaultDocumentPresentation"] = this.soidDefaultDocumentPresentation;
        data["soidAddManufacturedKitToExistingWO"] = this.soidAddManufacturedKitToExistingWO;
        data["soidDefaultHideOnWorksOrders"] = this.soidDefaultHideOnWorksOrders;
        data["soidKitsSelectionImageNumber"] = this.soidKitsSelectionImageNumber;
        data["soidEnableStandardKitPromotions"] = this.soidEnableStandardKitPromotions;
        data["soidABCDStockClassCalculationBasedOn"] = this.soidABCDStockClassCalculationBasedOn;
        data["soidNumberOfMonthsToBaseRankingsOn"] = this.soidNumberOfMonthsToBaseRankingsOn;
        data["soidNumberOfMonthsOfSalesBeforeRanking"] = this.soidNumberOfMonthsOfSalesBeforeRanking;
        data["soidStockClassARanking"] = this.soidStockClassARanking;
        data["soidStockClassBRanking"] = this.soidStockClassBRanking;
        data["soidStockClassCRanking"] = this.soidStockClassCRanking;
        data["soidStockClassDRanking"] = this.soidStockClassDRanking;
        data["soidRankInComparisonToProductGroupLevel"] = this.soidRankInComparisonToProductGroupLevel;
        data["soidSearchingIncludeOrderFindSupplierFields"] = this.soidSearchingIncludeOrderFindSupplierFields;
        data["soidHighlightOwnBrandProducts"] = this.soidHighlightOwnBrandProducts;
        data["soidExcludeBarcodeInOrderProductFind"] = this.soidExcludeBarcodeInOrderProductFind;
        data["soidUseExactProductCodeSearchOnCollectNow"] = this.soidUseExactProductCodeSearchOnCollectNow;
        data["soidSearchingSortFindDocumentFilterLists"] = this.soidSearchingSortFindDocumentFilterLists;
        data["soidSearchingUseIssuingBranch"] = this.soidSearchingUseIssuingBranch;
        data["soidBarcodePrefix"] = this.soidBarcodePrefix;
        data["soidUseAdditionalBarcodesInOrderProductFind"] = this.soidUseAdditionalBarcodesInOrderProductFind;
        data["soidSearchingFindDocsDeliveryAreaSearchStyle"] = this.soidSearchingFindDocsDeliveryAreaSearchStyle;
        data["soidSearchingTrimSearchText"] = this.soidSearchingTrimSearchText;
        data["soidSearchMOLTsInProductFindInOrderEntry"] = this.soidSearchMOLTsInProductFindInOrderEntry;
        data["soidSearchCouponsInProductFindInOrderEntry"] = this.soidSearchCouponsInProductFindInOrderEntry;
        data["soidSearchingDeliveryAreaSearchStyle"] = this.soidSearchingDeliveryAreaSearchStyle;
        data["soidAllowCustomerProductReference"] = this.soidAllowCustomerProductReference;
        data["soidSupplierReturnEnable"] = this.soidSupplierReturnEnable;
        data["soidSupplierReturnAlwaysDefaultCostToAverageCostWithAdd"] = this.soidSupplierReturnAlwaysDefaultCostToAverageCostWithAdd;
        data["soidSupplierReturnAllowBranchChangeWhenLinkedToDocument"] = this.soidSupplierReturnAllowBranchChangeWhenLinkedToDocument;
        data["soidSupplierReturnUseAccountsPayableGLCodeFromLinkedDocument"] = this.soidSupplierReturnUseAccountsPayableGLCodeFromLinkedDocument;
        data["soidSupplierReturnAllowInspectAfterPickup"] = this.soidSupplierReturnAllowInspectAfterPickup;
        data["soidOrdersPricingSpecialPriceMessage"] = this.soidOrdersPricingSpecialPriceMessage;
        data["soidOrdersPricingSpecialPriceMessageColour"] = this.soidOrdersPricingSpecialPriceMessageColour;
        data["soidOrdersPricingUseDeferredDiscountInCostCalc"] = this.soidOrdersPricingUseDeferredDiscountInCostCalc;
        data["soidPricingUseOrderCostForSpecialBackToBack"] = this.soidPricingUseOrderCostForSpecialBackToBack;
        data["soidSalesOrderSecondaryCostCalculation"] = this.soidSalesOrderSecondaryCostCalculation;
        data["soidPricingUseQuotePriceUnlessRuleExists"] = this.soidPricingUseQuotePriceUnlessRuleExists;
        data["soidPricingRecostOrderOn"] = this.soidPricingRecostOrderOn;
        data["soidPricingUseLastSellPriceWithin"] = this.soidPricingUseLastSellPriceWithin;
        data["soidOrdersPricingQuotePriceMessage"] = this.soidOrdersPricingQuotePriceMessage;
        data["soidOrdersPricingQuotePriceMessageColour"] = this.soidOrdersPricingQuotePriceMessageColour;
        data["soidOrdersPricingLastSellPriceMessage"] = this.soidOrdersPricingLastSellPriceMessage;
        data["soidOrdersPricingLastSellPriceMessageColour"] = this.soidOrdersPricingLastSellPriceMessageColour;
        data["soidCostDefaultQuoteToStandardBuy"] = this.soidCostDefaultQuoteToStandardBuy;
        data["soidCostDefaultTemplateOrderToStandardBuy"] = this.soidCostDefaultTemplateOrderToStandardBuy;
        data["soidOrdersPricingCheckIfCallOffExists"] = this.soidOrdersPricingCheckIfCallOffExists;
        data["soidPricingUseQuotePriceAlways"] = this.soidPricingUseQuotePriceAlways;
        data["soidOrdersLastSellPriceIsBranchSpecific"] = this.soidOrdersLastSellPriceIsBranchSpecific;
        data["soidOrdersPricingLumpSumQtySell"] = this.soidOrdersPricingLumpSumQtySell;
        data["soidOrdersPricingLumpSumQtyCost"] = this.soidOrdersPricingLumpSumQtyCost;
        data["soidOrdersPricingShowLastPOPriceInNegotiation"] = this.soidOrdersPricingShowLastPOPriceInNegotiation;
        data["soidOrdersPricingPOPriceOutOfDateDays"] = this.soidOrdersPricingPOPriceOutOfDateDays;
        data["soidOrdersPricingShowContributionOnOrders"] = this.soidOrdersPricingShowContributionOnOrders;
        data["soidOrdersPricingUseDeferredDiscountInLastCostCalc"] = this.soidOrdersPricingUseDeferredDiscountInLastCostCalc;
        data["soidOrdersPricingUseDeferredDiscountInAverageCostCalc"] = this.soidOrdersPricingUseDeferredDiscountInAverageCostCalc;
        data["soidOrdersPricingRecostBackToBackOrders"] = this.soidOrdersPricingRecostBackToBackOrders;
        data["soidOrdersPricingPromotionPointsPer"] = this.soidOrdersPricingPromotionPointsPer;
        data["soidOrdersPricingPromotionCalculateAfterDeliveryCharges"] = this.soidOrdersPricingPromotionCalculateAfterDeliveryCharges;
        data["soidOrdersPricingAllowNegotiateIfNoMarginOptions"] = this.soidOrdersPricingAllowNegotiateIfNoMarginOptions;
        data["soidOrdersPricingPromotionExcludeAbsolutePriceLines"] = this.soidOrdersPricingPromotionExcludeAbsolutePriceLines;
        data["soidOrdersPricingPromotionExcludeDirects"] = this.soidOrdersPricingPromotionExcludeDirects;
        data["soidOrdersPricingPromptToChangePriceOnIdenticalItems"] = this.soidOrdersPricingPromptToChangePriceOnIdenticalItems;
        data["soidOrdersPricingDefaultReplaceExistingLineDiscounts"] = this.soidOrdersPricingDefaultReplaceExistingLineDiscounts;
        data["soidOrdersPricingDefaultPriceRulesToCalculateDiscountsIntoUnitPrice"] = this.soidOrdersPricingDefaultPriceRulesToCalculateDiscountsIntoUnitPrice;
        data["soidOrdersPricingUseInternalCostInMarginCalcs"] = this.soidOrdersPricingUseInternalCostInMarginCalcs;
        data["soidOrdersPricingUseInternalCostRules"] = this.soidOrdersPricingUseInternalCostRules;
        data["soidOrdersPricingApplyPriceRoundingWhenManuallyPricingLines"] = this.soidOrdersPricingApplyPriceRoundingWhenManuallyPricingLines;
        data["soidOrdersPricingDefaultCostToZeroOnDirectSalesOrders"] = this.soidOrdersPricingDefaultCostToZeroOnDirectSalesOrders;
        data["soidOrdersPricingShowLastPriceDates"] = this.soidOrdersPricingShowLastPriceDates;
        data["soidOrdersPricingShowNextPricesXDays"] = this.soidOrdersPricingShowNextPricesXDays;
        data["soidOrdersPricingManualPriceOnMarginNegotiation"] = this.soidOrdersPricingManualPriceOnMarginNegotiation;
        data["soidOrdersPricingShowPriceBandsOnNegotiation"] = this.soidOrdersPricingShowPriceBandsOnNegotiation;
        data["soidOrdersPricingShowInternalCostInfo"] = this.soidOrdersPricingShowInternalCostInfo;
        data["soidOrdersPricingEnsureAVOInclusiveSellPriceExtends"] = this.soidOrdersPricingEnsureAVOInclusiveSellPriceExtends;
        data["soidOrdersPricingOrderlinePriceInfoToDisplay"] = this.soidOrdersPricingOrderlinePriceInfoToDisplay;
        data["soidOrdersPricingUseInternalCostRulesOnDirects"] = this.soidOrdersPricingUseInternalCostRulesOnDirects;
        data["soidOrdersPricingCalculatePriceBandDiscountsIntoUnitPrice"] = this.soidOrdersPricingCalculatePriceBandDiscountsIntoUnitPrice;
        data["soidOrdersPricingDefaultUseBasedOnProductsOnNewPriceRules"] = this.soidOrdersPricingDefaultUseBasedOnProductsOnNewPriceRules;
        data["soidOrdersPricingPriceBandsUtilizeBasedOnProducts"] = this.soidOrdersPricingPriceBandsUtilizeBasedOnProducts;
        data["soidOrdersPricingRecalcSellPriceOnNonSpecialManKitRefresh"] = this.soidOrdersPricingRecalcSellPriceOnNonSpecialManKitRefresh;
        data["soidOrdersPricingApplyPriceRoundingWhenNegotiatingMargin"] = this.soidOrdersPricingApplyPriceRoundingWhenNegotiatingMargin;
        data["soidOrdersPricingEnableManagerOverrideOnOrderLinePrice"] = this.soidOrdersPricingEnableManagerOverrideOnOrderLinePrice;
        data["soidOrdersPricingRequireReasonCodeOnSalesLinePriceChange"] = this.soidOrdersPricingRequireReasonCodeOnSalesLinePriceChange;
        data["soidOrdersPricingAllowMultiplePromotionsPerLine"] = this.soidOrdersPricingAllowMultiplePromotionsPerLine;
        data["soidOrdersPricingShowMultiplierOnOrderLine"] = this.soidOrdersPricingShowMultiplierOnOrderLine;
        data["soidOrdersPricingRetainOriginalPriceCalc"] = this.soidOrdersPricingRetainOriginalPriceCalc;
        data["soidOrdersPricingDefaultCostPerToSellingPerOnSalesOrder"] = this.soidOrdersPricingDefaultCostPerToSellingPerOnSalesOrder;
        data["soidOrdersPricingControlFreeOfChargeLines"] = this.soidOrdersPricingControlFreeOfChargeLines;
        data["soidOrdersPricingManualPriceAlwaysClearsDiscounts"] = this.soidOrdersPricingManualPriceAlwaysClearsDiscounts;
        data["soidOrdersPricingRecordSalesNetOfDiscounts"] = this.soidOrdersPricingRecordSalesNetOfDiscounts;
        data["soidOrdersPricingApplySettlementDiscountToCashOrderLines"] = this.soidOrdersPricingApplySettlementDiscountToCashOrderLines;
        data["soidOrdersIncludeAdditionalChargeInOrderLineTotalPrice"] = this.soidOrdersIncludeAdditionalChargeInOrderLineTotalPrice;
        data["soidOrdersRepriceOrderLinesAtFixedMarginPctPerLine"] = this.soidOrdersRepriceOrderLinesAtFixedMarginPctPerLine;
        data["soidOrdersRoundUpSellPriceOnMarginNegotiate"] = this.soidOrdersRoundUpSellPriceOnMarginNegotiate;
        data["soidOrdersRoundDiscountDown"] = this.soidOrdersRoundDiscountDown;
        data["soidOrdersPricingAutoCreateInvoiceCostAdjForSpecials"] = this.soidOrdersPricingAutoCreateInvoiceCostAdjForSpecials;
        data["soidOrdersPricingDefaultRepriceProductsOnFindAndReplace"] = this.soidOrdersPricingDefaultRepriceProductsOnFindAndReplace;
        data["soidDefaultCostPerToLastCostWithAdditionalPerOnTransfers"] = this.soidDefaultCostPerToLastCostWithAdditionalPerOnTransfers;
        data["soidOrdersPricingSpecialPriceMessageOverride"] = this.soidOrdersPricingSpecialPriceMessageOverride;
        data["soidOrdersPricingApplyPriceRoundingAfterDelChargeIsAdded"] = this.soidOrdersPricingApplyPriceRoundingAfterDelChargeIsAdded;
        data["soidOrdersPricingKeepPricePerWhenSpecificPriceBandIsUsed"] = this.soidOrdersPricingKeepPricePerWhenSpecificPriceBandIsUsed;
        data["soidOrdersPricingRestoreCostOnSpecialProductsOnRecalculate"] = this.soidOrdersPricingRestoreCostOnSpecialProductsOnRecalculate;
        data["soidOrdersPricingDisplayMultiplierInPriceRulesAndSellingBands"] = this.soidOrdersPricingDisplayMultiplierInPriceRulesAndSellingBands;
        data["soidOrdersPricingShowCostAndSellPriceMultipliersOnSalesSpecialOrderCreation"] = this.soidOrdersPricingShowCostAndSellPriceMultipliersOnSalesSpecialOrderCreation;
        data["soidOrdersPricingRecostSalesTransactionsOnCopyFrom"] = this.soidOrdersPricingRecostSalesTransactionsOnCopyFrom;
        data["soidOrdersPricingAutoCreateInvoiceCostAdjForNonSpecials"] = this.soidOrdersPricingAutoCreateInvoiceCostAdjForNonSpecials;
        data["soidAllowMarkingSalesOrderLinesAsNetPriced"] = this.soidAllowMarkingSalesOrderLinesAsNetPriced;
        data["soidOrdersPricingDefaultCostOnBackToBackOrderLines"] = this.soidOrdersPricingDefaultCostOnBackToBackOrderLines;
        data["soidOrdersPricingAutoCreateInvoiceCostAdjForManProducts"] = this.soidOrdersPricingAutoCreateInvoiceCostAdjForManProducts;
        data["soidDefaultCalculationMethodForCostBasedSellingPriceRules"] = this.soidDefaultCalculationMethodForCostBasedSellingPriceRules;
        data["soidOrdersPricingAutoApplySellingPriceChangesNightly"] = this.soidOrdersPricingAutoApplySellingPriceChangesNightly;
        data["soidOrdersUseDefaultJobAddressPriceProfile"] = this.soidOrdersUseDefaultJobAddressPriceProfile;
        data["soidExcludePriceRoundingWhenUsingSpecialPriceRules"] = this.soidExcludePriceRoundingWhenUsingSpecialPriceRules;
        data["soidQuantityBreaksThatUseSpecificPriceBandWillOnlyUseDiscountFromThatBand"] = this.soidQuantityBreaksThatUseSpecificPriceBandWillOnlyUseDiscountFromThatBand;
        data["soidOrdersPricingAllowMultipleSpendXSaveYCouponPromotions"] = this.soidOrdersPricingAllowMultipleSpendXSaveYCouponPromotions;
        data["soidBranchPrinter1"] = this.soidBranchPrinter1;
        data["soidBranchPrinter2"] = this.soidBranchPrinter2;
        data["soidBranchPrinter3"] = this.soidBranchPrinter3;
        data["soidBranchPrinter4"] = this.soidBranchPrinter4;
        data["soidBranchPrinter5"] = this.soidBranchPrinter5;
        data["soidBranchPrinter6"] = this.soidBranchPrinter6;
        data["soidBranchPrinter7"] = this.soidBranchPrinter7;
        data["soidBranchPrinter8"] = this.soidBranchPrinter8;
        data["soidBranchPrinter9"] = this.soidBranchPrinter9;
        data["soidBranchPrinter10"] = this.soidBranchPrinter10;
        data["soidPrintingMaxDocument"] = this.soidPrintingMaxDocument;
        data["soidAlternatePrintDialog"] = this.soidAlternatePrintDialog;
        data["soidAllowDocumentPrintingFromPreview"] = this.soidAllowDocumentPrintingFromPreview;
        data["soidPrinterListMethod"] = this.soidPrinterListMethod;
        data["soidPrintingSortPrinterList"] = this.soidPrintingSortPrinterList;
        data["soidPrintingPrinterDisplayFormat"] = this.soidPrintingPrinterDisplayFormat;
        data["soidDepartmentPinter1"] = this.soidDepartmentPinter1;
        data["soidDepartmentPinter2"] = this.soidDepartmentPinter2;
        data["soidDepartmentPinter3"] = this.soidDepartmentPinter3;
        data["soidDepartmentPinter4"] = this.soidDepartmentPinter4;
        data["soidDepartmentPinter5"] = this.soidDepartmentPinter5;
        data["soidDepartmentPinter6"] = this.soidDepartmentPinter6;
        data["soidDepartmentPinter7"] = this.soidDepartmentPinter7;
        data["soidDepartmentPinter8"] = this.soidDepartmentPinter8;
        data["soidDepartmentPinter9"] = this.soidDepartmentPinter9;
        data["soidDepartmentPinter10"] = this.soidDepartmentPinter10;
        data["soidOrdersEnablePricingOptionToChangeSellingPriceUOM"] = this.soidOrdersEnablePricingOptionToChangeSellingPriceUOM;
        data["soidCustomersDefaultRefRequired"] = this.soidCustomersDefaultRefRequired;
        data["soidCustomersDefaultDropdownLists"] = this.soidCustomersDefaultDropdownLists;
        data["soidCustomersDefaultEnforceEnterOrderContact"] = this.soidCustomersDefaultEnforceEnterOrderContact;
        data["soidAllowCustomerSalesRepToBeOptional"] = this.soidAllowCustomerSalesRepToBeOptional;
        data["soidRemitToAddressRequiredOnDefaultAddress"] = this.soidRemitToAddressRequiredOnDefaultAddress;
        data["soidPreventDuplicateJobReferencesPerCustomer"] = this.soidPreventDuplicateJobReferencesPerCustomer;
        data["soidRestrictUpdatingCustomersToHomeBranch"] = this.soidRestrictUpdatingCustomersToHomeBranch;
        data["soidAutoAllocateJobNumbers"] = this.soidAutoAllocateJobNumbers;
        data["soidCustomersEnablePermissionsByTab"] = this.soidCustomersEnablePermissionsByTab;
        data["soidCustomersLimitSearchToHomeBranch"] = this.soidCustomersLimitSearchToHomeBranch;
        data["soidCustomersUseTaxExemptionsFromARCustomer"] = this.soidCustomersUseTaxExemptionsFromARCustomer;
        data["soidCustomersDefaultEnforceJobAddressOrderEntry"] = this.soidCustomersDefaultEnforceJobAddressOrderEntry;
        data["soidCustomersDefaultFinanceChargeAmountToNotSet"] = this.soidCustomersDefaultFinanceChargeAmountToNotSet;
        data["soidCustomerCopyInstructionsToTransactions"] = this.soidCustomerCopyInstructionsToTransactions;
        data["soidCustomerDefaultAllowOvertypeInvoiceAddress"] = this.soidCustomerDefaultAllowOvertypeInvoiceAddress;
        data["soidCustomerForceVerifyOfContactIdentification"] = this.soidCustomerForceVerifyOfContactIdentification;
        data["soidCustomerLimitContactsToThoseBasedAtDeliveryAddress"] = this.soidCustomerLimitContactsToThoseBasedAtDeliveryAddress;
        data["soidCustomerDisplayCustomerContactDefaultOnOrders"] = this.soidCustomerDisplayCustomerContactDefaultOnOrders;
        data["soidCustomerDefaultHomeBranchInCustomerFindToLoggedInBranch"] = this.soidCustomerDefaultHomeBranchInCustomerFindToLoggedInBranch;
        data["soidOptimizeCustomerAddressUsage"] = this.soidOptimizeCustomerAddressUsage;
        data["soidCustomerTypeLevel1"] = this.soidCustomerTypeLevel1;
        data["soidCustomerTypeLevel2"] = this.soidCustomerTypeLevel2;
        data["soidCustomersAutomaticallyGenerateProspectCode"] = this.soidCustomersAutomaticallyGenerateProspectCode;
        data["soidCustomerEnableContactLoyaltyCards"] = this.soidCustomerEnableContactLoyaltyCards;
        data["soidPreventDuplicateAddressCodesPerCustomer"] = this.soidPreventDuplicateAddressCodesPerCustomer;
        data["soidForceStateSelectionFromDropdown"] = this.soidForceStateSelectionFromDropdown;
        data["soidCustomerLimitContactsToThoseWhoCanAuthoriseSalesOrders"] = this.soidCustomerLimitContactsToThoseWhoCanAuthoriseSalesOrders;
        data["soidGenerateCustomerCodesStartingPoint"] = this.soidGenerateCustomerCodesStartingPoint;
        data["soidUseCounterSalesCashAliasCreationFormInBisTrack"] = this.soidUseCounterSalesCashAliasCreationFormInBisTrack;
        data["soidAutomaticallyGenerateCashCustomerAliasCode"] = this.soidAutomaticallyGenerateCashCustomerAliasCode;
        data["soidAutomaticallyApproveJobs"] = this.soidAutomaticallyApproveJobs;
        data["soidCustomerGenerateNewAddressCodeMethod"] = this.soidCustomerGenerateNewAddressCodeMethod;
        data["soidCopyInfoFromDefaultJobAddress"] = this.soidCopyInfoFromDefaultJobAddress;
        data["soidAddressValidationMethod"] = this.soidAddressValidationMethod;
        data["soidPasswordExpiryDays"] = this.soidPasswordExpiryDays;
        data["soidAllowNonAdministrativePasswordChange"] = this.soidAllowNonAdministrativePasswordChange;
        data["soidStaffNumberRestoreOriginalUser"] = this.soidStaffNumberRestoreOriginalUser;
        data["soidStaffNumberRequiredForNonSalesTransactions"] = this.soidStaffNumberRequiredForNonSalesTransactions;
        data["soidServerManagerBackupFolder"] = this.soidServerManagerBackupFolder;
        data["soidOrdersPricingRequireReasonCodeOnQuoteLinePriceChange"] = this.soidOrdersPricingRequireReasonCodeOnQuoteLinePriceChange;
        data["soidEmailFaxAllowEmailFromOrderCompletion"] = this.soidEmailFaxAllowEmailFromOrderCompletion;
        data["soidEmailFaxAllowEmailFromPurchaseOrderCompletion"] = this.soidEmailFaxAllowEmailFromPurchaseOrderCompletion;
        data["soidEmailFaxCCOtherSalesRepsOnOrderSend"] = this.soidEmailFaxCCOtherSalesRepsOnOrderSend;
        data["soidDefaultSalesOrderEmailAddressFromContactEmailAddress"] = this.soidDefaultSalesOrderEmailAddressFromContactEmailAddress;
        data["soidEmailFaxFaxMethod"] = this.soidEmailFaxFaxMethod;
        data["soidEmailFaxFaxAutoSendFolder"] = this.soidEmailFaxFaxAutoSendFolder;
        data["soidEmailFaxFaxEmailAddress"] = this.soidEmailFaxFaxEmailAddress;
        data["soidEmailUseSMTPForAllEmail"] = this.soidEmailUseSMTPForAllEmail;
        data["soidEmailUseTemplates"] = this.soidEmailUseTemplates;
        data["soidDatabaseMailProfileName"] = this.soidDatabaseMailProfileName;
        data["soidPrefaceEmailAddressWithContact"] = this.soidPrefaceEmailAddressWithContact;
        data["soidEmailFaxVsiFaxEmailNotifyOnEvent"] = this.soidEmailFaxVsiFaxEmailNotifyOnEvent;
        data["soidCashDrawerTotalTolerance"] = this.soidCashDrawerTotalTolerance;
        data["soidCashDrawerTenderBillDenominations"] = this.soidCashDrawerTenderBillDenominations;
        data["soidCashDrawerTenderCoinDenominations"] = this.soidCashDrawerTenderCoinDenominations;
        data["soidCashDrawerRequireCashDetailsToBeEntered"] = this.soidCashDrawerRequireCashDetailsToBeEntered;
        data["soidCashDrawerRequireClosingFloatDetailsToBeEntered"] = this.soidCashDrawerRequireClosingFloatDetailsToBeEntered;
        data["soidCashDrawerRequireOpeningFloatToBeCountedBeforeUse"] = this.soidCashDrawerRequireOpeningFloatToBeCountedBeforeUse;
        data["soidCashDrawerRequireChequeDetailsToBeEntered"] = this.soidCashDrawerRequireChequeDetailsToBeEntered;
        data["soidTransportBookingAllowUse"] = this.soidTransportBookingAllowUse;
        data["soidTransportBookingDistanceUnit"] = this.soidTransportBookingDistanceUnit;
        data["soidTransportBookingRequireDistance"] = this.soidTransportBookingRequireDistance;
        data["soidTransportBookingRequireInstructionsOnPO"] = this.soidTransportBookingRequireInstructionsOnPO;
        data["soidTransportBookingRequireInstructionsOnSO"] = this.soidTransportBookingRequireInstructionsOnSO;
        data["soidDisableRemainingCountInFindDocuments"] = this.soidDisableRemainingCountInFindDocuments;
        data["soidDisableRemainingCountInFindObjects"] = this.soidDisableRemainingCountInFindObjects;
        data["soidWarnIfNoSearchTextEnteredInFindProducts"] = this.soidWarnIfNoSearchTextEnteredInFindProducts;
        data["soidWarnIfNoSearchTextEnteredInFindCustomers"] = this.soidWarnIfNoSearchTextEnteredInFindCustomers;
        data["soidAllowLoadAllInPriceRules"] = this.soidAllowLoadAllInPriceRules;
        data["soidPoleCommunicationMethod"] = this.soidPoleCommunicationMethod;
        data["soidCachedSalesOrderCount"] = this.soidCachedSalesOrderCount;
        data["soidPerformanceAllowLoadAllOnJobs"] = this.soidPerformanceAllowLoadAllOnJobs;
        data["soidEnableGarbageCollection"] = this.soidEnableGarbageCollection;
        data["soidEDICreateImportedProductsForAllBranches"] = this.soidEDICreateImportedProductsForAllBranches;
        data["soidEDIUpdateCompanyLevelPricesOnImport"] = this.soidEDIUpdateCompanyLevelPricesOnImport;
        data["soidElectronicPaymentMethod"] = this.soidElectronicPaymentMethod;
        data["soidElectronicPaymentsUsePostalCode"] = this.soidElectronicPaymentsUsePostalCode;
        data["soidWebTrackServicesDefaultLocation"] = this.soidWebTrackServicesDefaultLocation;
        data["soidNumberOfDigitsOfCardNumberForDisplay"] = this.soidNumberOfDigitsOfCardNumberForDisplay;
        data["soidElectronicPaymentLoggingLevel"] = this.soidElectronicPaymentLoggingLevel;
        data["soidElectronicPaymentsUseAVS"] = this.soidElectronicPaymentsUseAVS;
        data["soidElectronicPaymentLoginTimeout"] = this.soidElectronicPaymentLoginTimeout;
        data["soidElectronicPaymentTransactionTimeout"] = this.soidElectronicPaymentTransactionTimeout;
        data["soidbisTrackServicesDefaultLocation"] = this.soidbisTrackServicesDefaultLocation;
        data["soidWebTrackServicesDefaultKey"] = this.soidWebTrackServicesDefaultKey;
        data["soidElectronicPaymentNoLogin"] = this.soidElectronicPaymentNoLogin;
        data["soidEDIUpdatePurchaseOrderCostOnImport"] = this.soidEDIUpdatePurchaseOrderCostOnImport;
        data["soidElectronicPaymentProviderForPurchasingCards"] = this.soidElectronicPaymentProviderForPurchasingCards;
        data["soidPaymentProviderWebServiceURL"] = this.soidPaymentProviderWebServiceURL;
        data["soidEDIUpdateCompanyLevelCostsOnImport"] = this.soidEDIUpdateCompanyLevelCostsOnImport;
        data["soidEDIRootFolder"] = this.soidEDIRootFolder;
        data["soidEDIManualLineTypeAVOPOs"] = this.soidEDIManualLineTypeAVOPOs;
        data["soidEDIAddressCodeForStockOrders"] = this.soidEDIAddressCodeForStockOrders;
        data["soidEDIStockSalesOrderDocumentFormats"] = this.soidEDIStockSalesOrderDocumentFormats;
        data["soidEDICustomerSalesOrderDocumentFormats"] = this.soidEDICustomerSalesOrderDocumentFormats;
        data["soidEDIAgentComputerName"] = this.soidEDIAgentComputerName;
        data["soidEDIAutoApproveInternalTradingOrders"] = this.soidEDIAutoApproveInternalTradingOrders;
        data["soidElectronicPaymentsUseAddress"] = this.soidElectronicPaymentsUseAddress;
        data["soidEDIDefaultProductCodeToSKUForProductMaint"] = this.soidEDIDefaultProductCodeToSKUForProductMaint;
        data["soidEDIUpdatePurchaseOrderQuantityOnImport"] = this.soidEDIUpdatePurchaseOrderQuantityOnImport;
        data["soidEDIDefaultSupplierInvoiceManualOrderLineType"] = this.soidEDIDefaultSupplierInvoiceManualOrderLineType;
        data["soidEDIInternalTradingSupplierAtBranchLevel"] = this.soidEDIInternalTradingSupplierAtBranchLevel;
        data["soidElectronicPaymentsShowWarningWhenCardDontMatchPaymentMethod"] = this.soidElectronicPaymentsShowWarningWhenCardDontMatchPaymentMethod;
        data["soidElectronicPaymentsNoCardAuthenticationOnApprovedTransaction"] = this.soidElectronicPaymentsNoCardAuthenticationOnApprovedTransaction;
        data["soidEDIAddLinesOnInboundSupplierInvoiceIfNoProductMatch"] = this.soidEDIAddLinesOnInboundSupplierInvoiceIfNoProductMatch;
        data["soidEDIRequireSupplierProductCodeForOutboundPO"] = this.soidEDIRequireSupplierProductCodeForOutboundPO;
        data["soidEDIAddLinesOnInboundSupplierInvoiceIfPerIsNotMapped"] = this.soidEDIAddLinesOnInboundSupplierInvoiceIfPerIsNotMapped;
        data["soidEDICheckProductSpecialOrderBehaviourForXpressPOS"] = this.soidEDICheckProductSpecialOrderBehaviourForXpressPOS;
        data["soidShift4MerchantID"] = this.soidShift4MerchantID;
        data["soidShift4SerialNumber"] = this.soidShift4SerialNumber;
        data["soidShift4Vendor"] = this.soidShift4Vendor;
        data["soidEDIAllowSelectionOfEDISupplierReferenceOnSalesOrder"] = this.soidEDIAllowSelectionOfEDISupplierReferenceOnSalesOrder;
        data["soidShift4TokenLongTermStorageDuration"] = this.soidShift4TokenLongTermStorageDuration;
        data["soidShift4CaptureSignatureThresholdAmount"] = this.soidShift4CaptureSignatureThresholdAmount;
        data["soidShift4TransactionGlobalTimerIntervalInSeconds"] = this.soidShift4TransactionGlobalTimerIntervalInSeconds;
        data["soidShift4TransactionReTryTimerIntervalInSeconds"] = this.soidShift4TransactionReTryTimerIntervalInSeconds;
        data["soidShift4APIPassword"] = this.soidShift4APIPassword;
        data["soidShift4UserName"] = this.soidShift4UserName;
        data["soidShift4CreditCardsOnReturnsOnly"] = this.soidShift4CreditCardsOnReturnsOnly;
        data["soidElectronicPaymentConnectionDelay"] = this.soidElectronicPaymentConnectionDelay;
        data["soidEDIExportAdditionalChargesAsAllowances"] = this.soidEDIExportAdditionalChargesAsAllowances;
        data["soidEDIExportAVOsAsAllowances"] = this.soidEDIExportAVOsAsAllowances;
        data["soidShift4i4GoAccountID"] = this.soidShift4i4GoAccountID;
        data["soidShift4i4GoSiteID"] = this.soidShift4i4GoSiteID;
        data["soidShift4i4GoPassword"] = this.soidShift4i4GoPassword;
        data["soidCommunicateToShift4UTGServersUsingHTTPS"] = this.soidCommunicateToShift4UTGServersUsingHTTPS;
        data["soidEDIEnableDIBBuyingGroupFeatures"] = this.soidEDIEnableDIBBuyingGroupFeatures;
        data["soidTenderRetailConnectionTimeoutInSeconds"] = this.soidTenderRetailConnectionTimeoutInSeconds;
        data["soidTenderRetailResponseTimeoutInSeconds"] = this.soidTenderRetailResponseTimeoutInSeconds;
        data["soidTenderRetailPositiveAckTimeoutInSeconds"] = this.soidTenderRetailPositiveAckTimeoutInSeconds;
        data["soidGivexUserID"] = this.soidGivexUserID;
        data["soidGivexPassword"] = this.soidGivexPassword;
        data["soidShift4SkipSignatureCaptureForCardOnFile"] = this.soidShift4SkipSignatureCaptureForCardOnFile;
        data["soidShift4EnableSwipeAhead"] = this.soidShift4EnableSwipeAhead;
        data["soidShift4PINPadDisplayDelayInMilliseconds"] = this.soidShift4PINPadDisplayDelayInMilliseconds;
        data["soidEDIUpdateProductDescriptionOnEDIProductMaintenance"] = this.soidEDIUpdateProductDescriptionOnEDIProductMaintenance;
        data["soidEDIUpdateSupplierProductDescriptionOnEDIProductMaintenance"] = this.soidEDIUpdateSupplierProductDescriptionOnEDIProductMaintenance;
        data["soidShift4TRAllowTokensForSubsequentPaymentsOnSameTransaction"] = this.soidShift4TRAllowTokensForSubsequentPaymentsOnSameTransaction;
        data["soidDisplayPromoCodeForPrivateLabelCreditCardProcessing"] = this.soidDisplayPromoCodeForPrivateLabelCreditCardProcessing;
        data["soidEnableBlueTarpElectronicPaymentIntegration"] = this.soidEnableBlueTarpElectronicPaymentIntegration;
        data["soidShift4i4GoLiveURL"] = this.soidShift4i4GoLiveURL;
        data["soidShift4i4GoTestURL"] = this.soidShift4i4GoTestURL;
        data["soidBlueTarpMerchantID"] = this.soidBlueTarpMerchantID;
        data["soidBlueTarpClientKey"] = this.soidBlueTarpClientKey;
        data["soidBlueTarpBaseURL"] = this.soidBlueTarpBaseURL;
        data["soidEDIRestrictProductUpdateToDefaultSupplier"] = this.soidEDIRestrictProductUpdateToDefaultSupplier;
        data["soidCollectAirMilesCardDetailsWithPayments"] = this.soidCollectAirMilesCardDetailsWithPayments;
        data["soidAirMilesDefaultOfferCodeForCashSales"] = this.soidAirMilesDefaultOfferCodeForCashSales;
        data["soidAirMilesDefaultOfferCodeForCashSalesToChargeAccount"] = this.soidAirMilesDefaultOfferCodeForCashSalesToChargeAccount;
        data["soidAirMilesDefaultOfferCodeForZeroAmountAirMilesTransactions"] = this.soidAirMilesDefaultOfferCodeForZeroAmountAirMilesTransactions;
        data["soidAirMilesDefaultTerminalID"] = this.soidAirMilesDefaultTerminalID;
        data["soidAirMilesDefaultServerIPAddress"] = this.soidAirMilesDefaultServerIPAddress;
        data["soidAirMilesDefaultServerPortNumber"] = this.soidAirMilesDefaultServerPortNumber;
        data["soidAirMilesConnectionTimeoutInSeconds"] = this.soidAirMilesConnectionTimeoutInSeconds;
        data["soidAirMilesResponseTimeoutInSeconds"] = this.soidAirMilesResponseTimeoutInSeconds;
        data["soidShift4UseVoidOnDebitReversal"] = this.soidShift4UseVoidOnDebitReversal;
        data["soidPerformPreAuthWhenBackOrderingSOWithExistingWTPreAuth"] = this.soidPerformPreAuthWhenBackOrderingSOWithExistingWTPreAuth;
        data["soidShift4ReceiptTextWidth"] = this.soidShift4ReceiptTextWidth;
        data["soidShift4AccessMethod"] = this.soidShift4AccessMethod;
        data["soidEDITemplateManualOrderLine"] = this.soidEDITemplateManualOrderLine;
        data["soidShift4i4GoVersion"] = this.soidShift4i4GoVersion;
        data["soidEDIAPAutomationAttachmentsFolder"] = this.soidEDIAPAutomationAttachmentsFolder;
        data["soidDoNotDisplayManualCheckboxForShift4ElectronicPayments"] = this.soidDoNotDisplayManualCheckboxForShift4ElectronicPayments;
        data["soidPreSaveNewSalesOrdersBeforeProcessingShift4ElectronicPayment"] = this.soidPreSaveNewSalesOrdersBeforeProcessingShift4ElectronicPayment;
        data["soidShift4AllowManualEntryOfVoiceAuthorizations"] = this.soidShift4AllowManualEntryOfVoiceAuthorizations;
        data["soidShift4i4GoAccessLiveURL"] = this.soidShift4i4GoAccessLiveURL;
        data["soidShift4i4GoAccessTestURL"] = this.soidShift4i4GoAccessTestURL;
        data["soidShift4i4GoTokenServiceURL"] = this.soidShift4i4GoTokenServiceURL;
        data["soidShift4i4GoCardSecurityCodeRequired"] = this.soidShift4i4GoCardSecurityCodeRequired;
        data["soidShift4i4GoAcceptedCardTypes"] = this.soidShift4i4GoAcceptedCardTypes;
        data["soidShift4i4GoCardholderNamePrompt"] = this.soidShift4i4GoCardholderNamePrompt;
        data["soidShift4i4GoStreetAddressPrompt"] = this.soidShift4i4GoStreetAddressPrompt;
        data["soidShift4i4GoPostalCodePrompt"] = this.soidShift4i4GoPostalCodePrompt;
        data["soidShift4GetNewLongTermTokenWhenCardOnFileIsUsed"] = this.soidShift4GetNewLongTermTokenWhenCardOnFileIsUsed;
        data["soidShift4UseI4GoAVS"] = this.soidShift4UseI4GoAVS;
        data["soidShift4i4GoPublicIPServiceURL"] = this.soidShift4i4GoPublicIPServiceURL;
        data["soidTenderRetailProcessor"] = this.soidTenderRetailProcessor;
        data["soidShift4VoidOnTimeOut"] = this.soidShift4VoidOnTimeOut;
        data["soidShift4SendTransactionsInAsyncMode"] = this.soidShift4SendTransactionsInAsyncMode;
        data["soidAirMilesStandardOfferCodes"] = this.soidAirMilesStandardOfferCodes;
        data["soidShift4CreditCardsOnPaymentsOnly"] = this.soidShift4CreditCardsOnPaymentsOnly;
        data["soidTemplateManualOrderLineForAcePromotions"] = this.soidTemplateManualOrderLineForAcePromotions;
        data["soidAceCustomerLoyaltyLevel"] = this.soidAceCustomerLoyaltyLevel;
        data["soidACERewardsWebService"] = this.soidACERewardsWebService;
        data["soidACERewardsWebServiceUsername"] = this.soidACERewardsWebServiceUsername;
        data["soidACERewardsWebServicePassword"] = this.soidACERewardsWebServicePassword;
        data["soidUseDefaultCashCustomerForExistingACERewardsCustomers"] = this.soidUseDefaultCashCustomerForExistingACERewardsCustomers;
        data["soidACERewardsCustomerLookupWebService"] = this.soidACERewardsCustomerLookupWebService;
        data["soidTenderRetailCheckForWinsockErrorAfterSendingPositiveACK"] = this.soidTenderRetailCheckForWinsockErrorAfterSendingPositiveACK;
        data["soidACERewardsVerifyCustomerDetailsWhenRequestedByACE"] = this.soidACERewardsVerifyCustomerDetailsWhenRequestedByACE;
        data["soidEDIAPAutomationProcessTo"] = this.soidEDIAPAutomationProcessTo;
        data["soidShift4i4GoCardholderNamePromptInWebTrack"] = this.soidShift4i4GoCardholderNamePromptInWebTrack;
        data["soidShift4i4GoStreetAddressPromptInWebTrack"] = this.soidShift4i4GoStreetAddressPromptInWebTrack;
        data["soidShift4i4GoPostalCodePromptInWebTrack"] = this.soidShift4i4GoPostalCodePromptInWebTrack;
        data["soidEDIIgnoreBlankOrZeroValuesDuringProductMaintenanceUpdate"] = this.soidEDIIgnoreBlankOrZeroValuesDuringProductMaintenanceUpdate;
        data["soidEDIAttachmentFolderForSOProductImages"] = this.soidEDIAttachmentFolderForSOProductImages;
        data["soidEDIAPAutomationCreateInvoiceWithoutStockReceipt"] = this.soidEDIAPAutomationCreateInvoiceWithoutStockReceipt;
        data["soidGiftCardProductForACETypeXPromotions"] = this.soidGiftCardProductForACETypeXPromotions;
        data["soidSplitIntegratedCardPaymentMethodByTypeOnAccountPayments"] = this.soidSplitIntegratedCardPaymentMethodByTypeOnAccountPayments;
        data["soidEDIAPAutomationCreditNoteAttachmentFolder"] = this.soidEDIAPAutomationCreditNoteAttachmentFolder;
        data["soidWebTrackSecondsToWaitForReportServerToReturnDocument"] = this.soidWebTrackSecondsToWaitForReportServerToReturnDocument;
        data["soidWebTrackShift4i4GoAccountID"] = this.soidWebTrackShift4i4GoAccountID;
        data["soidWebTrackShift4i4GoSiteID"] = this.soidWebTrackShift4i4GoSiteID;
        data["soidWebTrackShift4i4GoPassword"] = this.soidWebTrackShift4i4GoPassword;
        data["soidWebTrackRestrictProdAccessUsingCustWTProdGrps"] = this.soidWebTrackRestrictProdAccessUsingCustWTProdGrps;
        data["soidWebTrackShowLocationWithVehicleTracking"] = this.soidWebTrackShowLocationWithVehicleTracking;
        data["soidOrdersEnableMiTekImportFeatures"] = this.soidOrdersEnableMiTekImportFeatures;
        data["soidOrdersMiTekImportFolder"] = this.soidOrdersMiTekImportFolder;
        data["soidOrdersImportReferenceDestination"] = this.soidOrdersImportReferenceDestination;
        data["soidNewPerMode"] = this.soidNewPerMode;
        data["soidNewTaxMode"] = this.soidNewTaxMode;
        data["soidLastLiveOrderID"] = this.soidLastLiveOrderID;
        data["soidLastLiveSellPriceRuleID"] = this.soidLastLiveSellPriceRuleID;
        data["soidNewReportPrintMode"] = this.soidNewReportPrintMode;
        data["soidNewPriceMode"] = this.soidNewPriceMode;
        data["soidSupplierInvoiceAllowPreEnteredStockReceipts"] = this.soidSupplierInvoiceAllowPreEnteredStockReceipts;
        data["soidEnablePromptForCrystalParameters"] = this.soidEnablePromptForCrystalParameters;
        data["soidUseOrderFilterForSOPSearches"] = this.soidUseOrderFilterForSOPSearches;
        data["soidNewSearchMode"] = this.soidNewSearchMode;
        data["soidDatabaseUpgrading"] = this.soidDatabaseUpgrading;
        data["soidUseInventoryAgingAndCommissionCosts"] = this.soidUseInventoryAgingAndCommissionCosts;
        data["soidEnablePerformanceLogging"] = this.soidEnablePerformanceLogging;
        data["soidPurchasingInputExchangeRateFromBase"] = this.soidPurchasingInputExchangeRateFromBase;
        data["soidUseOldCrystalPrintingMethods"] = this.soidUseOldCrystalPrintingMethods;
        data["soidShowInternalCostOnProductFind"] = this.soidShowInternalCostOnProductFind;
        data["soidAllowSupplierProductReference"] = this.soidAllowSupplierProductReference;
        data["soidEnableScanTrackIntegration"] = this.soidEnableScanTrackIntegration;
        data["soidJourneyPlanningStyle"] = this.soidJourneyPlanningStyle;
        data["soidEnableNewProductFindMode"] = this.soidEnableNewProductFindMode;
        data["soidDisableLicensing"] = this.soidDisableLicensing;
        data["soidDisableRebuildStockOnOrderForReceipt"] = this.soidDisableRebuildStockOnOrderForReceipt;
        data["soidCashDrawerRedirectMessageValidity"] = this.soidCashDrawerRedirectMessageValidity;
        data["soidLastProductGroupEdit"] = this.soidLastProductGroupEdit;
        data["soidLastSortedProductGroupUpdate"] = this.soidLastSortedProductGroupUpdate;
        data["soidAllowBranchLevelPackOptions"] = this.soidAllowBranchLevelPackOptions;
        data["soidUseRecordsetLoadWithNoTransaction"] = this.soidUseRecordsetLoadWithNoTransaction;
        data["soidAllowMemoQuantityInput"] = this.soidAllowMemoQuantityInput;
        data["soidJourneyPlannerAllowDeliveredPOs"] = this.soidJourneyPlannerAllowDeliveredPOs;
        data["soidQuickProductsImage1"] = this.soidQuickProductsImage1;
        data["soidQuickProductsImage2"] = this.soidQuickProductsImage2;
        data["soidQuickProductsImage3"] = this.soidQuickProductsImage3;
        data["soidQuickProductsShowImages"] = this.soidQuickProductsShowImages;
        data["soidAllowAuthorizedBuyerByJob"] = this.soidAllowAuthorizedBuyerByJob;
        data["soidEnablePricingPlanner"] = this.soidEnablePricingPlanner;
        data["soidSystemUpgradeEmailAddress"] = this.soidSystemUpgradeEmailAddress;
        data["soidEnablePriceChecker"] = this.soidEnablePriceChecker;
        data["soidEnableBisTrackCount"] = this.soidEnableBisTrackCount;
        data["soidEnableBisTrackReceipt"] = this.soidEnableBisTrackReceipt;
        data["soidPurchasingCostDebugMode"] = this.soidPurchasingCostDebugMode;
        data["soidAllowTotalStockAdjustmentOfStockByLengthProducts"] = this.soidAllowTotalStockAdjustmentOfStockByLengthProducts;
        data["soidWorksOrderKeepSameCostIfFinishedInSource"] = this.soidWorksOrderKeepSameCostIfFinishedInSource;
        data["soidPermissionDetailLastUpdateVersion"] = this.soidPermissionDetailLastUpdateVersion;
        data["soidAddSettlementDiscAvailToSalesAndProductAnalysisCubes"] = this.soidAddSettlementDiscAvailToSalesAndProductAnalysisCubes;
        data["soidSalesAnalysisCodeForSettlementDiscAvailInSalesAnalysis"] = this.soidSalesAnalysisCodeForSettlementDiscAvailInSalesAnalysis;
        data["soidPurchaseAnalysisType"] = this.soidPurchaseAnalysisType;
        data["soidPurchaseAnalysisDetailStartDate"] = this.soidPurchaseAnalysisDetailStartDate;
        data["soidSalesAnalysisCodeToPostSalesDiscountsToInSalesAnalysis"] = this.soidSalesAnalysisCodeToPostSalesDiscountsToInSalesAnalysis;
        data["soidPostPromotionDiscountAmountsProratedOverProducts"] = this.soidPostPromotionDiscountAmountsProratedOverProducts;
        data["soidReportServer2AgentPollingInterval"] = this.soidReportServer2AgentPollingInterval;
        data["soidReportServer2AgentLoggingLevel"] = this.soidReportServer2AgentLoggingLevel;
        data["soidReportServer2ProcessEmailedDocuments"] = this.soidReportServer2ProcessEmailedDocuments;
        data["soidReportServer2ImageInvoiceFormat"] = this.soidReportServer2ImageInvoiceFormat;
        data["soidReportServer2ImageCreditNoteFormat"] = this.soidReportServer2ImageCreditNoteFormat;
        data["soidReportServer2ImageSalesOrderFormat"] = this.soidReportServer2ImageSalesOrderFormat;
        data["soidReportServer2ImageInvoiceSTDocType"] = this.soidReportServer2ImageInvoiceSTDocType;
        data["soidReportServer2ImageCreditNoteSTDocType"] = this.soidReportServer2ImageCreditNoteSTDocType;
        data["soidReportServer2ImageSalesOrderSTDocType"] = this.soidReportServer2ImageSalesOrderSTDocType;
        data["soidReportServer2ImageReleasedFrom"] = this.soidReportServer2ImageReleasedFrom;
        data["soidReportServer2ImageFileType"] = this.soidReportServer2ImageFileType;
        data["soidReportServer2ImageColourDepth"] = this.soidReportServer2ImageColourDepth;
        data["soidReportServer2ImageDPI"] = this.soidReportServer2ImageDPI;
        data["soidReportServer2ImageJPGQuality"] = this.soidReportServer2ImageJPGQuality;
        data["soidReportServer2ImageTIFCompression"] = this.soidReportServer2ImageTIFCompression;
        data["soidReportServer2ImageTIFMultiPage"] = this.soidReportServer2ImageTIFMultiPage;
        data["soidReportServer2ImageTimeTo"] = this.soidReportServer2ImageTimeTo;
        data["soidReportServer2Timeout"] = this.soidReportServer2Timeout;
        data["soidReportServer2AutoDelInvoiceFormat"] = this.soidReportServer2AutoDelInvoiceFormat;
        data["soidReportServer2AutoDelInvoiceEmailTemplate"] = this.soidReportServer2AutoDelInvoiceEmailTemplate;
        data["soidReportServer2AutoDelCreditNoteFormat"] = this.soidReportServer2AutoDelCreditNoteFormat;
        data["soidReportServer2AutoDelCreditNoteEmailTemplate"] = this.soidReportServer2AutoDelCreditNoteEmailTemplate;
        data["soidReportServer2AutoDelSendTime"] = this.soidReportServer2AutoDelSendTime;
        data["soidReportServer2AutoDelDocumentsSince"] = this.soidReportServer2AutoDelDocumentsSince;
        data["soidReportServer2AutoDeliveryEnabled"] = this.soidReportServer2AutoDeliveryEnabled;
        data["soidDeadProductsCheck"] = this.soidDeadProductsCheck;
        data["soidDeadProductsIncludeTimber"] = this.soidDeadProductsIncludeTimber;
        data["soidDeadProductsLowUsageCount"] = this.soidDeadProductsLowUsageCount;
        data["soidDeadProductsLowReceiptCount"] = this.soidDeadProductsLowReceiptCount;
        data["soidDeadProductsMarkNonStockedIfLowActivityxMonths"] = this.soidDeadProductsMarkNonStockedIfLowActivityxMonths;
        data["soidDeadProductsMarkDeletedIfLowActivityxMonths"] = this.soidDeadProductsMarkDeletedIfLowActivityxMonths;
        data["soidDeadProductsStandardStockOnly"] = this.soidDeadProductsStandardStockOnly;
        data["soidDeadProductsSpecialsDaysAgo"] = this.soidDeadProductsSpecialsDaysAgo;
        data["soidReportServer2AutoDelCashInvoiceFormat"] = this.soidReportServer2AutoDelCashInvoiceFormat;
        data["soidReportServer2AutoDelCashRefundFormat"] = this.soidReportServer2AutoDelCashRefundFormat;
        data["soidReportServer2NotificationDeliveryInProgressEmailTemplate"] = this.soidReportServer2NotificationDeliveryInProgressEmailTemplate;
        data["soidReportServer2NotificationDeliveryInProgressFormat"] = this.soidReportServer2NotificationDeliveryInProgressFormat;
        data["soidReportServer2NotificationOrderDeliveredEmailTemplate"] = this.soidReportServer2NotificationOrderDeliveredEmailTemplate;
        data["soidReportServer2NotificationOrderDeliveredFormat"] = this.soidReportServer2NotificationOrderDeliveredFormat;
        data["soidReportServer2NotificationDeliveryETAEmailTemplate"] = this.soidReportServer2NotificationDeliveryETAEmailTemplate;
        data["soidReportServer2NotificationDeliveryETAFormat"] = this.soidReportServer2NotificationDeliveryETAFormat;
        data["soidCRMEventsQuoteAcceptEnable"] = this.soidCRMEventsQuoteAcceptEnable;
        data["soidCRMEventsQuoteRejectEnable"] = this.soidCRMEventsQuoteRejectEnable;
        data["soidCRMEventsEmailSentEnable"] = this.soidCRMEventsEmailSentEnable;
        data["soidCRMEventsLetterWrittenEnable"] = this.soidCRMEventsLetterWrittenEnable;
        data["soidCRMEventsOrderCreditHoldOnEnable"] = this.soidCRMEventsOrderCreditHoldOnEnable;
        data["soidCRMEventsOrderCreditHoldOffEnable"] = this.soidCRMEventsOrderCreditHoldOffEnable;
        data["soidCRMEventsAccountOnHoldEnable"] = this.soidCRMEventsAccountOnHoldEnable;
        data["soidCRMEventsAccountOffHoldEnable"] = this.soidCRMEventsAccountOffHoldEnable;
        data["soidCRMCalendarDayStart"] = this.soidCRMCalendarDayStart;
        data["soidCRMCalendarDayEnd"] = this.soidCRMCalendarDayEnd;
        data["soidCRMCalendarTimeInterval"] = this.soidCRMCalendarTimeInterval;
        data["soidCRMCalendarFollowUpDuration"] = this.soidCRMCalendarFollowUpDuration;
        data["soidCRMCampaignsDefaultNotepadType"] = this.soidCRMCampaignsDefaultNotepadType;
        data["soidCRMEventsCampaignActionComplete"] = this.soidCRMEventsCampaignActionComplete;
        data["soidItemMessageCreationSubject"] = this.soidItemMessageCreationSubject;
        data["soidItemMessageCreationBody"] = this.soidItemMessageCreationBody;
        data["soidItemMessageClosureSubject"] = this.soidItemMessageClosureSubject;
        data["soidItemMessageClosureBody"] = this.soidItemMessageClosureBody;
        data["soidItemMessageNotificationSubject"] = this.soidItemMessageNotificationSubject;
        data["soidItemMessageNotificationBody"] = this.soidItemMessageNotificationBody;
        data["soidItemDevSignOffPrompt1"] = this.soidItemDevSignOffPrompt1;
        data["soidItemDevSignOffPrompt2"] = this.soidItemDevSignOffPrompt2;
        data["soidItemDefaultTesterID"] = this.soidItemDefaultTesterID;
        data["soidItemDefaultTesterName"] = this.soidItemDefaultTesterName;
        data["soidItemDefaultTesterTypeOfWorkID"] = this.soidItemDefaultTesterTypeOfWorkID;
        data["soidItemDefaultTestAnalysisCodeID"] = this.soidItemDefaultTestAnalysisCodeID;
        data["soidItemForceProjectEntry"] = this.soidItemForceProjectEntry;
        data["soidItemNotesForNonDevItems"] = this.soidItemNotesForNonDevItems;
        data["soidItemGenerateCustomerSpecificeItemReferences"] = this.soidItemGenerateCustomerSpecificeItemReferences;
        data["soidItemUseBillToItems"] = this.soidItemUseBillToItems;
        data["soidItemLockTimeTransactionsPreviousToThisDate"] = this.soidItemLockTimeTransactionsPreviousToThisDate;
        data["soidItemPreventAddEditOfTimeOnClosedCancelledItems"] = this.soidItemPreventAddEditOfTimeOnClosedCancelledItems;
        data["soidSTServerFolder"] = this.soidSTServerFolder;
        data["soidItemAllowEntryOfSeparateChargeableTime"] = this.soidItemAllowEntryOfSeparateChargeableTime;
        data["soidItemAllowTimeSheetWeekApproval"] = this.soidItemAllowTimeSheetWeekApproval;
        data["soidItemNonDevVersionOptional"] = this.soidItemNonDevVersionOptional;
        data["soidItemNonDevDefaultPriority"] = this.soidItemNonDevDefaultPriority;
        data["soidItemLockChargingInfoBeforeThisDate"] = this.soidItemLockChargingInfoBeforeThisDate;
        data["soidItemUseProjectInvoiceApproval"] = this.soidItemUseProjectInvoiceApproval;
        data["soidEmailServer"] = this.soidEmailServer;
        data["soidEmailUsername"] = this.soidEmailUsername;
        data["soidEmailPassword"] = this.soidEmailPassword;
        data["soidEmailSenderAddress"] = this.soidEmailSenderAddress;
        data["soidEmailPort"] = this.soidEmailPort;
        data["soidEmailUseSMTPDefaultAsFromAddress"] = this.soidEmailUseSMTPDefaultAsFromAddress;
        data["soidEmailUseSMTPDefaultAsSenderAddress"] = this.soidEmailUseSMTPDefaultAsSenderAddress;
        data["soidEmailUseSMTPReplyToAddress"] = this.soidEmailUseSMTPReplyToAddress;
        data["soidEmailEncryption"] = this.soidEmailEncryption;
        data["soidInstantReleaseKey"] = this.soidInstantReleaseKey;
        data["soidCloudQuoteDocumentFormatNumber"] = this.soidCloudQuoteDocumentFormatNumber;
        data["soidCloudTemplateOrderDocumentFormatNumber"] = this.soidCloudTemplateOrderDocumentFormatNumber;
        data["soidCloudCallOffOrderDocumentFormatNumber"] = this.soidCloudCallOffOrderDocumentFormatNumber;
        data["soidCloudSalesOrderDocumentFormatNumber"] = this.soidCloudSalesOrderDocumentFormatNumber;
        data["soidCloudInvoiceDocumentFormatNumber"] = this.soidCloudInvoiceDocumentFormatNumber;
        data["soidCloudCreditNoteDocumentFormatNumber"] = this.soidCloudCreditNoteDocumentFormatNumber;
        data["soidCloudPurchaseOrderDocumentFormatNumber"] = this.soidCloudPurchaseOrderDocumentFormatNumber;
        data["soidCloudTransferDocumentFormatNumber"] = this.soidCloudTransferDocumentFormatNumber;
        data["soidCloudWorkOrderDocumentFormatNumber"] = this.soidCloudWorkOrderDocumentFormatNumber;
        data["soidCrystalUsePrintLayoutSettings"] = this.soidCrystalUsePrintLayoutSettings;
        data["soidCrystalUseRAS"] = this.soidCrystalUseRAS;
        data["soidCrystalUseThreading"] = this.soidCrystalUseThreading;
        data["soidCrystalThreadingTimeout"] = this.soidCrystalThreadingTimeout;
        data["soidEnableCTI"] = this.soidEnableCTI;
        data["soidOIGServerAddress"] = this.soidOIGServerAddress;
        data["soidOIGIcpIPAddress"] = this.soidOIGIcpIPAddress;
        data["soidOIGEventHandlerURL"] = this.soidOIGEventHandlerURL;
        data["soidOIGApplicationName"] = this.soidOIGApplicationName;
        data["soidOIGApplicationPassword"] = this.soidOIGApplicationPassword;
        data["soidOIGCompanyName"] = this.soidOIGCompanyName;
        data["soidOIGLocalPassword"] = this.soidOIGLocalPassword;
        data["soidCTIProvider"] = this.soidCTIProvider;
        data["soidCTICustomerDashboard"] = this.soidCTICustomerDashboard;
        data["soidCTISupplierDashboard"] = this.soidCTISupplierDashboard;
        data["soidCTIUserDashboard"] = this.soidCTIUserDashboard;
        data["soidCTICustomerDashboardDefault"] = this.soidCTICustomerDashboardDefault;
        data["soidCTISupplierDashboardDefault"] = this.soidCTISupplierDashboardDefault;
        data["soidCTIUserDashboardDefault"] = this.soidCTIUserDashboardDefault;
        data["soidGrahamsDemo"] = this.soidGrahamsDemo;
        data["soidSuppliersEnablePermissionsByTab"] = this.soidSuppliersEnablePermissionsByTab;
        data["soidDefaultOrderSingleLengthTalliedLumberQuantityToZero"] = this.soidDefaultOrderSingleLengthTalliedLumberQuantityToZero;
        data["soidOnlyUseReplacementProductWhenNoStock"] = this.soidOnlyUseReplacementProductWhenNoStock;
        data["soidAllowStockInformationForBranchesWithoutReadAccess"] = this.soidAllowStockInformationForBranchesWithoutReadAccess;
        data["soidLimitProductAddToQtyOnlyMethodOnTransfers"] = this.soidLimitProductAddToQtyOnlyMethodOnTransfers;
        data["soidBranchAccessLevelRequiredForIssuingBranch"] = this.soidBranchAccessLevelRequiredForIssuingBranch;
        data["soidEnableWMSProcessing"] = this.soidEnableWMSProcessing;
        data["soidDefaultCollectLaterWMSPickingStatus"] = this.soidDefaultCollectLaterWMSPickingStatus;
        data["soidWMSOutgoingGenerationInProgress"] = this.soidWMSOutgoingGenerationInProgress;
        data["soidEDIPurgeWMSDocumentDays"] = this.soidEDIPurgeWMSDocumentDays;
        data["soidConsolidateLineNotesOnSOConsolidate"] = this.soidConsolidateLineNotesOnSOConsolidate;
        data["soidDefaultExcludeSpecialsOnPricingOption"] = this.soidDefaultExcludeSpecialsOnPricingOption;
        data["soidTranferLimitToFinalCostWhenNoReadAccessToSendingBranch"] = this.soidTranferLimitToFinalCostWhenNoReadAccessToSendingBranch;
        data["soidDisplayProductPopupOnQuoteAcceptanceAndSalesCopy"] = this.soidDisplayProductPopupOnQuoteAcceptanceAndSalesCopy;
        data["soidEnableWMSBackWorksOrders"] = this.soidEnableWMSBackWorksOrders;
        data["soidEnableWMSDocumentPrinting"] = this.soidEnableWMSDocumentPrinting;
        data["soidWorksOrderDefaultWMSType"] = this.soidWorksOrderDefaultWMSType;
        data["soidUpdateSpecialProductDescriptionWithOrderLineDescription"] = this.soidUpdateSpecialProductDescriptionWithOrderLineDescription;
        data["soidCashSalesRequireFullPaymentForCollectLaterNowCompletion"] = this.soidCashSalesRequireFullPaymentForCollectLaterNowCompletion;
        data["soidDefaultOrderLineAmendReasonForWMSSubstitution"] = this.soidDefaultOrderLineAmendReasonForWMSSubstitution;
        data["soidWMSSubstitutionRecalculatePrice"] = this.soidWMSSubstitutionRecalculatePrice;
        data["soidDisplaySuccessfulConfirmationPopUps"] = this.soidDisplaySuccessfulConfirmationPopUps;
        data["soidConfirmContractSelectionOnSalesOrderCompletion"] = this.soidConfirmContractSelectionOnSalesOrderCompletion;
        data["soidWMSSendReleasedNotProcessedCreditNoteQuantityInQuantitySync"] = this.soidWMSSendReleasedNotProcessedCreditNoteQuantityInQuantitySync;
        data["soidEnableWMSBackTransfers"] = this.soidEnableWMSBackTransfers;
        data["soidEnablePurchaseOrderExcludeFromWMS"] = this.soidEnablePurchaseOrderExcludeFromWMS;
        data["soidWMSDoNotSentOrderLineInternalNotes"] = this.soidWMSDoNotSentOrderLineInternalNotes;
        data["soidWMSTimberTalliedProductsMustBeSingleLength"] = this.soidWMSTimberTalliedProductsMustBeSingleLength;
        data["soidWMSOrderHeaderLicensePlateUDF"] = this.soidWMSOrderHeaderLicensePlateUDF;
        data["soidShowCubeMeasures"] = this.soidShowCubeMeasures;
        data["soidDefaultPricingOptionsToPriceProfiles"] = this.soidDefaultPricingOptionsToPriceProfiles;
        data["soidUseNewSalesOrderEntryForm"] = this.soidUseNewSalesOrderEntryForm;
        data["soidWorksOrderSendMachineGroupToWMS"] = this.soidWorksOrderSendMachineGroupToWMS;
        data["soidOrdersSendJourneyReferenceToWMS"] = this.soidOrdersSendJourneyReferenceToWMS;
        data["soidReleaseOrdersForPickingToWMSDaysInAdvance"] = this.soidReleaseOrdersForPickingToWMSDaysInAdvance;
        data["soidWorksOrderRequireReleaseForManufactureInWMS"] = this.soidWorksOrderRequireReleaseForManufactureInWMS;
        data["soidReleaseWorksOrdersForManufactureToWMSDaysInAdvance"] = this.soidReleaseWorksOrdersForManufactureToWMSDaysInAdvance;
        data["soidGenerateWorkOrdersForIncomingSalesOrders"] = this.soidGenerateWorkOrdersForIncomingSalesOrders;
        data["soidWMSJourneyReferenceLength"] = this.soidWMSJourneyReferenceLength;
        data["soidWMSSendShipCompleteTagForSalesOrders"] = this.soidWMSSendShipCompleteTagForSalesOrders;
        data["soidDefaultSalesRepOnTransactionsToTakenByLinkedSalesRep"] = this.soidDefaultSalesRepOnTransactionsToTakenByLinkedSalesRep;
        data["soidWMSEnableASNTransactions"] = this.soidWMSEnableASNTransactions;
        return data; 
    }
}

export interface ISystemOptions {
    soidPickingZoneFormatNumber?: string | undefined;
    soidServerFolder?: string | undefined;
    soidAllowBlankPasswords?: string | undefined;
    soidMaximumProductGroupLevels?: string | undefined;
    soidCubeServerFolder?: string | undefined;
    soidHTMLServerFolder?: string | undefined;
    soidReportServerFolder?: string | undefined;
    soidTemplateServerFolder?: string | undefined;
    soidTerminalServers?: string | undefined;
    soidDefaultLabelPrinter?: string | undefined;
    soidAllowBackToBacks?: string | undefined;
    soidNoOfDocumentFormats?: string | undefined;
    soidShowDetailedPrinterDialogForLabels?: string | undefined;
    soidDefaultCountry?: string | undefined;
    soidOrderNumberIncrement?: string | undefined;
    soidCompanyName?: string | undefined;
    soidCompanyAddress?: string | undefined;
    soidCompanyRegistrationNumber?: string | undefined;
    soidVATRegistrationNumber?: string | undefined;
    soidCompanyCatalogueURL?: string | undefined;
    soidCompanyCatalogueName?: string | undefined;
    soidVATValidationURL?: string | undefined;
    soidLongRunningProceduresTimeout?: string | undefined;
    soidStandardSQLQueryTimeout?: string | undefined;
    soidUseReadUnCommittedTransactionIsolationLevel?: string | undefined;
    soidCrystalReportsVersion?: string | undefined;
    soidReportServerVersion?: string | undefined;
    soidCrystalReportsAllowIntegratedSecurity?: string | undefined;
    soidSQLReportsServerURL?: string | undefined;
    soidSQLReportsBuilderVersion?: string | undefined;
    soidSQLReportsServerVersion?: string | undefined;
    soidSQLReportsViewerVersion?: string | undefined;
    soidBaseCurrency?: string | undefined;
    soidAlternativeCurrency?: string | undefined;
    soidDefaultVatRate?: string | undefined;
    soidDefaultCashCustomer?: string | undefined;
    soidConsolidateLines?: string | undefined;
    soidVatRuleForDeliveryCharge?: string | undefined;
    soidMaximumDimensions?: string | undefined;
    soidAllowSetCustomerOnHold?: string | undefined;
    soidDueDateGraceDays?: string | undefined;
    soidIgnoreSmallBalancesUpTo?: string | undefined;
    soidOverdueBalanceChecking?: string | undefined;
    soidCreditControlDisableCreditLimitChecksOnOrders?: string | undefined;
    soidCreditControlAllowCashOnCreditHold?: string | undefined;
    soidCreditControlAllowInstantCreditRelease?: string | undefined;
    soidCreditControlPromptForOriginalComputer?: string | undefined;
    soidCreditControlAllowCashAccountBalances?: string | undefined;
    soidCreditControlOrderChangeTolerance?: string | undefined;
    soidCreditControlDisableCreditLimitChecksOnOrderAmend?: string | undefined;
    soidAllowGreatPlainsMessages?: string | undefined;
    soidCreditControlExcludePreviouslyReleasedOrdersFromCheck?: string | undefined;
    soidCreditControlDisableCreditChecksOnReleasedBackOrders?: string | undefined;
    soidCreditControlUseARCustomerForOrderCreditApproval?: string | undefined;
    soidCreditControlMaximumSalesOrderValueAmount?: string | undefined;
    soidCreditControlMaximumSalesOrderPercentage?: string | undefined;
    soidCreditControlCreditLimitExtensionPercentage?: string | undefined;
    soidCreditControlCreditHoldThresholdAmount?: string | undefined;
    soidCreditControlAllowPaymentOnAccountOnCreditHold?: string | undefined;
    soidCreditControlMarginHoldOrderChangeTolerance?: string | undefined;
    soidCustomerFullSyncJobName?: string | undefined;
    soidCustomerPartialSyncJobName?: string | undefined;
    soidSupplierFullSyncJobName?: string | undefined;
    soidSupplierPartialSyncJobName?: string | undefined;
    soidCreditControlPrintDocsAwaitingCustomerApproval?: string | undefined;
    soidDynamicsDatabase?: string | undefined;
    soidDynamicsServer?: string | undefined;
    soidDynamicsUserID?: string | undefined;
    soidFinancialInterfaceFolder?: string | undefined;
    soidFinancialInterfaceVersion?: string | undefined;
    soidNavisionCompanyName?: string | undefined;
    soidNavisionServer?: string | undefined;
    soidNavisionDatabase?: string | undefined;
    soidNavisionNTAuthentication?: string | undefined;
    soidNavisionUserID?: string | undefined;
    soidNavisionShowCFRONTErrors?: string | undefined;
    soidNavisionNetType?: string | undefined;
    soidSendDebitNotes?: string | undefined;
    soidSendDebitNotesOnHold?: string | undefined;
    soidAutoApplyCreditNotes?: string | undefined;
    soidUseNAVAgent?: string | undefined;
    soidAgentGenerateXMLOnly?: string | undefined;
    soidDisallowReExport?: string | undefined;
    soidSendDebitNoteAmount?: string | undefined;
    soidNavisionPostingGroupSales?: string | undefined;
    soidNavisionPostingGroupPurch?: string | undefined;
    soidNAVUseSeparateBatches?: string | undefined;
    soidUseNAVCache?: string | undefined;
    soidNAVCacheDatabaseName?: string | undefined;
    soidCreditControlCustomerReferencePutOrdersOnHold?: string | undefined;
    soidCalculateJobCreditLimitFromCustomerReferencePurchaseOrderAmounts?: string | undefined;
    soidCalculatedJobCreditLimitExtensionPercentage?: string | undefined;
    soidCalculateInvoiceDueAndDiscountDatesFromDeliveryDate?: string | undefined;
    soidCustomerAgedDebt1?: string | undefined;
    soidCustomerAgedDebt2?: string | undefined;
    soidCustomerAgedDebt3?: string | undefined;
    soidCustomerAgedDebt4?: string | undefined;
    soidCustomerAgedDebt5?: string | undefined;
    soidCustomerAgedDebt6?: string | undefined;
    soidCustomerAgedDebt7?: string | undefined;
    soidSupplierAgedDebt1?: string | undefined;
    soidSupplierAgedDebt2?: string | undefined;
    soidSupplierAgedDebt3?: string | undefined;
    soidSupplierAgedDebt4?: string | undefined;
    soidSupplierAgedDebt5?: string | undefined;
    soidSupplierAgedDebt6?: string | undefined;
    soidSupplierAgedDebt7?: string | undefined;
    soidGreatPlainsMessageQueue?: string | undefined;
    soidGreatPlainsMessageServer?: string | undefined;
    soidGreatPlainsPollInterval?: string | undefined;
    soidGreatPlainsLoggingLevel?: string | undefined;
    soidGreatPlainsCompanyID?: string | undefined;
    soidGreatPlainsServer?: string | undefined;
    soidGreatPlainseConnectServer?: string | undefined;
    soidBankAccountCash?: string | undefined;
    soidBankAccountCheque?: string | undefined;
    soidBankAccountCreditCard?: string | undefined;
    soidGreatPlainsOutputTo?: string | undefined;
    soidGreatPlainsARPathFile?: string | undefined;
    soidGreatPlainsAPPathFile?: string | undefined;
    soidGreatPlainsbisTrackServiceServer?: string | undefined;
    soidSalesGLRuleTaxSales?: string | undefined;
    soidWriteOffGLRule?: string | undefined;
    soidFinanceChargeGLRule?: string | undefined;
    soidNSFChargeGLRule?: string | undefined;
    soidCashGLCode?: string | undefined;
    soidChequeGLCode?: string | undefined;
    soidCreditCardGLCode?: string | undefined;
    soidGreatPlainsGLPathFile?: string | undefined;
    soidSalesDisableTaxSalesGLRule?: string | undefined;
    soidGPDirectUsername?: string | undefined;
    soidGPDirectPassword?: string | undefined;
    soidExtendedNumberFormat?: string | undefined;
    soidCreateGLTransactionsStockReceipts?: string | undefined;
    soidCreateGLTransactionsStockAdjustment?: string | undefined;
    soidFinancialDepositControl?: string | undefined;
    soidFinancialUnallocatedCashControl?: string | undefined;
    soidFinancialDepositVatPosting?: string | undefined;
    soidFinancialUnallocatedVatPosting?: string | undefined;
    soidbTAAccountCodeMask?: string | undefined;
    soidbTAApplyLateCharges?: string | undefined;
    soidbTAMinLatePaymentCharge?: string | undefined;
    soidbTAAutoWOThreshold?: string | undefined;
    soidbTALapsedAccountMonths?: string | undefined;
    soidbTAInactiveAccountMonths?: string | undefined;
    soidbTADeletedAccountMonths?: string | undefined;
    soidbTACustomerAgedBalanceMethod?: string | undefined;
    soidbTACustomerApplicationInProcess?: string | undefined;
    soidbTACustomerStatementReportName?: string | undefined;
    soidbTACustomerInterimStatementReportName?: string | undefined;
    soidbTAGeneralContractorInfoRequired?: string | undefined;
    soidbTACustomerStatementStyle?: string | undefined;
    soidbTAStatementScannedDocTypeForCollect?: string | undefined;
    soidbTAStatementScannedDocTypeForDelivered?: string | undefined;
    soidbTAStatementSendIntervalInSeconds?: string | undefined;
    soidbTAStatementEmailBodyText?: string | undefined;
    soidbTASettDiscToFullAmountWhenMatching?: string | undefined;
    soidbTAARBy?: string | undefined;
    soidbTAStatementScanTrackImagesOnly?: string | undefined;
    soidTransferGLRuleInbound?: string | undefined;
    soidTransferGLRuleOutbound?: string | undefined;
    soidTransferGLRuleInTransit?: string | undefined;
    soidTransferGLRuleUpliftCalculated?: string | undefined;
    soidTransferGLRuleUpliftInput?: string | undefined;
    soidTransferGLRuleTransferProfit?: string | undefined;
    soidGenericXMLARPathFileName?: string | undefined;
    soidGenericXMLAPPathFileName?: string | undefined;
    soidGenericXMLGLPathFileName?: string | undefined;
    soidbTAStatementScannedDocTypeForInvoice?: string | undefined;
    soidbTAStatementScannedDocTypeForCredit?: string | undefined;
    soidbTAStatementImagesDefaultReportName?: string | undefined;
    soidbTAStatementImages1upReportName?: string | undefined;
    soidbTAStatementImages2upReportName?: string | undefined;
    soidbTAStatementImages4upReportName?: string | undefined;
    soidbTAPostARGrossAndDiscountAtTimeOfSale?: string | undefined;
    soidbTACustomerAgedBalancePeriodStyle?: string | undefined;
    soidbTAAllowDifferentARCustomerOnCustomerAddress?: string | undefined;
    soidbTAAllowAccountsPaymentOnJobAddress?: string | undefined;
    soidbTAAllowEntryOfCustomerRemittanceAdvice?: string | undefined;
    soidbTACompareByAccountInFES?: string | undefined;
    soidbtaUseBranchAccessInAccounts?: string | undefined;
    soidbTAEmailBodyTextForStatementNotification?: string | undefined;
    soidbTAIgnoreDiscountDueDateWhenMatchingCreditNotes?: string | undefined;
    soidbTAUseExpectedDetailsCheckingWithBatchCash?: string | undefined;
    soidbTACustomerAgeCreditNotes?: string | undefined;
    soidbTACustomerAgeUnappliedCash?: string | undefined;
    soidbTAMatchingNewCustomerResetOptions?: string | undefined;
    soidbTADefaultNewCreditCustomerToOperationalStatus?: string | undefined;
    soidDefaultOrderToCashCustomer?: string | undefined;
    soidDefaultOrderSaleType?: string | undefined;
    soidDefaultOrderPlacementType?: string | undefined;
    soidDefaultManualOrderLineType?: string | undefined;
    soidDefaultOrderTestCertOption?: string | undefined;
    soidDefaultShowAVOsInUnitPrice?: string | undefined;
    soidPrintDocumentReleaseDelay?: string | undefined;
    soidPrintDocumentReleaseConfirm?: string | undefined;
    soidDefaultPrintFinalDocOnInvoiceAndCreditRelease?: string | undefined;
    soidAllowCashOnDelivery?: string | undefined;
    soidStaffNumberTimeout?: string | undefined;
    soidDefaultOrdersToNegotiation?: string | undefined;
    soidDefaultOrderQuantityToZero?: string | undefined;
    soidPrintOrderOnCashSales?: string | undefined;
    soidPurchaseFromOrderRequiredDays?: string | undefined;
    soidUseActualSizesForTimberCosts?: string | undefined;
    soidWarnIfDateRequiredNotChanged?: string | undefined;
    soidWarnIfDeliveryAddressNotChanged?: string | undefined;
    soidCheckForExistingQuotes?: string | undefined;
    soidPurchaseOrderNumberDisplayFormat?: string | undefined;
    soidStockReceiptNumberDisplayFormat?: string | undefined;
    soidOrderNumberDisplayFormat?: string | undefined;
    soidPickingNoteNumberDisplayFormat?: string | undefined;
    soidSubContractNumberDisplayFormat?: string | undefined;
    soidDeliveryNoteNumberDisplayFormat?: string | undefined;
    soidInvoiceNumberDisplayFormat?: string | undefined;
    soidCreditNoteNumberDisplayFormat?: string | undefined;
    soidCuttingOperationNumberDisplayFormat?: string | undefined;
    soidWorksOrderNumberDisplayFormat?: string | undefined;
    soidSupplierInvoiceNumberDisplayFormat?: string | undefined;
    soidDebitNoteNumberDisplayFormat?: string | undefined;
    soidSupplierCreditNoteNumberDisplayFormat?: string | undefined;
    soidCustomerReturnNumberDisplayFormat?: string | undefined;
    soidJourneyManifestNumberDisplayFormat?: string | undefined;
    soidStockWarningCollectedAlwaysProceed?: string | undefined;
    soidStockWarningNonCollectedAlwaysBackOrder?: string | undefined;
    soidStockWarningDefaultToProceed?: string | undefined;
    soidSupplierReturnNumberDisplayFormat?: string | undefined;
    soidCostAdjustmentNumberDisplayFormat?: string | undefined;
    soidDropDownListThreshold?: string | undefined;
    soidDefaultProductTypeSearch?: string | undefined;
    soidFindFromAvailableStock?: string | undefined;
    soidSearchPageSize?: string | undefined;
    soidReturnOwnBrandProductsFirst?: string | undefined;
    soidPriceHistorySize?: string | undefined;
    soidUseCurrentBranchForFindDocuments?: string | undefined;
    soidPackBarcodeNumberDisplayFormat?: string | undefined;
    soidAllowLoadAllInAllForProcessing?: string | undefined;
    soidStaffNumberTimeoutOperations?: string | undefined;
    soidPickingNoteReprint?: string | undefined;
    soidSchedulingNumberDisplayFormat?: string | undefined;
    soidOrderProductsByPriceBookSection?: string | undefined;
    soidDefaultQuoteDays?: string | undefined;
    soidDefaultReservationDays?: string | undefined;
    soidDefaultTemplateOrderQuoteDays?: string | undefined;
    soidProfitAbbreviation?: string | undefined;
    soidMarginAbbreviation?: string | undefined;
    soidSuppressCurrencyAndPercentageSymbolsInProfitAndMargin?: string | undefined;
    soidSuppressMarginWarningsWhenPriceRulesUsed?: string | undefined;
    soidSuppressMarginWarningsWhenStandardPriceUsed?: string | undefined;
    soidDefaultMergeProductsOnOrder?: string | undefined;
    soidDefaultShowDoubleRowsOnOrder?: string | undefined;
    soidSpecialProductCodePrefix?: string | undefined;
    soidSpecialProductCodeSuffixLength?: string | undefined;
    soidCheckForExistingQuotesInAllBranches?: string | undefined;
    soidAlwaysMergeProductsOnQuickAdd?: string | undefined;
    soidBillOfMaterialProductCodePrefix?: string | undefined;
    soidBillOfMaterialProductCodeSuffixLength?: string | undefined;
    soidSpecialGetHowSourcedFromBase?: string | undefined;
    soidCheckForExistingQuotesAtLineLevel?: string | undefined;
    soidbTADefaultTransactionStatusFilter?: string | undefined;
    soidbTADirectPostingBatchMode?: string | undefined;
    soidbTACreateCaseWhenMarkingInDispute?: string | undefined;
    soidbTARequireBatchCashMatchingNoteForUnmatchedCredits?: string | undefined;
    soidbTAUseMatchDateForStatements?: string | undefined;
    soidbTAAllowWriteOffMoreThanRemainingAmount?: string | undefined;
    soidShowCTLInstructionsWithoutCutFrom?: string | undefined;
    soidSuppressMarginWarningsForSpecials?: string | undefined;
    soidbTABatchCashMatchingSortOrder?: string | undefined;
    soidWorksOrderScheduleNumberDisplayFormat?: string | undefined;
    soidNotepadCaseNumberDisplayFormat?: string | undefined;
    soidStockWarningIncludeOnlyApprovedPurchaseOrdersForAllocation?: string | undefined;
    soidbTAAllowUnapplyingTransactionsInClosedFinancialPeriods?: string | undefined;
    soidbTAFinanceChargeDefaultGenerateBy?: string | undefined;
    soidbTACalcFinanceChargesOnFinanceCharges?: string | undefined;
    soidbTADisplayChildCreditTransactionsOnParentAccounts?: string | undefined;
    soidStaffNumberBatchProcessingTimeout?: string | undefined;
    soidProductSearchPageSize?: string | undefined;
    soidProductExplorerPageSize?: string | undefined;
    soidCustomerSearchPageSize?: string | undefined;
    soidSupplierSearchPageSize?: string | undefined;
    soidOrderMonitorPageSize?: string | undefined;
    soidJourneyPlannerPageSize?: string | undefined;
    soidDefaultCreateNewSpecialsOnOrderCopy?: string | undefined;
    soidDefaultSectionEndWithSubtotal?: string | undefined;
    soidCheckCustomerOnHoldOnPickingAndDelivery?: string | undefined;
    soidCheckCustomerCreditOnPickingAndDelivery?: string | undefined;
    soidAllowProceedOnPickingAndDeliveryCreditChecks?: string | undefined;
    soidEnableSteppedFinanceCharge?: string | undefined;
    soidCustomerChequeReferencesRequireCustomer?: string | undefined;
    soidbTADefaultNewCashCustomerToOperationalStatus?: string | undefined;
    soidDefaultTransportType?: string | undefined;
    soidDefaultDeliveryDate?: string | undefined;
    soidInputMaskforDeliveryReference?: string | undefined;
    soidEnableUnitPriceDeliveryCharges?: string | undefined;
    soidAutomaticallySendDeliveryNotificationsByEmail?: string | undefined;
    soidCalendarStartOfWeek?: string | undefined;
    soidDefaultDateRequiredDays?: string | undefined;
    soidDefaultDateRequiredOption?: string | undefined;
    soidDefaultDeliveryTime?: string | undefined;
    soidDefaultDateRequiredToBlankOnQuotes?: string | undefined;
    soidDefaultDateRequiredCutOffTime?: string | undefined;
    soidDefaultDateRequiredToBlankOnOrders?: string | undefined;
    soidEnableTransactionLocking?: string | undefined;
    soidSkipBranchPromptWhenUserHasDefault?: string | undefined;
    soidPurchaseOrderCostCalculation?: string | undefined;
    soidSalesOrderCostCalculation?: string | undefined;
    soidSalesOrderShowVatPercentage?: string | undefined;
    soidSupplierInvoiceToleranceStockPercent?: string | undefined;
    soidSupplierInvoiceToleranceStockValue?: string | undefined;
    soidSupplierInvoiceToleranceDirectPercent?: string | undefined;
    soidSupplierInvoiceToleranceDirectValue?: string | undefined;
    soidSupplierInvoiceToleranceAdditionalCostPercent?: string | undefined;
    soidSupplierInvoiceToleranceAdditionalCostValue?: string | undefined;
    soidDefaultCounterOrderSaleType?: string | undefined;
    soidSupplierInvoiceShowWeight?: string | undefined;
    soidSupplierInvoiceToleranceVatPercent?: string | undefined;
    soidSupplierInvoiceToleranceVatValue?: string | undefined;
    soidSupplierInvoiceShowVAT?: string | undefined;
    soidSupplierInvoiceCalcSettlementDiscOnCredits?: string | undefined;
    soidSupplierInvoiceDeliveryText?: string | undefined;
    soidSupplierInvoicePromptForDeliveryDetails?: string | undefined;
    soidSupplierInvoiceMustChooseGLCode?: string | undefined;
    soidSupplierInvoiceBlock2ndInvoiceOnDirectOrders?: string | undefined;
    soidSupplierInvoiceApproveDirectSalesOrderOnInvoiceApproval?: string | undefined;
    soidSupplierInvoiceSetDirectSalesInvoiceDateFromInvoice?: string | undefined;
    soidOrdersPricingIncludeAdditionalCostInDirectSalesOrderCost?: string | undefined;
    soidSupplierInvoiceUseSupplierPaymentTerms?: string | undefined;
    soidIncludeOnOrderInAvailableStock?: string | undefined;
    soidIncludeStockDueInAvailableStock?: string | undefined;
    soidIncludeThirdPartyInAvailableStock?: string | undefined;
    soidIncludeAwaitingProcessInAvailableStock?: string | undefined;
    soidAllocateStockOnBackToBacks?: string | undefined;
    soidAllowUseOfCostRecordAfterValuationDate?: string | undefined;
    soidIncludeAwaitingProcessForOrderOnlyInAvailStock?: string | undefined;
    soidCompanyStockLimitedByUserAccess?: string | undefined;
    soidDoNotAllowBackAndForwardDatingThatHarmsCostIntegrity?: string | undefined;
    soidStockCountAllowTickedStockUpdates?: string | undefined;
    soidStockCountAllowBackDatingOfCompletion?: string | undefined;
    soidStockIncludeLooseAndPackInStockCheckWhenAllocating?: string | undefined;
    soidIncludeStockAllocatedToBackToBackOrderInOnOrderStock?: string | undefined;
    soidAllowAddingProductsToTicketedStockCounts?: string | undefined;
    soidShowStockInformationInStockCountProductSearches?: string | undefined;
    soidShowActualAndAvailableStockWhenEnteringTicketCounts?: string | undefined;
    soidReasonCodeToUseForStockCount?: string | undefined;
    soidCustomerObjectReport?: string | undefined;
    soidProductObjectReport?: string | undefined;
    soidSupplierObjectReport?: string | undefined;
    soidFinancialInvoiceAuditCustomerReport?: string | undefined;
    soidFinancialInvoiceAuditSupplierReport?: string | undefined;
    soidStockPackReconciliationReport?: string | undefined;
    soidCashDrawerReportName?: string | undefined;
    soidCustomerProductRefObjectReport?: string | undefined;
    soidSuggestedPurchaseOrderDetailReport?: string | undefined;
    soidStockValuationNegativeStockReportName?: string | undefined;
    soidStockValuationReceivedNotInvoicedReportName?: string | undefined;
    soidStockValuationPaidNotReceivedReportName?: string | undefined;
    soidStockValuationIssuedNotInvoicedReportName?: string | undefined;
    soidStockValuationInvoicedNotIssuedReportName?: string | undefined;
    soidStockValuationPaidNotDeliveredReportName?: string | undefined;
    soidStockValuationTransferSentNotreceivedReportName?: string | undefined;
    soidScansUseDocReadPermissions?: string | undefined;
    soidReportsAccruedPurchaseDetailSupplierCredits?: string | undefined;
    soidDashboardRefreshInterval?: string | undefined;
    soidDashboardOperationsFilename?: string | undefined;
    soidDashboardSystemManagerFilename?: string | undefined;
    soidDashboardFigures?: string | undefined;
    soidDashboardOrderingBranch?: string | undefined;
    soidDashBoardEnableFlowLayouts?: string | undefined;
    soidDataRuleDataSetXML?: string | undefined;
    soidPerformanceMonitorShowProfit?: string | undefined;
    soidPerformanceMonitorUseInternalCosts?: string | undefined;
    soidDefaultCustomerVATRule?: string | undefined;
    soidDefaultProductVATRule?: string | undefined;
    soidCalculateVATOnGoodsLessDiscount?: string | undefined;
    soidCalculateVATTaxAtTotalLevel?: string | undefined;
    soidCalculateTaxBasedOnBranchTaxArea?: string | undefined;
    soidVatRateForAutomaticUplift?: string | undefined;
    soidCalculateSettlementAtTotalLevel?: string | undefined;
    soidVatRateForAutomaticLineCharge?: string | undefined;
    soidEnableNonDiscountableAmount?: string | undefined;
    soidVatRateForExportSales?: string | undefined;
    soidUseWashingtonStateTaxRateValidation?: string | undefined;
    soidRequireTaxVerificationOnDeliveredSalesOrders?: string | undefined;
    soidUseDefaultJobAddressTaxAreaForCustomerDefault?: string | undefined;
    soidCalculateTaxOnCostMinusWorksOrderAVOCost?: string | undefined;
    soidUseIssuingBranchTaxArea?: string | undefined;
    soidSalesTaxCalculationMethod?: string | undefined;
    soidUseBranchTaxAreaForCustomerDefault?: string | undefined;
    soidSendFullAddressInfoInWashingtonStateTaxRateValidation?: string | undefined;
    soidWashingtonStateTaxRateURL?: string | undefined;
    soidFinancialStockValuationCostType?: string | undefined;
    soidFinancialReferenceRequiredOnCheckPayment?: string | undefined;
    soidInputMaskForChequeReference?: string | undefined;
    soidPreventUseOfNewJournalNumberOnReExport?: string | undefined;
    soidUseFiscalCalendarToControlPostingDates?: string | undefined;
    soidSearchHistoryRecordsInFinancialPackage?: string | undefined;
    soidUpdateDailySalesAnalysisTable?: string | undefined;
    soidChequeGuaranteeCardNumberRequired?: string | undefined;
    soidAuthorisationCodeOrderValueThreshold?: string | undefined;
    soidSendSeparateBatchForEachBranchGLCode?: string | undefined;
    soidRetainOrigExchangeRateOnSOAndPO?: string | undefined;
    soidEnableGLCodeValidation?: string | undefined;
    soidFinancialGPbTGeneratesJournalEntryNumber?: string | undefined;
    soidFinancialGPMinbTJournalEntryNumber?: string | undefined;
    soidFinancialGPMaxbTJournalEntryNumber?: string | undefined;
    soidPostSalesAndCOGSWhenUsingIssuingBranchTo?: string | undefined;
    soidEnableIntercompanyDistribution?: string | undefined;
    soidEpicorTaxConnectAccountNumber?: string | undefined;
    soidEpicorTaxConnectLicenseKey?: string | undefined;
    soidEpicorTaxConnectWebAddress?: string | undefined;
    soidTaxToUseForEpicorTaxConnectTaxes?: string | undefined;
    soidEpicorTaxConnectCompanyCode?: string | undefined;
    soidGenericXMLFinancialExportMethod?: string | undefined;
    soidSettDiscAllowedWhenMatchedToCreditCardPayments?: string | undefined;
    soidSettDiscAllowedWhenMatchedToACHPayments?: string | undefined;
    soidNoOfSellingBands?: string | undefined;
    soidUsePriceRulesForSpecials?: string | undefined;
    soidDeliveryCriteriaPrecedence1?: string | undefined;
    soidDeliveryCriteriaPrecedence2?: string | undefined;
    soidDeliveryCriteriaPrecedence3?: string | undefined;
    soidDeliveryCriteriaPrecedence4?: string | undefined;
    soidUseStandardBuyCostForSpecials?: string | undefined;
    soidRebateIDRequiredForRebateAccruals?: string | undefined;
    soidPricingDefaultCompanyLevelPriceChange?: string | undefined;
    soidPricingUseOldCompanyPriceAsOldAmount?: string | undefined;
    soidSigmaNESTEnableIntegration?: string | undefined;
    soidSigmaNESTWorkOrderAttachmentFolder?: string | undefined;
    soidSigmaNESTWorkOrderAttachmentFilename?: string | undefined;
    soidSigmaNESTWorkOrderAttachmentOrigin?: string | undefined;
    soidDontCalculateSellingPriceWhenAddingProductWithZeroQuantity?: string | undefined;
    soidSupplierInvoiceConfirmZeroTax?: string | undefined;
    soidSupplierInvoiceAllowAlternateCreditor?: string | undefined;
    soidSupplierInvoiceAutoCalcSettlementDiscOnInvoices?: string | undefined;
    soidSupplierInvoiceIncludeCostOnDirectLineDescription?: string | undefined;
    soidSupplierInvoiceEnablePostingDate?: string | undefined;
    soidSupplierInvoiceAutoSelectPostingDate?: string | undefined;
    soidSupplierInvoiceOnlyExportDiscountsNotEqualToZero?: string | undefined;
    soidSupplierInvoiceCanadianTaxInput?: string | undefined;
    soidSupplierInvoiceShowSupplierProductCode?: string | undefined;
    soidSupplierInvoiceAllowZeroTotalInvoices?: string | undefined;
    soidSupplierInvoiceDisplayExpectedCostsFromPO?: string | undefined;
    soidSupplierInvoiceEnableWorkflow?: string | undefined;
    soidSupplierInvoiceShowBrowseForGLSubCodeThreshold?: string | undefined;
    soidSupplierInvoiceRestrictWorkflowMessagesToSingleRecipient?: string | undefined;
    soidSupplierInvoiceGPIncludePOSupplierCodeWhenAlternativeCreditor?: string | undefined;
    soidSupplierInvoiceRequireWorkflowMessageRecipient?: string | undefined;
    soidSupplierCreditRequiresReasonCode?: string | undefined;
    soidSupplierInvoicePrintBarcodeLabelOnMatchOrMatchAndApprove?: string | undefined;
    soidSupplierInvoiceAllowMatchingDirectSupplierInvoiceWhenPaymentOutstanding?: string | undefined;
    soidSupplierInvoiceSendOtherRefAsPONumberToGPForOverheadSIs?: string | undefined;
    soidSupplierInvoiceSkipMsgsWhenMatchingApproving?: string | undefined;
    soidSupplierInvoiceBranchSelectionType?: string | undefined;
    soidSupplierInvoiceCalculateGoodsTotalOnOverheadInvoicesWithNoPurchaseOrder?: string | undefined;
    soidNavisionUseIssuingBranchForDimension?: string | undefined;
    soidLoyaltyCurrencyToPointExchangeRate?: string | undefined;
    soidLoyaltyOrderEntryPromptPointMinimum?: string | undefined;
    soidLoyaltyRedeemManualOrderLineType?: string | undefined;
    soidLoyaltyRepeatRewardsMOLT?: string | undefined;
    soidDefaultSystemToImperial?: string | undefined;
    soidWeightPer?: string | undefined;
    soidWeightDecimalPlaces?: string | undefined;
    soidQuotePickDocumentReleaseFormat?: string | undefined;
    soidDepartmentUsage?: string | undefined;
    soidDefaultDepartmentUsageDepartment?: string | undefined;
    soidGeneralEnableReportingCost?: string | undefined;
    soidAllowManualAdjustmentOfVolumeOnAdditionalCostProrations?: string | undefined;
    soidShowJobReferenceInLists?: string | undefined;
    soidAllowMultipleOrderReferenceMasks?: string | undefined;
    soidLimitSellAndBuyPriceChangesToBranchWithUpdateAccess?: string | undefined;
    soidGeneralEnableNotepadNotifications?: string | undefined;
    soidGeneralValidateDefaultRefOnCustomerAddress?: string | undefined;
    soidLimitRelatedDocsBasedOnBranchAccess?: string | undefined;
    soidVerifyInternalGiftCardsAgainstLoadedGiftCardList?: string | undefined;
    soidSetDepartmentOnOrdersDuringCreation?: string | undefined;
    soidUpdateTransactionLineManualDescriptionWithSpecialProductDescription?: string | undefined;
    soidDefaultCustomerNotepadTypeFilterFromUserOption?: string | undefined;
    soidDepartmentOnAccountPaymentsWhereDepartmentUsageIsSalesRepOrComputer?: string | undefined;
    soidDepartmentOnCashDrawerLodgementsWhereDepartmentUsageIsSalesRepOrComputer?: string | undefined;
    soidPricingPlannerSmartView1?: string | undefined;
    soidPricingPlannerSmartView2?: string | undefined;
    soidPricingPlannerSmartView3?: string | undefined;
    soidPricingPlannerSmartView4?: string | undefined;
    soidPricingPlannerSmartView5?: string | undefined;
    soidWorksOrderSpecifyFinQtyWhenConfirmSourcePacks?: string | undefined;
    soidPurchasingLimitFindProdToSupplier?: string | undefined;
    soidPurchasingAllowApprovalIfCreditProblem?: string | undefined;
    soidPurchasingAutoApproveDirectOrders?: string | undefined;
    soidPurchaseOrderSecondaryCostCalculation?: string | undefined;
    soidPurchasingAutoApproveBackToBackOrders?: string | undefined;
    soidPurchasingRoundToInnerOuterPallet?: string | undefined;
    soidPurchasingInputGLCodeOnOverheadAdvanced?: string | undefined;
    soidPurchasingWarnWhenNotPrimarySupplier?: string | undefined;
    soidPurchasingAutoPrintDirectOrders?: string | undefined;
    soidPurchasingAutoPrintBackToBackOrders?: string | undefined;
    soidPurchasingPopulateAnalysisCodeOnGeneratedPO?: string | undefined;
    soidPurchasingCopyCostPerFromDirectOrBackToBack?: string | undefined;
    soidPurchasingAllowCostQtyChangeAfterStockReceipt?: string | undefined;
    soidPurchasingCostToleranceWarning?: string | undefined;
    soidPurchasingWarnIfNotInnerOuterPalletMultiple?: string | undefined;
    soidPurchasingAllowPrintingUnapprovedPurchaseOrders?: string | undefined;
    soidPurchaseOrderCallOffAutoComplete?: string | undefined;
    soidPurchasingShowAndAllowUpdateOfStandardBuyPrice?: string | undefined;
    soidPurchasingDefaultAnalysisCodeOnGenerateFromAVO?: string | undefined;
    soidPurchasingShowCustomerOnInternalNotes?: string | undefined;
    soidPurchasingDefaultInputPerToSupplierBuyPer?: string | undefined;
    soidPurchasingDisplayCompletionButtonsOnPO?: string | undefined;
    soidPurchasingDisplayCreatePOOnAddCostChargeOnXfers?: string | undefined;
    soidPurchasingAlwaysUseOverriddenDimsOnAddCosts?: string | undefined;
    soidPurchasingApplyEnvironmentalStatusRestrictions?: string | undefined;
    soidPurchasingAllowChangingUnitCostForCostControlledItems?: string | undefined;
    soidGenerateCallOffPOForDirectSO?: string | undefined;
    soidPurchasingPromptForSellPriceWhenDirectCostChanged?: string | undefined;
    soidPurchasingKeepDateRequiredInSynchForDirects?: string | undefined;
    soidPurchasingCheckForCallOffs?: string | undefined;
    soidPurchasingSetDefaultStockLocation?: string | undefined;
    soidPurchasingPurchaseOrderChangeApprovalThreshold?: string | undefined;
    soidPurchasingUseLeadTimeToSetPOLineDateExpected?: string | undefined;
    soidIncludeOrderLineLinksForSOItemsOnWMSPOs?: string | undefined;
    soidPurchasingPromptForBuyPriceRuleSelection?: string | undefined;
    soidGLCodeSelectionMethodForMOLTsOnOverheadPO?: string | undefined;
    soidCentralizedPurchasingIncludesSourcedByTransfer?: string | undefined;
    soidSuggestedOrdersSmartView1?: string | undefined;
    soidSuggestedOrdersSmartView2?: string | undefined;
    soidSuggestedOrdersSmartView3?: string | undefined;
    soidSuggestedOrdersSmartView4?: string | undefined;
    soidSuggestedOrdersSmartView5?: string | undefined;
    soidSuggestedOrdersAdjustByStockClass?: string | undefined;
    soidDefaultPurchaseAnalysisCodeOnOverheadPOs?: string | undefined;
    soidPurchasingUseSecondaryCostWhenPrimaryCostValueIsZero?: string | undefined;
    soidPurchasingShow15LevelsForAutoAverageCostAdjRule?: string | undefined;
    soidRetainRaisedByInformationWhenConvertingPOToADirect?: string | undefined;
    soidApplyFixedAmountManualLinesAndAdditionalCostsToAllStockReceipts?: string | undefined;
    soidPurchasingSetMOLTDescriptionToGLCodeDescriptionOnOverheadPO?: string | undefined;
    soidPurchasingAutoPrintLabels?: string | undefined;
    soidPurchasingShowSupplierPopupForAutomaticPurchaseOrders?: string | undefined;
    soidSuggestedOrderingIncludeAllOpenPurchaseOrders?: string | undefined;
    soidFindDocPreviewPaneSmartViewSO1?: string | undefined;
    soidFindDocPreviewPaneSmartViewSO2?: string | undefined;
    soidFindDocPreviewPaneSmartViewSO3?: string | undefined;
    soidFindDocPreviewPaneSmartViewSO4?: string | undefined;
    soidFindDocPreviewPaneSmartViewSO5?: string | undefined;
    soidFindDocPreviewPaneSmartViewQU1?: string | undefined;
    soidFindDocPreviewPaneSmartViewQU2?: string | undefined;
    soidFindDocPreviewPaneSmartViewQU3?: string | undefined;
    soidFindDocPreviewPaneSmartViewQU4?: string | undefined;
    soidFindDocPreviewPaneSmartViewQU5?: string | undefined;
    soidFindDocPreviewPaneSmartViewCO1?: string | undefined;
    soidFindDocPreviewPaneSmartViewCO2?: string | undefined;
    soidFindDocPreviewPaneSmartViewCO3?: string | undefined;
    soidFindDocPreviewPaneSmartViewCO4?: string | undefined;
    soidFindDocPreviewPaneSmartViewCO5?: string | undefined;
    soidFindDocPreviewPaneSmartViewPO1?: string | undefined;
    soidFindDocPreviewPaneSmartViewPO2?: string | undefined;
    soidFindDocPreviewPaneSmartViewPO3?: string | undefined;
    soidFindDocPreviewPaneSmartViewPO4?: string | undefined;
    soidFindDocPreviewPaneSmartViewPO5?: string | undefined;
    soidFindDocPreviewPaneSmartViewCN1?: string | undefined;
    soidFindDocPreviewPaneSmartViewCN2?: string | undefined;
    soidFindDocPreviewPaneSmartViewCN3?: string | undefined;
    soidFindDocPreviewPaneSmartViewCN4?: string | undefined;
    soidFindDocPreviewPaneSmartViewCN5?: string | undefined;
    soidSalesOrderAllowChangeCurrencies?: string | undefined;
    soidSalesOrderChangeTakenBy?: string | undefined;
    soidSalesOrderForceSupplierReview?: string | undefined;
    soidSalesOrderWarnIfDirectCostNotChanged?: string | undefined;
    soidSalesOrderMaximumReservationDays?: string | undefined;
    soidSalesOrderAllowDirectSalesInCounterSales?: string | undefined;
    soidSalesOrderOnlyApproveIssuedOrders?: string | undefined;
    soidSalesOrderParkedOrderFormats?: string | undefined;
    soidSalesOrderWaitForNewStockOnBackOrder?: string | undefined;
    soidSalesOrderWarnIfOrderLinePriceIsZero?: string | undefined;
    soidSalesOrderDeliveryAreaRequired?: string | undefined;
    soidSalesOrderAllowCashBackOnCashSales?: string | undefined;
    soidSalesOrderMaintainTakenByFromOriginalOrderOnBackOrder?: string | undefined;
    soidMarkOrderApprovedWhenStockIssued?: string | undefined;
    soidDefaultSpecialOrderQtyChangeToCreateBackOrder?: string | undefined;
    soidOrdersSuppressStockUpdatesDuringEntry?: string | undefined;
    soidOrdersProductCodeColumnContent?: string | undefined;
    soidOrdersReserveStockOnCallOff?: string | undefined;
    soidOrdersAutoApplyDeliveryCharges?: string | undefined;
    soidOrdersDisplayCommissionCode?: string | undefined;
    soidOrdersForceSupplierToBeChangedWhenSupplierIs?: string | undefined;
    soidSignatureCaptureCollectNow?: string | undefined;
    soidSignatureCaptureCollectLater?: string | undefined;
    soidOrdersShowBinLocationFromSROnSOLine?: string | undefined;
    soidOrderExcludeParkedOrdersFromOnOrderBalance?: string | undefined;
    soidOrdersDisplayStockLocationOnOrderEntry?: string | undefined;
    soidOrdersDefaultVehicleType?: string | undefined;
    soidOrdersDefaultOrderMonitorToAllBranches?: string | undefined;
    soidOrdersDefaultSellPriceFromParentNATally?: string | undefined;
    soidOrdersDefaultCustomerSearchOnOrdersToAddress?: string | undefined;
    soidOrdersManualLineDeliveryChargeExclusionCode?: string | undefined;
    soidOrdersDisplayTotalCostInOrderTotals?: string | undefined;
    soidOrdersAutoApplyRebateAccruals?: string | undefined;
    soidOrdersDisplayNegWarningOnGeneral?: string | undefined;
    soidOrdersAllowOverrideOfRebateSaleType?: string | undefined;
    soidOrdersOnlyCalcTransferCostForBranchesWithStock?: string | undefined;
    soidOrdersEnableMultipleBranches?: string | undefined;
    soidOrdersMixedBranchRestrictions?: string | undefined;
    soidOrdersAllowMixedSaleTypesOnOrders?: string | undefined;
    soidOrdersEnterAddressViaForm?: string | undefined;
    soidOrdersCallOffAllowCreateSOFromMultipleCallOffs?: string | undefined;
    soidOrdersEnableCollectNow?: string | undefined;
    soidOrdersEnableCollectLater?: string | undefined;
    soidOrdersEnableDelivered?: string | undefined;
    soidOrdersEnableDirect?: string | undefined;
    soidOrdersShowQuickProductsInCounter?: string | undefined;
    soidOrdersAllowTextLines?: string | undefined;
    soidOrdersAllowCustomerLookupByAddress?: string | undefined;
    soidOrdersAllowMultipleSalesRepPerOrder?: string | undefined;
    soidOrdersMinimumDeposit?: string | undefined;
    soidOrdersMergeDirectPOsForSameSO?: string | undefined;
    soidOrdersWarnIfVehicleTypeNotSet?: string | undefined;
    soidOrdersCallOffScheduleColumn1Heading?: string | undefined;
    soidOrdersCallOffScheduleColumn2Heading?: string | undefined;
    soidOrdersPromptForPacksIfAlwaysPackSelling?: string | undefined;
    soidOrdersAllowIssuingStockFromOtherBranches?: string | undefined;
    soidOrdersAllowIssuingBranchWithReadOnlyAccess?: string | undefined;
    soidOrdersKeepDeliveryAddressForCollectSales?: string | undefined;
    soidOrdersHideAvailableCreditOnSO?: string | undefined;
    soidOrdersCopyProductInternalLineNotesToLineNotes?: string | undefined;
    soidOrdersPromptToMarkOrderAsCollectedOnSaveAndClose?: string | undefined;
    soidOrdersAllowChangeOfNotesAndTypeOnOrdersInvoiced?: string | undefined;
    soidOrdersAllowFractionalKits?: string | undefined;
    soidOrdersSortByBinLocationWhenConsolidatingProductLines?: string | undefined;
    soidOrdersSpecialsCopyEnvironmentalStatus?: string | undefined;
    soidOrdersCanChangeSaleTypeIfCardholderNotPresentPayment?: string | undefined;
    soidOrdersIgnoreAllowProceedonStockWarningforBackOrder?: string | undefined;
    soidDisableOtherSizeOptionForStockByLengthProductsOnOrders?: string | undefined;
    soidOrdersDisplayOrderNumberDialog?: string | undefined;
    soidOrdersSkipOrderCompletionDialog?: string | undefined;
    soidOrdersWarnSupplierMinAmountOnPOs?: string | undefined;
    soidPickVehicleWhenMarkingOrderAsDelivered?: string | undefined;
    soidShowTotalQuantityInformationinCounterSales?: string | undefined;
    soidForceAddressSelectionInCounterSales?: string | undefined;
    soidCopySellPriceAndCostOnSpecialOrderCopyFromBaseItem?: string | undefined;
    soidUpdateExistingPOOnDirectBO?: string | undefined;
    soidOrdersApplyEnvironmentalStatusRestrictions?: string | undefined;
    soidOrdersShowChangeInformationDuringPrint?: string | undefined;
    soidOrdersReasonCodeOnLineAmend?: string | undefined;
    soidAllowLadingQuantityEntryDuringPicking?: string | undefined;
    soidOrdersMinimumDepositThreshold?: string | undefined;
    soidOrdersRequireFullPaymentWhenBelowMinimumDepositThreshold?: string | undefined;
    soidOrdersDisplayMinimumDepositOverrideButton?: string | undefined;
    soidOrdersSpecialLinesOnCashSalesMustBePaidInFull?: string | undefined;
    soidOrdersShowTaxAreaButton?: string | undefined;
    soidOrdersBackOrderReleaseCheckAvailableStock?: string | undefined;
    soidOrdersCheckMinimumDepositOnBackOrders?: string | undefined;
    soidOrdersPromptForReferenceInCounter?: string | undefined;
    soidWarnWhenDateRequiredMonthsInAdvance?: string | undefined;
    soidOrderFixOriginalQtyAt?: string | undefined;
    soidForceAddressSelectionInOperations?: string | undefined;
    soidOrdersDisplayPaymentScreenOnModifiedDeliveredCashSale?: string | undefined;
    soidSalesOrderSetDefaultSupplierOnDirects?: string | undefined;
    soidOrdersOpenPurchaseOrders?: string | undefined;
    soidOrdersLargeKitProcessing?: string | undefined;
    soidOrdersEnableEditQtyAndPriceInGrid?: string | undefined;
    soidTransferCreatorModify?: string | undefined;
    soidTransferCreatedByReceivingBranch?: string | undefined;
    soidTransferAutoApplyDeliveryCosts?: string | undefined;
    soidTransferReceiptConfirmationFormat?: string | undefined;
    soidTransferCanChangeViaBranch?: string | undefined;
    soidTransferCostCalculation?: string | undefined;
    soidTransferReturnAutoApplyDeliveryCosts?: string | undefined;
    soidDefaultTransferSaleType?: string | undefined;
    soidTransferSplitPacksToLoose?: string | undefined;
    soidTransferRequireUpdateAccessForToBranch?: string | undefined;
    soidTransferAllowZeroCost?: string | undefined;
    soidTransferAllowToBeLessThanCurrentCost?: string | undefined;
    soidTransferRequirePackConfirmation?: string | undefined;
    soidTransferApplyUplifts?: string | undefined;
    soidTransferBranchAccessLevelRequiredForFromBranch?: string | undefined;
    soidTransferReturnAtOriginalCost?: string | undefined;
    soidTransferRequireSendingBranchApproval?: string | undefined;
    soidTransferApprovalRequiredBeforeAllocation?: string | undefined;
    soidTransferSuggestionQuantity?: string | undefined;
    soidTransferDontApproveAllocateStockTransfersLinkedToPOUntilReceived?: string | undefined;
    soidTransferReturnUseOriginalBranchInGLTransferUplift?: string | undefined;
    soidTransferDateRequiredFromManufacturedSpecials?: string | undefined;
    soidCalculateBranchTransferCostsBasedOnTotalValues?: string | undefined;
    soidTransferDateRequiredDaysBetweenPOAndLinkTransfers?: string | undefined;
    soidTransferUpdateDateRequiredWhenLinkedSODateRequiredChanges?: string | undefined;
    soidOrdersNewOneTimeAddressIsBlank?: string | undefined;
    soidTransferReceiveInBranchesNotLoggedIn?: string | undefined;
    soidTransferCopyOrderLineAVOsToTransferLineWhenSourcedFromTransfer?: string | undefined;
    soidTransferUseVMICostForBranchTransferCostOnVMIProducts?: string | undefined;
    soidOrdersCopyFromSelectMultipleTemplates?: string | undefined;
    soidUpdateSpecialOrderCostOnChangesOnPO_SR_SI?: string | undefined;
    soidLumpSumSectionsOnCopyFrom?: string | undefined;
    soidConsolidatePositiveQuantitiesWithinSectionsByDefault?: string | undefined;
    soidOpenOrderLinePropertiesForRelatedProducts?: string | undefined;
    soidOrdersNotifyIfDeletedLinesOnSalesTransactionCopy?: string | undefined;
    soidOrderSectionsToMaintainSectionPrice?: string | undefined;
    soidBackToBackIgnoresHowSourced?: string | undefined;
    soidSectionSelectionBoxType?: string | undefined;
    soidOrdersPromptForBuyPriceRuleOnBackToBackPO?: string | undefined;
    soidOrdersAllowChangingSaleTypeAndDeliveryAfterPicking?: string | undefined;
    soidOrdersAllowChangingScheduledSalesOrders?: string | undefined;
    soidDefaultAddressTypeWhenCreatedFromSalesOrders?: string | undefined;
    soidCreateJobAddressesInSalesTransactionWithQuickJobScreen?: string | undefined;
    soidApplyPermissionsOnChangesWithPickingNotePrintedToDeliveredOrdersOnly?: string | undefined;
    soidTransfersAdvanceDaysFromOrder?: string | undefined;
    soidAllowEditingKitsAfterBackToBackPurchaseOrderApproved?: string | undefined;
    soidParkOrdersWhenWorkOrderDateRequiredFull?: string | undefined;
    soidOrdersPromptDuringOrderEntryWhenDefaultBatchDoesNotExist?: string | undefined;
    soidOrdersPromptDuringPickingWhenDefaultBatchDoesNotExist?: string | undefined;
    soidSuggestedOrdersIncludeSuggestionsInStockAvailable?: string | undefined;
    soidAllowAdjustmentOfQuantityDuringReceiptOfStockTransfer?: string | undefined;
    soidReasonCodeForACAGenearatedFromQuantityAdjustmentTransfers?: string | undefined;
    soidOrdersUseAlternatePaymentTermsByProductGroup?: string | undefined;
    soidWMSOnlyReleaseLinesAvailForPickWhenSplitDelivAllowed?: string | undefined;
    soidFindProductSmartView1?: string | undefined;
    soidFindProductSmartView2?: string | undefined;
    soidFindProductSmartView3?: string | undefined;
    soidFindProductSmartView4?: string | undefined;
    soidFindProductSmartView5?: string | undefined;
    soidFindCustomerSmartView1?: string | undefined;
    soidFindCustomerSmartView2?: string | undefined;
    soidFindCustomerSmartView3?: string | undefined;
    soidFindCustomerSmartView4?: string | undefined;
    soidFindCustomerSmartView5?: string | undefined;
    soidJourneyPlannerSmartView1?: string | undefined;
    soidJourneyPlannerSmartView2?: string | undefined;
    soidJourneyPlannerSmartView3?: string | undefined;
    soidJourneyPlannerSmartView4?: string | undefined;
    soidJourneyPlannerSmartView5?: string | undefined;
    soidOrderQuotesForceFollowUp?: string | undefined;
    soidOrderQuotesFollowUpDays?: string | undefined;
    soidOrderQuotesFollowUpNotepadType?: string | undefined;
    soidOrderQuotesApplyMarginWarningAndStops?: string | undefined;
    soidOrderQuotesAllowPark?: string | undefined;
    soidOrderQuotesAllowPrintWhenSupplierRequestExists?: string | undefined;
    soidOrderQuotesCopyCreatedByUserAndOrderingBranch?: string | undefined;
    soidOrderQuotesAllowMultipleAccept?: string | undefined;
    soidOrderQuotesForceRecalculateWhenAcceptingExpiredQuote?: string | undefined;
    soidOrderQuotesUseTakenByFromQuoteWhenAcceptingIntoOrder?: string | undefined;
    soidOrderQuotesAllowBlankText?: string | undefined;
    soidOrderQuotesExcludeQuotesFromPromotionalPricing?: string | undefined;
    soidOrdersDontCompleteOrdersWhenWorkOrdersNeedStock?: string | undefined;
    soidOrdersCompleteDeliveredOrdersWhenDateRequiredIsFull?: string | undefined;
    soidUseSearchForTakenBy?: string | undefined;
    soidSimpleOrderProcessCollectNow?: string | undefined;
    soidSimpleOrderProcessCollectLater?: string | undefined;
    soidSimpleOrderProcessDelivered?: string | undefined;
    soidSimpleOrderProcessDirect?: string | undefined;
    soidSimpleOrderProcessTransfer?: string | undefined;
    soidSimpleOrderControlAVOProcessing?: string | undefined;
    soidSimpleOrderPreAllocateOrderInvoiceNo?: string | undefined;
    soidSimpleConfirmPicking?: string | undefined;
    soidSimpleConfirmDelivery?: string | undefined;
    soidSimpleConfirmPODReturned?: string | undefined;
    soidSimplePrintPickingNoteOnPark?: string | undefined;
    soidSimpleDeliveryAfterPickingConfirmed?: string | undefined;
    soidSimpleOnlyAllowDeliveryPrintAfterMarked?: string | undefined;
    soidSimpleAutoIssueOnMarkAsDelivered?: string | undefined;
    soidSimpleOnlyInvoiceDirectsAfterSuppInv?: string | undefined;
    soidSimpleAllowPickDeliveryPrintWhenWaitingForStock?: string | undefined;
    soidSimpleDontIssueIfNegativeStock?: string | undefined;
    soidSimplePickingNoteFormat?: string | undefined;
    soidSimpleDeliveryNoteFormat?: string | undefined;
    soidSimpleCollectionNoteFormat?: string | undefined;
    soidSimpleDepositReceiptFormat?: string | undefined;
    soidSimpleDeliveryFormatSetCash?: string | undefined;
    soidSimpleOrderPickingStyle?: string | undefined;
    soidSimpleOrderPickingZonesFormatNumbers?: string | undefined;
    soidSimpleTransferDeliveryFormatSet?: string | undefined;
    soidSimplePrintDocumentsOnBackOrder?: string | undefined;
    soidSimpleOnlyInvoiceWhenCODFullyPaid?: string | undefined;
    soidSimpleOrderRecordPickingStarted?: string | undefined;
    soidSimpleOrderOnlyApproveIfJourneyComplete?: string | undefined;
    soidSimpleAutoIssueOnInvoiceIfNotYetIssued?: string | undefined;
    soidSimpleAVOFormatSet?: string | undefined;
    soidSimpleAdditionalCostFormat?: string | undefined;
    soidSimplePromptForDeliveryInAdvancedPicking?: string | undefined;
    soidSimplePromptUserIfQtyPickedNotEqualToQtyOrdered?: string | undefined;
    soidSimpleDeliveryFormatSetCredit?: string | undefined;
    soidSimpleCollectLaterFormatSetCash?: string | undefined;
    soidSimpleCollectLaterFormatSetCredit?: string | undefined;
    soidSimpleRequireReasonCodeOnPickShortage?: string | undefined;
    soidSimplePrintPickingNoteWhenStockAvailable?: string | undefined;
    soidSimpleDepositReceiptOnFinalPayment?: string | undefined;
    soidDefaultBackOrderBehaviourInAdvancedPicking?: string | undefined;
    soidSimpleCollectNowPickingDocumentFormatSet?: string | undefined;
    soidSimpleAllowAutoMarkPickWhenUsingAdvancedPicking?: string | undefined;
    soidSimpleAutoPrintSpecialOrderAcknowledgementDocument?: string | undefined;
    soidSimpleSpecialOrderAcknowledgementDocumentFormatSet?: string | undefined;
    soidSimpleDisplayBinLocationOnPickingConfirmation?: string | undefined;
    soidSimpleAllowPackReferenceScanningOnPickingConfirmation?: string | undefined;
    soidSimpleAllowPickingNotePrintOnDeliveredCashSaleWithOutstandingBalance?: string | undefined;
    soidSimpleAllowdeliveryNotePrintOnDeliveredCashSaleWithOutstandingBalance?: string | undefined;
    soidSimpleOrderAmendPrintFormatSet?: string | undefined;
    soidSimpleOrderAmendPrintHandling?: string | undefined;
    soidSimpleOrderAllowUnpickIfInvoiced?: string | undefined;
    soidDefaultPrintDeliveryNoteDocumentSet?: string | undefined;
    soidPrintDeliveryNoteFormatWhenMarkingDelivered?: string | undefined;
    soidOrderAllowQuantityLessThanPicked?: string | undefined;
    soidSimpleOrderDefaultPickingZoneFromOrderMonitor?: string | undefined;
    soidSimpleOrderHideItemsWhichAreNotInSelectedZone?: string | undefined;
    soidSimpleOrderDefaultMOLTasPickedInAdvancedPicking?: string | undefined;
    soidSimpleOrderOnlyReleaseBackOrderWithSingleDeliveryOption?: string | undefined;
    soidSimpleConfirmChecked?: string | undefined;
    soidDefaultPrintPickingNoteWhenMarkingPickStarted?: string | undefined;
    soidScanActionBarcodesInBatchUpdate?: string | undefined;
    soidSimpleDeliveryAfterChecked?: string | undefined;
    soidOrdersAllowCompleteWhenJobIsPreliminary?: string | undefined;
    soidCheckPickingRequiredFlagWhenDeterminingPickingZonePrintingFormats?: string | undefined;
    soidSimpleOrderSetDefaultReleaseQuantityToAll?: string | undefined;
    soidIncludeUnapprovedOrdersInOrdersForInvoicingFilter?: string | undefined;
    soidOrdersAllowChangingUOMsinQtyAndQtyPriceEntry?: string | undefined;
    soidShowMsgWhenPickingLessSpecialOrderThanAvailable?: string | undefined;
    soidSimpleOrderLimitPickingAndCheckedByUsersByBranch?: string | undefined;
    soidSimpleOrderDefaultPickingStartedUserToFirstAvailable?: string | undefined;
    soidPrintDeliveryNoteDocumentSetWhenMarkingDelvOrdersPicked?: string | undefined;
    soidSimpleOrderRecordPickComplete?: string | undefined;
    soidPromptSignatureWhenCompletingCollectNowOrderThatGoesCreditHold?: string | undefined;
    soidPromptSignatureWhenChangingWMSOrderTypeToCollectLaterNow?: string | undefined;
    soidUseSignatureCaptureSettingsForCollectNowWhenCompletingCollectLaterNow?: string | undefined;
    soidSimpleOrderEnableMarkFullyPicked?: string | undefined;
    soidDisplayAwaitingStockWarningMessagesInPickingConfirmation?: string | undefined;
    soidBackOrderEntireSingleDeliveryOrderWhenAnyLineBackOrdered?: string | undefined;
    soidWMSDefaultBackOrderBehaviour?: string | undefined;
    soidWMSMarkOrdersDeliveredWhenPickCompletedFromWMS?: string | undefined;
    soidCashSalesPercentToleranceForTalliedTimber?: string | undefined;
    soidCashSalesAmountToleranceForTalliedTimber?: string | undefined;
    soidCashSalesPercentToleranceForNonTalliedTimber?: string | undefined;
    soidCashSalesAmountToleranceForNonTalliedTimber?: string | undefined;
    soidCashSalesPercentToleranceForProductSubstitutions?: string | undefined;
    soidCashSalesAmountToleranceForProductSubstitutions?: string | undefined;
    soidCashSalesRestrictFullyPaidCashSaleToSameProductGroup?: string | undefined;
    soidCashSalesRunWithNewCashBehaviour?: string | undefined;
    soidCashSalesEnableToleranceChecking?: string | undefined;
    soidCashSalesAutoFinalizeDaily?: string | undefined;
    soidCashSalesForceAddressCollectNow?: string | undefined;
    soidCashSalesForceAddressCollectLater?: string | undefined;
    soidCashSalesOrderMaximumCashAllowed?: string | undefined;
    soidCashSalesAllowDepositGreaterThanOrderTotal?: string | undefined;
    soidCashSalesPostCheckOverpaymentAsChangeDue?: string | undefined;
    soidSimpleOnlyAllowDeliverySetPrintAfterMarked?: string | undefined;
    soidForceSelectionOfReasonCodeForLodgement?: string | undefined;
    soidCashSalesRetainInvoiceAddressWhenCopyingCashSales?: string | undefined;
    soidCashSalesDepositReceiptOnBackOrders?: string | undefined;
    soidDefaultLodgementPostingDate?: string | undefined;
    soidAllowLodgementsOnCreditAndDebitCards?: string | undefined;
    soidSortPaymentMethodByPaymentMethodCode?: string | undefined;
    soidReturnToPaymentDetailsAfterFullyPaid?: string | undefined;
    soidCashSalesAllowDeliveryCollectionOfUnpaid?: string | undefined;
    soidDefaultContractSchedule?: string | undefined;
    soidPostInstalledSalesShipmentsToManualOrderInvoicingLines?: string | undefined;
    soidPostSalesAmountAtTimeOfMaterialShipment?: string | undefined;
    soidForceSelectionOfAddressOnContractCreation?: string | undefined;
    soidDefaultOrdersAndCallOffsToUseOpenContracts?: string | undefined;
    soidAllowMultipleCallOffOrdersOnContracts?: string | undefined;
    soidDefaultMarginForPostCostToWIPMethod?: string | undefined;
    soidAccruedARInstalledSalesVarianceMOLT?: string | undefined;
    soidContractsCopyFromDefaultDocType?: string | undefined;
    soidContractsCopyFromDefaultConsolidateByMOLT?: string | undefined;
    soidAllowSettingTaxAreaOnContracts?: string | undefined;
    soidContractsIncludeSalesTaxAmountDuringCopySections?: string | undefined;
    soidAllowSettingRetentionPercentageOnContractInvoicingLines?: string | undefined;
    soidAutoCloseContractsWithNoTransactionsInNumberOfDays?: string | undefined;
    soidIncludeTaxInRetentionCalculations?: string | undefined;
    soidAllowSelectingJobAddressOnContractBillingLine?: string | undefined;
    soidShowTimberFunctionality?: string | undefined;
    soidTimberSplitPackRefSuffix?: string | undefined;
    soidTimberAllowSplitToLoose?: string | undefined;
    soidTimberSplitPackVolumeWarningTreshold?: string | undefined;
    soidTimberDuplicatePackReferenceOption?: string | undefined;
    soidTimberTallyLengthDecimalPlaces?: string | undefined;
    soidTimberPackTallyInput?: string | undefined;
    soidTimberAutoAllocatePackBarCodes?: string | undefined;
    soidTimberAllowDecimalPlacesOnNumberOfSheets?: string | undefined;
    soidTimberInputAdvanced?: string | undefined;
    soidTimberInputShowStdLengths?: string | undefined;
    soidTimberInputNoOfBlankRows?: string | undefined;
    soidTimberInputColumnSequence?: string | undefined;
    soidTimberAutoSetPackType?: string | undefined;
    soidTimberPercForAPTL?: string | undefined;
    soidTimberInputMaskContractRef?: string | undefined;
    soidTimberInputMaskContractPeriod?: string | undefined;
    soidTimberInputMaskShip?: string | undefined;
    soidTimberInputMaskVoyage?: string | undefined;
    soidTimberInputMaskBOLRef?: string | undefined;
    soidTimberInputMaskShipPackRef?: string | undefined;
    soidTimberPackVolFormatString?: string | undefined;
    soidTimberPackShowPackEstimate?: string | undefined;
    soidTimberDefaultStatusOnStockReceipt?: string | undefined;
    soidTimberPackQuantityAbbreviation?: string | undefined;
    soidTimberSplitPackAllowHigherVolume?: string | undefined;
    soidTimberUsePackSubstitution?: string | undefined;
    soidTimberPackVolDecimalPlaces?: string | undefined;
    soidTimberPackLengthDecimalPlaces?: string | undefined;
    soidTimberPackFindDefaultView?: string | undefined;
    soidTimberPackTallyDisplayAvailableOrActual?: string | undefined;
    soidTimberSplitPackReasonCode?: string | undefined;
    soidTimberInputRoundToNearestTallyLength?: string | undefined;
    soidTimberUseTallyCalculator?: string | undefined;
    soidTimberStockShortageWarningOnSOTally?: string | undefined;
    soidTimberOrdersShowInvalidTallyWarnings?: string | undefined;
    soidTimberAllowBulkChangeStockLocationOnFreePacks?: string | undefined;
    soidTimberDefaultNATalliedScreenToSplitTallyOnPO?: string | undefined;
    soidTimberAllowDifferentTallySelectionOnSalesTransactions?: string | undefined;
    soidTimberRetainPackRefWhenReuseSourceOnWorksOrders?: string | undefined;
    soidTimberIncludeFreePacksAsAvailable?: string | undefined;
    soidTimberIncludePackStockAsAvailableOnTallyInput?: string | undefined;
    soidTimberInputLimitToNoOfBlankRows?: string | undefined;
    soidTimberDisplayTallyLengthsInProductFindForAvailableStock?: string | undefined;
    soidTimberDefaultUsePackPriceSurcharge?: string | undefined;
    soidTimberAllowDifferentTallySelectionOnWorksOrderSourceLines?: string | undefined;
    soidTimberCopyParentTallyAndQuantityToNotesWhenTallySplit?: string | undefined;
    soidPacksAutoSplitOnPackConfirmation?: string | undefined;
    soidPacksCopyAttachmentsDuringSplit?: string | undefined;
    soidPacksReuseSourcePacksOnFinishedProducts?: string | undefined;
    soidAllowPartialCreditOfTaggedPacks?: string | undefined;
    soidTimberShowProductLinealFeetPercentage?: string | undefined;
    soidShowSteelFunctionality?: string | undefined;
    soidProfileSalesAnalysisCode?: string | undefined;
    soidDefaultProfileMachine?: string | undefined;
    soidDefaultProfileManualOrderLineType?: string | undefined;
    soidSteelPickingWeightDifferenceLow?: string | undefined;
    soidSteelPickingWeightDifferenceHigh?: string | undefined;
    soidAllowWeightAsStockingUnitOfMeasure?: string | undefined;
    soidEnableAlternateUnitOfMeasureForTallyLengths?: string | undefined;
    soidShowTestCertificateFunctionality?: string | undefined;
    soidTestCertificateAttachmentFolder?: string | undefined;
    soidEnableAVOTolerances?: string | undefined;
    soidMetalConformanceCertificateFormatNumber?: string | undefined;
    soidOrdersOrderLineAdditionalInfoDisplay?: string | undefined;
    soidSignatureCaptureDelivered?: string | undefined;
    soidSignatureCaptureDirect?: string | undefined;
    soidSignatureCaptureCollectLaterCash?: string | undefined;
    soidCalculateDeliveryChargesCostsBasedOnTotalValues?: string | undefined;
    soidCalculateDeliveryChargesAtLineLevelOnly?: string | undefined;
    soidRequireUserToAcceptSignaturesFromSignatureCapture?: string | undefined;
    soidDisplayMarginAndCostDuringQuickAddEntry?: string | undefined;
    soidDisplayExtendedOrderLineQuantityInformation?: string | undefined;
    soidOrdersAllowDisablingAndEditingOfDeliveryChargesWithPermission?: string | undefined;
    soidOrdersShowSaleTypeInDocumentInformationBar?: string | undefined;
    soidOrdersBackOrderReleaseCheckPackAndLooseAvailableStock?: string | undefined;
    soidOrdersForceUpperCaseAddress?: string | undefined;
    soidUpdateSpecialOrderSalesQuantityWithQuantityReceived?: string | undefined;
    soidAllowCompanyChequeOnOrdersCreatedFromCreditNotes?: string | undefined;
    soidOrdersCustomerJobInstructionsAsAutoText?: string | undefined;
    soidOrdersCalcDeliveryAndAllowCODonOrdersWithJustMOLTlines?: string | undefined;
    soidOrdersUsingF6GoesToCustomerField?: string | undefined;
    soidOrdersProrateDepositsDuringBackOrder?: string | undefined;
    soidOrdersOpenPurchaseOrdersOnSalesOrderUpdate?: string | undefined;
    soidOrdersAutomaticallyReleaseBackOrders?: string | undefined;
    soidOrdersAllowChangeOfVehicleAndDeliveryTimeOnOrdersInvoiced?: string | undefined;
    soidCheckMinimumDepositWhenOrderIsModified?: string | undefined;
    soidDisableAdditionalCostDeliveryChargesWhenDeliveryChargesAreDisabled?: string | undefined;
    soidbTAStatementsAlwaysPrintImages?: string | undefined;
    soidbTAFinanceChargeDefaultOverdueBy?: string | undefined;
    soidbTAFinanceChargeDefaultMonthlyFinanceChargePercent?: string | undefined;
    soidbTAFinanceChargeDefaultRevolvingAccountGrace?: string | undefined;
    soidbTAStatementGenerateDefaultIncludeCustomersWithNoTransactions?: string | undefined;
    soidbTAStatementGenerateDefaultTransactionsToInclude?: string | undefined;
    soidbTAStatementGenerateDefaultConsolidateGroupAccounts?: string | undefined;
    soidbTAStatementGenerateDefaultIndividualChildStatements?: string | undefined;
    soidbTAStatementSendDefaultIncludeStatementsWithZeroBalance?: string | undefined;
    soidbTAStatementSendDefaultIncludeFullyPaidTransactions?: string | undefined;
    soidbTACustomerStatementByJobReportName?: string | undefined;
    soidbTASummaryStatementReportName?: string | undefined;
    soidbTAAllowGeneratingStatementsByJob?: string | undefined;
    soidbTACanGenerateFinChargesByCustomerGroup?: string | undefined;
    soidbTADefaultAccountPaymentToCustomersHomeBranch?: string | undefined;
    soidbTAAccountPaymentCreditCardSurchargePercentage?: string | undefined;
    soidbTADirectPostingReasonCodeForAccountPaymentCreditCardSurcharge?: string | undefined;
    soidbTAAccountPaymentCreditCardSurchargeType?: string | undefined;
    soidbTAAllowMatchingTransactionsBetweenARAccounts?: string | undefined;
    soidbTAReasonCodeToUseForInterBranchDirectPostings?: string | undefined;
    soidbTAAllowSelectionOfPaymentMethodInBatchCasPosting?: string | undefined;
    soidbTAUseAcctPmtsInsteadOfCashPosting?: string | undefined;
    soidbTAAllowTakingDepositsOnARSalesOrders?: string | undefined;
    soidPopupJourneyDateVisible?: string | undefined;
    soidPopupJourneyDriverVisible?: string | undefined;
    soidPopupJourneyVehicleVisible?: string | undefined;
    soidPopupJourneyWeightVisible?: string | undefined;
    soidPopupJourneyDropsVisible?: string | undefined;
    soidPopupJourneyVolumeVisible?: string | undefined;
    soidJourneyPlannerGroupJourneysByReference?: string | undefined;
    soidJourneyPlannerTimeFrame?: string | undefined;
    soidJourneyPlannerFirstDayOfWeek?: string | undefined;
    soidJourneyPlannerWorkingDays?: string | undefined;
    soidJourneyPlannerStartOfDay?: string | undefined;
    soidJourneyPlannerEndOfDay?: string | undefined;
    soidJourneyPlannerTimeInterval?: string | undefined;
    soidJourneyPlannerWeightDecimalPlaces?: string | undefined;
    soidJourneyPlannerVolumeDecimalPlaces?: string | undefined;
    soidJourneyOnlyAllowTransportCostsForPicked?: string | undefined;
    soidJourneyAllowCompleteWithNoTransportCost?: string | undefined;
    soidJourneyApplyTransportCostsOnCompletion?: string | undefined;
    soidJourneyApplyTransportCostsTo?: string | undefined;
    soidJourneyPromptForCreditHoldOrParkedOrders?: string | undefined;
    soidJourneyPlannerBranchViewDefault?: string | undefined;
    soidJourneyPlannerTimeIntervalForCalendar?: string | undefined;
    soidJourneyPlannerGroupJourneysByDriver?: string | undefined;
    soidJourneyShowAdditionalCostsOnJourney?: string | undefined;
    soidJourneyAutoRemoveAndAddDocumentsToRelatedAddCostChargeProRates?: string | undefined;
    soidJourneyIncludePOWeight?: string | undefined;
    soidJourneyPlannerLimitToBranchVehicles?: string | undefined;
    soidJourneyMarkOrdersDeliveredWhenJourneyMarkedInProgress?: string | undefined;
    soidJourneyPlannerDisplayVIN?: string | undefined;
    soidJourneyEnableAutomaticScheduledRoutes?: string | undefined;
    soidJourneyPromptForExistingJourneyWithTheSameAddress?: string | undefined;
    soidJourneyPlannerAutoRefreshInterval?: string | undefined;
    soidJourneyAllowLinkingTrailersToTruchAndTrailerVehicles?: string | undefined;
    soidJourneyReferenceRequired?: string | undefined;
    soidJourneyShowWarningWhenDocumentDateRequiredDontMatchJourneyDate?: string | undefined;
    soidJourneyEnableAllowMultipleDeliveryAreasInJourney?: string | undefined;
    soidJourneyDefaultUnloadTimePerStop?: string | undefined;
    soidJourneyShowCreditNotePrintedInDocumentList?: string | undefined;
    soidJourneyPlannerAutoAddUnusedVehicles?: string | undefined;
    soidJourneyMarkDatesFull?: string | undefined;
    soidDirectionsSource?: string | undefined;
    soidAddressingSource?: string | undefined;
    soidAddReturnToStart?: string | undefined;
    soidCustomerMapPointFolder?: string | undefined;
    soidDirectionsGoogleMapsURL?: string | undefined;
    soidDirectionsBingMapsURL?: string | undefined;
    soidDirectionsAddressPattern?: string | undefined;
    soidVehicleTrackingSoftwareService?: string | undefined;
    soidVehicleTrackingWebServiceLocation?: string | undefined;
    soidVehicleTrackingClientAccessCode?: string | undefined;
    soidVehicleTrackingSpeedSuffix?: string | undefined;
    soidVehicleTrackingClientPassword?: string | undefined;
    soidVehicleTrackingInternetMapURL?: string | undefined;
    soidCustomerAddressMapGridSettings?: string | undefined;
    soidPassAddressCoordinatesForInternetMapping?: string | undefined;
    soidShowMapDirectlySkippingVehicleLocationForm?: string | undefined;
    soidDirectionsGMapsDirectionsURL?: string | undefined;
    soidDirectionsGMapsDirectionsKey?: string | undefined;
    soidWorksOrderWasteWarning?: string | undefined;
    soidDefaultToManufactured?: string | undefined;
    soidWorksOrderPrintOnChange?: string | undefined;
    soidWorksOrderEnableCalendarScheduling?: string | undefined;
    soidWorksOrderConsolidateIdenticalWOProcessesOnWOSchedule?: string | undefined;
    soidWorksOrderHybridCostingWarning?: string | undefined;
    soidWorksOrderSourcePrefixText?: string | undefined;
    soidWorksOrderNewLineAfterSourcePrefix?: string | undefined;
    soidWorksOrderProcessPrefixText?: string | undefined;
    soidWorksOrderFinishedPrefixText?: string | undefined;
    soidWorksOrderNewLineAfterFinishedPrefix?: string | undefined;
    soidWorksOrderSOWaitForStock?: string | undefined;
    soidWorksOrderAllowProcessingIfCreditControl?: string | undefined;
    soidWorksOrderAllowFinishCostOverride?: string | undefined;
    soidWorksOrderCreateProductsOnManufactured?: string | undefined;
    soidWorksOrderForceCreateOnManufactured?: string | undefined;
    soidCreateGLTransactionsWorksOrder?: string | undefined;
    soidWorksOrderBaseSpecialOnProdGroupID?: string | undefined;
    soidWorksOrderIgnoreHowSourcedOnSpecials?: string | undefined;
    soidCreateGLTransactionsCOGS?: string | undefined;
    soidCreateGLTransactionsStockTransfer?: string | undefined;
    soidCreateGLTransactionsSupplierReturns?: string | undefined;
    soidWorksOrderTrussDescription?: string | undefined;
    soidFinancialDescAppendDocRef?: string | undefined;
    soidWorksOrderAutoCopySourceToFinished?: string | undefined;
    soidWorksOrderAllowMultiplePacksWhenConfirmingSourceMaterialPacks?: string | undefined;
    soidWorksOrderEnablePCMInterface?: string | undefined;
    soidWorksOrderPCMInputFileLocation?: string | undefined;
    soidWorksOrderPCMOutputFileLocation?: string | undefined;
    soidWorksOrderPCMPackRefDestination?: string | undefined;
    soidWorksOrderPCMPackPrefix?: string | undefined;
    soidWorksOrderPCMDescriptionField?: string | undefined;
    soidWorksOrderUseDocumentReleaseProcess?: string | undefined;
    soidWorksOrderAlwaysReplaceForConfirmPacks?: string | undefined;
    soidWorksOrderDefaultLinesFromSalesOrderWOCreation?: string | undefined;
    soidWorksOrderAllowPartProcessing?: string | undefined;
    soidWorksOrderCopyAVONotesToOverheadPOManualLineDescription?: string | undefined;
    soidWorksOrderProcessDefaultManualLineType?: string | undefined;
    soidWorksOrderCombineAVOsIntoSinglePurchaseOrder?: string | undefined;
    soidWorksOrderAllowProcessingWorksOrderAwaitingSourceMaterial?: string | undefined;
    soidWorksOrderReviewSuppliersForPOCreatedFromWO?: string | undefined;
    soidWorksOrderForceSourceSelectionForPartProcess?: string | undefined;
    soidWorksOrderUseProcessWorkflow?: string | undefined;
    soidWorksOrderSuppressWorkflowPOPrint?: string | undefined;
    soidWorksOrderProcessPickingFormatSet?: string | undefined;
    soidWorksOrderProcessDeliveryFormatSet?: string | undefined;
    soidWorksOrderProcessCollectionFormatSet?: string | undefined;
    soidWorksOrderProcessReceiptFormatSet?: string | undefined;
    soidWorksOrderDefaultProcessWorksOrder?: string | undefined;
    soidWorksOrderFromOrderRequiredDays?: string | undefined;
    soidWorksOrderAllowDifferentAVOCurrency?: string | undefined;
    soidWorksOrderProcessReadyForCollectionFormatSet?: string | undefined;
    soidWorksOrderDefaultSourceProductsDisplayCostOnCreationToStandardBuy?: string | undefined;
    soidWorksOrderAllowOnJourneyIfHasWorkflow?: string | undefined;
    soidWorksOrderAutoSplitPacksDuringConfirmation?: string | undefined;
    soidWorksOrderDefaultAVOsToSpreadCostToLinesTheyAreBasedOn?: string | undefined;
    soidWorksOrderAllowBranchChangeWhenAllocated?: string | undefined;
    soidWorksOrderAlwaysAllocateStockWhenCopying?: string | undefined;
    soidWorksOrderUpdateDateRequiredWhenSODateRequiredChanges?: string | undefined;
    soidWorksOrderSetSpecialDescriptionFromFinishedLine?: string | undefined;
    soidWorksOrderDisplay_BF_SF_LF_MachineSchedule?: string | undefined;
    soidWorksOrderAveCostAdjReasonForProcessCostAppliedToSO?: string | undefined;
    soidWorksOrderSalesOrderAVOForProcessCostAppliedToSO?: string | undefined;
    soidWorksOrderDefaultNewWOCreation?: string | undefined;
    soidWorksOrderPromptToProcessUponScheduleCompletion?: string | undefined;
    soidWorksOrderDefaultApplyProcessCostsToLinesOnWOCreatedFromSO?: string | undefined;
    soidWorksOrderShowStockWarningOnWOGeneratedFromSO?: string | undefined;
    soidWorksOrderAllowProcessingIfSourceMaterialStockWillGoNegative?: string | undefined;
    soidWorksOrderPromptToPrintLabelsForTaggedPacksWhenWOCompleted?: string | undefined;
    soidWorksOrderPromptToPrintLabelsForTaggedPacksWhenWOProcessed?: string | undefined;
    soidWorksOrderAlwaysCalculateRequiredDateOnCreation?: string | undefined;
    soidWorksOrderSalesOrderAVOForWasteCosts?: string | undefined;
    soidWorksOrderAveCostAdjReasonForWasteCosts?: string | undefined;
    soidStockReceiptPrintOnChange?: string | undefined;
    soidStockReceiptsPreentered?: string | undefined;
    soidStockreceiptQtyOverReceivedWarningThreshold?: string | undefined;
    soidStockReceiptRetainERWhenReceivingPreEnteredPacks?: string | undefined;
    soidStockreceiptQtyUnderReceivedWarningThreshold?: string | undefined;
    soidStockReceiptAutoPrintLabels?: string | undefined;
    soidStockReceiptsRequiresDeliveryDetails?: string | undefined;
    soidStockReceiptsRequiresHaulierDetails?: string | undefined;
    soidStockReceiptsInAdvanceAffectOnOrder?: string | undefined;
    soidStockReceiptsQuickAddInputStyle?: string | undefined;
    soidStockReceiptBackdateERWhenBackdating?: string | undefined;
    soidStockReceiptRequireBinForSpecials?: string | undefined;
    soidInvoiceLowMarginCollected?: string | undefined;
    soidInvoiceLowMarginDelivered?: string | undefined;
    soidInvoiceLowMarginDirect?: string | undefined;
    soidInvoiceHighMargin?: string | undefined;
    soidDefaultInvoicePaymentMethod?: string | undefined;
    soidDefaultInvoicePaymentTerms?: string | undefined;
    soidIncludeOrderTextLinesInInvoice?: string | undefined;
    soidDefaultInvoiceBrowserFilterToUnreleased?: string | undefined;
    soidInvoiceOnMarkDelivered?: string | undefined;
    soidAllowUpdatesOfUnreleasedInvoices?: string | undefined;
    soidInvoiceAllowEditInternalNotesAfterCompletion?: string | undefined;
    soidInvoiceSendSeparateInvoicesForEachJob?: string | undefined;
    soidDefaultInvoiceCostAdjustmentReason?: string | undefined;
    soidAllowInvoiceToBeSentType?: string | undefined;
    soidOnlyMarkInvoicesSentFromBrowser?: string | undefined;
    soidOrdersAutoInvoiceCollectNowChargeOrdersOnCompletion?: string | undefined;
    soidOrdersMarkCollectNowChargeOrdersAsSentWhenInvoicingOnCompletion?: string | undefined;
    soidOrdersAutoInvoiceCollectLaterChargeOrdersOnCompletion?: string | undefined;
    soidInvoiceAutoApproveIfIssued?: string | undefined;
    soidInvoiceAutoSetDateTo?: string | undefined;
    soidInvoiceAutoOnlyIfOrderStatusIsInvoicing?: string | undefined;
    soidCreditDefaultReturnStockToZero?: string | undefined;
    soidCreditReturnStockToReceivingBranch?: string | undefined;
    soidCreditAllowSettlementDiscount?: string | undefined;
    soidCreditUserMustReconfirmPassword?: string | undefined;
    soidCreditRefundAmountToForceCompanyCheque?: string | undefined;
    soidCreditCalculateSellPriceManualLine?: string | undefined;
    soidCreditApplyRestockChargeToOwnBrandProducts?: string | undefined;
    soidCreditFullRestockChargeOnSpecials?: string | undefined;
    soidCreditLockCashRefundsToOriginalPayment?: string | undefined;
    soidCreditUseCustomerCreditsForCustomerReturns?: string | undefined;
    soidCreditRefundAmountToForceGiftCard?: string | undefined;
    soidCreditRefundChequeFormat?: string | undefined;
    soidCreditReturnToSupplierOnDirect?: string | undefined;
    soidCreditConfirmRefundAddress?: string | undefined;
    soidCreditNoteRequestFormatNumber?: string | undefined;
    soidCreditRefundAllowCompanyCheque?: string | undefined;
    soidCreditAllowPrintFinalDocumentOnRelease?: string | undefined;
    soidCreditSearchInvoicesByOrderNumber?: string | undefined;
    soidCreditAllowUnpaidCustomerCredits?: string | undefined;
    soidCreditAllowSalesOrderCreationFromCreditNotes?: string | undefined;
    soidCreditDefaultReturnStockToZeroFromProductsPurchased?: string | undefined;
    soidCreditUseTakenByFromLinkedInvoiceForSalesAnalysis?: string | undefined;
    soidCreditDoNotAllowReturnToStockCreditNotesBackToVMIPrograms?: string | undefined;
    soidCreditRefundAlwaysAllowCompanyCheque?: string | undefined;
    soidCreditUpdateQuantityCreditedAtTimeOfCreditCreation?: string | undefined;
    soidCreditDefaultHandling?: string | undefined;
    soidCreditAlwaysUseARCustomerFromAddress?: string | undefined;
    soidCreditAllowQuantityLessThanReturnToStockQuantity?: string | undefined;
    soidCreditAutoApproveCreditNoteOnCompletionWhenStockReturned?: string | undefined;
    soidCreditWMSRefuseOnTruckReasonCode?: string | undefined;
    soidCreditWMSRefuseOnTruckReasonCodeCash?: string | undefined;
    soidCreditWMSUpdateCreditQuantity?: string | undefined;
    soidCreditPostSalesAndCOGSToInvoiceBranch?: string | undefined;
    soidCreditRebillCreditNoteReason?: string | undefined;
    soidCreditRebillCashRefundReason?: string | undefined;
    soidCreditDefaultCreditNoteLinesToIncludeAVOCost?: string | undefined;
    soidCreditRequireCashRefundAuthorization?: string | undefined;
    soidCreditSignatureCaptureForReturnToBranch?: string | undefined;
    soidCreditReasonCodeToUseForContractBillingCreditNotes?: string | undefined;
    soidCreditReasonCodeToUseForContractBillingCashRefunds?: string | undefined;
    soidCreditCopyCustomerAddressNotesIntoDescription?: string | undefined;
    soidCreditDefaultProductsPurchasedDateSearch?: string | undefined;
    soidCreditPrintCreditFormatFromCashRefund?: string | undefined;
    soidCreditLimitInvoiceAndProductPurchasedSearchesToTheJobOnCreditNotes?: string | undefined;
    soidCashDrawerCOMEnabled?: string | undefined;
    soidCashDrawerDefaultClosingFloat?: string | undefined;
    soidUpdateLCPOnPurchaseOrderUpdate?: string | undefined;
    soidUpdateLCPOnStockReceiptUpdate?: string | undefined;
    soidUpdateLCPOnSupplierInvoiceApprove?: string | undefined;
    soidUpdateLCPOnWorksOrderProcess?: string | undefined;
    soidIncludeProratedManualCostsInACP?: string | undefined;
    soidIncludeProratedManualCostsInLCP?: string | undefined;
    soidUpdateLCPOnStockTransferReceipt?: string | undefined;
    soidInventoryAgingAnnualCostRate?: string | undefined;
    soidFreeDaysBeforeAgingApplies?: string | undefined;
    soidSkipUpdateACPOnSupplierInvoiceApprove?: string | undefined;
    soidTurnOffProduceInvoiceOnCOD?: string | undefined;
    soidVolumeDisplayUnitInOrderSummary?: string | undefined;
    soidDisplayVolumeAreaLengthInOrderSummary?: string | undefined;
    soidSalesAndPOLineVolumeDisplayPer?: string | undefined;
    soidSalesAndPOLineAreaDisplayPer?: string | undefined;
    soidSalesAndPOLineLengthDisplayPer?: string | undefined;
    soidEnableVMIProcessingUseThisOne?: string | undefined;
    soidShowReelFunctionality?: string | undefined;
    soidDefaultNotepadCaseStatus?: string | undefined;
    soidAllowVMIPRulesThatAreCalculatedFromSellPrice?: string | undefined;
    soidUseEstimateCostsOnlyOnAdditionalCostCalcs?: string | undefined;
    soidUpdateCostsOnSupplierInvoiceWhenStockReceiptPreEntered?: string | undefined;
    soidAlwaysProrateAdditionalCostsBySellPrice?: string | undefined;
    soidInventoryValueNetOfSupplierDiscount?: string | undefined;
    soidNumberOfCostDiscountFields?: string | undefined;
    soidSetAverageCostsOnSpecialOrderCreation?: string | undefined;
    soidEnableCostDiscountFieldsOnDirects?: string | undefined;
    soidPOCostControlledByPermission?: string | undefined;
    soidPPVCalculation?: string | undefined;
    soidReasonCodeForPPVWhenCreatingAutoACA?: string | undefined;
    soidIntrastatSupplierDefaultDeliveryTerms?: string | undefined;
    soidIntrastatSupplierDefaultModeOfTransport?: string | undefined;
    soidIntrastatCustomerDefaultDeliveryTerms?: string | undefined;
    soidIntrastatCustomerDefaultModeOfTransport?: string | undefined;
    soidIntrastatIntegration?: string | undefined;
    soidDefaultProductStockClass?: string | undefined;
    soidProductDefaultSpecialsToKeepStockFigures?: string | undefined;
    soidEnablePermissionsByProductTab?: string | undefined;
    soidProductShowAveCostInBuyPer?: string | undefined;
    soidNoOfProductImages?: string | undefined;
    soidProductImageNames?: string | undefined;
    soidDefaultProductHistoryDays?: string | undefined;
    soidProductShowCompanyStockInFindProducts?: string | undefined;
    soidProductEnableProductManagerNotifications?: string | undefined;
    soidProductDefaultSpecialsProductGroup?: string | undefined;
    soidProductAlternativeSupplierPriceWeeks?: string | undefined;
    soidProductEditProductGroupAffectsSalesAnalysis?: string | undefined;
    soidProductQtyInFindProductsToRead?: string | undefined;
    soidProductEnablePrintingofZebraLabels?: string | undefined;
    soidProductAllowDuplicateBarcodes?: string | undefined;
    soidProductSupplierPricesInSupplierCurrency?: string | undefined;
    soidProductDefaultStocked?: string | undefined;
    soidProductDefaultAllowSpecialsBasedOnThis?: string | undefined;
    soidProductRequireWeightOnProductsAndSpecials?: string | undefined;
    soidProductRequireEnvironmentalStatusOnSpecials?: string | undefined;
    soidProductUpdateStandardBranchPricesWithCompanyPrices?: string | undefined;
    soidProductSkipDetailsOnAutoCreatedPurchasedSpecials?: string | undefined;
    soidProductLimitSellingPriceBandsToSpecificBranches?: string | undefined;
    soidProductLimitStockOptionsToBranchesWithUpdateAccess?: string | undefined;
    soidProductDefaultSalesTabToCurrentBranch?: string | undefined;
    soidProductDefaultSalesTabToLast12Months?: string | undefined;
    soidProductSetupSellingQuantityBreakByBranch?: string | undefined;
    soidProductSetupPickingRequiredByBranch?: string | undefined;
    soidProductSetupAllowSettlementDiscountByBranch?: string | undefined;
    soidProductAllowChangingProductCodeOnSpecialOrderCreation?: string | undefined;
    soidProductSetSellEntireRelatedSet?: string | undefined;
    soidProductSetSelectDefaultToExpanded?: string | undefined;
    soidProductDefaultNewSpecialProductToBranchCreating?: string | undefined;
    soidProductDefaultShortDescriptionToDescriptionOnSpecialOrderCreation?: string | undefined;
    soidProductCopyPopupTextOnSpecialOrderCreation?: string | undefined;
    soidImportProductFollowBranchAccessPermissions?: string | undefined;
    soidConvertTalliesToSpecialInstructions?: string | undefined;
    soidDefaultDocumentPresentation?: string | undefined;
    soidAddManufacturedKitToExistingWO?: string | undefined;
    soidDefaultHideOnWorksOrders?: string | undefined;
    soidKitsSelectionImageNumber?: string | undefined;
    soidEnableStandardKitPromotions?: string | undefined;
    soidABCDStockClassCalculationBasedOn?: string | undefined;
    soidNumberOfMonthsToBaseRankingsOn?: string | undefined;
    soidNumberOfMonthsOfSalesBeforeRanking?: string | undefined;
    soidStockClassARanking?: string | undefined;
    soidStockClassBRanking?: string | undefined;
    soidStockClassCRanking?: string | undefined;
    soidStockClassDRanking?: string | undefined;
    soidRankInComparisonToProductGroupLevel?: string | undefined;
    soidSearchingIncludeOrderFindSupplierFields?: string | undefined;
    soidHighlightOwnBrandProducts?: string | undefined;
    soidExcludeBarcodeInOrderProductFind?: string | undefined;
    soidUseExactProductCodeSearchOnCollectNow?: string | undefined;
    soidSearchingSortFindDocumentFilterLists?: string | undefined;
    soidSearchingUseIssuingBranch?: string | undefined;
    soidBarcodePrefix?: string | undefined;
    soidUseAdditionalBarcodesInOrderProductFind?: string | undefined;
    soidSearchingFindDocsDeliveryAreaSearchStyle?: string | undefined;
    soidSearchingTrimSearchText?: string | undefined;
    soidSearchMOLTsInProductFindInOrderEntry?: string | undefined;
    soidSearchCouponsInProductFindInOrderEntry?: string | undefined;
    soidSearchingDeliveryAreaSearchStyle?: string | undefined;
    soidAllowCustomerProductReference?: string | undefined;
    soidSupplierReturnEnable?: string | undefined;
    soidSupplierReturnAlwaysDefaultCostToAverageCostWithAdd?: string | undefined;
    soidSupplierReturnAllowBranchChangeWhenLinkedToDocument?: string | undefined;
    soidSupplierReturnUseAccountsPayableGLCodeFromLinkedDocument?: string | undefined;
    soidSupplierReturnAllowInspectAfterPickup?: string | undefined;
    soidOrdersPricingSpecialPriceMessage?: string | undefined;
    soidOrdersPricingSpecialPriceMessageColour?: string | undefined;
    soidOrdersPricingUseDeferredDiscountInCostCalc?: string | undefined;
    soidPricingUseOrderCostForSpecialBackToBack?: string | undefined;
    soidSalesOrderSecondaryCostCalculation?: string | undefined;
    soidPricingUseQuotePriceUnlessRuleExists?: string | undefined;
    soidPricingRecostOrderOn?: string | undefined;
    soidPricingUseLastSellPriceWithin?: string | undefined;
    soidOrdersPricingQuotePriceMessage?: string | undefined;
    soidOrdersPricingQuotePriceMessageColour?: string | undefined;
    soidOrdersPricingLastSellPriceMessage?: string | undefined;
    soidOrdersPricingLastSellPriceMessageColour?: string | undefined;
    soidCostDefaultQuoteToStandardBuy?: string | undefined;
    soidCostDefaultTemplateOrderToStandardBuy?: string | undefined;
    soidOrdersPricingCheckIfCallOffExists?: string | undefined;
    soidPricingUseQuotePriceAlways?: string | undefined;
    soidOrdersLastSellPriceIsBranchSpecific?: string | undefined;
    soidOrdersPricingLumpSumQtySell?: string | undefined;
    soidOrdersPricingLumpSumQtyCost?: string | undefined;
    soidOrdersPricingShowLastPOPriceInNegotiation?: string | undefined;
    soidOrdersPricingPOPriceOutOfDateDays?: string | undefined;
    soidOrdersPricingShowContributionOnOrders?: string | undefined;
    soidOrdersPricingUseDeferredDiscountInLastCostCalc?: string | undefined;
    soidOrdersPricingUseDeferredDiscountInAverageCostCalc?: string | undefined;
    soidOrdersPricingRecostBackToBackOrders?: string | undefined;
    soidOrdersPricingPromotionPointsPer?: string | undefined;
    soidOrdersPricingPromotionCalculateAfterDeliveryCharges?: string | undefined;
    soidOrdersPricingAllowNegotiateIfNoMarginOptions?: string | undefined;
    soidOrdersPricingPromotionExcludeAbsolutePriceLines?: string | undefined;
    soidOrdersPricingPromotionExcludeDirects?: string | undefined;
    soidOrdersPricingPromptToChangePriceOnIdenticalItems?: string | undefined;
    soidOrdersPricingDefaultReplaceExistingLineDiscounts?: string | undefined;
    soidOrdersPricingDefaultPriceRulesToCalculateDiscountsIntoUnitPrice?: string | undefined;
    soidOrdersPricingUseInternalCostInMarginCalcs?: string | undefined;
    soidOrdersPricingUseInternalCostRules?: string | undefined;
    soidOrdersPricingApplyPriceRoundingWhenManuallyPricingLines?: string | undefined;
    soidOrdersPricingDefaultCostToZeroOnDirectSalesOrders?: string | undefined;
    soidOrdersPricingShowLastPriceDates?: string | undefined;
    soidOrdersPricingShowNextPricesXDays?: string | undefined;
    soidOrdersPricingManualPriceOnMarginNegotiation?: string | undefined;
    soidOrdersPricingShowPriceBandsOnNegotiation?: string | undefined;
    soidOrdersPricingShowInternalCostInfo?: string | undefined;
    soidOrdersPricingEnsureAVOInclusiveSellPriceExtends?: string | undefined;
    soidOrdersPricingOrderlinePriceInfoToDisplay?: string | undefined;
    soidOrdersPricingUseInternalCostRulesOnDirects?: string | undefined;
    soidOrdersPricingCalculatePriceBandDiscountsIntoUnitPrice?: string | undefined;
    soidOrdersPricingDefaultUseBasedOnProductsOnNewPriceRules?: string | undefined;
    soidOrdersPricingPriceBandsUtilizeBasedOnProducts?: string | undefined;
    soidOrdersPricingRecalcSellPriceOnNonSpecialManKitRefresh?: string | undefined;
    soidOrdersPricingApplyPriceRoundingWhenNegotiatingMargin?: string | undefined;
    soidOrdersPricingEnableManagerOverrideOnOrderLinePrice?: string | undefined;
    soidOrdersPricingRequireReasonCodeOnSalesLinePriceChange?: string | undefined;
    soidOrdersPricingAllowMultiplePromotionsPerLine?: string | undefined;
    soidOrdersPricingShowMultiplierOnOrderLine?: string | undefined;
    soidOrdersPricingRetainOriginalPriceCalc?: string | undefined;
    soidOrdersPricingDefaultCostPerToSellingPerOnSalesOrder?: string | undefined;
    soidOrdersPricingControlFreeOfChargeLines?: string | undefined;
    soidOrdersPricingManualPriceAlwaysClearsDiscounts?: string | undefined;
    soidOrdersPricingRecordSalesNetOfDiscounts?: string | undefined;
    soidOrdersPricingApplySettlementDiscountToCashOrderLines?: string | undefined;
    soidOrdersIncludeAdditionalChargeInOrderLineTotalPrice?: string | undefined;
    soidOrdersRepriceOrderLinesAtFixedMarginPctPerLine?: string | undefined;
    soidOrdersRoundUpSellPriceOnMarginNegotiate?: string | undefined;
    soidOrdersRoundDiscountDown?: string | undefined;
    soidOrdersPricingAutoCreateInvoiceCostAdjForSpecials?: string | undefined;
    soidOrdersPricingDefaultRepriceProductsOnFindAndReplace?: string | undefined;
    soidDefaultCostPerToLastCostWithAdditionalPerOnTransfers?: string | undefined;
    soidOrdersPricingSpecialPriceMessageOverride?: string | undefined;
    soidOrdersPricingApplyPriceRoundingAfterDelChargeIsAdded?: string | undefined;
    soidOrdersPricingKeepPricePerWhenSpecificPriceBandIsUsed?: string | undefined;
    soidOrdersPricingRestoreCostOnSpecialProductsOnRecalculate?: string | undefined;
    soidOrdersPricingDisplayMultiplierInPriceRulesAndSellingBands?: string | undefined;
    soidOrdersPricingShowCostAndSellPriceMultipliersOnSalesSpecialOrderCreation?: string | undefined;
    soidOrdersPricingRecostSalesTransactionsOnCopyFrom?: string | undefined;
    soidOrdersPricingAutoCreateInvoiceCostAdjForNonSpecials?: string | undefined;
    soidAllowMarkingSalesOrderLinesAsNetPriced?: string | undefined;
    soidOrdersPricingDefaultCostOnBackToBackOrderLines?: string | undefined;
    soidOrdersPricingAutoCreateInvoiceCostAdjForManProducts?: string | undefined;
    soidDefaultCalculationMethodForCostBasedSellingPriceRules?: string | undefined;
    soidOrdersPricingAutoApplySellingPriceChangesNightly?: string | undefined;
    soidOrdersUseDefaultJobAddressPriceProfile?: string | undefined;
    soidExcludePriceRoundingWhenUsingSpecialPriceRules?: string | undefined;
    soidQuantityBreaksThatUseSpecificPriceBandWillOnlyUseDiscountFromThatBand?: string | undefined;
    soidOrdersPricingAllowMultipleSpendXSaveYCouponPromotions?: string | undefined;
    soidBranchPrinter1?: string | undefined;
    soidBranchPrinter2?: string | undefined;
    soidBranchPrinter3?: string | undefined;
    soidBranchPrinter4?: string | undefined;
    soidBranchPrinter5?: string | undefined;
    soidBranchPrinter6?: string | undefined;
    soidBranchPrinter7?: string | undefined;
    soidBranchPrinter8?: string | undefined;
    soidBranchPrinter9?: string | undefined;
    soidBranchPrinter10?: string | undefined;
    soidPrintingMaxDocument?: string | undefined;
    soidAlternatePrintDialog?: string | undefined;
    soidAllowDocumentPrintingFromPreview?: string | undefined;
    soidPrinterListMethod?: string | undefined;
    soidPrintingSortPrinterList?: string | undefined;
    soidPrintingPrinterDisplayFormat?: string | undefined;
    soidDepartmentPinter1?: string | undefined;
    soidDepartmentPinter2?: string | undefined;
    soidDepartmentPinter3?: string | undefined;
    soidDepartmentPinter4?: string | undefined;
    soidDepartmentPinter5?: string | undefined;
    soidDepartmentPinter6?: string | undefined;
    soidDepartmentPinter7?: string | undefined;
    soidDepartmentPinter8?: string | undefined;
    soidDepartmentPinter9?: string | undefined;
    soidDepartmentPinter10?: string | undefined;
    soidOrdersEnablePricingOptionToChangeSellingPriceUOM?: string | undefined;
    soidCustomersDefaultRefRequired?: string | undefined;
    soidCustomersDefaultDropdownLists?: string | undefined;
    soidCustomersDefaultEnforceEnterOrderContact?: string | undefined;
    soidAllowCustomerSalesRepToBeOptional?: string | undefined;
    soidRemitToAddressRequiredOnDefaultAddress?: string | undefined;
    soidPreventDuplicateJobReferencesPerCustomer?: string | undefined;
    soidRestrictUpdatingCustomersToHomeBranch?: string | undefined;
    soidAutoAllocateJobNumbers?: string | undefined;
    soidCustomersEnablePermissionsByTab?: string | undefined;
    soidCustomersLimitSearchToHomeBranch?: string | undefined;
    soidCustomersUseTaxExemptionsFromARCustomer?: string | undefined;
    soidCustomersDefaultEnforceJobAddressOrderEntry?: string | undefined;
    soidCustomersDefaultFinanceChargeAmountToNotSet?: string | undefined;
    soidCustomerCopyInstructionsToTransactions?: string | undefined;
    soidCustomerDefaultAllowOvertypeInvoiceAddress?: string | undefined;
    soidCustomerForceVerifyOfContactIdentification?: string | undefined;
    soidCustomerLimitContactsToThoseBasedAtDeliveryAddress?: string | undefined;
    soidCustomerDisplayCustomerContactDefaultOnOrders?: string | undefined;
    soidCustomerDefaultHomeBranchInCustomerFindToLoggedInBranch?: string | undefined;
    soidOptimizeCustomerAddressUsage?: string | undefined;
    soidCustomerTypeLevel1?: string | undefined;
    soidCustomerTypeLevel2?: string | undefined;
    soidCustomersAutomaticallyGenerateProspectCode?: string | undefined;
    soidCustomerEnableContactLoyaltyCards?: string | undefined;
    soidPreventDuplicateAddressCodesPerCustomer?: string | undefined;
    soidForceStateSelectionFromDropdown?: string | undefined;
    soidCustomerLimitContactsToThoseWhoCanAuthoriseSalesOrders?: string | undefined;
    soidGenerateCustomerCodesStartingPoint?: string | undefined;
    soidUseCounterSalesCashAliasCreationFormInBisTrack?: string | undefined;
    soidAutomaticallyGenerateCashCustomerAliasCode?: string | undefined;
    soidAutomaticallyApproveJobs?: string | undefined;
    soidCustomerGenerateNewAddressCodeMethod?: string | undefined;
    soidCopyInfoFromDefaultJobAddress?: string | undefined;
    soidAddressValidationMethod?: string | undefined;
    soidPasswordExpiryDays?: string | undefined;
    soidAllowNonAdministrativePasswordChange?: string | undefined;
    soidStaffNumberRestoreOriginalUser?: string | undefined;
    soidStaffNumberRequiredForNonSalesTransactions?: string | undefined;
    soidServerManagerBackupFolder?: string | undefined;
    soidOrdersPricingRequireReasonCodeOnQuoteLinePriceChange?: string | undefined;
    soidEmailFaxAllowEmailFromOrderCompletion?: string | undefined;
    soidEmailFaxAllowEmailFromPurchaseOrderCompletion?: string | undefined;
    soidEmailFaxCCOtherSalesRepsOnOrderSend?: string | undefined;
    soidDefaultSalesOrderEmailAddressFromContactEmailAddress?: string | undefined;
    soidEmailFaxFaxMethod?: string | undefined;
    soidEmailFaxFaxAutoSendFolder?: string | undefined;
    soidEmailFaxFaxEmailAddress?: string | undefined;
    soidEmailUseSMTPForAllEmail?: string | undefined;
    soidEmailUseTemplates?: string | undefined;
    soidDatabaseMailProfileName?: string | undefined;
    soidPrefaceEmailAddressWithContact?: string | undefined;
    soidEmailFaxVsiFaxEmailNotifyOnEvent?: string | undefined;
    soidCashDrawerTotalTolerance?: string | undefined;
    soidCashDrawerTenderBillDenominations?: string | undefined;
    soidCashDrawerTenderCoinDenominations?: string | undefined;
    soidCashDrawerRequireCashDetailsToBeEntered?: string | undefined;
    soidCashDrawerRequireClosingFloatDetailsToBeEntered?: string | undefined;
    soidCashDrawerRequireOpeningFloatToBeCountedBeforeUse?: string | undefined;
    soidCashDrawerRequireChequeDetailsToBeEntered?: string | undefined;
    soidTransportBookingAllowUse?: string | undefined;
    soidTransportBookingDistanceUnit?: string | undefined;
    soidTransportBookingRequireDistance?: string | undefined;
    soidTransportBookingRequireInstructionsOnPO?: string | undefined;
    soidTransportBookingRequireInstructionsOnSO?: string | undefined;
    soidDisableRemainingCountInFindDocuments?: string | undefined;
    soidDisableRemainingCountInFindObjects?: string | undefined;
    soidWarnIfNoSearchTextEnteredInFindProducts?: string | undefined;
    soidWarnIfNoSearchTextEnteredInFindCustomers?: string | undefined;
    soidAllowLoadAllInPriceRules?: string | undefined;
    soidPoleCommunicationMethod?: string | undefined;
    soidCachedSalesOrderCount?: string | undefined;
    soidPerformanceAllowLoadAllOnJobs?: string | undefined;
    soidEnableGarbageCollection?: string | undefined;
    soidEDICreateImportedProductsForAllBranches?: string | undefined;
    soidEDIUpdateCompanyLevelPricesOnImport?: string | undefined;
    soidElectronicPaymentMethod?: string | undefined;
    soidElectronicPaymentsUsePostalCode?: string | undefined;
    soidWebTrackServicesDefaultLocation?: string | undefined;
    soidNumberOfDigitsOfCardNumberForDisplay?: string | undefined;
    soidElectronicPaymentLoggingLevel?: string | undefined;
    soidElectronicPaymentsUseAVS?: string | undefined;
    soidElectronicPaymentLoginTimeout?: string | undefined;
    soidElectronicPaymentTransactionTimeout?: string | undefined;
    soidbisTrackServicesDefaultLocation?: string | undefined;
    soidWebTrackServicesDefaultKey?: string | undefined;
    soidElectronicPaymentNoLogin?: string | undefined;
    soidEDIUpdatePurchaseOrderCostOnImport?: string | undefined;
    soidElectronicPaymentProviderForPurchasingCards?: string | undefined;
    soidPaymentProviderWebServiceURL?: string | undefined;
    soidEDIUpdateCompanyLevelCostsOnImport?: string | undefined;
    soidEDIRootFolder?: string | undefined;
    soidEDIManualLineTypeAVOPOs?: string | undefined;
    soidEDIAddressCodeForStockOrders?: string | undefined;
    soidEDIStockSalesOrderDocumentFormats?: string | undefined;
    soidEDICustomerSalesOrderDocumentFormats?: string | undefined;
    soidEDIAgentComputerName?: string | undefined;
    soidEDIAutoApproveInternalTradingOrders?: string | undefined;
    soidElectronicPaymentsUseAddress?: string | undefined;
    soidEDIDefaultProductCodeToSKUForProductMaint?: string | undefined;
    soidEDIUpdatePurchaseOrderQuantityOnImport?: string | undefined;
    soidEDIDefaultSupplierInvoiceManualOrderLineType?: string | undefined;
    soidEDIInternalTradingSupplierAtBranchLevel?: string | undefined;
    soidElectronicPaymentsShowWarningWhenCardDontMatchPaymentMethod?: string | undefined;
    soidElectronicPaymentsNoCardAuthenticationOnApprovedTransaction?: string | undefined;
    soidEDIAddLinesOnInboundSupplierInvoiceIfNoProductMatch?: string | undefined;
    soidEDIRequireSupplierProductCodeForOutboundPO?: string | undefined;
    soidEDIAddLinesOnInboundSupplierInvoiceIfPerIsNotMapped?: string | undefined;
    soidEDICheckProductSpecialOrderBehaviourForXpressPOS?: string | undefined;
    soidShift4MerchantID?: string | undefined;
    soidShift4SerialNumber?: string | undefined;
    soidShift4Vendor?: string | undefined;
    soidEDIAllowSelectionOfEDISupplierReferenceOnSalesOrder?: string | undefined;
    soidShift4TokenLongTermStorageDuration?: string | undefined;
    soidShift4CaptureSignatureThresholdAmount?: string | undefined;
    soidShift4TransactionGlobalTimerIntervalInSeconds?: string | undefined;
    soidShift4TransactionReTryTimerIntervalInSeconds?: string | undefined;
    soidShift4APIPassword?: string | undefined;
    soidShift4UserName?: string | undefined;
    soidShift4CreditCardsOnReturnsOnly?: string | undefined;
    soidElectronicPaymentConnectionDelay?: string | undefined;
    soidEDIExportAdditionalChargesAsAllowances?: string | undefined;
    soidEDIExportAVOsAsAllowances?: string | undefined;
    soidShift4i4GoAccountID?: string | undefined;
    soidShift4i4GoSiteID?: string | undefined;
    soidShift4i4GoPassword?: string | undefined;
    soidCommunicateToShift4UTGServersUsingHTTPS?: string | undefined;
    soidEDIEnableDIBBuyingGroupFeatures?: string | undefined;
    soidTenderRetailConnectionTimeoutInSeconds?: string | undefined;
    soidTenderRetailResponseTimeoutInSeconds?: string | undefined;
    soidTenderRetailPositiveAckTimeoutInSeconds?: string | undefined;
    soidGivexUserID?: string | undefined;
    soidGivexPassword?: string | undefined;
    soidShift4SkipSignatureCaptureForCardOnFile?: string | undefined;
    soidShift4EnableSwipeAhead?: string | undefined;
    soidShift4PINPadDisplayDelayInMilliseconds?: string | undefined;
    soidEDIUpdateProductDescriptionOnEDIProductMaintenance?: string | undefined;
    soidEDIUpdateSupplierProductDescriptionOnEDIProductMaintenance?: string | undefined;
    soidShift4TRAllowTokensForSubsequentPaymentsOnSameTransaction?: string | undefined;
    soidDisplayPromoCodeForPrivateLabelCreditCardProcessing?: string | undefined;
    soidEnableBlueTarpElectronicPaymentIntegration?: string | undefined;
    soidShift4i4GoLiveURL?: string | undefined;
    soidShift4i4GoTestURL?: string | undefined;
    soidBlueTarpMerchantID?: string | undefined;
    soidBlueTarpClientKey?: string | undefined;
    soidBlueTarpBaseURL?: string | undefined;
    soidEDIRestrictProductUpdateToDefaultSupplier?: string | undefined;
    soidCollectAirMilesCardDetailsWithPayments?: string | undefined;
    soidAirMilesDefaultOfferCodeForCashSales?: string | undefined;
    soidAirMilesDefaultOfferCodeForCashSalesToChargeAccount?: string | undefined;
    soidAirMilesDefaultOfferCodeForZeroAmountAirMilesTransactions?: string | undefined;
    soidAirMilesDefaultTerminalID?: string | undefined;
    soidAirMilesDefaultServerIPAddress?: string | undefined;
    soidAirMilesDefaultServerPortNumber?: string | undefined;
    soidAirMilesConnectionTimeoutInSeconds?: string | undefined;
    soidAirMilesResponseTimeoutInSeconds?: string | undefined;
    soidShift4UseVoidOnDebitReversal?: string | undefined;
    soidPerformPreAuthWhenBackOrderingSOWithExistingWTPreAuth?: string | undefined;
    soidShift4ReceiptTextWidth?: string | undefined;
    soidShift4AccessMethod?: string | undefined;
    soidEDITemplateManualOrderLine?: string | undefined;
    soidShift4i4GoVersion?: string | undefined;
    soidEDIAPAutomationAttachmentsFolder?: string | undefined;
    soidDoNotDisplayManualCheckboxForShift4ElectronicPayments?: string | undefined;
    soidPreSaveNewSalesOrdersBeforeProcessingShift4ElectronicPayment?: string | undefined;
    soidShift4AllowManualEntryOfVoiceAuthorizations?: string | undefined;
    soidShift4i4GoAccessLiveURL?: string | undefined;
    soidShift4i4GoAccessTestURL?: string | undefined;
    soidShift4i4GoTokenServiceURL?: string | undefined;
    soidShift4i4GoCardSecurityCodeRequired?: string | undefined;
    soidShift4i4GoAcceptedCardTypes?: string | undefined;
    soidShift4i4GoCardholderNamePrompt?: string | undefined;
    soidShift4i4GoStreetAddressPrompt?: string | undefined;
    soidShift4i4GoPostalCodePrompt?: string | undefined;
    soidShift4GetNewLongTermTokenWhenCardOnFileIsUsed?: string | undefined;
    soidShift4UseI4GoAVS?: string | undefined;
    soidShift4i4GoPublicIPServiceURL?: string | undefined;
    soidTenderRetailProcessor?: string | undefined;
    soidShift4VoidOnTimeOut?: string | undefined;
    soidShift4SendTransactionsInAsyncMode?: string | undefined;
    soidAirMilesStandardOfferCodes?: string | undefined;
    soidShift4CreditCardsOnPaymentsOnly?: string | undefined;
    soidTemplateManualOrderLineForAcePromotions?: string | undefined;
    soidAceCustomerLoyaltyLevel?: string | undefined;
    soidACERewardsWebService?: string | undefined;
    soidACERewardsWebServiceUsername?: string | undefined;
    soidACERewardsWebServicePassword?: string | undefined;
    soidUseDefaultCashCustomerForExistingACERewardsCustomers?: string | undefined;
    soidACERewardsCustomerLookupWebService?: string | undefined;
    soidTenderRetailCheckForWinsockErrorAfterSendingPositiveACK?: string | undefined;
    soidACERewardsVerifyCustomerDetailsWhenRequestedByACE?: string | undefined;
    soidEDIAPAutomationProcessTo?: string | undefined;
    soidShift4i4GoCardholderNamePromptInWebTrack?: string | undefined;
    soidShift4i4GoStreetAddressPromptInWebTrack?: string | undefined;
    soidShift4i4GoPostalCodePromptInWebTrack?: string | undefined;
    soidEDIIgnoreBlankOrZeroValuesDuringProductMaintenanceUpdate?: string | undefined;
    soidEDIAttachmentFolderForSOProductImages?: string | undefined;
    soidEDIAPAutomationCreateInvoiceWithoutStockReceipt?: string | undefined;
    soidGiftCardProductForACETypeXPromotions?: string | undefined;
    soidSplitIntegratedCardPaymentMethodByTypeOnAccountPayments?: string | undefined;
    soidEDIAPAutomationCreditNoteAttachmentFolder?: string | undefined;
    soidWebTrackSecondsToWaitForReportServerToReturnDocument?: string | undefined;
    soidWebTrackShift4i4GoAccountID?: string | undefined;
    soidWebTrackShift4i4GoSiteID?: string | undefined;
    soidWebTrackShift4i4GoPassword?: string | undefined;
    soidWebTrackRestrictProdAccessUsingCustWTProdGrps?: string | undefined;
    soidWebTrackShowLocationWithVehicleTracking?: string | undefined;
    soidOrdersEnableMiTekImportFeatures?: string | undefined;
    soidOrdersMiTekImportFolder?: string | undefined;
    soidOrdersImportReferenceDestination?: string | undefined;
    soidNewPerMode?: string | undefined;
    soidNewTaxMode?: string | undefined;
    soidLastLiveOrderID?: string | undefined;
    soidLastLiveSellPriceRuleID?: string | undefined;
    soidNewReportPrintMode?: string | undefined;
    soidNewPriceMode?: string | undefined;
    soidSupplierInvoiceAllowPreEnteredStockReceipts?: string | undefined;
    soidEnablePromptForCrystalParameters?: string | undefined;
    soidUseOrderFilterForSOPSearches?: string | undefined;
    soidNewSearchMode?: string | undefined;
    soidDatabaseUpgrading?: string | undefined;
    soidUseInventoryAgingAndCommissionCosts?: string | undefined;
    soidEnablePerformanceLogging?: string | undefined;
    soidPurchasingInputExchangeRateFromBase?: string | undefined;
    soidUseOldCrystalPrintingMethods?: string | undefined;
    soidShowInternalCostOnProductFind?: string | undefined;
    soidAllowSupplierProductReference?: string | undefined;
    soidEnableScanTrackIntegration?: string | undefined;
    soidJourneyPlanningStyle?: string | undefined;
    soidEnableNewProductFindMode?: string | undefined;
    soidDisableLicensing?: string | undefined;
    soidDisableRebuildStockOnOrderForReceipt?: string | undefined;
    soidCashDrawerRedirectMessageValidity?: string | undefined;
    soidLastProductGroupEdit?: string | undefined;
    soidLastSortedProductGroupUpdate?: string | undefined;
    soidAllowBranchLevelPackOptions?: string | undefined;
    soidUseRecordsetLoadWithNoTransaction?: string | undefined;
    soidAllowMemoQuantityInput?: string | undefined;
    soidJourneyPlannerAllowDeliveredPOs?: string | undefined;
    soidQuickProductsImage1?: string | undefined;
    soidQuickProductsImage2?: string | undefined;
    soidQuickProductsImage3?: string | undefined;
    soidQuickProductsShowImages?: string | undefined;
    soidAllowAuthorizedBuyerByJob?: string | undefined;
    soidEnablePricingPlanner?: string | undefined;
    soidSystemUpgradeEmailAddress?: string | undefined;
    soidEnablePriceChecker?: string | undefined;
    soidEnableBisTrackCount?: string | undefined;
    soidEnableBisTrackReceipt?: string | undefined;
    soidPurchasingCostDebugMode?: string | undefined;
    soidAllowTotalStockAdjustmentOfStockByLengthProducts?: string | undefined;
    soidWorksOrderKeepSameCostIfFinishedInSource?: string | undefined;
    soidPermissionDetailLastUpdateVersion?: string | undefined;
    soidAddSettlementDiscAvailToSalesAndProductAnalysisCubes?: string | undefined;
    soidSalesAnalysisCodeForSettlementDiscAvailInSalesAnalysis?: string | undefined;
    soidPurchaseAnalysisType?: string | undefined;
    soidPurchaseAnalysisDetailStartDate?: string | undefined;
    soidSalesAnalysisCodeToPostSalesDiscountsToInSalesAnalysis?: string | undefined;
    soidPostPromotionDiscountAmountsProratedOverProducts?: string | undefined;
    soidReportServer2AgentPollingInterval?: string | undefined;
    soidReportServer2AgentLoggingLevel?: string | undefined;
    soidReportServer2ProcessEmailedDocuments?: string | undefined;
    soidReportServer2ImageInvoiceFormat?: string | undefined;
    soidReportServer2ImageCreditNoteFormat?: string | undefined;
    soidReportServer2ImageSalesOrderFormat?: string | undefined;
    soidReportServer2ImageInvoiceSTDocType?: string | undefined;
    soidReportServer2ImageCreditNoteSTDocType?: string | undefined;
    soidReportServer2ImageSalesOrderSTDocType?: string | undefined;
    soidReportServer2ImageReleasedFrom?: string | undefined;
    soidReportServer2ImageFileType?: string | undefined;
    soidReportServer2ImageColourDepth?: string | undefined;
    soidReportServer2ImageDPI?: string | undefined;
    soidReportServer2ImageJPGQuality?: string | undefined;
    soidReportServer2ImageTIFCompression?: string | undefined;
    soidReportServer2ImageTIFMultiPage?: string | undefined;
    soidReportServer2ImageTimeTo?: string | undefined;
    soidReportServer2Timeout?: string | undefined;
    soidReportServer2AutoDelInvoiceFormat?: string | undefined;
    soidReportServer2AutoDelInvoiceEmailTemplate?: string | undefined;
    soidReportServer2AutoDelCreditNoteFormat?: string | undefined;
    soidReportServer2AutoDelCreditNoteEmailTemplate?: string | undefined;
    soidReportServer2AutoDelSendTime?: string | undefined;
    soidReportServer2AutoDelDocumentsSince?: string | undefined;
    soidReportServer2AutoDeliveryEnabled?: string | undefined;
    soidDeadProductsCheck?: string | undefined;
    soidDeadProductsIncludeTimber?: string | undefined;
    soidDeadProductsLowUsageCount?: string | undefined;
    soidDeadProductsLowReceiptCount?: string | undefined;
    soidDeadProductsMarkNonStockedIfLowActivityxMonths?: string | undefined;
    soidDeadProductsMarkDeletedIfLowActivityxMonths?: string | undefined;
    soidDeadProductsStandardStockOnly?: string | undefined;
    soidDeadProductsSpecialsDaysAgo?: string | undefined;
    soidReportServer2AutoDelCashInvoiceFormat?: string | undefined;
    soidReportServer2AutoDelCashRefundFormat?: string | undefined;
    soidReportServer2NotificationDeliveryInProgressEmailTemplate?: string | undefined;
    soidReportServer2NotificationDeliveryInProgressFormat?: string | undefined;
    soidReportServer2NotificationOrderDeliveredEmailTemplate?: string | undefined;
    soidReportServer2NotificationOrderDeliveredFormat?: string | undefined;
    soidReportServer2NotificationDeliveryETAEmailTemplate?: string | undefined;
    soidReportServer2NotificationDeliveryETAFormat?: string | undefined;
    soidCRMEventsQuoteAcceptEnable?: string | undefined;
    soidCRMEventsQuoteRejectEnable?: string | undefined;
    soidCRMEventsEmailSentEnable?: string | undefined;
    soidCRMEventsLetterWrittenEnable?: string | undefined;
    soidCRMEventsOrderCreditHoldOnEnable?: string | undefined;
    soidCRMEventsOrderCreditHoldOffEnable?: string | undefined;
    soidCRMEventsAccountOnHoldEnable?: string | undefined;
    soidCRMEventsAccountOffHoldEnable?: string | undefined;
    soidCRMCalendarDayStart?: string | undefined;
    soidCRMCalendarDayEnd?: string | undefined;
    soidCRMCalendarTimeInterval?: string | undefined;
    soidCRMCalendarFollowUpDuration?: string | undefined;
    soidCRMCampaignsDefaultNotepadType?: string | undefined;
    soidCRMEventsCampaignActionComplete?: string | undefined;
    soidItemMessageCreationSubject?: string | undefined;
    soidItemMessageCreationBody?: string | undefined;
    soidItemMessageClosureSubject?: string | undefined;
    soidItemMessageClosureBody?: string | undefined;
    soidItemMessageNotificationSubject?: string | undefined;
    soidItemMessageNotificationBody?: string | undefined;
    soidItemDevSignOffPrompt1?: string | undefined;
    soidItemDevSignOffPrompt2?: string | undefined;
    soidItemDefaultTesterID?: string | undefined;
    soidItemDefaultTesterName?: string | undefined;
    soidItemDefaultTesterTypeOfWorkID?: string | undefined;
    soidItemDefaultTestAnalysisCodeID?: string | undefined;
    soidItemForceProjectEntry?: string | undefined;
    soidItemNotesForNonDevItems?: string | undefined;
    soidItemGenerateCustomerSpecificeItemReferences?: string | undefined;
    soidItemUseBillToItems?: string | undefined;
    soidItemLockTimeTransactionsPreviousToThisDate?: string | undefined;
    soidItemPreventAddEditOfTimeOnClosedCancelledItems?: string | undefined;
    soidSTServerFolder?: string | undefined;
    soidItemAllowEntryOfSeparateChargeableTime?: string | undefined;
    soidItemAllowTimeSheetWeekApproval?: string | undefined;
    soidItemNonDevVersionOptional?: string | undefined;
    soidItemNonDevDefaultPriority?: string | undefined;
    soidItemLockChargingInfoBeforeThisDate?: string | undefined;
    soidItemUseProjectInvoiceApproval?: string | undefined;
    soidEmailServer?: string | undefined;
    soidEmailUsername?: string | undefined;
    soidEmailPassword?: string | undefined;
    soidEmailSenderAddress?: string | undefined;
    soidEmailPort?: string | undefined;
    soidEmailUseSMTPDefaultAsFromAddress?: string | undefined;
    soidEmailUseSMTPDefaultAsSenderAddress?: string | undefined;
    soidEmailUseSMTPReplyToAddress?: string | undefined;
    soidEmailEncryption?: string | undefined;
    soidInstantReleaseKey?: string | undefined;
    soidCloudQuoteDocumentFormatNumber?: string | undefined;
    soidCloudTemplateOrderDocumentFormatNumber?: string | undefined;
    soidCloudCallOffOrderDocumentFormatNumber?: string | undefined;
    soidCloudSalesOrderDocumentFormatNumber?: string | undefined;
    soidCloudInvoiceDocumentFormatNumber?: string | undefined;
    soidCloudCreditNoteDocumentFormatNumber?: string | undefined;
    soidCloudPurchaseOrderDocumentFormatNumber?: string | undefined;
    soidCloudTransferDocumentFormatNumber?: string | undefined;
    soidCloudWorkOrderDocumentFormatNumber?: string | undefined;
    soidCrystalUsePrintLayoutSettings?: string | undefined;
    soidCrystalUseRAS?: string | undefined;
    soidCrystalUseThreading?: string | undefined;
    soidCrystalThreadingTimeout?: string | undefined;
    soidEnableCTI?: string | undefined;
    soidOIGServerAddress?: string | undefined;
    soidOIGIcpIPAddress?: string | undefined;
    soidOIGEventHandlerURL?: string | undefined;
    soidOIGApplicationName?: string | undefined;
    soidOIGApplicationPassword?: string | undefined;
    soidOIGCompanyName?: string | undefined;
    soidOIGLocalPassword?: string | undefined;
    soidCTIProvider?: string | undefined;
    soidCTICustomerDashboard?: string | undefined;
    soidCTISupplierDashboard?: string | undefined;
    soidCTIUserDashboard?: string | undefined;
    soidCTICustomerDashboardDefault?: string | undefined;
    soidCTISupplierDashboardDefault?: string | undefined;
    soidCTIUserDashboardDefault?: string | undefined;
    soidGrahamsDemo?: string | undefined;
    soidSuppliersEnablePermissionsByTab?: string | undefined;
    soidDefaultOrderSingleLengthTalliedLumberQuantityToZero?: string | undefined;
    soidOnlyUseReplacementProductWhenNoStock?: string | undefined;
    soidAllowStockInformationForBranchesWithoutReadAccess?: string | undefined;
    soidLimitProductAddToQtyOnlyMethodOnTransfers?: string | undefined;
    soidBranchAccessLevelRequiredForIssuingBranch?: string | undefined;
    soidEnableWMSProcessing?: string | undefined;
    soidDefaultCollectLaterWMSPickingStatus?: string | undefined;
    soidWMSOutgoingGenerationInProgress?: string | undefined;
    soidEDIPurgeWMSDocumentDays?: string | undefined;
    soidConsolidateLineNotesOnSOConsolidate?: string | undefined;
    soidDefaultExcludeSpecialsOnPricingOption?: string | undefined;
    soidTranferLimitToFinalCostWhenNoReadAccessToSendingBranch?: string | undefined;
    soidDisplayProductPopupOnQuoteAcceptanceAndSalesCopy?: string | undefined;
    soidEnableWMSBackWorksOrders?: string | undefined;
    soidEnableWMSDocumentPrinting?: string | undefined;
    soidWorksOrderDefaultWMSType?: string | undefined;
    soidUpdateSpecialProductDescriptionWithOrderLineDescription?: string | undefined;
    soidCashSalesRequireFullPaymentForCollectLaterNowCompletion?: string | undefined;
    soidDefaultOrderLineAmendReasonForWMSSubstitution?: string | undefined;
    soidWMSSubstitutionRecalculatePrice?: string | undefined;
    soidDisplaySuccessfulConfirmationPopUps?: string | undefined;
    soidConfirmContractSelectionOnSalesOrderCompletion?: string | undefined;
    soidWMSSendReleasedNotProcessedCreditNoteQuantityInQuantitySync?: string | undefined;
    soidEnableWMSBackTransfers?: string | undefined;
    soidEnablePurchaseOrderExcludeFromWMS?: string | undefined;
    soidWMSDoNotSentOrderLineInternalNotes?: string | undefined;
    soidWMSTimberTalliedProductsMustBeSingleLength?: string | undefined;
    soidWMSOrderHeaderLicensePlateUDF?: string | undefined;
    soidShowCubeMeasures?: string | undefined;
    soidDefaultPricingOptionsToPriceProfiles?: string | undefined;
    soidUseNewSalesOrderEntryForm?: string | undefined;
    soidWorksOrderSendMachineGroupToWMS?: string | undefined;
    soidOrdersSendJourneyReferenceToWMS?: string | undefined;
    soidReleaseOrdersForPickingToWMSDaysInAdvance?: string | undefined;
    soidWorksOrderRequireReleaseForManufactureInWMS?: string | undefined;
    soidReleaseWorksOrdersForManufactureToWMSDaysInAdvance?: string | undefined;
    soidGenerateWorkOrdersForIncomingSalesOrders?: string | undefined;
    soidWMSJourneyReferenceLength?: string | undefined;
    soidWMSSendShipCompleteTagForSalesOrders?: string | undefined;
    soidDefaultSalesRepOnTransactionsToTakenByLinkedSalesRep?: string | undefined;
    soidWMSEnableASNTransactions?: string | undefined;
}

export enum SystemOptionResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum VocabularyResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum SystemOptions2 {
    SoidPickingZoneFormatNumber = "soidPickingZoneFormatNumber",
    SoidServerFolder = "soidServerFolder",
    SoidAllowBlankPasswords = "soidAllowBlankPasswords",
    SoidMaximumProductGroupLevels = "soidMaximumProductGroupLevels",
    SoidCubeServerFolder = "soidCubeServerFolder",
    SoidHTMLServerFolder = "soidHTMLServerFolder",
    SoidReportServerFolder = "soidReportServerFolder",
    SoidTemplateServerFolder = "soidTemplateServerFolder",
    SoidTerminalServers = "soidTerminalServers",
    SoidDefaultLabelPrinter = "soidDefaultLabelPrinter",
    SoidAllowBackToBacks = "soidAllowBackToBacks",
    SoidNoOfDocumentFormats = "soidNoOfDocumentFormats",
    SoidShowDetailedPrinterDialogForLabels = "soidShowDetailedPrinterDialogForLabels",
    SoidDefaultCountry = "soidDefaultCountry",
    SoidOrderNumberIncrement = "soidOrderNumberIncrement",
    SoidCompanyName = "soidCompanyName",
    SoidCompanyAddress = "soidCompanyAddress",
    SoidCompanyRegistrationNumber = "soidCompanyRegistrationNumber",
    SoidVATRegistrationNumber = "soidVATRegistrationNumber",
    SoidCompanyCatalogueURL = "soidCompanyCatalogueURL",
    SoidCompanyCatalogueName = "soidCompanyCatalogueName",
    SoidVATValidationURL = "soidVATValidationURL",
    SoidLongRunningProceduresTimeout = "soidLongRunningProceduresTimeout",
    SoidStandardSQLQueryTimeout = "soidStandardSQLQueryTimeout",
    SoidUseReadUnCommittedTransactionIsolationLevel = "soidUseReadUnCommittedTransactionIsolationLevel",
    SoidCrystalReportsVersion = "soidCrystalReportsVersion",
    SoidReportServerVersion = "soidReportServerVersion",
    SoidCrystalReportsAllowIntegratedSecurity = "soidCrystalReportsAllowIntegratedSecurity",
    SoidSQLReportsServerURL = "soidSQLReportsServerURL",
    SoidSQLReportsBuilderVersion = "soidSQLReportsBuilderVersion",
    SoidSQLReportsServerVersion = "soidSQLReportsServerVersion",
    SoidSQLReportsViewerVersion = "soidSQLReportsViewerVersion",
    SoidBaseCurrency = "soidBaseCurrency",
    SoidAlternativeCurrency = "soidAlternativeCurrency",
    SoidDefaultVatRate = "soidDefaultVatRate",
    SoidDefaultCashCustomer = "soidDefaultCashCustomer",
    SoidConsolidateLines = "soidConsolidateLines",
    SoidVatRuleForDeliveryCharge = "soidVatRuleForDeliveryCharge",
    SoidMaximumDimensions = "soidMaximumDimensions",
    SoidAllowSetCustomerOnHold = "soidAllowSetCustomerOnHold",
    SoidDueDateGraceDays = "soidDueDateGraceDays",
    SoidIgnoreSmallBalancesUpTo = "soidIgnoreSmallBalancesUpTo",
    SoidOverdueBalanceChecking = "soidOverdueBalanceChecking",
    SoidCreditControlDisableCreditLimitChecksOnOrders = "soidCreditControlDisableCreditLimitChecksOnOrders",
    SoidCreditControlAllowCashOnCreditHold = "soidCreditControlAllowCashOnCreditHold",
    SoidCreditControlAllowInstantCreditRelease = "soidCreditControlAllowInstantCreditRelease",
    SoidCreditControlPromptForOriginalComputer = "soidCreditControlPromptForOriginalComputer",
    SoidCreditControlAllowCashAccountBalances = "soidCreditControlAllowCashAccountBalances",
    SoidCreditControlOrderChangeTolerance = "soidCreditControlOrderChangeTolerance",
    SoidCreditControlDisableCreditLimitChecksOnOrderAmend = "soidCreditControlDisableCreditLimitChecksOnOrderAmend",
    SoidAllowGreatPlainsMessages = "soidAllowGreatPlainsMessages",
    SoidCreditControlExcludePreviouslyReleasedOrdersFromCheck = "soidCreditControlExcludePreviouslyReleasedOrdersFromCheck",
    SoidCreditControlDisableCreditChecksOnReleasedBackOrders = "soidCreditControlDisableCreditChecksOnReleasedBackOrders",
    SoidCreditControlUseARCustomerForOrderCreditApproval = "soidCreditControlUseARCustomerForOrderCreditApproval",
    SoidCreditControlMaximumSalesOrderValueAmount = "soidCreditControlMaximumSalesOrderValueAmount",
    SoidCreditControlMaximumSalesOrderPercentage = "soidCreditControlMaximumSalesOrderPercentage",
    SoidCreditControlCreditLimitExtensionPercentage = "soidCreditControlCreditLimitExtensionPercentage",
    SoidCreditControlCreditHoldThresholdAmount = "soidCreditControlCreditHoldThresholdAmount",
    SoidCreditControlAllowPaymentOnAccountOnCreditHold = "soidCreditControlAllowPaymentOnAccountOnCreditHold",
    SoidCreditControlMarginHoldOrderChangeTolerance = "soidCreditControlMarginHoldOrderChangeTolerance",
    SoidCustomerFullSyncJobName = "soidCustomerFullSyncJobName",
    SoidCustomerPartialSyncJobName = "soidCustomerPartialSyncJobName",
    SoidSupplierFullSyncJobName = "soidSupplierFullSyncJobName",
    SoidSupplierPartialSyncJobName = "soidSupplierPartialSyncJobName",
    SoidCreditControlPrintDocsAwaitingCustomerApproval = "soidCreditControlPrintDocsAwaitingCustomerApproval",
    SoidDynamicsDatabase = "soidDynamicsDatabase",
    SoidDynamicsServer = "soidDynamicsServer",
    SoidDynamicsUserID = "soidDynamicsUserID",
    SoidFinancialInterfaceFolder = "soidFinancialInterfaceFolder",
    SoidFinancialInterfaceVersion = "soidFinancialInterfaceVersion",
    SoidNavisionCompanyName = "soidNavisionCompanyName",
    SoidNavisionServer = "soidNavisionServer",
    SoidNavisionDatabase = "soidNavisionDatabase",
    SoidNavisionNTAuthentication = "soidNavisionNTAuthentication",
    SoidNavisionUserID = "soidNavisionUserID",
    SoidNavisionShowCFRONTErrors = "soidNavisionShowCFRONTErrors",
    SoidNavisionNetType = "soidNavisionNetType",
    SoidSendDebitNotes = "soidSendDebitNotes",
    SoidSendDebitNotesOnHold = "soidSendDebitNotesOnHold",
    SoidAutoApplyCreditNotes = "soidAutoApplyCreditNotes",
    SoidUseNAVAgent = "soidUseNAVAgent",
    SoidAgentGenerateXMLOnly = "soidAgentGenerateXMLOnly",
    SoidDisallowReExport = "soidDisallowReExport",
    SoidSendDebitNoteAmount = "soidSendDebitNoteAmount",
    SoidNavisionPostingGroupSales = "soidNavisionPostingGroupSales",
    SoidNavisionPostingGroupPurch = "soidNavisionPostingGroupPurch",
    SoidNAVUseSeparateBatches = "soidNAVUseSeparateBatches",
    SoidUseNAVCache = "soidUseNAVCache",
    SoidNAVCacheDatabaseName = "soidNAVCacheDatabaseName",
    SoidCreditControlCustomerReferencePutOrdersOnHold = "soidCreditControlCustomerReferencePutOrdersOnHold",
    SoidCalculateJobCreditLimitFromCustomerReferencePurchaseOrderAmounts = "soidCalculateJobCreditLimitFromCustomerReferencePurchaseOrderAmounts",
    SoidCalculatedJobCreditLimitExtensionPercentage = "soidCalculatedJobCreditLimitExtensionPercentage",
    SoidCalculateInvoiceDueAndDiscountDatesFromDeliveryDate = "soidCalculateInvoiceDueAndDiscountDatesFromDeliveryDate",
    SoidCustomerAgedDebt1 = "soidCustomerAgedDebt1",
    SoidCustomerAgedDebt2 = "soidCustomerAgedDebt2",
    SoidCustomerAgedDebt3 = "soidCustomerAgedDebt3",
    SoidCustomerAgedDebt4 = "soidCustomerAgedDebt4",
    SoidCustomerAgedDebt5 = "soidCustomerAgedDebt5",
    SoidCustomerAgedDebt6 = "soidCustomerAgedDebt6",
    SoidCustomerAgedDebt7 = "soidCustomerAgedDebt7",
    SoidSupplierAgedDebt1 = "soidSupplierAgedDebt1",
    SoidSupplierAgedDebt2 = "soidSupplierAgedDebt2",
    SoidSupplierAgedDebt3 = "soidSupplierAgedDebt3",
    SoidSupplierAgedDebt4 = "soidSupplierAgedDebt4",
    SoidSupplierAgedDebt5 = "soidSupplierAgedDebt5",
    SoidSupplierAgedDebt6 = "soidSupplierAgedDebt6",
    SoidSupplierAgedDebt7 = "soidSupplierAgedDebt7",
    SoidGreatPlainsMessageQueue = "soidGreatPlainsMessageQueue",
    SoidGreatPlainsMessageServer = "soidGreatPlainsMessageServer",
    SoidGreatPlainsPollInterval = "soidGreatPlainsPollInterval",
    SoidGreatPlainsLoggingLevel = "soidGreatPlainsLoggingLevel",
    SoidGreatPlainsCompanyID = "soidGreatPlainsCompanyID",
    SoidGreatPlainsServer = "soidGreatPlainsServer",
    SoidGreatPlainseConnectServer = "soidGreatPlainseConnectServer",
    SoidBankAccountCash = "soidBankAccountCash",
    SoidBankAccountCheque = "soidBankAccountCheque",
    SoidBankAccountCreditCard = "soidBankAccountCreditCard",
    SoidGreatPlainsOutputTo = "soidGreatPlainsOutputTo",
    SoidGreatPlainsARPathFile = "soidGreatPlainsARPathFile",
    SoidGreatPlainsAPPathFile = "soidGreatPlainsAPPathFile",
    SoidGreatPlainsbisTrackServiceServer = "soidGreatPlainsbisTrackServiceServer",
    SoidSalesGLRuleTaxSales = "soidSalesGLRuleTaxSales",
    SoidWriteOffGLRule = "soidWriteOffGLRule",
    SoidFinanceChargeGLRule = "soidFinanceChargeGLRule",
    SoidNSFChargeGLRule = "soidNSFChargeGLRule",
    SoidCashGLCode = "soidCashGLCode",
    SoidChequeGLCode = "soidChequeGLCode",
    SoidCreditCardGLCode = "soidCreditCardGLCode",
    SoidGreatPlainsGLPathFile = "soidGreatPlainsGLPathFile",
    SoidSalesDisableTaxSalesGLRule = "soidSalesDisableTaxSalesGLRule",
    SoidGPDirectUsername = "soidGPDirectUsername",
    SoidGPDirectPassword = "soidGPDirectPassword",
    SoidExtendedNumberFormat = "soidExtendedNumberFormat",
    SoidCreateGLTransactionsStockReceipts = "soidCreateGLTransactionsStockReceipts",
    SoidCreateGLTransactionsStockAdjustment = "soidCreateGLTransactionsStockAdjustment",
    SoidFinancialDepositControl = "soidFinancialDepositControl",
    SoidFinancialUnallocatedCashControl = "soidFinancialUnallocatedCashControl",
    SoidFinancialDepositVatPosting = "soidFinancialDepositVatPosting",
    SoidFinancialUnallocatedVatPosting = "soidFinancialUnallocatedVatPosting",
    SoidbTAAccountCodeMask = "soidbTAAccountCodeMask",
    SoidbTAApplyLateCharges = "soidbTAApplyLateCharges",
    SoidbTAMinLatePaymentCharge = "soidbTAMinLatePaymentCharge",
    SoidbTAAutoWOThreshold = "soidbTAAutoWOThreshold",
    SoidbTALapsedAccountMonths = "soidbTALapsedAccountMonths",
    SoidbTAInactiveAccountMonths = "soidbTAInactiveAccountMonths",
    SoidbTADeletedAccountMonths = "soidbTADeletedAccountMonths",
    SoidbTACustomerAgedBalanceMethod = "soidbTACustomerAgedBalanceMethod",
    SoidbTACustomerApplicationInProcess = "soidbTACustomerApplicationInProcess",
    SoidbTACustomerStatementReportName = "soidbTACustomerStatementReportName",
    SoidbTACustomerInterimStatementReportName = "soidbTACustomerInterimStatementReportName",
    SoidbTAGeneralContractorInfoRequired = "soidbTAGeneralContractorInfoRequired",
    SoidbTACustomerStatementStyle = "soidbTACustomerStatementStyle",
    SoidbTAStatementScannedDocTypeForCollect = "soidbTAStatementScannedDocTypeForCollect",
    SoidbTAStatementScannedDocTypeForDelivered = "soidbTAStatementScannedDocTypeForDelivered",
    SoidbTAStatementSendIntervalInSeconds = "soidbTAStatementSendIntervalInSeconds",
    SoidbTAStatementEmailBodyText = "soidbTAStatementEmailBodyText",
    SoidbTASettDiscToFullAmountWhenMatching = "soidbTASettDiscToFullAmountWhenMatching",
    SoidbTAARBy = "soidbTAARBy",
    SoidbTAStatementScanTrackImagesOnly = "soidbTAStatementScanTrackImagesOnly",
    SoidTransferGLRuleInbound = "soidTransferGLRuleInbound",
    SoidTransferGLRuleOutbound = "soidTransferGLRuleOutbound",
    SoidTransferGLRuleInTransit = "soidTransferGLRuleInTransit",
    SoidTransferGLRuleUpliftCalculated = "soidTransferGLRuleUpliftCalculated",
    SoidTransferGLRuleUpliftInput = "soidTransferGLRuleUpliftInput",
    SoidTransferGLRuleTransferProfit = "soidTransferGLRuleTransferProfit",
    SoidGenericXMLARPathFileName = "soidGenericXMLARPathFileName",
    SoidGenericXMLAPPathFileName = "soidGenericXMLAPPathFileName",
    SoidGenericXMLGLPathFileName = "soidGenericXMLGLPathFileName",
    SoidbTAStatementScannedDocTypeForInvoice = "soidbTAStatementScannedDocTypeForInvoice",
    SoidbTAStatementScannedDocTypeForCredit = "soidbTAStatementScannedDocTypeForCredit",
    SoidbTAStatementImagesDefaultReportName = "soidbTAStatementImagesDefaultReportName",
    SoidbTAStatementImages1upReportName = "soidbTAStatementImages1upReportName",
    SoidbTAStatementImages2upReportName = "soidbTAStatementImages2upReportName",
    SoidbTAStatementImages4upReportName = "soidbTAStatementImages4upReportName",
    SoidbTAPostARGrossAndDiscountAtTimeOfSale = "soidbTAPostARGrossAndDiscountAtTimeOfSale",
    SoidbTACustomerAgedBalancePeriodStyle = "soidbTACustomerAgedBalancePeriodStyle",
    SoidbTAAllowDifferentARCustomerOnCustomerAddress = "soidbTAAllowDifferentARCustomerOnCustomerAddress",
    SoidbTAAllowAccountsPaymentOnJobAddress = "soidbTAAllowAccountsPaymentOnJobAddress",
    SoidbTAAllowEntryOfCustomerRemittanceAdvice = "soidbTAAllowEntryOfCustomerRemittanceAdvice",
    SoidbTACompareByAccountInFES = "soidbTACompareByAccountInFES",
    SoidbtaUseBranchAccessInAccounts = "soidbtaUseBranchAccessInAccounts",
    SoidbTAEmailBodyTextForStatementNotification = "soidbTAEmailBodyTextForStatementNotification",
    SoidbTAIgnoreDiscountDueDateWhenMatchingCreditNotes = "soidbTAIgnoreDiscountDueDateWhenMatchingCreditNotes",
    SoidbTAUseExpectedDetailsCheckingWithBatchCash = "soidbTAUseExpectedDetailsCheckingWithBatchCash",
    SoidbTACustomerAgeCreditNotes = "soidbTACustomerAgeCreditNotes",
    SoidbTACustomerAgeUnappliedCash = "soidbTACustomerAgeUnappliedCash",
    SoidbTAMatchingNewCustomerResetOptions = "soidbTAMatchingNewCustomerResetOptions",
    SoidbTADefaultNewCreditCustomerToOperationalStatus = "soidbTADefaultNewCreditCustomerToOperationalStatus",
    SoidDefaultOrderToCashCustomer = "soidDefaultOrderToCashCustomer",
    SoidDefaultOrderSaleType = "soidDefaultOrderSaleType",
    SoidDefaultOrderPlacementType = "soidDefaultOrderPlacementType",
    SoidDefaultManualOrderLineType = "soidDefaultManualOrderLineType",
    SoidDefaultOrderTestCertOption = "soidDefaultOrderTestCertOption",
    SoidDefaultShowAVOsInUnitPrice = "soidDefaultShowAVOsInUnitPrice",
    SoidPrintDocumentReleaseDelay = "soidPrintDocumentReleaseDelay",
    SoidPrintDocumentReleaseConfirm = "soidPrintDocumentReleaseConfirm",
    SoidDefaultPrintFinalDocOnInvoiceAndCreditRelease = "soidDefaultPrintFinalDocOnInvoiceAndCreditRelease",
    SoidAllowCashOnDelivery = "soidAllowCashOnDelivery",
    SoidStaffNumberTimeout = "soidStaffNumberTimeout",
    SoidDefaultOrdersToNegotiation = "soidDefaultOrdersToNegotiation",
    SoidDefaultOrderQuantityToZero = "soidDefaultOrderQuantityToZero",
    SoidPrintOrderOnCashSales = "soidPrintOrderOnCashSales",
    SoidPurchaseFromOrderRequiredDays = "soidPurchaseFromOrderRequiredDays",
    SoidUseActualSizesForTimberCosts = "soidUseActualSizesForTimberCosts",
    SoidWarnIfDateRequiredNotChanged = "soidWarnIfDateRequiredNotChanged",
    SoidWarnIfDeliveryAddressNotChanged = "soidWarnIfDeliveryAddressNotChanged",
    SoidCheckForExistingQuotes = "soidCheckForExistingQuotes",
    SoidPurchaseOrderNumberDisplayFormat = "soidPurchaseOrderNumberDisplayFormat",
    SoidStockReceiptNumberDisplayFormat = "soidStockReceiptNumberDisplayFormat",
    SoidOrderNumberDisplayFormat = "soidOrderNumberDisplayFormat",
    SoidPickingNoteNumberDisplayFormat = "soidPickingNoteNumberDisplayFormat",
    SoidSubContractNumberDisplayFormat = "soidSubContractNumberDisplayFormat",
    SoidDeliveryNoteNumberDisplayFormat = "soidDeliveryNoteNumberDisplayFormat",
    SoidInvoiceNumberDisplayFormat = "soidInvoiceNumberDisplayFormat",
    SoidCreditNoteNumberDisplayFormat = "soidCreditNoteNumberDisplayFormat",
    SoidCuttingOperationNumberDisplayFormat = "soidCuttingOperationNumberDisplayFormat",
    SoidWorksOrderNumberDisplayFormat = "soidWorksOrderNumberDisplayFormat",
    SoidSupplierInvoiceNumberDisplayFormat = "soidSupplierInvoiceNumberDisplayFormat",
    SoidDebitNoteNumberDisplayFormat = "soidDebitNoteNumberDisplayFormat",
    SoidSupplierCreditNoteNumberDisplayFormat = "soidSupplierCreditNoteNumberDisplayFormat",
    SoidCustomerReturnNumberDisplayFormat = "soidCustomerReturnNumberDisplayFormat",
    SoidJourneyManifestNumberDisplayFormat = "soidJourneyManifestNumberDisplayFormat",
    SoidStockWarningCollectedAlwaysProceed = "soidStockWarningCollectedAlwaysProceed",
    SoidStockWarningNonCollectedAlwaysBackOrder = "soidStockWarningNonCollectedAlwaysBackOrder",
    SoidStockWarningDefaultToProceed = "soidStockWarningDefaultToProceed",
    SoidSupplierReturnNumberDisplayFormat = "soidSupplierReturnNumberDisplayFormat",
    SoidCostAdjustmentNumberDisplayFormat = "soidCostAdjustmentNumberDisplayFormat",
    SoidDropDownListThreshold = "soidDropDownListThreshold",
    SoidDefaultProductTypeSearch = "soidDefaultProductTypeSearch",
    SoidFindFromAvailableStock = "soidFindFromAvailableStock",
    SoidSearchPageSize = "soidSearchPageSize",
    SoidReturnOwnBrandProductsFirst = "soidReturnOwnBrandProductsFirst",
    SoidPriceHistorySize = "soidPriceHistorySize",
    SoidUseCurrentBranchForFindDocuments = "soidUseCurrentBranchForFindDocuments",
    SoidPackBarcodeNumberDisplayFormat = "soidPackBarcodeNumberDisplayFormat",
    SoidAllowLoadAllInAllForProcessing = "soidAllowLoadAllInAllForProcessing",
    SoidStaffNumberTimeoutOperations = "soidStaffNumberTimeoutOperations",
    SoidPickingNoteReprint = "soidPickingNoteReprint",
    SoidSchedulingNumberDisplayFormat = "soidSchedulingNumberDisplayFormat",
    SoidOrderProductsByPriceBookSection = "soidOrderProductsByPriceBookSection",
    SoidDefaultQuoteDays = "soidDefaultQuoteDays",
    SoidDefaultReservationDays = "soidDefaultReservationDays",
    SoidDefaultTemplateOrderQuoteDays = "soidDefaultTemplateOrderQuoteDays",
    SoidProfitAbbreviation = "soidProfitAbbreviation",
    SoidMarginAbbreviation = "soidMarginAbbreviation",
    SoidSuppressCurrencyAndPercentageSymbolsInProfitAndMargin = "soidSuppressCurrencyAndPercentageSymbolsInProfitAndMargin",
    SoidSuppressMarginWarningsWhenPriceRulesUsed = "soidSuppressMarginWarningsWhenPriceRulesUsed",
    SoidSuppressMarginWarningsWhenStandardPriceUsed = "soidSuppressMarginWarningsWhenStandardPriceUsed",
    SoidDefaultMergeProductsOnOrder = "soidDefaultMergeProductsOnOrder",
    SoidDefaultShowDoubleRowsOnOrder = "soidDefaultShowDoubleRowsOnOrder",
    SoidSpecialProductCodePrefix = "soidSpecialProductCodePrefix",
    SoidSpecialProductCodeSuffixLength = "soidSpecialProductCodeSuffixLength",
    SoidCheckForExistingQuotesInAllBranches = "soidCheckForExistingQuotesInAllBranches",
    SoidAlwaysMergeProductsOnQuickAdd = "soidAlwaysMergeProductsOnQuickAdd",
    SoidBillOfMaterialProductCodePrefix = "soidBillOfMaterialProductCodePrefix",
    SoidBillOfMaterialProductCodeSuffixLength = "soidBillOfMaterialProductCodeSuffixLength",
    SoidSpecialGetHowSourcedFromBase = "soidSpecialGetHowSourcedFromBase",
    SoidCheckForExistingQuotesAtLineLevel = "soidCheckForExistingQuotesAtLineLevel",
    SoidbTADefaultTransactionStatusFilter = "soidbTADefaultTransactionStatusFilter",
    SoidbTADirectPostingBatchMode = "soidbTADirectPostingBatchMode",
    SoidbTACreateCaseWhenMarkingInDispute = "soidbTACreateCaseWhenMarkingInDispute",
    SoidbTARequireBatchCashMatchingNoteForUnmatchedCredits = "soidbTARequireBatchCashMatchingNoteForUnmatchedCredits",
    SoidbTAUseMatchDateForStatements = "soidbTAUseMatchDateForStatements",
    SoidbTAAllowWriteOffMoreThanRemainingAmount = "soidbTAAllowWriteOffMoreThanRemainingAmount",
    SoidShowCTLInstructionsWithoutCutFrom = "soidShowCTLInstructionsWithoutCutFrom",
    SoidSuppressMarginWarningsForSpecials = "soidSuppressMarginWarningsForSpecials",
    SoidbTABatchCashMatchingSortOrder = "soidbTABatchCashMatchingSortOrder",
    SoidWorksOrderScheduleNumberDisplayFormat = "soidWorksOrderScheduleNumberDisplayFormat",
    SoidNotepadCaseNumberDisplayFormat = "soidNotepadCaseNumberDisplayFormat",
    SoidStockWarningIncludeOnlyApprovedPurchaseOrdersForAllocation = "soidStockWarningIncludeOnlyApprovedPurchaseOrdersForAllocation",
    SoidbTAAllowUnapplyingTransactionsInClosedFinancialPeriods = "soidbTAAllowUnapplyingTransactionsInClosedFinancialPeriods",
    SoidbTAFinanceChargeDefaultGenerateBy = "soidbTAFinanceChargeDefaultGenerateBy",
    SoidbTACalcFinanceChargesOnFinanceCharges = "soidbTACalcFinanceChargesOnFinanceCharges",
    SoidbTADisplayChildCreditTransactionsOnParentAccounts = "soidbTADisplayChildCreditTransactionsOnParentAccounts",
    SoidStaffNumberBatchProcessingTimeout = "soidStaffNumberBatchProcessingTimeout",
    SoidProductSearchPageSize = "soidProductSearchPageSize",
    SoidProductExplorerPageSize = "soidProductExplorerPageSize",
    SoidCustomerSearchPageSize = "soidCustomerSearchPageSize",
    SoidSupplierSearchPageSize = "soidSupplierSearchPageSize",
    SoidOrderMonitorPageSize = "soidOrderMonitorPageSize",
    SoidJourneyPlannerPageSize = "soidJourneyPlannerPageSize",
    SoidDefaultCreateNewSpecialsOnOrderCopy = "soidDefaultCreateNewSpecialsOnOrderCopy",
    SoidDefaultSectionEndWithSubtotal = "soidDefaultSectionEndWithSubtotal",
    SoidCheckCustomerOnHoldOnPickingAndDelivery = "soidCheckCustomerOnHoldOnPickingAndDelivery",
    SoidCheckCustomerCreditOnPickingAndDelivery = "soidCheckCustomerCreditOnPickingAndDelivery",
    SoidAllowProceedOnPickingAndDeliveryCreditChecks = "soidAllowProceedOnPickingAndDeliveryCreditChecks",
    SoidEnableSteppedFinanceCharge = "soidEnableSteppedFinanceCharge",
    SoidCustomerChequeReferencesRequireCustomer = "soidCustomerChequeReferencesRequireCustomer",
    SoidbTADefaultNewCashCustomerToOperationalStatus = "soidbTADefaultNewCashCustomerToOperationalStatus",
    SoidDefaultTransportType = "soidDefaultTransportType",
    SoidDefaultDeliveryDate = "soidDefaultDeliveryDate",
    SoidInputMaskforDeliveryReference = "soidInputMaskforDeliveryReference",
    SoidEnableUnitPriceDeliveryCharges = "soidEnableUnitPriceDeliveryCharges",
    SoidAutomaticallySendDeliveryNotificationsByEmail = "soidAutomaticallySendDeliveryNotificationsByEmail",
    SoidCalendarStartOfWeek = "soidCalendarStartOfWeek",
    SoidDefaultDateRequiredDays = "soidDefaultDateRequiredDays",
    SoidDefaultDateRequiredOption = "soidDefaultDateRequiredOption",
    SoidDefaultDeliveryTime = "soidDefaultDeliveryTime",
    SoidDefaultDateRequiredToBlankOnQuotes = "soidDefaultDateRequiredToBlankOnQuotes",
    SoidDefaultDateRequiredCutOffTime = "soidDefaultDateRequiredCutOffTime",
    SoidDefaultDateRequiredToBlankOnOrders = "soidDefaultDateRequiredToBlankOnOrders",
    SoidEnableTransactionLocking = "soidEnableTransactionLocking",
    SoidSkipBranchPromptWhenUserHasDefault = "soidSkipBranchPromptWhenUserHasDefault",
    SoidPurchaseOrderCostCalculation = "soidPurchaseOrderCostCalculation",
    SoidSalesOrderCostCalculation = "soidSalesOrderCostCalculation",
    SoidSalesOrderShowVatPercentage = "soidSalesOrderShowVatPercentage",
    SoidSupplierInvoiceToleranceStockPercent = "soidSupplierInvoiceToleranceStockPercent",
    SoidSupplierInvoiceToleranceStockValue = "soidSupplierInvoiceToleranceStockValue",
    SoidSupplierInvoiceToleranceDirectPercent = "soidSupplierInvoiceToleranceDirectPercent",
    SoidSupplierInvoiceToleranceDirectValue = "soidSupplierInvoiceToleranceDirectValue",
    SoidSupplierInvoiceToleranceAdditionalCostPercent = "soidSupplierInvoiceToleranceAdditionalCostPercent",
    SoidSupplierInvoiceToleranceAdditionalCostValue = "soidSupplierInvoiceToleranceAdditionalCostValue",
    SoidDefaultCounterOrderSaleType = "soidDefaultCounterOrderSaleType",
    SoidSupplierInvoiceShowWeight = "soidSupplierInvoiceShowWeight",
    SoidSupplierInvoiceToleranceVatPercent = "soidSupplierInvoiceToleranceVatPercent",
    SoidSupplierInvoiceToleranceVatValue = "soidSupplierInvoiceToleranceVatValue",
    SoidSupplierInvoiceShowVAT = "soidSupplierInvoiceShowVAT",
    SoidSupplierInvoiceCalcSettlementDiscOnCredits = "soidSupplierInvoiceCalcSettlementDiscOnCredits",
    SoidSupplierInvoiceDeliveryText = "soidSupplierInvoiceDeliveryText",
    SoidSupplierInvoicePromptForDeliveryDetails = "soidSupplierInvoicePromptForDeliveryDetails",
    SoidSupplierInvoiceMustChooseGLCode = "soidSupplierInvoiceMustChooseGLCode",
    SoidSupplierInvoiceBlock2ndInvoiceOnDirectOrders = "soidSupplierInvoiceBlock2ndInvoiceOnDirectOrders",
    SoidSupplierInvoiceApproveDirectSalesOrderOnInvoiceApproval = "soidSupplierInvoiceApproveDirectSalesOrderOnInvoiceApproval",
    SoidSupplierInvoiceSetDirectSalesInvoiceDateFromInvoice = "soidSupplierInvoiceSetDirectSalesInvoiceDateFromInvoice",
    SoidOrdersPricingIncludeAdditionalCostInDirectSalesOrderCost = "soidOrdersPricingIncludeAdditionalCostInDirectSalesOrderCost",
    SoidSupplierInvoiceUseSupplierPaymentTerms = "soidSupplierInvoiceUseSupplierPaymentTerms",
    SoidIncludeOnOrderInAvailableStock = "soidIncludeOnOrderInAvailableStock",
    SoidIncludeStockDueInAvailableStock = "soidIncludeStockDueInAvailableStock",
    SoidIncludeThirdPartyInAvailableStock = "soidIncludeThirdPartyInAvailableStock",
    SoidIncludeAwaitingProcessInAvailableStock = "soidIncludeAwaitingProcessInAvailableStock",
    SoidAllocateStockOnBackToBacks = "soidAllocateStockOnBackToBacks",
    SoidAllowUseOfCostRecordAfterValuationDate = "soidAllowUseOfCostRecordAfterValuationDate",
    SoidIncludeAwaitingProcessForOrderOnlyInAvailStock = "soidIncludeAwaitingProcessForOrderOnlyInAvailStock",
    SoidCompanyStockLimitedByUserAccess = "soidCompanyStockLimitedByUserAccess",
    SoidDoNotAllowBackAndForwardDatingThatHarmsCostIntegrity = "soidDoNotAllowBackAndForwardDatingThatHarmsCostIntegrity",
    SoidStockCountAllowTickedStockUpdates = "soidStockCountAllowTickedStockUpdates",
    SoidStockCountAllowBackDatingOfCompletion = "soidStockCountAllowBackDatingOfCompletion",
    SoidStockIncludeLooseAndPackInStockCheckWhenAllocating = "soidStockIncludeLooseAndPackInStockCheckWhenAllocating",
    SoidIncludeStockAllocatedToBackToBackOrderInOnOrderStock = "soidIncludeStockAllocatedToBackToBackOrderInOnOrderStock",
    SoidAllowAddingProductsToTicketedStockCounts = "soidAllowAddingProductsToTicketedStockCounts",
    SoidShowStockInformationInStockCountProductSearches = "soidShowStockInformationInStockCountProductSearches",
    SoidShowActualAndAvailableStockWhenEnteringTicketCounts = "soidShowActualAndAvailableStockWhenEnteringTicketCounts",
    SoidReasonCodeToUseForStockCount = "soidReasonCodeToUseForStockCount",
    SoidCustomerObjectReport = "soidCustomerObjectReport",
    SoidProductObjectReport = "soidProductObjectReport",
    SoidSupplierObjectReport = "soidSupplierObjectReport",
    SoidFinancialInvoiceAuditCustomerReport = "soidFinancialInvoiceAuditCustomerReport",
    SoidFinancialInvoiceAuditSupplierReport = "soidFinancialInvoiceAuditSupplierReport",
    SoidStockPackReconciliationReport = "soidStockPackReconciliationReport",
    SoidCashDrawerReportName = "soidCashDrawerReportName",
    SoidCustomerProductRefObjectReport = "soidCustomerProductRefObjectReport",
    SoidSuggestedPurchaseOrderDetailReport = "soidSuggestedPurchaseOrderDetailReport",
    SoidStockValuationNegativeStockReportName = "soidStockValuationNegativeStockReportName",
    SoidStockValuationReceivedNotInvoicedReportName = "soidStockValuationReceivedNotInvoicedReportName",
    SoidStockValuationPaidNotReceivedReportName = "soidStockValuationPaidNotReceivedReportName",
    SoidStockValuationIssuedNotInvoicedReportName = "soidStockValuationIssuedNotInvoicedReportName",
    SoidStockValuationInvoicedNotIssuedReportName = "soidStockValuationInvoicedNotIssuedReportName",
    SoidStockValuationPaidNotDeliveredReportName = "soidStockValuationPaidNotDeliveredReportName",
    SoidStockValuationTransferSentNotreceivedReportName = "soidStockValuationTransferSentNotreceivedReportName",
    SoidScansUseDocReadPermissions = "soidScansUseDocReadPermissions",
    SoidReportsAccruedPurchaseDetailSupplierCredits = "soidReportsAccruedPurchaseDetailSupplierCredits",
    SoidDashboardRefreshInterval = "soidDashboardRefreshInterval",
    SoidDashboardOperationsFilename = "soidDashboardOperationsFilename",
    SoidDashboardSystemManagerFilename = "soidDashboardSystemManagerFilename",
    SoidDashboardFigures = "soidDashboardFigures",
    SoidDashboardOrderingBranch = "soidDashboardOrderingBranch",
    SoidDashBoardEnableFlowLayouts = "soidDashBoardEnableFlowLayouts",
    SoidDataRuleDataSetXML = "soidDataRuleDataSetXML",
    SoidPerformanceMonitorShowProfit = "soidPerformanceMonitorShowProfit",
    SoidPerformanceMonitorUseInternalCosts = "soidPerformanceMonitorUseInternalCosts",
    SoidDefaultCustomerVATRule = "soidDefaultCustomerVATRule",
    SoidDefaultProductVATRule = "soidDefaultProductVATRule",
    SoidCalculateVATOnGoodsLessDiscount = "soidCalculateVATOnGoodsLessDiscount",
    SoidCalculateVATTaxAtTotalLevel = "soidCalculateVATTaxAtTotalLevel",
    SoidCalculateTaxBasedOnBranchTaxArea = "soidCalculateTaxBasedOnBranchTaxArea",
    SoidVatRateForAutomaticUplift = "soidVatRateForAutomaticUplift",
    SoidCalculateSettlementAtTotalLevel = "soidCalculateSettlementAtTotalLevel",
    SoidVatRateForAutomaticLineCharge = "soidVatRateForAutomaticLineCharge",
    SoidEnableNonDiscountableAmount = "soidEnableNonDiscountableAmount",
    SoidVatRateForExportSales = "soidVatRateForExportSales",
    SoidUseWashingtonStateTaxRateValidation = "soidUseWashingtonStateTaxRateValidation",
    SoidRequireTaxVerificationOnDeliveredSalesOrders = "soidRequireTaxVerificationOnDeliveredSalesOrders",
    SoidUseDefaultJobAddressTaxAreaForCustomerDefault = "soidUseDefaultJobAddressTaxAreaForCustomerDefault",
    SoidCalculateTaxOnCostMinusWorksOrderAVOCost = "soidCalculateTaxOnCostMinusWorksOrderAVOCost",
    SoidUseIssuingBranchTaxArea = "soidUseIssuingBranchTaxArea",
    SoidSalesTaxCalculationMethod = "soidSalesTaxCalculationMethod",
    SoidUseBranchTaxAreaForCustomerDefault = "soidUseBranchTaxAreaForCustomerDefault",
    SoidSendFullAddressInfoInWashingtonStateTaxRateValidation = "soidSendFullAddressInfoInWashingtonStateTaxRateValidation",
    SoidWashingtonStateTaxRateURL = "soidWashingtonStateTaxRateURL",
    SoidFinancialStockValuationCostType = "soidFinancialStockValuationCostType",
    SoidFinancialReferenceRequiredOnCheckPayment = "soidFinancialReferenceRequiredOnCheckPayment",
    SoidInputMaskForChequeReference = "soidInputMaskForChequeReference",
    SoidPreventUseOfNewJournalNumberOnReExport = "soidPreventUseOfNewJournalNumberOnReExport",
    SoidUseFiscalCalendarToControlPostingDates = "soidUseFiscalCalendarToControlPostingDates",
    SoidSearchHistoryRecordsInFinancialPackage = "soidSearchHistoryRecordsInFinancialPackage",
    SoidUpdateDailySalesAnalysisTable = "soidUpdateDailySalesAnalysisTable",
    SoidChequeGuaranteeCardNumberRequired = "soidChequeGuaranteeCardNumberRequired",
    SoidAuthorisationCodeOrderValueThreshold = "soidAuthorisationCodeOrderValueThreshold",
    SoidSendSeparateBatchForEachBranchGLCode = "soidSendSeparateBatchForEachBranchGLCode",
    SoidRetainOrigExchangeRateOnSOAndPO = "soidRetainOrigExchangeRateOnSOAndPO",
    SoidEnableGLCodeValidation = "soidEnableGLCodeValidation",
    SoidFinancialGPbTGeneratesJournalEntryNumber = "soidFinancialGPbTGeneratesJournalEntryNumber",
    SoidFinancialGPMinbTJournalEntryNumber = "soidFinancialGPMinbTJournalEntryNumber",
    SoidFinancialGPMaxbTJournalEntryNumber = "soidFinancialGPMaxbTJournalEntryNumber",
    SoidPostSalesAndCOGSWhenUsingIssuingBranchTo = "soidPostSalesAndCOGSWhenUsingIssuingBranchTo",
    SoidEnableIntercompanyDistribution = "soidEnableIntercompanyDistribution",
    SoidEpicorTaxConnectAccountNumber = "soidEpicorTaxConnectAccountNumber",
    SoidEpicorTaxConnectLicenseKey = "soidEpicorTaxConnectLicenseKey",
    SoidEpicorTaxConnectWebAddress = "soidEpicorTaxConnectWebAddress",
    SoidTaxToUseForEpicorTaxConnectTaxes = "soidTaxToUseForEpicorTaxConnectTaxes",
    SoidEpicorTaxConnectCompanyCode = "soidEpicorTaxConnectCompanyCode",
    SoidGenericXMLFinancialExportMethod = "soidGenericXMLFinancialExportMethod",
    SoidSettDiscAllowedWhenMatchedToCreditCardPayments = "soidSettDiscAllowedWhenMatchedToCreditCardPayments",
    SoidSettDiscAllowedWhenMatchedToACHPayments = "soidSettDiscAllowedWhenMatchedToACHPayments",
    SoidNoOfSellingBands = "soidNoOfSellingBands",
    SoidUsePriceRulesForSpecials = "soidUsePriceRulesForSpecials",
    SoidDeliveryCriteriaPrecedence1 = "soidDeliveryCriteriaPrecedence1",
    SoidDeliveryCriteriaPrecedence2 = "soidDeliveryCriteriaPrecedence2",
    SoidDeliveryCriteriaPrecedence3 = "soidDeliveryCriteriaPrecedence3",
    SoidDeliveryCriteriaPrecedence4 = "soidDeliveryCriteriaPrecedence4",
    SoidUseStandardBuyCostForSpecials = "soidUseStandardBuyCostForSpecials",
    SoidRebateIDRequiredForRebateAccruals = "soidRebateIDRequiredForRebateAccruals",
    SoidPricingDefaultCompanyLevelPriceChange = "soidPricingDefaultCompanyLevelPriceChange",
    SoidPricingUseOldCompanyPriceAsOldAmount = "soidPricingUseOldCompanyPriceAsOldAmount",
    SoidSigmaNESTEnableIntegration = "soidSigmaNESTEnableIntegration",
    SoidSigmaNESTWorkOrderAttachmentFolder = "soidSigmaNESTWorkOrderAttachmentFolder",
    SoidSigmaNESTWorkOrderAttachmentFilename = "soidSigmaNESTWorkOrderAttachmentFilename",
    SoidSigmaNESTWorkOrderAttachmentOrigin = "soidSigmaNESTWorkOrderAttachmentOrigin",
    SoidDontCalculateSellingPriceWhenAddingProductWithZeroQuantity = "soidDontCalculateSellingPriceWhenAddingProductWithZeroQuantity",
    SoidSupplierInvoiceConfirmZeroTax = "soidSupplierInvoiceConfirmZeroTax",
    SoidSupplierInvoiceAllowAlternateCreditor = "soidSupplierInvoiceAllowAlternateCreditor",
    SoidSupplierInvoiceAutoCalcSettlementDiscOnInvoices = "soidSupplierInvoiceAutoCalcSettlementDiscOnInvoices",
    SoidSupplierInvoiceIncludeCostOnDirectLineDescription = "soidSupplierInvoiceIncludeCostOnDirectLineDescription",
    SoidSupplierInvoiceEnablePostingDate = "soidSupplierInvoiceEnablePostingDate",
    SoidSupplierInvoiceAutoSelectPostingDate = "soidSupplierInvoiceAutoSelectPostingDate",
    SoidSupplierInvoiceOnlyExportDiscountsNotEqualToZero = "soidSupplierInvoiceOnlyExportDiscountsNotEqualToZero",
    SoidSupplierInvoiceCanadianTaxInput = "soidSupplierInvoiceCanadianTaxInput",
    SoidSupplierInvoiceShowSupplierProductCode = "soidSupplierInvoiceShowSupplierProductCode",
    SoidSupplierInvoiceAllowZeroTotalInvoices = "soidSupplierInvoiceAllowZeroTotalInvoices",
    SoidSupplierInvoiceDisplayExpectedCostsFromPO = "soidSupplierInvoiceDisplayExpectedCostsFromPO",
    SoidSupplierInvoiceEnableWorkflow = "soidSupplierInvoiceEnableWorkflow",
    SoidSupplierInvoiceShowBrowseForGLSubCodeThreshold = "soidSupplierInvoiceShowBrowseForGLSubCodeThreshold",
    SoidSupplierInvoiceRestrictWorkflowMessagesToSingleRecipient = "soidSupplierInvoiceRestrictWorkflowMessagesToSingleRecipient",
    SoidSupplierInvoiceGPIncludePOSupplierCodeWhenAlternativeCreditor = "soidSupplierInvoiceGPIncludePOSupplierCodeWhenAlternativeCreditor",
    SoidSupplierInvoiceRequireWorkflowMessageRecipient = "soidSupplierInvoiceRequireWorkflowMessageRecipient",
    SoidSupplierCreditRequiresReasonCode = "soidSupplierCreditRequiresReasonCode",
    SoidSupplierInvoicePrintBarcodeLabelOnMatchOrMatchAndApprove = "soidSupplierInvoicePrintBarcodeLabelOnMatchOrMatchAndApprove",
    SoidSupplierInvoiceAllowMatchingDirectSupplierInvoiceWhenPaymentOutstanding = "soidSupplierInvoiceAllowMatchingDirectSupplierInvoiceWhenPaymentOutstanding",
    SoidSupplierInvoiceSendOtherRefAsPONumberToGPForOverheadSIs = "soidSupplierInvoiceSendOtherRefAsPONumberToGPForOverheadSIs",
    SoidSupplierInvoiceSkipMsgsWhenMatchingApproving = "soidSupplierInvoiceSkipMsgsWhenMatchingApproving",
    SoidSupplierInvoiceBranchSelectionType = "soidSupplierInvoiceBranchSelectionType",
    SoidSupplierInvoiceCalculateGoodsTotalOnOverheadInvoicesWithNoPurchaseOrder = "soidSupplierInvoiceCalculateGoodsTotalOnOverheadInvoicesWithNoPurchaseOrder",
    SoidNavisionUseIssuingBranchForDimension = "soidNavisionUseIssuingBranchForDimension",
    SoidLoyaltyCurrencyToPointExchangeRate = "soidLoyaltyCurrencyToPointExchangeRate",
    SoidLoyaltyOrderEntryPromptPointMinimum = "soidLoyaltyOrderEntryPromptPointMinimum",
    SoidLoyaltyRedeemManualOrderLineType = "soidLoyaltyRedeemManualOrderLineType",
    SoidLoyaltyRepeatRewardsMOLT = "soidLoyaltyRepeatRewardsMOLT",
    SoidDefaultSystemToImperial = "soidDefaultSystemToImperial",
    SoidWeightPer = "soidWeightPer",
    SoidWeightDecimalPlaces = "soidWeightDecimalPlaces",
    SoidQuotePickDocumentReleaseFormat = "soidQuotePickDocumentReleaseFormat",
    SoidDepartmentUsage = "soidDepartmentUsage",
    SoidDefaultDepartmentUsageDepartment = "soidDefaultDepartmentUsageDepartment",
    SoidGeneralEnableReportingCost = "soidGeneralEnableReportingCost",
    SoidAllowManualAdjustmentOfVolumeOnAdditionalCostProrations = "soidAllowManualAdjustmentOfVolumeOnAdditionalCostProrations",
    SoidShowJobReferenceInLists = "soidShowJobReferenceInLists",
    SoidAllowMultipleOrderReferenceMasks = "soidAllowMultipleOrderReferenceMasks",
    SoidLimitSellAndBuyPriceChangesToBranchWithUpdateAccess = "soidLimitSellAndBuyPriceChangesToBranchWithUpdateAccess",
    SoidGeneralEnableNotepadNotifications = "soidGeneralEnableNotepadNotifications",
    SoidGeneralValidateDefaultRefOnCustomerAddress = "soidGeneralValidateDefaultRefOnCustomerAddress",
    SoidLimitRelatedDocsBasedOnBranchAccess = "soidLimitRelatedDocsBasedOnBranchAccess",
    SoidVerifyInternalGiftCardsAgainstLoadedGiftCardList = "soidVerifyInternalGiftCardsAgainstLoadedGiftCardList",
    SoidSetDepartmentOnOrdersDuringCreation = "soidSetDepartmentOnOrdersDuringCreation",
    SoidUpdateTransactionLineManualDescriptionWithSpecialProductDescription = "soidUpdateTransactionLineManualDescriptionWithSpecialProductDescription",
    SoidDefaultCustomerNotepadTypeFilterFromUserOption = "soidDefaultCustomerNotepadTypeFilterFromUserOption",
    SoidDepartmentOnAccountPaymentsWhereDepartmentUsageIsSalesRepOrComputer = "soidDepartmentOnAccountPaymentsWhereDepartmentUsageIsSalesRepOrComputer",
    SoidDepartmentOnCashDrawerLodgementsWhereDepartmentUsageIsSalesRepOrComputer = "soidDepartmentOnCashDrawerLodgementsWhereDepartmentUsageIsSalesRepOrComputer",
    SoidPricingPlannerSmartView1 = "soidPricingPlannerSmartView1",
    SoidPricingPlannerSmartView2 = "soidPricingPlannerSmartView2",
    SoidPricingPlannerSmartView3 = "soidPricingPlannerSmartView3",
    SoidPricingPlannerSmartView4 = "soidPricingPlannerSmartView4",
    SoidPricingPlannerSmartView5 = "soidPricingPlannerSmartView5",
    SoidWorksOrderSpecifyFinQtyWhenConfirmSourcePacks = "soidWorksOrderSpecifyFinQtyWhenConfirmSourcePacks",
    SoidPurchasingLimitFindProdToSupplier = "soidPurchasingLimitFindProdToSupplier",
    SoidPurchasingAllowApprovalIfCreditProblem = "soidPurchasingAllowApprovalIfCreditProblem",
    SoidPurchasingAutoApproveDirectOrders = "soidPurchasingAutoApproveDirectOrders",
    SoidPurchaseOrderSecondaryCostCalculation = "soidPurchaseOrderSecondaryCostCalculation",
    SoidPurchasingAutoApproveBackToBackOrders = "soidPurchasingAutoApproveBackToBackOrders",
    SoidPurchasingRoundToInnerOuterPallet = "soidPurchasingRoundToInnerOuterPallet",
    SoidPurchasingInputGLCodeOnOverheadAdvanced = "soidPurchasingInputGLCodeOnOverheadAdvanced",
    SoidPurchasingWarnWhenNotPrimarySupplier = "soidPurchasingWarnWhenNotPrimarySupplier",
    SoidPurchasingAutoPrintDirectOrders = "soidPurchasingAutoPrintDirectOrders",
    SoidPurchasingAutoPrintBackToBackOrders = "soidPurchasingAutoPrintBackToBackOrders",
    SoidPurchasingPopulateAnalysisCodeOnGeneratedPO = "soidPurchasingPopulateAnalysisCodeOnGeneratedPO",
    SoidPurchasingCopyCostPerFromDirectOrBackToBack = "soidPurchasingCopyCostPerFromDirectOrBackToBack",
    SoidPurchasingAllowCostQtyChangeAfterStockReceipt = "soidPurchasingAllowCostQtyChangeAfterStockReceipt",
    SoidPurchasingCostToleranceWarning = "soidPurchasingCostToleranceWarning",
    SoidPurchasingWarnIfNotInnerOuterPalletMultiple = "soidPurchasingWarnIfNotInnerOuterPalletMultiple",
    SoidPurchasingAllowPrintingUnapprovedPurchaseOrders = "soidPurchasingAllowPrintingUnapprovedPurchaseOrders",
    SoidPurchaseOrderCallOffAutoComplete = "soidPurchaseOrderCallOffAutoComplete",
    SoidPurchasingShowAndAllowUpdateOfStandardBuyPrice = "soidPurchasingShowAndAllowUpdateOfStandardBuyPrice",
    SoidPurchasingDefaultAnalysisCodeOnGenerateFromAVO = "soidPurchasingDefaultAnalysisCodeOnGenerateFromAVO",
    SoidPurchasingShowCustomerOnInternalNotes = "soidPurchasingShowCustomerOnInternalNotes",
    SoidPurchasingDefaultInputPerToSupplierBuyPer = "soidPurchasingDefaultInputPerToSupplierBuyPer",
    SoidPurchasingDisplayCompletionButtonsOnPO = "soidPurchasingDisplayCompletionButtonsOnPO",
    SoidPurchasingDisplayCreatePOOnAddCostChargeOnXfers = "soidPurchasingDisplayCreatePOOnAddCostChargeOnXfers",
    SoidPurchasingAlwaysUseOverriddenDimsOnAddCosts = "soidPurchasingAlwaysUseOverriddenDimsOnAddCosts",
    SoidPurchasingApplyEnvironmentalStatusRestrictions = "soidPurchasingApplyEnvironmentalStatusRestrictions",
    SoidPurchasingAllowChangingUnitCostForCostControlledItems = "soidPurchasingAllowChangingUnitCostForCostControlledItems",
    SoidGenerateCallOffPOForDirectSO = "soidGenerateCallOffPOForDirectSO",
    SoidPurchasingPromptForSellPriceWhenDirectCostChanged = "soidPurchasingPromptForSellPriceWhenDirectCostChanged",
    SoidPurchasingKeepDateRequiredInSynchForDirects = "soidPurchasingKeepDateRequiredInSynchForDirects",
    SoidPurchasingCheckForCallOffs = "soidPurchasingCheckForCallOffs",
    SoidPurchasingSetDefaultStockLocation = "soidPurchasingSetDefaultStockLocation",
    SoidPurchasingPurchaseOrderChangeApprovalThreshold = "soidPurchasingPurchaseOrderChangeApprovalThreshold",
    SoidPurchasingUseLeadTimeToSetPOLineDateExpected = "soidPurchasingUseLeadTimeToSetPOLineDateExpected",
    SoidIncludeOrderLineLinksForSOItemsOnWMSPOs = "soidIncludeOrderLineLinksForSOItemsOnWMSPOs",
    SoidPurchasingPromptForBuyPriceRuleSelection = "soidPurchasingPromptForBuyPriceRuleSelection",
    SoidGLCodeSelectionMethodForMOLTsOnOverheadPO = "soidGLCodeSelectionMethodForMOLTsOnOverheadPO",
    SoidCentralizedPurchasingIncludesSourcedByTransfer = "soidCentralizedPurchasingIncludesSourcedByTransfer",
    SoidSuggestedOrdersSmartView1 = "soidSuggestedOrdersSmartView1",
    SoidSuggestedOrdersSmartView2 = "soidSuggestedOrdersSmartView2",
    SoidSuggestedOrdersSmartView3 = "soidSuggestedOrdersSmartView3",
    SoidSuggestedOrdersSmartView4 = "soidSuggestedOrdersSmartView4",
    SoidSuggestedOrdersSmartView5 = "soidSuggestedOrdersSmartView5",
    SoidSuggestedOrdersAdjustByStockClass = "soidSuggestedOrdersAdjustByStockClass",
    SoidDefaultPurchaseAnalysisCodeOnOverheadPOs = "soidDefaultPurchaseAnalysisCodeOnOverheadPOs",
    SoidPurchasingUseSecondaryCostWhenPrimaryCostValueIsZero = "soidPurchasingUseSecondaryCostWhenPrimaryCostValueIsZero",
    SoidPurchasingShow15LevelsForAutoAverageCostAdjRule = "soidPurchasingShow15LevelsForAutoAverageCostAdjRule",
    SoidRetainRaisedByInformationWhenConvertingPOToADirect = "soidRetainRaisedByInformationWhenConvertingPOToADirect",
    SoidApplyFixedAmountManualLinesAndAdditionalCostsToAllStockReceipts = "soidApplyFixedAmountManualLinesAndAdditionalCostsToAllStockReceipts",
    SoidPurchasingSetMOLTDescriptionToGLCodeDescriptionOnOverheadPO = "soidPurchasingSetMOLTDescriptionToGLCodeDescriptionOnOverheadPO",
    SoidPurchasingAutoPrintLabels = "soidPurchasingAutoPrintLabels",
    SoidPurchasingShowSupplierPopupForAutomaticPurchaseOrders = "soidPurchasingShowSupplierPopupForAutomaticPurchaseOrders",
    SoidSuggestedOrderingIncludeAllOpenPurchaseOrders = "soidSuggestedOrderingIncludeAllOpenPurchaseOrders",
    SoidFindDocPreviewPaneSmartViewSO1 = "soidFindDocPreviewPaneSmartViewSO1",
    SoidFindDocPreviewPaneSmartViewSO2 = "soidFindDocPreviewPaneSmartViewSO2",
    SoidFindDocPreviewPaneSmartViewSO3 = "soidFindDocPreviewPaneSmartViewSO3",
    SoidFindDocPreviewPaneSmartViewSO4 = "soidFindDocPreviewPaneSmartViewSO4",
    SoidFindDocPreviewPaneSmartViewSO5 = "soidFindDocPreviewPaneSmartViewSO5",
    SoidFindDocPreviewPaneSmartViewQU1 = "soidFindDocPreviewPaneSmartViewQU1",
    SoidFindDocPreviewPaneSmartViewQU2 = "soidFindDocPreviewPaneSmartViewQU2",
    SoidFindDocPreviewPaneSmartViewQU3 = "soidFindDocPreviewPaneSmartViewQU3",
    SoidFindDocPreviewPaneSmartViewQU4 = "soidFindDocPreviewPaneSmartViewQU4",
    SoidFindDocPreviewPaneSmartViewQU5 = "soidFindDocPreviewPaneSmartViewQU5",
    SoidFindDocPreviewPaneSmartViewCO1 = "soidFindDocPreviewPaneSmartViewCO1",
    SoidFindDocPreviewPaneSmartViewCO2 = "soidFindDocPreviewPaneSmartViewCO2",
    SoidFindDocPreviewPaneSmartViewCO3 = "soidFindDocPreviewPaneSmartViewCO3",
    SoidFindDocPreviewPaneSmartViewCO4 = "soidFindDocPreviewPaneSmartViewCO4",
    SoidFindDocPreviewPaneSmartViewCO5 = "soidFindDocPreviewPaneSmartViewCO5",
    SoidFindDocPreviewPaneSmartViewPO1 = "soidFindDocPreviewPaneSmartViewPO1",
    SoidFindDocPreviewPaneSmartViewPO2 = "soidFindDocPreviewPaneSmartViewPO2",
    SoidFindDocPreviewPaneSmartViewPO3 = "soidFindDocPreviewPaneSmartViewPO3",
    SoidFindDocPreviewPaneSmartViewPO4 = "soidFindDocPreviewPaneSmartViewPO4",
    SoidFindDocPreviewPaneSmartViewPO5 = "soidFindDocPreviewPaneSmartViewPO5",
    SoidFindDocPreviewPaneSmartViewCN1 = "soidFindDocPreviewPaneSmartViewCN1",
    SoidFindDocPreviewPaneSmartViewCN2 = "soidFindDocPreviewPaneSmartViewCN2",
    SoidFindDocPreviewPaneSmartViewCN3 = "soidFindDocPreviewPaneSmartViewCN3",
    SoidFindDocPreviewPaneSmartViewCN4 = "soidFindDocPreviewPaneSmartViewCN4",
    SoidFindDocPreviewPaneSmartViewCN5 = "soidFindDocPreviewPaneSmartViewCN5",
    SoidSalesOrderAllowChangeCurrencies = "soidSalesOrderAllowChangeCurrencies",
    SoidSalesOrderChangeTakenBy = "soidSalesOrderChangeTakenBy",
    SoidSalesOrderForceSupplierReview = "soidSalesOrderForceSupplierReview",
    SoidSalesOrderWarnIfDirectCostNotChanged = "soidSalesOrderWarnIfDirectCostNotChanged",
    SoidSalesOrderMaximumReservationDays = "soidSalesOrderMaximumReservationDays",
    SoidSalesOrderAllowDirectSalesInCounterSales = "soidSalesOrderAllowDirectSalesInCounterSales",
    SoidSalesOrderOnlyApproveIssuedOrders = "soidSalesOrderOnlyApproveIssuedOrders",
    SoidSalesOrderParkedOrderFormats = "soidSalesOrderParkedOrderFormats",
    SoidSalesOrderWaitForNewStockOnBackOrder = "soidSalesOrderWaitForNewStockOnBackOrder",
    SoidSalesOrderWarnIfOrderLinePriceIsZero = "soidSalesOrderWarnIfOrderLinePriceIsZero",
    SoidSalesOrderDeliveryAreaRequired = "soidSalesOrderDeliveryAreaRequired",
    SoidSalesOrderAllowCashBackOnCashSales = "soidSalesOrderAllowCashBackOnCashSales",
    SoidSalesOrderMaintainTakenByFromOriginalOrderOnBackOrder = "soidSalesOrderMaintainTakenByFromOriginalOrderOnBackOrder",
    SoidMarkOrderApprovedWhenStockIssued = "soidMarkOrderApprovedWhenStockIssued",
    SoidDefaultSpecialOrderQtyChangeToCreateBackOrder = "soidDefaultSpecialOrderQtyChangeToCreateBackOrder",
    SoidOrdersSuppressStockUpdatesDuringEntry = "soidOrdersSuppressStockUpdatesDuringEntry",
    SoidOrdersProductCodeColumnContent = "soidOrdersProductCodeColumnContent",
    SoidOrdersReserveStockOnCallOff = "soidOrdersReserveStockOnCallOff",
    SoidOrdersAutoApplyDeliveryCharges = "soidOrdersAutoApplyDeliveryCharges",
    SoidOrdersDisplayCommissionCode = "soidOrdersDisplayCommissionCode",
    SoidOrdersForceSupplierToBeChangedWhenSupplierIs = "soidOrdersForceSupplierToBeChangedWhenSupplierIs",
    SoidSignatureCaptureCollectNow = "soidSignatureCaptureCollectNow",
    SoidSignatureCaptureCollectLater = "soidSignatureCaptureCollectLater",
    SoidOrdersShowBinLocationFromSROnSOLine = "soidOrdersShowBinLocationFromSROnSOLine",
    SoidOrderExcludeParkedOrdersFromOnOrderBalance = "soidOrderExcludeParkedOrdersFromOnOrderBalance",
    SoidOrdersDisplayStockLocationOnOrderEntry = "soidOrdersDisplayStockLocationOnOrderEntry",
    SoidOrdersDefaultVehicleType = "soidOrdersDefaultVehicleType",
    SoidOrdersDefaultOrderMonitorToAllBranches = "soidOrdersDefaultOrderMonitorToAllBranches",
    SoidOrdersDefaultSellPriceFromParentNATally = "soidOrdersDefaultSellPriceFromParentNATally",
    SoidOrdersDefaultCustomerSearchOnOrdersToAddress = "soidOrdersDefaultCustomerSearchOnOrdersToAddress",
    SoidOrdersManualLineDeliveryChargeExclusionCode = "soidOrdersManualLineDeliveryChargeExclusionCode",
    SoidOrdersDisplayTotalCostInOrderTotals = "soidOrdersDisplayTotalCostInOrderTotals",
    SoidOrdersAutoApplyRebateAccruals = "soidOrdersAutoApplyRebateAccruals",
    SoidOrdersDisplayNegWarningOnGeneral = "soidOrdersDisplayNegWarningOnGeneral",
    SoidOrdersAllowOverrideOfRebateSaleType = "soidOrdersAllowOverrideOfRebateSaleType",
    SoidOrdersOnlyCalcTransferCostForBranchesWithStock = "soidOrdersOnlyCalcTransferCostForBranchesWithStock",
    SoidOrdersEnableMultipleBranches = "soidOrdersEnableMultipleBranches",
    SoidOrdersMixedBranchRestrictions = "soidOrdersMixedBranchRestrictions",
    SoidOrdersAllowMixedSaleTypesOnOrders = "soidOrdersAllowMixedSaleTypesOnOrders",
    SoidOrdersEnterAddressViaForm = "soidOrdersEnterAddressViaForm",
    SoidOrdersCallOffAllowCreateSOFromMultipleCallOffs = "soidOrdersCallOffAllowCreateSOFromMultipleCallOffs",
    SoidOrdersEnableCollectNow = "soidOrdersEnableCollectNow",
    SoidOrdersEnableCollectLater = "soidOrdersEnableCollectLater",
    SoidOrdersEnableDelivered = "soidOrdersEnableDelivered",
    SoidOrdersEnableDirect = "soidOrdersEnableDirect",
    SoidOrdersShowQuickProductsInCounter = "soidOrdersShowQuickProductsInCounter",
    SoidOrdersAllowTextLines = "soidOrdersAllowTextLines",
    SoidOrdersAllowCustomerLookupByAddress = "soidOrdersAllowCustomerLookupByAddress",
    SoidOrdersAllowMultipleSalesRepPerOrder = "soidOrdersAllowMultipleSalesRepPerOrder",
    SoidOrdersMinimumDeposit = "soidOrdersMinimumDeposit",
    SoidOrdersMergeDirectPOsForSameSO = "soidOrdersMergeDirectPOsForSameSO",
    SoidOrdersWarnIfVehicleTypeNotSet = "soidOrdersWarnIfVehicleTypeNotSet",
    SoidOrdersCallOffScheduleColumn1Heading = "soidOrdersCallOffScheduleColumn1Heading",
    SoidOrdersCallOffScheduleColumn2Heading = "soidOrdersCallOffScheduleColumn2Heading",
    SoidOrdersPromptForPacksIfAlwaysPackSelling = "soidOrdersPromptForPacksIfAlwaysPackSelling",
    SoidOrdersAllowIssuingStockFromOtherBranches = "soidOrdersAllowIssuingStockFromOtherBranches",
    SoidOrdersAllowIssuingBranchWithReadOnlyAccess = "soidOrdersAllowIssuingBranchWithReadOnlyAccess",
    SoidOrdersKeepDeliveryAddressForCollectSales = "soidOrdersKeepDeliveryAddressForCollectSales",
    SoidOrdersHideAvailableCreditOnSO = "soidOrdersHideAvailableCreditOnSO",
    SoidOrdersCopyProductInternalLineNotesToLineNotes = "soidOrdersCopyProductInternalLineNotesToLineNotes",
    SoidOrdersPromptToMarkOrderAsCollectedOnSaveAndClose = "soidOrdersPromptToMarkOrderAsCollectedOnSaveAndClose",
    SoidOrdersAllowChangeOfNotesAndTypeOnOrdersInvoiced = "soidOrdersAllowChangeOfNotesAndTypeOnOrdersInvoiced",
    SoidOrdersAllowFractionalKits = "soidOrdersAllowFractionalKits",
    SoidOrdersSortByBinLocationWhenConsolidatingProductLines = "soidOrdersSortByBinLocationWhenConsolidatingProductLines",
    SoidOrdersSpecialsCopyEnvironmentalStatus = "soidOrdersSpecialsCopyEnvironmentalStatus",
    SoidOrdersCanChangeSaleTypeIfCardholderNotPresentPayment = "soidOrdersCanChangeSaleTypeIfCardholderNotPresentPayment",
    SoidOrdersIgnoreAllowProceedonStockWarningforBackOrder = "soidOrdersIgnoreAllowProceedonStockWarningforBackOrder",
    SoidDisableOtherSizeOptionForStockByLengthProductsOnOrders = "soidDisableOtherSizeOptionForStockByLengthProductsOnOrders",
    SoidOrdersDisplayOrderNumberDialog = "soidOrdersDisplayOrderNumberDialog",
    SoidOrdersSkipOrderCompletionDialog = "soidOrdersSkipOrderCompletionDialog",
    SoidOrdersWarnSupplierMinAmountOnPOs = "soidOrdersWarnSupplierMinAmountOnPOs",
    SoidPickVehicleWhenMarkingOrderAsDelivered = "soidPickVehicleWhenMarkingOrderAsDelivered",
    SoidShowTotalQuantityInformationinCounterSales = "soidShowTotalQuantityInformationinCounterSales",
    SoidForceAddressSelectionInCounterSales = "soidForceAddressSelectionInCounterSales",
    SoidCopySellPriceAndCostOnSpecialOrderCopyFromBaseItem = "soidCopySellPriceAndCostOnSpecialOrderCopyFromBaseItem",
    SoidUpdateExistingPOOnDirectBO = "soidUpdateExistingPOOnDirectBO",
    SoidOrdersApplyEnvironmentalStatusRestrictions = "soidOrdersApplyEnvironmentalStatusRestrictions",
    SoidOrdersShowChangeInformationDuringPrint = "soidOrdersShowChangeInformationDuringPrint",
    SoidOrdersReasonCodeOnLineAmend = "soidOrdersReasonCodeOnLineAmend",
    SoidAllowLadingQuantityEntryDuringPicking = "soidAllowLadingQuantityEntryDuringPicking",
    SoidOrdersMinimumDepositThreshold = "soidOrdersMinimumDepositThreshold",
    SoidOrdersRequireFullPaymentWhenBelowMinimumDepositThreshold = "soidOrdersRequireFullPaymentWhenBelowMinimumDepositThreshold",
    SoidOrdersDisplayMinimumDepositOverrideButton = "soidOrdersDisplayMinimumDepositOverrideButton",
    SoidOrdersSpecialLinesOnCashSalesMustBePaidInFull = "soidOrdersSpecialLinesOnCashSalesMustBePaidInFull",
    SoidOrdersShowTaxAreaButton = "soidOrdersShowTaxAreaButton",
    SoidOrdersBackOrderReleaseCheckAvailableStock = "soidOrdersBackOrderReleaseCheckAvailableStock",
    SoidOrdersCheckMinimumDepositOnBackOrders = "soidOrdersCheckMinimumDepositOnBackOrders",
    SoidOrdersPromptForReferenceInCounter = "soidOrdersPromptForReferenceInCounter",
    SoidWarnWhenDateRequiredMonthsInAdvance = "soidWarnWhenDateRequiredMonthsInAdvance",
    SoidOrderFixOriginalQtyAt = "soidOrderFixOriginalQtyAt",
    SoidForceAddressSelectionInOperations = "soidForceAddressSelectionInOperations",
    SoidOrdersDisplayPaymentScreenOnModifiedDeliveredCashSale = "soidOrdersDisplayPaymentScreenOnModifiedDeliveredCashSale",
    SoidSalesOrderSetDefaultSupplierOnDirects = "soidSalesOrderSetDefaultSupplierOnDirects",
    SoidOrdersOpenPurchaseOrders = "soidOrdersOpenPurchaseOrders",
    SoidOrdersLargeKitProcessing = "soidOrdersLargeKitProcessing",
    SoidOrdersEnableEditQtyAndPriceInGrid = "soidOrdersEnableEditQtyAndPriceInGrid",
    SoidTransferCreatorModify = "soidTransferCreatorModify",
    SoidTransferCreatedByReceivingBranch = "soidTransferCreatedByReceivingBranch",
    SoidTransferAutoApplyDeliveryCosts = "soidTransferAutoApplyDeliveryCosts",
    SoidTransferReceiptConfirmationFormat = "soidTransferReceiptConfirmationFormat",
    SoidTransferCanChangeViaBranch = "soidTransferCanChangeViaBranch",
    SoidTransferCostCalculation = "soidTransferCostCalculation",
    SoidTransferReturnAutoApplyDeliveryCosts = "soidTransferReturnAutoApplyDeliveryCosts",
    SoidDefaultTransferSaleType = "soidDefaultTransferSaleType",
    SoidTransferSplitPacksToLoose = "soidTransferSplitPacksToLoose",
    SoidTransferRequireUpdateAccessForToBranch = "soidTransferRequireUpdateAccessForToBranch",
    SoidTransferAllowZeroCost = "soidTransferAllowZeroCost",
    SoidTransferAllowToBeLessThanCurrentCost = "soidTransferAllowToBeLessThanCurrentCost",
    SoidTransferRequirePackConfirmation = "soidTransferRequirePackConfirmation",
    SoidTransferApplyUplifts = "soidTransferApplyUplifts",
    SoidTransferBranchAccessLevelRequiredForFromBranch = "soidTransferBranchAccessLevelRequiredForFromBranch",
    SoidTransferReturnAtOriginalCost = "soidTransferReturnAtOriginalCost",
    SoidTransferRequireSendingBranchApproval = "soidTransferRequireSendingBranchApproval",
    SoidTransferApprovalRequiredBeforeAllocation = "soidTransferApprovalRequiredBeforeAllocation",
    SoidTransferSuggestionQuantity = "soidTransferSuggestionQuantity",
    SoidTransferDontApproveAllocateStockTransfersLinkedToPOUntilReceived = "soidTransferDontApproveAllocateStockTransfersLinkedToPOUntilReceived",
    SoidTransferReturnUseOriginalBranchInGLTransferUplift = "soidTransferReturnUseOriginalBranchInGLTransferUplift",
    SoidTransferDateRequiredFromManufacturedSpecials = "soidTransferDateRequiredFromManufacturedSpecials",
    SoidCalculateBranchTransferCostsBasedOnTotalValues = "soidCalculateBranchTransferCostsBasedOnTotalValues",
    SoidTransferDateRequiredDaysBetweenPOAndLinkTransfers = "soidTransferDateRequiredDaysBetweenPOAndLinkTransfers",
    SoidTransferUpdateDateRequiredWhenLinkedSODateRequiredChanges = "soidTransferUpdateDateRequiredWhenLinkedSODateRequiredChanges",
    SoidOrdersNewOneTimeAddressIsBlank = "soidOrdersNewOneTimeAddressIsBlank",
    SoidTransferReceiveInBranchesNotLoggedIn = "soidTransferReceiveInBranchesNotLoggedIn",
    SoidTransferCopyOrderLineAVOsToTransferLineWhenSourcedFromTransfer = "soidTransferCopyOrderLineAVOsToTransferLineWhenSourcedFromTransfer",
    SoidTransferUseVMICostForBranchTransferCostOnVMIProducts = "soidTransferUseVMICostForBranchTransferCostOnVMIProducts",
    SoidOrdersCopyFromSelectMultipleTemplates = "soidOrdersCopyFromSelectMultipleTemplates",
    SoidUpdateSpecialOrderCostOnChangesOnPO_SR_SI = "soidUpdateSpecialOrderCostOnChangesOnPO_SR_SI",
    SoidLumpSumSectionsOnCopyFrom = "soidLumpSumSectionsOnCopyFrom",
    SoidConsolidatePositiveQuantitiesWithinSectionsByDefault = "soidConsolidatePositiveQuantitiesWithinSectionsByDefault",
    SoidOpenOrderLinePropertiesForRelatedProducts = "soidOpenOrderLinePropertiesForRelatedProducts",
    SoidOrdersNotifyIfDeletedLinesOnSalesTransactionCopy = "soidOrdersNotifyIfDeletedLinesOnSalesTransactionCopy",
    SoidOrderSectionsToMaintainSectionPrice = "soidOrderSectionsToMaintainSectionPrice",
    SoidBackToBackIgnoresHowSourced = "soidBackToBackIgnoresHowSourced",
    SoidSectionSelectionBoxType = "soidSectionSelectionBoxType",
    SoidOrdersPromptForBuyPriceRuleOnBackToBackPO = "soidOrdersPromptForBuyPriceRuleOnBackToBackPO",
    SoidOrdersAllowChangingSaleTypeAndDeliveryAfterPicking = "soidOrdersAllowChangingSaleTypeAndDeliveryAfterPicking",
    SoidOrdersAllowChangingScheduledSalesOrders = "soidOrdersAllowChangingScheduledSalesOrders",
    SoidDefaultAddressTypeWhenCreatedFromSalesOrders = "soidDefaultAddressTypeWhenCreatedFromSalesOrders",
    SoidCreateJobAddressesInSalesTransactionWithQuickJobScreen = "soidCreateJobAddressesInSalesTransactionWithQuickJobScreen",
    SoidApplyPermissionsOnChangesWithPickingNotePrintedToDeliveredOrdersOnly = "soidApplyPermissionsOnChangesWithPickingNotePrintedToDeliveredOrdersOnly",
    SoidTransfersAdvanceDaysFromOrder = "soidTransfersAdvanceDaysFromOrder",
    SoidAllowEditingKitsAfterBackToBackPurchaseOrderApproved = "soidAllowEditingKitsAfterBackToBackPurchaseOrderApproved",
    SoidParkOrdersWhenWorkOrderDateRequiredFull = "soidParkOrdersWhenWorkOrderDateRequiredFull",
    SoidOrdersPromptDuringOrderEntryWhenDefaultBatchDoesNotExist = "soidOrdersPromptDuringOrderEntryWhenDefaultBatchDoesNotExist",
    SoidOrdersPromptDuringPickingWhenDefaultBatchDoesNotExist = "soidOrdersPromptDuringPickingWhenDefaultBatchDoesNotExist",
    SoidSuggestedOrdersIncludeSuggestionsInStockAvailable = "soidSuggestedOrdersIncludeSuggestionsInStockAvailable",
    SoidAllowAdjustmentOfQuantityDuringReceiptOfStockTransfer = "soidAllowAdjustmentOfQuantityDuringReceiptOfStockTransfer",
    SoidReasonCodeForACAGenearatedFromQuantityAdjustmentTransfers = "soidReasonCodeForACAGenearatedFromQuantityAdjustmentTransfers",
    SoidOrdersUseAlternatePaymentTermsByProductGroup = "soidOrdersUseAlternatePaymentTermsByProductGroup",
    SoidWMSOnlyReleaseLinesAvailForPickWhenSplitDelivAllowed = "soidWMSOnlyReleaseLinesAvailForPickWhenSplitDelivAllowed",
    SoidFindProductSmartView1 = "soidFindProductSmartView1",
    SoidFindProductSmartView2 = "soidFindProductSmartView2",
    SoidFindProductSmartView3 = "soidFindProductSmartView3",
    SoidFindProductSmartView4 = "soidFindProductSmartView4",
    SoidFindProductSmartView5 = "soidFindProductSmartView5",
    SoidFindCustomerSmartView1 = "soidFindCustomerSmartView1",
    SoidFindCustomerSmartView2 = "soidFindCustomerSmartView2",
    SoidFindCustomerSmartView3 = "soidFindCustomerSmartView3",
    SoidFindCustomerSmartView4 = "soidFindCustomerSmartView4",
    SoidFindCustomerSmartView5 = "soidFindCustomerSmartView5",
    SoidJourneyPlannerSmartView1 = "soidJourneyPlannerSmartView1",
    SoidJourneyPlannerSmartView2 = "soidJourneyPlannerSmartView2",
    SoidJourneyPlannerSmartView3 = "soidJourneyPlannerSmartView3",
    SoidJourneyPlannerSmartView4 = "soidJourneyPlannerSmartView4",
    SoidJourneyPlannerSmartView5 = "soidJourneyPlannerSmartView5",
    SoidOrderQuotesForceFollowUp = "soidOrderQuotesForceFollowUp",
    SoidOrderQuotesFollowUpDays = "soidOrderQuotesFollowUpDays",
    SoidOrderQuotesFollowUpNotepadType = "soidOrderQuotesFollowUpNotepadType",
    SoidOrderQuotesApplyMarginWarningAndStops = "soidOrderQuotesApplyMarginWarningAndStops",
    SoidOrderQuotesAllowPark = "soidOrderQuotesAllowPark",
    SoidOrderQuotesAllowPrintWhenSupplierRequestExists = "soidOrderQuotesAllowPrintWhenSupplierRequestExists",
    SoidOrderQuotesCopyCreatedByUserAndOrderingBranch = "soidOrderQuotesCopyCreatedByUserAndOrderingBranch",
    SoidOrderQuotesAllowMultipleAccept = "soidOrderQuotesAllowMultipleAccept",
    SoidOrderQuotesForceRecalculateWhenAcceptingExpiredQuote = "soidOrderQuotesForceRecalculateWhenAcceptingExpiredQuote",
    SoidOrderQuotesUseTakenByFromQuoteWhenAcceptingIntoOrder = "soidOrderQuotesUseTakenByFromQuoteWhenAcceptingIntoOrder",
    SoidOrderQuotesAllowBlankText = "soidOrderQuotesAllowBlankText",
    SoidOrderQuotesExcludeQuotesFromPromotionalPricing = "soidOrderQuotesExcludeQuotesFromPromotionalPricing",
    SoidOrdersDontCompleteOrdersWhenWorkOrdersNeedStock = "soidOrdersDontCompleteOrdersWhenWorkOrdersNeedStock",
    SoidOrdersCompleteDeliveredOrdersWhenDateRequiredIsFull = "soidOrdersCompleteDeliveredOrdersWhenDateRequiredIsFull",
    SoidUseSearchForTakenBy = "soidUseSearchForTakenBy",
    SoidSimpleOrderProcessCollectNow = "soidSimpleOrderProcessCollectNow",
    SoidSimpleOrderProcessCollectLater = "soidSimpleOrderProcessCollectLater",
    SoidSimpleOrderProcessDelivered = "soidSimpleOrderProcessDelivered",
    SoidSimpleOrderProcessDirect = "soidSimpleOrderProcessDirect",
    SoidSimpleOrderProcessTransfer = "soidSimpleOrderProcessTransfer",
    SoidSimpleOrderControlAVOProcessing = "soidSimpleOrderControlAVOProcessing",
    SoidSimpleOrderPreAllocateOrderInvoiceNo = "soidSimpleOrderPreAllocateOrderInvoiceNo",
    SoidSimpleConfirmPicking = "soidSimpleConfirmPicking",
    SoidSimpleConfirmDelivery = "soidSimpleConfirmDelivery",
    SoidSimpleConfirmPODReturned = "soidSimpleConfirmPODReturned",
    SoidSimplePrintPickingNoteOnPark = "soidSimplePrintPickingNoteOnPark",
    SoidSimpleDeliveryAfterPickingConfirmed = "soidSimpleDeliveryAfterPickingConfirmed",
    SoidSimpleOnlyAllowDeliveryPrintAfterMarked = "soidSimpleOnlyAllowDeliveryPrintAfterMarked",
    SoidSimpleAutoIssueOnMarkAsDelivered = "soidSimpleAutoIssueOnMarkAsDelivered",
    SoidSimpleOnlyInvoiceDirectsAfterSuppInv = "soidSimpleOnlyInvoiceDirectsAfterSuppInv",
    SoidSimpleAllowPickDeliveryPrintWhenWaitingForStock = "soidSimpleAllowPickDeliveryPrintWhenWaitingForStock",
    SoidSimpleDontIssueIfNegativeStock = "soidSimpleDontIssueIfNegativeStock",
    SoidSimplePickingNoteFormat = "soidSimplePickingNoteFormat",
    SoidSimpleDeliveryNoteFormat = "soidSimpleDeliveryNoteFormat",
    SoidSimpleCollectionNoteFormat = "soidSimpleCollectionNoteFormat",
    SoidSimpleDepositReceiptFormat = "soidSimpleDepositReceiptFormat",
    SoidSimpleDeliveryFormatSetCash = "soidSimpleDeliveryFormatSetCash",
    SoidSimpleOrderPickingStyle = "soidSimpleOrderPickingStyle",
    SoidSimpleOrderPickingZonesFormatNumbers = "soidSimpleOrderPickingZonesFormatNumbers",
    SoidSimpleTransferDeliveryFormatSet = "soidSimpleTransferDeliveryFormatSet",
    SoidSimplePrintDocumentsOnBackOrder = "soidSimplePrintDocumentsOnBackOrder",
    SoidSimpleOnlyInvoiceWhenCODFullyPaid = "soidSimpleOnlyInvoiceWhenCODFullyPaid",
    SoidSimpleOrderRecordPickingStarted = "soidSimpleOrderRecordPickingStarted",
    SoidSimpleOrderOnlyApproveIfJourneyComplete = "soidSimpleOrderOnlyApproveIfJourneyComplete",
    SoidSimpleAutoIssueOnInvoiceIfNotYetIssued = "soidSimpleAutoIssueOnInvoiceIfNotYetIssued",
    SoidSimpleAVOFormatSet = "soidSimpleAVOFormatSet",
    SoidSimpleAdditionalCostFormat = "soidSimpleAdditionalCostFormat",
    SoidSimplePromptForDeliveryInAdvancedPicking = "soidSimplePromptForDeliveryInAdvancedPicking",
    SoidSimplePromptUserIfQtyPickedNotEqualToQtyOrdered = "soidSimplePromptUserIfQtyPickedNotEqualToQtyOrdered",
    SoidSimpleDeliveryFormatSetCredit = "soidSimpleDeliveryFormatSetCredit",
    SoidSimpleCollectLaterFormatSetCash = "soidSimpleCollectLaterFormatSetCash",
    SoidSimpleCollectLaterFormatSetCredit = "soidSimpleCollectLaterFormatSetCredit",
    SoidSimpleRequireReasonCodeOnPickShortage = "soidSimpleRequireReasonCodeOnPickShortage",
    SoidSimplePrintPickingNoteWhenStockAvailable = "soidSimplePrintPickingNoteWhenStockAvailable",
    SoidSimpleDepositReceiptOnFinalPayment = "soidSimpleDepositReceiptOnFinalPayment",
    SoidDefaultBackOrderBehaviourInAdvancedPicking = "soidDefaultBackOrderBehaviourInAdvancedPicking",
    SoidSimpleCollectNowPickingDocumentFormatSet = "soidSimpleCollectNowPickingDocumentFormatSet",
    SoidSimpleAllowAutoMarkPickWhenUsingAdvancedPicking = "soidSimpleAllowAutoMarkPickWhenUsingAdvancedPicking",
    SoidSimpleAutoPrintSpecialOrderAcknowledgementDocument = "soidSimpleAutoPrintSpecialOrderAcknowledgementDocument",
    SoidSimpleSpecialOrderAcknowledgementDocumentFormatSet = "soidSimpleSpecialOrderAcknowledgementDocumentFormatSet",
    SoidSimpleDisplayBinLocationOnPickingConfirmation = "soidSimpleDisplayBinLocationOnPickingConfirmation",
    SoidSimpleAllowPackReferenceScanningOnPickingConfirmation = "soidSimpleAllowPackReferenceScanningOnPickingConfirmation",
    SoidSimpleAllowPickingNotePrintOnDeliveredCashSaleWithOutstandingBalance = "soidSimpleAllowPickingNotePrintOnDeliveredCashSaleWithOutstandingBalance",
    SoidSimpleAllowdeliveryNotePrintOnDeliveredCashSaleWithOutstandingBalance = "soidSimpleAllowdeliveryNotePrintOnDeliveredCashSaleWithOutstandingBalance",
    SoidSimpleOrderAmendPrintFormatSet = "soidSimpleOrderAmendPrintFormatSet",
    SoidSimpleOrderAmendPrintHandling = "soidSimpleOrderAmendPrintHandling",
    SoidSimpleOrderAllowUnpickIfInvoiced = "soidSimpleOrderAllowUnpickIfInvoiced",
    SoidDefaultPrintDeliveryNoteDocumentSet = "soidDefaultPrintDeliveryNoteDocumentSet",
    SoidPrintDeliveryNoteFormatWhenMarkingDelivered = "soidPrintDeliveryNoteFormatWhenMarkingDelivered",
    SoidOrderAllowQuantityLessThanPicked = "soidOrderAllowQuantityLessThanPicked",
    SoidSimpleOrderDefaultPickingZoneFromOrderMonitor = "soidSimpleOrderDefaultPickingZoneFromOrderMonitor",
    SoidSimpleOrderHideItemsWhichAreNotInSelectedZone = "soidSimpleOrderHideItemsWhichAreNotInSelectedZone",
    SoidSimpleOrderDefaultMOLTasPickedInAdvancedPicking = "soidSimpleOrderDefaultMOLTasPickedInAdvancedPicking",
    SoidSimpleOrderOnlyReleaseBackOrderWithSingleDeliveryOption = "soidSimpleOrderOnlyReleaseBackOrderWithSingleDeliveryOption",
    SoidSimpleConfirmChecked = "soidSimpleConfirmChecked",
    SoidDefaultPrintPickingNoteWhenMarkingPickStarted = "soidDefaultPrintPickingNoteWhenMarkingPickStarted",
    SoidScanActionBarcodesInBatchUpdate = "soidScanActionBarcodesInBatchUpdate",
    SoidSimpleDeliveryAfterChecked = "soidSimpleDeliveryAfterChecked",
    SoidOrdersAllowCompleteWhenJobIsPreliminary = "soidOrdersAllowCompleteWhenJobIsPreliminary",
    SoidCheckPickingRequiredFlagWhenDeterminingPickingZonePrintingFormats = "soidCheckPickingRequiredFlagWhenDeterminingPickingZonePrintingFormats",
    SoidSimpleOrderSetDefaultReleaseQuantityToAll = "soidSimpleOrderSetDefaultReleaseQuantityToAll",
    SoidIncludeUnapprovedOrdersInOrdersForInvoicingFilter = "soidIncludeUnapprovedOrdersInOrdersForInvoicingFilter",
    SoidOrdersAllowChangingUOMsinQtyAndQtyPriceEntry = "soidOrdersAllowChangingUOMsinQtyAndQtyPriceEntry",
    SoidShowMsgWhenPickingLessSpecialOrderThanAvailable = "soidShowMsgWhenPickingLessSpecialOrderThanAvailable",
    SoidSimpleOrderLimitPickingAndCheckedByUsersByBranch = "soidSimpleOrderLimitPickingAndCheckedByUsersByBranch",
    SoidSimpleOrderDefaultPickingStartedUserToFirstAvailable = "soidSimpleOrderDefaultPickingStartedUserToFirstAvailable",
    SoidPrintDeliveryNoteDocumentSetWhenMarkingDelvOrdersPicked = "soidPrintDeliveryNoteDocumentSetWhenMarkingDelvOrdersPicked",
    SoidSimpleOrderRecordPickComplete = "soidSimpleOrderRecordPickComplete",
    SoidPromptSignatureWhenCompletingCollectNowOrderThatGoesCreditHold = "soidPromptSignatureWhenCompletingCollectNowOrderThatGoesCreditHold",
    SoidPromptSignatureWhenChangingWMSOrderTypeToCollectLaterNow = "soidPromptSignatureWhenChangingWMSOrderTypeToCollectLaterNow",
    SoidUseSignatureCaptureSettingsForCollectNowWhenCompletingCollectLaterNow = "soidUseSignatureCaptureSettingsForCollectNowWhenCompletingCollectLaterNow",
    SoidSimpleOrderEnableMarkFullyPicked = "soidSimpleOrderEnableMarkFullyPicked",
    SoidDisplayAwaitingStockWarningMessagesInPickingConfirmation = "soidDisplayAwaitingStockWarningMessagesInPickingConfirmation",
    SoidBackOrderEntireSingleDeliveryOrderWhenAnyLineBackOrdered = "soidBackOrderEntireSingleDeliveryOrderWhenAnyLineBackOrdered",
    SoidWMSDefaultBackOrderBehaviour = "soidWMSDefaultBackOrderBehaviour",
    SoidWMSMarkOrdersDeliveredWhenPickCompletedFromWMS = "soidWMSMarkOrdersDeliveredWhenPickCompletedFromWMS",
    SoidCashSalesPercentToleranceForTalliedTimber = "soidCashSalesPercentToleranceForTalliedTimber",
    SoidCashSalesAmountToleranceForTalliedTimber = "soidCashSalesAmountToleranceForTalliedTimber",
    SoidCashSalesPercentToleranceForNonTalliedTimber = "soidCashSalesPercentToleranceForNonTalliedTimber",
    SoidCashSalesAmountToleranceForNonTalliedTimber = "soidCashSalesAmountToleranceForNonTalliedTimber",
    SoidCashSalesPercentToleranceForProductSubstitutions = "soidCashSalesPercentToleranceForProductSubstitutions",
    SoidCashSalesAmountToleranceForProductSubstitutions = "soidCashSalesAmountToleranceForProductSubstitutions",
    SoidCashSalesRestrictFullyPaidCashSaleToSameProductGroup = "soidCashSalesRestrictFullyPaidCashSaleToSameProductGroup",
    SoidCashSalesRunWithNewCashBehaviour = "soidCashSalesRunWithNewCashBehaviour",
    SoidCashSalesEnableToleranceChecking = "soidCashSalesEnableToleranceChecking",
    SoidCashSalesAutoFinalizeDaily = "soidCashSalesAutoFinalizeDaily",
    SoidCashSalesForceAddressCollectNow = "soidCashSalesForceAddressCollectNow",
    SoidCashSalesForceAddressCollectLater = "soidCashSalesForceAddressCollectLater",
    SoidCashSalesOrderMaximumCashAllowed = "soidCashSalesOrderMaximumCashAllowed",
    SoidCashSalesAllowDepositGreaterThanOrderTotal = "soidCashSalesAllowDepositGreaterThanOrderTotal",
    SoidCashSalesPostCheckOverpaymentAsChangeDue = "soidCashSalesPostCheckOverpaymentAsChangeDue",
    SoidSimpleOnlyAllowDeliverySetPrintAfterMarked = "soidSimpleOnlyAllowDeliverySetPrintAfterMarked",
    SoidForceSelectionOfReasonCodeForLodgement = "soidForceSelectionOfReasonCodeForLodgement",
    SoidCashSalesRetainInvoiceAddressWhenCopyingCashSales = "soidCashSalesRetainInvoiceAddressWhenCopyingCashSales",
    SoidCashSalesDepositReceiptOnBackOrders = "soidCashSalesDepositReceiptOnBackOrders",
    SoidDefaultLodgementPostingDate = "soidDefaultLodgementPostingDate",
    SoidAllowLodgementsOnCreditAndDebitCards = "soidAllowLodgementsOnCreditAndDebitCards",
    SoidSortPaymentMethodByPaymentMethodCode = "soidSortPaymentMethodByPaymentMethodCode",
    SoidReturnToPaymentDetailsAfterFullyPaid = "soidReturnToPaymentDetailsAfterFullyPaid",
    SoidCashSalesAllowDeliveryCollectionOfUnpaid = "soidCashSalesAllowDeliveryCollectionOfUnpaid",
    SoidDefaultContractSchedule = "soidDefaultContractSchedule",
    SoidPostInstalledSalesShipmentsToManualOrderInvoicingLines = "soidPostInstalledSalesShipmentsToManualOrderInvoicingLines",
    SoidPostSalesAmountAtTimeOfMaterialShipment = "soidPostSalesAmountAtTimeOfMaterialShipment",
    SoidForceSelectionOfAddressOnContractCreation = "soidForceSelectionOfAddressOnContractCreation",
    SoidDefaultOrdersAndCallOffsToUseOpenContracts = "soidDefaultOrdersAndCallOffsToUseOpenContracts",
    SoidAllowMultipleCallOffOrdersOnContracts = "soidAllowMultipleCallOffOrdersOnContracts",
    SoidDefaultMarginForPostCostToWIPMethod = "soidDefaultMarginForPostCostToWIPMethod",
    SoidAccruedARInstalledSalesVarianceMOLT = "soidAccruedARInstalledSalesVarianceMOLT",
    SoidContractsCopyFromDefaultDocType = "soidContractsCopyFromDefaultDocType",
    SoidContractsCopyFromDefaultConsolidateByMOLT = "soidContractsCopyFromDefaultConsolidateByMOLT",
    SoidAllowSettingTaxAreaOnContracts = "soidAllowSettingTaxAreaOnContracts",
    SoidContractsIncludeSalesTaxAmountDuringCopySections = "soidContractsIncludeSalesTaxAmountDuringCopySections",
    SoidAllowSettingRetentionPercentageOnContractInvoicingLines = "soidAllowSettingRetentionPercentageOnContractInvoicingLines",
    SoidAutoCloseContractsWithNoTransactionsInNumberOfDays = "soidAutoCloseContractsWithNoTransactionsInNumberOfDays",
    SoidIncludeTaxInRetentionCalculations = "soidIncludeTaxInRetentionCalculations",
    SoidAllowSelectingJobAddressOnContractBillingLine = "soidAllowSelectingJobAddressOnContractBillingLine",
    SoidShowTimberFunctionality = "soidShowTimberFunctionality",
    SoidTimberSplitPackRefSuffix = "soidTimberSplitPackRefSuffix",
    SoidTimberAllowSplitToLoose = "soidTimberAllowSplitToLoose",
    SoidTimberSplitPackVolumeWarningTreshold = "soidTimberSplitPackVolumeWarningTreshold",
    SoidTimberDuplicatePackReferenceOption = "soidTimberDuplicatePackReferenceOption",
    SoidTimberTallyLengthDecimalPlaces = "soidTimberTallyLengthDecimalPlaces",
    SoidTimberPackTallyInput = "soidTimberPackTallyInput",
    SoidTimberAutoAllocatePackBarCodes = "soidTimberAutoAllocatePackBarCodes",
    SoidTimberAllowDecimalPlacesOnNumberOfSheets = "soidTimberAllowDecimalPlacesOnNumberOfSheets",
    SoidTimberInputAdvanced = "soidTimberInputAdvanced",
    SoidTimberInputShowStdLengths = "soidTimberInputShowStdLengths",
    SoidTimberInputNoOfBlankRows = "soidTimberInputNoOfBlankRows",
    SoidTimberInputColumnSequence = "soidTimberInputColumnSequence",
    SoidTimberAutoSetPackType = "soidTimberAutoSetPackType",
    SoidTimberPercForAPTL = "soidTimberPercForAPTL",
    SoidTimberInputMaskContractRef = "soidTimberInputMaskContractRef",
    SoidTimberInputMaskContractPeriod = "soidTimberInputMaskContractPeriod",
    SoidTimberInputMaskShip = "soidTimberInputMaskShip",
    SoidTimberInputMaskVoyage = "soidTimberInputMaskVoyage",
    SoidTimberInputMaskBOLRef = "soidTimberInputMaskBOLRef",
    SoidTimberInputMaskShipPackRef = "soidTimberInputMaskShipPackRef",
    SoidTimberPackVolFormatString = "soidTimberPackVolFormatString",
    SoidTimberPackShowPackEstimate = "soidTimberPackShowPackEstimate",
    SoidTimberDefaultStatusOnStockReceipt = "soidTimberDefaultStatusOnStockReceipt",
    SoidTimberPackQuantityAbbreviation = "soidTimberPackQuantityAbbreviation",
    SoidTimberSplitPackAllowHigherVolume = "soidTimberSplitPackAllowHigherVolume",
    SoidTimberUsePackSubstitution = "soidTimberUsePackSubstitution",
    SoidTimberPackVolDecimalPlaces = "soidTimberPackVolDecimalPlaces",
    SoidTimberPackLengthDecimalPlaces = "soidTimberPackLengthDecimalPlaces",
    SoidTimberPackFindDefaultView = "soidTimberPackFindDefaultView",
    SoidTimberPackTallyDisplayAvailableOrActual = "soidTimberPackTallyDisplayAvailableOrActual",
    SoidTimberSplitPackReasonCode = "soidTimberSplitPackReasonCode",
    SoidTimberInputRoundToNearestTallyLength = "soidTimberInputRoundToNearestTallyLength",
    SoidTimberUseTallyCalculator = "soidTimberUseTallyCalculator",
    SoidTimberStockShortageWarningOnSOTally = "soidTimberStockShortageWarningOnSOTally",
    SoidTimberOrdersShowInvalidTallyWarnings = "soidTimberOrdersShowInvalidTallyWarnings",
    SoidTimberAllowBulkChangeStockLocationOnFreePacks = "soidTimberAllowBulkChangeStockLocationOnFreePacks",
    SoidTimberDefaultNATalliedScreenToSplitTallyOnPO = "soidTimberDefaultNATalliedScreenToSplitTallyOnPO",
    SoidTimberAllowDifferentTallySelectionOnSalesTransactions = "soidTimberAllowDifferentTallySelectionOnSalesTransactions",
    SoidTimberRetainPackRefWhenReuseSourceOnWorksOrders = "soidTimberRetainPackRefWhenReuseSourceOnWorksOrders",
    SoidTimberIncludeFreePacksAsAvailable = "soidTimberIncludeFreePacksAsAvailable",
    SoidTimberIncludePackStockAsAvailableOnTallyInput = "soidTimberIncludePackStockAsAvailableOnTallyInput",
    SoidTimberInputLimitToNoOfBlankRows = "soidTimberInputLimitToNoOfBlankRows",
    SoidTimberDisplayTallyLengthsInProductFindForAvailableStock = "soidTimberDisplayTallyLengthsInProductFindForAvailableStock",
    SoidTimberDefaultUsePackPriceSurcharge = "soidTimberDefaultUsePackPriceSurcharge",
    SoidTimberAllowDifferentTallySelectionOnWorksOrderSourceLines = "soidTimberAllowDifferentTallySelectionOnWorksOrderSourceLines",
    SoidTimberCopyParentTallyAndQuantityToNotesWhenTallySplit = "soidTimberCopyParentTallyAndQuantityToNotesWhenTallySplit",
    SoidPacksAutoSplitOnPackConfirmation = "soidPacksAutoSplitOnPackConfirmation",
    SoidPacksCopyAttachmentsDuringSplit = "soidPacksCopyAttachmentsDuringSplit",
    SoidPacksReuseSourcePacksOnFinishedProducts = "soidPacksReuseSourcePacksOnFinishedProducts",
    SoidAllowPartialCreditOfTaggedPacks = "soidAllowPartialCreditOfTaggedPacks",
    SoidTimberShowProductLinealFeetPercentage = "soidTimberShowProductLinealFeetPercentage",
    SoidShowSteelFunctionality = "soidShowSteelFunctionality",
    SoidProfileSalesAnalysisCode = "soidProfileSalesAnalysisCode",
    SoidDefaultProfileMachine = "soidDefaultProfileMachine",
    SoidDefaultProfileManualOrderLineType = "soidDefaultProfileManualOrderLineType",
    SoidSteelPickingWeightDifferenceLow = "soidSteelPickingWeightDifferenceLow",
    SoidSteelPickingWeightDifferenceHigh = "soidSteelPickingWeightDifferenceHigh",
    SoidAllowWeightAsStockingUnitOfMeasure = "soidAllowWeightAsStockingUnitOfMeasure",
    SoidEnableAlternateUnitOfMeasureForTallyLengths = "soidEnableAlternateUnitOfMeasureForTallyLengths",
    SoidShowTestCertificateFunctionality = "soidShowTestCertificateFunctionality",
    SoidTestCertificateAttachmentFolder = "soidTestCertificateAttachmentFolder",
    SoidEnableAVOTolerances = "soidEnableAVOTolerances",
    SoidMetalConformanceCertificateFormatNumber = "soidMetalConformanceCertificateFormatNumber",
    SoidOrdersOrderLineAdditionalInfoDisplay = "soidOrdersOrderLineAdditionalInfoDisplay",
    SoidSignatureCaptureDelivered = "soidSignatureCaptureDelivered",
    SoidSignatureCaptureDirect = "soidSignatureCaptureDirect",
    SoidSignatureCaptureCollectLaterCash = "soidSignatureCaptureCollectLaterCash",
    SoidCalculateDeliveryChargesCostsBasedOnTotalValues = "soidCalculateDeliveryChargesCostsBasedOnTotalValues",
    SoidCalculateDeliveryChargesAtLineLevelOnly = "soidCalculateDeliveryChargesAtLineLevelOnly",
    SoidRequireUserToAcceptSignaturesFromSignatureCapture = "soidRequireUserToAcceptSignaturesFromSignatureCapture",
    SoidDisplayMarginAndCostDuringQuickAddEntry = "soidDisplayMarginAndCostDuringQuickAddEntry",
    SoidDisplayExtendedOrderLineQuantityInformation = "soidDisplayExtendedOrderLineQuantityInformation",
    SoidOrdersAllowDisablingAndEditingOfDeliveryChargesWithPermission = "soidOrdersAllowDisablingAndEditingOfDeliveryChargesWithPermission",
    SoidOrdersShowSaleTypeInDocumentInformationBar = "soidOrdersShowSaleTypeInDocumentInformationBar",
    SoidOrdersBackOrderReleaseCheckPackAndLooseAvailableStock = "soidOrdersBackOrderReleaseCheckPackAndLooseAvailableStock",
    SoidOrdersForceUpperCaseAddress = "soidOrdersForceUpperCaseAddress",
    SoidUpdateSpecialOrderSalesQuantityWithQuantityReceived = "soidUpdateSpecialOrderSalesQuantityWithQuantityReceived",
    SoidAllowCompanyChequeOnOrdersCreatedFromCreditNotes = "soidAllowCompanyChequeOnOrdersCreatedFromCreditNotes",
    SoidOrdersCustomerJobInstructionsAsAutoText = "soidOrdersCustomerJobInstructionsAsAutoText",
    SoidOrdersCalcDeliveryAndAllowCODonOrdersWithJustMOLTlines = "soidOrdersCalcDeliveryAndAllowCODonOrdersWithJustMOLTlines",
    SoidOrdersUsingF6GoesToCustomerField = "soidOrdersUsingF6GoesToCustomerField",
    SoidOrdersProrateDepositsDuringBackOrder = "soidOrdersProrateDepositsDuringBackOrder",
    SoidOrdersOpenPurchaseOrdersOnSalesOrderUpdate = "soidOrdersOpenPurchaseOrdersOnSalesOrderUpdate",
    SoidOrdersAutomaticallyReleaseBackOrders = "soidOrdersAutomaticallyReleaseBackOrders",
    SoidOrdersAllowChangeOfVehicleAndDeliveryTimeOnOrdersInvoiced = "soidOrdersAllowChangeOfVehicleAndDeliveryTimeOnOrdersInvoiced",
    SoidCheckMinimumDepositWhenOrderIsModified = "soidCheckMinimumDepositWhenOrderIsModified",
    SoidDisableAdditionalCostDeliveryChargesWhenDeliveryChargesAreDisabled = "soidDisableAdditionalCostDeliveryChargesWhenDeliveryChargesAreDisabled",
    SoidbTAStatementsAlwaysPrintImages = "soidbTAStatementsAlwaysPrintImages",
    SoidbTAFinanceChargeDefaultOverdueBy = "soidbTAFinanceChargeDefaultOverdueBy",
    SoidbTAFinanceChargeDefaultMonthlyFinanceChargePercent = "soidbTAFinanceChargeDefaultMonthlyFinanceChargePercent",
    SoidbTAFinanceChargeDefaultRevolvingAccountGrace = "soidbTAFinanceChargeDefaultRevolvingAccountGrace",
    SoidbTAStatementGenerateDefaultIncludeCustomersWithNoTransactions = "soidbTAStatementGenerateDefaultIncludeCustomersWithNoTransactions",
    SoidbTAStatementGenerateDefaultTransactionsToInclude = "soidbTAStatementGenerateDefaultTransactionsToInclude",
    SoidbTAStatementGenerateDefaultConsolidateGroupAccounts = "soidbTAStatementGenerateDefaultConsolidateGroupAccounts",
    SoidbTAStatementGenerateDefaultIndividualChildStatements = "soidbTAStatementGenerateDefaultIndividualChildStatements",
    SoidbTAStatementSendDefaultIncludeStatementsWithZeroBalance = "soidbTAStatementSendDefaultIncludeStatementsWithZeroBalance",
    SoidbTAStatementSendDefaultIncludeFullyPaidTransactions = "soidbTAStatementSendDefaultIncludeFullyPaidTransactions",
    SoidbTACustomerStatementByJobReportName = "soidbTACustomerStatementByJobReportName",
    SoidbTASummaryStatementReportName = "soidbTASummaryStatementReportName",
    SoidbTAAllowGeneratingStatementsByJob = "soidbTAAllowGeneratingStatementsByJob",
    SoidbTACanGenerateFinChargesByCustomerGroup = "soidbTACanGenerateFinChargesByCustomerGroup",
    SoidbTADefaultAccountPaymentToCustomersHomeBranch = "soidbTADefaultAccountPaymentToCustomersHomeBranch",
    SoidbTAAccountPaymentCreditCardSurchargePercentage = "soidbTAAccountPaymentCreditCardSurchargePercentage",
    SoidbTADirectPostingReasonCodeForAccountPaymentCreditCardSurcharge = "soidbTADirectPostingReasonCodeForAccountPaymentCreditCardSurcharge",
    SoidbTAAccountPaymentCreditCardSurchargeType = "soidbTAAccountPaymentCreditCardSurchargeType",
    SoidbTAAllowMatchingTransactionsBetweenARAccounts = "soidbTAAllowMatchingTransactionsBetweenARAccounts",
    SoidbTAReasonCodeToUseForInterBranchDirectPostings = "soidbTAReasonCodeToUseForInterBranchDirectPostings",
    SoidbTAAllowSelectionOfPaymentMethodInBatchCasPosting = "soidbTAAllowSelectionOfPaymentMethodInBatchCasPosting",
    SoidbTAUseAcctPmtsInsteadOfCashPosting = "soidbTAUseAcctPmtsInsteadOfCashPosting",
    SoidbTAAllowTakingDepositsOnARSalesOrders = "soidbTAAllowTakingDepositsOnARSalesOrders",
    SoidPopupJourneyDateVisible = "soidPopupJourneyDateVisible",
    SoidPopupJourneyDriverVisible = "soidPopupJourneyDriverVisible",
    SoidPopupJourneyVehicleVisible = "soidPopupJourneyVehicleVisible",
    SoidPopupJourneyWeightVisible = "soidPopupJourneyWeightVisible",
    SoidPopupJourneyDropsVisible = "soidPopupJourneyDropsVisible",
    SoidPopupJourneyVolumeVisible = "soidPopupJourneyVolumeVisible",
    SoidJourneyPlannerGroupJourneysByReference = "soidJourneyPlannerGroupJourneysByReference",
    SoidJourneyPlannerTimeFrame = "soidJourneyPlannerTimeFrame",
    SoidJourneyPlannerFirstDayOfWeek = "soidJourneyPlannerFirstDayOfWeek",
    SoidJourneyPlannerWorkingDays = "soidJourneyPlannerWorkingDays",
    SoidJourneyPlannerStartOfDay = "soidJourneyPlannerStartOfDay",
    SoidJourneyPlannerEndOfDay = "soidJourneyPlannerEndOfDay",
    SoidJourneyPlannerTimeInterval = "soidJourneyPlannerTimeInterval",
    SoidJourneyPlannerWeightDecimalPlaces = "soidJourneyPlannerWeightDecimalPlaces",
    SoidJourneyPlannerVolumeDecimalPlaces = "soidJourneyPlannerVolumeDecimalPlaces",
    SoidJourneyOnlyAllowTransportCostsForPicked = "soidJourneyOnlyAllowTransportCostsForPicked",
    SoidJourneyAllowCompleteWithNoTransportCost = "soidJourneyAllowCompleteWithNoTransportCost",
    SoidJourneyApplyTransportCostsOnCompletion = "soidJourneyApplyTransportCostsOnCompletion",
    SoidJourneyApplyTransportCostsTo = "soidJourneyApplyTransportCostsTo",
    SoidJourneyPromptForCreditHoldOrParkedOrders = "soidJourneyPromptForCreditHoldOrParkedOrders",
    SoidJourneyPlannerBranchViewDefault = "soidJourneyPlannerBranchViewDefault",
    SoidJourneyPlannerTimeIntervalForCalendar = "soidJourneyPlannerTimeIntervalForCalendar",
    SoidJourneyPlannerGroupJourneysByDriver = "soidJourneyPlannerGroupJourneysByDriver",
    SoidJourneyShowAdditionalCostsOnJourney = "soidJourneyShowAdditionalCostsOnJourney",
    SoidJourneyAutoRemoveAndAddDocumentsToRelatedAddCostChargeProRates = "soidJourneyAutoRemoveAndAddDocumentsToRelatedAddCostChargeProRates",
    SoidJourneyIncludePOWeight = "soidJourneyIncludePOWeight",
    SoidJourneyPlannerLimitToBranchVehicles = "soidJourneyPlannerLimitToBranchVehicles",
    SoidJourneyMarkOrdersDeliveredWhenJourneyMarkedInProgress = "soidJourneyMarkOrdersDeliveredWhenJourneyMarkedInProgress",
    SoidJourneyPlannerDisplayVIN = "soidJourneyPlannerDisplayVIN",
    SoidJourneyEnableAutomaticScheduledRoutes = "soidJourneyEnableAutomaticScheduledRoutes",
    SoidJourneyPromptForExistingJourneyWithTheSameAddress = "soidJourneyPromptForExistingJourneyWithTheSameAddress",
    SoidJourneyPlannerAutoRefreshInterval = "soidJourneyPlannerAutoRefreshInterval",
    SoidJourneyAllowLinkingTrailersToTruchAndTrailerVehicles = "soidJourneyAllowLinkingTrailersToTruchAndTrailerVehicles",
    SoidJourneyReferenceRequired = "soidJourneyReferenceRequired",
    SoidJourneyShowWarningWhenDocumentDateRequiredDontMatchJourneyDate = "soidJourneyShowWarningWhenDocumentDateRequiredDontMatchJourneyDate",
    SoidJourneyEnableAllowMultipleDeliveryAreasInJourney = "soidJourneyEnableAllowMultipleDeliveryAreasInJourney",
    SoidJourneyDefaultUnloadTimePerStop = "soidJourneyDefaultUnloadTimePerStop",
    SoidJourneyShowCreditNotePrintedInDocumentList = "soidJourneyShowCreditNotePrintedInDocumentList",
    SoidJourneyPlannerAutoAddUnusedVehicles = "soidJourneyPlannerAutoAddUnusedVehicles",
    SoidJourneyMarkDatesFull = "soidJourneyMarkDatesFull",
    SoidDirectionsSource = "soidDirectionsSource",
    SoidAddressingSource = "soidAddressingSource",
    SoidAddReturnToStart = "soidAddReturnToStart",
    SoidCustomerMapPointFolder = "soidCustomerMapPointFolder",
    SoidDirectionsGoogleMapsURL = "soidDirectionsGoogleMapsURL",
    SoidDirectionsBingMapsURL = "soidDirectionsBingMapsURL",
    SoidDirectionsAddressPattern = "soidDirectionsAddressPattern",
    SoidVehicleTrackingSoftwareService = "soidVehicleTrackingSoftwareService",
    SoidVehicleTrackingWebServiceLocation = "soidVehicleTrackingWebServiceLocation",
    SoidVehicleTrackingClientAccessCode = "soidVehicleTrackingClientAccessCode",
    SoidVehicleTrackingSpeedSuffix = "soidVehicleTrackingSpeedSuffix",
    SoidVehicleTrackingClientPassword = "soidVehicleTrackingClientPassword",
    SoidVehicleTrackingInternetMapURL = "soidVehicleTrackingInternetMapURL",
    SoidCustomerAddressMapGridSettings = "soidCustomerAddressMapGridSettings",
    SoidPassAddressCoordinatesForInternetMapping = "soidPassAddressCoordinatesForInternetMapping",
    SoidShowMapDirectlySkippingVehicleLocationForm = "soidShowMapDirectlySkippingVehicleLocationForm",
    SoidDirectionsGMapsDirectionsURL = "soidDirectionsGMapsDirectionsURL",
    SoidDirectionsGMapsDirectionsKey = "soidDirectionsGMapsDirectionsKey",
    SoidWorksOrderWasteWarning = "soidWorksOrderWasteWarning",
    SoidDefaultToManufactured = "soidDefaultToManufactured",
    SoidWorksOrderPrintOnChange = "soidWorksOrderPrintOnChange",
    SoidWorksOrderEnableCalendarScheduling = "soidWorksOrderEnableCalendarScheduling",
    SoidWorksOrderConsolidateIdenticalWOProcessesOnWOSchedule = "soidWorksOrderConsolidateIdenticalWOProcessesOnWOSchedule",
    SoidWorksOrderHybridCostingWarning = "soidWorksOrderHybridCostingWarning",
    SoidWorksOrderSourcePrefixText = "soidWorksOrderSourcePrefixText",
    SoidWorksOrderNewLineAfterSourcePrefix = "soidWorksOrderNewLineAfterSourcePrefix",
    SoidWorksOrderProcessPrefixText = "soidWorksOrderProcessPrefixText",
    SoidWorksOrderFinishedPrefixText = "soidWorksOrderFinishedPrefixText",
    SoidWorksOrderNewLineAfterFinishedPrefix = "soidWorksOrderNewLineAfterFinishedPrefix",
    SoidWorksOrderSOWaitForStock = "soidWorksOrderSOWaitForStock",
    SoidWorksOrderAllowProcessingIfCreditControl = "soidWorksOrderAllowProcessingIfCreditControl",
    SoidWorksOrderAllowFinishCostOverride = "soidWorksOrderAllowFinishCostOverride",
    SoidWorksOrderCreateProductsOnManufactured = "soidWorksOrderCreateProductsOnManufactured",
    SoidWorksOrderForceCreateOnManufactured = "soidWorksOrderForceCreateOnManufactured",
    SoidCreateGLTransactionsWorksOrder = "soidCreateGLTransactionsWorksOrder",
    SoidWorksOrderBaseSpecialOnProdGroupID = "soidWorksOrderBaseSpecialOnProdGroupID",
    SoidWorksOrderIgnoreHowSourcedOnSpecials = "soidWorksOrderIgnoreHowSourcedOnSpecials",
    SoidCreateGLTransactionsCOGS = "soidCreateGLTransactionsCOGS",
    SoidCreateGLTransactionsStockTransfer = "soidCreateGLTransactionsStockTransfer",
    SoidCreateGLTransactionsSupplierReturns = "soidCreateGLTransactionsSupplierReturns",
    SoidWorksOrderTrussDescription = "soidWorksOrderTrussDescription",
    SoidFinancialDescAppendDocRef = "soidFinancialDescAppendDocRef",
    SoidWorksOrderAutoCopySourceToFinished = "soidWorksOrderAutoCopySourceToFinished",
    SoidWorksOrderAllowMultiplePacksWhenConfirmingSourceMaterialPacks = "soidWorksOrderAllowMultiplePacksWhenConfirmingSourceMaterialPacks",
    SoidWorksOrderEnablePCMInterface = "soidWorksOrderEnablePCMInterface",
    SoidWorksOrderPCMInputFileLocation = "soidWorksOrderPCMInputFileLocation",
    SoidWorksOrderPCMOutputFileLocation = "soidWorksOrderPCMOutputFileLocation",
    SoidWorksOrderPCMPackRefDestination = "soidWorksOrderPCMPackRefDestination",
    SoidWorksOrderPCMPackPrefix = "soidWorksOrderPCMPackPrefix",
    SoidWorksOrderPCMDescriptionField = "soidWorksOrderPCMDescriptionField",
    SoidWorksOrderUseDocumentReleaseProcess = "soidWorksOrderUseDocumentReleaseProcess",
    SoidWorksOrderAlwaysReplaceForConfirmPacks = "soidWorksOrderAlwaysReplaceForConfirmPacks",
    SoidWorksOrderDefaultLinesFromSalesOrderWOCreation = "soidWorksOrderDefaultLinesFromSalesOrderWOCreation",
    SoidWorksOrderAllowPartProcessing = "soidWorksOrderAllowPartProcessing",
    SoidWorksOrderCopyAVONotesToOverheadPOManualLineDescription = "soidWorksOrderCopyAVONotesToOverheadPOManualLineDescription",
    SoidWorksOrderProcessDefaultManualLineType = "soidWorksOrderProcessDefaultManualLineType",
    SoidWorksOrderCombineAVOsIntoSinglePurchaseOrder = "soidWorksOrderCombineAVOsIntoSinglePurchaseOrder",
    SoidWorksOrderAllowProcessingWorksOrderAwaitingSourceMaterial = "soidWorksOrderAllowProcessingWorksOrderAwaitingSourceMaterial",
    SoidWorksOrderReviewSuppliersForPOCreatedFromWO = "soidWorksOrderReviewSuppliersForPOCreatedFromWO",
    SoidWorksOrderForceSourceSelectionForPartProcess = "soidWorksOrderForceSourceSelectionForPartProcess",
    SoidWorksOrderUseProcessWorkflow = "soidWorksOrderUseProcessWorkflow",
    SoidWorksOrderSuppressWorkflowPOPrint = "soidWorksOrderSuppressWorkflowPOPrint",
    SoidWorksOrderProcessPickingFormatSet = "soidWorksOrderProcessPickingFormatSet",
    SoidWorksOrderProcessDeliveryFormatSet = "soidWorksOrderProcessDeliveryFormatSet",
    SoidWorksOrderProcessCollectionFormatSet = "soidWorksOrderProcessCollectionFormatSet",
    SoidWorksOrderProcessReceiptFormatSet = "soidWorksOrderProcessReceiptFormatSet",
    SoidWorksOrderDefaultProcessWorksOrder = "soidWorksOrderDefaultProcessWorksOrder",
    SoidWorksOrderFromOrderRequiredDays = "soidWorksOrderFromOrderRequiredDays",
    SoidWorksOrderAllowDifferentAVOCurrency = "soidWorksOrderAllowDifferentAVOCurrency",
    SoidWorksOrderProcessReadyForCollectionFormatSet = "soidWorksOrderProcessReadyForCollectionFormatSet",
    SoidWorksOrderDefaultSourceProductsDisplayCostOnCreationToStandardBuy = "soidWorksOrderDefaultSourceProductsDisplayCostOnCreationToStandardBuy",
    SoidWorksOrderAllowOnJourneyIfHasWorkflow = "soidWorksOrderAllowOnJourneyIfHasWorkflow",
    SoidWorksOrderAutoSplitPacksDuringConfirmation = "soidWorksOrderAutoSplitPacksDuringConfirmation",
    SoidWorksOrderDefaultAVOsToSpreadCostToLinesTheyAreBasedOn = "soidWorksOrderDefaultAVOsToSpreadCostToLinesTheyAreBasedOn",
    SoidWorksOrderAllowBranchChangeWhenAllocated = "soidWorksOrderAllowBranchChangeWhenAllocated",
    SoidWorksOrderAlwaysAllocateStockWhenCopying = "soidWorksOrderAlwaysAllocateStockWhenCopying",
    SoidWorksOrderUpdateDateRequiredWhenSODateRequiredChanges = "soidWorksOrderUpdateDateRequiredWhenSODateRequiredChanges",
    SoidWorksOrderSetSpecialDescriptionFromFinishedLine = "soidWorksOrderSetSpecialDescriptionFromFinishedLine",
    SoidWorksOrderDisplay_BF_SF_LF_MachineSchedule = "soidWorksOrderDisplay_BF_SF_LF_MachineSchedule",
    SoidWorksOrderAveCostAdjReasonForProcessCostAppliedToSO = "soidWorksOrderAveCostAdjReasonForProcessCostAppliedToSO",
    SoidWorksOrderSalesOrderAVOForProcessCostAppliedToSO = "soidWorksOrderSalesOrderAVOForProcessCostAppliedToSO",
    SoidWorksOrderDefaultNewWOCreation = "soidWorksOrderDefaultNewWOCreation",
    SoidWorksOrderPromptToProcessUponScheduleCompletion = "soidWorksOrderPromptToProcessUponScheduleCompletion",
    SoidWorksOrderDefaultApplyProcessCostsToLinesOnWOCreatedFromSO = "soidWorksOrderDefaultApplyProcessCostsToLinesOnWOCreatedFromSO",
    SoidWorksOrderShowStockWarningOnWOGeneratedFromSO = "soidWorksOrderShowStockWarningOnWOGeneratedFromSO",
    SoidWorksOrderAllowProcessingIfSourceMaterialStockWillGoNegative = "soidWorksOrderAllowProcessingIfSourceMaterialStockWillGoNegative",
    SoidWorksOrderPromptToPrintLabelsForTaggedPacksWhenWOCompleted = "soidWorksOrderPromptToPrintLabelsForTaggedPacksWhenWOCompleted",
    SoidWorksOrderPromptToPrintLabelsForTaggedPacksWhenWOProcessed = "soidWorksOrderPromptToPrintLabelsForTaggedPacksWhenWOProcessed",
    SoidWorksOrderAlwaysCalculateRequiredDateOnCreation = "soidWorksOrderAlwaysCalculateRequiredDateOnCreation",
    SoidWorksOrderSalesOrderAVOForWasteCosts = "soidWorksOrderSalesOrderAVOForWasteCosts",
    SoidWorksOrderAveCostAdjReasonForWasteCosts = "soidWorksOrderAveCostAdjReasonForWasteCosts",
    SoidStockReceiptPrintOnChange = "soidStockReceiptPrintOnChange",
    SoidStockReceiptsPreentered = "soidStockReceiptsPreentered",
    SoidStockreceiptQtyOverReceivedWarningThreshold = "soidStockreceiptQtyOverReceivedWarningThreshold",
    SoidStockReceiptRetainERWhenReceivingPreEnteredPacks = "soidStockReceiptRetainERWhenReceivingPreEnteredPacks",
    SoidStockreceiptQtyUnderReceivedWarningThreshold = "soidStockreceiptQtyUnderReceivedWarningThreshold",
    SoidStockReceiptAutoPrintLabels = "soidStockReceiptAutoPrintLabels",
    SoidStockReceiptsRequiresDeliveryDetails = "soidStockReceiptsRequiresDeliveryDetails",
    SoidStockReceiptsRequiresHaulierDetails = "soidStockReceiptsRequiresHaulierDetails",
    SoidStockReceiptsInAdvanceAffectOnOrder = "soidStockReceiptsInAdvanceAffectOnOrder",
    SoidStockReceiptsQuickAddInputStyle = "soidStockReceiptsQuickAddInputStyle",
    SoidStockReceiptBackdateERWhenBackdating = "soidStockReceiptBackdateERWhenBackdating",
    SoidStockReceiptRequireBinForSpecials = "soidStockReceiptRequireBinForSpecials",
    SoidInvoiceLowMarginCollected = "soidInvoiceLowMarginCollected",
    SoidInvoiceLowMarginDelivered = "soidInvoiceLowMarginDelivered",
    SoidInvoiceLowMarginDirect = "soidInvoiceLowMarginDirect",
    SoidInvoiceHighMargin = "soidInvoiceHighMargin",
    SoidDefaultInvoicePaymentMethod = "soidDefaultInvoicePaymentMethod",
    SoidDefaultInvoicePaymentTerms = "soidDefaultInvoicePaymentTerms",
    SoidIncludeOrderTextLinesInInvoice = "soidIncludeOrderTextLinesInInvoice",
    SoidDefaultInvoiceBrowserFilterToUnreleased = "soidDefaultInvoiceBrowserFilterToUnreleased",
    SoidInvoiceOnMarkDelivered = "soidInvoiceOnMarkDelivered",
    SoidAllowUpdatesOfUnreleasedInvoices = "soidAllowUpdatesOfUnreleasedInvoices",
    SoidInvoiceAllowEditInternalNotesAfterCompletion = "soidInvoiceAllowEditInternalNotesAfterCompletion",
    SoidInvoiceSendSeparateInvoicesForEachJob = "soidInvoiceSendSeparateInvoicesForEachJob",
    SoidDefaultInvoiceCostAdjustmentReason = "soidDefaultInvoiceCostAdjustmentReason",
    SoidAllowInvoiceToBeSentType = "soidAllowInvoiceToBeSentType",
    SoidOnlyMarkInvoicesSentFromBrowser = "soidOnlyMarkInvoicesSentFromBrowser",
    SoidOrdersAutoInvoiceCollectNowChargeOrdersOnCompletion = "soidOrdersAutoInvoiceCollectNowChargeOrdersOnCompletion",
    SoidOrdersMarkCollectNowChargeOrdersAsSentWhenInvoicingOnCompletion = "soidOrdersMarkCollectNowChargeOrdersAsSentWhenInvoicingOnCompletion",
    SoidOrdersAutoInvoiceCollectLaterChargeOrdersOnCompletion = "soidOrdersAutoInvoiceCollectLaterChargeOrdersOnCompletion",
    SoidInvoiceAutoApproveIfIssued = "soidInvoiceAutoApproveIfIssued",
    SoidInvoiceAutoSetDateTo = "soidInvoiceAutoSetDateTo",
    SoidInvoiceAutoOnlyIfOrderStatusIsInvoicing = "soidInvoiceAutoOnlyIfOrderStatusIsInvoicing",
    SoidCreditDefaultReturnStockToZero = "soidCreditDefaultReturnStockToZero",
    SoidCreditReturnStockToReceivingBranch = "soidCreditReturnStockToReceivingBranch",
    SoidCreditAllowSettlementDiscount = "soidCreditAllowSettlementDiscount",
    SoidCreditUserMustReconfirmPassword = "soidCreditUserMustReconfirmPassword",
    SoidCreditRefundAmountToForceCompanyCheque = "soidCreditRefundAmountToForceCompanyCheque",
    SoidCreditCalculateSellPriceManualLine = "soidCreditCalculateSellPriceManualLine",
    SoidCreditApplyRestockChargeToOwnBrandProducts = "soidCreditApplyRestockChargeToOwnBrandProducts",
    SoidCreditFullRestockChargeOnSpecials = "soidCreditFullRestockChargeOnSpecials",
    SoidCreditLockCashRefundsToOriginalPayment = "soidCreditLockCashRefundsToOriginalPayment",
    SoidCreditUseCustomerCreditsForCustomerReturns = "soidCreditUseCustomerCreditsForCustomerReturns",
    SoidCreditRefundAmountToForceGiftCard = "soidCreditRefundAmountToForceGiftCard",
    SoidCreditRefundChequeFormat = "soidCreditRefundChequeFormat",
    SoidCreditReturnToSupplierOnDirect = "soidCreditReturnToSupplierOnDirect",
    SoidCreditConfirmRefundAddress = "soidCreditConfirmRefundAddress",
    SoidCreditNoteRequestFormatNumber = "soidCreditNoteRequestFormatNumber",
    SoidCreditRefundAllowCompanyCheque = "soidCreditRefundAllowCompanyCheque",
    SoidCreditAllowPrintFinalDocumentOnRelease = "soidCreditAllowPrintFinalDocumentOnRelease",
    SoidCreditSearchInvoicesByOrderNumber = "soidCreditSearchInvoicesByOrderNumber",
    SoidCreditAllowUnpaidCustomerCredits = "soidCreditAllowUnpaidCustomerCredits",
    SoidCreditAllowSalesOrderCreationFromCreditNotes = "soidCreditAllowSalesOrderCreationFromCreditNotes",
    SoidCreditDefaultReturnStockToZeroFromProductsPurchased = "soidCreditDefaultReturnStockToZeroFromProductsPurchased",
    SoidCreditUseTakenByFromLinkedInvoiceForSalesAnalysis = "soidCreditUseTakenByFromLinkedInvoiceForSalesAnalysis",
    SoidCreditDoNotAllowReturnToStockCreditNotesBackToVMIPrograms = "soidCreditDoNotAllowReturnToStockCreditNotesBackToVMIPrograms",
    SoidCreditRefundAlwaysAllowCompanyCheque = "soidCreditRefundAlwaysAllowCompanyCheque",
    SoidCreditUpdateQuantityCreditedAtTimeOfCreditCreation = "soidCreditUpdateQuantityCreditedAtTimeOfCreditCreation",
    SoidCreditDefaultHandling = "soidCreditDefaultHandling",
    SoidCreditAlwaysUseARCustomerFromAddress = "soidCreditAlwaysUseARCustomerFromAddress",
    SoidCreditAllowQuantityLessThanReturnToStockQuantity = "soidCreditAllowQuantityLessThanReturnToStockQuantity",
    SoidCreditAutoApproveCreditNoteOnCompletionWhenStockReturned = "soidCreditAutoApproveCreditNoteOnCompletionWhenStockReturned",
    SoidCreditWMSRefuseOnTruckReasonCode = "soidCreditWMSRefuseOnTruckReasonCode",
    SoidCreditWMSRefuseOnTruckReasonCodeCash = "soidCreditWMSRefuseOnTruckReasonCodeCash",
    SoidCreditWMSUpdateCreditQuantity = "soidCreditWMSUpdateCreditQuantity",
    SoidCreditPostSalesAndCOGSToInvoiceBranch = "soidCreditPostSalesAndCOGSToInvoiceBranch",
    SoidCreditRebillCreditNoteReason = "soidCreditRebillCreditNoteReason",
    SoidCreditRebillCashRefundReason = "soidCreditRebillCashRefundReason",
    SoidCreditDefaultCreditNoteLinesToIncludeAVOCost = "soidCreditDefaultCreditNoteLinesToIncludeAVOCost",
    SoidCreditRequireCashRefundAuthorization = "soidCreditRequireCashRefundAuthorization",
    SoidCreditSignatureCaptureForReturnToBranch = "soidCreditSignatureCaptureForReturnToBranch",
    SoidCreditReasonCodeToUseForContractBillingCreditNotes = "soidCreditReasonCodeToUseForContractBillingCreditNotes",
    SoidCreditReasonCodeToUseForContractBillingCashRefunds = "soidCreditReasonCodeToUseForContractBillingCashRefunds",
    SoidCreditCopyCustomerAddressNotesIntoDescription = "soidCreditCopyCustomerAddressNotesIntoDescription",
    SoidCreditDefaultProductsPurchasedDateSearch = "soidCreditDefaultProductsPurchasedDateSearch",
    SoidCreditPrintCreditFormatFromCashRefund = "soidCreditPrintCreditFormatFromCashRefund",
    SoidCreditLimitInvoiceAndProductPurchasedSearchesToTheJobOnCreditNotes = "soidCreditLimitInvoiceAndProductPurchasedSearchesToTheJobOnCreditNotes",
    SoidCashDrawerCOMEnabled = "soidCashDrawerCOMEnabled",
    SoidCashDrawerDefaultClosingFloat = "soidCashDrawerDefaultClosingFloat",
    SoidUpdateLCPOnPurchaseOrderUpdate = "soidUpdateLCPOnPurchaseOrderUpdate",
    SoidUpdateLCPOnStockReceiptUpdate = "soidUpdateLCPOnStockReceiptUpdate",
    SoidUpdateLCPOnSupplierInvoiceApprove = "soidUpdateLCPOnSupplierInvoiceApprove",
    SoidUpdateLCPOnWorksOrderProcess = "soidUpdateLCPOnWorksOrderProcess",
    SoidIncludeProratedManualCostsInACP = "soidIncludeProratedManualCostsInACP",
    SoidIncludeProratedManualCostsInLCP = "soidIncludeProratedManualCostsInLCP",
    SoidUpdateLCPOnStockTransferReceipt = "soidUpdateLCPOnStockTransferReceipt",
    SoidInventoryAgingAnnualCostRate = "soidInventoryAgingAnnualCostRate",
    SoidFreeDaysBeforeAgingApplies = "soidFreeDaysBeforeAgingApplies",
    SoidSkipUpdateACPOnSupplierInvoiceApprove = "soidSkipUpdateACPOnSupplierInvoiceApprove",
    SoidTurnOffProduceInvoiceOnCOD = "soidTurnOffProduceInvoiceOnCOD",
    SoidVolumeDisplayUnitInOrderSummary = "soidVolumeDisplayUnitInOrderSummary",
    SoidDisplayVolumeAreaLengthInOrderSummary = "soidDisplayVolumeAreaLengthInOrderSummary",
    SoidSalesAndPOLineVolumeDisplayPer = "soidSalesAndPOLineVolumeDisplayPer",
    SoidSalesAndPOLineAreaDisplayPer = "soidSalesAndPOLineAreaDisplayPer",
    SoidSalesAndPOLineLengthDisplayPer = "soidSalesAndPOLineLengthDisplayPer",
    SoidEnableVMIProcessingUseThisOne = "soidEnableVMIProcessingUseThisOne",
    SoidShowReelFunctionality = "soidShowReelFunctionality",
    SoidDefaultNotepadCaseStatus = "soidDefaultNotepadCaseStatus",
    SoidAllowVMIPRulesThatAreCalculatedFromSellPrice = "soidAllowVMIPRulesThatAreCalculatedFromSellPrice",
    SoidUseEstimateCostsOnlyOnAdditionalCostCalcs = "soidUseEstimateCostsOnlyOnAdditionalCostCalcs",
    SoidUpdateCostsOnSupplierInvoiceWhenStockReceiptPreEntered = "soidUpdateCostsOnSupplierInvoiceWhenStockReceiptPreEntered",
    SoidAlwaysProrateAdditionalCostsBySellPrice = "soidAlwaysProrateAdditionalCostsBySellPrice",
    SoidInventoryValueNetOfSupplierDiscount = "soidInventoryValueNetOfSupplierDiscount",
    SoidNumberOfCostDiscountFields = "soidNumberOfCostDiscountFields",
    SoidSetAverageCostsOnSpecialOrderCreation = "soidSetAverageCostsOnSpecialOrderCreation",
    SoidEnableCostDiscountFieldsOnDirects = "soidEnableCostDiscountFieldsOnDirects",
    SoidPOCostControlledByPermission = "soidPOCostControlledByPermission",
    SoidPPVCalculation = "soidPPVCalculation",
    SoidReasonCodeForPPVWhenCreatingAutoACA = "soidReasonCodeForPPVWhenCreatingAutoACA",
    SoidIntrastatSupplierDefaultDeliveryTerms = "soidIntrastatSupplierDefaultDeliveryTerms",
    SoidIntrastatSupplierDefaultModeOfTransport = "soidIntrastatSupplierDefaultModeOfTransport",
    SoidIntrastatCustomerDefaultDeliveryTerms = "soidIntrastatCustomerDefaultDeliveryTerms",
    SoidIntrastatCustomerDefaultModeOfTransport = "soidIntrastatCustomerDefaultModeOfTransport",
    SoidIntrastatIntegration = "soidIntrastatIntegration",
    SoidDefaultProductStockClass = "soidDefaultProductStockClass",
    SoidProductDefaultSpecialsToKeepStockFigures = "soidProductDefaultSpecialsToKeepStockFigures",
    SoidEnablePermissionsByProductTab = "soidEnablePermissionsByProductTab",
    SoidProductShowAveCostInBuyPer = "soidProductShowAveCostInBuyPer",
    SoidNoOfProductImages = "soidNoOfProductImages",
    SoidProductImageNames = "soidProductImageNames",
    SoidDefaultProductHistoryDays = "soidDefaultProductHistoryDays",
    SoidProductShowCompanyStockInFindProducts = "soidProductShowCompanyStockInFindProducts",
    SoidProductEnableProductManagerNotifications = "soidProductEnableProductManagerNotifications",
    SoidProductDefaultSpecialsProductGroup = "soidProductDefaultSpecialsProductGroup",
    SoidProductAlternativeSupplierPriceWeeks = "soidProductAlternativeSupplierPriceWeeks",
    SoidProductEditProductGroupAffectsSalesAnalysis = "soidProductEditProductGroupAffectsSalesAnalysis",
    SoidProductQtyInFindProductsToRead = "soidProductQtyInFindProductsToRead",
    SoidProductEnablePrintingofZebraLabels = "soidProductEnablePrintingofZebraLabels",
    SoidProductAllowDuplicateBarcodes = "soidProductAllowDuplicateBarcodes",
    SoidProductSupplierPricesInSupplierCurrency = "soidProductSupplierPricesInSupplierCurrency",
    SoidProductDefaultStocked = "soidProductDefaultStocked",
    SoidProductDefaultAllowSpecialsBasedOnThis = "soidProductDefaultAllowSpecialsBasedOnThis",
    SoidProductRequireWeightOnProductsAndSpecials = "soidProductRequireWeightOnProductsAndSpecials",
    SoidProductRequireEnvironmentalStatusOnSpecials = "soidProductRequireEnvironmentalStatusOnSpecials",
    SoidProductUpdateStandardBranchPricesWithCompanyPrices = "soidProductUpdateStandardBranchPricesWithCompanyPrices",
    SoidProductSkipDetailsOnAutoCreatedPurchasedSpecials = "soidProductSkipDetailsOnAutoCreatedPurchasedSpecials",
    SoidProductLimitSellingPriceBandsToSpecificBranches = "soidProductLimitSellingPriceBandsToSpecificBranches",
    SoidProductLimitStockOptionsToBranchesWithUpdateAccess = "soidProductLimitStockOptionsToBranchesWithUpdateAccess",
    SoidProductDefaultSalesTabToCurrentBranch = "soidProductDefaultSalesTabToCurrentBranch",
    SoidProductDefaultSalesTabToLast12Months = "soidProductDefaultSalesTabToLast12Months",
    SoidProductSetupSellingQuantityBreakByBranch = "soidProductSetupSellingQuantityBreakByBranch",
    SoidProductSetupPickingRequiredByBranch = "soidProductSetupPickingRequiredByBranch",
    SoidProductSetupAllowSettlementDiscountByBranch = "soidProductSetupAllowSettlementDiscountByBranch",
    SoidProductAllowChangingProductCodeOnSpecialOrderCreation = "soidProductAllowChangingProductCodeOnSpecialOrderCreation",
    SoidProductSetSellEntireRelatedSet = "soidProductSetSellEntireRelatedSet",
    SoidProductSetSelectDefaultToExpanded = "soidProductSetSelectDefaultToExpanded",
    SoidProductDefaultNewSpecialProductToBranchCreating = "soidProductDefaultNewSpecialProductToBranchCreating",
    SoidProductDefaultShortDescriptionToDescriptionOnSpecialOrderCreation = "soidProductDefaultShortDescriptionToDescriptionOnSpecialOrderCreation",
    SoidProductCopyPopupTextOnSpecialOrderCreation = "soidProductCopyPopupTextOnSpecialOrderCreation",
    SoidImportProductFollowBranchAccessPermissions = "soidImportProductFollowBranchAccessPermissions",
    SoidConvertTalliesToSpecialInstructions = "soidConvertTalliesToSpecialInstructions",
    SoidDefaultDocumentPresentation = "soidDefaultDocumentPresentation",
    SoidAddManufacturedKitToExistingWO = "soidAddManufacturedKitToExistingWO",
    SoidDefaultHideOnWorksOrders = "soidDefaultHideOnWorksOrders",
    SoidKitsSelectionImageNumber = "soidKitsSelectionImageNumber",
    SoidEnableStandardKitPromotions = "soidEnableStandardKitPromotions",
    SoidABCDStockClassCalculationBasedOn = "soidABCDStockClassCalculationBasedOn",
    SoidNumberOfMonthsToBaseRankingsOn = "soidNumberOfMonthsToBaseRankingsOn",
    SoidNumberOfMonthsOfSalesBeforeRanking = "soidNumberOfMonthsOfSalesBeforeRanking",
    SoidStockClassARanking = "soidStockClassARanking",
    SoidStockClassBRanking = "soidStockClassBRanking",
    SoidStockClassCRanking = "soidStockClassCRanking",
    SoidStockClassDRanking = "soidStockClassDRanking",
    SoidRankInComparisonToProductGroupLevel = "soidRankInComparisonToProductGroupLevel",
    SoidSearchingIncludeOrderFindSupplierFields = "soidSearchingIncludeOrderFindSupplierFields",
    SoidHighlightOwnBrandProducts = "soidHighlightOwnBrandProducts",
    SoidExcludeBarcodeInOrderProductFind = "soidExcludeBarcodeInOrderProductFind",
    SoidUseExactProductCodeSearchOnCollectNow = "soidUseExactProductCodeSearchOnCollectNow",
    SoidSearchingSortFindDocumentFilterLists = "soidSearchingSortFindDocumentFilterLists",
    SoidSearchingUseIssuingBranch = "soidSearchingUseIssuingBranch",
    SoidBarcodePrefix = "soidBarcodePrefix",
    SoidUseAdditionalBarcodesInOrderProductFind = "soidUseAdditionalBarcodesInOrderProductFind",
    SoidSearchingFindDocsDeliveryAreaSearchStyle = "soidSearchingFindDocsDeliveryAreaSearchStyle",
    SoidSearchingTrimSearchText = "soidSearchingTrimSearchText",
    SoidSearchMOLTsInProductFindInOrderEntry = "soidSearchMOLTsInProductFindInOrderEntry",
    SoidSearchCouponsInProductFindInOrderEntry = "soidSearchCouponsInProductFindInOrderEntry",
    SoidSearchingDeliveryAreaSearchStyle = "soidSearchingDeliveryAreaSearchStyle",
    SoidAllowCustomerProductReference = "soidAllowCustomerProductReference",
    SoidSupplierReturnEnable = "soidSupplierReturnEnable",
    SoidSupplierReturnAlwaysDefaultCostToAverageCostWithAdd = "soidSupplierReturnAlwaysDefaultCostToAverageCostWithAdd",
    SoidSupplierReturnAllowBranchChangeWhenLinkedToDocument = "soidSupplierReturnAllowBranchChangeWhenLinkedToDocument",
    SoidSupplierReturnUseAccountsPayableGLCodeFromLinkedDocument = "soidSupplierReturnUseAccountsPayableGLCodeFromLinkedDocument",
    SoidSupplierReturnAllowInspectAfterPickup = "soidSupplierReturnAllowInspectAfterPickup",
    SoidOrdersPricingSpecialPriceMessage = "soidOrdersPricingSpecialPriceMessage",
    SoidOrdersPricingSpecialPriceMessageColour = "soidOrdersPricingSpecialPriceMessageColour",
    SoidOrdersPricingUseDeferredDiscountInCostCalc = "soidOrdersPricingUseDeferredDiscountInCostCalc",
    SoidPricingUseOrderCostForSpecialBackToBack = "soidPricingUseOrderCostForSpecialBackToBack",
    SoidSalesOrderSecondaryCostCalculation = "soidSalesOrderSecondaryCostCalculation",
    SoidPricingUseQuotePriceUnlessRuleExists = "soidPricingUseQuotePriceUnlessRuleExists",
    SoidPricingRecostOrderOn = "soidPricingRecostOrderOn",
    SoidPricingUseLastSellPriceWithin = "soidPricingUseLastSellPriceWithin",
    SoidOrdersPricingQuotePriceMessage = "soidOrdersPricingQuotePriceMessage",
    SoidOrdersPricingQuotePriceMessageColour = "soidOrdersPricingQuotePriceMessageColour",
    SoidOrdersPricingLastSellPriceMessage = "soidOrdersPricingLastSellPriceMessage",
    SoidOrdersPricingLastSellPriceMessageColour = "soidOrdersPricingLastSellPriceMessageColour",
    SoidCostDefaultQuoteToStandardBuy = "soidCostDefaultQuoteToStandardBuy",
    SoidCostDefaultTemplateOrderToStandardBuy = "soidCostDefaultTemplateOrderToStandardBuy",
    SoidOrdersPricingCheckIfCallOffExists = "soidOrdersPricingCheckIfCallOffExists",
    SoidPricingUseQuotePriceAlways = "soidPricingUseQuotePriceAlways",
    SoidOrdersLastSellPriceIsBranchSpecific = "soidOrdersLastSellPriceIsBranchSpecific",
    SoidOrdersPricingLumpSumQtySell = "soidOrdersPricingLumpSumQtySell",
    SoidOrdersPricingLumpSumQtyCost = "soidOrdersPricingLumpSumQtyCost",
    SoidOrdersPricingShowLastPOPriceInNegotiation = "soidOrdersPricingShowLastPOPriceInNegotiation",
    SoidOrdersPricingPOPriceOutOfDateDays = "soidOrdersPricingPOPriceOutOfDateDays",
    SoidOrdersPricingShowContributionOnOrders = "soidOrdersPricingShowContributionOnOrders",
    SoidOrdersPricingUseDeferredDiscountInLastCostCalc = "soidOrdersPricingUseDeferredDiscountInLastCostCalc",
    SoidOrdersPricingUseDeferredDiscountInAverageCostCalc = "soidOrdersPricingUseDeferredDiscountInAverageCostCalc",
    SoidOrdersPricingRecostBackToBackOrders = "soidOrdersPricingRecostBackToBackOrders",
    SoidOrdersPricingPromotionPointsPer = "soidOrdersPricingPromotionPointsPer",
    SoidOrdersPricingPromotionCalculateAfterDeliveryCharges = "soidOrdersPricingPromotionCalculateAfterDeliveryCharges",
    SoidOrdersPricingAllowNegotiateIfNoMarginOptions = "soidOrdersPricingAllowNegotiateIfNoMarginOptions",
    SoidOrdersPricingPromotionExcludeAbsolutePriceLines = "soidOrdersPricingPromotionExcludeAbsolutePriceLines",
    SoidOrdersPricingPromotionExcludeDirects = "soidOrdersPricingPromotionExcludeDirects",
    SoidOrdersPricingPromptToChangePriceOnIdenticalItems = "soidOrdersPricingPromptToChangePriceOnIdenticalItems",
    SoidOrdersPricingDefaultReplaceExistingLineDiscounts = "soidOrdersPricingDefaultReplaceExistingLineDiscounts",
    SoidOrdersPricingDefaultPriceRulesToCalculateDiscountsIntoUnitPrice = "soidOrdersPricingDefaultPriceRulesToCalculateDiscountsIntoUnitPrice",
    SoidOrdersPricingUseInternalCostInMarginCalcs = "soidOrdersPricingUseInternalCostInMarginCalcs",
    SoidOrdersPricingUseInternalCostRules = "soidOrdersPricingUseInternalCostRules",
    SoidOrdersPricingApplyPriceRoundingWhenManuallyPricingLines = "soidOrdersPricingApplyPriceRoundingWhenManuallyPricingLines",
    SoidOrdersPricingDefaultCostToZeroOnDirectSalesOrders = "soidOrdersPricingDefaultCostToZeroOnDirectSalesOrders",
    SoidOrdersPricingShowLastPriceDates = "soidOrdersPricingShowLastPriceDates",
    SoidOrdersPricingShowNextPricesXDays = "soidOrdersPricingShowNextPricesXDays",
    SoidOrdersPricingManualPriceOnMarginNegotiation = "soidOrdersPricingManualPriceOnMarginNegotiation",
    SoidOrdersPricingShowPriceBandsOnNegotiation = "soidOrdersPricingShowPriceBandsOnNegotiation",
    SoidOrdersPricingShowInternalCostInfo = "soidOrdersPricingShowInternalCostInfo",
    SoidOrdersPricingEnsureAVOInclusiveSellPriceExtends = "soidOrdersPricingEnsureAVOInclusiveSellPriceExtends",
    SoidOrdersPricingOrderlinePriceInfoToDisplay = "soidOrdersPricingOrderlinePriceInfoToDisplay",
    SoidOrdersPricingUseInternalCostRulesOnDirects = "soidOrdersPricingUseInternalCostRulesOnDirects",
    SoidOrdersPricingCalculatePriceBandDiscountsIntoUnitPrice = "soidOrdersPricingCalculatePriceBandDiscountsIntoUnitPrice",
    SoidOrdersPricingDefaultUseBasedOnProductsOnNewPriceRules = "soidOrdersPricingDefaultUseBasedOnProductsOnNewPriceRules",
    SoidOrdersPricingPriceBandsUtilizeBasedOnProducts = "soidOrdersPricingPriceBandsUtilizeBasedOnProducts",
    SoidOrdersPricingRecalcSellPriceOnNonSpecialManKitRefresh = "soidOrdersPricingRecalcSellPriceOnNonSpecialManKitRefresh",
    SoidOrdersPricingApplyPriceRoundingWhenNegotiatingMargin = "soidOrdersPricingApplyPriceRoundingWhenNegotiatingMargin",
    SoidOrdersPricingEnableManagerOverrideOnOrderLinePrice = "soidOrdersPricingEnableManagerOverrideOnOrderLinePrice",
    SoidOrdersPricingRequireReasonCodeOnSalesLinePriceChange = "soidOrdersPricingRequireReasonCodeOnSalesLinePriceChange",
    SoidOrdersPricingAllowMultiplePromotionsPerLine = "soidOrdersPricingAllowMultiplePromotionsPerLine",
    SoidOrdersPricingShowMultiplierOnOrderLine = "soidOrdersPricingShowMultiplierOnOrderLine",
    SoidOrdersPricingRetainOriginalPriceCalc = "soidOrdersPricingRetainOriginalPriceCalc",
    SoidOrdersPricingDefaultCostPerToSellingPerOnSalesOrder = "soidOrdersPricingDefaultCostPerToSellingPerOnSalesOrder",
    SoidOrdersPricingControlFreeOfChargeLines = "soidOrdersPricingControlFreeOfChargeLines",
    SoidOrdersPricingManualPriceAlwaysClearsDiscounts = "soidOrdersPricingManualPriceAlwaysClearsDiscounts",
    SoidOrdersPricingRecordSalesNetOfDiscounts = "soidOrdersPricingRecordSalesNetOfDiscounts",
    SoidOrdersPricingApplySettlementDiscountToCashOrderLines = "soidOrdersPricingApplySettlementDiscountToCashOrderLines",
    SoidOrdersIncludeAdditionalChargeInOrderLineTotalPrice = "soidOrdersIncludeAdditionalChargeInOrderLineTotalPrice",
    SoidOrdersRepriceOrderLinesAtFixedMarginPctPerLine = "soidOrdersRepriceOrderLinesAtFixedMarginPctPerLine",
    SoidOrdersRoundUpSellPriceOnMarginNegotiate = "soidOrdersRoundUpSellPriceOnMarginNegotiate",
    SoidOrdersRoundDiscountDown = "soidOrdersRoundDiscountDown",
    SoidOrdersPricingAutoCreateInvoiceCostAdjForSpecials = "soidOrdersPricingAutoCreateInvoiceCostAdjForSpecials",
    SoidOrdersPricingDefaultRepriceProductsOnFindAndReplace = "soidOrdersPricingDefaultRepriceProductsOnFindAndReplace",
    SoidDefaultCostPerToLastCostWithAdditionalPerOnTransfers = "soidDefaultCostPerToLastCostWithAdditionalPerOnTransfers",
    SoidOrdersPricingSpecialPriceMessageOverride = "soidOrdersPricingSpecialPriceMessageOverride",
    SoidOrdersPricingApplyPriceRoundingAfterDelChargeIsAdded = "soidOrdersPricingApplyPriceRoundingAfterDelChargeIsAdded",
    SoidOrdersPricingKeepPricePerWhenSpecificPriceBandIsUsed = "soidOrdersPricingKeepPricePerWhenSpecificPriceBandIsUsed",
    SoidOrdersPricingRestoreCostOnSpecialProductsOnRecalculate = "soidOrdersPricingRestoreCostOnSpecialProductsOnRecalculate",
    SoidOrdersPricingDisplayMultiplierInPriceRulesAndSellingBands = "soidOrdersPricingDisplayMultiplierInPriceRulesAndSellingBands",
    SoidOrdersPricingShowCostAndSellPriceMultipliersOnSalesSpecialOrderCreation = "soidOrdersPricingShowCostAndSellPriceMultipliersOnSalesSpecialOrderCreation",
    SoidOrdersPricingRecostSalesTransactionsOnCopyFrom = "soidOrdersPricingRecostSalesTransactionsOnCopyFrom",
    SoidOrdersPricingAutoCreateInvoiceCostAdjForNonSpecials = "soidOrdersPricingAutoCreateInvoiceCostAdjForNonSpecials",
    SoidAllowMarkingSalesOrderLinesAsNetPriced = "soidAllowMarkingSalesOrderLinesAsNetPriced",
    SoidOrdersPricingDefaultCostOnBackToBackOrderLines = "soidOrdersPricingDefaultCostOnBackToBackOrderLines",
    SoidOrdersPricingAutoCreateInvoiceCostAdjForManProducts = "soidOrdersPricingAutoCreateInvoiceCostAdjForManProducts",
    SoidDefaultCalculationMethodForCostBasedSellingPriceRules = "soidDefaultCalculationMethodForCostBasedSellingPriceRules",
    SoidOrdersPricingAutoApplySellingPriceChangesNightly = "soidOrdersPricingAutoApplySellingPriceChangesNightly",
    SoidOrdersUseDefaultJobAddressPriceProfile = "soidOrdersUseDefaultJobAddressPriceProfile",
    SoidExcludePriceRoundingWhenUsingSpecialPriceRules = "soidExcludePriceRoundingWhenUsingSpecialPriceRules",
    SoidQuantityBreaksThatUseSpecificPriceBandWillOnlyUseDiscountFromThatBand = "soidQuantityBreaksThatUseSpecificPriceBandWillOnlyUseDiscountFromThatBand",
    SoidOrdersPricingAllowMultipleSpendXSaveYCouponPromotions = "soidOrdersPricingAllowMultipleSpendXSaveYCouponPromotions",
    SoidBranchPrinter1 = "soidBranchPrinter1",
    SoidBranchPrinter2 = "soidBranchPrinter2",
    SoidBranchPrinter3 = "soidBranchPrinter3",
    SoidBranchPrinter4 = "soidBranchPrinter4",
    SoidBranchPrinter5 = "soidBranchPrinter5",
    SoidBranchPrinter6 = "soidBranchPrinter6",
    SoidBranchPrinter7 = "soidBranchPrinter7",
    SoidBranchPrinter8 = "soidBranchPrinter8",
    SoidBranchPrinter9 = "soidBranchPrinter9",
    SoidBranchPrinter10 = "soidBranchPrinter10",
    SoidPrintingMaxDocument = "soidPrintingMaxDocument",
    SoidAlternatePrintDialog = "soidAlternatePrintDialog",
    SoidAllowDocumentPrintingFromPreview = "soidAllowDocumentPrintingFromPreview",
    SoidPrinterListMethod = "soidPrinterListMethod",
    SoidPrintingSortPrinterList = "soidPrintingSortPrinterList",
    SoidPrintingPrinterDisplayFormat = "soidPrintingPrinterDisplayFormat",
    SoidDepartmentPinter1 = "soidDepartmentPinter1",
    SoidDepartmentPinter2 = "soidDepartmentPinter2",
    SoidDepartmentPinter3 = "soidDepartmentPinter3",
    SoidDepartmentPinter4 = "soidDepartmentPinter4",
    SoidDepartmentPinter5 = "soidDepartmentPinter5",
    SoidDepartmentPinter6 = "soidDepartmentPinter6",
    SoidDepartmentPinter7 = "soidDepartmentPinter7",
    SoidDepartmentPinter8 = "soidDepartmentPinter8",
    SoidDepartmentPinter9 = "soidDepartmentPinter9",
    SoidDepartmentPinter10 = "soidDepartmentPinter10",
    SoidOrdersEnablePricingOptionToChangeSellingPriceUOM = "soidOrdersEnablePricingOptionToChangeSellingPriceUOM",
    SoidCustomersDefaultRefRequired = "soidCustomersDefaultRefRequired",
    SoidCustomersDefaultDropdownLists = "soidCustomersDefaultDropdownLists",
    SoidCustomersDefaultEnforceEnterOrderContact = "soidCustomersDefaultEnforceEnterOrderContact",
    SoidAllowCustomerSalesRepToBeOptional = "soidAllowCustomerSalesRepToBeOptional",
    SoidRemitToAddressRequiredOnDefaultAddress = "soidRemitToAddressRequiredOnDefaultAddress",
    SoidPreventDuplicateJobReferencesPerCustomer = "soidPreventDuplicateJobReferencesPerCustomer",
    SoidRestrictUpdatingCustomersToHomeBranch = "soidRestrictUpdatingCustomersToHomeBranch",
    SoidAutoAllocateJobNumbers = "soidAutoAllocateJobNumbers",
    SoidCustomersEnablePermissionsByTab = "soidCustomersEnablePermissionsByTab",
    SoidCustomersLimitSearchToHomeBranch = "soidCustomersLimitSearchToHomeBranch",
    SoidCustomersUseTaxExemptionsFromARCustomer = "soidCustomersUseTaxExemptionsFromARCustomer",
    SoidCustomersDefaultEnforceJobAddressOrderEntry = "soidCustomersDefaultEnforceJobAddressOrderEntry",
    SoidCustomersDefaultFinanceChargeAmountToNotSet = "soidCustomersDefaultFinanceChargeAmountToNotSet",
    SoidCustomerCopyInstructionsToTransactions = "soidCustomerCopyInstructionsToTransactions",
    SoidCustomerDefaultAllowOvertypeInvoiceAddress = "soidCustomerDefaultAllowOvertypeInvoiceAddress",
    SoidCustomerForceVerifyOfContactIdentification = "soidCustomerForceVerifyOfContactIdentification",
    SoidCustomerLimitContactsToThoseBasedAtDeliveryAddress = "soidCustomerLimitContactsToThoseBasedAtDeliveryAddress",
    SoidCustomerDisplayCustomerContactDefaultOnOrders = "soidCustomerDisplayCustomerContactDefaultOnOrders",
    SoidCustomerDefaultHomeBranchInCustomerFindToLoggedInBranch = "soidCustomerDefaultHomeBranchInCustomerFindToLoggedInBranch",
    SoidOptimizeCustomerAddressUsage = "soidOptimizeCustomerAddressUsage",
    SoidCustomerTypeLevel1 = "soidCustomerTypeLevel1",
    SoidCustomerTypeLevel2 = "soidCustomerTypeLevel2",
    SoidCustomersAutomaticallyGenerateProspectCode = "soidCustomersAutomaticallyGenerateProspectCode",
    SoidCustomerEnableContactLoyaltyCards = "soidCustomerEnableContactLoyaltyCards",
    SoidPreventDuplicateAddressCodesPerCustomer = "soidPreventDuplicateAddressCodesPerCustomer",
    SoidForceStateSelectionFromDropdown = "soidForceStateSelectionFromDropdown",
    SoidCustomerLimitContactsToThoseWhoCanAuthoriseSalesOrders = "soidCustomerLimitContactsToThoseWhoCanAuthoriseSalesOrders",
    SoidGenerateCustomerCodesStartingPoint = "soidGenerateCustomerCodesStartingPoint",
    SoidUseCounterSalesCashAliasCreationFormInBisTrack = "soidUseCounterSalesCashAliasCreationFormInBisTrack",
    SoidAutomaticallyGenerateCashCustomerAliasCode = "soidAutomaticallyGenerateCashCustomerAliasCode",
    SoidAutomaticallyApproveJobs = "soidAutomaticallyApproveJobs",
    SoidCustomerGenerateNewAddressCodeMethod = "soidCustomerGenerateNewAddressCodeMethod",
    SoidCopyInfoFromDefaultJobAddress = "soidCopyInfoFromDefaultJobAddress",
    SoidAddressValidationMethod = "soidAddressValidationMethod",
    SoidPasswordExpiryDays = "soidPasswordExpiryDays",
    SoidAllowNonAdministrativePasswordChange = "soidAllowNonAdministrativePasswordChange",
    SoidStaffNumberRestoreOriginalUser = "soidStaffNumberRestoreOriginalUser",
    SoidStaffNumberRequiredForNonSalesTransactions = "soidStaffNumberRequiredForNonSalesTransactions",
    SoidServerManagerBackupFolder = "soidServerManagerBackupFolder",
    SoidOrdersPricingRequireReasonCodeOnQuoteLinePriceChange = "soidOrdersPricingRequireReasonCodeOnQuoteLinePriceChange",
    SoidEmailFaxAllowEmailFromOrderCompletion = "soidEmailFaxAllowEmailFromOrderCompletion",
    SoidEmailFaxAllowEmailFromPurchaseOrderCompletion = "soidEmailFaxAllowEmailFromPurchaseOrderCompletion",
    SoidEmailFaxCCOtherSalesRepsOnOrderSend = "soidEmailFaxCCOtherSalesRepsOnOrderSend",
    SoidDefaultSalesOrderEmailAddressFromContactEmailAddress = "soidDefaultSalesOrderEmailAddressFromContactEmailAddress",
    SoidEmailFaxFaxMethod = "soidEmailFaxFaxMethod",
    SoidEmailFaxFaxAutoSendFolder = "soidEmailFaxFaxAutoSendFolder",
    SoidEmailFaxFaxEmailAddress = "soidEmailFaxFaxEmailAddress",
    SoidEmailUseSMTPForAllEmail = "soidEmailUseSMTPForAllEmail",
    SoidEmailUseTemplates = "soidEmailUseTemplates",
    SoidDatabaseMailProfileName = "soidDatabaseMailProfileName",
    SoidPrefaceEmailAddressWithContact = "soidPrefaceEmailAddressWithContact",
    SoidEmailFaxVsiFaxEmailNotifyOnEvent = "soidEmailFaxVsiFaxEmailNotifyOnEvent",
    SoidCashDrawerTotalTolerance = "soidCashDrawerTotalTolerance",
    SoidCashDrawerTenderBillDenominations = "soidCashDrawerTenderBillDenominations",
    SoidCashDrawerTenderCoinDenominations = "soidCashDrawerTenderCoinDenominations",
    SoidCashDrawerRequireCashDetailsToBeEntered = "soidCashDrawerRequireCashDetailsToBeEntered",
    SoidCashDrawerRequireClosingFloatDetailsToBeEntered = "soidCashDrawerRequireClosingFloatDetailsToBeEntered",
    SoidCashDrawerRequireOpeningFloatToBeCountedBeforeUse = "soidCashDrawerRequireOpeningFloatToBeCountedBeforeUse",
    SoidCashDrawerRequireChequeDetailsToBeEntered = "soidCashDrawerRequireChequeDetailsToBeEntered",
    SoidTransportBookingAllowUse = "soidTransportBookingAllowUse",
    SoidTransportBookingDistanceUnit = "soidTransportBookingDistanceUnit",
    SoidTransportBookingRequireDistance = "soidTransportBookingRequireDistance",
    SoidTransportBookingRequireInstructionsOnPO = "soidTransportBookingRequireInstructionsOnPO",
    SoidTransportBookingRequireInstructionsOnSO = "soidTransportBookingRequireInstructionsOnSO",
    SoidDisableRemainingCountInFindDocuments = "soidDisableRemainingCountInFindDocuments",
    SoidDisableRemainingCountInFindObjects = "soidDisableRemainingCountInFindObjects",
    SoidWarnIfNoSearchTextEnteredInFindProducts = "soidWarnIfNoSearchTextEnteredInFindProducts",
    SoidWarnIfNoSearchTextEnteredInFindCustomers = "soidWarnIfNoSearchTextEnteredInFindCustomers",
    SoidAllowLoadAllInPriceRules = "soidAllowLoadAllInPriceRules",
    SoidPoleCommunicationMethod = "soidPoleCommunicationMethod",
    SoidCachedSalesOrderCount = "soidCachedSalesOrderCount",
    SoidPerformanceAllowLoadAllOnJobs = "soidPerformanceAllowLoadAllOnJobs",
    SoidEnableGarbageCollection = "soidEnableGarbageCollection",
    SoidEDICreateImportedProductsForAllBranches = "soidEDICreateImportedProductsForAllBranches",
    SoidEDIUpdateCompanyLevelPricesOnImport = "soidEDIUpdateCompanyLevelPricesOnImport",
    SoidElectronicPaymentMethod = "soidElectronicPaymentMethod",
    SoidElectronicPaymentsUsePostalCode = "soidElectronicPaymentsUsePostalCode",
    SoidWebTrackServicesDefaultLocation = "soidWebTrackServicesDefaultLocation",
    SoidNumberOfDigitsOfCardNumberForDisplay = "soidNumberOfDigitsOfCardNumberForDisplay",
    SoidElectronicPaymentLoggingLevel = "soidElectronicPaymentLoggingLevel",
    SoidElectronicPaymentsUseAVS = "soidElectronicPaymentsUseAVS",
    SoidElectronicPaymentLoginTimeout = "soidElectronicPaymentLoginTimeout",
    SoidElectronicPaymentTransactionTimeout = "soidElectronicPaymentTransactionTimeout",
    SoidbisTrackServicesDefaultLocation = "soidbisTrackServicesDefaultLocation",
    SoidWebTrackServicesDefaultKey = "soidWebTrackServicesDefaultKey",
    SoidElectronicPaymentNoLogin = "soidElectronicPaymentNoLogin",
    SoidEDIUpdatePurchaseOrderCostOnImport = "soidEDIUpdatePurchaseOrderCostOnImport",
    SoidElectronicPaymentProviderForPurchasingCards = "soidElectronicPaymentProviderForPurchasingCards",
    SoidPaymentProviderWebServiceURL = "soidPaymentProviderWebServiceURL",
    SoidEDIUpdateCompanyLevelCostsOnImport = "soidEDIUpdateCompanyLevelCostsOnImport",
    SoidEDIRootFolder = "soidEDIRootFolder",
    SoidEDIManualLineTypeAVOPOs = "soidEDIManualLineTypeAVOPOs",
    SoidEDIAddressCodeForStockOrders = "soidEDIAddressCodeForStockOrders",
    SoidEDIStockSalesOrderDocumentFormats = "soidEDIStockSalesOrderDocumentFormats",
    SoidEDICustomerSalesOrderDocumentFormats = "soidEDICustomerSalesOrderDocumentFormats",
    SoidEDIAgentComputerName = "soidEDIAgentComputerName",
    SoidEDIAutoApproveInternalTradingOrders = "soidEDIAutoApproveInternalTradingOrders",
    SoidElectronicPaymentsUseAddress = "soidElectronicPaymentsUseAddress",
    SoidEDIDefaultProductCodeToSKUForProductMaint = "soidEDIDefaultProductCodeToSKUForProductMaint",
    SoidEDIUpdatePurchaseOrderQuantityOnImport = "soidEDIUpdatePurchaseOrderQuantityOnImport",
    SoidEDIDefaultSupplierInvoiceManualOrderLineType = "soidEDIDefaultSupplierInvoiceManualOrderLineType",
    SoidEDIInternalTradingSupplierAtBranchLevel = "soidEDIInternalTradingSupplierAtBranchLevel",
    SoidElectronicPaymentsShowWarningWhenCardDontMatchPaymentMethod = "soidElectronicPaymentsShowWarningWhenCardDontMatchPaymentMethod",
    SoidElectronicPaymentsNoCardAuthenticationOnApprovedTransaction = "soidElectronicPaymentsNoCardAuthenticationOnApprovedTransaction",
    SoidEDIAddLinesOnInboundSupplierInvoiceIfNoProductMatch = "soidEDIAddLinesOnInboundSupplierInvoiceIfNoProductMatch",
    SoidEDIRequireSupplierProductCodeForOutboundPO = "soidEDIRequireSupplierProductCodeForOutboundPO",
    SoidEDIAddLinesOnInboundSupplierInvoiceIfPerIsNotMapped = "soidEDIAddLinesOnInboundSupplierInvoiceIfPerIsNotMapped",
    SoidEDICheckProductSpecialOrderBehaviourForXpressPOS = "soidEDICheckProductSpecialOrderBehaviourForXpressPOS",
    SoidShift4MerchantID = "soidShift4MerchantID",
    SoidShift4SerialNumber = "soidShift4SerialNumber",
    SoidShift4Vendor = "soidShift4Vendor",
    SoidEDIAllowSelectionOfEDISupplierReferenceOnSalesOrder = "soidEDIAllowSelectionOfEDISupplierReferenceOnSalesOrder",
    SoidShift4TokenLongTermStorageDuration = "soidShift4TokenLongTermStorageDuration",
    SoidShift4CaptureSignatureThresholdAmount = "soidShift4CaptureSignatureThresholdAmount",
    SoidShift4TransactionGlobalTimerIntervalInSeconds = "soidShift4TransactionGlobalTimerIntervalInSeconds",
    SoidShift4TransactionReTryTimerIntervalInSeconds = "soidShift4TransactionReTryTimerIntervalInSeconds",
    SoidShift4APIPassword = "soidShift4APIPassword",
    SoidShift4UserName = "soidShift4UserName",
    SoidShift4CreditCardsOnReturnsOnly = "soidShift4CreditCardsOnReturnsOnly",
    SoidElectronicPaymentConnectionDelay = "soidElectronicPaymentConnectionDelay",
    SoidEDIExportAdditionalChargesAsAllowances = "soidEDIExportAdditionalChargesAsAllowances",
    SoidEDIExportAVOsAsAllowances = "soidEDIExportAVOsAsAllowances",
    SoidShift4i4GoAccountID = "soidShift4i4GoAccountID",
    SoidShift4i4GoSiteID = "soidShift4i4GoSiteID",
    SoidShift4i4GoPassword = "soidShift4i4GoPassword",
    SoidCommunicateToShift4UTGServersUsingHTTPS = "soidCommunicateToShift4UTGServersUsingHTTPS",
    SoidEDIEnableDIBBuyingGroupFeatures = "soidEDIEnableDIBBuyingGroupFeatures",
    SoidTenderRetailConnectionTimeoutInSeconds = "soidTenderRetailConnectionTimeoutInSeconds",
    SoidTenderRetailResponseTimeoutInSeconds = "soidTenderRetailResponseTimeoutInSeconds",
    SoidTenderRetailPositiveAckTimeoutInSeconds = "soidTenderRetailPositiveAckTimeoutInSeconds",
    SoidGivexUserID = "soidGivexUserID",
    SoidGivexPassword = "soidGivexPassword",
    SoidShift4SkipSignatureCaptureForCardOnFile = "soidShift4SkipSignatureCaptureForCardOnFile",
    SoidShift4EnableSwipeAhead = "soidShift4EnableSwipeAhead",
    SoidShift4PINPadDisplayDelayInMilliseconds = "soidShift4PINPadDisplayDelayInMilliseconds",
    SoidEDIUpdateProductDescriptionOnEDIProductMaintenance = "soidEDIUpdateProductDescriptionOnEDIProductMaintenance",
    SoidEDIUpdateSupplierProductDescriptionOnEDIProductMaintenance = "soidEDIUpdateSupplierProductDescriptionOnEDIProductMaintenance",
    SoidShift4TRAllowTokensForSubsequentPaymentsOnSameTransaction = "soidShift4TRAllowTokensForSubsequentPaymentsOnSameTransaction",
    SoidDisplayPromoCodeForPrivateLabelCreditCardProcessing = "soidDisplayPromoCodeForPrivateLabelCreditCardProcessing",
    SoidEnableBlueTarpElectronicPaymentIntegration = "soidEnableBlueTarpElectronicPaymentIntegration",
    SoidShift4i4GoLiveURL = "soidShift4i4GoLiveURL",
    SoidShift4i4GoTestURL = "soidShift4i4GoTestURL",
    SoidBlueTarpMerchantID = "soidBlueTarpMerchantID",
    SoidBlueTarpClientKey = "soidBlueTarpClientKey",
    SoidBlueTarpBaseURL = "soidBlueTarpBaseURL",
    SoidEDIRestrictProductUpdateToDefaultSupplier = "soidEDIRestrictProductUpdateToDefaultSupplier",
    SoidCollectAirMilesCardDetailsWithPayments = "soidCollectAirMilesCardDetailsWithPayments",
    SoidAirMilesDefaultOfferCodeForCashSales = "soidAirMilesDefaultOfferCodeForCashSales",
    SoidAirMilesDefaultOfferCodeForCashSalesToChargeAccount = "soidAirMilesDefaultOfferCodeForCashSalesToChargeAccount",
    SoidAirMilesDefaultOfferCodeForZeroAmountAirMilesTransactions = "soidAirMilesDefaultOfferCodeForZeroAmountAirMilesTransactions",
    SoidAirMilesDefaultTerminalID = "soidAirMilesDefaultTerminalID",
    SoidAirMilesDefaultServerIPAddress = "soidAirMilesDefaultServerIPAddress",
    SoidAirMilesDefaultServerPortNumber = "soidAirMilesDefaultServerPortNumber",
    SoidAirMilesConnectionTimeoutInSeconds = "soidAirMilesConnectionTimeoutInSeconds",
    SoidAirMilesResponseTimeoutInSeconds = "soidAirMilesResponseTimeoutInSeconds",
    SoidShift4UseVoidOnDebitReversal = "soidShift4UseVoidOnDebitReversal",
    SoidPerformPreAuthWhenBackOrderingSOWithExistingWTPreAuth = "soidPerformPreAuthWhenBackOrderingSOWithExistingWTPreAuth",
    SoidShift4ReceiptTextWidth = "soidShift4ReceiptTextWidth",
    SoidShift4AccessMethod = "soidShift4AccessMethod",
    SoidEDITemplateManualOrderLine = "soidEDITemplateManualOrderLine",
    SoidShift4i4GoVersion = "soidShift4i4GoVersion",
    SoidEDIAPAutomationAttachmentsFolder = "soidEDIAPAutomationAttachmentsFolder",
    SoidDoNotDisplayManualCheckboxForShift4ElectronicPayments = "soidDoNotDisplayManualCheckboxForShift4ElectronicPayments",
    SoidPreSaveNewSalesOrdersBeforeProcessingShift4ElectronicPayment = "soidPreSaveNewSalesOrdersBeforeProcessingShift4ElectronicPayment",
    SoidShift4AllowManualEntryOfVoiceAuthorizations = "soidShift4AllowManualEntryOfVoiceAuthorizations",
    SoidShift4i4GoAccessLiveURL = "soidShift4i4GoAccessLiveURL",
    SoidShift4i4GoAccessTestURL = "soidShift4i4GoAccessTestURL",
    SoidShift4i4GoTokenServiceURL = "soidShift4i4GoTokenServiceURL",
    SoidShift4i4GoCardSecurityCodeRequired = "soidShift4i4GoCardSecurityCodeRequired",
    SoidShift4i4GoAcceptedCardTypes = "soidShift4i4GoAcceptedCardTypes",
    SoidShift4i4GoCardholderNamePrompt = "soidShift4i4GoCardholderNamePrompt",
    SoidShift4i4GoStreetAddressPrompt = "soidShift4i4GoStreetAddressPrompt",
    SoidShift4i4GoPostalCodePrompt = "soidShift4i4GoPostalCodePrompt",
    SoidShift4GetNewLongTermTokenWhenCardOnFileIsUsed = "soidShift4GetNewLongTermTokenWhenCardOnFileIsUsed",
    SoidShift4UseI4GoAVS = "soidShift4UseI4GoAVS",
    SoidShift4i4GoPublicIPServiceURL = "soidShift4i4GoPublicIPServiceURL",
    SoidTenderRetailProcessor = "soidTenderRetailProcessor",
    SoidShift4VoidOnTimeOut = "soidShift4VoidOnTimeOut",
    SoidShift4SendTransactionsInAsyncMode = "soidShift4SendTransactionsInAsyncMode",
    SoidAirMilesStandardOfferCodes = "soidAirMilesStandardOfferCodes",
    SoidShift4CreditCardsOnPaymentsOnly = "soidShift4CreditCardsOnPaymentsOnly",
    SoidTemplateManualOrderLineForAcePromotions = "soidTemplateManualOrderLineForAcePromotions",
    SoidAceCustomerLoyaltyLevel = "soidAceCustomerLoyaltyLevel",
    SoidACERewardsWebService = "soidACERewardsWebService",
    SoidACERewardsWebServiceUsername = "soidACERewardsWebServiceUsername",
    SoidACERewardsWebServicePassword = "soidACERewardsWebServicePassword",
    SoidUseDefaultCashCustomerForExistingACERewardsCustomers = "soidUseDefaultCashCustomerForExistingACERewardsCustomers",
    SoidACERewardsCustomerLookupWebService = "soidACERewardsCustomerLookupWebService",
    SoidTenderRetailCheckForWinsockErrorAfterSendingPositiveACK = "soidTenderRetailCheckForWinsockErrorAfterSendingPositiveACK",
    SoidACERewardsVerifyCustomerDetailsWhenRequestedByACE = "soidACERewardsVerifyCustomerDetailsWhenRequestedByACE",
    SoidEDIAPAutomationProcessTo = "soidEDIAPAutomationProcessTo",
    SoidShift4i4GoCardholderNamePromptInWebTrack = "soidShift4i4GoCardholderNamePromptInWebTrack",
    SoidShift4i4GoStreetAddressPromptInWebTrack = "soidShift4i4GoStreetAddressPromptInWebTrack",
    SoidShift4i4GoPostalCodePromptInWebTrack = "soidShift4i4GoPostalCodePromptInWebTrack",
    SoidEDIIgnoreBlankOrZeroValuesDuringProductMaintenanceUpdate = "soidEDIIgnoreBlankOrZeroValuesDuringProductMaintenanceUpdate",
    SoidEDIAttachmentFolderForSOProductImages = "soidEDIAttachmentFolderForSOProductImages",
    SoidEDIAPAutomationCreateInvoiceWithoutStockReceipt = "soidEDIAPAutomationCreateInvoiceWithoutStockReceipt",
    SoidGiftCardProductForACETypeXPromotions = "soidGiftCardProductForACETypeXPromotions",
    SoidSplitIntegratedCardPaymentMethodByTypeOnAccountPayments = "soidSplitIntegratedCardPaymentMethodByTypeOnAccountPayments",
    SoidEDIAPAutomationCreditNoteAttachmentFolder = "soidEDIAPAutomationCreditNoteAttachmentFolder",
    SoidWebTrackSecondsToWaitForReportServerToReturnDocument = "soidWebTrackSecondsToWaitForReportServerToReturnDocument",
    SoidWebTrackShift4i4GoAccountID = "soidWebTrackShift4i4GoAccountID",
    SoidWebTrackShift4i4GoSiteID = "soidWebTrackShift4i4GoSiteID",
    SoidWebTrackShift4i4GoPassword = "soidWebTrackShift4i4GoPassword",
    SoidWebTrackRestrictProdAccessUsingCustWTProdGrps = "soidWebTrackRestrictProdAccessUsingCustWTProdGrps",
    SoidWebTrackShowLocationWithVehicleTracking = "soidWebTrackShowLocationWithVehicleTracking",
    SoidOrdersEnableMiTekImportFeatures = "soidOrdersEnableMiTekImportFeatures",
    SoidOrdersMiTekImportFolder = "soidOrdersMiTekImportFolder",
    SoidOrdersImportReferenceDestination = "soidOrdersImportReferenceDestination",
    SoidNewPerMode = "soidNewPerMode",
    SoidNewTaxMode = "soidNewTaxMode",
    SoidLastLiveOrderID = "soidLastLiveOrderID",
    SoidLastLiveSellPriceRuleID = "soidLastLiveSellPriceRuleID",
    SoidNewReportPrintMode = "soidNewReportPrintMode",
    SoidNewPriceMode = "soidNewPriceMode",
    SoidSupplierInvoiceAllowPreEnteredStockReceipts = "soidSupplierInvoiceAllowPreEnteredStockReceipts",
    SoidEnablePromptForCrystalParameters = "soidEnablePromptForCrystalParameters",
    SoidUseOrderFilterForSOPSearches = "soidUseOrderFilterForSOPSearches",
    SoidNewSearchMode = "soidNewSearchMode",
    SoidDatabaseUpgrading = "soidDatabaseUpgrading",
    SoidUseInventoryAgingAndCommissionCosts = "soidUseInventoryAgingAndCommissionCosts",
    SoidEnablePerformanceLogging = "soidEnablePerformanceLogging",
    SoidPurchasingInputExchangeRateFromBase = "soidPurchasingInputExchangeRateFromBase",
    SoidUseOldCrystalPrintingMethods = "soidUseOldCrystalPrintingMethods",
    SoidShowInternalCostOnProductFind = "soidShowInternalCostOnProductFind",
    SoidAllowSupplierProductReference = "soidAllowSupplierProductReference",
    SoidEnableScanTrackIntegration = "soidEnableScanTrackIntegration",
    SoidJourneyPlanningStyle = "soidJourneyPlanningStyle",
    SoidEnableNewProductFindMode = "soidEnableNewProductFindMode",
    SoidDisableLicensing = "soidDisableLicensing",
    SoidDisableRebuildStockOnOrderForReceipt = "soidDisableRebuildStockOnOrderForReceipt",
    SoidCashDrawerRedirectMessageValidity = "soidCashDrawerRedirectMessageValidity",
    SoidLastProductGroupEdit = "soidLastProductGroupEdit",
    SoidLastSortedProductGroupUpdate = "soidLastSortedProductGroupUpdate",
    SoidAllowBranchLevelPackOptions = "soidAllowBranchLevelPackOptions",
    SoidUseRecordsetLoadWithNoTransaction = "soidUseRecordsetLoadWithNoTransaction",
    SoidAllowMemoQuantityInput = "soidAllowMemoQuantityInput",
    SoidJourneyPlannerAllowDeliveredPOs = "soidJourneyPlannerAllowDeliveredPOs",
    SoidQuickProductsImage1 = "soidQuickProductsImage1",
    SoidQuickProductsImage2 = "soidQuickProductsImage2",
    SoidQuickProductsImage3 = "soidQuickProductsImage3",
    SoidQuickProductsShowImages = "soidQuickProductsShowImages",
    SoidAllowAuthorizedBuyerByJob = "soidAllowAuthorizedBuyerByJob",
    SoidEnablePricingPlanner = "soidEnablePricingPlanner",
    SoidSystemUpgradeEmailAddress = "soidSystemUpgradeEmailAddress",
    SoidEnablePriceChecker = "soidEnablePriceChecker",
    SoidEnableBisTrackCount = "soidEnableBisTrackCount",
    SoidEnableBisTrackReceipt = "soidEnableBisTrackReceipt",
    SoidPurchasingCostDebugMode = "soidPurchasingCostDebugMode",
    SoidAllowTotalStockAdjustmentOfStockByLengthProducts = "soidAllowTotalStockAdjustmentOfStockByLengthProducts",
    SoidWorksOrderKeepSameCostIfFinishedInSource = "soidWorksOrderKeepSameCostIfFinishedInSource",
    SoidPermissionDetailLastUpdateVersion = "soidPermissionDetailLastUpdateVersion",
    SoidAddSettlementDiscAvailToSalesAndProductAnalysisCubes = "soidAddSettlementDiscAvailToSalesAndProductAnalysisCubes",
    SoidSalesAnalysisCodeForSettlementDiscAvailInSalesAnalysis = "soidSalesAnalysisCodeForSettlementDiscAvailInSalesAnalysis",
    SoidPurchaseAnalysisType = "soidPurchaseAnalysisType",
    SoidPurchaseAnalysisDetailStartDate = "soidPurchaseAnalysisDetailStartDate",
    SoidSalesAnalysisCodeToPostSalesDiscountsToInSalesAnalysis = "soidSalesAnalysisCodeToPostSalesDiscountsToInSalesAnalysis",
    SoidPostPromotionDiscountAmountsProratedOverProducts = "soidPostPromotionDiscountAmountsProratedOverProducts",
    SoidReportServer2AgentPollingInterval = "soidReportServer2AgentPollingInterval",
    SoidReportServer2AgentLoggingLevel = "soidReportServer2AgentLoggingLevel",
    SoidReportServer2ProcessEmailedDocuments = "soidReportServer2ProcessEmailedDocuments",
    SoidReportServer2ImageInvoiceFormat = "soidReportServer2ImageInvoiceFormat",
    SoidReportServer2ImageCreditNoteFormat = "soidReportServer2ImageCreditNoteFormat",
    SoidReportServer2ImageSalesOrderFormat = "soidReportServer2ImageSalesOrderFormat",
    SoidReportServer2ImageInvoiceSTDocType = "soidReportServer2ImageInvoiceSTDocType",
    SoidReportServer2ImageCreditNoteSTDocType = "soidReportServer2ImageCreditNoteSTDocType",
    SoidReportServer2ImageSalesOrderSTDocType = "soidReportServer2ImageSalesOrderSTDocType",
    SoidReportServer2ImageReleasedFrom = "soidReportServer2ImageReleasedFrom",
    SoidReportServer2ImageFileType = "soidReportServer2ImageFileType",
    SoidReportServer2ImageColourDepth = "soidReportServer2ImageColourDepth",
    SoidReportServer2ImageDPI = "soidReportServer2ImageDPI",
    SoidReportServer2ImageJPGQuality = "soidReportServer2ImageJPGQuality",
    SoidReportServer2ImageTIFCompression = "soidReportServer2ImageTIFCompression",
    SoidReportServer2ImageTIFMultiPage = "soidReportServer2ImageTIFMultiPage",
    SoidReportServer2ImageTimeTo = "soidReportServer2ImageTimeTo",
    SoidReportServer2Timeout = "soidReportServer2Timeout",
    SoidReportServer2AutoDelInvoiceFormat = "soidReportServer2AutoDelInvoiceFormat",
    SoidReportServer2AutoDelInvoiceEmailTemplate = "soidReportServer2AutoDelInvoiceEmailTemplate",
    SoidReportServer2AutoDelCreditNoteFormat = "soidReportServer2AutoDelCreditNoteFormat",
    SoidReportServer2AutoDelCreditNoteEmailTemplate = "soidReportServer2AutoDelCreditNoteEmailTemplate",
    SoidReportServer2AutoDelSendTime = "soidReportServer2AutoDelSendTime",
    SoidReportServer2AutoDelDocumentsSince = "soidReportServer2AutoDelDocumentsSince",
    SoidReportServer2AutoDeliveryEnabled = "soidReportServer2AutoDeliveryEnabled",
    SoidDeadProductsCheck = "soidDeadProductsCheck",
    SoidDeadProductsIncludeTimber = "soidDeadProductsIncludeTimber",
    SoidDeadProductsLowUsageCount = "soidDeadProductsLowUsageCount",
    SoidDeadProductsLowReceiptCount = "soidDeadProductsLowReceiptCount",
    SoidDeadProductsMarkNonStockedIfLowActivityxMonths = "soidDeadProductsMarkNonStockedIfLowActivityxMonths",
    SoidDeadProductsMarkDeletedIfLowActivityxMonths = "soidDeadProductsMarkDeletedIfLowActivityxMonths",
    SoidDeadProductsStandardStockOnly = "soidDeadProductsStandardStockOnly",
    SoidDeadProductsSpecialsDaysAgo = "soidDeadProductsSpecialsDaysAgo",
    SoidReportServer2AutoDelCashInvoiceFormat = "soidReportServer2AutoDelCashInvoiceFormat",
    SoidReportServer2AutoDelCashRefundFormat = "soidReportServer2AutoDelCashRefundFormat",
    SoidReportServer2NotificationDeliveryInProgressEmailTemplate = "soidReportServer2NotificationDeliveryInProgressEmailTemplate",
    SoidReportServer2NotificationDeliveryInProgressFormat = "soidReportServer2NotificationDeliveryInProgressFormat",
    SoidReportServer2NotificationOrderDeliveredEmailTemplate = "soidReportServer2NotificationOrderDeliveredEmailTemplate",
    SoidReportServer2NotificationOrderDeliveredFormat = "soidReportServer2NotificationOrderDeliveredFormat",
    SoidReportServer2NotificationDeliveryETAEmailTemplate = "soidReportServer2NotificationDeliveryETAEmailTemplate",
    SoidReportServer2NotificationDeliveryETAFormat = "soidReportServer2NotificationDeliveryETAFormat",
    SoidCRMEventsQuoteAcceptEnable = "soidCRMEventsQuoteAcceptEnable",
    SoidCRMEventsQuoteRejectEnable = "soidCRMEventsQuoteRejectEnable",
    SoidCRMEventsEmailSentEnable = "soidCRMEventsEmailSentEnable",
    SoidCRMEventsLetterWrittenEnable = "soidCRMEventsLetterWrittenEnable",
    SoidCRMEventsOrderCreditHoldOnEnable = "soidCRMEventsOrderCreditHoldOnEnable",
    SoidCRMEventsOrderCreditHoldOffEnable = "soidCRMEventsOrderCreditHoldOffEnable",
    SoidCRMEventsAccountOnHoldEnable = "soidCRMEventsAccountOnHoldEnable",
    SoidCRMEventsAccountOffHoldEnable = "soidCRMEventsAccountOffHoldEnable",
    SoidCRMCalendarDayStart = "soidCRMCalendarDayStart",
    SoidCRMCalendarDayEnd = "soidCRMCalendarDayEnd",
    SoidCRMCalendarTimeInterval = "soidCRMCalendarTimeInterval",
    SoidCRMCalendarFollowUpDuration = "soidCRMCalendarFollowUpDuration",
    SoidCRMCampaignsDefaultNotepadType = "soidCRMCampaignsDefaultNotepadType",
    SoidCRMEventsCampaignActionComplete = "soidCRMEventsCampaignActionComplete",
    SoidItemMessageCreationSubject = "soidItemMessageCreationSubject",
    SoidItemMessageCreationBody = "soidItemMessageCreationBody",
    SoidItemMessageClosureSubject = "soidItemMessageClosureSubject",
    SoidItemMessageClosureBody = "soidItemMessageClosureBody",
    SoidItemMessageNotificationSubject = "soidItemMessageNotificationSubject",
    SoidItemMessageNotificationBody = "soidItemMessageNotificationBody",
    SoidItemDevSignOffPrompt1 = "soidItemDevSignOffPrompt1",
    SoidItemDevSignOffPrompt2 = "soidItemDevSignOffPrompt2",
    SoidItemDefaultTesterID = "soidItemDefaultTesterID",
    SoidItemDefaultTesterName = "soidItemDefaultTesterName",
    SoidItemDefaultTesterTypeOfWorkID = "soidItemDefaultTesterTypeOfWorkID",
    SoidItemDefaultTestAnalysisCodeID = "soidItemDefaultTestAnalysisCodeID",
    SoidItemForceProjectEntry = "soidItemForceProjectEntry",
    SoidItemNotesForNonDevItems = "soidItemNotesForNonDevItems",
    SoidItemGenerateCustomerSpecificeItemReferences = "soidItemGenerateCustomerSpecificeItemReferences",
    SoidItemUseBillToItems = "soidItemUseBillToItems",
    SoidItemLockTimeTransactionsPreviousToThisDate = "soidItemLockTimeTransactionsPreviousToThisDate",
    SoidItemPreventAddEditOfTimeOnClosedCancelledItems = "soidItemPreventAddEditOfTimeOnClosedCancelledItems",
    SoidSTServerFolder = "soidSTServerFolder",
    SoidItemAllowEntryOfSeparateChargeableTime = "soidItemAllowEntryOfSeparateChargeableTime",
    SoidItemAllowTimeSheetWeekApproval = "soidItemAllowTimeSheetWeekApproval",
    SoidItemNonDevVersionOptional = "soidItemNonDevVersionOptional",
    SoidItemNonDevDefaultPriority = "soidItemNonDevDefaultPriority",
    SoidItemLockChargingInfoBeforeThisDate = "soidItemLockChargingInfoBeforeThisDate",
    SoidItemUseProjectInvoiceApproval = "soidItemUseProjectInvoiceApproval",
    SoidEmailServer = "soidEmailServer",
    SoidEmailUsername = "soidEmailUsername",
    SoidEmailPassword = "soidEmailPassword",
    SoidEmailSenderAddress = "soidEmailSenderAddress",
    SoidEmailPort = "soidEmailPort",
    SoidEmailUseSMTPDefaultAsFromAddress = "soidEmailUseSMTPDefaultAsFromAddress",
    SoidEmailUseSMTPDefaultAsSenderAddress = "soidEmailUseSMTPDefaultAsSenderAddress",
    SoidEmailUseSMTPReplyToAddress = "soidEmailUseSMTPReplyToAddress",
    SoidEmailEncryption = "soidEmailEncryption",
    SoidInstantReleaseKey = "soidInstantReleaseKey",
    SoidCloudQuoteDocumentFormatNumber = "soidCloudQuoteDocumentFormatNumber",
    SoidCloudTemplateOrderDocumentFormatNumber = "soidCloudTemplateOrderDocumentFormatNumber",
    SoidCloudCallOffOrderDocumentFormatNumber = "soidCloudCallOffOrderDocumentFormatNumber",
    SoidCloudSalesOrderDocumentFormatNumber = "soidCloudSalesOrderDocumentFormatNumber",
    SoidCloudInvoiceDocumentFormatNumber = "soidCloudInvoiceDocumentFormatNumber",
    SoidCloudCreditNoteDocumentFormatNumber = "soidCloudCreditNoteDocumentFormatNumber",
    SoidCloudPurchaseOrderDocumentFormatNumber = "soidCloudPurchaseOrderDocumentFormatNumber",
    SoidCloudTransferDocumentFormatNumber = "soidCloudTransferDocumentFormatNumber",
    SoidCloudWorkOrderDocumentFormatNumber = "soidCloudWorkOrderDocumentFormatNumber",
    SoidCrystalUsePrintLayoutSettings = "soidCrystalUsePrintLayoutSettings",
    SoidCrystalUseRAS = "soidCrystalUseRAS",
    SoidCrystalUseThreading = "soidCrystalUseThreading",
    SoidCrystalThreadingTimeout = "soidCrystalThreadingTimeout",
    SoidEnableCTI = "soidEnableCTI",
    SoidOIGServerAddress = "soidOIGServerAddress",
    SoidOIGIcpIPAddress = "soidOIGIcpIPAddress",
    SoidOIGEventHandlerURL = "soidOIGEventHandlerURL",
    SoidOIGApplicationName = "soidOIGApplicationName",
    SoidOIGApplicationPassword = "soidOIGApplicationPassword",
    SoidOIGCompanyName = "soidOIGCompanyName",
    SoidOIGLocalPassword = "soidOIGLocalPassword",
    SoidCTIProvider = "soidCTIProvider",
    SoidCTICustomerDashboard = "soidCTICustomerDashboard",
    SoidCTISupplierDashboard = "soidCTISupplierDashboard",
    SoidCTIUserDashboard = "soidCTIUserDashboard",
    SoidCTICustomerDashboardDefault = "soidCTICustomerDashboardDefault",
    SoidCTISupplierDashboardDefault = "soidCTISupplierDashboardDefault",
    SoidCTIUserDashboardDefault = "soidCTIUserDashboardDefault",
    SoidGrahamsDemo = "soidGrahamsDemo",
    SoidSuppliersEnablePermissionsByTab = "soidSuppliersEnablePermissionsByTab",
    SoidDefaultOrderSingleLengthTalliedLumberQuantityToZero = "soidDefaultOrderSingleLengthTalliedLumberQuantityToZero",
    SoidOnlyUseReplacementProductWhenNoStock = "soidOnlyUseReplacementProductWhenNoStock",
    SoidAllowStockInformationForBranchesWithoutReadAccess = "soidAllowStockInformationForBranchesWithoutReadAccess",
    SoidLimitProductAddToQtyOnlyMethodOnTransfers = "soidLimitProductAddToQtyOnlyMethodOnTransfers",
    SoidBranchAccessLevelRequiredForIssuingBranch = "soidBranchAccessLevelRequiredForIssuingBranch",
    SoidEnableWMSProcessing = "soidEnableWMSProcessing",
    SoidDefaultCollectLaterWMSPickingStatus = "soidDefaultCollectLaterWMSPickingStatus",
    SoidWMSOutgoingGenerationInProgress = "soidWMSOutgoingGenerationInProgress",
    SoidEDIPurgeWMSDocumentDays = "soidEDIPurgeWMSDocumentDays",
    SoidConsolidateLineNotesOnSOConsolidate = "soidConsolidateLineNotesOnSOConsolidate",
    SoidDefaultExcludeSpecialsOnPricingOption = "soidDefaultExcludeSpecialsOnPricingOption",
    SoidTranferLimitToFinalCostWhenNoReadAccessToSendingBranch = "soidTranferLimitToFinalCostWhenNoReadAccessToSendingBranch",
    SoidDisplayProductPopupOnQuoteAcceptanceAndSalesCopy = "soidDisplayProductPopupOnQuoteAcceptanceAndSalesCopy",
    SoidEnableWMSBackWorksOrders = "soidEnableWMSBackWorksOrders",
    SoidEnableWMSDocumentPrinting = "soidEnableWMSDocumentPrinting",
    SoidWorksOrderDefaultWMSType = "soidWorksOrderDefaultWMSType",
    SoidUpdateSpecialProductDescriptionWithOrderLineDescription = "soidUpdateSpecialProductDescriptionWithOrderLineDescription",
    SoidCashSalesRequireFullPaymentForCollectLaterNowCompletion = "soidCashSalesRequireFullPaymentForCollectLaterNowCompletion",
    SoidDefaultOrderLineAmendReasonForWMSSubstitution = "soidDefaultOrderLineAmendReasonForWMSSubstitution",
    SoidWMSSubstitutionRecalculatePrice = "soidWMSSubstitutionRecalculatePrice",
    SoidDisplaySuccessfulConfirmationPopUps = "soidDisplaySuccessfulConfirmationPopUps",
    SoidConfirmContractSelectionOnSalesOrderCompletion = "soidConfirmContractSelectionOnSalesOrderCompletion",
    SoidWMSSendReleasedNotProcessedCreditNoteQuantityInQuantitySync = "soidWMSSendReleasedNotProcessedCreditNoteQuantityInQuantitySync",
    SoidEnableWMSBackTransfers = "soidEnableWMSBackTransfers",
    SoidEnablePurchaseOrderExcludeFromWMS = "soidEnablePurchaseOrderExcludeFromWMS",
    SoidWMSDoNotSentOrderLineInternalNotes = "soidWMSDoNotSentOrderLineInternalNotes",
    SoidWMSTimberTalliedProductsMustBeSingleLength = "soidWMSTimberTalliedProductsMustBeSingleLength",
    SoidWMSOrderHeaderLicensePlateUDF = "soidWMSOrderHeaderLicensePlateUDF",
    SoidShowCubeMeasures = "soidShowCubeMeasures",
    SoidDefaultPricingOptionsToPriceProfiles = "soidDefaultPricingOptionsToPriceProfiles",
    SoidUseNewSalesOrderEntryForm = "soidUseNewSalesOrderEntryForm",
    SoidWorksOrderSendMachineGroupToWMS = "soidWorksOrderSendMachineGroupToWMS",
    SoidOrdersSendJourneyReferenceToWMS = "soidOrdersSendJourneyReferenceToWMS",
    SoidReleaseOrdersForPickingToWMSDaysInAdvance = "soidReleaseOrdersForPickingToWMSDaysInAdvance",
    SoidWorksOrderRequireReleaseForManufactureInWMS = "soidWorksOrderRequireReleaseForManufactureInWMS",
    SoidReleaseWorksOrdersForManufactureToWMSDaysInAdvance = "soidReleaseWorksOrdersForManufactureToWMSDaysInAdvance",
    SoidGenerateWorkOrdersForIncomingSalesOrders = "soidGenerateWorkOrdersForIncomingSalesOrders",
    SoidWMSJourneyReferenceLength = "soidWMSJourneyReferenceLength",
    SoidWMSSendShipCompleteTagForSalesOrders = "soidWMSSendShipCompleteTagForSalesOrders",
    SoidDefaultSalesRepOnTransactionsToTakenByLinkedSalesRep = "soidDefaultSalesRepOnTransactionsToTakenByLinkedSalesRep",
    SoidWMSEnableASNTransactions = "soidWMSEnableASNTransactions",
}

export enum VehicleUpdateResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum AutoTextResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum DeliveryAreasResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum VehicleLocationResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum AuditRequestAuditType {
    None = "None",
    DatStockAllocationRemove = "datStockAllocationRemove",
    DatStockAdjustment = "datStockAdjustment",
    DatMovePlate = "datMovePlate",
    DatPlateDelete = "datPlateDelete",
    DatPlateEdit = "datPlateEdit",
    DatPlateRename = "datPlateRename",
    DatPlateStatusChange = "datPlateStatusChange",
    DatPlateAdd = "datPlateAdd",
    DatPlateFlagChange = "datPlateFlagChange",
    DatProductDelete = "datProductDelete",
    DatProductAdd = "datProductAdd",
    DatAutomatedPriceChange = "datAutomatedPriceChange",
    DatCurrencyDelete = "datCurrencyDelete",
    DatCurrencyEdit = "datCurrencyEdit",
    DatCurrencyAdd = "datCurrencyAdd",
    DatInstantCreditRelease = "datInstantCreditRelease",
    DatProductCodeChange = "datProductCodeChange",
    DatInstantCreditReleaseAllocate = "datInstantCreditReleaseAllocate",
    DatPackAdd = "datPackAdd",
    DatPackEdit = "datPackEdit",
    DatPackDelete = "datPackDelete",
    DatPackSplit = "datPackSplit",
    DatCreditControlRelease = "datCreditControlRelease",
    DatJobAdd = "datJobAdd",
    DatJobDelete = "datJobDelete",
    DatJobEdit = "datJobEdit",
    DatSalesOrderDelete = "datSalesOrderDelete",
    DatCreditStatusChange = "datCreditStatusChange",
    DatCreditControllerChange = "datCreditControllerChange",
    DatCreditLimitChange = "datCreditLimitChange",
    DatCreditRatingChange = "datCreditRatingChange",
    DatStockBatchMove = "datStockBatchMove",
    DatJobChange = "datJobChange",
    DatPackAllocation = "datPackAllocation",
    DatPackUnallocation = "datPackUnallocation",
    DatPackOrderIssue = "datPackOrderIssue",
    DatPackWorksOrderIssue = "datPackWorksOrderIssue",
    DatPackStockLocationChange = "datPackStockLocationChange",
    DatPackBinLocationChange = "datPackBinLocationChange",
    DatPackWorksOrderCreate = "datPackWorksOrderCreate",
    DatPackTallyChange = "datPackTallyChange",
    DatPackReferenceChange = "datPackReferenceChange",
    DatStockBatchChangeCost = "datStockBatchChangeCost",
    DatOrderQuantityChangeOutsideTolerance = "datOrderQuantityChangeOutsideTolerance",
    DatWorksOrderDelete = "datWorksOrderDelete",
    DatHandheldExport = "datHandheldExport",
    DatHandheldImport = "datHandheldImport",
    DatOfflineDatabaseDownloaded = "datOfflineDatabaseDownloaded",
    DatPackReserve = "datPackReserve",
    DatPackUnreserve = "datPackUnreserve",
    DatSellPriceChanges = "datSellPriceChanges",
    DatOurPackMarkChange = "datOurPackMarkChange",
    DatBuyingPriceRuleChange = "datBuyingPriceRuleChange",
    DatSellingPriceRuleChange = "datSellingPriceRuleChange",
    DatFreeOfChargeOrderLineAdd = "datFreeOfChargeOrderLineAdd",
    DatBackOrderRelease = "datBackOrderRelease",
    DatWebTrackLogonSuccess = "datWebTrackLogonSuccess",
    DatWebTrackLogonFailed = "datWebTrackLogonFailed",
    DatWebTrackFileDownload = "datWebTrackFileDownload",
    DatWebTrackDocumentView = "datWebTrackDocumentView",
    DatWebTrackPageAccess = "datWebTrackPageAccess",
    DatWebTrackOrderSuccess = "datWebTrackOrderSuccess",
    DatUserCreation = "datUserCreation",
    DatUserDeletion = "datUserDeletion",
    DatUserPermissionChange = "datUserPermissionChange",
    DatOrderLineQuantityChange = "datOrderLineQuantityChange",
    DatOrderLineTallyOrPackTallyChange = "datOrderLineTallyOrPackTallyChange",
    DatOrderLineAdd = "datOrderLineAdd",
    DatOrderLineDelete = "datOrderLineDelete",
    DatOrderLineProductSubstitution = "datOrderLineProductSubstitution",
    DatOrderLineConsolidation = "datOrderLineConsolidation",
    DatOrderDeliveryAddressChange = "datOrderDeliveryAddressChange",
    DatOrderInvoiceAddressChange = "datOrderInvoiceAddressChange",
    DatOrderPicked = "datOrderPicked",
    DatOrderNotPicked = "datOrderNotPicked",
    DatOrderDeliveredOrCollected = "datOrderDeliveredOrCollected",
    DatOrderNotDeliveredOrCollected = "datOrderNotDeliveredOrCollected",
    DatOrderPODReturned = "datOrderPODReturned",
    DatOrderNotPODReturned = "datOrderNotPODReturned",
    DatOrderIssue = "datOrderIssue",
    DatOrderUnissue = "datOrderUnissue",
    DatOrderApproved = "datOrderApproved",
    DatOrderInvoiced = "datOrderInvoiced",
    DatOrderLineCostChange = "datOrderLineCostChange",
    DatOrderCustomerRefChange = "datOrderCustomerRefChange",
    DatOrderDateRequiredChange = "datOrderDateRequiredChange",
    DatTransferSent = "datTransferSent",
    DatTransferReceived = "datTransferReceived",
    DatQuoteRejected = "datQuoteRejected",
    DatQuoteAccepted = "datQuoteAccepted",
    DatMinimumDepositOverride = "datMinimumDepositOverride",
    DatEDIDocDelete = "datEDIDocDelete",
    DatBatchItemNoDetail = "datBatchItemNoDetail",
    DatBatchItemManualDetail = "datBatchItemManualDetail",
    DatBatchItemDeleted = "datBatchItemDeleted",
    DatDashboard = "datDashboard",
    DatSmartView = "datSmartView",
    DatAccountsTransactionUnapplied = "datAccountsTransactionUnapplied",
    DatCustomerDelete = "datCustomerDelete",
    DatShift4Send = "datShift4Send",
    DatShift4Received = "datShift4Received",
    DatCallOffSchedulePlannedDateChange = "datCallOffSchedulePlannedDateChange",
    DatOrderHeaderUDFs = "datOrderHeaderUDFs",
    DatOrderMarginHoldRelease = "datOrderMarginHoldRelease",
    DatPOLineUnitCostChange = "datPOLineUnitCostChange",
    DatPODelete = "datPODelete",
    DatPOLineQuantityChange = "datPOLineQuantityChange",
    DatPOLineTallyOrPackTallyChange = "datPOLineTallyOrPackTallyChange",
    DatPOLineAdd = "datPOLineAdd",
    DatPOLineDelete = "datPOLineDelete",
    DatPOLineAnalysisCodeChange = "datPOLineAnalysisCodeChange",
    DatPOLineDateExpectedChange = "datPOLineDateExpectedChange",
    DatPOEstimatedFreightChange = "datPOEstimatedFreightChange",
    DatPOEstimatedMiscellaneousChange = "datPOEstimatedMiscellaneousChange",
    DatPOBranchChange = "datPOBranchChange",
    DatPOBuyingSocietyChange = "datPOBuyingSocietyChange",
    DatPOTypeOfPurchaseChange = "datPOTypeOfPurchaseChange",
    DatPOCountryOfOriginChange = "datPOCountryOfOriginChange",
    DatPOApprove = "datPOApprove",
    DatPOUnapprove = "datPOUnapprove",
    DatPOExchangeRateChange = "datPOExchangeRateChange",
    DatPOCollectedChange = "datPOCollectedChange",
    DatPOSupplierRefChange = "datPOSupplierRefChange",
    DatPODateRequiredChange = "datPODateRequiredChange",
    DatPOEarliestDateChange = "datPOEarliestDateChange",
    DatPOLatestDateChange = "datPOLatestDateChange",
    DatPOCurrencyChange = "datPOCurrencyChange",
    DatPODateExpectedChange = "datPODateExpectedChange",
    DatPOConfirmationRefChange = "datPOConfirmationRefChange",
    DatPOPaymentTermsChange = "datPOPaymentTermsChange",
    DatPOIntrastatDeliveryTermsChange = "datPOIntrastatDeliveryTermsChange",
    DatPOIntrastatTransportModeChange = "datPOIntrastatTransportModeChange",
    DatPOReferral = "datPOReferral",
    DatPOMerge = "datPOMerge",
    DatSRDeliveryNoteNumberChange = "datSRDeliveryNoteNumberChange",
    DatSRHaulierChange = "datSRHaulierChange",
    DatSRReferenceChange = "datSRReferenceChange",
    DatSRDateExpectedChange = "datSRDateExpectedChange",
    DatSRInAdvanceUnticked = "datSRInAdvanceUnticked",
    DatSREstimatedFreightChange = "datSREstimatedFreightChange",
    DatSREstimatedMiscellaneousChange = "datSREstimatedMiscellaneousChange",
    DatSRIntrastatDeliveryTermsChange = "datSRIntrastatDeliveryTermsChange",
    DatSRIntrastatTransportModeChange = "datSRIntrastatTransportModeChange",
    DatSRDateReceivedChange = "datSRDateReceivedChange",
    DatSRLineQtyReceivedChange = "datSRLineQtyReceivedChange",
    DatSRLineUnitCostChange = "datSRLineUnitCostChange",
    DatSRLineBinLocationChange = "datSRLineBinLocationChange",
    DatSRLineTallyChange = "datSRLineTallyChange",
    DatSRLineFullyReceivedManualUse = "datSRLineFullyReceivedManualUse",
    DatBatchItemAdded = "datBatchItemAdded",
    DatSISupplierReferenceChange = "datSISupplierReferenceChange",
    DatSIOtherReferenceChange = "datSIOtherReferenceChange",
    DatSIInvoiceDateChange = "datSIInvoiceDateChange",
    DatSIPostingDateChange = "datSIPostingDateChange",
    DatSIDueDateChange = "datSIDueDateChange",
    DatSICreditorChange = "datSICreditorChange",
    DatSIPaymentTermsChange = "datSIPaymentTermsChange",
    DatSIGoodsTotalChange = "datSIGoodsTotalChange",
    DatSIVATChange = "datSIVATChange",
    DatSITotalWeightChange = "datSITotalWeightChange",
    DatSIDiscountChange = "datSIDiscountChange",
    DatSIExchangeRateChange = "datSIExchangeRateChange",
    DatSILineGRNLineAdd = "datSILineGRNLineAdd",
    DatSILineGRNLineRemove = "datSILineGRNLineRemove",
    DatSILineQtyInvShipChange = "datSILineQtyInvShipChange",
    DatSILineInvoiceUnitCostChange = "datSILineInvoiceUnitCostChange",
    DatSILineTotalWeightChange = "datSILineTotalWeightChange",
    DatSILineGLCodeChange = "datSILineGLCodeChange",
    DatSILineVATChange = "datSILineVATChange",
    DatSILineInvoiceGoodsTotalChange = "datSILineInvoiceGoodsTotalChange",
    DatSCReferenceChange = "datSCReferenceChange",
    DatSCCreditDateChange = "datSCCreditDateChange",
    DatSCPostingDateChange = "datSCPostingDateChange",
    DatSCCreditorChange = "datSCCreditorChange",
    DatSCPaymentTermsChange = "datSCPaymentTermsChange",
    DatSCGoodsTotalChange = "datSCGoodsTotalChange",
    DatSCVATChange = "datSCVATChange",
    DatSCTotalWeightChange = "datSCTotalWeightChange",
    DatSCDiscountAmountChange = "datSCDiscountAmountChange",
    DatSCLineQtyCreditChange = "datSCLineQtyCreditChange",
    DatSCLineCreditGoodsTotalChange = "datSCLineCreditGoodsTotalChange",
    DatSCLineGLCodeChange = "datSCLineGLCodeChange",
    DatSCLineVATChange = "datSCLineVATChange",
    DatSCLineFullyCreditUsed = "datSCLineFullyCreditUsed",
    DatPOSupplierChange = "datPOSupplierChange",
    DatWebTrackGeofence = "datWebTrackGeofence",
    DatProductChange = "datProductChange",
    DatPerRuleChange = "datPerRuleChange",
    DatProductBarcodeAdd = "datProductBarcodeAdd",
    DatProductBarcodeChange = "datProductBarcodeChange",
    DatProductBarcodeDelete = "datProductBarcodeDelete",
    DatCreditNoteLineAdd = "datCreditNoteLineAdd",
    DatCreditNoteDelete = "datCreditNoteDelete",
    DatCreditNoteLineDelete = "datCreditNoteLineDelete",
    DatCreditNoteLineReturnQuantityChange = "datCreditNoteLineReturnQuantityChange",
    DatCreditNoteLineUnitPriceChange = "datCreditNoteLineUnitPriceChange",
    DatCreditNoteLineTotalCostChange = "datCreditNoteLineTotalCostChange",
    DatCreditNoteCustomerChange = "datCreditNoteCustomerChange",
    DatCreditNoteRelease = "datCreditNoteRelease",
    DatOrderCompleted = "datOrderCompleted",
    DatOrderBranchChange = "datOrderBranchChange",
    DatOrderIssuingBranchChange = "datOrderIssuingBranchChange",
    DatOrderCustomerChange = "datOrderCustomerChange",
    DatOrderSaleTypeChange = "datOrderSaleTypeChange",
    DatOrderDeliveryOptionChange = "datOrderDeliveryOptionChange",
    DatOrderCODAmountChange = "datOrderCODAmountChange",
    DatOrderJourneyChange = "datOrderJourneyChange",
    DatOrderLineSaleTypeChange = "datOrderLineSaleTypeChange",
    DatOrderLinePickingRequiredChange = "datOrderLinePickingRequiredChange",
    DatCustomerUpdate = "datCustomerUpdate",
    DatPOLineNoteChange = "datPOLineNoteChange",
    DatCreditNoteLineNoteChange = "datCreditNoteLineNoteChange",
    DatOrderLineNoteChange = "datOrderLineNoteChange",
    DatCreditNoteHandlingChange = "datCreditNoteHandlingChange",
    DatCreditNoteMarkedAsReturnedChange = "datCreditNoteMarkedAsReturnedChange",
    DatCreditNoteBranchChange = "datCreditNoteBranchChange",
    DatCreditNoteLineTotalAmountChange = "datCreditNoteLineTotalAmountChange",
    DatCreditNoteLineQuantityChange = "datCreditNoteLineQuantityChange",
    DatCreditNoteLineDescriptionChange = "datCreditNoteLineDescriptionChange",
    DatCreditNoteLineItemNumberChange = "datCreditNoteLineItemNumberChange",
    DatCreditNoteLineProductChange = "datCreditNoteLineProductChange",
    DatTransferToBranchChange = "datTransferToBranchChange",
    DatTenderRetailRequest = "datTenderRetailRequest",
    DatTenderRetailResponse = "datTenderRetailResponse",
    DatTenderRetailEvent = "datTenderRetailEvent",
    DatTenderRetailSettleRequest = "datTenderRetailSettleRequest",
    DatTenderRetailSettleResponse = "datTenderRetailSettleResponse",
    DatTenderRetailSettleEvent = "datTenderRetailSettleEvent",
    DatOrderLineNumberChange = "datOrderLineNumberChange",
    DatPOLineNumberChange = "datPOLineNumberChange",
    DatOrderWMSPickingStatusChange = "datOrderWMSPickingStatusChange",
    DatSupplierReturnSupplierChange = "datSupplierReturnSupplierChange",
    DatSupplierReturnBranchChange = "datSupplierReturnBranchChange",
    DatSupplierReturnStatusChange = "datSupplierReturnStatusChange",
    DatSupplierReturnDelete = "datSupplierReturnDelete",
    DatSupplierReturnLineAdd = "datSupplierReturnLineAdd",
    DatSupplierReturnLineDelete = "datSupplierReturnLineDelete",
    DatSupplierReturnLineQuantityChange = "datSupplierReturnLineQuantityChange",
    DatSupplierReturnLineNoteChange = "datSupplierReturnLineNoteChange",
    DatPOLineStatusChange = "datPOLineStatusChange",
    DatWorksOrderComplete = "datWorksOrderComplete",
    DatWorksOrderBranchChange = "datWorksOrderBranchChange",
    DatWorksOrderSourceLineAdd = "datWorksOrderSourceLineAdd",
    DatWorksOrderFinishedLineAdd = "datWorksOrderFinishedLineAdd",
    DatWorksOrderSourceLineDelete = "datWorksOrderSourceLineDelete",
    DatWorksOrderFinishedLineDelete = "datWorksOrderFinishedLineDelete",
    DatWorksOrderSourceLineQuantityChange = "datWorksOrderSourceLineQuantityChange",
    DatWorksOrderFinishedLineQuantityChange = "datWorksOrderFinishedLineQuantityChange",
    DatWorksOrderSourceLineNotesChange = "datWorksOrderSourceLineNotesChange",
    DatWorksOrderFinishedLineNotesChange = "datWorksOrderFinishedLineNotesChange",
    DatWorksOrderSourceLineNumberChange = "datWorksOrderSourceLineNumberChange",
    DatWorksOrderFinishedLineNumberChange = "datWorksOrderFinishedLineNumberChange",
    DatWorksOrderDateRequiredChange = "datWorksOrderDateRequiredChange",
    DatWorksOrderMachineNameChange = "datWorksOrderMachineNameChange",
    DatReports = "datReports",
    DatJourneyChange = "datJourneyChange",
    DatBlueTarpRequest = "datBlueTarpRequest",
    DatBlueTarpResponse = "datBlueTarpResponse",
    DatOrderTypeChange = "datOrderTypeChange",
    DatOrderLineDisableRebateAccrualsChange = "datOrderLineDisableRebateAccrualsChange",
    DatCreditNoteLineDisableRebateAccrualsChange = "datCreditNoteLineDisableRebateAccrualsChange",
    DatAirMilesRequest = "datAirMilesRequest",
    DatAirMilesResponse = "datAirMilesResponse",
    DatAirMilesEvent = "datAirMilesEvent",
    DatAirMilesBatchCloseRequest = "datAirMilesBatchCloseRequest",
    DatAirMilesBatchCloseResponse = "datAirMilesBatchCloseResponse",
    DatAirMilesBatchCloseEvent = "datAirMilesBatchCloseEvent",
    DatOrderTakenByChange = "datOrderTakenByChange",
    DatOrderDateRequestedChange = "datOrderDateRequestedChange",
    DatCreditNoteLineReturnToSupplierChange = "datCreditNoteLineReturnToSupplierChange",
    DatStockCount = "datStockCount",
    DatSupplierUpdate = "datSupplierUpdate",
    DatEpicorTaxConnectRequest = "datEpicorTaxConnectRequest",
    DatEpicorTaxConnectResponse = "datEpicorTaxConnectResponse",
    DatWMSInstanceBranchAdd = "datWMSInstanceBranchAdd",
    DatWMSInstanceBranchRemove = "datWMSInstanceBranchRemove",
    DatOrderLineBranchChange = "datOrderLineBranchChange",
    DatWorksOrderLinkBroken = "datWorksOrderLinkBroken",
    DatOrderLineReleasedForProcessing = "datOrderLineReleasedForProcessing",
    DatWorksOrderMachineGroupChange = "datWorksOrderMachineGroupChange",
    DatWorksOrderProcessLineAdd = "datWorksOrderProcessLineAdd",
    DatWorksOrderProcessLineDelete = "datWorksOrderProcessLineDelete",
    DatWorksOrderProcessLineNumberChange = "datWorksOrderProcessLineNumberChange",
    DatWorksOrderProcessMachineChange = "datWorksOrderProcessMachineChange",
    DatWorksOrderWMSHoldChange = "datWorksOrderWMSHoldChange",
    DatPackHeatNumberChange = "datPackHeatNumberChange",
    DatPODeliveryAddressChange = "datPODeliveryAddressChange",
    DatOrderLineWMSFullUnitOnly = "datOrderLineWMSFullUnitOnly",
    DatOrderLineWaitingForStockChange = "datOrderLineWaitingForStockChange",
    DatAttachmentAdd = "datAttachmentAdd",
    DatAttachmentDelete = "datAttachmentDelete",
    DatInstalledSalesContract = "datInstalledSalesContract",
    DatCreTransactionSent = "datCreTransactionSent",
    DatCreStatusUpdated = "datCreStatusUpdated",
    DatCreTransactionReceived = "datCreTransactionReceived",
    DatACERewardsCouponValidationOverride = "datACERewardsCouponValidationOverride",
    DatSystemOptionChange = "datSystemOptionChange",
}

export enum AuditRequestAuditGroup {
    None = "None",
    DagSalesOrder = "dagSalesOrder",
    DagPurchaseOrder = "dagPurchaseOrder",
    DagStockReceipt = "dagStockReceipt",
    DagSupplierInvoice = "dagSupplierInvoice",
    DagWorksOrder = "dagWorksOrder",
    DagJourney = "dagJourney",
    DagStockCount = "dagStockCount",
    DagInstalledSalesContract = "dagInstalledSalesContract",
}

export enum AuditResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum SupplierRequestSupplierFilter {
    SffAll = "sffAll",
    SffStockSuppliers = "sffStockSuppliers",
    SffHauliers = "sffHauliers",
    SffSubContractors = "sffSubContractors",
    SffNonOperational = "sffNonOperational",
    SffAgents = "sffAgents",
    SffOverheadSuppliers = "sffOverheadSuppliers",
    SffDeletedSuppliers = "sffDeletedSuppliers",
    SffStockSuppliersOnly = "sffStockSuppliersOnly",
    SffOverheadSuppliersOnly = "sffOverheadSuppliersOnly",
}

export enum SupplierResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum SupplierTypeOfPurchase {
    TopHome = "topHome",
    TopEU = "topEU",
    TopNonHomeEU = "topNonHomeEU",
}

export enum SupplierOrderMethod {
    ImNotSet = "imNotSet",
    ImNormal = "imNormal",
    ImEDI = "imEDI",
    ImEDITest = "imEDITest",
}

export enum SupplierEdiSupplierTransportMethod {
    EtmNotSet = "etmNotSet",
    EtmFTP = "etmFTP",
    EtmEMail = "etmEMail",
    EtmManual = "etmManual",
    EtmFTPS = "etmFTPS",
    EtmInternal = "etmInternal",
}

export enum SupplierEdiRemittanceAdviceMethod {
    SemNotSet = "semNotSet",
    SemNone = "semNone",
    SemEDI = "semEDI",
    SemEDITest = "semEDITest",
}

export enum SupplierEdiClaimsMethod {
    EcmNotSet = "ecmNotSet",
    EcmNone = "ecmNone",
    EcmEDI = "ecmEDI",
    EcmEDITest = "ecmEDITest",
}

export enum SupplierEdiSalesHistoryMethod {
    EshmNotSet = "eshmNotSet",
    EshmNone = "eshmNone",
    EshmEDI = "eshmEDI",
    EshmEDITest = "eshmEDITest",
}

export enum SupplierEdiUpdatePurchaseOrderCost {
    UpoDefault = "upoDefault",
    UpoNo = "upoNo",
    UpoYes = "upoYes",
}

export enum SupplierEdiUpdatePurchaseOrderQuantity {
    UpoDefault = "upoDefault",
    UpoNo = "upoNo",
    UpoYes = "upoYes",
}

export enum SupplierCatalogResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum SupplierCatalogTreeResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum UsersResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum CollectionObjectParamJobFindFilterType {
    JffAllJobs = "jffAllJobs",
    JffPreliminaryJobs = "jffPreliminaryJobs",
    JffOpenJobs = "jffOpenJobs",
    JffLienActiveJobs = "jffLienActiveJobs",
    JffClosedJobs = "jffClosedJobs",
}

export enum CollectionObjectParamPaymentTermsType {
    PttNone = "pttNone",
    PttCustomer = "pttCustomer",
    PttSupplier = "pttSupplier",
}

export enum CollectionObjectParamSupplierFilter {
    SffAll = "sffAll",
    SffStockSuppliers = "sffStockSuppliers",
    SffHauliers = "sffHauliers",
    SffSubContractors = "sffSubContractors",
    SffNonOperational = "sffNonOperational",
    SffAgents = "sffAgents",
    SffOverheadSuppliers = "sffOverheadSuppliers",
    SffDeletedSuppliers = "sffDeletedSuppliers",
    SffStockSuppliersOnly = "sffStockSuppliersOnly",
    SffOverheadSuppliersOnly = "sffOverheadSuppliersOnly",
}

export enum CollectionObjectParamCustomerFindFilter {
    CffAll = "cffAll",
    CffOperational = "cffOperational",
    CffProspects = "cffProspects",
    CffNonOperational = "cffNonOperational",
    CffCurrentBranch = "cffCurrentBranch",
    CffMyCustomers = "cffMyCustomers",
    CffAIP = "cffAIP",
    CffActive = "cffActive",
    CffLapsed = "cffLapsed",
    CffInactive = "cffInactive",
    CffDeleted = "cffDeleted",
    CffCompetitors = "cffCompetitors",
}

export enum CollectionObjectResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum UserDefinedFieldResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum UserOptionOptionType {
    UotJanusSettings = "uotJanusSettings",
    UotWindowSettings = "uotWindowSettings",
    UotSplitterSettings = "uotSplitterSettings",
    UotJanusExtraSettings = "uotJanusExtraSettings",
    UotMyOptionsSettings = "uotMyOptionsSettings",
    UotAutoRefreshSettings = "uotAutoRefreshSettings",
    UotPerformanceSettings = "uotPerformanceSettings",
    UotSupplierInvoiceSettings = "uotSupplierInvoiceSettings",
    UotJanusColumnList = "uotJanusColumnList",
    UotMiscFormSettings = "uotMiscFormSettings",
    UotSavedPackSearch = "uotSavedPackSearch",
    UotJourneyPlannerOptions = "uotJourneyPlannerOptions",
    UotSearchHistory = "uotSearchHistory",
    UotDashboardComponentFolderPath = "uotDashboardComponentFolderPath",
    UotThemeSettings = "uotThemeSettings",
    UotSelectedPreviewPaneTab = "uotSelectedPreviewPaneTab",
}

export enum UserOptionResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum SetUserOptionResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum ModuleDebugConfigModuleType {
    COREAPI = "COREAPI",
    FIELDAGENTAPI = "FIELDAGENTAPI",
    SESSION = "SESSION",
    LOGIN = "LOGIN",
    APPLICATION = "APPLICATION",
    JOURNEYPLANNER = "JOURNEYPLANNER",
    DOCUMENT = "DOCUMENT",
    REPORT = "REPORT",
    PRODUCT = "PRODUCT",
    FIELDAGENT = "FIELDAGENT",
    AUTH = "AUTH",
}

export enum SessionInfoStatus {
    SESSION_EXPIRED = "SESSION_EXPIRED",
    SESSION_ERROR = "SESSION_ERROR",
    SESSION_NOTFOUND = "SESSION_NOTFOUND",
    SESSION_CREATED = "SESSION_CREATED",
    SESSION_ALIVE = "SESSION_ALIVE",
    SESSION_EXISTS = "SESSION_EXISTS",
}

export enum DocumentManifestDocumentType {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export enum DocumentManifestStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE = "PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE",
    DOCUMENT_NOTFOUND = "DOCUMENT_NOTFOUND",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DATABASE_ERROR = "DATABASE_ERROR",
    JOURNEY_INVALID = "JOURNEY_INVALID",
    INVALID_DELIVERY = "INVALID_DELIVERY",
}

export enum OrderHeaderOrderType {
    OrtOrder = "ortOrder",
    OrtQuote = "ortQuote",
    OrtReservation = "ortReservation",
    OrtTransfer = "ortTransfer",
    OrtCallOffOrder = "ortCallOffOrder",
    OrtTemplateOrder = "ortTemplateOrder",
}

export enum OrderHeaderOrderStatus {
    OrsSaved = "orsSaved",
    OrsParked = "orsParked",
    OrsCreditControl = "orsCreditControl",
    OrsAwaitingStock = "orsAwaitingStock",
    OrsAwaitingPicking = "orsAwaitingPicking",
    OrsAwaitingPickingConfirmation = "orsAwaitingPickingConfirmation",
    OrsAwaitingDelivery = "orsAwaitingDelivery",
    OrsAwaitingInvoicing = "orsAwaitingInvoicing",
    OrsInvoiced = "orsInvoiced",
    OrsTransferToBeSent = "orsTransferToBeSent",
    OrsTransferToBeReceived = "orsTransferToBeReceived",
    OrsTransferComplete = "orsTransferComplete",
    OrsCallOffComplete = "orsCallOffComplete",
    OrsCallOffOpen = "orsCallOffOpen",
    OrsOpen = "orsOpen",
    OrsQuoteAccepted = "orsQuoteAccepted",
    OrsQuoteRejected = "orsQuoteRejected",
}

export enum OrderHeaderOrderSubStatus {
    OrssNone = "orssNone",
    OrssCreditControlAwaitingRelease = "orssCreditControlAwaitingRelease",
    OrssCreditControlInProgress = "orssCreditControlInProgress",
    OrssCreditControlFailed = "orssCreditControlFailed",
    OrssCreditControlAwaitingCustomerApproval = "orssCreditControlAwaitingCustomerApproval",
    OrssPickingStarted = "orssPickingStarted",
    OrssAwaitingCheck = "orssAwaitingCheck",
    OrssPickingCompleted = "orssPickingCompleted",
    OrssTransferAwaitingApproval = "orssTransferAwaitingApproval",
    OrssTransferRejected = "orssTransferRejected",
}

export enum AddCostProRateLineCostValueType {
    AccvtNotApplicable = "accvtNotApplicable",
    AccvtValue = "accvtValue",
    AccvtPercent = "accvtPercent",
    AccvtPerTonne = "accvtPerTonne",
    AccvtPerKilogram = "accvtPerKilogram",
    AccvtPerCubicMetre = "accvtPerCubicMetre",
    AccvtPer1000BoardFoot = "accvtPer1000BoardFoot",
    AccvtCalculated = "accvtCalculated",
    AccvtPer1000SquareFoot = "accvtPer1000SquareFoot",
    AccvtPerPound = "accvtPerPound",
    AccvtPer100Pound = "accvtPer100Pound",
    AccvtPerTon = "accvtPerTon",
}

export enum AddCostProRateLineCostProRateBy {
    None = "none",
    CcprbValue = "ccprbValue",
    CcprbVolume = "ccprbVolume",
    CcprbWeight = "ccprbWeight",
}

export enum AddCostProRateLineChargeValueType {
    AccvtNotApplicable = "accvtNotApplicable",
    AccvtValue = "accvtValue",
    AccvtPercent = "accvtPercent",
    AccvtPerTonne = "accvtPerTonne",
    AccvtPerKilogram = "accvtPerKilogram",
    AccvtPerCubicMetre = "accvtPerCubicMetre",
    AccvtPer1000BoardFoot = "accvtPer1000BoardFoot",
    AccvtCalculated = "accvtCalculated",
    AccvtPer1000SquareFoot = "accvtPer1000SquareFoot",
    AccvtPerPound = "accvtPerPound",
    AccvtPer100Pound = "accvtPer100Pound",
    AccvtPerTon = "accvtPerTon",
}

export enum AddCostProRateLineChargeProRateBy {
    None = "none",
    CcprbValue = "ccprbValue",
    CcprbVolume = "ccprbVolume",
    CcprbWeight = "ccprbWeight",
}

export enum AddCostProRateLineWorksOrderAddCostBasedOnType {
    WoacboNotApplicable = "woacboNotApplicable",
    WoacboSource = "woacboSource",
    WoacboFinished = "woacboFinished",
}

export enum AddCostProrationDocumentDocumentType {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export enum JourneyManifestLineDocumentTypeEnum {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export enum JourneyManifestLineDropsByProductDocumentTypeEnum {
    None = "None",
    PurchaseOrder = "PurchaseOrder",
    SalesOrder = "SalesOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    StockTransfer = "StockTransfer",
    PickingNote = "PickingNote",
    ProfileInstruction = "ProfileInstruction",
    DeliveryNote = "DeliveryNote",
    CollectionNote = "CollectionNote",
    ProofOfDelivery = "ProofOfDelivery",
    MaterialCertification = "MaterialCertification",
    Invoice = "Invoice",
    CashSaleInvoice = "CashSaleInvoice",
    CreditNote = "CreditNote",
    SubContractInstruction = "SubContractInstruction",
    TestCertificate = "TestCertificate",
    WorksOrder = "WorksOrder",
    CashSaleRefund = "CashSaleRefund",
    DebitNote = "DebitNote",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    StockReceipt = "StockReceipt",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    WorksOrderSchedule = "WorksOrderSchedule",
    SupplierInvoice = "SupplierInvoice",
    SupplierCreditNote = "SupplierCreditNote",
    AverageCostAdjustment = "AverageCostAdjustment",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    DtScheduling = "dtScheduling",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    SupplierRequest = "SupplierRequest",
}

export enum JourneyManifestHeaderDocumentType {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export enum JourneyLineDocumentType {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export enum JourneyLineDocType {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export enum JourneyLineDocumentListType {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export class Properties implements IProperties {
    journeyNumber?: string | undefined;
    journeyDate?: string | undefined;
    reference?: string | undefined;
    deliveryAreaID?: string | undefined;
    deliveryAreaIDs?: string | undefined;
    vehicleID?: string | undefined;
    truckVehicleID?: string | undefined;
    vehicleName?: string | undefined;
    driverID?: string | undefined;
    driverName?: string | undefined;
    vehicleMaxWeight?: string | undefined;
    vehicleMaxVolume?: string | undefined;
    totalWeight?: string | undefined;
    totalVolume?: string | undefined;
    isFirstInSchedule?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryAddress1?: string | undefined;
    deliveryAddress2?: string | undefined;
    deliveryAddress3?: string | undefined;
    deliveryCountry?: string | undefined;
    deliveryAddress?: string | undefined;
    deliveryAreaName?: string | undefined;
    orderJobRef?: string | undefined;
    documentNumber?: string | undefined;
    branchID?: string | undefined;
    branchName?: string | undefined;
    dateRequired?: string | undefined;
    dateRequiredOption?: string | undefined;
    stockLocationID?: string | undefined;
    toStockLocationID?: string | undefined;
    customerID?: string | undefined;
    deliveryAddressCode?: string | undefined;
    customerName?: string | undefined;
    viaBranchName?: string | undefined;
    toBranchName?: string | undefined;
    supplierName?: string | undefined;
    viaBranchAddress?: string | undefined;
    orderCustomerRef?: string | undefined;
    noOfPacks?: string | undefined;
    noOfDrops?: string | undefined;
    noOfCollections?: string | undefined;
    noOfStops?: string | undefined;
    vehicleTypeId?: string | undefined;
    vehicleTypeName?: string | undefined;

    constructor(data?: IProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.journeyNumber = _data["JourneyNumber"];
            this.journeyDate = _data["JourneyDate"];
            this.reference = _data["Reference"];
            this.deliveryAreaID = _data["DeliveryAreaID"];
            this.deliveryAreaIDs = _data["DeliveryAreaIDs"];
            this.vehicleID = _data["VehicleID"];
            this.truckVehicleID = _data["TruckVehicleID"];
            this.vehicleName = _data["VehicleName"];
            this.driverID = _data["DriverID"];
            this.driverName = _data["DriverName"];
            this.vehicleMaxWeight = _data["VehicleMaxWeight"];
            this.vehicleMaxVolume = _data["VehicleMaxVolume"];
            this.totalWeight = _data["TotalWeight"];
            this.totalVolume = _data["TotalVolume"];
            this.isFirstInSchedule = _data["IsFirstInSchedule"];
            this.deliveryCity = _data["DeliveryCity"];
            this.deliveryAddress1 = _data["DeliveryAddress1"];
            this.deliveryAddress2 = _data["DeliveryAddress2"];
            this.deliveryAddress3 = _data["DeliveryAddress3"];
            this.deliveryCountry = _data["DeliveryCountry"];
            this.deliveryAddress = _data["DeliveryAddress"];
            this.deliveryAreaName = _data["DeliveryAreaName"];
            this.orderJobRef = _data["OrderJobRef"];
            this.documentNumber = _data["DocumentNumber"];
            this.branchID = _data["BranchID"];
            this.branchName = _data["BranchName"];
            this.dateRequired = _data["DateRequired"];
            this.dateRequiredOption = _data["DateRequiredOption"];
            this.stockLocationID = _data["StockLocationID"];
            this.toStockLocationID = _data["ToStockLocationID"];
            this.customerID = _data["CustomerID"];
            this.deliveryAddressCode = _data["DeliveryAddressCode"];
            this.customerName = _data["CustomerName"];
            this.viaBranchName = _data["ViaBranchName"];
            this.toBranchName = _data["ToBranchName"];
            this.supplierName = _data["SupplierName"];
            this.viaBranchAddress = _data["ViaBranchAddress"];
            this.orderCustomerRef = _data["OrderCustomerRef"];
            this.noOfPacks = _data["NoOfPacks"];
            this.noOfDrops = _data["NoOfDrops"];
            this.noOfCollections = _data["NoOfCollections"];
            this.noOfStops = _data["NoOfStops"];
            this.vehicleTypeId = _data["VehicleTypeId"];
            this.vehicleTypeName = _data["VehicleTypeName"];
        }
    }

    static fromJS(data: any): Properties {
        data = typeof data === 'object' ? data : {};
        let result = new Properties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["JourneyNumber"] = this.journeyNumber;
        data["JourneyDate"] = this.journeyDate;
        data["Reference"] = this.reference;
        data["DeliveryAreaID"] = this.deliveryAreaID;
        data["DeliveryAreaIDs"] = this.deliveryAreaIDs;
        data["VehicleID"] = this.vehicleID;
        data["TruckVehicleID"] = this.truckVehicleID;
        data["VehicleName"] = this.vehicleName;
        data["DriverID"] = this.driverID;
        data["DriverName"] = this.driverName;
        data["VehicleMaxWeight"] = this.vehicleMaxWeight;
        data["VehicleMaxVolume"] = this.vehicleMaxVolume;
        data["TotalWeight"] = this.totalWeight;
        data["TotalVolume"] = this.totalVolume;
        data["IsFirstInSchedule"] = this.isFirstInSchedule;
        data["DeliveryCity"] = this.deliveryCity;
        data["DeliveryAddress1"] = this.deliveryAddress1;
        data["DeliveryAddress2"] = this.deliveryAddress2;
        data["DeliveryAddress3"] = this.deliveryAddress3;
        data["DeliveryCountry"] = this.deliveryCountry;
        data["DeliveryAddress"] = this.deliveryAddress;
        data["DeliveryAreaName"] = this.deliveryAreaName;
        data["OrderJobRef"] = this.orderJobRef;
        data["DocumentNumber"] = this.documentNumber;
        data["BranchID"] = this.branchID;
        data["BranchName"] = this.branchName;
        data["DateRequired"] = this.dateRequired;
        data["DateRequiredOption"] = this.dateRequiredOption;
        data["StockLocationID"] = this.stockLocationID;
        data["ToStockLocationID"] = this.toStockLocationID;
        data["CustomerID"] = this.customerID;
        data["DeliveryAddressCode"] = this.deliveryAddressCode;
        data["CustomerName"] = this.customerName;
        data["ViaBranchName"] = this.viaBranchName;
        data["ToBranchName"] = this.toBranchName;
        data["SupplierName"] = this.supplierName;
        data["ViaBranchAddress"] = this.viaBranchAddress;
        data["OrderCustomerRef"] = this.orderCustomerRef;
        data["NoOfPacks"] = this.noOfPacks;
        data["NoOfDrops"] = this.noOfDrops;
        data["NoOfCollections"] = this.noOfCollections;
        data["NoOfStops"] = this.noOfStops;
        data["VehicleTypeId"] = this.vehicleTypeId;
        data["VehicleTypeName"] = this.vehicleTypeName;
        return data; 
    }
}

export interface IProperties {
    journeyNumber?: string | undefined;
    journeyDate?: string | undefined;
    reference?: string | undefined;
    deliveryAreaID?: string | undefined;
    deliveryAreaIDs?: string | undefined;
    vehicleID?: string | undefined;
    truckVehicleID?: string | undefined;
    vehicleName?: string | undefined;
    driverID?: string | undefined;
    driverName?: string | undefined;
    vehicleMaxWeight?: string | undefined;
    vehicleMaxVolume?: string | undefined;
    totalWeight?: string | undefined;
    totalVolume?: string | undefined;
    isFirstInSchedule?: string | undefined;
    deliveryCity?: string | undefined;
    deliveryAddress1?: string | undefined;
    deliveryAddress2?: string | undefined;
    deliveryAddress3?: string | undefined;
    deliveryCountry?: string | undefined;
    deliveryAddress?: string | undefined;
    deliveryAreaName?: string | undefined;
    orderJobRef?: string | undefined;
    documentNumber?: string | undefined;
    branchID?: string | undefined;
    branchName?: string | undefined;
    dateRequired?: string | undefined;
    dateRequiredOption?: string | undefined;
    stockLocationID?: string | undefined;
    toStockLocationID?: string | undefined;
    customerID?: string | undefined;
    deliveryAddressCode?: string | undefined;
    customerName?: string | undefined;
    viaBranchName?: string | undefined;
    toBranchName?: string | undefined;
    supplierName?: string | undefined;
    viaBranchAddress?: string | undefined;
    orderCustomerRef?: string | undefined;
    noOfPacks?: string | undefined;
    noOfDrops?: string | undefined;
    noOfCollections?: string | undefined;
    noOfStops?: string | undefined;
    vehicleTypeId?: string | undefined;
    vehicleTypeName?: string | undefined;
}

export enum DocumentManifestRequestDocumentType {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export enum DocumentHeaderManifestDocumentType {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export enum DocumentHeaderManifestStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE = "PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE",
    DOCUMENT_NOTFOUND = "DOCUMENT_NOTFOUND",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DATABASE_ERROR = "DATABASE_ERROR",
    JOURNEY_INVALID = "JOURNEY_INVALID",
    INVALID_DELIVERY = "INVALID_DELIVERY",
}

export enum RelatedDocumentQueryParamsDocumentListType {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export enum DocumentsListResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum DocumentDataDocumentType {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export enum DocumentOpStatusResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE = "PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE",
    DOCUMENT_NOTFOUND = "DOCUMENT_NOTFOUND",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DATABASE_ERROR = "DATABASE_ERROR",
    JOURNEY_INVALID = "JOURNEY_INVALID",
    INVALID_DELIVERY = "INVALID_DELIVERY",
}

export enum MarkOrderRequestProcessOption {
    PoPickStarted = "poPickStarted",
    PoPick = "poPick",
    PoPickChecked = "poPickChecked",
    PoDeliver = "poDeliver",
    PoCollect = "poCollect",
    PoUnPick = "poUnPick",
    PoPODReturn = "poPODReturn",
    PoFullPick = "poFullPick",
    PoUnDeliver = "poUnDeliver",
    PoUnCollect = "poUnCollect",
    PoUnPODReturn = "poUnPODReturn",
    PoPickComplete = "poPickComplete",
    PoUnPickComplete = "poUnPickComplete",
}

export enum UserDialogResponseId {
    JP_PromptDocumentDateDoesNotMatchJourneyDate_OK = "JP_PromptDocumentDateDoesNotMatchJourneyDate_OK",
    JP_PromtSupplierReturnNotDeliveredSale_OkCancel = "JP_PromtSupplierReturnNotDeliveredSale_OkCancel",
    JP_PromptDocumentIsNotDelivered = "JP_PromptDocumentIsNotDelivered",
    JP_PromptForCreditHoldOrParkedOrders_OkCancel = "JP_PromptForCreditHoldOrParkedOrders_OkCancel",
    JP_PromptForCreditHoldOrParkedOrders_Ok = "JP_PromptForCreditHoldOrParkedOrders_Ok",
    JP_PromptJourneyToViaBranch_Option = "JP_PromptJourneyToViaBranch_Option",
    JP_PromptJourneyViaBranchOrFinalDestinationBranch_Option = "JP_PromptJourneyViaBranchOrFinalDestinationBranch_Option",
    JP_PromptSameAddressJourney_YESNO = "JP_PromptSameAddressJourney_YESNO",
    ADDCOST_PromptForDocumentValidation_OK = "ADDCOST_PromptForDocumentValidation_OK",
    OrderMonitor_PromptForWMSCheck_OkCancel = "OrderMonitor_PromptForWMSCheck_OkCancel",
    OrderMonitor_PromptForMarkOrders_OK = "OrderMonitor_PromptForMarkOrders_OK",
    OrderMonitor_ExecuteProcessOptionDialog1_YesNo = "OrderMonitor_ExecuteProcessOptionDialog1_YesNo",
    OrderMonitor_ExecuteProcessOptionDialog2_YesNoCancel = "OrderMonitor_ExecuteProcessOptionDialog2_YesNoCancel",
    OrderMonitor_ExecuteProcessOptionDialog3_YesNoCancel = "OrderMonitor_ExecuteProcessOptionDialog3_YesNoCancel",
    OrderMonitor_ExecuteProcessOptionDialog4_YesNoCancel = "OrderMonitor_ExecuteProcessOptionDialog4_YesNoCancel",
    OrderMonitor_ExecuteProcessOptionDialog5_YesNoCancel = "OrderMonitor_ExecuteProcessOptionDialog5_YesNoCancel",
    OrderMonitor_SendTransfer_YesNo = "OrderMonitor_SendTransfer_YesNo",
    OrderMonitor_OrderDisplay_OkCancel = "OrderMonitor_OrderDisplay_OkCancel",
    OrderMonitor_OrderTransferDialog1_YesNo = "OrderMonitor_OrderTransferDialog1_YesNo",
    OrderMonitor_OrderTransferDialog2_YesNo = "OrderMonitor_OrderTransferDialog2_YesNo",
    OrderMonitor_OrderTransferDialog3_YesNo = "OrderMonitor_OrderTransferDialog3_YesNo",
    OrderMonitor_ApproveOrders_YesNo = "OrderMonitor_ApproveOrders_YesNo",
    OrderMonitor_OptionInvoice_Dialog1_YesNo = "OrderMonitor_OptionInvoice_Dialog1_YesNo",
    OrderMonitor_OptionInvoice_Dialog2_YesNo = "OrderMonitor_OptionInvoice_Dialog2_YesNo",
    OrderMonitor_StockTransferReceiptQty_Dialog = "OrderMonitor_StockTransferReceiptQty_Dialog",
    OrderMonitor_DocumentPrint_Dialog = "OrderMonitor_DocumentPrint_Dialog",
    OrderMonitor_InvoiceReleaseDisplay_Dialog = "OrderMonitor_InvoiceReleaseDisplay_Dialog",
    OrderMonitor_ProcessDisplay_Dialog = "OrderMonitor_ProcessDisplay_Dialog",
    OrderMonitor_ValidateOrderDelivery_OK = "OrderMonitor_ValidateOrderDelivery_OK",
    OrderMonitor_OrderDeliveryDetailsInvoiced_OK = "OrderMonitor_OrderDeliveryDetailsInvoiced_OK",
    OrderMonitor_PaymentValidation_OK = "OrderMonitor_PaymentValidation_OK",
    OrderMonitor_WMSBranchCheck_OK = "OrderMonitor_WMSBranchCheck_OK",
    Prompt_OK = "Prompt_OK",
}

export enum UserDialogResponseResponse {
    OK = "OK",
    Cancel = "Cancel",
    Yes = "Yes",
    No = "No",
    Option = "Option",
}

export enum ProcessDisplayProcess {
    ProInvoiceApproval = "proInvoiceApproval",
    ProInvoiceUnApproval = "proInvoiceUnApproval",
    ProInvoiceRelease = "proInvoiceRelease",
    ProInvoiceDelete = "proInvoiceDelete",
    ProMarkOrderPicked = "proMarkOrderPicked",
    ProMarkOrderFullyPicked = "proMarkOrderFullyPicked",
    ProMarkOrderDelivered = "proMarkOrderDelivered",
    ProMarkOrderPODReturned = "proMarkOrderPODReturned",
    ProMarkOrderUnPickComplete = "proMarkOrderUnPickComplete",
    ProMarkOrderUnPicked = "proMarkOrderUnPicked",
    ProMarkOrderUnDelivered = "proMarkOrderUnDelivered",
    ProMarkOrderUnPODReturned = "proMarkOrderUnPODReturned",
    ProOrderIssue = "proOrderIssue",
    ProOrderApprove = "proOrderApprove",
    ProOrderInvoice = "proOrderInvoice",
    ProOrderApprovalHold = "proOrderApprovalHold",
    ProOrderApprovalHoldOff = "proOrderApprovalHoldOff",
    ProOrderUnissue = "proOrderUnissue",
    ProOrderDelete = "proOrderDelete",
    ProConfirmCollection = "proConfirmCollection",
    ProMarkCreditNoteAsPaid = "proMarkCreditNoteAsPaid",
    ProCompleteAVOs = "proCompleteAVOs",
    ProWMSPickingRelease = "proWMSPickingRelease",
    ProWMSPickingUnrelease = "proWMSPickingUnrelease",
    ProOrderUnapprove = "proOrderUnapprove",
    ProRefreshNonSpecialManufacturedKits = "proRefreshNonSpecialManufacturedKits",
    ProReleaseForProcessing = "proReleaseForProcessing",
}

export enum OrderDocumentListDocumentType {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export enum MarkOrderResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE = "PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE",
    DOCUMENT_NOTFOUND = "DOCUMENT_NOTFOUND",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DATABASE_ERROR = "DATABASE_ERROR",
    JOURNEY_INVALID = "JOURNEY_INVALID",
    INVALID_DELIVERY = "INVALID_DELIVERY",
}

export enum ConvertDocumentParamsConversionType {
    JlctSalesToPicking = "jlctSalesToPicking",
    JlctPickingToDelivery = "jlctPickingToDelivery",
}

export enum ConvertDocumentResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE = "PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE",
    VEHICLE_BUSY = "VEHICLE_BUSY",
    JOURNEY_LOCKED = "JOURNEY_LOCKED",
    HAS_WORKFLOW_PROCESS = "HAS_WORKFLOW_PROCESS",
    QUERY_ADD_TO_EXISTING_JOURNEY = "QUERY_ADD_TO_EXISTING_JOURNEY",
    ERROR_ADDING_DOCUMENT = "ERROR_ADDING_DOCUMENT",
    JOURNEY_NOTFOUND = "JOURNEY_NOTFOUND",
    SCHEDULEDLINE_NOTFOUND = "SCHEDULEDLINE_NOTFOUND",
    DOCUMENT_NOTFOUND = "DOCUMENT_NOTFOUND",
    CREDID_CONTROL_HOLD = "CREDID_CONTROL_HOLD",
    QUERY_CREDID_CONTROL_HOLD = "QUERY_CREDID_CONTROL_HOLD",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    PERMISSION_DENIED_MARKFULLDAY = "PERMISSION_DENIED_MARKFULLDAY",
    PERMISSION_DENIED_UPDATE_BRANCH = "PERMISSION_DENIED_UPDATE_BRANCH",
    NO_ADDRESS_TO_MAP = "NO_ADDRESS_TO_MAP",
    JOURNEY_INVALID = "JOURNEY_INVALID",
}

export enum CalendarEventsResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE = "PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE",
    VEHICLE_BUSY = "VEHICLE_BUSY",
    JOURNEY_LOCKED = "JOURNEY_LOCKED",
    HAS_WORKFLOW_PROCESS = "HAS_WORKFLOW_PROCESS",
    QUERY_ADD_TO_EXISTING_JOURNEY = "QUERY_ADD_TO_EXISTING_JOURNEY",
    ERROR_ADDING_DOCUMENT = "ERROR_ADDING_DOCUMENT",
    JOURNEY_NOTFOUND = "JOURNEY_NOTFOUND",
    SCHEDULEDLINE_NOTFOUND = "SCHEDULEDLINE_NOTFOUND",
    DOCUMENT_NOTFOUND = "DOCUMENT_NOTFOUND",
    CREDID_CONTROL_HOLD = "CREDID_CONTROL_HOLD",
    QUERY_CREDID_CONTROL_HOLD = "QUERY_CREDID_CONTROL_HOLD",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    PERMISSION_DENIED_MARKFULLDAY = "PERMISSION_DENIED_MARKFULLDAY",
    PERMISSION_DENIED_UPDATE_BRANCH = "PERMISSION_DENIED_UPDATE_BRANCH",
    NO_ADDRESS_TO_MAP = "NO_ADDRESS_TO_MAP",
    JOURNEY_INVALID = "JOURNEY_INVALID",
}

export enum JourneyStatus {
    Saved = "Saved",
    InProgress = "InProgress",
    Complete = "Complete",
}

export class Properties2 implements IProperties2 {
    canEdit?: string | undefined;
    keyedByDate?: string | undefined;
    reference?: string | undefined;
    peakWeight?: string | undefined;
    peakVolume?: string | undefined;
    vehicleMaxVolume?: string | undefined;
    vehicleMaxWeight?: string | undefined;
    totalWeight?: string | undefined;
    totalVolume?: string | undefined;
    journeyDate?: string | undefined;
    maxLength?: string | undefined;
    maxWidth?: string | undefined;
    plannedStartDateTime?: string | undefined;
    plannedFinishDateTime?: string | undefined;
    actualDateTimeStarted?: string | undefined;
    actualDateTimeFinished?: string | undefined;
    cutOffDateTime?: string | undefined;
    vehicleID?: string | undefined;
    vehicleRegistration?: string | undefined;
    maximumWidth?: string | undefined;
    truckVehicleID?: string | undefined;
    truckRegistration?: string | undefined;
    capacityPercent?: string | undefined;
    vehicleName?: string | undefined;
    driverID?: string | undefined;
    driverName?: string | undefined;
    trailervehicleID?: string | undefined;
    trailerRegistration?: string | undefined;
    noOfPacks?: string | undefined;
    noOfDrops?: string | undefined;
    noOfCollections?: string | undefined;
    noOfStops?: string | undefined;

    constructor(data?: IProperties2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canEdit = _data["CanEdit"];
            this.keyedByDate = _data["KeyedByDate"];
            this.reference = _data["Reference"];
            this.peakWeight = _data["PeakWeight"];
            this.peakVolume = _data["PeakVolume"];
            this.vehicleMaxVolume = _data["VehicleMaxVolume"];
            this.vehicleMaxWeight = _data["VehicleMaxWeight"];
            this.totalWeight = _data["TotalWeight"];
            this.totalVolume = _data["TotalVolume"];
            this.journeyDate = _data["JourneyDate"];
            this.maxLength = _data["MaxLength"];
            this.maxWidth = _data["MaxWidth"];
            this.plannedStartDateTime = _data["PlannedStartDateTime"];
            this.plannedFinishDateTime = _data["PlannedFinishDateTime"];
            this.actualDateTimeStarted = _data["ActualDateTimeStarted"];
            this.actualDateTimeFinished = _data["ActualDateTimeFinished"];
            this.cutOffDateTime = _data["CutOffDateTime"];
            this.vehicleID = _data["VehicleID"];
            this.vehicleRegistration = _data["VehicleRegistration"];
            this.maximumWidth = _data["MaximumWidth"];
            this.truckVehicleID = _data["TruckVehicleID"];
            this.truckRegistration = _data["TruckRegistration"];
            this.capacityPercent = _data["CapacityPercent"];
            this.vehicleName = _data["VehicleName"];
            this.driverID = _data["DriverID"];
            this.driverName = _data["DriverName"];
            this.trailervehicleID = _data["TrailervehicleID"];
            this.trailerRegistration = _data["TrailerRegistration"];
            this.noOfPacks = _data["NoOfPacks"];
            this.noOfDrops = _data["NoOfDrops"];
            this.noOfCollections = _data["NoOfCollections"];
            this.noOfStops = _data["NoOfStops"];
        }
    }

    static fromJS(data: any): Properties2 {
        data = typeof data === 'object' ? data : {};
        let result = new Properties2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CanEdit"] = this.canEdit;
        data["KeyedByDate"] = this.keyedByDate;
        data["Reference"] = this.reference;
        data["PeakWeight"] = this.peakWeight;
        data["PeakVolume"] = this.peakVolume;
        data["VehicleMaxVolume"] = this.vehicleMaxVolume;
        data["VehicleMaxWeight"] = this.vehicleMaxWeight;
        data["TotalWeight"] = this.totalWeight;
        data["TotalVolume"] = this.totalVolume;
        data["JourneyDate"] = this.journeyDate;
        data["MaxLength"] = this.maxLength;
        data["MaxWidth"] = this.maxWidth;
        data["PlannedStartDateTime"] = this.plannedStartDateTime;
        data["PlannedFinishDateTime"] = this.plannedFinishDateTime;
        data["ActualDateTimeStarted"] = this.actualDateTimeStarted;
        data["ActualDateTimeFinished"] = this.actualDateTimeFinished;
        data["CutOffDateTime"] = this.cutOffDateTime;
        data["VehicleID"] = this.vehicleID;
        data["VehicleRegistration"] = this.vehicleRegistration;
        data["MaximumWidth"] = this.maximumWidth;
        data["TruckVehicleID"] = this.truckVehicleID;
        data["TruckRegistration"] = this.truckRegistration;
        data["CapacityPercent"] = this.capacityPercent;
        data["VehicleName"] = this.vehicleName;
        data["DriverID"] = this.driverID;
        data["DriverName"] = this.driverName;
        data["TrailervehicleID"] = this.trailervehicleID;
        data["TrailerRegistration"] = this.trailerRegistration;
        data["NoOfPacks"] = this.noOfPacks;
        data["NoOfDrops"] = this.noOfDrops;
        data["NoOfCollections"] = this.noOfCollections;
        data["NoOfStops"] = this.noOfStops;
        return data; 
    }
}

export interface IProperties2 {
    canEdit?: string | undefined;
    keyedByDate?: string | undefined;
    reference?: string | undefined;
    peakWeight?: string | undefined;
    peakVolume?: string | undefined;
    vehicleMaxVolume?: string | undefined;
    vehicleMaxWeight?: string | undefined;
    totalWeight?: string | undefined;
    totalVolume?: string | undefined;
    journeyDate?: string | undefined;
    maxLength?: string | undefined;
    maxWidth?: string | undefined;
    plannedStartDateTime?: string | undefined;
    plannedFinishDateTime?: string | undefined;
    actualDateTimeStarted?: string | undefined;
    actualDateTimeFinished?: string | undefined;
    cutOffDateTime?: string | undefined;
    vehicleID?: string | undefined;
    vehicleRegistration?: string | undefined;
    maximumWidth?: string | undefined;
    truckVehicleID?: string | undefined;
    truckRegistration?: string | undefined;
    capacityPercent?: string | undefined;
    vehicleName?: string | undefined;
    driverID?: string | undefined;
    driverName?: string | undefined;
    trailervehicleID?: string | undefined;
    trailerRegistration?: string | undefined;
    noOfPacks?: string | undefined;
    noOfDrops?: string | undefined;
    noOfCollections?: string | undefined;
    noOfStops?: string | undefined;
}

export enum ScheduleEventParamsDocumentType {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export enum ScheduleEventParamsAddDocumentOption {
    VIA_BRANCH = "VIA_BRANCH",
    CUSTOMER_ADDRESS = "CUSTOMER_ADDRESS",
    FINAL_DESTINATION_BRANCH = "FINAL_DESTINATION_BRANCH",
}

export enum ScheduleEventParamsAddToExistingJourney {
    NONE = "NONE",
    TRUE = "TRUE",
    FALSE = "FALSE",
}

export enum ScheduleVehicleParamsTrailerTypeId {
    None = "None",
    TtTruckAndTrailer = "ttTruckAndTrailer",
    TtTrailerOnly = "ttTrailerOnly",
    TtTruckOnly = "ttTruckOnly",
}

export enum ScheduleEventResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE = "PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE",
    VEHICLE_BUSY = "VEHICLE_BUSY",
    JOURNEY_LOCKED = "JOURNEY_LOCKED",
    HAS_WORKFLOW_PROCESS = "HAS_WORKFLOW_PROCESS",
    QUERY_ADD_TO_EXISTING_JOURNEY = "QUERY_ADD_TO_EXISTING_JOURNEY",
    ERROR_ADDING_DOCUMENT = "ERROR_ADDING_DOCUMENT",
    JOURNEY_NOTFOUND = "JOURNEY_NOTFOUND",
    SCHEDULEDLINE_NOTFOUND = "SCHEDULEDLINE_NOTFOUND",
    DOCUMENT_NOTFOUND = "DOCUMENT_NOTFOUND",
    CREDID_CONTROL_HOLD = "CREDID_CONTROL_HOLD",
    QUERY_CREDID_CONTROL_HOLD = "QUERY_CREDID_CONTROL_HOLD",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    PERMISSION_DENIED_MARKFULLDAY = "PERMISSION_DENIED_MARKFULLDAY",
    PERMISSION_DENIED_UPDATE_BRANCH = "PERMISSION_DENIED_UPDATE_BRANCH",
    NO_ADDRESS_TO_MAP = "NO_ADDRESS_TO_MAP",
    JOURNEY_INVALID = "JOURNEY_INVALID",
}

export enum UnusedVehicleResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE = "PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE",
    VEHICLE_BUSY = "VEHICLE_BUSY",
    JOURNEY_LOCKED = "JOURNEY_LOCKED",
    HAS_WORKFLOW_PROCESS = "HAS_WORKFLOW_PROCESS",
    QUERY_ADD_TO_EXISTING_JOURNEY = "QUERY_ADD_TO_EXISTING_JOURNEY",
    ERROR_ADDING_DOCUMENT = "ERROR_ADDING_DOCUMENT",
    JOURNEY_NOTFOUND = "JOURNEY_NOTFOUND",
    SCHEDULEDLINE_NOTFOUND = "SCHEDULEDLINE_NOTFOUND",
    DOCUMENT_NOTFOUND = "DOCUMENT_NOTFOUND",
    CREDID_CONTROL_HOLD = "CREDID_CONTROL_HOLD",
    QUERY_CREDID_CONTROL_HOLD = "QUERY_CREDID_CONTROL_HOLD",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    PERMISSION_DENIED_MARKFULLDAY = "PERMISSION_DENIED_MARKFULLDAY",
    PERMISSION_DENIED_UPDATE_BRANCH = "PERMISSION_DENIED_UPDATE_BRANCH",
    NO_ADDRESS_TO_MAP = "NO_ADDRESS_TO_MAP",
    JOURNEY_INVALID = "JOURNEY_INVALID",
}

export enum ScheduledDocumentMoveResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE = "PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE",
    VEHICLE_BUSY = "VEHICLE_BUSY",
    JOURNEY_LOCKED = "JOURNEY_LOCKED",
    HAS_WORKFLOW_PROCESS = "HAS_WORKFLOW_PROCESS",
    QUERY_ADD_TO_EXISTING_JOURNEY = "QUERY_ADD_TO_EXISTING_JOURNEY",
    ERROR_ADDING_DOCUMENT = "ERROR_ADDING_DOCUMENT",
    JOURNEY_NOTFOUND = "JOURNEY_NOTFOUND",
    SCHEDULEDLINE_NOTFOUND = "SCHEDULEDLINE_NOTFOUND",
    DOCUMENT_NOTFOUND = "DOCUMENT_NOTFOUND",
    CREDID_CONTROL_HOLD = "CREDID_CONTROL_HOLD",
    QUERY_CREDID_CONTROL_HOLD = "QUERY_CREDID_CONTROL_HOLD",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    PERMISSION_DENIED_MARKFULLDAY = "PERMISSION_DENIED_MARKFULLDAY",
    PERMISSION_DENIED_UPDATE_BRANCH = "PERMISSION_DENIED_UPDATE_BRANCH",
    NO_ADDRESS_TO_MAP = "NO_ADDRESS_TO_MAP",
    JOURNEY_INVALID = "JOURNEY_INVALID",
}

export enum JourneyPlannerOptionsResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE = "PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE",
    VEHICLE_BUSY = "VEHICLE_BUSY",
    JOURNEY_LOCKED = "JOURNEY_LOCKED",
    HAS_WORKFLOW_PROCESS = "HAS_WORKFLOW_PROCESS",
    QUERY_ADD_TO_EXISTING_JOURNEY = "QUERY_ADD_TO_EXISTING_JOURNEY",
    ERROR_ADDING_DOCUMENT = "ERROR_ADDING_DOCUMENT",
    JOURNEY_NOTFOUND = "JOURNEY_NOTFOUND",
    SCHEDULEDLINE_NOTFOUND = "SCHEDULEDLINE_NOTFOUND",
    DOCUMENT_NOTFOUND = "DOCUMENT_NOTFOUND",
    CREDID_CONTROL_HOLD = "CREDID_CONTROL_HOLD",
    QUERY_CREDID_CONTROL_HOLD = "QUERY_CREDID_CONTROL_HOLD",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    PERMISSION_DENIED_MARKFULLDAY = "PERMISSION_DENIED_MARKFULLDAY",
    PERMISSION_DENIED_UPDATE_BRANCH = "PERMISSION_DENIED_UPDATE_BRANCH",
    NO_ADDRESS_TO_MAP = "NO_ADDRESS_TO_MAP",
    JOURNEY_INVALID = "JOURNEY_INVALID",
}

export enum JourneyPlannerOptionsTimeFrame {
    None = "none",
    JptfSingleDay = "jptfSingleDay",
    JptfSingleDayAndTime = "jptfSingleDayAndTime",
    JptfWorkWeek = "jptfWorkWeek",
    JptfCalendarWeek = "jptfCalendarWeek",
    JptfCalendarMonth = "jptfCalendarMonth",
    JptfSingleDayAndTimePlanned = "jptfSingleDayAndTimePlanned",
    JptfJourneyBoard = "jptfJourneyBoard",
    JptfCalendarStyle = "jptfCalendarStyle",
}

export enum JourneyPlannerOptionsNewTimeFrame {
    None = "none",
    JptfSingleDay = "jptfSingleDay",
    JptfSingleDayAndTime = "jptfSingleDayAndTime",
    JptfWorkWeek = "jptfWorkWeek",
    JptfCalendarWeek = "jptfCalendarWeek",
    JptfCalendarMonth = "jptfCalendarMonth",
    JptfSingleDayAndTimePlanned = "jptfSingleDayAndTimePlanned",
    JptfJourneyBoard = "jptfJourneyBoard",
    JptfCalendarStyle = "jptfCalendarStyle",
}

export enum AppOPStatusResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum JourneyOpStatusResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE = "PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE",
    VEHICLE_BUSY = "VEHICLE_BUSY",
    JOURNEY_LOCKED = "JOURNEY_LOCKED",
    HAS_WORKFLOW_PROCESS = "HAS_WORKFLOW_PROCESS",
    QUERY_ADD_TO_EXISTING_JOURNEY = "QUERY_ADD_TO_EXISTING_JOURNEY",
    ERROR_ADDING_DOCUMENT = "ERROR_ADDING_DOCUMENT",
    JOURNEY_NOTFOUND = "JOURNEY_NOTFOUND",
    SCHEDULEDLINE_NOTFOUND = "SCHEDULEDLINE_NOTFOUND",
    DOCUMENT_NOTFOUND = "DOCUMENT_NOTFOUND",
    CREDID_CONTROL_HOLD = "CREDID_CONTROL_HOLD",
    QUERY_CREDID_CONTROL_HOLD = "QUERY_CREDID_CONTROL_HOLD",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    PERMISSION_DENIED_MARKFULLDAY = "PERMISSION_DENIED_MARKFULLDAY",
    PERMISSION_DENIED_UPDATE_BRANCH = "PERMISSION_DENIED_UPDATE_BRANCH",
    NO_ADDRESS_TO_MAP = "NO_ADDRESS_TO_MAP",
    JOURNEY_INVALID = "JOURNEY_INVALID",
}

export enum JourneyManifestResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE = "PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE",
    VEHICLE_BUSY = "VEHICLE_BUSY",
    JOURNEY_LOCKED = "JOURNEY_LOCKED",
    HAS_WORKFLOW_PROCESS = "HAS_WORKFLOW_PROCESS",
    QUERY_ADD_TO_EXISTING_JOURNEY = "QUERY_ADD_TO_EXISTING_JOURNEY",
    ERROR_ADDING_DOCUMENT = "ERROR_ADDING_DOCUMENT",
    JOURNEY_NOTFOUND = "JOURNEY_NOTFOUND",
    SCHEDULEDLINE_NOTFOUND = "SCHEDULEDLINE_NOTFOUND",
    DOCUMENT_NOTFOUND = "DOCUMENT_NOTFOUND",
    CREDID_CONTROL_HOLD = "CREDID_CONTROL_HOLD",
    QUERY_CREDID_CONTROL_HOLD = "QUERY_CREDID_CONTROL_HOLD",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    PERMISSION_DENIED_MARKFULLDAY = "PERMISSION_DENIED_MARKFULLDAY",
    PERMISSION_DENIED_UPDATE_BRANCH = "PERMISSION_DENIED_UPDATE_BRANCH",
    NO_ADDRESS_TO_MAP = "NO_ADDRESS_TO_MAP",
    JOURNEY_INVALID = "JOURNEY_INVALID",
}

export enum TimeEstimateResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE = "PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE",
    VEHICLE_BUSY = "VEHICLE_BUSY",
    JOURNEY_LOCKED = "JOURNEY_LOCKED",
    HAS_WORKFLOW_PROCESS = "HAS_WORKFLOW_PROCESS",
    QUERY_ADD_TO_EXISTING_JOURNEY = "QUERY_ADD_TO_EXISTING_JOURNEY",
    ERROR_ADDING_DOCUMENT = "ERROR_ADDING_DOCUMENT",
    JOURNEY_NOTFOUND = "JOURNEY_NOTFOUND",
    SCHEDULEDLINE_NOTFOUND = "SCHEDULEDLINE_NOTFOUND",
    DOCUMENT_NOTFOUND = "DOCUMENT_NOTFOUND",
    CREDID_CONTROL_HOLD = "CREDID_CONTROL_HOLD",
    QUERY_CREDID_CONTROL_HOLD = "QUERY_CREDID_CONTROL_HOLD",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    PERMISSION_DENIED_MARKFULLDAY = "PERMISSION_DENIED_MARKFULLDAY",
    PERMISSION_DENIED_UPDATE_BRANCH = "PERMISSION_DENIED_UPDATE_BRANCH",
    NO_ADDRESS_TO_MAP = "NO_ADDRESS_TO_MAP",
    JOURNEY_INVALID = "JOURNEY_INVALID",
}

export enum FindFromDocumentRequestDocumentType {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export enum FindFromDocumentResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE = "PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE",
    VEHICLE_BUSY = "VEHICLE_BUSY",
    JOURNEY_LOCKED = "JOURNEY_LOCKED",
    HAS_WORKFLOW_PROCESS = "HAS_WORKFLOW_PROCESS",
    QUERY_ADD_TO_EXISTING_JOURNEY = "QUERY_ADD_TO_EXISTING_JOURNEY",
    ERROR_ADDING_DOCUMENT = "ERROR_ADDING_DOCUMENT",
    JOURNEY_NOTFOUND = "JOURNEY_NOTFOUND",
    SCHEDULEDLINE_NOTFOUND = "SCHEDULEDLINE_NOTFOUND",
    DOCUMENT_NOTFOUND = "DOCUMENT_NOTFOUND",
    CREDID_CONTROL_HOLD = "CREDID_CONTROL_HOLD",
    QUERY_CREDID_CONTROL_HOLD = "QUERY_CREDID_CONTROL_HOLD",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    PERMISSION_DENIED_MARKFULLDAY = "PERMISSION_DENIED_MARKFULLDAY",
    PERMISSION_DENIED_UPDATE_BRANCH = "PERMISSION_DENIED_UPDATE_BRANCH",
    NO_ADDRESS_TO_MAP = "NO_ADDRESS_TO_MAP",
    JOURNEY_INVALID = "JOURNEY_INVALID",
}

export enum JourneyDirectionResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE = "PERMISSION_DENIED_CREATE_JOURNEY_VEHICLE",
    VEHICLE_BUSY = "VEHICLE_BUSY",
    JOURNEY_LOCKED = "JOURNEY_LOCKED",
    HAS_WORKFLOW_PROCESS = "HAS_WORKFLOW_PROCESS",
    QUERY_ADD_TO_EXISTING_JOURNEY = "QUERY_ADD_TO_EXISTING_JOURNEY",
    ERROR_ADDING_DOCUMENT = "ERROR_ADDING_DOCUMENT",
    JOURNEY_NOTFOUND = "JOURNEY_NOTFOUND",
    SCHEDULEDLINE_NOTFOUND = "SCHEDULEDLINE_NOTFOUND",
    DOCUMENT_NOTFOUND = "DOCUMENT_NOTFOUND",
    CREDID_CONTROL_HOLD = "CREDID_CONTROL_HOLD",
    QUERY_CREDID_CONTROL_HOLD = "QUERY_CREDID_CONTROL_HOLD",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    PERMISSION_DENIED_MARKFULLDAY = "PERMISSION_DENIED_MARKFULLDAY",
    PERMISSION_DENIED_UPDATE_BRANCH = "PERMISSION_DENIED_UPDATE_BRANCH",
    NO_ADDRESS_TO_MAP = "NO_ADDRESS_TO_MAP",
    JOURNEY_INVALID = "JOURNEY_INVALID",
}

export enum LoginUserResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    CLIENT_NOT_SETUP = "CLIENT_NOT_SETUP",
    FINANCIAL_NOT_SETUP = "FINANCIAL_NOT_SETUP",
    CURRENTCONTROL_LOAD_ERROR = "CURRENTCONTROL_LOAD_ERROR",
    SETTINGS_LOAD_ERROR = "SETTINGS_LOAD_ERROR",
    CURRENTUSER_LOAD_ERROR = "CURRENTUSER_LOAD_ERROR",
    CURRENTCONTROL_OPTION_NOT_SET = "CURRENTCONTROL_OPTION_NOT_SET",
    NO_BISTRACK_SERVER_LICENSE = "NO_BISTRACK_SERVER_LICENSE",
    BISTRACK_LICENSE_EXPIRED = "BISTRACK_LICENSE_EXPIRED",
    LICENSE_ERROR = "LICENSE_ERROR",
    NO_LICENSE_MODEL = "NO_LICENSE_MODEL",
    PASSWORD_EXPIRED = "PASSWORD_EXPIRED",
    ERROR_LOADING_COMPUTER = "ERROR_LOADING_COMPUTER",
    DATABASE_UPGRADING = "DATABASE_UPGRADING",
    INVLIAD_COUNTRY_SETTINGS = "INVLIAD_COUNTRY_SETTINGS",
    MISSING_DATABASE_CONFIG = "MISSING_DATABASE_CONFIG",
}

export enum CurrentUserResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    CLIENT_NOT_SETUP = "CLIENT_NOT_SETUP",
    FINANCIAL_NOT_SETUP = "FINANCIAL_NOT_SETUP",
    CURRENTCONTROL_LOAD_ERROR = "CURRENTCONTROL_LOAD_ERROR",
    SETTINGS_LOAD_ERROR = "SETTINGS_LOAD_ERROR",
    CURRENTUSER_LOAD_ERROR = "CURRENTUSER_LOAD_ERROR",
    CURRENTCONTROL_OPTION_NOT_SET = "CURRENTCONTROL_OPTION_NOT_SET",
    NO_BISTRACK_SERVER_LICENSE = "NO_BISTRACK_SERVER_LICENSE",
    BISTRACK_LICENSE_EXPIRED = "BISTRACK_LICENSE_EXPIRED",
    LICENSE_ERROR = "LICENSE_ERROR",
    NO_LICENSE_MODEL = "NO_LICENSE_MODEL",
    PASSWORD_EXPIRED = "PASSWORD_EXPIRED",
    ERROR_LOADING_COMPUTER = "ERROR_LOADING_COMPUTER",
    DATABASE_UPGRADING = "DATABASE_UPGRADING",
    INVLIAD_COUNTRY_SETTINGS = "INVLIAD_COUNTRY_SETTINGS",
    MISSING_DATABASE_CONFIG = "MISSING_DATABASE_CONFIG",
}

export enum UserAppMenuResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    CLIENT_NOT_SETUP = "CLIENT_NOT_SETUP",
    FINANCIAL_NOT_SETUP = "FINANCIAL_NOT_SETUP",
    CURRENTCONTROL_LOAD_ERROR = "CURRENTCONTROL_LOAD_ERROR",
    SETTINGS_LOAD_ERROR = "SETTINGS_LOAD_ERROR",
    CURRENTUSER_LOAD_ERROR = "CURRENTUSER_LOAD_ERROR",
    CURRENTCONTROL_OPTION_NOT_SET = "CURRENTCONTROL_OPTION_NOT_SET",
    NO_BISTRACK_SERVER_LICENSE = "NO_BISTRACK_SERVER_LICENSE",
    BISTRACK_LICENSE_EXPIRED = "BISTRACK_LICENSE_EXPIRED",
    LICENSE_ERROR = "LICENSE_ERROR",
    NO_LICENSE_MODEL = "NO_LICENSE_MODEL",
    PASSWORD_EXPIRED = "PASSWORD_EXPIRED",
    ERROR_LOADING_COMPUTER = "ERROR_LOADING_COMPUTER",
    DATABASE_UPGRADING = "DATABASE_UPGRADING",
    INVLIAD_COUNTRY_SETTINGS = "INVLIAD_COUNTRY_SETTINGS",
    MISSING_DATABASE_CONFIG = "MISSING_DATABASE_CONFIG",
}

export enum UserNavigationMenuResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    CLIENT_NOT_SETUP = "CLIENT_NOT_SETUP",
    FINANCIAL_NOT_SETUP = "FINANCIAL_NOT_SETUP",
    CURRENTCONTROL_LOAD_ERROR = "CURRENTCONTROL_LOAD_ERROR",
    SETTINGS_LOAD_ERROR = "SETTINGS_LOAD_ERROR",
    CURRENTUSER_LOAD_ERROR = "CURRENTUSER_LOAD_ERROR",
    CURRENTCONTROL_OPTION_NOT_SET = "CURRENTCONTROL_OPTION_NOT_SET",
    NO_BISTRACK_SERVER_LICENSE = "NO_BISTRACK_SERVER_LICENSE",
    BISTRACK_LICENSE_EXPIRED = "BISTRACK_LICENSE_EXPIRED",
    LICENSE_ERROR = "LICENSE_ERROR",
    NO_LICENSE_MODEL = "NO_LICENSE_MODEL",
    PASSWORD_EXPIRED = "PASSWORD_EXPIRED",
    ERROR_LOADING_COMPUTER = "ERROR_LOADING_COMPUTER",
    DATABASE_UPGRADING = "DATABASE_UPGRADING",
    INVLIAD_COUNTRY_SETTINGS = "INVLIAD_COUNTRY_SETTINGS",
    MISSING_DATABASE_CONFIG = "MISSING_DATABASE_CONFIG",
}

export enum MenuItemFeatureType {
    JourneyPlanner = "JourneyPlanner",
    None = "None",
    Dashboard = "Dashboard",
    FaContacts = "FaContacts",
    FaOpportunities = "FaOpportunities",
    FaProducts = "FaProducts",
    FaCustomers = "FaCustomers",
    FaNotepad = "FaNotepad",
    FaCalendar = "FaCalendar",
    FaDashboards = "FaDashboards",
    FaStore = "FaStore",
    FaSmartViews = "FaSmartViews",
    FaDocuments = "FaDocuments",
    FaQuickOrder = "FaQuickOrder",
    FaQuickPurchase = "FaQuickPurchase",
    FaBinLocations = "FaBinLocations",
    FaLabels = "FaLabels",
    FaQuickTransfer = "FaQuickTransfer",
    FaCompetitorPricing = "FaCompetitorPricing",
}

export enum KitDetailsResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
    NOT_MANUFACTURED_KIT = "NOT_MANUFACTURED_KIT",
    KIT_NOT_FOUND = "KIT_NOT_FOUND",
    IMG_NOT_FOUND = "IMG_NOT_FOUND",
    KIT_LINE_NOT_FOUND = "KIT_LINE_NOT_FOUND",
    KIT_WITHIN_KIT = "KIT_WITHIN_KIT",
}

export enum KitManifestResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
    NOT_MANUFACTURED_KIT = "NOT_MANUFACTURED_KIT",
    KIT_NOT_FOUND = "KIT_NOT_FOUND",
    IMG_NOT_FOUND = "IMG_NOT_FOUND",
    KIT_LINE_NOT_FOUND = "KIT_LINE_NOT_FOUND",
    KIT_WITHIN_KIT = "KIT_WITHIN_KIT",
}

export enum KitConfiguratorResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
    NOT_MANUFACTURED_KIT = "NOT_MANUFACTURED_KIT",
    KIT_NOT_FOUND = "KIT_NOT_FOUND",
    IMG_NOT_FOUND = "IMG_NOT_FOUND",
    KIT_LINE_NOT_FOUND = "KIT_LINE_NOT_FOUND",
    KIT_WITHIN_KIT = "KIT_WITHIN_KIT",
}

export enum ReportFormatResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum DocumentReportRequestPrintTool {
    PtoPrintOrder = "ptoPrintOrder",
    PtoPrintConfirmation = "ptoPrintConfirmation",
    PtoPrintPickingNote = "ptoPrintPickingNote",
    PtoPrintDeliveryNote = "ptoPrintDeliveryNote",
    PtoPrintDeliveryNoteSet = "ptoPrintDeliveryNoteSet",
    PtoPrintCollectionNoteSet = "ptoPrintCollectionNoteSet",
    PtoPrintInvoice = "ptoPrintInvoice",
    PtoPrintTransfer = "ptoPrintTransfer",
    PtoPrintTransferDeliverySet = "ptoPrintTransferDeliverySet",
    PtoPrintPickingNoteTransfer = "ptoPrintPickingNoteTransfer",
    PtoPrintDeliveryNoteTransfer = "ptoPrintDeliveryNoteTransfer",
}

export enum DocumentReportRequestDocumentType {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export enum DocumentReportResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum ReportsValidationResponseStatus {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    DISABLED = "DISABLED",
    USER_INVALID = "USER_INVALID",
    INTERNAL_ERROR = "INTERNAL_ERROR",
    ERROR_LOADING = "ERROR_LOADING",
    INVALID_ARGUMENT = "INVALID_ARGUMENT",
    EOF = "EOF",
    NOT_FOUND = "NOT_FOUND",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    DOC_NOT_ADDED_TO_PRORATION = "DOC_NOT_ADDED_TO_PRORATION",
    DOC_VALIDATION_ERROR = "DOC_VALIDATION_ERROR",
    NO_DOCUMENTS = "NO_DOCUMENTS",
    ORDER_NOT_VALID = "ORDER_NOT_VALID",
    INVALID_SELECTION = "INVALID_SELECTION",
    ERROR_PROCESSING_ORDERS = "ERROR_PROCESSING_ORDERS",
    SET_REASON_CODE = "SET_REASON_CODE",
}

export enum ReportValidationDocumentDocumentType {
    None = "None",
    AVO = "AVO",
    CreditNote = "CreditNote",
    CuttingOperation = "CuttingOperation",
    DeliveryNote = "DeliveryNote",
    Invoice = "Invoice",
    PickingNote = "PickingNote",
    ProfileOperation = "ProfileOperation",
    PurchaseOrder = "PurchaseOrder",
    Quote = "Quote",
    Reservation = "Reservation",
    SalesOrder = "SalesOrder",
    SelfBillingInvoice = "SelfBillingInvoice",
    StockReceipt = "StockReceipt",
    StockTransfer = "StockTransfer",
    SubContractInstruction = "SubContractInstruction",
    WorksOrder = "WorksOrder",
    DebitNote = "DebitNote",
    SupplierInvoice = "SupplierInvoice",
    Journey = "Journey",
    CustomerReturn = "CustomerReturn",
    SupplierCreditNote = "SupplierCreditNote",
    SupplierReturn = "SupplierReturn",
    CallOffOrder = "CallOffOrder",
    TemplateOrder = "TemplateOrder",
    InvoiceCostAdjustment = "InvoiceCostAdjustment",
    WorksOrderSchedule = "WorksOrderSchedule",
    AverageCostAdjustment = "AverageCostAdjustment",
    StockAdjustment = "StockAdjustment",
    ScanTrackImage = "ScanTrackImage",
    EDIDocument = "EDIDocument",
    CallOffPurchaseOrder = "CallOffPurchaseOrder",
    ElectronicPaymentReceipt = "ElectronicPaymentReceipt",
    Contract = "Contract",
    StockReceiptAdjustment = "StockReceiptAdjustment",
    WorksOrderPartialProcess = "WorksOrderPartialProcess",
    AddCostProration = "AddCostProration",
    WorksOrderProcess = "WorksOrderProcess",
    Scheduling = "Scheduling",
    CashDrawerLodgement = "CashDrawerLodgement",
    Attachment = "Attachment",
    WorksOrderProcessHeader = "WorksOrderProcessHeader",
    WorksOrderProcessHeaderToCollect = "WorksOrderProcessHeaderToCollect",
    SalesOrderAVO = "SalesOrderAVO",
    StockCount = "StockCount",
    SuggestedPurchaseOrder = "SuggestedPurchaseOrder",
    CustomerStratification = "CustomerStratification",
    CustomerStratificationSummary = "CustomerStratificationSummary",
    PurchaseOrderDelivered = "PurchaseOrderDelivered",
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}